
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredab2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredab2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8qnmK", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $6222e065a61944b2$export$2c73285ae9390cec);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("7BgeB");
var $1dq9r = parcelRequire("1dq9r");

var $87vq4 = parcelRequire("87vq4");

var $1UZVJ = parcelRequire("1UZVJ");
/** @soyCompatible */ let $6222e065a61944b2$export$2c73285ae9390cec = class TextField extends (0, $87vq4.TextFieldBase) {
};
$6222e065a61944b2$export$2c73285ae9390cec.styles = [
    (0, $1UZVJ.styles)
];
$6222e065a61944b2$export$2c73285ae9390cec = (0, $czHfO.__decorate)([
    (0, $1dq9r.customElement)('mwc-textfield')
], $6222e065a61944b2$export$2c73285ae9390cec);

});
parcelRegister("czHfO", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $927a4e448519a67d$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $927a4e448519a67d$export$18ce0697a983be9b);
$parcel$export(module.exports, "__decorate", () => $927a4e448519a67d$export$29e00dfd3077644b);
$parcel$export(module.exports, "__values", () => $927a4e448519a67d$export$19a8beecd37a4c45);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $927a4e448519a67d$var$extendStatics = function(d, b) {
    $927a4e448519a67d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $927a4e448519a67d$var$extendStatics(d, b);
};
function $927a4e448519a67d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $927a4e448519a67d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $927a4e448519a67d$export$18ce0697a983be9b = function() {
    $927a4e448519a67d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $927a4e448519a67d$export$18ce0697a983be9b.apply(this, arguments);
};
function $927a4e448519a67d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $927a4e448519a67d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $927a4e448519a67d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $927a4e448519a67d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $927a4e448519a67d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $927a4e448519a67d$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $927a4e448519a67d$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $927a4e448519a67d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $927a4e448519a67d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $927a4e448519a67d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $927a4e448519a67d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $927a4e448519a67d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $927a4e448519a67d$export$45d3717a4c69092e(o, m, p);
}
function $927a4e448519a67d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $927a4e448519a67d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $927a4e448519a67d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($927a4e448519a67d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $927a4e448519a67d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $927a4e448519a67d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $927a4e448519a67d$export$10c90e4f7922046c(v) {
    return this instanceof $927a4e448519a67d$export$10c90e4f7922046c ? (this.v = v, this) : new $927a4e448519a67d$export$10c90e4f7922046c(v);
}
function $927a4e448519a67d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $927a4e448519a67d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $927a4e448519a67d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $927a4e448519a67d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $927a4e448519a67d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $927a4e448519a67d$export$19a8beecd37a4c45 === "function" ? $927a4e448519a67d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $927a4e448519a67d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $927a4e448519a67d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $927a4e448519a67d$var$ownKeys = function(o) {
    $927a4e448519a67d$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $927a4e448519a67d$var$ownKeys(o);
};
function $927a4e448519a67d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $927a4e448519a67d$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $927a4e448519a67d$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $927a4e448519a67d$var$__setModuleDefault(result, mod);
    return result;
}
function $927a4e448519a67d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $927a4e448519a67d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $927a4e448519a67d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $927a4e448519a67d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $927a4e448519a67d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $927a4e448519a67d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $927a4e448519a67d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $927a4e448519a67d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $927a4e448519a67d$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $927a4e448519a67d$export$2e2bcd8739ae039 = {
    __extends: $927a4e448519a67d$export$a8ba968b8961cb8a,
    __assign: $927a4e448519a67d$export$18ce0697a983be9b,
    __rest: $927a4e448519a67d$export$3c9a16f847548506,
    __decorate: $927a4e448519a67d$export$29e00dfd3077644b,
    __param: $927a4e448519a67d$export$d5ad3fd78186038f,
    __esDecorate: $927a4e448519a67d$export$3a84e1ae4e97e9b0,
    __runInitializers: $927a4e448519a67d$export$d831c04e792af3d,
    __propKey: $927a4e448519a67d$export$6a2a36740a146cb8,
    __setFunctionName: $927a4e448519a67d$export$d1a06452d3489bc7,
    __metadata: $927a4e448519a67d$export$f1db080c865becb9,
    __awaiter: $927a4e448519a67d$export$1050f835b63b671e,
    __generator: $927a4e448519a67d$export$67ebef60e6f28a6,
    __createBinding: $927a4e448519a67d$export$45d3717a4c69092e,
    __exportStar: $927a4e448519a67d$export$f33643c0debef087,
    __values: $927a4e448519a67d$export$19a8beecd37a4c45,
    __read: $927a4e448519a67d$export$8d051b38c9118094,
    __spread: $927a4e448519a67d$export$afc72e2116322959,
    __spreadArrays: $927a4e448519a67d$export$6388937ca91ccae8,
    __spreadArray: $927a4e448519a67d$export$1216008129fb82ed,
    __await: $927a4e448519a67d$export$10c90e4f7922046c,
    __asyncGenerator: $927a4e448519a67d$export$e427f37a30a4de9b,
    __asyncDelegator: $927a4e448519a67d$export$bbd80228419bb833,
    __asyncValues: $927a4e448519a67d$export$e3b29a3d6162315f,
    __makeTemplateObject: $927a4e448519a67d$export$4fb47efe1390b86f,
    __importStar: $927a4e448519a67d$export$c21735bcef00d192,
    __importDefault: $927a4e448519a67d$export$da59b14a69baef04,
    __classPrivateFieldGet: $927a4e448519a67d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $927a4e448519a67d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $927a4e448519a67d$export$81fdc39f203e4e04,
    __addDisposableResource: $927a4e448519a67d$export$88ac25d8e944e405,
    __disposeResources: $927a4e448519a67d$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $927a4e448519a67d$export$889dfb5d17574b0b
};

});

parcelRegister("7BgeB", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("1dq9r")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("avP5s")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("h9Q79")).state);
$parcel$export(module.exports, "eventOptions", () => (parcelRequire("jYmjf")).eventOptions);
$parcel$export(module.exports, "query", () => (parcelRequire("i6Q5l")).query);
parcelRequire("1dq9r");
parcelRequire("avP5s");
parcelRequire("h9Q79");
parcelRequire("jYmjf");
parcelRequire("i6Q5l");
parcelRequire("dojJB");
parcelRequire("lfSTG");
parcelRequire("8hoLH");
parcelRequire("025C1");

});
parcelRegister("1dq9r", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $0e2b4a76f709940e$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0e2b4a76f709940e$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("avP5s", function(module, exports) {

$parcel$export(module.exports, "property", () => $7a746d735733ea6b$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7a746d735733ea6b$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $7a746d735733ea6b$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $7a746d735733ea6b$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $7a746d735733ea6b$var$e(n, t, o) : $7a746d735733ea6b$var$i(n, t);
}

});

parcelRegister("h9Q79", function(module, exports) {

$parcel$export(module.exports, "state", () => $c7dbb3c2e0a9df51$export$ca000e230c0caa3e);

var $avP5s = parcelRequire("avP5s");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c7dbb3c2e0a9df51$export$ca000e230c0caa3e(t) {
    return (0, $avP5s.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("jYmjf", function(module, exports) {

$parcel$export(module.exports, "eventOptions", () => $e8a4ed163297e7a3$export$b2b799818fbabcf3);

var $6wvMp = parcelRequire("6wvMp");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e8a4ed163297e7a3$export$b2b799818fbabcf3(e) {
    return (0, $6wvMp.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("6wvMp", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", () => $4bfe62054f06bec7$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4bfe62054f06bec7$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $4bfe62054f06bec7$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $4bfe62054f06bec7$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("i6Q5l", function(module, exports) {

$parcel$export(module.exports, "query", () => $d2f1308b797ea1f5$export$2fa187e846a241c4);

var $6wvMp = parcelRequire("6wvMp");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d2f1308b797ea1f5$export$2fa187e846a241c4(i, n) {
    return (0, $6wvMp.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("dojJB", function(module, exports) {

var $6wvMp = parcelRequire("6wvMp");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9bfcd31e893bcd1d$export$dcd0d083aa86c355(e) {
    return (0, $6wvMp.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("lfSTG", function(module, exports) {

var $6wvMp = parcelRequire("6wvMp");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f7959519aef732fd$export$163dfc35cc43f240(e) {
    return (0, $6wvMp.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("8hoLH", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $60731fba4283ceb9$export$4682af2d9ee91415);

var $6wvMp = parcelRequire("6wvMp");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $60731fba4283ceb9$var$n;
const $60731fba4283ceb9$var$e = null != (null === ($60731fba4283ceb9$var$n = window.HTMLSlotElement) || void 0 === $60731fba4283ceb9$var$n ? void 0 : $60731fba4283ceb9$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $60731fba4283ceb9$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $6wvMp.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $60731fba4283ceb9$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("025C1", function(module, exports) {

var $6wvMp = parcelRequire("6wvMp");

var $8hoLH = parcelRequire("8hoLH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $00648a8351c26572$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $8hoLH.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $6wvMp.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("87vq4", function(module, exports) {

$parcel$export(module.exports, "TextFieldBase", () => $5e97596efa728e55$export$d22444a338b6e3c2);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("5auXy");
parcelRequire("cMU8m");
var $gSEYT = parcelRequire("gSEYT");
var $cMU8m = parcelRequire("cMU8m");

var $k4Ngf = parcelRequire("k4Ngf");

var $eUOHt = parcelRequire("eUOHt");

var $3ddFX = parcelRequire("3ddFX");

var $94bPH = parcelRequire("94bPH");
parcelRequire("8qGBw");
var $dEBa6 = parcelRequire("dEBa6");
parcelRequire("7BgeB");
var $jYmjf = parcelRequire("jYmjf");
var $avP5s = parcelRequire("avP5s");
var $i6Q5l = parcelRequire("i6Q5l");
var $h9Q79 = parcelRequire("h9Q79");
parcelRequire("1CHUK");
var $lvqMI = parcelRequire("lvqMI");
parcelRequire("4bkOp");
var $eBGeQ = parcelRequire("eBGeQ");
parcelRequire("hBaoW");
var $eXn6D = parcelRequire("eXn6D");
const $5e97596efa728e55$var$passiveEvents = [
    'touchstart',
    'touchmove',
    'scroll',
    'mousewheel'
];
const $5e97596efa728e55$var$createValidityObj = (customValidity = {})=>{
    /*
     * We need to make ValidityState an object because it is readonly and
     * we cannot use the spread operator. Also, we don't export
     * `CustomValidityState` because it is a leaky implementation and the user
     * already has access to `ValidityState` in lib.dom.ts. Also an interface
     * {a: Type} can be casted to {readonly a: Type} so passing any object
     * should be fine.
     */ const objectifiedCustomValidity = {};
    // eslint-disable-next-line guard-for-in
    for(const propName in customValidity)/*
         * Casting is needed because ValidityState's props are all readonly and
         * thus cannot be set on `onjectifiedCustomValidity`. In the end, the
         * interface is the same as ValidityState (but not readonly), but the
         * function signature casts the output to ValidityState (thus readonly).
         */ objectifiedCustomValidity[propName] = customValidity[propName];
    return Object.assign({
        badInput: false,
        customError: false,
        patternMismatch: false,
        rangeOverflow: false,
        rangeUnderflow: false,
        stepMismatch: false,
        tooLong: false,
        tooShort: false,
        typeMismatch: false,
        valid: true,
        valueMissing: false
    }, objectifiedCustomValidity);
};
class $5e97596efa728e55$export$d22444a338b6e3c2 extends (0, $cMU8m.FormElement) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $94bPH.default);
        this.value = '';
        this.type = 'text';
        this.placeholder = '';
        this.label = '';
        this.icon = '';
        this.iconTrailing = '';
        this.disabled = false;
        this.required = false;
        this.minLength = -1;
        this.maxLength = -1;
        this.outlined = false;
        this.helper = '';
        this.validateOnInitialRender = false;
        this.validationMessage = '';
        this.autoValidate = false;
        this.pattern = '';
        this.min = '';
        this.max = '';
        /**
         * step can be a number or the keyword "any".
         *
         * Use `String` typing to pass down the value as a string and let the native
         * input cast internally as needed.
         */ this.step = null;
        this.size = null;
        this.helperPersistent = false;
        this.charCounter = false;
        this.endAligned = false;
        this.prefix = '';
        this.suffix = '';
        this.name = '';
        this.readOnly = false;
        this.autocapitalize = '';
        this.outlineOpen = false;
        this.outlineWidth = 0;
        this.isUiValid = true;
        this.focused = false;
        this._validity = $5e97596efa728e55$var$createValidityObj();
        this.validityTransform = null;
    }
    get validity() {
        this._checkValidity(this.value);
        return this._validity;
    }
    get willValidate() {
        return this.formElement.willValidate;
    }
    get selectionStart() {
        return this.formElement.selectionStart;
    }
    get selectionEnd() {
        return this.formElement.selectionEnd;
    }
    focus() {
        const focusEvt = new CustomEvent('focus');
        this.formElement.dispatchEvent(focusEvt);
        this.formElement.focus();
    }
    blur() {
        const blurEvt = new CustomEvent('blur');
        this.formElement.dispatchEvent(blurEvt);
        this.formElement.blur();
    }
    select() {
        this.formElement.select();
    }
    setSelectionRange(selectionStart, selectionEnd, selectionDirection) {
        this.formElement.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
    }
    update(changedProperties) {
        if (changedProperties.has('autoValidate') && this.mdcFoundation) this.mdcFoundation.setValidateOnValueChange(this.autoValidate);
        if (changedProperties.has('value') && typeof this.value !== 'string') this.value = `${this.value}`;
        super.update(changedProperties);
    }
    setFormData(formData) {
        if (this.name) formData.append(this.name, this.value);
    }
    /** @soyTemplate */ render() {
        const shouldRenderCharCounter = this.charCounter && this.maxLength !== -1;
        const shouldRenderHelperText = !!this.helper || !!this.validationMessage || shouldRenderCharCounter;
        /** @classMap */ const classes = {
            'mdc-text-field--disabled': this.disabled,
            'mdc-text-field--no-label': !this.label,
            'mdc-text-field--filled': !this.outlined,
            'mdc-text-field--outlined': this.outlined,
            'mdc-text-field--with-leading-icon': this.icon,
            'mdc-text-field--with-trailing-icon': this.iconTrailing,
            'mdc-text-field--end-aligned': this.endAligned
        };
        return (0, $dEBa6.html)`
      <label class="mdc-text-field ${(0, $lvqMI.classMap)(classes)}">
        ${this.renderRipple()}
        ${this.outlined ? this.renderOutline() : this.renderLabel()}
        ${this.renderLeadingIcon()}
        ${this.renderPrefix()}
        ${this.renderInput(shouldRenderHelperText)}
        ${this.renderSuffix()}
        ${this.renderTrailingIcon()}
        ${this.renderLineRipple()}
      </label>
      ${this.renderHelperText(shouldRenderHelperText, shouldRenderCharCounter)}
    `;
    }
    updated(changedProperties) {
        if (changedProperties.has('value') && changedProperties.get('value') !== undefined) {
            this.mdcFoundation.setValue(this.value);
            if (this.autoValidate) this.reportValidity();
        }
    }
    /** @soyTemplate */ renderRipple() {
        return this.outlined ? '' : (0, $dEBa6.html)`
      <span class="mdc-text-field__ripple"></span>
    `;
    }
    /** @soyTemplate */ renderOutline() {
        return !this.outlined ? '' : (0, $dEBa6.html)`
      <mwc-notched-outline
          .width=${this.outlineWidth}
          .open=${this.outlineOpen}
          class="mdc-notched-outline">
        ${this.renderLabel()}
      </mwc-notched-outline>`;
    }
    /** @soyTemplate */ renderLabel() {
        return !this.label ? '' : (0, $dEBa6.html)`
      <span
          .floatingLabelFoundation=${(0, $eUOHt.floatingLabel)(this.label)}
          id="label">${this.label}</span>
    `;
    }
    /** @soyTemplate */ renderLeadingIcon() {
        return this.icon ? this.renderIcon(this.icon) : '';
    }
    /** @soyTemplate */ renderTrailingIcon() {
        return this.iconTrailing ? this.renderIcon(this.iconTrailing, true) : '';
    }
    /** @soyTemplate */ renderIcon(icon, isTrailingIcon = false) {
        /** @classMap */ const classes = {
            'mdc-text-field__icon--leading': !isTrailingIcon,
            'mdc-text-field__icon--trailing': isTrailingIcon
        };
        return (0, $dEBa6.html)`<i class="material-icons mdc-text-field__icon ${(0, $lvqMI.classMap)(classes)}">${icon}</i>`;
    }
    /** @soyTemplate */ renderPrefix() {
        return this.prefix ? this.renderAffix(this.prefix) : '';
    }
    /** @soyTemplate */ renderSuffix() {
        return this.suffix ? this.renderAffix(this.suffix, true) : '';
    }
    /** @soyTemplate */ renderAffix(content, isSuffix = false) {
        /** @classMap */ const classes = {
            'mdc-text-field__affix--prefix': !isSuffix,
            'mdc-text-field__affix--suffix': isSuffix
        };
        return (0, $dEBa6.html)`<span class="mdc-text-field__affix ${(0, $lvqMI.classMap)(classes)}">
        ${content}</span>`;
    }
    /** @soyTemplate */ renderInput(shouldRenderHelperText) {
        const minOrUndef = this.minLength === -1 ? undefined : this.minLength;
        const maxOrUndef = this.maxLength === -1 ? undefined : this.maxLength;
        const autocapitalizeOrUndef = this.autocapitalize ? this.autocapitalize : undefined;
        const showValidationMessage = this.validationMessage && !this.isUiValid;
        const ariaLabelledbyOrUndef = !!this.label ? 'label' : undefined;
        const ariaControlsOrUndef = shouldRenderHelperText ? 'helper-text' : undefined;
        const ariaDescribedbyOrUndef = this.focused || this.helperPersistent || showValidationMessage ? 'helper-text' : undefined;
        // TODO: live() directive needs casting for lit-analyzer
        // https://github.com/runem/lit-analyzer/pull/91/files
        // TODO: lit-analyzer labels min/max as (number|string) instead of string
        return (0, $dEBa6.html)`
      <input
          aria-labelledby=${(0, $eBGeQ.ifDefined)(ariaLabelledbyOrUndef)}
          aria-controls="${(0, $eBGeQ.ifDefined)(ariaControlsOrUndef)}"
          aria-describedby="${(0, $eBGeQ.ifDefined)(ariaDescribedbyOrUndef)}"
          class="mdc-text-field__input"
          type="${this.type}"
          .value="${(0, $eXn6D.live)(this.value)}"
          ?disabled="${this.disabled}"
          placeholder="${this.placeholder}"
          ?required="${this.required}"
          ?readonly="${this.readOnly}"
          minlength="${(0, $eBGeQ.ifDefined)(minOrUndef)}"
          maxlength="${(0, $eBGeQ.ifDefined)(maxOrUndef)}"
          pattern="${(0, $eBGeQ.ifDefined)(this.pattern ? this.pattern : undefined)}"
          min="${(0, $eBGeQ.ifDefined)(this.min === '' ? undefined : this.min)}"
          max="${(0, $eBGeQ.ifDefined)(this.max === '' ? undefined : this.max)}"
          step="${(0, $eBGeQ.ifDefined)(this.step === null ? undefined : this.step)}"
          size="${(0, $eBGeQ.ifDefined)(this.size === null ? undefined : this.size)}"
          name="${(0, $eBGeQ.ifDefined)(this.name === '' ? undefined : this.name)}"
          inputmode="${(0, $eBGeQ.ifDefined)(this.inputMode)}"
          autocapitalize="${(0, $eBGeQ.ifDefined)(autocapitalizeOrUndef)}"
          @input="${this.handleInputChange}"
          @focus="${this.onInputFocus}"
          @blur="${this.onInputBlur}">`;
    }
    /** @soyTemplate */ renderLineRipple() {
        return this.outlined ? '' : (0, $dEBa6.html)`
      <span .lineRippleFoundation=${(0, $3ddFX.lineRipple)()}></span>
    `;
    }
    /** @soyTemplate */ renderHelperText(shouldRenderHelperText, shouldRenderCharCounter) {
        const showValidationMessage = this.validationMessage && !this.isUiValid;
        /** @classMap */ const classes = {
            'mdc-text-field-helper-text--persistent': this.helperPersistent,
            'mdc-text-field-helper-text--validation-msg': showValidationMessage
        };
        const ariaHiddenOrUndef = this.focused || this.helperPersistent || showValidationMessage ? undefined : 'true';
        const helperText = showValidationMessage ? this.validationMessage : this.helper;
        return !shouldRenderHelperText ? '' : (0, $dEBa6.html)`
      <div class="mdc-text-field-helper-line">
        <div id="helper-text"
             aria-hidden="${(0, $eBGeQ.ifDefined)(ariaHiddenOrUndef)}"
             class="mdc-text-field-helper-text ${(0, $lvqMI.classMap)(classes)}"
             >${helperText}</div>
        ${this.renderCharCounter(shouldRenderCharCounter)}
      </div>`;
    }
    /** @soyTemplate */ renderCharCounter(shouldRenderCharCounter) {
        const length = Math.min(this.value.length, this.maxLength);
        return !shouldRenderCharCounter ? '' : (0, $dEBa6.html)`
      <span class="mdc-text-field-character-counter"
            >${length} / ${this.maxLength}</span>`;
    }
    onInputFocus() {
        this.focused = true;
    }
    onInputBlur() {
        this.focused = false;
        this.reportValidity();
    }
    checkValidity() {
        const isValid = this._checkValidity(this.value);
        if (!isValid) {
            const invalidEvent = new Event('invalid', {
                bubbles: false,
                cancelable: true
            });
            this.dispatchEvent(invalidEvent);
        }
        return isValid;
    }
    reportValidity() {
        const isValid = this.checkValidity();
        this.mdcFoundation.setValid(isValid);
        this.isUiValid = isValid;
        return isValid;
    }
    _checkValidity(value) {
        const nativeValidity = this.formElement.validity;
        let validity = $5e97596efa728e55$var$createValidityObj(nativeValidity);
        if (this.validityTransform) {
            const customValidity = this.validityTransform(value, validity);
            validity = Object.assign(Object.assign({}, validity), customValidity);
            this.mdcFoundation.setUseNativeValidation(false);
        } else this.mdcFoundation.setUseNativeValidation(true);
        this._validity = validity;
        return this._validity.valid;
    }
    setCustomValidity(message) {
        this.validationMessage = message;
        this.formElement.setCustomValidity(message);
    }
    handleInputChange() {
        this.value = this.formElement.value;
    }
    createAdapter() {
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, this.getRootAdapterMethods()), this.getInputAdapterMethods()), this.getLabelAdapterMethods()), this.getLineRippleAdapterMethods()), this.getOutlineAdapterMethods());
    }
    getRootAdapterMethods() {
        return Object.assign({
            registerTextFieldInteractionHandler: (evtType, handler)=>this.addEventListener(evtType, handler),
            deregisterTextFieldInteractionHandler: (evtType, handler)=>this.removeEventListener(evtType, handler),
            registerValidationAttributeChangeHandler: (handler)=>{
                const getAttributesList = (mutationsList)=>{
                    return mutationsList.map((mutation)=>mutation.attributeName).filter((attributeName)=>attributeName);
                };
                const observer = new MutationObserver((mutationsList)=>{
                    handler(getAttributesList(mutationsList));
                });
                const config = {
                    attributes: true
                };
                observer.observe(this.formElement, config);
                return observer;
            },
            deregisterValidationAttributeChangeHandler: (observer)=>observer.disconnect()
        }, (0, $gSEYT.addHasRemoveClass)(this.mdcRoot));
    }
    getInputAdapterMethods() {
        return {
            getNativeInput: ()=>this.formElement,
            // since HelperTextFoundation is not used, aria-describedby a11y logic
            // is implemented in render method instead of these adapter methods
            setInputAttr: ()=>undefined,
            removeInputAttr: ()=>undefined,
            isFocused: ()=>this.shadowRoot ? this.shadowRoot.activeElement === this.formElement : false,
            registerInputInteractionHandler: (evtType, handler)=>this.formElement.addEventListener(evtType, handler, {
                    passive: evtType in $5e97596efa728e55$var$passiveEvents
                }),
            deregisterInputInteractionHandler: (evtType, handler)=>this.formElement.removeEventListener(evtType, handler)
        };
    }
    getLabelAdapterMethods() {
        return {
            floatLabel: (shouldFloat)=>this.labelElement && this.labelElement.floatingLabelFoundation.float(shouldFloat),
            getLabelWidth: ()=>{
                return this.labelElement ? this.labelElement.floatingLabelFoundation.getWidth() : 0;
            },
            hasLabel: ()=>Boolean(this.labelElement),
            shakeLabel: (shouldShake)=>this.labelElement && this.labelElement.floatingLabelFoundation.shake(shouldShake),
            setLabelRequired: (isRequired)=>{
                if (this.labelElement) this.labelElement.floatingLabelFoundation.setRequired(isRequired);
            }
        };
    }
    getLineRippleAdapterMethods() {
        return {
            activateLineRipple: ()=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.activate();
            },
            deactivateLineRipple: ()=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.deactivate();
            },
            setLineRippleTransformOrigin: (normalizedX)=>{
                if (this.lineRippleElement) this.lineRippleElement.lineRippleFoundation.setRippleCenter(normalizedX);
            }
        };
    }
    // tslint:disable:ban-ts-ignore
    async getUpdateComplete() {
        var _a;
        // @ts-ignore
        const result = await super.getUpdateComplete();
        await ((_a = this.outlineElement) === null || _a === void 0 ? void 0 : _a.updateComplete);
        return result;
    }
    // tslint:enable:ban-ts-ignore
    firstUpdated() {
        var _a;
        super.firstUpdated();
        this.mdcFoundation.setValidateOnValueChange(this.autoValidate);
        if (this.validateOnInitialRender) this.reportValidity();
        // wait for the outline element to render to update the notch width
        (_a = this.outlineElement) === null || _a === void 0 || _a.updateComplete.then(()=>{
            var _a;
            // `foundation.notchOutline()` assumes the label isn't floating and
            // multiplies by a constant, but the label is already is floating at this
            // stage, therefore directly set the outline width to the label width
            this.outlineWidth = ((_a = this.labelElement) === null || _a === void 0 ? void 0 : _a.floatingLabelFoundation.getWidth()) || 0;
        });
    }
    getOutlineAdapterMethods() {
        return {
            closeOutline: ()=>this.outlineElement && (this.outlineOpen = false),
            hasOutline: ()=>Boolean(this.outlineElement),
            notchOutline: (labelWidth)=>{
                const outlineElement = this.outlineElement;
                if (outlineElement && !this.outlineOpen) {
                    this.outlineWidth = labelWidth;
                    this.outlineOpen = true;
                }
            }
        };
    }
    async layout() {
        await this.updateComplete;
        const labelElement = this.labelElement;
        if (!labelElement) {
            this.outlineOpen = false;
            return;
        }
        const shouldFloat = !!this.label && !!this.value;
        labelElement.floatingLabelFoundation.float(shouldFloat);
        if (!this.outlined) return;
        this.outlineOpen = shouldFloat;
        await this.updateComplete;
        /* When the textfield automatically notches due to a value and label
         * being defined, the textfield may be set to `display: none` by the user.
         * this means that the notch is of size 0px. We provide this function so
         * that the user may manually resize the notch to the floated label's
         * width.
         */ const labelWidth = labelElement.floatingLabelFoundation.getWidth();
        if (this.outlineOpen) {
            this.outlineWidth = labelWidth;
            await this.updateComplete;
        }
    }
}
(0, $czHfO.__decorate)([
    (0, $i6Q5l.query)('.mdc-text-field')
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $i6Q5l.query)('input')
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "formElement", void 0);
(0, $czHfO.__decorate)([
    (0, $i6Q5l.query)('.mdc-floating-label')
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "labelElement", void 0);
(0, $czHfO.__decorate)([
    (0, $i6Q5l.query)('.mdc-line-ripple')
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "lineRippleElement", void 0);
(0, $czHfO.__decorate)([
    (0, $i6Q5l.query)('mwc-notched-outline')
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "outlineElement", void 0);
(0, $czHfO.__decorate)([
    (0, $i6Q5l.query)('.mdc-notched-outline__notch')
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "notchElement", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "value", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "type", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "placeholder", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    }),
    (0, $k4Ngf.observer)(function(_newVal, oldVal) {
        if (oldVal !== undefined && this.label !== oldVal) this.layout();
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "label", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "icon", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "iconTrailing", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean,
        reflect: true
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "disabled", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "required", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Number
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "minLength", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Number
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "maxLength", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean,
        reflect: true
    }),
    (0, $k4Ngf.observer)(function(_newVal, oldVal) {
        if (oldVal !== undefined && this.outlined !== oldVal) this.layout();
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "outlined", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "helper", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "validateOnInitialRender", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "validationMessage", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "autoValidate", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "pattern", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "min", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "max", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "step", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Number
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "size", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "helperPersistent", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "charCounter", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "endAligned", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "prefix", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "suffix", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "name", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "inputMode", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: Boolean
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "readOnly", void 0);
(0, $czHfO.__decorate)([
    (0, $avP5s.property)({
        type: String
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "autocapitalize", void 0);
(0, $czHfO.__decorate)([
    (0, $h9Q79.state)()
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "outlineOpen", void 0);
(0, $czHfO.__decorate)([
    (0, $h9Q79.state)()
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "outlineWidth", void 0);
(0, $czHfO.__decorate)([
    (0, $h9Q79.state)()
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "isUiValid", void 0);
(0, $czHfO.__decorate)([
    (0, $h9Q79.state)()
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "focused", void 0);
(0, $czHfO.__decorate)([
    (0, $jYmjf.eventOptions)({
        passive: true
    })
], $5e97596efa728e55$export$d22444a338b6e3c2.prototype, "handleInputChange", null);

});
parcelRegister("5auXy", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("dvKNA");
var $dUhCH = parcelRequire("dUhCH");

var $6uLwX = parcelRequire("6uLwX");

var $2G48P = parcelRequire("2G48P");
let $3c35e6d974ecb3c5$export$3058494686005c96 = class NotchedOutline extends (0, $6uLwX.NotchedOutlineBase) {
};
$3c35e6d974ecb3c5$export$3058494686005c96.styles = [
    (0, $2G48P.styles)
];
$3c35e6d974ecb3c5$export$3058494686005c96 = (0, $czHfO.__decorate)([
    (0, $dUhCH.customElement)('mwc-notched-outline')
], $3c35e6d974ecb3c5$export$3058494686005c96);

});
parcelRegister("dvKNA", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("dUhCH")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("bdR0n")).property);
$parcel$export(module.exports, "query", () => (parcelRequire("jSSYG")).query);
parcelRequire("dUhCH");
parcelRequire("bdR0n");
parcelRequire("dr8qn");
parcelRequire("a0fq7");
parcelRequire("jSSYG");
parcelRequire("btymy");
parcelRequire("ag2d6");
parcelRequire("3JyQv");
parcelRequire("3FRI7");

});
parcelRegister("dUhCH", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $a1fe2ced9acdba95$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a1fe2ced9acdba95$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("bdR0n", function(module, exports) {

$parcel$export(module.exports, "property", () => $82ba064a307f32c2$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $82ba064a307f32c2$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $82ba064a307f32c2$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $82ba064a307f32c2$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $82ba064a307f32c2$var$e(n, t, o) : $82ba064a307f32c2$var$i(n, t);
}

});

parcelRegister("dr8qn", function(module, exports) {

var $bdR0n = parcelRequire("bdR0n");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9c8454e4b5239ed8$export$ca000e230c0caa3e(t) {
    return (0, $bdR0n.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("a0fq7", function(module, exports) {

var $a6FZN = parcelRequire("a6FZN");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7485dd982b775bfe$export$b2b799818fbabcf3(e) {
    return (0, $a6FZN.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("a6FZN", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", () => $75bb0a6a51df321c$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $75bb0a6a51df321c$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $75bb0a6a51df321c$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $75bb0a6a51df321c$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("jSSYG", function(module, exports) {

$parcel$export(module.exports, "query", () => $e79db4e646ac6f94$export$2fa187e846a241c4);

var $a6FZN = parcelRequire("a6FZN");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e79db4e646ac6f94$export$2fa187e846a241c4(i, n) {
    return (0, $a6FZN.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("btymy", function(module, exports) {

var $a6FZN = parcelRequire("a6FZN");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $85ad0ee0042d0557$export$dcd0d083aa86c355(e) {
    return (0, $a6FZN.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("ag2d6", function(module, exports) {

var $a6FZN = parcelRequire("a6FZN");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $777d1cf3dc4ef21e$export$163dfc35cc43f240(e) {
    return (0, $a6FZN.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("3JyQv", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $2b809ab6ce55819e$export$4682af2d9ee91415);

var $a6FZN = parcelRequire("a6FZN");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $2b809ab6ce55819e$var$n;
const $2b809ab6ce55819e$var$e = null != (null === ($2b809ab6ce55819e$var$n = window.HTMLSlotElement) || void 0 === $2b809ab6ce55819e$var$n ? void 0 : $2b809ab6ce55819e$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $2b809ab6ce55819e$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $a6FZN.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $2b809ab6ce55819e$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("3FRI7", function(module, exports) {

var $a6FZN = parcelRequire("a6FZN");

var $3JyQv = parcelRequire("3JyQv");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $2acedd37976f0e2b$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $3JyQv.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $a6FZN.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("6uLwX", function(module, exports) {

$parcel$export(module.exports, "NotchedOutlineBase", () => $4baa6a002bc1d172$export$81f8fe999345ef19);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");

var $4ifWP = parcelRequire("4ifWP");

var $2lCwe = parcelRequire("2lCwe");
parcelRequire("6CRLU");
var $fsepf = parcelRequire("fsepf");
parcelRequire("dvKNA");
var $bdR0n = parcelRequire("bdR0n");
var $jSSYG = parcelRequire("jSSYG");
parcelRequire("7UMn8");
var $2gaKm = parcelRequire("2gaKm");
class $4baa6a002bc1d172$export$81f8fe999345ef19 extends (0, $4ifWP.BaseElement) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $2lCwe.MDCNotchedOutlineFoundation);
        this.width = 0;
        this.open = false;
        this.lastOpen = this.open;
    }
    createAdapter() {
        return {
            addClass: (className)=>this.mdcRoot.classList.add(className),
            removeClass: (className)=>this.mdcRoot.classList.remove(className),
            setNotchWidthProperty: (width)=>this.notchElement.style.setProperty('width', `${width}px`),
            removeNotchWidthProperty: ()=>this.notchElement.style.removeProperty('width')
        };
    }
    openOrClose(shouldOpen, width) {
        if (!this.mdcFoundation) return;
        if (shouldOpen && width !== undefined) this.mdcFoundation.notch(width);
        else this.mdcFoundation.closeNotch();
    }
    render() {
        this.openOrClose(this.open, this.width);
        const classes = (0, $2gaKm.classMap)({
            'mdc-notched-outline--notched': this.open
        });
        return (0, $fsepf.html)`
      <span class="mdc-notched-outline ${classes}">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <slot></slot>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>`;
    }
}
(0, $czHfO.__decorate)([
    (0, $jSSYG.query)('.mdc-notched-outline')
], $4baa6a002bc1d172$export$81f8fe999345ef19.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $bdR0n.property)({
        type: Number
    })
], $4baa6a002bc1d172$export$81f8fe999345ef19.prototype, "width", void 0);
(0, $czHfO.__decorate)([
    (0, $bdR0n.property)({
        type: Boolean,
        reflect: true
    })
], $4baa6a002bc1d172$export$81f8fe999345ef19.prototype, "open", void 0);
(0, $czHfO.__decorate)([
    (0, $jSSYG.query)('.mdc-notched-outline__notch')
], $4baa6a002bc1d172$export$81f8fe999345ef19.prototype, "notchElement", void 0);

});
parcelRegister("4ifWP", function(module, exports) {

$parcel$export(module.exports, "BaseElement", () => $320536c81df891c5$export$a1a7283d3ef4b3a1);
$parcel$export(module.exports, "addHasRemoveClass", () => (parcelRequire("gSEYT")).addHasRemoveClass);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ parcelRequire("hMtRt");
var $858AH = parcelRequire("858AH");

var $gSEYT = parcelRequire("gSEYT");
class $320536c81df891c5$export$a1a7283d3ef4b3a1 extends (0, $858AH.LitElement) {
    click() {
        if (this.mdcRoot) {
            this.mdcRoot.focus();
            this.mdcRoot.click();
            return;
        }
        super.click();
    }
    /**
     * Create and attach the MDC Foundation to the instance
     */ createFoundation() {
        if (this.mdcFoundation !== undefined) this.mdcFoundation.destroy();
        if (this.mdcFoundationClass) {
            this.mdcFoundation = new this.mdcFoundationClass(this.createAdapter());
            this.mdcFoundation.init();
        }
    }
    firstUpdated() {
        this.createFoundation();
    }
}

});
parcelRegister("hMtRt", function(module, exports) {
$parcel$export(module.exports, "LitElement", () => (parcelRequire("858AH")).LitElement);
parcelRequire("gcXA2");
parcelRequire("02zI5");
parcelRequire("858AH");
parcelRequire("cJl4x");

});
parcelRegister("gcXA2", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $bccbfbb94a864ac7$export$c7c07a37856565d);

var $9EFVB = parcelRequire("9EFVB");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $bccbfbb94a864ac7$var$s;
const $bccbfbb94a864ac7$var$e = window, $bccbfbb94a864ac7$var$r = $bccbfbb94a864ac7$var$e.trustedTypes, $bccbfbb94a864ac7$var$h = $bccbfbb94a864ac7$var$r ? $bccbfbb94a864ac7$var$r.emptyScript : "", $bccbfbb94a864ac7$var$o = $bccbfbb94a864ac7$var$e.reactiveElementPolyfillSupport, $bccbfbb94a864ac7$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $bccbfbb94a864ac7$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $bccbfbb94a864ac7$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $bccbfbb94a864ac7$var$l = {
    attribute: !0,
    type: String,
    converter: $bccbfbb94a864ac7$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $bccbfbb94a864ac7$export$53a6892c50694894
}, $bccbfbb94a864ac7$var$d = "finalized";
class $bccbfbb94a864ac7$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $bccbfbb94a864ac7$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $bccbfbb94a864ac7$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($bccbfbb94a864ac7$var$d)) return !1;
        this[$bccbfbb94a864ac7$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $9EFVB.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $9EFVB.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $9EFVB.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $bccbfbb94a864ac7$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $bccbfbb94a864ac7$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $bccbfbb94a864ac7$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $bccbfbb94a864ac7$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$bccbfbb94a864ac7$export$c7c07a37856565d[$bccbfbb94a864ac7$var$d] = !0, $bccbfbb94a864ac7$export$c7c07a37856565d.elementProperties = new Map, $bccbfbb94a864ac7$export$c7c07a37856565d.elementStyles = [], $bccbfbb94a864ac7$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $bccbfbb94a864ac7$var$o || $bccbfbb94a864ac7$var$o({
    ReactiveElement: $bccbfbb94a864ac7$export$c7c07a37856565d
}), (null !== ($bccbfbb94a864ac7$var$s = $bccbfbb94a864ac7$var$e.reactiveElementVersions) && void 0 !== $bccbfbb94a864ac7$var$s ? $bccbfbb94a864ac7$var$s : $bccbfbb94a864ac7$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("9EFVB", function(module, exports) {

$parcel$export(module.exports, "adoptStyles", () => $70785f853484f0e0$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $70785f853484f0e0$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $70785f853484f0e0$var$t = window, $70785f853484f0e0$export$b4d10f6001c083c2 = $70785f853484f0e0$var$t.ShadowRoot && (void 0 === $70785f853484f0e0$var$t.ShadyCSS || $70785f853484f0e0$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $70785f853484f0e0$var$s = Symbol(), $70785f853484f0e0$var$n = new WeakMap;
class $70785f853484f0e0$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $70785f853484f0e0$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($70785f853484f0e0$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $70785f853484f0e0$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $70785f853484f0e0$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $70785f853484f0e0$export$8d80f9cac07cdb3 = (t)=>new $70785f853484f0e0$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $70785f853484f0e0$var$s), $70785f853484f0e0$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $70785f853484f0e0$export$505d1e8739bad805(n, t, $70785f853484f0e0$var$s);
}, $70785f853484f0e0$export$2ca4a66ec4cecb90 = (s, n)=>{
    $70785f853484f0e0$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $70785f853484f0e0$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $70785f853484f0e0$export$ee69dfd951e24778 = $70785f853484f0e0$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $70785f853484f0e0$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("02zI5", function(module, exports) {

$parcel$export(module.exports, "noChange", () => $007be34f3e7fd91f$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "render", () => $007be34f3e7fd91f$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $007be34f3e7fd91f$var$t;
const $007be34f3e7fd91f$var$i = window, $007be34f3e7fd91f$var$s = $007be34f3e7fd91f$var$i.trustedTypes, $007be34f3e7fd91f$var$e = $007be34f3e7fd91f$var$s ? $007be34f3e7fd91f$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $007be34f3e7fd91f$var$o = "$lit$", $007be34f3e7fd91f$var$n = `lit$${(Math.random() + "").slice(9)}$`, $007be34f3e7fd91f$var$l = "?" + $007be34f3e7fd91f$var$n, $007be34f3e7fd91f$var$h = `<${$007be34f3e7fd91f$var$l}>`, $007be34f3e7fd91f$var$r = document, $007be34f3e7fd91f$var$u = ()=>$007be34f3e7fd91f$var$r.createComment(""), $007be34f3e7fd91f$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $007be34f3e7fd91f$var$c = Array.isArray, $007be34f3e7fd91f$var$v = (t)=>$007be34f3e7fd91f$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $007be34f3e7fd91f$var$a = "[ \t\n\f\r]", $007be34f3e7fd91f$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $007be34f3e7fd91f$var$_ = /-->/g, $007be34f3e7fd91f$var$m = />/g, $007be34f3e7fd91f$var$p = RegExp(`>|${$007be34f3e7fd91f$var$a}(?:([^\\s"'>=/]+)(${$007be34f3e7fd91f$var$a}*=${$007be34f3e7fd91f$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $007be34f3e7fd91f$var$g = /'/g, $007be34f3e7fd91f$var$$ = /"/g, $007be34f3e7fd91f$var$y = /^(?:script|style|textarea|title)$/i, $007be34f3e7fd91f$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $007be34f3e7fd91f$export$c0bb0b647f701bb5 = $007be34f3e7fd91f$var$w(1), $007be34f3e7fd91f$export$7ed1367e7fa1ad68 = $007be34f3e7fd91f$var$w(2), $007be34f3e7fd91f$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $007be34f3e7fd91f$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $007be34f3e7fd91f$var$E = new WeakMap, $007be34f3e7fd91f$var$C = $007be34f3e7fd91f$var$r.createTreeWalker($007be34f3e7fd91f$var$r, 129, null, !1);
function $007be34f3e7fd91f$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $007be34f3e7fd91f$var$e ? $007be34f3e7fd91f$var$e.createHTML(i) : i;
}
const $007be34f3e7fd91f$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $007be34f3e7fd91f$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $007be34f3e7fd91f$var$f ? "!--" === c[1] ? u = $007be34f3e7fd91f$var$_ : void 0 !== c[1] ? u = $007be34f3e7fd91f$var$m : void 0 !== c[2] ? ($007be34f3e7fd91f$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $007be34f3e7fd91f$var$p) : void 0 !== c[3] && (u = $007be34f3e7fd91f$var$p) : u === $007be34f3e7fd91f$var$p ? ">" === c[0] ? (u = null != l ? l : $007be34f3e7fd91f$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $007be34f3e7fd91f$var$p : '"' === c[3] ? $007be34f3e7fd91f$var$$ : $007be34f3e7fd91f$var$g) : u === $007be34f3e7fd91f$var$$ || u === $007be34f3e7fd91f$var$g ? u = $007be34f3e7fd91f$var$p : u === $007be34f3e7fd91f$var$_ || u === $007be34f3e7fd91f$var$m ? u = $007be34f3e7fd91f$var$f : (u = $007be34f3e7fd91f$var$p, l = void 0);
        const w = u === $007be34f3e7fd91f$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $007be34f3e7fd91f$var$f ? s + $007be34f3e7fd91f$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $007be34f3e7fd91f$var$o + s.slice(v) + $007be34f3e7fd91f$var$n + w) : s + $007be34f3e7fd91f$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $007be34f3e7fd91f$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $007be34f3e7fd91f$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $007be34f3e7fd91f$var$V(t, i);
        if (this.el = $007be34f3e7fd91f$var$N.createElement(a, e), $007be34f3e7fd91f$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $007be34f3e7fd91f$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($007be34f3e7fd91f$var$o) || i.startsWith($007be34f3e7fd91f$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $007be34f3e7fd91f$var$o).split($007be34f3e7fd91f$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $007be34f3e7fd91f$var$H : "?" === i[1] ? $007be34f3e7fd91f$var$L : "@" === i[1] ? $007be34f3e7fd91f$var$z : $007be34f3e7fd91f$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($007be34f3e7fd91f$var$y.test(h.tagName)) {
                    const t = h.textContent.split($007be34f3e7fd91f$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $007be34f3e7fd91f$var$s ? $007be34f3e7fd91f$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $007be34f3e7fd91f$var$u()), $007be34f3e7fd91f$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $007be34f3e7fd91f$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $007be34f3e7fd91f$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($007be34f3e7fd91f$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $007be34f3e7fd91f$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $007be34f3e7fd91f$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $007be34f3e7fd91f$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $007be34f3e7fd91f$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $007be34f3e7fd91f$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $007be34f3e7fd91f$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $007be34f3e7fd91f$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $007be34f3e7fd91f$var$r).importNode(s, !0);
        $007be34f3e7fd91f$var$C.currentNode = o;
        let n = $007be34f3e7fd91f$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $007be34f3e7fd91f$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $007be34f3e7fd91f$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $007be34f3e7fd91f$var$C.nextNode(), l++);
        }
        return $007be34f3e7fd91f$var$C.currentNode = $007be34f3e7fd91f$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $007be34f3e7fd91f$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $007be34f3e7fd91f$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $007be34f3e7fd91f$var$S(this, t, i), $007be34f3e7fd91f$var$d(t) ? t === $007be34f3e7fd91f$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $007be34f3e7fd91f$export$45b790e32b2810ee && this._$AR(), this._$AH = $007be34f3e7fd91f$export$45b790e32b2810ee) : t !== this._$AH && t !== $007be34f3e7fd91f$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $007be34f3e7fd91f$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $007be34f3e7fd91f$export$45b790e32b2810ee && $007be34f3e7fd91f$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($007be34f3e7fd91f$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $007be34f3e7fd91f$var$N.createElement($007be34f3e7fd91f$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $007be34f3e7fd91f$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $007be34f3e7fd91f$var$E.get(t.strings);
        return void 0 === i && $007be34f3e7fd91f$var$E.set(t.strings, i = new $007be34f3e7fd91f$var$N(t)), i;
    }
    T(t) {
        $007be34f3e7fd91f$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $007be34f3e7fd91f$var$R(this.k($007be34f3e7fd91f$var$u()), this.k($007be34f3e7fd91f$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $007be34f3e7fd91f$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $007be34f3e7fd91f$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $007be34f3e7fd91f$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $007be34f3e7fd91f$var$S(this, t, i, 0), n = !$007be34f3e7fd91f$var$d(t) || t !== this._$AH && t !== $007be34f3e7fd91f$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $007be34f3e7fd91f$var$S(this, e[s + l], i, l), h === $007be34f3e7fd91f$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$007be34f3e7fd91f$var$d(h) || h !== this._$AH[l]), h === $007be34f3e7fd91f$export$45b790e32b2810ee ? t = $007be34f3e7fd91f$export$45b790e32b2810ee : t !== $007be34f3e7fd91f$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $007be34f3e7fd91f$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $007be34f3e7fd91f$var$H extends $007be34f3e7fd91f$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $007be34f3e7fd91f$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $007be34f3e7fd91f$var$I = $007be34f3e7fd91f$var$s ? $007be34f3e7fd91f$var$s.emptyScript : "";
class $007be34f3e7fd91f$var$L extends $007be34f3e7fd91f$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $007be34f3e7fd91f$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $007be34f3e7fd91f$var$I) : this.element.removeAttribute(this.name);
    }
}
class $007be34f3e7fd91f$var$z extends $007be34f3e7fd91f$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $007be34f3e7fd91f$var$S(this, t, i, 0)) && void 0 !== s ? s : $007be34f3e7fd91f$export$45b790e32b2810ee) === $007be34f3e7fd91f$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $007be34f3e7fd91f$export$45b790e32b2810ee && e !== $007be34f3e7fd91f$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $007be34f3e7fd91f$export$45b790e32b2810ee && (e === $007be34f3e7fd91f$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $007be34f3e7fd91f$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $007be34f3e7fd91f$var$S(this, t);
    }
}
const $007be34f3e7fd91f$export$8613d1ca9052b22e = {
    O: $007be34f3e7fd91f$var$o,
    P: $007be34f3e7fd91f$var$n,
    A: $007be34f3e7fd91f$var$l,
    C: 1,
    M: $007be34f3e7fd91f$var$V,
    L: $007be34f3e7fd91f$var$M,
    R: $007be34f3e7fd91f$var$v,
    D: $007be34f3e7fd91f$var$S,
    I: $007be34f3e7fd91f$var$R,
    V: $007be34f3e7fd91f$var$k,
    H: $007be34f3e7fd91f$var$L,
    N: $007be34f3e7fd91f$var$z,
    U: $007be34f3e7fd91f$var$H,
    F: $007be34f3e7fd91f$var$Z
}, $007be34f3e7fd91f$var$B = $007be34f3e7fd91f$var$i.litHtmlPolyfillSupport;
null == $007be34f3e7fd91f$var$B || $007be34f3e7fd91f$var$B($007be34f3e7fd91f$var$N, $007be34f3e7fd91f$var$R), (null !== ($007be34f3e7fd91f$var$t = $007be34f3e7fd91f$var$i.litHtmlVersions) && void 0 !== $007be34f3e7fd91f$var$t ? $007be34f3e7fd91f$var$t : $007be34f3e7fd91f$var$i.litHtmlVersions = []).push("2.8.0");
const $007be34f3e7fd91f$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $007be34f3e7fd91f$var$R(i.insertBefore($007be34f3e7fd91f$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("858AH", function(module, exports) {

$parcel$export(module.exports, "LitElement", () => $5e257459aa47f365$export$3f2f9f5909897157);

var $gcXA2 = parcelRequire("gcXA2");

var $02zI5 = parcelRequire("02zI5");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $5e257459aa47f365$var$l, $5e257459aa47f365$var$o;
const $5e257459aa47f365$export$8bf27daf9e8907c9 = (0, $gcXA2.ReactiveElement);
class $5e257459aa47f365$export$3f2f9f5909897157 extends (0, $gcXA2.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $02zI5.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $02zI5.noChange;
    }
}
$5e257459aa47f365$export$3f2f9f5909897157.finalized = !0, $5e257459aa47f365$export$3f2f9f5909897157._$litElement$ = !0, null === ($5e257459aa47f365$var$l = globalThis.litElementHydrateSupport) || void 0 === $5e257459aa47f365$var$l || $5e257459aa47f365$var$l.call(globalThis, {
    LitElement: $5e257459aa47f365$export$3f2f9f5909897157
});
const $5e257459aa47f365$var$n = globalThis.litElementPolyfillSupport;
null == $5e257459aa47f365$var$n || $5e257459aa47f365$var$n({
    LitElement: $5e257459aa47f365$export$3f2f9f5909897157
});
const $5e257459aa47f365$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($5e257459aa47f365$var$o = globalThis.litElementVersions) && void 0 !== $5e257459aa47f365$var$o ? $5e257459aa47f365$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("cJl4x", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $944a087fa93a90f3$export$6acf61af03e62db = !1;

});


parcelRegister("gSEYT", function(module, exports) {

$parcel$export(module.exports, "isNodeElement", () => $c4a17a807123068a$export$c86dc70db5dbb27d);
$parcel$export(module.exports, "addHasRemoveClass", () => $c4a17a807123068a$export$122d35ad43dccfa3);
$parcel$export(module.exports, "supportsPassiveEventListener", () => $c4a17a807123068a$export$dd8b371dc4bf436e);
$parcel$export(module.exports, "deepActiveElementPath", () => $c4a17a807123068a$export$8b6ad084041b2343);
$parcel$export(module.exports, "doesElementContainFocus", () => $c4a17a807123068a$export$597abdf7826dd64a);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
/**
 * Determines whether a node is an element.
 *
 * @param node Node to check
 */ const $c4a17a807123068a$export$c86dc70db5dbb27d = (node)=>{
    return node.nodeType === Node.ELEMENT_NODE;
};
function $c4a17a807123068a$export$122d35ad43dccfa3(element) {
    return {
        addClass: (className)=>{
            element.classList.add(className);
        },
        removeClass: (className)=>{
            element.classList.remove(className);
        },
        hasClass: (className)=>element.classList.contains(className)
    };
}
let $c4a17a807123068a$var$supportsPassive = false;
const $c4a17a807123068a$var$fn = ()=>{};
const $c4a17a807123068a$var$optionsBlock = {
    get passive () {
        $c4a17a807123068a$var$supportsPassive = true;
        return false;
    }
};
document.addEventListener('x', $c4a17a807123068a$var$fn, $c4a17a807123068a$var$optionsBlock);
document.removeEventListener('x', $c4a17a807123068a$var$fn);
const $c4a17a807123068a$export$dd8b371dc4bf436e = $c4a17a807123068a$var$supportsPassive;
const $c4a17a807123068a$export$8b6ad084041b2343 = (doc = window.document)=>{
    let activeElement = doc.activeElement;
    const path = [];
    if (!activeElement) return path;
    while(activeElement){
        path.push(activeElement);
        if (activeElement.shadowRoot) activeElement = activeElement.shadowRoot.activeElement;
        else break;
    }
    return path;
};
const $c4a17a807123068a$export$597abdf7826dd64a = (element)=>{
    const activePath = $c4a17a807123068a$export$8b6ad084041b2343();
    if (!activePath.length) return false;
    const deepActiveElement = activePath[activePath.length - 1];
    const focusEv = new Event('check-if-focused', {
        bubbles: true,
        composed: true
    });
    let composedPath = [];
    const listener = (ev)=>{
        composedPath = ev.composedPath();
    };
    document.body.addEventListener('check-if-focused', listener);
    deepActiveElement.dispatchEvent(focusEv);
    document.body.removeEventListener('check-if-focused', listener);
    return composedPath.indexOf(element) !== -1;
};

});


parcelRegister("2lCwe", function(module, exports) {

$parcel$export(module.exports, "MDCNotchedOutlineFoundation", () => $1b5b6bfcf773a162$export$1416251f3c23f76c);
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");

var $gQdxd = parcelRequire("gQdxd");

var $dAe6d = parcelRequire("dAe6d");
var $1b5b6bfcf773a162$export$1416251f3c23f76c = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCNotchedOutlineFoundation, _super);
    function MDCNotchedOutlineFoundation(adapter) {
        return _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCNotchedOutlineFoundation.defaultAdapter), adapter)) || this;
    }
    Object.defineProperty(MDCNotchedOutlineFoundation, "strings", {
        get: function() {
            return 0, $dAe6d.strings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCNotchedOutlineFoundation, "cssClasses", {
        get: function() {
            return 0, $dAe6d.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCNotchedOutlineFoundation, "numbers", {
        get: function() {
            return 0, $dAe6d.numbers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCNotchedOutlineFoundation, "defaultAdapter", {
        /**
         * See {@link MDCNotchedOutlineAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                setNotchWidthProperty: function() {
                    return undefined;
                },
                removeNotchWidthProperty: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds the outline notched selector and updates the notch width calculated based off of notchWidth.
     */ MDCNotchedOutlineFoundation.prototype.notch = function(notchWidth) {
        var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
        if (notchWidth > 0) notchWidth += (0, $dAe6d.numbers).NOTCH_ELEMENT_PADDING; // Add padding from left/right.
        this.adapter.setNotchWidthProperty(notchWidth);
        this.adapter.addClass(OUTLINE_NOTCHED);
    };
    /**
     * Removes notched outline selector to close the notch in the outline.
     */ MDCNotchedOutlineFoundation.prototype.closeNotch = function() {
        var OUTLINE_NOTCHED = MDCNotchedOutlineFoundation.cssClasses.OUTLINE_NOTCHED;
        this.adapter.removeClass(OUTLINE_NOTCHED);
        this.adapter.removeNotchWidthProperty();
    };
    return MDCNotchedOutlineFoundation;
}((0, $gQdxd.MDCFoundation));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$1b5b6bfcf773a162$export$2e2bcd8739ae039 = $1b5b6bfcf773a162$export$1416251f3c23f76c;

});
parcelRegister("gQdxd", function(module, exports) {

$parcel$export(module.exports, "MDCFoundation", () => $c42c0062ca56b269$export$a81b11d69c993162);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $c42c0062ca56b269$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$c42c0062ca56b269$export$2e2bcd8739ae039 = $c42c0062ca56b269$export$a81b11d69c993162;

});

parcelRegister("dAe6d", function(module, exports) {

$parcel$export(module.exports, "strings", () => $9e3992f7b4d2f449$export$21c51bc433c16634);
$parcel$export(module.exports, "numbers", () => $9e3992f7b4d2f449$export$1f6c9cc012ebacae);
$parcel$export(module.exports, "cssClasses", () => $9e3992f7b4d2f449$export$c1c0562ec8379000);
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $9e3992f7b4d2f449$export$21c51bc433c16634 = {
    NOTCH_ELEMENT_SELECTOR: '.mdc-notched-outline__notch'
};
var $9e3992f7b4d2f449$export$1f6c9cc012ebacae = {
    // This should stay in sync with $mdc-notched-outline-padding * 2.
    NOTCH_ELEMENT_PADDING: 8
};
var $9e3992f7b4d2f449$export$c1c0562ec8379000 = {
    NO_LABEL: 'mdc-notched-outline--no-label',
    OUTLINE_NOTCHED: 'mdc-notched-outline--notched',
    OUTLINE_UPGRADED: 'mdc-notched-outline--upgraded'
};

});


parcelRegister("6CRLU", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("8UC9o")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("fsepf")).html);
parcelRequire("gJb2w");
parcelRequire("fsepf");
parcelRequire("k7LN0");
parcelRequire("4kgML");

});
parcelRegister("gJb2w", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $c2d9698e8b8ee7aa$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("8UC9o")).css);

var $8UC9o = parcelRequire("8UC9o");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $c2d9698e8b8ee7aa$var$s;
const $c2d9698e8b8ee7aa$var$e = window, $c2d9698e8b8ee7aa$var$r = $c2d9698e8b8ee7aa$var$e.trustedTypes, $c2d9698e8b8ee7aa$var$h = $c2d9698e8b8ee7aa$var$r ? $c2d9698e8b8ee7aa$var$r.emptyScript : "", $c2d9698e8b8ee7aa$var$o = $c2d9698e8b8ee7aa$var$e.reactiveElementPolyfillSupport, $c2d9698e8b8ee7aa$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $c2d9698e8b8ee7aa$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $c2d9698e8b8ee7aa$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $c2d9698e8b8ee7aa$var$l = {
    attribute: !0,
    type: String,
    converter: $c2d9698e8b8ee7aa$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $c2d9698e8b8ee7aa$export$53a6892c50694894
}, $c2d9698e8b8ee7aa$var$d = "finalized";
class $c2d9698e8b8ee7aa$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $c2d9698e8b8ee7aa$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $c2d9698e8b8ee7aa$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($c2d9698e8b8ee7aa$var$d)) return !1;
        this[$c2d9698e8b8ee7aa$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $8UC9o.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $8UC9o.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $8UC9o.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $c2d9698e8b8ee7aa$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $c2d9698e8b8ee7aa$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $c2d9698e8b8ee7aa$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $c2d9698e8b8ee7aa$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$c2d9698e8b8ee7aa$export$c7c07a37856565d[$c2d9698e8b8ee7aa$var$d] = !0, $c2d9698e8b8ee7aa$export$c7c07a37856565d.elementProperties = new Map, $c2d9698e8b8ee7aa$export$c7c07a37856565d.elementStyles = [], $c2d9698e8b8ee7aa$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $c2d9698e8b8ee7aa$var$o || $c2d9698e8b8ee7aa$var$o({
    ReactiveElement: $c2d9698e8b8ee7aa$export$c7c07a37856565d
}), (null !== ($c2d9698e8b8ee7aa$var$s = $c2d9698e8b8ee7aa$var$e.reactiveElementVersions) && void 0 !== $c2d9698e8b8ee7aa$var$s ? $c2d9698e8b8ee7aa$var$s : $c2d9698e8b8ee7aa$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("8UC9o", function(module, exports) {

$parcel$export(module.exports, "css", () => $67d12597e39043f7$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $67d12597e39043f7$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $67d12597e39043f7$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $67d12597e39043f7$var$t = window, $67d12597e39043f7$export$b4d10f6001c083c2 = $67d12597e39043f7$var$t.ShadowRoot && (void 0 === $67d12597e39043f7$var$t.ShadyCSS || $67d12597e39043f7$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $67d12597e39043f7$var$s = Symbol(), $67d12597e39043f7$var$n = new WeakMap;
class $67d12597e39043f7$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $67d12597e39043f7$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($67d12597e39043f7$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $67d12597e39043f7$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $67d12597e39043f7$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $67d12597e39043f7$export$8d80f9cac07cdb3 = (t)=>new $67d12597e39043f7$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $67d12597e39043f7$var$s), $67d12597e39043f7$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $67d12597e39043f7$export$505d1e8739bad805(n, t, $67d12597e39043f7$var$s);
}, $67d12597e39043f7$export$2ca4a66ec4cecb90 = (s, n)=>{
    $67d12597e39043f7$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $67d12597e39043f7$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $67d12597e39043f7$export$ee69dfd951e24778 = $67d12597e39043f7$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $67d12597e39043f7$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("fsepf", function(module, exports) {

$parcel$export(module.exports, "html", () => $b404a54f9383e4d6$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $b404a54f9383e4d6$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "render", () => $b404a54f9383e4d6$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $b404a54f9383e4d6$var$t;
const $b404a54f9383e4d6$var$i = window, $b404a54f9383e4d6$var$s = $b404a54f9383e4d6$var$i.trustedTypes, $b404a54f9383e4d6$var$e = $b404a54f9383e4d6$var$s ? $b404a54f9383e4d6$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $b404a54f9383e4d6$var$o = "$lit$", $b404a54f9383e4d6$var$n = `lit$${(Math.random() + "").slice(9)}$`, $b404a54f9383e4d6$var$l = "?" + $b404a54f9383e4d6$var$n, $b404a54f9383e4d6$var$h = `<${$b404a54f9383e4d6$var$l}>`, $b404a54f9383e4d6$var$r = document, $b404a54f9383e4d6$var$u = ()=>$b404a54f9383e4d6$var$r.createComment(""), $b404a54f9383e4d6$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $b404a54f9383e4d6$var$c = Array.isArray, $b404a54f9383e4d6$var$v = (t)=>$b404a54f9383e4d6$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $b404a54f9383e4d6$var$a = "[ \t\n\f\r]", $b404a54f9383e4d6$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $b404a54f9383e4d6$var$_ = /-->/g, $b404a54f9383e4d6$var$m = />/g, $b404a54f9383e4d6$var$p = RegExp(`>|${$b404a54f9383e4d6$var$a}(?:([^\\s"'>=/]+)(${$b404a54f9383e4d6$var$a}*=${$b404a54f9383e4d6$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $b404a54f9383e4d6$var$g = /'/g, $b404a54f9383e4d6$var$$ = /"/g, $b404a54f9383e4d6$var$y = /^(?:script|style|textarea|title)$/i, $b404a54f9383e4d6$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $b404a54f9383e4d6$export$c0bb0b647f701bb5 = $b404a54f9383e4d6$var$w(1), $b404a54f9383e4d6$export$7ed1367e7fa1ad68 = $b404a54f9383e4d6$var$w(2), $b404a54f9383e4d6$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $b404a54f9383e4d6$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $b404a54f9383e4d6$var$E = new WeakMap, $b404a54f9383e4d6$var$C = $b404a54f9383e4d6$var$r.createTreeWalker($b404a54f9383e4d6$var$r, 129, null, !1);
function $b404a54f9383e4d6$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $b404a54f9383e4d6$var$e ? $b404a54f9383e4d6$var$e.createHTML(i) : i;
}
const $b404a54f9383e4d6$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $b404a54f9383e4d6$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $b404a54f9383e4d6$var$f ? "!--" === c[1] ? u = $b404a54f9383e4d6$var$_ : void 0 !== c[1] ? u = $b404a54f9383e4d6$var$m : void 0 !== c[2] ? ($b404a54f9383e4d6$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $b404a54f9383e4d6$var$p) : void 0 !== c[3] && (u = $b404a54f9383e4d6$var$p) : u === $b404a54f9383e4d6$var$p ? ">" === c[0] ? (u = null != l ? l : $b404a54f9383e4d6$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $b404a54f9383e4d6$var$p : '"' === c[3] ? $b404a54f9383e4d6$var$$ : $b404a54f9383e4d6$var$g) : u === $b404a54f9383e4d6$var$$ || u === $b404a54f9383e4d6$var$g ? u = $b404a54f9383e4d6$var$p : u === $b404a54f9383e4d6$var$_ || u === $b404a54f9383e4d6$var$m ? u = $b404a54f9383e4d6$var$f : (u = $b404a54f9383e4d6$var$p, l = void 0);
        const w = u === $b404a54f9383e4d6$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $b404a54f9383e4d6$var$f ? s + $b404a54f9383e4d6$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $b404a54f9383e4d6$var$o + s.slice(v) + $b404a54f9383e4d6$var$n + w) : s + $b404a54f9383e4d6$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $b404a54f9383e4d6$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $b404a54f9383e4d6$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $b404a54f9383e4d6$var$V(t, i);
        if (this.el = $b404a54f9383e4d6$var$N.createElement(a, e), $b404a54f9383e4d6$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $b404a54f9383e4d6$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($b404a54f9383e4d6$var$o) || i.startsWith($b404a54f9383e4d6$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $b404a54f9383e4d6$var$o).split($b404a54f9383e4d6$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $b404a54f9383e4d6$var$H : "?" === i[1] ? $b404a54f9383e4d6$var$L : "@" === i[1] ? $b404a54f9383e4d6$var$z : $b404a54f9383e4d6$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($b404a54f9383e4d6$var$y.test(h.tagName)) {
                    const t = h.textContent.split($b404a54f9383e4d6$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $b404a54f9383e4d6$var$s ? $b404a54f9383e4d6$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $b404a54f9383e4d6$var$u()), $b404a54f9383e4d6$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $b404a54f9383e4d6$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $b404a54f9383e4d6$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($b404a54f9383e4d6$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $b404a54f9383e4d6$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $b404a54f9383e4d6$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $b404a54f9383e4d6$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $b404a54f9383e4d6$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $b404a54f9383e4d6$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $b404a54f9383e4d6$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $b404a54f9383e4d6$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $b404a54f9383e4d6$var$r).importNode(s, !0);
        $b404a54f9383e4d6$var$C.currentNode = o;
        let n = $b404a54f9383e4d6$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $b404a54f9383e4d6$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $b404a54f9383e4d6$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $b404a54f9383e4d6$var$C.nextNode(), l++);
        }
        return $b404a54f9383e4d6$var$C.currentNode = $b404a54f9383e4d6$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $b404a54f9383e4d6$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $b404a54f9383e4d6$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $b404a54f9383e4d6$var$S(this, t, i), $b404a54f9383e4d6$var$d(t) ? t === $b404a54f9383e4d6$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $b404a54f9383e4d6$export$45b790e32b2810ee && this._$AR(), this._$AH = $b404a54f9383e4d6$export$45b790e32b2810ee) : t !== this._$AH && t !== $b404a54f9383e4d6$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $b404a54f9383e4d6$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $b404a54f9383e4d6$export$45b790e32b2810ee && $b404a54f9383e4d6$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($b404a54f9383e4d6$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $b404a54f9383e4d6$var$N.createElement($b404a54f9383e4d6$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $b404a54f9383e4d6$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $b404a54f9383e4d6$var$E.get(t.strings);
        return void 0 === i && $b404a54f9383e4d6$var$E.set(t.strings, i = new $b404a54f9383e4d6$var$N(t)), i;
    }
    T(t) {
        $b404a54f9383e4d6$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $b404a54f9383e4d6$var$R(this.k($b404a54f9383e4d6$var$u()), this.k($b404a54f9383e4d6$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $b404a54f9383e4d6$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $b404a54f9383e4d6$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $b404a54f9383e4d6$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $b404a54f9383e4d6$var$S(this, t, i, 0), n = !$b404a54f9383e4d6$var$d(t) || t !== this._$AH && t !== $b404a54f9383e4d6$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $b404a54f9383e4d6$var$S(this, e[s + l], i, l), h === $b404a54f9383e4d6$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$b404a54f9383e4d6$var$d(h) || h !== this._$AH[l]), h === $b404a54f9383e4d6$export$45b790e32b2810ee ? t = $b404a54f9383e4d6$export$45b790e32b2810ee : t !== $b404a54f9383e4d6$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $b404a54f9383e4d6$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $b404a54f9383e4d6$var$H extends $b404a54f9383e4d6$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $b404a54f9383e4d6$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $b404a54f9383e4d6$var$I = $b404a54f9383e4d6$var$s ? $b404a54f9383e4d6$var$s.emptyScript : "";
class $b404a54f9383e4d6$var$L extends $b404a54f9383e4d6$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $b404a54f9383e4d6$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $b404a54f9383e4d6$var$I) : this.element.removeAttribute(this.name);
    }
}
class $b404a54f9383e4d6$var$z extends $b404a54f9383e4d6$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $b404a54f9383e4d6$var$S(this, t, i, 0)) && void 0 !== s ? s : $b404a54f9383e4d6$export$45b790e32b2810ee) === $b404a54f9383e4d6$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $b404a54f9383e4d6$export$45b790e32b2810ee && e !== $b404a54f9383e4d6$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $b404a54f9383e4d6$export$45b790e32b2810ee && (e === $b404a54f9383e4d6$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $b404a54f9383e4d6$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $b404a54f9383e4d6$var$S(this, t);
    }
}
const $b404a54f9383e4d6$export$8613d1ca9052b22e = {
    O: $b404a54f9383e4d6$var$o,
    P: $b404a54f9383e4d6$var$n,
    A: $b404a54f9383e4d6$var$l,
    C: 1,
    M: $b404a54f9383e4d6$var$V,
    L: $b404a54f9383e4d6$var$M,
    R: $b404a54f9383e4d6$var$v,
    D: $b404a54f9383e4d6$var$S,
    I: $b404a54f9383e4d6$var$R,
    V: $b404a54f9383e4d6$var$k,
    H: $b404a54f9383e4d6$var$L,
    N: $b404a54f9383e4d6$var$z,
    U: $b404a54f9383e4d6$var$H,
    F: $b404a54f9383e4d6$var$Z
}, $b404a54f9383e4d6$var$B = $b404a54f9383e4d6$var$i.litHtmlPolyfillSupport;
null == $b404a54f9383e4d6$var$B || $b404a54f9383e4d6$var$B($b404a54f9383e4d6$var$N, $b404a54f9383e4d6$var$R), (null !== ($b404a54f9383e4d6$var$t = $b404a54f9383e4d6$var$i.litHtmlVersions) && void 0 !== $b404a54f9383e4d6$var$t ? $b404a54f9383e4d6$var$t : $b404a54f9383e4d6$var$i.litHtmlVersions = []).push("2.8.0");
const $b404a54f9383e4d6$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $b404a54f9383e4d6$var$R(i.insertBefore($b404a54f9383e4d6$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("k7LN0", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("8UC9o")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("gJb2w")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("fsepf")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("fsepf")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("fsepf")).render);

var $gJb2w = parcelRequire("gJb2w");

var $fsepf = parcelRequire("fsepf");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $ea69881756b16962$var$l, $ea69881756b16962$var$o;
const $ea69881756b16962$export$8bf27daf9e8907c9 = (0, $gJb2w.ReactiveElement);
class $ea69881756b16962$export$3f2f9f5909897157 extends (0, $gJb2w.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $fsepf.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $fsepf.noChange;
    }
}
$ea69881756b16962$export$3f2f9f5909897157.finalized = !0, $ea69881756b16962$export$3f2f9f5909897157._$litElement$ = !0, null === ($ea69881756b16962$var$l = globalThis.litElementHydrateSupport) || void 0 === $ea69881756b16962$var$l || $ea69881756b16962$var$l.call(globalThis, {
    LitElement: $ea69881756b16962$export$3f2f9f5909897157
});
const $ea69881756b16962$var$n = globalThis.litElementPolyfillSupport;
null == $ea69881756b16962$var$n || $ea69881756b16962$var$n({
    LitElement: $ea69881756b16962$export$3f2f9f5909897157
});
const $ea69881756b16962$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($ea69881756b16962$var$o = globalThis.litElementVersions) && void 0 !== $ea69881756b16962$var$o ? $ea69881756b16962$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("4kgML", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $32660cf238e79f38$export$6acf61af03e62db = !1;

});


parcelRegister("7UMn8", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("2gaKm")).classMap);
parcelRequire("2gaKm");

});
parcelRegister("2gaKm", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $1a556975fe3e1471$export$56cc687933817664);

var $fsepf = parcelRequire("fsepf");

var $flhW8 = parcelRequire("flhW8");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1a556975fe3e1471$export$56cc687933817664 = (0, $flhW8.directive)(class extends (0, $flhW8.Directive) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $flhW8.PartType).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $fsepf.noChange;
    }
});

});
parcelRegister("flhW8", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $b2b6bb09031ea6ef$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $b2b6bb09031ea6ef$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $b2b6bb09031ea6ef$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b2b6bb09031ea6ef$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $b2b6bb09031ea6ef$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $b2b6bb09031ea6ef$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});




parcelRegister("2G48P", function(module, exports) {

$parcel$export(module.exports, "styles", () => $1f32b76852a2ed65$export$9dd6ff9ea0189349);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ parcelRequire("6CRLU");
var $8UC9o = parcelRequire("8UC9o");
const $1f32b76852a2ed65$export$9dd6ff9ea0189349 = (0, $8UC9o.css)`.mdc-notched-outline{display:flex;position:absolute;top:0;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}[dir=rtl] .mdc-notched-outline,.mdc-notched-outline[dir=rtl]{text-align:right}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{box-sizing:border-box;height:100%;border-top:1px solid;border-bottom:1px solid;pointer-events:none}.mdc-notched-outline__leading{border-left:1px solid;border-right:none;width:12px}[dir=rtl] .mdc-notched-outline__leading,.mdc-notched-outline__leading[dir=rtl]{border-left:none;border-right:1px solid}.mdc-notched-outline__trailing{border-left:none;border-right:1px solid;flex-grow:1}[dir=rtl] .mdc-notched-outline__trailing,.mdc-notched-outline__trailing[dir=rtl]{border-left:1px solid;border-right:none}.mdc-notched-outline__notch{flex:0 0 auto;width:auto;max-width:calc(100% - 12px * 2)}.mdc-notched-outline .mdc-floating-label{display:inline-block;position:relative;max-width:100%}.mdc-notched-outline .mdc-floating-label--float-above{text-overflow:clip}.mdc-notched-outline--upgraded .mdc-floating-label--float-above{max-width:calc(100% / 0.75)}.mdc-notched-outline--notched .mdc-notched-outline__notch{padding-left:0;padding-right:8px;border-top:none}[dir=rtl] .mdc-notched-outline--notched .mdc-notched-outline__notch,.mdc-notched-outline--notched .mdc-notched-outline__notch[dir=rtl]{padding-left:8px;padding-right:0}.mdc-notched-outline--no-label .mdc-notched-outline__notch{display:none}:host{display:block;position:absolute;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}[dir=rtl] :host,:host([dir=rtl]){text-align:right}::slotted(.mdc-floating-label){display:inline-block;position:relative;top:17px;bottom:auto;max-width:100%}::slotted(.mdc-floating-label--float-above){text-overflow:clip}.mdc-notched-outline--upgraded ::slotted(.mdc-floating-label--float-above){max-width:calc(100% / 0.75)}.mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}[dir=rtl] .mdc-notched-outline .mdc-notched-outline__leading,.mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}@supports(top: max(0%)){.mdc-notched-outline .mdc-notched-outline__leading{width:max(12px, var(--mdc-shape-small, 4px))}}@supports(top: max(0%)){.mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px, var(--mdc-shape-small, 4px)) * 2)}}.mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}[dir=rtl] .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{border-color:var(--mdc-notched-outline-border-color, var(--mdc-theme-primary, #6200ee));border-width:1px;border-width:var(--mdc-notched-outline-stroke-width, 1px)}.mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0;padding-top:var(--mdc-notched-outline-notch-offset, 0)}`;

});


parcelRegister("cMU8m", function(module, exports) {

$parcel$export(module.exports, "FormElement", () => $94f582bf97e2b4bd$export$fcc7a416e8ecbf7a);
$parcel$export(module.exports, "addHasRemoveClass", () => (parcelRequire("gSEYT")).addHasRemoveClass);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("dUm3v");
var $thgko = parcelRequire("thgko");
parcelRequire("4ifWP");
var $gSEYT = parcelRequire("gSEYT");
var $4ifWP = parcelRequire("4ifWP");
var $94f582bf97e2b4bd$var$_a, $94f582bf97e2b4bd$var$_b;
// ShadyDOM should submit <input> elements in component internals
const $94f582bf97e2b4bd$var$USING_SHADY_DOM = ($94f582bf97e2b4bd$var$_b = ($94f582bf97e2b4bd$var$_a = window.ShadyDOM) === null || $94f582bf97e2b4bd$var$_a === void 0 ? void 0 : $94f582bf97e2b4bd$var$_a.inUse) !== null && $94f582bf97e2b4bd$var$_b !== void 0 ? $94f582bf97e2b4bd$var$_b : false;
class $94f582bf97e2b4bd$export$fcc7a416e8ecbf7a extends (0, $4ifWP.BaseElement) {
    constructor(){
        super(...arguments);
        /**
         * Disabled state for the component. When `disabled` is set to `true`, the
         * component will not be added to form submission.
         */ this.disabled = false;
        /**
         * Form element that contains this element
         */ this.containingForm = null;
        this.formDataListener = (ev)=>{
            if (!this.disabled) this.setFormData(ev.formData);
        };
    }
    findFormElement() {
        // If the component internals are not in Shadow DOM, subscribing to form
        // data events could lead to duplicated data, which may not work correctly
        // on the server side.
        if (!this.shadowRoot || $94f582bf97e2b4bd$var$USING_SHADY_DOM) return null;
        const root = this.getRootNode();
        const forms = root.querySelectorAll('form');
        for (const form of Array.from(forms)){
            if (form.contains(this)) return form;
        }
        return null;
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.containingForm = this.findFormElement();
        (_a = this.containingForm) === null || _a === void 0 || _a.addEventListener('formdata', this.formDataListener);
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.containingForm) === null || _a === void 0 || _a.removeEventListener('formdata', this.formDataListener);
        this.containingForm = null;
    }
    click() {
        if (this.formElement && !this.disabled) {
            this.formElement.focus();
            this.formElement.click();
        }
    }
    firstUpdated() {
        super.firstUpdated();
        if (this.shadowRoot) this.mdcRoot.addEventListener('change', (e)=>{
            this.dispatchEvent(new Event('change', e));
        });
    }
}
$94f582bf97e2b4bd$export$fcc7a416e8ecbf7a.shadowRootOptions = {
    mode: 'open',
    delegatesFocus: true
};
(0, $czHfO.__decorate)([
    (0, $thgko.property)({
        type: Boolean
    })
], $94f582bf97e2b4bd$export$fcc7a416e8ecbf7a.prototype, "disabled", void 0);

});
parcelRegister("dUm3v", function(module, exports) {
$parcel$export(module.exports, "property", () => (parcelRequire("thgko")).property);
parcelRequire("kMIxs");
parcelRequire("thgko");
parcelRequire("51kHx");
parcelRequire("1R7sb");
parcelRequire("4pevP");
parcelRequire("9NPX1");
parcelRequire("eHmKZ");
parcelRequire("iz3Nl");
parcelRequire("dgLhl");

});
parcelRegister("kMIxs", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f21ad6cab174be7d$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("thgko", function(module, exports) {

$parcel$export(module.exports, "property", () => $0580197dfbff3140$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0580197dfbff3140$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $0580197dfbff3140$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $0580197dfbff3140$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $0580197dfbff3140$var$e(n, t, o) : $0580197dfbff3140$var$i(n, t);
}

});

parcelRegister("51kHx", function(module, exports) {

var $thgko = parcelRequire("thgko");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3a7d1a98e76988ae$export$ca000e230c0caa3e(t) {
    return (0, $thgko.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("1R7sb", function(module, exports) {

var $ipygT = parcelRequire("ipygT");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $15a085ce96ee6886$export$b2b799818fbabcf3(e) {
    return (0, $ipygT.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("ipygT", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", () => $d67525682d510c70$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d67525682d510c70$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $d67525682d510c70$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $d67525682d510c70$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("4pevP", function(module, exports) {

var $ipygT = parcelRequire("ipygT");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3354c10fb58b6c4b$export$2fa187e846a241c4(i, n) {
    return (0, $ipygT.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("9NPX1", function(module, exports) {

var $ipygT = parcelRequire("ipygT");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7230fd0543d1cda8$export$dcd0d083aa86c355(e) {
    return (0, $ipygT.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("eHmKZ", function(module, exports) {

var $ipygT = parcelRequire("ipygT");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ab36bbdf6a66a248$export$163dfc35cc43f240(e) {
    return (0, $ipygT.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("iz3Nl", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $d83e70701c4052de$export$4682af2d9ee91415);

var $ipygT = parcelRequire("ipygT");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $d83e70701c4052de$var$n;
const $d83e70701c4052de$var$e = null != (null === ($d83e70701c4052de$var$n = window.HTMLSlotElement) || void 0 === $d83e70701c4052de$var$n ? void 0 : $d83e70701c4052de$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $d83e70701c4052de$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $ipygT.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $d83e70701c4052de$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("dgLhl", function(module, exports) {

var $ipygT = parcelRequire("ipygT");

var $iz3Nl = parcelRequire("iz3Nl");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9a91718c839b5dfe$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $iz3Nl.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $ipygT.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});



parcelRegister("k4Ngf", function(module, exports) {

$parcel$export(module.exports, "observer", () => $e9da6491a097c5a4$export$b6ae1bc530f4c149);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Specifies an observer callback that is run when the decorated property
 * changes. The observer receives the current and old value as arguments.
 */ const $e9da6491a097c5a4$export$b6ae1bc530f4c149 = (observer)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (proto, propName)=>{
        // if we haven't wrapped `updated` in this class, do so
        if (!proto.constructor._observers) {
            proto.constructor._observers = new Map();
            const userUpdated = proto.updated;
            proto.updated = function(changedProperties) {
                userUpdated.call(this, changedProperties);
                changedProperties.forEach((v, k)=>{
                    const observers = this.constructor._observers;
                    const observer = observers.get(k);
                    if (observer !== undefined) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    observer.call(this, this[k], v);
                });
            };
        // clone any existing observers (superclasses)
        // eslint-disable-next-line no-prototype-builtins
        } else if (!proto.constructor.hasOwnProperty('_observers')) {
            const observers = proto.constructor._observers;
            proto.constructor._observers = new Map();
            observers.forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (v, k)=>proto.constructor._observers.set(k, v));
        }
        // set this method
        proto.constructor._observers.set(propName, observer);
    };

});

parcelRegister("eUOHt", function(module, exports) {

$parcel$export(module.exports, "floatingLabel", () => $adbd9fad02a68cf0$export$a5e5b5e75cfc3b36);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $ih7ti = parcelRequire("ih7ti");
parcelRequire("xrimV");
var $kwoeK = parcelRequire("kwoeK");
const $adbd9fad02a68cf0$var$createAdapter = (labelElement)=>{
    return {
        addClass: (className)=>labelElement.classList.add(className),
        removeClass: (className)=>labelElement.classList.remove(className),
        getWidth: ()=>labelElement.scrollWidth,
        registerInteractionHandler: (evtType, handler)=>{
            labelElement.addEventListener(evtType, handler);
        },
        deregisterInteractionHandler: (evtType, handler)=>{
            labelElement.removeEventListener(evtType, handler);
        }
    };
};
class $adbd9fad02a68cf0$var$FloatingLabelDirective extends (0, $kwoeK.Directive) {
    constructor(partInfo){
        super(partInfo);
        this.foundation = null;
        this.previousPart = null;
        switch(partInfo.type){
            // Only allow Attribute and Part bindings
            case (0, $kwoeK.PartType).ATTRIBUTE:
            case (0, $kwoeK.PartType).PROPERTY:
                break;
            default:
                throw new Error('FloatingLabel directive only support attribute and property parts');
        }
    }
    /**
     * There is no PropertyPart in Lit 2 so far. For more info see:
     * https://github.com/lit/lit/issues/1863
     */ update(part, [label]) {
        if (part !== this.previousPart) {
            if (this.foundation) this.foundation.destroy();
            this.previousPart = part;
            const labelElement = part.element;
            labelElement.classList.add('mdc-floating-label');
            const adapter = $adbd9fad02a68cf0$var$createAdapter(labelElement);
            this.foundation = new (0, $ih7ti.MDCFloatingLabelFoundation)(adapter);
            this.foundation.init();
        }
        return this.render(label);
    }
    render(_label) {
        return this.foundation;
    }
}
const $adbd9fad02a68cf0$export$a5e5b5e75cfc3b36 = (0, $kwoeK.directive)($adbd9fad02a68cf0$var$FloatingLabelDirective);

});
parcelRegister("ih7ti", function(module, exports) {

$parcel$export(module.exports, "MDCFloatingLabelFoundation", () => $d4df9c30e0d641d7$export$c260f97a6b4add0a);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");

var $7F8dN = parcelRequire("7F8dN");

var $5ctC8 = parcelRequire("5ctC8");
var $d4df9c30e0d641d7$export$c260f97a6b4add0a = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCFloatingLabelFoundation, _super);
    function MDCFloatingLabelFoundation(adapter) {
        var _this = _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCFloatingLabelFoundation.defaultAdapter), adapter)) || this;
        _this.shakeAnimationEndHandler = function() {
            _this.handleShakeAnimationEnd();
        };
        return _this;
    }
    Object.defineProperty(MDCFloatingLabelFoundation, "cssClasses", {
        get: function() {
            return 0, $5ctC8.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFloatingLabelFoundation, "defaultAdapter", {
        /**
         * See {@link MDCFloatingLabelAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                getWidth: function() {
                    return 0;
                },
                registerInteractionHandler: function() {
                    return undefined;
                },
                deregisterInteractionHandler: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCFloatingLabelFoundation.prototype.init = function() {
        this.adapter.registerInteractionHandler('animationend', this.shakeAnimationEndHandler);
    };
    MDCFloatingLabelFoundation.prototype.destroy = function() {
        this.adapter.deregisterInteractionHandler('animationend', this.shakeAnimationEndHandler);
    };
    /**
     * Returns the width of the label element.
     */ MDCFloatingLabelFoundation.prototype.getWidth = function() {
        return this.adapter.getWidth();
    };
    /**
     * Styles the label to produce a shake animation to indicate an error.
     * @param shouldShake If true, adds the shake CSS class; otherwise, removes shake class.
     */ MDCFloatingLabelFoundation.prototype.shake = function(shouldShake) {
        var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
        if (shouldShake) this.adapter.addClass(LABEL_SHAKE);
        else this.adapter.removeClass(LABEL_SHAKE);
    };
    /**
     * Styles the label to float or dock.
     * @param shouldFloat If true, adds the float CSS class; otherwise, removes float and shake classes to dock the label.
     */ MDCFloatingLabelFoundation.prototype.float = function(shouldFloat) {
        var _a = MDCFloatingLabelFoundation.cssClasses, LABEL_FLOAT_ABOVE = _a.LABEL_FLOAT_ABOVE, LABEL_SHAKE = _a.LABEL_SHAKE;
        if (shouldFloat) this.adapter.addClass(LABEL_FLOAT_ABOVE);
        else {
            this.adapter.removeClass(LABEL_FLOAT_ABOVE);
            this.adapter.removeClass(LABEL_SHAKE);
        }
    };
    /**
     * Styles the label as required.
     * @param isRequired If true, adds an asterisk to the label, indicating that it is required.
     */ MDCFloatingLabelFoundation.prototype.setRequired = function(isRequired) {
        var LABEL_REQUIRED = MDCFloatingLabelFoundation.cssClasses.LABEL_REQUIRED;
        if (isRequired) this.adapter.addClass(LABEL_REQUIRED);
        else this.adapter.removeClass(LABEL_REQUIRED);
    };
    MDCFloatingLabelFoundation.prototype.handleShakeAnimationEnd = function() {
        var LABEL_SHAKE = MDCFloatingLabelFoundation.cssClasses.LABEL_SHAKE;
        this.adapter.removeClass(LABEL_SHAKE);
    };
    return MDCFloatingLabelFoundation;
}((0, $7F8dN.MDCFoundation));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$d4df9c30e0d641d7$export$2e2bcd8739ae039 = $d4df9c30e0d641d7$export$c260f97a6b4add0a;

});
parcelRegister("7F8dN", function(module, exports) {

$parcel$export(module.exports, "MDCFoundation", () => $5942bd5fccac9f5e$export$a81b11d69c993162);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $5942bd5fccac9f5e$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$5942bd5fccac9f5e$export$2e2bcd8739ae039 = $5942bd5fccac9f5e$export$a81b11d69c993162;

});

parcelRegister("5ctC8", function(module, exports) {

$parcel$export(module.exports, "cssClasses", () => $3c950b78483eb843$export$c1c0562ec8379000);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $3c950b78483eb843$export$c1c0562ec8379000 = {
    LABEL_FLOAT_ABOVE: 'mdc-floating-label--float-above',
    LABEL_REQUIRED: 'mdc-floating-label--required',
    LABEL_SHAKE: 'mdc-floating-label--shake',
    ROOT: 'mdc-floating-label'
};

});


parcelRegister("xrimV", function(module, exports) {
$parcel$export(module.exports, "directive", () => (parcelRequire("kwoeK")).directive);
$parcel$export(module.exports, "Directive", () => (parcelRequire("kwoeK")).Directive);
$parcel$export(module.exports, "PartType", () => (parcelRequire("kwoeK")).PartType);
parcelRequire("kwoeK");

});
parcelRegister("kwoeK", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $ef0998bd49a3982c$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $ef0998bd49a3982c$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $ef0998bd49a3982c$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ef0998bd49a3982c$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $ef0998bd49a3982c$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $ef0998bd49a3982c$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("3ddFX", function(module, exports) {

$parcel$export(module.exports, "lineRipple", () => $256d31b630ad710b$export$4e67d44fb59b80f2);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $4Q398 = parcelRequire("4Q398");
parcelRequire("5nO9g");
var $3CMXb = parcelRequire("3CMXb");
const $256d31b630ad710b$var$createAdapter = (lineElement)=>{
    return {
        addClass: (className)=>lineElement.classList.add(className),
        removeClass: (className)=>lineElement.classList.remove(className),
        hasClass: (className)=>lineElement.classList.contains(className),
        setStyle: (propertyName, value)=>lineElement.style.setProperty(propertyName, value),
        registerEventHandler: (evtType, handler)=>{
            lineElement.addEventListener(evtType, handler);
        },
        deregisterEventHandler: (evtType, handler)=>{
            lineElement.removeEventListener(evtType, handler);
        }
    };
};
class $256d31b630ad710b$export$9acada7bd0657fb9 extends (0, $3CMXb.Directive) {
    constructor(partInfo){
        super(partInfo);
        this.previousPart = null;
        this.foundation = null;
        switch(partInfo.type){
            case (0, $3CMXb.PartType).ATTRIBUTE:
            case (0, $3CMXb.PartType).PROPERTY:
                return;
            default:
                throw new Error('LineRipple only support attribute and property parts.');
        }
    }
    /**
     * There is no PropertyPart in Lit 2 so far. For more info see:
     * https://github.com/lit/lit/issues/1863
     */ update(part, _params) {
        if (this.previousPart !== part) {
            if (this.foundation) this.foundation.destroy();
            this.previousPart = part;
            const lineElement = part.element;
            lineElement.classList.add('mdc-line-ripple');
            const adapter = $256d31b630ad710b$var$createAdapter(lineElement);
            this.foundation = new (0, $4Q398.MDCLineRippleFoundation)(adapter);
            this.foundation.init();
        }
        return this.render();
    }
    render() {
        return this.foundation;
    }
}
const $256d31b630ad710b$export$4e67d44fb59b80f2 = (0, $3CMXb.directive)($256d31b630ad710b$export$9acada7bd0657fb9);

});
parcelRegister("4Q398", function(module, exports) {

$parcel$export(module.exports, "MDCLineRippleFoundation", () => $385e7588056bd2df$export$305b613fbe54f455);
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");

var $iB3O2 = parcelRequire("iB3O2");

var $lXP4x = parcelRequire("lXP4x");
var $385e7588056bd2df$export$305b613fbe54f455 = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCLineRippleFoundation, _super);
    function MDCLineRippleFoundation(adapter) {
        var _this = _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCLineRippleFoundation.defaultAdapter), adapter)) || this;
        _this.transitionEndHandler = function(evt) {
            _this.handleTransitionEnd(evt);
        };
        return _this;
    }
    Object.defineProperty(MDCLineRippleFoundation, "cssClasses", {
        get: function() {
            return 0, $lXP4x.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCLineRippleFoundation, "defaultAdapter", {
        /**
         * See {@link MDCLineRippleAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                setStyle: function() {
                    return undefined;
                },
                registerEventHandler: function() {
                    return undefined;
                },
                deregisterEventHandler: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCLineRippleFoundation.prototype.init = function() {
        this.adapter.registerEventHandler('transitionend', this.transitionEndHandler);
    };
    MDCLineRippleFoundation.prototype.destroy = function() {
        this.adapter.deregisterEventHandler('transitionend', this.transitionEndHandler);
    };
    MDCLineRippleFoundation.prototype.activate = function() {
        this.adapter.removeClass((0, $lXP4x.cssClasses).LINE_RIPPLE_DEACTIVATING);
        this.adapter.addClass((0, $lXP4x.cssClasses).LINE_RIPPLE_ACTIVE);
    };
    MDCLineRippleFoundation.prototype.setRippleCenter = function(xCoordinate) {
        this.adapter.setStyle('transform-origin', xCoordinate + "px center");
    };
    MDCLineRippleFoundation.prototype.deactivate = function() {
        this.adapter.addClass((0, $lXP4x.cssClasses).LINE_RIPPLE_DEACTIVATING);
    };
    MDCLineRippleFoundation.prototype.handleTransitionEnd = function(evt) {
        // Wait for the line ripple to be either transparent or opaque
        // before emitting the animation end event
        var isDeactivating = this.adapter.hasClass((0, $lXP4x.cssClasses).LINE_RIPPLE_DEACTIVATING);
        if (evt.propertyName === 'opacity') {
            if (isDeactivating) {
                this.adapter.removeClass((0, $lXP4x.cssClasses).LINE_RIPPLE_ACTIVE);
                this.adapter.removeClass((0, $lXP4x.cssClasses).LINE_RIPPLE_DEACTIVATING);
            }
        }
    };
    return MDCLineRippleFoundation;
}((0, $iB3O2.MDCFoundation));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$385e7588056bd2df$export$2e2bcd8739ae039 = $385e7588056bd2df$export$305b613fbe54f455;

});
parcelRegister("iB3O2", function(module, exports) {

$parcel$export(module.exports, "MDCFoundation", () => $d89ea279ff9ea382$export$a81b11d69c993162);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $d89ea279ff9ea382$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$d89ea279ff9ea382$export$2e2bcd8739ae039 = $d89ea279ff9ea382$export$a81b11d69c993162;

});

parcelRegister("lXP4x", function(module, exports) {

$parcel$export(module.exports, "cssClasses", () => $ffd6b987374603df$export$c1c0562ec8379000);
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ffd6b987374603df$export$c1c0562ec8379000 = {
    LINE_RIPPLE_ACTIVE: 'mdc-line-ripple--active',
    LINE_RIPPLE_DEACTIVATING: 'mdc-line-ripple--deactivating'
};

});


parcelRegister("5nO9g", function(module, exports) {
$parcel$export(module.exports, "directive", () => (parcelRequire("3CMXb")).directive);
$parcel$export(module.exports, "Directive", () => (parcelRequire("3CMXb")).Directive);
$parcel$export(module.exports, "PartType", () => (parcelRequire("3CMXb")).PartType);
parcelRequire("3CMXb");

});
parcelRegister("3CMXb", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $2a3ae4e2fb7c4c3a$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $2a3ae4e2fb7c4c3a$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $2a3ae4e2fb7c4c3a$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2a3ae4e2fb7c4c3a$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $2a3ae4e2fb7c4c3a$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $2a3ae4e2fb7c4c3a$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("94bPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $699daa8b942faafd$export$2e2bcd8739ae039);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");

var $970hW = parcelRequire("970hW");

var $eBNll = parcelRequire("eBNll");
var $699daa8b942faafd$var$POINTERDOWN_EVENTS = [
    'mousedown',
    'touchstart'
];
var $699daa8b942faafd$var$INTERACTION_EVENTS = [
    'click',
    'keydown'
];
var $699daa8b942faafd$export$e62c196cd9ca6c2c = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCTextFieldFoundation, _super);
    /**
     * @param adapter
     * @param foundationMap Map from subcomponent names to their subfoundations.
     */ function MDCTextFieldFoundation(adapter, foundationMap) {
        if (foundationMap === void 0) foundationMap = {};
        var _this = _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCTextFieldFoundation.defaultAdapter), adapter)) || this;
        _this.isFocused = false;
        _this.receivedUserInput = false;
        _this.valid = true;
        _this.useNativeValidation = true;
        _this.validateOnValueChange = true;
        _this.helperText = foundationMap.helperText;
        _this.characterCounter = foundationMap.characterCounter;
        _this.leadingIcon = foundationMap.leadingIcon;
        _this.trailingIcon = foundationMap.trailingIcon;
        _this.inputFocusHandler = function() {
            _this.activateFocus();
        };
        _this.inputBlurHandler = function() {
            _this.deactivateFocus();
        };
        _this.inputInputHandler = function() {
            _this.handleInput();
        };
        _this.setPointerXOffset = function(evt) {
            _this.setTransformOrigin(evt);
        };
        _this.textFieldInteractionHandler = function() {
            _this.handleTextFieldInteraction();
        };
        _this.validationAttributeChangeHandler = function(attributesList) {
            _this.handleValidationAttributeChange(attributesList);
        };
        return _this;
    }
    Object.defineProperty(MDCTextFieldFoundation, "cssClasses", {
        get: function() {
            return 0, $eBNll.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation, "strings", {
        get: function() {
            return 0, $eBNll.strings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation, "numbers", {
        get: function() {
            return 0, $eBNll.numbers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldAlwaysFloat", {
        get: function() {
            var type = this.getNativeInput().type;
            return (0, $eBNll.ALWAYS_FLOAT_TYPES).indexOf(type) >= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldFloat", {
        get: function() {
            return this.shouldAlwaysFloat || this.isFocused || !!this.getValue() || this.isBadInput();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation.prototype, "shouldShake", {
        get: function() {
            return !this.isFocused && !this.isValid() && !!this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTextFieldFoundation, "defaultAdapter", {
        /**
         * See {@link MDCTextFieldAdapter} for typing information on parameters and
         * return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return true;
                },
                setInputAttr: function() {
                    return undefined;
                },
                removeInputAttr: function() {
                    return undefined;
                },
                registerTextFieldInteractionHandler: function() {
                    return undefined;
                },
                deregisterTextFieldInteractionHandler: function() {
                    return undefined;
                },
                registerInputInteractionHandler: function() {
                    return undefined;
                },
                deregisterInputInteractionHandler: function() {
                    return undefined;
                },
                registerValidationAttributeChangeHandler: function() {
                    return new MutationObserver(function() {
                        return undefined;
                    });
                },
                deregisterValidationAttributeChangeHandler: function() {
                    return undefined;
                },
                getNativeInput: function() {
                    return null;
                },
                isFocused: function() {
                    return false;
                },
                activateLineRipple: function() {
                    return undefined;
                },
                deactivateLineRipple: function() {
                    return undefined;
                },
                setLineRippleTransformOrigin: function() {
                    return undefined;
                },
                shakeLabel: function() {
                    return undefined;
                },
                floatLabel: function() {
                    return undefined;
                },
                setLabelRequired: function() {
                    return undefined;
                },
                hasLabel: function() {
                    return false;
                },
                getLabelWidth: function() {
                    return 0;
                },
                hasOutline: function() {
                    return false;
                },
                notchOutline: function() {
                    return undefined;
                },
                closeOutline: function() {
                    return undefined;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    MDCTextFieldFoundation.prototype.init = function() {
        var e_1, _a, e_2, _b;
        if (this.adapter.hasLabel() && this.getNativeInput().required) this.adapter.setLabelRequired(true);
        if (this.adapter.isFocused()) this.inputFocusHandler();
        else if (this.adapter.hasLabel() && this.shouldFloat) {
            this.notchOutline(true);
            this.adapter.floatLabel(true);
            this.styleFloating(true);
        }
        this.adapter.registerInputInteractionHandler('focus', this.inputFocusHandler);
        this.adapter.registerInputInteractionHandler('blur', this.inputBlurHandler);
        this.adapter.registerInputInteractionHandler('input', this.inputInputHandler);
        try {
            for(var POINTERDOWN_EVENTS_1 = (0, $czHfO.__values)($699daa8b942faafd$var$POINTERDOWN_EVENTS), POINTERDOWN_EVENTS_1_1 = POINTERDOWN_EVENTS_1.next(); !POINTERDOWN_EVENTS_1_1.done; POINTERDOWN_EVENTS_1_1 = POINTERDOWN_EVENTS_1.next()){
                var evtType = POINTERDOWN_EVENTS_1_1.value;
                this.adapter.registerInputInteractionHandler(evtType, this.setPointerXOffset);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (POINTERDOWN_EVENTS_1_1 && !POINTERDOWN_EVENTS_1_1.done && (_a = POINTERDOWN_EVENTS_1.return)) _a.call(POINTERDOWN_EVENTS_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var INTERACTION_EVENTS_1 = (0, $czHfO.__values)($699daa8b942faafd$var$INTERACTION_EVENTS), INTERACTION_EVENTS_1_1 = INTERACTION_EVENTS_1.next(); !INTERACTION_EVENTS_1_1.done; INTERACTION_EVENTS_1_1 = INTERACTION_EVENTS_1.next()){
                var evtType = INTERACTION_EVENTS_1_1.value;
                this.adapter.registerTextFieldInteractionHandler(evtType, this.textFieldInteractionHandler);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (INTERACTION_EVENTS_1_1 && !INTERACTION_EVENTS_1_1.done && (_b = INTERACTION_EVENTS_1.return)) _b.call(INTERACTION_EVENTS_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        this.validationObserver = this.adapter.registerValidationAttributeChangeHandler(this.validationAttributeChangeHandler);
        this.setcharacterCounter(this.getValue().length);
    };
    MDCTextFieldFoundation.prototype.destroy = function() {
        var e_3, _a, e_4, _b;
        this.adapter.deregisterInputInteractionHandler('focus', this.inputFocusHandler);
        this.adapter.deregisterInputInteractionHandler('blur', this.inputBlurHandler);
        this.adapter.deregisterInputInteractionHandler('input', this.inputInputHandler);
        try {
            for(var POINTERDOWN_EVENTS_2 = (0, $czHfO.__values)($699daa8b942faafd$var$POINTERDOWN_EVENTS), POINTERDOWN_EVENTS_2_1 = POINTERDOWN_EVENTS_2.next(); !POINTERDOWN_EVENTS_2_1.done; POINTERDOWN_EVENTS_2_1 = POINTERDOWN_EVENTS_2.next()){
                var evtType = POINTERDOWN_EVENTS_2_1.value;
                this.adapter.deregisterInputInteractionHandler(evtType, this.setPointerXOffset);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (POINTERDOWN_EVENTS_2_1 && !POINTERDOWN_EVENTS_2_1.done && (_a = POINTERDOWN_EVENTS_2.return)) _a.call(POINTERDOWN_EVENTS_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var INTERACTION_EVENTS_2 = (0, $czHfO.__values)($699daa8b942faafd$var$INTERACTION_EVENTS), INTERACTION_EVENTS_2_1 = INTERACTION_EVENTS_2.next(); !INTERACTION_EVENTS_2_1.done; INTERACTION_EVENTS_2_1 = INTERACTION_EVENTS_2.next()){
                var evtType = INTERACTION_EVENTS_2_1.value;
                this.adapter.deregisterTextFieldInteractionHandler(evtType, this.textFieldInteractionHandler);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (INTERACTION_EVENTS_2_1 && !INTERACTION_EVENTS_2_1.done && (_b = INTERACTION_EVENTS_2.return)) _b.call(INTERACTION_EVENTS_2);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        this.adapter.deregisterValidationAttributeChangeHandler(this.validationObserver);
    };
    /**
     * Handles user interactions with the Text Field.
     */ MDCTextFieldFoundation.prototype.handleTextFieldInteraction = function() {
        var nativeInput = this.adapter.getNativeInput();
        if (nativeInput && nativeInput.disabled) return;
        this.receivedUserInput = true;
    };
    /**
     * Handles validation attribute changes
     */ MDCTextFieldFoundation.prototype.handleValidationAttributeChange = function(attributesList) {
        var _this = this;
        attributesList.some(function(attributeName) {
            if ((0, $eBNll.VALIDATION_ATTR_WHITELIST).indexOf(attributeName) > -1) {
                _this.styleValidity(true);
                _this.adapter.setLabelRequired(_this.getNativeInput().required);
                return true;
            }
            return false;
        });
        if (attributesList.indexOf('maxlength') > -1) this.setcharacterCounter(this.getValue().length);
    };
    /**
     * Opens/closes the notched outline.
     */ MDCTextFieldFoundation.prototype.notchOutline = function(openNotch) {
        if (!this.adapter.hasOutline() || !this.adapter.hasLabel()) return;
        if (openNotch) {
            var labelWidth = this.adapter.getLabelWidth() * (0, $eBNll.numbers).LABEL_SCALE;
            this.adapter.notchOutline(labelWidth);
        } else this.adapter.closeOutline();
    };
    /**
     * Activates the text field focus state.
     */ MDCTextFieldFoundation.prototype.activateFocus = function() {
        this.isFocused = true;
        this.styleFocused(this.isFocused);
        this.adapter.activateLineRipple();
        if (this.adapter.hasLabel()) {
            this.notchOutline(this.shouldFloat);
            this.adapter.floatLabel(this.shouldFloat);
            this.styleFloating(this.shouldFloat);
            this.adapter.shakeLabel(this.shouldShake);
        }
        if (this.helperText && (this.helperText.isPersistent() || !this.helperText.isValidation() || !this.valid)) this.helperText.showToScreenReader();
    };
    /**
     * Sets the line ripple's transform origin, so that the line ripple activate
     * animation will animate out from the user's click location.
     */ MDCTextFieldFoundation.prototype.setTransformOrigin = function(evt) {
        if (this.isDisabled() || this.adapter.hasOutline()) return;
        var touches = evt.touches;
        var targetEvent = touches ? touches[0] : evt;
        var targetClientRect = targetEvent.target.getBoundingClientRect();
        var normalizedX = targetEvent.clientX - targetClientRect.left;
        this.adapter.setLineRippleTransformOrigin(normalizedX);
    };
    /**
     * Handles input change of text input and text area.
     */ MDCTextFieldFoundation.prototype.handleInput = function() {
        this.autoCompleteFocus();
        this.setcharacterCounter(this.getValue().length);
    };
    /**
     * Activates the Text Field's focus state in cases when the input value
     * changes without user input (e.g. programmatically).
     */ MDCTextFieldFoundation.prototype.autoCompleteFocus = function() {
        if (!this.receivedUserInput) this.activateFocus();
    };
    /**
     * Deactivates the Text Field's focus state.
     */ MDCTextFieldFoundation.prototype.deactivateFocus = function() {
        this.isFocused = false;
        this.adapter.deactivateLineRipple();
        var isValid = this.isValid();
        this.styleValidity(isValid);
        this.styleFocused(this.isFocused);
        if (this.adapter.hasLabel()) {
            this.notchOutline(this.shouldFloat);
            this.adapter.floatLabel(this.shouldFloat);
            this.styleFloating(this.shouldFloat);
            this.adapter.shakeLabel(this.shouldShake);
        }
        if (!this.shouldFloat) this.receivedUserInput = false;
    };
    MDCTextFieldFoundation.prototype.getValue = function() {
        return this.getNativeInput().value;
    };
    /**
     * @param value The value to set on the input Element.
     */ MDCTextFieldFoundation.prototype.setValue = function(value) {
        // Prevent Safari from moving the caret to the end of the input when the
        // value has not changed.
        if (this.getValue() !== value) this.getNativeInput().value = value;
        this.setcharacterCounter(value.length);
        if (this.validateOnValueChange) {
            var isValid = this.isValid();
            this.styleValidity(isValid);
        }
        if (this.adapter.hasLabel()) {
            this.notchOutline(this.shouldFloat);
            this.adapter.floatLabel(this.shouldFloat);
            this.styleFloating(this.shouldFloat);
            if (this.validateOnValueChange) this.adapter.shakeLabel(this.shouldShake);
        }
    };
    /**
     * @return The custom validity state, if set; otherwise, the result of a
     *     native validity check.
     */ MDCTextFieldFoundation.prototype.isValid = function() {
        return this.useNativeValidation ? this.isNativeInputValid() : this.valid;
    };
    /**
     * @param isValid Sets the custom validity state of the Text Field.
     */ MDCTextFieldFoundation.prototype.setValid = function(isValid) {
        this.valid = isValid;
        this.styleValidity(isValid);
        var shouldShake = !isValid && !this.isFocused && !!this.getValue();
        if (this.adapter.hasLabel()) this.adapter.shakeLabel(shouldShake);
    };
    /**
     * @param shouldValidate Whether or not validity should be updated on
     *     value change.
     */ MDCTextFieldFoundation.prototype.setValidateOnValueChange = function(shouldValidate) {
        this.validateOnValueChange = shouldValidate;
    };
    /**
     * @return Whether or not validity should be updated on value change. `true`
     *     by default.
     */ MDCTextFieldFoundation.prototype.getValidateOnValueChange = function() {
        return this.validateOnValueChange;
    };
    /**
     * Enables or disables the use of native validation. Use this for custom
     * validation.
     * @param useNativeValidation Set this to false to ignore native input
     *     validation.
     */ MDCTextFieldFoundation.prototype.setUseNativeValidation = function(useNativeValidation) {
        this.useNativeValidation = useNativeValidation;
    };
    MDCTextFieldFoundation.prototype.isDisabled = function() {
        return this.getNativeInput().disabled;
    };
    /**
     * @param disabled Sets the text-field disabled or enabled.
     */ MDCTextFieldFoundation.prototype.setDisabled = function(disabled) {
        this.getNativeInput().disabled = disabled;
        this.styleDisabled(disabled);
    };
    /**
     * @param content Sets the content of the helper text.
     */ MDCTextFieldFoundation.prototype.setHelperTextContent = function(content) {
        if (this.helperText) this.helperText.setContent(content);
    };
    /**
     * Sets the aria label of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconAriaLabel = function(label) {
        if (this.leadingIcon) this.leadingIcon.setAriaLabel(label);
    };
    /**
     * Sets the text content of the leading icon.
     */ MDCTextFieldFoundation.prototype.setLeadingIconContent = function(content) {
        if (this.leadingIcon) this.leadingIcon.setContent(content);
    };
    /**
     * Sets the aria label of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconAriaLabel = function(label) {
        if (this.trailingIcon) this.trailingIcon.setAriaLabel(label);
    };
    /**
     * Sets the text content of the trailing icon.
     */ MDCTextFieldFoundation.prototype.setTrailingIconContent = function(content) {
        if (this.trailingIcon) this.trailingIcon.setContent(content);
    };
    /**
     * Sets character counter values that shows characters used and the total
     * character limit.
     */ MDCTextFieldFoundation.prototype.setcharacterCounter = function(currentLength) {
        if (!this.characterCounter) return;
        var maxLength = this.getNativeInput().maxLength;
        if (maxLength === -1) throw new Error('MDCTextFieldFoundation: Expected maxlength html property on text input or textarea.');
        this.characterCounter.setCounterValue(currentLength, maxLength);
    };
    /**
     * @return True if the Text Field input fails in converting the user-supplied
     *     value.
     */ MDCTextFieldFoundation.prototype.isBadInput = function() {
        // The badInput property is not supported in IE 11 💩.
        return this.getNativeInput().validity.badInput || false;
    };
    /**
     * @return The result of native validity checking (ValidityState.valid).
     */ MDCTextFieldFoundation.prototype.isNativeInputValid = function() {
        return this.getNativeInput().validity.valid;
    };
    /**
     * Styles the component based on the validity state.
     */ MDCTextFieldFoundation.prototype.styleValidity = function(isValid) {
        var INVALID = MDCTextFieldFoundation.cssClasses.INVALID;
        if (isValid) this.adapter.removeClass(INVALID);
        else this.adapter.addClass(INVALID);
        if (this.helperText) {
            this.helperText.setValidity(isValid);
            // We dynamically set or unset aria-describedby for validation helper text
            // only, based on whether the field is valid
            var helperTextValidation = this.helperText.isValidation();
            if (!helperTextValidation) return;
            var helperTextVisible = this.helperText.isVisible();
            var helperTextId = this.helperText.getId();
            if (helperTextVisible && helperTextId) this.adapter.setInputAttr((0, $eBNll.strings).ARIA_DESCRIBEDBY, helperTextId);
            else this.adapter.removeInputAttr((0, $eBNll.strings).ARIA_DESCRIBEDBY);
        }
    };
    /**
     * Styles the component based on the focused state.
     */ MDCTextFieldFoundation.prototype.styleFocused = function(isFocused) {
        var FOCUSED = MDCTextFieldFoundation.cssClasses.FOCUSED;
        if (isFocused) this.adapter.addClass(FOCUSED);
        else this.adapter.removeClass(FOCUSED);
    };
    /**
     * Styles the component based on the disabled state.
     */ MDCTextFieldFoundation.prototype.styleDisabled = function(isDisabled) {
        var _a = MDCTextFieldFoundation.cssClasses, DISABLED = _a.DISABLED, INVALID = _a.INVALID;
        if (isDisabled) {
            this.adapter.addClass(DISABLED);
            this.adapter.removeClass(INVALID);
        } else this.adapter.removeClass(DISABLED);
        if (this.leadingIcon) this.leadingIcon.setDisabled(isDisabled);
        if (this.trailingIcon) this.trailingIcon.setDisabled(isDisabled);
    };
    /**
     * Styles the component based on the label floating state.
     */ MDCTextFieldFoundation.prototype.styleFloating = function(isFloating) {
        var LABEL_FLOATING = MDCTextFieldFoundation.cssClasses.LABEL_FLOATING;
        if (isFloating) this.adapter.addClass(LABEL_FLOATING);
        else this.adapter.removeClass(LABEL_FLOATING);
    };
    /**
     * @return The native text input element from the host environment, or an
     *     object with the same shape for unit tests.
     */ MDCTextFieldFoundation.prototype.getNativeInput = function() {
        // this.adapter may be undefined in foundation unit tests. This happens when
        // testdouble is creating a mock object and invokes the
        // shouldShake/shouldFloat getters (which in turn call getValue(), which
        // calls this method) before init() has been called from the MDCTextField
        // constructor. To work around that issue, we return a dummy object.
        var nativeInput = this.adapter ? this.adapter.getNativeInput() : null;
        return nativeInput || {
            disabled: false,
            maxLength: -1,
            required: false,
            type: 'input',
            validity: {
                badInput: false,
                valid: true
            },
            value: ''
        };
    };
    return MDCTextFieldFoundation;
}((0, $970hW.MDCFoundation));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$699daa8b942faafd$export$2e2bcd8739ae039 = $699daa8b942faafd$export$e62c196cd9ca6c2c;

});
parcelRegister("970hW", function(module, exports) {

$parcel$export(module.exports, "MDCFoundation", () => $6a24fdcad647660a$export$a81b11d69c993162);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $6a24fdcad647660a$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$6a24fdcad647660a$export$2e2bcd8739ae039 = $6a24fdcad647660a$export$a81b11d69c993162;

});

parcelRegister("eBNll", function(module, exports) {

$parcel$export(module.exports, "strings", () => $aa2acbf2cf24ed78$export$21c51bc433c16634);
$parcel$export(module.exports, "cssClasses", () => $aa2acbf2cf24ed78$export$c1c0562ec8379000);
$parcel$export(module.exports, "numbers", () => $aa2acbf2cf24ed78$export$1f6c9cc012ebacae);
$parcel$export(module.exports, "VALIDATION_ATTR_WHITELIST", () => $aa2acbf2cf24ed78$export$b45590aaec0cdbc6);
$parcel$export(module.exports, "ALWAYS_FLOAT_TYPES", () => $aa2acbf2cf24ed78$export$51a97178494bc025);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $aa2acbf2cf24ed78$export$21c51bc433c16634 = {
    ARIA_CONTROLS: 'aria-controls',
    ARIA_DESCRIBEDBY: 'aria-describedby',
    INPUT_SELECTOR: '.mdc-text-field__input',
    LABEL_SELECTOR: '.mdc-floating-label',
    LEADING_ICON_SELECTOR: '.mdc-text-field__icon--leading',
    LINE_RIPPLE_SELECTOR: '.mdc-line-ripple',
    OUTLINE_SELECTOR: '.mdc-notched-outline',
    PREFIX_SELECTOR: '.mdc-text-field__affix--prefix',
    SUFFIX_SELECTOR: '.mdc-text-field__affix--suffix',
    TRAILING_ICON_SELECTOR: '.mdc-text-field__icon--trailing'
};
var $aa2acbf2cf24ed78$export$c1c0562ec8379000 = {
    DISABLED: 'mdc-text-field--disabled',
    FOCUSED: 'mdc-text-field--focused',
    HELPER_LINE: 'mdc-text-field-helper-line',
    INVALID: 'mdc-text-field--invalid',
    LABEL_FLOATING: 'mdc-text-field--label-floating',
    NO_LABEL: 'mdc-text-field--no-label',
    OUTLINED: 'mdc-text-field--outlined',
    ROOT: 'mdc-text-field',
    TEXTAREA: 'mdc-text-field--textarea',
    WITH_LEADING_ICON: 'mdc-text-field--with-leading-icon',
    WITH_TRAILING_ICON: 'mdc-text-field--with-trailing-icon',
    WITH_INTERNAL_COUNTER: 'mdc-text-field--with-internal-counter'
};
var $aa2acbf2cf24ed78$export$1f6c9cc012ebacae = {
    LABEL_SCALE: 0.75
};
/**
 * Whitelist based off of
 * https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation
 * under the "Validation-related attributes" section.
 */ var $aa2acbf2cf24ed78$export$b45590aaec0cdbc6 = [
    'pattern',
    'min',
    'max',
    'required',
    'step',
    'minlength',
    'maxlength'
];
/**
 * Label should always float for these types as they show some UI even if value
 * is empty.
 */ var $aa2acbf2cf24ed78$export$51a97178494bc025 = [
    'color',
    'date',
    'datetime-local',
    'month',
    'range',
    'time',
    'week'
];

});


parcelRegister("8qGBw", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("aTPL8")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("dEBa6")).html);
parcelRequire("1k4aS");
parcelRequire("dEBa6");
parcelRequire("2iFrb");
parcelRequire("1hFwd");

});
parcelRegister("1k4aS", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $0f6ae5a4a70d7a09$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("aTPL8")).css);

var $aTPL8 = parcelRequire("aTPL8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $0f6ae5a4a70d7a09$var$s;
const $0f6ae5a4a70d7a09$var$e = window, $0f6ae5a4a70d7a09$var$r = $0f6ae5a4a70d7a09$var$e.trustedTypes, $0f6ae5a4a70d7a09$var$h = $0f6ae5a4a70d7a09$var$r ? $0f6ae5a4a70d7a09$var$r.emptyScript : "", $0f6ae5a4a70d7a09$var$o = $0f6ae5a4a70d7a09$var$e.reactiveElementPolyfillSupport, $0f6ae5a4a70d7a09$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $0f6ae5a4a70d7a09$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $0f6ae5a4a70d7a09$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $0f6ae5a4a70d7a09$var$l = {
    attribute: !0,
    type: String,
    converter: $0f6ae5a4a70d7a09$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $0f6ae5a4a70d7a09$export$53a6892c50694894
}, $0f6ae5a4a70d7a09$var$d = "finalized";
class $0f6ae5a4a70d7a09$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $0f6ae5a4a70d7a09$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $0f6ae5a4a70d7a09$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($0f6ae5a4a70d7a09$var$d)) return !1;
        this[$0f6ae5a4a70d7a09$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $aTPL8.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $aTPL8.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $aTPL8.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $0f6ae5a4a70d7a09$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $0f6ae5a4a70d7a09$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $0f6ae5a4a70d7a09$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $0f6ae5a4a70d7a09$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$0f6ae5a4a70d7a09$export$c7c07a37856565d[$0f6ae5a4a70d7a09$var$d] = !0, $0f6ae5a4a70d7a09$export$c7c07a37856565d.elementProperties = new Map, $0f6ae5a4a70d7a09$export$c7c07a37856565d.elementStyles = [], $0f6ae5a4a70d7a09$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $0f6ae5a4a70d7a09$var$o || $0f6ae5a4a70d7a09$var$o({
    ReactiveElement: $0f6ae5a4a70d7a09$export$c7c07a37856565d
}), (null !== ($0f6ae5a4a70d7a09$var$s = $0f6ae5a4a70d7a09$var$e.reactiveElementVersions) && void 0 !== $0f6ae5a4a70d7a09$var$s ? $0f6ae5a4a70d7a09$var$s : $0f6ae5a4a70d7a09$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("aTPL8", function(module, exports) {

$parcel$export(module.exports, "css", () => $7ef730b82c923348$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $7ef730b82c923348$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $7ef730b82c923348$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7ef730b82c923348$var$t = window, $7ef730b82c923348$export$b4d10f6001c083c2 = $7ef730b82c923348$var$t.ShadowRoot && (void 0 === $7ef730b82c923348$var$t.ShadyCSS || $7ef730b82c923348$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $7ef730b82c923348$var$s = Symbol(), $7ef730b82c923348$var$n = new WeakMap;
class $7ef730b82c923348$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $7ef730b82c923348$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($7ef730b82c923348$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $7ef730b82c923348$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $7ef730b82c923348$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $7ef730b82c923348$export$8d80f9cac07cdb3 = (t)=>new $7ef730b82c923348$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $7ef730b82c923348$var$s), $7ef730b82c923348$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $7ef730b82c923348$export$505d1e8739bad805(n, t, $7ef730b82c923348$var$s);
}, $7ef730b82c923348$export$2ca4a66ec4cecb90 = (s, n)=>{
    $7ef730b82c923348$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $7ef730b82c923348$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $7ef730b82c923348$export$ee69dfd951e24778 = $7ef730b82c923348$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $7ef730b82c923348$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("dEBa6", function(module, exports) {

$parcel$export(module.exports, "html", () => $9f0bd65a1261f8f8$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $9f0bd65a1261f8f8$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $9f0bd65a1261f8f8$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $9f0bd65a1261f8f8$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $9f0bd65a1261f8f8$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $9f0bd65a1261f8f8$var$t;
const $9f0bd65a1261f8f8$var$i = window, $9f0bd65a1261f8f8$var$s = $9f0bd65a1261f8f8$var$i.trustedTypes, $9f0bd65a1261f8f8$var$e = $9f0bd65a1261f8f8$var$s ? $9f0bd65a1261f8f8$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $9f0bd65a1261f8f8$var$o = "$lit$", $9f0bd65a1261f8f8$var$n = `lit$${(Math.random() + "").slice(9)}$`, $9f0bd65a1261f8f8$var$l = "?" + $9f0bd65a1261f8f8$var$n, $9f0bd65a1261f8f8$var$h = `<${$9f0bd65a1261f8f8$var$l}>`, $9f0bd65a1261f8f8$var$r = document, $9f0bd65a1261f8f8$var$u = ()=>$9f0bd65a1261f8f8$var$r.createComment(""), $9f0bd65a1261f8f8$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $9f0bd65a1261f8f8$var$c = Array.isArray, $9f0bd65a1261f8f8$var$v = (t)=>$9f0bd65a1261f8f8$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $9f0bd65a1261f8f8$var$a = "[ \t\n\f\r]", $9f0bd65a1261f8f8$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $9f0bd65a1261f8f8$var$_ = /-->/g, $9f0bd65a1261f8f8$var$m = />/g, $9f0bd65a1261f8f8$var$p = RegExp(`>|${$9f0bd65a1261f8f8$var$a}(?:([^\\s"'>=/]+)(${$9f0bd65a1261f8f8$var$a}*=${$9f0bd65a1261f8f8$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $9f0bd65a1261f8f8$var$g = /'/g, $9f0bd65a1261f8f8$var$$ = /"/g, $9f0bd65a1261f8f8$var$y = /^(?:script|style|textarea|title)$/i, $9f0bd65a1261f8f8$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $9f0bd65a1261f8f8$export$c0bb0b647f701bb5 = $9f0bd65a1261f8f8$var$w(1), $9f0bd65a1261f8f8$export$7ed1367e7fa1ad68 = $9f0bd65a1261f8f8$var$w(2), $9f0bd65a1261f8f8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $9f0bd65a1261f8f8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $9f0bd65a1261f8f8$var$E = new WeakMap, $9f0bd65a1261f8f8$var$C = $9f0bd65a1261f8f8$var$r.createTreeWalker($9f0bd65a1261f8f8$var$r, 129, null, !1);
function $9f0bd65a1261f8f8$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $9f0bd65a1261f8f8$var$e ? $9f0bd65a1261f8f8$var$e.createHTML(i) : i;
}
const $9f0bd65a1261f8f8$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $9f0bd65a1261f8f8$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $9f0bd65a1261f8f8$var$f ? "!--" === c[1] ? u = $9f0bd65a1261f8f8$var$_ : void 0 !== c[1] ? u = $9f0bd65a1261f8f8$var$m : void 0 !== c[2] ? ($9f0bd65a1261f8f8$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $9f0bd65a1261f8f8$var$p) : void 0 !== c[3] && (u = $9f0bd65a1261f8f8$var$p) : u === $9f0bd65a1261f8f8$var$p ? ">" === c[0] ? (u = null != l ? l : $9f0bd65a1261f8f8$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $9f0bd65a1261f8f8$var$p : '"' === c[3] ? $9f0bd65a1261f8f8$var$$ : $9f0bd65a1261f8f8$var$g) : u === $9f0bd65a1261f8f8$var$$ || u === $9f0bd65a1261f8f8$var$g ? u = $9f0bd65a1261f8f8$var$p : u === $9f0bd65a1261f8f8$var$_ || u === $9f0bd65a1261f8f8$var$m ? u = $9f0bd65a1261f8f8$var$f : (u = $9f0bd65a1261f8f8$var$p, l = void 0);
        const w = u === $9f0bd65a1261f8f8$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $9f0bd65a1261f8f8$var$f ? s + $9f0bd65a1261f8f8$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $9f0bd65a1261f8f8$var$o + s.slice(v) + $9f0bd65a1261f8f8$var$n + w) : s + $9f0bd65a1261f8f8$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $9f0bd65a1261f8f8$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $9f0bd65a1261f8f8$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $9f0bd65a1261f8f8$var$V(t, i);
        if (this.el = $9f0bd65a1261f8f8$var$N.createElement(a, e), $9f0bd65a1261f8f8$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $9f0bd65a1261f8f8$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($9f0bd65a1261f8f8$var$o) || i.startsWith($9f0bd65a1261f8f8$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $9f0bd65a1261f8f8$var$o).split($9f0bd65a1261f8f8$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $9f0bd65a1261f8f8$var$H : "?" === i[1] ? $9f0bd65a1261f8f8$var$L : "@" === i[1] ? $9f0bd65a1261f8f8$var$z : $9f0bd65a1261f8f8$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($9f0bd65a1261f8f8$var$y.test(h.tagName)) {
                    const t = h.textContent.split($9f0bd65a1261f8f8$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $9f0bd65a1261f8f8$var$s ? $9f0bd65a1261f8f8$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $9f0bd65a1261f8f8$var$u()), $9f0bd65a1261f8f8$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $9f0bd65a1261f8f8$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $9f0bd65a1261f8f8$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($9f0bd65a1261f8f8$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $9f0bd65a1261f8f8$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $9f0bd65a1261f8f8$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $9f0bd65a1261f8f8$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $9f0bd65a1261f8f8$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $9f0bd65a1261f8f8$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $9f0bd65a1261f8f8$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $9f0bd65a1261f8f8$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $9f0bd65a1261f8f8$var$r).importNode(s, !0);
        $9f0bd65a1261f8f8$var$C.currentNode = o;
        let n = $9f0bd65a1261f8f8$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $9f0bd65a1261f8f8$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $9f0bd65a1261f8f8$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $9f0bd65a1261f8f8$var$C.nextNode(), l++);
        }
        return $9f0bd65a1261f8f8$var$C.currentNode = $9f0bd65a1261f8f8$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $9f0bd65a1261f8f8$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $9f0bd65a1261f8f8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $9f0bd65a1261f8f8$var$S(this, t, i), $9f0bd65a1261f8f8$var$d(t) ? t === $9f0bd65a1261f8f8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $9f0bd65a1261f8f8$export$45b790e32b2810ee && this._$AR(), this._$AH = $9f0bd65a1261f8f8$export$45b790e32b2810ee) : t !== this._$AH && t !== $9f0bd65a1261f8f8$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $9f0bd65a1261f8f8$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $9f0bd65a1261f8f8$export$45b790e32b2810ee && $9f0bd65a1261f8f8$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($9f0bd65a1261f8f8$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $9f0bd65a1261f8f8$var$N.createElement($9f0bd65a1261f8f8$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $9f0bd65a1261f8f8$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $9f0bd65a1261f8f8$var$E.get(t.strings);
        return void 0 === i && $9f0bd65a1261f8f8$var$E.set(t.strings, i = new $9f0bd65a1261f8f8$var$N(t)), i;
    }
    T(t) {
        $9f0bd65a1261f8f8$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $9f0bd65a1261f8f8$var$R(this.k($9f0bd65a1261f8f8$var$u()), this.k($9f0bd65a1261f8f8$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $9f0bd65a1261f8f8$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $9f0bd65a1261f8f8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $9f0bd65a1261f8f8$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $9f0bd65a1261f8f8$var$S(this, t, i, 0), n = !$9f0bd65a1261f8f8$var$d(t) || t !== this._$AH && t !== $9f0bd65a1261f8f8$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $9f0bd65a1261f8f8$var$S(this, e[s + l], i, l), h === $9f0bd65a1261f8f8$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$9f0bd65a1261f8f8$var$d(h) || h !== this._$AH[l]), h === $9f0bd65a1261f8f8$export$45b790e32b2810ee ? t = $9f0bd65a1261f8f8$export$45b790e32b2810ee : t !== $9f0bd65a1261f8f8$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $9f0bd65a1261f8f8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $9f0bd65a1261f8f8$var$H extends $9f0bd65a1261f8f8$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $9f0bd65a1261f8f8$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $9f0bd65a1261f8f8$var$I = $9f0bd65a1261f8f8$var$s ? $9f0bd65a1261f8f8$var$s.emptyScript : "";
class $9f0bd65a1261f8f8$var$L extends $9f0bd65a1261f8f8$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $9f0bd65a1261f8f8$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $9f0bd65a1261f8f8$var$I) : this.element.removeAttribute(this.name);
    }
}
class $9f0bd65a1261f8f8$var$z extends $9f0bd65a1261f8f8$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $9f0bd65a1261f8f8$var$S(this, t, i, 0)) && void 0 !== s ? s : $9f0bd65a1261f8f8$export$45b790e32b2810ee) === $9f0bd65a1261f8f8$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $9f0bd65a1261f8f8$export$45b790e32b2810ee && e !== $9f0bd65a1261f8f8$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $9f0bd65a1261f8f8$export$45b790e32b2810ee && (e === $9f0bd65a1261f8f8$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $9f0bd65a1261f8f8$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $9f0bd65a1261f8f8$var$S(this, t);
    }
}
const $9f0bd65a1261f8f8$export$8613d1ca9052b22e = {
    O: $9f0bd65a1261f8f8$var$o,
    P: $9f0bd65a1261f8f8$var$n,
    A: $9f0bd65a1261f8f8$var$l,
    C: 1,
    M: $9f0bd65a1261f8f8$var$V,
    L: $9f0bd65a1261f8f8$var$M,
    R: $9f0bd65a1261f8f8$var$v,
    D: $9f0bd65a1261f8f8$var$S,
    I: $9f0bd65a1261f8f8$var$R,
    V: $9f0bd65a1261f8f8$var$k,
    H: $9f0bd65a1261f8f8$var$L,
    N: $9f0bd65a1261f8f8$var$z,
    U: $9f0bd65a1261f8f8$var$H,
    F: $9f0bd65a1261f8f8$var$Z
}, $9f0bd65a1261f8f8$var$B = $9f0bd65a1261f8f8$var$i.litHtmlPolyfillSupport;
null == $9f0bd65a1261f8f8$var$B || $9f0bd65a1261f8f8$var$B($9f0bd65a1261f8f8$var$N, $9f0bd65a1261f8f8$var$R), (null !== ($9f0bd65a1261f8f8$var$t = $9f0bd65a1261f8f8$var$i.litHtmlVersions) && void 0 !== $9f0bd65a1261f8f8$var$t ? $9f0bd65a1261f8f8$var$t : $9f0bd65a1261f8f8$var$i.litHtmlVersions = []).push("2.8.0");
const $9f0bd65a1261f8f8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $9f0bd65a1261f8f8$var$R(i.insertBefore($9f0bd65a1261f8f8$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("2iFrb", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("aTPL8")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("1k4aS")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("dEBa6")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("dEBa6")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("dEBa6")).render);

var $1k4aS = parcelRequire("1k4aS");

var $dEBa6 = parcelRequire("dEBa6");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $1acd67cc6522e4ee$var$l, $1acd67cc6522e4ee$var$o;
const $1acd67cc6522e4ee$export$8bf27daf9e8907c9 = (0, $1k4aS.ReactiveElement);
class $1acd67cc6522e4ee$export$3f2f9f5909897157 extends (0, $1k4aS.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $dEBa6.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $dEBa6.noChange;
    }
}
$1acd67cc6522e4ee$export$3f2f9f5909897157.finalized = !0, $1acd67cc6522e4ee$export$3f2f9f5909897157._$litElement$ = !0, null === ($1acd67cc6522e4ee$var$l = globalThis.litElementHydrateSupport) || void 0 === $1acd67cc6522e4ee$var$l || $1acd67cc6522e4ee$var$l.call(globalThis, {
    LitElement: $1acd67cc6522e4ee$export$3f2f9f5909897157
});
const $1acd67cc6522e4ee$var$n = globalThis.litElementPolyfillSupport;
null == $1acd67cc6522e4ee$var$n || $1acd67cc6522e4ee$var$n({
    LitElement: $1acd67cc6522e4ee$export$3f2f9f5909897157
});
const $1acd67cc6522e4ee$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($1acd67cc6522e4ee$var$o = globalThis.litElementVersions) && void 0 !== $1acd67cc6522e4ee$var$o ? $1acd67cc6522e4ee$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("1hFwd", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $0ef795b41ebec07e$export$6acf61af03e62db = !1;

});


parcelRegister("1CHUK", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("lvqMI")).classMap);
parcelRequire("lvqMI");

});
parcelRegister("lvqMI", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $fa814522dc259434$export$56cc687933817664);

var $dEBa6 = parcelRequire("dEBa6");

var $4I7Ov = parcelRequire("4I7Ov");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fa814522dc259434$export$56cc687933817664 = (0, $4I7Ov.directive)(class extends (0, $4I7Ov.Directive) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $4I7Ov.PartType).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $dEBa6.noChange;
    }
});

});
parcelRegister("4I7Ov", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $36e155159f4ee0d6$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $36e155159f4ee0d6$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $36e155159f4ee0d6$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $36e155159f4ee0d6$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $36e155159f4ee0d6$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $36e155159f4ee0d6$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("4bkOp", function(module, exports) {
$parcel$export(module.exports, "ifDefined", () => (parcelRequire("eBGeQ")).ifDefined);
parcelRequire("eBGeQ");

});
parcelRegister("eBGeQ", function(module, exports) {

$parcel$export(module.exports, "ifDefined", () => $aa2549168342fceb$export$f68dd208b5df064d);

var $dEBa6 = parcelRequire("dEBa6");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $aa2549168342fceb$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $dEBa6.nothing);

});


parcelRegister("hBaoW", function(module, exports) {
$parcel$export(module.exports, "live", () => (parcelRequire("eXn6D")).live);
parcelRequire("eXn6D");

});
parcelRegister("eXn6D", function(module, exports) {

$parcel$export(module.exports, "live", () => $ae387fc424973416$export$28cf49ad70f82d12);

var $dEBa6 = parcelRequire("dEBa6");

var $4I7Ov = parcelRequire("4I7Ov");

var $8YQHD = parcelRequire("8YQHD");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ae387fc424973416$export$28cf49ad70f82d12 = (0, $4I7Ov.directive)(class extends (0, $4I7Ov.Directive) {
    constructor(r){
        if (super(r), r.type !== (0, $4I7Ov.PartType).PROPERTY && r.type !== (0, $4I7Ov.PartType).ATTRIBUTE && r.type !== (0, $4I7Ov.PartType).BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
        if (!(0, $8YQHD.isSingleExpression)(r)) throw Error("`live` bindings can only contain a single expression");
    }
    render(r) {
        return r;
    }
    update(i, [t]) {
        if (t === (0, $dEBa6.noChange) || t === (0, $dEBa6.nothing)) return t;
        const o = i.element, l = i.name;
        if (i.type === (0, $4I7Ov.PartType).PROPERTY) {
            if (t === o[l]) return 0, $dEBa6.noChange;
        } else if (i.type === (0, $4I7Ov.PartType).BOOLEAN_ATTRIBUTE) {
            if (!!t === o.hasAttribute(l)) return 0, $dEBa6.noChange;
        } else if (i.type === (0, $4I7Ov.PartType).ATTRIBUTE && o.getAttribute(l) === t + "") return 0, $dEBa6.noChange;
        return (0, $8YQHD.setCommittedValue)(i), t;
    }
});

});
parcelRegister("8YQHD", function(module, exports) {

$parcel$export(module.exports, "isSingleExpression", () => $689ccf037f1b81a0$export$7f431ad0fff82fd9);
$parcel$export(module.exports, "setCommittedValue", () => $689ccf037f1b81a0$export$ea70d9dd5965b1c8);

var $dEBa6 = parcelRequire("dEBa6");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $689ccf037f1b81a0$var$l } = (0, $dEBa6._$LH), $689ccf037f1b81a0$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $689ccf037f1b81a0$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $689ccf037f1b81a0$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $689ccf037f1b81a0$export$6a0e8de894d2fcca = (o)=>{
    var l;
    return null != (null === (l = null == o ? void 0 : o._$litType$) || void 0 === l ? void 0 : l.h);
}, $689ccf037f1b81a0$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $689ccf037f1b81a0$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $689ccf037f1b81a0$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $689ccf037f1b81a0$var$r = ()=>document.createComment(""), $689ccf037f1b81a0$export$291b2338ad9b0b30 = (o, i, n)=>{
    var t;
    const v = o._$AA.parentNode, d = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = v.insertBefore($689ccf037f1b81a0$var$r(), d), t = v.insertBefore($689ccf037f1b81a0$var$r(), d);
        n = new $689ccf037f1b81a0$var$l(i, t, o, o.options);
    } else {
        const l = n._$AB.nextSibling, i = n._$AM, u = i !== o;
        if (u) {
            let l;
            null === (t = n._$AQ) || void 0 === t || t.call(n, o), n._$AM = o, void 0 !== n._$AP && (l = o._$AU) !== i._$AU && n._$AP(l);
        }
        if (l !== d || u) {
            let o = n._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                v.insertBefore(o, d), o = l;
            }
        }
    }
    return n;
}, $689ccf037f1b81a0$export$cb8bf9562088e9f4 = (o, l, i = o)=>(o._$AI(l, i), o), $689ccf037f1b81a0$var$s = {}, $689ccf037f1b81a0$export$ea70d9dd5965b1c8 = (o, l = $689ccf037f1b81a0$var$s)=>o._$AH = l, $689ccf037f1b81a0$export$59e9bce518cde500 = (o)=>o._$AH, $689ccf037f1b81a0$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let i = o._$AA;
    const n = o._$AB.nextSibling;
    for(; i !== n;){
        const o = i.nextSibling;
        i.remove(), i = o;
    }
}, $689ccf037f1b81a0$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});




parcelRegister("1UZVJ", function(module, exports) {

$parcel$export(module.exports, "styles", () => $165b0f726ec545be$export$9dd6ff9ea0189349);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ parcelRequire("8qGBw");
var $aTPL8 = parcelRequire("aTPL8");
const $165b0f726ec545be$export$9dd6ff9ea0189349 = (0, $aTPL8.css)`.mdc-floating-label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);position:absolute;left:0;-webkit-transform-origin:left top;transform-origin:left top;line-height:1.15rem;text-align:left;text-overflow:ellipsis;white-space:nowrap;cursor:text;overflow:hidden;will-change:transform;transition:transform 150ms cubic-bezier(0.4, 0, 0.2, 1),color 150ms cubic-bezier(0.4, 0, 0.2, 1)}[dir=rtl] .mdc-floating-label,.mdc-floating-label[dir=rtl]{right:0;left:auto;-webkit-transform-origin:right top;transform-origin:right top;text-align:right}.mdc-floating-label--float-above{cursor:auto}.mdc-floating-label--required::after{margin-left:1px;margin-right:0px;content:"*"}[dir=rtl] .mdc-floating-label--required::after,.mdc-floating-label--required[dir=rtl]::after{margin-left:0;margin-right:1px}.mdc-floating-label--float-above{transform:translateY(-106%) scale(0.75)}.mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-standard 250ms 1}@keyframes mdc-floating-label-shake-float-above-standard{0%{transform:translateX(calc(0 - 0%)) translateY(-106%) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-106%) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-106%) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-106%) scale(0.75)}}.mdc-line-ripple::before,.mdc-line-ripple::after{position:absolute;bottom:0;left:0;width:100%;border-bottom-style:solid;content:""}.mdc-line-ripple::before{border-bottom-width:1px}.mdc-line-ripple::before{z-index:1}.mdc-line-ripple::after{transform:scaleX(0);border-bottom-width:2px;opacity:0;z-index:2}.mdc-line-ripple::after{transition:transform 180ms cubic-bezier(0.4, 0, 0.2, 1),opacity 180ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-line-ripple--active::after{transform:scaleX(1);opacity:1}.mdc-line-ripple--deactivating::after{opacity:0}.mdc-notched-outline{display:flex;position:absolute;top:0;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}[dir=rtl] .mdc-notched-outline,.mdc-notched-outline[dir=rtl]{text-align:right}.mdc-notched-outline__leading,.mdc-notched-outline__notch,.mdc-notched-outline__trailing{box-sizing:border-box;height:100%;border-top:1px solid;border-bottom:1px solid;pointer-events:none}.mdc-notched-outline__leading{border-left:1px solid;border-right:none;width:12px}[dir=rtl] .mdc-notched-outline__leading,.mdc-notched-outline__leading[dir=rtl]{border-left:none;border-right:1px solid}.mdc-notched-outline__trailing{border-left:none;border-right:1px solid;flex-grow:1}[dir=rtl] .mdc-notched-outline__trailing,.mdc-notched-outline__trailing[dir=rtl]{border-left:1px solid;border-right:none}.mdc-notched-outline__notch{flex:0 0 auto;width:auto;max-width:calc(100% - 12px * 2)}.mdc-notched-outline .mdc-floating-label{display:inline-block;position:relative;max-width:100%}.mdc-notched-outline .mdc-floating-label--float-above{text-overflow:clip}.mdc-notched-outline--upgraded .mdc-floating-label--float-above{max-width:calc(100% / 0.75)}.mdc-notched-outline--notched .mdc-notched-outline__notch{padding-left:0;padding-right:8px;border-top:none}[dir=rtl] .mdc-notched-outline--notched .mdc-notched-outline__notch,.mdc-notched-outline--notched .mdc-notched-outline__notch[dir=rtl]{padding-left:8px;padding-right:0}.mdc-notched-outline--no-label .mdc-notched-outline__notch{display:none}@keyframes mdc-ripple-fg-radius-in{from{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transform:translate(var(--mdc-ripple-fg-translate-start, 0)) scale(1)}to{transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}}@keyframes mdc-ripple-fg-opacity-in{from{animation-timing-function:linear;opacity:0}to{opacity:var(--mdc-ripple-fg-opacity, 0)}}@keyframes mdc-ripple-fg-opacity-out{from{animation-timing-function:linear;opacity:var(--mdc-ripple-fg-opacity, 0)}to{opacity:0}}.mdc-text-field--filled{--mdc-ripple-fg-size: 0;--mdc-ripple-left: 0;--mdc-ripple-top: 0;--mdc-ripple-fg-scale: 1;--mdc-ripple-fg-translate-end: 0;--mdc-ripple-fg-translate-start: 0;-webkit-tap-highlight-color:rgba(0,0,0,0);will-change:transform,opacity}.mdc-text-field--filled .mdc-text-field__ripple::before,.mdc-text-field--filled .mdc-text-field__ripple::after{position:absolute;border-radius:50%;opacity:0;pointer-events:none;content:""}.mdc-text-field--filled .mdc-text-field__ripple::before{transition:opacity 15ms linear,background-color 15ms linear;z-index:1;z-index:var(--mdc-ripple-z-index, 1)}.mdc-text-field--filled .mdc-text-field__ripple::after{z-index:0;z-index:var(--mdc-ripple-z-index, 0)}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple::before{transform:scale(var(--mdc-ripple-fg-scale, 1))}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple::after{top:0;left:0;transform:scale(0);transform-origin:center center}.mdc-text-field--filled.mdc-ripple-upgraded--unbounded .mdc-text-field__ripple::after{top:var(--mdc-ripple-top, 0);left:var(--mdc-ripple-left, 0)}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-activation .mdc-text-field__ripple::after{animation:mdc-ripple-fg-radius-in 225ms forwards,mdc-ripple-fg-opacity-in 75ms forwards}.mdc-text-field--filled.mdc-ripple-upgraded--foreground-deactivation .mdc-text-field__ripple::after{animation:mdc-ripple-fg-opacity-out 150ms;transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}.mdc-text-field--filled .mdc-text-field__ripple::before,.mdc-text-field--filled .mdc-text-field__ripple::after{top:calc(50% - 100%);left:calc(50% - 100%);width:200%;height:200%}.mdc-text-field--filled.mdc-ripple-upgraded .mdc-text-field__ripple::after{width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-text-field__ripple{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none}.mdc-text-field{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:0;border-bottom-left-radius:0;display:inline-flex;align-items:baseline;padding:0 16px;position:relative;box-sizing:border-box;overflow:hidden;will-change:opacity,transform,color}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-floating-label{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:rgba(0, 0, 0, 0.87)}@media all{.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input::placeholder{color:rgba(0, 0, 0, 0.54)}}@media all{.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input:-ms-input-placeholder{color:rgba(0, 0, 0, 0.54)}}.mdc-text-field .mdc-text-field__input{caret-color:#6200ee;caret-color:var(--mdc-theme-primary, #6200ee)}.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-helper-text{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field-character-counter,.mdc-text-field:not(.mdc-text-field--disabled)+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--leading{color:rgba(0, 0, 0, 0.54)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:rgba(0, 0, 0, 0.54)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--prefix{color:rgba(0, 0, 0, 0.6)}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__affix--suffix{color:rgba(0, 0, 0, 0.6)}.mdc-text-field .mdc-floating-label{top:50%;transform:translateY(-50%);pointer-events:none}.mdc-text-field__input{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);height:28px;transition:opacity 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);width:100%;min-width:0;border:none;border-radius:0;background:none;appearance:none;padding:0}.mdc-text-field__input::-ms-clear{display:none}.mdc-text-field__input::-webkit-calendar-picker-indicator{display:none}.mdc-text-field__input:focus{outline:none}.mdc-text-field__input:invalid{box-shadow:none}@media all{.mdc-text-field__input::placeholder{transition:opacity 67ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}}@media all{.mdc-text-field__input:-ms-input-placeholder{transition:opacity 67ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0}}@media all{.mdc-text-field--no-label .mdc-text-field__input::placeholder,.mdc-text-field--focused .mdc-text-field__input::placeholder{transition-delay:40ms;transition-duration:110ms;opacity:1}}@media all{.mdc-text-field--no-label .mdc-text-field__input:-ms-input-placeholder,.mdc-text-field--focused .mdc-text-field__input:-ms-input-placeholder{transition-delay:40ms;transition-duration:110ms;opacity:1}}.mdc-text-field__affix{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);height:28px;transition:opacity 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1);opacity:0;white-space:nowrap}.mdc-text-field--label-floating .mdc-text-field__affix,.mdc-text-field--no-label .mdc-text-field__affix{opacity:1}@supports(-webkit-hyphens: none){.mdc-text-field--outlined .mdc-text-field__affix{align-items:center;align-self:center;display:inline-flex;height:100%}}.mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field__affix--prefix,.mdc-text-field__affix--prefix[dir=rtl]{padding-left:2px;padding-right:0}.mdc-text-field--end-aligned .mdc-text-field__affix--prefix{padding-left:0;padding-right:12px}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--end-aligned .mdc-text-field__affix--prefix[dir=rtl]{padding-left:12px;padding-right:0}.mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field__affix--suffix,.mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:12px}.mdc-text-field--end-aligned .mdc-text-field__affix--suffix{padding-left:2px;padding-right:0}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--end-aligned .mdc-text-field__affix--suffix[dir=rtl]{padding-left:0;padding-right:2px}.mdc-text-field--filled{height:56px}.mdc-text-field--filled .mdc-text-field__ripple::before,.mdc-text-field--filled .mdc-text-field__ripple::after{background-color:rgba(0, 0, 0, 0.87);background-color:var(--mdc-ripple-color, rgba(0, 0, 0, 0.87))}.mdc-text-field--filled:hover .mdc-text-field__ripple::before,.mdc-text-field--filled.mdc-ripple-surface--hover .mdc-text-field__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-text-field--filled.mdc-ripple-upgraded--background-focused .mdc-text-field__ripple::before,.mdc-text-field--filled:not(.mdc-ripple-upgraded):focus .mdc-text-field__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-text-field--filled::before{display:inline-block;width:0;height:40px;content:"";vertical-align:0}.mdc-text-field--filled:not(.mdc-text-field--disabled){background-color:whitesmoke}.mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.42)}.mdc-text-field--filled:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.87)}.mdc-text-field--filled .mdc-line-ripple::after{border-bottom-color:#6200ee;border-bottom-color:var(--mdc-theme-primary, #6200ee)}.mdc-text-field--filled .mdc-floating-label{left:16px;right:initial}[dir=rtl] .mdc-text-field--filled .mdc-floating-label,.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:16px}.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-106%) scale(0.75)}.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{height:100%}.mdc-text-field--filled.mdc-text-field--no-label .mdc-floating-label{display:none}.mdc-text-field--filled.mdc-text-field--no-label::before{display:none}@supports(-webkit-hyphens: none){.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__affix{align-items:center;align-self:center;display:inline-flex;height:100%}}.mdc-text-field--outlined{height:56px;overflow:visible}.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-37.25px) scale(1)}.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px) scale(0.75)}.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--outlined .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-text-field-outlined 250ms 1}@keyframes mdc-floating-label-shake-float-above-text-field-outlined{0%{transform:translateX(calc(0 - 0%)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-34.75px) scale(0.75)}}.mdc-text-field--outlined .mdc-text-field__input{height:100%}.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.38)}.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.87)}.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#6200ee;border-color:var(--mdc-theme-primary, #6200ee)}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading[dir=rtl]{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}@supports(top: max(0%)){.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading{width:max(12px, var(--mdc-shape-small, 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch{max-width:calc(100% - max(12px, var(--mdc-shape-small, 4px)) * 2)}}.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing{border-top-left-radius:0;border-top-right-radius:4px;border-top-right-radius:var(--mdc-shape-small, 4px);border-bottom-right-radius:4px;border-bottom-right-radius:var(--mdc-shape-small, 4px);border-bottom-left-radius:0}[dir=rtl] .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing,.mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing[dir=rtl]{border-top-left-radius:4px;border-top-left-radius:var(--mdc-shape-small, 4px);border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:4px;border-bottom-left-radius:var(--mdc-shape-small, 4px)}@supports(top: max(0%)){.mdc-text-field--outlined{padding-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined{padding-right:max(16px, var(--mdc-shape-small, 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined+.mdc-text-field-helper-line{padding-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}@supports(top: max(0%)){.mdc-text-field--outlined+.mdc-text-field-helper-line{padding-right:max(16px, var(--mdc-shape-small, 4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-left:0}@supports(top: max(0%)){.mdc-text-field--outlined.mdc-text-field--with-leading-icon{padding-right:max(16px, var(--mdc-shape-small, 4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-right:0}@supports(top: max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-leading-icon,.mdc-text-field--outlined.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:max(16px, var(--mdc-shape-small, 4px))}}.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-right:0}@supports(top: max(0%)){.mdc-text-field--outlined.mdc-text-field--with-trailing-icon{padding-left:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0}@supports(top: max(0%)){[dir=rtl] .mdc-text-field--outlined.mdc-text-field--with-trailing-icon,.mdc-text-field--outlined.mdc-text-field--with-trailing-icon[dir=rtl]{padding-right:max(16px, calc(var(--mdc-shape-small, 4px) + 4px))}}.mdc-text-field--outlined.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:1px}.mdc-text-field--outlined .mdc-text-field__ripple::before,.mdc-text-field--outlined .mdc-text-field__ripple::after{background-color:transparent;background-color:var(--mdc-ripple-color, transparent)}.mdc-text-field--outlined .mdc-floating-label{left:4px;right:initial}[dir=rtl] .mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:4px}.mdc-text-field--outlined .mdc-text-field__input{display:flex;border:none !important;background-color:transparent}.mdc-text-field--outlined .mdc-notched-outline{z-index:1}.mdc-text-field--textarea{flex-direction:column;align-items:center;width:auto;height:auto;padding:0;transition:none}.mdc-text-field--textarea .mdc-floating-label{top:19px}.mdc-text-field--textarea .mdc-floating-label:not(.mdc-floating-label--float-above){transform:none}.mdc-text-field--textarea .mdc-text-field__input{flex-grow:1;height:auto;min-height:1.5rem;overflow-x:hidden;overflow-y:auto;box-sizing:border-box;resize:none;padding:0 16px;line-height:1.5rem}.mdc-text-field--textarea.mdc-text-field--filled::before{display:none}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--float-above{transform:translateY(-10.25px) scale(0.75)}.mdc-text-field--textarea.mdc-text-field--filled .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-textarea-filled 250ms 1}@keyframes mdc-floating-label-shake-float-above-textarea-filled{0%{transform:translateX(calc(0 - 0%)) translateY(-10.25px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-10.25px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-10.25px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-10.25px) scale(0.75)}}.mdc-text-field--textarea.mdc-text-field--filled .mdc-text-field__input{margin-top:23px;margin-bottom:9px}.mdc-text-field--textarea.mdc-text-field--filled.mdc-text-field--no-label .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-27.25px) scale(1)}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--textarea.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-24.75px) scale(0.75)}.mdc-text-field--textarea.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--textarea.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-textarea-outlined 250ms 1}@keyframes mdc-floating-label-shake-float-above-textarea-outlined{0%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 0%)) translateY(-24.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 0%)) translateY(-24.75px) scale(0.75)}100%{transform:translateX(calc(0 - 0%)) translateY(-24.75px) scale(0.75)}}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-text-field__input{margin-top:16px;margin-bottom:16px}.mdc-text-field--textarea.mdc-text-field--outlined .mdc-floating-label{top:18px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field__input{margin-bottom:2px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter{align-self:flex-end;padding:0 16px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter::after{display:inline-block;width:0;height:16px;content:"";vertical-align:-16px}.mdc-text-field--textarea.mdc-text-field--with-internal-counter .mdc-text-field-character-counter::before{display:none}.mdc-text-field__resizer{align-self:stretch;display:inline-flex;flex-direction:column;flex-grow:1;max-height:100%;max-width:100%;min-height:56px;min-width:fit-content;min-width:-moz-available;min-width:-webkit-fill-available;overflow:hidden;resize:both}.mdc-text-field--filled .mdc-text-field__resizer{transform:translateY(-1px)}.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--filled .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translateY(1px)}.mdc-text-field--outlined .mdc-text-field__resizer{transform:translateX(-1px) translateY(-1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer,.mdc-text-field--outlined .mdc-text-field__resizer[dir=rtl]{transform:translateX(1px) translateY(-1px)}.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter{transform:translateX(1px) translateY(1px)}[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input,[dir=rtl] .mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter,.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field__input[dir=rtl],.mdc-text-field--outlined .mdc-text-field__resizer .mdc-text-field-character-counter[dir=rtl]{transform:translateX(-1px) translateY(1px)}.mdc-text-field--with-leading-icon{padding-left:0;padding-right:16px}[dir=rtl] .mdc-text-field--with-leading-icon,.mdc-text-field--with-leading-icon[dir=rtl]{padding-left:16px;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 48px);left:48px;right:initial}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label[dir=rtl]{left:initial;right:48px}.mdc-text-field--with-leading-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 64px / 0.75)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label{left:36px;right:initial}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label[dir=rtl]{left:initial;right:36px}.mdc-text-field--with-leading-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{transform:translateY(-37.25px) translateX(-32px) scale(1)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-37.25px) translateX(32px) scale(1)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--float-above{font-size:.75rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{transform:translateY(-34.75px) translateX(-32px) scale(0.75)}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl],.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above[dir=rtl]{transform:translateY(-34.75px) translateX(32px) scale(0.75)}.mdc-text-field--with-leading-icon.mdc-text-field--outlined.mdc-notched-outline--upgraded .mdc-floating-label--float-above,.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-notched-outline--upgraded .mdc-floating-label--float-above{font-size:1rem}.mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-text-field-outlined-leading-icon 250ms 1}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon{0%{transform:translateX(calc(0 - 32px)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - 32px)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - 32px)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - 32px)) translateY(-34.75px) scale(0.75)}}[dir=rtl] .mdc-text-field--with-leading-icon.mdc-text-field--outlined .mdc-floating-label--shake,.mdc-text-field--with-leading-icon.mdc-text-field--outlined[dir=rtl] .mdc-floating-label--shake{animation:mdc-floating-label-shake-float-above-text-field-outlined-leading-icon 250ms 1}@keyframes mdc-floating-label-shake-float-above-text-field-outlined-leading-icon-rtl{0%{transform:translateX(calc(0 - -32px)) translateY(-34.75px) scale(0.75)}33%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(calc(4% - -32px)) translateY(-34.75px) scale(0.75)}66%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(calc(-4% - -32px)) translateY(-34.75px) scale(0.75)}100%{transform:translateX(calc(0 - -32px)) translateY(-34.75px) scale(0.75)}}.mdc-text-field--with-trailing-icon{padding-left:16px;padding-right:0}[dir=rtl] .mdc-text-field--with-trailing-icon,.mdc-text-field--with-trailing-icon[dir=rtl]{padding-left:0;padding-right:16px}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 64px)}.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 64px / 0.75)}.mdc-text-field--with-trailing-icon.mdc-text-field--outlined :not(.mdc-notched-outline--notched) .mdc-notched-outline__notch{max-width:calc(100% - 60px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon{padding-left:0;padding-right:0}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label{max-width:calc(100% - 96px)}.mdc-text-field--with-leading-icon.mdc-text-field--with-trailing-icon.mdc-text-field--filled .mdc-floating-label--float-above{max-width:calc(100% / 0.75 - 96px / 0.75)}.mdc-text-field-helper-line{display:flex;justify-content:space-between;box-sizing:border-box}.mdc-text-field+.mdc-text-field-helper-line{padding-right:16px;padding-left:16px}.mdc-form-field>.mdc-text-field+label{align-self:flex-start}.mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:rgba(98, 0, 238, 0.87)}.mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--focused .mdc-notched-outline__trailing{border-width:2px}.mdc-text-field--focused+.mdc-text-field-helper-line .mdc-text-field-helper-text:not(.mdc-text-field-helper-text--validation-msg){opacity:1}.mdc-text-field--focused.mdc-text-field--outlined .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:2px}.mdc-text-field--focused.mdc-text-field--outlined.mdc-text-field--textarea .mdc-notched-outline--notched .mdc-notched-outline__notch{padding-top:0}.mdc-text-field--invalid:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple::after{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid .mdc-text-field__input{caret-color:#b00020;caret-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__icon--trailing{color:#b00020;color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled):not(.mdc-text-field--focused):hover .mdc-notched-outline .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__leading,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__notch,.mdc-text-field--invalid:not(.mdc-text-field--disabled).mdc-text-field--focused .mdc-notched-outline__trailing{border-color:#b00020;border-color:var(--mdc-theme-error, #b00020)}.mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-helper-text--validation-msg{opacity:1}.mdc-text-field--disabled{pointer-events:none}.mdc-text-field--disabled .mdc-text-field__input{color:rgba(0, 0, 0, 0.38)}@media all{.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:rgba(0, 0, 0, 0.38)}}@media all{.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:rgba(0, 0, 0, 0.38)}}.mdc-text-field--disabled .mdc-floating-label{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-text-field__icon--leading{color:rgba(0, 0, 0, 0.3)}.mdc-text-field--disabled .mdc-text-field__icon--trailing{color:rgba(0, 0, 0, 0.3)}.mdc-text-field--disabled .mdc-text-field__affix--prefix{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:rgba(0, 0, 0, 0.38)}.mdc-text-field--disabled .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.06)}.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:rgba(0, 0, 0, 0.06)}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__input::placeholder{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__input:-ms-input-placeholder{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-floating-label{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-helper-text{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field-character-counter,.mdc-text-field--disabled+.mdc-text-field-helper-line .mdc-text-field-character-counter{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__icon--leading{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__icon--trailing{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__affix--prefix{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-text-field__affix--suffix{color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-line-ripple::before{border-bottom-color:GrayText}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-text-field--disabled .mdc-notched-outline__leading,.mdc-text-field--disabled .mdc-notched-outline__notch,.mdc-text-field--disabled .mdc-notched-outline__trailing{border-color:GrayText}}@media screen and (forced-colors: active){.mdc-text-field--disabled .mdc-text-field__input{background-color:Window}.mdc-text-field--disabled .mdc-floating-label{z-index:1}}.mdc-text-field--disabled .mdc-floating-label{cursor:default}.mdc-text-field--disabled.mdc-text-field--filled{background-color:#fafafa}.mdc-text-field--disabled.mdc-text-field--filled .mdc-text-field__ripple{display:none}.mdc-text-field--disabled .mdc-text-field__input{pointer-events:auto}.mdc-text-field--end-aligned .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--end-aligned .mdc-text-field__input[dir=rtl]{text-align:left}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix{direction:ltr}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{padding-left:0;padding-right:2px}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{padding-left:12px;padding-right:0}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--leading,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--leading{order:1}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--suffix{order:2}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__input,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__input{order:3}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__affix--prefix{order:4}[dir=rtl] .mdc-text-field--ltr-text .mdc-text-field__icon--trailing,.mdc-text-field--ltr-text[dir=rtl] .mdc-text-field__icon--trailing{order:5}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__input,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__input{text-align:right}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--prefix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--prefix{padding-right:12px}[dir=rtl] .mdc-text-field--ltr-text.mdc-text-field--end-aligned .mdc-text-field__affix--suffix,.mdc-text-field--ltr-text.mdc-text-field--end-aligned[dir=rtl] .mdc-text-field__affix--suffix{padding-left:2px}.mdc-text-field-helper-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-caption-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.75rem;font-size:var(--mdc-typography-caption-font-size, 0.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight, 400);letter-spacing:0.0333333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing, 0.0333333333em);text-decoration:inherit;text-decoration:var(--mdc-typography-caption-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform, inherit);display:block;margin-top:0;line-height:normal;margin:0;opacity:0;will-change:opacity;transition:opacity 150ms 0ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-text-field-helper-text::before{display:inline-block;width:0;height:16px;content:"";vertical-align:0}.mdc-text-field-helper-text--persistent{transition:none;opacity:1;will-change:initial}.mdc-text-field-character-counter{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-caption-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.75rem;font-size:var(--mdc-typography-caption-font-size, 0.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight, 400);letter-spacing:0.0333333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing, 0.0333333333em);text-decoration:inherit;text-decoration:var(--mdc-typography-caption-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform, inherit);display:block;margin-top:0;line-height:normal;margin-left:auto;margin-right:0;padding-left:16px;padding-right:0;white-space:nowrap}.mdc-text-field-character-counter::before{display:inline-block;width:0;height:16px;content:"";vertical-align:0}[dir=rtl] .mdc-text-field-character-counter,.mdc-text-field-character-counter[dir=rtl]{margin-left:0;margin-right:auto}[dir=rtl] .mdc-text-field-character-counter,.mdc-text-field-character-counter[dir=rtl]{padding-left:0;padding-right:16px}.mdc-text-field__icon{align-self:center;cursor:pointer}.mdc-text-field__icon:not([tabindex]),.mdc-text-field__icon[tabindex="-1"]{cursor:default;pointer-events:none}.mdc-text-field__icon svg{display:block}.mdc-text-field__icon--leading{margin-left:16px;margin-right:8px}[dir=rtl] .mdc-text-field__icon--leading,.mdc-text-field__icon--leading[dir=rtl]{margin-left:8px;margin-right:16px}.mdc-text-field__icon--trailing{padding:12px;margin-left:0px;margin-right:0px}[dir=rtl] .mdc-text-field__icon--trailing,.mdc-text-field__icon--trailing[dir=rtl]{margin-left:0px;margin-right:0px}.material-icons{font-family:var(--mdc-icon-font, "Material Icons");font-weight:normal;font-style:normal;font-size:var(--mdc-icon-size, 24px);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:"liga"}:host{display:inline-flex;flex-direction:column;outline:none}.mdc-text-field{width:100%}.mdc-text-field:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.42);border-bottom-color:var(--mdc-text-field-idle-line-color, rgba(0, 0, 0, 0.42))}.mdc-text-field:not(.mdc-text-field--disabled):hover .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.87);border-bottom-color:var(--mdc-text-field-hover-line-color, rgba(0, 0, 0, 0.87))}.mdc-text-field.mdc-text-field--disabled .mdc-line-ripple::before{border-bottom-color:rgba(0, 0, 0, 0.06);border-bottom-color:var(--mdc-text-field-disabled-line-color, rgba(0, 0, 0, 0.06))}.mdc-text-field.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple::before{border-bottom-color:#b00020;border-bottom-color:var(--mdc-theme-error, #b00020)}.mdc-text-field__input{direction:inherit}mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-outlined-idle-border-color, rgba(0, 0, 0, 0.38) )}:host(:not([disabled]):hover) :not(.mdc-text-field--invalid):not(.mdc-text-field--focused) mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-outlined-hover-border-color, rgba(0, 0, 0, 0.87) )}:host(:not([disabled])) .mdc-text-field:not(.mdc-text-field--outlined){background-color:var(--mdc-text-field-fill-color, whitesmoke)}:host(:not([disabled])) .mdc-text-field.mdc-text-field--invalid mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-error-color, var(--mdc-theme-error, #b00020) )}:host(:not([disabled])) .mdc-text-field.mdc-text-field--invalid+.mdc-text-field-helper-line .mdc-text-field-character-counter,:host(:not([disabled])) .mdc-text-field.mdc-text-field--invalid .mdc-text-field__icon{color:var(--mdc-text-field-error-color, var(--mdc-theme-error, #b00020))}:host(:not([disabled])) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label,:host(:not([disabled])) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label::after{color:var(--mdc-text-field-label-ink-color, rgba(0, 0, 0, 0.6))}:host(:not([disabled])) .mdc-text-field.mdc-text-field--focused mwc-notched-outline{--mdc-notched-outline-stroke-width: 2px}:host(:not([disabled])) .mdc-text-field.mdc-text-field--focused:not(.mdc-text-field--invalid) mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-focused-label-color, var(--mdc-theme-primary, rgba(98, 0, 238, 0.87)) )}:host(:not([disabled])) .mdc-text-field.mdc-text-field--focused:not(.mdc-text-field--invalid) .mdc-floating-label{color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}:host(:not([disabled])) .mdc-text-field .mdc-text-field__input{color:var(--mdc-text-field-ink-color, rgba(0, 0, 0, 0.87))}:host(:not([disabled])) .mdc-text-field .mdc-text-field__input::placeholder{color:var(--mdc-text-field-label-ink-color, rgba(0, 0, 0, 0.6))}:host(:not([disabled])) .mdc-text-field-helper-line .mdc-text-field-helper-text:not(.mdc-text-field-helper-text--validation-msg),:host(:not([disabled])) .mdc-text-field-helper-line:not(.mdc-text-field--invalid) .mdc-text-field-character-counter{color:var(--mdc-text-field-label-ink-color, rgba(0, 0, 0, 0.6))}:host([disabled]) .mdc-text-field:not(.mdc-text-field--outlined){background-color:var(--mdc-text-field-disabled-fill-color, #fafafa)}:host([disabled]) .mdc-text-field.mdc-text-field--outlined mwc-notched-outline{--mdc-notched-outline-border-color: var( --mdc-text-field-outlined-disabled-border-color, rgba(0, 0, 0, 0.06) )}:host([disabled]) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label,:host([disabled]) .mdc-text-field:not(.mdc-text-field--invalid):not(.mdc-text-field--focused) .mdc-floating-label::after{color:var(--mdc-text-field-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-text-field .mdc-text-field__input,:host([disabled]) .mdc-text-field .mdc-text-field__input::placeholder{color:var(--mdc-text-field-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-text-field-helper-line .mdc-text-field-helper-text,:host([disabled]) .mdc-text-field-helper-line .mdc-text-field-character-counter{color:var(--mdc-text-field-disabled-ink-color, rgba(0, 0, 0, 0.38))}`;

});


parcelRegister("8J3FQ", function(module, exports) {

$parcel$export(module.exports, "Button", () => $65a5603cebce531b$export$353f5b6fc5456de1);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("3F6f7");
var $6z5E5 = parcelRequire("6z5E5");

var $5tPGb = parcelRequire("5tPGb");

var $9vjNJ = parcelRequire("9vjNJ");
/** @soyCompatible */ let $65a5603cebce531b$export$353f5b6fc5456de1 = class Button extends (0, $5tPGb.ButtonBase) {
};
$65a5603cebce531b$export$353f5b6fc5456de1.styles = [
    (0, $9vjNJ.styles)
];
$65a5603cebce531b$export$353f5b6fc5456de1 = (0, $czHfO.__decorate)([
    (0, $6z5E5.customElement)('mwc-button')
], $65a5603cebce531b$export$353f5b6fc5456de1);

});
parcelRegister("3F6f7", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("6z5E5")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("3S1ZM")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("869TO")).state);
$parcel$export(module.exports, "eventOptions", () => (parcelRequire("lLudS")).eventOptions);
$parcel$export(module.exports, "query", () => (parcelRequire("gVOKm")).query);
$parcel$export(module.exports, "queryAsync", () => (parcelRequire("kSHsL")).queryAsync);
parcelRequire("6z5E5");
parcelRequire("3S1ZM");
parcelRequire("869TO");
parcelRequire("lLudS");
parcelRequire("gVOKm");
parcelRequire("9d5YI");
parcelRequire("kSHsL");
parcelRequire("3XccR");
parcelRequire("fTVFC");

});
parcelRegister("6z5E5", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $4c7a641081f096db$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4c7a641081f096db$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("3S1ZM", function(module, exports) {

$parcel$export(module.exports, "property", () => $2d17f6860a2d9938$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2d17f6860a2d9938$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $2d17f6860a2d9938$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $2d17f6860a2d9938$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $2d17f6860a2d9938$var$e(n, t, o) : $2d17f6860a2d9938$var$i(n, t);
}

});

parcelRegister("869TO", function(module, exports) {

$parcel$export(module.exports, "state", () => $5e56900dc0f98caf$export$ca000e230c0caa3e);

var $3S1ZM = parcelRequire("3S1ZM");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5e56900dc0f98caf$export$ca000e230c0caa3e(t) {
    return (0, $3S1ZM.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("lLudS", function(module, exports) {

$parcel$export(module.exports, "eventOptions", () => $fd856e61e4ab2d35$export$b2b799818fbabcf3);

var $4YmMH = parcelRequire("4YmMH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fd856e61e4ab2d35$export$b2b799818fbabcf3(e) {
    return (0, $4YmMH.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("4YmMH", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", () => $39ee708ef95e4baa$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $39ee708ef95e4baa$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $39ee708ef95e4baa$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $39ee708ef95e4baa$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("gVOKm", function(module, exports) {

$parcel$export(module.exports, "query", () => $c5395572aa2c7aea$export$2fa187e846a241c4);

var $4YmMH = parcelRequire("4YmMH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c5395572aa2c7aea$export$2fa187e846a241c4(i, n) {
    return (0, $4YmMH.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("9d5YI", function(module, exports) {

var $4YmMH = parcelRequire("4YmMH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6b49f71ed4a43ca7$export$dcd0d083aa86c355(e) {
    return (0, $4YmMH.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("kSHsL", function(module, exports) {

$parcel$export(module.exports, "queryAsync", () => $f33a90a33d18bc78$export$163dfc35cc43f240);

var $4YmMH = parcelRequire("4YmMH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f33a90a33d18bc78$export$163dfc35cc43f240(e) {
    return (0, $4YmMH.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("3XccR", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $2e1059bf7f63986c$export$4682af2d9ee91415);

var $4YmMH = parcelRequire("4YmMH");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $2e1059bf7f63986c$var$n;
const $2e1059bf7f63986c$var$e = null != (null === ($2e1059bf7f63986c$var$n = window.HTMLSlotElement) || void 0 === $2e1059bf7f63986c$var$n ? void 0 : $2e1059bf7f63986c$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $2e1059bf7f63986c$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $4YmMH.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $2e1059bf7f63986c$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("fTVFC", function(module, exports) {

var $4YmMH = parcelRequire("4YmMH");

var $3XccR = parcelRequire("3XccR");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $b938ba312fb64c57$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $3XccR.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $4YmMH.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("5tPGb", function(module, exports) {

$parcel$export(module.exports, "ButtonBase", () => $3fd7bf9e7b221017$export$b0bb876e969289cd);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("j8uFH");
parcelRequire("aX7Bm");

var $bAdyM = parcelRequire("bAdyM");

var $2qnKN = parcelRequire("2qnKN");
parcelRequire("i6A5S");
var $lzESM = parcelRequire("lzESM");
var $3J4ii = parcelRequire("3J4ii");
parcelRequire("3F6f7");
var $lLudS = parcelRequire("lLudS");
var $3S1ZM = parcelRequire("3S1ZM");
var $gVOKm = parcelRequire("gVOKm");
var $kSHsL = parcelRequire("kSHsL");
var $869TO = parcelRequire("869TO");
parcelRequire("379zR");
var $9BmKO = parcelRequire("9BmKO");
parcelRequire("kx3Sc");
var $5g1ov = parcelRequire("5g1ov");
class $3fd7bf9e7b221017$export$b0bb876e969289cd extends (0, $3J4ii.LitElement) {
    constructor(){
        super(...arguments);
        this.raised = false;
        this.unelevated = false;
        this.outlined = false;
        this.dense = false;
        this.disabled = false;
        this.trailingIcon = false;
        this.fullwidth = false;
        this.icon = '';
        this.label = '';
        this.expandContent = false;
        this.shouldRenderRipple = false;
        this.rippleHandlers = new (0, $2qnKN.RippleHandlers)(()=>{
            this.shouldRenderRipple = true;
            return this.ripple;
        });
    }
    /** @soyTemplate */ renderOverlay() {
        return (0, $lzESM.html)``;
    }
    /** @soyTemplate */ renderRipple() {
        const filled = this.raised || this.unelevated;
        return this.shouldRenderRipple ? (0, $lzESM.html)`<mwc-ripple class="ripple" .primary="${!filled}" .disabled="${this.disabled}"></mwc-ripple>` : '';
    }
    focus() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.startFocus();
            buttonElement.focus();
        }
    }
    blur() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.endFocus();
            buttonElement.blur();
        }
    }
    /** @soyTemplate */ getRenderClasses() {
        return {
            'mdc-button--raised': this.raised,
            'mdc-button--unelevated': this.unelevated,
            'mdc-button--outlined': this.outlined,
            'mdc-button--dense': this.dense
        };
    }
    /**
     * @soyTemplate
     * @soyAttributes buttonAttributes: #button
     * @soyClasses buttonClasses: #button
     */ render() {
        return (0, $lzESM.html)`
      <button
          id="button"
          class="mdc-button ${(0, $9BmKO.classMap)(this.getRenderClasses())}"
          ?disabled="${this.disabled}"
          aria-label="${this.label || this.icon}"
          aria-haspopup="${(0, $5g1ov.ifDefined)(this.ariaHasPopup)}"
          @focus="${this.handleRippleFocus}"
          @blur="${this.handleRippleBlur}"
          @mousedown="${this.handleRippleActivate}"
          @mouseenter="${this.handleRippleMouseEnter}"
          @mouseleave="${this.handleRippleMouseLeave}"
          @touchstart="${this.handleRippleActivate}"
          @touchend="${this.handleRippleDeactivate}"
          @touchcancel="${this.handleRippleDeactivate}">
        ${this.renderOverlay()}
        ${this.renderRipple()}
        <span class="leading-icon">
          <slot name="icon">
            ${this.icon && !this.trailingIcon ? this.renderIcon() : ''}
          </slot>
        </span>
        <span class="mdc-button__label">${this.label}</span>
        <span class="slot-container ${(0, $9BmKO.classMap)({
            flex: this.expandContent
        })}">
          <slot></slot>
        </span>
        <span class="trailing-icon">
          <slot name="trailingIcon">
            ${this.icon && this.trailingIcon ? this.renderIcon() : ''}
          </slot>
        </span>
      </button>`;
    }
    /** @soyTemplate */ renderIcon() {
        return (0, $lzESM.html)`
    <mwc-icon class="mdc-button__icon">
      ${this.icon}
    </mwc-icon>`;
    }
    handleRippleActivate(evt) {
        const onUp = ()=>{
            window.removeEventListener('mouseup', onUp);
            this.handleRippleDeactivate();
        };
        window.addEventListener('mouseup', onUp);
        this.rippleHandlers.startPress(evt);
    }
    handleRippleDeactivate() {
        this.rippleHandlers.endPress();
    }
    handleRippleMouseEnter() {
        this.rippleHandlers.startHover();
    }
    handleRippleMouseLeave() {
        this.rippleHandlers.endHover();
    }
    handleRippleFocus() {
        this.rippleHandlers.startFocus();
    }
    handleRippleBlur() {
        this.rippleHandlers.endFocus();
    }
}
$3fd7bf9e7b221017$export$b0bb876e969289cd.shadowRootOptions = {
    mode: 'open',
    delegatesFocus: true
};
(0, $czHfO.__decorate)([
    (0, $bAdyM.ariaProperty),
    (0, $3S1ZM.property)({
        type: String,
        attribute: 'aria-haspopup'
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "ariaHasPopup", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean,
        reflect: true
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "raised", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean,
        reflect: true
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "unelevated", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean,
        reflect: true
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "outlined", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "dense", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean,
        reflect: true
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "disabled", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean,
        attribute: 'trailingicon'
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "trailingIcon", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean,
        reflect: true
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "fullwidth", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: String
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "icon", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: String
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "label", void 0);
(0, $czHfO.__decorate)([
    (0, $3S1ZM.property)({
        type: Boolean
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "expandContent", void 0);
(0, $czHfO.__decorate)([
    (0, $gVOKm.query)('#button')
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "buttonElement", void 0);
(0, $czHfO.__decorate)([
    (0, $kSHsL.queryAsync)('mwc-ripple')
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "ripple", void 0);
(0, $czHfO.__decorate)([
    (0, $869TO.state)()
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "shouldRenderRipple", void 0);
(0, $czHfO.__decorate)([
    (0, $lLudS.eventOptions)({
        passive: true
    })
], $3fd7bf9e7b221017$export$b0bb876e969289cd.prototype, "handleRippleActivate", null);

});
parcelRegister("j8uFH", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("itMOk");
var $2zmoY = parcelRequire("2zmoY");
var $1Pko8 = parcelRequire("1Pko8");
parcelRequire("1ggEW");
var $hm5o2 = parcelRequire("hm5o2");

var $csjH2 = parcelRequire("csjH2");
/** @soyCompatible */ let $dee68e68baa7030e$export$f04a61298a47a40f = class Icon extends (0, $1Pko8.LitElement) {
    /** @soyTemplate */ render() {
        return (0, $2zmoY.html)`<span><slot></slot></span>`;
    }
};
$dee68e68baa7030e$export$f04a61298a47a40f.styles = [
    (0, $csjH2.styles)
];
$dee68e68baa7030e$export$f04a61298a47a40f = (0, $czHfO.__decorate)([
    (0, $hm5o2.customElement)('mwc-icon')
], $dee68e68baa7030e$export$f04a61298a47a40f);

});
parcelRegister("itMOk", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("2w8Sz")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("2zmoY")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("1Pko8")).LitElement);
parcelRequire("7H6Mx");
parcelRequire("2zmoY");
parcelRequire("1Pko8");
parcelRequire("1P8ye");

});
parcelRegister("7H6Mx", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $59a1cf46287252d6$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("2w8Sz")).css);

var $2w8Sz = parcelRequire("2w8Sz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $59a1cf46287252d6$var$s;
const $59a1cf46287252d6$var$e = window, $59a1cf46287252d6$var$r = $59a1cf46287252d6$var$e.trustedTypes, $59a1cf46287252d6$var$h = $59a1cf46287252d6$var$r ? $59a1cf46287252d6$var$r.emptyScript : "", $59a1cf46287252d6$var$o = $59a1cf46287252d6$var$e.reactiveElementPolyfillSupport, $59a1cf46287252d6$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $59a1cf46287252d6$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $59a1cf46287252d6$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $59a1cf46287252d6$var$l = {
    attribute: !0,
    type: String,
    converter: $59a1cf46287252d6$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $59a1cf46287252d6$export$53a6892c50694894
}, $59a1cf46287252d6$var$d = "finalized";
class $59a1cf46287252d6$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $59a1cf46287252d6$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $59a1cf46287252d6$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($59a1cf46287252d6$var$d)) return !1;
        this[$59a1cf46287252d6$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $2w8Sz.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $2w8Sz.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $2w8Sz.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $59a1cf46287252d6$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $59a1cf46287252d6$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $59a1cf46287252d6$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $59a1cf46287252d6$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$59a1cf46287252d6$export$c7c07a37856565d[$59a1cf46287252d6$var$d] = !0, $59a1cf46287252d6$export$c7c07a37856565d.elementProperties = new Map, $59a1cf46287252d6$export$c7c07a37856565d.elementStyles = [], $59a1cf46287252d6$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $59a1cf46287252d6$var$o || $59a1cf46287252d6$var$o({
    ReactiveElement: $59a1cf46287252d6$export$c7c07a37856565d
}), (null !== ($59a1cf46287252d6$var$s = $59a1cf46287252d6$var$e.reactiveElementVersions) && void 0 !== $59a1cf46287252d6$var$s ? $59a1cf46287252d6$var$s : $59a1cf46287252d6$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("2w8Sz", function(module, exports) {

$parcel$export(module.exports, "css", () => $1d557526343190b2$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $1d557526343190b2$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $1d557526343190b2$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1d557526343190b2$var$t = window, $1d557526343190b2$export$b4d10f6001c083c2 = $1d557526343190b2$var$t.ShadowRoot && (void 0 === $1d557526343190b2$var$t.ShadyCSS || $1d557526343190b2$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $1d557526343190b2$var$s = Symbol(), $1d557526343190b2$var$n = new WeakMap;
class $1d557526343190b2$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $1d557526343190b2$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($1d557526343190b2$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $1d557526343190b2$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $1d557526343190b2$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $1d557526343190b2$export$8d80f9cac07cdb3 = (t)=>new $1d557526343190b2$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $1d557526343190b2$var$s), $1d557526343190b2$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $1d557526343190b2$export$505d1e8739bad805(n, t, $1d557526343190b2$var$s);
}, $1d557526343190b2$export$2ca4a66ec4cecb90 = (s, n)=>{
    $1d557526343190b2$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $1d557526343190b2$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $1d557526343190b2$export$ee69dfd951e24778 = $1d557526343190b2$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $1d557526343190b2$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("2zmoY", function(module, exports) {

$parcel$export(module.exports, "html", () => $1df03a31c754e43f$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $1df03a31c754e43f$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "render", () => $1df03a31c754e43f$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $1df03a31c754e43f$var$t;
const $1df03a31c754e43f$var$i = window, $1df03a31c754e43f$var$s = $1df03a31c754e43f$var$i.trustedTypes, $1df03a31c754e43f$var$e = $1df03a31c754e43f$var$s ? $1df03a31c754e43f$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $1df03a31c754e43f$var$o = "$lit$", $1df03a31c754e43f$var$n = `lit$${(Math.random() + "").slice(9)}$`, $1df03a31c754e43f$var$l = "?" + $1df03a31c754e43f$var$n, $1df03a31c754e43f$var$h = `<${$1df03a31c754e43f$var$l}>`, $1df03a31c754e43f$var$r = document, $1df03a31c754e43f$var$u = ()=>$1df03a31c754e43f$var$r.createComment(""), $1df03a31c754e43f$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $1df03a31c754e43f$var$c = Array.isArray, $1df03a31c754e43f$var$v = (t)=>$1df03a31c754e43f$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $1df03a31c754e43f$var$a = "[ \t\n\f\r]", $1df03a31c754e43f$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $1df03a31c754e43f$var$_ = /-->/g, $1df03a31c754e43f$var$m = />/g, $1df03a31c754e43f$var$p = RegExp(`>|${$1df03a31c754e43f$var$a}(?:([^\\s"'>=/]+)(${$1df03a31c754e43f$var$a}*=${$1df03a31c754e43f$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $1df03a31c754e43f$var$g = /'/g, $1df03a31c754e43f$var$$ = /"/g, $1df03a31c754e43f$var$y = /^(?:script|style|textarea|title)$/i, $1df03a31c754e43f$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $1df03a31c754e43f$export$c0bb0b647f701bb5 = $1df03a31c754e43f$var$w(1), $1df03a31c754e43f$export$7ed1367e7fa1ad68 = $1df03a31c754e43f$var$w(2), $1df03a31c754e43f$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $1df03a31c754e43f$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $1df03a31c754e43f$var$E = new WeakMap, $1df03a31c754e43f$var$C = $1df03a31c754e43f$var$r.createTreeWalker($1df03a31c754e43f$var$r, 129, null, !1);
function $1df03a31c754e43f$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $1df03a31c754e43f$var$e ? $1df03a31c754e43f$var$e.createHTML(i) : i;
}
const $1df03a31c754e43f$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $1df03a31c754e43f$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $1df03a31c754e43f$var$f ? "!--" === c[1] ? u = $1df03a31c754e43f$var$_ : void 0 !== c[1] ? u = $1df03a31c754e43f$var$m : void 0 !== c[2] ? ($1df03a31c754e43f$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $1df03a31c754e43f$var$p) : void 0 !== c[3] && (u = $1df03a31c754e43f$var$p) : u === $1df03a31c754e43f$var$p ? ">" === c[0] ? (u = null != l ? l : $1df03a31c754e43f$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $1df03a31c754e43f$var$p : '"' === c[3] ? $1df03a31c754e43f$var$$ : $1df03a31c754e43f$var$g) : u === $1df03a31c754e43f$var$$ || u === $1df03a31c754e43f$var$g ? u = $1df03a31c754e43f$var$p : u === $1df03a31c754e43f$var$_ || u === $1df03a31c754e43f$var$m ? u = $1df03a31c754e43f$var$f : (u = $1df03a31c754e43f$var$p, l = void 0);
        const w = u === $1df03a31c754e43f$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $1df03a31c754e43f$var$f ? s + $1df03a31c754e43f$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $1df03a31c754e43f$var$o + s.slice(v) + $1df03a31c754e43f$var$n + w) : s + $1df03a31c754e43f$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $1df03a31c754e43f$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $1df03a31c754e43f$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $1df03a31c754e43f$var$V(t, i);
        if (this.el = $1df03a31c754e43f$var$N.createElement(a, e), $1df03a31c754e43f$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $1df03a31c754e43f$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($1df03a31c754e43f$var$o) || i.startsWith($1df03a31c754e43f$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $1df03a31c754e43f$var$o).split($1df03a31c754e43f$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $1df03a31c754e43f$var$H : "?" === i[1] ? $1df03a31c754e43f$var$L : "@" === i[1] ? $1df03a31c754e43f$var$z : $1df03a31c754e43f$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($1df03a31c754e43f$var$y.test(h.tagName)) {
                    const t = h.textContent.split($1df03a31c754e43f$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $1df03a31c754e43f$var$s ? $1df03a31c754e43f$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $1df03a31c754e43f$var$u()), $1df03a31c754e43f$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $1df03a31c754e43f$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $1df03a31c754e43f$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($1df03a31c754e43f$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $1df03a31c754e43f$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $1df03a31c754e43f$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $1df03a31c754e43f$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $1df03a31c754e43f$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $1df03a31c754e43f$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $1df03a31c754e43f$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $1df03a31c754e43f$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $1df03a31c754e43f$var$r).importNode(s, !0);
        $1df03a31c754e43f$var$C.currentNode = o;
        let n = $1df03a31c754e43f$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $1df03a31c754e43f$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $1df03a31c754e43f$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $1df03a31c754e43f$var$C.nextNode(), l++);
        }
        return $1df03a31c754e43f$var$C.currentNode = $1df03a31c754e43f$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $1df03a31c754e43f$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $1df03a31c754e43f$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $1df03a31c754e43f$var$S(this, t, i), $1df03a31c754e43f$var$d(t) ? t === $1df03a31c754e43f$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $1df03a31c754e43f$export$45b790e32b2810ee && this._$AR(), this._$AH = $1df03a31c754e43f$export$45b790e32b2810ee) : t !== this._$AH && t !== $1df03a31c754e43f$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $1df03a31c754e43f$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $1df03a31c754e43f$export$45b790e32b2810ee && $1df03a31c754e43f$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($1df03a31c754e43f$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $1df03a31c754e43f$var$N.createElement($1df03a31c754e43f$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $1df03a31c754e43f$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $1df03a31c754e43f$var$E.get(t.strings);
        return void 0 === i && $1df03a31c754e43f$var$E.set(t.strings, i = new $1df03a31c754e43f$var$N(t)), i;
    }
    T(t) {
        $1df03a31c754e43f$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $1df03a31c754e43f$var$R(this.k($1df03a31c754e43f$var$u()), this.k($1df03a31c754e43f$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $1df03a31c754e43f$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $1df03a31c754e43f$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $1df03a31c754e43f$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $1df03a31c754e43f$var$S(this, t, i, 0), n = !$1df03a31c754e43f$var$d(t) || t !== this._$AH && t !== $1df03a31c754e43f$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $1df03a31c754e43f$var$S(this, e[s + l], i, l), h === $1df03a31c754e43f$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$1df03a31c754e43f$var$d(h) || h !== this._$AH[l]), h === $1df03a31c754e43f$export$45b790e32b2810ee ? t = $1df03a31c754e43f$export$45b790e32b2810ee : t !== $1df03a31c754e43f$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $1df03a31c754e43f$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $1df03a31c754e43f$var$H extends $1df03a31c754e43f$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $1df03a31c754e43f$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $1df03a31c754e43f$var$I = $1df03a31c754e43f$var$s ? $1df03a31c754e43f$var$s.emptyScript : "";
class $1df03a31c754e43f$var$L extends $1df03a31c754e43f$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $1df03a31c754e43f$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $1df03a31c754e43f$var$I) : this.element.removeAttribute(this.name);
    }
}
class $1df03a31c754e43f$var$z extends $1df03a31c754e43f$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $1df03a31c754e43f$var$S(this, t, i, 0)) && void 0 !== s ? s : $1df03a31c754e43f$export$45b790e32b2810ee) === $1df03a31c754e43f$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $1df03a31c754e43f$export$45b790e32b2810ee && e !== $1df03a31c754e43f$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $1df03a31c754e43f$export$45b790e32b2810ee && (e === $1df03a31c754e43f$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $1df03a31c754e43f$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $1df03a31c754e43f$var$S(this, t);
    }
}
const $1df03a31c754e43f$export$8613d1ca9052b22e = {
    O: $1df03a31c754e43f$var$o,
    P: $1df03a31c754e43f$var$n,
    A: $1df03a31c754e43f$var$l,
    C: 1,
    M: $1df03a31c754e43f$var$V,
    L: $1df03a31c754e43f$var$M,
    R: $1df03a31c754e43f$var$v,
    D: $1df03a31c754e43f$var$S,
    I: $1df03a31c754e43f$var$R,
    V: $1df03a31c754e43f$var$k,
    H: $1df03a31c754e43f$var$L,
    N: $1df03a31c754e43f$var$z,
    U: $1df03a31c754e43f$var$H,
    F: $1df03a31c754e43f$var$Z
}, $1df03a31c754e43f$var$B = $1df03a31c754e43f$var$i.litHtmlPolyfillSupport;
null == $1df03a31c754e43f$var$B || $1df03a31c754e43f$var$B($1df03a31c754e43f$var$N, $1df03a31c754e43f$var$R), (null !== ($1df03a31c754e43f$var$t = $1df03a31c754e43f$var$i.litHtmlVersions) && void 0 !== $1df03a31c754e43f$var$t ? $1df03a31c754e43f$var$t : $1df03a31c754e43f$var$i.litHtmlVersions = []).push("2.8.0");
const $1df03a31c754e43f$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $1df03a31c754e43f$var$R(i.insertBefore($1df03a31c754e43f$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("1Pko8", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("2w8Sz")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("7H6Mx")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("2zmoY")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("2zmoY")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("2zmoY")).render);

$parcel$export(module.exports, "LitElement", () => $154a5e89a83e8b26$export$3f2f9f5909897157);

var $7H6Mx = parcelRequire("7H6Mx");

var $2zmoY = parcelRequire("2zmoY");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $154a5e89a83e8b26$var$l, $154a5e89a83e8b26$var$o;
const $154a5e89a83e8b26$export$8bf27daf9e8907c9 = (0, $7H6Mx.ReactiveElement);
class $154a5e89a83e8b26$export$3f2f9f5909897157 extends (0, $7H6Mx.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $2zmoY.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $2zmoY.noChange;
    }
}
$154a5e89a83e8b26$export$3f2f9f5909897157.finalized = !0, $154a5e89a83e8b26$export$3f2f9f5909897157._$litElement$ = !0, null === ($154a5e89a83e8b26$var$l = globalThis.litElementHydrateSupport) || void 0 === $154a5e89a83e8b26$var$l || $154a5e89a83e8b26$var$l.call(globalThis, {
    LitElement: $154a5e89a83e8b26$export$3f2f9f5909897157
});
const $154a5e89a83e8b26$var$n = globalThis.litElementPolyfillSupport;
null == $154a5e89a83e8b26$var$n || $154a5e89a83e8b26$var$n({
    LitElement: $154a5e89a83e8b26$export$3f2f9f5909897157
});
const $154a5e89a83e8b26$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($154a5e89a83e8b26$var$o = globalThis.litElementVersions) && void 0 !== $154a5e89a83e8b26$var$o ? $154a5e89a83e8b26$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("1P8ye", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $15412ff6c3d095d0$export$6acf61af03e62db = !1;

});


parcelRegister("1ggEW", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("hm5o2")).customElement);
parcelRequire("hm5o2");
parcelRequire("CIYmB");
parcelRequire("eHXhN");
parcelRequire("8dhE1");
parcelRequire("03re0");
parcelRequire("hfA8N");
parcelRequire("e8KmJ");
parcelRequire("lC7V7");
parcelRequire("8oCvw");

});
parcelRegister("hm5o2", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $ca28ab6a716a128e$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ca28ab6a716a128e$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("CIYmB", function(module, exports) {

$parcel$export(module.exports, "property", () => $07466f58d9773b8c$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $07466f58d9773b8c$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $07466f58d9773b8c$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $07466f58d9773b8c$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $07466f58d9773b8c$var$e(n, t, o) : $07466f58d9773b8c$var$i(n, t);
}

});

parcelRegister("eHXhN", function(module, exports) {

var $CIYmB = parcelRequire("CIYmB");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ab5311d30190f74b$export$ca000e230c0caa3e(t) {
    return (0, $CIYmB.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("8dhE1", function(module, exports) {

var $i2tTx = parcelRequire("i2tTx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5fad397c01bc9b86$export$b2b799818fbabcf3(e) {
    return (0, $i2tTx.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("i2tTx", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", () => $d21f9a5f72f1a575$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d21f9a5f72f1a575$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $d21f9a5f72f1a575$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $d21f9a5f72f1a575$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("03re0", function(module, exports) {

var $i2tTx = parcelRequire("i2tTx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $00a5663cc486d6f2$export$2fa187e846a241c4(i, n) {
    return (0, $i2tTx.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("hfA8N", function(module, exports) {

var $i2tTx = parcelRequire("i2tTx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c8efdf3486bb1d27$export$dcd0d083aa86c355(e) {
    return (0, $i2tTx.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("e8KmJ", function(module, exports) {

var $i2tTx = parcelRequire("i2tTx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a4b5c7516f4f01d0$export$163dfc35cc43f240(e) {
    return (0, $i2tTx.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("lC7V7", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $fbc34a5e05836ee7$export$4682af2d9ee91415);

var $i2tTx = parcelRequire("i2tTx");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fbc34a5e05836ee7$var$n;
const $fbc34a5e05836ee7$var$e = null != (null === ($fbc34a5e05836ee7$var$n = window.HTMLSlotElement) || void 0 === $fbc34a5e05836ee7$var$n ? void 0 : $fbc34a5e05836ee7$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $fbc34a5e05836ee7$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $i2tTx.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $fbc34a5e05836ee7$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("8oCvw", function(module, exports) {

var $i2tTx = parcelRequire("i2tTx");

var $lC7V7 = parcelRequire("lC7V7");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $61ce6f69593bc205$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $lC7V7.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $i2tTx.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("csjH2", function(module, exports) {

$parcel$export(module.exports, "styles", () => $9117603cbd267a23$export$9dd6ff9ea0189349);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ parcelRequire("itMOk");
var $2w8Sz = parcelRequire("2w8Sz");
const $9117603cbd267a23$export$9dd6ff9ea0189349 = (0, $2w8Sz.css)`:host{font-family:var(--mdc-icon-font, "Material Icons");font-weight:normal;font-style:normal;font-size:var(--mdc-icon-size, 24px);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:"liga"}`;

});


parcelRegister("aX7Bm", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("5X7LR");
var $fye4C = parcelRequire("fye4C");

var $5wlgS = parcelRequire("5wlgS");

var $d4Air = parcelRequire("d4Air");
/** @soyCompatible */ let $7f954f9a5bae69bf$export$9e9146f7e027fdaa = class Ripple extends (0, $5wlgS.RippleBase) {
};
$7f954f9a5bae69bf$export$9e9146f7e027fdaa.styles = [
    (0, $d4Air.styles)
];
$7f954f9a5bae69bf$export$9e9146f7e027fdaa = (0, $czHfO.__decorate)([
    (0, $fye4C.customElement)('mwc-ripple')
], $7f954f9a5bae69bf$export$9e9146f7e027fdaa);

});
parcelRegister("5X7LR", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("fye4C")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("02fBp")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("lhKJu")).state);
$parcel$export(module.exports, "query", () => (parcelRequire("2VH94")).query);
parcelRequire("fye4C");
parcelRequire("02fBp");
parcelRequire("lhKJu");
parcelRequire("22dhK");
parcelRequire("2VH94");
parcelRequire("jlk1t");
parcelRequire("jS8aD");
parcelRequire("4bkYJ");
parcelRequire("bCMAY");

});
parcelRegister("fye4C", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $b524f2b13a429077$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b524f2b13a429077$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("02fBp", function(module, exports) {

$parcel$export(module.exports, "property", () => $006c4a4de694fe1f$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $006c4a4de694fe1f$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $006c4a4de694fe1f$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $006c4a4de694fe1f$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $006c4a4de694fe1f$var$e(n, t, o) : $006c4a4de694fe1f$var$i(n, t);
}

});

parcelRegister("lhKJu", function(module, exports) {

$parcel$export(module.exports, "state", () => $f7ef6fab9cd063c5$export$ca000e230c0caa3e);

var $02fBp = parcelRequire("02fBp");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f7ef6fab9cd063c5$export$ca000e230c0caa3e(t) {
    return (0, $02fBp.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("22dhK", function(module, exports) {

var $f6Z7h = parcelRequire("f6Z7h");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $17b612df4406c7b4$export$b2b799818fbabcf3(e) {
    return (0, $f6Z7h.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("f6Z7h", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", () => $b006d3052aea6151$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b006d3052aea6151$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $b006d3052aea6151$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $b006d3052aea6151$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("2VH94", function(module, exports) {

$parcel$export(module.exports, "query", () => $22225f65279adf1d$export$2fa187e846a241c4);

var $f6Z7h = parcelRequire("f6Z7h");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $22225f65279adf1d$export$2fa187e846a241c4(i, n) {
    return (0, $f6Z7h.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("jlk1t", function(module, exports) {

var $f6Z7h = parcelRequire("f6Z7h");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e14f829679acd77f$export$dcd0d083aa86c355(e) {
    return (0, $f6Z7h.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("jS8aD", function(module, exports) {

var $f6Z7h = parcelRequire("f6Z7h");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e77965fa8fe7f42c$export$163dfc35cc43f240(e) {
    return (0, $f6Z7h.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("4bkYJ", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $30b876639785d65c$export$4682af2d9ee91415);

var $f6Z7h = parcelRequire("f6Z7h");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $30b876639785d65c$var$n;
const $30b876639785d65c$var$e = null != (null === ($30b876639785d65c$var$n = window.HTMLSlotElement) || void 0 === $30b876639785d65c$var$n ? void 0 : $30b876639785d65c$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $30b876639785d65c$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $f6Z7h.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $30b876639785d65c$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("bCMAY", function(module, exports) {

var $f6Z7h = parcelRequire("f6Z7h");

var $4bkYJ = parcelRequire("4bkYJ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8768f05c8ce84437$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $4bkYJ.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $f6Z7h.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("5wlgS", function(module, exports) {

$parcel$export(module.exports, "RippleBase", () => $405070f2edeed7dc$export$6ecc905fed2eeb50);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");

var $5ykzV = parcelRequire("5ykzV");

var $4ifWP = parcelRequire("4ifWP");

var $lNw0M = parcelRequire("lNw0M");
parcelRequire("3DBaL");
var $6uuWr = parcelRequire("6uuWr");
parcelRequire("5X7LR");
var $02fBp = parcelRequire("02fBp");
var $2VH94 = parcelRequire("2VH94");
var $lhKJu = parcelRequire("lhKJu");
parcelRequire("jNp8f");
var $5Lo8m = parcelRequire("5Lo8m");
parcelRequire("9p3hX");
var $cqiF9 = parcelRequire("cqiF9");
class $405070f2edeed7dc$export$6ecc905fed2eeb50 extends (0, $4ifWP.BaseElement) {
    constructor(){
        super(...arguments);
        this.primary = false;
        this.accent = false;
        this.unbounded = false;
        this.disabled = false;
        this.activated = false;
        this.selected = false;
        this.internalUseStateLayerCustomProperties = false;
        this.hovering = false;
        this.bgFocused = false;
        this.fgActivation = false;
        this.fgDeactivation = false;
        this.fgScale = '';
        this.fgSize = '';
        this.translateStart = '';
        this.translateEnd = '';
        this.leftPos = '';
        this.topPos = '';
        this.mdcFoundationClass = (0, $lNw0M.default);
    }
    get isActive() {
        return (0, $5ykzV.matches)(this.parentElement || this, ':active');
    }
    createAdapter() {
        return {
            browserSupportsCssVars: ()=>true,
            isUnbounded: ()=>this.unbounded,
            isSurfaceActive: ()=>this.isActive,
            isSurfaceDisabled: ()=>this.disabled,
            addClass: (className)=>{
                switch(className){
                    case 'mdc-ripple-upgraded--background-focused':
                        this.bgFocused = true;
                        break;
                    case 'mdc-ripple-upgraded--foreground-activation':
                        this.fgActivation = true;
                        break;
                    case 'mdc-ripple-upgraded--foreground-deactivation':
                        this.fgDeactivation = true;
                        break;
                    default:
                        break;
                }
            },
            removeClass: (className)=>{
                switch(className){
                    case 'mdc-ripple-upgraded--background-focused':
                        this.bgFocused = false;
                        break;
                    case 'mdc-ripple-upgraded--foreground-activation':
                        this.fgActivation = false;
                        break;
                    case 'mdc-ripple-upgraded--foreground-deactivation':
                        this.fgDeactivation = false;
                        break;
                    default:
                        break;
                }
            },
            containsEventTarget: ()=>true,
            registerInteractionHandler: ()=>undefined,
            deregisterInteractionHandler: ()=>undefined,
            registerDocumentInteractionHandler: ()=>undefined,
            deregisterDocumentInteractionHandler: ()=>undefined,
            registerResizeHandler: ()=>undefined,
            deregisterResizeHandler: ()=>undefined,
            updateCssVariable: (varName, value)=>{
                switch(varName){
                    case '--mdc-ripple-fg-scale':
                        this.fgScale = value;
                        break;
                    case '--mdc-ripple-fg-size':
                        this.fgSize = value;
                        break;
                    case '--mdc-ripple-fg-translate-end':
                        this.translateEnd = value;
                        break;
                    case '--mdc-ripple-fg-translate-start':
                        this.translateStart = value;
                        break;
                    case '--mdc-ripple-left':
                        this.leftPos = value;
                        break;
                    case '--mdc-ripple-top':
                        this.topPos = value;
                        break;
                    default:
                        break;
                }
            },
            computeBoundingRect: ()=>(this.parentElement || this).getBoundingClientRect(),
            getWindowPageOffset: ()=>({
                    x: window.pageXOffset,
                    y: window.pageYOffset
                })
        };
    }
    startPress(ev) {
        this.waitForFoundation(()=>{
            this.mdcFoundation.activate(ev);
        });
    }
    endPress() {
        this.waitForFoundation(()=>{
            this.mdcFoundation.deactivate();
        });
    }
    startFocus() {
        this.waitForFoundation(()=>{
            this.mdcFoundation.handleFocus();
        });
    }
    endFocus() {
        this.waitForFoundation(()=>{
            this.mdcFoundation.handleBlur();
        });
    }
    startHover() {
        this.hovering = true;
    }
    endHover() {
        this.hovering = false;
    }
    /**
     * Wait for the MDCFoundation to be created by `firstUpdated`
     */ waitForFoundation(fn) {
        if (this.mdcFoundation) fn();
        else this.updateComplete.then(fn);
    }
    update(changedProperties) {
        if (changedProperties.has('disabled')) // stop hovering when ripple is disabled to prevent a stuck "hover" state
        // When re-enabled, the outer component will get a `mouseenter` event on
        // the first movement, which will call `startHover()`
        {
            if (this.disabled) this.endHover();
        }
        super.update(changedProperties);
    }
    /** @soyTemplate */ render() {
        const shouldActivateInPrimary = this.activated && (this.primary || !this.accent);
        const shouldSelectInPrimary = this.selected && (this.primary || !this.accent);
        /** @classMap */ const classes = {
            'mdc-ripple-surface--accent': this.accent,
            'mdc-ripple-surface--primary--activated': shouldActivateInPrimary,
            'mdc-ripple-surface--accent--activated': this.accent && this.activated,
            'mdc-ripple-surface--primary--selected': shouldSelectInPrimary,
            'mdc-ripple-surface--accent--selected': this.accent && this.selected,
            'mdc-ripple-surface--disabled': this.disabled,
            'mdc-ripple-surface--hover': this.hovering,
            'mdc-ripple-surface--primary': this.primary,
            'mdc-ripple-surface--selected': this.selected,
            'mdc-ripple-upgraded--background-focused': this.bgFocused,
            'mdc-ripple-upgraded--foreground-activation': this.fgActivation,
            'mdc-ripple-upgraded--foreground-deactivation': this.fgDeactivation,
            'mdc-ripple-upgraded--unbounded': this.unbounded,
            'mdc-ripple-surface--internal-use-state-layer-custom-properties': this.internalUseStateLayerCustomProperties
        };
        return (0, $6uuWr.html)`
        <div class="mdc-ripple-surface mdc-ripple-upgraded ${(0, $5Lo8m.classMap)(classes)}"
          style="${(0, $cqiF9.styleMap)({
            '--mdc-ripple-fg-scale': this.fgScale,
            '--mdc-ripple-fg-size': this.fgSize,
            '--mdc-ripple-fg-translate-end': this.translateEnd,
            '--mdc-ripple-fg-translate-start': this.translateStart,
            '--mdc-ripple-left': this.leftPos,
            '--mdc-ripple-top': this.topPos
        })}"></div>`;
    }
}
(0, $czHfO.__decorate)([
    (0, $2VH94.query)('.mdc-ripple-surface')
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $02fBp.property)({
        type: Boolean
    })
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "primary", void 0);
(0, $czHfO.__decorate)([
    (0, $02fBp.property)({
        type: Boolean
    })
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "accent", void 0);
(0, $czHfO.__decorate)([
    (0, $02fBp.property)({
        type: Boolean
    })
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "unbounded", void 0);
(0, $czHfO.__decorate)([
    (0, $02fBp.property)({
        type: Boolean
    })
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "disabled", void 0);
(0, $czHfO.__decorate)([
    (0, $02fBp.property)({
        type: Boolean
    })
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "activated", void 0);
(0, $czHfO.__decorate)([
    (0, $02fBp.property)({
        type: Boolean
    })
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "selected", void 0);
(0, $czHfO.__decorate)([
    (0, $02fBp.property)({
        type: Boolean
    })
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "internalUseStateLayerCustomProperties", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "hovering", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "bgFocused", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "fgActivation", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "fgDeactivation", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "fgScale", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "fgSize", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "translateStart", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "translateEnd", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "leftPos", void 0);
(0, $czHfO.__decorate)([
    (0, $lhKJu.state)()
], $405070f2edeed7dc$export$6ecc905fed2eeb50.prototype, "topPos", void 0);

});
parcelRegister("5ykzV", function(module, exports) {

$parcel$export(module.exports, "matches", () => $40b0172f554e940a$export$de994efd351b291c);
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
 */ function $40b0172f554e940a$export$ff7f7c97cdce86e(element, selector) {
    if (element.closest) return element.closest(selector);
    var el = element;
    while(el){
        if ($40b0172f554e940a$export$de994efd351b291c(el, selector)) return el;
        el = el.parentElement;
    }
    return null;
}
function $40b0172f554e940a$export$de994efd351b291c(element, selector) {
    var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    return nativeMatches.call(element, selector);
}
function $40b0172f554e940a$export$30f5493effae393e(element) {
    // Check the offsetParent. If the element inherits display: none from any
    // parent, the offsetParent property will be null (see
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
    // This check ensures we only clone the node when necessary.
    var htmlEl = element;
    if (htmlEl.offsetParent !== null) return htmlEl.scrollWidth;
    var clone = htmlEl.cloneNode(true);
    clone.style.setProperty('position', 'absolute');
    clone.style.setProperty('transform', 'translate(-9999px, -9999px)');
    document.documentElement.appendChild(clone);
    var scrollWidth = clone.scrollWidth;
    document.documentElement.removeChild(clone);
    return scrollWidth;
}

});

parcelRegister("lNw0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde701646d4bc616$export$2e2bcd8739ae039);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");

var $dnVN6 = parcelRequire("dnVN6");

var $lTuEj = parcelRequire("lTuEj");

var $3Y5vC = parcelRequire("3Y5vC");
// Activation events registered on the root element of each instance for activation
var $fde701646d4bc616$var$ACTIVATION_EVENT_TYPES = [
    'touchstart',
    'pointerdown',
    'mousedown',
    'keydown'
];
// Deactivation events registered on documentElement when a pointer-related down event occurs
var $fde701646d4bc616$var$POINTER_DEACTIVATION_EVENT_TYPES = [
    'touchend',
    'pointerup',
    'mouseup',
    'contextmenu'
];
// simultaneous nested activations
var $fde701646d4bc616$var$activatedTargets = [];
var $fde701646d4bc616$export$fb5f028029d92ef5 = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCRippleFoundation, _super);
    function MDCRippleFoundation(adapter) {
        var _this = _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCRippleFoundation.defaultAdapter), adapter)) || this;
        _this.activationAnimationHasEnded = false;
        _this.activationTimer = 0;
        _this.fgDeactivationRemovalTimer = 0;
        _this.fgScale = '0';
        _this.frame = {
            width: 0,
            height: 0
        };
        _this.initialSize = 0;
        _this.layoutFrame = 0;
        _this.maxRadius = 0;
        _this.unboundedCoords = {
            left: 0,
            top: 0
        };
        _this.activationState = _this.defaultActivationState();
        _this.activationTimerCallback = function() {
            _this.activationAnimationHasEnded = true;
            _this.runDeactivationUXLogicIfReady();
        };
        _this.activateHandler = function(e) {
            _this.activateImpl(e);
        };
        _this.deactivateHandler = function() {
            _this.deactivateImpl();
        };
        _this.focusHandler = function() {
            _this.handleFocus();
        };
        _this.blurHandler = function() {
            _this.handleBlur();
        };
        _this.resizeHandler = function() {
            _this.layout();
        };
        return _this;
    }
    Object.defineProperty(MDCRippleFoundation, "cssClasses", {
        get: function() {
            return 0, $lTuEj.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "strings", {
        get: function() {
            return 0, $lTuEj.strings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "numbers", {
        get: function() {
            return 0, $lTuEj.numbers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCRippleFoundation, "defaultAdapter", {
        get: function() {
            return {
                addClass: function() {
                    return undefined;
                },
                browserSupportsCssVars: function() {
                    return true;
                },
                computeBoundingRect: function() {
                    return {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                },
                containsEventTarget: function() {
                    return true;
                },
                deregisterDocumentInteractionHandler: function() {
                    return undefined;
                },
                deregisterInteractionHandler: function() {
                    return undefined;
                },
                deregisterResizeHandler: function() {
                    return undefined;
                },
                getWindowPageOffset: function() {
                    return {
                        x: 0,
                        y: 0
                    };
                },
                isSurfaceActive: function() {
                    return true;
                },
                isSurfaceDisabled: function() {
                    return true;
                },
                isUnbounded: function() {
                    return true;
                },
                registerDocumentInteractionHandler: function() {
                    return undefined;
                },
                registerInteractionHandler: function() {
                    return undefined;
                },
                registerResizeHandler: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                updateCssVariable: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCRippleFoundation.prototype.init = function() {
        var _this = this;
        var supportsPressRipple = this.supportsPressRipple();
        this.registerRootHandlers(supportsPressRipple);
        if (supportsPressRipple) {
            var _a = MDCRippleFoundation.cssClasses, ROOT_1 = _a.ROOT, UNBOUNDED_1 = _a.UNBOUNDED;
            requestAnimationFrame(function() {
                _this.adapter.addClass(ROOT_1);
                if (_this.adapter.isUnbounded()) {
                    _this.adapter.addClass(UNBOUNDED_1);
                    // Unbounded ripples need layout logic applied immediately to set coordinates for both shade and ripple
                    _this.layoutInternal();
                }
            });
        }
    };
    MDCRippleFoundation.prototype.destroy = function() {
        var _this = this;
        if (this.supportsPressRipple()) {
            if (this.activationTimer) {
                clearTimeout(this.activationTimer);
                this.activationTimer = 0;
                this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_ACTIVATION);
            }
            if (this.fgDeactivationRemovalTimer) {
                clearTimeout(this.fgDeactivationRemovalTimer);
                this.fgDeactivationRemovalTimer = 0;
                this.adapter.removeClass(MDCRippleFoundation.cssClasses.FG_DEACTIVATION);
            }
            var _a = MDCRippleFoundation.cssClasses, ROOT_2 = _a.ROOT, UNBOUNDED_2 = _a.UNBOUNDED;
            requestAnimationFrame(function() {
                _this.adapter.removeClass(ROOT_2);
                _this.adapter.removeClass(UNBOUNDED_2);
                _this.removeCssVars();
            });
        }
        this.deregisterRootHandlers();
        this.deregisterDeactivationHandlers();
    };
    /**
     * @param evt Optional event containing position information.
     */ MDCRippleFoundation.prototype.activate = function(evt) {
        this.activateImpl(evt);
    };
    MDCRippleFoundation.prototype.deactivate = function() {
        this.deactivateImpl();
    };
    MDCRippleFoundation.prototype.layout = function() {
        var _this = this;
        if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(function() {
            _this.layoutInternal();
            _this.layoutFrame = 0;
        });
    };
    MDCRippleFoundation.prototype.setUnbounded = function(unbounded) {
        var UNBOUNDED = MDCRippleFoundation.cssClasses.UNBOUNDED;
        if (unbounded) this.adapter.addClass(UNBOUNDED);
        else this.adapter.removeClass(UNBOUNDED);
    };
    MDCRippleFoundation.prototype.handleFocus = function() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.adapter.addClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
    };
    MDCRippleFoundation.prototype.handleBlur = function() {
        var _this = this;
        requestAnimationFrame(function() {
            return _this.adapter.removeClass(MDCRippleFoundation.cssClasses.BG_FOCUSED);
        });
    };
    /**
     * We compute this property so that we are not querying information about the client
     * until the point in time where the foundation requests it. This prevents scenarios where
     * client-side feature-detection may happen too early, such as when components are rendered on the server
     * and then initialized at mount time on the client.
     */ MDCRippleFoundation.prototype.supportsPressRipple = function() {
        return this.adapter.browserSupportsCssVars();
    };
    MDCRippleFoundation.prototype.defaultActivationState = function() {
        return {
            activationEvent: undefined,
            hasDeactivationUXRun: false,
            isActivated: false,
            isProgrammatic: false,
            wasActivatedByPointer: false,
            wasElementMadeActive: false
        };
    };
    /**
     * supportsPressRipple Passed from init to save a redundant function call
     */ MDCRippleFoundation.prototype.registerRootHandlers = function(supportsPressRipple) {
        var e_1, _a;
        if (supportsPressRipple) {
            try {
                for(var ACTIVATION_EVENT_TYPES_1 = (0, $czHfO.__values)($fde701646d4bc616$var$ACTIVATION_EVENT_TYPES), ACTIVATION_EVENT_TYPES_1_1 = ACTIVATION_EVENT_TYPES_1.next(); !ACTIVATION_EVENT_TYPES_1_1.done; ACTIVATION_EVENT_TYPES_1_1 = ACTIVATION_EVENT_TYPES_1.next()){
                    var evtType = ACTIVATION_EVENT_TYPES_1_1.value;
                    this.adapter.registerInteractionHandler(evtType, this.activateHandler);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (ACTIVATION_EVENT_TYPES_1_1 && !ACTIVATION_EVENT_TYPES_1_1.done && (_a = ACTIVATION_EVENT_TYPES_1.return)) _a.call(ACTIVATION_EVENT_TYPES_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (this.adapter.isUnbounded()) this.adapter.registerResizeHandler(this.resizeHandler);
        }
        this.adapter.registerInteractionHandler('focus', this.focusHandler);
        this.adapter.registerInteractionHandler('blur', this.blurHandler);
    };
    MDCRippleFoundation.prototype.registerDeactivationHandlers = function(evt) {
        var e_2, _a;
        if (evt.type === 'keydown') this.adapter.registerInteractionHandler('keyup', this.deactivateHandler);
        else try {
            for(var POINTER_DEACTIVATION_EVENT_TYPES_1 = (0, $czHfO.__values)($fde701646d4bc616$var$POINTER_DEACTIVATION_EVENT_TYPES), POINTER_DEACTIVATION_EVENT_TYPES_1_1 = POINTER_DEACTIVATION_EVENT_TYPES_1.next(); !POINTER_DEACTIVATION_EVENT_TYPES_1_1.done; POINTER_DEACTIVATION_EVENT_TYPES_1_1 = POINTER_DEACTIVATION_EVENT_TYPES_1.next()){
                var evtType = POINTER_DEACTIVATION_EVENT_TYPES_1_1.value;
                this.adapter.registerDocumentInteractionHandler(evtType, this.deactivateHandler);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (POINTER_DEACTIVATION_EVENT_TYPES_1_1 && !POINTER_DEACTIVATION_EVENT_TYPES_1_1.done && (_a = POINTER_DEACTIVATION_EVENT_TYPES_1.return)) _a.call(POINTER_DEACTIVATION_EVENT_TYPES_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MDCRippleFoundation.prototype.deregisterRootHandlers = function() {
        var e_3, _a;
        try {
            for(var ACTIVATION_EVENT_TYPES_2 = (0, $czHfO.__values)($fde701646d4bc616$var$ACTIVATION_EVENT_TYPES), ACTIVATION_EVENT_TYPES_2_1 = ACTIVATION_EVENT_TYPES_2.next(); !ACTIVATION_EVENT_TYPES_2_1.done; ACTIVATION_EVENT_TYPES_2_1 = ACTIVATION_EVENT_TYPES_2.next()){
                var evtType = ACTIVATION_EVENT_TYPES_2_1.value;
                this.adapter.deregisterInteractionHandler(evtType, this.activateHandler);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (ACTIVATION_EVENT_TYPES_2_1 && !ACTIVATION_EVENT_TYPES_2_1.done && (_a = ACTIVATION_EVENT_TYPES_2.return)) _a.call(ACTIVATION_EVENT_TYPES_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        this.adapter.deregisterInteractionHandler('focus', this.focusHandler);
        this.adapter.deregisterInteractionHandler('blur', this.blurHandler);
        if (this.adapter.isUnbounded()) this.adapter.deregisterResizeHandler(this.resizeHandler);
    };
    MDCRippleFoundation.prototype.deregisterDeactivationHandlers = function() {
        var e_4, _a;
        this.adapter.deregisterInteractionHandler('keyup', this.deactivateHandler);
        try {
            for(var POINTER_DEACTIVATION_EVENT_TYPES_2 = (0, $czHfO.__values)($fde701646d4bc616$var$POINTER_DEACTIVATION_EVENT_TYPES), POINTER_DEACTIVATION_EVENT_TYPES_2_1 = POINTER_DEACTIVATION_EVENT_TYPES_2.next(); !POINTER_DEACTIVATION_EVENT_TYPES_2_1.done; POINTER_DEACTIVATION_EVENT_TYPES_2_1 = POINTER_DEACTIVATION_EVENT_TYPES_2.next()){
                var evtType = POINTER_DEACTIVATION_EVENT_TYPES_2_1.value;
                this.adapter.deregisterDocumentInteractionHandler(evtType, this.deactivateHandler);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (POINTER_DEACTIVATION_EVENT_TYPES_2_1 && !POINTER_DEACTIVATION_EVENT_TYPES_2_1.done && (_a = POINTER_DEACTIVATION_EVENT_TYPES_2.return)) _a.call(POINTER_DEACTIVATION_EVENT_TYPES_2);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
    };
    MDCRippleFoundation.prototype.removeCssVars = function() {
        var _this = this;
        var rippleStrings = MDCRippleFoundation.strings;
        var keys = Object.keys(rippleStrings);
        keys.forEach(function(key) {
            if (key.indexOf('VAR_') === 0) _this.adapter.updateCssVariable(rippleStrings[key], null);
        });
    };
    MDCRippleFoundation.prototype.activateImpl = function(evt) {
        var _this = this;
        if (this.adapter.isSurfaceDisabled()) return;
        var activationState = this.activationState;
        if (activationState.isActivated) return;
        // Avoid reacting to follow-on events fired by touch device after an already-processed user interaction
        var previousActivationEvent = this.previousActivationEvent;
        var isSameInteraction = previousActivationEvent && evt !== undefined && previousActivationEvent.type !== evt.type;
        if (isSameInteraction) return;
        activationState.isActivated = true;
        activationState.isProgrammatic = evt === undefined;
        activationState.activationEvent = evt;
        activationState.wasActivatedByPointer = activationState.isProgrammatic ? false : evt !== undefined && (evt.type === 'mousedown' || evt.type === 'touchstart' || evt.type === 'pointerdown');
        var hasActivatedChild = evt !== undefined && $fde701646d4bc616$var$activatedTargets.length > 0 && $fde701646d4bc616$var$activatedTargets.some(function(target) {
            return _this.adapter.containsEventTarget(target);
        });
        if (hasActivatedChild) {
            // Immediately reset activation state, while preserving logic that prevents touch follow-on events
            this.resetActivationState();
            return;
        }
        if (evt !== undefined) {
            $fde701646d4bc616$var$activatedTargets.push(evt.target);
            this.registerDeactivationHandlers(evt);
        }
        activationState.wasElementMadeActive = this.checkElementMadeActive(evt);
        if (activationState.wasElementMadeActive) this.animateActivation();
        requestAnimationFrame(function() {
            // Reset array on next frame after the current event has had a chance to bubble to prevent ancestor ripples
            $fde701646d4bc616$var$activatedTargets = [];
            if (!activationState.wasElementMadeActive && evt !== undefined && (evt.key === ' ' || evt.keyCode === 32)) {
                // If space was pressed, try again within an rAF call to detect :active, because different UAs report
                // active states inconsistently when they're called within event handling code:
                // - https://bugs.chromium.org/p/chromium/issues/detail?id=635971
                // - https://bugzilla.mozilla.org/show_bug.cgi?id=1293741
                // We try first outside rAF to support Edge, which does not exhibit this problem, but will crash if a CSS
                // variable is set within a rAF callback for a submit button interaction (#2241).
                activationState.wasElementMadeActive = _this.checkElementMadeActive(evt);
                if (activationState.wasElementMadeActive) _this.animateActivation();
            }
            if (!activationState.wasElementMadeActive) // Reset activation state immediately if element was not made active.
            _this.activationState = _this.defaultActivationState();
        });
    };
    MDCRippleFoundation.prototype.checkElementMadeActive = function(evt) {
        return evt !== undefined && evt.type === 'keydown' ? this.adapter.isSurfaceActive() : true;
    };
    MDCRippleFoundation.prototype.animateActivation = function() {
        var _this = this;
        var _a = MDCRippleFoundation.strings, VAR_FG_TRANSLATE_START = _a.VAR_FG_TRANSLATE_START, VAR_FG_TRANSLATE_END = _a.VAR_FG_TRANSLATE_END;
        var _b = MDCRippleFoundation.cssClasses, FG_DEACTIVATION = _b.FG_DEACTIVATION, FG_ACTIVATION = _b.FG_ACTIVATION;
        var DEACTIVATION_TIMEOUT_MS = MDCRippleFoundation.numbers.DEACTIVATION_TIMEOUT_MS;
        this.layoutInternal();
        var translateStart = '';
        var translateEnd = '';
        if (!this.adapter.isUnbounded()) {
            var _c = this.getFgTranslationCoordinates(), startPoint = _c.startPoint, endPoint = _c.endPoint;
            translateStart = startPoint.x + "px, " + startPoint.y + "px";
            translateEnd = endPoint.x + "px, " + endPoint.y + "px";
        }
        this.adapter.updateCssVariable(VAR_FG_TRANSLATE_START, translateStart);
        this.adapter.updateCssVariable(VAR_FG_TRANSLATE_END, translateEnd);
        // Cancel any ongoing activation/deactivation animations
        clearTimeout(this.activationTimer);
        clearTimeout(this.fgDeactivationRemovalTimer);
        this.rmBoundedActivationClasses();
        this.adapter.removeClass(FG_DEACTIVATION);
        // Force layout in order to re-trigger the animation.
        this.adapter.computeBoundingRect();
        this.adapter.addClass(FG_ACTIVATION);
        this.activationTimer = setTimeout(function() {
            _this.activationTimerCallback();
        }, DEACTIVATION_TIMEOUT_MS);
    };
    MDCRippleFoundation.prototype.getFgTranslationCoordinates = function() {
        var _a = this.activationState, activationEvent = _a.activationEvent, wasActivatedByPointer = _a.wasActivatedByPointer;
        var startPoint;
        if (wasActivatedByPointer) startPoint = (0, $3Y5vC.getNormalizedEventCoords)(activationEvent, this.adapter.getWindowPageOffset(), this.adapter.computeBoundingRect());
        else startPoint = {
            x: this.frame.width / 2,
            y: this.frame.height / 2
        };
        // Center the element around the start point.
        startPoint = {
            x: startPoint.x - this.initialSize / 2,
            y: startPoint.y - this.initialSize / 2
        };
        var endPoint = {
            x: this.frame.width / 2 - this.initialSize / 2,
            y: this.frame.height / 2 - this.initialSize / 2
        };
        return {
            startPoint: startPoint,
            endPoint: endPoint
        };
    };
    MDCRippleFoundation.prototype.runDeactivationUXLogicIfReady = function() {
        var _this = this;
        // This method is called both when a pointing device is released, and when the activation animation ends.
        // The deactivation animation should only run after both of those occur.
        var FG_DEACTIVATION = MDCRippleFoundation.cssClasses.FG_DEACTIVATION;
        var _a = this.activationState, hasDeactivationUXRun = _a.hasDeactivationUXRun, isActivated = _a.isActivated;
        var activationHasEnded = hasDeactivationUXRun || !isActivated;
        if (activationHasEnded && this.activationAnimationHasEnded) {
            this.rmBoundedActivationClasses();
            this.adapter.addClass(FG_DEACTIVATION);
            this.fgDeactivationRemovalTimer = setTimeout(function() {
                _this.adapter.removeClass(FG_DEACTIVATION);
            }, (0, $lTuEj.numbers).FG_DEACTIVATION_MS);
        }
    };
    MDCRippleFoundation.prototype.rmBoundedActivationClasses = function() {
        var FG_ACTIVATION = MDCRippleFoundation.cssClasses.FG_ACTIVATION;
        this.adapter.removeClass(FG_ACTIVATION);
        this.activationAnimationHasEnded = false;
        this.adapter.computeBoundingRect();
    };
    MDCRippleFoundation.prototype.resetActivationState = function() {
        var _this = this;
        this.previousActivationEvent = this.activationState.activationEvent;
        this.activationState = this.defaultActivationState();
        // Touch devices may fire additional events for the same interaction within a short time.
        // Store the previous event until it's safe to assume that subsequent events are for new interactions.
        setTimeout(function() {
            return _this.previousActivationEvent = undefined;
        }, MDCRippleFoundation.numbers.TAP_DELAY_MS);
    };
    MDCRippleFoundation.prototype.deactivateImpl = function() {
        var _this = this;
        var activationState = this.activationState;
        // This can happen in scenarios such as when you have a keyup event that blurs the element.
        if (!activationState.isActivated) return;
        var state = (0, $czHfO.__assign)({}, activationState);
        if (activationState.isProgrammatic) {
            requestAnimationFrame(function() {
                _this.animateDeactivation(state);
            });
            this.resetActivationState();
        } else {
            this.deregisterDeactivationHandlers();
            requestAnimationFrame(function() {
                _this.activationState.hasDeactivationUXRun = true;
                _this.animateDeactivation(state);
                _this.resetActivationState();
            });
        }
    };
    MDCRippleFoundation.prototype.animateDeactivation = function(_a) {
        var wasActivatedByPointer = _a.wasActivatedByPointer, wasElementMadeActive = _a.wasElementMadeActive;
        if (wasActivatedByPointer || wasElementMadeActive) this.runDeactivationUXLogicIfReady();
    };
    MDCRippleFoundation.prototype.layoutInternal = function() {
        var _this = this;
        this.frame = this.adapter.computeBoundingRect();
        var maxDim = Math.max(this.frame.height, this.frame.width);
        // Surface diameter is treated differently for unbounded vs. bounded ripples.
        // Unbounded ripple diameter is calculated smaller since the surface is expected to already be padded appropriately
        // to extend the hitbox, and the ripple is expected to meet the edges of the padded hitbox (which is typically
        // square). Bounded ripples, on the other hand, are fully expected to expand beyond the surface's longest diameter
        // (calculated based on the diagonal plus a constant padding), and are clipped at the surface's border via
        // `overflow: hidden`.
        var getBoundedRadius = function() {
            var hypotenuse = Math.sqrt(Math.pow(_this.frame.width, 2) + Math.pow(_this.frame.height, 2));
            return hypotenuse + MDCRippleFoundation.numbers.PADDING;
        };
        this.maxRadius = this.adapter.isUnbounded() ? maxDim : getBoundedRadius();
        // Ripple is sized as a fraction of the largest dimension of the surface, then scales up using a CSS scale transform
        var initialSize = Math.floor(maxDim * MDCRippleFoundation.numbers.INITIAL_ORIGIN_SCALE);
        // Unbounded ripple size should always be even number to equally center align.
        if (this.adapter.isUnbounded() && initialSize % 2 !== 0) this.initialSize = initialSize - 1;
        else this.initialSize = initialSize;
        this.fgScale = "" + this.maxRadius / this.initialSize;
        this.updateLayoutCssVars();
    };
    MDCRippleFoundation.prototype.updateLayoutCssVars = function() {
        var _a = MDCRippleFoundation.strings, VAR_FG_SIZE = _a.VAR_FG_SIZE, VAR_LEFT = _a.VAR_LEFT, VAR_TOP = _a.VAR_TOP, VAR_FG_SCALE = _a.VAR_FG_SCALE;
        this.adapter.updateCssVariable(VAR_FG_SIZE, this.initialSize + "px");
        this.adapter.updateCssVariable(VAR_FG_SCALE, this.fgScale);
        if (this.adapter.isUnbounded()) {
            this.unboundedCoords = {
                left: Math.round(this.frame.width / 2 - this.initialSize / 2),
                top: Math.round(this.frame.height / 2 - this.initialSize / 2)
            };
            this.adapter.updateCssVariable(VAR_LEFT, this.unboundedCoords.left + "px");
            this.adapter.updateCssVariable(VAR_TOP, this.unboundedCoords.top + "px");
        }
    };
    return MDCRippleFoundation;
}((0, $dnVN6.MDCFoundation));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$fde701646d4bc616$export$2e2bcd8739ae039 = $fde701646d4bc616$export$fb5f028029d92ef5;

});
parcelRegister("dnVN6", function(module, exports) {

$parcel$export(module.exports, "MDCFoundation", () => $9bea406ee7e96502$export$a81b11d69c993162);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $9bea406ee7e96502$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$9bea406ee7e96502$export$2e2bcd8739ae039 = $9bea406ee7e96502$export$a81b11d69c993162;

});

parcelRegister("lTuEj", function(module, exports) {

$parcel$export(module.exports, "cssClasses", () => $ff06825280a04718$export$c1c0562ec8379000);
$parcel$export(module.exports, "strings", () => $ff06825280a04718$export$21c51bc433c16634);
$parcel$export(module.exports, "numbers", () => $ff06825280a04718$export$1f6c9cc012ebacae);
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $ff06825280a04718$export$c1c0562ec8379000 = {
    // Ripple is a special case where the "root" component is really a "mixin" of sorts,
    // given that it's an 'upgrade' to an existing component. That being said it is the root
    // CSS class that all other CSS classes derive from.
    BG_FOCUSED: 'mdc-ripple-upgraded--background-focused',
    FG_ACTIVATION: 'mdc-ripple-upgraded--foreground-activation',
    FG_DEACTIVATION: 'mdc-ripple-upgraded--foreground-deactivation',
    ROOT: 'mdc-ripple-upgraded',
    UNBOUNDED: 'mdc-ripple-upgraded--unbounded'
};
var $ff06825280a04718$export$21c51bc433c16634 = {
    VAR_FG_SCALE: '--mdc-ripple-fg-scale',
    VAR_FG_SIZE: '--mdc-ripple-fg-size',
    VAR_FG_TRANSLATE_END: '--mdc-ripple-fg-translate-end',
    VAR_FG_TRANSLATE_START: '--mdc-ripple-fg-translate-start',
    VAR_LEFT: '--mdc-ripple-left',
    VAR_TOP: '--mdc-ripple-top'
};
var $ff06825280a04718$export$1f6c9cc012ebacae = {
    DEACTIVATION_TIMEOUT_MS: 225,
    FG_DEACTIVATION_MS: 150,
    INITIAL_ORIGIN_SCALE: 0.6,
    PADDING: 10,
    TAP_DELAY_MS: 300
};

});

parcelRegister("3Y5vC", function(module, exports) {

$parcel$export(module.exports, "getNormalizedEventCoords", () => $2e3b3fa8152a8244$export$82f3563636a128ae);
/**
 * Stores result from supportsCssVariables to avoid redundant processing to
 * detect CSS custom variable support.
 */ var $2e3b3fa8152a8244$var$supportsCssVariables_;
function $2e3b3fa8152a8244$export$599ecc0c8c1caa3e(windowObj, forceRefresh) {
    if (forceRefresh === void 0) forceRefresh = false;
    var CSS = windowObj.CSS;
    var supportsCssVars = $2e3b3fa8152a8244$var$supportsCssVariables_;
    if (typeof $2e3b3fa8152a8244$var$supportsCssVariables_ === 'boolean' && !forceRefresh) return $2e3b3fa8152a8244$var$supportsCssVariables_;
    var supportsFunctionPresent = CSS && typeof CSS.supports === 'function';
    if (!supportsFunctionPresent) return false;
    var explicitlySupportsCssVars = CSS.supports('--css-vars', 'yes');
    // See: https://bugs.webkit.org/show_bug.cgi?id=154669
    // See: README section on Safari
    var weAreFeatureDetectingSafari10plus = CSS.supports('(--css-vars: yes)') && CSS.supports('color', '#00000000');
    supportsCssVars = explicitlySupportsCssVars || weAreFeatureDetectingSafari10plus;
    if (!forceRefresh) $2e3b3fa8152a8244$var$supportsCssVariables_ = supportsCssVars;
    return supportsCssVars;
}
function $2e3b3fa8152a8244$export$82f3563636a128ae(evt, pageOffset, clientRect) {
    if (!evt) return {
        x: 0,
        y: 0
    };
    var x = pageOffset.x, y = pageOffset.y;
    var documentX = x + clientRect.left;
    var documentY = y + clientRect.top;
    var normalizedX;
    var normalizedY;
    // Determine touch point relative to the ripple container.
    if (evt.type === 'touchstart') {
        var touchEvent = evt;
        normalizedX = touchEvent.changedTouches[0].pageX - documentX;
        normalizedY = touchEvent.changedTouches[0].pageY - documentY;
    } else {
        var mouseEvent = evt;
        normalizedX = mouseEvent.pageX - documentX;
        normalizedY = mouseEvent.pageY - documentY;
    }
    return {
        x: normalizedX,
        y: normalizedY
    };
}

});


parcelRegister("3DBaL", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("lBvkL")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("6uuWr")).html);
parcelRequire("7qzSW");
parcelRequire("6uuWr");
parcelRequire("5wvgX");
parcelRequire("d2S2c");

});
parcelRegister("7qzSW", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $5686cc22cf954394$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("lBvkL")).css);

var $lBvkL = parcelRequire("lBvkL");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $5686cc22cf954394$var$s;
const $5686cc22cf954394$var$e = window, $5686cc22cf954394$var$r = $5686cc22cf954394$var$e.trustedTypes, $5686cc22cf954394$var$h = $5686cc22cf954394$var$r ? $5686cc22cf954394$var$r.emptyScript : "", $5686cc22cf954394$var$o = $5686cc22cf954394$var$e.reactiveElementPolyfillSupport, $5686cc22cf954394$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $5686cc22cf954394$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $5686cc22cf954394$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $5686cc22cf954394$var$l = {
    attribute: !0,
    type: String,
    converter: $5686cc22cf954394$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $5686cc22cf954394$export$53a6892c50694894
}, $5686cc22cf954394$var$d = "finalized";
class $5686cc22cf954394$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $5686cc22cf954394$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $5686cc22cf954394$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($5686cc22cf954394$var$d)) return !1;
        this[$5686cc22cf954394$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $lBvkL.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $lBvkL.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $lBvkL.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $5686cc22cf954394$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $5686cc22cf954394$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $5686cc22cf954394$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $5686cc22cf954394$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$5686cc22cf954394$export$c7c07a37856565d[$5686cc22cf954394$var$d] = !0, $5686cc22cf954394$export$c7c07a37856565d.elementProperties = new Map, $5686cc22cf954394$export$c7c07a37856565d.elementStyles = [], $5686cc22cf954394$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $5686cc22cf954394$var$o || $5686cc22cf954394$var$o({
    ReactiveElement: $5686cc22cf954394$export$c7c07a37856565d
}), (null !== ($5686cc22cf954394$var$s = $5686cc22cf954394$var$e.reactiveElementVersions) && void 0 !== $5686cc22cf954394$var$s ? $5686cc22cf954394$var$s : $5686cc22cf954394$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("lBvkL", function(module, exports) {

$parcel$export(module.exports, "css", () => $fba55bea7e739bec$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $fba55bea7e739bec$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $fba55bea7e739bec$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fba55bea7e739bec$var$t = window, $fba55bea7e739bec$export$b4d10f6001c083c2 = $fba55bea7e739bec$var$t.ShadowRoot && (void 0 === $fba55bea7e739bec$var$t.ShadyCSS || $fba55bea7e739bec$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $fba55bea7e739bec$var$s = Symbol(), $fba55bea7e739bec$var$n = new WeakMap;
class $fba55bea7e739bec$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $fba55bea7e739bec$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($fba55bea7e739bec$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $fba55bea7e739bec$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $fba55bea7e739bec$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $fba55bea7e739bec$export$8d80f9cac07cdb3 = (t)=>new $fba55bea7e739bec$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $fba55bea7e739bec$var$s), $fba55bea7e739bec$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $fba55bea7e739bec$export$505d1e8739bad805(n, t, $fba55bea7e739bec$var$s);
}, $fba55bea7e739bec$export$2ca4a66ec4cecb90 = (s, n)=>{
    $fba55bea7e739bec$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $fba55bea7e739bec$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $fba55bea7e739bec$export$ee69dfd951e24778 = $fba55bea7e739bec$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $fba55bea7e739bec$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("6uuWr", function(module, exports) {

$parcel$export(module.exports, "html", () => $4b9d8bcb63a69d2f$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $4b9d8bcb63a69d2f$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "render", () => $4b9d8bcb63a69d2f$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $4b9d8bcb63a69d2f$var$t;
const $4b9d8bcb63a69d2f$var$i = window, $4b9d8bcb63a69d2f$var$s = $4b9d8bcb63a69d2f$var$i.trustedTypes, $4b9d8bcb63a69d2f$var$e = $4b9d8bcb63a69d2f$var$s ? $4b9d8bcb63a69d2f$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $4b9d8bcb63a69d2f$var$o = "$lit$", $4b9d8bcb63a69d2f$var$n = `lit$${(Math.random() + "").slice(9)}$`, $4b9d8bcb63a69d2f$var$l = "?" + $4b9d8bcb63a69d2f$var$n, $4b9d8bcb63a69d2f$var$h = `<${$4b9d8bcb63a69d2f$var$l}>`, $4b9d8bcb63a69d2f$var$r = document, $4b9d8bcb63a69d2f$var$u = ()=>$4b9d8bcb63a69d2f$var$r.createComment(""), $4b9d8bcb63a69d2f$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $4b9d8bcb63a69d2f$var$c = Array.isArray, $4b9d8bcb63a69d2f$var$v = (t)=>$4b9d8bcb63a69d2f$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $4b9d8bcb63a69d2f$var$a = "[ \t\n\f\r]", $4b9d8bcb63a69d2f$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $4b9d8bcb63a69d2f$var$_ = /-->/g, $4b9d8bcb63a69d2f$var$m = />/g, $4b9d8bcb63a69d2f$var$p = RegExp(`>|${$4b9d8bcb63a69d2f$var$a}(?:([^\\s"'>=/]+)(${$4b9d8bcb63a69d2f$var$a}*=${$4b9d8bcb63a69d2f$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $4b9d8bcb63a69d2f$var$g = /'/g, $4b9d8bcb63a69d2f$var$$ = /"/g, $4b9d8bcb63a69d2f$var$y = /^(?:script|style|textarea|title)$/i, $4b9d8bcb63a69d2f$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $4b9d8bcb63a69d2f$export$c0bb0b647f701bb5 = $4b9d8bcb63a69d2f$var$w(1), $4b9d8bcb63a69d2f$export$7ed1367e7fa1ad68 = $4b9d8bcb63a69d2f$var$w(2), $4b9d8bcb63a69d2f$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $4b9d8bcb63a69d2f$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $4b9d8bcb63a69d2f$var$E = new WeakMap, $4b9d8bcb63a69d2f$var$C = $4b9d8bcb63a69d2f$var$r.createTreeWalker($4b9d8bcb63a69d2f$var$r, 129, null, !1);
function $4b9d8bcb63a69d2f$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $4b9d8bcb63a69d2f$var$e ? $4b9d8bcb63a69d2f$var$e.createHTML(i) : i;
}
const $4b9d8bcb63a69d2f$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $4b9d8bcb63a69d2f$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $4b9d8bcb63a69d2f$var$f ? "!--" === c[1] ? u = $4b9d8bcb63a69d2f$var$_ : void 0 !== c[1] ? u = $4b9d8bcb63a69d2f$var$m : void 0 !== c[2] ? ($4b9d8bcb63a69d2f$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $4b9d8bcb63a69d2f$var$p) : void 0 !== c[3] && (u = $4b9d8bcb63a69d2f$var$p) : u === $4b9d8bcb63a69d2f$var$p ? ">" === c[0] ? (u = null != l ? l : $4b9d8bcb63a69d2f$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $4b9d8bcb63a69d2f$var$p : '"' === c[3] ? $4b9d8bcb63a69d2f$var$$ : $4b9d8bcb63a69d2f$var$g) : u === $4b9d8bcb63a69d2f$var$$ || u === $4b9d8bcb63a69d2f$var$g ? u = $4b9d8bcb63a69d2f$var$p : u === $4b9d8bcb63a69d2f$var$_ || u === $4b9d8bcb63a69d2f$var$m ? u = $4b9d8bcb63a69d2f$var$f : (u = $4b9d8bcb63a69d2f$var$p, l = void 0);
        const w = u === $4b9d8bcb63a69d2f$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $4b9d8bcb63a69d2f$var$f ? s + $4b9d8bcb63a69d2f$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $4b9d8bcb63a69d2f$var$o + s.slice(v) + $4b9d8bcb63a69d2f$var$n + w) : s + $4b9d8bcb63a69d2f$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $4b9d8bcb63a69d2f$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $4b9d8bcb63a69d2f$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $4b9d8bcb63a69d2f$var$V(t, i);
        if (this.el = $4b9d8bcb63a69d2f$var$N.createElement(a, e), $4b9d8bcb63a69d2f$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $4b9d8bcb63a69d2f$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($4b9d8bcb63a69d2f$var$o) || i.startsWith($4b9d8bcb63a69d2f$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $4b9d8bcb63a69d2f$var$o).split($4b9d8bcb63a69d2f$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $4b9d8bcb63a69d2f$var$H : "?" === i[1] ? $4b9d8bcb63a69d2f$var$L : "@" === i[1] ? $4b9d8bcb63a69d2f$var$z : $4b9d8bcb63a69d2f$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($4b9d8bcb63a69d2f$var$y.test(h.tagName)) {
                    const t = h.textContent.split($4b9d8bcb63a69d2f$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $4b9d8bcb63a69d2f$var$s ? $4b9d8bcb63a69d2f$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $4b9d8bcb63a69d2f$var$u()), $4b9d8bcb63a69d2f$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $4b9d8bcb63a69d2f$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $4b9d8bcb63a69d2f$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($4b9d8bcb63a69d2f$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $4b9d8bcb63a69d2f$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $4b9d8bcb63a69d2f$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $4b9d8bcb63a69d2f$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $4b9d8bcb63a69d2f$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $4b9d8bcb63a69d2f$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $4b9d8bcb63a69d2f$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $4b9d8bcb63a69d2f$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $4b9d8bcb63a69d2f$var$r).importNode(s, !0);
        $4b9d8bcb63a69d2f$var$C.currentNode = o;
        let n = $4b9d8bcb63a69d2f$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $4b9d8bcb63a69d2f$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $4b9d8bcb63a69d2f$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $4b9d8bcb63a69d2f$var$C.nextNode(), l++);
        }
        return $4b9d8bcb63a69d2f$var$C.currentNode = $4b9d8bcb63a69d2f$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $4b9d8bcb63a69d2f$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $4b9d8bcb63a69d2f$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $4b9d8bcb63a69d2f$var$S(this, t, i), $4b9d8bcb63a69d2f$var$d(t) ? t === $4b9d8bcb63a69d2f$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $4b9d8bcb63a69d2f$export$45b790e32b2810ee && this._$AR(), this._$AH = $4b9d8bcb63a69d2f$export$45b790e32b2810ee) : t !== this._$AH && t !== $4b9d8bcb63a69d2f$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $4b9d8bcb63a69d2f$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $4b9d8bcb63a69d2f$export$45b790e32b2810ee && $4b9d8bcb63a69d2f$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($4b9d8bcb63a69d2f$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $4b9d8bcb63a69d2f$var$N.createElement($4b9d8bcb63a69d2f$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $4b9d8bcb63a69d2f$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $4b9d8bcb63a69d2f$var$E.get(t.strings);
        return void 0 === i && $4b9d8bcb63a69d2f$var$E.set(t.strings, i = new $4b9d8bcb63a69d2f$var$N(t)), i;
    }
    T(t) {
        $4b9d8bcb63a69d2f$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $4b9d8bcb63a69d2f$var$R(this.k($4b9d8bcb63a69d2f$var$u()), this.k($4b9d8bcb63a69d2f$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $4b9d8bcb63a69d2f$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $4b9d8bcb63a69d2f$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $4b9d8bcb63a69d2f$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $4b9d8bcb63a69d2f$var$S(this, t, i, 0), n = !$4b9d8bcb63a69d2f$var$d(t) || t !== this._$AH && t !== $4b9d8bcb63a69d2f$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $4b9d8bcb63a69d2f$var$S(this, e[s + l], i, l), h === $4b9d8bcb63a69d2f$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$4b9d8bcb63a69d2f$var$d(h) || h !== this._$AH[l]), h === $4b9d8bcb63a69d2f$export$45b790e32b2810ee ? t = $4b9d8bcb63a69d2f$export$45b790e32b2810ee : t !== $4b9d8bcb63a69d2f$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $4b9d8bcb63a69d2f$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $4b9d8bcb63a69d2f$var$H extends $4b9d8bcb63a69d2f$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $4b9d8bcb63a69d2f$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $4b9d8bcb63a69d2f$var$I = $4b9d8bcb63a69d2f$var$s ? $4b9d8bcb63a69d2f$var$s.emptyScript : "";
class $4b9d8bcb63a69d2f$var$L extends $4b9d8bcb63a69d2f$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $4b9d8bcb63a69d2f$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $4b9d8bcb63a69d2f$var$I) : this.element.removeAttribute(this.name);
    }
}
class $4b9d8bcb63a69d2f$var$z extends $4b9d8bcb63a69d2f$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $4b9d8bcb63a69d2f$var$S(this, t, i, 0)) && void 0 !== s ? s : $4b9d8bcb63a69d2f$export$45b790e32b2810ee) === $4b9d8bcb63a69d2f$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $4b9d8bcb63a69d2f$export$45b790e32b2810ee && e !== $4b9d8bcb63a69d2f$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $4b9d8bcb63a69d2f$export$45b790e32b2810ee && (e === $4b9d8bcb63a69d2f$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $4b9d8bcb63a69d2f$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $4b9d8bcb63a69d2f$var$S(this, t);
    }
}
const $4b9d8bcb63a69d2f$export$8613d1ca9052b22e = {
    O: $4b9d8bcb63a69d2f$var$o,
    P: $4b9d8bcb63a69d2f$var$n,
    A: $4b9d8bcb63a69d2f$var$l,
    C: 1,
    M: $4b9d8bcb63a69d2f$var$V,
    L: $4b9d8bcb63a69d2f$var$M,
    R: $4b9d8bcb63a69d2f$var$v,
    D: $4b9d8bcb63a69d2f$var$S,
    I: $4b9d8bcb63a69d2f$var$R,
    V: $4b9d8bcb63a69d2f$var$k,
    H: $4b9d8bcb63a69d2f$var$L,
    N: $4b9d8bcb63a69d2f$var$z,
    U: $4b9d8bcb63a69d2f$var$H,
    F: $4b9d8bcb63a69d2f$var$Z
}, $4b9d8bcb63a69d2f$var$B = $4b9d8bcb63a69d2f$var$i.litHtmlPolyfillSupport;
null == $4b9d8bcb63a69d2f$var$B || $4b9d8bcb63a69d2f$var$B($4b9d8bcb63a69d2f$var$N, $4b9d8bcb63a69d2f$var$R), (null !== ($4b9d8bcb63a69d2f$var$t = $4b9d8bcb63a69d2f$var$i.litHtmlVersions) && void 0 !== $4b9d8bcb63a69d2f$var$t ? $4b9d8bcb63a69d2f$var$t : $4b9d8bcb63a69d2f$var$i.litHtmlVersions = []).push("2.8.0");
const $4b9d8bcb63a69d2f$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $4b9d8bcb63a69d2f$var$R(i.insertBefore($4b9d8bcb63a69d2f$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("5wvgX", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("lBvkL")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("7qzSW")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("6uuWr")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("6uuWr")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("6uuWr")).render);

var $7qzSW = parcelRequire("7qzSW");

var $6uuWr = parcelRequire("6uuWr");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $405832fa50129ef2$var$l, $405832fa50129ef2$var$o;
const $405832fa50129ef2$export$8bf27daf9e8907c9 = (0, $7qzSW.ReactiveElement);
class $405832fa50129ef2$export$3f2f9f5909897157 extends (0, $7qzSW.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $6uuWr.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $6uuWr.noChange;
    }
}
$405832fa50129ef2$export$3f2f9f5909897157.finalized = !0, $405832fa50129ef2$export$3f2f9f5909897157._$litElement$ = !0, null === ($405832fa50129ef2$var$l = globalThis.litElementHydrateSupport) || void 0 === $405832fa50129ef2$var$l || $405832fa50129ef2$var$l.call(globalThis, {
    LitElement: $405832fa50129ef2$export$3f2f9f5909897157
});
const $405832fa50129ef2$var$n = globalThis.litElementPolyfillSupport;
null == $405832fa50129ef2$var$n || $405832fa50129ef2$var$n({
    LitElement: $405832fa50129ef2$export$3f2f9f5909897157
});
const $405832fa50129ef2$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($405832fa50129ef2$var$o = globalThis.litElementVersions) && void 0 !== $405832fa50129ef2$var$o ? $405832fa50129ef2$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("d2S2c", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $97f56066e73adc96$export$6acf61af03e62db = !1;

});


parcelRegister("jNp8f", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("5Lo8m")).classMap);
parcelRequire("5Lo8m");

});
parcelRegister("5Lo8m", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $4324100687db0efc$export$56cc687933817664);

var $6uuWr = parcelRequire("6uuWr");

var $hxOYg = parcelRequire("hxOYg");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4324100687db0efc$export$56cc687933817664 = (0, $hxOYg.directive)(class extends (0, $hxOYg.Directive) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $hxOYg.PartType).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $6uuWr.noChange;
    }
});

});
parcelRegister("hxOYg", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $cc5d0e7fcad336f8$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $cc5d0e7fcad336f8$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $cc5d0e7fcad336f8$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cc5d0e7fcad336f8$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $cc5d0e7fcad336f8$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $cc5d0e7fcad336f8$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("9p3hX", function(module, exports) {
$parcel$export(module.exports, "styleMap", () => (parcelRequire("cqiF9")).styleMap);
parcelRequire("cqiF9");

});
parcelRegister("cqiF9", function(module, exports) {

$parcel$export(module.exports, "styleMap", () => $90b663c6d610d401$export$1e5b4ce2fa884e6a);

var $6uuWr = parcelRequire("6uuWr");

var $hxOYg = parcelRequire("hxOYg");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $90b663c6d610d401$var$i = "important", $90b663c6d610d401$var$n = " !" + $90b663c6d610d401$var$i, $90b663c6d610d401$export$1e5b4ce2fa884e6a = (0, $hxOYg.directive)(class extends (0, $hxOYg.Directive) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $hxOYg.PartType).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ht) {
            this.ht = new Set;
            for(const t in r)this.ht.add(t);
            return this.render(r);
        }
        this.ht.forEach((t)=>{
            null == r[t] && (this.ht.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ht.add(t);
                const r = "string" == typeof e && e.endsWith($90b663c6d610d401$var$n);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $90b663c6d610d401$var$i : "") : s[t] = e;
            }
        }
        return 0, $6uuWr.noChange;
    }
});

});



parcelRegister("d4Air", function(module, exports) {

$parcel$export(module.exports, "styles", () => $9847cdce00b3f75d$export$9dd6ff9ea0189349);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ parcelRequire("3DBaL");
var $lBvkL = parcelRequire("lBvkL");
const $9847cdce00b3f75d$export$9dd6ff9ea0189349 = (0, $lBvkL.css)`.mdc-ripple-surface{--mdc-ripple-fg-size: 0;--mdc-ripple-left: 0;--mdc-ripple-top: 0;--mdc-ripple-fg-scale: 1;--mdc-ripple-fg-translate-end: 0;--mdc-ripple-fg-translate-start: 0;-webkit-tap-highlight-color:rgba(0,0,0,0);will-change:transform,opacity;position:relative;outline:none;overflow:hidden}.mdc-ripple-surface::before,.mdc-ripple-surface::after{position:absolute;border-radius:50%;opacity:0;pointer-events:none;content:""}.mdc-ripple-surface::before{transition:opacity 15ms linear,background-color 15ms linear;z-index:1;z-index:var(--mdc-ripple-z-index, 1)}.mdc-ripple-surface::after{z-index:0;z-index:var(--mdc-ripple-z-index, 0)}.mdc-ripple-surface.mdc-ripple-upgraded::before{transform:scale(var(--mdc-ripple-fg-scale, 1))}.mdc-ripple-surface.mdc-ripple-upgraded::after{top:0;left:0;transform:scale(0);transform-origin:center center}.mdc-ripple-surface.mdc-ripple-upgraded--unbounded::after{top:var(--mdc-ripple-top, 0);left:var(--mdc-ripple-left, 0)}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-activation::after{animation:mdc-ripple-fg-radius-in 225ms forwards,mdc-ripple-fg-opacity-in 75ms forwards}.mdc-ripple-surface.mdc-ripple-upgraded--foreground-deactivation::after{animation:mdc-ripple-fg-opacity-out 150ms;transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}.mdc-ripple-surface::before,.mdc-ripple-surface::after{top:calc(50% - 100%);left:calc(50% - 100%);width:200%;height:200%}.mdc-ripple-surface.mdc-ripple-upgraded::after{width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded],.mdc-ripple-upgraded--unbounded{overflow:visible}.mdc-ripple-surface[data-mdc-ripple-is-unbounded]::before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded]::after,.mdc-ripple-upgraded--unbounded::before,.mdc-ripple-upgraded--unbounded::after{top:calc(50% - 50%);left:calc(50% - 50%);width:100%;height:100%}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded::before,.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded::after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded::before,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded::after{top:var(--mdc-ripple-top, calc(50% - 50%));left:var(--mdc-ripple-left, calc(50% - 50%));width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-ripple-surface[data-mdc-ripple-is-unbounded].mdc-ripple-upgraded::after,.mdc-ripple-upgraded--unbounded.mdc-ripple-upgraded::after{width:var(--mdc-ripple-fg-size, 100%);height:var(--mdc-ripple-fg-size, 100%)}.mdc-ripple-surface::before,.mdc-ripple-surface::after{background-color:#000;background-color:var(--mdc-ripple-color, #000)}.mdc-ripple-surface:hover::before,.mdc-ripple-surface.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-ripple-surface.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-ripple-surface:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}@keyframes mdc-ripple-fg-radius-in{from{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transform:translate(var(--mdc-ripple-fg-translate-start, 0)) scale(1)}to{transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}}@keyframes mdc-ripple-fg-opacity-in{from{animation-timing-function:linear;opacity:0}to{opacity:var(--mdc-ripple-fg-opacity, 0)}}@keyframes mdc-ripple-fg-opacity-out{from{animation-timing-function:linear;opacity:var(--mdc-ripple-fg-opacity, 0)}to{opacity:0}}:host{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;display:block}:host .mdc-ripple-surface{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;will-change:unset}.mdc-ripple-surface--primary::before,.mdc-ripple-surface--primary::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-ripple-surface--primary:hover::before,.mdc-ripple-surface--primary.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-ripple-surface--primary.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--primary:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-ripple-surface--primary:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--primary:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--primary.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--primary--activated::before{opacity:0.12;opacity:var(--mdc-ripple-activated-opacity, 0.12)}.mdc-ripple-surface--primary--activated::before,.mdc-ripple-surface--primary--activated::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-ripple-surface--primary--activated:hover::before,.mdc-ripple-surface--primary--activated.mdc-ripple-surface--hover::before{opacity:0.16;opacity:var(--mdc-ripple-hover-opacity, 0.16)}.mdc-ripple-surface--primary--activated.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--primary--activated:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-focus-opacity, 0.24)}.mdc-ripple-surface--primary--activated:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--primary--activated:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--primary--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--primary--selected::before{opacity:0.08;opacity:var(--mdc-ripple-selected-opacity, 0.08)}.mdc-ripple-surface--primary--selected::before,.mdc-ripple-surface--primary--selected::after{background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-ripple-surface--primary--selected:hover::before,.mdc-ripple-surface--primary--selected.mdc-ripple-surface--hover::before{opacity:0.12;opacity:var(--mdc-ripple-hover-opacity, 0.12)}.mdc-ripple-surface--primary--selected.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--primary--selected:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-focus-opacity, 0.2)}.mdc-ripple-surface--primary--selected:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--primary--selected:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--primary--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--accent::before,.mdc-ripple-surface--accent::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-ripple-surface--accent:hover::before,.mdc-ripple-surface--accent.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-ripple-surface--accent.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--accent:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-ripple-surface--accent:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--accent:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--accent.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-ripple-surface--accent--activated::before{opacity:0.12;opacity:var(--mdc-ripple-activated-opacity, 0.12)}.mdc-ripple-surface--accent--activated::before,.mdc-ripple-surface--accent--activated::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-ripple-surface--accent--activated:hover::before,.mdc-ripple-surface--accent--activated.mdc-ripple-surface--hover::before{opacity:0.16;opacity:var(--mdc-ripple-hover-opacity, 0.16)}.mdc-ripple-surface--accent--activated.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--accent--activated:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-focus-opacity, 0.24)}.mdc-ripple-surface--accent--activated:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--accent--activated:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--accent--activated.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-ripple-surface--accent--selected::before{opacity:0.08;opacity:var(--mdc-ripple-selected-opacity, 0.08)}.mdc-ripple-surface--accent--selected::before,.mdc-ripple-surface--accent--selected::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-ripple-surface--accent--selected:hover::before,.mdc-ripple-surface--accent--selected.mdc-ripple-surface--hover::before{opacity:0.12;opacity:var(--mdc-ripple-hover-opacity, 0.12)}.mdc-ripple-surface--accent--selected.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--accent--selected:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-focus-opacity, 0.2)}.mdc-ripple-surface--accent--selected:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--accent--selected:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.2;opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--accent--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.2)}.mdc-ripple-surface--disabled{opacity:0}.mdc-ripple-surface--internal-use-state-layer-custom-properties::before,.mdc-ripple-surface--internal-use-state-layer-custom-properties::after{background-color:#000;background-color:var(--mdc-ripple-hover-state-layer-color, #000)}.mdc-ripple-surface--internal-use-state-layer-custom-properties:hover::before,.mdc-ripple-surface--internal-use-state-layer-custom-properties.mdc-ripple-surface--hover::before{opacity:0.04;opacity:var(--mdc-ripple-hover-state-layer-opacity, 0.04)}.mdc-ripple-surface--internal-use-state-layer-custom-properties.mdc-ripple-upgraded--background-focused::before,.mdc-ripple-surface--internal-use-state-layer-custom-properties:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-state-layer-opacity, 0.12)}.mdc-ripple-surface--internal-use-state-layer-custom-properties:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-ripple-surface--internal-use-state-layer-custom-properties:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-pressed-state-layer-opacity, 0.12)}.mdc-ripple-surface--internal-use-state-layer-custom-properties.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-pressed-state-layer-opacity, 0.12)}`;

});


parcelRegister("bAdyM", function(module, exports) {

$parcel$export(module.exports, "ariaProperty", () => $86ed933d13f5f1ef$export$ae33cbacf67da030);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * TypeScript version of the decorator
 * @see https://www.typescriptlang.org/docs/handbook/decorators.html#property-decorators
 */ function $86ed933d13f5f1ef$var$tsDecorator(prototype, name, descriptor) {
    const constructor = prototype.constructor;
    if (!descriptor) {
        /**
         * lit uses internal properties with two leading underscores to
         * provide storage for accessors
         */ const litInternalPropertyKey = `__${name}`;
        descriptor = constructor.getPropertyDescriptor(name, litInternalPropertyKey);
        if (!descriptor) throw new Error('@ariaProperty must be used after a @property decorator');
    }
    // descriptor must exist at this point, reassign so typescript understands
    const propDescriptor = descriptor;
    let attribute = '';
    if (!propDescriptor.set) throw new Error(`@ariaProperty requires a setter for ${name}`);
    // TODO(b/202853219): Remove this check when internal tooling is
    // compatible
    // tslint:disable-next-line:no-any bail if applied to internal generated class
    if (prototype.dispatchWizEvent) return descriptor;
    const wrappedDescriptor = {
        configurable: true,
        enumerable: true,
        set (value) {
            if (attribute === '') {
                const options = constructor.getPropertyOptions(name);
                // if attribute is not a string, use `name` instead
                attribute = typeof options.attribute === 'string' ? options.attribute : name;
            }
            if (this.hasAttribute(attribute)) this.removeAttribute(attribute);
            propDescriptor.set.call(this, value);
        }
    };
    if (propDescriptor.get) wrappedDescriptor.get = function() {
        return propDescriptor.get.call(this);
    };
    return wrappedDescriptor;
}
function $86ed933d13f5f1ef$export$ae33cbacf67da030(protoOrDescriptor, name, // tslint:disable-next-line:no-any any is required as a return type from decorators
descriptor) {
    if (name !== undefined) return $86ed933d13f5f1ef$var$tsDecorator(protoOrDescriptor, name, descriptor);
    else throw new Error('@ariaProperty only supports TypeScript Decorators');
}

});

parcelRegister("2qnKN", function(module, exports) {

$parcel$export(module.exports, "RippleHandlers", () => $1c406f7b49a95235$export$9a192fb0d53f68ea);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Class that encapsulates the events handlers for `mwc-ripple`
 *
 *
 * Example:
 * ```
 * class XFoo extends LitElement {
 *   async getRipple() {
 *     this.renderRipple = true;
 *     await this.updateComplete;
 *     return this.renderRoot.querySelector('mwc-ripple');
 *   }
 *   rippleHandlers = new RippleHandlers(() => this.getRipple());
 *
 *   render() {
 *     return html`
 *       <div @mousedown=${this.rippleHandlers.startPress}></div>
 *       ${this.renderRipple ? html`<mwc-ripple></mwc-ripple>` : ''}
 *     `;
 *   }
 * }
 * ```
 */ class $1c406f7b49a95235$export$9a192fb0d53f68ea {
    constructor(/** Function that returns a `mwc-ripple` */ rippleFn){
        this.startPress = (ev)=>{
            rippleFn().then((r)=>{
                r && r.startPress(ev);
            });
        };
        this.endPress = ()=>{
            rippleFn().then((r)=>{
                r && r.endPress();
            });
        };
        this.startFocus = ()=>{
            rippleFn().then((r)=>{
                r && r.startFocus();
            });
        };
        this.endFocus = ()=>{
            rippleFn().then((r)=>{
                r && r.endFocus();
            });
        };
        this.startHover = ()=>{
            rippleFn().then((r)=>{
                r && r.startHover();
            });
        };
        this.endHover = ()=>{
            rippleFn().then((r)=>{
                r && r.endHover();
            });
        };
    }
}

});

parcelRegister("i6A5S", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("hL8sJ")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("lzESM")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("3J4ii")).LitElement);
parcelRequire("iEe4V");
parcelRequire("lzESM");
parcelRequire("3J4ii");
parcelRequire("kYJix");

});
parcelRegister("iEe4V", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $d936e2161e3bf1fc$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("hL8sJ")).css);

var $hL8sJ = parcelRequire("hL8sJ");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $d936e2161e3bf1fc$var$s;
const $d936e2161e3bf1fc$var$e = window, $d936e2161e3bf1fc$var$r = $d936e2161e3bf1fc$var$e.trustedTypes, $d936e2161e3bf1fc$var$h = $d936e2161e3bf1fc$var$r ? $d936e2161e3bf1fc$var$r.emptyScript : "", $d936e2161e3bf1fc$var$o = $d936e2161e3bf1fc$var$e.reactiveElementPolyfillSupport, $d936e2161e3bf1fc$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $d936e2161e3bf1fc$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $d936e2161e3bf1fc$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $d936e2161e3bf1fc$var$l = {
    attribute: !0,
    type: String,
    converter: $d936e2161e3bf1fc$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $d936e2161e3bf1fc$export$53a6892c50694894
}, $d936e2161e3bf1fc$var$d = "finalized";
class $d936e2161e3bf1fc$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $d936e2161e3bf1fc$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $d936e2161e3bf1fc$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($d936e2161e3bf1fc$var$d)) return !1;
        this[$d936e2161e3bf1fc$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $hL8sJ.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $hL8sJ.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $hL8sJ.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $d936e2161e3bf1fc$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $d936e2161e3bf1fc$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $d936e2161e3bf1fc$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $d936e2161e3bf1fc$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$d936e2161e3bf1fc$export$c7c07a37856565d[$d936e2161e3bf1fc$var$d] = !0, $d936e2161e3bf1fc$export$c7c07a37856565d.elementProperties = new Map, $d936e2161e3bf1fc$export$c7c07a37856565d.elementStyles = [], $d936e2161e3bf1fc$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $d936e2161e3bf1fc$var$o || $d936e2161e3bf1fc$var$o({
    ReactiveElement: $d936e2161e3bf1fc$export$c7c07a37856565d
}), (null !== ($d936e2161e3bf1fc$var$s = $d936e2161e3bf1fc$var$e.reactiveElementVersions) && void 0 !== $d936e2161e3bf1fc$var$s ? $d936e2161e3bf1fc$var$s : $d936e2161e3bf1fc$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("hL8sJ", function(module, exports) {

$parcel$export(module.exports, "css", () => $cedd63ecd217c1e6$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $cedd63ecd217c1e6$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $cedd63ecd217c1e6$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cedd63ecd217c1e6$var$t = window, $cedd63ecd217c1e6$export$b4d10f6001c083c2 = $cedd63ecd217c1e6$var$t.ShadowRoot && (void 0 === $cedd63ecd217c1e6$var$t.ShadyCSS || $cedd63ecd217c1e6$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $cedd63ecd217c1e6$var$s = Symbol(), $cedd63ecd217c1e6$var$n = new WeakMap;
class $cedd63ecd217c1e6$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $cedd63ecd217c1e6$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($cedd63ecd217c1e6$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $cedd63ecd217c1e6$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $cedd63ecd217c1e6$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $cedd63ecd217c1e6$export$8d80f9cac07cdb3 = (t)=>new $cedd63ecd217c1e6$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $cedd63ecd217c1e6$var$s), $cedd63ecd217c1e6$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $cedd63ecd217c1e6$export$505d1e8739bad805(n, t, $cedd63ecd217c1e6$var$s);
}, $cedd63ecd217c1e6$export$2ca4a66ec4cecb90 = (s, n)=>{
    $cedd63ecd217c1e6$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $cedd63ecd217c1e6$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $cedd63ecd217c1e6$export$ee69dfd951e24778 = $cedd63ecd217c1e6$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $cedd63ecd217c1e6$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("lzESM", function(module, exports) {

$parcel$export(module.exports, "html", () => $fb4c944165aa74ae$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $fb4c944165aa74ae$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $fb4c944165aa74ae$export$45b790e32b2810ee);
$parcel$export(module.exports, "render", () => $fb4c944165aa74ae$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $fb4c944165aa74ae$var$t;
const $fb4c944165aa74ae$var$i = window, $fb4c944165aa74ae$var$s = $fb4c944165aa74ae$var$i.trustedTypes, $fb4c944165aa74ae$var$e = $fb4c944165aa74ae$var$s ? $fb4c944165aa74ae$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $fb4c944165aa74ae$var$o = "$lit$", $fb4c944165aa74ae$var$n = `lit$${(Math.random() + "").slice(9)}$`, $fb4c944165aa74ae$var$l = "?" + $fb4c944165aa74ae$var$n, $fb4c944165aa74ae$var$h = `<${$fb4c944165aa74ae$var$l}>`, $fb4c944165aa74ae$var$r = document, $fb4c944165aa74ae$var$u = ()=>$fb4c944165aa74ae$var$r.createComment(""), $fb4c944165aa74ae$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $fb4c944165aa74ae$var$c = Array.isArray, $fb4c944165aa74ae$var$v = (t)=>$fb4c944165aa74ae$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $fb4c944165aa74ae$var$a = "[ \t\n\f\r]", $fb4c944165aa74ae$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $fb4c944165aa74ae$var$_ = /-->/g, $fb4c944165aa74ae$var$m = />/g, $fb4c944165aa74ae$var$p = RegExp(`>|${$fb4c944165aa74ae$var$a}(?:([^\\s"'>=/]+)(${$fb4c944165aa74ae$var$a}*=${$fb4c944165aa74ae$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $fb4c944165aa74ae$var$g = /'/g, $fb4c944165aa74ae$var$$ = /"/g, $fb4c944165aa74ae$var$y = /^(?:script|style|textarea|title)$/i, $fb4c944165aa74ae$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $fb4c944165aa74ae$export$c0bb0b647f701bb5 = $fb4c944165aa74ae$var$w(1), $fb4c944165aa74ae$export$7ed1367e7fa1ad68 = $fb4c944165aa74ae$var$w(2), $fb4c944165aa74ae$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $fb4c944165aa74ae$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $fb4c944165aa74ae$var$E = new WeakMap, $fb4c944165aa74ae$var$C = $fb4c944165aa74ae$var$r.createTreeWalker($fb4c944165aa74ae$var$r, 129, null, !1);
function $fb4c944165aa74ae$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $fb4c944165aa74ae$var$e ? $fb4c944165aa74ae$var$e.createHTML(i) : i;
}
const $fb4c944165aa74ae$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $fb4c944165aa74ae$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $fb4c944165aa74ae$var$f ? "!--" === c[1] ? u = $fb4c944165aa74ae$var$_ : void 0 !== c[1] ? u = $fb4c944165aa74ae$var$m : void 0 !== c[2] ? ($fb4c944165aa74ae$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $fb4c944165aa74ae$var$p) : void 0 !== c[3] && (u = $fb4c944165aa74ae$var$p) : u === $fb4c944165aa74ae$var$p ? ">" === c[0] ? (u = null != l ? l : $fb4c944165aa74ae$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $fb4c944165aa74ae$var$p : '"' === c[3] ? $fb4c944165aa74ae$var$$ : $fb4c944165aa74ae$var$g) : u === $fb4c944165aa74ae$var$$ || u === $fb4c944165aa74ae$var$g ? u = $fb4c944165aa74ae$var$p : u === $fb4c944165aa74ae$var$_ || u === $fb4c944165aa74ae$var$m ? u = $fb4c944165aa74ae$var$f : (u = $fb4c944165aa74ae$var$p, l = void 0);
        const w = u === $fb4c944165aa74ae$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $fb4c944165aa74ae$var$f ? s + $fb4c944165aa74ae$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $fb4c944165aa74ae$var$o + s.slice(v) + $fb4c944165aa74ae$var$n + w) : s + $fb4c944165aa74ae$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $fb4c944165aa74ae$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $fb4c944165aa74ae$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $fb4c944165aa74ae$var$V(t, i);
        if (this.el = $fb4c944165aa74ae$var$N.createElement(a, e), $fb4c944165aa74ae$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $fb4c944165aa74ae$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($fb4c944165aa74ae$var$o) || i.startsWith($fb4c944165aa74ae$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $fb4c944165aa74ae$var$o).split($fb4c944165aa74ae$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $fb4c944165aa74ae$var$H : "?" === i[1] ? $fb4c944165aa74ae$var$L : "@" === i[1] ? $fb4c944165aa74ae$var$z : $fb4c944165aa74ae$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($fb4c944165aa74ae$var$y.test(h.tagName)) {
                    const t = h.textContent.split($fb4c944165aa74ae$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $fb4c944165aa74ae$var$s ? $fb4c944165aa74ae$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $fb4c944165aa74ae$var$u()), $fb4c944165aa74ae$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $fb4c944165aa74ae$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $fb4c944165aa74ae$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($fb4c944165aa74ae$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $fb4c944165aa74ae$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $fb4c944165aa74ae$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $fb4c944165aa74ae$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $fb4c944165aa74ae$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $fb4c944165aa74ae$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $fb4c944165aa74ae$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $fb4c944165aa74ae$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $fb4c944165aa74ae$var$r).importNode(s, !0);
        $fb4c944165aa74ae$var$C.currentNode = o;
        let n = $fb4c944165aa74ae$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $fb4c944165aa74ae$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $fb4c944165aa74ae$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $fb4c944165aa74ae$var$C.nextNode(), l++);
        }
        return $fb4c944165aa74ae$var$C.currentNode = $fb4c944165aa74ae$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $fb4c944165aa74ae$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $fb4c944165aa74ae$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $fb4c944165aa74ae$var$S(this, t, i), $fb4c944165aa74ae$var$d(t) ? t === $fb4c944165aa74ae$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $fb4c944165aa74ae$export$45b790e32b2810ee && this._$AR(), this._$AH = $fb4c944165aa74ae$export$45b790e32b2810ee) : t !== this._$AH && t !== $fb4c944165aa74ae$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $fb4c944165aa74ae$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $fb4c944165aa74ae$export$45b790e32b2810ee && $fb4c944165aa74ae$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($fb4c944165aa74ae$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $fb4c944165aa74ae$var$N.createElement($fb4c944165aa74ae$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $fb4c944165aa74ae$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $fb4c944165aa74ae$var$E.get(t.strings);
        return void 0 === i && $fb4c944165aa74ae$var$E.set(t.strings, i = new $fb4c944165aa74ae$var$N(t)), i;
    }
    T(t) {
        $fb4c944165aa74ae$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $fb4c944165aa74ae$var$R(this.k($fb4c944165aa74ae$var$u()), this.k($fb4c944165aa74ae$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $fb4c944165aa74ae$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $fb4c944165aa74ae$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $fb4c944165aa74ae$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $fb4c944165aa74ae$var$S(this, t, i, 0), n = !$fb4c944165aa74ae$var$d(t) || t !== this._$AH && t !== $fb4c944165aa74ae$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $fb4c944165aa74ae$var$S(this, e[s + l], i, l), h === $fb4c944165aa74ae$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$fb4c944165aa74ae$var$d(h) || h !== this._$AH[l]), h === $fb4c944165aa74ae$export$45b790e32b2810ee ? t = $fb4c944165aa74ae$export$45b790e32b2810ee : t !== $fb4c944165aa74ae$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $fb4c944165aa74ae$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $fb4c944165aa74ae$var$H extends $fb4c944165aa74ae$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $fb4c944165aa74ae$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $fb4c944165aa74ae$var$I = $fb4c944165aa74ae$var$s ? $fb4c944165aa74ae$var$s.emptyScript : "";
class $fb4c944165aa74ae$var$L extends $fb4c944165aa74ae$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $fb4c944165aa74ae$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $fb4c944165aa74ae$var$I) : this.element.removeAttribute(this.name);
    }
}
class $fb4c944165aa74ae$var$z extends $fb4c944165aa74ae$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $fb4c944165aa74ae$var$S(this, t, i, 0)) && void 0 !== s ? s : $fb4c944165aa74ae$export$45b790e32b2810ee) === $fb4c944165aa74ae$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $fb4c944165aa74ae$export$45b790e32b2810ee && e !== $fb4c944165aa74ae$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $fb4c944165aa74ae$export$45b790e32b2810ee && (e === $fb4c944165aa74ae$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $fb4c944165aa74ae$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $fb4c944165aa74ae$var$S(this, t);
    }
}
const $fb4c944165aa74ae$export$8613d1ca9052b22e = {
    O: $fb4c944165aa74ae$var$o,
    P: $fb4c944165aa74ae$var$n,
    A: $fb4c944165aa74ae$var$l,
    C: 1,
    M: $fb4c944165aa74ae$var$V,
    L: $fb4c944165aa74ae$var$M,
    R: $fb4c944165aa74ae$var$v,
    D: $fb4c944165aa74ae$var$S,
    I: $fb4c944165aa74ae$var$R,
    V: $fb4c944165aa74ae$var$k,
    H: $fb4c944165aa74ae$var$L,
    N: $fb4c944165aa74ae$var$z,
    U: $fb4c944165aa74ae$var$H,
    F: $fb4c944165aa74ae$var$Z
}, $fb4c944165aa74ae$var$B = $fb4c944165aa74ae$var$i.litHtmlPolyfillSupport;
null == $fb4c944165aa74ae$var$B || $fb4c944165aa74ae$var$B($fb4c944165aa74ae$var$N, $fb4c944165aa74ae$var$R), (null !== ($fb4c944165aa74ae$var$t = $fb4c944165aa74ae$var$i.litHtmlVersions) && void 0 !== $fb4c944165aa74ae$var$t ? $fb4c944165aa74ae$var$t : $fb4c944165aa74ae$var$i.litHtmlVersions = []).push("2.8.0");
const $fb4c944165aa74ae$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $fb4c944165aa74ae$var$R(i.insertBefore($fb4c944165aa74ae$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("3J4ii", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("hL8sJ")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("iEe4V")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("lzESM")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("lzESM")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("lzESM")).render);

$parcel$export(module.exports, "LitElement", () => $2b68e7cd49cf887a$export$3f2f9f5909897157);

var $iEe4V = parcelRequire("iEe4V");

var $lzESM = parcelRequire("lzESM");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $2b68e7cd49cf887a$var$l, $2b68e7cd49cf887a$var$o;
const $2b68e7cd49cf887a$export$8bf27daf9e8907c9 = (0, $iEe4V.ReactiveElement);
class $2b68e7cd49cf887a$export$3f2f9f5909897157 extends (0, $iEe4V.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $lzESM.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $lzESM.noChange;
    }
}
$2b68e7cd49cf887a$export$3f2f9f5909897157.finalized = !0, $2b68e7cd49cf887a$export$3f2f9f5909897157._$litElement$ = !0, null === ($2b68e7cd49cf887a$var$l = globalThis.litElementHydrateSupport) || void 0 === $2b68e7cd49cf887a$var$l || $2b68e7cd49cf887a$var$l.call(globalThis, {
    LitElement: $2b68e7cd49cf887a$export$3f2f9f5909897157
});
const $2b68e7cd49cf887a$var$n = globalThis.litElementPolyfillSupport;
null == $2b68e7cd49cf887a$var$n || $2b68e7cd49cf887a$var$n({
    LitElement: $2b68e7cd49cf887a$export$3f2f9f5909897157
});
const $2b68e7cd49cf887a$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($2b68e7cd49cf887a$var$o = globalThis.litElementVersions) && void 0 !== $2b68e7cd49cf887a$var$o ? $2b68e7cd49cf887a$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("kYJix", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f45c8c7a59c0478b$export$6acf61af03e62db = !1;

});


parcelRegister("379zR", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("9BmKO")).classMap);
parcelRequire("9BmKO");

});
parcelRegister("9BmKO", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $6fd9383b88954e20$export$56cc687933817664);

var $lzESM = parcelRequire("lzESM");

var $dsRaW = parcelRequire("dsRaW");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6fd9383b88954e20$export$56cc687933817664 = (0, $dsRaW.directive)(class extends (0, $dsRaW.Directive) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $dsRaW.PartType).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $lzESM.noChange;
    }
});

});
parcelRegister("dsRaW", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $9cd7236859db58af$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $9cd7236859db58af$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $9cd7236859db58af$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9cd7236859db58af$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $9cd7236859db58af$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $9cd7236859db58af$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("kx3Sc", function(module, exports) {
$parcel$export(module.exports, "ifDefined", () => (parcelRequire("5g1ov")).ifDefined);
parcelRequire("5g1ov");

});
parcelRegister("5g1ov", function(module, exports) {

$parcel$export(module.exports, "ifDefined", () => $3d3f873d1e693c2d$export$f68dd208b5df064d);

var $lzESM = parcelRequire("lzESM");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3d3f873d1e693c2d$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $lzESM.nothing);

});



parcelRegister("9vjNJ", function(module, exports) {

$parcel$export(module.exports, "styles", () => $6eb65e66ca47479f$export$9dd6ff9ea0189349);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ parcelRequire("i6A5S");
var $hL8sJ = parcelRequire("hL8sJ");
const $6eb65e66ca47479f$export$9dd6ff9ea0189349 = (0, $hL8sJ.css)`.mdc-button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-button-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-button-font-size, 0.875rem);line-height:2.25rem;line-height:var(--mdc-typography-button-line-height, 2.25rem);font-weight:500;font-weight:var(--mdc-typography-button-font-weight, 500);letter-spacing:0.0892857143em;letter-spacing:var(--mdc-typography-button-letter-spacing, 0.0892857143em);text-decoration:none;text-decoration:var(--mdc-typography-button-text-decoration, none);text-transform:uppercase;text-transform:var(--mdc-typography-button-text-transform, uppercase)}.mdc-touch-target-wrapper{display:inline}.mdc-elevation-overlay{position:absolute;border-radius:inherit;pointer-events:none;opacity:0;opacity:var(--mdc-elevation-overlay-opacity, 0);transition:opacity 280ms cubic-bezier(0.4, 0, 0.2, 1);background-color:#fff;background-color:var(--mdc-elevation-overlay-color, #fff)}.mdc-button{position:relative;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-width:64px;border:none;outline:none;line-height:inherit;user-select:none;-webkit-appearance:none;overflow:visible;vertical-align:middle;background:transparent}.mdc-button .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}.mdc-button::-moz-focus-inner{padding:0;border:0}.mdc-button:active{outline:none}.mdc-button:hover{cursor:pointer}.mdc-button:disabled{cursor:default;pointer-events:none}.mdc-button .mdc-button__icon{margin-left:0;margin-right:8px;display:inline-block;position:relative;vertical-align:top}[dir=rtl] .mdc-button .mdc-button__icon,.mdc-button .mdc-button__icon[dir=rtl]{margin-left:8px;margin-right:0}.mdc-button .mdc-button__label{position:relative}.mdc-button .mdc-button__focus-ring{display:none}@media screen and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring{pointer-events:none;border:2px solid transparent;border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc( 100% + 4px );width:calc( 100% + 4px );display:block}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring::after,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring::after{content:"";border:2px solid transparent;border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-button.mdc-ripple-upgraded--background-focused .mdc-button__focus-ring::after,.mdc-button:not(.mdc-ripple-upgraded):focus .mdc-button__focus-ring::after{border-color:CanvasText}}.mdc-button .mdc-button__touch{position:absolute;top:50%;height:48px;left:0;right:0;transform:translateY(-50%)}.mdc-button__label+.mdc-button__icon{margin-left:8px;margin-right:0}[dir=rtl] .mdc-button__label+.mdc-button__icon,.mdc-button__label+.mdc-button__icon[dir=rtl]{margin-left:0;margin-right:8px}svg.mdc-button__icon{fill:currentColor}.mdc-button--touch{margin-top:6px;margin-bottom:6px}.mdc-button{padding:0 8px 0 8px}.mdc-button--unelevated{transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);padding:0 16px 0 16px}.mdc-button--unelevated.mdc-button--icon-trailing{padding:0 12px 0 16px}.mdc-button--unelevated.mdc-button--icon-leading{padding:0 16px 0 12px}.mdc-button--raised{transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);padding:0 16px 0 16px}.mdc-button--raised.mdc-button--icon-trailing{padding:0 12px 0 16px}.mdc-button--raised.mdc-button--icon-leading{padding:0 16px 0 12px}.mdc-button--outlined{border-style:solid;transition:border 280ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-button--outlined .mdc-button__ripple{border-style:solid;border-color:transparent}.mdc-button{height:36px;border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button:not(:disabled){color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}.mdc-button:disabled{color:rgba(0, 0, 0, 0.38)}.mdc-button .mdc-button__icon{font-size:1.125rem;width:1.125rem;height:1.125rem}.mdc-button .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--raised,.mdc-button--unelevated{height:36px;border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--raised:not(:disabled),.mdc-button--unelevated:not(:disabled){background-color:#6200ee;background-color:var(--mdc-theme-primary, #6200ee)}.mdc-button--raised:disabled,.mdc-button--unelevated:disabled{background-color:rgba(0, 0, 0, 0.12)}.mdc-button--raised:not(:disabled),.mdc-button--unelevated:not(:disabled){color:#fff;color:var(--mdc-theme-on-primary, #fff)}.mdc-button--raised:disabled,.mdc-button--unelevated:disabled{color:rgba(0, 0, 0, 0.38)}.mdc-button--raised .mdc-button__icon,.mdc-button--unelevated .mdc-button__icon{font-size:1.125rem;width:1.125rem;height:1.125rem}.mdc-button--raised .mdc-button__ripple,.mdc-button--unelevated .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--outlined{height:36px;border-radius:4px;border-radius:var(--mdc-shape-small, 4px);padding:0 15px 0 15px;border-width:1px}.mdc-button--outlined:not(:disabled){color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}.mdc-button--outlined:disabled{color:rgba(0, 0, 0, 0.38)}.mdc-button--outlined .mdc-button__icon{font-size:1.125rem;width:1.125rem;height:1.125rem}.mdc-button--outlined .mdc-button__ripple{border-radius:4px;border-radius:var(--mdc-shape-small, 4px)}.mdc-button--outlined:not(:disabled){border-color:rgba(0, 0, 0, 0.12)}.mdc-button--outlined:disabled{border-color:rgba(0, 0, 0, 0.12)}.mdc-button--outlined.mdc-button--icon-trailing{padding:0 11px 0 15px}.mdc-button--outlined.mdc-button--icon-leading{padding:0 15px 0 11px}.mdc-button--outlined .mdc-button__ripple{top:-1px;left:-1px;bottom:-1px;right:-1px;border-width:1px}.mdc-button--outlined .mdc-button__touch{left:calc(-1 * 1px);width:calc(100% + 2 * 1px)}.mdc-button--raised{box-shadow:0px 3px 1px -2px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 1px 5px 0px rgba(0,0,0,.12);transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-button--raised:hover,.mdc-button--raised:focus{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0,0,0,.12)}.mdc-button--raised:active{box-shadow:0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0,0,0,.12)}.mdc-button--raised:disabled{box-shadow:0px 0px 0px 0px rgba(0, 0, 0, 0.2),0px 0px 0px 0px rgba(0, 0, 0, 0.14),0px 0px 0px 0px rgba(0,0,0,.12)}:host{display:inline-flex;outline:none;-webkit-tap-highlight-color:transparent;vertical-align:top}:host([fullwidth]){width:100%}:host([raised]),:host([unelevated]){--mdc-ripple-color:#fff;--mdc-ripple-focus-opacity:0.24;--mdc-ripple-hover-opacity:0.08;--mdc-ripple-press-opacity:0.24}.trailing-icon ::slotted(*),.trailing-icon .mdc-button__icon,.leading-icon ::slotted(*),.leading-icon .mdc-button__icon{margin-left:0;margin-right:8px;display:inline-block;position:relative;vertical-align:top;font-size:1.125rem;height:1.125rem;width:1.125rem}[dir=rtl] .trailing-icon ::slotted(*),[dir=rtl] .trailing-icon .mdc-button__icon,[dir=rtl] .leading-icon ::slotted(*),[dir=rtl] .leading-icon .mdc-button__icon,.trailing-icon ::slotted(*[dir=rtl]),.trailing-icon .mdc-button__icon[dir=rtl],.leading-icon ::slotted(*[dir=rtl]),.leading-icon .mdc-button__icon[dir=rtl]{margin-left:8px;margin-right:0}.trailing-icon ::slotted(*),.trailing-icon .mdc-button__icon{margin-left:8px;margin-right:0}[dir=rtl] .trailing-icon ::slotted(*),[dir=rtl] .trailing-icon .mdc-button__icon,.trailing-icon ::slotted(*[dir=rtl]),.trailing-icon .mdc-button__icon[dir=rtl]{margin-left:0;margin-right:8px}.slot-container{display:inline-flex;align-items:center;justify-content:center}.slot-container.flex{flex:auto}.mdc-button{flex:auto;overflow:hidden;padding-left:8px;padding-left:var(--mdc-button-horizontal-padding, 8px);padding-right:8px;padding-right:var(--mdc-button-horizontal-padding, 8px)}.mdc-button--raised{box-shadow:0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow, 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12))}.mdc-button--raised:focus{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-focus, var(--mdc-button-raised-box-shadow-hover, 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)))}.mdc-button--raised:hover{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-hover, 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12))}.mdc-button--raised:active{box-shadow:0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-active, 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12))}.mdc-button--raised:disabled{box-shadow:0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);box-shadow:var(--mdc-button-raised-box-shadow-disabled, 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12))}.mdc-button--raised,.mdc-button--unelevated{padding-left:16px;padding-left:var(--mdc-button-horizontal-padding, 16px);padding-right:16px;padding-right:var(--mdc-button-horizontal-padding, 16px)}.mdc-button--outlined{border-width:1px;border-width:var(--mdc-button-outline-width, 1px);padding-left:calc(16px - 1px);padding-left:calc(var(--mdc-button-horizontal-padding, 16px) - var(--mdc-button-outline-width, 1px));padding-right:calc(16px - 1px);padding-right:calc(var(--mdc-button-horizontal-padding, 16px) - var(--mdc-button-outline-width, 1px))}.mdc-button--outlined:not(:disabled){border-color:rgba(0, 0, 0, 0.12);border-color:var(--mdc-button-outline-color, rgba(0, 0, 0, 0.12))}.mdc-button--outlined .ripple{top:calc(-1 * 1px);top:calc(-1 * var(--mdc-button-outline-width, 1px));left:calc(-1 * 1px);left:calc(-1 * var(--mdc-button-outline-width, 1px));right:initial;right:initial;border-width:1px;border-width:var(--mdc-button-outline-width, 1px);border-style:solid;border-color:transparent}[dir=rtl] .mdc-button--outlined .ripple,.mdc-button--outlined .ripple[dir=rtl]{left:initial;left:initial;right:calc(-1 * 1px);right:calc(-1 * var(--mdc-button-outline-width, 1px))}.mdc-button--dense{height:28px;margin-top:0;margin-bottom:0}.mdc-button--dense .mdc-button__touch{height:100%}:host([disabled]){pointer-events:none}:host([disabled]) .mdc-button{color:rgba(0, 0, 0, 0.38);color:var(--mdc-button-disabled-ink-color, rgba(0, 0, 0, 0.38))}:host([disabled]) .mdc-button--raised,:host([disabled]) .mdc-button--unelevated{background-color:rgba(0, 0, 0, 0.12);background-color:var(--mdc-button-disabled-fill-color, rgba(0, 0, 0, 0.12))}:host([disabled]) .mdc-button--outlined{border-color:rgba(0, 0, 0, 0.12);border-color:var(--mdc-button-disabled-outline-color, rgba(0, 0, 0, 0.12))}`;

});


parcelRegister("31pE8", function(module, exports) {

$parcel$export(module.exports, "LinearProgress", () => $23355bf13207afb9$export$11f983dff6f48944);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("7UWw0");
var $hf5U4 = parcelRequire("hf5U4");

var $99vuI = parcelRequire("99vuI");

var $wsv5c = parcelRequire("wsv5c");
/** @soyCompatible */ let $23355bf13207afb9$export$11f983dff6f48944 = class LinearProgress extends (0, $99vuI.LinearProgressBase) {
};
$23355bf13207afb9$export$11f983dff6f48944.styles = [
    (0, $wsv5c.styles)
];
$23355bf13207afb9$export$11f983dff6f48944 = (0, $czHfO.__decorate)([
    (0, $hf5U4.customElement)('mwc-linear-progress')
], $23355bf13207afb9$export$11f983dff6f48944);

});
parcelRegister("7UWw0", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("hf5U4")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("9iB4A")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("kR2tn")).state);
$parcel$export(module.exports, "query", () => (parcelRequire("6l212")).query);
parcelRequire("hf5U4");
parcelRequire("9iB4A");
parcelRequire("kR2tn");
parcelRequire("4zu8C");
parcelRequire("6l212");
parcelRequire("hP1Ao");
parcelRequire("bIWRb");
parcelRequire("cZlwE");
parcelRequire("biNHT");

});
parcelRegister("hf5U4", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $c8d86aa79b6a97ad$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c8d86aa79b6a97ad$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);

});

parcelRegister("9iB4A", function(module, exports) {

$parcel$export(module.exports, "property", () => $01bf44585de579c2$export$d541bacb2bda4494);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $01bf44585de579c2$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $01bf44585de579c2$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $01bf44585de579c2$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $01bf44585de579c2$var$e(n, t, o) : $01bf44585de579c2$var$i(n, t);
}

});

parcelRegister("kR2tn", function(module, exports) {

$parcel$export(module.exports, "state", () => $f2eaace8e7d3fb23$export$ca000e230c0caa3e);

var $9iB4A = parcelRequire("9iB4A");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f2eaace8e7d3fb23$export$ca000e230c0caa3e(t) {
    return (0, $9iB4A.property)({
        ...t,
        state: !0
    });
}

});

parcelRegister("4zu8C", function(module, exports) {

var $bUeZ8 = parcelRequire("bUeZ8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3541cf1a1a4e5163$export$b2b799818fbabcf3(e) {
    return (0, $bUeZ8.decorateProperty)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}

});
parcelRegister("bUeZ8", function(module, exports) {

$parcel$export(module.exports, "decorateProperty", () => $8ab08c67bd8f81ae$export$757d561a932dc1cb);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8ab08c67bd8f81ae$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $8ab08c67bd8f81ae$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $8ab08c67bd8f81ae$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };

});


parcelRegister("6l212", function(module, exports) {

$parcel$export(module.exports, "query", () => $49d6448194d412f5$export$2fa187e846a241c4);

var $bUeZ8 = parcelRequire("bUeZ8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $49d6448194d412f5$export$2fa187e846a241c4(i, n) {
    return (0, $bUeZ8.decorateProperty)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}

});

parcelRegister("hP1Ao", function(module, exports) {

var $bUeZ8 = parcelRequire("bUeZ8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $cf986e0aa2aae451$export$dcd0d083aa86c355(e) {
    return (0, $bUeZ8.decorateProperty)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("bIWRb", function(module, exports) {

var $bUeZ8 = parcelRequire("bUeZ8");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $889175873c84e575$export$163dfc35cc43f240(e) {
    return (0, $bUeZ8.decorateProperty)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("cZlwE", function(module, exports) {

$parcel$export(module.exports, "queryAssignedElements", () => $974be1112563a14d$export$4682af2d9ee91415);

var $bUeZ8 = parcelRequire("bUeZ8");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $974be1112563a14d$var$n;
const $974be1112563a14d$var$e = null != (null === ($974be1112563a14d$var$n = window.HTMLSlotElement) || void 0 === $974be1112563a14d$var$n ? void 0 : $974be1112563a14d$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $974be1112563a14d$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $bUeZ8.decorateProperty)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $974be1112563a14d$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});

parcelRegister("biNHT", function(module, exports) {

var $bUeZ8 = parcelRequire("bUeZ8");

var $cZlwE = parcelRequire("cZlwE");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $83a7eee9312b0357$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $cZlwE.queryAssignedElements)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $bUeZ8.decorateProperty)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}

});


parcelRegister("99vuI", function(module, exports) {

$parcel$export(module.exports, "LinearProgressBase", () => $6a9d627519e38bad$export$ea3f39fd9cd4234f);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");

var $bAdyM = parcelRequire("bAdyM");
parcelRequire("iLLEM");
var $3jtoy = parcelRequire("3jtoy");
var $ciomC = parcelRequire("ciomC");
parcelRequire("7UWw0");
var $9iB4A = parcelRequire("9iB4A");
var $6l212 = parcelRequire("6l212");
var $kR2tn = parcelRequire("kR2tn");
parcelRequire("gD45I");
var $1GHc7 = parcelRequire("1GHc7");
parcelRequire("2yjmG");
var $evlEm = parcelRequire("evlEm");
parcelRequire("ewfCG");
var $7082i = parcelRequire("7082i");
class $6a9d627519e38bad$export$ea3f39fd9cd4234f extends (0, $ciomC.LitElement) {
    constructor(){
        super(...arguments);
        this.indeterminate = false;
        this.progress = 0;
        this.buffer = 1;
        this.reverse = false;
        this.closed = false;
        this.stylePrimaryHalf = '';
        this.stylePrimaryFull = '';
        this.styleSecondaryQuarter = '';
        this.styleSecondaryHalf = '';
        this.styleSecondaryFull = '';
        this.animationReady = true;
        this.closedAnimationOff = false;
        this.resizeObserver = null;
    }
    connectedCallback() {
        super.connectedCallback();
        // if detached and reattached
        if (this.rootEl) this.attachResizeObserver();
    }
    /**
     * @soyTemplate
     */ render() {
        /** @classMap */ const classes = {
            'mdc-linear-progress--closed': this.closed,
            'mdc-linear-progress--closed-animation-off': this.closedAnimationOff,
            'mdc-linear-progress--indeterminate': this.indeterminate,
            // needed for controller-less render
            'mdc-linear-progress--animation-ready': this.animationReady
        };
        /** @styleMap */ const rootStyles = {
            '--mdc-linear-progress-primary-half': this.stylePrimaryHalf,
            '--mdc-linear-progress-primary-half-neg': this.stylePrimaryHalf !== '' ? `-${this.stylePrimaryHalf}` : '',
            '--mdc-linear-progress-primary-full': this.stylePrimaryFull,
            '--mdc-linear-progress-primary-full-neg': this.stylePrimaryFull !== '' ? `-${this.stylePrimaryFull}` : '',
            '--mdc-linear-progress-secondary-quarter': this.styleSecondaryQuarter,
            '--mdc-linear-progress-secondary-quarter-neg': this.styleSecondaryQuarter !== '' ? `-${this.styleSecondaryQuarter}` : '',
            '--mdc-linear-progress-secondary-half': this.styleSecondaryHalf,
            '--mdc-linear-progress-secondary-half-neg': this.styleSecondaryHalf !== '' ? `-${this.styleSecondaryHalf}` : '',
            '--mdc-linear-progress-secondary-full': this.styleSecondaryFull,
            '--mdc-linear-progress-secondary-full-neg': this.styleSecondaryFull !== '' ? `-${this.styleSecondaryFull}` : ''
        };
        /** @styleMap */ const bufferBarStyles = {
            'flex-basis': this.indeterminate ? '100%' : `${this.buffer * 100}%`
        };
        /** @styleMap */ const primaryBarStyles = {
            transform: this.indeterminate ? 'scaleX(1)' : `scaleX(${this.progress})`
        };
        return (0, $3jtoy.html)`
      <div
          role="progressbar"
          class="mdc-linear-progress ${(0, $1GHc7.classMap)(classes)}"
          style="${(0, $7082i.styleMap)(rootStyles)}"
          dir="${(0, $evlEm.ifDefined)(this.reverse ? 'rtl' : undefined)}"
          aria-label="${(0, $evlEm.ifDefined)(this.ariaLabel)}"
          aria-valuemin="0"
          aria-valuemax="1"
          aria-valuenow="${(0, $evlEm.ifDefined)(this.indeterminate ? undefined : this.progress)}"
        @transitionend="${this.syncClosedState}">
        <div class="mdc-linear-progress__buffer">
          <div
            class="mdc-linear-progress__buffer-bar"
            style=${(0, $7082i.styleMap)(bufferBarStyles)}>
          </div>
          <div class="mdc-linear-progress__buffer-dots"></div>
        </div>
        <div
            class="mdc-linear-progress__bar mdc-linear-progress__primary-bar"
            style=${(0, $7082i.styleMap)(primaryBarStyles)}>
          <span class="mdc-linear-progress__bar-inner"></span>
        </div>
        <div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
          <span class="mdc-linear-progress__bar-inner"></span>
        </div>
      </div>`;
    }
    update(changedProperties) {
        // - When showing the indicator, enable animations immediately.
        // - On first render, disable the animation immediately.
        // - For normal calls to hide the component, let transitionend event trigger
        //   disabling of animations instead (see render method), so that animation
        //   does not jump in the middle of fade out.
        if (changedProperties.has('closed') && (!this.closed || changedProperties.get('closed') === undefined)) this.syncClosedState();
        super.update(changedProperties);
    }
    async firstUpdated(changed) {
        super.firstUpdated(changed);
        this.attachResizeObserver();
    }
    syncClosedState() {
        this.closedAnimationOff = this.closed;
    }
    updated(changed) {
        // restart animation for timing if reverse changed and is indeterminate.
        // don't restart here if indeterminate has changed as well because we don't
        // want to incur an extra style recalculation
        if (!changed.has('indeterminate') && changed.has('reverse') && this.indeterminate) this.restartAnimation();
        // Recaclulate the animation css custom props and restart the calculation
        // if this is not the first render cycle, otherwise, resize observer init
        // will already handle this and prevent unnecessary rerender + style recalc
        // but resize observer will not update animation vals while determinate
        if (changed.has('indeterminate') && changed.get('indeterminate') !== undefined && this.indeterminate && window.ResizeObserver) this.calculateAndSetAnimationDimensions(this.rootEl.offsetWidth);
        super.updated(changed);
    }
    disconnectedCallback() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        super.disconnectedCallback();
    }
    attachResizeObserver() {
        if (window.ResizeObserver) {
            this.resizeObserver = new window.ResizeObserver((entries)=>{
                if (!this.indeterminate) return;
                for (const entry of entries)if (entry.contentRect) {
                    const width = entry.contentRect.width;
                    this.calculateAndSetAnimationDimensions(width);
                }
            });
            this.resizeObserver.observe(this.rootEl);
            return;
        }
        this.resizeObserver = null;
    }
    calculateAndSetAnimationDimensions(width) {
        const primaryHalf = width * 0.8367142;
        const primaryFull = width * 2.00611057;
        const secondaryQuarter = width * 0.37651913;
        const secondaryHalf = width * 0.84386165;
        const secondaryFull = width * 1.60277782;
        this.stylePrimaryHalf = `${primaryHalf}px`;
        this.stylePrimaryFull = `${primaryFull}px`;
        this.styleSecondaryQuarter = `${secondaryQuarter}px`;
        this.styleSecondaryHalf = `${secondaryHalf}px`;
        this.styleSecondaryFull = `${secondaryFull}px`;
        // need to restart animation for custom props to apply to keyframes
        this.restartAnimation();
    }
    async restartAnimation() {
        this.animationReady = false;
        await this.updateComplete;
        await new Promise(requestAnimationFrame);
        this.animationReady = true;
        await this.updateComplete;
    }
    open() {
        this.closed = false;
    }
    close() {
        this.closed = true;
    }
}
(0, $czHfO.__decorate)([
    (0, $6l212.query)('.mdc-linear-progress')
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "rootEl", void 0);
(0, $czHfO.__decorate)([
    (0, $9iB4A.property)({
        type: Boolean,
        reflect: true
    })
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "indeterminate", void 0);
(0, $czHfO.__decorate)([
    (0, $9iB4A.property)({
        type: Number
    })
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "progress", void 0);
(0, $czHfO.__decorate)([
    (0, $9iB4A.property)({
        type: Number
    })
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "buffer", void 0);
(0, $czHfO.__decorate)([
    (0, $9iB4A.property)({
        type: Boolean,
        reflect: true
    })
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "reverse", void 0);
(0, $czHfO.__decorate)([
    (0, $9iB4A.property)({
        type: Boolean,
        reflect: true
    })
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "closed", void 0);
(0, $czHfO.__decorate)([
    (0, $bAdyM.ariaProperty),
    (0, $9iB4A.property)({
        attribute: 'aria-label'
    })
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "ariaLabel", void 0);
(0, $czHfO.__decorate)([
    (0, $kR2tn.state)()
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "stylePrimaryHalf", void 0);
(0, $czHfO.__decorate)([
    (0, $kR2tn.state)()
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "stylePrimaryFull", void 0);
(0, $czHfO.__decorate)([
    (0, $kR2tn.state)()
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "styleSecondaryQuarter", void 0);
(0, $czHfO.__decorate)([
    (0, $kR2tn.state)()
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "styleSecondaryHalf", void 0);
(0, $czHfO.__decorate)([
    (0, $kR2tn.state)()
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "styleSecondaryFull", void 0);
(0, $czHfO.__decorate)([
    (0, $kR2tn.state)()
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "animationReady", void 0);
(0, $czHfO.__decorate)([
    (0, $kR2tn.state)()
], $6a9d627519e38bad$export$ea3f39fd9cd4234f.prototype, "closedAnimationOff", void 0);

});
parcelRegister("iLLEM", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("6hcq5")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("3jtoy")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("ciomC")).LitElement);
parcelRequire("7xXnC");
parcelRequire("3jtoy");
parcelRequire("ciomC");
parcelRequire("6sHxX");

});
parcelRegister("7xXnC", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $57e9ad17dcb97e82$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("6hcq5")).css);

var $6hcq5 = parcelRequire("6hcq5");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $57e9ad17dcb97e82$var$s;
const $57e9ad17dcb97e82$var$e = window, $57e9ad17dcb97e82$var$r = $57e9ad17dcb97e82$var$e.trustedTypes, $57e9ad17dcb97e82$var$h = $57e9ad17dcb97e82$var$r ? $57e9ad17dcb97e82$var$r.emptyScript : "", $57e9ad17dcb97e82$var$o = $57e9ad17dcb97e82$var$e.reactiveElementPolyfillSupport, $57e9ad17dcb97e82$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $57e9ad17dcb97e82$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $57e9ad17dcb97e82$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $57e9ad17dcb97e82$var$l = {
    attribute: !0,
    type: String,
    converter: $57e9ad17dcb97e82$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $57e9ad17dcb97e82$export$53a6892c50694894
}, $57e9ad17dcb97e82$var$d = "finalized";
class $57e9ad17dcb97e82$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $57e9ad17dcb97e82$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $57e9ad17dcb97e82$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($57e9ad17dcb97e82$var$d)) return !1;
        this[$57e9ad17dcb97e82$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $6hcq5.getCompatibleStyle)(i));
        } else void 0 !== i && s.push((0, $6hcq5.getCompatibleStyle)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $6hcq5.adoptStyles)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $57e9ad17dcb97e82$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $57e9ad17dcb97e82$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $57e9ad17dcb97e82$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $57e9ad17dcb97e82$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$57e9ad17dcb97e82$export$c7c07a37856565d[$57e9ad17dcb97e82$var$d] = !0, $57e9ad17dcb97e82$export$c7c07a37856565d.elementProperties = new Map, $57e9ad17dcb97e82$export$c7c07a37856565d.elementStyles = [], $57e9ad17dcb97e82$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $57e9ad17dcb97e82$var$o || $57e9ad17dcb97e82$var$o({
    ReactiveElement: $57e9ad17dcb97e82$export$c7c07a37856565d
}), (null !== ($57e9ad17dcb97e82$var$s = $57e9ad17dcb97e82$var$e.reactiveElementVersions) && void 0 !== $57e9ad17dcb97e82$var$s ? $57e9ad17dcb97e82$var$s : $57e9ad17dcb97e82$var$e.reactiveElementVersions = []).push("1.6.3");

});
parcelRegister("6hcq5", function(module, exports) {

$parcel$export(module.exports, "css", () => $491df6ebff240585$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $491df6ebff240585$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $491df6ebff240585$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $491df6ebff240585$var$t = window, $491df6ebff240585$export$b4d10f6001c083c2 = $491df6ebff240585$var$t.ShadowRoot && (void 0 === $491df6ebff240585$var$t.ShadyCSS || $491df6ebff240585$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $491df6ebff240585$var$s = Symbol(), $491df6ebff240585$var$n = new WeakMap;
class $491df6ebff240585$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $491df6ebff240585$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($491df6ebff240585$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $491df6ebff240585$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $491df6ebff240585$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $491df6ebff240585$export$8d80f9cac07cdb3 = (t)=>new $491df6ebff240585$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $491df6ebff240585$var$s), $491df6ebff240585$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $491df6ebff240585$export$505d1e8739bad805(n, t, $491df6ebff240585$var$s);
}, $491df6ebff240585$export$2ca4a66ec4cecb90 = (s, n)=>{
    $491df6ebff240585$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $491df6ebff240585$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $491df6ebff240585$export$ee69dfd951e24778 = $491df6ebff240585$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $491df6ebff240585$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("3jtoy", function(module, exports) {

$parcel$export(module.exports, "html", () => $2699f2af210a1866$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $2699f2af210a1866$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $2699f2af210a1866$export$45b790e32b2810ee);
$parcel$export(module.exports, "render", () => $2699f2af210a1866$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $2699f2af210a1866$var$t;
const $2699f2af210a1866$var$i = window, $2699f2af210a1866$var$s = $2699f2af210a1866$var$i.trustedTypes, $2699f2af210a1866$var$e = $2699f2af210a1866$var$s ? $2699f2af210a1866$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $2699f2af210a1866$var$o = "$lit$", $2699f2af210a1866$var$n = `lit$${(Math.random() + "").slice(9)}$`, $2699f2af210a1866$var$l = "?" + $2699f2af210a1866$var$n, $2699f2af210a1866$var$h = `<${$2699f2af210a1866$var$l}>`, $2699f2af210a1866$var$r = document, $2699f2af210a1866$var$u = ()=>$2699f2af210a1866$var$r.createComment(""), $2699f2af210a1866$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $2699f2af210a1866$var$c = Array.isArray, $2699f2af210a1866$var$v = (t)=>$2699f2af210a1866$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $2699f2af210a1866$var$a = "[ \t\n\f\r]", $2699f2af210a1866$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $2699f2af210a1866$var$_ = /-->/g, $2699f2af210a1866$var$m = />/g, $2699f2af210a1866$var$p = RegExp(`>|${$2699f2af210a1866$var$a}(?:([^\\s"'>=/]+)(${$2699f2af210a1866$var$a}*=${$2699f2af210a1866$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $2699f2af210a1866$var$g = /'/g, $2699f2af210a1866$var$$ = /"/g, $2699f2af210a1866$var$y = /^(?:script|style|textarea|title)$/i, $2699f2af210a1866$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $2699f2af210a1866$export$c0bb0b647f701bb5 = $2699f2af210a1866$var$w(1), $2699f2af210a1866$export$7ed1367e7fa1ad68 = $2699f2af210a1866$var$w(2), $2699f2af210a1866$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $2699f2af210a1866$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $2699f2af210a1866$var$E = new WeakMap, $2699f2af210a1866$var$C = $2699f2af210a1866$var$r.createTreeWalker($2699f2af210a1866$var$r, 129, null, !1);
function $2699f2af210a1866$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $2699f2af210a1866$var$e ? $2699f2af210a1866$var$e.createHTML(i) : i;
}
const $2699f2af210a1866$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $2699f2af210a1866$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $2699f2af210a1866$var$f ? "!--" === c[1] ? u = $2699f2af210a1866$var$_ : void 0 !== c[1] ? u = $2699f2af210a1866$var$m : void 0 !== c[2] ? ($2699f2af210a1866$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $2699f2af210a1866$var$p) : void 0 !== c[3] && (u = $2699f2af210a1866$var$p) : u === $2699f2af210a1866$var$p ? ">" === c[0] ? (u = null != l ? l : $2699f2af210a1866$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $2699f2af210a1866$var$p : '"' === c[3] ? $2699f2af210a1866$var$$ : $2699f2af210a1866$var$g) : u === $2699f2af210a1866$var$$ || u === $2699f2af210a1866$var$g ? u = $2699f2af210a1866$var$p : u === $2699f2af210a1866$var$_ || u === $2699f2af210a1866$var$m ? u = $2699f2af210a1866$var$f : (u = $2699f2af210a1866$var$p, l = void 0);
        const w = u === $2699f2af210a1866$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $2699f2af210a1866$var$f ? s + $2699f2af210a1866$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $2699f2af210a1866$var$o + s.slice(v) + $2699f2af210a1866$var$n + w) : s + $2699f2af210a1866$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $2699f2af210a1866$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $2699f2af210a1866$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $2699f2af210a1866$var$V(t, i);
        if (this.el = $2699f2af210a1866$var$N.createElement(a, e), $2699f2af210a1866$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $2699f2af210a1866$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($2699f2af210a1866$var$o) || i.startsWith($2699f2af210a1866$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $2699f2af210a1866$var$o).split($2699f2af210a1866$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $2699f2af210a1866$var$H : "?" === i[1] ? $2699f2af210a1866$var$L : "@" === i[1] ? $2699f2af210a1866$var$z : $2699f2af210a1866$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($2699f2af210a1866$var$y.test(h.tagName)) {
                    const t = h.textContent.split($2699f2af210a1866$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $2699f2af210a1866$var$s ? $2699f2af210a1866$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $2699f2af210a1866$var$u()), $2699f2af210a1866$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $2699f2af210a1866$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $2699f2af210a1866$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($2699f2af210a1866$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $2699f2af210a1866$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $2699f2af210a1866$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $2699f2af210a1866$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $2699f2af210a1866$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $2699f2af210a1866$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $2699f2af210a1866$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $2699f2af210a1866$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $2699f2af210a1866$var$r).importNode(s, !0);
        $2699f2af210a1866$var$C.currentNode = o;
        let n = $2699f2af210a1866$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $2699f2af210a1866$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $2699f2af210a1866$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $2699f2af210a1866$var$C.nextNode(), l++);
        }
        return $2699f2af210a1866$var$C.currentNode = $2699f2af210a1866$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $2699f2af210a1866$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $2699f2af210a1866$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $2699f2af210a1866$var$S(this, t, i), $2699f2af210a1866$var$d(t) ? t === $2699f2af210a1866$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $2699f2af210a1866$export$45b790e32b2810ee && this._$AR(), this._$AH = $2699f2af210a1866$export$45b790e32b2810ee) : t !== this._$AH && t !== $2699f2af210a1866$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $2699f2af210a1866$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $2699f2af210a1866$export$45b790e32b2810ee && $2699f2af210a1866$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($2699f2af210a1866$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $2699f2af210a1866$var$N.createElement($2699f2af210a1866$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $2699f2af210a1866$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $2699f2af210a1866$var$E.get(t.strings);
        return void 0 === i && $2699f2af210a1866$var$E.set(t.strings, i = new $2699f2af210a1866$var$N(t)), i;
    }
    T(t) {
        $2699f2af210a1866$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $2699f2af210a1866$var$R(this.k($2699f2af210a1866$var$u()), this.k($2699f2af210a1866$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $2699f2af210a1866$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $2699f2af210a1866$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $2699f2af210a1866$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $2699f2af210a1866$var$S(this, t, i, 0), n = !$2699f2af210a1866$var$d(t) || t !== this._$AH && t !== $2699f2af210a1866$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $2699f2af210a1866$var$S(this, e[s + l], i, l), h === $2699f2af210a1866$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$2699f2af210a1866$var$d(h) || h !== this._$AH[l]), h === $2699f2af210a1866$export$45b790e32b2810ee ? t = $2699f2af210a1866$export$45b790e32b2810ee : t !== $2699f2af210a1866$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $2699f2af210a1866$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $2699f2af210a1866$var$H extends $2699f2af210a1866$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $2699f2af210a1866$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $2699f2af210a1866$var$I = $2699f2af210a1866$var$s ? $2699f2af210a1866$var$s.emptyScript : "";
class $2699f2af210a1866$var$L extends $2699f2af210a1866$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $2699f2af210a1866$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $2699f2af210a1866$var$I) : this.element.removeAttribute(this.name);
    }
}
class $2699f2af210a1866$var$z extends $2699f2af210a1866$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $2699f2af210a1866$var$S(this, t, i, 0)) && void 0 !== s ? s : $2699f2af210a1866$export$45b790e32b2810ee) === $2699f2af210a1866$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $2699f2af210a1866$export$45b790e32b2810ee && e !== $2699f2af210a1866$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $2699f2af210a1866$export$45b790e32b2810ee && (e === $2699f2af210a1866$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $2699f2af210a1866$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $2699f2af210a1866$var$S(this, t);
    }
}
const $2699f2af210a1866$export$8613d1ca9052b22e = {
    O: $2699f2af210a1866$var$o,
    P: $2699f2af210a1866$var$n,
    A: $2699f2af210a1866$var$l,
    C: 1,
    M: $2699f2af210a1866$var$V,
    L: $2699f2af210a1866$var$M,
    R: $2699f2af210a1866$var$v,
    D: $2699f2af210a1866$var$S,
    I: $2699f2af210a1866$var$R,
    V: $2699f2af210a1866$var$k,
    H: $2699f2af210a1866$var$L,
    N: $2699f2af210a1866$var$z,
    U: $2699f2af210a1866$var$H,
    F: $2699f2af210a1866$var$Z
}, $2699f2af210a1866$var$B = $2699f2af210a1866$var$i.litHtmlPolyfillSupport;
null == $2699f2af210a1866$var$B || $2699f2af210a1866$var$B($2699f2af210a1866$var$N, $2699f2af210a1866$var$R), (null !== ($2699f2af210a1866$var$t = $2699f2af210a1866$var$i.litHtmlVersions) && void 0 !== $2699f2af210a1866$var$t ? $2699f2af210a1866$var$t : $2699f2af210a1866$var$i.litHtmlVersions = []).push("2.8.0");
const $2699f2af210a1866$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $2699f2af210a1866$var$R(i.insertBefore($2699f2af210a1866$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("ciomC", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("6hcq5")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("7xXnC")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("3jtoy")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("3jtoy")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("3jtoy")).render);

$parcel$export(module.exports, "LitElement", () => $8f3a109f0f3eb76e$export$3f2f9f5909897157);

var $7xXnC = parcelRequire("7xXnC");

var $3jtoy = parcelRequire("3jtoy");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $8f3a109f0f3eb76e$var$l, $8f3a109f0f3eb76e$var$o;
const $8f3a109f0f3eb76e$export$8bf27daf9e8907c9 = (0, $7xXnC.ReactiveElement);
class $8f3a109f0f3eb76e$export$3f2f9f5909897157 extends (0, $7xXnC.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $3jtoy.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $3jtoy.noChange;
    }
}
$8f3a109f0f3eb76e$export$3f2f9f5909897157.finalized = !0, $8f3a109f0f3eb76e$export$3f2f9f5909897157._$litElement$ = !0, null === ($8f3a109f0f3eb76e$var$l = globalThis.litElementHydrateSupport) || void 0 === $8f3a109f0f3eb76e$var$l || $8f3a109f0f3eb76e$var$l.call(globalThis, {
    LitElement: $8f3a109f0f3eb76e$export$3f2f9f5909897157
});
const $8f3a109f0f3eb76e$var$n = globalThis.litElementPolyfillSupport;
null == $8f3a109f0f3eb76e$var$n || $8f3a109f0f3eb76e$var$n({
    LitElement: $8f3a109f0f3eb76e$export$3f2f9f5909897157
});
const $8f3a109f0f3eb76e$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($8f3a109f0f3eb76e$var$o = globalThis.litElementVersions) && void 0 !== $8f3a109f0f3eb76e$var$o ? $8f3a109f0f3eb76e$var$o : globalThis.litElementVersions = []).push("3.3.3");

});

parcelRegister("6sHxX", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4b47230cd2a57fb5$export$6acf61af03e62db = !1;

});


parcelRegister("gD45I", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("1GHc7")).classMap);
parcelRequire("1GHc7");

});
parcelRegister("1GHc7", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $13ab3838f070a4de$export$56cc687933817664);

var $3jtoy = parcelRequire("3jtoy");

var $4QLTm = parcelRequire("4QLTm");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $13ab3838f070a4de$export$56cc687933817664 = (0, $4QLTm.directive)(class extends (0, $4QLTm.Directive) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $4QLTm.PartType).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $3jtoy.noChange;
    }
});

});
parcelRegister("4QLTm", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $38812b10f5dfa9f3$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $38812b10f5dfa9f3$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $38812b10f5dfa9f3$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $38812b10f5dfa9f3$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $38812b10f5dfa9f3$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $38812b10f5dfa9f3$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("2yjmG", function(module, exports) {
$parcel$export(module.exports, "ifDefined", () => (parcelRequire("evlEm")).ifDefined);
parcelRequire("evlEm");

});
parcelRegister("evlEm", function(module, exports) {

$parcel$export(module.exports, "ifDefined", () => $a8f4c131c4665ed2$export$f68dd208b5df064d);

var $3jtoy = parcelRequire("3jtoy");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a8f4c131c4665ed2$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $3jtoy.nothing);

});


parcelRegister("ewfCG", function(module, exports) {
$parcel$export(module.exports, "styleMap", () => (parcelRequire("7082i")).styleMap);
parcelRequire("7082i");

});
parcelRegister("7082i", function(module, exports) {

$parcel$export(module.exports, "styleMap", () => $518ec44c34060cff$export$1e5b4ce2fa884e6a);

var $3jtoy = parcelRequire("3jtoy");

var $4QLTm = parcelRequire("4QLTm");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $518ec44c34060cff$var$i = "important", $518ec44c34060cff$var$n = " !" + $518ec44c34060cff$var$i, $518ec44c34060cff$export$1e5b4ce2fa884e6a = (0, $4QLTm.directive)(class extends (0, $4QLTm.Directive) {
    constructor(t){
        var e;
        if (super(t), t.type !== (0, $4QLTm.PartType).ATTRIBUTE || "style" !== t.name || (null === (e = t.strings) || void 0 === e ? void 0 : e.length) > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return Object.keys(t).reduce((e, r)=>{
            const s = t[r];
            return null == s ? e : e + `${r = r.includes("-") ? r : r.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s};`;
        }, "");
    }
    update(e, [r]) {
        const { style: s } = e.element;
        if (void 0 === this.ht) {
            this.ht = new Set;
            for(const t in r)this.ht.add(t);
            return this.render(r);
        }
        this.ht.forEach((t)=>{
            null == r[t] && (this.ht.delete(t), t.includes("-") ? s.removeProperty(t) : s[t] = "");
        });
        for(const t in r){
            const e = r[t];
            if (null != e) {
                this.ht.add(t);
                const r = "string" == typeof e && e.endsWith($518ec44c34060cff$var$n);
                t.includes("-") || r ? s.setProperty(t, r ? e.slice(0, -11) : e, r ? $518ec44c34060cff$var$i : "") : s[t] = e;
            }
        }
        return 0, $3jtoy.noChange;
    }
});

});



parcelRegister("wsv5c", function(module, exports) {

$parcel$export(module.exports, "styles", () => $061918d8b9af2dd0$export$9dd6ff9ea0189349);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ parcelRequire("iLLEM");
var $6hcq5 = parcelRequire("6hcq5");
const $061918d8b9af2dd0$export$9dd6ff9ea0189349 = (0, $6hcq5.css)`@keyframes mdc-linear-progress-primary-indeterminate-translate{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(83.67142%);transform:translateX(var(--mdc-linear-progress-primary-half, 83.67142%))}100%{transform:translateX(200.611057%);transform:translateX(var(--mdc-linear-progress-primary-full, 200.611057%))}}@keyframes mdc-linear-progress-primary-indeterminate-scale{0%{transform:scaleX(0.08)}36.65%{animation-timing-function:cubic-bezier(0.334731, 0.12482, 0.785844, 1);transform:scaleX(0.08)}69.15%{animation-timing-function:cubic-bezier(0.06, 0.11, 0.6, 1);transform:scaleX(0.661479)}100%{transform:scaleX(0.08)}}@keyframes mdc-linear-progress-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(0.15, 0, 0.515058, 0.409685);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(0.31033, 0.284058, 0.8, 0.733712);transform:translateX(37.651913%);transform:translateX(var(--mdc-linear-progress-secondary-quarter, 37.651913%))}48.35%{animation-timing-function:cubic-bezier(0.4, 0.627035, 0.6, 0.902026);transform:translateX(84.386165%);transform:translateX(var(--mdc-linear-progress-secondary-half, 84.386165%))}100%{transform:translateX(160.277782%);transform:translateX(var(--mdc-linear-progress-secondary-full, 160.277782%))}}@keyframes mdc-linear-progress-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(0.205028, 0.057051, 0.57661, 0.453971);transform:scaleX(0.08)}19.15%{animation-timing-function:cubic-bezier(0.152313, 0.196432, 0.648374, 1.004315);transform:scaleX(0.457104)}44.15%{animation-timing-function:cubic-bezier(0.257759, -0.003163, 0.211762, 1.38179);transform:scaleX(0.72796)}100%{transform:scaleX(0.08)}}@keyframes mdc-linear-progress-buffering{from{transform:rotate(180deg) translateX(-10px)}}@keyframes mdc-linear-progress-primary-indeterminate-translate-reverse{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(0.5, 0, 0.701732, 0.495819);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);transform:translateX(-83.67142%);transform:translateX(var(--mdc-linear-progress-primary-half-neg, -83.67142%))}100%{transform:translateX(-200.611057%);transform:translateX(var(--mdc-linear-progress-primary-full-neg, -200.611057%))}}@keyframes mdc-linear-progress-secondary-indeterminate-translate-reverse{0%{animation-timing-function:cubic-bezier(0.15, 0, 0.515058, 0.409685);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(0.31033, 0.284058, 0.8, 0.733712);transform:translateX(-37.651913%);transform:translateX(var(--mdc-linear-progress-secondary-quarter-neg, -37.651913%))}48.35%{animation-timing-function:cubic-bezier(0.4, 0.627035, 0.6, 0.902026);transform:translateX(-84.386165%);transform:translateX(var(--mdc-linear-progress-secondary-half-neg, -84.386165%))}100%{transform:translateX(-160.277782%);transform:translateX(var(--mdc-linear-progress-secondary-full-neg, -160.277782%))}}@keyframes mdc-linear-progress-buffering-reverse{from{transform:translateX(-10px)}}.mdc-linear-progress{position:relative;width:100%;transform:translateZ(0);outline:1px solid transparent;overflow:hidden;transition:opacity 250ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}@media screen and (forced-colors: active){.mdc-linear-progress{outline-color:CanvasText}}.mdc-linear-progress__bar{position:absolute;width:100%;height:100%;animation:none;transform-origin:top left;transition:transform 250ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-linear-progress__bar-inner{display:inline-block;position:absolute;width:100%;animation:none;border-top-style:solid}.mdc-linear-progress__buffer{display:flex;position:absolute;width:100%;height:100%}.mdc-linear-progress__buffer-dots{background-repeat:repeat-x;flex:auto;transform:rotate(180deg);animation:mdc-linear-progress-buffering 250ms infinite linear}.mdc-linear-progress__buffer-bar{flex:0 1 100%;transition:flex-basis 250ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-linear-progress__primary-bar{transform:scaleX(0)}.mdc-linear-progress__secondary-bar{display:none}.mdc-linear-progress--indeterminate .mdc-linear-progress__bar{transition:none}.mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{left:-145.166611%}.mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{left:-54.888891%;display:block}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation:mdc-linear-progress-primary-indeterminate-translate 2s infinite linear}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar>.mdc-linear-progress__bar-inner{animation:mdc-linear-progress-primary-indeterminate-scale 2s infinite linear}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation:mdc-linear-progress-secondary-indeterminate-translate 2s infinite linear}.mdc-linear-progress--indeterminate.mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar>.mdc-linear-progress__bar-inner{animation:mdc-linear-progress-secondary-indeterminate-scale 2s infinite linear}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__bar{right:0;-webkit-transform-origin:center right;transform-origin:center right}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__primary-bar{animation-name:mdc-linear-progress-primary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--animation-ready .mdc-linear-progress__secondary-bar{animation-name:mdc-linear-progress-secondary-indeterminate-translate-reverse}[dir=rtl] .mdc-linear-progress:not([dir=ltr]) .mdc-linear-progress__buffer-dots,.mdc-linear-progress[dir=rtl]:not([dir=ltr]) .mdc-linear-progress__buffer-dots{animation:mdc-linear-progress-buffering-reverse 250ms infinite linear;transform:rotate(0)}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__primary-bar{right:-145.166611%;left:auto}[dir=rtl] .mdc-linear-progress:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar,.mdc-linear-progress[dir=rtl]:not([dir=ltr]).mdc-linear-progress--indeterminate .mdc-linear-progress__secondary-bar{right:-54.888891%;left:auto}.mdc-linear-progress--closed{opacity:0}.mdc-linear-progress--closed-animation-off .mdc-linear-progress__buffer-dots{animation:none}.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar,.mdc-linear-progress--closed-animation-off.mdc-linear-progress--indeterminate .mdc-linear-progress__bar .mdc-linear-progress__bar-inner{animation:none}.mdc-linear-progress__bar-inner{border-color:#6200ee;border-color:var(--mdc-theme-primary, #6200ee)}.mdc-linear-progress__buffer-dots{background-image:url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E")}.mdc-linear-progress__buffer-bar{background-color:#e6e6e6}.mdc-linear-progress{height:4px}.mdc-linear-progress__bar-inner{border-top-width:4px}.mdc-linear-progress__buffer-dots{background-size:10px 4px}:host{display:block}.mdc-linear-progress__buffer-bar{background-color:#e6e6e6;background-color:var(--mdc-linear-progress-buffer-color, #e6e6e6)}.mdc-linear-progress__buffer-dots{background-image:url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E");background-image:var(--mdc-linear-progress-buffering-dots-image, url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23e6e6e6'/%3E%3C/svg%3E"))}`;

});


parcelRegister("eUQW6", function(module, exports) {

$parcel$export(module.exports, "getQueueDisplayName", () => $9b1b90046743dc6f$export$9e40e2d6c84415ac);
$parcel$export(module.exports, "showClearingButtonForQueue", () => $9b1b90046743dc6f$export$da8505e9a2eb7e5);
// name-mapping.ts

var $a30lF = parcelRequire("a30lF");
function $9b1b90046743dc6f$export$9e40e2d6c84415ac(queueName) {
    (0, $a30lF.log).debug('DEBUG getQueueDisplayName - input:', queueName);
    // First check if it's already a direct mapping
    if ($9b1b90046743dc6f$var$QUEUE_BASE_NAME_MAPPING[queueName]) {
        (0, $a30lF.log).debug('DEBUG getQueueDisplayName - direct match found:', $9b1b90046743dc6f$var$QUEUE_BASE_NAME_MAPPING[queueName]);
        return $9b1b90046743dc6f$var$QUEUE_BASE_NAME_MAPPING[queueName];
    }
    // Extract the base queue name from the full queue name
    // Flexible pattern to handle different client prefixes and environment formats
    // Patterns supported:
    // - <client>-<environment>-<number>-<queue_base_name>
    // - <client>-<environment>-<queue_base_name>
    // - <environment>-<queue_base_name> (legacy)
    let match;
    let baseQueueName;
    // Try pattern: client-env-number-queue_name (e.g., devk-dev-1-hitl-classification-rb)
    match = queueName.match(/^[^-]+-[^-]+-\d+-(.+)$/);
    if (match) {
        baseQueueName = match[1];
        (0, $a30lF.log).debug('DEBUG getQueueDisplayName - pattern 1 match:', baseQueueName);
    } else {
        // Try pattern: client-env-queue_name (e.g., devk-dev-hitl-classification-rb)
        match = queueName.match(/^[^-]+-[^-]+-(.+)$/);
        if (match) {
            baseQueueName = match[1];
            (0, $a30lF.log).debug('DEBUG getQueueDisplayName - pattern 2 match:', baseQueueName);
        } else {
            // Try pattern: env-queue_name (legacy format)
            match = queueName.match(/^[^-]+-(.+)$/);
            if (match) {
                baseQueueName = match[1];
                (0, $a30lF.log).debug('DEBUG getQueueDisplayName - pattern 3 match:', baseQueueName);
            } else {
                // No pattern matched, check if it's already a base queue name
                baseQueueName = queueName;
                (0, $a30lF.log).debug('DEBUG getQueueDisplayName - no pattern match, using original:', baseQueueName);
            }
        }
    }
    // Always apply friendly names if available, regardless of environment
    const friendlyName = $9b1b90046743dc6f$var$QUEUE_BASE_NAME_MAPPING[baseQueueName];
    (0, $a30lF.log).debug('DEBUG getQueueDisplayName - baseQueueName:', baseQueueName, 'friendlyName:', friendlyName);
    if (friendlyName) return friendlyName;
    // For unmapped queues, return the original name
    (0, $a30lF.log).debug('DEBUG getQueueDisplayName - no mapping found, returning original:', queueName);
    return queueName;
}
// Base queue name mappings (without environment prefixes)
const $9b1b90046743dc6f$var$QUEUE_BASE_NAME_MAPPING = {
    // Full queue names (with hitl- prefix)
    "hitl-classification-business-area": "Intelligente Weiche",
    "hitl-classification-rb": "Dokumentenklassifikation RS-Betrieb",
    "hitl-data-extraction-rb": "Datenextraktion RS-Betrieb",
    "hitl-data-extraction-rb-kuendigung": "Datenextraktion RB K\xfcndigung",
    // RS queues (from locals.tf)
    "hitl-classification-rs": "Dokumentenklassifikation RS-Schaden (Neu- vs. Folgeschaden)",
    "hitl-splitting-rs-existing-case": "Dokumententrennung RS-Schaden (Folgeschaden)",
    "hitl-data-extraction-rs-existing-case": "Datenextraktion RS-Schaden (Folgeschaden)",
    "hitl-classification-rs-new-case": "Dokumentenklassifikation RS-Schaden (Neuschaden)",
    "hitl-data-extraction-rs-new-case-master": "Datenextraktion RS-Schaden (Neuschaden)",
    // SHUK queues
    "hitl-data-extraction-shuk-towing-invoice": "Datenextraktion SHUK Abschlepprechnung",
    // Leben-Betrieb (LB) queues
    "hitl-classification-lb": "Dokumentenklassifikation Leben-Betrieb",
    "hitl-data-extraction-lb": "Datenextraktion Leben-Betrieb",
    // Leben-Leistung (LL) queues
    "hitl-classification-ll": "Dokumentenklassifikation Leben-Leistung",
    "hitl-data-extraction-ll": "Datenextraktion Leben-Leistung",
    // PubSub queue identifiers (without hitl- prefix)
    "classification_business_area": "Intelligente Weiche",
    "classification_rb": "Dokumentenklassifikation RS-Betrieb",
    "data_extraction_rb": "Datenextraktion RS-Betrieb",
    "data_extraction_rb_kuendigung": "Datenextraktion RB K\xfcndigung"
};
const $9b1b90046743dc6f$export$3982a425b7a5866a = {};
function $9b1b90046743dc6f$export$da8505e9a2eb7e5(queueName) {
    return ![
        "hitl-classification-business-area",
        "classification_business_area"
    ].includes(queueName);
}

});
parcelRegister("a30lF", function(module, exports) {

$parcel$export(module.exports, "configurePubsubLogger", () => $84b95680f8aab3bb$export$75643afc2c316bb9);
$parcel$export(module.exports, "setPubsubAccessToken", () => $84b95680f8aab3bb$export$9252e2f76c7e435);
$parcel$export(module.exports, "logAction", () => $84b95680f8aab3bb$export$64fa290de62d7ebc);
$parcel$export(module.exports, "sendCriticalLog", () => $84b95680f8aab3bb$export$2cf61d988fb43479);
$parcel$export(module.exports, "log", () => $84b95680f8aab3bb$export$bef1f36f5486a6a3);
/**
 * Logger module for asynchronous logging to Pub/Sub via its REST API.
 */ // Global variables for configuration
let $84b95680f8aab3bb$var$pubsubAccessToken = null;
let $84b95680f8aab3bb$var$pubsubPublishUrl = null;
function $84b95680f8aab3bb$export$75643afc2c316bb9(environment, accessToken) {
    // Environment should match infrastructure naming: {workload}-{workspace}-hitl-logger
    const topicName = `${environment}-hitl-logger`;
    $84b95680f8aab3bb$var$pubsubPublishUrl = `https://pubsub.googleapis.com/v1/projects/${"DEFAULT_PROJECT_ID"}/topics/${topicName}:publish`;
    $84b95680f8aab3bb$var$pubsubAccessToken = accessToken;
    console.log(`HITL Logger configured for environment: ${environment}`);
    console.log(`HITL Logger topic name: ${topicName}`);
    console.log(`HITL Logger URL: ${$84b95680f8aab3bb$var$pubsubPublishUrl}`);
    console.log(`HITL Logger client prefix: ${"DEFAULT_CLIENT_PREFIX"}`);
}
function $84b95680f8aab3bb$export$9252e2f76c7e435(token) {
    $84b95680f8aab3bb$var$pubsubAccessToken = token;
    // Fallback to legacy topic name if no URL is configured yet
    if (!$84b95680f8aab3bb$var$pubsubPublishUrl) {
        $84b95680f8aab3bb$var$pubsubPublishUrl = `https://pubsub.googleapis.com/v1/projects/${"DEFAULT_PROJECT_ID"}/topics/hitl_logger:publish`;
        console.warn('Using legacy hitl_logger topic name. Consider using configurePubsubLogger() for environment-aware logging.');
    }
}
let $84b95680f8aab3bb$var$logBuffer = [];
const $84b95680f8aab3bb$var$BUFFER_TIMEOUT_MS = 5000;
let $84b95680f8aab3bb$var$bufferFlushTimer = null;
/**
 * Flushes the buffered logs to Pub/Sub using the REST API.
 */ function $84b95680f8aab3bb$var$flushLogBuffer() {
    if (!$84b95680f8aab3bb$var$pubsubAccessToken || !$84b95680f8aab3bb$var$pubsubPublishUrl) {
        console.error("Pub/Sub access token or URL not set; cannot flush logs.");
        return;
    }
    if ($84b95680f8aab3bb$var$logBuffer.length > 0) {
        const logsToSend = [
            ...$84b95680f8aab3bb$var$logBuffer
        ];
        $84b95680f8aab3bb$var$logBuffer = [];
        // Construct messages array as required by Pub/Sub.
        const messages = logsToSend.map((entry)=>({
                data: btoa(JSON.stringify(entry))
            }));
        fetch($84b95680f8aab3bb$var$pubsubPublishUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${$84b95680f8aab3bb$var$pubsubAccessToken}`
            },
            body: JSON.stringify({
                messages: messages
            }),
            keepalive: true
        }).catch((error)=>{
            console.error(`Failed to publish logs: ${error}`);
        // Optionally, re-buffer logsToSend if needed.
        });
    }
    if ($84b95680f8aab3bb$var$bufferFlushTimer) {
        clearTimeout($84b95680f8aab3bb$var$bufferFlushTimer);
        $84b95680f8aab3bb$var$bufferFlushTimer = null;
    }
}
function $84b95680f8aab3bb$export$64fa290de62d7ebc(logEntry) {
    $84b95680f8aab3bb$var$logBuffer.push(logEntry);
    if (!$84b95680f8aab3bb$var$bufferFlushTimer) $84b95680f8aab3bb$var$bufferFlushTimer = window.setTimeout(()=>{
        $84b95680f8aab3bb$var$flushLogBuffer();
    }, $84b95680f8aab3bb$var$BUFFER_TIMEOUT_MS);
}
async function $84b95680f8aab3bb$export$2cf61d988fb43479(logEntry) {
    if (!$84b95680f8aab3bb$var$pubsubAccessToken || !$84b95680f8aab3bb$var$pubsubPublishUrl) {
        console.error("Pub/Sub access token or URL not set; cannot send critical log.");
        return;
    }
    try {
        const message = {
            data: btoa(JSON.stringify(logEntry))
        };
        await fetch($84b95680f8aab3bb$var$pubsubPublishUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${$84b95680f8aab3bb$var$pubsubAccessToken}`
            },
            body: JSON.stringify({
                messages: [
                    message
                ]
            }),
            keepalive: true
        });
    } catch (error) {
        console.error(`Failed to send critical log: ${error}`);
    }
}
const $84b95680f8aab3bb$export$bef1f36f5486a6a3 = {
    /**
   * Debug level - only shown in dev/sit/ci environments
   */ debug: (...args)=>{
        const env = "DEFAULT_ENVIRONMENT"?.toLowerCase() || '';
        if (env.includes('dev') || env.includes('sit') || env.includes('ci')) console.debug(...args);
    },
    /**
   * Info level - shown in all environments
   */ info: (...args)=>{
        console.info(...args);
    },
    /**
   * Warning level - shown in all environments
   */ warn: (...args)=>{
        console.warn(...args);
    },
    /**
   * Error level - shown in all environments
   */ error: (...args)=>{
        console.error(...args);
    }
};

});


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * Suppresses console.log and console.debug in production/staging environments.
 * Must be imported as early as possible (side-effect import).
 *
 * Environments where logs ARE shown: dev-*, sit, ci, local (empty string)
 * Environments where logs are SUPPRESSED: stg, prd, poc
 */ const $81e79df93e027de2$var$env = "DEFAULT_ENVIRONMENT".toLowerCase();
const $81e79df93e027de2$var$isDevEnvironment = $81e79df93e027de2$var$env === "" || $81e79df93e027de2$var$env.includes("dev") || $81e79df93e027de2$var$env.includes("sit") || $81e79df93e027de2$var$env.includes("ci") || $81e79df93e027de2$var$env.includes("poc");
if (!$81e79df93e027de2$var$isDevEnvironment) {
    const noop = ()=>{};
    console.log = noop;
    console.debug = noop;
}


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f57b1293e9d8fdf8$var$t = globalThis, $f57b1293e9d8fdf8$export$b4d10f6001c083c2 = $f57b1293e9d8fdf8$var$t.ShadowRoot && (void 0 === $f57b1293e9d8fdf8$var$t.ShadyCSS || $f57b1293e9d8fdf8$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $f57b1293e9d8fdf8$var$s = Symbol(), $f57b1293e9d8fdf8$var$o = new WeakMap;
class $f57b1293e9d8fdf8$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $f57b1293e9d8fdf8$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($f57b1293e9d8fdf8$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $f57b1293e9d8fdf8$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $f57b1293e9d8fdf8$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $f57b1293e9d8fdf8$export$8d80f9cac07cdb3 = (t)=>new $f57b1293e9d8fdf8$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $f57b1293e9d8fdf8$var$s), $f57b1293e9d8fdf8$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $f57b1293e9d8fdf8$export$505d1e8739bad805(o, t, $f57b1293e9d8fdf8$var$s);
}, $f57b1293e9d8fdf8$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($f57b1293e9d8fdf8$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $f57b1293e9d8fdf8$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $f57b1293e9d8fdf8$export$ee69dfd951e24778 = $f57b1293e9d8fdf8$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $f57b1293e9d8fdf8$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $9081a043ddd975e7$var$i, defineProperty: $9081a043ddd975e7$var$e, getOwnPropertyDescriptor: $9081a043ddd975e7$var$h, getOwnPropertyNames: $9081a043ddd975e7$var$r, getOwnPropertySymbols: $9081a043ddd975e7$var$o, getPrototypeOf: $9081a043ddd975e7$var$n } = Object, $9081a043ddd975e7$var$a = globalThis, $9081a043ddd975e7$var$c = $9081a043ddd975e7$var$a.trustedTypes, $9081a043ddd975e7$var$l = $9081a043ddd975e7$var$c ? $9081a043ddd975e7$var$c.emptyScript : "", $9081a043ddd975e7$var$p = $9081a043ddd975e7$var$a.reactiveElementPolyfillSupport, $9081a043ddd975e7$var$d = (t, s)=>t, $9081a043ddd975e7$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $9081a043ddd975e7$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $9081a043ddd975e7$export$53a6892c50694894 = (t, s)=>!$9081a043ddd975e7$var$i(t, s), $9081a043ddd975e7$var$b = {
    attribute: !0,
    type: String,
    converter: $9081a043ddd975e7$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $9081a043ddd975e7$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $9081a043ddd975e7$var$a.litPropertyMetadata ??= new WeakMap;
class $9081a043ddd975e7$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $9081a043ddd975e7$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $9081a043ddd975e7$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $9081a043ddd975e7$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $9081a043ddd975e7$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($9081a043ddd975e7$var$d("elementProperties"))) return;
        const t = $9081a043ddd975e7$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($9081a043ddd975e7$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($9081a043ddd975e7$var$d("properties"))) {
            const t = this.properties, s = [
                ...$9081a043ddd975e7$var$r(t),
                ...$9081a043ddd975e7$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $f57b1293e9d8fdf8$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $f57b1293e9d8fdf8$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $f57b1293e9d8fdf8$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $9081a043ddd975e7$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $9081a043ddd975e7$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            const e = this.constructor, h = this[t];
            if (i ??= e.getPropertyOptions(t), !((i.hasChanged ?? $9081a043ddd975e7$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(e._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$9081a043ddd975e7$export$c7c07a37856565d.elementStyles = [], $9081a043ddd975e7$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $9081a043ddd975e7$export$c7c07a37856565d[$9081a043ddd975e7$var$d("elementProperties")] = new Map, $9081a043ddd975e7$export$c7c07a37856565d[$9081a043ddd975e7$var$d("finalized")] = new Map, $9081a043ddd975e7$var$p?.({
    ReactiveElement: $9081a043ddd975e7$export$c7c07a37856565d
}), ($9081a043ddd975e7$var$a.reactiveElementVersions ??= []).push("2.1.1");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e4c6f5c4fa111bdf$var$t = globalThis, $e4c6f5c4fa111bdf$var$i = $e4c6f5c4fa111bdf$var$t.trustedTypes, $e4c6f5c4fa111bdf$var$s = $e4c6f5c4fa111bdf$var$i ? $e4c6f5c4fa111bdf$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e4c6f5c4fa111bdf$var$e = "$lit$", $e4c6f5c4fa111bdf$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e4c6f5c4fa111bdf$var$o = "?" + $e4c6f5c4fa111bdf$var$h, $e4c6f5c4fa111bdf$var$n = `<${$e4c6f5c4fa111bdf$var$o}>`, $e4c6f5c4fa111bdf$var$r = document, $e4c6f5c4fa111bdf$var$l = ()=>$e4c6f5c4fa111bdf$var$r.createComment(""), $e4c6f5c4fa111bdf$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e4c6f5c4fa111bdf$var$a = Array.isArray, $e4c6f5c4fa111bdf$var$u = (t)=>$e4c6f5c4fa111bdf$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e4c6f5c4fa111bdf$var$d = "[ \t\n\f\r]", $e4c6f5c4fa111bdf$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e4c6f5c4fa111bdf$var$v = /-->/g, $e4c6f5c4fa111bdf$var$_ = />/g, $e4c6f5c4fa111bdf$var$m = RegExp(`>|${$e4c6f5c4fa111bdf$var$d}(?:([^\\s"'>=/]+)(${$e4c6f5c4fa111bdf$var$d}*=${$e4c6f5c4fa111bdf$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e4c6f5c4fa111bdf$var$p = /'/g, $e4c6f5c4fa111bdf$var$g = /"/g, $e4c6f5c4fa111bdf$var$$ = /^(?:script|style|textarea|title)$/i, $e4c6f5c4fa111bdf$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5 = $e4c6f5c4fa111bdf$var$y(1), $e4c6f5c4fa111bdf$export$7ed1367e7fa1ad68 = $e4c6f5c4fa111bdf$var$y(2), $e4c6f5c4fa111bdf$export$47d5b44d225be5b4 = $e4c6f5c4fa111bdf$var$y(3), $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e4c6f5c4fa111bdf$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e4c6f5c4fa111bdf$var$A = new WeakMap, $e4c6f5c4fa111bdf$var$C = $e4c6f5c4fa111bdf$var$r.createTreeWalker($e4c6f5c4fa111bdf$var$r, 129);
function $e4c6f5c4fa111bdf$var$P(t, i) {
    if (!$e4c6f5c4fa111bdf$var$a(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e4c6f5c4fa111bdf$var$s ? $e4c6f5c4fa111bdf$var$s.createHTML(i) : i;
}
const $e4c6f5c4fa111bdf$var$V = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e4c6f5c4fa111bdf$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e4c6f5c4fa111bdf$var$f ? "!--" === u[1] ? c = $e4c6f5c4fa111bdf$var$v : void 0 !== u[1] ? c = $e4c6f5c4fa111bdf$var$_ : void 0 !== u[2] ? ($e4c6f5c4fa111bdf$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e4c6f5c4fa111bdf$var$m) : void 0 !== u[3] && (c = $e4c6f5c4fa111bdf$var$m) : c === $e4c6f5c4fa111bdf$var$m ? ">" === u[0] ? (c = r ?? $e4c6f5c4fa111bdf$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e4c6f5c4fa111bdf$var$m : '"' === u[3] ? $e4c6f5c4fa111bdf$var$g : $e4c6f5c4fa111bdf$var$p) : c === $e4c6f5c4fa111bdf$var$g || c === $e4c6f5c4fa111bdf$var$p ? c = $e4c6f5c4fa111bdf$var$m : c === $e4c6f5c4fa111bdf$var$v || c === $e4c6f5c4fa111bdf$var$_ ? c = $e4c6f5c4fa111bdf$var$f : (c = $e4c6f5c4fa111bdf$var$m, r = void 0);
        const x = c === $e4c6f5c4fa111bdf$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e4c6f5c4fa111bdf$var$f ? s + $e4c6f5c4fa111bdf$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e4c6f5c4fa111bdf$var$e + s.slice(d) + $e4c6f5c4fa111bdf$var$h + x) : s + $e4c6f5c4fa111bdf$var$h + (-2 === d ? i : x);
    }
    return [
        $e4c6f5c4fa111bdf$var$P(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        o
    ];
};
class $e4c6f5c4fa111bdf$var$N {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e4c6f5c4fa111bdf$var$V(t, s);
        if (this.el = $e4c6f5c4fa111bdf$var$N.createElement(f, n), $e4c6f5c4fa111bdf$var$C.currentNode = this.el.content, 2 === s || 3 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e4c6f5c4fa111bdf$var$C.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e4c6f5c4fa111bdf$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e4c6f5c4fa111bdf$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e4c6f5c4fa111bdf$var$H : "?" === e[1] ? $e4c6f5c4fa111bdf$var$I : "@" === e[1] ? $e4c6f5c4fa111bdf$var$L : $e4c6f5c4fa111bdf$var$k
                    }), r.removeAttribute(t);
                } else t.startsWith($e4c6f5c4fa111bdf$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e4c6f5c4fa111bdf$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e4c6f5c4fa111bdf$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e4c6f5c4fa111bdf$var$i ? $e4c6f5c4fa111bdf$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e4c6f5c4fa111bdf$var$l()), $e4c6f5c4fa111bdf$var$C.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e4c6f5c4fa111bdf$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e4c6f5c4fa111bdf$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e4c6f5c4fa111bdf$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e4c6f5c4fa111bdf$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e4c6f5c4fa111bdf$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e4c6f5c4fa111bdf$var$S(t, i, s = t, e) {
    if (i === $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e4c6f5c4fa111bdf$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e4c6f5c4fa111bdf$var$S(t, h._$AS(t, i.values), h, e)), i;
}
class $e4c6f5c4fa111bdf$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e4c6f5c4fa111bdf$var$r).importNode(i, !0);
        $e4c6f5c4fa111bdf$var$C.currentNode = e;
        let h = $e4c6f5c4fa111bdf$var$C.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e4c6f5c4fa111bdf$var$R(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e4c6f5c4fa111bdf$var$z(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e4c6f5c4fa111bdf$var$C.nextNode(), o++);
        }
        return $e4c6f5c4fa111bdf$var$C.currentNode = $e4c6f5c4fa111bdf$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e4c6f5c4fa111bdf$var$R {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e4c6f5c4fa111bdf$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e4c6f5c4fa111bdf$var$S(this, t, i), $e4c6f5c4fa111bdf$var$c(t) ? t === $e4c6f5c4fa111bdf$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e4c6f5c4fa111bdf$export$45b790e32b2810ee && this._$AR(), this._$AH = $e4c6f5c4fa111bdf$export$45b790e32b2810ee) : t !== this._$AH && t !== $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e4c6f5c4fa111bdf$var$u(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e4c6f5c4fa111bdf$export$45b790e32b2810ee && $e4c6f5c4fa111bdf$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e4c6f5c4fa111bdf$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e4c6f5c4fa111bdf$var$N.createElement($e4c6f5c4fa111bdf$var$P(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e4c6f5c4fa111bdf$var$M(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e4c6f5c4fa111bdf$var$A.get(t.strings);
        return void 0 === i && $e4c6f5c4fa111bdf$var$A.set(t.strings, i = new $e4c6f5c4fa111bdf$var$N(t)), i;
    }
    k(t) {
        $e4c6f5c4fa111bdf$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e4c6f5c4fa111bdf$var$R(this.O($e4c6f5c4fa111bdf$var$l()), this.O($e4c6f5c4fa111bdf$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e4c6f5c4fa111bdf$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e4c6f5c4fa111bdf$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e4c6f5c4fa111bdf$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e4c6f5c4fa111bdf$var$S(this, t, i, 0), o = !$e4c6f5c4fa111bdf$var$c(t) || t !== this._$AH && t !== $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e4c6f5c4fa111bdf$var$S(this, e[s + n], i, n), r === $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e4c6f5c4fa111bdf$var$c(r) || r !== this._$AH[n], r === $e4c6f5c4fa111bdf$export$45b790e32b2810ee ? t = $e4c6f5c4fa111bdf$export$45b790e32b2810ee : t !== $e4c6f5c4fa111bdf$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e4c6f5c4fa111bdf$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e4c6f5c4fa111bdf$var$H extends $e4c6f5c4fa111bdf$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e4c6f5c4fa111bdf$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e4c6f5c4fa111bdf$var$I extends $e4c6f5c4fa111bdf$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e4c6f5c4fa111bdf$export$45b790e32b2810ee);
    }
}
class $e4c6f5c4fa111bdf$var$L extends $e4c6f5c4fa111bdf$var$k {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e4c6f5c4fa111bdf$var$S(this, t, i, 0) ?? $e4c6f5c4fa111bdf$export$45b790e32b2810ee) === $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e4c6f5c4fa111bdf$export$45b790e32b2810ee && s !== $e4c6f5c4fa111bdf$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e4c6f5c4fa111bdf$export$45b790e32b2810ee && (s === $e4c6f5c4fa111bdf$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e4c6f5c4fa111bdf$var$z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e4c6f5c4fa111bdf$var$S(this, t);
    }
}
const $e4c6f5c4fa111bdf$export$8613d1ca9052b22e = {
    M: $e4c6f5c4fa111bdf$var$e,
    P: $e4c6f5c4fa111bdf$var$h,
    A: $e4c6f5c4fa111bdf$var$o,
    C: 1,
    L: $e4c6f5c4fa111bdf$var$V,
    R: $e4c6f5c4fa111bdf$var$M,
    D: $e4c6f5c4fa111bdf$var$u,
    V: $e4c6f5c4fa111bdf$var$S,
    I: $e4c6f5c4fa111bdf$var$R,
    H: $e4c6f5c4fa111bdf$var$k,
    N: $e4c6f5c4fa111bdf$var$I,
    U: $e4c6f5c4fa111bdf$var$L,
    B: $e4c6f5c4fa111bdf$var$H,
    F: $e4c6f5c4fa111bdf$var$z
}, $e4c6f5c4fa111bdf$var$j = $e4c6f5c4fa111bdf$var$t.litHtmlPolyfillSupport;
$e4c6f5c4fa111bdf$var$j?.($e4c6f5c4fa111bdf$var$N, $e4c6f5c4fa111bdf$var$R), ($e4c6f5c4fa111bdf$var$t.litHtmlVersions ??= []).push("3.3.1");
const $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e4c6f5c4fa111bdf$var$R(i.insertBefore($e4c6f5c4fa111bdf$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9cd293958617bb59$var$s = globalThis;
class $9cd293958617bb59$export$3f2f9f5909897157 extends (0, $9081a043ddd975e7$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8;
    }
}
$9cd293958617bb59$export$3f2f9f5909897157._$litElement$ = !0, $9cd293958617bb59$export$3f2f9f5909897157["finalized"] = !0, $9cd293958617bb59$var$s.litElementHydrateSupport?.({
    LitElement: $9cd293958617bb59$export$3f2f9f5909897157
});
const $9cd293958617bb59$var$o = $9cd293958617bb59$var$s.litElementPolyfillSupport;
$9cd293958617bb59$var$o?.({
    LitElement: $9cd293958617bb59$export$3f2f9f5909897157
});
const $9cd293958617bb59$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($9cd293958617bb59$var$s.litElementVersions ??= []).push("4.2.1");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3448009a1a85eb15$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $df800a9dc9638977$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ea0a8a49bb7a0c56$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $9081a043ddd975e7$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $9081a043ddd975e7$export$53a6892c50694894)
}, $ea0a8a49bb7a0c56$export$8d623b1670eb40f4 = (t = $ea0a8a49bb7a0c56$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $ea0a8a49bb7a0c56$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $ea0a8a49bb7a0c56$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c0a011b960dd7d47$export$ca000e230c0caa3e(r) {
    return (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f0641f2d3597fd79$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $80506bd38f95433e$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $106eae4019cc62ca$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $80506bd38f95433e$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $80506bd38f95433e$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $0d4e772aca152022$var$e;
function $0d4e772aca152022$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $80506bd38f95433e$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($0d4e772aca152022$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d3064cda33e02d78$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $80506bd38f95433e$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8c2088e3a575f71a$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $80506bd38f95433e$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $cc3f89f756f1a0d7$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $80506bd38f95433e$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6c5f3cda7e712574$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    NOT_AVAILABLE: "Not Available",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
const $6c5f3cda7e712574$export$2b71909294c66558 = {
    SUCCESS: 200,
    SUCCESS_RANGE_START: 200,
    SUCCESS_RANGE_END: 299,
    REDIRECT: 302,
    CLIENT_ERROR: 400,
    CLIENT_ERROR_RANGE_START: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    GONE: 410,
    TOO_MANY_REQUESTS: 429,
    CLIENT_ERROR_RANGE_END: 499,
    SERVER_ERROR: 500,
    SERVER_ERROR_RANGE_START: 500,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
    SERVER_ERROR_RANGE_END: 599,
    MULTI_SIDED_ERROR: 600
};
const $6c5f3cda7e712574$export$8343e6f32f5246de = {
    GET: "GET",
    POST: "POST"
};
const $6c5f3cda7e712574$export$893b1b5b686d84ef = [
    $6c5f3cda7e712574$export$a002182e51710d39.OPENID_SCOPE,
    $6c5f3cda7e712574$export$a002182e51710d39.PROFILE_SCOPE,
    $6c5f3cda7e712574$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
const $6c5f3cda7e712574$export$268e88275f5afab2 = [
    ...$6c5f3cda7e712574$export$893b1b5b686d84ef,
    $6c5f3cda7e712574$export$a002182e51710d39.EMAIL_SCOPE
];
/**
 * Request header names
 */ const $6c5f3cda7e712574$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $6c5f3cda7e712574$export$81ab9ba9bd28255c = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $6c5f3cda7e712574$export$e18ac120172ed505 = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $6c5f3cda7e712574$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $6c5f3cda7e712574$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $6c5f3cda7e712574$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * Allowed values for response_type
 */ const $6c5f3cda7e712574$export$5ef2b2ebd3da3e04 = {
    CODE: "code",
    IDTOKEN_TOKEN: "id_token token",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for server response type
 * @deprecated Use ResponseMode instead
 */ const $6c5f3cda7e712574$export$b34cb6fbea2adc44 = {
    QUERY: "query",
    FRAGMENT: "fragment"
};
/**
 * allowed values for response_mode
 */ const $6c5f3cda7e712574$export$f990a5bae1260b8c = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $6c5f3cda7e712574$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
};
/**
 * Account types in Cache
 */ const $6c5f3cda7e712574$export$23244fafa2e7f55c = {
    MSSTS_ACCOUNT_TYPE: "MSSTS",
    ADFS_ACCOUNT_TYPE: "ADFS",
    MSAV1_ACCOUNT_TYPE: "MSA",
    GENERIC_ACCOUNT_TYPE: "Generic"
};
/**
 * Separators used in cache
 */ const $6c5f3cda7e712574$export$520854da2ba5d734 = {
    CACHE_KEY_SEPARATOR: "-",
    CLIENT_INFO_SEPARATOR: "."
};
/**
 * Credential Type stored in the cache
 */ const $6c5f3cda7e712574$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $6c5f3cda7e712574$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $6c5f3cda7e712574$export$7e1bea6dc1b6b32e = "appmetadata";
const $6c5f3cda7e712574$export$476989d62bcb4c85 = "client_info";
const $6c5f3cda7e712574$export$978fe7ab5e74b539 = "1";
const $6c5f3cda7e712574$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400
};
const $6c5f3cda7e712574$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $6c5f3cda7e712574$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ const $6c5f3cda7e712574$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $6c5f3cda7e712574$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
const $6c5f3cda7e712574$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ const $6c5f3cda7e712574$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Region Discovery Sources
 */ const $6c5f3cda7e712574$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $6c5f3cda7e712574$export$92a685f9218422bd = {
    CONFIGURED_NO_AUTO_DETECTION: "2",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $6c5f3cda7e712574$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $6c5f3cda7e712574$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $6c5f3cda7e712574$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $6c5f3cda7e712574$export$8d50f42618161d1a = 300;
const $6c5f3cda7e712574$export$6592cb873eed5846 = {
    BASE64: "base64",
    HEX: "hex",
    UTF8: "utf-8"
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $9d8c7bd8b3e958dc$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($9d8c7bd8b3e958dc$export$243e62d78d3b544d || ($9d8c7bd8b3e958dc$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $9d8c7bd8b3e958dc$export$efa9a398d6368992 {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $9d8c7bd8b3e958dc$export$efa9a398d6368992.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion, correlationId) {
        return new $9d8c7bd8b3e958dc$export$efa9a398d6368992({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${options.correlationId || this.correlationId || ""}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$9d8c7bd8b3e958dc$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9d8c7bd8b3e958dc$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $408770affa359606$export$4cda21933050d9ec = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};

var $bb6c67187aec31ed$exports = {};

$parcel$export($bb6c67187aec31ed$exports, "redirectUriEmpty", () => $bb6c67187aec31ed$export$7a02f9bdce79dd4e);
$parcel$export($bb6c67187aec31ed$exports, "claimsRequestParsingError", () => $bb6c67187aec31ed$export$561c97672a478709);
$parcel$export($bb6c67187aec31ed$exports, "authorityUriInsecure", () => $bb6c67187aec31ed$export$f77c6af656c8444b);
$parcel$export($bb6c67187aec31ed$exports, "urlParseError", () => $bb6c67187aec31ed$export$ee2a1a3389f75508);
$parcel$export($bb6c67187aec31ed$exports, "urlEmptyError", () => $bb6c67187aec31ed$export$859df485a5e0f239);
$parcel$export($bb6c67187aec31ed$exports, "emptyInputScopesError", () => $bb6c67187aec31ed$export$6ac27379c42383f);
$parcel$export($bb6c67187aec31ed$exports, "invalidClaims", () => $bb6c67187aec31ed$export$96e755c70e0d0e34);
$parcel$export($bb6c67187aec31ed$exports, "tokenRequestEmpty", () => $bb6c67187aec31ed$export$eca67ff7a91fed9d);
$parcel$export($bb6c67187aec31ed$exports, "logoutRequestEmpty", () => $bb6c67187aec31ed$export$9eb2eeb401492d88);
$parcel$export($bb6c67187aec31ed$exports, "invalidCodeChallengeMethod", () => $bb6c67187aec31ed$export$b8d8b332f17376dc);
$parcel$export($bb6c67187aec31ed$exports, "pkceParamsMissing", () => $bb6c67187aec31ed$export$2da3866b327f1753);
$parcel$export($bb6c67187aec31ed$exports, "invalidCloudDiscoveryMetadata", () => $bb6c67187aec31ed$export$92a2985751150ca5);
$parcel$export($bb6c67187aec31ed$exports, "invalidAuthorityMetadata", () => $bb6c67187aec31ed$export$edb4d5942bc8ccff);
$parcel$export($bb6c67187aec31ed$exports, "untrustedAuthority", () => $bb6c67187aec31ed$export$50c3162fda5f57);
$parcel$export($bb6c67187aec31ed$exports, "missingSshJwk", () => $bb6c67187aec31ed$export$8fbed44b22d9136f);
$parcel$export($bb6c67187aec31ed$exports, "missingSshKid", () => $bb6c67187aec31ed$export$b728bd8a588956c);
$parcel$export($bb6c67187aec31ed$exports, "missingNonceAuthenticationHeader", () => $bb6c67187aec31ed$export$4f88b4462bcef15f);
$parcel$export($bb6c67187aec31ed$exports, "invalidAuthenticationHeader", () => $bb6c67187aec31ed$export$bea58e1a2e503b59);
$parcel$export($bb6c67187aec31ed$exports, "cannotSetOIDCOptions", () => $bb6c67187aec31ed$export$a5c9fbb90473dca2);
$parcel$export($bb6c67187aec31ed$exports, "cannotAllowPlatformBroker", () => $bb6c67187aec31ed$export$9a3a7609ff879ac7);
$parcel$export($bb6c67187aec31ed$exports, "authorityMismatch", () => $bb6c67187aec31ed$export$91415fb6baea5d09);
$parcel$export($bb6c67187aec31ed$exports, "invalidRequestMethodForEAR", () => $bb6c67187aec31ed$export$370f4bd236cb2302);
$parcel$export($bb6c67187aec31ed$exports, "invalidAuthorizePostBodyParameters", () => $bb6c67187aec31ed$export$54c6a0c3921e0e0b);
$parcel$export($bb6c67187aec31ed$exports, "invalidPlatformBrokerConfiguration", () => $bb6c67187aec31ed$export$771e0d8e79da4143);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $bb6c67187aec31ed$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $bb6c67187aec31ed$export$561c97672a478709 = "claims_request_parsing_error";
const $bb6c67187aec31ed$export$f77c6af656c8444b = "authority_uri_insecure";
const $bb6c67187aec31ed$export$ee2a1a3389f75508 = "url_parse_error";
const $bb6c67187aec31ed$export$859df485a5e0f239 = "empty_url_error";
const $bb6c67187aec31ed$export$6ac27379c42383f = "empty_input_scopes_error";
const $bb6c67187aec31ed$export$96e755c70e0d0e34 = "invalid_claims";
const $bb6c67187aec31ed$export$eca67ff7a91fed9d = "token_request_empty";
const $bb6c67187aec31ed$export$9eb2eeb401492d88 = "logout_request_empty";
const $bb6c67187aec31ed$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $bb6c67187aec31ed$export$2da3866b327f1753 = "pkce_params_missing";
const $bb6c67187aec31ed$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $bb6c67187aec31ed$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $bb6c67187aec31ed$export$50c3162fda5f57 = "untrusted_authority";
const $bb6c67187aec31ed$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $bb6c67187aec31ed$export$b728bd8a588956c = "missing_ssh_kid";
const $bb6c67187aec31ed$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $bb6c67187aec31ed$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $bb6c67187aec31ed$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $bb6c67187aec31ed$export$9a3a7609ff879ac7 = "cannot_allow_platform_broker";
const $bb6c67187aec31ed$export$91415fb6baea5d09 = "authority_mismatch";
const $bb6c67187aec31ed$export$370f4bd236cb2302 = "invalid_request_method_for_EAR";
const $bb6c67187aec31ed$export$54c6a0c3921e0e0b = "invalid_authorize_post_body_parameters";
const $bb6c67187aec31ed$export$771e0d8e79da4143 = "invalid_platform_broker_configuration";

/*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 
var $0269aad95c21e8be$exports = {};

$parcel$export($0269aad95c21e8be$exports, "unexpectedError", () => $0269aad95c21e8be$export$efbc88c27b0be04);
$parcel$export($0269aad95c21e8be$exports, "postRequestFailed", () => $0269aad95c21e8be$export$7a1e28a7b60ca602);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $0269aad95c21e8be$export$efbc88c27b0be04 = "unexpected_error";
const $0269aad95c21e8be$export$7a1e28a7b60ca602 = "post_request_failed";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0a726c4076f6517d$export$cd5f04206718d3a5 = {
    [(0, $0269aad95c21e8be$export$efbc88c27b0be04)]: "Unexpected error in authentication.",
    [(0, $0269aad95c21e8be$export$7a1e28a7b60ca602)]: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
};
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use AuthErrorCodes instead
 */ const $0a726c4076f6517d$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: (0, $0269aad95c21e8be$export$efbc88c27b0be04),
        desc: $0a726c4076f6517d$export$cd5f04206718d3a5[0, $0269aad95c21e8be$export$efbc88c27b0be04]
    },
    postRequestFailed: {
        code: (0, $0269aad95c21e8be$export$7a1e28a7b60ca602),
        desc: $0a726c4076f6517d$export$cd5f04206718d3a5[0, $0269aad95c21e8be$export$7a1e28a7b60ca602]
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ class $0a726c4076f6517d$export$145273558d58e0ac extends Error {
    constructor(errorCode, errorMessage, suberror){
        const errorString = errorMessage ? `${errorCode}: ${errorMessage}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $0a726c4076f6517d$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.errorMessage = errorMessage || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.subError = suberror || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.name = "AuthError";
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
}
function $0a726c4076f6517d$export$eb157f7636c79bd2(code, additionalMessage) {
    return new $0a726c4076f6517d$export$145273558d58e0ac(code, additionalMessage ? `${$0a726c4076f6517d$export$cd5f04206718d3a5[code]} ${additionalMessage}` : $0a726c4076f6517d$export$cd5f04206718d3a5[code]);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $826bb5c860ac82b9$export$45752b5111a13710 = {
    [(0, $bb6c67187aec31ed$export$7a02f9bdce79dd4e)]: "A redirect URI is required for all calls, and none has been set.",
    [(0, $bb6c67187aec31ed$export$561c97672a478709)]: "Could not parse the given claims request object.",
    [(0, $bb6c67187aec31ed$export$f77c6af656c8444b)]: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
    [(0, $bb6c67187aec31ed$export$ee2a1a3389f75508)]: "URL could not be parsed into appropriate segments.",
    [(0, $bb6c67187aec31ed$export$859df485a5e0f239)]: "URL was empty or null.",
    [(0, $bb6c67187aec31ed$export$6ac27379c42383f)]: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token.",
    [(0, $bb6c67187aec31ed$export$96e755c70e0d0e34)]: "Given claims parameter must be a stringified JSON object.",
    [(0, $bb6c67187aec31ed$export$eca67ff7a91fed9d)]: "Token request was empty and not found in cache.",
    [(0, $bb6c67187aec31ed$export$9eb2eeb401492d88)]: "The logout request was null or undefined.",
    [(0, $bb6c67187aec31ed$export$b8d8b332f17376dc)]: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".',
    [(0, $bb6c67187aec31ed$export$2da3866b327f1753)]: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request",
    [(0, $bb6c67187aec31ed$export$92a2985751150ca5)]: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields",
    [(0, $bb6c67187aec31ed$export$edb4d5942bc8ccff)]: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields.",
    [(0, $bb6c67187aec31ed$export$50c3162fda5f57)]: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter.",
    [(0, $bb6c67187aec31ed$export$8fbed44b22d9136f)]: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme.",
    [(0, $bb6c67187aec31ed$export$b728bd8a588956c)]: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme.",
    [(0, $bb6c67187aec31ed$export$4f88b4462bcef15f)]: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce.",
    [(0, $bb6c67187aec31ed$export$bea58e1a2e503b59)]: "Invalid authentication header provided",
    [(0, $bb6c67187aec31ed$export$a5c9fbb90473dca2)]: "Cannot set OIDCOptions parameter. Please change the protocol mode to OIDC or use a non-Microsoft authority.",
    [(0, $bb6c67187aec31ed$export$9a3a7609ff879ac7)]: "Cannot set allowPlatformBroker parameter to true when not in AAD protocol mode.",
    [(0, $bb6c67187aec31ed$export$91415fb6baea5d09)]: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority.",
    [(0, $bb6c67187aec31ed$export$54c6a0c3921e0e0b)]: "Invalid authorize post body parameters provided. If you are using authorizePostBodyParameters, the request method must be POST. Please check the request method and parameters.",
    [(0, $bb6c67187aec31ed$export$370f4bd236cb2302)]: "Invalid request method for EAR protocol mode. The request method cannot be GET when using EAR protocol mode. Please change the request method to POST.",
    [(0, $bb6c67187aec31ed$export$771e0d8e79da4143)]: "Invalid platform broker configuration. `allowPlatformBrokerWithDOM` can only be enabled when `allowPlatformBroker` is enabled."
};
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use ClientConfigurationErrorCodes instead
 */ const $826bb5c860ac82b9$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: (0, $bb6c67187aec31ed$export$7a02f9bdce79dd4e),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$7a02f9bdce79dd4e]
    },
    claimsRequestParsingError: {
        code: (0, $bb6c67187aec31ed$export$561c97672a478709),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$561c97672a478709]
    },
    authorityUriInsecure: {
        code: (0, $bb6c67187aec31ed$export$f77c6af656c8444b),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$f77c6af656c8444b]
    },
    urlParseError: {
        code: (0, $bb6c67187aec31ed$export$ee2a1a3389f75508),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$ee2a1a3389f75508]
    },
    urlEmptyError: {
        code: (0, $bb6c67187aec31ed$export$859df485a5e0f239),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$859df485a5e0f239]
    },
    emptyScopesError: {
        code: (0, $bb6c67187aec31ed$export$6ac27379c42383f),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$6ac27379c42383f]
    },
    invalidClaimsRequest: {
        code: (0, $bb6c67187aec31ed$export$96e755c70e0d0e34),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$96e755c70e0d0e34]
    },
    tokenRequestEmptyError: {
        code: (0, $bb6c67187aec31ed$export$eca67ff7a91fed9d),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$eca67ff7a91fed9d]
    },
    logoutRequestEmptyError: {
        code: (0, $bb6c67187aec31ed$export$9eb2eeb401492d88),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$9eb2eeb401492d88]
    },
    invalidCodeChallengeMethod: {
        code: (0, $bb6c67187aec31ed$export$b8d8b332f17376dc),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$b8d8b332f17376dc]
    },
    invalidCodeChallengeParams: {
        code: (0, $bb6c67187aec31ed$export$2da3866b327f1753),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$2da3866b327f1753]
    },
    invalidCloudDiscoveryMetadata: {
        code: (0, $bb6c67187aec31ed$export$92a2985751150ca5),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$92a2985751150ca5]
    },
    invalidAuthorityMetadata: {
        code: (0, $bb6c67187aec31ed$export$edb4d5942bc8ccff),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$edb4d5942bc8ccff]
    },
    untrustedAuthority: {
        code: (0, $bb6c67187aec31ed$export$50c3162fda5f57),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$50c3162fda5f57]
    },
    missingSshJwk: {
        code: (0, $bb6c67187aec31ed$export$8fbed44b22d9136f),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$8fbed44b22d9136f]
    },
    missingSshKid: {
        code: (0, $bb6c67187aec31ed$export$b728bd8a588956c),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$b728bd8a588956c]
    },
    missingNonceAuthenticationHeader: {
        code: (0, $bb6c67187aec31ed$export$4f88b4462bcef15f),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$4f88b4462bcef15f]
    },
    invalidAuthenticationHeader: {
        code: (0, $bb6c67187aec31ed$export$bea58e1a2e503b59),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$bea58e1a2e503b59]
    },
    cannotSetOIDCOptions: {
        code: (0, $bb6c67187aec31ed$export$a5c9fbb90473dca2),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$a5c9fbb90473dca2]
    },
    cannotAllowPlatformBroker: {
        code: (0, $bb6c67187aec31ed$export$9a3a7609ff879ac7),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$9a3a7609ff879ac7]
    },
    authorityMismatch: {
        code: (0, $bb6c67187aec31ed$export$91415fb6baea5d09),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$91415fb6baea5d09]
    },
    invalidAuthorizePostBodyParameters: {
        code: (0, $bb6c67187aec31ed$export$54c6a0c3921e0e0b),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$54c6a0c3921e0e0b]
    },
    invalidRequestMethodForEAR: {
        code: (0, $bb6c67187aec31ed$export$370f4bd236cb2302),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$370f4bd236cb2302]
    },
    invalidPlatformBrokerConfiguration: {
        code: (0, $bb6c67187aec31ed$export$771e0d8e79da4143),
        desc: $826bb5c860ac82b9$export$45752b5111a13710[0, $bb6c67187aec31ed$export$771e0d8e79da4143]
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $826bb5c860ac82b9$export$ac9d9d20c2327339 extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode){
        super(errorCode, $826bb5c860ac82b9$export$45752b5111a13710[errorCode]);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $826bb5c860ac82b9$export$ac9d9d20c2327339.prototype);
    }
}
function $826bb5c860ac82b9$export$5d63d098f4f130a1(errorCode) {
    return new $826bb5c860ac82b9$export$ac9d9d20c2327339(errorCode);
}

/*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 
var $4c3d14616baac1bd$exports = {};

$parcel$export($4c3d14616baac1bd$exports, "clientInfoDecodingError", () => $4c3d14616baac1bd$export$ccdf48c387c47b82);
$parcel$export($4c3d14616baac1bd$exports, "clientInfoEmptyError", () => $4c3d14616baac1bd$export$12315251e24e0181);
$parcel$export($4c3d14616baac1bd$exports, "tokenParsingError", () => $4c3d14616baac1bd$export$ad362b2e3a260143);
$parcel$export($4c3d14616baac1bd$exports, "nullOrEmptyToken", () => $4c3d14616baac1bd$export$78d01e29cb494be2);
$parcel$export($4c3d14616baac1bd$exports, "endpointResolutionError", () => $4c3d14616baac1bd$export$c9fcc93738cc2bc3);
$parcel$export($4c3d14616baac1bd$exports, "networkError", () => $4c3d14616baac1bd$export$4358cbadf08aa73);
$parcel$export($4c3d14616baac1bd$exports, "openIdConfigError", () => $4c3d14616baac1bd$export$73566da29bc073eb);
$parcel$export($4c3d14616baac1bd$exports, "hashNotDeserialized", () => $4c3d14616baac1bd$export$14c4d54a8414667f);
$parcel$export($4c3d14616baac1bd$exports, "invalidState", () => $4c3d14616baac1bd$export$72a77317632c052b);
$parcel$export($4c3d14616baac1bd$exports, "stateMismatch", () => $4c3d14616baac1bd$export$6a56d8f882843cd8);
$parcel$export($4c3d14616baac1bd$exports, "stateNotFound", () => $4c3d14616baac1bd$export$ef9214cfa5960fc);
$parcel$export($4c3d14616baac1bd$exports, "nonceMismatch", () => $4c3d14616baac1bd$export$edd0491c2c280be7);
$parcel$export($4c3d14616baac1bd$exports, "authTimeNotFound", () => $4c3d14616baac1bd$export$43356944266c945e);
$parcel$export($4c3d14616baac1bd$exports, "maxAgeTranspired", () => $4c3d14616baac1bd$export$f95fb86904f89749);
$parcel$export($4c3d14616baac1bd$exports, "multipleMatchingTokens", () => $4c3d14616baac1bd$export$47c50a2451614107);
$parcel$export($4c3d14616baac1bd$exports, "multipleMatchingAccounts", () => $4c3d14616baac1bd$export$2804a8b1b4c3be8b);
$parcel$export($4c3d14616baac1bd$exports, "multipleMatchingAppMetadata", () => $4c3d14616baac1bd$export$575bb2924bcd0084);
$parcel$export($4c3d14616baac1bd$exports, "requestCannotBeMade", () => $4c3d14616baac1bd$export$4ac9fb1f531eded7);
$parcel$export($4c3d14616baac1bd$exports, "cannotRemoveEmptyScope", () => $4c3d14616baac1bd$export$f7a276c01beb068a);
$parcel$export($4c3d14616baac1bd$exports, "cannotAppendScopeSet", () => $4c3d14616baac1bd$export$93883786cf4a4a27);
$parcel$export($4c3d14616baac1bd$exports, "emptyInputScopeSet", () => $4c3d14616baac1bd$export$41e2ce5958c42c83);
$parcel$export($4c3d14616baac1bd$exports, "deviceCodePollingCancelled", () => $4c3d14616baac1bd$export$e3af42f9856ab2a);
$parcel$export($4c3d14616baac1bd$exports, "deviceCodeExpired", () => $4c3d14616baac1bd$export$c0ef55deeb5e30d5);
$parcel$export($4c3d14616baac1bd$exports, "deviceCodeUnknownError", () => $4c3d14616baac1bd$export$4a9e9cce395ba70c);
$parcel$export($4c3d14616baac1bd$exports, "noAccountInSilentRequest", () => $4c3d14616baac1bd$export$5a3c7d1c90ac9220);
$parcel$export($4c3d14616baac1bd$exports, "invalidCacheRecord", () => $4c3d14616baac1bd$export$d396103576f879cc);
$parcel$export($4c3d14616baac1bd$exports, "invalidCacheEnvironment", () => $4c3d14616baac1bd$export$dedc648643245fa1);
$parcel$export($4c3d14616baac1bd$exports, "noAccountFound", () => $4c3d14616baac1bd$export$b98ebfe073f0162f);
$parcel$export($4c3d14616baac1bd$exports, "noCryptoObject", () => $4c3d14616baac1bd$export$c39e501a22cba395);
$parcel$export($4c3d14616baac1bd$exports, "unexpectedCredentialType", () => $4c3d14616baac1bd$export$21fdd1f95350cd6d);
$parcel$export($4c3d14616baac1bd$exports, "invalidAssertion", () => $4c3d14616baac1bd$export$e168896c692fb06b);
$parcel$export($4c3d14616baac1bd$exports, "invalidClientCredential", () => $4c3d14616baac1bd$export$c483ba88a47982b1);
$parcel$export($4c3d14616baac1bd$exports, "tokenRefreshRequired", () => $4c3d14616baac1bd$export$e23b692cce0c7779);
$parcel$export($4c3d14616baac1bd$exports, "userTimeoutReached", () => $4c3d14616baac1bd$export$afbb99ff17e87b86);
$parcel$export($4c3d14616baac1bd$exports, "tokenClaimsCnfRequiredForSignedJwt", () => $4c3d14616baac1bd$export$6f89b8a7d491b526);
$parcel$export($4c3d14616baac1bd$exports, "authorizationCodeMissingFromServerResponse", () => $4c3d14616baac1bd$export$93625fc864d26bba);
$parcel$export($4c3d14616baac1bd$exports, "bindingKeyNotRemoved", () => $4c3d14616baac1bd$export$5765db5d84418d29);
$parcel$export($4c3d14616baac1bd$exports, "endSessionEndpointNotSupported", () => $4c3d14616baac1bd$export$c3bd741c16a889f3);
$parcel$export($4c3d14616baac1bd$exports, "keyIdMissing", () => $4c3d14616baac1bd$export$3c9338a50e294d1);
$parcel$export($4c3d14616baac1bd$exports, "noNetworkConnectivity", () => $4c3d14616baac1bd$export$31ae862f18c3b2b7);
$parcel$export($4c3d14616baac1bd$exports, "userCanceled", () => $4c3d14616baac1bd$export$8ee329e65a880ec7);
$parcel$export($4c3d14616baac1bd$exports, "missingTenantIdError", () => $4c3d14616baac1bd$export$8c321d057617a458);
$parcel$export($4c3d14616baac1bd$exports, "methodNotImplemented", () => $4c3d14616baac1bd$export$24176fc1f15eea22);
$parcel$export($4c3d14616baac1bd$exports, "nestedAppAuthBridgeDisabled", () => $4c3d14616baac1bd$export$3078b0202fe7eea3);
$parcel$export($4c3d14616baac1bd$exports, "platformBrokerError", () => $4c3d14616baac1bd$export$3642667d172bf3ce);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $4c3d14616baac1bd$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $4c3d14616baac1bd$export$12315251e24e0181 = "client_info_empty_error";
const $4c3d14616baac1bd$export$ad362b2e3a260143 = "token_parsing_error";
const $4c3d14616baac1bd$export$78d01e29cb494be2 = "null_or_empty_token";
const $4c3d14616baac1bd$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $4c3d14616baac1bd$export$4358cbadf08aa73 = "network_error";
const $4c3d14616baac1bd$export$73566da29bc073eb = "openid_config_error";
const $4c3d14616baac1bd$export$14c4d54a8414667f = "hash_not_deserialized";
const $4c3d14616baac1bd$export$72a77317632c052b = "invalid_state";
const $4c3d14616baac1bd$export$6a56d8f882843cd8 = "state_mismatch";
const $4c3d14616baac1bd$export$ef9214cfa5960fc = "state_not_found";
const $4c3d14616baac1bd$export$edd0491c2c280be7 = "nonce_mismatch";
const $4c3d14616baac1bd$export$43356944266c945e = "auth_time_not_found";
const $4c3d14616baac1bd$export$f95fb86904f89749 = "max_age_transpired";
const $4c3d14616baac1bd$export$47c50a2451614107 = "multiple_matching_tokens";
const $4c3d14616baac1bd$export$2804a8b1b4c3be8b = "multiple_matching_accounts";
const $4c3d14616baac1bd$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $4c3d14616baac1bd$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $4c3d14616baac1bd$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $4c3d14616baac1bd$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $4c3d14616baac1bd$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $4c3d14616baac1bd$export$e3af42f9856ab2a = "device_code_polling_cancelled";
const $4c3d14616baac1bd$export$c0ef55deeb5e30d5 = "device_code_expired";
const $4c3d14616baac1bd$export$4a9e9cce395ba70c = "device_code_unknown_error";
const $4c3d14616baac1bd$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $4c3d14616baac1bd$export$d396103576f879cc = "invalid_cache_record";
const $4c3d14616baac1bd$export$dedc648643245fa1 = "invalid_cache_environment";
const $4c3d14616baac1bd$export$b98ebfe073f0162f = "no_account_found";
const $4c3d14616baac1bd$export$c39e501a22cba395 = "no_crypto_object";
const $4c3d14616baac1bd$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $4c3d14616baac1bd$export$e168896c692fb06b = "invalid_assertion";
const $4c3d14616baac1bd$export$c483ba88a47982b1 = "invalid_client_credential";
const $4c3d14616baac1bd$export$e23b692cce0c7779 = "token_refresh_required";
const $4c3d14616baac1bd$export$afbb99ff17e87b86 = "user_timeout_reached";
const $4c3d14616baac1bd$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $4c3d14616baac1bd$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $4c3d14616baac1bd$export$5765db5d84418d29 = "binding_key_not_removed";
const $4c3d14616baac1bd$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $4c3d14616baac1bd$export$3c9338a50e294d1 = "key_id_missing";
const $4c3d14616baac1bd$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $4c3d14616baac1bd$export$8ee329e65a880ec7 = "user_canceled";
const $4c3d14616baac1bd$export$8c321d057617a458 = "missing_tenant_id_error";
const $4c3d14616baac1bd$export$24176fc1f15eea22 = "method_not_implemented";
const $4c3d14616baac1bd$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";
const $4c3d14616baac1bd$export$3642667d172bf3ce = "platform_broker_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $0114b0a218ba15f8$export$8190ec70cbf7ec08 = {
    [(0, $4c3d14616baac1bd$export$ccdf48c387c47b82)]: "The client info could not be parsed/decoded correctly",
    [(0, $4c3d14616baac1bd$export$12315251e24e0181)]: "The client info was empty",
    [(0, $4c3d14616baac1bd$export$ad362b2e3a260143)]: "Token cannot be parsed",
    [(0, $4c3d14616baac1bd$export$78d01e29cb494be2)]: "The token is null or empty",
    [(0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3)]: "Endpoints cannot be resolved",
    [(0, $4c3d14616baac1bd$export$4358cbadf08aa73)]: "Network request failed",
    [(0, $4c3d14616baac1bd$export$73566da29bc073eb)]: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints.",
    [(0, $4c3d14616baac1bd$export$14c4d54a8414667f)]: "The hash parameters could not be deserialized",
    [(0, $4c3d14616baac1bd$export$72a77317632c052b)]: "State was not the expected format",
    [(0, $4c3d14616baac1bd$export$6a56d8f882843cd8)]: "State mismatch error",
    [(0, $4c3d14616baac1bd$export$ef9214cfa5960fc)]: "State not found",
    [(0, $4c3d14616baac1bd$export$edd0491c2c280be7)]: "Nonce mismatch error",
    [(0, $4c3d14616baac1bd$export$43356944266c945e)]: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information.",
    [(0, $4c3d14616baac1bd$export$f95fb86904f89749)]: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication.",
    [(0, $4c3d14616baac1bd$export$47c50a2451614107)]: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account.",
    [(0, $4c3d14616baac1bd$export$2804a8b1b4c3be8b)]: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account",
    [(0, $4c3d14616baac1bd$export$575bb2924bcd0084)]: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata",
    [(0, $4c3d14616baac1bd$export$4ac9fb1f531eded7)]: "Token request cannot be made without authorization code or refresh token.",
    [(0, $4c3d14616baac1bd$export$f7a276c01beb068a)]: "Cannot remove null or empty scope from ScopeSet",
    [(0, $4c3d14616baac1bd$export$93883786cf4a4a27)]: "Cannot append ScopeSet",
    [(0, $4c3d14616baac1bd$export$41e2ce5958c42c83)]: "Empty input ScopeSet cannot be processed",
    [(0, $4c3d14616baac1bd$export$e3af42f9856ab2a)]: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true.",
    [(0, $4c3d14616baac1bd$export$c0ef55deeb5e30d5)]: "Device code is expired.",
    [(0, $4c3d14616baac1bd$export$4a9e9cce395ba70c)]: "Device code stopped polling for unknown reasons.",
    [(0, $4c3d14616baac1bd$export$5a3c7d1c90ac9220)]: "Please pass an account object, silent flow is not supported without account information",
    [(0, $4c3d14616baac1bd$export$d396103576f879cc)]: "Cache record object was null or undefined.",
    [(0, $4c3d14616baac1bd$export$dedc648643245fa1)]: "Invalid environment when attempting to create cache entry",
    [(0, $4c3d14616baac1bd$export$b98ebfe073f0162f)]: "No account found in cache for given key.",
    [(0, $4c3d14616baac1bd$export$c39e501a22cba395)]: "No crypto object detected.",
    [(0, $4c3d14616baac1bd$export$21fdd1f95350cd6d)]: "Unexpected credential type.",
    [(0, $4c3d14616baac1bd$export$e168896c692fb06b)]: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515",
    [(0, $4c3d14616baac1bd$export$c483ba88a47982b1)]: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential",
    [(0, $4c3d14616baac1bd$export$e23b692cce0c7779)]: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired.",
    [(0, $4c3d14616baac1bd$export$afbb99ff17e87b86)]: "User defined timeout for device code polling reached",
    [(0, $4c3d14616baac1bd$export$6f89b8a7d491b526)]: "Cannot generate a POP jwt if the token_claims are not populated",
    [(0, $4c3d14616baac1bd$export$93625fc864d26bba)]: "Server response does not contain an authorization code to proceed",
    [(0, $4c3d14616baac1bd$export$5765db5d84418d29)]: "Could not remove the credential's binding key from storage.",
    [(0, $4c3d14616baac1bd$export$c3bd741c16a889f3)]: "The provided authority does not support logout",
    [(0, $4c3d14616baac1bd$export$3c9338a50e294d1)]: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key.",
    [(0, $4c3d14616baac1bd$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $4c3d14616baac1bd$export$8ee329e65a880ec7)]: "User cancelled the flow.",
    [(0, $4c3d14616baac1bd$export$8c321d057617a458)]: "A tenant id - not common, organizations, or consumers - must be specified when using the client_credentials flow.",
    [(0, $4c3d14616baac1bd$export$24176fc1f15eea22)]: "This method has not been implemented",
    [(0, $4c3d14616baac1bd$export$3078b0202fe7eea3)]: "The nested app auth bridge is disabled",
    [(0, $4c3d14616baac1bd$export$3642667d172bf3ce)]: "An error occurred in the native broker. See the platformBrokerError property for details."
};
/**
 * String constants used by error codes and messages.
 * @deprecated Use ClientAuthErrorCodes instead
 */ const $0114b0a218ba15f8$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: (0, $4c3d14616baac1bd$export$ccdf48c387c47b82),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$ccdf48c387c47b82]
    },
    clientInfoEmptyError: {
        code: (0, $4c3d14616baac1bd$export$12315251e24e0181),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$12315251e24e0181]
    },
    tokenParsingError: {
        code: (0, $4c3d14616baac1bd$export$ad362b2e3a260143),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$ad362b2e3a260143]
    },
    nullOrEmptyToken: {
        code: (0, $4c3d14616baac1bd$export$78d01e29cb494be2),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$78d01e29cb494be2]
    },
    endpointResolutionError: {
        code: (0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3]
    },
    networkError: {
        code: (0, $4c3d14616baac1bd$export$4358cbadf08aa73),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$4358cbadf08aa73]
    },
    unableToGetOpenidConfigError: {
        code: (0, $4c3d14616baac1bd$export$73566da29bc073eb),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$73566da29bc073eb]
    },
    hashNotDeserialized: {
        code: (0, $4c3d14616baac1bd$export$14c4d54a8414667f),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$14c4d54a8414667f]
    },
    invalidStateError: {
        code: (0, $4c3d14616baac1bd$export$72a77317632c052b),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$72a77317632c052b]
    },
    stateMismatchError: {
        code: (0, $4c3d14616baac1bd$export$6a56d8f882843cd8),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$6a56d8f882843cd8]
    },
    stateNotFoundError: {
        code: (0, $4c3d14616baac1bd$export$ef9214cfa5960fc),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$ef9214cfa5960fc]
    },
    nonceMismatchError: {
        code: (0, $4c3d14616baac1bd$export$edd0491c2c280be7),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$edd0491c2c280be7]
    },
    authTimeNotFoundError: {
        code: (0, $4c3d14616baac1bd$export$43356944266c945e),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$43356944266c945e]
    },
    maxAgeTranspired: {
        code: (0, $4c3d14616baac1bd$export$f95fb86904f89749),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$f95fb86904f89749]
    },
    multipleMatchingTokens: {
        code: (0, $4c3d14616baac1bd$export$47c50a2451614107),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$47c50a2451614107]
    },
    multipleMatchingAccounts: {
        code: (0, $4c3d14616baac1bd$export$2804a8b1b4c3be8b),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$2804a8b1b4c3be8b]
    },
    multipleMatchingAppMetadata: {
        code: (0, $4c3d14616baac1bd$export$575bb2924bcd0084),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$575bb2924bcd0084]
    },
    tokenRequestCannotBeMade: {
        code: (0, $4c3d14616baac1bd$export$4ac9fb1f531eded7),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$4ac9fb1f531eded7]
    },
    removeEmptyScopeError: {
        code: (0, $4c3d14616baac1bd$export$f7a276c01beb068a),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$f7a276c01beb068a]
    },
    appendScopeSetError: {
        code: (0, $4c3d14616baac1bd$export$93883786cf4a4a27),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$93883786cf4a4a27]
    },
    emptyInputScopeSetError: {
        code: (0, $4c3d14616baac1bd$export$41e2ce5958c42c83),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$41e2ce5958c42c83]
    },
    DeviceCodePollingCancelled: {
        code: (0, $4c3d14616baac1bd$export$e3af42f9856ab2a),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$e3af42f9856ab2a]
    },
    DeviceCodeExpired: {
        code: (0, $4c3d14616baac1bd$export$c0ef55deeb5e30d5),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$c0ef55deeb5e30d5]
    },
    DeviceCodeUnknownError: {
        code: (0, $4c3d14616baac1bd$export$4a9e9cce395ba70c),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$4a9e9cce395ba70c]
    },
    NoAccountInSilentRequest: {
        code: (0, $4c3d14616baac1bd$export$5a3c7d1c90ac9220),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$5a3c7d1c90ac9220]
    },
    invalidCacheRecord: {
        code: (0, $4c3d14616baac1bd$export$d396103576f879cc),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$d396103576f879cc]
    },
    invalidCacheEnvironment: {
        code: (0, $4c3d14616baac1bd$export$dedc648643245fa1),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$dedc648643245fa1]
    },
    noAccountFound: {
        code: (0, $4c3d14616baac1bd$export$b98ebfe073f0162f),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$b98ebfe073f0162f]
    },
    noCryptoObj: {
        code: (0, $4c3d14616baac1bd$export$c39e501a22cba395),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$c39e501a22cba395]
    },
    unexpectedCredentialType: {
        code: (0, $4c3d14616baac1bd$export$21fdd1f95350cd6d),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$21fdd1f95350cd6d]
    },
    invalidAssertion: {
        code: (0, $4c3d14616baac1bd$export$e168896c692fb06b),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$e168896c692fb06b]
    },
    invalidClientCredential: {
        code: (0, $4c3d14616baac1bd$export$c483ba88a47982b1),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$c483ba88a47982b1]
    },
    tokenRefreshRequired: {
        code: (0, $4c3d14616baac1bd$export$e23b692cce0c7779),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$e23b692cce0c7779]
    },
    userTimeoutReached: {
        code: (0, $4c3d14616baac1bd$export$afbb99ff17e87b86),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$afbb99ff17e87b86]
    },
    tokenClaimsRequired: {
        code: (0, $4c3d14616baac1bd$export$6f89b8a7d491b526),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$6f89b8a7d491b526]
    },
    noAuthorizationCodeFromServer: {
        code: (0, $4c3d14616baac1bd$export$93625fc864d26bba),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$93625fc864d26bba]
    },
    bindingKeyNotRemovedError: {
        code: (0, $4c3d14616baac1bd$export$5765db5d84418d29),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$5765db5d84418d29]
    },
    logoutNotSupported: {
        code: (0, $4c3d14616baac1bd$export$c3bd741c16a889f3),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$c3bd741c16a889f3]
    },
    keyIdMissing: {
        code: (0, $4c3d14616baac1bd$export$3c9338a50e294d1),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$3c9338a50e294d1]
    },
    noNetworkConnectivity: {
        code: (0, $4c3d14616baac1bd$export$31ae862f18c3b2b7),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$31ae862f18c3b2b7]
    },
    userCanceledError: {
        code: (0, $4c3d14616baac1bd$export$8ee329e65a880ec7),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$8ee329e65a880ec7]
    },
    missingTenantIdError: {
        code: (0, $4c3d14616baac1bd$export$8c321d057617a458),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$8c321d057617a458]
    },
    nestedAppAuthBridgeDisabled: {
        code: (0, $4c3d14616baac1bd$export$3078b0202fe7eea3),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$3078b0202fe7eea3]
    },
    platformBrokerError: {
        code: (0, $4c3d14616baac1bd$export$3642667d172bf3ce),
        desc: $0114b0a218ba15f8$export$8190ec70cbf7ec08[0, $4c3d14616baac1bd$export$3642667d172bf3ce]
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $0114b0a218ba15f8$export$a839ff85a7957561 extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, additionalMessage){
        super(errorCode, additionalMessage ? `${$0114b0a218ba15f8$export$8190ec70cbf7ec08[errorCode]}: ${additionalMessage}` : $0114b0a218ba15f8$export$8190ec70cbf7ec08[errorCode]);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $0114b0a218ba15f8$export$a839ff85a7957561.prototype);
    }
}
function $0114b0a218ba15f8$export$ea892ce48f5bb4f3(errorCode, additionalMessage) {
    return new $0114b0a218ba15f8$export$a839ff85a7957561(errorCode, additionalMessage);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $487fc5d1c5f0967c$export$865f57d401606752 = {
    createNewGuid: ()=>{
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    base64Decode: ()=>{
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    base64Encode: ()=>{
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    base64UrlEncode: ()=>{
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    encodeKid: ()=>{
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    async getPublicKeyThumbprint () {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    async removeTokenBindingKey () {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    async clearKeystore () {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    async signJwt () {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    async hashString () {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
};




/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/* eslint-disable header/header */ const $a9bd283efb93627c$export$a8ff84c12d48cfa6 = "@azure/msal-common";
const $a9bd283efb93627c$export$83d89fbfd8236492 = "15.13.3";



/*! @azure/msal-common v15.13.3 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $95ac7d904346f305$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ static matchPattern(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?"));
        return regex.test(input);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $3840a7b7d2141fd6$export$b9b82b0f94ae1f99 {
    constructor(inputScopes){
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, $95ac7d904346f305$export$ecc754f99843e759).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, $95ac7d904346f305$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Check if scopes array has at least one member
        if (!filteredInput || !filteredInput.length) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$6ac27379c42383f));
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString) {
        const scopeString = inputScopeString || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        const inputScopes = scopeString.split(" ");
        return new $3840a7b7d2141fd6$export$b9b82b0f94ae1f99(inputScopes);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString) {
        // Handle empty scopes by using default OIDC scopes for cache lookup
        const scopesToUse = inputScopeString && inputScopeString.length > 0 ? inputScopeString : [
            ...(0, $6c5f3cda7e712574$export$893b1b5b686d84ef)
        ];
        const scopeSet = new $3840a7b7d2141fd6$export$b9b82b0f94ae1f99(scopesToUse);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $6c5f3cda7e712574$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $3840a7b7d2141fd6$export$b9b82b0f94ae1f99(lowerCaseScopes);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, $6c5f3cda7e712574$export$268e88275f5afab2).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$93883786cf4a4a27));
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$f7a276c01beb068a));
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, $6c5f3cda7e712574$export$268e88275f5afab2).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$41e2ce5958c42c83));
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$41e2ce5958c42c83));
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $51de415de522dc09$export$575e1419cfbab7f8(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$12315251e24e0181));
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$ccdf48c387c47b82));
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $51de415de522dc09$export$63508a6d6b7dbe07(homeAccountId) {
    if (!homeAccountId) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$ccdf48c387c47b82));
    const clientInfoParts = homeAccountId.split((0, $6c5f3cda7e712574$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $d08229a94d11167d$export$bc62fd222eddc2d7(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $d08229a94d11167d$export$924857724cb21ba4(homeAccountId, localAccountId, tenantId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr, preferred_username: preferred_username, upn: upn, login_hint: login_hint } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            username: preferred_username || upn || "",
            loginHint: login_hint,
            isHomeTenant: $d08229a94d11167d$export$bc62fd222eddc2d7(tenantId, homeAccountId)
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        username: "",
        isHomeTenant: $d08229a94d11167d$export$bc62fd222eddc2d7(tenantId, homeAccountId)
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $d08229a94d11167d$export$452a054c78b83dad(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant, loginHint, and sid which are part of tenant profile but not base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $d08229a94d11167d$export$924857724cb21ba4(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}



/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $e4974a8758ed20fc$export$cd82032b224a3839 = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};


/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $01daa942f7822733$export$8e1decb9a5e2932(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $54a6ab7df522528c$export$73a3e3dedd37150d = {
    /**
     * Auth Code + PKCE with Entra ID (formerly AAD) specific optimizations and features
     */ AAD: "AAD",
    /**
     * Auth Code + PKCE without Entra ID specific optimizations and features. For use only with non-Microsoft owned authorities.
     * Support is limited for this mode.
     */ OIDC: "OIDC",
    /**
     * Encrypted Authorize Response (EAR) with Entra ID specific optimizations and features
     */ EAR: "EAR"
};



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      nativeAccountId: Account identifier on the native device
 *      tenantProfiles: Array of tenant profile objects for each tenant that the account has authenticated with in the browser
 * }
 * @internal
 */ class $b16513504135b2c0$export$680160523e6bfa6a {
    /**
     * Returns the AccountInfo interface for this account.
     */ static getAccountInfo(accountEntity) {
        return {
            homeAccountId: accountEntity.homeAccountId,
            environment: accountEntity.environment,
            tenantId: accountEntity.realm,
            username: accountEntity.username,
            localAccountId: accountEntity.localAccountId,
            loginHint: accountEntity.loginHint,
            name: accountEntity.name,
            nativeAccountId: accountEntity.nativeAccountId,
            authorityType: accountEntity.authorityType,
            // Deserialize tenant profiles array into a Map
            tenantProfiles: new Map((accountEntity.tenantProfiles || []).map((tenantProfile)=>{
                return [
                    tenantProfile.tenantId,
                    tenantProfile
                ];
            })),
            dataBoundary: accountEntity.dataBoundary
        };
    }
    /**
     * Returns true if the account entity is in single tenant format (outdated), false otherwise
     */ isSingleTenant() {
        return !this.tenantProfiles;
    }
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param accountDetails
     */ static createAccount(accountDetails, authority, base64Decode) {
        const account = new $b16513504135b2c0$export$680160523e6bfa6a();
        if (authority.authorityType === (0, $e4974a8758ed20fc$export$cd82032b224a3839).Adfs) account.authorityType = (0, $6c5f3cda7e712574$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE;
        else if (authority.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC) account.authorityType = (0, $6c5f3cda7e712574$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        else account.authorityType = (0, $6c5f3cda7e712574$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        let clientInfo;
        if (accountDetails.clientInfo && base64Decode) {
            clientInfo = (0, $51de415de522dc09$export$575e1419cfbab7f8)(accountDetails.clientInfo, base64Decode);
            if (clientInfo.xms_tdbr) account.dataBoundary = clientInfo.xms_tdbr === "EU" ? "EU" : "None";
        }
        account.clientInfo = accountDetails.clientInfo;
        account.homeAccountId = accountDetails.homeAccountId;
        account.nativeAccountId = accountDetails.nativeAccountId;
        const env = accountDetails.environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$dedc648643245fa1));
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = clientInfo?.utid || (0, $01daa942f7822733$export$8e1decb9a5e2932)(accountDetails.idTokenClaims) || "";
        // How do you account for MSA CID here?
        account.localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
        const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
        account.username = preferredUsername || email || "";
        account.loginHint = accountDetails.idTokenClaims?.login_hint;
        account.name = accountDetails.idTokenClaims?.name || "";
        account.cloudGraphHostName = accountDetails.cloudGraphHostName;
        account.msGraphHost = accountDetails.msGraphHost;
        if (accountDetails.tenantProfiles) account.tenantProfiles = accountDetails.tenantProfiles;
        else {
            const tenantProfile = (0, $d08229a94d11167d$export$924857724cb21ba4)(accountDetails.homeAccountId, account.localAccountId, account.realm, accountDetails.idTokenClaims);
            account.tenantProfiles = [
                tenantProfile
            ];
        }
        return account;
    }
    /**
     * Creates an AccountEntity object from AccountInfo
     * @param accountInfo
     * @param cloudGraphHostName
     * @param msGraphHost
     * @returns
     */ static createFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
        const account = new $b16513504135b2c0$export$680160523e6bfa6a();
        account.authorityType = accountInfo.authorityType || (0, $6c5f3cda7e712574$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = accountInfo.homeAccountId;
        account.localAccountId = accountInfo.localAccountId;
        account.nativeAccountId = accountInfo.nativeAccountId;
        account.realm = accountInfo.tenantId;
        account.environment = accountInfo.environment;
        account.username = accountInfo.username;
        account.name = accountInfo.name;
        account.loginHint = accountInfo.loginHint;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        // Serialize tenant profiles map into an array
        account.tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
        account.dataBoundary = accountInfo.dataBoundary;
        return account;
    }
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ static generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, idTokenClaims) {
        // since ADFS/DSTS do not have tid and does not set client_info
        if (!(authType === (0, $e4974a8758ed20fc$export$cd82032b224a3839).Adfs || authType === (0, $e4974a8758ed20fc$export$cd82032b224a3839).Dsts)) {
            // for cases where there is clientInfo
            if (serverClientInfo) try {
                const clientInfo = (0, $51de415de522dc09$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj.base64Decode);
                if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
            } catch (e) {}
            logger.warning("No client info in response");
        }
        // default to "sub" claim
        return idTokenClaims?.sub || "";
    }
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ static isAccountEntity(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    }
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ static accountInfoIsEqual(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        let claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            const accountAClaims = accountA.idTokenClaims || {};
            const accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.loginHint === accountB.loginHint && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    }
}




var $4f8cb1da78e4daf9$exports = {};

$parcel$export($4f8cb1da78e4daf9$exports, "extractTokenClaims", () => $4f8cb1da78e4daf9$export$8a59e6f35fb00518);
$parcel$export($4f8cb1da78e4daf9$exports, "getJWSPayload", () => $4f8cb1da78e4daf9$export$b9f318d6daf53c97);
$parcel$export($4f8cb1da78e4daf9$exports, "isKmsi", () => $4f8cb1da78e4daf9$export$9475d607926d7a45);
$parcel$export($4f8cb1da78e4daf9$exports, "checkMaxAge", () => $4f8cb1da78e4daf9$export$ee7a34ea7880144c);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $4f8cb1da78e4daf9$export$8a59e6f35fb00518(encodedToken, base64Decode) {
    const jswPayload = $4f8cb1da78e4daf9$export$b9f318d6daf53c97(encodedToken);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$ad362b2e3a260143));
    }
}
/**
 * Check if the signin_state claim contains "kmsi"
 * @param idTokenClaims
 * @returns
 */ function $4f8cb1da78e4daf9$export$9475d607926d7a45(idTokenClaims) {
    if (!idTokenClaims.signin_state) return false;
    /**
     * Signin_state claim known values:
     * dvc_mngd - device is managed
     * dvc_dmjd - device is domain joined
     * kmsi - user opted to "keep me signed in"
     * inknownntwk - Request made inside a known network. Don't use this, use CAE instead.
     */ const kmsiClaims = [
        "kmsi",
        "dvc_dmjd"
    ]; // There are some cases where kmsi may not be returned but persistent storage is still OK - allow dvc_dmjd as well
    const kmsi = idTokenClaims.signin_state.some((value)=>kmsiClaims.includes(value.trim().toLowerCase()));
    return kmsi;
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $4f8cb1da78e4daf9$export$b9f318d6daf53c97(authToken) {
    if (!authToken) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$78d01e29cb494be2));
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$ad362b2e3a260143));
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/**
 * Determine if the token's max_age has transpired
 */ function $4f8cb1da78e4daf9$export$ee7a34ea7880144c(authTime, maxAge) {
    /*
     * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
     * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
     */ const fiveMinuteSkew = 300000; // five minutes in milliseconds
    if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$f95fb86904f89749));
}



/*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 


var $2bfa541b563305f9$exports = {};

$parcel$export($2bfa541b563305f9$exports, "stripLeadingHashOrQuery", () => $2bfa541b563305f9$export$fe89dd256736a6b3);
$parcel$export($2bfa541b563305f9$exports, "getDeserializedResponse", () => $2bfa541b563305f9$export$f98e0976781b1204);
$parcel$export($2bfa541b563305f9$exports, "mapToQueryString", () => $2bfa541b563305f9$export$44d4663acf79cde2);
$parcel$export($2bfa541b563305f9$exports, "normalizeUrlForComparison", () => $2bfa541b563305f9$export$d87ce1a4b7c183c8);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Canonicalizes a URL by making it lowercase and ensuring it ends with /
 * Inlined version of UrlString.canonicalizeUri to avoid circular dependency
 * @param url - URL to canonicalize
 * @returns Canonicalized URL
 */ function $2bfa541b563305f9$var$canonicalizeUrl(url) {
    if (!url) return url;
    let lowerCaseUrl = url.toLowerCase();
    if ((0, $95ac7d904346f305$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
    else if ((0, $95ac7d904346f305$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
    if (!(0, $95ac7d904346f305$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
    return lowerCaseUrl;
}
/**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $2bfa541b563305f9$export$fe89dd256736a6b3(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $2bfa541b563305f9$export$f98e0976781b1204(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $2bfa541b563305f9$export$fe89dd256736a6b3(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.ear_jwe || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$14c4d54a8414667f));
    }
    return null;
}
/**
 * Utility to create a URL from the params map
 */ function $2bfa541b563305f9$export$44d4663acf79cde2(parameters, encodeExtraParams = true, extraQueryParameters) {
    const queryParameterArray = new Array();
    parameters.forEach((value, key)=>{
        if (!encodeExtraParams && extraQueryParameters && key in extraQueryParameters) queryParameterArray.push(`${key}=${value}`);
        else queryParameterArray.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParameterArray.join("&");
}
/**
 * Normalizes URLs for comparison by removing hash, canonicalizing,
 * and ensuring consistent URL encoding in query parameters.
 * This fixes redirect loops when URLs contain encoded characters like apostrophes (%27).
 * @param url - URL to normalize
 * @returns Normalized URL string for comparison
 */ function $2bfa541b563305f9$export$d87ce1a4b7c183c8(url) {
    if (!url) return url;
    // Remove hash first
    const urlWithoutHash = url.split("#")[0];
    try {
        // Parse the URL to handle encoding consistently
        const urlObj = new URL(urlWithoutHash);
        /*
         * Reconstruct the URL with properly decoded query parameters
         * This ensures that %27 and ' are treated as equivalent
         */ const normalizedUrl = urlObj.origin + urlObj.pathname + urlObj.search;
        // Apply canonicalization logic inline to avoid circular dependency
        return $2bfa541b563305f9$var$canonicalizeUrl(normalizedUrl);
    } catch (e) {
        // Fallback to original logic if URL parsing fails
        return $2bfa541b563305f9$var$canonicalizeUrl(urlWithoutHash);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $7c3562667cdabc20$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url){
        this._urlString = url;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$859df485a5e0f239));
        if (!url.includes("#")) this._urlString = $7c3562667cdabc20$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $95ac7d904346f305$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $95ac7d904346f305$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $95ac7d904346f305$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$ee2a1a3389f75508));
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$ee2a1a3389f75508));
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$f77c6af656c8444b));
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $7c3562667cdabc20$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $6c5f3cda7e712574$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $6c5f3cda7e712574$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $7c3562667cdabc20$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$ee2a1a3389f75508));
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$ee2a1a3389f75508));
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $6c5f3cda7e712574$export$a002182e51710d39).FORWARD_SLASH) {
            const url = new $7c3562667cdabc20$export$3abcdca7229e54f2(baseUrl);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject) {
        return new $7c3562667cdabc20$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    }
    /**
     * Check if the hash of the URL string contains known properties
     * @deprecated This API will be removed in a future version
     */ static hashContainsKnownProperties(response) {
        return !!(0, $2bfa541b563305f9$export$f98e0976781b1204)(response);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a59d185da4abcbb3$export$223f43dfec89cb87 = {
    endpointMetadata: {
        "login.microsoftonline.com": {
            token_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.com/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.com/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/logout"
        },
        "login.chinacloudapi.cn": {
            token_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.chinacloudapi.cn/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            authorization_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/logout"
        },
        "login.microsoftonline.us": {
            token_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.us/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.us/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/logout"
        }
    },
    instanceDiscoveryMetadata: {
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            }
        ]
    }
};
const $a59d185da4abcbb3$export$f612854287391207 = $a59d185da4abcbb3$export$223f43dfec89cb87.endpointMetadata;
const $a59d185da4abcbb3$export$a21acafc3b6f5582 = $a59d185da4abcbb3$export$223f43dfec89cb87.instanceDiscoveryMetadata;
const $a59d185da4abcbb3$export$7d026f079148cd31 = new Set();
$a59d185da4abcbb3$export$a21acafc3b6f5582.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $a59d185da4abcbb3$export$7d026f079148cd31.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $a59d185da4abcbb3$export$2c21adf4b4d4efc0(staticAuthorityOptions, logger) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(canonicalAuthority).getUrlComponents().HostNameAndPort;
        staticAliases = $a59d185da4abcbb3$export$d195904946de56a1(authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).CONFIG, logger) || $a59d185da4abcbb3$export$d195904946de56a1(authorityHost, $a59d185da4abcbb3$export$a21acafc3b6f5582.metadata, (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).HARDCODED_VALUES, logger) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $a59d185da4abcbb3$export$d195904946de56a1(authorityHost, cloudDiscoveryMetadata, source, logger) {
    logger?.trace(`getAliasesFromMetadata called with source: ${source}`);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $a59d185da4abcbb3$export$6e21098ea6e60dc(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger?.trace(`getAliasesFromMetadata: found cloud discovery metadata in ${source}, returning aliases`);
            return metadata.aliases;
        } else logger?.trace(`getAliasesFromMetadata: did not find cloud discovery metadata in ${source}`);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $a59d185da4abcbb3$export$1b1433f93c9873f(authorityHost) {
    const metadata = $a59d185da4abcbb3$export$6e21098ea6e60dc($a59d185da4abcbb3$export$a21acafc3b6f5582.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $a59d185da4abcbb3$export$6e21098ea6e60dc(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 
var $6e7371d16fb9bd24$exports = {};

$parcel$export($6e7371d16fb9bd24$exports, "cacheQuotaExceeded", () => $6e7371d16fb9bd24$export$e55c8be2f026d30a);
$parcel$export($6e7371d16fb9bd24$exports, "cacheErrorUnknown", () => $6e7371d16fb9bd24$export$6f650427f72a7890);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6e7371d16fb9bd24$export$e55c8be2f026d30a = "cache_quota_exceeded";
const $6e7371d16fb9bd24$export$6f650427f72a7890 = "cache_error_unknown";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a5bb7e4c0fc3284b$export$7ab11f0b2c87dadd = {
    [(0, $6e7371d16fb9bd24$export$e55c8be2f026d30a)]: "Exceeded cache storage capacity.",
    [(0, $6e7371d16fb9bd24$export$6f650427f72a7890)]: "Unexpected error occurred when using cache storage."
};
/**
 * Error thrown when there is an error with the cache
 */ class $a5bb7e4c0fc3284b$export$78ff06e91c3de382 extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        const message = errorMessage || ($a5bb7e4c0fc3284b$export$7ab11f0b2c87dadd[errorCode] ? $a5bb7e4c0fc3284b$export$7ab11f0b2c87dadd[errorCode] : $a5bb7e4c0fc3284b$export$7ab11f0b2c87dadd[0, $6e7371d16fb9bd24$export$6f650427f72a7890]);
        super(`${errorCode}: ${message}`);
        Object.setPrototypeOf(this, $a5bb7e4c0fc3284b$export$78ff06e91c3de382.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function $a5bb7e4c0fc3284b$export$2056718aee1b1d88(e) {
    if (!(e instanceof Error)) return new $a5bb7e4c0fc3284b$export$78ff06e91c3de382((0, $6e7371d16fb9bd24$export$6f650427f72a7890));
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new $a5bb7e4c0fc3284b$export$78ff06e91c3de382((0, $6e7371d16fb9bd24$export$e55c8be2f026d30a));
    else return new $a5bb7e4c0fc3284b$export$78ff06e91c3de382(e.name, e.message);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $6d50c43f626b7d71$export$996e3ea69314b5c6 {
    constructor(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $a9bd283efb93627c$export$a8ff84c12d48cfa6), (0, $a9bd283efb93627c$export$83d89fbfd8236492));
        this.staticAuthorityOptions = staticAuthorityOptions;
        this.performanceClient = performanceClient;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter, correlationId) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        if (Object.keys(accountFilter).length === 0 || Object.values(accountFilter).every((value)=>!value)) {
            this.commonLogger.warning("getAccountInfoFilteredBy: Account filter is empty or invalid, returning null");
            return null;
        }
        const allAccounts = this.getAllAccounts(accountFilter, correlationId);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((account)=>{
                return account.idTokenClaims ? -1 : 1;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return (0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(accountEntities[0]);
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, $4f8cb1da78e4daf9$export$8a59e6f35fb00518)(idToken.secret, this.cryptoImpl.base64Decode);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, $d08229a94d11167d$export$452a054c78b83dad)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = (0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(accountEntity);
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param correlationId {?string} correlation id
     * @param kmsi - Keep Me Signed In
     * @param storeInCache {?StoreInCache}
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, storeInCache) {
        if (!cacheRecord) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$d396103576f879cc));
        try {
            if (!!cacheRecord.account) await this.setAccount(cacheRecord.account, correlationId, kmsi);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) await this.setIdTokenCredential(cacheRecord.idToken, correlationId, kmsi);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId, kmsi);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) await this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId, kmsi);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error(`CacheManager.saveCacheRecord: failed`);
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) throw e;
            else throw (0, $a5bb7e4c0fc3284b$export$2056718aee1b1d88)(e);
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential, correlationId, kmsi) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType,
            requestedClaimsHash: credential.requestedClaimsHash
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(credential.target);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                const tokenScopeSet = (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        await this.setAccessTokenCredential(credential, correlationId, kmsi);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            const entity = this.getAccount(cacheKey, correlationId);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.username && !this.matchUsername(entity.username, accountFilter.username)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ credentialMatchesFilter(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $6c5f3cda7e712574$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ getAppMetadataFilteredBy(filter) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ getAuthorityMetadataByAlias(host) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ removeAllAccounts(correlationId) {
        const accounts = this.getAllAccounts({}, correlationId);
        accounts.forEach((account)=>{
            this.removeAccount(account, correlationId);
        });
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ removeAccount(account, correlationId) {
        this.removeAccountContext(account, correlationId);
        const accountKeys = this.getAccountKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        accountKeys.filter(keyFilter).forEach((key)=>{
            this.removeItem(key, correlationId);
            this.performanceClient.incrementFields({
                accountsRemoved: 1
            }, correlationId);
        });
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        allTokenKeys.idToken.filter(keyFilter).forEach((key)=>{
            this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.filter(keyFilter).forEach((key)=>{
            this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.filter(keyFilter).forEach((key)=>{
            this.removeRefreshToken(key, correlationId);
        });
    }
    /**
     * Removes accessToken from the cache
     * @param key
     * @param correlationId
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        this.removeItem(key, correlationId);
        this.performanceClient.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        if (!credential || credential.credentialType.toLowerCase() !== (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase() || credential.tokenType !== (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP) // If the credential is not a PoP token, we can return
        return;
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        const kid = credential.keyId;
        if (kid) this.cryptoImpl.removeTokenBindingKey(kid).catch(()=>{
            this.commonLogger.error(`Failed to remove token binding key ${kid}`, correlationId);
            this.performanceClient?.incrementFields({
                removeTokenBindingKeyFailure: 1
            }, correlationId);
        });
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm, performanceClient) {
        this.commonLogger.trace("CacheManager - getIdToken called");
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account but none match account entity tenant id, returning first result");
                    return idTokenMap.values().next().value;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account, defaulting to home tenant profile");
                    return homeIdTokenMap.values().next().value;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("CacheManager:getIdToken - Multiple matching ID tokens found, clearing them");
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning ID token");
        return idTokenMap.values().next().value;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param correlationId {?string}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getAccessToken(account, request, tokenKeys, targetRealm) {
        const correlationId = request.correlationId;
        this.commonLogger.trace("CacheManager - getAccessToken called", correlationId);
        const scopes = (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        const authScheme = request.authenticationScheme || (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found", correlationId);
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them", correlationId);
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken(this.generateCredentialKey(accessToken), correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token", correlationId);
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param correlationId {?string}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys, performanceClient) {
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        const id = familyRT ? (0, $6c5f3cda7e712574$export$978fe7ab5e74b539) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1 && performanceClient && correlationId) performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$575bb2924bcd0084));
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment) {
        const appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $6c5f3cda7e712574$export$978fe7ab5e74b539));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, $a59d185da4abcbb3$export$2c21adf4b4d4efc0)(this.staticAuthorityOptions, this.commonLogger);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ matchNativeAccountId(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, $6c5f3cda7e712574$export$7e1bea6dc1b6b32e)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, $6c5f3cda7e712574$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${(0, $6c5f3cda7e712574$export$d483f966e66f4db5).CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $6d50c43f626b7d71$export$b7254d304b3004b6 extends $6d50c43f626b7d71$export$996e3ea69314b5c6 {
    async setAccount() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getAccount() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    async setIdTokenCredential() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getIdTokenCredential() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    async setAccessTokenCredential() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getAccessTokenCredential() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    async setRefreshTokenCredential() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getRefreshTokenCredential() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    setAppMetadata() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getAppMetadata() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    setServerTelemetry() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getServerTelemetry() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    setAuthorityMetadata() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getAuthorityMetadata() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getAuthorityMetadataKeys() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    setThrottlingCache() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getThrottlingCache() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    removeItem() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getKeys() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getAccountKeys() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    getTokenKeys() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    generateCredentialKey() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
    generateAccountKey() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
}




/*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ const $978df372b022f65e$export$2f2811a3e1b21823 = {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ AcquireTokenByCode: "acquireTokenByCode",
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ AcquireTokenByRefreshToken: "acquireTokenByRefreshToken",
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ AcquireTokenSilent: "acquireTokenSilent",
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ AcquireTokenSilentAsync: "acquireTokenSilentAsync",
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ AcquireTokenPopup: "acquireTokenPopup",
    /**
     * acquireTokenPreRedirect (msal-browser).
     * First part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenPreRedirect: "acquireTokenPreRedirect",
    /**
     * acquireTokenRedirect (msal-browser).
     * Second part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenRedirect: "acquireTokenRedirect",
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ CryptoOptsGetPublicKeyThumbprint: "cryptoOptsGetPublicKeyThumbprint",
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ CryptoOptsSignJwt: "cryptoOptsSignJwt",
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ SilentCacheClientAcquireToken: "silentCacheClientAcquireToken",
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ SilentIframeClientAcquireToken: "silentIframeClientAcquireToken",
    AwaitConcurrentIframe: "awaitConcurrentIframe",
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ SilentRefreshClientAcquireToken: "silentRefreshClientAcquireToken",
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ SsoSilent: "ssoSilent",
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ StandardInteractionClientGetDiscoveredAuthority: "standardInteractionClientGetDiscoveredAuthority",
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ FetchAccountIdWithNativeBroker: "fetchAccountIdWithNativeBroker",
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ NativeInteractionClientAcquireToken: "nativeInteractionClientAcquireToken",
    /**
     * Time spent creating default headers for requests to token endpoint
     */ BaseClientCreateTokenRequestHeaders: "baseClientCreateTokenRequestHeaders",
    /**
     * Time spent sending/waiting for the response of a request to the token endpoint
     */ NetworkClientSendPostRequestAsync: "networkClientSendPostRequestAsync",
    RefreshTokenClientExecutePostToTokenEndpoint: "refreshTokenClientExecutePostToTokenEndpoint",
    AuthorizationCodeClientExecutePostToTokenEndpoint: "authorizationCodeClientExecutePostToTokenEndpoint",
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ BrokerHandhshake: "brokerHandshake",
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ AcquireTokenByRefreshTokenInBroker: "acquireTokenByRefreshTokenInBroker",
    /**
     * Time taken for token acquisition by broker
     */ AcquireTokenByBroker: "acquireTokenByBroker",
    /**
     * Time spent on the network for refresh token acquisition
     */ RefreshTokenClientExecuteTokenRequest: "refreshTokenClientExecuteTokenRequest",
    /**
     * Time taken for acquiring refresh token , records RT size
     */ RefreshTokenClientAcquireToken: "refreshTokenClientAcquireToken",
    /**
     * Time taken for acquiring cached refresh token
     */ RefreshTokenClientAcquireTokenWithCachedRefreshToken: "refreshTokenClientAcquireTokenWithCachedRefreshToken",
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ RefreshTokenClientAcquireTokenByRefreshToken: "refreshTokenClientAcquireTokenByRefreshToken",
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ RefreshTokenClientCreateTokenRequestBody: "refreshTokenClientCreateTokenRequestBody",
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ AcquireTokenFromCache: "acquireTokenFromCache",
    SilentFlowClientAcquireCachedToken: "silentFlowClientAcquireCachedToken",
    SilentFlowClientGenerateResultFromCacheRecord: "silentFlowClientGenerateResultFromCacheRecord",
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ AcquireTokenBySilentIframe: "acquireTokenBySilentIframe",
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ InitializeBaseRequest: "initializeBaseRequest",
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ InitializeSilentRequest: "initializeSilentRequest",
    InitializeClientApplication: "initializeClientApplication",
    InitializeCache: "initializeCache",
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ SilentIframeClientTokenHelper: "silentIframeClientTokenHelper",
    /**
     * SilentHandler
     */ SilentHandlerInitiateAuthRequest: "silentHandlerInitiateAuthRequest",
    SilentHandlerMonitorIframeForHash: "silentHandlerMonitorIframeForHash",
    SilentHandlerLoadFrame: "silentHandlerLoadFrame",
    SilentHandlerLoadFrameSync: "silentHandlerLoadFrameSync",
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ StandardInteractionClientCreateAuthCodeClient: "standardInteractionClientCreateAuthCodeClient",
    StandardInteractionClientGetClientConfiguration: "standardInteractionClientGetClientConfiguration",
    StandardInteractionClientInitializeAuthorizationRequest: "standardInteractionClientInitializeAuthorizationRequest",
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ GetAuthCodeUrl: "getAuthCodeUrl",
    GetStandardParams: "getStandardParams",
    /**
     * Functions from InteractionHandler (msal-browser)
     */ HandleCodeResponseFromServer: "handleCodeResponseFromServer",
    HandleCodeResponse: "handleCodeResponse",
    HandleResponseEar: "handleResponseEar",
    HandleResponsePlatformBroker: "handleResponsePlatformBroker",
    HandleResponseCode: "handleResponseCode",
    UpdateTokenEndpointAuthority: "updateTokenEndpointAuthority",
    /**
     * APIs in Authorization Code Client (msal-common)
     */ AuthClientAcquireToken: "authClientAcquireToken",
    AuthClientExecuteTokenRequest: "authClientExecuteTokenRequest",
    AuthClientCreateTokenRequestBody: "authClientCreateTokenRequestBody",
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PopTokenGenerateCnf: "popTokenGenerateCnf",
    PopTokenGenerateKid: "popTokenGenerateKid",
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ HandleServerTokenResponse: "handleServerTokenResponse",
    DeserializeResponse: "deserializeResponse",
    /**
     * Authority functions
     */ AuthorityFactoryCreateDiscoveredInstance: "authorityFactoryCreateDiscoveredInstance",
    AuthorityResolveEndpointsAsync: "authorityResolveEndpointsAsync",
    AuthorityResolveEndpointsFromLocalSources: "authorityResolveEndpointsFromLocalSources",
    AuthorityGetCloudDiscoveryMetadataFromNetwork: "authorityGetCloudDiscoveryMetadataFromNetwork",
    AuthorityUpdateCloudDiscoveryMetadata: "authorityUpdateCloudDiscoveryMetadata",
    AuthorityGetEndpointMetadataFromNetwork: "authorityGetEndpointMetadataFromNetwork",
    AuthorityUpdateEndpointMetadata: "authorityUpdateEndpointMetadata",
    AuthorityUpdateMetadataWithRegionalInformation: "authorityUpdateMetadataWithRegionalInformation",
    /**
     * Region Discovery functions
     */ RegionDiscoveryDetectRegion: "regionDiscoveryDetectRegion",
    RegionDiscoveryGetRegionFromIMDS: "regionDiscoveryGetRegionFromIMDS",
    RegionDiscoveryGetCurrentVersion: "regionDiscoveryGetCurrentVersion",
    AcquireTokenByCodeAsync: "acquireTokenByCodeAsync",
    GetEndpointMetadataFromNetwork: "getEndpointMetadataFromNetwork",
    GetCloudDiscoveryMetadataFromNetworkMeasurement: "getCloudDiscoveryMetadataFromNetworkMeasurement",
    HandleRedirectPromiseMeasurement: "handleRedirectPromise",
    HandleNativeRedirectPromiseMeasurement: "handleNativeRedirectPromise",
    UpdateCloudDiscoveryMetadataMeasurement: "updateCloudDiscoveryMetadataMeasurement",
    UsernamePasswordClientAcquireToken: "usernamePasswordClientAcquireToken",
    NativeMessageHandlerHandshake: "nativeMessageHandlerHandshake",
    NativeGenerateAuthResult: "nativeGenerateAuthResult",
    RemoveHiddenIframe: "removeHiddenIframe",
    /**
     * Cache operations
     */ ClearTokensAndKeysWithClaims: "clearTokensAndKeysWithClaims",
    CacheManagerGetRefreshToken: "cacheManagerGetRefreshToken",
    ImportExistingCache: "importExistingCache",
    SetUserData: "setUserData",
    LocalStorageUpdated: "localStorageUpdated",
    /**
     * Crypto Operations
     */ GeneratePkceCodes: "generatePkceCodes",
    GenerateCodeVerifier: "generateCodeVerifier",
    GenerateCodeChallengeFromVerifier: "generateCodeChallengeFromVerifier",
    Sha256Digest: "sha256Digest",
    GetRandomValues: "getRandomValues",
    GenerateHKDF: "generateHKDF",
    GenerateBaseKey: "generateBaseKey",
    Base64Decode: "base64Decode",
    UrlEncodeArr: "urlEncodeArr",
    Encrypt: "encrypt",
    Decrypt: "decrypt",
    GenerateEarKey: "generateEarKey",
    DecryptEarResponse: "decryptEarResponse"
};
const $978df372b022f65e$export$8dc198b6eb7c4c72 = new Map([
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenByCode,
        "ATByCode"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenByRefreshToken,
        "ATByRT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenSilent,
        "ATS"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenSilentAsync,
        "ATSAsync"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenPopup,
        "ATPopup"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenRedirect,
        "ATRedirect"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.CryptoOptsGetPublicKeyThumbprint,
        "CryptoGetPKThumb"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.CryptoOptsSignJwt,
        "CryptoSignJwt"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentCacheClientAcquireToken,
        "SltCacheClientAT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentIframeClientAcquireToken,
        "SltIframeClientAT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentRefreshClientAcquireToken,
        "SltRClientAT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SsoSilent,
        "SsoSlt"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.StandardInteractionClientGetDiscoveredAuthority,
        "StdIntClientGetDiscAuth"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.FetchAccountIdWithNativeBroker,
        "FetchAccIdWithNtvBroker"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.NativeInteractionClientAcquireToken,
        "NtvIntClientAT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.BaseClientCreateTokenRequestHeaders,
        "BaseClientCreateTReqHead"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.NetworkClientSendPostRequestAsync,
        "NetClientSendPost"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RefreshTokenClientExecutePostToTokenEndpoint,
        "RTClientExecPost"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorizationCodeClientExecutePostToTokenEndpoint,
        "AuthCodeClientExecPost"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.BrokerHandhshake,
        "BrokerHandshake"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenByRefreshTokenInBroker,
        "ATByRTInBroker"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenByBroker,
        "ATByBroker"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RefreshTokenClientExecuteTokenRequest,
        "RTClientExecTReq"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RefreshTokenClientAcquireToken,
        "RTClientAT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenWithCachedRefreshToken,
        "RTClientATWithCachedRT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenByRefreshToken,
        "RTClientATByRT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RefreshTokenClientCreateTokenRequestBody,
        "RTClientCreateTReqBody"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenFromCache,
        "ATFromCache"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentFlowClientAcquireCachedToken,
        "SltFlowClientATCached"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentFlowClientGenerateResultFromCacheRecord,
        "SltFlowClientGenResFromCache"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenBySilentIframe,
        "ATBySltIframe"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.InitializeBaseRequest,
        "InitBaseReq"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.InitializeSilentRequest,
        "InitSltReq"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.InitializeClientApplication,
        "InitClientApplication"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.InitializeCache,
        "InitCache"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.ImportExistingCache,
        "importCache"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SetUserData,
        "setUserData"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.LocalStorageUpdated,
        "localStorageUpdated"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentIframeClientTokenHelper,
        "SIClientTHelper"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentHandlerInitiateAuthRequest,
        "SHandlerInitAuthReq"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentHandlerMonitorIframeForHash,
        "SltHandlerMonitorIframeForHash"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentHandlerLoadFrame,
        "SHandlerLoadFrame"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.SilentHandlerLoadFrameSync,
        "SHandlerLoadFrameSync"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.StandardInteractionClientCreateAuthCodeClient,
        "StdIntClientCreateAuthCodeClient"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.StandardInteractionClientGetClientConfiguration,
        "StdIntClientGetClientConf"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationRequest,
        "StdIntClientInitAuthReq"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GetAuthCodeUrl,
        "GetAuthCodeUrl"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleCodeResponseFromServer,
        "HandleCodeResFromServer"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleCodeResponse,
        "HandleCodeResp"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleResponseEar,
        "HandleRespEar"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleResponseCode,
        "HandleRespCode"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleResponsePlatformBroker,
        "HandleRespPlatBroker"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.UpdateTokenEndpointAuthority,
        "UpdTEndpointAuth"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthClientAcquireToken,
        "AuthClientAT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthClientExecuteTokenRequest,
        "AuthClientExecTReq"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthClientCreateTokenRequestBody,
        "AuthClientCreateTReqBody"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.PopTokenGenerateCnf,
        "PopTGenCnf"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.PopTokenGenerateKid,
        "PopTGenKid"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleServerTokenResponse,
        "HandleServerTRes"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.DeserializeResponse,
        "DeserializeRes"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityFactoryCreateDiscoveredInstance,
        "AuthFactCreateDiscInst"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityResolveEndpointsAsync,
        "AuthResolveEndpointsAsync"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityResolveEndpointsFromLocalSources,
        "AuthResolveEndpointsFromLocal"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityGetCloudDiscoveryMetadataFromNetwork,
        "AuthGetCDMetaFromNet"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityUpdateCloudDiscoveryMetadata,
        "AuthUpdCDMeta"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityGetEndpointMetadataFromNetwork,
        "AuthUpdCDMetaFromNet"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityUpdateEndpointMetadata,
        "AuthUpdEndpointMeta"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AuthorityUpdateMetadataWithRegionalInformation,
        "AuthUpdMetaWithRegInfo"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RegionDiscoveryDetectRegion,
        "RegDiscDetectReg"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RegionDiscoveryGetRegionFromIMDS,
        "RegDiscGetRegFromIMDS"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RegionDiscoveryGetCurrentVersion,
        "RegDiscGetCurrentVer"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.AcquireTokenByCodeAsync,
        "ATByCodeAsync"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GetEndpointMetadataFromNetwork,
        "GetEndpointMetaFromNet"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GetCloudDiscoveryMetadataFromNetworkMeasurement,
        "GetCDMetaFromNet"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleRedirectPromiseMeasurement,
        "HandleRedirectPromise"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.HandleNativeRedirectPromiseMeasurement,
        "HandleNtvRedirectPromise"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.UpdateCloudDiscoveryMetadataMeasurement,
        "UpdateCDMeta"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.UsernamePasswordClientAcquireToken,
        "UserPassClientAT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.NativeMessageHandlerHandshake,
        "NtvMsgHandlerHandshake"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.NativeGenerateAuthResult,
        "NtvGenAuthRes"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.RemoveHiddenIframe,
        "RemoveHiddenIframe"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.ClearTokensAndKeysWithClaims,
        "ClearTAndKeysWithClaims"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.CacheManagerGetRefreshToken,
        "CacheManagerGetRT"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GeneratePkceCodes,
        "GenPkceCodes"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GenerateCodeVerifier,
        "GenCodeVerifier"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GenerateCodeChallengeFromVerifier,
        "GenCodeChallengeFromVerifier"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.Sha256Digest,
        "Sha256Digest"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GetRandomValues,
        "GetRandomValues"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GenerateHKDF,
        "genHKDF"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GenerateBaseKey,
        "genBaseKey"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.Base64Decode,
        "b64Decode"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.UrlEncodeArr,
        "urlEncArr"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.Encrypt,
        "encrypt"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.Decrypt,
        "decrypt"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.GenerateEarKey,
        "genEarKey"
    ],
    [
        $978df372b022f65e$export$2f2811a3e1b21823.DecryptEarResponse,
        "decryptEarResp"
    ]
]);
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $978df372b022f65e$export$bc3547c8ae7b1db = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
const $978df372b022f65e$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT",
    "unencryptedCacheCount",
    "encryptedCacheExpiredCount",
    "oldAccountCount",
    "oldAccessCount",
    "oldIdCount",
    "oldRefreshCount",
    "currAccountCount",
    "currAccessCount",
    "currIdCount",
    "currRefreshCount",
    "expiredCacheRemovedCount",
    "upgradedCacheCount"
]);


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $918248d5b9dc501b$export$647004217f4122f0 {
    startMeasurement() {
        return;
    }
    endMeasurement() {
        return;
    }
    flushMeasurement() {
        return null;
    }
}
class $918248d5b9dc501b$export$c70f2989a65fda3e {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, $978df372b022f65e$export$bc3547c8ae7b1db).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            },
            measurement: new $918248d5b9dc501b$export$647004217f4122f0()
        };
    }
    startPerformanceMeasurement() {
        return new $918248d5b9dc501b$export$647004217f4122f0();
    }
    calculateQueuedTime() {
        return 0;
    }
    addQueueMeasurement() {
        return;
    }
    setPreQueueTime() {
        return;
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8778110eec982731$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: (0, $6c5f3cda7e712574$export$8d50f42618161d1a),
    preventCorsPreflight: false
};
const $8778110eec982731$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d).Info,
    correlationId: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
};
const $8778110eec982731$var$DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: false
};
const $8778110eec982731$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    },
    async sendPostRequestAsync () {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22));
    }
};
const $8778110eec982731$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $6c5f3cda7e712574$export$a002182e51710d39).SKU,
    version: (0, $a9bd283efb93627c$export$83d89fbfd8236492),
    cpu: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
};
const $8778110eec982731$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
const $8778110eec982731$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $408770affa359606$export$4cda21933050d9ec).None,
    tenant: `${(0, $6c5f3cda7e712574$export$a002182e51710d39).DEFAULT_COMMON_TENANT}`
};
const $8778110eec982731$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $8778110eec982731$export$57a091701dcdabb2({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, cacheOptions: userCacheOptions, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$8778110eec982731$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: $8778110eec982731$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$8778110eec982731$export$f7a7dd6bfc156d75,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        cacheOptions: {
            ...$8778110eec982731$var$DEFAULT_CACHE_OPTIONS,
            ...userCacheOptions
        },
        storageInterface: storageImplementation || new (0, $6d50c43f626b7d71$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $487fc5d1c5f0967c$export$865f57d401606752), new (0, $9d8c7bd8b3e958dc$export$efa9a398d6368992)(loggerOptions), new (0, $918248d5b9dc501b$export$c70f2989a65fda3e)()),
        networkInterface: networkImplementation || $8778110eec982731$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $487fc5d1c5f0967c$export$865f57d401606752),
        clientCredentials: clientCredentials || $8778110eec982731$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$8778110eec982731$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$8778110eec982731$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $8778110eec982731$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $8778110eec982731$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false,
        instanceAware: false,
        encodeExtraQueryParams: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $8778110eec982731$export$25afa7198c2ed9b9(config) {
    return config.authOptions.authority.options.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC;
}

/*! @azure/msal-common v15.13.3 2025-12-04 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d9f4f8119f40a208$export$6d95060a8ed7155a = {
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22)));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$24176fc1f15eea22)));
    }
};


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $d94c9b6ecea78646$export$a0a689e4294b9880 = {
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $d94c9b6ecea78646$export$3ebdf53424883b5f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS",
    MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
    DOM_API_NAME: "DOM API",
    PLATFORM_DOM_APIS: "get-token-and-sign-out",
    PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
    PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
};
const $d94c9b6ecea78646$export$3536098be6c7dadb = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $d94c9b6ecea78646$export$573384e47a12d835 = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $d94c9b6ecea78646$export$c774c31b4c31da8 = {
    GET: "GET",
    POST: "POST"
};
const $d94c9b6ecea78646$export$dc1d3aa5f3837765 = {
    SIGNIN: "signin",
    SIGNOUT: "signout"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $d94c9b6ecea78646$export$21d55bedf0d269fb = {
    ORIGIN_URI: "request.origin",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    VERIFIER: "code.verifier",
    INTERACTION_STATUS_KEY: "interaction.status",
    NATIVE_REQUEST: "request.native"
};
/**
 * Cache keys stored in-memory
 */ const $d94c9b6ecea78646$export$8f546f90896bcfa9 = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */ const $d94c9b6ecea78646$export$192d74ad69b40705 = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var $d94c9b6ecea78646$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($d94c9b6ecea78646$export$4ec29255e7e7f68f || ($d94c9b6ecea78646$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $d94c9b6ecea78646$export$bec20eda0179362b = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when all login calls occuring
     */ Login: "login",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set for ssoSilent calls
     */ SsoSilent: "ssoSilent",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $d94c9b6ecea78646$export$7e12949cd6884193 = {
    scopes: (0, $6c5f3cda7e712574$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $d94c9b6ecea78646$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
const $d94c9b6ecea78646$export$8abb9de997bb4e44 = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $d94c9b6ecea78646$export$3c22ff8b64b8f565 = "msal.db";
const $d94c9b6ecea78646$export$6a9022b4c5fcea02 = 1;
const $d94c9b6ecea78646$export$9d785db034fb436f = `${$d94c9b6ecea78646$export$3c22ff8b64b8f565}.keys`;
const $d94c9b6ecea78646$export$4394baa7e922d42d = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $d94c9b6ecea78646$export$736180706fb122ee = [
    $d94c9b6ecea78646$export$4394baa7e922d42d.Default,
    $d94c9b6ecea78646$export$4394baa7e922d42d.Skip,
    $d94c9b6ecea78646$export$4394baa7e922d42d.RefreshTokenAndNetwork
];


/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-browser v4.27.0 2025-12-04 */ 
/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $32d5e65f31c9045a$export$ee549107fa376fc1 = "pkce_not_created";
const $32d5e65f31c9045a$export$2c031f99d3e081ff = "ear_jwk_empty";
const $32d5e65f31c9045a$export$b9f7c47ac4054f3d = "ear_jwe_empty";
const $32d5e65f31c9045a$export$6319761d10f0cc4c = "crypto_nonexistent";
const $32d5e65f31c9045a$export$be9285c64f247822 = "empty_navigate_uri";
const $32d5e65f31c9045a$export$a29c42a1dd414317 = "hash_empty_error";
const $32d5e65f31c9045a$export$211c8e8843a8d278 = "no_state_in_hash";
const $32d5e65f31c9045a$export$5743873a5ba5d124 = "hash_does_not_contain_known_properties";
const $32d5e65f31c9045a$export$237bdd0b913cb30c = "unable_to_parse_state";
const $32d5e65f31c9045a$export$499b1b95c97a1c75 = "state_interaction_type_mismatch";
const $32d5e65f31c9045a$export$2700dc1c133d227e = "interaction_in_progress";
const $32d5e65f31c9045a$export$f1b7091ee48d0b3e = "popup_window_error";
const $32d5e65f31c9045a$export$5e827e513523a576 = "empty_window_error";
const $32d5e65f31c9045a$export$6bae303c5e922702 = "user_cancelled";
const $32d5e65f31c9045a$export$e2e3374c08b8ef2a = "monitor_popup_timeout";
const $32d5e65f31c9045a$export$c8b6efb19551013d = "monitor_window_timeout";
const $32d5e65f31c9045a$export$9cc12eb574ceee30 = "redirect_in_iframe";
const $32d5e65f31c9045a$export$71bafc2814e56c09 = "block_iframe_reload";
const $32d5e65f31c9045a$export$c4a80c97d7b48f72 = "block_nested_popups";
const $32d5e65f31c9045a$export$6a76760db525f402 = "iframe_closed_prematurely";
const $32d5e65f31c9045a$export$78523a40be105a03 = "silent_logout_unsupported";
const $32d5e65f31c9045a$export$87933d7d4116cb12 = "no_account_error";
const $32d5e65f31c9045a$export$24dae796d0958d3 = "silent_prompt_value_error";
const $32d5e65f31c9045a$export$8b51939fb2aab3d7 = "no_token_request_cache_error";
const $32d5e65f31c9045a$export$f3ae24cdfaab4488 = "unable_to_parse_token_request_cache_error";
const $32d5e65f31c9045a$export$c47649cf6408c7b2 = "auth_request_not_set_error";
const $32d5e65f31c9045a$export$ff7164a2aeeff392 = "invalid_cache_type";
const $32d5e65f31c9045a$export$932e0f52d657f7fb = "non_browser_environment";
const $32d5e65f31c9045a$export$4752ced1a1a262f = "database_not_open";
const $32d5e65f31c9045a$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $32d5e65f31c9045a$export$7a1e28a7b60ca602 = "post_request_failed";
const $32d5e65f31c9045a$export$45e7eaaecd19d31e = "get_request_failed";
const $32d5e65f31c9045a$export$96735047beea85a0 = "failed_to_parse_response";
const $32d5e65f31c9045a$export$6acf650331eb5f5f = "unable_to_load_token";
const $32d5e65f31c9045a$export$a416b0eceb5c15df = "crypto_key_not_found";
const $32d5e65f31c9045a$export$e502d98cd8d2da43 = "auth_code_required";
const $32d5e65f31c9045a$export$8bea68053103eaeb = "auth_code_or_nativeAccountId_required";
const $32d5e65f31c9045a$export$1efb009e9d75bbe4 = "spa_code_and_nativeAccountId_present";
const $32d5e65f31c9045a$export$c1110692d2978b8 = "database_unavailable";
const $32d5e65f31c9045a$export$b897bbe2c683def2 = "unable_to_acquire_token_from_native_platform";
const $32d5e65f31c9045a$export$4747c302ef0117fd = "native_handshake_timeout";
const $32d5e65f31c9045a$export$59080ea2398ee306 = "native_extension_not_installed";
const $32d5e65f31c9045a$export$7b7357e3538624aa = "native_connection_not_established";
const $32d5e65f31c9045a$export$436657cdcd7fe2be = "uninitialized_public_client_application";
const $32d5e65f31c9045a$export$62fdd8848aa75547 = "native_prompt_not_supported";
const $32d5e65f31c9045a$export$fcc6790b5d12da63 = "invalid_base64_string";
const $32d5e65f31c9045a$export$f6f43ae33ad04b91 = "invalid_pop_token_request";
const $32d5e65f31c9045a$export$df9e6aae71bd84f = "failed_to_build_headers";
const $32d5e65f31c9045a$export$487fe7232a90003c = "failed_to_parse_headers";
const $32d5e65f31c9045a$export$6e3539c6f28cd91f = "failed_to_decrypt_ear_response";
const $32d5e65f31c9045a$export$ce7eeda4eb1dd3c6 = "timed_out";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d8ef97823beb75e7$var$ErrorLink = "For more visit: aka.ms/msaljs/browser-errors";
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $d8ef97823beb75e7$export$16ffff3fb076c606 = {
    [(0, $32d5e65f31c9045a$export$ee549107fa376fc1)]: "The PKCE code challenge and verifier could not be generated.",
    [(0, $32d5e65f31c9045a$export$2c031f99d3e081ff)]: "No EAR encryption key provided. This is unexpected.",
    [(0, $32d5e65f31c9045a$export$b9f7c47ac4054f3d)]: "Server response does not contain ear_jwe property. This is unexpected.",
    [(0, $32d5e65f31c9045a$export$6319761d10f0cc4c)]: "The crypto object or function is not available.",
    [(0, $32d5e65f31c9045a$export$be9285c64f247822)]: "Navigation URI is empty. Please check stack trace for more info.",
    [(0, $32d5e65f31c9045a$export$a29c42a1dd414317)]: `Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$211c8e8843a8d278)]: "Hash does not contain state. Please verify that the request originated from msal.",
    [(0, $32d5e65f31c9045a$export$5743873a5ba5d124)]: `Hash does not contain known properites. Please verify that your redirectUri is not changing the hash.  ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$237bdd0b913cb30c)]: "Unable to parse state. Please verify that the request originated from msal.",
    [(0, $32d5e65f31c9045a$export$499b1b95c97a1c75)]: "Hash contains state but the interaction type does not match the caller.",
    [(0, $32d5e65f31c9045a$export$2700dc1c133d227e)]: `Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.   ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$f1b7091ee48d0b3e)]: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser.",
    [(0, $32d5e65f31c9045a$export$5e827e513523a576)]: "window.open returned null or undefined window object.",
    [(0, $32d5e65f31c9045a$export$6bae303c5e922702)]: "User cancelled the flow.",
    [(0, $32d5e65f31c9045a$export$e2e3374c08b8ef2a)]: `Token acquisition in popup failed due to timeout.  ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$c8b6efb19551013d)]: `Token acquisition in iframe failed due to timeout.  ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$9cc12eb574ceee30)]: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs.",
    [(0, $32d5e65f31c9045a$export$71bafc2814e56c09)]: `Request was blocked inside an iframe because MSAL detected an authentication response.  ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$c4a80c97d7b48f72)]: "Request was blocked inside a popup because MSAL detected it was running in a popup.",
    [(0, $32d5e65f31c9045a$export$6a76760db525f402)]: "The iframe being monitored was closed prematurely.",
    [(0, $32d5e65f31c9045a$export$78523a40be105a03)]: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead.",
    [(0, $32d5e65f31c9045a$export$87933d7d4116cb12)]: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request.",
    [(0, $32d5e65f31c9045a$export$24dae796d0958d3)]: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'.",
    [(0, $32d5e65f31c9045a$export$8b51939fb2aab3d7)]: "No token request found in cache.",
    [(0, $32d5e65f31c9045a$export$f3ae24cdfaab4488)]: "The cached token request could not be parsed.",
    [(0, $32d5e65f31c9045a$export$c47649cf6408c7b2)]: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler",
    [(0, $32d5e65f31c9045a$export$ff7164a2aeeff392)]: "Invalid cache type",
    [(0, $32d5e65f31c9045a$export$932e0f52d657f7fb)]: "Login and token requests are not supported in non-browser environments.",
    [(0, $32d5e65f31c9045a$export$4752ced1a1a262f)]: "Database is not open!",
    [(0, $32d5e65f31c9045a$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $32d5e65f31c9045a$export$7a1e28a7b60ca602)]: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'",
    [(0, $32d5e65f31c9045a$export$45e7eaaecd19d31e)]: "Network request failed. Please check the network trace to determine root cause.",
    [(0, $32d5e65f31c9045a$export$96735047beea85a0)]: "Failed to parse network response. Check network trace.",
    [(0, $32d5e65f31c9045a$export$6acf650331eb5f5f)]: "Error loading token to cache.",
    [(0, $32d5e65f31c9045a$export$a416b0eceb5c15df)]: "Cryptographic Key or Keypair not found in browser storage.",
    [(0, $32d5e65f31c9045a$export$e502d98cd8d2da43)]: "An authorization code must be provided (as the `code` property on the request) to this flow.",
    [(0, $32d5e65f31c9045a$export$8bea68053103eaeb)]: "An authorization code or nativeAccountId must be provided to this flow.",
    [(0, $32d5e65f31c9045a$export$1efb009e9d75bbe4)]: "Request cannot contain both spa code and native account id.",
    [(0, $32d5e65f31c9045a$export$c1110692d2978b8)]: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts.",
    [(0, $32d5e65f31c9045a$export$b897bbe2c683def2)]: `Unable to acquire token from native platform.  ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$4747c302ef0117fd)]: "Timed out while attempting to establish connection to browser extension",
    [(0, $32d5e65f31c9045a$export$59080ea2398ee306)]: "Native extension is not installed. If you think this is a mistake call the initialize function.",
    [(0, $32d5e65f31c9045a$export$7b7357e3538624aa)]: `Connection to native platform has not been established. Please install a compatible browser extension and run initialize().  ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$436657cdcd7fe2be)]: `You must call and await the initialize function before attempting to call any other MSAL API.  ${$d8ef97823beb75e7$var$ErrorLink}`,
    [(0, $32d5e65f31c9045a$export$62fdd8848aa75547)]: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow.",
    [(0, $32d5e65f31c9045a$export$fcc6790b5d12da63)]: "Invalid base64 encoded string.",
    [(0, $32d5e65f31c9045a$export$f6f43ae33ad04b91)]: "Invalid PoP token request. The request should not have both a popKid value and signPopToken set to true.",
    [(0, $32d5e65f31c9045a$export$df9e6aae71bd84f)]: "Failed to build request headers object.",
    [(0, $32d5e65f31c9045a$export$487fe7232a90003c)]: "Failed to parse response headers",
    [(0, $32d5e65f31c9045a$export$6e3539c6f28cd91f)]: "Failed to decrypt ear response",
    [(0, $32d5e65f31c9045a$export$ce7eeda4eb1dd3c6)]: "The request timed out."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use exported BrowserAuthErrorCodes instead.
 * In your app you can do :
 * ```
 * import { BrowserAuthErrorCodes } from "@azure/msal-browser";
 * ```
 */ const $d8ef97823beb75e7$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: (0, $32d5e65f31c9045a$export$ee549107fa376fc1),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$ee549107fa376fc1]
    },
    cryptoDoesNotExist: {
        code: (0, $32d5e65f31c9045a$export$6319761d10f0cc4c),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$6319761d10f0cc4c]
    },
    emptyNavigateUriError: {
        code: (0, $32d5e65f31c9045a$export$be9285c64f247822),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$be9285c64f247822]
    },
    hashEmptyError: {
        code: (0, $32d5e65f31c9045a$export$a29c42a1dd414317),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$a29c42a1dd414317]
    },
    hashDoesNotContainStateError: {
        code: (0, $32d5e65f31c9045a$export$211c8e8843a8d278),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$211c8e8843a8d278]
    },
    hashDoesNotContainKnownPropertiesError: {
        code: (0, $32d5e65f31c9045a$export$5743873a5ba5d124),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$5743873a5ba5d124]
    },
    unableToParseStateError: {
        code: (0, $32d5e65f31c9045a$export$237bdd0b913cb30c),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$237bdd0b913cb30c]
    },
    stateInteractionTypeMismatchError: {
        code: (0, $32d5e65f31c9045a$export$499b1b95c97a1c75),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$499b1b95c97a1c75]
    },
    interactionInProgress: {
        code: (0, $32d5e65f31c9045a$export$2700dc1c133d227e),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$2700dc1c133d227e]
    },
    popupWindowError: {
        code: (0, $32d5e65f31c9045a$export$f1b7091ee48d0b3e),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$f1b7091ee48d0b3e]
    },
    emptyWindowError: {
        code: (0, $32d5e65f31c9045a$export$5e827e513523a576),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$5e827e513523a576]
    },
    userCancelledError: {
        code: (0, $32d5e65f31c9045a$export$6bae303c5e922702),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$6bae303c5e922702]
    },
    monitorPopupTimeoutError: {
        code: (0, $32d5e65f31c9045a$export$e2e3374c08b8ef2a),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$e2e3374c08b8ef2a]
    },
    monitorIframeTimeoutError: {
        code: (0, $32d5e65f31c9045a$export$c8b6efb19551013d),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$c8b6efb19551013d]
    },
    redirectInIframeError: {
        code: (0, $32d5e65f31c9045a$export$9cc12eb574ceee30),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$9cc12eb574ceee30]
    },
    blockTokenRequestsInHiddenIframeError: {
        code: (0, $32d5e65f31c9045a$export$71bafc2814e56c09),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$71bafc2814e56c09]
    },
    blockAcquireTokenInPopupsError: {
        code: (0, $32d5e65f31c9045a$export$c4a80c97d7b48f72),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$c4a80c97d7b48f72]
    },
    iframeClosedPrematurelyError: {
        code: (0, $32d5e65f31c9045a$export$6a76760db525f402),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$6a76760db525f402]
    },
    silentLogoutUnsupportedError: {
        code: (0, $32d5e65f31c9045a$export$78523a40be105a03),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$78523a40be105a03]
    },
    noAccountError: {
        code: (0, $32d5e65f31c9045a$export$87933d7d4116cb12),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$87933d7d4116cb12]
    },
    silentPromptValueError: {
        code: (0, $32d5e65f31c9045a$export$24dae796d0958d3),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$24dae796d0958d3]
    },
    noTokenRequestCacheError: {
        code: (0, $32d5e65f31c9045a$export$8b51939fb2aab3d7),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$8b51939fb2aab3d7]
    },
    unableToParseTokenRequestCacheError: {
        code: (0, $32d5e65f31c9045a$export$f3ae24cdfaab4488),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$f3ae24cdfaab4488]
    },
    authRequestNotSet: {
        code: (0, $32d5e65f31c9045a$export$c47649cf6408c7b2),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$c47649cf6408c7b2]
    },
    invalidCacheType: {
        code: (0, $32d5e65f31c9045a$export$ff7164a2aeeff392),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$ff7164a2aeeff392]
    },
    notInBrowserEnvironment: {
        code: (0, $32d5e65f31c9045a$export$932e0f52d657f7fb),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$932e0f52d657f7fb]
    },
    databaseNotOpen: {
        code: (0, $32d5e65f31c9045a$export$4752ced1a1a262f),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$4752ced1a1a262f]
    },
    noNetworkConnectivity: {
        code: (0, $32d5e65f31c9045a$export$31ae862f18c3b2b7),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$31ae862f18c3b2b7]
    },
    postRequestFailed: {
        code: (0, $32d5e65f31c9045a$export$7a1e28a7b60ca602),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$7a1e28a7b60ca602]
    },
    getRequestFailed: {
        code: (0, $32d5e65f31c9045a$export$45e7eaaecd19d31e),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$45e7eaaecd19d31e]
    },
    failedToParseNetworkResponse: {
        code: (0, $32d5e65f31c9045a$export$96735047beea85a0),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$96735047beea85a0]
    },
    unableToLoadTokenError: {
        code: (0, $32d5e65f31c9045a$export$6acf650331eb5f5f),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$6acf650331eb5f5f]
    },
    signingKeyNotFoundInStorage: {
        code: (0, $32d5e65f31c9045a$export$a416b0eceb5c15df),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$a416b0eceb5c15df]
    },
    authCodeRequired: {
        code: (0, $32d5e65f31c9045a$export$e502d98cd8d2da43),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$e502d98cd8d2da43]
    },
    authCodeOrNativeAccountRequired: {
        code: (0, $32d5e65f31c9045a$export$8bea68053103eaeb),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$8bea68053103eaeb]
    },
    spaCodeAndNativeAccountPresent: {
        code: (0, $32d5e65f31c9045a$export$1efb009e9d75bbe4),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$1efb009e9d75bbe4]
    },
    databaseUnavailable: {
        code: (0, $32d5e65f31c9045a$export$c1110692d2978b8),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$c1110692d2978b8]
    },
    unableToAcquireTokenFromNativePlatform: {
        code: (0, $32d5e65f31c9045a$export$b897bbe2c683def2),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$b897bbe2c683def2]
    },
    nativeHandshakeTimeout: {
        code: (0, $32d5e65f31c9045a$export$4747c302ef0117fd),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$4747c302ef0117fd]
    },
    nativeExtensionNotInstalled: {
        code: (0, $32d5e65f31c9045a$export$59080ea2398ee306),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$59080ea2398ee306]
    },
    nativeConnectionNotEstablished: {
        code: (0, $32d5e65f31c9045a$export$7b7357e3538624aa),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$7b7357e3538624aa]
    },
    uninitializedPublicClientApplication: {
        code: (0, $32d5e65f31c9045a$export$436657cdcd7fe2be),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$436657cdcd7fe2be]
    },
    nativePromptNotSupported: {
        code: (0, $32d5e65f31c9045a$export$62fdd8848aa75547),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$62fdd8848aa75547]
    },
    invalidBase64StringError: {
        code: (0, $32d5e65f31c9045a$export$fcc6790b5d12da63),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$fcc6790b5d12da63]
    },
    invalidPopTokenRequest: {
        code: (0, $32d5e65f31c9045a$export$f6f43ae33ad04b91),
        desc: $d8ef97823beb75e7$export$16ffff3fb076c606[0, $32d5e65f31c9045a$export$f6f43ae33ad04b91]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $d8ef97823beb75e7$export$f8eb6760ca13876a extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, subError){
        super(errorCode, $d8ef97823beb75e7$export$16ffff3fb076c606[errorCode], subError);
        Object.setPrototypeOf(this, $d8ef97823beb75e7$export$f8eb6760ca13876a.prototype);
        this.name = "BrowserAuthError";
    }
}
function $d8ef97823beb75e7$export$72f7b48f3bc1d4cb(errorCode, subError) {
    return new $d8ef97823beb75e7$export$f8eb6760ca13876a(errorCode, subError);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $0959b3db41cb4f80$export$d0d362a73d466c9b {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $0959b3db41cb4f80$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $0959b3db41cb4f80$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        else window.location.assign(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$ce7eeda4eb1dd3c6), "failed_to_redirect"));
            }, options.timeout);
        });
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $131354001216b17e$export$bae979e68e4dc802 extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $131354001216b17e$export$bae979e68e4dc802.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $131354001216b17e$export$262c4a35fb53be19(error, httpStatus, responseHeaders, additionalError) {
    error.errorMessage = `${error.errorMessage}, additionalErrorInfo: error.name:${additionalError?.name}, error.message:${additionalError?.message}`;
    return new $131354001216b17e$export$bae979e68e4dc802(error, httpStatus, responseHeaders);
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $12534a979a907265$export$4c206ef5be879972 {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $12534a979a907265$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, $d94c9b6ecea78646$export$c774c31b4c31da8).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, $131354001216b17e$export$262c4a35fb53be19)((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $32d5e65f31c9045a$export$45e7eaaecd19d31e) : (0, $32d5e65f31c9045a$export$31ae862f18c3b2b7)), undefined, undefined, e);
        }
        responseHeaders = $12534a979a907265$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $131354001216b17e$export$262c4a35fb53be19)((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$96735047beea85a0)), responseStatus, responseHeaders, e);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $12534a979a907265$var$getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, $d94c9b6ecea78646$export$c774c31b4c31da8).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, $131354001216b17e$export$262c4a35fb53be19)((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $32d5e65f31c9045a$export$7a1e28a7b60ca602) : (0, $32d5e65f31c9045a$export$31ae862f18c3b2b7)), undefined, undefined, e);
        }
        responseHeaders = $12534a979a907265$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $131354001216b17e$export$262c4a35fb53be19)((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$96735047beea85a0)), responseStatus, responseHeaders, e);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $12534a979a907265$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, $131354001216b17e$export$262c4a35fb53be19)((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$df9e6aae71bd84f)), undefined, undefined, e);
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $12534a979a907265$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$487fe7232a90003c));
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ var $1ac773f7bc3e26ca$exports = {};

$parcel$export($1ac773f7bc3e26ca$exports, "instrumentBrokerParams", () => $1ac773f7bc3e26ca$export$7153a1ee4346fa3b);
$parcel$export($1ac773f7bc3e26ca$exports, "addResponseType", () => $1ac773f7bc3e26ca$export$3e2fd8b32dd28470);
$parcel$export($1ac773f7bc3e26ca$exports, "addResponseMode", () => $1ac773f7bc3e26ca$export$f1c153626c2c2d91);
$parcel$export($1ac773f7bc3e26ca$exports, "addNativeBroker", () => $1ac773f7bc3e26ca$export$8c305b8d324c4edb);
$parcel$export($1ac773f7bc3e26ca$exports, "addScopes", () => $1ac773f7bc3e26ca$export$c213bf8f125826ba);
$parcel$export($1ac773f7bc3e26ca$exports, "addClientId", () => $1ac773f7bc3e26ca$export$8360c651f9cc692b);
$parcel$export($1ac773f7bc3e26ca$exports, "addRedirectUri", () => $1ac773f7bc3e26ca$export$6758d6264f4f06);
$parcel$export($1ac773f7bc3e26ca$exports, "addPostLogoutRedirectUri", () => $1ac773f7bc3e26ca$export$bb8081db67b059c0);
$parcel$export($1ac773f7bc3e26ca$exports, "addIdTokenHint", () => $1ac773f7bc3e26ca$export$c6f34f6f67740950);
$parcel$export($1ac773f7bc3e26ca$exports, "addDomainHint", () => $1ac773f7bc3e26ca$export$1bd007a9d7fec290);
$parcel$export($1ac773f7bc3e26ca$exports, "addLoginHint", () => $1ac773f7bc3e26ca$export$65f43fd4b28bba5f);
$parcel$export($1ac773f7bc3e26ca$exports, "addCcsUpn", () => $1ac773f7bc3e26ca$export$aa9cca16bcc29d2d);
$parcel$export($1ac773f7bc3e26ca$exports, "addCcsOid", () => $1ac773f7bc3e26ca$export$68a633ecf634a2ea);
$parcel$export($1ac773f7bc3e26ca$exports, "addSid", () => $1ac773f7bc3e26ca$export$9d8531b0fa366b30);
$parcel$export($1ac773f7bc3e26ca$exports, "addClaims", () => $1ac773f7bc3e26ca$export$b04c3bca9165ed02);
$parcel$export($1ac773f7bc3e26ca$exports, "addClientCapabilitiesToClaims", () => $1ac773f7bc3e26ca$export$f40e790983a9797e);
$parcel$export($1ac773f7bc3e26ca$exports, "addCorrelationId", () => $1ac773f7bc3e26ca$export$8a224ff809946e9c);
$parcel$export($1ac773f7bc3e26ca$exports, "addLibraryInfo", () => $1ac773f7bc3e26ca$export$3ecac3764b147c3f);
$parcel$export($1ac773f7bc3e26ca$exports, "addApplicationTelemetry", () => $1ac773f7bc3e26ca$export$37ec1b76d865654a);
$parcel$export($1ac773f7bc3e26ca$exports, "addPrompt", () => $1ac773f7bc3e26ca$export$e982ccd37a61cde6);
$parcel$export($1ac773f7bc3e26ca$exports, "addState", () => $1ac773f7bc3e26ca$export$4a8b8c14090dd065);
$parcel$export($1ac773f7bc3e26ca$exports, "addNonce", () => $1ac773f7bc3e26ca$export$87b1d5d886e84b11);
$parcel$export($1ac773f7bc3e26ca$exports, "addCodeChallengeParams", () => $1ac773f7bc3e26ca$export$57a984e7ed784e16);
$parcel$export($1ac773f7bc3e26ca$exports, "addAuthorizationCode", () => $1ac773f7bc3e26ca$export$ff027aab2d77a49c);
$parcel$export($1ac773f7bc3e26ca$exports, "addDeviceCode", () => $1ac773f7bc3e26ca$export$8999dc4307159304);
$parcel$export($1ac773f7bc3e26ca$exports, "addRefreshToken", () => $1ac773f7bc3e26ca$export$b9e8ccbb425b80a3);
$parcel$export($1ac773f7bc3e26ca$exports, "addCodeVerifier", () => $1ac773f7bc3e26ca$export$dceb49e3b4703cbb);
$parcel$export($1ac773f7bc3e26ca$exports, "addClientSecret", () => $1ac773f7bc3e26ca$export$8df84bbb0e2465bc);
$parcel$export($1ac773f7bc3e26ca$exports, "addClientAssertion", () => $1ac773f7bc3e26ca$export$2d3d772920e2496e);
$parcel$export($1ac773f7bc3e26ca$exports, "addClientAssertionType", () => $1ac773f7bc3e26ca$export$55ad911d12112f00);
$parcel$export($1ac773f7bc3e26ca$exports, "addOboAssertion", () => $1ac773f7bc3e26ca$export$34b131001eea36b1);
$parcel$export($1ac773f7bc3e26ca$exports, "addRequestTokenUse", () => $1ac773f7bc3e26ca$export$b6d65fd125460167);
$parcel$export($1ac773f7bc3e26ca$exports, "addGrantType", () => $1ac773f7bc3e26ca$export$e5f700fdeb4022b2);
$parcel$export($1ac773f7bc3e26ca$exports, "addClientInfo", () => $1ac773f7bc3e26ca$export$86b85a101d45e918);
$parcel$export($1ac773f7bc3e26ca$exports, "addInstanceAware", () => $1ac773f7bc3e26ca$export$50b40dfb1d11b77a);
$parcel$export($1ac773f7bc3e26ca$exports, "addExtraQueryParameters", () => $1ac773f7bc3e26ca$export$1a9f676bcc5d37da);
$parcel$export($1ac773f7bc3e26ca$exports, "addUsername", () => $1ac773f7bc3e26ca$export$d38c772efe03a690);
$parcel$export($1ac773f7bc3e26ca$exports, "addPassword", () => $1ac773f7bc3e26ca$export$bfe833e59aa823e8);
$parcel$export($1ac773f7bc3e26ca$exports, "addPopToken", () => $1ac773f7bc3e26ca$export$6dfc34809d8c4096);
$parcel$export($1ac773f7bc3e26ca$exports, "addSshJwk", () => $1ac773f7bc3e26ca$export$f004de9a266b8070);
$parcel$export($1ac773f7bc3e26ca$exports, "addServerTelemetry", () => $1ac773f7bc3e26ca$export$79fb524b159705e9);
$parcel$export($1ac773f7bc3e26ca$exports, "addThrottling", () => $1ac773f7bc3e26ca$export$26592ae2037df9de);
$parcel$export($1ac773f7bc3e26ca$exports, "addLogoutHint", () => $1ac773f7bc3e26ca$export$e0d4676d7288bded);
$parcel$export($1ac773f7bc3e26ca$exports, "addBrokerParameters", () => $1ac773f7bc3e26ca$export$5ea4577e2a518c27);
$parcel$export($1ac773f7bc3e26ca$exports, "addEARParameters", () => $1ac773f7bc3e26ca$export$ec0b476da4a9fb0);
$parcel$export($1ac773f7bc3e26ca$exports, "addPostBodyParameters", () => $1ac773f7bc3e26ca$export$c9658e697f771ac4);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 
var $8fa592d3142882bc$exports = {};

$parcel$export($8fa592d3142882bc$exports, "CLIENT_ID", () => $8fa592d3142882bc$export$c7b1b63f5b60f8e);
$parcel$export($8fa592d3142882bc$exports, "REDIRECT_URI", () => $8fa592d3142882bc$export$89711068e98820c5);
$parcel$export($8fa592d3142882bc$exports, "RESPONSE_TYPE", () => $8fa592d3142882bc$export$af70b7209f1c7f6e);
$parcel$export($8fa592d3142882bc$exports, "RESPONSE_MODE", () => $8fa592d3142882bc$export$2ae8b352eb8edff7);
$parcel$export($8fa592d3142882bc$exports, "GRANT_TYPE", () => $8fa592d3142882bc$export$47f09697d0642170);
$parcel$export($8fa592d3142882bc$exports, "CLAIMS", () => $8fa592d3142882bc$export$c9b29cc9615296dd);
$parcel$export($8fa592d3142882bc$exports, "SCOPE", () => $8fa592d3142882bc$export$1c5a554c78c0cd12);
$parcel$export($8fa592d3142882bc$exports, "ERROR", () => $8fa592d3142882bc$export$103bedf43ba882db);
$parcel$export($8fa592d3142882bc$exports, "ERROR_DESCRIPTION", () => $8fa592d3142882bc$export$a9d2d02ea6b73527);
$parcel$export($8fa592d3142882bc$exports, "ACCESS_TOKEN", () => $8fa592d3142882bc$export$cdbdf26448f9da5b);
$parcel$export($8fa592d3142882bc$exports, "ID_TOKEN", () => $8fa592d3142882bc$export$9e690c458f1b1eda);
$parcel$export($8fa592d3142882bc$exports, "REFRESH_TOKEN", () => $8fa592d3142882bc$export$2a2261c5a58ac0);
$parcel$export($8fa592d3142882bc$exports, "EXPIRES_IN", () => $8fa592d3142882bc$export$a9f2539254087dfb);
$parcel$export($8fa592d3142882bc$exports, "REFRESH_TOKEN_EXPIRES_IN", () => $8fa592d3142882bc$export$97e3ac17371277);
$parcel$export($8fa592d3142882bc$exports, "STATE", () => $8fa592d3142882bc$export$63b4527a2777036f);
$parcel$export($8fa592d3142882bc$exports, "NONCE", () => $8fa592d3142882bc$export$8646168ae3eb91e1);
$parcel$export($8fa592d3142882bc$exports, "PROMPT", () => $8fa592d3142882bc$export$19855bb42e55939d);
$parcel$export($8fa592d3142882bc$exports, "SESSION_STATE", () => $8fa592d3142882bc$export$3edd0f3d0bfcddba);
$parcel$export($8fa592d3142882bc$exports, "CLIENT_INFO", () => $8fa592d3142882bc$export$476989d62bcb4c85);
$parcel$export($8fa592d3142882bc$exports, "CODE", () => $8fa592d3142882bc$export$ec5856072852bd7f);
$parcel$export($8fa592d3142882bc$exports, "CODE_CHALLENGE", () => $8fa592d3142882bc$export$58d2be3216991fee);
$parcel$export($8fa592d3142882bc$exports, "CODE_CHALLENGE_METHOD", () => $8fa592d3142882bc$export$129e6f0601e36303);
$parcel$export($8fa592d3142882bc$exports, "CODE_VERIFIER", () => $8fa592d3142882bc$export$a5a34ec10c757281);
$parcel$export($8fa592d3142882bc$exports, "CLIENT_REQUEST_ID", () => $8fa592d3142882bc$export$633c8d7cd18ad9a9);
$parcel$export($8fa592d3142882bc$exports, "X_CLIENT_SKU", () => $8fa592d3142882bc$export$fe2f04d04881f19d);
$parcel$export($8fa592d3142882bc$exports, "X_CLIENT_VER", () => $8fa592d3142882bc$export$d0d0201281a553c0);
$parcel$export($8fa592d3142882bc$exports, "X_CLIENT_OS", () => $8fa592d3142882bc$export$35497983a44f9406);
$parcel$export($8fa592d3142882bc$exports, "X_CLIENT_CPU", () => $8fa592d3142882bc$export$d14a6ca469cd1d2b);
$parcel$export($8fa592d3142882bc$exports, "X_CLIENT_CURR_TELEM", () => $8fa592d3142882bc$export$770dc090fda61e98);
$parcel$export($8fa592d3142882bc$exports, "X_CLIENT_LAST_TELEM", () => $8fa592d3142882bc$export$99d6087ff3bfb0d3);
$parcel$export($8fa592d3142882bc$exports, "X_MS_LIB_CAPABILITY", () => $8fa592d3142882bc$export$c5cd103a582a276);
$parcel$export($8fa592d3142882bc$exports, "X_APP_NAME", () => $8fa592d3142882bc$export$6101af169595a2ae);
$parcel$export($8fa592d3142882bc$exports, "X_APP_VER", () => $8fa592d3142882bc$export$a8707209cc4254a);
$parcel$export($8fa592d3142882bc$exports, "POST_LOGOUT_URI", () => $8fa592d3142882bc$export$965624bb436bcb2);
$parcel$export($8fa592d3142882bc$exports, "ID_TOKEN_HINT", () => $8fa592d3142882bc$export$8d6737236a319b56);
$parcel$export($8fa592d3142882bc$exports, "DEVICE_CODE", () => $8fa592d3142882bc$export$a575303545717aec);
$parcel$export($8fa592d3142882bc$exports, "CLIENT_SECRET", () => $8fa592d3142882bc$export$69f7aececf3ea5d7);
$parcel$export($8fa592d3142882bc$exports, "CLIENT_ASSERTION", () => $8fa592d3142882bc$export$cddd1d85c78cca51);
$parcel$export($8fa592d3142882bc$exports, "CLIENT_ASSERTION_TYPE", () => $8fa592d3142882bc$export$21aecb34d0e7d9c0);
$parcel$export($8fa592d3142882bc$exports, "TOKEN_TYPE", () => $8fa592d3142882bc$export$5706a68daf4f000a);
$parcel$export($8fa592d3142882bc$exports, "REQ_CNF", () => $8fa592d3142882bc$export$427afb3f9eefe31e);
$parcel$export($8fa592d3142882bc$exports, "OBO_ASSERTION", () => $8fa592d3142882bc$export$3529b31b0ae94ae0);
$parcel$export($8fa592d3142882bc$exports, "REQUESTED_TOKEN_USE", () => $8fa592d3142882bc$export$97bc1bf63f077c4a);
$parcel$export($8fa592d3142882bc$exports, "ON_BEHALF_OF", () => $8fa592d3142882bc$export$4aca5741d44e318e);
$parcel$export($8fa592d3142882bc$exports, "FOCI", () => $8fa592d3142882bc$export$a03331b9d99609d6);
$parcel$export($8fa592d3142882bc$exports, "CCS_HEADER", () => $8fa592d3142882bc$export$773357fabf610b1f);
$parcel$export($8fa592d3142882bc$exports, "RETURN_SPA_CODE", () => $8fa592d3142882bc$export$f58b98a40c1faa68);
$parcel$export($8fa592d3142882bc$exports, "NATIVE_BROKER", () => $8fa592d3142882bc$export$830ff7e6cf071f86);
$parcel$export($8fa592d3142882bc$exports, "LOGOUT_HINT", () => $8fa592d3142882bc$export$a96ff88ff08babe2);
$parcel$export($8fa592d3142882bc$exports, "SID", () => $8fa592d3142882bc$export$e9405f9e95799b52);
$parcel$export($8fa592d3142882bc$exports, "LOGIN_HINT", () => $8fa592d3142882bc$export$defd6be6e02aaeb3);
$parcel$export($8fa592d3142882bc$exports, "DOMAIN_HINT", () => $8fa592d3142882bc$export$41459bac1e74ba19);
$parcel$export($8fa592d3142882bc$exports, "X_CLIENT_EXTRA_SKU", () => $8fa592d3142882bc$export$493429868d5ba9bc);
$parcel$export($8fa592d3142882bc$exports, "BROKER_CLIENT_ID", () => $8fa592d3142882bc$export$3f910906fd5fe047);
$parcel$export($8fa592d3142882bc$exports, "BROKER_REDIRECT_URI", () => $8fa592d3142882bc$export$c3ecf58e7e228261);
$parcel$export($8fa592d3142882bc$exports, "INSTANCE_AWARE", () => $8fa592d3142882bc$export$d72b25d13120919d);
$parcel$export($8fa592d3142882bc$exports, "EAR_JWK", () => $8fa592d3142882bc$export$1e9ebf38b05380ef);
$parcel$export($8fa592d3142882bc$exports, "EAR_JWE_CRYPTO", () => $8fa592d3142882bc$export$79d2fd0e357f5119);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8fa592d3142882bc$export$c7b1b63f5b60f8e = "client_id";
const $8fa592d3142882bc$export$89711068e98820c5 = "redirect_uri";
const $8fa592d3142882bc$export$af70b7209f1c7f6e = "response_type";
const $8fa592d3142882bc$export$2ae8b352eb8edff7 = "response_mode";
const $8fa592d3142882bc$export$47f09697d0642170 = "grant_type";
const $8fa592d3142882bc$export$c9b29cc9615296dd = "claims";
const $8fa592d3142882bc$export$1c5a554c78c0cd12 = "scope";
const $8fa592d3142882bc$export$103bedf43ba882db = "error";
const $8fa592d3142882bc$export$a9d2d02ea6b73527 = "error_description";
const $8fa592d3142882bc$export$cdbdf26448f9da5b = "access_token";
const $8fa592d3142882bc$export$9e690c458f1b1eda = "id_token";
const $8fa592d3142882bc$export$2a2261c5a58ac0 = "refresh_token";
const $8fa592d3142882bc$export$a9f2539254087dfb = "expires_in";
const $8fa592d3142882bc$export$97e3ac17371277 = "refresh_token_expires_in";
const $8fa592d3142882bc$export$63b4527a2777036f = "state";
const $8fa592d3142882bc$export$8646168ae3eb91e1 = "nonce";
const $8fa592d3142882bc$export$19855bb42e55939d = "prompt";
const $8fa592d3142882bc$export$3edd0f3d0bfcddba = "session_state";
const $8fa592d3142882bc$export$476989d62bcb4c85 = "client_info";
const $8fa592d3142882bc$export$ec5856072852bd7f = "code";
const $8fa592d3142882bc$export$58d2be3216991fee = "code_challenge";
const $8fa592d3142882bc$export$129e6f0601e36303 = "code_challenge_method";
const $8fa592d3142882bc$export$a5a34ec10c757281 = "code_verifier";
const $8fa592d3142882bc$export$633c8d7cd18ad9a9 = "client-request-id";
const $8fa592d3142882bc$export$fe2f04d04881f19d = "x-client-SKU";
const $8fa592d3142882bc$export$d0d0201281a553c0 = "x-client-VER";
const $8fa592d3142882bc$export$35497983a44f9406 = "x-client-OS";
const $8fa592d3142882bc$export$d14a6ca469cd1d2b = "x-client-CPU";
const $8fa592d3142882bc$export$770dc090fda61e98 = "x-client-current-telemetry";
const $8fa592d3142882bc$export$99d6087ff3bfb0d3 = "x-client-last-telemetry";
const $8fa592d3142882bc$export$c5cd103a582a276 = "x-ms-lib-capability";
const $8fa592d3142882bc$export$6101af169595a2ae = "x-app-name";
const $8fa592d3142882bc$export$a8707209cc4254a = "x-app-ver";
const $8fa592d3142882bc$export$965624bb436bcb2 = "post_logout_redirect_uri";
const $8fa592d3142882bc$export$8d6737236a319b56 = "id_token_hint";
const $8fa592d3142882bc$export$a575303545717aec = "device_code";
const $8fa592d3142882bc$export$69f7aececf3ea5d7 = "client_secret";
const $8fa592d3142882bc$export$cddd1d85c78cca51 = "client_assertion";
const $8fa592d3142882bc$export$21aecb34d0e7d9c0 = "client_assertion_type";
const $8fa592d3142882bc$export$5706a68daf4f000a = "token_type";
const $8fa592d3142882bc$export$427afb3f9eefe31e = "req_cnf";
const $8fa592d3142882bc$export$3529b31b0ae94ae0 = "assertion";
const $8fa592d3142882bc$export$97bc1bf63f077c4a = "requested_token_use";
const $8fa592d3142882bc$export$4aca5741d44e318e = "on_behalf_of";
const $8fa592d3142882bc$export$a03331b9d99609d6 = "foci";
const $8fa592d3142882bc$export$773357fabf610b1f = "X-AnchorMailbox";
const $8fa592d3142882bc$export$f58b98a40c1faa68 = "return_spa_code";
const $8fa592d3142882bc$export$830ff7e6cf071f86 = "nativebroker";
const $8fa592d3142882bc$export$a96ff88ff08babe2 = "logout_hint";
const $8fa592d3142882bc$export$e9405f9e95799b52 = "sid";
const $8fa592d3142882bc$export$defd6be6e02aaeb3 = "login_hint";
const $8fa592d3142882bc$export$41459bac1e74ba19 = "domain_hint";
const $8fa592d3142882bc$export$493429868d5ba9bc = "x-client-xtra-sku";
const $8fa592d3142882bc$export$3f910906fd5fe047 = "brk_client_id";
const $8fa592d3142882bc$export$c3ecf58e7e228261 = "brk_redirect_uri";
const $8fa592d3142882bc$export$d72b25d13120919d = "instance_aware";
const $8fa592d3142882bc$export$1e9ebf38b05380ef = "ear_jwk";
const $8fa592d3142882bc$export$79d2fd0e357f5119 = "ear_jwe_crypto";





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1ac773f7bc3e26ca$export$7153a1ee4346fa3b(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, $8fa592d3142882bc$export$c7b1b63f5b60f8e));
    if (clientId && parameters.has((0, $8fa592d3142882bc$export$3f910906fd5fe047))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, $8fa592d3142882bc$export$89711068e98820c5))
    }, correlationId);
}
/**
 * Add the given response_type
 * @param parameters
 * @param responseType
 */ function $1ac773f7bc3e26ca$export$3e2fd8b32dd28470(parameters, responseType) {
    parameters.set((0, $8fa592d3142882bc$export$af70b7209f1c7f6e), responseType);
}
/**
 * add response_mode. defaults to query.
 * @param responseMode
 */ function $1ac773f7bc3e26ca$export$f1c153626c2c2d91(parameters, responseMode) {
    parameters.set((0, $8fa592d3142882bc$export$2ae8b352eb8edff7), responseMode ? responseMode : (0, $6c5f3cda7e712574$export$f990a5bae1260b8c).QUERY);
}
/**
 * Add flag to indicate STS should attempt to use WAM if available
 */ function $1ac773f7bc3e26ca$export$8c305b8d324c4edb(parameters) {
    parameters.set((0, $8fa592d3142882bc$export$830ff7e6cf071f86), "1");
}
/**
 * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
 * @param scopeSet
 * @param addOidcScopes
 */ function $1ac773f7bc3e26ca$export$c213bf8f125826ba(parameters, scopes, addOidcScopes = true, defaultScopes = (0, $6c5f3cda7e712574$export$893b1b5b686d84ef)) {
    // Always add openid to the scopes when adding OIDC scopes
    if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
    const requestScopes = addOidcScopes ? [
        ...scopes || [],
        ...defaultScopes
    ] : scopes || [];
    const scopeSet = new (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99)(requestScopes);
    parameters.set((0, $8fa592d3142882bc$export$1c5a554c78c0cd12), scopeSet.printScopes());
}
/**
 * add clientId
 * @param clientId
 */ function $1ac773f7bc3e26ca$export$8360c651f9cc692b(parameters, clientId) {
    parameters.set((0, $8fa592d3142882bc$export$c7b1b63f5b60f8e), clientId);
}
/**
 * add redirect_uri
 * @param redirectUri
 */ function $1ac773f7bc3e26ca$export$6758d6264f4f06(parameters, redirectUri) {
    parameters.set((0, $8fa592d3142882bc$export$89711068e98820c5), redirectUri);
}
/**
 * add post logout redirectUri
 * @param redirectUri
 */ function $1ac773f7bc3e26ca$export$bb8081db67b059c0(parameters, redirectUri) {
    parameters.set((0, $8fa592d3142882bc$export$965624bb436bcb2), redirectUri);
}
/**
 * add id_token_hint to logout request
 * @param idTokenHint
 */ function $1ac773f7bc3e26ca$export$c6f34f6f67740950(parameters, idTokenHint) {
    parameters.set((0, $8fa592d3142882bc$export$8d6737236a319b56), idTokenHint);
}
/**
 * add domain_hint
 * @param domainHint
 */ function $1ac773f7bc3e26ca$export$1bd007a9d7fec290(parameters, domainHint) {
    parameters.set((0, $8fa592d3142882bc$export$41459bac1e74ba19), domainHint);
}
/**
 * add login_hint
 * @param loginHint
 */ function $1ac773f7bc3e26ca$export$65f43fd4b28bba5f(parameters, loginHint) {
    parameters.set((0, $8fa592d3142882bc$export$defd6be6e02aaeb3), loginHint);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for login_hint
 * @param loginHint
 */ function $1ac773f7bc3e26ca$export$aa9cca16bcc29d2d(parameters, loginHint) {
    parameters.set((0, $6c5f3cda7e712574$export$28d77f87efed1d88).CCS_HEADER, `UPN:${loginHint}`);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for account object
 * @param loginHint
 */ function $1ac773f7bc3e26ca$export$68a633ecf634a2ea(parameters, clientInfo) {
    parameters.set((0, $6c5f3cda7e712574$export$28d77f87efed1d88).CCS_HEADER, `Oid:${clientInfo.uid}@${clientInfo.utid}`);
}
/**
 * add sid
 * @param sid
 */ function $1ac773f7bc3e26ca$export$9d8531b0fa366b30(parameters, sid) {
    parameters.set((0, $8fa592d3142882bc$export$e9405f9e95799b52), sid);
}
/**
 * add claims
 * @param claims
 */ function $1ac773f7bc3e26ca$export$b04c3bca9165ed02(parameters, claims, clientCapabilities) {
    const mergedClaims = $1ac773f7bc3e26ca$export$f40e790983a9797e(claims, clientCapabilities);
    try {
        JSON.parse(mergedClaims);
    } catch (e) {
        throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$96e755c70e0d0e34));
    }
    parameters.set((0, $8fa592d3142882bc$export$c9b29cc9615296dd), mergedClaims);
}
/**
 * add correlationId
 * @param correlationId
 */ function $1ac773f7bc3e26ca$export$8a224ff809946e9c(parameters, correlationId) {
    parameters.set((0, $8fa592d3142882bc$export$633c8d7cd18ad9a9), correlationId);
}
/**
 * add library info query params
 * @param libraryInfo
 */ function $1ac773f7bc3e26ca$export$3ecac3764b147c3f(parameters, libraryInfo) {
    // Telemetry Info
    parameters.set((0, $8fa592d3142882bc$export$fe2f04d04881f19d), libraryInfo.sku);
    parameters.set((0, $8fa592d3142882bc$export$d0d0201281a553c0), libraryInfo.version);
    if (libraryInfo.os) parameters.set((0, $8fa592d3142882bc$export$35497983a44f9406), libraryInfo.os);
    if (libraryInfo.cpu) parameters.set((0, $8fa592d3142882bc$export$d14a6ca469cd1d2b), libraryInfo.cpu);
}
/**
 * Add client telemetry parameters
 * @param appTelemetry
 */ function $1ac773f7bc3e26ca$export$37ec1b76d865654a(parameters, appTelemetry) {
    if (appTelemetry?.appName) parameters.set((0, $8fa592d3142882bc$export$6101af169595a2ae), appTelemetry.appName);
    if (appTelemetry?.appVersion) parameters.set((0, $8fa592d3142882bc$export$a8707209cc4254a), appTelemetry.appVersion);
}
/**
 * add prompt
 * @param prompt
 */ function $1ac773f7bc3e26ca$export$e982ccd37a61cde6(parameters, prompt) {
    parameters.set((0, $8fa592d3142882bc$export$19855bb42e55939d), prompt);
}
/**
 * add state
 * @param state
 */ function $1ac773f7bc3e26ca$export$4a8b8c14090dd065(parameters, state) {
    if (state) parameters.set((0, $8fa592d3142882bc$export$63b4527a2777036f), state);
}
/**
 * add nonce
 * @param nonce
 */ function $1ac773f7bc3e26ca$export$87b1d5d886e84b11(parameters, nonce) {
    parameters.set((0, $8fa592d3142882bc$export$8646168ae3eb91e1), nonce);
}
/**
 * add code_challenge and code_challenge_method
 * - throw if either of them are not passed
 * @param codeChallenge
 * @param codeChallengeMethod
 */ function $1ac773f7bc3e26ca$export$57a984e7ed784e16(parameters, codeChallenge, codeChallengeMethod) {
    if (codeChallenge && codeChallengeMethod) {
        parameters.set((0, $8fa592d3142882bc$export$58d2be3216991fee), codeChallenge);
        parameters.set((0, $8fa592d3142882bc$export$129e6f0601e36303), codeChallengeMethod);
    } else throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$2da3866b327f1753));
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $1ac773f7bc3e26ca$export$ff027aab2d77a49c(parameters, code) {
    parameters.set((0, $8fa592d3142882bc$export$ec5856072852bd7f), code);
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $1ac773f7bc3e26ca$export$8999dc4307159304(parameters, code) {
    parameters.set((0, $8fa592d3142882bc$export$a575303545717aec), code);
}
/**
 * add the `refreshToken` passed by the user
 * @param refreshToken
 */ function $1ac773f7bc3e26ca$export$b9e8ccbb425b80a3(parameters, refreshToken) {
    parameters.set((0, $8fa592d3142882bc$export$2a2261c5a58ac0), refreshToken);
}
/**
 * add the `code_verifier` passed by the user to exchange for a token
 * @param codeVerifier
 */ function $1ac773f7bc3e26ca$export$dceb49e3b4703cbb(parameters, codeVerifier) {
    parameters.set((0, $8fa592d3142882bc$export$a5a34ec10c757281), codeVerifier);
}
/**
 * add client_secret
 * @param clientSecret
 */ function $1ac773f7bc3e26ca$export$8df84bbb0e2465bc(parameters, clientSecret) {
    parameters.set((0, $8fa592d3142882bc$export$69f7aececf3ea5d7), clientSecret);
}
/**
 * add clientAssertion for confidential client flows
 * @param clientAssertion
 */ function $1ac773f7bc3e26ca$export$2d3d772920e2496e(parameters, clientAssertion) {
    if (clientAssertion) parameters.set((0, $8fa592d3142882bc$export$cddd1d85c78cca51), clientAssertion);
}
/**
 * add clientAssertionType for confidential client flows
 * @param clientAssertionType
 */ function $1ac773f7bc3e26ca$export$55ad911d12112f00(parameters, clientAssertionType) {
    if (clientAssertionType) parameters.set((0, $8fa592d3142882bc$export$21aecb34d0e7d9c0), clientAssertionType);
}
/**
 * add OBO assertion for confidential client flows
 * @param clientAssertion
 */ function $1ac773f7bc3e26ca$export$34b131001eea36b1(parameters, oboAssertion) {
    parameters.set((0, $8fa592d3142882bc$export$3529b31b0ae94ae0), oboAssertion);
}
/**
 * add grant type
 * @param grantType
 */ function $1ac773f7bc3e26ca$export$b6d65fd125460167(parameters, tokenUse) {
    parameters.set((0, $8fa592d3142882bc$export$97bc1bf63f077c4a), tokenUse);
}
/**
 * add grant type
 * @param grantType
 */ function $1ac773f7bc3e26ca$export$e5f700fdeb4022b2(parameters, grantType) {
    parameters.set((0, $8fa592d3142882bc$export$47f09697d0642170), grantType);
}
/**
 * add client info
 *
 */ function $1ac773f7bc3e26ca$export$86b85a101d45e918(parameters) {
    parameters.set((0, $6c5f3cda7e712574$export$476989d62bcb4c85), "1");
}
function $1ac773f7bc3e26ca$export$50b40dfb1d11b77a(parameters) {
    if (!parameters.has((0, $8fa592d3142882bc$export$d72b25d13120919d))) parameters.set((0, $8fa592d3142882bc$export$d72b25d13120919d), "true");
}
/**
 * add extraQueryParams
 * @param eQParams
 */ function $1ac773f7bc3e26ca$export$1a9f676bcc5d37da(parameters, eQParams) {
    Object.entries(eQParams).forEach(([key, value])=>{
        if (!parameters.has(key) && value) parameters.set(key, value);
    });
}
function $1ac773f7bc3e26ca$export$f40e790983a9797e(claims, clientCapabilities) {
    let mergedClaims;
    // Parse provided claims into JSON object or initialize empty object
    if (!claims) mergedClaims = {};
    else try {
        mergedClaims = JSON.parse(claims);
    } catch (e) {
        throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$96e755c70e0d0e34));
    }
    if (clientCapabilities && clientCapabilities.length > 0) {
        if (!mergedClaims.hasOwnProperty((0, $6c5f3cda7e712574$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
        mergedClaims[(0, $6c5f3cda7e712574$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
        // Add xms_cc claim with provided clientCapabilities to access_token key
        mergedClaims[(0, $6c5f3cda7e712574$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $6c5f3cda7e712574$export$c125cda26c71ef54).XMS_CC] = {
            values: clientCapabilities
        };
    }
    return JSON.stringify(mergedClaims);
}
/**
 * adds `username` for Password Grant flow
 * @param username
 */ function $1ac773f7bc3e26ca$export$d38c772efe03a690(parameters, username) {
    parameters.set((0, $6c5f3cda7e712574$export$fa8b29062cab1da).username, username);
}
/**
 * adds `password` for Password Grant flow
 * @param password
 */ function $1ac773f7bc3e26ca$export$bfe833e59aa823e8(parameters, password) {
    parameters.set((0, $6c5f3cda7e712574$export$fa8b29062cab1da).password, password);
}
/**
 * add pop_jwk to query params
 * @param cnfString
 */ function $1ac773f7bc3e26ca$export$6dfc34809d8c4096(parameters, cnfString) {
    if (cnfString) {
        parameters.set((0, $8fa592d3142882bc$export$5706a68daf4f000a), (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP);
        parameters.set((0, $8fa592d3142882bc$export$427afb3f9eefe31e), cnfString);
    }
}
/**
 * add SSH JWK and key ID to query params
 */ function $1ac773f7bc3e26ca$export$f004de9a266b8070(parameters, sshJwkString) {
    if (sshJwkString) {
        parameters.set((0, $8fa592d3142882bc$export$5706a68daf4f000a), (0, $6c5f3cda7e712574$export$901491a717da2ba5).SSH);
        parameters.set((0, $8fa592d3142882bc$export$427afb3f9eefe31e), sshJwkString);
    }
}
/**
 * add server telemetry fields
 * @param serverTelemetryManager
 */ function $1ac773f7bc3e26ca$export$79fb524b159705e9(parameters, serverTelemetryManager) {
    parameters.set((0, $8fa592d3142882bc$export$770dc090fda61e98), serverTelemetryManager.generateCurrentRequestHeaderValue());
    parameters.set((0, $8fa592d3142882bc$export$99d6087ff3bfb0d3), serverTelemetryManager.generateLastRequestHeaderValue());
}
/**
 * Adds parameter that indicates to the server that throttling is supported
 */ function $1ac773f7bc3e26ca$export$26592ae2037df9de(parameters) {
    parameters.set((0, $8fa592d3142882bc$export$c5cd103a582a276), (0, $6c5f3cda7e712574$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
}
/**
 * Adds logout_hint parameter for "silent" logout which prevent server account picker
 */ function $1ac773f7bc3e26ca$export$e0d4676d7288bded(parameters, logoutHint) {
    parameters.set((0, $8fa592d3142882bc$export$a96ff88ff08babe2), logoutHint);
}
function $1ac773f7bc3e26ca$export$5ea4577e2a518c27(parameters, brokerClientId, brokerRedirectUri) {
    if (!parameters.has((0, $8fa592d3142882bc$export$3f910906fd5fe047))) parameters.set((0, $8fa592d3142882bc$export$3f910906fd5fe047), brokerClientId);
    if (!parameters.has((0, $8fa592d3142882bc$export$c3ecf58e7e228261))) parameters.set((0, $8fa592d3142882bc$export$c3ecf58e7e228261), brokerRedirectUri);
}
/**
 * Add EAR (Encrypted Authorize Response) request parameters
 * @param parameters
 * @param jwk
 */ function $1ac773f7bc3e26ca$export$ec0b476da4a9fb0(parameters, jwk) {
    parameters.set((0, $8fa592d3142882bc$export$1e9ebf38b05380ef), encodeURIComponent(jwk));
    // ear_jwe_crypto will always have value: {"alg":"dir","enc":"A256GCM"} so we can hardcode this
    const jweCryptoB64Encoded = "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0";
    parameters.set((0, $8fa592d3142882bc$export$79d2fd0e357f5119), jweCryptoB64Encoded);
}
/**
 * Adds authorize body parameters to the request parameters
 * @param parameters
 * @param bodyParameters
 */ function $1ac773f7bc3e26ca$export$c9658e697f771ac4(parameters, bodyParameters) {
    Object.entries(bodyParameters).forEach(([key, value])=>{
        if (value) parameters.set(key, value);
    });
}




/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $22782b013da7b52b$export$9ef804feabbcbaf1(input) {
    return encodeURIComponent($22782b013da7b52b$export$e510a73ee562749(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $22782b013da7b52b$export$84f5a428c7153a69(inputArr) {
    return $22782b013da7b52b$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $22782b013da7b52b$export$e510a73ee562749(input) {
    return $22782b013da7b52b$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $22782b013da7b52b$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $0d858b7a75e8c5ef$export$c62426fdd000a97e(input) {
    return new TextDecoder().decode($0d858b7a75e8c5ef$export$8f0c237d3e8188bc(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $0d858b7a75e8c5ef$export$8f0c237d3e8188bc(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$fcc6790b5d12da63));
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // Algorithms
const $6f7127724a699469$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
const $6f7127724a699469$var$AES_GCM = "AES-GCM";
const $6f7127724a699469$var$HKDF = "HKDF";
// SHA-256 hashing algorithm
const $6f7127724a699469$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
const $6f7127724a699469$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $6f7127724a699469$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $6f7127724a699469$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $6f7127724a699469$var$UINT32_ARR = new Uint32Array(1);
// Key Format
const $6f7127724a699469$var$RAW = "raw";
// Key Usages
const $6f7127724a699469$var$ENCRYPT = "encrypt";
const $6f7127724a699469$var$DECRYPT = "decrypt";
const $6f7127724a699469$var$DERIVE_KEY = "deriveKey";
// Suberror
const $6f7127724a699469$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $6f7127724a699469$var$keygenAlgorithmOptions = {
    name: $6f7127724a699469$var$PKCS1_V15_KEYGEN_ALG,
    hash: $6f7127724a699469$var$S256_HASH_ALG,
    modulusLength: $6f7127724a699469$var$MODULUS_LENGTH,
    publicExponent: $6f7127724a699469$var$PUBLIC_EXPONENT
};
/**
 * Check whether browser crypto is available.
 */ function $6f7127724a699469$export$1ddcc6bab2bf2314(skipValidateSubtleCrypto) {
    if (!window) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$932e0f52d657f7fb));
    if (!window.crypto) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6319761d10f0cc4c));
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6319761d10f0cc4c), $6f7127724a699469$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $6f7127724a699469$export$52caff7bddbaf316(dataString, performanceClient, correlationId) {
    performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).Sha256Digest, correlationId);
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($6f7127724a699469$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $6f7127724a699469$export$960b9ff25e7d4257(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $6f7127724a699469$var$getRandomUint32() {
    window.crypto.getRandomValues($6f7127724a699469$var$UINT32_ARR);
    return $6f7127724a699469$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $6f7127724a699469$export$6ef0355fa80a5278() {
    const currentTimestamp = Date.now();
    const baseRand = $6f7127724a699469$var$getRandomUint32() * 0x400 + ($6f7127724a699469$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $6f7127724a699469$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $6f7127724a699469$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $6f7127724a699469$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on current keygen algorithm config.
 * @param extractable
 * @param usages
 */ async function $6f7127724a699469$export$a949d36eab55b41f(extractable, usages) {
    return window.crypto.subtle.generateKey($6f7127724a699469$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $6f7127724a699469$export$88781b8595a7d2ff(key) {
    return window.crypto.subtle.exportKey((0, $d94c9b6ecea78646$export$1294c3e3f84694cd), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 */ async function $6f7127724a699469$export$8bdea4e2e3f593c9(key, extractable, usages) {
    return window.crypto.subtle.importKey((0, $d94c9b6ecea78646$export$1294c3e3f84694cd), key, $6f7127724a699469$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Signs given data with given key
 * @param key
 * @param data
 */ async function $6f7127724a699469$export$c5552dfdbc7cec71(key, data) {
    return window.crypto.subtle.sign($6f7127724a699469$var$keygenAlgorithmOptions, key, data);
}
/**
 * Generates Base64 encoded jwk used in the Encrypted Authorize Response (EAR) flow
 */ async function $6f7127724a699469$export$95528b8a314880d1() {
    const key = await $6f7127724a699469$export$1222fa1cada87c76();
    const keyStr = (0, $22782b013da7b52b$export$84f5a428c7153a69)(new Uint8Array(key));
    const jwk = {
        alg: "dir",
        kty: "oct",
        k: keyStr
    };
    return (0, $22782b013da7b52b$export$e510a73ee562749)(JSON.stringify(jwk));
}
/**
 * Parses earJwk for encryption key and returns CryptoKey object
 * @param earJwk
 * @returns
 */ async function $6f7127724a699469$export$cf6da4e13ceceed(earJwk) {
    const b64DecodedJwk = (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e)(earJwk);
    const jwkJson = JSON.parse(b64DecodedJwk);
    const rawKey = jwkJson.k;
    const keyBuffer = (0, $0d858b7a75e8c5ef$export$8f0c237d3e8188bc)(rawKey);
    return window.crypto.subtle.importKey($6f7127724a699469$var$RAW, keyBuffer, $6f7127724a699469$var$AES_GCM, false, [
        $6f7127724a699469$var$DECRYPT
    ]);
}
/**
 * Decrypt ear_jwe response returned in the Encrypted Authorize Response (EAR) flow
 * @param earJwk
 * @param earJwe
 * @returns
 */ async function $6f7127724a699469$export$13b9c776ab498ef3(earJwk, earJwe) {
    const earJweParts = earJwe.split(".");
    if (earJweParts.length !== 5) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6e3539c6f28cd91f), "jwe_length");
    const key = await $6f7127724a699469$export$cf6da4e13ceceed(earJwk).catch(()=>{
        throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6e3539c6f28cd91f), "import_key");
    });
    try {
        const header = new TextEncoder().encode(earJweParts[0]);
        const iv = (0, $0d858b7a75e8c5ef$export$8f0c237d3e8188bc)(earJweParts[2]);
        const ciphertext = (0, $0d858b7a75e8c5ef$export$8f0c237d3e8188bc)(earJweParts[3]);
        const tag = (0, $0d858b7a75e8c5ef$export$8f0c237d3e8188bc)(earJweParts[4]);
        const tagLengthBits = tag.byteLength * 8;
        // Concat ciphertext and tag
        const encryptedData = new Uint8Array(ciphertext.length + tag.length);
        encryptedData.set(ciphertext);
        encryptedData.set(tag, ciphertext.length);
        const decryptedData = await window.crypto.subtle.decrypt({
            name: $6f7127724a699469$var$AES_GCM,
            iv: iv,
            tagLength: tagLengthBits,
            additionalData: header
        }, key, encryptedData);
        return new TextDecoder().decode(decryptedData);
    } catch (e) {
        throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6e3539c6f28cd91f), "decrypt");
    }
}
/**
 * Generates symmetric base encryption key. This may be stored as all encryption/decryption keys will be derived from this one.
 */ async function $6f7127724a699469$export$1222fa1cada87c76() {
    const key = await window.crypto.subtle.generateKey({
        name: $6f7127724a699469$var$AES_GCM,
        length: 256
    }, true, [
        $6f7127724a699469$var$ENCRYPT,
        $6f7127724a699469$var$DECRYPT
    ]);
    return window.crypto.subtle.exportKey($6f7127724a699469$var$RAW, key);
}
/**
 * Returns the raw key to be passed into the key derivation function
 * @param baseKey
 * @returns
 */ async function $6f7127724a699469$export$5a71d4e3178f19c4(baseKey) {
    return window.crypto.subtle.importKey($6f7127724a699469$var$RAW, baseKey, $6f7127724a699469$var$HKDF, false, [
        $6f7127724a699469$var$DERIVE_KEY
    ]);
}
/**
 * Given a base key and a nonce generates a derived key to be used in encryption and decryption.
 * Note: every time we encrypt a new key is derived
 * @param baseKey
 * @param nonce
 * @returns
 */ async function $6f7127724a699469$var$deriveKey(baseKey, nonce, context) {
    return window.crypto.subtle.deriveKey({
        name: $6f7127724a699469$var$HKDF,
        salt: nonce,
        hash: $6f7127724a699469$var$S256_HASH_ALG,
        info: new TextEncoder().encode(context)
    }, baseKey, {
        name: $6f7127724a699469$var$AES_GCM,
        length: 256
    }, false, [
        $6f7127724a699469$var$ENCRYPT,
        $6f7127724a699469$var$DECRYPT
    ]);
}
/**
 * Encrypt the given data given a base key. Returns encrypted data and a nonce that must be provided during decryption
 * @param key
 * @param rawData
 */ async function $6f7127724a699469$export$5b0f6292f11d1d18(baseKey, rawData, context) {
    const encodedData = new TextEncoder().encode(rawData);
    // The nonce must never be reused with a given key.
    const nonce = window.crypto.getRandomValues(new Uint8Array(16));
    const derivedKey = await $6f7127724a699469$var$deriveKey(baseKey, nonce, context);
    const encryptedData = await window.crypto.subtle.encrypt({
        name: $6f7127724a699469$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return {
        data: (0, $22782b013da7b52b$export$84f5a428c7153a69)(new Uint8Array(encryptedData)),
        nonce: (0, $22782b013da7b52b$export$84f5a428c7153a69)(nonce)
    };
}
/**
 * Decrypt data with the given key and nonce
 * @param key
 * @param nonce
 * @param encryptedData
 * @returns
 */ async function $6f7127724a699469$export$e85a0c9a1067c5d3(baseKey, nonce, context, encryptedData) {
    const encodedData = (0, $0d858b7a75e8c5ef$export$8f0c237d3e8188bc)(encryptedData);
    const derivedKey = await $6f7127724a699469$var$deriveKey(baseKey, (0, $0d858b7a75e8c5ef$export$8f0c237d3e8188bc)(nonce), context);
    const decryptedData = await window.crypto.subtle.decrypt({
        name: $6f7127724a699469$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return new TextDecoder().decode(decryptedData);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $6f7127724a699469$export$9169be2e06c9c165(plainText) {
    const hashBuffer = await $6f7127724a699469$export$52caff7bddbaf316(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, $22782b013da7b52b$export$84f5a428c7153a69)(hashBytes);
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d6a9baaee9b919a3$export$41d7a3d4e14d6113 = "storage_not_supported";
const $d6a9baaee9b919a3$export$1377ea690fa0b6d8 = "stubbed_public_client_application_called";
const $d6a9baaee9b919a3$export$37486e3b6bed61c6 = "in_mem_redirect_unavailable";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $06da63a64b0bddd1$export$a14089932466e176 = {
    [(0, $d6a9baaee9b919a3$export$41d7a3d4e14d6113)]: "Given storage configuration option was not supported.",
    [(0, $d6a9baaee9b919a3$export$1377ea690fa0b6d8)]: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors",
    [(0, $d6a9baaee9b919a3$export$37486e3b6bed61c6)]: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use BrowserAuthErrorCodes instead
 */ const $06da63a64b0bddd1$export$daccd9364f884077 = {
    storageNotSupportedError: {
        code: (0, $d6a9baaee9b919a3$export$41d7a3d4e14d6113),
        desc: $06da63a64b0bddd1$export$a14089932466e176[0, $d6a9baaee9b919a3$export$41d7a3d4e14d6113]
    },
    stubPcaInstanceCalled: {
        code: (0, $d6a9baaee9b919a3$export$1377ea690fa0b6d8),
        desc: $06da63a64b0bddd1$export$a14089932466e176[0, $d6a9baaee9b919a3$export$1377ea690fa0b6d8]
    },
    inMemRedirectUnavailable: {
        code: (0, $d6a9baaee9b919a3$export$37486e3b6bed61c6),
        desc: $06da63a64b0bddd1$export$a14089932466e176[0, $d6a9baaee9b919a3$export$37486e3b6bed61c6]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $06da63a64b0bddd1$export$2eb7a1dfdc4c5fba extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $06da63a64b0bddd1$export$2eb7a1dfdc4c5fba.prototype);
    }
}
function $06da63a64b0bddd1$export$176bd5050947ba0c(errorCode) {
    return new $06da63a64b0bddd1$export$2eb7a1dfdc4c5fba(errorCode, $06da63a64b0bddd1$export$a14089932466e176[errorCode]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Clears hash from window url.
 */ function $3e9f4e3d34d422a9$export$a20c3032ba81d6aa(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $3e9f4e3d34d422a9$export$9bf2691bda54425c(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $3e9f4e3d34d422a9$export$9f140ed41af5108c() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $3e9f4e3d34d422a9$export$722fdce8786cc28b() {
    return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf(`${(0, $d94c9b6ecea78646$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.`) === 0;
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $3e9f4e3d34d422a9$export$1204531fbbf6ecde() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $3e9f4e3d34d422a9$export$60785768478b4ffc() {
    const currentUrl = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(window.location.href);
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $3e9f4e3d34d422a9$export$8fdba407d8e31f54() {
    const isResponseHash = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $3e9f4e3d34d422a9$export$9f140ed41af5108c()) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$71bafc2814e56c09));
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $3e9f4e3d34d422a9$export$5ae6b09f947c8a9e(allowRedirectInIframe) {
    if ($3e9f4e3d34d422a9$export$9f140ed41af5108c() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$9cc12eb574ceee30));
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $3e9f4e3d34d422a9$export$dc99b653c8cd2cd7() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($3e9f4e3d34d422a9$export$722fdce8786cc28b()) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$c4a80c97d7b48f72));
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $3e9f4e3d34d422a9$export$c7939bfe92ae2787() {
    if (typeof window === "undefined") throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$932e0f52d657f7fb));
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $3e9f4e3d34d422a9$export$630119c5db8b5529(initialized) {
    if (!initialized) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$436657cdcd7fe2be));
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $3e9f4e3d34d422a9$export$4dd091cbdc98b52e(initialized) {
    // Block request if not in browser environment
    $3e9f4e3d34d422a9$export$c7939bfe92ae2787();
    // Block auth requests inside a hidden iframe
    $3e9f4e3d34d422a9$export$8fdba407d8e31f54();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $3e9f4e3d34d422a9$export$dc99b653c8cd2cd7();
    // Block token acquisition before initialize has been called
    $3e9f4e3d34d422a9$export$630119c5db8b5529(initialized);
}
/**
 * Helper to validate app enviornment before making redirect request
 * @param initialized
 * @param config
 */ function $3e9f4e3d34d422a9$export$62c8f4fdca4df60f(initialized, config) {
    $3e9f4e3d34d422a9$export$4dd091cbdc98b52e(initialized);
    $3e9f4e3d34d422a9$export$5ae6b09f947c8a9e(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
    if (config.cache.cacheLocation === (0, $d94c9b6ecea78646$export$573384e47a12d835).MemoryStorage && !config.cache.storeAuthStateInCookie) throw (0, $06da63a64b0bddd1$export$176bd5050947ba0c)((0, $d6a9baaee9b919a3$export$37486e3b6bed61c6));
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $3e9f4e3d34d422a9$export$a0816fa17a9e79be(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $3e9f4e3d34d422a9$export$7571c350ed9fec74() {
    return (0, $6f7127724a699469$export$6ef0355fa80a5278)();
}
const $3e9f4e3d34d422a9$export$f40e790983a9797e = (0, $1ac773f7bc3e26ca$exports).addClientCapabilitiesToClaims;


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $cd84efde5e2481ce$export$a5835ee54399d410 = 60000;
const $cd84efde5e2481ce$export$f3ffe700be354b19 = 10000;
const $cd84efde5e2481ce$export$293647e7865520c6 = 30000;
const $cd84efde5e2481ce$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $cd84efde5e2481ce$export$f8352245bee68086({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
        authority: `${(0, $6c5f3cda7e712574$export$a002182e51710d39).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: typeof window !== "undefined" ? (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)() : "",
        postLogoutRedirectUri: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $54a6ab7df522528c$export$73a3e3dedd37150d).AAD,
        OIDCOptions: {
            serverResponseType: (0, $6c5f3cda7e712574$export$b34cb6fbea2adc44).FRAGMENT,
            defaultScopes: [
                (0, $6c5f3cda7e712574$export$a002182e51710d39).OPENID_SCOPE,
                (0, $6c5f3cda7e712574$export$a002182e51710d39).PROFILE_SCOPE,
                (0, $6c5f3cda7e712574$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, $408770affa359606$export$4cda21933050d9ec).None,
            tenant: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false,
        supportsNestedAppAuth: false,
        instanceAware: false,
        encodeExtraQueryParams: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $d94c9b6ecea78646$export$573384e47a12d835).SessionStorage,
        cacheRetentionDays: 5,
        temporaryCacheLocation: (0, $d94c9b6ecea78646$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $d94c9b6ecea78646$export$573384e47a12d835).LocalStorage ? true : false,
        claimsBasedCachingEnabled: false
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, $8778110eec982731$export$f7a7dd6bfc156d75),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, $12534a979a907265$export$4c206ef5be879972)() : (0, $d9f4f8119f40a208$export$6d95060a8ed7155a),
        navigationClient: new (0, $0959b3db41cb4f80$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: userInputSystem?.loadFrameTimeout || $cd84efde5e2481ce$export$a5835ee54399d410,
        iframeHashTimeout: userInputSystem?.loadFrameTimeout || $cd84efde5e2481ce$export$f3ffe700be354b19,
        navigateFrameWait: 0,
        redirectNavigationTimeout: $cd84efde5e2481ce$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowPlatformBroker: false,
        allowPlatformBrokerWithDOM: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $cd84efde5e2481ce$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $d94c9b6ecea78646$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
        },
        client: new (0, $918248d5b9dc501b$export$c70f2989a65fda3e)()
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputAuth?.protocolMode !== (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, $9d8c7bd8b3e958dc$export$efa9a398d6368992)(providedSystemOptions.loggerOptions);
        logger.warning(JSON.stringify((0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).cannotSetOIDCOptions)));
    }
    // Throw an error if user has set allowPlatformBroker to true with OIDC protocol mode
    if (userInputAuth?.protocolMode && userInputAuth.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC && providedSystemOptions?.allowPlatformBroker) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).cannotAllowPlatformBroker);
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/* eslint-disable header/header */ const $cdd21367776b6362$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
const $cdd21367776b6362$export$83d89fbfd8236492 = "4.27.0";



/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $82743da031e636d6$export$8a682ae47622dbb9 = "msal";
const $82743da031e636d6$var$BROWSER_PREFIX = "browser";
const $82743da031e636d6$export$9e9532f57bbb139e = "|";
const $82743da031e636d6$export$ec2ec5cd3d01f05d = 2;
const $82743da031e636d6$export$4693794d1f911b27 = 2;
const $82743da031e636d6$export$b28668d53eb57e63 = `${$82743da031e636d6$export$8a682ae47622dbb9}.${$82743da031e636d6$var$BROWSER_PREFIX}.log.level`;
const $82743da031e636d6$export$d9bc1c202a3825f1 = `${$82743da031e636d6$export$8a682ae47622dbb9}.${$82743da031e636d6$var$BROWSER_PREFIX}.log.pii`;
const $82743da031e636d6$export$54408f0b0cf727d4 = `${$82743da031e636d6$export$8a682ae47622dbb9}.${$82743da031e636d6$var$BROWSER_PREFIX}.performance.enabled`;
const $82743da031e636d6$export$6825ebfedde34998 = `${$82743da031e636d6$export$8a682ae47622dbb9}.version`;
const $82743da031e636d6$export$55a9047ed9cd2b03 = "account.keys";
const $82743da031e636d6$export$332974f1fffb359a = "token.keys";
function $82743da031e636d6$export$8cef587ddea5c5f6(schema = $82743da031e636d6$export$4693794d1f911b27) {
    if (schema < 1) return `${$82743da031e636d6$export$8a682ae47622dbb9}.${$82743da031e636d6$export$55a9047ed9cd2b03}`;
    return `${$82743da031e636d6$export$8a682ae47622dbb9}.${schema}.${$82743da031e636d6$export$55a9047ed9cd2b03}`;
}
function $82743da031e636d6$export$79944bbef1910535(clientId, schema = $82743da031e636d6$export$ec2ec5cd3d01f05d) {
    if (schema < 1) return `${$82743da031e636d6$export$8a682ae47622dbb9}.${$82743da031e636d6$export$332974f1fffb359a}.${clientId}`;
    return `${$82743da031e636d6$export$8a682ae47622dbb9}.${schema}.${$82743da031e636d6$export$332974f1fffb359a}.${clientId}`;
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $b47a92f2512e1181$export$3aea257f46651b2b {
    static loggerCallback(level, message) {
        switch(level){
            case (0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, $cd84efde5e2481ce$export$f8352245bee68086)(config, this.browserEnvironment);
        let sessionStorage;
        try {
            sessionStorage = window[(0, $d94c9b6ecea78646$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, $82743da031e636d6$export$b28668d53eb57e63));
        const piiLoggingKey = sessionStorage?.getItem((0, $82743da031e636d6$export$d9bc1c202a3825f1))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d)).includes(logLevelKey) ? (0, $9d8c7bd8b3e958dc$export$243e62d78d3b544d)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $b47a92f2512e1181$export$3aea257f46651b2b.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, $9d8c7bd8b3e958dc$export$efa9a398d6368992)(loggerOptions, (0, $cdd21367776b6362$export$a8ff84c12d48cfa6), (0, $cdd21367776b6362$export$83d89fbfd8236492));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $fd6d6e346bcca7ef$export$6d05f68c12a46a00 = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $29650ba599b9ebde$export$d974b2d5dad1979e {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = $29650ba599b9ebde$export$d974b2d5dad1979e.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    $29650ba599b9ebde$export$d974b2d5dad1979e.bridgeRequests.splice($29650ba599b9ebde$export$d974b2d5dad1979e.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = $29650ba599b9ebde$export$d974b2d5dad1979e.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                $29650ba599b9ebde$export$d974b2d5dad1979e.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return $29650ba599b9ebde$export$d974b2d5dad1979e.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $29650ba599b9ebde$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.token),
            account: $29650ba599b9ebde$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, $6f7127724a699469$export$6ef0355fa80a5278)(),
            sendTime: Date.now(),
            clientLibrary: (0, $d94c9b6ecea78646$export$a0a689e4294b9880).MSAL_SKU,
            clientLibraryVersion: (0, $cdd21367776b6362$export$83d89fbfd8236492),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = $29650ba599b9ebde$export$d974b2d5dad1979e.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            $29650ba599b9ebde$export$d974b2d5dad1979e.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $29650ba599b9ebde$export$d974b2d5dad1979e.initializeNestedAppAuthBridge();
        return new $29650ba599b9ebde$export$d974b2d5dad1979e(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
$29650ba599b9ebde$export$d974b2d5dad1979e.bridgeRequests = [];


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $46eb2566ded48f95$export$a2170d4e3f010950 extends (0, $b47a92f2512e1181$export$3aea257f46651b2b) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $46eb2566ded48f95$export$a2170d4e3f010950.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $46eb2566ded48f95$export$a2170d4e3f010950.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, $29650ba599b9ebde$export$d974b2d5dad1979e).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`Could not initialize Nested App Auth bridge (${ex})`);
        }
        this.logger.info(`Nested App Auth Bridge available: ${this.available}`);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $46eb2566ded48f95$export$a2170d4e3f010950.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $46eb2566ded48f95$export$a2170d4e3f010950.ID = "NestedAppOperatingContext";


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $56db67b6066c95af$export$f39c23bbfed89e6e extends (0, $b47a92f2512e1181$export$3aea257f46651b2b) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $56db67b6066c95af$export$f39c23bbfed89e6e.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $56db67b6066c95af$export$f39c23bbfed89e6e.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $56db67b6066c95af$export$f39c23bbfed89e6e.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $56db67b6066c95af$export$f39c23bbfed89e6e.ID = "StandardOperatingContext";


/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $4394dd0d76000050$export$e2ac717a196f20ed = "missing_kid_error";
const $4394dd0d76000050$export$de67390d0a514010 = "missing_alg_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $e1631cedfef9120d$export$ce96a12d056376ad = {
    [(0, $4394dd0d76000050$export$e2ac717a196f20ed)]: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided.",
    [(0, $4394dd0d76000050$export$de67390d0a514010)]: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $e1631cedfef9120d$export$980ad46b7a115fad extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $e1631cedfef9120d$export$980ad46b7a115fad.prototype);
    }
}
/** Returns JoseHeaderError object */ function $e1631cedfef9120d$export$3ef463ea134172ed(code) {
    return new $e1631cedfef9120d$export$980ad46b7a115fad(code, $e1631cedfef9120d$export$ce96a12d056376ad[code]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $9a1afc12fe12507c$export$91748d132e6cb9b3 {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $e1631cedfef9120d$export$3ef463ea134172ed)((0, $4394dd0d76000050$export$e2ac717a196f20ed));
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $e1631cedfef9120d$export$3ef463ea134172ed)((0, $4394dd0d76000050$export$de67390d0a514010));
        const shrHeader = new $9a1afc12fe12507c$export$91748d132e6cb9b3({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $6c5f3cda7e712574$export$fe5c42ed17efe603).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}






/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $1bc4791233c36ff2$export$286b0f3b569e5f16 {
    constructor(){
        this.dbName = (0, $d94c9b6ecea78646$export$3c22ff8b64b8f565);
        this.version = (0, $d94c9b6ecea78646$export$6a9022b4c5fcea02);
        this.tableName = (0, $d94c9b6ecea78646$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$c1110692d2978b8))));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, $d94c9b6ecea78646$export$3c22ff8b64b8f565));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c17c48c8ea3147b8$export$d7392285c701ecf5 {
    constructor(){
        this.cache = new Map();
    }
    async initialize() {
    // Memory storage does not require initialization
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
    decryptData() {
        // Memory storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $b82333cd19096d72$export$b38f35aab37afcde {
    constructor(logger){
        this.inMemoryCache = new (0, $c17c48c8ea3147b8$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $1bc4791233c36ff2$export$286b0f3b569e5f16)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error) {
        if (error instanceof (0, $d8ef97823beb75e7$export$f8eb6760ca13876a) && error.errorCode === (0, $32d5e65f31c9045a$export$c1110692d2978b8)) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ async getItem(key) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ async setItem(key, value) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ async removeItem(key) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ async getKeys() {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ async containsKey(key) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     */ clearInMemory() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose(`Deleting in-memory keystore`);
        this.inMemoryCache.clear();
        this.logger.verbose(`In-memory keystore deleted`);
    }
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ async clearPersistent() {
        try {
            this.logger.verbose("Deleting persistent keystore");
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e);
            return false;
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $15ce4860f5b428a8$export$c274a7f0ebd24b14 {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, $6f7127724a699469$export$1ddcc6bab2bf2314)(skipValidateSubtleCrypto ?? false);
        this.cache = new (0, $b82333cd19096d72$export$b38f35aab37afcde)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, $6f7127724a699469$export$6ef0355fa80a5278)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, $22782b013da7b52b$export$e510a73ee562749)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, $22782b013da7b52b$export$9ef804feabbcbaf1)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        // Generate Keypair
        const keyPair = await (0, $6f7127724a699469$export$a949d36eab55b41f)($15ce4860f5b428a8$export$c274a7f0ebd24b14.EXTRACTABLE, $15ce4860f5b428a8$export$c274a7f0ebd24b14.POP_KEY_USAGES);
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, $6f7127724a699469$export$88781b8595a7d2ff)(keyPair.publicKey);
        const pubKeyThumprintObj = {
            e: publicKeyJwk.e,
            kty: publicKeyJwk.kty,
            n: publicKeyJwk.n
        };
        const publicJwkString = $15ce4860f5b428a8$var$getSortedObjectString(pubKeyThumprintObj);
        const publicJwkHash = await this.hashString(publicJwkString);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, $6f7127724a699469$export$88781b8595a7d2ff)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, $6f7127724a699469$export$8bdea4e2e3f593c9)(privateKeyJwk, false, [
            "sign"
        ]);
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        });
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ async removeTokenBindingKey(kid) {
        await this.cache.removeItem(kid);
        const keyFound = await this.cache.containsKey(kid);
        if (keyFound) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).bindingKeyNotRemoved);
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ async clearKeystore() {
        // Delete in-memory keystores
        this.cache.clearInMemory();
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent();
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`Clearing keystore failed with error: ${e.message}`);
            else this.logger.error("Clearing keystore failed with unknown error");
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
        const cachedKeyPair = await this.cache.getItem(kid);
        if (!cachedKeyPair) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$a416b0eceb5c15df));
        // Get public key as JWK
        const publicKeyJwk = await (0, $6f7127724a699469$export$88781b8595a7d2ff)(cachedKeyPair.publicKey);
        const publicKeyJwkString = $15ce4860f5b428a8$var$getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, $22782b013da7b52b$export$9ef804feabbcbaf1)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, $9a1afc12fe12507c$export$91748d132e6cb9b3).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, $22782b013da7b52b$export$9ef804feabbcbaf1)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, $22782b013da7b52b$export$9ef804feabbcbaf1)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, $6f7127724a699469$export$c5552dfdbc7cec71)(cachedKeyPair.privateKey, tokenBuffer);
        const encodedSignature = (0, $22782b013da7b52b$export$84f5a428c7153a69)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, $6f7127724a699469$export$9169be2e06c9c165)(plainText);
    }
}
$15ce4860f5b428a8$export$c274a7f0ebd24b14.POP_KEY_USAGES = [
    "sign",
    "verify"
];
$15ce4860f5b428a8$export$c274a7f0ebd24b14.EXTRACTABLE = true;
function $15ce4860f5b428a8$var$getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $36420b0d5b35cd56$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}









/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $502f1e0d8d872837$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $bba454abc25e2c71$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 

/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6f6c8f5d4b87838$export$468cda29b159ee5d = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        try {
            const result = callback(...args);
            inProgressEvent?.end({
                success: true
            });
            logger.trace(`Returning result from ${eventName}`);
            return result;
        } catch (e) {
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6f6c8f5d4b87838$export$e4feded94d9adb18 = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        telemetryClient?.setPreQueueTime(eventName, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`Returning result from ${eventName}`);
            inProgressEvent?.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        });
    };
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $de3b52de3340d9c7$export$1afa9d0f261ebb47 {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $de3b52de3340d9c7$export$1afa9d0f261ebb47.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)((0, $6c5f3cda7e712574$export$a002182e51710d39).IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === (0, $6c5f3cda7e712574$export$2b71909294c66558).SUCCESS) {
                    autodetectedRegionName = localIMDSVersionResponse.body;
                    regionDiscoveryMetadata.region_source = (0, $6c5f3cda7e712574$export$3d4a3e11df589b40).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, $6c5f3cda7e712574$export$2b71909294c66558).BAD_REQUEST) {
                    const currentIMDSVersion = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getCurrentVersion.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, $6c5f3cda7e712574$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, $6c5f3cda7e712574$export$2b71909294c66558).SUCCESS) {
                        autodetectedRegionName = currentIMDSVersionResponse.body;
                        regionDiscoveryMetadata.region_source = (0, $6c5f3cda7e712574$export$3d4a3e11df589b40).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, $6c5f3cda7e712574$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, $6c5f3cda7e712574$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $6c5f3cda7e712574$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ async getRegionFromIMDS(version, options) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
        return this.networkInterface.sendGetRequestAsync(`${(0, $6c5f3cda7e712574$export$a002182e51710d39).IMDS_ENDPOINT}?api-version=${version}&format=text`, options, (0, $6c5f3cda7e712574$export$a002182e51710d39).IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, $6c5f3cda7e712574$export$a002182e51710d39).IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, $6c5f3cda7e712574$export$2b71909294c66558).BAD_REQUEST && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$de3b52de3340d9c7$export$1afa9d0f261ebb47.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};





var $2175959ac3ad49fc$exports = {};

$parcel$export($2175959ac3ad49fc$exports, "createIdTokenEntity", () => $2175959ac3ad49fc$export$d8a173a23f325769);
$parcel$export($2175959ac3ad49fc$exports, "createAccessTokenEntity", () => $2175959ac3ad49fc$export$fa005e75d915b6db);
$parcel$export($2175959ac3ad49fc$exports, "createRefreshTokenEntity", () => $2175959ac3ad49fc$export$9095b5885dfa55cc);
$parcel$export($2175959ac3ad49fc$exports, "isCredentialEntity", () => $2175959ac3ad49fc$export$b8fc93e8af17dc04);
$parcel$export($2175959ac3ad49fc$exports, "isAccessTokenEntity", () => $2175959ac3ad49fc$export$d7e6bcc84cf680df);
$parcel$export($2175959ac3ad49fc$exports, "isIdTokenEntity", () => $2175959ac3ad49fc$export$71eec93d11c94dfc);
$parcel$export($2175959ac3ad49fc$exports, "isRefreshTokenEntity", () => $2175959ac3ad49fc$export$f1bb3af43d5b8bc7);
$parcel$export($2175959ac3ad49fc$exports, "isServerTelemetryEntity", () => $2175959ac3ad49fc$export$7ad16989078344e5);
$parcel$export($2175959ac3ad49fc$exports, "isThrottlingEntity", () => $2175959ac3ad49fc$export$7e43cc7efaf4bec2);
$parcel$export($2175959ac3ad49fc$exports, "generateAppMetadataKey", () => $2175959ac3ad49fc$export$ddbc6773ab812685);
$parcel$export($2175959ac3ad49fc$exports, "isAppMetadataEntity", () => $2175959ac3ad49fc$export$bb2a01b66d0b3486);
$parcel$export($2175959ac3ad49fc$exports, "isAuthorityMetadataEntity", () => $2175959ac3ad49fc$export$6231cab310116b3c);
$parcel$export($2175959ac3ad49fc$exports, "generateAuthorityMetadataExpiresAt", () => $2175959ac3ad49fc$export$90f464c4238c27e5);
$parcel$export($2175959ac3ad49fc$exports, "updateAuthorityEndpointMetadata", () => $2175959ac3ad49fc$export$ef87e8fbd8af5f96);
$parcel$export($2175959ac3ad49fc$exports, "updateCloudDiscoveryMetadata", () => $2175959ac3ad49fc$export$6d4972e1d88c8518);
$parcel$export($2175959ac3ad49fc$exports, "isAuthorityMetadataExpired", () => $2175959ac3ad49fc$export$b96839cf63a15b0f);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 


var $0e146ed7106c6e64$exports = {};

$parcel$export($0e146ed7106c6e64$exports, "nowSeconds", () => $0e146ed7106c6e64$export$ae62599a119ac50a);
$parcel$export($0e146ed7106c6e64$exports, "toSecondsFromDate", () => $0e146ed7106c6e64$export$13bf6a15fb02e52d);
$parcel$export($0e146ed7106c6e64$exports, "toDateFromSeconds", () => $0e146ed7106c6e64$export$dcee164673849555);
$parcel$export($0e146ed7106c6e64$exports, "isTokenExpired", () => $0e146ed7106c6e64$export$b007d77a962aa175);
$parcel$export($0e146ed7106c6e64$exports, "isCacheExpired", () => $0e146ed7106c6e64$export$d812b641f1458de4);
$parcel$export($0e146ed7106c6e64$exports, "wasClockTurnedBack", () => $0e146ed7106c6e64$export$8961be72dcbc368e);
$parcel$export($0e146ed7106c6e64$exports, "delay", () => $0e146ed7106c6e64$export$1391212d75b2ee65);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $0e146ed7106c6e64$export$ae62599a119ac50a() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * Converts JS Date object to seconds
 * @param date Date
 */ function $0e146ed7106c6e64$export$13bf6a15fb02e52d(date) {
    // Convert date to seconds
    return date.getTime() / 1000;
}
/**
 * Convert seconds to JS Date object. Seconds can be in a number or string format or undefined (will still return a date).
 * @param seconds
 */ function $0e146ed7106c6e64$export$dcee164673849555(seconds) {
    if (seconds) return new Date(Number(seconds) * 1000);
    return new Date();
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $0e146ed7106c6e64$export$b007d77a962aa175(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $0e146ed7106c6e64$export$ae62599a119ac50a() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * Checks if a cache entry is expired based on the last updated time and cache retention days.
 * @param lastUpdatedAt
 * @param cacheRetentionDays
 * @returns
 */ function $0e146ed7106c6e64$export$d812b641f1458de4(lastUpdatedAt, cacheRetentionDays) {
    const cacheExpirationTimestamp = Number(lastUpdatedAt) + cacheRetentionDays * 86400000;
    return Date.now() > cacheExpirationTimestamp;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $0e146ed7106c6e64$export$8961be72dcbc368e(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $0e146ed7106c6e64$export$ae62599a119ac50a();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function $0e146ed7106c6e64$export$1391212d75b2ee65(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $2175959ac3ad49fc$export$d8a173a23f325769(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId,
        lastUpdatedAt: Date.now().toString()
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $2175959ac3ad49fc$export$fa005e75d915b6db(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, $0e146ed7106c6e64$export$ae62599a119ac50a)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    if (requestedClaims) {
        atEntity.requestedClaims = requestedClaims;
        atEntity.requestedClaimsHash = requestedClaimsHash;
    }
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, $4f8cb1da78e4daf9$export$8a59e6f35fb00518)(accessToken, base64Decode);
                if (!tokenClaims?.cnf?.kid) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$6f89b8a7d491b526));
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, $6c5f3cda7e712574$export$901491a717da2ba5).SSH:
                atEntity.keyId = keyId;
        }
    }
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $2175959ac3ad49fc$export$9095b5885dfa55cc(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $2175959ac3ad49fc$export$b8fc93e8af17dc04(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $2175959ac3ad49fc$export$d7e6bcc84cf680df(entity) {
    if (!entity) return false;
    return $2175959ac3ad49fc$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $2175959ac3ad49fc$export$71eec93d11c94dfc(entity) {
    if (!entity) return false;
    return $2175959ac3ad49fc$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $2175959ac3ad49fc$export$f1bb3af43d5b8bc7(entity) {
    if (!entity) return false;
    return $2175959ac3ad49fc$export$b8fc93e8af17dc04(entity) && entity["credentialType"] === (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).REFRESH_TOKEN;
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $2175959ac3ad49fc$export$7ad16989078344e5(key, entity) {
    const validateKey = key.indexOf((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $2175959ac3ad49fc$export$7e43cc7efaf4bec2(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, $6c5f3cda7e712574$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $2175959ac3ad49fc$export$ddbc6773ab812685({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        (0, $6c5f3cda7e712574$export$7e1bea6dc1b6b32e),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, $6c5f3cda7e712574$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $2175959ac3ad49fc$export$bb2a01b66d0b3486(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $6c5f3cda7e712574$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $2175959ac3ad49fc$export$6231cab310116b3c(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $6c5f3cda7e712574$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $2175959ac3ad49fc$export$90f464c4238c27e5() {
    return (0, $0e146ed7106c6e64$export$ae62599a119ac50a)() + (0, $6c5f3cda7e712574$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
}
function $2175959ac3ad49fc$export$ef87e8fbd8af5f96(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
function $2175959ac3ad49fc$export$6d4972e1d88c8518(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 */ function $2175959ac3ad49fc$export$b96839cf63a15b0f(metadata) {
    return metadata.expiresAt <= (0, $0e146ed7106c6e64$export$ae62599a119ac50a)();
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $55d9936263fe2e81$export$f1c6ec2e6d68c49c {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, $de3b52de3340d9c7$export$1afa9d0f261ebb47)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $6c5f3cda7e712574$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $e4974a8758ed20fc$export$cd82032b224a3839).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $6c5f3cda7e712574$export$a002182e51710d39).ADFS:
                return (0, $e4974a8758ed20fc$export$cd82032b224a3839).Adfs;
            case (0, $6c5f3cda7e712574$export$a002182e51710d39).DSTS:
                return (0, $e4974a8758ed20fc$export$cd82032b224a3839).Dsts;
        }
        return (0, $e4974a8758ed20fc$export$cd82032b224a3839).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(url);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c3bd741c16a889f3));
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$55d9936263fe2e81$export$f1c6ec2e6d68c49c.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $e4974a8758ed20fc$export$cd82032b224a3839).Default && this.protocolMode !== (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`Replacing tenant domain name ${cachedPart} with id ${tenantId}`);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, $e4974a8758ed20fc$export$cd82032b224a3839).Adfs || this.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.updateCloudDiscoveryMetadata.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.updateEndpointMetadata.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwiser returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, $2175959ac3ad49fc$export$90f464c4238c27e5)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).CACHE && endpointMetadataResult?.source !== (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, $2175959ac3ad49fc$export$90f464c4238c27e5)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, $2175959ac3ad49fc$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getEndpointMetadataFromNetwork.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, $2175959ac3ad49fc$export$ef87e8fbd8af5f96)(metadataEntity, metadata, true);
            return (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$73566da29bc073eb), this.defaultOpenIdConfigurationEndpoint);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get endpoint metadata from authority configuration");
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("Found endpoint metadata in authority configuration");
            (0, $2175959ac3ad49fc$export$ef87e8fbd8af5f96)(metadataEntity, configMetadata, false);
            return {
                source: (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).CONFIG
            };
        }
        this.logger.verbose("Did not find endpoint metadata in the config... Attempting to get endpoint metadata from the hardcoded values.");
        // skipAuthorityMetadataCache is used to bypass hardcoded authority metadata and force a network metadata cache lookup and network metadata request if no cached response is available.
        if (this.authorityOptions.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get endpoint metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
            if (hardcodedMetadata) {
                (0, $2175959ac3ad49fc$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                return {
                    source: (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).HARDCODED_VALUES,
                    metadata: hardcodedMetadata
                };
            } else this.logger.verbose("Did not find endpoint metadata in hardcoded values... Attempting to get endpoint metadata from the network metadata cache.");
        }
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, $2175959ac3ad49fc$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("Found endpoint metadata in the cache.");
            return {
                source: (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$edb4d5942bc8ccff));
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: attempting to retrieve OAuth endpoints from ${openIdConfigurationEndpoint}`);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, $36420b0d5b35cd56$export$aab44dc88900a3b)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: could not parse response as OpenID configuration`);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: ${e}`);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, $a59d185da4abcbb3$export$f612854287391207)) return (0, $a59d185da4abcbb3$export$f612854287391207)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, $6c5f3cda7e712574$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = (0, $6c5f3cda7e712574$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $55d9936263fe2e81$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion);
            }
            const autodetectedRegionName = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, $978df372b022f65e$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, $6c5f3cda7e712574$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $55d9936263fe2e81$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, autodetectedRegionName);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, $6c5f3cda7e712574$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, $2175959ac3ad49fc$export$6d4972e1d88c8518)(metadataEntity, metadata, true);
            return (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$50c3162fda5f57));
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get cloud discovery metadata  from authority configuration");
        this.logger.verbosePii(`Known Authorities: ${this.authorityOptions.knownAuthorities || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Authority Metadata: ${this.authorityOptions.authorityMetadata || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Canonical Authority: ${metadataEntity.canonical_authority || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_APPLICABLE}`);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("Found cloud discovery metadata in authority configuration");
            (0, $2175959ac3ad49fc$export$6d4972e1d88c8518)(metadataEntity, metadata, false);
            return (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the hardcoded values.");
        if (this.options.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded cloud discovery metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get cloud discovery metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = (0, $a59d185da4abcbb3$export$1b1433f93c9873f)(this.hostnameAndPort);
            if (hardcodedMetadata) {
                this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                (0, $2175959ac3ad49fc$export$6d4972e1d88c8518)(metadataEntity, hardcodedMetadata, false);
                return (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).HARDCODED_VALUES;
            }
            this.logger.verbose("Did not find cloud discovery metadata in hardcoded values... Attempting to get cloud discovery metadata from the network metadata cache.");
        }
        const metadataEntityExpired = (0, $2175959ac3ad49fc$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("Found cloud discovery metadata in the cache.");
            // No need to update
            return (0, $6c5f3cda7e712574$export$5d365d77acfcb55d).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $e4974a8758ed20fc$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return $55d9936263fe2e81$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, $a59d185da4abcbb3$export$6e21098ea6e60dc)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$92a2985751150ca5));
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return $55d9936263fe2e81$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
        const instanceDiscoveryEndpoint = `${(0, $6c5f3cda7e712574$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, $502f1e0d8d872837$export$b288ea4a1e969e42)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`tenant_discovery_endpoint is: ${typedResponseBody.tenant_discovery_endpoint}`);
            } else if ((0, $bba454abc25e2c71$export$6716273459d383f8)(response.body)) {
                this.logger.warning(`A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: ${response.status}`);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, $6c5f3cda7e712574$export$a002182e51710d39).INVALID_INSTANCE) {
                    this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                    return null;
                }
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error is ${typedResponseBody.error}`);
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error description is ${typedResponseBody.error_description}`);
                this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                metadata = [];
            } else {
                this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                return null;
            }
            this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
            match = (0, $a59d185da4abcbb3$export$6e21098ea6e60dc)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) this.logger.error(`There was a network error while attempting to get the cloud discovery instance metadata.\nError: ${error.errorCode}\nError Description: ${error.errorMessage}`);
            else {
                const typedError = error;
                this.logger.error(`A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: ${typedError.name}\nError Description: ${typedError.message}`);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
            this.logger.verbose("Creating custom Authority for custom domain scenario.");
            match = $55d9936263fe2e81$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ isInKnownAuthorities() {
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === this.hostnameAndPort;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $408770affa359606$export$4cda21933050d9ec).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $6c5f3cda7e712574$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return (0, $6c5f3cda7e712574$export$a002182e51710d39).DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, $a59d185da4abcbb3$export$7d026f079148cd31).has(host);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, $6c5f3cda7e712574$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${(0, $6c5f3cda7e712574$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $55d9936263fe2e81$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion);
        regionalMetadata.token_endpoint = $55d9936263fe2e81$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $55d9936263fe2e81$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(authority);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $6c5f3cda7e712574$export$a002182e51710d39).CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${(0, $6c5f3cda7e712574$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$55d9936263fe2e81$export$f1c6ec2e6d68c49c.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, $6c5f3cda7e712574$export$e18ac120172ed505).COMMON,
    (0, $6c5f3cda7e712574$export$e18ac120172ed505).CONSUMERS,
    (0, $6c5f3cda7e712574$export$e18ac120172ed505).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $55d9936263fe2e81$export$6ed5af33d279fbc7(authority) {
    const authorityUrl = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(authority);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, $6c5f3cda7e712574$export$e18ac120172ed505).COMMON:
        case (0, $6c5f3cda7e712574$export$e18ac120172ed505).ORGANIZATIONS:
        case (0, $6c5f3cda7e712574$export$e18ac120172ed505).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $55d9936263fe2e81$export$4030f3538167cb9e(authorityUri) {
    return authorityUri.endsWith((0, $6c5f3cda7e712574$export$a002182e51710d39).FORWARD_SLASH) ? authorityUri : `${authorityUri}${(0, $6c5f3cda7e712574$export$a002182e51710d39).FORWARD_SLASH}`;
}
function $55d9936263fe2e81$export$2b9ebf6f25078cc0(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$92a2985751150ca5));
    }
    return {
        canonicalAuthority: authOptions.authority ? $55d9936263fe2e81$export$4030f3538167cb9e(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}

/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $58fde9510481ec07$export$2daa8cfcf54c2b48(clientId, request, homeAccountId) {
    return {
        clientId: clientId,
        authority: request.authority,
        scopes: request.scopes,
        homeAccountIdentifier: homeAccountId,
        claims: request.claims,
        authenticationScheme: request.authenticationScheme,
        resourceRequestMethod: request.resourceRequestMethod,
        resourceRequestUri: request.resourceRequestUri,
        shrClaims: request.shrClaims,
        sshKid: request.sshKid,
        embeddedClientId: request.embeddedClientId || request.tokenBodyParameters?.clientId
    };
}

/*! @azure/msal-common v15.13.3 2025-12-04 */ 

var $802def46dc9c1a5c$exports = {};

$parcel$export($802def46dc9c1a5c$exports, "noTokensFound", () => $802def46dc9c1a5c$export$e408b083cd212696);
$parcel$export($802def46dc9c1a5c$exports, "nativeAccountUnavailable", () => $802def46dc9c1a5c$export$3bf2eb3358f5f570);
$parcel$export($802def46dc9c1a5c$exports, "refreshTokenExpired", () => $802def46dc9c1a5c$export$a90e8b9c10991b49);
$parcel$export($802def46dc9c1a5c$exports, "uxNotAllowed", () => $802def46dc9c1a5c$export$a58b5e049da4f1a6);
$parcel$export($802def46dc9c1a5c$exports, "interactionRequired", () => $802def46dc9c1a5c$export$cdb77bf88e749c31);
$parcel$export($802def46dc9c1a5c$exports, "consentRequired", () => $802def46dc9c1a5c$export$ca4e8d96d12fe4c5);
$parcel$export($802def46dc9c1a5c$exports, "loginRequired", () => $802def46dc9c1a5c$export$402ebc0f96d7decb);
$parcel$export($802def46dc9c1a5c$exports, "badToken", () => $802def46dc9c1a5c$export$2e3666c77d45a4da);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Codes defined by MSAL
const $802def46dc9c1a5c$export$e408b083cd212696 = "no_tokens_found";
const $802def46dc9c1a5c$export$3bf2eb3358f5f570 = "native_account_unavailable";
const $802def46dc9c1a5c$export$a90e8b9c10991b49 = "refresh_token_expired";
const $802def46dc9c1a5c$export$a58b5e049da4f1a6 = "ux_not_allowed";
// Codes potentially returned by server
const $802def46dc9c1a5c$export$cdb77bf88e749c31 = "interaction_required";
const $802def46dc9c1a5c$export$ca4e8d96d12fe4c5 = "consent_required";
const $802def46dc9c1a5c$export$402ebc0f96d7decb = "login_required";
const $802def46dc9c1a5c$export$2e3666c77d45a4da = "bad_token";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $6fdc601aa485fcf1$export$e16d6a6c677acec5 = [
    (0, $802def46dc9c1a5c$export$cdb77bf88e749c31),
    (0, $802def46dc9c1a5c$export$ca4e8d96d12fe4c5),
    (0, $802def46dc9c1a5c$export$402ebc0f96d7decb),
    (0, $802def46dc9c1a5c$export$2e3666c77d45a4da),
    (0, $802def46dc9c1a5c$export$a58b5e049da4f1a6)
];
const $6fdc601aa485fcf1$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token"
];
const $6fdc601aa485fcf1$var$InteractionRequiredAuthErrorMessages = {
    [(0, $802def46dc9c1a5c$export$e408b083cd212696)]: "No refresh token found in the cache. Please sign-in.",
    [(0, $802def46dc9c1a5c$export$3bf2eb3358f5f570)]: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API.",
    [(0, $802def46dc9c1a5c$export$a90e8b9c10991b49)]: "Refresh token has expired.",
    [(0, $802def46dc9c1a5c$export$2e3666c77d45a4da)]: "Identity provider returned bad_token due to an expired or invalid refresh token. Please invoke an interactive API to resolve.",
    [(0, $802def46dc9c1a5c$export$a58b5e049da4f1a6)]: "`canShowUI` flag in Edge was set to false. User interaction required on web page. Please invoke an interactive API to resolve."
};
/**
 * Interaction required errors defined by the SDK
 * @deprecated Use InteractionRequiredAuthErrorCodes instead
 */ const $6fdc601aa485fcf1$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: (0, $802def46dc9c1a5c$export$e408b083cd212696),
        desc: $6fdc601aa485fcf1$var$InteractionRequiredAuthErrorMessages[0, $802def46dc9c1a5c$export$e408b083cd212696]
    },
    native_account_unavailable: {
        code: (0, $802def46dc9c1a5c$export$3bf2eb3358f5f570),
        desc: $6fdc601aa485fcf1$var$InteractionRequiredAuthErrorMessages[0, $802def46dc9c1a5c$export$3bf2eb3358f5f570]
    },
    bad_token: {
        code: (0, $802def46dc9c1a5c$export$2e3666c77d45a4da),
        desc: $6fdc601aa485fcf1$var$InteractionRequiredAuthErrorMessages[0, $802def46dc9c1a5c$export$2e3666c77d45a4da]
    }
};
/**
 * Error thrown when user interaction is required.
 */ class $6fdc601aa485fcf1$export$6ba3e818c6bc76ba extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims, errorNo){
        super(errorCode, errorMessage, subError);
        Object.setPrototypeOf(this, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba.prototype);
        this.timestamp = timestamp || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.traceId = traceId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.correlationId = correlationId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.claims = claims || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $6fdc601aa485fcf1$export$376c3c4c19cb933a(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $6fdc601aa485fcf1$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $6fdc601aa485fcf1$export$9689959ec6716811.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $6fdc601aa485fcf1$export$e16d6a6c677acec5.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $6fdc601aa485fcf1$export$8f7a741750c16535(errorCode) {
    return new $6fdc601aa485fcf1$export$6ba3e818c6bc76ba(errorCode, $6fdc601aa485fcf1$var$InteractionRequiredAuthErrorMessages[errorCode]);
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 



/*! @azure/msal-browser v4.27.0 2025-12-04 */ 





/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $be605cc436241a1d$var$COOKIE_LIFE_MULTIPLIER = 86400000;
const $be605cc436241a1d$export$b18f4dec3e412d34 = {
    Lax: "Lax",
    None: "None"
};
class $be605cc436241a1d$export$dae7d845015939d5 {
    initialize() {
        return Promise.resolve();
    }
    getItem(key) {
        const name = `${encodeURIComponent(key)}`;
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i];
            const [key, ...rest] = decodeURIComponent(cookie).trim().split("=");
            const value = rest.join("=");
            if (key === name) return value;
        }
        return "";
    }
    getUserData() {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).methodNotImplemented);
    }
    setItem(key, value, cookieLifeDays, secure = true, sameSite = $be605cc436241a1d$export$b18f4dec3e412d34.Lax) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=${sameSite};`;
        if (cookieLifeDays) {
            const expireTime = $be605cc436241a1d$export$b720d871a37fa65(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure || sameSite === $be605cc436241a1d$export$b18f4dec3e412d34.None) // SameSite None requires Secure flag
        cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    async setUserData() {
        return Promise.reject((0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).methodNotImplemented));
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const cookieParts = decodeURIComponent(cookie).trim().split("=");
            keys.push(cookieParts[0]);
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
    decryptData() {
        // Cookie storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $be605cc436241a1d$export$b720d871a37fa65(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $be605cc436241a1d$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}



/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns a list of cache keys for all known accounts
 * @param storage
 * @returns
 */ function $adebb03b44a6887e$export$beb6809f8bbb3df6(storage, schemaVersion) {
    const accountKeys = storage.getItem((0, $82743da031e636d6$export$8cef587ddea5c5f6)(schemaVersion));
    if (accountKeys) return JSON.parse(accountKeys);
    return [];
}
/**
 * Returns a list of cache keys for all known tokens
 * @param clientId
 * @param storage
 * @returns
 */ function $adebb03b44a6887e$export$ee837b3b857e6cf8(clientId, storage, schemaVersion) {
    const item = storage.getItem((0, $82743da031e636d6$export$79944bbef1910535)(clientId, schemaVersion));
    if (item) {
        const tokenKeys = JSON.parse(item);
        if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
    }
    return {
        idToken: [],
        accessToken: [],
        refreshToken: []
    };
}



/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $64a257c4fae463d7$export$691b4523c5340423(data) {
    return data.hasOwnProperty("id") && data.hasOwnProperty("nonce") && data.hasOwnProperty("data");
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $83389795bce34632$var$ENCRYPTION_KEY = "msal.cache.encryption";
const $83389795bce34632$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.cache";
class $83389795bce34632$export$19fffca37ef3e106 {
    constructor(clientId, logger, performanceClient){
        if (!window.localStorage) throw (0, $06da63a64b0bddd1$export$176bd5050947ba0c)((0, $d6a9baaee9b919a3$export$41d7a3d4e14d6113));
        this.memoryStorage = new (0, $c17c48c8ea3147b8$export$d7392285c701ecf5)();
        this.initialized = false;
        this.clientId = clientId;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.broadcast = new BroadcastChannel($83389795bce34632$var$BROADCAST_CHANNEL_NAME);
    }
    async initialize(correlationId) {
        const cookies = new (0, $be605cc436241a1d$export$dae7d845015939d5)();
        const cookieString = cookies.getItem($83389795bce34632$var$ENCRYPTION_KEY);
        let parsedCookie = {
            key: "",
            id: ""
        };
        if (cookieString) try {
            parsedCookie = JSON.parse(cookieString);
        } catch (e) {}
        if (parsedCookie.key && parsedCookie.id) {
            // Encryption key already exists, import
            const baseKey = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $0d858b7a75e8c5ef$export$8f0c237d3e8188bc), (0, $978df372b022f65e$export$2f2811a3e1b21823).Base64Decode, this.logger, this.performanceClient, correlationId)(parsedCookie.key);
            this.encryptionCookie = {
                id: parsedCookie.id,
                key: await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$5a71d4e3178f19c4), (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
        } else {
            // Encryption key doesn't exist or is invalid, generate a new one
            const id = (0, $6f7127724a699469$export$6ef0355fa80a5278)();
            const baseKey = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$1222fa1cada87c76), (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateBaseKey, this.logger, this.performanceClient, correlationId)();
            const keyStr = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $22782b013da7b52b$export$84f5a428c7153a69), (0, $978df372b022f65e$export$2f2811a3e1b21823).UrlEncodeArr, this.logger, this.performanceClient, correlationId)(new Uint8Array(baseKey));
            this.encryptionCookie = {
                id: id,
                key: await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$5a71d4e3178f19c4), (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
            const cookieData = {
                id: id,
                key: keyStr
            };
            cookies.setItem($83389795bce34632$var$ENCRYPTION_KEY, JSON.stringify(cookieData), 0, true, (0, $be605cc436241a1d$export$b18f4dec3e412d34).None // SameSite must be None to support iframed apps
            );
        }
        await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.importExistingCache.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).ImportExistingCache, this.logger, this.performanceClient, correlationId)(correlationId);
        // Register listener for cache updates in other tabs
        this.broadcast.addEventListener("message", this.updateCache.bind(this));
        this.initialized = true;
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    getUserData(key) {
        if (!this.initialized) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$436657cdcd7fe2be));
        return this.memoryStorage.getItem(key);
    }
    async decryptData(key, data, correlationId) {
        if (!this.initialized || !this.encryptionCookie) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$436657cdcd7fe2be));
        if (data.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$e85a0c9a1067c5d3), (0, $978df372b022f65e$export$2f2811a3e1b21823).Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, data.nonce, this.getContext(key), data.data);
        if (!decryptedData) return null;
        try {
            return {
                ...JSON.parse(decryptedData),
                lastUpdatedAt: data.lastUpdatedAt
            };
        } catch (e) {
            this.performanceClient.incrementFields({
                encryptedCacheCorruptionCount: 1
            }, correlationId);
            return null;
        }
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    async setUserData(key, value, correlationId, timestamp, kmsi) {
        if (!this.initialized || !this.encryptionCookie) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$436657cdcd7fe2be));
        if (kmsi) this.setItem(key, value);
        else {
            const { data: data, nonce: nonce } = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$5b0f6292f11d1d18), (0, $978df372b022f65e$export$2f2811a3e1b21823).Encrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, value, this.getContext(key));
            const encryptedData = {
                id: this.encryptionCookie.id,
                nonce: nonce,
                data: data,
                lastUpdatedAt: timestamp
            };
            this.setItem(key, JSON.stringify(encryptedData));
        }
        this.memoryStorage.setItem(key, value);
        // Notify other frames to update their in-memory cache
        this.broadcast.postMessage({
            key: key,
            value: value,
            context: this.getContext(key)
        });
    }
    removeItem(key) {
        if (this.memoryStorage.containsKey(key)) {
            this.memoryStorage.removeItem(key);
            this.broadcast.postMessage({
                key: key,
                value: null,
                context: this.getContext(key)
            });
        }
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
    /**
     * Removes all known MSAL keys from the cache
     */ clear() {
        // Removes all remaining MSAL cache items
        this.memoryStorage.clear();
        const accountKeys = (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this);
        accountKeys.forEach((key)=>this.removeItem(key));
        const tokenKeys = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken.forEach((key)=>this.removeItem(key));
        tokenKeys.accessToken.forEach((key)=>this.removeItem(key));
        tokenKeys.refreshToken.forEach((key)=>this.removeItem(key));
        // Clean up anything left
        this.getKeys().forEach((cacheKey)=>{
            if (cacheKey.startsWith((0, $82743da031e636d6$export$8a682ae47622dbb9)) || cacheKey.indexOf(this.clientId) !== -1) this.removeItem(cacheKey);
        });
    }
    /**
     * Helper to decrypt all known MSAL keys in localStorage and save them to inMemory storage
     * @returns
     */ async importExistingCache(correlationId) {
        if (!this.encryptionCookie) return;
        let accountKeys = (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this);
        accountKeys = await this.importArray(accountKeys, correlationId);
        // Write valid account keys back to map
        if (accountKeys.length) this.setItem((0, $82743da031e636d6$export$8cef587ddea5c5f6)(), JSON.stringify(accountKeys));
        else this.removeItem((0, $82743da031e636d6$export$8cef587ddea5c5f6)());
        const tokenKeys = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this);
        tokenKeys.idToken = await this.importArray(tokenKeys.idToken, correlationId);
        tokenKeys.accessToken = await this.importArray(tokenKeys.accessToken, correlationId);
        tokenKeys.refreshToken = await this.importArray(tokenKeys.refreshToken, correlationId);
        // Write valid token keys back to map
        if (tokenKeys.idToken.length || tokenKeys.accessToken.length || tokenKeys.refreshToken.length) this.setItem((0, $82743da031e636d6$export$79944bbef1910535)(this.clientId), JSON.stringify(tokenKeys));
        else this.removeItem((0, $82743da031e636d6$export$79944bbef1910535)(this.clientId));
    }
    /**
     * Helper to decrypt and save cache entries
     * @param key
     * @returns
     */ async getItemFromEncryptedCache(key, correlationId) {
        if (!this.encryptionCookie) return null;
        const rawCache = this.getItem(key);
        if (!rawCache) return null;
        let encObj;
        try {
            encObj = JSON.parse(rawCache);
        } catch (e) {
            // Not a valid encrypted object, remove
            return null;
        }
        if (!(0, $64a257c4fae463d7$export$691b4523c5340423)(encObj)) {
            // Data is not encrypted
            this.performanceClient.incrementFields({
                unencryptedCacheCount: 1
            }, correlationId);
            return rawCache;
        }
        if (encObj.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        this.performanceClient.incrementFields({
            encryptedCacheCount: 1
        }, correlationId);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$e85a0c9a1067c5d3), (0, $978df372b022f65e$export$2f2811a3e1b21823).Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, encObj.nonce, this.getContext(key), encObj.data);
    }
    /**
     * Helper to decrypt and save an array of cache keys
     * @param arr
     * @returns Array of keys successfully imported
     */ async importArray(arr, correlationId) {
        const importedArr = [];
        const promiseArr = [];
        arr.forEach((key)=>{
            const promise = this.getItemFromEncryptedCache(key, correlationId).then((value)=>{
                if (value) {
                    this.memoryStorage.setItem(key, value);
                    importedArr.push(key);
                } else // If value is empty, unencrypted or expired remove
                this.removeItem(key);
            });
            promiseArr.push(promise);
        });
        await Promise.all(promiseArr);
        return importedArr;
    }
    /**
     * Gets encryption context for a given cache entry. This is clientId for app specific entries, empty string for shared entries
     * @param key
     * @returns
     */ getContext(key) {
        let context = "";
        if (key.includes(this.clientId)) context = this.clientId; // Used to bind encryption key to this appId
        return context;
    }
    updateCache(event) {
        this.logger.trace("Updating internal cache from broadcast event");
        const perfMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).LocalStorageUpdated);
        perfMeasurement.add({
            isBackground: true
        });
        const { key: key, value: value, context: context } = event.data;
        if (!key) {
            this.logger.error("Broadcast event missing key");
            perfMeasurement.end({
                success: false,
                errorCode: "noKey"
            });
            return;
        }
        if (context && context !== this.clientId) {
            this.logger.trace(`Ignoring broadcast event from clientId: ${context}`);
            perfMeasurement.end({
                success: false,
                errorCode: "contextMismatch"
            });
            return;
        }
        if (!value) {
            this.memoryStorage.removeItem(key);
            this.logger.verbose("Removed item from internal cache");
        } else {
            this.memoryStorage.setItem(key, value);
            this.logger.verbose("Updated item in internal cache");
        }
        perfMeasurement.end({
            success: true
        });
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $81ed4695d20b9a5d$export$2c4b17e1c2e0931 {
    constructor(){
        if (!window.sessionStorage) throw (0, $06da63a64b0bddd1$export$176bd5050947ba0c)((0, $d6a9baaee9b919a3$export$41d7a3d4e14d6113));
    }
    async initialize() {
    // Session storage does not require initialization
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
    decryptData() {
        // Session storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}







/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9140a68e3a7e9307$export$3d7865934588d77e = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACCOUNT_ADDED: "msal:accountAdded",
    ACCOUNT_REMOVED: "msal:accountRemoved",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_START: "msal:loginStart",
    LOGIN_SUCCESS: "msal:loginSuccess",
    LOGIN_FAILURE: "msal:loginFailure",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    SSO_SILENT_START: "msal:ssoSilentStart",
    SSO_SILENT_SUCCESS: "msal:ssoSilentSuccess",
    SSO_SILENT_FAILURE: "msal:ssoSilentFailure",
    ACQUIRE_TOKEN_BY_CODE_START: "msal:acquireTokenByCodeStart",
    ACQUIRE_TOKEN_BY_CODE_SUCCESS: "msal:acquireTokenByCodeSuccess",
    ACQUIRE_TOKEN_BY_CODE_FAILURE: "msal:acquireTokenByCodeFailure",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
    BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
};




/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility function to remove an element from an array in place.
 * @param array - The array from which to remove the element.
 * @param element - The element to remove from the array.
 */ function $25496c73929d0eac$export$f6b67b4ecd4149d9(array, element) {
    const index = array.indexOf(element);
    if (index > -1) array.splice(index, 1);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ class $1e67d23838b7b4f7$export$44d7291b5c8cc149 extends (0, $6d50c43f626b7d71$export$996e3ea69314b5c6) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, performanceClient, eventHandler, staticAuthorityOptions){
        super(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, $c17c48c8ea3147b8$export$d7392285c701ecf5)();
        this.browserStorage = $1e67d23838b7b4f7$var$getStorageImplementation(clientId, cacheConfig.cacheLocation, logger, performanceClient);
        this.temporaryCacheStorage = $1e67d23838b7b4f7$var$getStorageImplementation(clientId, cacheConfig.temporaryCacheLocation, logger, performanceClient);
        this.cookieStorage = new (0, $be605cc436241a1d$export$dae7d845015939d5)();
        this.eventHandler = eventHandler;
    }
    async initialize(correlationId) {
        this.performanceClient.addFields({
            cacheLocation: this.cacheConfig.cacheLocation,
            cacheRetentionDays: this.cacheConfig.cacheRetentionDays
        }, correlationId);
        await this.browserStorage.initialize(correlationId);
        await this.migrateExistingCache(correlationId);
        this.trackVersionChanges(correlationId);
    }
    /**
     * Migrates any existing cache data from previous versions of MSAL.js into the current cache structure.
     */ async migrateExistingCache(correlationId) {
        let accountKeys = (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this.browserStorage);
        let tokenKeys = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            preMigrateAcntCount: accountKeys.length,
            preMigrateATCount: tokenKeys.accessToken.length,
            preMigrateITCount: tokenKeys.idToken.length,
            preMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
        for(let i = 0; i < (0, $82743da031e636d6$export$4693794d1f911b27); i++){
            const credentialSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.removeStaleAccounts(i, credentialSchema, correlationId);
        }
        // Must migrate idTokens first to ensure we have KMSI info for the rest
        for(let i = 0; i < (0, $82743da031e636d6$export$ec2ec5cd3d01f05d); i++){
            const accountSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.migrateIdTokens(i, accountSchema, correlationId);
        }
        const kmsiMap = this.getKMSIValues();
        for(let i = 0; i < (0, $82743da031e636d6$export$ec2ec5cd3d01f05d); i++){
            await this.migrateAccessTokens(i, kmsiMap, correlationId);
            await this.migrateRefreshTokens(i, kmsiMap, correlationId);
        }
        accountKeys = (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this.browserStorage);
        tokenKeys = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            postMigrateAcntCount: accountKeys.length,
            postMigrateATCount: tokenKeys.accessToken.length,
            postMigrateITCount: tokenKeys.idToken.length,
            postMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
    }
    /**
     * Parses entry, adds lastUpdatedAt if it doesn't exist, removes entry if expired or invalid
     * @param key
     * @param correlationId
     * @returns
     */ async updateOldEntry(key, correlationId) {
        const rawValue = this.browserStorage.getItem(key);
        const parsedValue = this.validateAndParseJson(rawValue || "");
        if (!parsedValue) {
            this.browserStorage.removeItem(key);
            return null;
        }
        if (!parsedValue.lastUpdatedAt) {
            // Add lastUpdatedAt to the existing v0 entry if it doesnt exist so we know when it's safe to remove it
            parsedValue.lastUpdatedAt = Date.now().toString();
            this.setItem(key, JSON.stringify(parsedValue), correlationId);
        } else if ((0, $0e146ed7106c6e64$exports).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
            this.browserStorage.removeItem(key);
            this.performanceClient.incrementFields({
                expiredCacheRemovedCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = (0, $64a257c4fae463d7$export$691b4523c5340423)(parsedValue) ? await this.browserStorage.decryptData(key, parsedValue, correlationId) : parsedValue;
        if (!decryptedData || !(0, $2175959ac3ad49fc$exports).isCredentialEntity(decryptedData)) {
            this.performanceClient.incrementFields({
                invalidCacheCount: 1
            }, correlationId);
            return null;
        }
        if (((0, $2175959ac3ad49fc$exports).isAccessTokenEntity(decryptedData) || (0, $2175959ac3ad49fc$exports).isRefreshTokenEntity(decryptedData)) && decryptedData.expiresOn && (0, $0e146ed7106c6e64$exports).isTokenExpired(decryptedData.expiresOn, (0, $6c5f3cda7e712574$export$8d50f42618161d1a))) {
            this.browserStorage.removeItem(key);
            this.performanceClient.incrementFields({
                expiredCacheRemovedCount: 1
            }, correlationId);
            return null;
        }
        return decryptedData;
    }
    /**
     * Remove accounts from the cache for older schema versions if they have not been updated in the last cacheRetentionDays
     * @param accountSchema
     * @param credentialSchema
     * @param correlationId
     * @returns
     */ async removeStaleAccounts(accountSchema, credentialSchema, correlationId) {
        const accountKeysToCheck = (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this.browserStorage, accountSchema);
        if (accountKeysToCheck.length === 0) return;
        for (const accountKey of [
            ...accountKeysToCheck
        ]){
            this.performanceClient.incrementFields({
                oldAcntCount: 1
            }, correlationId);
            const rawValue = this.browserStorage.getItem(accountKey);
            const parsedValue = this.validateAndParseJson(rawValue || "");
            if (!parsedValue) {
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(accountKeysToCheck, accountKey);
                continue;
            }
            if (!parsedValue.lastUpdatedAt) {
                // Add lastUpdatedAt to the existing entry if it doesnt exist so we know when it's safe to remove it
                parsedValue.lastUpdatedAt = Date.now().toString();
                this.setItem(accountKey, JSON.stringify(parsedValue), correlationId);
                continue;
            } else if ((0, $0e146ed7106c6e64$exports).isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
                // Cache expired remove account and associated tokens
                await this.removeAccountOldSchema(accountKey, parsedValue, credentialSchema, correlationId);
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(accountKeysToCheck, accountKey);
            }
        }
        this.setAccountKeys(accountKeysToCheck, correlationId, accountSchema);
    }
    /**
     * Remove the given account and all associated tokens from the cache
     * @param accountKey
     * @param rawObject
     * @param credentialSchema
     * @param correlationId
     */ async removeAccountOldSchema(accountKey, rawObject, credentialSchema, correlationId) {
        const decryptedData = (0, $64a257c4fae463d7$export$691b4523c5340423)(rawObject) ? await this.browserStorage.decryptData(accountKey, rawObject, correlationId) : rawObject;
        const homeAccountId = decryptedData?.homeAccountId;
        if (homeAccountId) {
            const tokenKeys = this.getTokenKeys(credentialSchema);
            [
                ...tokenKeys.idToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(tokenKeys.idToken, key);
            });
            [
                ...tokenKeys.accessToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(tokenKeys.accessToken, key);
            });
            [
                ...tokenKeys.refreshToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(tokenKeys.refreshToken, key);
            });
            this.setTokenKeys(tokenKeys, correlationId, credentialSchema);
        }
        this.performanceClient.incrementFields({
            expiredAcntRemovedCount: 1
        }, correlationId);
        this.browserStorage.removeItem(accountKey);
    }
    /**
     * Gets key value pair mapping homeAccountId to KMSI value
     * @returns
     */ getKMSIValues() {
        const kmsiMap = {};
        const tokenKeys = this.getTokenKeys().idToken;
        for (const key of tokenKeys){
            const rawValue = this.browserStorage.getUserData(key);
            if (rawValue) {
                const idToken = JSON.parse(rawValue);
                const claims = (0, $4f8cb1da78e4daf9$exports).extractTokenClaims(idToken.secret, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e));
                if (claims) kmsiMap[idToken.homeAccountId] = (0, $4f8cb1da78e4daf9$exports).isKmsi(claims);
            }
        }
        return kmsiMap;
    }
    /**
     * Migrates id tokens from the old schema to the new schema, also migrates associated account object if it doesn't already exist in the new schema
     * @param credentialSchema
     * @param accountSchema
     * @param correlationId
     * @returns
     */ async migrateIdTokens(credentialSchema, accountSchema, correlationId) {
        const credentialKeysToMigrate = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.idToken.length === 0) return;
        const currentCredentialKeys = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $82743da031e636d6$export$ec2ec5cd3d01f05d));
        const currentAccountKeys = (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this.browserStorage);
        const previousAccountKeys = (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this.browserStorage, accountSchema);
        for (const idTokenKey of [
            ...credentialKeysToMigrate.idToken
        ]){
            this.performanceClient.incrementFields({
                oldITCount: 1
            }, correlationId);
            const oldSchemaData = await this.updateOldEntry(idTokenKey, correlationId);
            if (!oldSchemaData) {
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.idToken, idTokenKey);
                continue;
            }
            const currentAccountKey = currentAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            const previousAccountKey = previousAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            let account = null;
            if (currentAccountKey) account = this.getAccount(currentAccountKey, correlationId);
            else if (previousAccountKey) {
                const rawValue = this.browserStorage.getItem(previousAccountKey);
                const parsedValue = this.validateAndParseJson(rawValue || "");
                account = parsedValue && (0, $64a257c4fae463d7$export$691b4523c5340423)(parsedValue) ? await this.browserStorage.decryptData(previousAccountKey, parsedValue, correlationId) : parsedValue;
            }
            if (!account) {
                // Don't migrate idToken if we don't have an account for it
                this.performanceClient.incrementFields({
                    skipITMigrateCount: 1
                }, correlationId);
                continue;
            }
            const claims = (0, $4f8cb1da78e4daf9$exports).extractTokenClaims(oldSchemaData.secret, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e));
            const newIdTokenKey = this.generateCredentialKey(oldSchemaData);
            const currentIdToken = this.getIdTokenCredential(newIdTokenKey, correlationId);
            const oldTokenHasSignInState = Object.keys(claims).includes("signin_state");
            const currentTokenHasSignInState = currentIdToken && Object.keys((0, $4f8cb1da78e4daf9$exports).extractTokenClaims(currentIdToken.secret, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e)) || {}).includes("signin_state");
            /**
             * Only migrate if:
             * 1. Token doesn't yet exist in current schema
             * 2. Old schema token has been updated more recently than the current one AND migrating it won't result in loss of KMSI state
             */ if (!currentIdToken || oldSchemaData.lastUpdatedAt > currentIdToken.lastUpdatedAt && (oldTokenHasSignInState || !currentTokenHasSignInState)) {
                const tenantProfiles = account.tenantProfiles || [];
                const tenantId = (0, $01daa942f7822733$export$8e1decb9a5e2932)(claims) || account.realm;
                if (tenantId && !tenantProfiles.find((tenantProfile)=>{
                    return tenantProfile.tenantId === tenantId;
                })) {
                    const newTenantProfile = (0, $d08229a94d11167d$export$924857724cb21ba4)(account.homeAccountId, account.localAccountId, tenantId, claims);
                    tenantProfiles.push(newTenantProfile);
                }
                account.tenantProfiles = tenantProfiles;
                const newAccountKey = this.generateAccountKey((0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(account));
                const kmsi = (0, $4f8cb1da78e4daf9$exports).isKmsi(claims);
                await this.setUserData(newAccountKey, JSON.stringify(account), correlationId, account.lastUpdatedAt, kmsi);
                if (!currentAccountKeys.includes(newAccountKey)) currentAccountKeys.push(newAccountKey);
                await this.setUserData(newIdTokenKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedITCount: 1
                }, correlationId);
                currentCredentialKeys.idToken.push(newIdTokenKey);
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
        this.setAccountKeys(currentAccountKeys, correlationId);
    }
    /**
     * Migrates access tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateAccessTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.accessToken.length === 0) return;
        const currentCredentialKeys = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $82743da031e636d6$export$ec2ec5cd3d01f05d));
        for (const accessTokenKey of [
            ...credentialKeysToMigrate.accessToken
        ]){
            this.performanceClient.incrementFields({
                oldATCount: 1
            }, correlationId);
            const oldSchemaData = await this.updateOldEntry(accessTokenKey, correlationId);
            if (!oldSchemaData) {
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.accessToken, accessTokenKey);
                continue;
            }
            if (!Object.keys(kmsiMap).includes(oldSchemaData.homeAccountId)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipATMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.accessToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedATCount: 1
                }, correlationId);
                currentCredentialKeys.accessToken.push(newKey);
            } else {
                const currentToken = this.getAccessTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedATCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Migrates refresh tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateRefreshTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.refreshToken.length === 0) return;
        const currentCredentialKeys = (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, (0, $82743da031e636d6$export$ec2ec5cd3d01f05d));
        for (const refreshTokenKey of [
            ...credentialKeysToMigrate.refreshToken
        ]){
            this.performanceClient.incrementFields({
                oldRTCount: 1
            }, correlationId);
            const oldSchemaData = await this.updateOldEntry(refreshTokenKey, correlationId);
            if (!oldSchemaData) {
                (0, $25496c73929d0eac$export$f6b67b4ecd4149d9)(credentialKeysToMigrate.refreshToken, refreshTokenKey);
                continue;
            }
            if (!Object.keys(kmsiMap).includes(oldSchemaData.homeAccountId)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipRTMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.refreshToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedRTCount: 1
                }, correlationId);
                currentCredentialKeys.refreshToken.push(newKey);
            } else {
                const currentToken = this.getRefreshTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedRTCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Tracks upgrades and downgrades for telemetry and debugging purposes
     */ trackVersionChanges(correlationId) {
        const previousVersion = this.browserStorage.getItem((0, $82743da031e636d6$export$6825ebfedde34998));
        if (previousVersion) {
            this.logger.info(`MSAL.js was last initialized by version: ${previousVersion}`);
            this.performanceClient.addFields({
                previousLibraryVersion: previousVersion
            }, correlationId);
        }
        if (previousVersion !== (0, $cdd21367776b6362$export$83d89fbfd8236492)) this.setItem((0, $82743da031e636d6$export$6825ebfedde34998), (0, $cdd21367776b6362$export$83d89fbfd8236492), correlationId);
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        if (!jsonValue) return null;
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * Helper to setItem in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        const tokenKeysCount = new Array((0, $82743da031e636d6$export$ec2ec5cd3d01f05d) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)// Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
        try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, $82743da031e636d6$export$ec2ec5cd3d01f05d); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $a5bb7e4c0fc3284b$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $6e7371d16fb9bd24$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    // If we are currently trying to set the token keys, use the value we're trying to set
                    for(let i = 0; i <= (0, $82743da031e636d6$export$ec2ec5cd3d01f05d); i++)if (key === (0, $82743da031e636d6$export$79944bbef1910535)(this.clientId, i)) {
                        const tokenKeys = JSON.parse(value).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    } else {
                        const tokenKeys = this.getTokenKeys(i).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    }
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Helper to setUserData in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     * @param correlationId
     */ async setUserData(key, value, correlationId, timestamp, kmsi) {
        const tokenKeysCount = new Array((0, $82743da031e636d6$export$ec2ec5cd3d01f05d) + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            // Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
            await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.browserStorage.setUserData.bind(this.browserStorage), (0, $978df372b022f65e$export$2f2811a3e1b21823).SetUserData, this.logger, this.performanceClient)(key, value, correlationId, timestamp, kmsi);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= (0, $82743da031e636d6$export$ec2ec5cd3d01f05d); schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $a5bb7e4c0fc3284b$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $6e7371d16fb9bd24$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) // If we are currently trying to set the token keys, use the value we're trying to set
                for(let i = 0; i <= (0, $82743da031e636d6$export$ec2ec5cd3d01f05d); i++){
                    const tokenKeys = this.getTokenKeys(i).accessToken;
                    accessTokenKeys.push(...tokenKeys);
                    tokenKeysCount[i] = tokenKeys.length;
                }
                if (accessTokenKeys.length <= i) // Nothing left to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getAccount(accountKey, correlationId) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        const serializedAccount = this.browserStorage.getUserData(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, $b16513504135b2c0$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) return null;
        return (0, $6d50c43f626b7d71$export$996e3ea69314b5c6).toObject(new (0, $b16513504135b2c0$export$680160523e6bfa6a)(), parsedAccount);
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ async setAccount(account, correlationId, kmsi) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        const key = this.generateAccountKey((0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(account));
        const timestamp = Date.now().toString();
        account.lastUpdatedAt = timestamp;
        await this.setUserData(key, JSON.stringify(account), correlationId, timestamp, kmsi);
        const wasAdded = this.addAccountKeyToMap(key, correlationId);
        this.performanceClient.addFields({
            kmsi: kmsi
        }, correlationId);
        /**
         * @deprecated - Remove this in next major version in favor of more consistent LOGIN event
         */ if (this.cacheConfig.cacheLocation === (0, $d94c9b6ecea78646$export$573384e47a12d835).LocalStorage && wasAdded) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, (0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(account));
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        return (0, $adebb03b44a6887e$export$beb6809f8bbb3df6)(this.browserStorage);
    }
    setAccountKeys(accountKeys, correlationId, schemaVersion = (0, $82743da031e636d6$export$4693794d1f911b27)) {
        if (accountKeys.length === 0) this.removeItem((0, $82743da031e636d6$export$8cef587ddea5c5f6)(schemaVersion));
        else this.setItem((0, $82743da031e636d6$export$8cef587ddea5c5f6)(schemaVersion), JSON.stringify(accountKeys), correlationId);
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii(`BrowserCacheManager.addAccountKeyToMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $82743da031e636d6$export$8cef587ddea5c5f6)(), JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
            return true;
        } else {
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
            return false;
        }
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii(`BrowserCacheManager.removeAccountKeyFromMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setAccountKeys(accountKeys, correlationId);
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ removeAccount(account, correlationId) {
        const activeAccount = this.getActiveAccount(correlationId);
        if (activeAccount?.homeAccountId === account.homeAccountId && activeAccount?.environment === account.environment) this.setActiveAccount(null, correlationId);
        super.removeAccount(account, correlationId);
        this.removeAccountKeyFromMap(this.generateAccountKey(account), correlationId);
        // Remove all other associated cache items
        this.browserStorage.getKeys().forEach((key)=>{
            if (key.includes(account.homeAccountId) && key.includes(account.environment)) this.browserStorage.removeItem(key);
        });
        /**
         * @deprecated - Remove this in next major version in favor of more consistent LOGOUT event
         */ if (this.cacheConfig.cacheLocation === (0, $d94c9b6ecea78646$export$573384e47a12d835).LocalStorage) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, account);
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const idRemoval = tokenKeys.idToken.indexOf(key);
        if (idRemoval > -1) {
            this.logger.info("idToken removed from tokenKeys map");
            tokenKeys.idToken.splice(idRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        updateTokenKeys && this.removeAccessTokenKeys([
            key
        ], correlationId);
    }
    /**
     * Remove access token key from the key map
     * @param key
     * @param correlationId
     * @param tokenKeys
     */ removeAccessTokenKeys(keys, correlationId, schemaVersion = (0, $82743da031e636d6$export$ec2ec5cd3d01f05d)) {
        this.logger.trace("removeAccessTokenKey called");
        const tokenKeys = this.getTokenKeys(schemaVersion);
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`removed ${keysRemoved} accessToken keys from tokenKeys map`);
            this.setTokenKeys(tokenKeys, correlationId, schemaVersion);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
        if (refreshRemoval > -1) {
            this.logger.info("refreshToken removed from tokenKeys map");
            tokenKeys.refreshToken.splice(refreshRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys(schemaVersion = (0, $82743da031e636d6$export$ec2ec5cd3d01f05d)) {
        return (0, $adebb03b44a6887e$export$ee837b3b857e6cf8)(this.clientId, this.browserStorage, schemaVersion);
    }
    /**
     * Stores the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId, schemaVersion = (0, $82743da031e636d6$export$ec2ec5cd3d01f05d)) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem((0, $82743da031e636d6$export$79944bbef1910535)(this.clientId, schemaVersion));
            return;
        } else this.setItem((0, $82743da031e636d6$export$79944bbef1910535)(this.clientId, schemaVersion), JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $2175959ac3ad49fc$exports).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ async setIdTokenCredential(idToken, correlationId, kmsi) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        const idTokenKey = this.generateCredentialKey(idToken);
        const timestamp = Date.now().toString();
        idToken.lastUpdatedAt = timestamp;
        await this.setUserData(idTokenKey, JSON.stringify(idToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.idToken.indexOf(idTokenKey) === -1) {
            this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
            tokenKeys.idToken.push(idTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeAccessTokenKeys([
                accessTokenKey
            ], correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $2175959ac3ad49fc$exports).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ async setAccessTokenCredential(accessToken, correlationId, kmsi) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        const accessTokenKey = this.generateCredentialKey(accessToken);
        const timestamp = Date.now().toString();
        accessToken.lastUpdatedAt = timestamp;
        await this.setUserData(accessTokenKey, JSON.stringify(accessToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        const index = tokenKeys.accessToken.indexOf(accessTokenKey);
        if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
        this.logger.trace(`access token ${index === -1 ? "added to" : "updated in"} map`);
        tokenKeys.accessToken.push(accessTokenKey);
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeRefreshToken(refreshTokenKey, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $2175959ac3ad49fc$exports).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ async setRefreshTokenCredential(refreshToken, correlationId, kmsi) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        const refreshTokenKey = this.generateCredentialKey(refreshToken);
        const timestamp = Date.now().toString();
        refreshToken.lastUpdatedAt = timestamp;
        await this.setUserData(refreshTokenKey, JSON.stringify(refreshToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.refreshToken.indexOf(refreshTokenKey) === -1) {
            this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
            tokenKeys.refreshToken.push(refreshTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ getAppMetadata(appMetadataKey) {
        const value = this.browserStorage.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $2175959ac3ad49fc$exports).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        const appMetadataKey = (0, $2175959ac3ad49fc$exports).generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ getServerTelemetry(serverTelemetryKey) {
        const value = this.browserStorage.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, $2175959ac3ad49fc$exports).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $2175959ac3ad49fc$exports).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $d94c9b6ecea78646$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $d94c9b6ecea78646$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, $d94c9b6ecea78646$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        const version = this.internalStorage.getItem((0, $d94c9b6ecea78646$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param entity
     */ setAuthorityMetadata(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey((0, $6c5f3cda7e712574$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.browserStorage.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters found");
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey((0, $6c5f3cda7e712574$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId,
                lastUpdatedAt: (0, $0e146ed7106c6e64$exports).nowSeconds().toString()
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
        }
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED);
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ getThrottlingCache(throttlingCacheKey) {
        const value = this.browserStorage.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $2175959ac3ad49fc$exports).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ getTemporaryCache(cacheKey, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            const itemCookie = this.cookieStorage.getItem(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        const value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $d94c9b6ecea78646$export$573384e47a12d835).LocalStorage) {
                const item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    }
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.cookieStorage.setItem(key, value, undefined, this.cacheConfig.secureCookies);
        }
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.cookieStorage.removeItem(key);
        }
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ clear(correlationId) {
        // Removes all accounts and their credentials
        this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $82743da031e636d6$export$8a682ae47622dbb9)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $82743da031e636d6$export$8a682ae47622dbb9)) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param performanceClient {IPerformanceClient}
     * @param correlationId {string} correlation id
     * @returns
     */ clearTokensAndKeysWithClaims(correlationId) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, correlationId);
        const tokenKeys = this.getTokenKeys();
        let removedAccessTokens = 0;
        tokenKeys.accessToken.forEach((key)=>{
            // if the access token has claims in its key, remove the token key and the token
            const credential = this.getAccessTokenCredential(key, correlationId);
            if (credential?.requestedClaimsHash && key.includes(credential.requestedClaimsHash.toLowerCase())) {
                this.removeAccessToken(key, correlationId);
                removedAccessTokens++;
            }
        });
        // warn if any access tokens are removed
        if (removedAccessTokens > 0) this.logger.warning(`${removedAccessTokens} access tokens with claims in the cache keys have been removed from the cache.`);
    }
    /**
     * Prepend msal.<client-id> to each key
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        if ((0, $95ac7d904346f305$export$ecc754f99843e759).startsWith(key, (0, $82743da031e636d6$export$8a682ae47622dbb9))) return key;
        return `${0, $82743da031e636d6$export$8a682ae47622dbb9}.${this.clientId}.${key}`;
    }
    /**
     * Cache Key: msal.<schema_version>-<home_account_id>-<environment>-<credential_type>-<client_id or familyId>-<realm>-<scopes>-<claims hash>-<scheme>
     * IdToken Example: uid.utid-login.microsoftonline.com-idtoken-app_client_id-contoso.com
     * AccessToken Example: uid.utid-login.microsoftonline.com-accesstoken-app_client_id-contoso.com-scope1 scope2--pop
     * RefreshToken Example: uid.utid-login.microsoftonline.com-refreshtoken-1-contoso.com
     * @param credentialEntity
     * @returns
     */ generateCredentialKey(credential) {
        const familyId = credential.credentialType === (0, $6c5f3cda7e712574$export$eca2dc7e6e608a68).REFRESH_TOKEN && credential.familyId || credential.clientId;
        const scheme = credential.tokenType && credential.tokenType.toLowerCase() !== (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER.toLowerCase() ? credential.tokenType.toLowerCase() : "";
        const credentialKey = [
            `${(0, $82743da031e636d6$export$8a682ae47622dbb9)}.${(0, $82743da031e636d6$export$ec2ec5cd3d01f05d)}`,
            credential.homeAccountId,
            credential.environment,
            credential.credentialType,
            familyId,
            credential.realm || "",
            credential.target || "",
            credential.requestedClaimsHash || "",
            scheme
        ];
        return credentialKey.join((0, $82743da031e636d6$export$9e9532f57bbb139e)).toLowerCase();
    }
    /**
     * Cache Key: msal.<schema_version>.<home_account_id>.<environment>.<tenant_id>
     * @param account
     * @returns
     */ generateAccountKey(account) {
        const homeTenantId = account.homeAccountId.split(".")[1];
        const accountKey = [
            `${(0, $82743da031e636d6$export$8a682ae47622dbb9)}.${(0, $82743da031e636d6$export$4693794d1f911b27)}`,
            account.homeAccountId,
            account.environment,
            homeTenantId || account.tenantId || ""
        ];
        return accountKey.join((0, $82743da031e636d6$export$9e9532f57bbb139e)).toLowerCase();
    }
    /**
     * Reset all temporary cache items
     * @param state
     */ resetRequestCache() {
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        this.removeTemporaryItem(this.generateCacheKey((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).VERIFIER));
        this.removeTemporaryItem(this.generateCacheKey((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    }
    cacheAuthorizeRequest(authCodeRequest, codeVerifier) {
        this.logger.trace("BrowserCacheManager.cacheAuthorizeRequest called");
        const encodedValue = (0, $22782b013da7b52b$export$e510a73ee562749)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
        if (codeVerifier) {
            const encodedVerifier = (0, $22782b013da7b52b$export$e510a73ee562749)(codeVerifier);
            this.setTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).VERIFIER, encodedVerifier, true);
        }
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ getCachedRequest() {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$8b51939fb2aab3d7));
        const encodedVerifier = this.getTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).VERIFIER, true);
        let parsedRequest;
        let verifier = "";
        try {
            parsedRequest = JSON.parse((0, $0d858b7a75e8c5ef$export$c62426fdd000a97e)(encodedTokenRequest));
            if (encodedVerifier) verifier = (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e)(encodedVerifier);
        } catch (e) {
            this.logger.errorPii(`Attempted to parse: ${encodedTokenRequest}`);
            this.logger.error(`Parsing cached token request threw with error: ${e}`);
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$f3ae24cdfaab4488));
        }
        return [
            parsedRequest,
            verifier
        ];
    }
    /**
     * Gets cached native request for redirect flows
     */ getCachedNativeRequest() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        const cachedRequest = this.getTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress()?.clientId;
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, $82743da031e636d6$export$8a682ae47622dbb9)}.${(0, $d94c9b6ecea78646$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        const value = this.getTemporaryCache(key, false);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            // Remove interaction and other temp keys if interaction status can't be parsed
            this.logger.error(`Cannot parse interaction status. Removing temporary cache items and clearing url hash. Retrying interaction should fix the error`);
            this.removeTemporaryItem(key);
            this.resetRequestCache();
            (0, $3e9f4e3d34d422a9$export$a20c3032ba81d6aa)(window);
            return null;
        }
    }
    setInteractionInProgress(inProgress, type = (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNIN) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, $82743da031e636d6$export$8a682ae47622dbb9)}.${(0, $d94c9b6ecea78646$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$2700dc1c133d227e));
            else // No interaction is in progress
            this.setTemporaryCache(key, JSON.stringify({
                clientId: this.clientId,
                type: type
            }), false);
        } else if (!inProgress && this.getInteractionInProgress()?.clientId === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, $2175959ac3ad49fc$exports).createIdTokenEntity(result.account?.homeAccountId, result.account?.environment, result.idToken, this.clientId, result.tenantId);
        let claimsHash;
        if (request.claims) claimsHash = await this.cryptoImpl.hashString(request.claims);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, $2175959ac3ad49fc$exports).createAccessTokenEntity(result.account?.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), // Access token expiresOn stored in seconds, converting from AuthenticationResult expiresOn stored as Date
        result.expiresOn ? (0, $0e146ed7106c6e64$exports).toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? (0, $0e146ed7106c6e64$exports).toSecondsFromDate(result.extExpiresOn) : 0, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e), undefined, result.tokenType, undefined, request.sshKid, request.claims, claimsHash);
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId, (0, $4f8cb1da78e4daf9$exports).isKmsi((0, $4f8cb1da78e4daf9$exports).extractTokenClaims(result.idToken, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e))));
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, kmsi, storeInCache);
        } catch (e) {
            if (e instanceof (0, $a5bb7e4c0fc3284b$export$78ff06e91c3de382) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
/**
 * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
 * @param cacheLocation
 */ function $1e67d23838b7b4f7$var$getStorageImplementation(clientId, cacheLocation, logger, performanceClient) {
    try {
        switch(cacheLocation){
            case (0, $d94c9b6ecea78646$export$573384e47a12d835).LocalStorage:
                return new (0, $83389795bce34632$export$19fffca37ef3e106)(clientId, logger, performanceClient);
            case (0, $d94c9b6ecea78646$export$573384e47a12d835).SessionStorage:
                return new (0, $81ed4695d20b9a5d$export$2c4b17e1c2e0931)();
            case (0, $d94c9b6ecea78646$export$573384e47a12d835).MemoryStorage:
            default:
                break;
        }
    } catch (e) {
        logger.error(e);
    }
    return new (0, $c17c48c8ea3147b8$export$d7392285c701ecf5)();
}
const $1e67d23838b7b4f7$export$8e2d54002f8f6e5d = (clientId, logger, performanceClient, eventHandler)=>{
    const cacheOptions = {
        cacheLocation: (0, $d94c9b6ecea78646$export$573384e47a12d835).MemoryStorage,
        cacheRetentionDays: 5,
        temporaryCacheLocation: (0, $d94c9b6ecea78646$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: false
    };
    return new $1e67d23838b7b4f7$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $487fc5d1c5f0967c$export$865f57d401606752), logger, performanceClient, eventHandler);
};


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $262567445a7c060e$export$a4fc43c2a99143cd(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("getAllAccounts called");
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter || {}, correlationId) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $262567445a7c060e$export$4f9234baf34abd0(accountFilter, logger, browserStorage, correlationId) {
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("getAccount: Account matching provided filter found, returning");
        return account;
    } else {
        logger.verbose("getAccount: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching username.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found.
 * This API is provided for convenience but getAccountById should be used for best reliability
 * @param username
 * @returns The account object stored in MSAL
 */ function $262567445a7c060e$export$d915baf55d86927d(username, logger, browserStorage, correlationId) {
    logger.trace("getAccountByUsername called");
    if (!username) {
        logger.warning("getAccountByUsername: No username provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        username: username
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByUsername: Account matching username found, returning");
        logger.verbosePii(`getAccountByUsername: Returning signed-in accounts matching username: ${username}`);
        return account;
    } else {
        logger.verbose("getAccountByUsername: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching homeAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param homeAccountId
 * @returns The account object stored in MSAL
 */ function $262567445a7c060e$export$d6fa7d1e8099998e(homeAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByHomeId called");
    if (!homeAccountId) {
        logger.warning("getAccountByHomeId: No homeAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        homeAccountId: homeAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
        logger.verbosePii(`getAccountByHomeId: Returning signed-in accounts matching homeAccountId: ${homeAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByHomeId: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching localAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param localAccountId
 * @returns The account object stored in MSAL
 */ function $262567445a7c060e$export$7ac8aa09fdf78340(localAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByLocalId called");
    if (!localAccountId) {
        logger.warning("getAccountByLocalId: No localAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        localAccountId: localAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
        logger.verbosePii(`getAccountByLocalId: Returning signed-in accounts matching localAccountId: ${localAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByLocalId: No matching account found, returning null");
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $262567445a7c060e$export$c55c3d25cf1bcd99(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function $262567445a7c060e$export$13dd2e33a23839ad(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}





/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $12c2eca48a8818eb$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.event";
class $12c2eca48a8818eb$export$ce0ba2422a1c7815 {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, $9d8c7bd8b3e958dc$export$efa9a398d6368992)({});
        if (typeof BroadcastChannel !== "undefined") this.broadcastChannel = new BroadcastChannel($12c2eca48a8818eb$var$BROADCAST_CHANNEL_NAME);
        this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, $3e9f4e3d34d422a9$export$7571c350ed9fec74)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`Event callback with id: ${id} is already registered. Please provide a unique id or remove the existing callback and try again.`);
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`Event callback registered with id: ${id}`);
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`Event callback ${callbackId} removed.`);
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, interactionType, payload, error) {
        const message = {
            eventType: eventType,
            interactionType: interactionType || null,
            payload: payload || null,
            error: error || null,
            timestamp: Date.now()
        };
        switch(eventType){
            case (0, $9140a68e3a7e9307$export$3d7865934588d77e).ACCOUNT_ADDED:
            case (0, $9140a68e3a7e9307$export$3d7865934588d77e).ACCOUNT_REMOVED:
            case (0, $9140a68e3a7e9307$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED:
                // Send event to other open tabs / MSAL instances on same domain
                this.broadcastChannel?.postMessage(message);
                break;
            default:
                // Emit event to callbacks registered in this instance
                this.invokeCallbacks(message);
                break;
        }
    }
    /**
     * Invoke registered callbacks
     * @param message
     */ invokeCallbacks(message) {
        this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
            if (eventTypes.length === 0 || eventTypes.includes(message.eventType)) {
                this.logger.verbose(`Emitting event to callback ${callbackId}: ${message.eventType}`);
                callback.apply(null, [
                    message
                ]);
            }
        });
    }
    /**
     * Wrapper around invokeCallbacks to handle broadcast events received from other tabs/instances
     * @param event
     */ invokeCrossTabCallbacks(event) {
        const message = event.data;
        this.invokeCallbacks(message);
    }
    /**
     * Listen for events broadcasted from other tabs/instances
     */ subscribeCrossTab() {
        this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
    }
    /**
     * Unsubscribe from broadcast events
     */ unsubscribeCrossTab() {
        this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 



/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $c04ec59cc6033cfb$export$17b7b3ac1abef49f = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};





var $d550ccf255a4e7b5$exports = {};

$parcel$export($d550ccf255a4e7b5$exports, "createDiscoveredInstance", () => $d550ccf255a4e7b5$export$ab9db5e7e572e7da);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param protocolMode
 * @internal
 */ async function $d550ccf255a4e7b5$export$ab9db5e7e572e7da(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
    const authorityUriFinal = (0, $55d9936263fe2e81$export$f1c6ec2e6d68c49c).transformCIAMAuthority((0, $55d9936263fe2e81$export$4030f3538167cb9e)(authorityUri));
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, $55d9936263fe2e81$export$f1c6ec2e6d68c49c)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c9fcc93738cc2bc3));
    }
}



/*! @azure/msal-common v15.13.3 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $74e5e9d464560d66$export$ea52035eac03daf0 extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, errorNo, status){
        super(errorCode, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $74e5e9d464560d66$export$ea52035eac03daf0.prototype);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $a7bcd64f684b1e3a$export$c060a619741dd765 {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${(0, $6c5f3cda7e712574$export$a2330d6808e6d893).THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = $a7bcd64f684b1e3a$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new (0, $74e5e9d464560d66$export$ea52035eac03daf0)(value.errorCodes?.join(" ") || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        if ($a7bcd64f684b1e3a$export$c060a619741dd765.checkResponseStatus(response) || $a7bcd64f684b1e3a$export$c060a619741dd765.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $a7bcd64f684b1e3a$export$c060a619741dd765.calculateThrottleTime(parseInt(response.headers[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($a7bcd64f684b1e3a$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $6c5f3cda7e712574$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $6c5f3cda7e712574$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $6c5f3cda7e712574$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = (0, $58fde9510481ec07$export$2daa8cfcf54c2b48)(clientId, request, homeAccountIdentifier);
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 * @internal
 */ class $45a151a2a9ebe1f6$export$4f22f74eddb7716a {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $8778110eec982731$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $9d8c7bd8b3e958dc$export$efa9a398d6368992)(this.config.loggerOptions, (0, $a9bd283efb93627c$export$a8ff84c12d48cfa6), (0, $a9bd283efb93627c$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ createTokenRequestHeaders(ccsCred) {
        const headers = {};
        headers[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $6c5f3cda7e712574$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $51de415de522dc09$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).UPN:
                headers[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
                break;
        }
        return headers;
    }
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ async executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, queuedEvent) {
        if (queuedEvent) this.performanceClient?.addQueueMeasurement(queuedEvent, correlationId);
        const response = await this.sendPostRequest(thumbprint, tokenEndpoint, {
            body: queryString,
            headers: headers
        }, correlationId);
        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
        this.config.serverTelemetryManager.clearTelemetryCache();
        return response;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint - Request thumbprint for throttling
     * @param tokenEndpoint - Endpoint to make the POST to
     * @param options - Body and Headers to include on the POST request
     * @param correlationId - CorrelationId for telemetry
     */ async sendPostRequest(thumbprint, tokenEndpoint, options, correlationId) {
        (0, $a7bcd64f684b1e3a$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint, correlationId);
        let response;
        try {
            response = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.networkClient.sendPostRequestAsync.bind(this.networkClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).NetworkClientSendPostRequestAsync, this.logger, this.performanceClient, correlationId)(tokenEndpoint, options);
            const responseHeaders = response.headers || {};
            this.performanceClient?.addFields({
                refreshTokenSize: response.body.refresh_token?.length || 0,
                httpVerToken: responseHeaders[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).X_MS_REQUEST_ID] || ""
            }, correlationId);
        } catch (e) {
            if (e instanceof (0, $131354001216b17e$export$bae979e68e4dc802)) {
                const responseHeaders = e.responseHeaders;
                if (responseHeaders) this.performanceClient?.addFields({
                    httpVerToken: responseHeaders[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                    requestId: responseHeaders[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).X_MS_REQUEST_ID] || "",
                    contentTypeHeader: responseHeaders[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).CONTENT_TYPE] || undefined,
                    contentLengthHeader: responseHeaders[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).CONTENT_LENGTH] || undefined,
                    httpStatus: e.httpStatus
                }, correlationId);
                throw e.error;
            }
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) throw e;
            else throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$4358cbadf08aa73));
        }
        (0, $a7bcd64f684b1e3a$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response, correlationId);
        return response;
    }
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ async updateAuthority(cloudInstanceHostname, correlationId) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, correlationId);
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostname}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, $d550ccf255a4e7b5$export$ab9db5e7e572e7da)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
    /**
     * Creates query string for the /token request
     * @param request
     */ createTokenQueryParameters(request) {
        const parameters = new Map();
        if (request.embeddedClientId) (0, $1ac773f7bc3e26ca$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenQueryParameters) (0, $1ac773f7bc3e26ca$export$1a9f676bcc5d37da)(parameters, request.tokenQueryParameters);
        (0, $1ac773f7bc3e26ca$export$8a224ff809946e9c)(parameters, request.correlationId);
        (0, $1ac773f7bc3e26ca$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        return (0, $2bfa541b563305f9$export$44d4663acf79cde2)(parameters);
    }
}







/*! @azure/msal-common v15.13.3 2025-12-04 */ 




/*! @azure/msal-common v15.13.3 2025-12-04 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ class $ec77d46e72c7980c$export$871e33217042c65e {
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ static setRequestState(cryptoObj, userState, meta) {
        const libraryState = $ec77d46e72c7980c$export$871e33217042c65e.generateLibraryState(cryptoObj, meta);
        return userState ? `${libraryState}${(0, $6c5f3cda7e712574$export$a002182e51710d39).RESOURCE_DELIM}${userState}` : libraryState;
    }
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ static generateLibraryState(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c39e501a22cba395));
        // Create a state object containing a unique id and the timestamp of the request creation
        const stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        const stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    }
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ static parseRequestState(cryptoObj, state) {
        if (!cryptoObj) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$c39e501a22cba395));
        if (!state) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$72a77317632c052b));
        try {
            // Split the state between library state and user passed state and decode them separately
            const splitState = state.split((0, $6c5f3cda7e712574$export$a002182e51710d39).RESOURCE_DELIM);
            const libraryState = splitState[0];
            const userState = splitState.length > 1 ? splitState.slice(1).join((0, $6c5f3cda7e712574$export$a002182e51710d39).RESOURCE_DELIM) : (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
            const libraryStateString = cryptoObj.base64Decode(libraryState);
            const libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: userState || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$72a77317632c052b));
        }
    }
}



/*! @azure/msal-common v15.13.3 2025-12-04 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d505067a6a64c47e$var$KeyLocation = {
    SW: "sw"
};
/** @internal */ class $d505067a6a64c47e$export$3dd8467151c83e3e {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
        const reqCnf = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.generateKid.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: $d505067a6a64c47e$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, $0e146ed7106c6e64$export$ae62599a119ac50a)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}


/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $d35e46c84e171903$export$500ab620f6bcc747 {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 * @internal
 */ class $2e62d88635b5d0eb$export$f456c9835cc63582 {
    constructor(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_AVAILABLE} - Description: ${serverResponse.error_description || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || (0, $6c5f3cda7e712574$export$a002182e51710d39).NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, $74e5e9d464560d66$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $6c5f3cda7e712574$export$2b71909294c66558).SERVER_ERROR_RANGE_START && serverResponse.status <= (0, $6c5f3cda7e712574$export$2b71909294c66558).SERVER_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently unavailable and the access token is unable to be refreshed.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $6c5f3cda7e712574$export$2b71909294c66558).CLIENT_ERROR_RANGE_START && serverResponse.status <= (0, $6c5f3cda7e712574$export$2b71909294c66558).CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently available but is unable to refresh the access token.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, $6fdc601aa485fcf1$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, $4f8cb1da78e4daf9$export$8a59e6f35fb00518)(serverTokenResponse.id_token || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj.base64Decode);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$edd0491c2c280be7));
            }
            // token max_age check
            if (request.maxAge || request.maxAge === 0) {
                const authTime = idTokenClaims.auth_time;
                if (!authTime) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$43356944266c945e));
                (0, $4f8cb1da78e4daf9$export$ee7a34ea7880144c)(authTime, request.maxAge);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, $b16513504135b2c0$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $ec77d46e72c7980c$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                cacheContext = new (0, $d35e46c84e171903$export$500ab620f6bcc747)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const key = this.cacheStorage.generateAccountKey((0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(cacheRecord.account));
                const account = this.cacheStorage.getAccount(key, request.correlationId);
                if (!account) {
                    this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                    return await $2e62d88635b5d0eb$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, (0, $4f8cb1da78e4daf9$export$9475d607926d7a45)(idTokenClaims || {}), request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $2e62d88635b5d0eb$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$dedc648643245fa1));
        const claimsTenantId = (0, $01daa942f7822733$export$8e1decb9a5e2932)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, $2175959ac3ad49fc$export$d8a173a23f325769)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $2e62d88635b5d0eb$export$73b84062d58a1307(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $2175959ac3ad49fc$export$fa005e75d915b6db)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
            }
            cachedRefreshToken = (0, $2175959ac3ad49fc$export$9095b5885dfa55cc)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP && !request.popKid) {
                const popTokenGenerator = new (0, $d505067a6a64c47e$export$3dd8467151c83e3e)(cryptoObj);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$3c9338a50e294d1));
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            // Access token expiresOn cached in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, $0e146ed7106c6e64$export$dcee164673849555)(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, $0e146ed7106c6e64$export$dcee164673849555)(cacheRecord.accessToken.extendedExpiresOn);
            if (cacheRecord.accessToken.refreshOn) refreshOn = (0, $0e146ed7106c6e64$export$dcee164673849555)(cacheRecord.accessToken.refreshOn);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $6c5f3cda7e712574$export$978fe7ab5e74b539) ? (0, $6c5f3cda7e712574$export$978fe7ab5e74b539) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
        const accountInfo = cacheRecord.account ? (0, $d08229a94d11167d$export$452a054c78b83dad)((0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(cacheRecord.account), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
            state: requestState ? requestState.userRequestState : (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: cacheRecord.account?.msGraphHost || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
            code: serverTokenResponse?.spa_code,
            fromNativeBroker: false
        };
    }
}
function $2e62d88635b5d0eb$export$73b84062d58a1307(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger) {
    logger?.verbose("setCachedAccount called");
    // Check if base account is already cached
    const accountKeys = cacheStorage.getAccountKeys();
    const baseAccountKey = accountKeys.find((accountKey)=>{
        return accountKey.startsWith(homeAccountId);
    });
    let cachedAccount = null;
    if (baseAccountKey) cachedAccount = cacheStorage.getAccount(baseAccountKey, correlationId);
    const baseAccount = cachedAccount || (0, $b16513504135b2c0$export$680160523e6bfa6a).createAccount({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, $d08229a94d11167d$export$924857724cb21ba4)(homeAccountId, baseAccount.localAccountId, tenantId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}












/*! @azure/msal-common v15.13.3 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $a6e7c7d7a5c7e4be$export$620d3a93bf8b59fb(clientAssertion, clientId, tokenEndpoint) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint
        };
        return clientAssertion(config);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $2ba20fbd707f4716$export$8538731fd397fb90 extends (0, $45a151a2a9ebe1f6$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, authCodePayload) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
        if (!request.code) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$4ac9fb1f531eded7));
        const reqTimestamp = (0, $0e146ed7106c6e64$export$ae62599a119ac50a)();
        const response = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $2e62d88635b5d0eb$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$9eb2eeb401492d88));
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $7c3562667cdabc20$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $51de415de522dc09$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${(0, $6c5f3cda7e712574$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        const headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
        const thumbprint = (0, $58fde9510481ec07$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
        const parameters = new Map();
        (0, $1ac773f7bc3e26ca$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.tokenBodyParameters?.[0, $8fa592d3142882bc$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) {
            // Just validate
            if (!request.redirectUri) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$7a02f9bdce79dd4e));
        } else // Validate and include redirect uri
        (0, $1ac773f7bc3e26ca$export$6758d6264f4f06)(parameters, request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        (0, $1ac773f7bc3e26ca$export$c213bf8f125826ba)(parameters, request.scopes, true, this.oidcDefaultScopes);
        // add code: user set, not validated
        (0, $1ac773f7bc3e26ca$export$ff027aab2d77a49c)(parameters, request.code);
        // Add library metadata
        (0, $1ac773f7bc3e26ca$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $1ac773f7bc3e26ca$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $1ac773f7bc3e26ca$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $8778110eec982731$export$25afa7198c2ed9b9)(this.config)) (0, $1ac773f7bc3e26ca$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) (0, $1ac773f7bc3e26ca$export$dceb49e3b4703cbb)(parameters, request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) (0, $1ac773f7bc3e26ca$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $1ac773f7bc3e26ca$export$2d3d772920e2496e)(parameters, await (0, $a6e7c7d7a5c7e4be$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $1ac773f7bc3e26ca$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        (0, $1ac773f7bc3e26ca$export$e5f700fdeb4022b2)(parameters, (0, $6c5f3cda7e712574$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
        (0, $1ac773f7bc3e26ca$export$86b85a101d45e918)(parameters);
        if (request.authenticationScheme === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $d505067a6a64c47e$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $978df372b022f65e$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $1ac773f7bc3e26ca$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $6c5f3cda7e712574$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $1ac773f7bc3e26ca$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$8fbed44b22d9136f));
        }
        if (!(0, $95ac7d904346f305$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) (0, $1ac773f7bc3e26ca$export$b04c3bca9165ed02)(parameters, request.claims, this.config.authOptions.clientCapabilities);
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $51de415de522dc09$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${(0, $6c5f3cda7e712574$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $51de415de522dc09$export$63508a6d6b7dbe07)(ccsCred.credential);
                    (0, $1ac773f7bc3e26ca$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).UPN:
                (0, $1ac773f7bc3e26ca$export$aa9cca16bcc29d2d)(parameters, ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) (0, $1ac773f7bc3e26ca$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenBodyParameters) (0, $1ac773f7bc3e26ca$export$1a9f676bcc5d37da)(parameters, request.tokenBodyParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[0, $8fa592d3142882bc$export$f58b98a40c1faa68])) (0, $1ac773f7bc3e26ca$export$1a9f676bcc5d37da)(parameters, {
            [(0, $8fa592d3142882bc$export$f58b98a40c1faa68)]: "1"
        });
        (0, $1ac773f7bc3e26ca$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        return (0, $2bfa541b563305f9$export$44d4663acf79cde2)(parameters);
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameters = new Map();
        if (request.postLogoutRedirectUri) (0, $1ac773f7bc3e26ca$export$bb8081db67b059c0)(parameters, request.postLogoutRedirectUri);
        if (request.correlationId) (0, $1ac773f7bc3e26ca$export$8a224ff809946e9c)(parameters, request.correlationId);
        if (request.idTokenHint) (0, $1ac773f7bc3e26ca$export$c6f34f6f67740950)(parameters, request.idTokenHint);
        if (request.state) (0, $1ac773f7bc3e26ca$export$4a8b8c14090dd065)(parameters, request.state);
        if (request.logoutHint) (0, $1ac773f7bc3e26ca$export$e0d4676d7288bded)(parameters, request.logoutHint);
        if (request.extraQueryParameters) (0, $1ac773f7bc3e26ca$export$1a9f676bcc5d37da)(parameters, request.extraQueryParameters);
        if (this.config.authOptions.instanceAware) (0, $1ac773f7bc3e26ca$export$50b40dfb1d11b77a)(parameters);
        return (0, $2bfa541b563305f9$export$44d4663acf79cde2)(parameters, this.config.authOptions.encodeExtraQueryParams, request.extraQueryParameters);
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ /*! @azure/msal-common v15.13.3 2025-12-04 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1d2c81b0b1bfc4d0$var$skuGroupSeparator = ",";
const $1d2c81b0b1bfc4d0$var$skuValueSeparator = "|";
function $1d2c81b0b1bfc4d0$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($1d2c81b0b1bfc4d0$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$1d2c81b0b1bfc4d0$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $1d2c81b0b1bfc4d0$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($1d2c81b0b1bfc4d0$var$skuGroupSeparator);
}
function $1d2c81b0b1bfc4d0$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($1d2c81b0b1bfc4d0$var$skuValueSeparator);
}
/** @internal */ class $1d2c81b0b1bfc4d0$export$bddbbc43a3ca9c53 {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, $6c5f3cda7e712574$export$aa4af185ea049f6b).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $6c5f3cda7e712574$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $1d2c81b0b1bfc4d0$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        const lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (error instanceof Error && !!error && error.toString()) {
            if (error instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                if (error.subError) lastRequests.errors.push(error.subError);
                else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push(error.toString());
        } else lastRequests.errors.push((0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $1d2c81b0b1bfc4d0$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
            const errorCode = serverTelemetryEntity.errors[i] || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $6c5f3cda7e712574$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return $1d2c81b0b1bfc4d0$var$makeExtraSkuString(params);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c195e70a46d17059$export$d858565f81c03f1f {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.platformAuthProvider = platformAuthProvider;
        this.correlationId = correlationId || (0, $6f7127724a699469$export$6ef0355fa80a5278)();
        this.logger = logger.clone((0, $d94c9b6ecea78646$export$a0a689e4294b9880).MSAL_SKU, (0, $cdd21367776b6362$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    async clearCacheOnLogout(correlationId, account) {
        if (account) // Clear given account.
        try {
            this.browserStorage.removeAccount(account, correlationId);
            this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
        } catch (error) {
            this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
        }
        else try {
            this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
            // Clear all accounts and tokens
            this.browserStorage.clear(correlationId);
            // Clear any stray keys from IndexedDB
            await this.browserCrypto.clearKeystore();
        } catch (e) {
            this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
        }
    }
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ getRedirectUri(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        const redirectUri = requestRedirectUri || this.config.auth.redirectUri;
        return (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)());
    }
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ initializeServerTelemetryManager(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        const telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $1d2c81b0b1bfc4d0$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    }
    /**
     * Used to get a discovered version of the default authority.
     * @param params {
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async getDiscoveredAuthority(params) {
        const { account: account } = params;
        const instanceAwareEQ = params.requestExtraQueryParameters && params.requestExtraQueryParameters.hasOwnProperty("instance_aware") ? params.requestExtraQueryParameters["instance_aware"] : undefined;
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            OIDCOptions: this.config.auth.OIDCOptions,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
        const resolvedAuthority = params.requestAuthority || this.config.auth.authority;
        const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : this.config.auth.instanceAware;
        const userAuthority = account && resolvedInstanceAware ? this.config.auth.authority.replace((0, $7c3562667cdabc20$export$3abcdca7229e54f2).getDomainFromUrl(resolvedAuthority), account.environment) : resolvedAuthority;
        // fall back to the authority from config
        const builtAuthority = (0, $55d9936263fe2e81$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, params.requestAzureCloudOptions || this.config.auth.azureCloudOptions);
        const discoveredAuthority = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $d550ccf255a4e7b5$exports).createDiscoveredInstance, (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.logger, this.performanceClient, this.correlationId)(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.correlationId, this.performanceClient);
        if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).authorityMismatch);
        return discoveredAuthority;
    }
}






/*! @azure/msal-browser v4.27.0 2025-12-04 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 */ async function $d1aaa9bd4087c904$export$8e461fcf1fd6910b(request, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER;
        logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
    } else {
        if (validatedRequest.authenticationScheme === (0, $6c5f3cda7e712574$export$901491a717da2ba5).SSH) {
            if (!request.sshJwk) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).missingSshJwk);
            if (!request.sshKid) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).missingSshKid);
        }
        logger.verbose(`Authentication Scheme set to "${validatedRequest.authenticationScheme}" as configured in Auth request`);
    }
    // Set requested claims hash if claims-based caching is enabled and claims were requested
    if (config.cache.claimsBasedCachingEnabled && request.claims && // Checks for empty stringified object "{}" which doesn't qualify as requested claims
    !(0, $95ac7d904346f305$export$ecc754f99843e759).isEmptyObj(request.claims)) validatedRequest.requestedClaimsHash = await (0, $6f7127724a699469$export$9169be2e06c9c165)(request.claims);
    return validatedRequest;
}
async function $d1aaa9bd4087c904$export$4c8aa78c426811d4(request, account, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
    const baseRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)($d1aaa9bd4087c904$export$8e461fcf1fd6910b, (0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}
/**
 * Validates that the combination of request method, protocol mode and authorize body parameters is correct.
 * Returns the validated or defaulted HTTP method or throws if the configured combination is invalid.
 * @param interactionRequest
 * @param protocolMode
 * @returns
 */ function $d1aaa9bd4087c904$export$253b550f4555e4bf(interactionRequest, protocolMode) {
    let httpMethod;
    const requestMethod = interactionRequest.httpMethod;
    if (protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).EAR) {
        // Don't override httpMethod if it is already set, default to POST if not set
        httpMethod = requestMethod || (0, $6c5f3cda7e712574$export$8343e6f32f5246de).POST;
        // Validate that method is not GET if protocol mode is EAR
        if (httpMethod !== (0, $6c5f3cda7e712574$export$8343e6f32f5246de).POST) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).invalidRequestMethodForEAR);
    } else // For non-EAR protocol modes, default to GET if httpMethod is not set
    httpMethod = requestMethod || (0, $6c5f3cda7e712574$export$8343e6f32f5246de).GET;
    // Regardless of protocolMode, if there are authorizePostBodyParameters, validate the request method is POST
    if (interactionRequest.authorizePostBodyParameters && httpMethod !== (0, $6c5f3cda7e712574$export$8343e6f32f5246de).POST) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).invalidAuthorizePostBodyParameters);
    return httpMethod;
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $e07870fd0db9b50c$export$fa9179cade3eb05a extends (0, $c195e70a46d17059$export$d858565f81c03f1f) {
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest?.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId || (0, $6f7127724a699469$export$6ef0355fa80a5278)(),
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getAbsoluteUrl((0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)(), (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
        // Create auth module.
        const clientConfig = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, $2ba20fbd707f4716$export$8538731fd397fb90)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
        const discoveredAuthority = params.authority || await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: requestAzureCloudOptions,
            requestExtraQueryParameters: requestExtraQueryParameters,
            account: account
        });
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cacheOptions: {
                claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, $d94c9b6ecea78646$export$a0a689e4294b9880).MSAL_SKU,
                version: (0, $cdd21367776b6362$export$83d89fbfd8236492),
                cpu: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING,
                os: (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING
            },
            telemetry: this.config.telemetry
        };
    }
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ async initializeAuthorizationRequest(request, interactionType) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
        const redirectUri = this.getRedirectUri(request.redirectUri);
        const browserState = {
            interactionType: interactionType
        };
        const state = (0, $ec77d46e72c7980c$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, browserState);
        const baseRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $d1aaa9bd4087c904$export$8e461fcf1fd6910b), (0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, this.correlationId)({
            ...request,
            correlationId: this.correlationId
        }, this.config, this.performanceClient, this.logger);
        const interactionRequest = {
            ...baseRequest,
            redirectUri: redirectUri,
            state: state,
            nonce: request.nonce || (0, $6f7127724a699469$export$6ef0355fa80a5278)(),
            responseMode: this.config.auth.OIDCOptions.serverResponseType
        };
        const validatedRequest = {
            ...interactionRequest,
            httpMethod: (0, $d1aaa9bd4087c904$export$253b550f4555e4bf)(interactionRequest, this.config.auth.protocolMode)
        };
        // Skip active account lookup if either login hint or session id is set
        if (request.loginHint || request.sid) return validatedRequest;
        const account = request.account || this.browserStorage.getActiveAccount(this.correlationId);
        if (account) {
            this.logger.verbose("Setting validated request account", this.correlationId);
            this.logger.verbosePii(`Setting validated request account: ${account.homeAccountId}`, this.correlationId);
            validatedRequest.account = account;
        }
        return validatedRequest;
    }
}






/*! @azure/msal-browser v4.27.0 2025-12-04 */ 

/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $8a64dcbf751e0905$export$68ec87f530f5f536(browserCrypto, state) {
    if (!state) return null;
    try {
        const requestStateObj = (0, $ec77d46e72c7980c$export$871e33217042c65e).parseRequestState(browserCrypto, state);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).invalidState);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $2972d39af2213d69$export$e64c1808ed72a7c(responseString, responseLocation, logger) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, $2bfa541b563305f9$exports).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, $2bfa541b563305f9$exports).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`The request has returned to the redirectUri but a ${responseLocation} is not present. It's likely that the ${responseLocation} has been removed or the page has been redirected by code running on the redirectUri page.`);
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$a29c42a1dd414317));
        } else {
            logger.error(`A ${responseLocation} is present in the iframe but it does not contain known properties. It's likely that the ${responseLocation} has been replaced by code running on the redirectUri page.`);
            logger.errorPii(`The ${responseLocation} detected is: ${responseString}`);
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$5743873a5ba5d124));
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $2972d39af2213d69$export$af0c72d18284aa0(response, browserCrypto, interactionType) {
    if (!response.state) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$211c8e8843a8d278));
    const platformStateObj = (0, $8a64dcbf751e0905$export$68ec87f530f5f536)(browserCrypto, response.state);
    if (!platformStateObj) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$237bdd0b913cb30c));
    if (platformStateObj.interactionType !== interactionType) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$499b1b95c97a1c75));
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ var $1e317ba7365dc00e$exports = {};

$parcel$export($1e317ba7365dc00e$exports, "getStandardAuthorizeRequestParameters", () => $1e317ba7365dc00e$export$61cf790f71e46219);
$parcel$export($1e317ba7365dc00e$exports, "getAuthorizeUrl", () => $1e317ba7365dc00e$export$e397eb426c115a0a);
$parcel$export($1e317ba7365dc00e$exports, "getAuthorizationCodePayload", () => $1e317ba7365dc00e$export$36c64a7d10cf377b);
$parcel$export($1e317ba7365dc00e$exports, "validateAuthorizationResponse", () => $1e317ba7365dc00e$export$9979de10627480c5);
/*! @azure/msal-common v15.13.3 2025-12-04 */ 









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ function $1e317ba7365dc00e$export$61cf790f71e46219(authOptions, request, logger, performanceClient) {
    // generate the correlationId if not set by the user and add
    const correlationId = request.correlationId;
    const parameters = new Map();
    (0, $1ac773f7bc3e26ca$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.extraQueryParameters?.[0, $8fa592d3142882bc$export$c7b1b63f5b60f8e] || authOptions.clientId);
    const requestScopes = [
        ...request.scopes || [],
        ...request.extraScopesToConsent || []
    ];
    (0, $1ac773f7bc3e26ca$export$c213bf8f125826ba)(parameters, requestScopes, true, authOptions.authority.options.OIDCOptions?.defaultScopes);
    (0, $1ac773f7bc3e26ca$export$6758d6264f4f06)(parameters, request.redirectUri);
    (0, $1ac773f7bc3e26ca$export$8a224ff809946e9c)(parameters, correlationId);
    // add response_mode. If not passed in it defaults to query.
    (0, $1ac773f7bc3e26ca$export$f1c153626c2c2d91)(parameters, request.responseMode);
    // add client_info=1
    (0, $1ac773f7bc3e26ca$export$86b85a101d45e918)(parameters);
    if (request.prompt) {
        (0, $1ac773f7bc3e26ca$export$e982ccd37a61cde6)(parameters, request.prompt);
        performanceClient?.addFields({
            prompt: request.prompt
        }, correlationId);
    }
    if (request.domainHint) {
        (0, $1ac773f7bc3e26ca$export$1bd007a9d7fec290)(parameters, request.domainHint);
        performanceClient?.addFields({
            domainHintFromRequest: true
        }, correlationId);
    }
    // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
    if (request.prompt !== (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
        // AAD will throw if prompt=select_account is passed with an account hint
        if (request.sid && request.prompt === (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE) {
            // SessionID is only used in silent calls
            logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
            (0, $1ac773f7bc3e26ca$export$9d8531b0fa366b30)(parameters, request.sid);
            performanceClient?.addFields({
                sidFromRequest: true
            }, correlationId);
        } else if (request.account) {
            const accountSid = $1e317ba7365dc00e$var$extractAccountSid(request.account);
            let accountLoginHintClaim = $1e317ba7365dc00e$var$extractLoginHint(request.account);
            if (accountLoginHintClaim && request.domainHint) {
                logger.warning(`AuthorizationCodeClient.createAuthCodeUrlQueryString: "domainHint" param is set, skipping opaque "login_hint" claim. Please consider not passing domainHint`);
                accountLoginHintClaim = null;
            }
            // If login_hint claim is present, use it over sid/username
            if (accountLoginHintClaim) {
                logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                (0, $1ac773f7bc3e26ca$export$65f43fd4b28bba5f)(parameters, accountLoginHintClaim);
                performanceClient?.addFields({
                    loginHintFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $51de415de522dc09$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $1ac773f7bc3e26ca$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            } else if (accountSid && request.prompt === (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE) {
                /*
                 * If account and loginHint are provided, we will check account first for sid before adding loginHint
                 * SessionId is only used in silent calls
                 */ logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                (0, $1ac773f7bc3e26ca$export$9d8531b0fa366b30)(parameters, accountSid);
                performanceClient?.addFields({
                    sidFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = (0, $51de415de522dc09$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $1ac773f7bc3e26ca$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            } else if (request.loginHint) {
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                (0, $1ac773f7bc3e26ca$export$65f43fd4b28bba5f)(parameters, request.loginHint);
                (0, $1ac773f7bc3e26ca$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
                performanceClient?.addFields({
                    loginHintFromRequest: true
                }, correlationId);
            } else if (request.account.username) {
                // Fallback to account username if provided
                logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                (0, $1ac773f7bc3e26ca$export$65f43fd4b28bba5f)(parameters, request.account.username);
                performanceClient?.addFields({
                    loginHintFromUpn: true
                }, correlationId);
                try {
                    const clientInfo = (0, $51de415de522dc09$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                    (0, $1ac773f7bc3e26ca$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                }
            }
        } else if (request.loginHint) {
            logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
            (0, $1ac773f7bc3e26ca$export$65f43fd4b28bba5f)(parameters, request.loginHint);
            (0, $1ac773f7bc3e26ca$export$aa9cca16bcc29d2d)(parameters, request.loginHint);
            performanceClient?.addFields({
                loginHintFromRequest: true
            }, correlationId);
        }
    } else logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
    if (request.nonce) (0, $1ac773f7bc3e26ca$export$87b1d5d886e84b11)(parameters, request.nonce);
    if (request.state) (0, $1ac773f7bc3e26ca$export$4a8b8c14090dd065)(parameters, request.state);
    if (request.claims || authOptions.clientCapabilities && authOptions.clientCapabilities.length > 0) (0, $1ac773f7bc3e26ca$export$b04c3bca9165ed02)(parameters, request.claims, authOptions.clientCapabilities);
    if (request.embeddedClientId) (0, $1ac773f7bc3e26ca$export$5ea4577e2a518c27)(parameters, authOptions.clientId, authOptions.redirectUri);
    // If extraQueryParameters includes instance_aware its value will be added when extraQueryParameters are added
    if (authOptions.instanceAware && (!request.extraQueryParameters || !Object.keys(request.extraQueryParameters).includes((0, $8fa592d3142882bc$export$d72b25d13120919d)))) (0, $1ac773f7bc3e26ca$export$50b40dfb1d11b77a)(parameters);
    return parameters;
}
/**
 * Returns authorize endpoint with given request parameters in the query string
 * @param authority
 * @param requestParameters
 * @returns
 */ function $1e317ba7365dc00e$export$e397eb426c115a0a(authority, requestParameters, encodeParams, extraQueryParameters) {
    const queryString = (0, $2bfa541b563305f9$export$44d4663acf79cde2)(requestParameters, encodeParams, extraQueryParameters);
    return (0, $7c3562667cdabc20$export$3abcdca7229e54f2).appendQueryString(authority.authorizationEndpoint, queryString);
}
/**
 * Handles the hash fragment response from public client code request. Returns a code response used by
 * the client to exchange for a token in acquireToken.
 * @param serverParams
 * @param cachedState
 */ function $1e317ba7365dc00e$export$36c64a7d10cf377b(serverParams, cachedState) {
    // Get code response
    $1e317ba7365dc00e$export$9979de10627480c5(serverParams, cachedState);
    // throw when there is no auth code in the response
    if (!serverParams.code) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$93625fc864d26bba));
    return serverParams;
}
/**
 * Function which validates server authorization code response.
 * @param serverResponseHash
 * @param requestState
 */ function $1e317ba7365dc00e$export$9979de10627480c5(serverResponse, requestState) {
    if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$ef9214cfa5960fc), "Cached State") : (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$ef9214cfa5960fc), "Server State");
    let decodedServerResponseState;
    let decodedRequestState;
    try {
        decodedServerResponseState = decodeURIComponent(serverResponse.state);
    } catch (e) {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$72a77317632c052b), serverResponse.state);
    }
    try {
        decodedRequestState = decodeURIComponent(requestState);
    } catch (e) {
        throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$72a77317632c052b), serverResponse.state);
    }
    if (decodedServerResponseState !== decodedRequestState) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$6a56d8f882843cd8));
    // Check for error
    if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
        const serverErrorNo = $1e317ba7365dc00e$var$parseServerErrorNo(serverResponse);
        if ((0, $6fdc601aa485fcf1$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.correlation_id || "", serverResponse.claims || "", serverErrorNo);
        throw new (0, $74e5e9d464560d66$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverErrorNo);
    }
}
/**
 * Get server error No from the error_uri
 * @param serverResponse
 * @returns
 */ function $1e317ba7365dc00e$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
 * @param account
 */ function $1e317ba7365dc00e$var$extractAccountSid(account) {
    return account.idTokenClaims?.sid || null;
}
function $1e317ba7365dc00e$var$extractLoginHint(account) {
    return account.loginHint || account.idTokenClaims?.login_hint || null;
}






/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $97faeb8064d8ec72$export$a30cd982b4e89bdb {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).HandleCodeResponse, request.correlationId);
        let authCodeResponse;
        try {
            authCodeResponse = (0, $1e317ba7365dc00e$exports).getAuthorizationCodePayload(response, request.state);
        } catch (e) {
            if (e instanceof (0, $74e5e9d464560d66$export$ea52035eac03daf0) && e.subError === (0, $32d5e65f31c9045a$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6bae303c5e922702));
            else throw e;
        }
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.handleCodeResponseFromServer.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, validateNonce = true) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).HandleCodeResponseFromServer, request.correlationId);
        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $978df372b022f65e$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodeResponse.cloud_instance_host_name, request.correlationId);
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.authModule.acquireToken.bind(this.authModule), (0, $978df372b022f65e$export$2f2811a3e1b21823).AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).UPN
        };
        return null;
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 

/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $80e5be9fae3f011e$export$fbe5ac8608048ea9 = "ContentError";
const $80e5be9fae3f011e$export$9da03c0dbf887a8 = "PageException";
const $80e5be9fae3f011e$export$966ec8558e4d7922 = "user_switch";


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $7299e2bf3cde3356$export$e0aac30e542b316c = "USER_INTERACTION_REQUIRED";
const $7299e2bf3cde3356$export$bec5e49cc27c5c10 = "USER_CANCEL";
const $7299e2bf3cde3356$export$3c68b4973c91ba = "NO_NETWORK";
const $7299e2bf3cde3356$export$8cd212c10b4124d2 = "DISABLED";
const $7299e2bf3cde3356$export$f4c2bddc98c93ffc = "ACCOUNT_UNAVAILABLE";
const $7299e2bf3cde3356$export$17f9d85d4c738bc7 = "UX_NOT_ALLOWED";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $0a7a126f0093ead7$var$INVALID_METHOD_ERROR = -2147186943;
const $0a7a126f0093ead7$export$9a1233b0d52ed7cd = {
    [(0, $80e5be9fae3f011e$export$966ec8558e4d7922)]: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
};
class $0a7a126f0093ead7$export$4b8a4f6256e840ab extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, description, ext){
        super(errorCode, description);
        Object.setPrototypeOf(this, $0a7a126f0093ead7$export$4b8a4f6256e840ab.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $0a7a126f0093ead7$export$f21e42e365baeb50(error) {
    if (error.ext && error.ext.status && error.ext.status === (0, $7299e2bf3cde3356$export$8cd212c10b4124d2)) return true;
    if (error.ext && error.ext.error && error.ext.error === $0a7a126f0093ead7$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, $80e5be9fae3f011e$export$fbe5ac8608048ea9:
        case 0, $80e5be9fae3f011e$export$9da03c0dbf887a8:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $0a7a126f0093ead7$export$9154414ec87d187b(code, description, ext) {
    if (ext && ext.status) switch(ext.status){
        case 0, $7299e2bf3cde3356$export$f4c2bddc98c93ffc:
            return (0, $6fdc601aa485fcf1$export$8f7a741750c16535)((0, $802def46dc9c1a5c$exports).nativeAccountUnavailable);
        case 0, $7299e2bf3cde3356$export$e0aac30e542b316c:
            return new (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba)(code, description);
        case 0, $7299e2bf3cde3356$export$bec5e49cc27c5c10:
            return (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6bae303c5e922702));
        case 0, $7299e2bf3cde3356$export$3c68b4973c91ba:
            return (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$31ae862f18c3b2b7));
        case 0, $7299e2bf3cde3356$export$17f9d85d4c738bc7:
            return (0, $6fdc601aa485fcf1$export$8f7a741750c16535)((0, $802def46dc9c1a5c$exports).uxNotAllowed);
    }
    return new $0a7a126f0093ead7$export$4b8a4f6256e840ab(code, $0a7a126f0093ead7$export$9a1233b0d52ed7cd[code] || description, ext);
}



/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 










'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $f8d379810684c677$export$e344f5b12c464597 extends (0, $45a151a2a9ebe1f6$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, request.correlationId);
        let lastCacheOutcome = (0, $6c5f3cda7e712574$export$aa4af185ea049f6b).NOT_APPLICABLE;
        if (request.forceRefresh || !this.config.cacheOptions.claimsBasedCachingEnabled && !(0, $95ac7d904346f305$export$ecc754f99843e759).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, $6c5f3cda7e712574$export$aa4af185ea049f6b).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$e23b692cce0c7779));
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$5a3c7d1c90ac9220));
        const requestTenantId = request.account.tenantId || (0, $55d9936263fe2e81$export$6ed5af33d279fbc7)(request.authority);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, $6c5f3cda7e712574$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$e23b692cce0c7779));
        } else if ((0, $0e146ed7106c6e64$export$8961be72dcbc368e)(cachedAccessToken.cachedAt) || (0, $0e146ed7106c6e64$export$b007d77a962aa175)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, $6c5f3cda7e712574$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$e23b692cce0c7779));
        } else if (cachedAccessToken.refreshOn && (0, $0e146ed7106c6e64$export$b007d77a962aa175)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, $6c5f3cda7e712574$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(request.account), request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId, this.performanceClient),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.generateResultFromCacheRecord.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, $6c5f3cda7e712574$export$aa4af185ea049f6b).NOT_APPLICABLE) this.logger.info(`Token refresh is required due to cache outcome: ${cacheOutcome}`);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, request.correlationId);
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, $4f8cb1da78e4daf9$export$8a59e6f35fb00518)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode);
        // token max_age check
        if (request.maxAge || request.maxAge === 0) {
            const authTime = idTokenClaims?.auth_time;
            if (!authTime) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$43356944266c945e));
            (0, $4f8cb1da78e4daf9$export$ee7a34ea7880144c)(authTime, request.maxAge);
        }
        return (0, $2e62d88635b5d0eb$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenClaims);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $dd39764699851949$export$59d4f873ee62d01e extends (0, $e07870fd0db9b50c$export$fa9179cade3eb05a) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const clientConfig = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, $f8d379810684c677$export$e344f5b12c464597)(clientConfig, this.performanceClient);
        this.logger.verbose("Silent auth client created");
        try {
            const response = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, $d8ef97823beb75e7$export$f8eb6760ca13876a) && error.errorCode === (0, $32d5e65f31c9045a$export$a416b0eceb5c15df)) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return this.clearCacheOnLogout(validLogoutRequest.correlationId, validLogoutRequest?.account);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $61a4b151dc513230$export$3f89612b3fd8831f extends (0, $c195e70a46d17059$export$d858565f81c03f1f) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.apiId = apiId;
        this.accountId = accountId;
        this.platformAuthProvider = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, $dd39764699851949$export$59d4f873ee62d01e)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        const extensionName = this.platformAuthProvider.getExtensionName();
        this.skus = (0, $1d2c81b0b1bfc4d0$export$bddbbc43a3ca9c53).makeExtraSkuString({
            libraryName: (0, $d94c9b6ecea78646$export$a0a689e4294b9880).MSAL_SKU,
            libraryVersion: (0, $cdd21367776b6362$export$83d89fbfd8236492),
            extensionName: extensionName,
            extensionVersion: this.platformAuthProvider.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, $8fa592d3142882bc$exports).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, this.correlationId);
        this.logger.trace("NativeInteractionClient - acquireToken called.");
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, this.correlationId);
        const reqTimestamp = (0, $0e146ed7106c6e64$exports).nowSeconds();
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // initialize native request
            const nativeRequest = await this.initializeNativeRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                if (cacheLookupPolicy === (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessToken) {
                    this.logger.info("MSAL internal Cache does not contain tokens, return error as per cache policy");
                    nativeATMeasurement.end({
                        success: false,
                        brokerErrorCode: "cache_request_failed"
                    });
                    throw e;
                }
                // continue with a native call for any and all errors
                this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
            }
            const validatedResponse = await this.platformAuthProvider.sendMessage(nativeRequest);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, $0a7a126f0093ead7$export$4b8a4f6256e840ab)) serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            nativeATMeasurement.end({
                success: false
            });
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
            throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).noAccountFound);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        }, this.correlationId);
        if (!account) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).noAccountFound);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const fullAccount = {
                ...account,
                idTokenClaims: result?.idTokenClaims,
                idToken: result?.idToken
            };
            return {
                ...result,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     */ async acquireTokenRedirect(request, rootMeasurement) {
        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
        const { ...remainingParameters } = request;
        delete remainingParameters.onRedirectNavigate;
        const nativeRequest = await this.initializeNativeRequest(remainingParameters);
        try {
            await this.platformAuthProvider.sendMessage(nativeRequest);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, $0a7a126f0093ead7$export$4b8a4f6256e840ab)) {
                const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, $0a7a126f0093ead7$export$f21e42e365baeb50)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise(performanceClient, correlationId) {
        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
            if (performanceClient && correlationId) performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, correlationId);
            return null;
        }
        const { prompt: prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).NATIVE_REQUEST));
        const reqTimestamp = (0, $0e146ed7106c6e64$exports).nowSeconds();
        try {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
            const response = await this.platformAuthProvider.sendMessage(request);
            const authResult = await this.handleNativeResponse(response, request, reqTimestamp);
            const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
            serverTelemetryManager.clearNativeBrokerErrorCode();
            if (performanceClient && this.correlationId) this.performanceClient.addFields({
                isNativeBroker: true
            }, this.correlationId);
            return authResult;
        } catch (e) {
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
        // generate identifiers
        const idTokenClaims = (0, $4f8cb1da78e4daf9$exports).extractTokenClaims(response.id_token, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e));
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        // add exception for double brokering, please note this is temporary and will be fortified in future
        if (request.extraParameters?.child_client_id && response.account.id !== request.accountId) this.logger.info("handleNativeServerResponse: Double broker flow detected, ignoring accountId mismatch");
        else if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, $0a7a126f0093ead7$export$9154414ec87d187b)((0, $80e5be9fae3f011e$export$966ec8558e4d7922));
        // Get the preferred_cache domain for the given authority
        const authority = await this.getDiscoveredAuthority({
            requestAuthority: request.authority
        });
        const baseAccount = (0, $2e62d88635b5d0eb$export$73b84062d58a1307)(this.browserStorage, authority, homeAccountIdentifier, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e), this.correlationId, idTokenClaims, response.client_info, undefined, idTokenClaims.tid, undefined, response.account.id, this.logger);
        // Ensure expires_in is in number format
        response.expires_in = Number(response.expires_in);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        await this.cacheAccount(baseAccount, this.correlationId, (0, $4f8cb1da78e4daf9$exports).isKmsi(idTokenClaims));
        await this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, response.access_token, result.tenantId, reqTimestamp);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, $b16513504135b2c0$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING, (0, $e4974a8758ed20fc$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(requestScopes, responseScopes) {
        return responseScopes ? (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(responseScopes) : (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(requestScopes);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, $d505067a6a64c47e$export$3dd8467151c83e3e)(this.browserCrypto);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).keyIdMissing);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response.properties.MATS);
        // If scopes not returned in server response, use request scopes
        const responseScopes = this.generateScopes(request.scope, response.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
        const accountInfo = (0, $d08229a94d11167d$export$452a054c78b83dad)((0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(accountEntity), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) accountInfo.nativeAccountId = response.account.id;
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP ? (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP : (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            // Request timestamp and NativeResponse expires_in are in seconds, converting to Date for AuthenticationResult
            expiresOn: (0, $0e146ed7106c6e64$exports).toDateFromSeconds(reqTimestamp + response.expires_in),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromNativeBroker: true
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ async cacheAccount(accountEntity, correlationId, kmsi) {
        // Store the account info and hence `nativeAccountId` in browser cache
        await this.browserStorage.setAccount(accountEntity, this.correlationId, kmsi);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext((0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(accountEntity), correlationId);
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, responseAccessToken, tenantId, reqTimestamp) {
        const cachedIdToken = (0, $2175959ac3ad49fc$exports).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP ? (0, $6c5f3cda7e712574$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response.scope, request.scope);
        const cachedAccessToken = (0, $2175959ac3ad49fc$exports).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e), undefined, request.tokenType, undefined, request.keyId);
        const nativeCacheRecord = {
            idToken: cachedIdToken,
            accessToken: cachedAccessToken
        };
        return this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, this.correlationId, (0, $4f8cb1da78e4daf9$exports).isKmsi(idTokenClaims), request.storeInCache);
    }
    getExpiresInValue(tokenType, expiresIn) {
        return tokenType === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP ? (0, $6c5f3cda7e712574$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof expiresIn === "string" ? parseInt(expiresIn, 10) : expiresIn) || 0;
    }
    addTelemetryFromNativeResponse(matsResponse) {
        const mats = this.getMATSFromResponse(matsResponse);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.platformAuthProvider.getExtensionId(),
            extensionVersion: this.platformAuthProvider.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(matsResponse) {
        if (matsResponse) try {
            return JSON.parse(matsResponse);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializeNativeRequest(request) {
        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
        const canonicalAuthority = await this.getCanonicalAuthority(request);
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes: scopes, ...remainingProperties } = request;
        const scopeSet = new (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99)(scopes || []);
        scopeSet.appendScopes((0, $6c5f3cda7e712574$export$893b1b5b686d84ef));
        const validatedRequest = {
            ...remainingProperties,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: this.getRedirectUri(request.redirectUri),
            prompt: this.getPrompt(request.prompt),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraQueryParameters,
                ...request.tokenQueryParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$f6f43ae33ad04b91));
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            const popTokenGenerator = new (0, $d505067a6a64c47e$export$3dd8467151c83e3e)(this.browserCrypto);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $978df372b022f65e$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, this.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    async getCanonicalAuthority(request) {
        const requestAuthority = request.authority || this.config.auth.authority;
        if (request.account) // validate authority
        await this.getDiscoveredAuthority({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: request.azureCloudOptions,
            account: request.account
        });
        const canonicalAuthority = new (0, $7c3562667cdabc20$export$3abcdca7229e54f2)(requestAuthority);
        canonicalAuthority.validateAsUri();
        return canonicalAuthority;
    }
    getPrompt(prompt) {
        // If request is silent, prompt is always none
        switch(this.apiId){
            case (0, $d94c9b6ecea78646$export$192d74ad69b40705).ssoSilent:
            case (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                return (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE;
        }
        // Prompt not provided, request may proceed and native broker decides if it needs to prompt
        if (!prompt) {
            this.logger.trace("initializeNativeRequest: prompt was not provided");
            return undefined;
        }
        // If request is interactive, check if prompt provided is allowed to go directly to native broker
        switch(prompt){
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE:
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).CONSENT:
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).LOGIN:
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).SELECT_ACCOUNT:
                this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                return prompt;
            default:
                this.logger.trace(`initializeNativeRequest: prompt = ${prompt} is not compatible with native flow`);
                throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$62fdd8848aa75547));
        }
    }
    /**
     * Handles extra broker request parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, $8fa592d3142882bc$exports).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, $8fa592d3142882bc$exports).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, $8fa592d3142882bc$exports).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, $8fa592d3142882bc$exports).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, $8fa592d3142882bc$exports).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, this.correlationId);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $4be626c90f3b0bb8$var$getStandardParameters(config, authority, request, logger, performanceClient) {
    const parameters = (0, $1e317ba7365dc00e$exports).getStandardAuthorizeRequestParameters({
        ...config.auth,
        authority: authority
    }, request, logger, performanceClient);
    (0, $1ac773f7bc3e26ca$exports).addLibraryInfo(parameters, {
        sku: (0, $d94c9b6ecea78646$export$a0a689e4294b9880).MSAL_SKU,
        version: (0, $cdd21367776b6362$export$83d89fbfd8236492),
        os: "",
        cpu: ""
    });
    if (config.auth.protocolMode !== (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC) (0, $1ac773f7bc3e26ca$exports).addApplicationTelemetry(parameters, config.telemetry.application);
    if (request.platformBroker) {
        // signal ests that this is a WAM call
        (0, $1ac773f7bc3e26ca$exports).addNativeBroker(parameters);
        // instrument JS-platform bridge specific fields
        performanceClient.addFields({
            isPlatformAuthorizeRequest: true
        }, request.correlationId);
        // pass the req_cnf for POP
        if (request.authenticationScheme === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP) {
            const cryptoOps = new (0, $15ce4860f5b428a8$export$c274a7f0ebd24b14)(logger, performanceClient);
            const popTokenGenerator = new (0, $d505067a6a64c47e$export$3dd8467151c83e3e)(cryptoOps);
            // req_cnf is always sent as a string for SPAs
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $978df372b022f65e$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, performanceClient, request.correlationId)(request, logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = cryptoOps.encodeKid(request.popKid);
            (0, $1ac773f7bc3e26ca$exports).addPopToken(parameters, reqCnfData);
        }
    }
    (0, $1ac773f7bc3e26ca$exports).instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return parameters;
}
/**
 * Gets the full /authorize URL with request parameters when using Auth Code + PKCE
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $4be626c90f3b0bb8$export$a256231ce8625983(config, authority, request, logger, performanceClient) {
    if (!request.codeChallenge) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).pkceParamsMissing);
    const parameters = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)($4be626c90f3b0bb8$var$getStandardParameters, (0, $978df372b022f65e$export$2f2811a3e1b21823).GetStandardParams, logger, performanceClient, request.correlationId)(config, authority, request, logger, performanceClient);
    (0, $1ac773f7bc3e26ca$exports).addResponseType(parameters, (0, $6c5f3cda7e712574$export$5ef2b2ebd3da3e04).CODE);
    (0, $1ac773f7bc3e26ca$exports).addCodeChallengeParams(parameters, request.codeChallenge, (0, $6c5f3cda7e712574$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD);
    (0, $1ac773f7bc3e26ca$exports).addExtraQueryParameters(parameters, request.extraQueryParameters || {});
    return (0, $1e317ba7365dc00e$exports).getAuthorizeUrl(authority, parameters, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using EAR
 */ async function $4be626c90f3b0bb8$export$3c140ef19fa8de34(frame, config, authority, request, logger, performanceClient) {
    if (!request.earJwk) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$2c031f99d3e081ff));
    const parameters = await $4be626c90f3b0bb8$var$getStandardParameters(config, authority, request, logger, performanceClient);
    (0, $1ac773f7bc3e26ca$exports).addResponseType(parameters, (0, $6c5f3cda7e712574$export$5ef2b2ebd3da3e04).IDTOKEN_TOKEN_REFRESHTOKEN);
    (0, $1ac773f7bc3e26ca$exports).addEARParameters(parameters, request.earJwk);
    // Also add codeChallenge as backup in case EAR is not supported
    (0, $1ac773f7bc3e26ca$exports).addCodeChallengeParams(parameters, request.codeChallenge, (0, $6c5f3cda7e712574$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD);
    const queryParams = new Map();
    (0, $1ac773f7bc3e26ca$exports).addExtraQueryParameters(queryParams, request.extraQueryParameters || {});
    const url = (0, $1e317ba7365dc00e$exports).getAuthorizeUrl(authority, queryParams, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
    return $4be626c90f3b0bb8$var$createForm(frame, url, parameters);
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using POST method
 */ async function $4be626c90f3b0bb8$export$a76e1509233f1aec(frame, config, authority, request, logger, performanceClient) {
    const parameters = await $4be626c90f3b0bb8$var$getStandardParameters(config, authority, request, logger, performanceClient);
    (0, $1ac773f7bc3e26ca$exports).addResponseType(parameters, (0, $6c5f3cda7e712574$export$5ef2b2ebd3da3e04).CODE);
    (0, $1ac773f7bc3e26ca$exports).addCodeChallengeParams(parameters, request.codeChallenge, request.codeChallengeMethod || (0, $6c5f3cda7e712574$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD);
    (0, $1ac773f7bc3e26ca$exports).addPostBodyParameters(parameters, request.authorizePostBodyParameters || {});
    const queryParams = new Map();
    (0, $1ac773f7bc3e26ca$exports).addExtraQueryParameters(queryParams, request.extraQueryParameters || {});
    const url = (0, $1e317ba7365dc00e$exports).getAuthorizeUrl(authority, queryParams, config.auth.encodeExtraQueryParams, request.extraQueryParameters);
    return $4be626c90f3b0bb8$var$createForm(frame, url, parameters);
}
/**
 * Creates form element in the provided document with auth parameters in the post body
 * @param frame
 * @param authorizeUrl
 * @param parameters
 * @returns
 */ function $4be626c90f3b0bb8$var$createForm(frame, authorizeUrl, parameters) {
    const form = frame.createElement("form");
    form.method = "post";
    form.action = authorizeUrl;
    parameters.forEach((value, key)=>{
        const param = frame.createElement("input");
        param.hidden = true;
        param.name = key;
        param.value = value;
        form.appendChild(param);
    });
    frame.body.appendChild(form);
    return form;
}
/**
 * Response handler when server returns accountId on the /authorize request
 * @param request
 * @param accountId
 * @param apiId
 * @param config
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $4be626c90f3b0bb8$export$51c4d8201b4a42eb(request, accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    logger.verbose("Account id found, calling WAM for token");
    if (!platformAuthProvider) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$7b7357e3538624aa));
    const browserCrypto = new (0, $15ce4860f5b428a8$export$c274a7f0ebd24b14)(logger, performanceClient);
    const nativeInteractionClient = new (0, $61a4b151dc513230$export$3f89612b3fd8831f)(config, browserStorage, browserCrypto, logger, eventHandler, config.system.navigationClient, apiId, performanceClient, platformAuthProvider, accountId, nativeStorage, request.correlationId);
    const { userRequestState: userRequestState } = (0, $ec77d46e72c7980c$export$871e33217042c65e).parseRequestState(browserCrypto, request.state);
    return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, logger, performanceClient, request.correlationId)({
        ...request,
        state: userRequestState,
        prompt: undefined
    });
}
/**
 * Response handler when server returns code on the /authorize request
 * @param request
 * @param response
 * @param codeVerifier
 * @param authClient
 * @param browserStorage
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $4be626c90f3b0bb8$export$907304a743d3578a(request, response, codeVerifier, apiId, config, authClient, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $a7bcd64f684b1e3a$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    if (response.accountId) return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)($4be626c90f3b0bb8$export$51c4d8201b4a42eb, (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, response.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const authCodeRequest = {
        ...request,
        code: response.code || "",
        codeVerifier: codeVerifier
    };
    // Create popup interaction handler.
    const interactionHandler = new (0, $97faeb8064d8ec72$export$a30cd982b4e89bdb)(authClient, browserStorage, authCodeRequest, logger, performanceClient);
    // Handle response from hash string.
    const result = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleCodeResponse, logger, performanceClient, request.correlationId)(response, request);
    return result;
}
/**
 * Response handler when server returns ear_jwe on the /authorize request
 * @param request
 * @param response
 * @param apiId
 * @param config
 * @param authority
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $4be626c90f3b0bb8$export$21aeb02dac823516(request, response, apiId, config, authority, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    (0, $a7bcd64f684b1e3a$export$c060a619741dd765).removeThrottle(browserStorage, config.auth.clientId, request);
    // Validate state & check response for errors
    (0, $1e317ba7365dc00e$exports).validateAuthorizationResponse(response, request.state);
    if (!response.ear_jwe) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$b9f7c47ac4054f3d));
    if (!request.earJwk) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$2c031f99d3e081ff));
    const decryptedData = JSON.parse(await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$13b9c776ab498ef3), (0, $978df372b022f65e$export$2f2811a3e1b21823).DecryptEarResponse, logger, performanceClient, request.correlationId)(request.earJwk, response.ear_jwe));
    if (decryptedData.accountId) return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)($4be626c90f3b0bb8$export$51c4d8201b4a42eb, (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, decryptedData.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const responseHandler = new (0, $2e62d88635b5d0eb$export$f456c9835cc63582)(config.auth.clientId, browserStorage, new (0, $15ce4860f5b428a8$export$c274a7f0ebd24b14)(logger, performanceClient), logger, null, null, performanceClient);
    // Validate response. This function throws a server error if an error is returned by the server.
    responseHandler.validateTokenResponse(decryptedData);
    // Temporary until response handler is refactored to be more flow agnostic.
    const additionalData = {
        code: "",
        state: request.state,
        nonce: request.nonce,
        client_info: decryptedData.client_info,
        cloud_graph_host_name: decryptedData.cloud_graph_host_name,
        cloud_instance_host_name: decryptedData.cloud_instance_host_name,
        cloud_instance_name: decryptedData.cloud_instance_name,
        msgraph_host: decryptedData.msgraph_host
    };
    return await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleServerTokenResponse, logger, performanceClient, request.correlationId)(decryptedData, authority, (0, $0e146ed7106c6e64$exports).nowSeconds(), request, additionalData, undefined, undefined, undefined, undefined);
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $8c0aba2bb99ff08c$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $8c0aba2bb99ff08c$export$91d5e5a023803853(performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, correlationId);
    const codeVerifier = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)($8c0aba2bb99ff08c$var$generateCodeVerifier, (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)($8c0aba2bb99ff08c$var$generateCodeChallengeFromVerifier, (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $8c0aba2bb99ff08c$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($8c0aba2bb99ff08c$var$RANDOM_BYTE_ARR_LENGTH);
        (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $6f7127724a699469$export$960b9ff25e7d4257), (0, $978df372b022f65e$export$2f2811a3e1b21823).GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, $22782b013da7b52b$export$84f5a428c7153a69)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$ee549107fa376fc1));
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $8c0aba2bb99ff08c$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, correlationId);
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$52caff7bddbaf316), (0, $978df372b022f65e$export$2f2811a3e1b21823).Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier, performanceClient, correlationId);
        // encode hash as base64
        return (0, $22782b013da7b52b$export$84f5a428c7153a69)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$ee549107fa376fc1));
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $2d3b06de4d0f5457$export$de4c158ddf8b89f6 {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
        this.platformAuthType = (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).PLATFORM_EXTENSION_PROVIDER;
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param request
     */ async sendMessage(request) {
        this.logger.trace(this.platformAuthType + " - sendMessage called.");
        // fall back to native calls
        const messageBody = {
            method: (0, $d94c9b6ecea78646$export$3536098be6c7dadb).GetToken,
            request: request
        };
        const req = {
            channel: (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $6f7127724a699469$export$6ef0355fa80a5278)(),
            body: messageBody
        };
        this.logger.trace(this.platformAuthType + " - Sending request to browser extension");
        this.logger.tracePii(this.platformAuthType + ` - Sending request to browser extension: ${JSON.stringify(req)}`);
        this.messageChannel.port1.postMessage(req);
        const response = await new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
        const validatedResponse = this.validatePlatformBrokerResponse(response);
        return validatedResponse;
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient) {
        logger.trace("PlatformAuthExtensionHandler - createProvider called.");
        try {
            const preferredProvider = new $2d3b06de4d0f5457$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient, (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest();
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $2d3b06de4d0f5457$export$de4c158ddf8b89f6(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest();
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest() {
        this.logger.trace(this.platformAuthType + " - sendHandshakeRequest called.");
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $6f7127724a699469$export$6ef0355fa80a5278)(),
            body: {
                method: (0, $d94c9b6ecea78646$export$3536098be6c7dadb).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$4747c302ef0117fd)));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        this.logger.trace(this.platformAuthType + " - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $d94c9b6ecea78646$export$3536098be6c7dadb).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(this.platformAuthType + `.onWindowMessage - resolver can't be found for request ${request.responseId}`);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `Extension with id: ${request.extensionId} not installed` : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$59080ea2398ee306)));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        this.logger.trace(this.platformAuthType + " - onChannelMessage called.");
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, $d94c9b6ecea78646$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace(this.platformAuthType + " - Received response from browser extension");
                this.logger.tracePii(this.platformAuthType + ` - Received response from browser extension: ${JSON.stringify(response)}`);
                if (response.status !== "Success") resolver.reject((0, $0a7a126f0093ead7$export$9154414ec87d187b)(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $0a7a126f0093ead7$export$9154414ec87d187b)(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $0a726c4076f6517d$export$eb157f7636c79bd2)((0, $0269aad95c21e8be$exports).unexpectedError, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $d94c9b6ecea78646$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(this.platformAuthType + `.onChannelMessage - resolver can't be found for request ${request.responseId}`);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(this.platformAuthType + ` - Received HandshakeResponse from extension: ${this.extensionId}`);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii(`Error parsing response from WAM Extension: ${err}`);
            this.logger.errorPii(`Unable to parse ${event}`);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $0a726c4076f6517d$export$eb157f7636c79bd2)((0, $0269aad95c21e8be$exports).unexpectedError, "Response missing expected properties.");
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    getExtensionName() {
        return this.getExtensionId() === (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : undefined;
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $0d71154966fe23de$export$aa8591dfbb8a4c65 {
    constructor(logger, performanceClient, correlationId){
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.platformAuthType = (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(logger, performanceClient, correlationId) {
        logger.trace("PlatformAuthDOMHandler: createProvider called");
        // @ts-ignore
        if (window.navigator?.platformAuthentication) {
            const supportedContracts = // @ts-ignore
            await window.navigator.platformAuthentication.getSupportedContracts((0, $d94c9b6ecea78646$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID);
            if (supportedContracts?.includes((0, $d94c9b6ecea78646$export$3ebdf53424883b5f).PLATFORM_DOM_APIS)) {
                logger.trace("Platform auth api available in DOM");
                return new $0d71154966fe23de$export$aa8591dfbb8a4c65(logger, performanceClient, correlationId);
            }
        }
        return undefined;
    }
    /**
     * Returns the Id for the broker extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
        return "";
    }
    getExtensionName() {
        return (0, $d94c9b6ecea78646$export$3ebdf53424883b5f).DOM_API_NAME;
    }
    /**
     * Send token request to platform broker via browser DOM API
     * @param request
     * @returns
     */ async sendMessage(request) {
        this.logger.trace(this.platformAuthType + " - Sending request to browser DOM API");
        try {
            const platformDOMRequest = this.initializePlatformDOMRequest(request);
            const response = // @ts-ignore
            await window.navigator.platformAuthentication.executeGetToken(platformDOMRequest);
            return this.validatePlatformBrokerResponse(response);
        } catch (e) {
            this.logger.error(this.platformAuthType + " - executeGetToken DOM API error");
            throw e;
        }
    }
    initializePlatformDOMRequest(request) {
        this.logger.trace(this.platformAuthType + " - initializeNativeDOMRequest called");
        const { accountId: accountId, clientId: clientId, authority: authority, scope: scope, redirectUri: redirectUri, correlationId: correlationId, state: state, storeInCache: storeInCache, embeddedClientId: embeddedClientId, extraParameters: extraParameters, ...remainingProperties } = request;
        const validExtraParameters = this.getDOMExtraParams(remainingProperties);
        const platformDOMRequest = {
            accountId: accountId,
            brokerId: this.getExtensionId(),
            authority: authority,
            clientId: clientId,
            correlationId: correlationId || this.correlationId,
            extraParameters: {
                ...extraParameters,
                ...validExtraParameters
            },
            isSecurityTokenService: false,
            redirectUri: redirectUri,
            scope: scope,
            state: state,
            storeInCache: storeInCache,
            embeddedClientId: embeddedClientId
        };
        return platformDOMRequest;
    }
    validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("isSuccess")) {
            if (response.hasOwnProperty("accessToken") && response.hasOwnProperty("idToken") && response.hasOwnProperty("clientInfo") && response.hasOwnProperty("account") && response.hasOwnProperty("scopes") && response.hasOwnProperty("expiresIn")) {
                this.logger.trace(this.platformAuthType + " - platform broker returned successful and valid response");
                return this.convertToPlatformBrokerResponse(response);
            } else if (response.hasOwnProperty("error")) {
                const errorResponse = response;
                if (errorResponse.isSuccess === false && errorResponse.error && errorResponse.error.code) {
                    this.logger.trace(this.platformAuthType + " - platform broker returned error response");
                    throw (0, $0a7a126f0093ead7$export$9154414ec87d187b)(errorResponse.error.code, errorResponse.error.description, {
                        error: parseInt(errorResponse.error.errorCode),
                        protocol_error: errorResponse.error.protocolError,
                        status: errorResponse.error.status,
                        properties: errorResponse.error.properties
                    });
                }
            }
        }
        throw (0, $0a726c4076f6517d$export$eb157f7636c79bd2)((0, $0269aad95c21e8be$exports).unexpectedError, "Response missing expected properties.");
    }
    convertToPlatformBrokerResponse(response) {
        this.logger.trace(this.platformAuthType + " - convertToNativeResponse called");
        const nativeResponse = {
            access_token: response.accessToken,
            id_token: response.idToken,
            client_info: response.clientInfo,
            account: response.account,
            expires_in: response.expiresIn,
            scope: response.scopes,
            state: response.state || "",
            properties: response.properties || {},
            extendedLifetimeToken: response.extendedLifetimeToken ?? false,
            shr: response.proofOfPossessionPayload
        };
        return nativeResponse;
    }
    getDOMExtraParams(extraParameters) {
        const stringifiedParams = Object.entries(extraParameters).reduce((record, [key, value])=>{
            record[key] = String(value);
            return record;
        }, {});
        const validExtraParams = {
            ...stringifiedParams
        };
        return validExtraParams;
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks if the platform broker is available in the current environment.
 * @param loggerOptions
 * @param perfClient
 * @returns
 */ async function $c1ac581036487902$export$bce61db0d62ff8e2(loggerOptions, perfClient, correlationId, domConfig) {
    const logger = new (0, $9d8c7bd8b3e958dc$export$efa9a398d6368992)(loggerOptions || {}, (0, $cdd21367776b6362$export$a8ff84c12d48cfa6), (0, $cdd21367776b6362$export$83d89fbfd8236492));
    logger.trace("isPlatformBrokerAvailable called");
    const performanceClient = perfClient || new (0, $918248d5b9dc501b$export$c70f2989a65fda3e)();
    if (typeof window === "undefined") {
        logger.trace("Non-browser environment detected, returning false");
        return false;
    }
    return !!await $c1ac581036487902$export$b2c9df3607dc771a(logger, performanceClient, correlationId || (0, $6f7127724a699469$export$6ef0355fa80a5278)(), undefined, domConfig);
}
async function $c1ac581036487902$export$b2c9df3607dc771a(logger, performanceClient, correlationId, nativeBrokerHandshakeTimeout, enablePlatformBrokerDOMSupport) {
    logger.trace("getPlatformAuthProvider called", correlationId);
    logger.trace("Has client allowed platform auth via DOM API: " + enablePlatformBrokerDOMSupport);
    let platformAuthProvider;
    try {
        if (enablePlatformBrokerDOMSupport) // Check if DOM platform API is supported first
        platformAuthProvider = await (0, $0d71154966fe23de$export$aa8591dfbb8a4c65).createProvider(logger, performanceClient, correlationId);
        if (!platformAuthProvider) {
            logger.trace("Platform auth via DOM API not available, checking for extension");
            /*
             * If DOM APIs are not available, check if browser extension is available.
             * Platform authentication via DOM APIs is preferred over extension APIs.
             */ platformAuthProvider = await (0, $2d3b06de4d0f5457$export$de4c158ddf8b89f6).createProvider(logger, nativeBrokerHandshakeTimeout || (0, $cd84efde5e2481ce$export$73d1d87a8b7ddb57), performanceClient);
        }
    } catch (e) {
        logger.trace("Platform auth not available", e);
    }
    return platformAuthProvider;
}
/**
 * Returns boolean indicating whether or not the request should attempt to use native broker
 * @param logger
 * @param config
 * @param platformAuthProvider
 * @param authenticationScheme
 */ function $c1ac581036487902$export$4815cc9f88d4f6a5(config, logger, platformAuthProvider, authenticationScheme) {
    logger.trace("isPlatformAuthAllowed called");
    // throw an error if allowPlatformBroker is not enabled and allowPlatformBrokerWithDOM is enabled
    if (!config.system.allowPlatformBroker && config.system.allowPlatformBrokerWithDOM) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$exports).invalidPlatformBrokerConfiguration);
    if (!config.system.allowPlatformBroker) {
        logger.trace("isPlatformAuthAllowed: allowPlatformBroker is not enabled, returning false");
        // Developer disabled WAM
        return false;
    }
    if (!platformAuthProvider) {
        logger.trace("isPlatformAuthAllowed: Platform auth provider is not initialized, returning false");
        // Platform broker auth providers are not available
        return false;
    }
    if (authenticationScheme) switch(authenticationScheme){
        case (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER:
        case (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP:
            logger.trace("isPlatformAuthAllowed: authenticationScheme is supported, returning true");
            return true;
        default:
            logger.trace("isPlatformAuthAllowed: authenticationScheme is not supported, returning false");
            return false;
    }
    return true;
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $39af8753fb8b2f3d$export$43b0fce132d066f4 extends (0, $e07870fd0db9b50c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, platformAuthHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthHandler, correlationId);
        // Properly sets this reference for the unload event.
        this.unloadWindow = this.unloadWindow.bind(this);
        this.nativeStorage = nativeStorageImpl;
        this.eventHandler = eventHandler;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     * @param pkceCodes
     */ acquireToken(request, pkceCodes) {
        let popupParams = undefined;
        try {
            const popupName = this.generatePopupName(request.scopes || (0, $6c5f3cda7e712574$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            this.performanceClient.addFields({
                isAsyncPopup: this.config.system.asyncPopups
            }, this.correlationId);
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            } else {
                // Pre-validate request method to avoid opening popup if the request is invalid
                const validatedRequest = {
                    ...request,
                    httpMethod: (0, $d1aaa9bd4087c904$export$253b550f4555e4bf)(request, this.config.auth.protocolMode)
                };
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(validatedRequest, popupParams, pkceCodes);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param request
     * @param popupParams
     * @param pkceCodes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams, pkceCodes) {
        this.logger.verbose("acquireTokenPopupAsync called");
        const validRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup);
        /*
         * Skip pre-connect for async popups to reduce time between user interaction and popup window creation to avoid
         * popup from being blocked by browsers with shorter popup timers
         */ if (popupParams.popup) (0, $3e9f4e3d34d422a9$export$a0816fa17a9e79be)(validRequest.authority);
        const isPlatformBroker = (0, $c1ac581036487902$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme);
        validRequest.platformBroker = isPlatformBroker;
        if (this.config.auth.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(validRequest, popupParams, pkceCodes);
        else return this.executeCodeFlow(validRequest, popupParams, pkceCodes);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @param popupParams
     * @param pkceCodes
     * @returns
     */ async executeCodeFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenPopup);
        const pkce = pkceCodes || await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $8c0aba2bb99ff08c$export$91d5e5a023803853), (0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            codeChallenge: pkce.challenge
        };
        try {
            // Initialize the client
            const authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: popupRequest.authority,
                requestAzureCloudOptions: popupRequest.azureCloudOptions,
                requestExtraQueryParameters: popupRequest.extraQueryParameters,
                account: popupRequest.account
            });
            if (popupRequest.httpMethod === (0, $6c5f3cda7e712574$export$8343e6f32f5246de).POST) return await this.executeCodeFlowWithPost(popupRequest, popupParams, authClient, pkce.verifier);
            else {
                // Create acquire token url.
                const navigateUrl = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$a256231ce8625983), (0, $978df372b022f65e$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, popupRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Get the window handle for the popup.
                const popupWindow = this.initiateAuthRequest(navigateUrl, popupParams);
                this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).POPUP_OPENED, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, {
                    popupWindow: popupWindow
                }, null);
                // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
                const responseString = await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent);
                const serverParams = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $2972d39af2213d69$export$e64c1808ed72a7c), (0, $978df372b022f65e$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
                return await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$907304a743d3578a), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkce.verifier, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
            }
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$95528b8a314880d1), (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkce = pkceCodes || await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $8c0aba2bb99ff08c$export$91d5e5a023803853), (0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const popupRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkce.challenge
        };
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const form = await (0, $4be626c90f3b0bb8$export$3c140ef19fa8de34)(popupWindow.document, this.config, discoveredAuthority, popupRequest, this.logger, this.performanceClient);
        form.submit();
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.monitorPopupForHash.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $2972d39af2213d69$export$e64c1808ed72a7c), (0, $978df372b022f65e$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
        if (!serverParams.ear_jwe && serverParams.code) {
            const authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenPopup),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$907304a743d3578a), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$21aeb02dac823516), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenPopup, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async executeCodeFlowWithPost(request, popupParams, authClient, pkceVerifier) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const form = await (0, $4be626c90f3b0bb8$export$a76e1509233f1aec)(popupWindow.document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.monitorPopupForHash.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(popupWindow, popupParams.popupWindowParent);
        const serverParams = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $2972d39af2213d69$export$e64c1808ed72a7c), (0, $978df372b022f65e$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$907304a743d3578a), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkceVerifier, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("logoutPopupAsync called");
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, validRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).logoutPopup);
        try {
            // Clear cache on logout
            await this.clearCacheOnLogout(this.correlationId, validRequest.account);
            // Initialize the client
            const authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC) {
                    this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, $d94c9b6ecea78646$export$192d74ad69b40705).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)());
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, validRequest);
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(logoutUri, popupParams);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).POPUP_OPENED, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, $d94c9b6ecea78646$export$192d74ad69b40705).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)());
                this.logger.verbose("Redirecting main window to url specified in the request");
                this.logger.verbosePii(`Redirecting main window to: ${absoluteUrl}`);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("No main window navigation requested");
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, null, e);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_END, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_END, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`Navigate to: ${requestUrl}`);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$be9285c64f247822));
        }
    }
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ monitorPopupForHash(popupWindow, popupWindowParent) {
        return new Promise((resolve, reject)=>{
            this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            const intervalId = setInterval(()=>{
                // Window is closed
                if (popupWindow.closed) {
                    this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    clearInterval(intervalId);
                    reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6bae303c5e922702)));
                    return;
                }
                let href = "";
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if (!href || href === "about:blank") return;
                clearInterval(intervalId);
                let responseString = "";
                const responseType = this.config.auth.OIDCOptions.serverResponseType;
                if (popupWindow) {
                    if (responseType === (0, $6c5f3cda7e712574$export$b34cb6fbea2adc44).QUERY) responseString = popupWindow.location.search;
                    else responseString = popupWindow.location.hash;
                }
                this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                resolve(responseString);
            }, this.config.system.pollIntervalMilliseconds);
        }).finally(()=>{
            this.cleanPopup(popupWindow, popupWindowParent);
        });
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`Navigating popup window to: ${urlNavigate}`);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`Opening popup window to: ${urlNavigate}`);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$5e827e513523a576));
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            popupParams.popupWindowParent.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$f1b7091ee48d0b3e));
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $d94c9b6ecea78646$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $d94c9b6ecea78646$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $d94c9b6ecea78646$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $d94c9b6ecea78646$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Event callback to unload main window.
     */ unloadWindow(e) {
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    }
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ cleanPopup(popupWindow, popupWindowParent) {
        // Close window.
        popupWindow.close();
        // Remove window unload function
        popupWindowParent.removeEventListener("beforeunload", this.unloadWindow);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, $d94c9b6ecea78646$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, $d94c9b6ecea78646$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 











'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $6e2bd7f3092e3421$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $6e2bd7f3092e3421$export$a368977effbc1ed6 extends (0, $e07870fd0db9b50c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, platformAuthHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthHandler, correlationId);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
        validRequest.platformBroker = (0, $c1ac581036487902$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                this.browserStorage.resetRequestCache();
                this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
            }
        };
        const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
        this.logger.verbosePii(`Redirect start page: ${redirectStartPage}`);
        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
        this.browserStorage.setTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).ORIGIN_URI, redirectStartPage, true);
        // Clear temporary cache if the back button is clicked during the redirect flow.
        window.addEventListener("pageshow", handleBackButton);
        try {
            if (this.config.auth.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).EAR) await this.executeEarFlow(validRequest);
            else await this.executeCodeFlow(validRequest, request.onRedirectNavigate);
        } catch (e) {
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) e.setCorrelationId(this.correlationId);
            window.removeEventListener("pageshow", handleBackButton);
            throw e;
        }
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request, onRedirectNavigate) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenRedirect);
        const pkceCodes = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $8c0aba2bb99ff08c$export$91d5e5a023803853), (0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, pkceCodes.verifier);
        try {
            if (redirectRequest.httpMethod === (0, $6c5f3cda7e712574$export$8343e6f32f5246de).POST) return await this.executeCodeFlowWithPost(redirectRequest);
            else {
                // Initialize the client
                const authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                    serverTelemetryManager: serverTelemetryManager,
                    requestAuthority: redirectRequest.authority,
                    requestAzureCloudOptions: redirectRequest.azureCloudOptions,
                    requestExtraQueryParameters: redirectRequest.extraQueryParameters,
                    account: redirectRequest.account
                });
                // Create acquire token url.
                const navigateUrl = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$a256231ce8625983), (0, $978df372b022f65e$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, request.correlationId)(this.config, authClient.authority, redirectRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                return await this.initiateAuthRequest(navigateUrl, onRedirectNavigate);
            }
        } catch (e) {
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$95528b8a314880d1), (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $8c0aba2bb99ff08c$export$91d5e5a023803853), (0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const redirectRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, pkceCodes.verifier);
        const form = await (0, $4be626c90f3b0bb8$export$3c140ef19fa8de34)(document, this.config, discoveredAuthority, redirectRequest, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$ce7eeda4eb1dd3c6), "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Executes classic Authorization Code flow with a POST request.
     * @param request
     */ async executeCodeFlowWithPost(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        this.browserStorage.cacheAuthorizeRequest(request);
        const form = await (0, $4be626c90f3b0bb8$export$a76e1509233f1aec)(document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$ce7eeda4eb1dd3c6), "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     */ async handleRedirectPromise(hash = "", request, pkceVerifier, parentMeasurement) {
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).handleRedirectPromise);
        try {
            const [serverParams, responseString] = this.getRedirectResponse(hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("handleRedirectPromise did not detect a response as a result of a redirect. Cleaning temporary cache.");
                this.browserStorage.resetRequestCache();
                // Do not instrument "no_server_response" if user clicked back button
                if ($6e2bd7f3092e3421$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("Back navigation event detected. Muting no_server_response error");
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
            const loginRequestUrlNormalized = (0, $2bfa541b563305f9$exports).normalizeUrlForComparison(loginRequestUrl);
            const currentUrlNormalized = (0, $2bfa541b563305f9$exports).normalizeUrlForComparison(window.location.href);
            if (loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("Current page is loginRequestUrl, handling response");
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, $3e9f4e3d34d422a9$export$9bf2691bda54425c)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
                return handleHashResult;
            } else if (!this.config.auth.navigateToLoginRequestUrl) {
                this.logger.verbose("NavigateToLoginRequestUrl set to false, handling response");
                return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            } else if (!(0, $3e9f4e3d34d422a9$export$9f140ed41af5108c)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, $d94c9b6ecea78646$export$192d74ad69b40705).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl || loginRequestUrl === "null") {
                    // Redirect to home page if login request url is null (real null or the string null)
                    const homepage = (0, $3e9f4e3d34d422a9$export$60785768478b4ffc)();
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                    this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`Navigating to loginRequestUrl: ${loginRequestUrl}`);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.serverResponseType === (0, $6c5f3cda7e712574$export$b34cb6fbea2adc44).QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, $2bfa541b563305f9$exports).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, $2972d39af2213d69$export$af0c72d18284aa0)(response, this.browserCrypto, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
            } catch (e) {
                if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) this.logger.error(`Interaction type validation failed due to ${e.errorCode}: ${e.errorMessage}`);
                return [
                    null,
                    ""
                ];
            }
            (0, $3e9f4e3d34d422a9$export$a20c3032ba81d6aa)(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $d94c9b6ecea78646$export$21d55bedf0d269fb).URL_HASH));
        if (cachedHash) {
            response = (0, $2bfa541b563305f9$exports).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("Hash does not contain known properties, returning cached hash");
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, request, codeVerifier, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$211c8e8843a8d278));
        if (serverParams.ear_jwe) {
            const discoveredAuthority = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, request.correlationId)({
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$21aeb02dac823516), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, request.correlationId)(request, serverParams, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenRedirect, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        }
        const authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: request.authority
        });
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$907304a743d3578a), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, request.correlationId)(request, serverParams, codeVerifier, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenRedirect, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     * @param onRedirectNavigateRequest - onRedirectNavigate callback provided on the request
     */ async initiateAuthRequest(requestUrl, onRedirectNavigateRequest) {
        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
        // Navigate if valid URL
        if (requestUrl) {
            this.logger.infoPii(`RedirectHandler.initiateAuthRequest: Navigate to: ${requestUrl}`);
            const navigationOptions = {
                apiId: (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const onRedirectNavigate = onRedirectNavigateRequest || this.config.auth.onRedirectNavigate;
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof onRedirectNavigate === "function") {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                const navigate = onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                    await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$be9285c64f247822));
        }
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).logout);
        try {
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, logoutRequest);
            // Clear cache on logout
            await this.clearCacheOnLogout(this.correlationId, validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, $d94c9b6ecea78646$export$192d74ad69b40705).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            if (logoutRequest && typeof logoutRequest.onRedirectNavigate === "function") {
                const navigate = logoutRequest.onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNOUT);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNOUT);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, null, e);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_END, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGOUT_END, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        return (0, $7c3562667cdabc20$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $3e9f4e3d34d422a9$export$1204531fbbf6ecde)());
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 



/*! @azure/msal-browser v4.27.0 2025-12-04 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates a hidden iframe to given URL using user-requested scopes as an id.
 * @param urlNavigate
 * @param userRequestScopes
 */ async function $40a8b0cdf17a96da$export$b5cc8574c3c26d11(requestUrl, performanceClient, logger, correlationId, navigateFrameWait) {
    performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, correlationId);
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("Navigate url is empty");
        throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$be9285c64f247822));
    }
    if (navigateFrameWait) return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)($40a8b0cdf17a96da$var$loadFrame, (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerLoadFrame, logger, performanceClient, correlationId)(requestUrl, navigateFrameWait, performanceClient, correlationId);
    return (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)($40a8b0cdf17a96da$var$loadFrameSync, (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerLoadFrameSync, logger, performanceClient, correlationId)(requestUrl);
}
async function $40a8b0cdf17a96da$export$99ef719e5be9ef9(config, authority, request, logger, performanceClient) {
    const frame = $40a8b0cdf17a96da$var$createHiddenIframe();
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, $4be626c90f3b0bb8$export$a76e1509233f1aec)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
async function $40a8b0cdf17a96da$export$dfeea08a8aa03859(config, authority, request, logger, performanceClient) {
    const frame = $40a8b0cdf17a96da$var$createHiddenIframe();
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await (0, $4be626c90f3b0bb8$export$3c140ef19fa8de34)(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
/**
 * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
 * @param iframe
 * @param timeout
 */ async function $40a8b0cdf17a96da$export$9ee275d2f26db8a7(iframe, timeout, pollIntervalMilliseconds, performanceClient, logger, correlationId, responseType) {
    performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, correlationId);
    return new Promise((resolve, reject)=>{
        if (timeout < (0, $cd84efde5e2481ce$export$f3ffe700be354b19)) logger.warning(`system.loadFrameTimeout or system.iframeHashTimeout set to lower (${timeout}ms) than the default (${(0, $cd84efde5e2481ce$export$f3ffe700be354b19)}ms). This may result in timeouts.`);
        /*
         * Polling for iframes can be purely timing based,
         * since we don't need to account for interaction.
         */ const timeoutId = window.setTimeout(()=>{
            window.clearInterval(intervalId);
            reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$c8b6efb19551013d)));
        }, timeout);
        const intervalId = window.setInterval(()=>{
            let href = "";
            const contentWindow = iframe.contentWindow;
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = contentWindow ? contentWindow.location.href : "";
            } catch (e) {}
            if (!href || href === "about:blank") return;
            let responseString = "";
            if (contentWindow) {
                if (responseType === (0, $6c5f3cda7e712574$export$b34cb6fbea2adc44).QUERY) responseString = contentWindow.location.search;
                else responseString = contentWindow.location.hash;
            }
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
            resolve(responseString);
        }, pollIntervalMilliseconds);
    }).finally(()=>{
        (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)($40a8b0cdf17a96da$var$removeHiddenIframe, (0, $978df372b022f65e$export$2f2811a3e1b21823).RemoveHiddenIframe, logger, performanceClient, correlationId)(iframe);
    });
}
/**
 * @hidden
 * Loads iframe with authorization endpoint URL
 * @ignore
 * @deprecated
 */ function $40a8b0cdf17a96da$var$loadFrame(urlNavigate, navigateFrameWait, performanceClient, correlationId) {
    performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerLoadFrame, correlationId);
    /*
     * This trick overcomes iframe navigation in IE
     * IE does not load the page consistently in iframe
     */ return new Promise((resolve, reject)=>{
        const frameHandle = $40a8b0cdf17a96da$var$createHiddenIframe();
        window.setTimeout(()=>{
            if (!frameHandle) {
                reject("Unable to load iframe");
                return;
            }
            frameHandle.src = urlNavigate;
            resolve(frameHandle);
        }, navigateFrameWait);
    });
}
/**
 * @hidden
 * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
 * @param urlNavigate
 * @param frameName
 * @param logger
 */ function $40a8b0cdf17a96da$var$loadFrameSync(urlNavigate) {
    const frameHandle = $40a8b0cdf17a96da$var$createHiddenIframe();
    frameHandle.src = urlNavigate;
    return frameHandle;
}
/**
 * @hidden
 * Creates a new hidden iframe or gets an existing one for silent token renewal.
 * @ignore
 */ function $40a8b0cdf17a96da$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    authFrame.setAttribute("allow", "local-network-access *");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from the page.
 * @ignore
 */ function $40a8b0cdf17a96da$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $19f5ddfa4f92b2d7$export$e81c7938bccef977 extends (0, $e07870fd0db9b50c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, platformAuthProvider, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE && inputRequest.prompt !== (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NO_SESSION) {
                this.logger.warning(`SilentIframeClient. Replacing invalid prompt ${inputRequest.prompt} with ${(0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE}`);
                inputRequest.prompt = (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE;
            }
        } else inputRequest.prompt = (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE;
        // Create silent request
        const silentRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent);
        silentRequest.platformBroker = (0, $c1ac581036487902$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, silentRequest.authenticationScheme);
        (0, $3e9f4e3d34d422a9$export$a0816fa17a9e79be)(silentRequest.authority);
        if (this.config.auth.protocolMode === (0, $54a6ab7df522528c$export$73a3e3dedd37150d).EAR) return this.executeEarFlow(silentRequest);
        else return this.executeCodeFlow(silentRequest);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        let authClient;
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Initialize the client
            authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, request);
        } catch (e) {
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) || e.errorCode !== (0, $d94c9b6ecea78646$export$a0a689e4294b9880).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            return await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, request);
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const correlationId = request.correlationId;
        const discoveredAuthority = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)({
            requestAuthority: request.authority,
            requestAzureCloudOptions: request.azureCloudOptions,
            requestExtraQueryParameters: request.extraQueryParameters,
            account: request.account
        });
        const earJwk = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $6f7127724a699469$export$95528b8a314880d1), (0, $978df372b022f65e$export$2f2811a3e1b21823).GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $8c0aba2bb99ff08c$export$91d5e5a023803853), (0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        const msalFrame = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $40a8b0cdf17a96da$export$dfeea08a8aa03859), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(this.config, discoveredAuthority, silentRequest, this.logger, this.performanceClient);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $40a8b0cdf17a96da$export$9ee275d2f26db8a7), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $2972d39af2213d69$export$e64c1808ed72a7c), (0, $978df372b022f65e$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger);
        if (!serverParams.ear_jwe && serverParams.code) {
            // If server doesn't support EAR, they may fallback to auth code flow instead
            const authClient = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: this.initializeServerTelemetryManager(this.apiId),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$907304a743d3578a), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$21aeb02dac823516), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseEar, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, this.apiId, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$78523a40be105a03)));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, request) {
        const correlationId = request.correlationId;
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, correlationId);
        const pkceCodes = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $8c0aba2bb99ff08c$export$91d5e5a023803853), (0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge
        };
        let msalFrame;
        if (request.httpMethod === (0, $6c5f3cda7e712574$export$8343e6f32f5246de).POST) msalFrame = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $40a8b0cdf17a96da$export$99ef719e5be9ef9), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
        else {
            // Create authorize request url
            const navigateUrl = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$a256231ce8625983), (0, $978df372b022f65e$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
            // Get the frame handle for the silent request
            msalFrame = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $40a8b0cdf17a96da$export$b5cc8574c3c26d11), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(navigateUrl, this.performanceClient, this.logger, correlationId, this.config.system.navigateFrameWait);
        }
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $40a8b0cdf17a96da$export$9ee275d2f26db8a7), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)((0, $2972d39af2213d69$export$e64c1808ed72a7c), (0, $978df372b022f65e$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $4be626c90f3b0bb8$export$907304a743d3578a), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
/*! @azure/msal-common v15.13.3 2025-12-04 */ 























'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $86941347f07cebae$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $86941347f07cebae$export$9cb096b89b92d8a8 extends (0, $45a151a2a9ebe1f6$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    async acquireToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $0e146ed7106c6e64$export$ae62599a119ac50a)();
        const response = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $6c5f3cda7e712574$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $2e62d88635b5d0eb$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$eca67ff7a91fed9d));
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$export$5a3c7d1c90ac9220));
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba) && e.errorCode === (0, $802def46dc9c1a5c$export$e408b083cd212696);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, $74e5e9d464560d66$export$ea52035eac03daf0) && e.errorCode === (0, $6c5f3cda7e712574$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $6c5f3cda7e712574$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, $978df372b022f65e$export$2f2811a3e1b21823).CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined, this.performanceClient);
        if (!refreshToken) throw (0, $6fdc601aa485fcf1$export$8f7a741750c16535)((0, $802def46dc9c1a5c$export$e408b083cd212696));
        if (refreshToken.expiresOn && (0, $0e146ed7106c6e64$export$b007d77a962aa175)(refreshToken.expiresOn, request.refreshTokenExpirationOffsetSeconds || $86941347f07cebae$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS)) {
            this.performanceClient?.addFields({
                rtExpiresOnMs: Number(refreshToken.expiresOn)
            }, request.correlationId);
            throw (0, $6fdc601aa485fcf1$export$8f7a741750c16535)((0, $802def46dc9c1a5c$export$a90e8b9c10991b49));
        }
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireToken.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest);
        } catch (e) {
            if (e instanceof (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba)) {
                this.performanceClient?.addFields({
                    rtExpiresOnMs: Number(refreshToken.expiresOn)
                }, request.correlationId);
                if (e.subError === (0, $802def46dc9c1a5c$export$2e3666c77d45a4da)) {
                    // Remove bad refresh token from cache
                    this.logger.verbose("acquireTokenWithRefreshToken: bad refresh token, removing from cache");
                    const badRefreshTokenKey = this.cacheManager.generateCredentialKey(refreshToken);
                    this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
                }
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $7c3562667cdabc20$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = this.createTokenRequestHeaders(request.ccsCredential);
        const thumbprint = (0, $58fde9510481ec07$export$2daa8cfcf54c2b48)(this.config.authOptions.clientId, request);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
        const parameters = new Map();
        (0, $1ac773f7bc3e26ca$export$8360c651f9cc692b)(parameters, request.embeddedClientId || request.tokenBodyParameters?.[0, $8fa592d3142882bc$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        if (request.redirectUri) (0, $1ac773f7bc3e26ca$export$6758d6264f4f06)(parameters, request.redirectUri);
        (0, $1ac773f7bc3e26ca$export$c213bf8f125826ba)(parameters, request.scopes, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        (0, $1ac773f7bc3e26ca$export$e5f700fdeb4022b2)(parameters, (0, $6c5f3cda7e712574$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
        (0, $1ac773f7bc3e26ca$export$86b85a101d45e918)(parameters);
        (0, $1ac773f7bc3e26ca$export$3ecac3764b147c3f)(parameters, this.config.libraryInfo);
        (0, $1ac773f7bc3e26ca$export$37ec1b76d865654a)(parameters, this.config.telemetry.application);
        (0, $1ac773f7bc3e26ca$export$26592ae2037df9de)(parameters);
        if (this.serverTelemetryManager && !(0, $8778110eec982731$export$25afa7198c2ed9b9)(this.config)) (0, $1ac773f7bc3e26ca$export$79fb524b159705e9)(parameters, this.serverTelemetryManager);
        (0, $1ac773f7bc3e26ca$export$b9e8ccbb425b80a3)(parameters, request.refreshToken);
        if (this.config.clientCredentials.clientSecret) (0, $1ac773f7bc3e26ca$export$8df84bbb0e2465bc)(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            (0, $1ac773f7bc3e26ca$export$2d3d772920e2496e)(parameters, await (0, $a6e7c7d7a5c7e4be$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            (0, $1ac773f7bc3e26ca$export$55ad911d12112f00)(parameters, clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, $6c5f3cda7e712574$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $d505067a6a64c47e$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $978df372b022f65e$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            (0, $1ac773f7bc3e26ca$export$6dfc34809d8c4096)(parameters, reqCnfData);
        } else if (request.authenticationScheme === (0, $6c5f3cda7e712574$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) (0, $1ac773f7bc3e26ca$export$f004de9a266b8070)(parameters, request.sshJwk);
            else throw (0, $826bb5c860ac82b9$export$5d63d098f4f130a1)((0, $bb6c67187aec31ed$export$8fbed44b22d9136f));
        }
        if (!(0, $95ac7d904346f305$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) (0, $1ac773f7bc3e26ca$export$b04c3bca9165ed02)(parameters, request.claims, this.config.authOptions.clientCapabilities);
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $51de415de522dc09$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                    (0, $1ac773f7bc3e26ca$export$68a633ecf634a2ea)(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $c04ec59cc6033cfb$export$17b7b3ac1abef49f).UPN:
                (0, $1ac773f7bc3e26ca$export$aa9cca16bcc29d2d)(parameters, request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) (0, $1ac773f7bc3e26ca$export$5ea4577e2a518c27)(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.tokenBodyParameters) (0, $1ac773f7bc3e26ca$export$1a9f676bcc5d37da)(parameters, request.tokenBodyParameters);
        (0, $1ac773f7bc3e26ca$export$7153a1ee4346fa3b)(parameters, request.correlationId, this.performanceClient);
        return (0, $2bfa541b563305f9$export$44d4663acf79cde2)(parameters);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $79709beb3402e666$export$b4a36596822a5d2 extends (0, $e07870fd0db9b50c$export$fa9179cade3eb05a) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
        const baseRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $d1aaa9bd4087c904$export$8e461fcf1fd6910b), (0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = this.getRedirectUri(request.redirectUri);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest).catch((e)=>{
            e.setCorrelationId(this.correlationId);
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$78523a40be105a03)));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, $86941347f07cebae$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient);
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ class $34acb5a008a9998e$export$ed5d1a18907a1001 {
    constructor(configuration, storage, logger, cryptoObj){
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ async loadExternalTokens(request, response, options) {
        if (!this.isBrowserEnvironment) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$932e0f52d657f7fb));
        const correlationId = request.correlationId || (0, $6f7127724a699469$export$6ef0355fa80a5278)();
        const idTokenClaims = response.id_token ? (0, $4f8cb1da78e4daf9$exports).extractTokenClaims(response.id_token, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e)) : undefined;
        const kmsi = (0, $4f8cb1da78e4daf9$exports).isKmsi(idTokenClaims || {});
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        const authority = request.authority ? new (0, $55d9936263fe2e81$export$f1c6ec2e6d68c49c)((0, $55d9936263fe2e81$export$f1c6ec2e6d68c49c).generateAuthority(request.authority, request.azureCloudOptions), this.config.system.networkClient, this.storage, authorityOptions, this.logger, request.correlationId || (0, $6f7127724a699469$export$6ef0355fa80a5278)()) : undefined;
        const cacheRecordAccount = await this.loadAccount(request, options.clientInfo || response.client_info || "", correlationId, idTokenClaims, authority);
        const idToken = await this.loadIdToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, correlationId, kmsi);
        const accessToken = await this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, options, correlationId, kmsi);
        const refreshToken = await this.loadRefreshToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, correlationId, kmsi);
        return this.generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        }, idTokenClaims, authority);
    }
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ async loadAccount(request, clientInfo, correlationId, idTokenClaims, authority) {
        this.logger.verbose("TokenCache - loading account");
        if (request.account) {
            const accountEntity = (0, $b16513504135b2c0$export$680160523e6bfa6a).createFromAccountInfo(request.account);
            await this.storage.setAccount(accountEntity, correlationId, (0, $4f8cb1da78e4daf9$exports).isKmsi(idTokenClaims || {}));
            return accountEntity;
        } else if (!authority || !clientInfo && !idTokenClaims) {
            this.logger.error("TokenCache - if an account is not provided on the request, authority and either clientInfo or idToken must be provided instead.");
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$6acf650331eb5f5f));
        }
        const homeAccountId = (0, $b16513504135b2c0$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        const claimsTenantId = idTokenClaims?.tid;
        const cachedAccount = (0, $2e62d88635b5d0eb$export$73b84062d58a1307)(this.storage, authority, homeAccountId, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e), correlationId, idTokenClaims, clientInfo, authority.hostnameAndPort, claimsTenantId, undefined, undefined, this.logger);
        await this.storage.setAccount(cachedAccount, correlationId, (0, $4f8cb1da78e4daf9$exports).isKmsi(idTokenClaims || {}));
        return cachedAccount;
    }
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ async loadIdToken(response, homeAccountId, environment, tenantId, correlationId, kmsi) {
        if (!response.id_token) {
            this.logger.verbose("TokenCache - no id token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading id token");
        const idTokenEntity = (0, $2175959ac3ad49fc$exports).createIdTokenEntity(homeAccountId, environment, response.id_token, this.config.auth.clientId, tenantId);
        await this.storage.setIdTokenCredential(idTokenEntity, correlationId, kmsi);
        return idTokenEntity;
    }
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ async loadAccessToken(request, response, homeAccountId, environment, tenantId, options, correlationId, kmsi) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - no access token found in response");
            return null;
        } else if (!response.expires_in) {
            this.logger.error("TokenCache - no expiration set on the access token. Cannot add it to the cache.");
            return null;
        } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
            this.logger.error("TokenCache - scopes not specified in the request or response. Cannot add token to the cache.");
            return null;
        }
        this.logger.verbose("TokenCache - loading access token");
        const scopes = response.scope ? (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(response.scope) : new (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99)(request.scopes);
        const expiresOn = options.expiresOn || response.expires_in + (0, $0e146ed7106c6e64$exports).nowSeconds();
        const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + (0, $0e146ed7106c6e64$exports).nowSeconds();
        const accessTokenEntity = (0, $2175959ac3ad49fc$exports).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, (0, $0d858b7a75e8c5ef$export$c62426fdd000a97e));
        await this.storage.setAccessTokenCredential(accessTokenEntity, correlationId, kmsi);
        return accessTokenEntity;
    }
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ async loadRefreshToken(response, homeAccountId, environment, correlationId, kmsi) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - no refresh token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading refresh token");
        const refreshTokenEntity = (0, $2175959ac3ad49fc$exports).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId, response.foci, undefined, response.refresh_token_expires_in);
        await this.storage.setRefreshTokenCredential(refreshTokenEntity, correlationId, kmsi);
        return refreshTokenEntity;
    }
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ generateAuthenticationResult(request, cacheRecord, idTokenClaims, authority) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        if (cacheRecord?.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $3840a7b7d2141fd6$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            // Access token expiresOn stored in seconds, converting to Date for AuthenticationResult
            expiresOn = (0, $0e146ed7106c6e64$exports).toDateFromSeconds(cacheRecord.accessToken.expiresOn);
            extExpiresOn = (0, $0e146ed7106c6e64$exports).toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
        }
        const accountEntity = cacheRecord.account;
        return {
            authority: authority ? authority.canonicalAuthority : "",
            uniqueId: cacheRecord.account.localAccountId,
            tenantId: cacheRecord.account.realm,
            scopes: responseScopes,
            account: (0, $b16513504135b2c0$export$680160523e6bfa6a).getAccountInfo(accountEntity),
            idToken: cacheRecord.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || "",
            requestId: "",
            extExpiresOn: extExpiresOn,
            familyId: cacheRecord.refreshToken?.familyId || "",
            tokenType: cacheRecord?.accessToken?.tokenType || "",
            state: request.state || "",
            cloudGraphHostName: accountEntity.cloudGraphHostName || "",
            msGraphHost: accountEntity.msGraphHost || "",
            fromNativeBroker: false
        };
    }
}





/*! @azure/msal-browser v4.27.0 2025-12-04 */ 



/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c3f6f4f61d69be1d$export$a2dbbd28e9bce542 extends (0, $2ba20fbd707f4716$export$8538731fd397fb90) {
    constructor(config){
        super(config);
        this.includeRedirectUri = false;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $a08e71ec34928e29$export$d7f5ef311b3e9fca extends (0, $e07870fd0db9b50c$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, platformAuthProvider, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, platformAuthProvider, correlationId);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$e502d98cd8d2da43));
        // Create silent request
        const silentRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(request, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, $c3f6f4f61d69be1d$export$a2dbbd28e9bce542)(clientConfig);
            this.logger.verbose("Auth code client created");
            // Create silent handler
            const interactionHandler = new (0, $97faeb8064d8ec72$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, false);
        } catch (e) {
            if (e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$78523a40be105a03)));
    }
}







/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $c4d29cc1401b582e$export$fe0570c25bf19cec(currentClientId, performanceEvent, logger) {
    const frameInstances = // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i)=>i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) logger.warning("There is already an instance of MSAL.js in the window with the same client id.");
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount
    });
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $23eec85159b3be07$var$preflightCheck(initialized, performanceEvent, account) {
    try {
        (0, $3e9f4e3d34d422a9$export$4dd091cbdc98b52e)(initialized);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e, account);
        throw e;
    }
}
class $23eec85159b3be07$export$e9d1ef1cb8705404 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $15ce4860f5b428a8$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $487fc5d1c5f0967c$export$865f57d401606752);
        this.eventHandler = new (0, $12c2eca48a8818eb$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $1e67d23838b7b4f7$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $55d9936263fe2e81$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $1e67d23838b7b4f7$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, $d94c9b6ecea78646$export$573384e47a12d835).MemoryStorage,
            cacheRetentionDays: 5,
            temporaryCacheLocation: (0, $d94c9b6ecea78646$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: false
        };
        this.nativeInternalStorage = new (0, $1e67d23838b7b4f7$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler);
        // Initialize the token cache
        this.tokenCache = new (0, $34acb5a008a9998e$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackPageVisibility = this.trackPageVisibility.bind(this);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $23eec85159b3be07$export$e9d1ef1cb8705404(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackPageVisibility(correlationId) {
        if (!correlationId) return;
        this.logger.info("Perf: Visibility change detected");
        this.performanceClient.incrementFields({
            visibilityChangeCount: 1
        }, correlationId);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request, isBroker) {
        this.logger.trace("initialize called");
        if (this.initialized) {
            this.logger.info("initialize has already been called, exiting early.");
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, exiting early.");
            this.initialized = true;
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).INITIALIZE_END);
            return;
        }
        const initCorrelationId = request?.correlationId || this.getRequestCorrelationId();
        const allowPlatformBroker = this.config.system.allowPlatformBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeClientApplication, initCorrelationId);
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).INITIALIZE_START);
        // Broker applications are initialized twice, so we avoid double-counting it
        if (!isBroker) try {
            this.logMultipleInstances(initMeasurement);
        } catch  {}
        await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.browserStorage.initialize.bind(this.browserStorage), (0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeCache, this.logger, this.performanceClient, initCorrelationId)(initCorrelationId);
        if (allowPlatformBroker) try {
            // check if platform authentication is available via DOM or browser extension and create relevant handlers
            this.platformAuthProvider = await (0, $c1ac581036487902$export$b2c9df3607dc771a)(this.logger, this.performanceClient, initCorrelationId, this.config.system.nativeBrokerHandshakeTimeout, this.config.system.allowPlatformBrokerWithDOM);
        } catch (e) {
            this.logger.verbose(e);
        }
        if (!this.config.cache.claimsBasedCachingEnabled) {
            this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
            (0, $e6f6c8f5d4b87838$export$468cda29b159ee5d)(this.browserStorage.clearTokensAndKeysWithClaims.bind(this.browserStorage), (0, $978df372b022f65e$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, this.logger, this.performanceClient, initCorrelationId)(initCorrelationId);
        }
        this.config.system.asyncPopups && await this.preGeneratePkceCodes(initCorrelationId);
        this.initialized = true;
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).INITIALIZE_END);
        initMeasurement.end({
            allowPlatformBroker: allowPlatformBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(hash) {
        this.logger.verbose("handleRedirectPromise called");
        // Block token acquisition before initialize has been called
        (0, $3e9f4e3d34d422a9$export$630119c5db8b5529)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(hash);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
            } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
            return response;
        }
        this.logger.verbose("handleRedirectPromise returns null, not browser environment");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(hash) {
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        const interactionType = this.browserStorage.getInteractionInProgress()?.type;
        if (interactionType === (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNOUT) {
            this.logger.verbose("handleRedirectPromise removing interaction_in_progress flag and returning null after sign-out");
            this.browserStorage.setInteractionInProgress(false);
            return Promise.resolve(null);
        }
        const loggedInAccounts = this.getAllAccounts();
        const platformBrokerRequest = this.browserStorage.getCachedNativeRequest();
        const useNative = platformBrokerRequest && this.platformAuthProvider && !hash;
        let rootMeasurement;
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
        let redirectResponse;
        try {
            if (useNative && this.platformAuthProvider) {
                rootMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenRedirect, platformBrokerRequest?.correlationId || "");
                this.logger.trace("handleRedirectPromise - acquiring token from native platform");
                rootMeasurement.add({
                    isPlatformBrokerRequest: true
                });
                const nativeClient = new (0, $61a4b151dc513230$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $d94c9b6ecea78646$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.platformAuthProvider, platformBrokerRequest.accountId, this.nativeInternalStorage, platformBrokerRequest.correlationId);
                redirectResponse = (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(this.performanceClient, rootMeasurement.event.correlationId);
            } else {
                const [standardRequest, codeVerifier] = this.browserStorage.getCachedRequest();
                const correlationId = standardRequest.correlationId;
                // Reset rootMeasurement now that we have correlationId
                rootMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId);
                this.logger.trace("handleRedirectPromise - acquiring token from web flow");
                const redirectClient = this.createRedirectClient(correlationId);
                redirectResponse = (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(hash, standardRequest, codeVerifier, rootMeasurement);
            }
        } catch (e) {
            this.browserStorage.resetRequestCache();
            throw e;
        }
        return redirectResponse.then((result)=>{
            if (result) {
                this.browserStorage.resetRequestCache();
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, login success");
                } else {
                    this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                }
                rootMeasurement.end({
                    success: true
                }, undefined, result.account);
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            }, undefined);
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
            return result;
        }).catch((e)=>{
            this.browserStorage.resetRequestCache();
            const eventError = e;
            // Emit login event if there is an account
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, null, eventError);
            else this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGIN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("acquireTokenRedirect called", correlationId);
        const atrMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            scenarioId: request.scenarioId
        });
        // Override on request only if set, as onRedirectNavigate field is deprecated
        const onRedirectNavigateCb = request.onRedirectNavigate;
        if (onRedirectNavigateCb) request.onRedirectNavigate = (url)=>{
            const navigate = typeof onRedirectNavigateCb === "function" ? onRedirectNavigateCb(url) : undefined;
            atrMeasurement.add({
                navigateCallbackResult: navigate !== false
            });
            atrMeasurement.event = atrMeasurement.end({
                success: true
            }, undefined, request.account) || atrMeasurement.event;
            return navigate;
        };
        else {
            const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
            this.config.auth.onRedirectNavigate = (url)=>{
                const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
                atrMeasurement.add({
                    navigateCallbackResult: navigate !== false
                });
                atrMeasurement.event = atrMeasurement.end({
                    success: true
                }, undefined, request.account) || atrMeasurement.event;
                return navigate;
            };
        }
        // If logged in, emit acquire token events
        const isLoggedIn = this.getAllAccounts().length > 0;
        try {
            (0, $3e9f4e3d34d422a9$export$62c8f4fdca4df60f)(this.initialized, this.config);
            this.browserStorage.setInteractionInProgress(true, (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNIN);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, request);
            else this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGIN_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, request);
            let result;
            if (this.platformAuthProvider && this.canUsePlatformBroker(request)) {
                const nativeClient = new (0, $61a4b151dc513230$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = nativeClient.acquireTokenRedirect(request, atrMeasurement).catch((e)=>{
                    atrMeasurement.add({
                        brokerErrorName: e.name,
                        brokerErrorCode: e.errorCode
                    });
                    if (e instanceof (0, $0a7a126f0093ead7$export$4b8a4f6256e840ab) && (0, $0a7a126f0093ead7$export$f21e42e365baeb50)(e)) {
                        this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba)) {
                        this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            this.browserStorage.resetRequestCache();
            /*
             * Pre-redirect event completes before navigation occurs.
             * Timed out navigation needs to be instrumented separately as a post-redirect event.
             */ if (atrMeasurement.event.status === 2) this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId).end({
                success: false
            }, e, request.account);
            else atrMeasurement.end({
                success: false
            }, e, request.account);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, null, e);
            else this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGIN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            $23eec85159b3be07$var$preflightCheck(this.initialized, atPopupMeasurement, request.account);
            this.browserStorage.setInteractionInProgress(true, (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNIN);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGIN_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, request);
        let result;
        const pkce = this.getPreGeneratedPkceCodes(correlationId);
        if (this.canUsePlatformBroker(request)) {
            atPopupMeasurement.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative({
                ...request,
                correlationId: correlationId
            }, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenPopup).then((response)=>{
                atPopupMeasurement.end({
                    success: true
                }, undefined, response.account);
                return response;
            }).catch((e)=>{
                atPopupMeasurement.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                if (e instanceof (0, $0a7a126f0093ead7$export$4b8a4f6256e840ab) && (0, $0a7a126f0093ead7$export$f21e42e365baeb50)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to continuing to attempt platform broker calls
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                } else if (e instanceof (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba)) {
                    this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                }
                throw e;
            });
        } else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request, pkce);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            if (isLoggingIn) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, result);
            else this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            return result;
        }).catch((e)=>{
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, null, e);
            else this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).LOGIN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }).finally(async ()=>{
            this.browserStorage.setInteractionInProgress(false);
            if (this.config.system.asyncPopups) await this.preGeneratePkceCodes(correlationId);
        });
    }
    trackPageVisibilityWithMeasurement() {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1
        });
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            // will be PromptValue.NONE or PromptValue.NO_SESSION
            prompt: request.prompt,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId
        });
        $23eec85159b3be07$var$preflightCheck(this.initialized, this.ssoSilentMeasurement, request.account);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        this.logger.verbose("ssoSilent called", correlationId);
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).SSO_SILENT_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, validRequest);
        let result;
        if (this.canUsePlatformBroker(validRequest)) {
            this.ssoSilentMeasurement?.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative(validRequest, (0, $d94c9b6ecea78646$export$192d74ad69b40705).ssoSilent).catch((e)=>{
                this.ssoSilentMeasurement?.add({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                });
                // If native token acquisition fails for availability reasons fallback to standard flow
                if (e instanceof (0, $0a7a126f0093ead7$export$4b8a4f6256e840ab) && (0, $0a7a126f0093ead7$export$f21e42e365baeb50)(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                    const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    return silentIframeClient.acquireToken(validRequest);
                }
                throw e;
            });
        } else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, response);
            this.ssoSilentMeasurement?.end({
                success: true,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length
            }, undefined, response.account);
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw e;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("acquireTokenByCode called", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenByCode, correlationId);
        $23eec85159b3be07$var$preflightCheck(this.initialized, atbcMeasurement);
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$1efb009e9d75bbe4));
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        }, undefined, result.account);
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("Existing acquireTokenByCode request found", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUsePlatformBroker(request, request.nativeAccountId)) {
                    atbcMeasurement.add({
                        isPlatformBrokerRequest: true
                    });
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, $0a7a126f0093ead7$export$4b8a4f6256e840ab) && (0, $0a7a126f0093ead7$export$f21e42e365baeb50)(e)) this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        atbcMeasurement.add({
                            brokerErrorName: e.name,
                            brokerErrorCode: e.errorCode
                        });
                        throw e;
                    });
                    atbcMeasurement.end({
                        success: true
                    }, undefined, result.account);
                    return result;
                } else throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$b897bbe2c683def2));
            } else throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$8bea68053103eaeb));
        } catch (e) {
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).Default:
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessToken:
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).Default:
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).RefreshToken:
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, $978df372b022f65e$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ async logout(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
        return this.logoutRedirect({
            correlationId: correlationId,
            ...logoutRequest
        });
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, $3e9f4e3d34d422a9$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNOUT);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, $3e9f4e3d34d422a9$export$4dd091cbdc98b52e)(this.initialized);
            this.browserStorage.setInteractionInProgress(true, (0, $d94c9b6ecea78646$export$dc1d3aa5f3837765).SIGNOUT);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest).finally(()=>{
                this.browserStorage.setInteractionInProgress(false);
            });
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, returning early.");
            return;
        }
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $262567445a7c060e$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnvironment, correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $262567445a7c060e$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $262567445a7c060e$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $262567445a7c060e$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $262567445a7c060e$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        const correlationId = this.getRequestCorrelationId();
        (0, $262567445a7c060e$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = this.getRequestCorrelationId();
        return (0, $262567445a7c060e$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, $b16513504135b2c0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, $4f8cb1da78e4daf9$exports).isKmsi(result.idTokenClaims));
        if (result.fromNativeBroker) {
            this.logger.verbose("Response was from native broker, storing in-memory");
            // Tokens from native broker are stored in-memory
            return this.nativeInternalStorage.hydrateCache(result, request);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId, cacheLookupPolicy) {
        this.logger.trace("acquireTokenNative called");
        if (!this.platformAuthProvider) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$7b7357e3538624aa));
        const nativeClient = new (0, $61a4b151dc513230$export$3f89612b3fd8831f)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.platformAuthProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
        return nativeClient.acquireToken(request, cacheLookupPolicy);
    }
    /**
     * Returns boolean indicating if this request can use the platform broker
     * @param request
     */ canUsePlatformBroker(request, accountId) {
        this.logger.trace("canUsePlatformBroker called");
        if (!this.platformAuthProvider) {
            this.logger.trace("canUsePlatformBroker: platform broker unavilable, returning false");
            return false;
        }
        if (!(0, $c1ac581036487902$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, request.authenticationScheme)) {
            this.logger.trace("canUsePlatformBroker: isBrokerAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).NONE:
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).CONSENT:
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).LOGIN:
            case (0, $6c5f3cda7e712574$export$49a06cbda5acaa5).SELECT_ACCOUNT:
                this.logger.trace("canUsePlatformBroker: prompt is compatible with platform broker flow");
                break;
            default:
                this.logger.trace(`canUsePlatformBroker: prompt = ${request.prompt} is not compatible with platform broker flow, returning false`);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUsePlatformBroker: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, $39af8753fb8b2f3d$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, $6e2bd7f3092e3421$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, $19f5ddfa4f92b2d7$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $d94c9b6ecea78646$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, $dd39764699851949$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, $79709beb3402e666$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, $a08e71ec34928e29$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.platformAuthProvider, correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, $3e9f4e3d34d422a9$export$c7939bfe92ae2787)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     * @deprecated These events will be raised by default and this method will be removed in a future major version.
     */ enableAccountStorageEvents() {
        if (this.config.cache.cacheLocation !== (0, $d94c9b6ecea78646$export$573384e47a12d835).LocalStorage) {
            this.logger.info("Account storage events are only available when cacheLocation is set to localStorage");
            return;
        }
        this.eventHandler.subscribeCrossTab();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     * @deprecated These events will be raised by default and this method will be removed in a future major version.
     */ disableAccountStorageEvents() {
        if (this.config.cache.cacheLocation !== (0, $d94c9b6ecea78646$export$573384e47a12d835).LocalStorage) {
            this.logger.info("Account storage events are only available when cacheLocation is set to localStorage");
            return;
        }
        this.eventHandler.unsubscribeCrossTab();
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.tokenCache;
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, $6f7127724a699469$export$6ef0355fa80a5278)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $6c5f3cda7e712574$export$a002182e51710d39).EMPTY_STRING;
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginRedirect called", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || (0, $d94c9b6ecea78646$export$7e12949cd6884193)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || (0, $d94c9b6ecea78646$export$7e12949cd6884193)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId
        });
        $23eec85159b3be07$var$preflightCheck(this.initialized, atsMeasurement, request.account);
        this.logger.verbose("acquireTokenSilent called", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, $d8ef97823beb75e7$export$72f7b48f3bc1d4cb)((0, $32d5e65f31c9045a$export$87933d7d4116cb12));
        return this.acquireTokenSilentDeduped(request, account, correlationId).then((result)=>{
            atsMeasurement.end({
                success: true,
                fromCache: result.fromCache,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            return {
                ...result,
                state: request.state,
                correlationId: correlationId
            };
        }).catch((error)=>{
            if (error instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac)) // Ensures PWB scenarios can correctly match request to response
            error.setCorrelationId(correlationId);
            atsMeasurement.end({
                success: false
            }, error, account);
            throw error;
        });
    }
    /**
     * Checks if identical request is already in flight and returns reference to the existing promise or fires off a new one if this is the first
     * @param request
     * @param account
     * @param correlationId
     * @returns
     */ async acquireTokenSilentDeduped(request, account, correlationId) {
        const thumbprint = (0, $58fde9510481ec07$export$2daa8cfcf54c2b48)(this.config.auth.clientId, {
            ...request,
            authority: request.authority || this.config.auth.authority,
            correlationId: correlationId
        }, account.homeAccountId);
        const silentRequestKey = JSON.stringify(thumbprint);
        const inProgressRequest = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof inProgressRequest === "undefined") {
            this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
            this.performanceClient.addFields({
                deduped: false
            }, correlationId);
            const activeRequest = (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenSilentAsync.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account);
            this.activeSilentTokenRequests.set(silentRequestKey, activeRequest);
            return activeRequest.finally(()=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
            });
        } else {
            this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
            this.performanceClient.addFields({
                deduped: true
            }, correlationId);
            return inProgressRequest;
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackPageVisibility = ()=>this.trackPageVisibility(request.correlationId);
        this.performanceClient.addQueueMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0
        }, request.correlationId);
        document.addEventListener("visibilitychange", trackPageVisibility);
        const silentRequest = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $d1aaa9bd4087c904$export$4c8aa78c426811d4), (0, $978df372b022f65e$export$2f2811a3e1b21823).InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, $d94c9b6ecea78646$export$4394baa7e922d42d).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $23eec85159b3be07$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", silentRequest.correlationId);
                    return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, $d94c9b6ecea78646$export$4394baa7e922d42d).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`Iframe request is already in progress, awaiting resolution for request with correlationId: ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`Parallel iframe request with correlationId: ${activeCorrelationId} succeeded. Retrying cache and/or RT redemption`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`Iframe request with correlationId: ${activeCorrelationId} failed. Interaction is required.`);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("Another iframe request is currently in progress and CacheLookupPolicy is set to Skip. This may result in degraded performance and/or reliability for both calls. Please consider changing the CacheLookupPolicy to take advantage of request queuing and token cache.", silentRequest.correlationId);
                    return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, response);
            this.performanceClient.addFields({
                fromCache: response.fromCache
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", trackPageVisibility);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        // if the cache policy is set to access_token only, we should not be hitting the native layer yet
        if ((0, $c1ac581036487902$export$4815cc9f88d4f6a5)(this.config, this.logger, this.platformAuthProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
            this.performanceClient.addFields({
                isPlatformBrokerRequest: true
            }, silentRequest.correlationId);
            return this.acquireTokenNative(silentRequest, (0, $d94c9b6ecea78646$export$192d74ad69b40705).acquireTokenSilent_silentFlow, silentRequest.account.nativeAccountId, cacheLookupPolicy).catch(async (e)=>{
                this.performanceClient.addFields({
                    brokerErrorName: e.name,
                    brokerErrorCode: e.errorCode
                }, silentRequest.correlationId);
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, $0a7a126f0093ead7$export$4b8a4f6256e840ab) && (0, $0a7a126f0093ead7$export$f21e42e365baeb50)(e)) {
                    this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                    this.platformAuthProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).tokenRefreshRequired);
                }
                throw e;
            });
        } else {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
            // add logs to identify embedded cache retrieval
            if (cacheLookupPolicy === (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessToken) this.logger.verbose("acquireTokenSilent - cache lookup policy set to AccessToken, attempting to acquire token from local cache");
            return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenFromCache.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, silentRequest);
                return (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)(this.acquireTokenByRefreshToken.bind(this), (0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
    /**
     * Pre-generates PKCE codes and stores it in local variable
     * @param correlationId
     */ async preGeneratePkceCodes(correlationId) {
        this.logger.verbose("Generating new PKCE codes");
        this.pkceCode = await (0, $e6f6c8f5d4b87838$export$e4feded94d9adb18)((0, $8c0aba2bb99ff08c$export$91d5e5a023803853), (0, $978df372b022f65e$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        return Promise.resolve();
    }
    /**
     * Provides pre-generated PKCE codes, if any
     * @param correlationId
     */ getPreGeneratedPkceCodes(correlationId) {
        this.logger.verbose("Attempting to pick up pre-generated PKCE codes");
        const res = this.pkceCode ? {
            ...this.pkceCode
        } : undefined;
        this.pkceCode = undefined;
        this.logger.verbose(`${res ? "Found" : "Did not find"} pre-generated PKCE codes`);
        this.performanceClient.addFields({
            usePreGeneratedPkce: !!res
        }, correlationId);
        return res;
    }
    logMultipleInstances(performanceEvent) {
        const clientId = this.config.auth.clientId;
        if (!window) return;
        // @ts-ignore
        window.msal = window.msal || {};
        // @ts-ignore
        window.msal.clientIds = window.msal.clientIds || [];
        // @ts-ignore
        const clientIds = window.msal.clientIds;
        if (clientIds.length > 0) this.logger.verbose("There is already an instance of MSAL.js in the window.");
        // @ts-ignore
        window.msal.clientIds.push(clientId);
        (0, $c4d29cc1401b582e$export$fe0570c25bf19cec)(clientId, performanceEvent, this.logger);
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $23eec85159b3be07$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, $802def46dc9c1a5c$exports).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, $d94c9b6ecea78646$export$a0a689e4294b9880).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, $4c3d14616baac1bd$exports).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, $802def46dc9c1a5c$exports).noTokensFound || refreshTokenError.errorCode === (0, $802def46dc9c1a5c$exports).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, $d94c9b6ecea78646$export$736180706fb122ee).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
/*! @azure/msal-browser v4.27.0 2025-12-04 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1195aa0ebc98118a$export$caa3bc10e51dd7ee(error) {
    return error.status !== undefined;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9149f8b50567f3d6$export$cee94b20506f02aa {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const claims = (0, $1ac773f7bc3e26ca$exports).addClientCapabilitiesToClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, $6c5f3cda7e712574$export$893b1b5b686d84ef);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !(0, $95ac7d904346f305$export$ecc754f99843e759).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).nullOrEmptyToken);
        // Request timestamp and AuthResult expires_in are in seconds, converting to Date for AuthenticationResult
        const expiresOn = (0, $0e146ed7106c6e64$exports).toDateFromSeconds(reqTimestamp + (response.token.expires_in || 0));
        const idTokenClaims = (0, $4f8cb1da78e4daf9$exports).extractTokenClaims(response.token.id_token, this.crypto.base64Decode);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        const tenantId = fromAccount.tenantId || effectiveIdTokenClaims?.tid || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        const username = fromAccount.username || effectiveIdTokenClaims?.preferred_username || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name;
        const loginHint = fromAccount.loginHint || effectiveIdTokenClaims?.login_hint;
        const tenantProfiles = new Map();
        const tenantProfile = (0, $d08229a94d11167d$export$924857724cb21ba4)(homeAccountId, localAccountId, tenantId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: fromAccount.environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            loginHint: loginHint,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, $1195aa0ebc98118a$export$caa3bc10e51dd7ee)(error)) switch(error.status){
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).UserCancel:
                return new (0, $0114b0a218ba15f8$export$a839ff85a7957561)((0, $4c3d14616baac1bd$exports).userCanceled);
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).NoNetwork:
                return new (0, $0114b0a218ba15f8$export$a839ff85a7957561)((0, $4c3d14616baac1bd$exports).noNetworkConnectivity);
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).AccountUnavailable:
                return new (0, $0114b0a218ba15f8$export$a839ff85a7957561)((0, $4c3d14616baac1bd$exports).noAccountFound);
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).Disabled:
                return new (0, $0114b0a218ba15f8$export$a839ff85a7957561)((0, $4c3d14616baac1bd$exports).nestedAppAuthBridgeDisabled);
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).NestedAppAuthUnavailable:
                return new (0, $0114b0a218ba15f8$export$a839ff85a7957561)(error.code || (0, $4c3d14616baac1bd$exports).nestedAppAuthBridgeDisabled, error.description);
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).TransientError:
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).PersistentError:
                return new (0, $74e5e9d464560d66$export$ea52035eac03daf0)(error.code, error.description);
            case (0, $fd6d6e346bcca7ef$export$6d05f68c12a46a00).UserInteractionRequired:
                return new (0, $6fdc601aa485fcf1$export$6ba3e818c6bc76ba)(error.code, error.description);
            default:
                return new (0, $0a726c4076f6517d$export$145273558d58e0ac)(error.code, error.description);
        }
        else return new (0, $0a726c4076f6517d$export$145273558d58e0ac)("unknown_error", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, $0114b0a218ba15f8$export$ea892ce48f5bb4f3)((0, $4c3d14616baac1bd$exports).nullOrEmptyToken);
        const idTokenClaims = (0, $4f8cb1da78e4daf9$exports).extractTokenClaims(idToken.secret, this.crypto.base64Decode);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: (0, $0e146ed7106c6e64$exports).toDateFromSeconds(accessToken.expiresOn),
            extExpiresOn: (0, $0e146ed7106c6e64$exports).toDateFromSeconds(accessToken.extendedExpiresOn),
            tokenType: request.authenticationScheme || (0, $6c5f3cda7e712574$export$901491a717da2ba5).BEARER,
            correlationId: correlationId,
            state: request.state
        };
        return authenticationResult;
    }
}


/*! @azure/msal-browser v4.27.0 2025-12-04 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * NestedAppAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $62e1fdaf9688b8b1$export$81a70490e660273a = {
    unsupportedMethod: {
        code: "unsupported_method",
        desc: "This method is not supported in nested app environment."
    }
};
class $62e1fdaf9688b8b1$export$7c79ceb488783308 extends (0, $0a726c4076f6517d$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $62e1fdaf9688b8b1$export$7c79ceb488783308.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError() {
        return new $62e1fdaf9688b8b1$export$7c79ceb488783308($62e1fdaf9688b8b1$export$81a70490e660273a.unsupportedMethod.code, $62e1fdaf9688b8b1$export$81a70490e660273a.unsupportedMethod.desc);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $503808c7e3e21bd2$export$2319deb182e38ab3 {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, $15ce4860f5b428a8$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, true) : (0, $487fc5d1c5f0967c$export$865f57d401606752);
        this.eventHandler = new (0, $12c2eca48a8818eb$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, $1e67d23838b7b4f7$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, (0, $55d9936263fe2e81$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $1e67d23838b7b4f7$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler);
        this.nestedAppAuthAdapter = new (0, $9149f8b50567f3d6$export$cee94b20506f02aa)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        this.currentAccountContext = accountContext ? accountContext : null;
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $503808c7e3e21bd2$export$2319deb182e38ab3(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ async initialize(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isBroker) {
        const initCorrelationId = request?.correlationId || (0, $6f7127724a699469$export$6ef0355fa80a5278)();
        await this.browserStorage.initialize(initCorrelationId);
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenPopup, validRequest.correlationId);
        atPopupMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $0e146ed7106c6e64$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`Failed to hydrate cache. Error: ${error}`, validRequest.correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).SsoSilent, validRequest.correlationId);
        ssoSilentMeasurement.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            naaRequest.forceRefresh = validRequest.forceRefresh;
            const reqTimestamp = (0, $0e146ed7106c6e64$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`Failed to hydrate cache. Error: ${error}`, validRequest.correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof (0, $0a726c4076f6517d$export$145273558d58e0ac) ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const atsMeasurement = this.performanceClient.startMeasurement((0, $978df372b022f65e$export$2f2811a3e1b21823).AcquireTokenSilent, request.correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("Claims are present in the request, skipping cache lookup");
            return null;
        }
        // if the request has forceRefresh, we cannot look up in the cache
        if (request.forceRefresh) {
            this.logger.verbose("forceRefresh is set to true, skipping cache lookup");
            return null;
        }
        // respect cache lookup policy
        let result = null;
        if (!request.cacheLookupPolicy) request.cacheLookupPolicy = (0, $d94c9b6ecea78646$export$4394baa7e922d42d).Default;
        switch(request.cacheLookupPolicy){
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).Default:
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessToken:
            case (0, $d94c9b6ecea78646$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, result);
            atsMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atsMeasurement.end({
                success: true
            }, undefined, result.account);
            return result;
        }
        this.logger.warning("Cached tokens are not found for the account, proceeding with silent token request.");
        this.eventHandler.emitEvent((0, $9140a68e3a7e9307$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $d94c9b6ecea78646$export$4ec29255e7e7f68f).Silent, null);
        atsMeasurement.end({
            success: false
        }, undefined, request.account);
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        // always prioritize the account context from the bridge
        const accountContext = this.bridgeProxy.getAccountContext() || this.currentAccountContext;
        let currentAccount = null;
        const correlationId = request.correlationId || this.browserCrypto.createNewGuid();
        if (accountContext) currentAccount = (0, $262567445a7c060e$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage, correlationId);
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("No active account found, falling back to the host");
            return Promise.resolve(null);
        }
        this.logger.verbose("active account found, attempting to acquire token silently");
        const authRequest = {
            ...request,
            correlationId: request.correlationId || this.browserCrypto.createNewGuid(),
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, $6c5f3cda7e712574$export$893b1b5b686d84ef)
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("No cached access token found");
            return Promise.resolve(null);
        } else if ((0, $0e146ed7106c6e64$exports).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, $0e146ed7106c6e64$exports).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("Cached access token has expired");
            return Promise.resolve(null);
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId, this.performanceClient);
        if (!cachedIdToken) {
            this.logger.verbose("No cached id token found");
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenRedirect(request) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenByCode(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenNative flow is not currently supported in nested app auth
     * @param request
     * @param apiId
     * @param accountId
     */ acquireTokenNative(request, apiId, accountId // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenByRefreshToken flow is not currently supported in nested app auth
     * @param commonRequest
     * @param silentRequest
     */ acquireTokenByRefreshToken(commonRequest, silentRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    enableAccountStorageEvents() {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    disableAccountStorageEvents() {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $262567445a7c060e$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnv(), correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $262567445a7c060e$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $262567445a7c060e$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $262567445a7c060e$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $262567445a7c060e$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ const correlationId = this.browserCrypto.createNewGuid();
        return (0, $262567445a7c060e$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = this.browserCrypto.createNewGuid();
        return (0, $262567445a7c060e$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    handleRedirectPromise(hash // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, $d94c9b6ecea78646$export$7e12949cd6884193));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    logout(logoutRequest) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutRedirect(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutPopup(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    getTokenCache() {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("setNavigationClient is not supported in nested app auth");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    getRedirectResponse() {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, $62e1fdaf9688b8b1$export$7c79ceb488783308).createUnsupportedError();
    }
    async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        const accountEntity = (0, $b16513504135b2c0$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, (0, $4f8cb1da78e4daf9$exports).isKmsi(result.idTokenClaims));
        return this.browserStorage.hydrateCache(result, request);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $729384e402b59414$export$414d5e42be8c56db(config, request) {
    const standard = new (0, $56db67b6066c95af$export$f39c23bbfed89e6e)(config);
    await standard.initialize();
    return (0, $23eec85159b3be07$export$e9d1ef1cb8705404).createController(standard, request);
}
async function $729384e402b59414$export$6a1d744b364856f2(config) {
    const standard = new (0, $56db67b6066c95af$export$f39c23bbfed89e6e)(config);
    const nestedApp = new (0, $46eb2566ded48f95$export$a2170d4e3f010950)(config);
    const operatingContexts = [
        standard.initialize(),
        nestedApp.initialize()
    ];
    await Promise.all(operatingContexts);
    if (nestedApp.isAvailable() && config.auth.supportsNestedAppAuth) return (0, $503808c7e3e21bd2$export$2319deb182e38ab3).createController(nestedApp);
    else if (standard.isAvailable()) return (0, $23eec85159b3be07$export$e9d1ef1cb8705404).createController(standard);
    else // Since neither of the actual operating contexts are available keep the UnknownOperatingContextController
    return null;
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $3bd58a16e7acfae5$export$89f4855ef88b7920 {
    /**
     * Creates StandardController and passes it to the PublicClientApplication
     *
     * @param configuration {Configuration}
     */ static async createPublicClientApplication(configuration) {
        const controller = await (0, $729384e402b59414$export$414d5e42be8c56db)(configuration);
        const pca = new $3bd58a16e7acfae5$export$89f4855ef88b7920(configuration, controller);
        return pca;
    }
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.isBroker = false;
        this.controller = controller || new (0, $23eec85159b3be07$export$e9d1ef1cb8705404)(new (0, $56db67b6066c95af$export$f39c23bbfed89e6e)(configuration));
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request, this.isBroker);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        this.controller.enableAccountStorageEvents();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        this.controller.disableAccountStorageEvents();
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByHomeId(homeAccountId) {
        return this.controller.getAccountByHomeId(homeAccountId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByLocalId(localId) {
        return this.controller.getAccountByLocalId(localId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param userName
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByUsername(userName) {
        return this.controller.getAccountByUsername(userName);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(hash) {
        return this.controller.handleRedirectPromise(hash);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ logout(logoutRequest) {
        return this.controller.logout(logoutRequest);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.controller.getTokenCache();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $3bd58a16e7acfae5$export$210078d2745a65ac(configuration) {
    const nestedAppAuth = new (0, $46eb2566ded48f95$export$a2170d4e3f010950)(configuration);
    await nestedAppAuth.initialize();
    if (nestedAppAuth.isAvailable()) {
        const controller = new (0, $503808c7e3e21bd2$export$2319deb182e38ab3)(nestedAppAuth);
        const nestablePCA = new $3bd58a16e7acfae5$export$89f4855ef88b7920(configuration, controller);
        await nestablePCA.initialize();
        return nestablePCA;
    }
    return $3bd58a16e7acfae5$export$f28b97cfb2f3098(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $3bd58a16e7acfae5$export$f28b97cfb2f3098(configuration) {
    const pca = new $3bd58a16e7acfae5$export$89f4855ef88b7920(configuration);
    await pca.initialize();
    return pca;
}


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2c3eaa156e16e0a0$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2da6c7f6d471231d$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $2da6c7f6d471231d$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $2da6c7f6d471231d$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $2da6c7f6d471231d$var$e(n, t, o) : $2da6c7f6d471231d$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ef71443d6d0f7297$export$ca000e230c0caa3e(t) {
    return (0, $2da6c7f6d471231d$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c81d54b7fa05a91f$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $c81d54b7fa05a91f$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $c81d54b7fa05a91f$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $372e520d9a696e75$export$b2b799818fbabcf3(e) {
    return (0, $c81d54b7fa05a91f$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c2d4f21b11859e3f$export$2fa187e846a241c4(i, n) {
    return (0, $c81d54b7fa05a91f$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $35bf7f144a1f8407$export$dcd0d083aa86c355(e) {
    return (0, $c81d54b7fa05a91f$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c72d431fd68825ee$export$163dfc35cc43f240(e) {
    return (0, $c81d54b7fa05a91f$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $1fd696000eedde0f$var$n;
const $1fd696000eedde0f$var$e = null != (null === ($1fd696000eedde0f$var$n = window.HTMLSlotElement) || void 0 === $1fd696000eedde0f$var$n ? void 0 : $1fd696000eedde0f$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $1fd696000eedde0f$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $c81d54b7fa05a91f$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $1fd696000eedde0f$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9beb25801f05a3ff$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $1fd696000eedde0f$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $c81d54b7fa05a91f$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $db75749bcbdfa130$var$t = window, $db75749bcbdfa130$export$b4d10f6001c083c2 = $db75749bcbdfa130$var$t.ShadowRoot && (void 0 === $db75749bcbdfa130$var$t.ShadyCSS || $db75749bcbdfa130$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $db75749bcbdfa130$var$s = Symbol(), $db75749bcbdfa130$var$n = new WeakMap;
class $db75749bcbdfa130$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $db75749bcbdfa130$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($db75749bcbdfa130$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $db75749bcbdfa130$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $db75749bcbdfa130$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $db75749bcbdfa130$export$8d80f9cac07cdb3 = (t)=>new $db75749bcbdfa130$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $db75749bcbdfa130$var$s), $db75749bcbdfa130$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $db75749bcbdfa130$export$505d1e8739bad805(n, t, $db75749bcbdfa130$var$s);
}, $db75749bcbdfa130$export$2ca4a66ec4cecb90 = (s, n)=>{
    $db75749bcbdfa130$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $db75749bcbdfa130$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $db75749bcbdfa130$export$ee69dfd951e24778 = $db75749bcbdfa130$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $db75749bcbdfa130$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $10ad292b36c2f201$var$s;
const $10ad292b36c2f201$var$e = window, $10ad292b36c2f201$var$r = $10ad292b36c2f201$var$e.trustedTypes, $10ad292b36c2f201$var$h = $10ad292b36c2f201$var$r ? $10ad292b36c2f201$var$r.emptyScript : "", $10ad292b36c2f201$var$o = $10ad292b36c2f201$var$e.reactiveElementPolyfillSupport, $10ad292b36c2f201$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $10ad292b36c2f201$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $10ad292b36c2f201$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $10ad292b36c2f201$var$l = {
    attribute: !0,
    type: String,
    converter: $10ad292b36c2f201$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $10ad292b36c2f201$export$53a6892c50694894
}, $10ad292b36c2f201$var$d = "finalized";
class $10ad292b36c2f201$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $10ad292b36c2f201$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $10ad292b36c2f201$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($10ad292b36c2f201$var$d)) return !1;
        this[$10ad292b36c2f201$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $db75749bcbdfa130$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $db75749bcbdfa130$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $db75749bcbdfa130$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $10ad292b36c2f201$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $10ad292b36c2f201$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $10ad292b36c2f201$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $10ad292b36c2f201$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$10ad292b36c2f201$export$c7c07a37856565d[$10ad292b36c2f201$var$d] = !0, $10ad292b36c2f201$export$c7c07a37856565d.elementProperties = new Map, $10ad292b36c2f201$export$c7c07a37856565d.elementStyles = [], $10ad292b36c2f201$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $10ad292b36c2f201$var$o || $10ad292b36c2f201$var$o({
    ReactiveElement: $10ad292b36c2f201$export$c7c07a37856565d
}), (null !== ($10ad292b36c2f201$var$s = $10ad292b36c2f201$var$e.reactiveElementVersions) && void 0 !== $10ad292b36c2f201$var$s ? $10ad292b36c2f201$var$s : $10ad292b36c2f201$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $0c528c0604fb47de$var$t;
const $0c528c0604fb47de$var$i = window, $0c528c0604fb47de$var$s = $0c528c0604fb47de$var$i.trustedTypes, $0c528c0604fb47de$var$e = $0c528c0604fb47de$var$s ? $0c528c0604fb47de$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $0c528c0604fb47de$var$o = "$lit$", $0c528c0604fb47de$var$n = `lit$${(Math.random() + "").slice(9)}$`, $0c528c0604fb47de$var$l = "?" + $0c528c0604fb47de$var$n, $0c528c0604fb47de$var$h = `<${$0c528c0604fb47de$var$l}>`, $0c528c0604fb47de$var$r = document, $0c528c0604fb47de$var$u = ()=>$0c528c0604fb47de$var$r.createComment(""), $0c528c0604fb47de$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $0c528c0604fb47de$var$c = Array.isArray, $0c528c0604fb47de$var$v = (t)=>$0c528c0604fb47de$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $0c528c0604fb47de$var$a = "[ \t\n\f\r]", $0c528c0604fb47de$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $0c528c0604fb47de$var$_ = /-->/g, $0c528c0604fb47de$var$m = />/g, $0c528c0604fb47de$var$p = RegExp(`>|${$0c528c0604fb47de$var$a}(?:([^\\s"'>=/]+)(${$0c528c0604fb47de$var$a}*=${$0c528c0604fb47de$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $0c528c0604fb47de$var$g = /'/g, $0c528c0604fb47de$var$$ = /"/g, $0c528c0604fb47de$var$y = /^(?:script|style|textarea|title)$/i, $0c528c0604fb47de$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $0c528c0604fb47de$export$c0bb0b647f701bb5 = $0c528c0604fb47de$var$w(1), $0c528c0604fb47de$export$7ed1367e7fa1ad68 = $0c528c0604fb47de$var$w(2), $0c528c0604fb47de$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $0c528c0604fb47de$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $0c528c0604fb47de$var$E = new WeakMap, $0c528c0604fb47de$var$C = $0c528c0604fb47de$var$r.createTreeWalker($0c528c0604fb47de$var$r, 129, null, !1);
function $0c528c0604fb47de$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $0c528c0604fb47de$var$e ? $0c528c0604fb47de$var$e.createHTML(i) : i;
}
const $0c528c0604fb47de$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $0c528c0604fb47de$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $0c528c0604fb47de$var$f ? "!--" === c[1] ? u = $0c528c0604fb47de$var$_ : void 0 !== c[1] ? u = $0c528c0604fb47de$var$m : void 0 !== c[2] ? ($0c528c0604fb47de$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $0c528c0604fb47de$var$p) : void 0 !== c[3] && (u = $0c528c0604fb47de$var$p) : u === $0c528c0604fb47de$var$p ? ">" === c[0] ? (u = null != l ? l : $0c528c0604fb47de$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $0c528c0604fb47de$var$p : '"' === c[3] ? $0c528c0604fb47de$var$$ : $0c528c0604fb47de$var$g) : u === $0c528c0604fb47de$var$$ || u === $0c528c0604fb47de$var$g ? u = $0c528c0604fb47de$var$p : u === $0c528c0604fb47de$var$_ || u === $0c528c0604fb47de$var$m ? u = $0c528c0604fb47de$var$f : (u = $0c528c0604fb47de$var$p, l = void 0);
        const w = u === $0c528c0604fb47de$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $0c528c0604fb47de$var$f ? s + $0c528c0604fb47de$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $0c528c0604fb47de$var$o + s.slice(v) + $0c528c0604fb47de$var$n + w) : s + $0c528c0604fb47de$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $0c528c0604fb47de$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $0c528c0604fb47de$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $0c528c0604fb47de$var$V(t, i);
        if (this.el = $0c528c0604fb47de$var$N.createElement(a, e), $0c528c0604fb47de$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $0c528c0604fb47de$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($0c528c0604fb47de$var$o) || i.startsWith($0c528c0604fb47de$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $0c528c0604fb47de$var$o).split($0c528c0604fb47de$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $0c528c0604fb47de$var$H : "?" === i[1] ? $0c528c0604fb47de$var$L : "@" === i[1] ? $0c528c0604fb47de$var$z : $0c528c0604fb47de$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($0c528c0604fb47de$var$y.test(h.tagName)) {
                    const t = h.textContent.split($0c528c0604fb47de$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $0c528c0604fb47de$var$s ? $0c528c0604fb47de$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $0c528c0604fb47de$var$u()), $0c528c0604fb47de$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $0c528c0604fb47de$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $0c528c0604fb47de$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($0c528c0604fb47de$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $0c528c0604fb47de$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $0c528c0604fb47de$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $0c528c0604fb47de$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $0c528c0604fb47de$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $0c528c0604fb47de$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $0c528c0604fb47de$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $0c528c0604fb47de$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $0c528c0604fb47de$var$r).importNode(s, !0);
        $0c528c0604fb47de$var$C.currentNode = o;
        let n = $0c528c0604fb47de$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $0c528c0604fb47de$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $0c528c0604fb47de$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $0c528c0604fb47de$var$C.nextNode(), l++);
        }
        return $0c528c0604fb47de$var$C.currentNode = $0c528c0604fb47de$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $0c528c0604fb47de$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $0c528c0604fb47de$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $0c528c0604fb47de$var$S(this, t, i), $0c528c0604fb47de$var$d(t) ? t === $0c528c0604fb47de$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $0c528c0604fb47de$export$45b790e32b2810ee && this._$AR(), this._$AH = $0c528c0604fb47de$export$45b790e32b2810ee) : t !== this._$AH && t !== $0c528c0604fb47de$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $0c528c0604fb47de$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $0c528c0604fb47de$export$45b790e32b2810ee && $0c528c0604fb47de$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($0c528c0604fb47de$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $0c528c0604fb47de$var$N.createElement($0c528c0604fb47de$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $0c528c0604fb47de$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $0c528c0604fb47de$var$E.get(t.strings);
        return void 0 === i && $0c528c0604fb47de$var$E.set(t.strings, i = new $0c528c0604fb47de$var$N(t)), i;
    }
    T(t) {
        $0c528c0604fb47de$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $0c528c0604fb47de$var$R(this.k($0c528c0604fb47de$var$u()), this.k($0c528c0604fb47de$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $0c528c0604fb47de$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $0c528c0604fb47de$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $0c528c0604fb47de$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $0c528c0604fb47de$var$S(this, t, i, 0), n = !$0c528c0604fb47de$var$d(t) || t !== this._$AH && t !== $0c528c0604fb47de$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $0c528c0604fb47de$var$S(this, e[s + l], i, l), h === $0c528c0604fb47de$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$0c528c0604fb47de$var$d(h) || h !== this._$AH[l]), h === $0c528c0604fb47de$export$45b790e32b2810ee ? t = $0c528c0604fb47de$export$45b790e32b2810ee : t !== $0c528c0604fb47de$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $0c528c0604fb47de$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $0c528c0604fb47de$var$H extends $0c528c0604fb47de$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $0c528c0604fb47de$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $0c528c0604fb47de$var$I = $0c528c0604fb47de$var$s ? $0c528c0604fb47de$var$s.emptyScript : "";
class $0c528c0604fb47de$var$L extends $0c528c0604fb47de$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $0c528c0604fb47de$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $0c528c0604fb47de$var$I) : this.element.removeAttribute(this.name);
    }
}
class $0c528c0604fb47de$var$z extends $0c528c0604fb47de$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $0c528c0604fb47de$var$S(this, t, i, 0)) && void 0 !== s ? s : $0c528c0604fb47de$export$45b790e32b2810ee) === $0c528c0604fb47de$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $0c528c0604fb47de$export$45b790e32b2810ee && e !== $0c528c0604fb47de$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $0c528c0604fb47de$export$45b790e32b2810ee && (e === $0c528c0604fb47de$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $0c528c0604fb47de$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $0c528c0604fb47de$var$S(this, t);
    }
}
const $0c528c0604fb47de$export$8613d1ca9052b22e = {
    O: $0c528c0604fb47de$var$o,
    P: $0c528c0604fb47de$var$n,
    A: $0c528c0604fb47de$var$l,
    C: 1,
    M: $0c528c0604fb47de$var$V,
    L: $0c528c0604fb47de$var$M,
    R: $0c528c0604fb47de$var$v,
    D: $0c528c0604fb47de$var$S,
    I: $0c528c0604fb47de$var$R,
    V: $0c528c0604fb47de$var$k,
    H: $0c528c0604fb47de$var$L,
    N: $0c528c0604fb47de$var$z,
    U: $0c528c0604fb47de$var$H,
    F: $0c528c0604fb47de$var$Z
}, $0c528c0604fb47de$var$B = $0c528c0604fb47de$var$i.litHtmlPolyfillSupport;
null == $0c528c0604fb47de$var$B || $0c528c0604fb47de$var$B($0c528c0604fb47de$var$N, $0c528c0604fb47de$var$R), (null !== ($0c528c0604fb47de$var$t = $0c528c0604fb47de$var$i.litHtmlVersions) && void 0 !== $0c528c0604fb47de$var$t ? $0c528c0604fb47de$var$t : $0c528c0604fb47de$var$i.litHtmlVersions = []).push("2.8.0");
const $0c528c0604fb47de$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $0c528c0604fb47de$var$R(i.insertBefore($0c528c0604fb47de$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $399a79170bb71cc6$var$l, $399a79170bb71cc6$var$o;
const $399a79170bb71cc6$export$8bf27daf9e8907c9 = (0, $10ad292b36c2f201$export$c7c07a37856565d);
class $399a79170bb71cc6$export$3f2f9f5909897157 extends (0, $10ad292b36c2f201$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $0c528c0604fb47de$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $0c528c0604fb47de$export$9c068ae9cc5db4e8;
    }
}
$399a79170bb71cc6$export$3f2f9f5909897157.finalized = !0, $399a79170bb71cc6$export$3f2f9f5909897157._$litElement$ = !0, null === ($399a79170bb71cc6$var$l = globalThis.litElementHydrateSupport) || void 0 === $399a79170bb71cc6$var$l || $399a79170bb71cc6$var$l.call(globalThis, {
    LitElement: $399a79170bb71cc6$export$3f2f9f5909897157
});
const $399a79170bb71cc6$var$n = globalThis.litElementPolyfillSupport;
null == $399a79170bb71cc6$var$n || $399a79170bb71cc6$var$n({
    LitElement: $399a79170bb71cc6$export$3f2f9f5909897157
});
const $399a79170bb71cc6$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($399a79170bb71cc6$var$o = globalThis.litElementVersions) && void 0 !== $399a79170bb71cc6$var$o ? $399a79170bb71cc6$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $161bc3438776cb8f$export$6acf61af03e62db = !1;




const $cb2d6fb0288da888$export$9dd6ff9ea0189349 = (0, $db75749bcbdfa130$export$dbf350e5966cf602)`.mdc-top-app-bar{background-color:#6200ee;background-color:var(--mdc-theme-primary, #6200ee);color:white;display:flex;position:fixed;flex-direction:column;justify-content:space-between;box-sizing:border-box;width:100%;z-index:4}.mdc-top-app-bar .mdc-top-app-bar__action-item,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon{color:#fff;color:var(--mdc-theme-on-primary, #fff)}.mdc-top-app-bar .mdc-top-app-bar__action-item::before,.mdc-top-app-bar .mdc-top-app-bar__action-item::after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon::after{background-color:#fff;background-color:var(--mdc-ripple-color, var(--mdc-theme-on-primary, #fff))}.mdc-top-app-bar .mdc-top-app-bar__action-item:hover::before,.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-surface--hover::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:hover::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-surface--hover::before{opacity:0.08;opacity:var(--mdc-ripple-hover-opacity, 0.08)}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded--background-focused::before,.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):focus::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded--background-focused::before,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):focus::before{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-focus-opacity, 0.24)}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded)::after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded)::after{transition:opacity 150ms linear}.mdc-top-app-bar .mdc-top-app-bar__action-item:not(.mdc-ripple-upgraded):active::after,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon:not(.mdc-ripple-upgraded):active::after{transition-duration:75ms;opacity:0.24;opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-top-app-bar .mdc-top-app-bar__action-item.mdc-ripple-upgraded,.mdc-top-app-bar .mdc-top-app-bar__navigation-icon.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.24)}.mdc-top-app-bar__row{display:flex;position:relative;box-sizing:border-box;width:100%;height:64px}.mdc-top-app-bar__section{display:inline-flex;flex:1 1 auto;align-items:center;min-width:0;padding:8px 12px;z-index:1}.mdc-top-app-bar__section--align-start{justify-content:flex-start;order:-1}.mdc-top-app-bar__section--align-end{justify-content:flex-end;order:1}.mdc-top-app-bar__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-headline6-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size, 1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height, 2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight, 500);letter-spacing:0.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing, 0.0125em);text-decoration:inherit;text-decoration:var(--mdc-typography-headline6-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform, inherit);padding-left:20px;padding-right:0;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;z-index:1}[dir=rtl] .mdc-top-app-bar__title,.mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--short-collapsed{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:24px;border-bottom-left-radius:0}[dir=rtl] .mdc-top-app-bar--short-collapsed,.mdc-top-app-bar--short-collapsed[dir=rtl]{border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:24px}.mdc-top-app-bar--short{top:0;right:auto;left:0;width:100%;transition:width 250ms cubic-bezier(0.4, 0, 0.2, 1)}[dir=rtl] .mdc-top-app-bar--short,.mdc-top-app-bar--short[dir=rtl]{right:0;left:auto}.mdc-top-app-bar--short .mdc-top-app-bar__row{height:56px}.mdc-top-app-bar--short .mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short .mdc-top-app-bar__title{transition:opacity 200ms cubic-bezier(0.4, 0, 0.2, 1);opacity:1}.mdc-top-app-bar--short-collapsed{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0,0,0,.12);width:56px;transition:width 300ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__title{display:none}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__action-item{transition:padding 150ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item{width:112px}.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed.mdc-top-app-bar--short-has-action-item .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--dense .mdc-top-app-bar__row{height:48px}.mdc-top-app-bar--dense .mdc-top-app-bar__section{padding:0 4px}.mdc-top-app-bar--dense .mdc-top-app-bar__title{padding-left:12px;padding-right:0}[dir=rtl] .mdc-top-app-bar--dense .mdc-top-app-bar__title,.mdc-top-app-bar--dense .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:12px}.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:128px}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{align-self:flex-end;padding-bottom:2px}.mdc-top-app-bar--prominent .mdc-top-app-bar__action-item,.mdc-top-app-bar--prominent .mdc-top-app-bar__navigation-icon{align-self:flex-start}.mdc-top-app-bar--fixed{transition:box-shadow 200ms linear}.mdc-top-app-bar--fixed-scrolled{box-shadow:0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0,0,0,.12);transition:box-shadow 200ms linear}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__row{height:96px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__section{padding:0 12px}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-left:20px;padding-right:0;padding-bottom:9px}[dir=rtl] .mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title,.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__title[dir=rtl]{padding-left:0;padding-right:20px}.mdc-top-app-bar--fixed-adjust{padding-top:64px}.mdc-top-app-bar--dense-fixed-adjust{padding-top:48px}.mdc-top-app-bar--short-fixed-adjust{padding-top:56px}.mdc-top-app-bar--prominent-fixed-adjust{padding-top:128px}.mdc-top-app-bar--dense-prominent-fixed-adjust{padding-top:96px}@media(max-width: 599px){.mdc-top-app-bar__row{height:56px}.mdc-top-app-bar__section{padding:4px}.mdc-top-app-bar--short{transition:width 200ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed{transition:width 250ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end{padding-left:0;padding-right:12px}[dir=rtl] .mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end,.mdc-top-app-bar--short-collapsed .mdc-top-app-bar__section--align-end[dir=rtl]{padding-left:12px;padding-right:0}.mdc-top-app-bar--prominent .mdc-top-app-bar__title{padding-bottom:6px}.mdc-top-app-bar--fixed-adjust{padding-top:56px}}:host{display:block}.mdc-top-app-bar{color:#fff;color:var(--mdc-theme-on-primary, #fff);width:100%;width:var(--mdc-top-app-bar-width, 100%)}.mdc-top-app-bar--prominent #navigation ::slotted(*),.mdc-top-app-bar--prominent #actions ::slotted(*){align-self:flex-start}#navigation ::slotted(*),#actions ::slotted(*){--mdc-icon-button-ripple-opacity: 0.24}.mdc-top-app-bar--short-collapsed #actions ::slotted(*){transition:padding 150ms cubic-bezier(0.4, 0, 0.2, 1)}.mdc-top-app-bar__section--align-center{justify-content:center}.mdc-top-app-bar__section--align-center .mdc-top-app-bar__title{padding-left:0;padding-right:0}.center-title .mdc-top-app-bar__section--align-start,.center-title .mdc-top-app-bar__section--align-end{flex-basis:0}.mdc-top-app-bar--dense.mdc-top-app-bar--prominent .mdc-top-app-bar__section--align-center .mdc-top-app-bar__title{padding-left:0;padding-right:0}.mdc-top-app-bar--fixed-scrolled{box-shadow:var(--mdc-top-app-bar-fixed-box-shadow, 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12))}`;


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $a85e16a28bed7aa7$export$c1c0562ec8379000 = {
    FIXED_CLASS: 'mdc-top-app-bar--fixed',
    FIXED_SCROLLED_CLASS: 'mdc-top-app-bar--fixed-scrolled',
    SHORT_CLASS: 'mdc-top-app-bar--short',
    SHORT_COLLAPSED_CLASS: 'mdc-top-app-bar--short-collapsed',
    SHORT_HAS_ACTION_ITEM_CLASS: 'mdc-top-app-bar--short-has-action-item'
};
var $a85e16a28bed7aa7$export$1f6c9cc012ebacae = {
    DEBOUNCE_THROTTLE_RESIZE_TIME_MS: 100,
    MAX_TOP_APP_BAR_HEIGHT: 128
};
var $a85e16a28bed7aa7$export$21c51bc433c16634 = {
    ACTION_ITEM_SELECTOR: '.mdc-top-app-bar__action-item',
    NAVIGATION_EVENT: 'MDCTopAppBar:nav',
    NAVIGATION_ICON_SELECTOR: '.mdc-top-app-bar__navigation-icon',
    ROOT_SELECTOR: '.mdc-top-app-bar',
    TITLE_SELECTOR: '.mdc-top-app-bar__title'
};


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $5d3d4557b4c842e4$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$5d3d4557b4c842e4$export$2e2bcd8739ae039 = $5d3d4557b4c842e4$export$a81b11d69c993162;



var $d9d47d2c77edb389$export$8d607f703c13e7f1 = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCTopAppBarBaseFoundation, _super);
    /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarBaseFoundation(adapter) {
        return _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCTopAppBarBaseFoundation.defaultAdapter), adapter)) || this;
    }
    Object.defineProperty(MDCTopAppBarBaseFoundation, "strings", {
        get: function() {
            return 0, $a85e16a28bed7aa7$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTopAppBarBaseFoundation, "cssClasses", {
        get: function() {
            return 0, $a85e16a28bed7aa7$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTopAppBarBaseFoundation, "numbers", {
        get: function() {
            return 0, $a85e16a28bed7aa7$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCTopAppBarBaseFoundation, "defaultAdapter", {
        /**
         * See {@link MDCTopAppBarAdapter} for typing information on parameters and return types.
         */ get: function() {
            // tslint:disable:object-literal-sort-keys Methods should be in the same order as the adapter interface.
            return {
                addClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                hasClass: function() {
                    return false;
                },
                setStyle: function() {
                    return undefined;
                },
                getTopAppBarHeight: function() {
                    return 0;
                },
                notifyNavigationIconClicked: function() {
                    return undefined;
                },
                getViewportScrollY: function() {
                    return 0;
                },
                getTotalActionItems: function() {
                    return 0;
                }
            };
        // tslint:enable:object-literal-sort-keys
        },
        enumerable: false,
        configurable: true
    });
    /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleTargetScroll = function() {}; // tslint:disable-line:no-empty
    /** Other variants of TopAppBar foundation overrides this method */ MDCTopAppBarBaseFoundation.prototype.handleWindowResize = function() {}; // tslint:disable-line:no-empty
    MDCTopAppBarBaseFoundation.prototype.handleNavigationClick = function() {
        this.adapter.notifyNavigationIconClicked();
    };
    return MDCTopAppBarBaseFoundation;
}((0, $5d3d4557b4c842e4$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$d9d47d2c77edb389$export$2e2bcd8739ae039 = $d9d47d2c77edb389$export$8d607f703c13e7f1;


var $ac9bf926236c51ad$var$INITIAL_VALUE = 0;
var $ac9bf926236c51ad$export$fb8cee90da48470f = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCTopAppBarFoundation, _super);
    /* istanbul ignore next: optional argument is not a branch statement */ function MDCTopAppBarFoundation(adapter) {
        var _this = _super.call(this, adapter) || this;
        /**
         * Indicates if the top app bar was docked in the previous scroll handler iteration.
         */ _this.wasDocked = true;
        /**
         * Indicates if the top app bar is docked in the fully shown position.
         */ _this.isDockedShowing = true;
        /**
         * Variable for current scroll position of the top app bar
         */ _this.currentAppBarOffsetTop = 0;
        /**
         * Used to prevent the top app bar from being scrolled out of view during resize events
         */ _this.isCurrentlyBeingResized = false;
        /**
         * The timeout that's used to throttle the resize events
         */ _this.resizeThrottleId = $ac9bf926236c51ad$var$INITIAL_VALUE;
        /**
         * The timeout that's used to debounce toggling the isCurrentlyBeingResized
         * variable after a resize
         */ _this.resizeDebounceId = $ac9bf926236c51ad$var$INITIAL_VALUE;
        _this.lastScrollPosition = _this.adapter.getViewportScrollY();
        _this.topAppBarHeight = _this.adapter.getTopAppBarHeight();
        return _this;
    }
    MDCTopAppBarFoundation.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        this.adapter.setStyle('top', '');
    };
    /**
     * Scroll handler for the default scroll behavior of the top app bar.
     */ MDCTopAppBarFoundation.prototype.handleTargetScroll = function() {
        var currentScrollPosition = Math.max(this.adapter.getViewportScrollY(), 0);
        var diff = currentScrollPosition - this.lastScrollPosition;
        this.lastScrollPosition = currentScrollPosition;
        // If the window is being resized the lastScrollPosition needs to be updated
        // but the current scroll of the top app bar should stay in the same
        // position.
        if (!this.isCurrentlyBeingResized) {
            this.currentAppBarOffsetTop -= diff;
            if (this.currentAppBarOffsetTop > 0) this.currentAppBarOffsetTop = 0;
            else if (Math.abs(this.currentAppBarOffsetTop) > this.topAppBarHeight) this.currentAppBarOffsetTop = -this.topAppBarHeight;
            this.moveTopAppBar();
        }
    };
    /**
     * Top app bar resize handler that throttle/debounce functions that execute updates.
     */ MDCTopAppBarFoundation.prototype.handleWindowResize = function() {
        var _this = this;
        // Throttle resize events 10 p/s
        if (!this.resizeThrottleId) this.resizeThrottleId = setTimeout(function() {
            _this.resizeThrottleId = $ac9bf926236c51ad$var$INITIAL_VALUE;
            _this.throttledResizeHandler();
        }, (0, $a85e16a28bed7aa7$export$1f6c9cc012ebacae).DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
        this.isCurrentlyBeingResized = true;
        if (this.resizeDebounceId) clearTimeout(this.resizeDebounceId);
        this.resizeDebounceId = setTimeout(function() {
            _this.handleTargetScroll();
            _this.isCurrentlyBeingResized = false;
            _this.resizeDebounceId = $ac9bf926236c51ad$var$INITIAL_VALUE;
        }, (0, $a85e16a28bed7aa7$export$1f6c9cc012ebacae).DEBOUNCE_THROTTLE_RESIZE_TIME_MS);
    };
    /**
     * Function to determine if the DOM needs to update.
     */ MDCTopAppBarFoundation.prototype.checkForUpdate = function() {
        var offscreenBoundaryTop = -this.topAppBarHeight;
        var hasAnyPixelsOffscreen = this.currentAppBarOffsetTop < 0;
        var hasAnyPixelsOnscreen = this.currentAppBarOffsetTop > offscreenBoundaryTop;
        var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
        // If it's partially showing, it can't be docked.
        if (partiallyShowing) this.wasDocked = false;
        else {
            // Not previously docked and not partially showing, it's now docked.
            if (!this.wasDocked) {
                this.wasDocked = true;
                return true;
            } else if (this.isDockedShowing !== hasAnyPixelsOnscreen) {
                this.isDockedShowing = hasAnyPixelsOnscreen;
                return true;
            }
        }
        return partiallyShowing;
    };
    /**
     * Function to move the top app bar if needed.
     */ MDCTopAppBarFoundation.prototype.moveTopAppBar = function() {
        if (this.checkForUpdate()) {
            // Once the top app bar is fully hidden we use the max potential top app bar height as our offset
            // so the top app bar doesn't show if the window resizes and the new height > the old height.
            var offset = this.currentAppBarOffsetTop;
            if (Math.abs(offset) >= this.topAppBarHeight) offset = -(0, $a85e16a28bed7aa7$export$1f6c9cc012ebacae).MAX_TOP_APP_BAR_HEIGHT;
            this.adapter.setStyle('top', offset + 'px');
        }
    };
    /**
     * Throttled function that updates the top app bar scrolled values if the
     * top app bar height changes.
     */ MDCTopAppBarFoundation.prototype.throttledResizeHandler = function() {
        var currentHeight = this.adapter.getTopAppBarHeight();
        if (this.topAppBarHeight !== currentHeight) {
            this.wasDocked = false;
            // Since the top app bar has a different height depending on the screen width, this
            // will ensure that the top app bar remains in the correct location if
            // completely hidden and a resize makes the top app bar a different height.
            this.currentAppBarOffsetTop -= this.topAppBarHeight - currentHeight;
            this.topAppBarHeight = currentHeight;
        }
        this.handleTargetScroll();
    };
    return MDCTopAppBarFoundation;
}((0, $d9d47d2c77edb389$export$8d607f703c13e7f1));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$ac9bf926236c51ad$export$2e2bcd8739ae039 = $ac9bf926236c51ad$export$fb8cee90da48470f;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f9cc53f965d2068c$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $17712fc32181b67c$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $17712fc32181b67c$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $17712fc32181b67c$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $17712fc32181b67c$var$e(n, t, o) : $17712fc32181b67c$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $11d2cfc219741804$export$ca000e230c0caa3e(t) {
    return (0, $17712fc32181b67c$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $df233c3e152d0bfe$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $df233c3e152d0bfe$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $df233c3e152d0bfe$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9b04c60f2dd3143f$export$b2b799818fbabcf3(e) {
    return (0, $df233c3e152d0bfe$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ce36c8280e6b0eed$export$2fa187e846a241c4(i, n) {
    return (0, $df233c3e152d0bfe$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6b356bcab2dcc4c5$export$dcd0d083aa86c355(e) {
    return (0, $df233c3e152d0bfe$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ed628b30daf88199$export$163dfc35cc43f240(e) {
    return (0, $df233c3e152d0bfe$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $2b54e8a85ec18726$var$n;
const $2b54e8a85ec18726$var$e = null != (null === ($2b54e8a85ec18726$var$n = window.HTMLSlotElement) || void 0 === $2b54e8a85ec18726$var$n ? void 0 : $2b54e8a85ec18726$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $2b54e8a85ec18726$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $df233c3e152d0bfe$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $2b54e8a85ec18726$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $901029dbd6901c75$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $2b54e8a85ec18726$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $df233c3e152d0bfe$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("4ifWP");
var $gSEYT = parcelRequire("gSEYT");
var $4ifWP = parcelRequire("4ifWP");

var $gSEYT = parcelRequire("gSEYT");




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $567c1abded71059d$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $567c1abded71059d$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $567c1abded71059d$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $af15453a60b91c2f$export$56cc687933817664 = (0, $567c1abded71059d$export$99b43ad1ed32e735)(class extends (0, $567c1abded71059d$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $567c1abded71059d$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $0c528c0604fb47de$export$9c068ae9cc5db4e8;
    }
});




const $9721949092f8f2a2$export$f7426bc6d3d50eba = (0, $gSEYT.supportsPassiveEventListener) ? {
    passive: true
} : undefined;
class $9721949092f8f2a2$export$d372b7d973f22f7c extends (0, $4ifWP.BaseElement) {
    constructor(){
        super(...arguments);
        this.centerTitle = false;
        this.handleTargetScroll = ()=>{
            this.mdcFoundation.handleTargetScroll();
        };
        this.handleNavigationClick = ()=>{
            this.mdcFoundation.handleNavigationClick();
        };
    }
    get scrollTarget() {
        return this._scrollTarget || window;
    }
    set scrollTarget(value) {
        this.unregisterScrollListener();
        const old = this.scrollTarget;
        this._scrollTarget = value;
        this.updateRootPosition();
        this.requestUpdate('scrollTarget', old);
        this.registerScrollListener();
    }
    updateRootPosition() {
        if (this.mdcRoot) {
            const windowScroller = this.scrollTarget === window;
            // we add support for top-app-bar's tied to an element scroller.
            this.mdcRoot.style.position = windowScroller ? '' : 'absolute';
        }
    }
    render() {
        // clang-format off
        let title = (0, $0c528c0604fb47de$export$c0bb0b647f701bb5)`<span class="mdc-top-app-bar__title"><slot name="title"></slot></span>`;
        if (this.centerTitle) title = (0, $0c528c0604fb47de$export$c0bb0b647f701bb5)`<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-center">${title}</section>`;
        // clang-format on
        return (0, $0c528c0604fb47de$export$c0bb0b647f701bb5)`
      <header class="mdc-top-app-bar ${(0, $af15453a60b91c2f$export$56cc687933817664)(this.barClasses())}">
      <div class="mdc-top-app-bar__row">
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start" id="navigation">
          <slot name="navigationIcon"
            @click=${this.handleNavigationClick}></slot>
          ${this.centerTitle ? null : title}
        </section>
        ${this.centerTitle ? title : null}
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" id="actions" role="toolbar">
          <slot name="actionItems"></slot>
        </section>
      </div>
    </header>
    <div class="${(0, $af15453a60b91c2f$export$56cc687933817664)(this.contentClasses())}">
      <slot></slot>
    </div>
    `;
    }
    createAdapter() {
        return Object.assign(Object.assign({}, (0, $gSEYT.addHasRemoveClass)(this.mdcRoot)), {
            setStyle: (property, value)=>this.mdcRoot.style.setProperty(property, value),
            getTopAppBarHeight: ()=>this.mdcRoot.clientHeight,
            notifyNavigationIconClicked: ()=>{
                this.dispatchEvent(new Event((0, $a85e16a28bed7aa7$export$21c51bc433c16634).NAVIGATION_EVENT, {
                    bubbles: true,
                    cancelable: true
                }));
            },
            getViewportScrollY: ()=>this.scrollTarget instanceof Window ? this.scrollTarget.pageYOffset : this.scrollTarget.scrollTop,
            getTotalActionItems: ()=>this._actionItemsSlot.assignedNodes({
                    flatten: true
                }).length
        });
    }
    registerListeners() {
        this.registerScrollListener();
    }
    unregisterListeners() {
        this.unregisterScrollListener();
    }
    registerScrollListener() {
        this.scrollTarget.addEventListener('scroll', this.handleTargetScroll, $9721949092f8f2a2$export$f7426bc6d3d50eba);
    }
    unregisterScrollListener() {
        this.scrollTarget.removeEventListener('scroll', this.handleTargetScroll);
    }
    firstUpdated() {
        super.firstUpdated();
        this.updateRootPosition();
        this.registerListeners();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.unregisterListeners();
    }
}
(0, $czHfO.__decorate)([
    (0, $ce36c8280e6b0eed$export$2fa187e846a241c4)('.mdc-top-app-bar')
], $9721949092f8f2a2$export$d372b7d973f22f7c.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $ce36c8280e6b0eed$export$2fa187e846a241c4)('slot[name="actionItems"]')
], $9721949092f8f2a2$export$d372b7d973f22f7c.prototype, "_actionItemsSlot", void 0);
(0, $czHfO.__decorate)([
    (0, $17712fc32181b67c$export$d541bacb2bda4494)({
        type: Boolean
    })
], $9721949092f8f2a2$export$d372b7d973f22f7c.prototype, "centerTitle", void 0);
(0, $czHfO.__decorate)([
    (0, $17712fc32181b67c$export$d541bacb2bda4494)({
        type: Object
    })
], $9721949092f8f2a2$export$d372b7d973f22f7c.prototype, "scrollTarget", null);


class $de4a9debc5edb9fa$export$7d83700306637ce9 extends (0, $9721949092f8f2a2$export$d372b7d973f22f7c) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $ac9bf926236c51ad$export$2e2bcd8739ae039);
        this.prominent = false;
        this.dense = false;
        this.handleResize = ()=>{
            this.mdcFoundation.handleWindowResize();
        };
    }
    barClasses() {
        return {
            'mdc-top-app-bar--dense': this.dense,
            'mdc-top-app-bar--prominent': this.prominent,
            'center-title': this.centerTitle
        };
    }
    contentClasses() {
        return {
            'mdc-top-app-bar--fixed-adjust': !this.dense && !this.prominent,
            'mdc-top-app-bar--dense-fixed-adjust': this.dense && !this.prominent,
            'mdc-top-app-bar--prominent-fixed-adjust': !this.dense && this.prominent,
            'mdc-top-app-bar--dense-prominent-fixed-adjust': this.dense && this.prominent
        };
    }
    registerListeners() {
        super.registerListeners();
        window.addEventListener('resize', this.handleResize, (0, $9721949092f8f2a2$export$f7426bc6d3d50eba));
    }
    unregisterListeners() {
        super.unregisterListeners();
        window.removeEventListener('resize', this.handleResize);
    }
}
(0, $czHfO.__decorate)([
    (0, $17712fc32181b67c$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $de4a9debc5edb9fa$export$7d83700306637ce9.prototype, "prominent", void 0);
(0, $czHfO.__decorate)([
    (0, $17712fc32181b67c$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $de4a9debc5edb9fa$export$7d83700306637ce9.prototype, "dense", void 0);



/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");


var $1e4424aaaead20f6$export$7ab4745f9177da15 = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCFixedTopAppBarFoundation, _super);
    function MDCFixedTopAppBarFoundation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * State variable for the previous scroll iteration top app bar state
         */ _this.wasScrolled = false;
        return _this;
    }
    /**
     * Scroll handler for applying/removing the modifier class on the fixed top app bar.
     */ MDCFixedTopAppBarFoundation.prototype.handleTargetScroll = function() {
        var currentScroll = this.adapter.getViewportScrollY();
        if (currentScroll <= 0) {
            if (this.wasScrolled) {
                this.adapter.removeClass((0, $a85e16a28bed7aa7$export$c1c0562ec8379000).FIXED_SCROLLED_CLASS);
                this.wasScrolled = false;
            }
        } else if (!this.wasScrolled) {
            this.adapter.addClass((0, $a85e16a28bed7aa7$export$c1c0562ec8379000).FIXED_SCROLLED_CLASS);
            this.wasScrolled = true;
        }
    };
    return MDCFixedTopAppBarFoundation;
}((0, $ac9bf926236c51ad$export$fb8cee90da48470f));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$1e4424aaaead20f6$export$2e2bcd8739ae039 = $1e4424aaaead20f6$export$7ab4745f9177da15;


class $9061d77101ecfbcd$export$f10dd04d0b60147a extends (0, $de4a9debc5edb9fa$export$7d83700306637ce9) {
    constructor(){
        super(...arguments);
        this.mdcFoundationClass = (0, $1e4424aaaead20f6$export$2e2bcd8739ae039);
    }
    barClasses() {
        return Object.assign(Object.assign({}, super.barClasses()), {
            'mdc-top-app-bar--fixed': true
        });
    }
    registerListeners() {
        this.scrollTarget.addEventListener('scroll', this.handleTargetScroll, (0, $9721949092f8f2a2$export$f7426bc6d3d50eba));
    }
    unregisterListeners() {
        this.scrollTarget.removeEventListener('scroll', this.handleTargetScroll);
    }
}


let $c45f4c8109fadf6b$export$61a1599c2ddf7de3 = class TopAppBarFixed extends (0, $9061d77101ecfbcd$export$f10dd04d0b60147a) {
};
$c45f4c8109fadf6b$export$61a1599c2ddf7de3.styles = [
    (0, $cb2d6fb0288da888$export$9dd6ff9ea0189349)
];
$c45f4c8109fadf6b$export$61a1599c2ddf7de3 = (0, $czHfO.__decorate)([
    (0, $2c3eaa156e16e0a0$export$da64fc29f17f9d0e)('mwc-top-app-bar-fixed')
], $c45f4c8109fadf6b$export$61a1599c2ddf7de3);


parcelRequire("8qnmK");
parcelRequire("8J3FQ");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8c2bd622e304dd44$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $711a6ba61b027374$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $711a6ba61b027374$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $711a6ba61b027374$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $711a6ba61b027374$var$e(n, t, o) : $711a6ba61b027374$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $06733b95f056f54c$export$ca000e230c0caa3e(t) {
    return (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c762dcab8a40ff5f$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $c762dcab8a40ff5f$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $c762dcab8a40ff5f$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $728358531ec72778$export$b2b799818fbabcf3(e) {
    return (0, $c762dcab8a40ff5f$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $07620277c937646f$export$2fa187e846a241c4(i, n) {
    return (0, $c762dcab8a40ff5f$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $fa0bdac5aa51d44c$export$dcd0d083aa86c355(e) {
    return (0, $c762dcab8a40ff5f$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $271f0e86b456d810$export$163dfc35cc43f240(e) {
    return (0, $c762dcab8a40ff5f$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $732b1f5aaf18fac5$var$n;
const $732b1f5aaf18fac5$var$e = null != (null === ($732b1f5aaf18fac5$var$n = window.HTMLSlotElement) || void 0 === $732b1f5aaf18fac5$var$n ? void 0 : $732b1f5aaf18fac5$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $732b1f5aaf18fac5$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $c762dcab8a40ff5f$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $732b1f5aaf18fac5$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $11ed934955df9f62$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $732b1f5aaf18fac5$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $c762dcab8a40ff5f$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("aX7Bm");

var $bAdyM = parcelRequire("bAdyM");

var $cMU8m = parcelRequire("cMU8m");

var $2qnKN = parcelRequire("2qnKN");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $776fade94803d18f$var$t = window, $776fade94803d18f$export$b4d10f6001c083c2 = $776fade94803d18f$var$t.ShadowRoot && (void 0 === $776fade94803d18f$var$t.ShadyCSS || $776fade94803d18f$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $776fade94803d18f$var$s = Symbol(), $776fade94803d18f$var$n = new WeakMap;
class $776fade94803d18f$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $776fade94803d18f$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($776fade94803d18f$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $776fade94803d18f$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $776fade94803d18f$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $776fade94803d18f$export$8d80f9cac07cdb3 = (t)=>new $776fade94803d18f$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $776fade94803d18f$var$s), $776fade94803d18f$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $776fade94803d18f$export$505d1e8739bad805(n, t, $776fade94803d18f$var$s);
}, $776fade94803d18f$export$2ca4a66ec4cecb90 = (s, n)=>{
    $776fade94803d18f$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $776fade94803d18f$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $776fade94803d18f$export$ee69dfd951e24778 = $776fade94803d18f$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $776fade94803d18f$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $a1ce27442efa946b$var$s;
const $a1ce27442efa946b$var$e = window, $a1ce27442efa946b$var$r = $a1ce27442efa946b$var$e.trustedTypes, $a1ce27442efa946b$var$h = $a1ce27442efa946b$var$r ? $a1ce27442efa946b$var$r.emptyScript : "", $a1ce27442efa946b$var$o = $a1ce27442efa946b$var$e.reactiveElementPolyfillSupport, $a1ce27442efa946b$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $a1ce27442efa946b$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $a1ce27442efa946b$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $a1ce27442efa946b$var$l = {
    attribute: !0,
    type: String,
    converter: $a1ce27442efa946b$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $a1ce27442efa946b$export$53a6892c50694894
}, $a1ce27442efa946b$var$d = "finalized";
class $a1ce27442efa946b$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $a1ce27442efa946b$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $a1ce27442efa946b$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($a1ce27442efa946b$var$d)) return !1;
        this[$a1ce27442efa946b$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $776fade94803d18f$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $776fade94803d18f$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $776fade94803d18f$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $a1ce27442efa946b$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $a1ce27442efa946b$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $a1ce27442efa946b$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $a1ce27442efa946b$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$a1ce27442efa946b$export$c7c07a37856565d[$a1ce27442efa946b$var$d] = !0, $a1ce27442efa946b$export$c7c07a37856565d.elementProperties = new Map, $a1ce27442efa946b$export$c7c07a37856565d.elementStyles = [], $a1ce27442efa946b$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $a1ce27442efa946b$var$o || $a1ce27442efa946b$var$o({
    ReactiveElement: $a1ce27442efa946b$export$c7c07a37856565d
}), (null !== ($a1ce27442efa946b$var$s = $a1ce27442efa946b$var$e.reactiveElementVersions) && void 0 !== $a1ce27442efa946b$var$s ? $a1ce27442efa946b$var$s : $a1ce27442efa946b$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $047536623440a31e$var$t;
const $047536623440a31e$var$i = window, $047536623440a31e$var$s = $047536623440a31e$var$i.trustedTypes, $047536623440a31e$var$e = $047536623440a31e$var$s ? $047536623440a31e$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $047536623440a31e$var$o = "$lit$", $047536623440a31e$var$n = `lit$${(Math.random() + "").slice(9)}$`, $047536623440a31e$var$l = "?" + $047536623440a31e$var$n, $047536623440a31e$var$h = `<${$047536623440a31e$var$l}>`, $047536623440a31e$var$r = document, $047536623440a31e$var$u = ()=>$047536623440a31e$var$r.createComment(""), $047536623440a31e$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $047536623440a31e$var$c = Array.isArray, $047536623440a31e$var$v = (t)=>$047536623440a31e$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $047536623440a31e$var$a = "[ \t\n\f\r]", $047536623440a31e$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $047536623440a31e$var$_ = /-->/g, $047536623440a31e$var$m = />/g, $047536623440a31e$var$p = RegExp(`>|${$047536623440a31e$var$a}(?:([^\\s"'>=/]+)(${$047536623440a31e$var$a}*=${$047536623440a31e$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $047536623440a31e$var$g = /'/g, $047536623440a31e$var$$ = /"/g, $047536623440a31e$var$y = /^(?:script|style|textarea|title)$/i, $047536623440a31e$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $047536623440a31e$export$c0bb0b647f701bb5 = $047536623440a31e$var$w(1), $047536623440a31e$export$7ed1367e7fa1ad68 = $047536623440a31e$var$w(2), $047536623440a31e$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $047536623440a31e$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $047536623440a31e$var$E = new WeakMap, $047536623440a31e$var$C = $047536623440a31e$var$r.createTreeWalker($047536623440a31e$var$r, 129, null, !1);
function $047536623440a31e$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $047536623440a31e$var$e ? $047536623440a31e$var$e.createHTML(i) : i;
}
const $047536623440a31e$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $047536623440a31e$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $047536623440a31e$var$f ? "!--" === c[1] ? u = $047536623440a31e$var$_ : void 0 !== c[1] ? u = $047536623440a31e$var$m : void 0 !== c[2] ? ($047536623440a31e$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $047536623440a31e$var$p) : void 0 !== c[3] && (u = $047536623440a31e$var$p) : u === $047536623440a31e$var$p ? ">" === c[0] ? (u = null != l ? l : $047536623440a31e$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $047536623440a31e$var$p : '"' === c[3] ? $047536623440a31e$var$$ : $047536623440a31e$var$g) : u === $047536623440a31e$var$$ || u === $047536623440a31e$var$g ? u = $047536623440a31e$var$p : u === $047536623440a31e$var$_ || u === $047536623440a31e$var$m ? u = $047536623440a31e$var$f : (u = $047536623440a31e$var$p, l = void 0);
        const w = u === $047536623440a31e$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $047536623440a31e$var$f ? s + $047536623440a31e$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $047536623440a31e$var$o + s.slice(v) + $047536623440a31e$var$n + w) : s + $047536623440a31e$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $047536623440a31e$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $047536623440a31e$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $047536623440a31e$var$V(t, i);
        if (this.el = $047536623440a31e$var$N.createElement(a, e), $047536623440a31e$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $047536623440a31e$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($047536623440a31e$var$o) || i.startsWith($047536623440a31e$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $047536623440a31e$var$o).split($047536623440a31e$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $047536623440a31e$var$H : "?" === i[1] ? $047536623440a31e$var$L : "@" === i[1] ? $047536623440a31e$var$z : $047536623440a31e$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($047536623440a31e$var$y.test(h.tagName)) {
                    const t = h.textContent.split($047536623440a31e$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $047536623440a31e$var$s ? $047536623440a31e$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $047536623440a31e$var$u()), $047536623440a31e$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $047536623440a31e$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $047536623440a31e$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($047536623440a31e$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $047536623440a31e$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $047536623440a31e$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $047536623440a31e$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $047536623440a31e$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $047536623440a31e$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $047536623440a31e$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $047536623440a31e$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $047536623440a31e$var$r).importNode(s, !0);
        $047536623440a31e$var$C.currentNode = o;
        let n = $047536623440a31e$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $047536623440a31e$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $047536623440a31e$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $047536623440a31e$var$C.nextNode(), l++);
        }
        return $047536623440a31e$var$C.currentNode = $047536623440a31e$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $047536623440a31e$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $047536623440a31e$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $047536623440a31e$var$S(this, t, i), $047536623440a31e$var$d(t) ? t === $047536623440a31e$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $047536623440a31e$export$45b790e32b2810ee && this._$AR(), this._$AH = $047536623440a31e$export$45b790e32b2810ee) : t !== this._$AH && t !== $047536623440a31e$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $047536623440a31e$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $047536623440a31e$export$45b790e32b2810ee && $047536623440a31e$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($047536623440a31e$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $047536623440a31e$var$N.createElement($047536623440a31e$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $047536623440a31e$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $047536623440a31e$var$E.get(t.strings);
        return void 0 === i && $047536623440a31e$var$E.set(t.strings, i = new $047536623440a31e$var$N(t)), i;
    }
    T(t) {
        $047536623440a31e$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $047536623440a31e$var$R(this.k($047536623440a31e$var$u()), this.k($047536623440a31e$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $047536623440a31e$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $047536623440a31e$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $047536623440a31e$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $047536623440a31e$var$S(this, t, i, 0), n = !$047536623440a31e$var$d(t) || t !== this._$AH && t !== $047536623440a31e$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $047536623440a31e$var$S(this, e[s + l], i, l), h === $047536623440a31e$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$047536623440a31e$var$d(h) || h !== this._$AH[l]), h === $047536623440a31e$export$45b790e32b2810ee ? t = $047536623440a31e$export$45b790e32b2810ee : t !== $047536623440a31e$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $047536623440a31e$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $047536623440a31e$var$H extends $047536623440a31e$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $047536623440a31e$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $047536623440a31e$var$I = $047536623440a31e$var$s ? $047536623440a31e$var$s.emptyScript : "";
class $047536623440a31e$var$L extends $047536623440a31e$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $047536623440a31e$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $047536623440a31e$var$I) : this.element.removeAttribute(this.name);
    }
}
class $047536623440a31e$var$z extends $047536623440a31e$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $047536623440a31e$var$S(this, t, i, 0)) && void 0 !== s ? s : $047536623440a31e$export$45b790e32b2810ee) === $047536623440a31e$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $047536623440a31e$export$45b790e32b2810ee && e !== $047536623440a31e$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $047536623440a31e$export$45b790e32b2810ee && (e === $047536623440a31e$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $047536623440a31e$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $047536623440a31e$var$S(this, t);
    }
}
const $047536623440a31e$export$8613d1ca9052b22e = {
    O: $047536623440a31e$var$o,
    P: $047536623440a31e$var$n,
    A: $047536623440a31e$var$l,
    C: 1,
    M: $047536623440a31e$var$V,
    L: $047536623440a31e$var$M,
    R: $047536623440a31e$var$v,
    D: $047536623440a31e$var$S,
    I: $047536623440a31e$var$R,
    V: $047536623440a31e$var$k,
    H: $047536623440a31e$var$L,
    N: $047536623440a31e$var$z,
    U: $047536623440a31e$var$H,
    F: $047536623440a31e$var$Z
}, $047536623440a31e$var$B = $047536623440a31e$var$i.litHtmlPolyfillSupport;
null == $047536623440a31e$var$B || $047536623440a31e$var$B($047536623440a31e$var$N, $047536623440a31e$var$R), (null !== ($047536623440a31e$var$t = $047536623440a31e$var$i.litHtmlVersions) && void 0 !== $047536623440a31e$var$t ? $047536623440a31e$var$t : $047536623440a31e$var$i.litHtmlVersions = []).push("2.8.0");
const $047536623440a31e$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $047536623440a31e$var$R(i.insertBefore($047536623440a31e$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $a2f7869e7b05cd3e$var$l, $a2f7869e7b05cd3e$var$o;
const $a2f7869e7b05cd3e$export$8bf27daf9e8907c9 = (0, $a1ce27442efa946b$export$c7c07a37856565d);
class $a2f7869e7b05cd3e$export$3f2f9f5909897157 extends (0, $a1ce27442efa946b$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $047536623440a31e$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $047536623440a31e$export$9c068ae9cc5db4e8;
    }
}
$a2f7869e7b05cd3e$export$3f2f9f5909897157.finalized = !0, $a2f7869e7b05cd3e$export$3f2f9f5909897157._$litElement$ = !0, null === ($a2f7869e7b05cd3e$var$l = globalThis.litElementHydrateSupport) || void 0 === $a2f7869e7b05cd3e$var$l || $a2f7869e7b05cd3e$var$l.call(globalThis, {
    LitElement: $a2f7869e7b05cd3e$export$3f2f9f5909897157
});
const $a2f7869e7b05cd3e$var$n = globalThis.litElementPolyfillSupport;
null == $a2f7869e7b05cd3e$var$n || $a2f7869e7b05cd3e$var$n({
    LitElement: $a2f7869e7b05cd3e$export$3f2f9f5909897157
});
const $a2f7869e7b05cd3e$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($a2f7869e7b05cd3e$var$o = globalThis.litElementVersions) && void 0 !== $a2f7869e7b05cd3e$var$o ? $a2f7869e7b05cd3e$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b01cad57ed8b103f$export$6acf61af03e62db = !1;






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $444df0c0f50ff3d4$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $444df0c0f50ff3d4$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $444df0c0f50ff3d4$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2e43e920d0d5b738$export$56cc687933817664 = (0, $444df0c0f50ff3d4$export$99b43ad1ed32e735)(class extends (0, $444df0c0f50ff3d4$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $444df0c0f50ff3d4$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $047536623440a31e$export$9c068ae9cc5db4e8;
    }
});





/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6e74b7d85b81502e$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $047536623440a31e$export$45b790e32b2810ee);




class $6689181a08a2284c$export$f56e96de55837300 extends (0, $cMU8m.FormElement) {
    constructor(){
        super(...arguments);
        this.checked = false;
        this.indeterminate = false;
        this.disabled = false;
        this.name = '';
        this.value = 'on';
        /**
         * Touch target extends beyond visual boundary of a component by default.
         * Set to `true` to remove touch target added to the component.
         * @see https://material.io/design/usability/accessibility.html
         */ this.reducedTouchTarget = false;
        this.animationClass = '';
        this.shouldRenderRipple = false;
        this.focused = false;
        // MDC Foundation is unused
        this.mdcFoundationClass = undefined;
        this.mdcFoundation = undefined;
        this.rippleElement = null;
        this.rippleHandlers = new (0, $2qnKN.RippleHandlers)(()=>{
            this.shouldRenderRipple = true;
            this.ripple.then((v)=>this.rippleElement = v);
            return this.ripple;
        });
    }
    createAdapter() {
        return {};
    }
    update(changedProperties) {
        const oldIndeterminate = changedProperties.get('indeterminate');
        const oldChecked = changedProperties.get('checked');
        const oldDisabled = changedProperties.get('disabled');
        if (oldIndeterminate !== undefined || oldChecked !== undefined || oldDisabled !== undefined) {
            const oldState = this.calculateAnimationStateName(!!oldChecked, !!oldIndeterminate, !!oldDisabled);
            const newState = this.calculateAnimationStateName(this.checked, this.indeterminate, this.disabled);
            this.animationClass = `${oldState}-${newState}`;
        }
        super.update(changedProperties);
    }
    calculateAnimationStateName(checked, indeterminate, disabled) {
        if (disabled) return 'disabled';
        else if (indeterminate) return 'indeterminate';
        else if (checked) return 'checked';
        else return 'unchecked';
    }
    // TODO(dfreedm): Make this use selected as a param after Polymer/internal#739
    /** @soyTemplate */ renderRipple() {
        return this.shouldRenderRipple ? this.renderRippleTemplate() : '';
    }
    /** @soyTemplate */ renderRippleTemplate() {
        return (0, $047536623440a31e$export$c0bb0b647f701bb5)`<mwc-ripple
        .disabled="${this.disabled}"
        unbounded></mwc-ripple>`;
    }
    /**
     * @soyTemplate
     * @soyAttributes checkboxAttributes: input
     * @soyClasses checkboxClasses: .mdc-checkbox
     */ render() {
        const selected = this.indeterminate || this.checked;
        /* eslint-disable eqeqeq */ // tslint:disable:triple-equals
        /** @classMap */ const classes = {
            'mdc-checkbox--disabled': this.disabled,
            'mdc-checkbox--selected': selected,
            'mdc-checkbox--touch': !this.reducedTouchTarget,
            'mdc-ripple-upgraded--background-focused': this.focused,
            // transition animiation classes
            'mdc-checkbox--anim-checked-indeterminate': this.animationClass == 'checked-indeterminate',
            'mdc-checkbox--anim-checked-unchecked': this.animationClass == 'checked-unchecked',
            'mdc-checkbox--anim-indeterminate-checked': this.animationClass == 'indeterminate-checked',
            'mdc-checkbox--anim-indeterminate-unchecked': this.animationClass == 'indeterminate-unchecked',
            'mdc-checkbox--anim-unchecked-checked': this.animationClass == 'unchecked-checked',
            'mdc-checkbox--anim-unchecked-indeterminate': this.animationClass == 'unchecked-indeterminate'
        };
        // tslint:enable:triple-equals
        /* eslint-enable eqeqeq */ const ariaChecked = this.indeterminate ? 'mixed' : undefined;
        return (0, $047536623440a31e$export$c0bb0b647f701bb5)`
      <div class="mdc-checkbox mdc-checkbox--upgraded ${(0, $2e43e920d0d5b738$export$56cc687933817664)(classes)}">
        <input type="checkbox"
              class="mdc-checkbox__native-control"
              name="${(0, $6e74b7d85b81502e$export$f68dd208b5df064d)(this.name)}"
              aria-checked="${(0, $6e74b7d85b81502e$export$f68dd208b5df064d)(ariaChecked)}"
              aria-label="${(0, $6e74b7d85b81502e$export$f68dd208b5df064d)(this.ariaLabel)}"
              aria-labelledby="${(0, $6e74b7d85b81502e$export$f68dd208b5df064d)(this.ariaLabelledBy)}"
              aria-describedby="${(0, $6e74b7d85b81502e$export$f68dd208b5df064d)(this.ariaDescribedBy)}"
              data-indeterminate="${this.indeterminate ? 'true' : 'false'}"
              ?disabled="${this.disabled}"
              .indeterminate="${this.indeterminate}"
              .checked="${this.checked}"
              .value="${this.value}"
              @change="${this.handleChange}"
              @focus="${this.handleFocus}"
              @blur="${this.handleBlur}"
              @mousedown="${this.handleRippleMouseDown}"
              @mouseenter="${this.handleRippleMouseEnter}"
              @mouseleave="${this.handleRippleMouseLeave}"
              @touchstart="${this.handleRippleTouchStart}"
              @touchend="${this.handleRippleDeactivate}"
              @touchcancel="${this.handleRippleDeactivate}">
        <div class="mdc-checkbox__background"
          @animationend="${this.resetAnimationClass}">
          <svg class="mdc-checkbox__checkmark"
              viewBox="0 0 24 24">
            <path class="mdc-checkbox__checkmark-path"
                  fill="none"
                  d="M1.73,12.91 8.1,19.28 22.79,4.59"></path>
          </svg>
          <div class="mdc-checkbox__mixedmark"></div>
        </div>
        ${this.renderRipple()}
      </div>`;
    }
    setFormData(formData) {
        if (this.name && this.checked) formData.append(this.name, this.value);
    }
    handleFocus() {
        this.focused = true;
        this.handleRippleFocus();
    }
    handleBlur() {
        this.focused = false;
        this.handleRippleBlur();
    }
    handleRippleMouseDown(event) {
        const onUp = ()=>{
            window.removeEventListener('mouseup', onUp);
            this.handleRippleDeactivate();
        };
        window.addEventListener('mouseup', onUp);
        this.rippleHandlers.startPress(event);
    }
    handleRippleTouchStart(event) {
        this.rippleHandlers.startPress(event);
    }
    handleRippleDeactivate() {
        this.rippleHandlers.endPress();
    }
    handleRippleMouseEnter() {
        this.rippleHandlers.startHover();
    }
    handleRippleMouseLeave() {
        this.rippleHandlers.endHover();
    }
    handleRippleFocus() {
        this.rippleHandlers.startFocus();
    }
    handleRippleBlur() {
        this.rippleHandlers.endFocus();
    }
    handleChange() {
        this.checked = this.formElement.checked;
        this.indeterminate = this.formElement.indeterminate;
    }
    resetAnimationClass() {
        this.animationClass = '';
    }
    get isRippleActive() {
        var _a;
        return ((_a = this.rippleElement) === null || _a === void 0 ? void 0 : _a.isActive) || false;
    }
}
(0, $czHfO.__decorate)([
    (0, $07620277c937646f$export$2fa187e846a241c4)('.mdc-checkbox')
], $6689181a08a2284c$export$f56e96de55837300.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $07620277c937646f$export$2fa187e846a241c4)('input')
], $6689181a08a2284c$export$f56e96de55837300.prototype, "formElement", void 0);
(0, $czHfO.__decorate)([
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "checked", void 0);
(0, $czHfO.__decorate)([
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: Boolean
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "indeterminate", void 0);
(0, $czHfO.__decorate)([
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "disabled", void 0);
(0, $czHfO.__decorate)([
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "name", void 0);
(0, $czHfO.__decorate)([
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: String
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "value", void 0);
(0, $czHfO.__decorate)([
    (0, $bAdyM.ariaProperty),
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: String,
        attribute: 'aria-label'
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "ariaLabel", void 0);
(0, $czHfO.__decorate)([
    (0, $bAdyM.ariaProperty),
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: String,
        attribute: 'aria-labelledby'
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "ariaLabelledBy", void 0);
(0, $czHfO.__decorate)([
    (0, $bAdyM.ariaProperty),
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: String,
        attribute: 'aria-describedby'
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "ariaDescribedBy", void 0);
(0, $czHfO.__decorate)([
    (0, $711a6ba61b027374$export$d541bacb2bda4494)({
        type: Boolean
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "reducedTouchTarget", void 0);
(0, $czHfO.__decorate)([
    (0, $06733b95f056f54c$export$ca000e230c0caa3e)()
], $6689181a08a2284c$export$f56e96de55837300.prototype, "animationClass", void 0);
(0, $czHfO.__decorate)([
    (0, $06733b95f056f54c$export$ca000e230c0caa3e)()
], $6689181a08a2284c$export$f56e96de55837300.prototype, "shouldRenderRipple", void 0);
(0, $czHfO.__decorate)([
    (0, $06733b95f056f54c$export$ca000e230c0caa3e)()
], $6689181a08a2284c$export$f56e96de55837300.prototype, "focused", void 0);
(0, $czHfO.__decorate)([
    (0, $271f0e86b456d810$export$163dfc35cc43f240)('mwc-ripple')
], $6689181a08a2284c$export$f56e96de55837300.prototype, "ripple", void 0);
(0, $czHfO.__decorate)([
    (0, $728358531ec72778$export$b2b799818fbabcf3)({
        passive: true
    })
], $6689181a08a2284c$export$f56e96de55837300.prototype, "handleRippleTouchStart", null);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $533aaedf23e79256$export$9dd6ff9ea0189349 = (0, $776fade94803d18f$export$dbf350e5966cf602)`.mdc-checkbox{padding:calc((40px - 18px) / 2);padding:calc((var(--mdc-checkbox-ripple-size, 40px) - 18px) / 2);margin:calc((40px - 40px) / 2);margin:calc((var(--mdc-checkbox-touch-target-size, 40px) - 40px) / 2)}.mdc-checkbox .mdc-checkbox__ripple::before,.mdc-checkbox .mdc-checkbox__ripple::after{background-color:#000;background-color:var(--mdc-ripple-color, #000)}.mdc-checkbox:hover .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-checkbox:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-checkbox:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-checkbox.mdc-checkbox--selected:hover .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-surface--hover .mdc-checkbox__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded--background-focused .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):focus .mdc-checkbox__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded) .mdc-checkbox__ripple::after{transition:opacity 150ms linear}.mdc-checkbox.mdc-checkbox--selected:not(.mdc-ripple-upgraded):active .mdc-checkbox__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-checkbox--selected.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::before,.mdc-checkbox.mdc-ripple-upgraded--background-focused.mdc-checkbox--selected .mdc-checkbox__ripple::after{background-color:#018786;background-color:var(--mdc-ripple-color, var(--mdc-theme-secondary, #018786))}.mdc-checkbox .mdc-checkbox__background{top:calc((40px - 18px) / 2);top:calc((var(--mdc-checkbox-ripple-size, 40px) - 18px) / 2);left:calc((40px - 18px) / 2);left:calc((var(--mdc-checkbox-ripple-size, 40px) - 18px) / 2)}.mdc-checkbox .mdc-checkbox__native-control{top:calc((40px - 40px) / 2);top:calc((40px - var(--mdc-checkbox-touch-target-size, 40px)) / 2);right:calc((40px - 40px) / 2);right:calc((40px - var(--mdc-checkbox-touch-target-size, 40px)) / 2);left:calc((40px - 40px) / 2);left:calc((40px - var(--mdc-checkbox-touch-target-size, 40px)) / 2);width:40px;width:var(--mdc-checkbox-touch-target-size, 40px);height:40px;height:var(--mdc-checkbox-touch-target-size, 40px)}.mdc-checkbox .mdc-checkbox__native-control:enabled:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled~.mdc-checkbox__background{border-color:#018786;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786))}@keyframes mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786{0%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}50%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786))}}@keyframes mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786{0%,80%{border-color:#018786;border-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786));background-color:#018786;background-color:var(--mdc-checkbox-checked-color, var(--mdc-theme-secondary, #018786))}100%{border-color:rgba(0, 0, 0, 0.54);border-color:var(--mdc-checkbox-unchecked-color, rgba(0, 0, 0, 0.54));background-color:transparent}}.mdc-checkbox.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-in-background-8A000000FF01878600000000FF018786}.mdc-checkbox.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__native-control:enabled~.mdc-checkbox__background{animation-name:mdc-checkbox-fade-out-background-8A000000FF01878600000000FF018786}.mdc-checkbox .mdc-checkbox__native-control[disabled]:not(:checked):not(:indeterminate):not([data-indeterminate=true])~.mdc-checkbox__background{border-color:rgba(0, 0, 0, 0.38);border-color:var(--mdc-checkbox-disabled-color, rgba(0, 0, 0, 0.38));background-color:transparent}.mdc-checkbox .mdc-checkbox__native-control[disabled]:checked~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[disabled]:indeterminate~.mdc-checkbox__background,.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true][disabled]~.mdc-checkbox__background{border-color:transparent;background-color:rgba(0, 0, 0, 0.38);background-color:var(--mdc-checkbox-disabled-color, rgba(0, 0, 0, 0.38))}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:#fff;color:var(--mdc-checkbox-ink-color, #fff)}.mdc-checkbox .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color, #fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__checkmark{color:#fff;color:var(--mdc-checkbox-ink-color, #fff)}.mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__mixedmark{border-color:#fff;border-color:var(--mdc-checkbox-ink-color, #fff)}.mdc-touch-target-wrapper{display:inline}@keyframes mdc-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:29.7833385}50%{animation-timing-function:cubic-bezier(0, 0, 0.2, 1)}100%{stroke-dashoffset:0}}@keyframes mdc-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0, 0, 0, 1)}100%{transform:scaleX(1)}}@keyframes mdc-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(0.4, 0, 1, 1);opacity:1;stroke-dashoffset:0}to{opacity:0;stroke-dashoffset:-29.7833385}}@keyframes mdc-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0, 0, 0.2, 1);transform:rotate(0deg);opacity:1}to{transform:rotate(45deg);opacity:0}}@keyframes mdc-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);transform:rotate(45deg);opacity:0}to{transform:rotate(360deg);opacity:1}}@keyframes mdc-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:mdc-animation-deceleration-curve-timing-function;transform:rotate(-45deg);opacity:0}to{transform:rotate(0deg);opacity:1}}@keyframes mdc-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);transform:rotate(0deg);opacity:1}to{transform:rotate(315deg);opacity:0}}@keyframes mdc-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;transform:scaleX(1);opacity:1}32.8%,100%{transform:scaleX(0);opacity:0}}.mdc-checkbox{display:inline-block;position:relative;flex:0 0 18px;box-sizing:content-box;width:18px;height:18px;line-height:0;white-space:nowrap;cursor:pointer;vertical-align:bottom}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring{pointer-events:none;border:2px solid transparent;border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}@media screen and (forced-colors: active){.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring{border-color:CanvasText}}.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring::after,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring::after{content:"";border:2px solid transparent;border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}@media screen and (forced-colors: active){.mdc-checkbox.mdc-ripple-upgraded--background-focused .mdc-checkbox__focus-ring::after,.mdc-checkbox:not(.mdc-ripple-upgraded):focus .mdc-checkbox__focus-ring::after{border-color:CanvasText}}@media all and (-ms-high-contrast: none){.mdc-checkbox .mdc-checkbox__focus-ring{display:none}}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-checkbox__mixedmark{margin:0 1px}}.mdc-checkbox--disabled{cursor:default;pointer-events:none}.mdc-checkbox__background{display:inline-flex;position:absolute;align-items:center;justify-content:center;box-sizing:border-box;width:18px;height:18px;border:2px solid currentColor;border-radius:2px;background-color:transparent;pointer-events:none;will-change:background-color,border-color;transition:background-color 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1),border-color 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox__checkmark{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;opacity:0;transition:opacity 180ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox--upgraded .mdc-checkbox__checkmark{opacity:1}.mdc-checkbox__checkmark-path{transition:stroke-dashoffset 180ms 0ms cubic-bezier(0.4, 0, 0.6, 1);stroke:currentColor;stroke-width:3.12px;stroke-dashoffset:29.7833385;stroke-dasharray:29.7833385}.mdc-checkbox__mixedmark{width:100%;height:0;transform:scaleX(0) rotate(0deg);border-width:1px;border-style:solid;opacity:0;transition:opacity 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1),transform 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__background,.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__background,.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__background,.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__background{animation-duration:180ms;animation-timing-function:linear}.mdc-checkbox--anim-unchecked-checked .mdc-checkbox__checkmark-path{animation:mdc-checkbox-unchecked-checked-checkmark-path 180ms linear 0s;transition:none}.mdc-checkbox--anim-unchecked-indeterminate .mdc-checkbox__mixedmark{animation:mdc-checkbox-unchecked-indeterminate-mixedmark 90ms linear 0s;transition:none}.mdc-checkbox--anim-checked-unchecked .mdc-checkbox__checkmark-path{animation:mdc-checkbox-checked-unchecked-checkmark-path 90ms linear 0s;transition:none}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__checkmark{animation:mdc-checkbox-checked-indeterminate-checkmark 90ms linear 0s;transition:none}.mdc-checkbox--anim-checked-indeterminate .mdc-checkbox__mixedmark{animation:mdc-checkbox-checked-indeterminate-mixedmark 90ms linear 0s;transition:none}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__checkmark{animation:mdc-checkbox-indeterminate-checked-checkmark 500ms linear 0s;transition:none}.mdc-checkbox--anim-indeterminate-checked .mdc-checkbox__mixedmark{animation:mdc-checkbox-indeterminate-checked-mixedmark 500ms linear 0s;transition:none}.mdc-checkbox--anim-indeterminate-unchecked .mdc-checkbox__mixedmark{animation:mdc-checkbox-indeterminate-unchecked-mixedmark 300ms linear 0s;transition:none}.mdc-checkbox__native-control:checked~.mdc-checkbox__background,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background{transition:border-color 90ms 0ms cubic-bezier(0, 0, 0.2, 1),background-color 90ms 0ms cubic-bezier(0, 0, 0.2, 1)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark-path,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark-path{stroke-dashoffset:0}.mdc-checkbox__native-control{position:absolute;margin:0;padding:0;opacity:0;cursor:inherit}.mdc-checkbox__native-control:disabled{cursor:default;pointer-events:none}.mdc-checkbox--touch{margin:calc((48px - 40px) / 2);margin:calc((var(--mdc-checkbox-state-layer-size, 48px) - var(--mdc-checkbox-state-layer-size, 40px)) / 2)}.mdc-checkbox--touch .mdc-checkbox__native-control{top:calc((40px - 48px) / 2);top:calc((var(--mdc-checkbox-state-layer-size, 40px) - var(--mdc-checkbox-state-layer-size, 48px)) / 2);right:calc((40px - 48px) / 2);right:calc((var(--mdc-checkbox-state-layer-size, 40px) - var(--mdc-checkbox-state-layer-size, 48px)) / 2);left:calc((40px - 48px) / 2);left:calc((var(--mdc-checkbox-state-layer-size, 40px) - var(--mdc-checkbox-state-layer-size, 48px)) / 2);width:48px;width:var(--mdc-checkbox-state-layer-size, 48px);height:48px;height:var(--mdc-checkbox-state-layer-size, 48px)}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__checkmark{transition:opacity 180ms 0ms cubic-bezier(0, 0, 0.2, 1),transform 180ms 0ms cubic-bezier(0, 0, 0.2, 1);opacity:1}.mdc-checkbox__native-control:checked~.mdc-checkbox__background .mdc-checkbox__mixedmark{transform:scaleX(1) rotate(-45deg)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__checkmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__checkmark{transform:rotate(45deg);opacity:0;transition:opacity 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1),transform 90ms 0ms cubic-bezier(0.4, 0, 0.6, 1)}.mdc-checkbox__native-control:indeterminate~.mdc-checkbox__background .mdc-checkbox__mixedmark,.mdc-checkbox__native-control[data-indeterminate=true]~.mdc-checkbox__background .mdc-checkbox__mixedmark{transform:scaleX(1) rotate(0deg);opacity:1}.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__background,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__checkmark-path,.mdc-checkbox.mdc-checkbox--upgraded .mdc-checkbox__mixedmark{transition:none}:host{outline:none;display:inline-flex;-webkit-tap-highlight-color:transparent}:host([checked]),:host([indeterminate]){--mdc-ripple-color:var(--mdc-theme-secondary, #018786)}.mdc-checkbox .mdc-checkbox__background::before{content:none}`;


/** @soyCompatible */ let $a2c303365afc0427$export$48513f6b9f8ce62d = class Checkbox extends (0, $6689181a08a2284c$export$f56e96de55837300) {
};
$a2c303365afc0427$export$48513f6b9f8ce62d.styles = [
    (0, $533aaedf23e79256$export$9dd6ff9ea0189349)
];
$a2c303365afc0427$export$48513f6b9f8ce62d = (0, $czHfO.__decorate)([
    (0, $8c2bd622e304dd44$export$da64fc29f17f9d0e)('mwc-checkbox')
], $a2c303365afc0427$export$48513f6b9f8ce62d);


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $1adc8f2244430e9a$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9c58ef87857528af$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $9c58ef87857528af$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $9c58ef87857528af$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $9c58ef87857528af$var$e(n, t, o) : $9c58ef87857528af$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e61a8bcd4caf0daa$export$ca000e230c0caa3e(t) {
    return (0, $9c58ef87857528af$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f259edeef29dbca8$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $f259edeef29dbca8$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $f259edeef29dbca8$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e428adea1d1236f7$export$b2b799818fbabcf3(e) {
    return (0, $f259edeef29dbca8$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $980f73c1e242e863$export$2fa187e846a241c4(i, n) {
    return (0, $f259edeef29dbca8$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $3d8fcbcce237f03b$export$dcd0d083aa86c355(e) {
    return (0, $f259edeef29dbca8$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1e3657ee591dd94a$export$163dfc35cc43f240(e) {
    return (0, $f259edeef29dbca8$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $c66c7edf1173b4f5$var$n;
const $c66c7edf1173b4f5$var$e = null != (null === ($c66c7edf1173b4f5$var$n = window.HTMLSlotElement) || void 0 === $c66c7edf1173b4f5$var$n ? void 0 : $c66c7edf1173b4f5$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $c66c7edf1173b4f5$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $f259edeef29dbca8$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $c66c7edf1173b4f5$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $b50e36ec7102c76d$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $c66c7edf1173b4f5$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $f259edeef29dbca8$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $b7779d110a00a906$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$b7779d110a00a906$export$2e2bcd8739ae039 = $b7779d110a00a906$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $78861d376324a9fc$export$c1c0562ec8379000 = {
    ROOT: 'mdc-form-field'
};
var $78861d376324a9fc$export$21c51bc433c16634 = {
    LABEL_SELECTOR: '.mdc-form-field > label'
};


var $ce1a496931e17fa4$export$8fa447b14b16afbc = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCFormFieldFoundation, _super);
    function MDCFormFieldFoundation(adapter) {
        var _this = _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCFormFieldFoundation.defaultAdapter), adapter)) || this;
        _this.click = function() {
            _this.handleClick();
        };
        return _this;
    }
    Object.defineProperty(MDCFormFieldFoundation, "cssClasses", {
        get: function() {
            return 0, $78861d376324a9fc$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFormFieldFoundation, "strings", {
        get: function() {
            return 0, $78861d376324a9fc$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFormFieldFoundation, "defaultAdapter", {
        get: function() {
            return {
                activateInputRipple: function() {
                    return undefined;
                },
                deactivateInputRipple: function() {
                    return undefined;
                },
                deregisterInteractionHandler: function() {
                    return undefined;
                },
                registerInteractionHandler: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCFormFieldFoundation.prototype.init = function() {
        this.adapter.registerInteractionHandler('click', this.click);
    };
    MDCFormFieldFoundation.prototype.destroy = function() {
        this.adapter.deregisterInteractionHandler('click', this.click);
    };
    MDCFormFieldFoundation.prototype.handleClick = function() {
        var _this = this;
        this.adapter.activateInputRipple();
        requestAnimationFrame(function() {
            _this.adapter.deactivateInputRipple();
        });
    };
    return MDCFormFieldFoundation;
}((0, $b7779d110a00a906$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$ce1a496931e17fa4$export$2e2bcd8739ae039 = $ce1a496931e17fa4$export$8fa447b14b16afbc;



var $4ifWP = parcelRequire("4ifWP");

var $cMU8m = parcelRequire("cMU8m");

var $k4Ngf = parcelRequire("k4Ngf");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9fa673f93e520cc9$var$t = window, $9fa673f93e520cc9$export$b4d10f6001c083c2 = $9fa673f93e520cc9$var$t.ShadowRoot && (void 0 === $9fa673f93e520cc9$var$t.ShadyCSS || $9fa673f93e520cc9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $9fa673f93e520cc9$var$s = Symbol(), $9fa673f93e520cc9$var$n = new WeakMap;
class $9fa673f93e520cc9$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $9fa673f93e520cc9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($9fa673f93e520cc9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $9fa673f93e520cc9$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $9fa673f93e520cc9$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $9fa673f93e520cc9$export$8d80f9cac07cdb3 = (t)=>new $9fa673f93e520cc9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $9fa673f93e520cc9$var$s), $9fa673f93e520cc9$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $9fa673f93e520cc9$export$505d1e8739bad805(n, t, $9fa673f93e520cc9$var$s);
}, $9fa673f93e520cc9$export$2ca4a66ec4cecb90 = (s, n)=>{
    $9fa673f93e520cc9$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $9fa673f93e520cc9$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $9fa673f93e520cc9$export$ee69dfd951e24778 = $9fa673f93e520cc9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $9fa673f93e520cc9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $9a68991e136661f3$var$s;
const $9a68991e136661f3$var$e = window, $9a68991e136661f3$var$r = $9a68991e136661f3$var$e.trustedTypes, $9a68991e136661f3$var$h = $9a68991e136661f3$var$r ? $9a68991e136661f3$var$r.emptyScript : "", $9a68991e136661f3$var$o = $9a68991e136661f3$var$e.reactiveElementPolyfillSupport, $9a68991e136661f3$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $9a68991e136661f3$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $9a68991e136661f3$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $9a68991e136661f3$var$l = {
    attribute: !0,
    type: String,
    converter: $9a68991e136661f3$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $9a68991e136661f3$export$53a6892c50694894
}, $9a68991e136661f3$var$d = "finalized";
class $9a68991e136661f3$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $9a68991e136661f3$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $9a68991e136661f3$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($9a68991e136661f3$var$d)) return !1;
        this[$9a68991e136661f3$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $9fa673f93e520cc9$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $9fa673f93e520cc9$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $9fa673f93e520cc9$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $9a68991e136661f3$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $9a68991e136661f3$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $9a68991e136661f3$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $9a68991e136661f3$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$9a68991e136661f3$export$c7c07a37856565d[$9a68991e136661f3$var$d] = !0, $9a68991e136661f3$export$c7c07a37856565d.elementProperties = new Map, $9a68991e136661f3$export$c7c07a37856565d.elementStyles = [], $9a68991e136661f3$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $9a68991e136661f3$var$o || $9a68991e136661f3$var$o({
    ReactiveElement: $9a68991e136661f3$export$c7c07a37856565d
}), (null !== ($9a68991e136661f3$var$s = $9a68991e136661f3$var$e.reactiveElementVersions) && void 0 !== $9a68991e136661f3$var$s ? $9a68991e136661f3$var$s : $9a68991e136661f3$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $81bc5ae5727dfca3$var$t;
const $81bc5ae5727dfca3$var$i = window, $81bc5ae5727dfca3$var$s = $81bc5ae5727dfca3$var$i.trustedTypes, $81bc5ae5727dfca3$var$e = $81bc5ae5727dfca3$var$s ? $81bc5ae5727dfca3$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $81bc5ae5727dfca3$var$o = "$lit$", $81bc5ae5727dfca3$var$n = `lit$${(Math.random() + "").slice(9)}$`, $81bc5ae5727dfca3$var$l = "?" + $81bc5ae5727dfca3$var$n, $81bc5ae5727dfca3$var$h = `<${$81bc5ae5727dfca3$var$l}>`, $81bc5ae5727dfca3$var$r = document, $81bc5ae5727dfca3$var$u = ()=>$81bc5ae5727dfca3$var$r.createComment(""), $81bc5ae5727dfca3$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $81bc5ae5727dfca3$var$c = Array.isArray, $81bc5ae5727dfca3$var$v = (t)=>$81bc5ae5727dfca3$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $81bc5ae5727dfca3$var$a = "[ \t\n\f\r]", $81bc5ae5727dfca3$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $81bc5ae5727dfca3$var$_ = /-->/g, $81bc5ae5727dfca3$var$m = />/g, $81bc5ae5727dfca3$var$p = RegExp(`>|${$81bc5ae5727dfca3$var$a}(?:([^\\s"'>=/]+)(${$81bc5ae5727dfca3$var$a}*=${$81bc5ae5727dfca3$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $81bc5ae5727dfca3$var$g = /'/g, $81bc5ae5727dfca3$var$$ = /"/g, $81bc5ae5727dfca3$var$y = /^(?:script|style|textarea|title)$/i, $81bc5ae5727dfca3$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $81bc5ae5727dfca3$export$c0bb0b647f701bb5 = $81bc5ae5727dfca3$var$w(1), $81bc5ae5727dfca3$export$7ed1367e7fa1ad68 = $81bc5ae5727dfca3$var$w(2), $81bc5ae5727dfca3$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $81bc5ae5727dfca3$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $81bc5ae5727dfca3$var$E = new WeakMap, $81bc5ae5727dfca3$var$C = $81bc5ae5727dfca3$var$r.createTreeWalker($81bc5ae5727dfca3$var$r, 129, null, !1);
function $81bc5ae5727dfca3$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $81bc5ae5727dfca3$var$e ? $81bc5ae5727dfca3$var$e.createHTML(i) : i;
}
const $81bc5ae5727dfca3$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $81bc5ae5727dfca3$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $81bc5ae5727dfca3$var$f ? "!--" === c[1] ? u = $81bc5ae5727dfca3$var$_ : void 0 !== c[1] ? u = $81bc5ae5727dfca3$var$m : void 0 !== c[2] ? ($81bc5ae5727dfca3$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $81bc5ae5727dfca3$var$p) : void 0 !== c[3] && (u = $81bc5ae5727dfca3$var$p) : u === $81bc5ae5727dfca3$var$p ? ">" === c[0] ? (u = null != l ? l : $81bc5ae5727dfca3$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $81bc5ae5727dfca3$var$p : '"' === c[3] ? $81bc5ae5727dfca3$var$$ : $81bc5ae5727dfca3$var$g) : u === $81bc5ae5727dfca3$var$$ || u === $81bc5ae5727dfca3$var$g ? u = $81bc5ae5727dfca3$var$p : u === $81bc5ae5727dfca3$var$_ || u === $81bc5ae5727dfca3$var$m ? u = $81bc5ae5727dfca3$var$f : (u = $81bc5ae5727dfca3$var$p, l = void 0);
        const w = u === $81bc5ae5727dfca3$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $81bc5ae5727dfca3$var$f ? s + $81bc5ae5727dfca3$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $81bc5ae5727dfca3$var$o + s.slice(v) + $81bc5ae5727dfca3$var$n + w) : s + $81bc5ae5727dfca3$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $81bc5ae5727dfca3$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $81bc5ae5727dfca3$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $81bc5ae5727dfca3$var$V(t, i);
        if (this.el = $81bc5ae5727dfca3$var$N.createElement(a, e), $81bc5ae5727dfca3$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $81bc5ae5727dfca3$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($81bc5ae5727dfca3$var$o) || i.startsWith($81bc5ae5727dfca3$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $81bc5ae5727dfca3$var$o).split($81bc5ae5727dfca3$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $81bc5ae5727dfca3$var$H : "?" === i[1] ? $81bc5ae5727dfca3$var$L : "@" === i[1] ? $81bc5ae5727dfca3$var$z : $81bc5ae5727dfca3$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($81bc5ae5727dfca3$var$y.test(h.tagName)) {
                    const t = h.textContent.split($81bc5ae5727dfca3$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $81bc5ae5727dfca3$var$s ? $81bc5ae5727dfca3$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $81bc5ae5727dfca3$var$u()), $81bc5ae5727dfca3$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $81bc5ae5727dfca3$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $81bc5ae5727dfca3$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($81bc5ae5727dfca3$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $81bc5ae5727dfca3$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $81bc5ae5727dfca3$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $81bc5ae5727dfca3$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $81bc5ae5727dfca3$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $81bc5ae5727dfca3$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $81bc5ae5727dfca3$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $81bc5ae5727dfca3$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $81bc5ae5727dfca3$var$r).importNode(s, !0);
        $81bc5ae5727dfca3$var$C.currentNode = o;
        let n = $81bc5ae5727dfca3$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $81bc5ae5727dfca3$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $81bc5ae5727dfca3$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $81bc5ae5727dfca3$var$C.nextNode(), l++);
        }
        return $81bc5ae5727dfca3$var$C.currentNode = $81bc5ae5727dfca3$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $81bc5ae5727dfca3$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $81bc5ae5727dfca3$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $81bc5ae5727dfca3$var$S(this, t, i), $81bc5ae5727dfca3$var$d(t) ? t === $81bc5ae5727dfca3$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $81bc5ae5727dfca3$export$45b790e32b2810ee && this._$AR(), this._$AH = $81bc5ae5727dfca3$export$45b790e32b2810ee) : t !== this._$AH && t !== $81bc5ae5727dfca3$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $81bc5ae5727dfca3$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $81bc5ae5727dfca3$export$45b790e32b2810ee && $81bc5ae5727dfca3$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($81bc5ae5727dfca3$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $81bc5ae5727dfca3$var$N.createElement($81bc5ae5727dfca3$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $81bc5ae5727dfca3$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $81bc5ae5727dfca3$var$E.get(t.strings);
        return void 0 === i && $81bc5ae5727dfca3$var$E.set(t.strings, i = new $81bc5ae5727dfca3$var$N(t)), i;
    }
    T(t) {
        $81bc5ae5727dfca3$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $81bc5ae5727dfca3$var$R(this.k($81bc5ae5727dfca3$var$u()), this.k($81bc5ae5727dfca3$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $81bc5ae5727dfca3$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $81bc5ae5727dfca3$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $81bc5ae5727dfca3$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $81bc5ae5727dfca3$var$S(this, t, i, 0), n = !$81bc5ae5727dfca3$var$d(t) || t !== this._$AH && t !== $81bc5ae5727dfca3$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $81bc5ae5727dfca3$var$S(this, e[s + l], i, l), h === $81bc5ae5727dfca3$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$81bc5ae5727dfca3$var$d(h) || h !== this._$AH[l]), h === $81bc5ae5727dfca3$export$45b790e32b2810ee ? t = $81bc5ae5727dfca3$export$45b790e32b2810ee : t !== $81bc5ae5727dfca3$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $81bc5ae5727dfca3$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $81bc5ae5727dfca3$var$H extends $81bc5ae5727dfca3$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $81bc5ae5727dfca3$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $81bc5ae5727dfca3$var$I = $81bc5ae5727dfca3$var$s ? $81bc5ae5727dfca3$var$s.emptyScript : "";
class $81bc5ae5727dfca3$var$L extends $81bc5ae5727dfca3$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $81bc5ae5727dfca3$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $81bc5ae5727dfca3$var$I) : this.element.removeAttribute(this.name);
    }
}
class $81bc5ae5727dfca3$var$z extends $81bc5ae5727dfca3$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $81bc5ae5727dfca3$var$S(this, t, i, 0)) && void 0 !== s ? s : $81bc5ae5727dfca3$export$45b790e32b2810ee) === $81bc5ae5727dfca3$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $81bc5ae5727dfca3$export$45b790e32b2810ee && e !== $81bc5ae5727dfca3$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $81bc5ae5727dfca3$export$45b790e32b2810ee && (e === $81bc5ae5727dfca3$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $81bc5ae5727dfca3$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $81bc5ae5727dfca3$var$S(this, t);
    }
}
const $81bc5ae5727dfca3$export$8613d1ca9052b22e = {
    O: $81bc5ae5727dfca3$var$o,
    P: $81bc5ae5727dfca3$var$n,
    A: $81bc5ae5727dfca3$var$l,
    C: 1,
    M: $81bc5ae5727dfca3$var$V,
    L: $81bc5ae5727dfca3$var$M,
    R: $81bc5ae5727dfca3$var$v,
    D: $81bc5ae5727dfca3$var$S,
    I: $81bc5ae5727dfca3$var$R,
    V: $81bc5ae5727dfca3$var$k,
    H: $81bc5ae5727dfca3$var$L,
    N: $81bc5ae5727dfca3$var$z,
    U: $81bc5ae5727dfca3$var$H,
    F: $81bc5ae5727dfca3$var$Z
}, $81bc5ae5727dfca3$var$B = $81bc5ae5727dfca3$var$i.litHtmlPolyfillSupport;
null == $81bc5ae5727dfca3$var$B || $81bc5ae5727dfca3$var$B($81bc5ae5727dfca3$var$N, $81bc5ae5727dfca3$var$R), (null !== ($81bc5ae5727dfca3$var$t = $81bc5ae5727dfca3$var$i.litHtmlVersions) && void 0 !== $81bc5ae5727dfca3$var$t ? $81bc5ae5727dfca3$var$t : $81bc5ae5727dfca3$var$i.litHtmlVersions = []).push("2.8.0");
const $81bc5ae5727dfca3$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $81bc5ae5727dfca3$var$R(i.insertBefore($81bc5ae5727dfca3$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $a707c501e04b880f$var$l, $a707c501e04b880f$var$o;
const $a707c501e04b880f$export$8bf27daf9e8907c9 = (0, $9a68991e136661f3$export$c7c07a37856565d);
class $a707c501e04b880f$export$3f2f9f5909897157 extends (0, $9a68991e136661f3$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $81bc5ae5727dfca3$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $81bc5ae5727dfca3$export$9c068ae9cc5db4e8;
    }
}
$a707c501e04b880f$export$3f2f9f5909897157.finalized = !0, $a707c501e04b880f$export$3f2f9f5909897157._$litElement$ = !0, null === ($a707c501e04b880f$var$l = globalThis.litElementHydrateSupport) || void 0 === $a707c501e04b880f$var$l || $a707c501e04b880f$var$l.call(globalThis, {
    LitElement: $a707c501e04b880f$export$3f2f9f5909897157
});
const $a707c501e04b880f$var$n = globalThis.litElementPolyfillSupport;
null == $a707c501e04b880f$var$n || $a707c501e04b880f$var$n({
    LitElement: $a707c501e04b880f$export$3f2f9f5909897157
});
const $a707c501e04b880f$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($a707c501e04b880f$var$o = globalThis.litElementVersions) && void 0 !== $a707c501e04b880f$var$o ? $a707c501e04b880f$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5f49d42b693e3075$export$6acf61af03e62db = !1;






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $367052feb070caa9$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $367052feb070caa9$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $367052feb070caa9$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d2c9fd5aacf166a8$export$56cc687933817664 = (0, $367052feb070caa9$export$99b43ad1ed32e735)(class extends (0, $367052feb070caa9$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $367052feb070caa9$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $81bc5ae5727dfca3$export$9c068ae9cc5db4e8;
    }
});




class $6bf450e5ffb4bb7b$export$488c57c7e30ce194 extends (0, $4ifWP.BaseElement) {
    constructor(){
        super(...arguments);
        this.alignEnd = false;
        this.spaceBetween = false;
        this.nowrap = false;
        this.label = '';
        this.mdcFoundationClass = (0, $ce1a496931e17fa4$export$2e2bcd8739ae039);
    }
    createAdapter() {
        return {
            registerInteractionHandler: (type, handler)=>{
                this.labelEl.addEventListener(type, handler);
            },
            deregisterInteractionHandler: (type, handler)=>{
                this.labelEl.removeEventListener(type, handler);
            },
            activateInputRipple: async ()=>{
                const input = this.input;
                if (input instanceof (0, $cMU8m.FormElement)) {
                    const ripple = await input.ripple;
                    if (ripple) ripple.startPress();
                }
            },
            deactivateInputRipple: async ()=>{
                const input = this.input;
                if (input instanceof (0, $cMU8m.FormElement)) {
                    const ripple = await input.ripple;
                    if (ripple) ripple.endPress();
                }
            }
        };
    }
    get input() {
        var _a, _b;
        return (_b = (_a = this.slottedInputs) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
    }
    render() {
        const classes = {
            'mdc-form-field--align-end': this.alignEnd,
            'mdc-form-field--space-between': this.spaceBetween,
            'mdc-form-field--nowrap': this.nowrap
        };
        return (0, $81bc5ae5727dfca3$export$c0bb0b647f701bb5)`
      <div class="mdc-form-field ${(0, $d2c9fd5aacf166a8$export$56cc687933817664)(classes)}">
        <slot></slot>
        <label class="mdc-label"
               @click="${this._labelClick}">${this.label}</label>
      </div>`;
    }
    click() {
        this._labelClick();
    }
    _labelClick() {
        const input = this.input;
        if (input) {
            input.focus();
            input.click();
        }
    }
}
(0, $czHfO.__decorate)([
    (0, $9c58ef87857528af$export$d541bacb2bda4494)({
        type: Boolean
    })
], $6bf450e5ffb4bb7b$export$488c57c7e30ce194.prototype, "alignEnd", void 0);
(0, $czHfO.__decorate)([
    (0, $9c58ef87857528af$export$d541bacb2bda4494)({
        type: Boolean
    })
], $6bf450e5ffb4bb7b$export$488c57c7e30ce194.prototype, "spaceBetween", void 0);
(0, $czHfO.__decorate)([
    (0, $9c58ef87857528af$export$d541bacb2bda4494)({
        type: Boolean
    })
], $6bf450e5ffb4bb7b$export$488c57c7e30ce194.prototype, "nowrap", void 0);
(0, $czHfO.__decorate)([
    (0, $9c58ef87857528af$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $k4Ngf.observer)(async function(label) {
        var _a;
        (_a = this.input) === null || _a === void 0 || _a.setAttribute('aria-label', label);
    })
], $6bf450e5ffb4bb7b$export$488c57c7e30ce194.prototype, "label", void 0);
(0, $czHfO.__decorate)([
    (0, $980f73c1e242e863$export$2fa187e846a241c4)('.mdc-form-field')
], $6bf450e5ffb4bb7b$export$488c57c7e30ce194.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $b50e36ec7102c76d$export$1bdbe53f9df1b8)('', true, '*')
], $6bf450e5ffb4bb7b$export$488c57c7e30ce194.prototype, "slottedInputs", void 0);
(0, $czHfO.__decorate)([
    (0, $980f73c1e242e863$export$2fa187e846a241c4)('label')
], $6bf450e5ffb4bb7b$export$488c57c7e30ce194.prototype, "labelEl", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $afa75048a8f83ae2$export$9dd6ff9ea0189349 = (0, $9fa673f93e520cc9$export$dbf350e5966cf602)`.mdc-form-field{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);color:rgba(0, 0, 0, 0.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87));display:inline-flex;align-items:center;vertical-align:middle}.mdc-form-field>label{margin-left:0;margin-right:auto;padding-left:4px;padding-right:0;order:0}[dir=rtl] .mdc-form-field>label,.mdc-form-field>label[dir=rtl]{margin-left:auto;margin-right:0}[dir=rtl] .mdc-form-field>label,.mdc-form-field>label[dir=rtl]{padding-left:0;padding-right:4px}.mdc-form-field--nowrap>label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.mdc-form-field--align-end>label{margin-left:auto;margin-right:0;padding-left:0;padding-right:4px;order:-1}[dir=rtl] .mdc-form-field--align-end>label,.mdc-form-field--align-end>label[dir=rtl]{margin-left:0;margin-right:auto}[dir=rtl] .mdc-form-field--align-end>label,.mdc-form-field--align-end>label[dir=rtl]{padding-left:4px;padding-right:0}.mdc-form-field--space-between{justify-content:space-between}.mdc-form-field--space-between>label{margin:0}[dir=rtl] .mdc-form-field--space-between>label,.mdc-form-field--space-between>label[dir=rtl]{margin:0}:host{display:inline-flex}.mdc-form-field{width:100%}::slotted(*){-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);color:rgba(0, 0, 0, 0.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87))}::slotted(mwc-switch){margin-right:10px}[dir=rtl] ::slotted(mwc-switch),::slotted(mwc-switch[dir=rtl]){margin-left:10px}`;


let $520b4d8dfbad4b29$export$f3f6c8e2b6fe00eb = class Formfield extends (0, $6bf450e5ffb4bb7b$export$488c57c7e30ce194) {
};
$520b4d8dfbad4b29$export$f3f6c8e2b6fe00eb.styles = [
    (0, $afa75048a8f83ae2$export$9dd6ff9ea0189349)
];
$520b4d8dfbad4b29$export$f3f6c8e2b6fe00eb = (0, $czHfO.__decorate)([
    (0, $1adc8f2244430e9a$export$da64fc29f17f9d0e)('mwc-formfield')
], $520b4d8dfbad4b29$export$f3f6c8e2b6fe00eb);


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $aad64538e1539f1f$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b3ad0a5fe35f4222$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $b3ad0a5fe35f4222$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $b3ad0a5fe35f4222$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $b3ad0a5fe35f4222$var$e(n, t, o) : $b3ad0a5fe35f4222$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $4d08594497802f3b$export$ca000e230c0caa3e(t) {
    return (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5c625651071b5c74$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $5c625651071b5c74$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $5c625651071b5c74$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $052c0635f6066c9f$export$b2b799818fbabcf3(e) {
    return (0, $5c625651071b5c74$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ae0690fab2767131$export$2fa187e846a241c4(i, n) {
    return (0, $5c625651071b5c74$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $346576d76cc0411f$export$dcd0d083aa86c355(e) {
    return (0, $5c625651071b5c74$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $79258afd9aeee9f3$export$163dfc35cc43f240(e) {
    return (0, $5c625651071b5c74$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $3d08fd18c8c33ea8$var$n;
const $3d08fd18c8c33ea8$var$e = null != (null === ($3d08fd18c8c33ea8$var$n = window.HTMLSlotElement) || void 0 === $3d08fd18c8c33ea8$var$n ? void 0 : $3d08fd18c8c33ea8$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $3d08fd18c8c33ea8$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $5c625651071b5c74$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $3d08fd18c8c33ea8$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $15644790a144096c$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $3d08fd18c8c33ea8$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $5c625651071b5c74$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (()=>{
    var _a, _b, _c;
    /* Symbols for private properties */ const _blockingElements = Symbol();
    const _alreadyInertElements = Symbol();
    const _topElParents = Symbol();
    const _siblingsToRestore = Symbol();
    const _parentMO = Symbol();
    /* Symbols for private static methods */ const _topChanged = Symbol();
    const _swapInertedSibling = Symbol();
    const _inertSiblings = Symbol();
    const _restoreInertedSiblings = Symbol();
    const _getParents = Symbol();
    const _getDistributedChildren = Symbol();
    const _isInertable = Symbol();
    const _handleMutations = Symbol();
    class BlockingElementsImpl {
        constructor(){
            /**
             * The blocking elements.
             */ this[_a] = [];
            /**
             * Used to keep track of the parents of the top element, from the element
             * itself up to body. When top changes, the old top might have been removed
             * from the document, so we need to memoize the inerted parents' siblings
             * in order to restore their inerteness when top changes.
             */ this[_b] = [];
            /**
             * Elements that are already inert before the first blocking element is
             * pushed.
             */ this[_c] = new Set();
        }
        destructor() {
            // Restore original inertness.
            this[_restoreInertedSiblings](this[_topElParents]);
            // Note we don't want to make these properties nullable on the class,
            // since then we'd need non-null casts in many places. Calling a method on
            // a BlockingElements instance after calling destructor will result in an
            // exception.
            const nullable = this;
            nullable[_blockingElements] = null;
            nullable[_topElParents] = null;
            nullable[_alreadyInertElements] = null;
        }
        get top() {
            const elems = this[_blockingElements];
            return elems[elems.length - 1] || null;
        }
        push(element) {
            if (!element || element === this.top) return;
            // Remove it from the stack, we'll bring it to the top.
            this.remove(element);
            this[_topChanged](element);
            this[_blockingElements].push(element);
        }
        remove(element) {
            const i = this[_blockingElements].indexOf(element);
            if (i === -1) return false;
            this[_blockingElements].splice(i, 1);
            // Top changed only if the removed element was the top element.
            if (i === this[_blockingElements].length) this[_topChanged](this.top);
            return true;
        }
        pop() {
            const top = this.top;
            top && this.remove(top);
            return top;
        }
        has(element) {
            return this[_blockingElements].indexOf(element) !== -1;
        }
        /**
         * Sets `inert` to all document elements except the new top element, its
         * parents, and its distributed content.
         */ [(_a = _blockingElements, _b = _topElParents, _c = _alreadyInertElements, _topChanged)](newTop) {
            const toKeepInert = this[_alreadyInertElements];
            const oldParents = this[_topElParents];
            // No new top, reset old top if any.
            if (!newTop) {
                this[_restoreInertedSiblings](oldParents);
                toKeepInert.clear();
                this[_topElParents] = [];
                return;
            }
            const newParents = this[_getParents](newTop);
            // New top is not contained in the main document!
            if (newParents[newParents.length - 1].parentNode !== document.body) throw Error('Non-connected element cannot be a blocking element');
            // Cast here because we know we'll call _inertSiblings on newParents
            // below.
            this[_topElParents] = newParents;
            const toSkip = this[_getDistributedChildren](newTop);
            // No previous top element.
            if (!oldParents.length) {
                this[_inertSiblings](newParents, toSkip, toKeepInert);
                return;
            }
            let i = oldParents.length - 1;
            let j = newParents.length - 1;
            // Find common parent. Index 0 is the element itself (so stop before it).
            while(i > 0 && j > 0 && oldParents[i] === newParents[j]){
                i--;
                j--;
            }
            // If up the parents tree there are 2 elements that are siblings, swap
            // the inerted sibling.
            if (oldParents[i] !== newParents[j]) this[_swapInertedSibling](oldParents[i], newParents[j]);
            // Restore old parents siblings inertness.
            i > 0 && this[_restoreInertedSiblings](oldParents.slice(0, i));
            // Make new parents siblings inert.
            j > 0 && this[_inertSiblings](newParents.slice(0, j), toSkip, null);
        }
        /**
         * Swaps inertness between two sibling elements.
         * Sets the property `inert` over the attribute since the inert spec
         * doesn't specify if it should be reflected.
         * https://html.spec.whatwg.org/multipage/interaction.html#inert
         */ [_swapInertedSibling](oldInert, newInert) {
            const siblingsToRestore = oldInert[_siblingsToRestore];
            // oldInert is not contained in siblings to restore, so we have to check
            // if it's inertable and if already inert.
            if (this[_isInertable](oldInert) && !oldInert.inert) {
                oldInert.inert = true;
                siblingsToRestore.add(oldInert);
            }
            // If newInert was already between the siblings to restore, it means it is
            // inertable and must be restored.
            if (siblingsToRestore.has(newInert)) {
                newInert.inert = false;
                siblingsToRestore.delete(newInert);
            }
            newInert[_parentMO] = oldInert[_parentMO];
            newInert[_siblingsToRestore] = siblingsToRestore;
            oldInert[_parentMO] = undefined;
            oldInert[_siblingsToRestore] = undefined;
        }
        /**
         * Restores original inertness to the siblings of the elements.
         * Sets the property `inert` over the attribute since the inert spec
         * doesn't specify if it should be reflected.
         * https://html.spec.whatwg.org/multipage/interaction.html#inert
         */ [_restoreInertedSiblings](elements) {
            for (const element of elements){
                const mo = element[_parentMO];
                mo.disconnect();
                element[_parentMO] = undefined;
                const siblings = element[_siblingsToRestore];
                for (const sibling of siblings)sibling.inert = false;
                element[_siblingsToRestore] = undefined;
            }
        }
        /**
         * Inerts the siblings of the elements except the elements to skip. Stores
         * the inerted siblings into the element's symbol `_siblingsToRestore`.
         * Pass `toKeepInert` to collect the already inert elements.
         * Sets the property `inert` over the attribute since the inert spec
         * doesn't specify if it should be reflected.
         * https://html.spec.whatwg.org/multipage/interaction.html#inert
         */ [_inertSiblings](elements, toSkip, toKeepInert) {
            for (const element of elements){
                // Assume element is not a Document, so it must have a parentNode.
                const parent = element.parentNode;
                const children = parent.children;
                const inertedSiblings = new Set();
                for(let j = 0; j < children.length; j++){
                    const sibling = children[j];
                    // Skip the input element, if not inertable or to be skipped.
                    if (sibling === element || !this[_isInertable](sibling) || toSkip && toSkip.has(sibling)) continue;
                    // Should be collected since already inerted.
                    if (toKeepInert && sibling.inert) toKeepInert.add(sibling);
                    else {
                        sibling.inert = true;
                        inertedSiblings.add(sibling);
                    }
                }
                // Store the siblings that were inerted.
                element[_siblingsToRestore] = inertedSiblings;
                // Observe only immediate children mutations on the parent.
                const mo = new MutationObserver(this[_handleMutations].bind(this));
                element[_parentMO] = mo;
                let parentToObserve = parent;
                // If we're using the ShadyDOM polyfill, then our parent could be a
                // shady root, which is an object that acts like a ShadowRoot, but isn't
                // actually a node in the real DOM. Observe the real DOM parent instead.
                const maybeShadyRoot = parentToObserve;
                if (maybeShadyRoot.__shady && maybeShadyRoot.host) parentToObserve = maybeShadyRoot.host;
                mo.observe(parentToObserve, {
                    childList: true
                });
            }
        }
        /**
         * Handles newly added/removed nodes by toggling their inertness.
         * It also checks if the current top Blocking Element has been removed,
         * notifying and removing it.
         */ [_handleMutations](mutations) {
            const parents = this[_topElParents];
            const toKeepInert = this[_alreadyInertElements];
            for (const mutation of mutations){
                // If the target is a shadowRoot, get its host as we skip shadowRoots when
                // computing _topElParents.
                const target = mutation.target.host || mutation.target;
                const idx = target === document.body ? parents.length : parents.indexOf(target);
                const inertedChild = parents[idx - 1];
                const inertedSiblings = inertedChild[_siblingsToRestore];
                // To restore.
                for(let i = 0; i < mutation.removedNodes.length; i++){
                    const sibling = mutation.removedNodes[i];
                    if (sibling === inertedChild) {
                        console.info('Detected removal of the top Blocking Element.');
                        this.pop();
                        return;
                    }
                    if (inertedSiblings.has(sibling)) {
                        sibling.inert = false;
                        inertedSiblings.delete(sibling);
                    }
                }
                // To inert.
                for(let i = 0; i < mutation.addedNodes.length; i++){
                    const sibling = mutation.addedNodes[i];
                    if (!this[_isInertable](sibling)) continue;
                    if (toKeepInert && sibling.inert) toKeepInert.add(sibling);
                    else {
                        sibling.inert = true;
                        inertedSiblings.add(sibling);
                    }
                }
            }
        }
        /**
         * Returns if the element is inertable.
         */ [_isInertable](element) {
            return false === /^(style|template|script)$/.test(element.localName);
        }
        /**
         * Returns the list of newParents of an element, starting from element
         * (included) up to `document.body` (excluded).
         */ [_getParents](element) {
            const parents = [];
            let current = element;
            // Stop to body.
            while(current && current !== document.body){
                // Skip shadow roots.
                if (current.nodeType === Node.ELEMENT_NODE) parents.push(current);
                // ShadowDom v1
                if (current.assignedSlot) {
                    // Collect slots from deepest slot to top.
                    while(current = current.assignedSlot)parents.push(current);
                    // Continue the search on the top slot.
                    current = parents.pop();
                    continue;
                }
                current = current.parentNode || current.host;
            }
            return parents;
        }
        /**
         * Returns the distributed children of the element's shadow root.
         * Returns null if the element doesn't have a shadow root.
         */ [_getDistributedChildren](element) {
            const shadowRoot = element.shadowRoot;
            if (!shadowRoot) return null;
            const result = new Set();
            let i;
            let j;
            let nodes;
            const slots = shadowRoot.querySelectorAll('slot');
            if (slots.length && slots[0].assignedNodes) for(i = 0; i < slots.length; i++){
                nodes = slots[i].assignedNodes({
                    flatten: true
                });
                for(j = 0; j < nodes.length; j++)if (nodes[j].nodeType === Node.ELEMENT_NODE) result.add(nodes[j]);
            }
            return result;
        }
    }
    document.$blockingElements = new BlockingElementsImpl();
})();


var $9a355f6a715e9d6a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $9a355f6a715e9d6a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * This work is licensed under the W3C Software and Document License
 * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
 */ (function() {
    // Return early if we're not running inside of the browser.
    if (typeof window === 'undefined' || typeof Element === 'undefined') return;
    // Convenience function for converting NodeLists.
    /** @type {typeof Array.prototype.slice} */ var slice = Array.prototype.slice;
    /**
   * IE has a non-standard name for "matches".
   * @type {typeof Element.prototype.matches}
   */ var matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    /** @type {string} */ var _focusableElementsString = [
        'a[href]',
        'area[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'details',
        'summary',
        'iframe',
        'object',
        'embed',
        'video',
        '[contenteditable]'
    ].join(',');
    /**
   * `InertRoot` manages a single inert subtree, i.e. a DOM subtree whose root element has an `inert`
   * attribute.
   *
   * Its main functions are:
   *
   * - to create and maintain a set of managed `InertNode`s, including when mutations occur in the
   *   subtree. The `makeSubtreeUnfocusable()` method handles collecting `InertNode`s via registering
   *   each focusable node in the subtree with the singleton `InertManager` which manages all known
   *   focusable nodes within inert subtrees. `InertManager` ensures that a single `InertNode`
   *   instance exists for each focusable node which has at least one inert root as an ancestor.
   *
   * - to notify all managed `InertNode`s when this subtree stops being inert (i.e. when the `inert`
   *   attribute is removed from the root node). This is handled in the destructor, which calls the
   *   `deregister` method on `InertManager` for each managed inert node.
   */ var InertRoot = function() {
        /**
     * @param {!HTMLElement} rootElement The HTMLElement at the root of the inert subtree.
     * @param {!InertManager} inertManager The global singleton InertManager object.
     */ function InertRoot(rootElement, inertManager) {
            $9a355f6a715e9d6a$var$_classCallCheck(this, InertRoot);
            /** @type {!InertManager} */ this._inertManager = inertManager;
            /** @type {!HTMLElement} */ this._rootElement = rootElement;
            /**
       * @type {!Set<!InertNode>}
       * All managed focusable nodes in this InertRoot's subtree.
       */ this._managedNodes = new Set();
            // Make the subtree hidden from assistive technology
            if (this._rootElement.hasAttribute('aria-hidden')) /** @type {?string} */ this._savedAriaHidden = this._rootElement.getAttribute('aria-hidden');
            else this._savedAriaHidden = null;
            this._rootElement.setAttribute('aria-hidden', 'true');
            // Make all focusable elements in the subtree unfocusable and add them to _managedNodes
            this._makeSubtreeUnfocusable(this._rootElement);
            // Watch for:
            // - any additions in the subtree: make them unfocusable too
            // - any removals from the subtree: remove them from this inert root's managed nodes
            // - attribute changes: if `tabindex` is added, or removed from an intrinsically focusable
            //   element, make that node a managed node.
            this._observer = new MutationObserver(this._onMutation.bind(this));
            this._observer.observe(this._rootElement, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        /**
     * Call this whenever this object is about to become obsolete.  This unwinds all of the state
     * stored in this object and updates the state of all of the managed nodes.
     */ $9a355f6a715e9d6a$var$_createClass(InertRoot, [
            {
                key: 'destructor',
                value: function destructor() {
                    this._observer.disconnect();
                    if (this._rootElement) {
                        if (this._savedAriaHidden !== null) this._rootElement.setAttribute('aria-hidden', this._savedAriaHidden);
                        else this._rootElement.removeAttribute('aria-hidden');
                    }
                    this._managedNodes.forEach(function(inertNode) {
                        this._unmanageNode(inertNode.node);
                    }, this);
                    // Note we cast the nulls to the ANY type here because:
                    // 1) We want the class properties to be declared as non-null, or else we
                    //    need even more casts throughout this code. All bets are off if an
                    //    instance has been destroyed and a method is called.
                    // 2) We don't want to cast "this", because we want type-aware optimizations
                    //    to know which properties we're setting.
                    this._observer = /** @type {?} */ null;
                    this._rootElement = /** @type {?} */ null;
                    this._managedNodes = /** @type {?} */ null;
                    this._inertManager = /** @type {?} */ null;
                }
            },
            {
                key: '_makeSubtreeUnfocusable',
                /**
       * @param {!Node} startNode
       */ value: function _makeSubtreeUnfocusable(startNode) {
                    var _this2 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this2._visitNode(node);
                    });
                    var activeElement = document.activeElement;
                    if (!document.body.contains(startNode)) {
                        // startNode may be in shadow DOM, so find its nearest shadowRoot to get the activeElement.
                        var node = startNode;
                        /** @type {!ShadowRoot|undefined} */ var root = undefined;
                        while(node){
                            if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                root = /** @type {!ShadowRoot} */ node;
                                break;
                            }
                            node = node.parentNode;
                        }
                        if (root) activeElement = root.activeElement;
                    }
                    if (startNode.contains(activeElement)) {
                        activeElement.blur();
                        // In IE11, if an element is already focused, and then set to tabindex=-1
                        // calling blur() will not actually move the focus.
                        // To work around this we call focus() on the body instead.
                        if (activeElement === document.activeElement) document.body.focus();
                    }
                }
            },
            {
                key: '_visitNode',
                value: function _visitNode(node) {
                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ node;
                    // If a descendant inert root becomes un-inert, its descendants will still be inert because of
                    // this inert root, so all of its managed nodes need to be adopted by this InertRoot.
                    if (element !== this._rootElement && element.hasAttribute('inert')) this._adoptInertRoot(element);
                    if (matches.call(element, _focusableElementsString) || element.hasAttribute('tabindex')) this._manageNode(element);
                }
            },
            {
                key: '_manageNode',
                value: function _manageNode(node) {
                    var inertNode = this._inertManager.register(node, this);
                    this._managedNodes.add(inertNode);
                }
            },
            {
                key: '_unmanageNode',
                value: function _unmanageNode(node) {
                    var inertNode = this._inertManager.deregister(node, this);
                    if (inertNode) this._managedNodes['delete'](inertNode);
                }
            },
            {
                key: '_unmanageSubtree',
                value: function _unmanageSubtree(startNode) {
                    var _this3 = this;
                    composedTreeWalk(startNode, function(node) {
                        return _this3._unmanageNode(node);
                    });
                }
            },
            {
                key: '_adoptInertRoot',
                value: function _adoptInertRoot(node) {
                    var inertSubroot = this._inertManager.getInertRoot(node);
                    // During initialisation this inert root may not have been registered yet,
                    // so register it now if need be.
                    if (!inertSubroot) {
                        this._inertManager.setInert(node, true);
                        inertSubroot = this._inertManager.getInertRoot(node);
                    }
                    inertSubroot.managedNodes.forEach(function(savedInertNode) {
                        this._manageNode(savedInertNode.node);
                    }, this);
                }
            },
            {
                key: '_onMutation',
                value: function _onMutation(records, self) {
                    records.forEach(function(record) {
                        var target = /** @type {!HTMLElement} */ record.target;
                        if (record.type === 'childList') {
                            // Manage added nodes
                            slice.call(record.addedNodes).forEach(function(node) {
                                this._makeSubtreeUnfocusable(node);
                            }, this);
                            // Un-manage removed nodes
                            slice.call(record.removedNodes).forEach(function(node) {
                                this._unmanageSubtree(node);
                            }, this);
                        } else if (record.type === 'attributes') {
                            if (record.attributeName === 'tabindex') // Re-initialise inert node if tabindex changes
                            this._manageNode(target);
                            else if (target !== this._rootElement && record.attributeName === 'inert' && target.hasAttribute('inert')) {
                                // If a new inert root is added, adopt its managed nodes and make sure it knows about the
                                // already managed nodes from this inert subroot.
                                this._adoptInertRoot(target);
                                var inertSubroot = this._inertManager.getInertRoot(target);
                                this._managedNodes.forEach(function(managedNode) {
                                    if (target.contains(managedNode.node)) inertSubroot._manageNode(managedNode.node);
                                });
                            }
                        }
                    }, this);
                }
            },
            {
                key: 'managedNodes',
                get: function get() {
                    return new Set(this._managedNodes);
                }
            },
            {
                key: 'hasSavedAriaHidden',
                get: function get() {
                    return this._savedAriaHidden !== null;
                }
            },
            {
                key: 'savedAriaHidden',
                set: function set(ariaHidden) {
                    this._savedAriaHidden = ariaHidden;
                },
                get: function get() {
                    return this._savedAriaHidden;
                }
            }
        ]);
        return InertRoot;
    }();
    /**
   * `InertNode` initialises and manages a single inert node.
   * A node is inert if it is a descendant of one or more inert root elements.
   *
   * On construction, `InertNode` saves the existing `tabindex` value for the node, if any, and
   * either removes the `tabindex` attribute or sets it to `-1`, depending on whether the element
   * is intrinsically focusable or not.
   *
   * `InertNode` maintains a set of `InertRoot`s which are descendants of this `InertNode`. When an
   * `InertRoot` is destroyed, and calls `InertManager.deregister()`, the `InertManager` notifies the
   * `InertNode` via `removeInertRoot()`, which in turn destroys the `InertNode` if no `InertRoot`s
   * remain in the set. On destruction, `InertNode` reinstates the stored `tabindex` if one exists,
   * or removes the `tabindex` attribute if the element is intrinsically focusable.
   */ var InertNode = function() {
        /**
     * @param {!Node} node A focusable element to be made inert.
     * @param {!InertRoot} inertRoot The inert root element associated with this inert node.
     */ function InertNode(node, inertRoot) {
            $9a355f6a715e9d6a$var$_classCallCheck(this, InertNode);
            /** @type {!Node} */ this._node = node;
            /** @type {boolean} */ this._overrodeFocusMethod = false;
            /**
       * @type {!Set<!InertRoot>} The set of descendant inert roots.
       *    If and only if this set becomes empty, this node is no longer inert.
       */ this._inertRoots = new Set([
                inertRoot
            ]);
            /** @type {?number} */ this._savedTabIndex = null;
            /** @type {boolean} */ this._destroyed = false;
            // Save any prior tabindex info and make this node untabbable
            this.ensureUntabbable();
        }
        /**
     * Call this whenever this object is about to become obsolete.
     * This makes the managed node focusable again and deletes all of the previously stored state.
     */ $9a355f6a715e9d6a$var$_createClass(InertNode, [
            {
                key: 'destructor',
                value: function destructor() {
                    this._throwIfDestroyed();
                    if (this._node && this._node.nodeType === Node.ELEMENT_NODE) {
                        var element = /** @type {!HTMLElement} */ this._node;
                        if (this._savedTabIndex !== null) element.setAttribute('tabindex', this._savedTabIndex);
                        else element.removeAttribute('tabindex');
                        // Use `delete` to restore native focus method.
                        if (this._overrodeFocusMethod) delete element.focus;
                    }
                    // See note in InertRoot.destructor for why we cast these nulls to ANY.
                    this._node = /** @type {?} */ null;
                    this._inertRoots = /** @type {?} */ null;
                    this._destroyed = true;
                }
            },
            {
                key: '_throwIfDestroyed',
                /**
       * Throw if user tries to access destroyed InertNode.
       */ value: function _throwIfDestroyed() {
                    if (this.destroyed) throw new Error('Trying to access destroyed InertNode');
                }
            },
            {
                key: 'ensureUntabbable',
                /** Save the existing tabindex value and make the node untabbable and unfocusable */ value: function ensureUntabbable() {
                    if (this.node.nodeType !== Node.ELEMENT_NODE) return;
                    var element = /** @type {!HTMLElement} */ this.node;
                    if (matches.call(element, _focusableElementsString)) {
                        if (/** @type {!HTMLElement} */ element.tabIndex === -1 && this.hasSavedTabIndex) return;
                        if (element.hasAttribute('tabindex')) this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.setAttribute('tabindex', '-1');
                        if (element.nodeType === Node.ELEMENT_NODE) {
                            element.focus = function() {};
                            this._overrodeFocusMethod = true;
                        }
                    } else if (element.hasAttribute('tabindex')) {
                        this._savedTabIndex = /** @type {!HTMLElement} */ element.tabIndex;
                        element.removeAttribute('tabindex');
                    }
                }
            },
            {
                key: 'addInertRoot',
                value: function addInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots.add(inertRoot);
                }
            },
            {
                key: 'removeInertRoot',
                value: function removeInertRoot(inertRoot) {
                    this._throwIfDestroyed();
                    this._inertRoots['delete'](inertRoot);
                    if (this._inertRoots.size === 0) this.destructor();
                }
            },
            {
                key: 'destroyed',
                get: function get() {
                    return /** @type {!InertNode} */ this._destroyed;
                }
            },
            {
                key: 'hasSavedTabIndex',
                get: function get() {
                    return this._savedTabIndex !== null;
                }
            },
            {
                key: 'node',
                get: function get() {
                    this._throwIfDestroyed();
                    return this._node;
                }
            },
            {
                key: 'savedTabIndex',
                set: function set(tabIndex) {
                    this._throwIfDestroyed();
                    this._savedTabIndex = tabIndex;
                },
                get: function get() {
                    this._throwIfDestroyed();
                    return this._savedTabIndex;
                }
            }
        ]);
        return InertNode;
    }();
    /**
   * InertManager is a per-document singleton object which manages all inert roots and nodes.
   *
   * When an element becomes an inert root by having an `inert` attribute set and/or its `inert`
   * property set to `true`, the `setInert` method creates an `InertRoot` object for the element.
   * The `InertRoot` in turn registers itself as managing all of the element's focusable descendant
   * nodes via the `register()` method. The `InertManager` ensures that a single `InertNode` instance
   * is created for each such node, via the `_managedNodes` map.
   */ var InertManager = function() {
        /**
     * @param {!Document} document
     */ function InertManager(document1) {
            $9a355f6a715e9d6a$var$_classCallCheck(this, InertManager);
            if (!document1) throw new Error('Missing required argument; InertManager needs to wrap a document.');
            /** @type {!Document} */ this._document = document1;
            /**
       * All managed nodes known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertNode>}
       */ this._managedNodes = new Map();
            /**
       * All inert roots known to this InertManager. In a map to allow looking up by Node.
       * @type {!Map<!Node, !InertRoot>}
       */ this._inertRoots = new Map();
            /**
       * Observer for mutations on `document.body`.
       * @type {!MutationObserver}
       */ this._observer = new MutationObserver(this._watchForInert.bind(this));
            // Add inert style.
            addInertStyle(document1.head || document1.body || document1.documentElement);
            // Wait for document to be loaded.
            if (document1.readyState === 'loading') document1.addEventListener('DOMContentLoaded', this._onDocumentLoaded.bind(this));
            else this._onDocumentLoaded();
        }
        /**
     * Set whether the given element should be an inert root or not.
     * @param {!HTMLElement} root
     * @param {boolean} inert
     */ $9a355f6a715e9d6a$var$_createClass(InertManager, [
            {
                key: 'setInert',
                value: function setInert(root, inert) {
                    if (inert) {
                        if (this._inertRoots.has(root)) // element is already inert
                        return;
                        var inertRoot = new InertRoot(root, this);
                        root.setAttribute('inert', '');
                        this._inertRoots.set(root, inertRoot);
                        // If not contained in the document, it must be in a shadowRoot.
                        // Ensure inert styles are added there.
                        if (!this._document.body.contains(root)) {
                            var parent = root.parentNode;
                            while(parent){
                                if (parent.nodeType === 11) addInertStyle(parent);
                                parent = parent.parentNode;
                            }
                        }
                    } else {
                        if (!this._inertRoots.has(root)) // element is already non-inert
                        return;
                        var _inertRoot = this._inertRoots.get(root);
                        _inertRoot.destructor();
                        this._inertRoots['delete'](root);
                        root.removeAttribute('inert');
                    }
                }
            },
            {
                key: 'getInertRoot',
                value: function getInertRoot(element) {
                    return this._inertRoots.get(element);
                }
            },
            {
                key: 'register',
                value: function register(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (inertNode !== undefined) // node was already in an inert subtree
                    inertNode.addInertRoot(inertRoot);
                    else inertNode = new InertNode(node, inertRoot);
                    this._managedNodes.set(node, inertNode);
                    return inertNode;
                }
            },
            {
                key: 'deregister',
                value: function deregister(node, inertRoot) {
                    var inertNode = this._managedNodes.get(node);
                    if (!inertNode) return null;
                    inertNode.removeInertRoot(inertRoot);
                    if (inertNode.destroyed) this._managedNodes['delete'](node);
                    return inertNode;
                }
            },
            {
                key: '_onDocumentLoaded',
                value: function _onDocumentLoaded() {
                    // Find all inert roots in document and make them actually inert.
                    var inertElements = slice.call(this._document.querySelectorAll('[inert]'));
                    inertElements.forEach(function(inertElement) {
                        this.setInert(inertElement, true);
                    }, this);
                    // Comment this out to use programmatic API only.
                    this._observer.observe(this._document.body || this._document.documentElement, {
                        attributes: true,
                        subtree: true,
                        childList: true
                    });
                }
            },
            {
                key: '_watchForInert',
                value: function _watchForInert(records, self) {
                    var _this = this;
                    records.forEach(function(record) {
                        switch(record.type){
                            case 'childList':
                                slice.call(record.addedNodes).forEach(function(node) {
                                    if (node.nodeType !== Node.ELEMENT_NODE) return;
                                    var inertElements = slice.call(node.querySelectorAll('[inert]'));
                                    if (matches.call(node, '[inert]')) inertElements.unshift(node);
                                    inertElements.forEach(function(inertElement) {
                                        this.setInert(inertElement, true);
                                    }, _this);
                                }, _this);
                                break;
                            case 'attributes':
                                if (record.attributeName !== 'inert') return;
                                var target = /** @type {!HTMLElement} */ record.target;
                                var inert = target.hasAttribute('inert');
                                _this.setInert(target, inert);
                                break;
                        }
                    }, this);
                }
            }
        ]);
        return InertManager;
    }();
    /**
   * Recursively walk the composed tree from |node|.
   * @param {!Node} node
   * @param {(function (!HTMLElement))=} callback Callback to be called for each element traversed,
   *     before descending into child nodes.
   * @param {?ShadowRoot=} shadowRootAncestor The nearest ShadowRoot ancestor, if any.
   */ function composedTreeWalk(node, callback, shadowRootAncestor) {
        if (node.nodeType == Node.ELEMENT_NODE) {
            var element = /** @type {!HTMLElement} */ node;
            if (callback) callback(element);
            // Descend into node:
            // If it has a ShadowRoot, ignore all child elements - these will be picked
            // up by the <content> or <shadow> elements. Descend straight into the
            // ShadowRoot.
            var shadowRoot = /** @type {!HTMLElement} */ element.shadowRoot;
            if (shadowRoot) {
                composedTreeWalk(shadowRoot, callback, shadowRoot);
                return;
            }
            // If it is a <content> element, descend into distributed elements - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == 'content') {
                var content = /** @type {!HTMLContentElement} */ element;
                // Verifies if ShadowDom v0 is supported.
                var distributedNodes = content.getDistributedNodes ? content.getDistributedNodes() : [];
                for(var i = 0; i < distributedNodes.length; i++)composedTreeWalk(distributedNodes[i], callback, shadowRootAncestor);
                return;
            }
            // If it is a <slot> element, descend into assigned nodes - these
            // are elements from outside the shadow root which are rendered inside the
            // shadow DOM.
            if (element.localName == 'slot') {
                var slot = /** @type {!HTMLSlotElement} */ element;
                // Verify if ShadowDom v1 is supported.
                var _distributedNodes = slot.assignedNodes ? slot.assignedNodes({
                    flatten: true
                }) : [];
                for(var _i = 0; _i < _distributedNodes.length; _i++)composedTreeWalk(_distributedNodes[_i], callback, shadowRootAncestor);
                return;
            }
        }
        // If it is neither the parent of a ShadowRoot, a <content> element, a <slot>
        // element, nor a <shadow> element recurse normally.
        var child = node.firstChild;
        while(child != null){
            composedTreeWalk(child, callback, shadowRootAncestor);
            child = child.nextSibling;
        }
    }
    /**
   * Adds a style element to the node containing the inert specific styles
   * @param {!Node} node
   */ function addInertStyle(node) {
        if (node.querySelector('style#inert-style, link#inert-style')) return;
        var style = document.createElement('style');
        style.setAttribute('id', 'inert-style');
        style.textContent = "\n[inert] {\n  pointer-events: none;\n  cursor: default;\n}\n\n[inert], [inert] * {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n";
        node.appendChild(style);
    }
    if (!HTMLElement.prototype.hasOwnProperty('inert')) {
        /** @type {!InertManager} */ var inertManager = new InertManager(document);
        Object.defineProperty(HTMLElement.prototype, 'inert', {
            enumerable: true,
            /** @this {!HTMLElement} */ get: function get() {
                return this.hasAttribute('inert');
            },
            /** @this {!HTMLElement} */ set: function set(inert) {
                inertManager.setInert(this, inert);
            }
        });
    }
})();


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $66bcb18e9bbd5409$export$c1c0562ec8379000 = {
    CLOSING: 'mdc-dialog--closing',
    OPEN: 'mdc-dialog--open',
    OPENING: 'mdc-dialog--opening',
    SCROLLABLE: 'mdc-dialog--scrollable',
    SCROLL_LOCK: 'mdc-dialog-scroll-lock',
    STACKED: 'mdc-dialog--stacked',
    FULLSCREEN: 'mdc-dialog--fullscreen',
    // Class for showing a scroll divider on full-screen dialog header element.
    // Should only be displayed on scrollable content, when the dialog content is
    // scrolled "underneath" the header.
    SCROLL_DIVIDER_HEADER: 'mdc-dialog-scroll-divider-header',
    // Class for showing a scroll divider on a full-screen dialog footer element.
    // Should only be displayed on scrolalble content, when the dialog content is
    // obscured "underneath" the footer.
    SCROLL_DIVIDER_FOOTER: 'mdc-dialog-scroll-divider-footer',
    // The "surface scrim" is a scrim covering only the surface of a dialog. This
    // is used in situations where a confirmation dialog is shown over an already
    // opened full-screen dialog. On larger screen-sizes, the full-screen dialog
    // is sized as a modal and so in these situations we display a "surface scrim"
    // to prevent a "double scrim" (where the scrim from the secondary
    // confirmation dialog would overlap with the scrim from the full-screen
    // dialog).
    SURFACE_SCRIM_SHOWN: 'mdc-dialog__surface-scrim--shown',
    // "Showing" animating class for the surface-scrim.
    SURFACE_SCRIM_SHOWING: 'mdc-dialog__surface-scrim--showing',
    // "Hiding" animating class for the surface-scrim.
    SURFACE_SCRIM_HIDING: 'mdc-dialog__surface-scrim--hiding',
    // Class to hide a dialog's scrim (used in conjunction with a surface-scrim).
    // Note that we only hide the original scrim rather than removing it entirely
    // to prevent interactions with the content behind this scrim, and to capture
    // scrim clicks.
    SCRIM_HIDDEN: 'mdc-dialog__scrim--hidden'
};
var $66bcb18e9bbd5409$export$21c51bc433c16634 = {
    ACTION_ATTRIBUTE: 'data-mdc-dialog-action',
    BUTTON_DEFAULT_ATTRIBUTE: 'data-mdc-dialog-button-default',
    BUTTON_SELECTOR: '.mdc-dialog__button',
    CLOSED_EVENT: 'MDCDialog:closed',
    CLOSE_ACTION: 'close',
    CLOSING_EVENT: 'MDCDialog:closing',
    CONTAINER_SELECTOR: '.mdc-dialog__container',
    CONTENT_SELECTOR: '.mdc-dialog__content',
    DESTROY_ACTION: 'destroy',
    INITIAL_FOCUS_ATTRIBUTE: 'data-mdc-dialog-initial-focus',
    OPENED_EVENT: 'MDCDialog:opened',
    OPENING_EVENT: 'MDCDialog:opening',
    SCRIM_SELECTOR: '.mdc-dialog__scrim',
    SUPPRESS_DEFAULT_PRESS_SELECTOR: [
        'textarea',
        '.mdc-menu .mdc-list-item',
        '.mdc-menu .mdc-deprecated-list-item'
    ].join(', '),
    SURFACE_SELECTOR: '.mdc-dialog__surface'
};
var $66bcb18e9bbd5409$export$1f6c9cc012ebacae = {
    DIALOG_ANIMATION_CLOSE_TIME_MS: 75,
    DIALOG_ANIMATION_OPEN_TIME_MS: 150
};


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * AnimationFrame provides a user-friendly abstraction around requesting
 * and canceling animation frames.
 */ var $144230e3cdbb29f9$export$1f3d5b43727c648a = /** @class */ function() {
    function AnimationFrame() {
        this.rafIDs = new Map();
    }
    /**
     * Requests an animation frame. Cancels any existing frame with the same key.
     * @param {string} key The key for this callback.
     * @param {FrameRequestCallback} callback The callback to be executed.
     */ AnimationFrame.prototype.request = function(key, callback) {
        var _this = this;
        this.cancel(key);
        var frameID = requestAnimationFrame(function(frame) {
            _this.rafIDs.delete(key);
            // Callback must come *after* the key is deleted so that nested calls to
            // request with the same key are not deleted.
            callback(frame);
        });
        this.rafIDs.set(key, frameID);
    };
    /**
     * Cancels a queued callback with the given key.
     * @param {string} key The key for this callback.
     */ AnimationFrame.prototype.cancel = function(key) {
        var rafID = this.rafIDs.get(key);
        if (rafID) {
            cancelAnimationFrame(rafID);
            this.rafIDs.delete(key);
        }
    };
    /**
     * Cancels all queued callback.
     */ AnimationFrame.prototype.cancelAll = function() {
        var _this = this;
        // Need to use forEach because it's the only iteration method supported
        // by IE11. Suppress the underscore because we don't need it.
        // tslint:disable-next-line:enforce-name-casing
        this.rafIDs.forEach(function(_, key) {
            _this.cancel(key);
        });
    };
    /**
     * Returns the queue of unexecuted callback keys.
     */ AnimationFrame.prototype.getQueue = function() {
        var queue = [];
        // Need to use forEach because it's the only iteration method supported
        // by IE11. Suppress the underscore because we don't need it.
        // tslint:disable-next-line:enforce-name-casing
        this.rafIDs.forEach(function(_, key) {
            queue.push(key);
        });
        return queue;
    };
    return AnimationFrame;
}();


/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $097683d6aecf6cf3$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$097683d6aecf6cf3$export$2e2bcd8739ae039 = $097683d6aecf6cf3$export$a81b11d69c993162;



var $e72f79f56620d5b2$var$AnimationKeys;
(function(AnimationKeys) {
    AnimationKeys["POLL_SCROLL_POS"] = "poll_scroll_position";
    AnimationKeys["POLL_LAYOUT_CHANGE"] = "poll_layout_change";
})($e72f79f56620d5b2$var$AnimationKeys || ($e72f79f56620d5b2$var$AnimationKeys = {}));
var $e72f79f56620d5b2$export$dac9922df5f517f1 = /** @class */ function(_super) {
    (0, $czHfO.__extends)(MDCDialogFoundation, _super);
    function MDCDialogFoundation(adapter) {
        var _this = _super.call(this, (0, $czHfO.__assign)((0, $czHfO.__assign)({}, MDCDialogFoundation.defaultAdapter), adapter)) || this;
        _this.dialogOpen = false;
        _this.isFullscreen = false;
        _this.animationFrame = 0;
        _this.animationTimer = 0;
        _this.escapeKeyAction = (0, $66bcb18e9bbd5409$export$21c51bc433c16634).CLOSE_ACTION;
        _this.scrimClickAction = (0, $66bcb18e9bbd5409$export$21c51bc433c16634).CLOSE_ACTION;
        _this.autoStackButtons = true;
        _this.areButtonsStacked = false;
        _this.suppressDefaultPressSelector = (0, $66bcb18e9bbd5409$export$21c51bc433c16634).SUPPRESS_DEFAULT_PRESS_SELECTOR;
        _this.animFrame = new (0, $144230e3cdbb29f9$export$1f3d5b43727c648a)();
        _this.contentScrollHandler = function() {
            _this.handleScrollEvent();
        };
        _this.windowResizeHandler = function() {
            _this.layout();
        };
        _this.windowOrientationChangeHandler = function() {
            _this.layout();
        };
        return _this;
    }
    Object.defineProperty(MDCDialogFoundation, "cssClasses", {
        get: function() {
            return 0, $66bcb18e9bbd5409$export$c1c0562ec8379000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "strings", {
        get: function() {
            return 0, $66bcb18e9bbd5409$export$21c51bc433c16634;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "numbers", {
        get: function() {
            return 0, $66bcb18e9bbd5409$export$1f6c9cc012ebacae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCDialogFoundation, "defaultAdapter", {
        get: function() {
            return {
                addBodyClass: function() {
                    return undefined;
                },
                addClass: function() {
                    return undefined;
                },
                areButtonsStacked: function() {
                    return false;
                },
                clickDefaultButton: function() {
                    return undefined;
                },
                eventTargetMatches: function() {
                    return false;
                },
                getActionFromEvent: function() {
                    return '';
                },
                getInitialFocusEl: function() {
                    return null;
                },
                hasClass: function() {
                    return false;
                },
                isContentScrollable: function() {
                    return false;
                },
                notifyClosed: function() {
                    return undefined;
                },
                notifyClosing: function() {
                    return undefined;
                },
                notifyOpened: function() {
                    return undefined;
                },
                notifyOpening: function() {
                    return undefined;
                },
                releaseFocus: function() {
                    return undefined;
                },
                removeBodyClass: function() {
                    return undefined;
                },
                removeClass: function() {
                    return undefined;
                },
                reverseButtons: function() {
                    return undefined;
                },
                trapFocus: function() {
                    return undefined;
                },
                registerContentEventHandler: function() {
                    return undefined;
                },
                deregisterContentEventHandler: function() {
                    return undefined;
                },
                isScrollableContentAtTop: function() {
                    return false;
                },
                isScrollableContentAtBottom: function() {
                    return false;
                },
                registerWindowEventHandler: function() {
                    return undefined;
                },
                deregisterWindowEventHandler: function() {
                    return undefined;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    MDCDialogFoundation.prototype.init = function() {
        if (this.adapter.hasClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).STACKED)) this.setAutoStackButtons(false);
        this.isFullscreen = this.adapter.hasClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).FULLSCREEN);
    };
    MDCDialogFoundation.prototype.destroy = function() {
        if (this.animationTimer) {
            clearTimeout(this.animationTimer);
            this.handleAnimationTimerEnd();
        }
        if (this.isFullscreen) this.adapter.deregisterContentEventHandler('scroll', this.contentScrollHandler);
        this.animFrame.cancelAll();
        this.adapter.deregisterWindowEventHandler('resize', this.windowResizeHandler);
        this.adapter.deregisterWindowEventHandler('orientationchange', this.windowOrientationChangeHandler);
    };
    MDCDialogFoundation.prototype.open = function(dialogOptions) {
        var _this = this;
        this.dialogOpen = true;
        this.adapter.notifyOpening();
        this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).OPENING);
        if (this.isFullscreen) // A scroll event listener is registered even if the dialog is not
        // scrollable on open, since the window resize event, or orientation
        // change may make the dialog scrollable after it is opened.
        this.adapter.registerContentEventHandler('scroll', this.contentScrollHandler);
        if (dialogOptions && dialogOptions.isAboveFullscreenDialog) this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCRIM_HIDDEN);
        this.adapter.registerWindowEventHandler('resize', this.windowResizeHandler);
        this.adapter.registerWindowEventHandler('orientationchange', this.windowOrientationChangeHandler);
        // Wait a frame once display is no longer "none", to establish basis for
        // animation
        this.runNextAnimationFrame(function() {
            _this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).OPEN);
            _this.adapter.addBodyClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_LOCK);
            _this.layout();
            _this.animationTimer = setTimeout(function() {
                _this.handleAnimationTimerEnd();
                _this.adapter.trapFocus(_this.adapter.getInitialFocusEl());
                _this.adapter.notifyOpened();
            }, (0, $66bcb18e9bbd5409$export$1f6c9cc012ebacae).DIALOG_ANIMATION_OPEN_TIME_MS);
        });
    };
    MDCDialogFoundation.prototype.close = function(action) {
        var _this = this;
        if (action === void 0) action = '';
        if (!this.dialogOpen) // Avoid redundant close calls (and events), e.g. from keydown on elements
        // that inherently emit click
        return;
        this.dialogOpen = false;
        this.adapter.notifyClosing(action);
        this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).CLOSING);
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).OPEN);
        this.adapter.removeBodyClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_LOCK);
        if (this.isFullscreen) this.adapter.deregisterContentEventHandler('scroll', this.contentScrollHandler);
        this.adapter.deregisterWindowEventHandler('resize', this.windowResizeHandler);
        this.adapter.deregisterWindowEventHandler('orientationchange', this.windowOrientationChangeHandler);
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = 0;
        clearTimeout(this.animationTimer);
        this.animationTimer = setTimeout(function() {
            _this.adapter.releaseFocus();
            _this.handleAnimationTimerEnd();
            _this.adapter.notifyClosed(action);
        }, (0, $66bcb18e9bbd5409$export$1f6c9cc012ebacae).DIALOG_ANIMATION_CLOSE_TIME_MS);
    };
    /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Shows the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.showSurfaceScrim = function() {
        var _this = this;
        this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWING);
        this.runNextAnimationFrame(function() {
            _this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWN);
        });
    };
    /**
     * Used only in instances of showing a secondary dialog over a full-screen
     * dialog. Hides the "surface scrim" displayed over the full-screen dialog.
     */ MDCDialogFoundation.prototype.hideSurfaceScrim = function() {
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWN);
        this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SURFACE_SCRIM_HIDING);
    };
    /**
     * Handles `transitionend` event triggered when surface scrim animation is
     * finished.
     */ MDCDialogFoundation.prototype.handleSurfaceScrimTransitionEnd = function() {
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SURFACE_SCRIM_HIDING);
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SURFACE_SCRIM_SHOWING);
    };
    MDCDialogFoundation.prototype.isOpen = function() {
        return this.dialogOpen;
    };
    MDCDialogFoundation.prototype.getEscapeKeyAction = function() {
        return this.escapeKeyAction;
    };
    MDCDialogFoundation.prototype.setEscapeKeyAction = function(action) {
        this.escapeKeyAction = action;
    };
    MDCDialogFoundation.prototype.getScrimClickAction = function() {
        return this.scrimClickAction;
    };
    MDCDialogFoundation.prototype.setScrimClickAction = function(action) {
        this.scrimClickAction = action;
    };
    MDCDialogFoundation.prototype.getAutoStackButtons = function() {
        return this.autoStackButtons;
    };
    MDCDialogFoundation.prototype.setAutoStackButtons = function(autoStack) {
        this.autoStackButtons = autoStack;
    };
    MDCDialogFoundation.prototype.getSuppressDefaultPressSelector = function() {
        return this.suppressDefaultPressSelector;
    };
    MDCDialogFoundation.prototype.setSuppressDefaultPressSelector = function(selector) {
        this.suppressDefaultPressSelector = selector;
    };
    MDCDialogFoundation.prototype.layout = function() {
        var _this = this;
        this.animFrame.request($e72f79f56620d5b2$var$AnimationKeys.POLL_LAYOUT_CHANGE, function() {
            _this.layoutInternal();
        });
    };
    /** Handles click on the dialog root element. */ MDCDialogFoundation.prototype.handleClick = function(evt) {
        var isScrim = this.adapter.eventTargetMatches(evt.target, (0, $66bcb18e9bbd5409$export$21c51bc433c16634).SCRIM_SELECTOR);
        // Check for scrim click first since it doesn't require querying ancestors.
        if (isScrim && this.scrimClickAction !== '') this.close(this.scrimClickAction);
        else {
            var action = this.adapter.getActionFromEvent(evt);
            if (action) this.close(action);
        }
    };
    /** Handles keydown on the dialog root element. */ MDCDialogFoundation.prototype.handleKeydown = function(evt) {
        var isEnter = evt.key === 'Enter' || evt.keyCode === 13;
        if (!isEnter) return;
        var action = this.adapter.getActionFromEvent(evt);
        if (action) // Action button callback is handled in `handleClick`,
        // since space/enter keydowns on buttons trigger click events.
        return;
        // `composedPath` is used here, when available, to account for use cases
        // where a target meant to suppress the default press behaviour
        // may exist in a shadow root.
        // For example, a textarea inside a web component:
        // <mwc-dialog>
        //   <horizontal-layout>
        //     #shadow-root (open)
        //       <mwc-textarea>
        //         #shadow-root (open)
        //           <textarea></textarea>
        //       </mwc-textarea>
        //   </horizontal-layout>
        // </mwc-dialog>
        var target = evt.composedPath ? evt.composedPath()[0] : evt.target;
        var isDefault = this.suppressDefaultPressSelector ? !this.adapter.eventTargetMatches(target, this.suppressDefaultPressSelector) : true;
        if (isEnter && isDefault) this.adapter.clickDefaultButton();
    };
    /** Handles keydown on the document. */ MDCDialogFoundation.prototype.handleDocumentKeydown = function(evt) {
        var isEscape = evt.key === 'Escape' || evt.keyCode === 27;
        if (isEscape && this.escapeKeyAction !== '') this.close(this.escapeKeyAction);
    };
    /**
     * Handles scroll event on the dialog's content element -- showing a scroll
     * divider on the header or footer based on the scroll position. This handler
     * should only be registered on full-screen dialogs with scrollable content.
     */ MDCDialogFoundation.prototype.handleScrollEvent = function() {
        var _this = this;
        // Since scroll events can fire at a high rate, we throttle these events by
        // using requestAnimationFrame.
        this.animFrame.request($e72f79f56620d5b2$var$AnimationKeys.POLL_SCROLL_POS, function() {
            _this.toggleScrollDividerHeader();
            _this.toggleScrollDividerFooter();
        });
    };
    MDCDialogFoundation.prototype.layoutInternal = function() {
        if (this.autoStackButtons) this.detectStackedButtons();
        this.toggleScrollableClasses();
    };
    MDCDialogFoundation.prototype.handleAnimationTimerEnd = function() {
        this.animationTimer = 0;
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).OPENING);
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).CLOSING);
    };
    /**
     * Runs the given logic on the next animation frame, using setTimeout to
     * factor in Firefox reflow behavior.
     */ MDCDialogFoundation.prototype.runNextAnimationFrame = function(callback) {
        var _this = this;
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = requestAnimationFrame(function() {
            _this.animationFrame = 0;
            clearTimeout(_this.animationTimer);
            _this.animationTimer = setTimeout(callback, 0);
        });
    };
    MDCDialogFoundation.prototype.detectStackedButtons = function() {
        // Remove the class first to let us measure the buttons' natural positions.
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).STACKED);
        var areButtonsStacked = this.adapter.areButtonsStacked();
        if (areButtonsStacked) this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).STACKED);
        if (areButtonsStacked !== this.areButtonsStacked) {
            this.adapter.reverseButtons();
            this.areButtonsStacked = areButtonsStacked;
        }
    };
    MDCDialogFoundation.prototype.toggleScrollableClasses = function() {
        // Remove the class first to let us measure the natural height of the
        // content.
        this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLLABLE);
        if (this.adapter.isContentScrollable()) {
            this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLLABLE);
            if (this.isFullscreen) {
                // If dialog is full-screen and scrollable, check if a scroll divider
                // should be shown.
                this.toggleScrollDividerHeader();
                this.toggleScrollDividerFooter();
            }
        }
    };
    MDCDialogFoundation.prototype.toggleScrollDividerHeader = function() {
        if (!this.adapter.isScrollableContentAtTop()) this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER);
        else if (this.adapter.hasClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER)) this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_DIVIDER_HEADER);
    };
    MDCDialogFoundation.prototype.toggleScrollDividerFooter = function() {
        if (!this.adapter.isScrollableContentAtBottom()) this.adapter.addClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER);
        else if (this.adapter.hasClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER)) this.adapter.removeClass((0, $66bcb18e9bbd5409$export$c1c0562ec8379000).SCROLL_DIVIDER_FOOTER);
    };
    return MDCDialogFoundation;
}((0, $097683d6aecf6cf3$export$a81b11d69c993162));
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$e72f79f56620d5b2$export$2e2bcd8739ae039 = $e72f79f56620d5b2$export$dac9922df5f517f1;


/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Determine whether the current browser supports passive event listeners, and
 * if so, use them.
 */ function $3a56503555e3a29c$export$82e1592afef3b60f(globalObj) {
    if (globalObj === void 0) globalObj = window;
    return $3a56503555e3a29c$var$supportsPassiveOption(globalObj) ? {
        passive: true
    } : false;
}
function $3a56503555e3a29c$var$supportsPassiveOption(globalObj) {
    if (globalObj === void 0) globalObj = window;
    // See
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
    var passiveSupported = false;
    try {
        var options = {
            // This function will be called when the browser
            // attempts to access the passive property.
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        var handler = function() {};
        globalObj.document.addEventListener('test', handler, options);
        globalObj.document.removeEventListener('test', handler, options);
    } catch (err) {
        passiveSupported = false;
    }
    return passiveSupported;
}


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * @fileoverview A "ponyfill" is a polyfill that doesn't modify the global prototype chain.
 * This makes ponyfills safer than traditional polyfills, especially for libraries like MDC.
 */ function $1d6b0fe22404cf64$export$ff7f7c97cdce86e(element, selector) {
    if (element.closest) return element.closest(selector);
    var el = element;
    while(el){
        if ($1d6b0fe22404cf64$export$de994efd351b291c(el, selector)) return el;
        el = el.parentElement;
    }
    return null;
}
function $1d6b0fe22404cf64$export$de994efd351b291c(element, selector) {
    var nativeMatches = element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    return nativeMatches.call(element, selector);
}
function $1d6b0fe22404cf64$export$30f5493effae393e(element) {
    // Check the offsetParent. If the element inherits display: none from any
    // parent, the offsetParent property will be null (see
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent).
    // This check ensures we only clone the node when necessary.
    var htmlEl = element;
    if (htmlEl.offsetParent !== null) return htmlEl.scrollWidth;
    var clone = htmlEl.cloneNode(true);
    clone.style.setProperty('position', 'absolute');
    clone.style.setProperty('transform', 'translate(-9999px, -9999px)');
    document.documentElement.appendChild(clone);
    var scrollWidth = clone.scrollWidth;
    document.documentElement.removeChild(clone);
    return scrollWidth;
}


parcelRequire("4ifWP");
var $gSEYT = parcelRequire("gSEYT");
var $4ifWP = parcelRequire("4ifWP");

var $k4Ngf = parcelRequire("k4Ngf");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $726575774620c042$var$t = window, $726575774620c042$export$b4d10f6001c083c2 = $726575774620c042$var$t.ShadowRoot && (void 0 === $726575774620c042$var$t.ShadyCSS || $726575774620c042$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $726575774620c042$var$s = Symbol(), $726575774620c042$var$n = new WeakMap;
class $726575774620c042$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $726575774620c042$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($726575774620c042$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $726575774620c042$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $726575774620c042$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $726575774620c042$export$8d80f9cac07cdb3 = (t)=>new $726575774620c042$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $726575774620c042$var$s), $726575774620c042$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $726575774620c042$export$505d1e8739bad805(n, t, $726575774620c042$var$s);
}, $726575774620c042$export$2ca4a66ec4cecb90 = (s, n)=>{
    $726575774620c042$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $726575774620c042$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $726575774620c042$export$ee69dfd951e24778 = $726575774620c042$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $726575774620c042$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $1d0c5c7918146060$var$s;
const $1d0c5c7918146060$var$e = window, $1d0c5c7918146060$var$r = $1d0c5c7918146060$var$e.trustedTypes, $1d0c5c7918146060$var$h = $1d0c5c7918146060$var$r ? $1d0c5c7918146060$var$r.emptyScript : "", $1d0c5c7918146060$var$o = $1d0c5c7918146060$var$e.reactiveElementPolyfillSupport, $1d0c5c7918146060$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $1d0c5c7918146060$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $1d0c5c7918146060$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $1d0c5c7918146060$var$l = {
    attribute: !0,
    type: String,
    converter: $1d0c5c7918146060$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $1d0c5c7918146060$export$53a6892c50694894
}, $1d0c5c7918146060$var$d = "finalized";
class $1d0c5c7918146060$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $1d0c5c7918146060$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $1d0c5c7918146060$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($1d0c5c7918146060$var$d)) return !1;
        this[$1d0c5c7918146060$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $726575774620c042$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $726575774620c042$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $726575774620c042$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $1d0c5c7918146060$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $1d0c5c7918146060$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $1d0c5c7918146060$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $1d0c5c7918146060$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$1d0c5c7918146060$export$c7c07a37856565d[$1d0c5c7918146060$var$d] = !0, $1d0c5c7918146060$export$c7c07a37856565d.elementProperties = new Map, $1d0c5c7918146060$export$c7c07a37856565d.elementStyles = [], $1d0c5c7918146060$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $1d0c5c7918146060$var$o || $1d0c5c7918146060$var$o({
    ReactiveElement: $1d0c5c7918146060$export$c7c07a37856565d
}), (null !== ($1d0c5c7918146060$var$s = $1d0c5c7918146060$var$e.reactiveElementVersions) && void 0 !== $1d0c5c7918146060$var$s ? $1d0c5c7918146060$var$s : $1d0c5c7918146060$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e26ef06dfacae484$var$t;
const $e26ef06dfacae484$var$i = window, $e26ef06dfacae484$var$s = $e26ef06dfacae484$var$i.trustedTypes, $e26ef06dfacae484$var$e = $e26ef06dfacae484$var$s ? $e26ef06dfacae484$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e26ef06dfacae484$var$o = "$lit$", $e26ef06dfacae484$var$n = `lit$${(Math.random() + "").slice(9)}$`, $e26ef06dfacae484$var$l = "?" + $e26ef06dfacae484$var$n, $e26ef06dfacae484$var$h = `<${$e26ef06dfacae484$var$l}>`, $e26ef06dfacae484$var$r = document, $e26ef06dfacae484$var$u = ()=>$e26ef06dfacae484$var$r.createComment(""), $e26ef06dfacae484$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e26ef06dfacae484$var$c = Array.isArray, $e26ef06dfacae484$var$v = (t)=>$e26ef06dfacae484$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $e26ef06dfacae484$var$a = "[ \t\n\f\r]", $e26ef06dfacae484$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e26ef06dfacae484$var$_ = /-->/g, $e26ef06dfacae484$var$m = />/g, $e26ef06dfacae484$var$p = RegExp(`>|${$e26ef06dfacae484$var$a}(?:([^\\s"'>=/]+)(${$e26ef06dfacae484$var$a}*=${$e26ef06dfacae484$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e26ef06dfacae484$var$g = /'/g, $e26ef06dfacae484$var$$ = /"/g, $e26ef06dfacae484$var$y = /^(?:script|style|textarea|title)$/i, $e26ef06dfacae484$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e26ef06dfacae484$export$c0bb0b647f701bb5 = $e26ef06dfacae484$var$w(1), $e26ef06dfacae484$export$7ed1367e7fa1ad68 = $e26ef06dfacae484$var$w(2), $e26ef06dfacae484$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e26ef06dfacae484$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e26ef06dfacae484$var$E = new WeakMap, $e26ef06dfacae484$var$C = $e26ef06dfacae484$var$r.createTreeWalker($e26ef06dfacae484$var$r, 129, null, !1);
function $e26ef06dfacae484$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e26ef06dfacae484$var$e ? $e26ef06dfacae484$var$e.createHTML(i) : i;
}
const $e26ef06dfacae484$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $e26ef06dfacae484$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $e26ef06dfacae484$var$f ? "!--" === c[1] ? u = $e26ef06dfacae484$var$_ : void 0 !== c[1] ? u = $e26ef06dfacae484$var$m : void 0 !== c[2] ? ($e26ef06dfacae484$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $e26ef06dfacae484$var$p) : void 0 !== c[3] && (u = $e26ef06dfacae484$var$p) : u === $e26ef06dfacae484$var$p ? ">" === c[0] ? (u = null != l ? l : $e26ef06dfacae484$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $e26ef06dfacae484$var$p : '"' === c[3] ? $e26ef06dfacae484$var$$ : $e26ef06dfacae484$var$g) : u === $e26ef06dfacae484$var$$ || u === $e26ef06dfacae484$var$g ? u = $e26ef06dfacae484$var$p : u === $e26ef06dfacae484$var$_ || u === $e26ef06dfacae484$var$m ? u = $e26ef06dfacae484$var$f : (u = $e26ef06dfacae484$var$p, l = void 0);
        const w = u === $e26ef06dfacae484$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $e26ef06dfacae484$var$f ? s + $e26ef06dfacae484$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $e26ef06dfacae484$var$o + s.slice(v) + $e26ef06dfacae484$var$n + w) : s + $e26ef06dfacae484$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $e26ef06dfacae484$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $e26ef06dfacae484$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $e26ef06dfacae484$var$V(t, i);
        if (this.el = $e26ef06dfacae484$var$N.createElement(a, e), $e26ef06dfacae484$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $e26ef06dfacae484$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($e26ef06dfacae484$var$o) || i.startsWith($e26ef06dfacae484$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $e26ef06dfacae484$var$o).split($e26ef06dfacae484$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e26ef06dfacae484$var$H : "?" === i[1] ? $e26ef06dfacae484$var$L : "@" === i[1] ? $e26ef06dfacae484$var$z : $e26ef06dfacae484$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($e26ef06dfacae484$var$y.test(h.tagName)) {
                    const t = h.textContent.split($e26ef06dfacae484$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $e26ef06dfacae484$var$s ? $e26ef06dfacae484$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $e26ef06dfacae484$var$u()), $e26ef06dfacae484$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $e26ef06dfacae484$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $e26ef06dfacae484$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($e26ef06dfacae484$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $e26ef06dfacae484$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e26ef06dfacae484$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e26ef06dfacae484$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e26ef06dfacae484$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $e26ef06dfacae484$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $e26ef06dfacae484$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $e26ef06dfacae484$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e26ef06dfacae484$var$r).importNode(s, !0);
        $e26ef06dfacae484$var$C.currentNode = o;
        let n = $e26ef06dfacae484$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $e26ef06dfacae484$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $e26ef06dfacae484$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $e26ef06dfacae484$var$C.nextNode(), l++);
        }
        return $e26ef06dfacae484$var$C.currentNode = $e26ef06dfacae484$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e26ef06dfacae484$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e26ef06dfacae484$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e26ef06dfacae484$var$S(this, t, i), $e26ef06dfacae484$var$d(t) ? t === $e26ef06dfacae484$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e26ef06dfacae484$export$45b790e32b2810ee && this._$AR(), this._$AH = $e26ef06dfacae484$export$45b790e32b2810ee) : t !== this._$AH && t !== $e26ef06dfacae484$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $e26ef06dfacae484$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $e26ef06dfacae484$export$45b790e32b2810ee && $e26ef06dfacae484$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($e26ef06dfacae484$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e26ef06dfacae484$var$N.createElement($e26ef06dfacae484$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $e26ef06dfacae484$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e26ef06dfacae484$var$E.get(t.strings);
        return void 0 === i && $e26ef06dfacae484$var$E.set(t.strings, i = new $e26ef06dfacae484$var$N(t)), i;
    }
    T(t) {
        $e26ef06dfacae484$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e26ef06dfacae484$var$R(this.k($e26ef06dfacae484$var$u()), this.k($e26ef06dfacae484$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e26ef06dfacae484$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e26ef06dfacae484$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e26ef06dfacae484$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e26ef06dfacae484$var$S(this, t, i, 0), n = !$e26ef06dfacae484$var$d(t) || t !== this._$AH && t !== $e26ef06dfacae484$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e26ef06dfacae484$var$S(this, e[s + l], i, l), h === $e26ef06dfacae484$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e26ef06dfacae484$var$d(h) || h !== this._$AH[l]), h === $e26ef06dfacae484$export$45b790e32b2810ee ? t = $e26ef06dfacae484$export$45b790e32b2810ee : t !== $e26ef06dfacae484$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $e26ef06dfacae484$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e26ef06dfacae484$var$H extends $e26ef06dfacae484$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e26ef06dfacae484$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e26ef06dfacae484$var$I = $e26ef06dfacae484$var$s ? $e26ef06dfacae484$var$s.emptyScript : "";
class $e26ef06dfacae484$var$L extends $e26ef06dfacae484$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $e26ef06dfacae484$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e26ef06dfacae484$var$I) : this.element.removeAttribute(this.name);
    }
}
class $e26ef06dfacae484$var$z extends $e26ef06dfacae484$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e26ef06dfacae484$var$S(this, t, i, 0)) && void 0 !== s ? s : $e26ef06dfacae484$export$45b790e32b2810ee) === $e26ef06dfacae484$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e26ef06dfacae484$export$45b790e32b2810ee && e !== $e26ef06dfacae484$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e26ef06dfacae484$export$45b790e32b2810ee && (e === $e26ef06dfacae484$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e26ef06dfacae484$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e26ef06dfacae484$var$S(this, t);
    }
}
const $e26ef06dfacae484$export$8613d1ca9052b22e = {
    O: $e26ef06dfacae484$var$o,
    P: $e26ef06dfacae484$var$n,
    A: $e26ef06dfacae484$var$l,
    C: 1,
    M: $e26ef06dfacae484$var$V,
    L: $e26ef06dfacae484$var$M,
    R: $e26ef06dfacae484$var$v,
    D: $e26ef06dfacae484$var$S,
    I: $e26ef06dfacae484$var$R,
    V: $e26ef06dfacae484$var$k,
    H: $e26ef06dfacae484$var$L,
    N: $e26ef06dfacae484$var$z,
    U: $e26ef06dfacae484$var$H,
    F: $e26ef06dfacae484$var$Z
}, $e26ef06dfacae484$var$B = $e26ef06dfacae484$var$i.litHtmlPolyfillSupport;
null == $e26ef06dfacae484$var$B || $e26ef06dfacae484$var$B($e26ef06dfacae484$var$N, $e26ef06dfacae484$var$R), (null !== ($e26ef06dfacae484$var$t = $e26ef06dfacae484$var$i.litHtmlVersions) && void 0 !== $e26ef06dfacae484$var$t ? $e26ef06dfacae484$var$t : $e26ef06dfacae484$var$i.litHtmlVersions = []).push("2.8.0");
const $e26ef06dfacae484$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e26ef06dfacae484$var$R(i.insertBefore($e26ef06dfacae484$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $8fd1a2b52948f5af$var$l, $8fd1a2b52948f5af$var$o;
const $8fd1a2b52948f5af$export$8bf27daf9e8907c9 = (0, $1d0c5c7918146060$export$c7c07a37856565d);
class $8fd1a2b52948f5af$export$3f2f9f5909897157 extends (0, $1d0c5c7918146060$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e26ef06dfacae484$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $e26ef06dfacae484$export$9c068ae9cc5db4e8;
    }
}
$8fd1a2b52948f5af$export$3f2f9f5909897157.finalized = !0, $8fd1a2b52948f5af$export$3f2f9f5909897157._$litElement$ = !0, null === ($8fd1a2b52948f5af$var$l = globalThis.litElementHydrateSupport) || void 0 === $8fd1a2b52948f5af$var$l || $8fd1a2b52948f5af$var$l.call(globalThis, {
    LitElement: $8fd1a2b52948f5af$export$3f2f9f5909897157
});
const $8fd1a2b52948f5af$var$n = globalThis.litElementPolyfillSupport;
null == $8fd1a2b52948f5af$var$n || $8fd1a2b52948f5af$var$n({
    LitElement: $8fd1a2b52948f5af$export$3f2f9f5909897157
});
const $8fd1a2b52948f5af$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($8fd1a2b52948f5af$var$o = globalThis.litElementVersions) && void 0 !== $8fd1a2b52948f5af$var$o ? $8fd1a2b52948f5af$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $aaf69ccc4b0a4387$export$6acf61af03e62db = !1;






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c152bbc30d862449$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $c152bbc30d862449$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $c152bbc30d862449$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ca4fbf9f09d47182$export$56cc687933817664 = (0, $c152bbc30d862449$export$99b43ad1ed32e735)(class extends (0, $c152bbc30d862449$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $c152bbc30d862449$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $e26ef06dfacae484$export$9c068ae9cc5db4e8;
    }
});




const $ff35184d57cb5079$var$blockingElements = document.$blockingElements;
class $ff35184d57cb5079$export$569e42c9a98af7b7 extends (0, $4ifWP.BaseElement) {
    constructor(){
        super(...arguments);
        this.hideActions = false;
        this.stacked = false;
        this.heading = '';
        this.scrimClickAction = 'close';
        this.escapeKeyAction = 'close';
        this.open = false;
        this.defaultAction = 'close';
        this.actionAttribute = 'dialogAction';
        this.initialFocusAttribute = 'dialogInitialFocus';
        this.initialSupressDefaultPressSelector = '';
        this.mdcFoundationClass = (0, $e72f79f56620d5b2$export$2e2bcd8739ae039);
        this.boundHandleClick = null;
        this.boundHandleKeydown = null;
        this.boundHandleDocumentKeydown = null;
    }
    set suppressDefaultPressSelector(selector) {
        if (this.mdcFoundation) this.mdcFoundation.setSuppressDefaultPressSelector(selector);
        else this.initialSupressDefaultPressSelector = selector;
    }
    /**
     * @export
     */ get suppressDefaultPressSelector() {
        return this.mdcFoundation ? this.mdcFoundation.getSuppressDefaultPressSelector() : this.initialSupressDefaultPressSelector;
    }
    get primaryButton() {
        let assignedNodes = this.primarySlot.assignedNodes();
        assignedNodes = assignedNodes.filter((node)=>node instanceof HTMLElement);
        const button = assignedNodes[0];
        return button ? button : null;
    }
    emitNotification(name, action) {
        const init = {
            detail: action ? {
                action: action
            } : {}
        };
        const ev = new CustomEvent(name, init);
        this.dispatchEvent(ev);
    }
    getInitialFocusEl() {
        const initFocusSelector = `[${this.initialFocusAttribute}]`;
        // only search light DOM. This typically handles all the cases
        const lightDomQs = this.querySelector(initFocusSelector);
        if (lightDomQs) return lightDomQs;
        // if not in light dom, search each flattened distributed node.
        const primarySlot = this.primarySlot;
        const primaryNodes = primarySlot.assignedNodes({
            flatten: true
        });
        const primaryFocusElement = this.searchNodeTreesForAttribute(primaryNodes, this.initialFocusAttribute);
        if (primaryFocusElement) return primaryFocusElement;
        const secondarySlot = this.secondarySlot;
        const secondaryNodes = secondarySlot.assignedNodes({
            flatten: true
        });
        const secondaryFocusElement = this.searchNodeTreesForAttribute(secondaryNodes, this.initialFocusAttribute);
        if (secondaryFocusElement) return secondaryFocusElement;
        const contentSlot = this.contentSlot;
        const contentNodes = contentSlot.assignedNodes({
            flatten: true
        });
        const initFocusElement = this.searchNodeTreesForAttribute(contentNodes, this.initialFocusAttribute);
        return initFocusElement;
    }
    searchNodeTreesForAttribute(nodes, attribute) {
        for (const node of nodes){
            if (!(node instanceof HTMLElement)) continue;
            if (node.hasAttribute(attribute)) return node;
            else {
                const selection = node.querySelector(`[${attribute}]`);
                if (selection) return selection;
            }
        }
        return null;
    }
    createAdapter() {
        return Object.assign(Object.assign({}, (0, $gSEYT.addHasRemoveClass)(this.mdcRoot)), {
            addBodyClass: ()=>document.body.style.overflow = 'hidden',
            removeBodyClass: ()=>document.body.style.overflow = '',
            areButtonsStacked: ()=>this.stacked,
            clickDefaultButton: ()=>{
                const primary = this.primaryButton;
                if (primary) primary.click();
            },
            eventTargetMatches: (target, selector)=>target ? (0, $1d6b0fe22404cf64$export$de994efd351b291c)(target, selector) : false,
            getActionFromEvent: (e)=>{
                if (!e.target) return '';
                const element = (0, $1d6b0fe22404cf64$export$ff7f7c97cdce86e)(e.target, `[${this.actionAttribute}]`);
                const action = element && element.getAttribute(this.actionAttribute);
                return action;
            },
            getInitialFocusEl: ()=>{
                return this.getInitialFocusEl();
            },
            isContentScrollable: ()=>{
                const el = this.contentElement;
                return el ? el.scrollHeight > el.offsetHeight : false;
            },
            notifyClosed: (action)=>this.emitNotification('closed', action),
            notifyClosing: (action)=>{
                if (!this.closingDueToDisconnect) // Don't set our open state to closed just because we were
                // disconnected. That way if we get reconnected, we'll know to
                // re-open.
                this.open = false;
                this.emitNotification('closing', action);
            },
            notifyOpened: ()=>this.emitNotification('opened'),
            notifyOpening: ()=>{
                this.open = true;
                this.emitNotification('opening');
            },
            reverseButtons: ()=>{},
            releaseFocus: ()=>{
                $ff35184d57cb5079$var$blockingElements.remove(this);
            },
            trapFocus: (el)=>{
                if (!this.isConnected) // this is the case where it is opened and closed and then removed
                // from DOM before the animation has completed. Blocking Elements will
                // throw if this is the case
                return;
                $ff35184d57cb5079$var$blockingElements.push(this);
                if (el) el.focus();
            },
            registerContentEventHandler: (evtType, handler)=>{
                const el = this.contentElement;
                el.addEventListener(evtType, handler);
            },
            deregisterContentEventHandler: (evtType, handler)=>{
                const el = this.contentElement;
                el.removeEventListener(evtType, handler);
            },
            isScrollableContentAtTop: ()=>{
                const el = this.contentElement;
                return el ? el.scrollTop === 0 : false;
            },
            isScrollableContentAtBottom: ()=>{
                const el = this.contentElement;
                return el ? Math.ceil(el.scrollHeight - el.scrollTop) === el.clientHeight : false;
            },
            registerWindowEventHandler: (evtType, handler)=>{
                window.addEventListener(evtType, handler, (0, $3a56503555e3a29c$export$82e1592afef3b60f)());
            },
            deregisterWindowEventHandler: (evtType, handler)=>{
                window.removeEventListener(evtType, handler, (0, $3a56503555e3a29c$export$82e1592afef3b60f)());
            }
        });
    }
    render() {
        const classes = {
            [(0, $66bcb18e9bbd5409$export$c1c0562ec8379000).STACKED]: this.stacked
        };
        let heading = (0, $e26ef06dfacae484$export$c0bb0b647f701bb5)``;
        if (this.heading) heading = this.renderHeading();
        const actionsClasses = {
            'mdc-dialog__actions': !this.hideActions
        };
        return (0, $e26ef06dfacae484$export$c0bb0b647f701bb5)`
    <div class="mdc-dialog ${(0, $ca4fbf9f09d47182$export$56cc687933817664)(classes)}"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="title"
        aria-describedby="content">
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          ${heading}
          <div id="content" class="mdc-dialog__content">
            <slot id="contentSlot"></slot>
          </div>
          <footer
              id="actions"
              class="${(0, $ca4fbf9f09d47182$export$56cc687933817664)(actionsClasses)}">
            <span>
              <slot name="secondaryAction"></slot>
            </span>
            <span>
             <slot name="primaryAction"></slot>
            </span>
          </footer>
        </div>
      </div>
      <div class="mdc-dialog__scrim"></div>
    </div>`;
    }
    renderHeading() {
        return (0, $e26ef06dfacae484$export$c0bb0b647f701bb5)`
      <h2 id="title" class="mdc-dialog__title">${this.heading}</h2>`;
    }
    firstUpdated() {
        super.firstUpdated();
        this.mdcFoundation.setAutoStackButtons(true);
        if (this.initialSupressDefaultPressSelector) this.suppressDefaultPressSelector = this.initialSupressDefaultPressSelector;
        else this.suppressDefaultPressSelector = [
            this.suppressDefaultPressSelector,
            'mwc-textarea',
            'mwc-menu mwc-list-item',
            'mwc-select mwc-list-item'
        ].join(', ');
        this.boundHandleClick = this.mdcFoundation.handleClick.bind(this.mdcFoundation);
        this.boundHandleKeydown = this.mdcFoundation.handleKeydown.bind(this.mdcFoundation);
        this.boundHandleDocumentKeydown = this.mdcFoundation.handleDocumentKeydown.bind(this.mdcFoundation);
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.open && this.mdcFoundation && !this.mdcFoundation.isOpen()) {
            // We probably got disconnected while we were still open. Re-open,
            // matching the behavior of native <dialog>.
            this.setEventListeners();
            this.mdcFoundation.open();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.open && this.mdcFoundation) {
            // If this dialog is opened and then disconnected, we want to close
            // the foundation, so that 1) any pending timers are cancelled
            // (in particular for trapFocus), and 2) if we reconnect, we can open
            // the foundation again to retrigger animations and focus.
            this.removeEventListeners();
            this.closingDueToDisconnect = true;
            this.mdcFoundation.close(this.currentAction || this.defaultAction);
            this.closingDueToDisconnect = false;
            this.currentAction = undefined;
            // When we close normally, the releaseFocus callback handles removing
            // ourselves from the blocking elements stack. However, that callback
            // happens on a delay, and when we are closing due to a disconnect we
            // need to remove ourselves before the blocking element polyfill's
            // mutation observer notices and logs a warning, since it's not valid to
            // be in the blocking elements stack while disconnected.
            $ff35184d57cb5079$var$blockingElements.remove(this);
        }
    }
    forceLayout() {
        this.mdcFoundation.layout();
    }
    focus() {
        const initialFocusEl = this.getInitialFocusEl();
        initialFocusEl && initialFocusEl.focus();
    }
    blur() {
        if (!this.shadowRoot) return;
        const activeEl = this.shadowRoot.activeElement;
        if (activeEl) {
            if (activeEl instanceof HTMLElement) activeEl.blur();
        } else {
            const root = this.getRootNode();
            const activeEl = root instanceof Document ? root.activeElement : null;
            if (activeEl instanceof HTMLElement) activeEl.blur();
        }
    }
    setEventListeners() {
        if (this.boundHandleClick) this.mdcRoot.addEventListener('click', this.boundHandleClick);
        if (this.boundHandleKeydown) this.mdcRoot.addEventListener('keydown', this.boundHandleKeydown, (0, $3a56503555e3a29c$export$82e1592afef3b60f)());
        if (this.boundHandleDocumentKeydown) document.addEventListener('keydown', this.boundHandleDocumentKeydown, (0, $3a56503555e3a29c$export$82e1592afef3b60f)());
    }
    removeEventListeners() {
        if (this.boundHandleClick) this.mdcRoot.removeEventListener('click', this.boundHandleClick);
        if (this.boundHandleKeydown) this.mdcRoot.removeEventListener('keydown', this.boundHandleKeydown);
        if (this.boundHandleDocumentKeydown) document.removeEventListener('keydown', this.boundHandleDocumentKeydown);
    }
    close() {
        this.open = false;
    }
    show() {
        this.open = true;
    }
}
(0, $czHfO.__decorate)([
    (0, $ae0690fab2767131$export$2fa187e846a241c4)('.mdc-dialog')
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $ae0690fab2767131$export$2fa187e846a241c4)('slot[name="primaryAction"]')
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "primarySlot", void 0);
(0, $czHfO.__decorate)([
    (0, $ae0690fab2767131$export$2fa187e846a241c4)('slot[name="secondaryAction"]')
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "secondarySlot", void 0);
(0, $czHfO.__decorate)([
    (0, $ae0690fab2767131$export$2fa187e846a241c4)('#contentSlot')
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "contentSlot", void 0);
(0, $czHfO.__decorate)([
    (0, $ae0690fab2767131$export$2fa187e846a241c4)('.mdc-dialog__content')
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "contentElement", void 0);
(0, $czHfO.__decorate)([
    (0, $ae0690fab2767131$export$2fa187e846a241c4)('.mdc-container')
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "conatinerElement", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)({
        type: Boolean
    })
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "hideActions", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $k4Ngf.observer)(function() {
        this.forceLayout();
    })
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "stacked", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)({
        type: String
    })
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "heading", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $k4Ngf.observer)(function(newAction) {
        this.mdcFoundation.setScrimClickAction(newAction);
    })
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "scrimClickAction", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $k4Ngf.observer)(function(newAction) {
        this.mdcFoundation.setEscapeKeyAction(newAction);
    })
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "escapeKeyAction", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $k4Ngf.observer)(function(isOpen) {
        // Check isConnected because we could have been disconnected before first
        // update. If we're now closed, then we shouldn't start the MDC foundation
        // opening animation. If we're now closed, then we've already closed the
        // foundation in disconnectedCallback.
        if (this.mdcFoundation && this.isConnected) {
            if (isOpen) {
                this.setEventListeners();
                this.mdcFoundation.open();
            } else {
                this.removeEventListeners();
                this.mdcFoundation.close(this.currentAction || this.defaultAction);
                this.currentAction = undefined;
            }
        }
    })
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "open", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)()
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "defaultAction", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)()
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "actionAttribute", void 0);
(0, $czHfO.__decorate)([
    (0, $b3ad0a5fe35f4222$export$d541bacb2bda4494)()
], $ff35184d57cb5079$export$569e42c9a98af7b7.prototype, "initialFocusAttribute", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $3687c0716c1f27db$export$9dd6ff9ea0189349 = (0, $726575774620c042$export$dbf350e5966cf602)`.mdc-dialog .mdc-dialog__surface{background-color:#fff;background-color:var(--mdc-theme-surface, #fff)}.mdc-dialog .mdc-dialog__scrim{background-color:rgba(0,0,0,.32)}.mdc-dialog .mdc-dialog__surface-scrim{background-color:rgba(0,0,0,.32)}.mdc-dialog .mdc-dialog__title{color:rgba(0,0,0,.87)}.mdc-dialog .mdc-dialog__content{color:rgba(0,0,0,.6)}.mdc-dialog .mdc-dialog__close{color:#000;color:var(--mdc-theme-on-surface, #000)}.mdc-dialog .mdc-dialog__close .mdc-icon-button__ripple::before,.mdc-dialog .mdc-dialog__close .mdc-icon-button__ripple::after{background-color:#000;background-color:var(--mdc-ripple-color, var(--mdc-theme-on-surface, #000))}.mdc-dialog .mdc-dialog__close:hover .mdc-icon-button__ripple::before,.mdc-dialog .mdc-dialog__close.mdc-ripple-surface--hover .mdc-icon-button__ripple::before{opacity:0.04;opacity:var(--mdc-ripple-hover-opacity, 0.04)}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded--background-focused .mdc-icon-button__ripple::before,.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):focus .mdc-icon-button__ripple::before{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-focus-opacity, 0.12)}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded) .mdc-icon-button__ripple::after{transition:opacity 150ms linear}.mdc-dialog .mdc-dialog__close:not(.mdc-ripple-upgraded):active .mdc-icon-button__ripple::after{transition-duration:75ms;opacity:0.12;opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-dialog .mdc-dialog__close.mdc-ripple-upgraded{--mdc-ripple-fg-opacity:var(--mdc-ripple-press-opacity, 0.12)}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title,.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__actions,.mdc-dialog.mdc-dialog--scrollable.mdc-dialog-scroll-divider-footer .mdc-dialog__actions{border-color:rgba(0,0,0,.12)}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:1px solid rgba(0,0,0,.12);margin-bottom:0}.mdc-dialog.mdc-dialog-scroll-divider-header.mdc-dialog--fullscreen .mdc-dialog__header{box-shadow:0px 3px 1px -2px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 1px 5px 0px rgba(0,0,0,.12)}.mdc-dialog .mdc-dialog__surface{border-radius:4px;border-radius:var(--mdc-shape-medium, 4px)}.mdc-dialog__surface{box-shadow:0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0,0,0,.12)}.mdc-dialog__title{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-headline6-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1.25rem;font-size:var(--mdc-typography-headline6-font-size, 1.25rem);line-height:2rem;line-height:var(--mdc-typography-headline6-line-height, 2rem);font-weight:500;font-weight:var(--mdc-typography-headline6-font-weight, 500);letter-spacing:0.0125em;letter-spacing:var(--mdc-typography-headline6-letter-spacing, 0.0125em);text-decoration:inherit;text-decoration:var(--mdc-typography-headline6-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-headline6-text-transform, inherit)}.mdc-dialog__content{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-body1-font-size, 1rem);line-height:1.5rem;line-height:var(--mdc-typography-body1-line-height, 1.5rem);font-weight:400;font-weight:var(--mdc-typography-body1-font-weight, 400);letter-spacing:0.03125em;letter-spacing:var(--mdc-typography-body1-letter-spacing, 0.03125em);text-decoration:inherit;text-decoration:var(--mdc-typography-body1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body1-text-transform, inherit)}.mdc-elevation-overlay{position:absolute;border-radius:inherit;pointer-events:none;opacity:0;opacity:var(--mdc-elevation-overlay-opacity, 0);transition:opacity 280ms cubic-bezier(0.4, 0, 0.2, 1);background-color:#fff;background-color:var(--mdc-elevation-overlay-color, #fff)}.mdc-dialog,.mdc-dialog__scrim{position:fixed;top:0;left:0;align-items:center;justify-content:center;box-sizing:border-box;width:100%;height:100%}.mdc-dialog{display:none;z-index:7;z-index:var(--mdc-dialog-z-index, 7)}.mdc-dialog .mdc-dialog__content{padding:20px 24px 20px 24px}.mdc-dialog .mdc-dialog__surface{min-width:280px}@media(max-width: 592px){.mdc-dialog .mdc-dialog__surface{max-width:calc(100vw - 32px)}}@media(min-width: 592px){.mdc-dialog .mdc-dialog__surface{max-width:560px}}.mdc-dialog .mdc-dialog__surface{max-height:calc(100% - 32px)}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-width:none}@media(max-width: 960px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:560px;width:560px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media(max-width: 720px)and (max-width: 672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{width:calc(100vw - 112px)}}@media(max-width: 720px)and (min-width: 672px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{width:560px}}@media(max-width: 720px)and (max-height: 720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:calc(100vh - 160px)}}@media(max-width: 720px)and (min-height: 720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{max-height:560px}}@media(max-width: 720px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}@media(max-width: 720px)and (max-height: 400px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{height:100%;max-height:100vh;max-width:100vw;width:100vw;border-radius:0}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{padding:0 16px 9px;justify-content:flex-start}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:calc(16px - 2 * 12px)}}@media(max-width: 600px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{height:100%;max-height:100vh;max-width:100vw;width:100vw;border-radius:0}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{order:-1;left:-12px}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__header{padding:0 16px 9px;justify-content:flex-start}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__title{margin-left:calc(16px - 2 * 12px)}}@media(min-width: 960px){.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface{width:calc(100vw - 400px)}.mdc-dialog.mdc-dialog--fullscreen .mdc-dialog__surface .mdc-dialog__close{right:-12px}}.mdc-dialog.mdc-dialog__scrim--hidden .mdc-dialog__scrim{opacity:0}.mdc-dialog__scrim{opacity:0;z-index:-1}.mdc-dialog__container{display:flex;flex-direction:row;align-items:center;justify-content:space-around;box-sizing:border-box;height:100%;transform:scale(0.8);opacity:0;pointer-events:none}.mdc-dialog__surface{position:relative;display:flex;flex-direction:column;flex-grow:0;flex-shrink:0;box-sizing:border-box;max-width:100%;max-height:100%;pointer-events:auto;overflow-y:auto}.mdc-dialog__surface .mdc-elevation-overlay{width:100%;height:100%;top:0;left:0}[dir=rtl] .mdc-dialog__surface,.mdc-dialog__surface[dir=rtl]{text-align:right}@media screen and (forced-colors: active),(-ms-high-contrast: active){.mdc-dialog__surface{outline:2px solid windowText}}.mdc-dialog__surface::before{position:absolute;box-sizing:border-box;width:100%;height:100%;top:0;left:0;border:2px solid transparent;border-radius:inherit;content:"";pointer-events:none}@media screen and (forced-colors: active){.mdc-dialog__surface::before{border-color:CanvasText}}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.mdc-dialog__surface::before{content:none}}.mdc-dialog__title{display:block;margin-top:0;position:relative;flex-shrink:0;box-sizing:border-box;margin:0 0 1px;padding:0 24px 9px}.mdc-dialog__title::before{display:inline-block;width:0;height:40px;content:"";vertical-align:0}[dir=rtl] .mdc-dialog__title,.mdc-dialog__title[dir=rtl]{text-align:right}.mdc-dialog--scrollable .mdc-dialog__title{margin-bottom:1px;padding-bottom:15px}.mdc-dialog--fullscreen .mdc-dialog__header{align-items:baseline;border-bottom:1px solid transparent;display:inline-flex;justify-content:space-between;padding:0 24px 9px;z-index:1}@media screen and (forced-colors: active){.mdc-dialog--fullscreen .mdc-dialog__header{border-bottom-color:CanvasText}}.mdc-dialog--fullscreen .mdc-dialog__header .mdc-dialog__close{right:-12px}.mdc-dialog--fullscreen .mdc-dialog__title{margin-bottom:0;padding:0;border-bottom:0}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__title{border-bottom:0;margin-bottom:0}.mdc-dialog--fullscreen .mdc-dialog__close{top:5px}.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__actions{border-top:1px solid transparent}@media screen and (forced-colors: active){.mdc-dialog--fullscreen.mdc-dialog--scrollable .mdc-dialog__actions{border-top-color:CanvasText}}.mdc-dialog__content{flex-grow:1;box-sizing:border-box;margin:0;overflow:auto}.mdc-dialog__content>:first-child{margin-top:0}.mdc-dialog__content>:last-child{margin-bottom:0}.mdc-dialog__title+.mdc-dialog__content,.mdc-dialog__header+.mdc-dialog__content{padding-top:0}.mdc-dialog--scrollable .mdc-dialog__title+.mdc-dialog__content{padding-top:8px;padding-bottom:8px}.mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:6px 0 0}.mdc-dialog--scrollable .mdc-dialog__content .mdc-deprecated-list:first-child:last-child{padding:0}.mdc-dialog__actions{display:flex;position:relative;flex-shrink:0;flex-wrap:wrap;align-items:center;justify-content:flex-end;box-sizing:border-box;min-height:52px;margin:0;padding:8px;border-top:1px solid transparent}@media screen and (forced-colors: active){.mdc-dialog__actions{border-top-color:CanvasText}}.mdc-dialog--stacked .mdc-dialog__actions{flex-direction:column;align-items:flex-end}.mdc-dialog__button{margin-left:8px;margin-right:0;max-width:100%;text-align:right}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{margin-left:0;margin-right:8px}.mdc-dialog__button:first-child{margin-left:0;margin-right:0}[dir=rtl] .mdc-dialog__button:first-child,.mdc-dialog__button:first-child[dir=rtl]{margin-left:0;margin-right:0}[dir=rtl] .mdc-dialog__button,.mdc-dialog__button[dir=rtl]{text-align:left}.mdc-dialog--stacked .mdc-dialog__button:not(:first-child){margin-top:12px}.mdc-dialog--open,.mdc-dialog--opening,.mdc-dialog--closing{display:flex}.mdc-dialog--opening .mdc-dialog__scrim{transition:opacity 150ms linear}.mdc-dialog--opening .mdc-dialog__container{transition:opacity 75ms linear,transform 150ms 0ms cubic-bezier(0, 0, 0.2, 1)}.mdc-dialog--closing .mdc-dialog__scrim,.mdc-dialog--closing .mdc-dialog__container{transition:opacity 75ms linear}.mdc-dialog--closing .mdc-dialog__container{transform:none}.mdc-dialog--open .mdc-dialog__scrim{opacity:1}.mdc-dialog--open .mdc-dialog__container{transform:none;opacity:1}.mdc-dialog--open.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim{opacity:1;z-index:1}.mdc-dialog--open.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{transition:opacity 75ms linear}.mdc-dialog--open.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim{transition:opacity 150ms linear}.mdc-dialog__surface-scrim{display:none;opacity:0;position:absolute;width:100%;height:100%}.mdc-dialog__surface-scrim--shown .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--showing .mdc-dialog__surface-scrim,.mdc-dialog__surface-scrim--hiding .mdc-dialog__surface-scrim{display:block}.mdc-dialog-scroll-lock{overflow:hidden}.mdc-dialog--no-content-padding .mdc-dialog__content{padding:0}.mdc-dialog--sheet .mdc-dialog__close{right:12px;top:9px;position:absolute;z-index:1}#actions:not(.mdc-dialog__actions){display:none}.mdc-dialog__surface{box-shadow:var(--mdc-dialog-box-shadow, 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12))}@media(min-width: 560px){.mdc-dialog .mdc-dialog__surface{max-width:560px;max-width:var(--mdc-dialog-max-width, 560px)}}.mdc-dialog .mdc-dialog__scrim{background-color:rgba(0, 0, 0, 0.32);background-color:var(--mdc-dialog-scrim-color, rgba(0, 0, 0, 0.32))}.mdc-dialog .mdc-dialog__title{color:rgba(0, 0, 0, 0.87);color:var(--mdc-dialog-heading-ink-color, rgba(0, 0, 0, 0.87))}.mdc-dialog .mdc-dialog__content{color:rgba(0, 0, 0, 0.6);color:var(--mdc-dialog-content-ink-color, rgba(0, 0, 0, 0.6))}.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__title,.mdc-dialog.mdc-dialog--scrollable .mdc-dialog__actions{border-color:rgba(0, 0, 0, 0.12);border-color:var(--mdc-dialog-scroll-divider-color, rgba(0, 0, 0, 0.12))}.mdc-dialog .mdc-dialog__surface{min-width:280px;min-width:var(--mdc-dialog-min-width, 280px)}.mdc-dialog .mdc-dialog__surface{max-height:var(--mdc-dialog-max-height, calc(100% - 32px))}#actions ::slotted(*){margin-left:8px;margin-right:0;max-width:100%;text-align:right}[dir=rtl] #actions ::slotted(*),#actions ::slotted(*[dir=rtl]){margin-left:0;margin-right:8px}[dir=rtl] #actions ::slotted(*),#actions ::slotted(*[dir=rtl]){text-align:left}.mdc-dialog--stacked #actions{flex-direction:column-reverse}.mdc-dialog--stacked #actions *:not(:last-child) ::slotted(*){flex-basis:.000000001px;margin-top:12px}`;


let $b3b0be2f44ca574d$export$3ddf2d174ce01153 = class Dialog extends (0, $ff35184d57cb5079$export$569e42c9a98af7b7) {
};
$b3b0be2f44ca574d$export$3ddf2d174ce01153.styles = [
    (0, $3687c0716c1f27db$export$9dd6ff9ea0189349)
];
$b3b0be2f44ca574d$export$3ddf2d174ce01153 = (0, $czHfO.__decorate)([
    (0, $aad64538e1539f1f$export$da64fc29f17f9d0e)('mwc-dialog')
], $b3b0be2f44ca574d$export$3ddf2d174ce01153);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f06e04512dfe3b3d$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $ea23336b77775fcf$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $ea23336b77775fcf$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $ea23336b77775fcf$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $ea23336b77775fcf$var$e(n, t, o) : $ea23336b77775fcf$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c1884e33bd521cfb$export$ca000e230c0caa3e(t) {
    return (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $448bff2ad3f5dce0$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $448bff2ad3f5dce0$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $448bff2ad3f5dce0$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $10a489db51715441$export$b2b799818fbabcf3(e) {
    return (0, $448bff2ad3f5dce0$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7c5121c1c38448b3$export$2fa187e846a241c4(i, n) {
    return (0, $448bff2ad3f5dce0$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $4e697d1390faaf42$export$dcd0d083aa86c355(e) {
    return (0, $448bff2ad3f5dce0$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $4767c1f9f430470e$export$163dfc35cc43f240(e) {
    return (0, $448bff2ad3f5dce0$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $902e2e504aad4177$var$n;
const $902e2e504aad4177$var$e = null != (null === ($902e2e504aad4177$var$n = window.HTMLSlotElement) || void 0 === $902e2e504aad4177$var$n ? void 0 : $902e2e504aad4177$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $902e2e504aad4177$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $448bff2ad3f5dce0$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $902e2e504aad4177$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c3ef3cefb9b61ba4$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $902e2e504aad4177$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $448bff2ad3f5dce0$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("aX7Bm");

var $k4Ngf = parcelRequire("k4Ngf");

var $2qnKN = parcelRequire("2qnKN");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9a9518a2664ee96e$var$t = window, $9a9518a2664ee96e$export$b4d10f6001c083c2 = $9a9518a2664ee96e$var$t.ShadowRoot && (void 0 === $9a9518a2664ee96e$var$t.ShadyCSS || $9a9518a2664ee96e$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $9a9518a2664ee96e$var$s = Symbol(), $9a9518a2664ee96e$var$n = new WeakMap;
class $9a9518a2664ee96e$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $9a9518a2664ee96e$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($9a9518a2664ee96e$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $9a9518a2664ee96e$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $9a9518a2664ee96e$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $9a9518a2664ee96e$export$8d80f9cac07cdb3 = (t)=>new $9a9518a2664ee96e$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $9a9518a2664ee96e$var$s), $9a9518a2664ee96e$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $9a9518a2664ee96e$export$505d1e8739bad805(n, t, $9a9518a2664ee96e$var$s);
}, $9a9518a2664ee96e$export$2ca4a66ec4cecb90 = (s, n)=>{
    $9a9518a2664ee96e$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $9a9518a2664ee96e$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $9a9518a2664ee96e$export$ee69dfd951e24778 = $9a9518a2664ee96e$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $9a9518a2664ee96e$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $261ab7bd3035fdfd$var$s;
const $261ab7bd3035fdfd$var$e = window, $261ab7bd3035fdfd$var$r = $261ab7bd3035fdfd$var$e.trustedTypes, $261ab7bd3035fdfd$var$h = $261ab7bd3035fdfd$var$r ? $261ab7bd3035fdfd$var$r.emptyScript : "", $261ab7bd3035fdfd$var$o = $261ab7bd3035fdfd$var$e.reactiveElementPolyfillSupport, $261ab7bd3035fdfd$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $261ab7bd3035fdfd$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $261ab7bd3035fdfd$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $261ab7bd3035fdfd$var$l = {
    attribute: !0,
    type: String,
    converter: $261ab7bd3035fdfd$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $261ab7bd3035fdfd$export$53a6892c50694894
}, $261ab7bd3035fdfd$var$d = "finalized";
class $261ab7bd3035fdfd$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $261ab7bd3035fdfd$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $261ab7bd3035fdfd$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($261ab7bd3035fdfd$var$d)) return !1;
        this[$261ab7bd3035fdfd$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $9a9518a2664ee96e$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $9a9518a2664ee96e$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $9a9518a2664ee96e$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $261ab7bd3035fdfd$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $261ab7bd3035fdfd$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $261ab7bd3035fdfd$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $261ab7bd3035fdfd$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$261ab7bd3035fdfd$export$c7c07a37856565d[$261ab7bd3035fdfd$var$d] = !0, $261ab7bd3035fdfd$export$c7c07a37856565d.elementProperties = new Map, $261ab7bd3035fdfd$export$c7c07a37856565d.elementStyles = [], $261ab7bd3035fdfd$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $261ab7bd3035fdfd$var$o || $261ab7bd3035fdfd$var$o({
    ReactiveElement: $261ab7bd3035fdfd$export$c7c07a37856565d
}), (null !== ($261ab7bd3035fdfd$var$s = $261ab7bd3035fdfd$var$e.reactiveElementVersions) && void 0 !== $261ab7bd3035fdfd$var$s ? $261ab7bd3035fdfd$var$s : $261ab7bd3035fdfd$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $6405b2275767d4a5$var$t;
const $6405b2275767d4a5$var$i = window, $6405b2275767d4a5$var$s = $6405b2275767d4a5$var$i.trustedTypes, $6405b2275767d4a5$var$e = $6405b2275767d4a5$var$s ? $6405b2275767d4a5$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $6405b2275767d4a5$var$o = "$lit$", $6405b2275767d4a5$var$n = `lit$${(Math.random() + "").slice(9)}$`, $6405b2275767d4a5$var$l = "?" + $6405b2275767d4a5$var$n, $6405b2275767d4a5$var$h = `<${$6405b2275767d4a5$var$l}>`, $6405b2275767d4a5$var$r = document, $6405b2275767d4a5$var$u = ()=>$6405b2275767d4a5$var$r.createComment(""), $6405b2275767d4a5$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $6405b2275767d4a5$var$c = Array.isArray, $6405b2275767d4a5$var$v = (t)=>$6405b2275767d4a5$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $6405b2275767d4a5$var$a = "[ \t\n\f\r]", $6405b2275767d4a5$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $6405b2275767d4a5$var$_ = /-->/g, $6405b2275767d4a5$var$m = />/g, $6405b2275767d4a5$var$p = RegExp(`>|${$6405b2275767d4a5$var$a}(?:([^\\s"'>=/]+)(${$6405b2275767d4a5$var$a}*=${$6405b2275767d4a5$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $6405b2275767d4a5$var$g = /'/g, $6405b2275767d4a5$var$$ = /"/g, $6405b2275767d4a5$var$y = /^(?:script|style|textarea|title)$/i, $6405b2275767d4a5$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $6405b2275767d4a5$export$c0bb0b647f701bb5 = $6405b2275767d4a5$var$w(1), $6405b2275767d4a5$export$7ed1367e7fa1ad68 = $6405b2275767d4a5$var$w(2), $6405b2275767d4a5$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $6405b2275767d4a5$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $6405b2275767d4a5$var$E = new WeakMap, $6405b2275767d4a5$var$C = $6405b2275767d4a5$var$r.createTreeWalker($6405b2275767d4a5$var$r, 129, null, !1);
function $6405b2275767d4a5$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $6405b2275767d4a5$var$e ? $6405b2275767d4a5$var$e.createHTML(i) : i;
}
const $6405b2275767d4a5$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $6405b2275767d4a5$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $6405b2275767d4a5$var$f ? "!--" === c[1] ? u = $6405b2275767d4a5$var$_ : void 0 !== c[1] ? u = $6405b2275767d4a5$var$m : void 0 !== c[2] ? ($6405b2275767d4a5$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $6405b2275767d4a5$var$p) : void 0 !== c[3] && (u = $6405b2275767d4a5$var$p) : u === $6405b2275767d4a5$var$p ? ">" === c[0] ? (u = null != l ? l : $6405b2275767d4a5$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $6405b2275767d4a5$var$p : '"' === c[3] ? $6405b2275767d4a5$var$$ : $6405b2275767d4a5$var$g) : u === $6405b2275767d4a5$var$$ || u === $6405b2275767d4a5$var$g ? u = $6405b2275767d4a5$var$p : u === $6405b2275767d4a5$var$_ || u === $6405b2275767d4a5$var$m ? u = $6405b2275767d4a5$var$f : (u = $6405b2275767d4a5$var$p, l = void 0);
        const w = u === $6405b2275767d4a5$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $6405b2275767d4a5$var$f ? s + $6405b2275767d4a5$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $6405b2275767d4a5$var$o + s.slice(v) + $6405b2275767d4a5$var$n + w) : s + $6405b2275767d4a5$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $6405b2275767d4a5$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $6405b2275767d4a5$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $6405b2275767d4a5$var$V(t, i);
        if (this.el = $6405b2275767d4a5$var$N.createElement(a, e), $6405b2275767d4a5$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $6405b2275767d4a5$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($6405b2275767d4a5$var$o) || i.startsWith($6405b2275767d4a5$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $6405b2275767d4a5$var$o).split($6405b2275767d4a5$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $6405b2275767d4a5$var$H : "?" === i[1] ? $6405b2275767d4a5$var$L : "@" === i[1] ? $6405b2275767d4a5$var$z : $6405b2275767d4a5$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($6405b2275767d4a5$var$y.test(h.tagName)) {
                    const t = h.textContent.split($6405b2275767d4a5$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $6405b2275767d4a5$var$s ? $6405b2275767d4a5$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $6405b2275767d4a5$var$u()), $6405b2275767d4a5$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $6405b2275767d4a5$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $6405b2275767d4a5$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($6405b2275767d4a5$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $6405b2275767d4a5$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $6405b2275767d4a5$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $6405b2275767d4a5$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $6405b2275767d4a5$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $6405b2275767d4a5$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $6405b2275767d4a5$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $6405b2275767d4a5$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $6405b2275767d4a5$var$r).importNode(s, !0);
        $6405b2275767d4a5$var$C.currentNode = o;
        let n = $6405b2275767d4a5$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $6405b2275767d4a5$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $6405b2275767d4a5$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $6405b2275767d4a5$var$C.nextNode(), l++);
        }
        return $6405b2275767d4a5$var$C.currentNode = $6405b2275767d4a5$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $6405b2275767d4a5$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $6405b2275767d4a5$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $6405b2275767d4a5$var$S(this, t, i), $6405b2275767d4a5$var$d(t) ? t === $6405b2275767d4a5$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $6405b2275767d4a5$export$45b790e32b2810ee && this._$AR(), this._$AH = $6405b2275767d4a5$export$45b790e32b2810ee) : t !== this._$AH && t !== $6405b2275767d4a5$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $6405b2275767d4a5$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $6405b2275767d4a5$export$45b790e32b2810ee && $6405b2275767d4a5$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($6405b2275767d4a5$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $6405b2275767d4a5$var$N.createElement($6405b2275767d4a5$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $6405b2275767d4a5$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $6405b2275767d4a5$var$E.get(t.strings);
        return void 0 === i && $6405b2275767d4a5$var$E.set(t.strings, i = new $6405b2275767d4a5$var$N(t)), i;
    }
    T(t) {
        $6405b2275767d4a5$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $6405b2275767d4a5$var$R(this.k($6405b2275767d4a5$var$u()), this.k($6405b2275767d4a5$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $6405b2275767d4a5$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $6405b2275767d4a5$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $6405b2275767d4a5$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $6405b2275767d4a5$var$S(this, t, i, 0), n = !$6405b2275767d4a5$var$d(t) || t !== this._$AH && t !== $6405b2275767d4a5$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $6405b2275767d4a5$var$S(this, e[s + l], i, l), h === $6405b2275767d4a5$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$6405b2275767d4a5$var$d(h) || h !== this._$AH[l]), h === $6405b2275767d4a5$export$45b790e32b2810ee ? t = $6405b2275767d4a5$export$45b790e32b2810ee : t !== $6405b2275767d4a5$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $6405b2275767d4a5$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $6405b2275767d4a5$var$H extends $6405b2275767d4a5$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $6405b2275767d4a5$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $6405b2275767d4a5$var$I = $6405b2275767d4a5$var$s ? $6405b2275767d4a5$var$s.emptyScript : "";
class $6405b2275767d4a5$var$L extends $6405b2275767d4a5$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $6405b2275767d4a5$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $6405b2275767d4a5$var$I) : this.element.removeAttribute(this.name);
    }
}
class $6405b2275767d4a5$var$z extends $6405b2275767d4a5$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $6405b2275767d4a5$var$S(this, t, i, 0)) && void 0 !== s ? s : $6405b2275767d4a5$export$45b790e32b2810ee) === $6405b2275767d4a5$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $6405b2275767d4a5$export$45b790e32b2810ee && e !== $6405b2275767d4a5$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $6405b2275767d4a5$export$45b790e32b2810ee && (e === $6405b2275767d4a5$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $6405b2275767d4a5$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $6405b2275767d4a5$var$S(this, t);
    }
}
const $6405b2275767d4a5$export$8613d1ca9052b22e = {
    O: $6405b2275767d4a5$var$o,
    P: $6405b2275767d4a5$var$n,
    A: $6405b2275767d4a5$var$l,
    C: 1,
    M: $6405b2275767d4a5$var$V,
    L: $6405b2275767d4a5$var$M,
    R: $6405b2275767d4a5$var$v,
    D: $6405b2275767d4a5$var$S,
    I: $6405b2275767d4a5$var$R,
    V: $6405b2275767d4a5$var$k,
    H: $6405b2275767d4a5$var$L,
    N: $6405b2275767d4a5$var$z,
    U: $6405b2275767d4a5$var$H,
    F: $6405b2275767d4a5$var$Z
}, $6405b2275767d4a5$var$B = $6405b2275767d4a5$var$i.litHtmlPolyfillSupport;
null == $6405b2275767d4a5$var$B || $6405b2275767d4a5$var$B($6405b2275767d4a5$var$N, $6405b2275767d4a5$var$R), (null !== ($6405b2275767d4a5$var$t = $6405b2275767d4a5$var$i.litHtmlVersions) && void 0 !== $6405b2275767d4a5$var$t ? $6405b2275767d4a5$var$t : $6405b2275767d4a5$var$i.litHtmlVersions = []).push("2.8.0");
const $6405b2275767d4a5$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $6405b2275767d4a5$var$R(i.insertBefore($6405b2275767d4a5$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $5b07a0e31bee6796$var$l, $5b07a0e31bee6796$var$o;
const $5b07a0e31bee6796$export$8bf27daf9e8907c9 = (0, $261ab7bd3035fdfd$export$c7c07a37856565d);
class $5b07a0e31bee6796$export$3f2f9f5909897157 extends (0, $261ab7bd3035fdfd$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $6405b2275767d4a5$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $6405b2275767d4a5$export$9c068ae9cc5db4e8;
    }
}
$5b07a0e31bee6796$export$3f2f9f5909897157.finalized = !0, $5b07a0e31bee6796$export$3f2f9f5909897157._$litElement$ = !0, null === ($5b07a0e31bee6796$var$l = globalThis.litElementHydrateSupport) || void 0 === $5b07a0e31bee6796$var$l || $5b07a0e31bee6796$var$l.call(globalThis, {
    LitElement: $5b07a0e31bee6796$export$3f2f9f5909897157
});
const $5b07a0e31bee6796$var$n = globalThis.litElementPolyfillSupport;
null == $5b07a0e31bee6796$var$n || $5b07a0e31bee6796$var$n({
    LitElement: $5b07a0e31bee6796$export$3f2f9f5909897157
});
const $5b07a0e31bee6796$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($5b07a0e31bee6796$var$o = globalThis.litElementVersions) && void 0 !== $5b07a0e31bee6796$var$o ? $5b07a0e31bee6796$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $28ddb8ceeaf7e8d9$export$6acf61af03e62db = !1;






/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $563a963bffe9387a$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $563a963bffe9387a$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $563a963bffe9387a$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $49425fdcca742a3e$export$56cc687933817664 = (0, $563a963bffe9387a$export$99b43ad1ed32e735)(class extends (0, $563a963bffe9387a$export$befdefbdce210f91) {
    constructor(t){
        var i;
        if (super(t), t.type !== (0, $563a963bffe9387a$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || (null === (i = t.strings) || void 0 === i ? void 0 : i.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((i)=>t[i]).join(" ") + " ";
    }
    update(i, [s]) {
        var r, o;
        if (void 0 === this.it) {
            this.it = new Set, void 0 !== i.strings && (this.nt = new Set(i.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !(null === (r = this.nt) || void 0 === r ? void 0 : r.has(t)) && this.it.add(t);
            return this.render(s);
        }
        const e = i.element.classList;
        this.it.forEach((t)=>{
            t in s || (e.remove(t), this.it.delete(t));
        });
        for(const t in s){
            const i = !!s[t];
            i === this.it.has(t) || (null === (o = this.nt) || void 0 === o ? void 0 : o.has(t)) || (i ? (e.add(t), this.it.add(t)) : (e.remove(t), this.it.delete(t)));
        }
        return 0, $6405b2275767d4a5$export$9c068ae9cc5db4e8;
    }
});




class $07424e342e0f9bfb$export$a2e32775fe3b6225 extends (0, $5b07a0e31bee6796$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.value = '';
        this.group = null;
        this.tabindex = -1;
        this.disabled = false;
        this.twoline = false;
        this.activated = false;
        this.graphic = null;
        this.multipleGraphics = false;
        this.hasMeta = false;
        this.noninteractive = false;
        this.selected = false;
        this.shouldRenderRipple = false;
        this._managingList = null;
        this.boundOnClick = this.onClick.bind(this);
        this._firstChanged = true;
        this._skipPropRequest = false;
        this.rippleHandlers = new (0, $2qnKN.RippleHandlers)(()=>{
            this.shouldRenderRipple = true;
            return this.ripple;
        });
        this.listeners = [
            {
                target: this,
                eventNames: [
                    'click'
                ],
                cb: ()=>{
                    this.onClick();
                }
            },
            {
                target: this,
                eventNames: [
                    'mouseenter'
                ],
                cb: this.rippleHandlers.startHover
            },
            {
                target: this,
                eventNames: [
                    'mouseleave'
                ],
                cb: this.rippleHandlers.endHover
            },
            {
                target: this,
                eventNames: [
                    'focus'
                ],
                cb: this.rippleHandlers.startFocus
            },
            {
                target: this,
                eventNames: [
                    'blur'
                ],
                cb: this.rippleHandlers.endFocus
            },
            {
                target: this,
                eventNames: [
                    'mousedown',
                    'touchstart'
                ],
                cb: (e)=>{
                    const name = e.type;
                    this.onDown(name === 'mousedown' ? 'mouseup' : 'touchend', e);
                }
            }
        ];
    }
    get text() {
        const textContent = this.textContent;
        return textContent ? textContent.trim() : '';
    }
    render() {
        const text = this.renderText();
        const graphic = this.graphic ? this.renderGraphic() : (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)``;
        const meta = this.hasMeta ? this.renderMeta() : (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)``;
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      ${this.renderRipple()}
      ${graphic}
      ${text}
      ${meta}`;
    }
    renderRipple() {
        if (this.shouldRenderRipple) return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      <mwc-ripple
        .activated=${this.activated}>
      </mwc-ripple>`;
        else if (this.activated) return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`<div class="fake-activated-ripple"></div>`;
        else return '';
    }
    renderGraphic() {
        const graphicClasses = {
            multi: this.multipleGraphics
        };
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__graphic material-icons ${(0, $49425fdcca742a3e$export$56cc687933817664)(graphicClasses)}">
        <slot name="graphic"></slot>
      </span>`;
    }
    renderMeta() {
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__meta material-icons">
        <slot name="meta"></slot>
      </span>`;
    }
    renderText() {
        const inner = this.twoline ? this.renderTwoline() : this.renderSingleLine();
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__text">
        ${inner}
      </span>`;
    }
    renderSingleLine() {
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
    renderTwoline() {
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      <span class="mdc-deprecated-list-item__primary-text">
        <slot></slot>
      </span>
      <span class="mdc-deprecated-list-item__secondary-text">
        <slot name="secondary"></slot>
      </span>
    `;
    }
    onClick() {
        this.fireRequestSelected(!this.selected, 'interaction');
    }
    onDown(upName, evt) {
        const onUp = ()=>{
            window.removeEventListener(upName, onUp);
            this.rippleHandlers.endPress();
        };
        window.addEventListener(upName, onUp);
        this.rippleHandlers.startPress(evt);
    }
    fireRequestSelected(selected, source) {
        if (this.noninteractive) return;
        const customEv = new CustomEvent('request-selected', {
            bubbles: true,
            composed: true,
            detail: {
                source: source,
                selected: selected
            }
        });
        this.dispatchEvent(customEv);
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.noninteractive) this.setAttribute('mwc-list-item', '');
        for (const listener of this.listeners)for (const eventName of listener.eventNames)listener.target.addEventListener(eventName, listener.cb, {
            passive: true
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        for (const listener of this.listeners)for (const eventName of listener.eventNames)listener.target.removeEventListener(eventName, listener.cb);
        if (this._managingList) this._managingList.debouncedLayout ? this._managingList.debouncedLayout(true) : this._managingList.layout(true);
    }
    // composed flag, event fire through shadow root and up through composed tree
    firstUpdated() {
        const ev = new Event('list-item-rendered', {
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(ev);
    }
}
(0, $czHfO.__decorate)([
    (0, $7c5121c1c38448b3$export$2fa187e846a241c4)('slot')
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "slotElement", void 0);
(0, $czHfO.__decorate)([
    (0, $4767c1f9f430470e$export$163dfc35cc43f240)('mwc-ripple')
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "ripple", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "value", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "group", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "tabindex", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $k4Ngf.observer)(function(value) {
        if (value) this.setAttribute('aria-disabled', 'true');
        else this.setAttribute('aria-disabled', 'false');
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "disabled", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "twoline", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "activated", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "graphic", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "multipleGraphics", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "hasMeta", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $k4Ngf.observer)(function(value) {
        if (value) {
            this.removeAttribute('aria-checked');
            this.removeAttribute('mwc-list-item');
            this.selected = false;
            this.activated = false;
            this.tabIndex = -1;
        } else this.setAttribute('mwc-list-item', '');
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "noninteractive", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $k4Ngf.observer)(function(value) {
        const role = this.getAttribute('role');
        const isAriaSelectable = role === 'gridcell' || role === 'option' || role === 'row' || role === 'tab';
        if (isAriaSelectable && value) this.setAttribute('aria-selected', 'true');
        else if (isAriaSelectable) this.setAttribute('aria-selected', 'false');
        if (this._firstChanged) {
            this._firstChanged = false;
            return;
        }
        if (this._skipPropRequest) return;
        this.fireRequestSelected(value, 'property');
    })
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "selected", void 0);
(0, $czHfO.__decorate)([
    (0, $c1884e33bd521cfb$export$ca000e230c0caa3e)()
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "shouldRenderRipple", void 0);
(0, $czHfO.__decorate)([
    (0, $c1884e33bd521cfb$export$ca000e230c0caa3e)()
], $07424e342e0f9bfb$export$a2e32775fe3b6225.prototype, "_managingList", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $ca44dfca37dcc040$export$9dd6ff9ea0189349 = (0, $9a9518a2664ee96e$export$dbf350e5966cf602)`:host{cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;height:48px;display:flex;position:relative;align-items:center;justify-content:flex-start;overflow:hidden;padding:0;padding-left:var(--mdc-list-side-padding, 16px);padding-right:var(--mdc-list-side-padding, 16px);outline:none;height:48px;color:rgba(0,0,0,.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87))}:host:focus{outline:none}:host([activated]){color:#6200ee;color:var(--mdc-theme-primary, #6200ee);--mdc-ripple-color: var( --mdc-theme-primary, #6200ee )}:host([activated]) .mdc-deprecated-list-item__graphic{color:#6200ee;color:var(--mdc-theme-primary, #6200ee)}:host([activated]) .fake-activated-ripple::before{position:absolute;display:block;top:0;bottom:0;left:0;right:0;width:100%;height:100%;pointer-events:none;z-index:1;content:"";opacity:0.12;opacity:var(--mdc-ripple-activated-opacity, 0.12);background-color:#6200ee;background-color:var(--mdc-ripple-color, var(--mdc-theme-primary, #6200ee))}.mdc-deprecated-list-item__graphic{flex-shrink:0;align-items:center;justify-content:center;fill:currentColor;display:inline-flex}.mdc-deprecated-list-item__graphic ::slotted(*){flex-shrink:0;align-items:center;justify-content:center;fill:currentColor;width:100%;height:100%;text-align:center}.mdc-deprecated-list-item__meta{width:var(--mdc-list-item-meta-size, 24px);height:var(--mdc-list-item-meta-size, 24px);margin-left:auto;margin-right:0;color:rgba(0, 0, 0, 0.38);color:var(--mdc-theme-text-hint-on-background, rgba(0, 0, 0, 0.38))}.mdc-deprecated-list-item__meta.multi{width:auto}.mdc-deprecated-list-item__meta ::slotted(*){width:var(--mdc-list-item-meta-size, 24px);line-height:var(--mdc-list-item-meta-size, 24px)}.mdc-deprecated-list-item__meta ::slotted(.material-icons),.mdc-deprecated-list-item__meta ::slotted(mwc-icon){line-height:var(--mdc-list-item-meta-size, 24px) !important}.mdc-deprecated-list-item__meta ::slotted(:not(.material-icons):not(mwc-icon)){-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-caption-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.75rem;font-size:var(--mdc-typography-caption-font-size, 0.75rem);line-height:1.25rem;line-height:var(--mdc-typography-caption-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-caption-font-weight, 400);letter-spacing:0.0333333333em;letter-spacing:var(--mdc-typography-caption-letter-spacing, 0.0333333333em);text-decoration:inherit;text-decoration:var(--mdc-typography-caption-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-caption-text-transform, inherit)}[dir=rtl] .mdc-deprecated-list-item__meta,.mdc-deprecated-list-item__meta[dir=rtl]{margin-left:0;margin-right:auto}.mdc-deprecated-list-item__meta ::slotted(*){width:100%;height:100%}.mdc-deprecated-list-item__text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.mdc-deprecated-list-item__text ::slotted([for]),.mdc-deprecated-list-item__text[for]{pointer-events:none}.mdc-deprecated-list-item__primary-text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:block;margin-top:0;line-height:normal;margin-bottom:-20px;display:block}.mdc-deprecated-list-item__primary-text::before{display:inline-block;width:0;height:32px;content:"";vertical-align:0}.mdc-deprecated-list-item__primary-text::after{display:inline-block;width:0;height:20px;content:"";vertical-align:-20px}.mdc-deprecated-list-item__secondary-text{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-body2-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:0.875rem;font-size:var(--mdc-typography-body2-font-size, 0.875rem);line-height:1.25rem;line-height:var(--mdc-typography-body2-line-height, 1.25rem);font-weight:400;font-weight:var(--mdc-typography-body2-font-weight, 400);letter-spacing:0.0178571429em;letter-spacing:var(--mdc-typography-body2-letter-spacing, 0.0178571429em);text-decoration:inherit;text-decoration:var(--mdc-typography-body2-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-body2-text-transform, inherit);text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:block;margin-top:0;line-height:normal;display:block}.mdc-deprecated-list-item__secondary-text::before{display:inline-block;width:0;height:20px;content:"";vertical-align:0}.mdc-deprecated-list--dense .mdc-deprecated-list-item__secondary-text{font-size:inherit}* ::slotted(a),a{color:inherit;text-decoration:none}:host([twoline]){height:72px}:host([twoline]) .mdc-deprecated-list-item__text{align-self:flex-start}:host([disabled]),:host([noninteractive]){cursor:default;pointer-events:none}:host([disabled]) .mdc-deprecated-list-item__text ::slotted(*){opacity:.38}:host([disabled]) .mdc-deprecated-list-item__text ::slotted(*),:host([disabled]) .mdc-deprecated-list-item__primary-text ::slotted(*),:host([disabled]) .mdc-deprecated-list-item__secondary-text ::slotted(*){color:#000;color:var(--mdc-theme-on-surface, #000)}.mdc-deprecated-list-item__secondary-text ::slotted(*){color:rgba(0, 0, 0, 0.54);color:var(--mdc-theme-text-secondary-on-background, rgba(0, 0, 0, 0.54))}.mdc-deprecated-list-item__graphic ::slotted(*){background-color:transparent;color:rgba(0, 0, 0, 0.38);color:var(--mdc-theme-text-icon-on-background, rgba(0, 0, 0, 0.38))}.mdc-deprecated-list-group__subheader ::slotted(*){color:rgba(0, 0, 0, 0.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87))}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic{width:var(--mdc-list-item-graphic-size, 40px);height:var(--mdc-list-item-graphic-size, 40px)}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic.multi{width:auto}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(*){width:var(--mdc-list-item-graphic-size, 40px);line-height:var(--mdc-list-item-graphic-size, 40px)}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon){line-height:var(--mdc-list-item-graphic-size, 40px) !important}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic ::slotted(*){border-radius:50%}:host([graphic=avatar]) .mdc-deprecated-list-item__graphic,:host([graphic=medium]) .mdc-deprecated-list-item__graphic,:host([graphic=large]) .mdc-deprecated-list-item__graphic,:host([graphic=control]) .mdc-deprecated-list-item__graphic{margin-left:0;margin-right:var(--mdc-list-item-graphic-margin, 16px)}[dir=rtl] :host([graphic=avatar]) .mdc-deprecated-list-item__graphic,[dir=rtl] :host([graphic=medium]) .mdc-deprecated-list-item__graphic,[dir=rtl] :host([graphic=large]) .mdc-deprecated-list-item__graphic,[dir=rtl] :host([graphic=control]) .mdc-deprecated-list-item__graphic,:host([graphic=avatar]) .mdc-deprecated-list-item__graphic[dir=rtl],:host([graphic=medium]) .mdc-deprecated-list-item__graphic[dir=rtl],:host([graphic=large]) .mdc-deprecated-list-item__graphic[dir=rtl],:host([graphic=control]) .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:var(--mdc-list-item-graphic-margin, 16px);margin-right:0}:host([graphic=icon]) .mdc-deprecated-list-item__graphic{width:var(--mdc-list-item-graphic-size, 24px);height:var(--mdc-list-item-graphic-size, 24px);margin-left:0;margin-right:var(--mdc-list-item-graphic-margin, 32px)}:host([graphic=icon]) .mdc-deprecated-list-item__graphic.multi{width:auto}:host([graphic=icon]) .mdc-deprecated-list-item__graphic ::slotted(*){width:var(--mdc-list-item-graphic-size, 24px);line-height:var(--mdc-list-item-graphic-size, 24px)}:host([graphic=icon]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=icon]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon){line-height:var(--mdc-list-item-graphic-size, 24px) !important}[dir=rtl] :host([graphic=icon]) .mdc-deprecated-list-item__graphic,:host([graphic=icon]) .mdc-deprecated-list-item__graphic[dir=rtl]{margin-left:var(--mdc-list-item-graphic-margin, 32px);margin-right:0}:host([graphic=avatar]:not([twoLine])),:host([graphic=icon]:not([twoLine])){height:56px}:host([graphic=medium]:not([twoLine])),:host([graphic=large]:not([twoLine])){height:72px}:host([graphic=medium]) .mdc-deprecated-list-item__graphic,:host([graphic=large]) .mdc-deprecated-list-item__graphic{width:var(--mdc-list-item-graphic-size, 56px);height:var(--mdc-list-item-graphic-size, 56px)}:host([graphic=medium]) .mdc-deprecated-list-item__graphic.multi,:host([graphic=large]) .mdc-deprecated-list-item__graphic.multi{width:auto}:host([graphic=medium]) .mdc-deprecated-list-item__graphic ::slotted(*),:host([graphic=large]) .mdc-deprecated-list-item__graphic ::slotted(*){width:var(--mdc-list-item-graphic-size, 56px);line-height:var(--mdc-list-item-graphic-size, 56px)}:host([graphic=medium]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=medium]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon),:host([graphic=large]) .mdc-deprecated-list-item__graphic ::slotted(.material-icons),:host([graphic=large]) .mdc-deprecated-list-item__graphic ::slotted(mwc-icon){line-height:var(--mdc-list-item-graphic-size, 56px) !important}:host([graphic=large]){padding-left:0px}`;


let $5b50f8d0cfb2d2f7$export$a7b06bfba60a8a78 = class ListItem extends (0, $07424e342e0f9bfb$export$a2e32775fe3b6225) {
};
$5b50f8d0cfb2d2f7$export$a7b06bfba60a8a78.styles = [
    (0, $ca44dfca37dcc040$export$9dd6ff9ea0189349)
];
$5b50f8d0cfb2d2f7$export$a7b06bfba60a8a78 = (0, $czHfO.__decorate)([
    (0, $f06e04512dfe3b3d$export$da64fc29f17f9d0e)('mwc-list-item')
], $5b50f8d0cfb2d2f7$export$a7b06bfba60a8a78);



var $4ifWP = parcelRequire("4ifWP");

var $k4Ngf = parcelRequire("k4Ngf");

var $gSEYT = parcelRequire("gSEYT");



/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f1dcd76806134b37$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $6405b2275767d4a5$export$45b790e32b2810ee);




/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Style preference for leading underscores.
// tslint:disable:strip-private-property-underscore
/**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $2e1b343c32488911$export$a81b11d69c993162 = /** @class */ function() {
    function MDCFoundation(adapter) {
        if (adapter === void 0) adapter = {};
        this.adapter = adapter;
    }
    Object.defineProperty(MDCFoundation, "cssClasses", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports every
            // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "strings", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "numbers", {
        get: function() {
            // Classes extending MDCFoundation should implement this method to return an object which exports all
            // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MDCFoundation, "defaultAdapter", {
        get: function() {
            // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
            // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
            // validation.
            return {};
        },
        enumerable: false,
        configurable: true
    });
    MDCFoundation.prototype.init = function() {
    // Subclasses should override this method to perform initialization routines (registering events, etc.)
    };
    MDCFoundation.prototype.destroy = function() {
    // Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
    };
    return MDCFoundation;
}();
var // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.
$2e1b343c32488911$export$2e2bcd8739ae039 = $2e1b343c32488911$export$a81b11d69c993162;


/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * KEY provides normalized string values for keys.
 */ var $95c51301a788e333$export$7167c830cefcb6b5 = {
    UNKNOWN: 'Unknown',
    BACKSPACE: 'Backspace',
    ENTER: 'Enter',
    SPACEBAR: 'Spacebar',
    PAGE_UP: 'PageUp',
    PAGE_DOWN: 'PageDown',
    END: 'End',
    HOME: 'Home',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
    DELETE: 'Delete',
    ESCAPE: 'Escape',
    TAB: 'Tab'
};
var $95c51301a788e333$var$normalizedKeys = new Set();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.BACKSPACE);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ENTER);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.SPACEBAR);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.PAGE_UP);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.PAGE_DOWN);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.END);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.HOME);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_LEFT);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_UP);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_RIGHT);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_DOWN);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.DELETE);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ESCAPE);
$95c51301a788e333$var$normalizedKeys.add($95c51301a788e333$export$7167c830cefcb6b5.TAB);
var $95c51301a788e333$var$KEY_CODE = {
    BACKSPACE: 8,
    ENTER: 13,
    SPACEBAR: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ESCAPE: 27,
    TAB: 9
};
var $95c51301a788e333$var$mappedKeyCodes = new Map();
// IE11 has no support for new Map with iterable so we need to initialize this
// by hand.
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.BACKSPACE, $95c51301a788e333$export$7167c830cefcb6b5.BACKSPACE);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.ENTER, $95c51301a788e333$export$7167c830cefcb6b5.ENTER);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.SPACEBAR, $95c51301a788e333$export$7167c830cefcb6b5.SPACEBAR);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.PAGE_UP, $95c51301a788e333$export$7167c830cefcb6b5.PAGE_UP);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.PAGE_DOWN, $95c51301a788e333$export$7167c830cefcb6b5.PAGE_DOWN);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.END, $95c51301a788e333$export$7167c830cefcb6b5.END);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.HOME, $95c51301a788e333$export$7167c830cefcb6b5.HOME);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.ARROW_LEFT, $95c51301a788e333$export$7167c830cefcb6b5.ARROW_LEFT);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.ARROW_UP, $95c51301a788e333$export$7167c830cefcb6b5.ARROW_UP);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.ARROW_RIGHT, $95c51301a788e333$export$7167c830cefcb6b5.ARROW_RIGHT);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.ARROW_DOWN, $95c51301a788e333$export$7167c830cefcb6b5.ARROW_DOWN);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.DELETE, $95c51301a788e333$export$7167c830cefcb6b5.DELETE);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.ESCAPE, $95c51301a788e333$export$7167c830cefcb6b5.ESCAPE);
$95c51301a788e333$var$mappedKeyCodes.set($95c51301a788e333$var$KEY_CODE.TAB, $95c51301a788e333$export$7167c830cefcb6b5.TAB);
var $95c51301a788e333$var$navigationKeys = new Set();
// IE11 has no support for new Set with iterable so we need to initialize this
// by hand.
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.PAGE_UP);
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.PAGE_DOWN);
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.END);
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.HOME);
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_LEFT);
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_UP);
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_RIGHT);
$95c51301a788e333$var$navigationKeys.add($95c51301a788e333$export$7167c830cefcb6b5.ARROW_DOWN);
function $95c51301a788e333$export$e0c709538cb8ae18(evt) {
    var key = evt.key;
    // If the event already has a normalized key, return it
    if ($95c51301a788e333$var$normalizedKeys.has(key)) return key;
    // tslint:disable-next-line:deprecation
    var mappedKey = $95c51301a788e333$var$mappedKeyCodes.get(evt.keyCode);
    if (mappedKey) return mappedKey;
    return $95c51301a788e333$export$7167c830cefcb6b5.UNKNOWN;
}
function $95c51301a788e333$export$15e092e359be91e2(evt) {
    return $95c51301a788e333$var$navigationKeys.has($95c51301a788e333$export$e0c709538cb8ae18(evt));
}


/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $a70be20fc0845b0a$var$_a, $a70be20fc0845b0a$var$_b;
var $a70be20fc0845b0a$export$c1c0562ec8379000 = {
    LIST_ITEM_ACTIVATED_CLASS: 'mdc-list-item--activated',
    LIST_ITEM_CLASS: 'mdc-list-item',
    LIST_ITEM_DISABLED_CLASS: 'mdc-list-item--disabled',
    LIST_ITEM_SELECTED_CLASS: 'mdc-list-item--selected',
    LIST_ITEM_TEXT_CLASS: 'mdc-list-item__text',
    LIST_ITEM_PRIMARY_TEXT_CLASS: 'mdc-list-item__primary-text',
    ROOT: 'mdc-list'
};
var $a70be20fc0845b0a$export$4e3f9f206c48734b = ($a70be20fc0845b0a$var$_a = {}, $a70be20fc0845b0a$var$_a["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = 'mdc-list-item--activated', $a70be20fc0845b0a$var$_a["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] = 'mdc-list-item', $a70be20fc0845b0a$var$_a["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = 'mdc-list-item--disabled', $a70be20fc0845b0a$var$_a["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = 'mdc-list-item--selected', $a70be20fc0845b0a$var$_a["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = 'mdc-list-item__primary-text', $a70be20fc0845b0a$var$_a["" + $a70be20fc0845b0a$export$c1c0562ec8379000.ROOT] = 'mdc-list', $a70be20fc0845b0a$var$_a);
var $a70be20fc0845b0a$export$58c7601cd6e42ae1 = ($a70be20fc0845b0a$var$_b = {}, $a70be20fc0845b0a$var$_b["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_ACTIVATED_CLASS] = 'mdc-deprecated-list-item--activated', $a70be20fc0845b0a$var$_b["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] = 'mdc-deprecated-list-item', $a70be20fc0845b0a$var$_b["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_DISABLED_CLASS] = 'mdc-deprecated-list-item--disabled', $a70be20fc0845b0a$var$_b["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_SELECTED_CLASS] = 'mdc-deprecated-list-item--selected', $a70be20fc0845b0a$var$_b["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_TEXT_CLASS] = 'mdc-deprecated-list-item__text', $a70be20fc0845b0a$var$_b["" + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_PRIMARY_TEXT_CLASS] = 'mdc-deprecated-list-item__primary-text', $a70be20fc0845b0a$var$_b["" + $a70be20fc0845b0a$export$c1c0562ec8379000.ROOT] = 'mdc-deprecated-list', $a70be20fc0845b0a$var$_b);
var $a70be20fc0845b0a$export$21c51bc433c16634 = {
    ACTION_EVENT: 'MDCList:action',
    SELECTION_CHANGE_EVENT: 'MDCList:selectionChange',
    ARIA_CHECKED: 'aria-checked',
    ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
    ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
    ARIA_CURRENT: 'aria-current',
    ARIA_DISABLED: 'aria-disabled',
    ARIA_ORIENTATION: 'aria-orientation',
    ARIA_ORIENTATION_HORIZONTAL: 'horizontal',
    ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
    ARIA_SELECTED: 'aria-selected',
    ARIA_INTERACTIVE_ROLES_SELECTOR: '[role="listbox"], [role="menu"]',
    ARIA_MULTI_SELECTABLE_SELECTOR: '[aria-multiselectable="true"]',
    CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"], input[type="radio"]',
    CHECKBOX_SELECTOR: 'input[type="checkbox"]',
    CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $a70be20fc0845b0a$export$58c7601cd6e42ae1[$a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $a70be20fc0845b0a$export$58c7601cd6e42ae1[$a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a\n  ",
    DEPRECATED_SELECTOR: '.mdc-deprecated-list',
    FOCUSABLE_CHILD_ELEMENTS: "\n    ." + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS + " a,\n    ." + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS + " input[type=\"radio\"]:not(:disabled),\n    ." + $a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS + " input[type=\"checkbox\"]:not(:disabled),\n    ." + $a70be20fc0845b0a$export$58c7601cd6e42ae1[$a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " button:not(:disabled),\n    ." + $a70be20fc0845b0a$export$58c7601cd6e42ae1[$a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " a,\n    ." + $a70be20fc0845b0a$export$58c7601cd6e42ae1[$a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " input[type=\"radio\"]:not(:disabled),\n    ." + $a70be20fc0845b0a$export$58c7601cd6e42ae1[$a70be20fc0845b0a$export$c1c0562ec8379000.LIST_ITEM_CLASS] + " input[type=\"checkbox\"]:not(:disabled)\n  ",
    RADIO_SELECTOR: 'input[type="radio"]',
    SELECTED_ITEM_SELECTOR: '[aria-selected="true"], [aria-current="true"]'
};
var $a70be20fc0845b0a$export$1f6c9cc012ebacae = {
    UNSET_INDEX: -1,
    TYPEAHEAD_BUFFER_CLEAR_TIMEOUT_MS: 300
};
var $a70be20fc0845b0a$export$37a660f6ba30d8b = 'evolution';


const $c8e0afcd6967f0e5$var$integerSort = (a, b)=>{
    return a - b;
};
const $c8e0afcd6967f0e5$var$findIndexDiff = (oldSet, newSet)=>{
    const oldArr = Array.from(oldSet);
    const newArr = Array.from(newSet);
    const diff = {
        added: [],
        removed: []
    };
    const oldSorted = oldArr.sort($c8e0afcd6967f0e5$var$integerSort);
    const newSorted = newArr.sort($c8e0afcd6967f0e5$var$integerSort);
    let i = 0;
    let j = 0;
    while(i < oldSorted.length || j < newSorted.length){
        const oldVal = oldSorted[i];
        const newVal = newSorted[j];
        if (oldVal === newVal) {
            i++;
            j++;
            continue;
        }
        if (oldVal !== undefined && (newVal === undefined || oldVal < newVal)) {
            diff.removed.push(oldVal);
            i++;
            continue;
        }
        if (newVal !== undefined && (oldVal === undefined || newVal < oldVal)) {
            diff.added.push(newVal);
            j++;
            continue;
        }
    }
    return diff;
};
const $c8e0afcd6967f0e5$var$ELEMENTS_KEY_ALLOWED_IN = [
    'input',
    'button',
    'textarea',
    'select'
];
function $c8e0afcd6967f0e5$export$859dd8be312c112(selectedIndex) {
    return selectedIndex instanceof Set;
}
function $c8e0afcd6967f0e5$export$edc86bddb6888d05(evt) {
    return $c8e0afcd6967f0e5$export$859dd8be312c112(evt.detail.index);
}
const $c8e0afcd6967f0e5$export$cb327cf74b9b3806 = (index)=>{
    const entry = index === (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX ? new Set() : index;
    return $c8e0afcd6967f0e5$export$859dd8be312c112(entry) ? new Set(entry) : new Set([
        entry
    ]);
};
class $c8e0afcd6967f0e5$export$7a84b4bb1a2b9eb9 extends (0, $2e1b343c32488911$export$a81b11d69c993162) {
    constructor(adapter){
        super(Object.assign(Object.assign({}, $c8e0afcd6967f0e5$export$7a84b4bb1a2b9eb9.defaultAdapter), adapter));
        this.isMulti_ = false;
        this.wrapFocus_ = false;
        this.isVertical_ = true;
        this.selectedIndex_ = (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX;
        this.focusedItemIndex_ = (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX;
        this.useActivatedClass_ = false;
        this.ariaCurrentAttrValue_ = null;
    }
    static get strings() {
        return 0, $a70be20fc0845b0a$export$21c51bc433c16634;
    }
    static get numbers() {
        return 0, $a70be20fc0845b0a$export$1f6c9cc012ebacae;
    }
    static get defaultAdapter() {
        return {
            focusItemAtIndex: ()=>undefined,
            getFocusedElementIndex: ()=>0,
            getListItemCount: ()=>0,
            isFocusInsideList: ()=>false,
            isRootFocused: ()=>false,
            notifyAction: ()=>undefined,
            notifySelected: ()=>undefined,
            getSelectedStateForElementIndex: ()=>false,
            setDisabledStateForElementIndex: ()=>undefined,
            getDisabledStateForElementIndex: ()=>false,
            setSelectedStateForElementIndex: ()=>undefined,
            setActivatedStateForElementIndex: ()=>undefined,
            setTabIndexForElementIndex: ()=>undefined,
            setAttributeForElementIndex: ()=>undefined,
            getAttributeForElementIndex: ()=>null
        };
    }
    /**
     * Sets the private wrapFocus_ variable.
     */ setWrapFocus(value) {
        this.wrapFocus_ = value;
    }
    /**
     * Sets the private wrapFocus_ variable.
     */ setMulti(value) {
        this.isMulti_ = value;
        const currentIndex = this.selectedIndex_;
        if (value) // number to set
        {
            if (!$c8e0afcd6967f0e5$export$859dd8be312c112(currentIndex)) {
                const isUnset = currentIndex === (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX;
                this.selectedIndex_ = isUnset ? new Set() : new Set([
                    currentIndex
                ]);
            }
        } else // set to first sorted number in set
        if ($c8e0afcd6967f0e5$export$859dd8be312c112(currentIndex)) {
            if (currentIndex.size) {
                const vals = Array.from(currentIndex).sort($c8e0afcd6967f0e5$var$integerSort);
                this.selectedIndex_ = vals[0];
            } else this.selectedIndex_ = (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX;
        }
    }
    /**
     * Sets the isVertical_ private variable.
     */ setVerticalOrientation(value) {
        this.isVertical_ = value;
    }
    /**
     * Sets the useActivatedClass_ private variable.
     */ setUseActivatedClass(useActivated) {
        this.useActivatedClass_ = useActivated;
    }
    getSelectedIndex() {
        return this.selectedIndex_;
    }
    setSelectedIndex(index) {
        if (!this.isIndexValid_(index)) return;
        if (this.isMulti_) this.setMultiSelectionAtIndex_($c8e0afcd6967f0e5$export$cb327cf74b9b3806(index));
        else this.setSingleSelectionAtIndex_(index);
    }
    /**
     * Focus in handler for the list items.
     */ handleFocusIn(_, listItemIndex) {
        if (listItemIndex >= 0) this.adapter.setTabIndexForElementIndex(listItemIndex, 0);
    }
    /**
     * Focus out handler for the list items.
     */ handleFocusOut(_, listItemIndex) {
        if (listItemIndex >= 0) this.adapter.setTabIndexForElementIndex(listItemIndex, -1);
        /**
         * Between Focusout & Focusin some browsers do not have focus on any
         * element. Setting a delay to wait till the focus is moved to next element.
         */ setTimeout(()=>{
            if (!this.adapter.isFocusInsideList()) this.setTabindexToFirstSelectedItem_();
        }, 0);
    }
    /**
     * Key handler for the list.
     */ handleKeydown(event, isRootListItem, listItemIndex) {
        const isArrowLeft = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'ArrowLeft';
        const isArrowUp = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'ArrowUp';
        const isArrowRight = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'ArrowRight';
        const isArrowDown = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'ArrowDown';
        const isHome = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'Home';
        const isEnd = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'End';
        const isEnter = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'Enter';
        const isSpace = (0, $95c51301a788e333$export$e0c709538cb8ae18)(event) === 'Spacebar';
        if (this.adapter.isRootFocused()) {
            if (isArrowUp || isEnd) {
                event.preventDefault();
                this.focusLastElement();
            } else if (isArrowDown || isHome) {
                event.preventDefault();
                this.focusFirstElement();
            }
            return;
        }
        let currentIndex = this.adapter.getFocusedElementIndex();
        if (currentIndex === -1) {
            currentIndex = listItemIndex;
            if (currentIndex < 0) // If this event doesn't have a mdc-deprecated-list-item ancestor from
            // the current list (not from a sublist), return early.
            return;
        }
        let nextIndex;
        if (this.isVertical_ && isArrowDown || !this.isVertical_ && isArrowRight) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusNextElement(currentIndex);
        } else if (this.isVertical_ && isArrowUp || !this.isVertical_ && isArrowLeft) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusPrevElement(currentIndex);
        } else if (isHome) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusFirstElement();
        } else if (isEnd) {
            this.preventDefaultEvent(event);
            nextIndex = this.focusLastElement();
        } else if (isEnter || isSpace) {
            if (isRootListItem) {
                // Return early if enter key is pressed on anchor element which triggers
                // synthetic MouseEvent event.
                const target = event.target;
                if (target && target.tagName === 'A' && isEnter) return;
                this.preventDefaultEvent(event);
                this.setSelectedIndexOnAction_(currentIndex, true);
            }
        }
        this.focusedItemIndex_ = currentIndex;
        if (nextIndex !== undefined) {
            this.setTabindexAtIndex_(nextIndex);
            this.focusedItemIndex_ = nextIndex;
        }
    }
    /**
     * Click handler for the list.
     */ handleSingleSelection(index, isInteraction, force) {
        if (index === (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX) return;
        this.setSelectedIndexOnAction_(index, isInteraction, force);
        this.setTabindexAtIndex_(index);
        this.focusedItemIndex_ = index;
    }
    /**
     * Focuses the next element on the list.
     */ focusNextElement(index) {
        const count = this.adapter.getListItemCount();
        let nextIndex = index + 1;
        if (nextIndex >= count) {
            if (this.wrapFocus_) nextIndex = 0;
            else // Return early because last item is already focused.
            return index;
        }
        this.adapter.focusItemAtIndex(nextIndex);
        return nextIndex;
    }
    /**
     * Focuses the previous element on the list.
     */ focusPrevElement(index) {
        let prevIndex = index - 1;
        if (prevIndex < 0) {
            if (this.wrapFocus_) prevIndex = this.adapter.getListItemCount() - 1;
            else // Return early because first item is already focused.
            return index;
        }
        this.adapter.focusItemAtIndex(prevIndex);
        return prevIndex;
    }
    focusFirstElement() {
        this.adapter.focusItemAtIndex(0);
        return 0;
    }
    focusLastElement() {
        const lastIndex = this.adapter.getListItemCount() - 1;
        this.adapter.focusItemAtIndex(lastIndex);
        return lastIndex;
    }
    /**
     * @param itemIndex Index of the list item
     * @param isEnabled Sets the list item to enabled or disabled.
     */ setEnabled(itemIndex, isEnabled) {
        if (!this.isIndexValid_(itemIndex)) return;
        this.adapter.setDisabledStateForElementIndex(itemIndex, !isEnabled);
    }
    /**
     * Ensures that preventDefault is only called if the containing element
     * doesn't consume the event, and it will cause an unintended scroll.
     */ preventDefaultEvent(evt) {
        const target = evt.target;
        const tagName = `${target.tagName}`.toLowerCase();
        if ($c8e0afcd6967f0e5$var$ELEMENTS_KEY_ALLOWED_IN.indexOf(tagName) === -1) evt.preventDefault();
    }
    setSingleSelectionAtIndex_(index, isInteraction = true) {
        if (this.selectedIndex_ === index) return;
        // unset previous
        if (this.selectedIndex_ !== (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX) {
            this.adapter.setSelectedStateForElementIndex(this.selectedIndex_, false);
            if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(this.selectedIndex_, false);
        }
        // set new
        if (isInteraction) this.adapter.setSelectedStateForElementIndex(index, true);
        if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(index, true);
        this.setAriaForSingleSelectionAtIndex_(index);
        this.selectedIndex_ = index;
        this.adapter.notifySelected(index);
    }
    setMultiSelectionAtIndex_(newIndex, isInteraction = true) {
        const oldIndex = $c8e0afcd6967f0e5$export$cb327cf74b9b3806(this.selectedIndex_);
        const diff = $c8e0afcd6967f0e5$var$findIndexDiff(oldIndex, newIndex);
        if (!diff.removed.length && !diff.added.length) return;
        for (const removed of diff.removed){
            if (isInteraction) this.adapter.setSelectedStateForElementIndex(removed, false);
            if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(removed, false);
        }
        for (const added of diff.added){
            if (isInteraction) this.adapter.setSelectedStateForElementIndex(added, true);
            if (this.useActivatedClass_) this.adapter.setActivatedStateForElementIndex(added, true);
        }
        this.selectedIndex_ = newIndex;
        this.adapter.notifySelected(newIndex, diff);
    }
    /**
     * Sets aria attribute for single selection at given index.
     */ setAriaForSingleSelectionAtIndex_(index) {
        // Detect the presence of aria-current and get the value only during list
        // initialization when it is in unset state.
        if (this.selectedIndex_ === (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX) this.ariaCurrentAttrValue_ = this.adapter.getAttributeForElementIndex(index, (0, $a70be20fc0845b0a$export$21c51bc433c16634).ARIA_CURRENT);
        const isAriaCurrent = this.ariaCurrentAttrValue_ !== null;
        const ariaAttribute = isAriaCurrent ? (0, $a70be20fc0845b0a$export$21c51bc433c16634).ARIA_CURRENT : (0, $a70be20fc0845b0a$export$21c51bc433c16634).ARIA_SELECTED;
        if (this.selectedIndex_ !== (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX) this.adapter.setAttributeForElementIndex(this.selectedIndex_, ariaAttribute, 'false');
        const ariaAttributeValue = isAriaCurrent ? this.ariaCurrentAttrValue_ : 'true';
        this.adapter.setAttributeForElementIndex(index, ariaAttribute, ariaAttributeValue);
    }
    setTabindexAtIndex_(index) {
        if (this.focusedItemIndex_ === (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX && index !== 0) // If no list item was selected set first list item's tabindex to -1.
        // Generally, tabindex is set to 0 on first list item of list that has no
        // preselected items.
        this.adapter.setTabIndexForElementIndex(0, -1);
        else if (this.focusedItemIndex_ >= 0 && this.focusedItemIndex_ !== index) this.adapter.setTabIndexForElementIndex(this.focusedItemIndex_, -1);
        this.adapter.setTabIndexForElementIndex(index, 0);
    }
    setTabindexToFirstSelectedItem_() {
        let targetIndex = 0;
        if (typeof this.selectedIndex_ === 'number' && this.selectedIndex_ !== (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX) targetIndex = this.selectedIndex_;
        else if ($c8e0afcd6967f0e5$export$859dd8be312c112(this.selectedIndex_) && this.selectedIndex_.size > 0) targetIndex = Math.min(...this.selectedIndex_);
        this.setTabindexAtIndex_(targetIndex);
    }
    isIndexValid_(index) {
        if (index instanceof Set) {
            if (!this.isMulti_) throw new Error('MDCListFoundation: Array of index is only supported for checkbox based list');
            if (index.size === 0) return true;
            else {
                let isOneInRange = false;
                for (const entry of index){
                    isOneInRange = this.isIndexInRange_(entry);
                    if (isOneInRange) break;
                }
                return isOneInRange;
            }
        } else if (typeof index === 'number') {
            if (this.isMulti_) throw new Error('MDCListFoundation: Expected array of index for checkbox based list but got number: ' + index);
            return index === (0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX || this.isIndexInRange_(index);
        } else return false;
    }
    isIndexInRange_(index) {
        const listSize = this.adapter.getListItemCount();
        return index >= 0 && index < listSize;
    }
    /**
     * Sets selected index on user action, toggles checkbox / radio based on
     * toggleCheckbox value. User interaction should not toggle list item(s) when
     * disabled.
     */ setSelectedIndexOnAction_(index, isInteraction, force) {
        if (this.adapter.getDisabledStateForElementIndex(index)) return;
        let checkedIndex = index;
        if (this.isMulti_) checkedIndex = new Set([
            index
        ]);
        if (!this.isIndexValid_(checkedIndex)) return;
        if (this.isMulti_) this.toggleMultiAtIndex(index, force, isInteraction);
        else if (isInteraction || force) this.setSingleSelectionAtIndex_(index, isInteraction);
        else {
            const isDeselection = this.selectedIndex_ === index;
            if (isDeselection) this.setSingleSelectionAtIndex_((0, $a70be20fc0845b0a$export$1f6c9cc012ebacae).UNSET_INDEX);
        }
        if (isInteraction) this.adapter.notifyAction(index);
    }
    toggleMultiAtIndex(index, force, isInteraction = true) {
        let newSelectionValue = false;
        if (force === undefined) newSelectionValue = !this.adapter.getSelectedStateForElementIndex(index);
        else newSelectionValue = force;
        const newSet = $c8e0afcd6967f0e5$export$cb327cf74b9b3806(this.selectedIndex_);
        if (newSelectionValue) newSet.add(index);
        else newSet.delete(index);
        this.setMultiSelectionAtIndex_(newSet, isInteraction);
    }
}
var // tslint:disable-next-line:no-default-export Needed for backward compatibility
// with MDC Web v0.44.0 and earlier.
$c8e0afcd6967f0e5$export$2e2bcd8739ae039 = $c8e0afcd6967f0e5$export$7a84b4bb1a2b9eb9;


function $971e8ee8213db93e$var$debounceLayout(callback, waitInMS = 50) {
    let timeoutId;
    // tslint:disable-next-line
    return function(updateItems = true) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            callback(updateItems);
        }, waitInMS);
    };
}
const $971e8ee8213db93e$var$isListItem = (element)=>{
    return element.hasAttribute('mwc-list-item');
};
function $971e8ee8213db93e$var$clearAndCreateItemsReadyPromise() {
    const oldResolver = this.itemsReadyResolver;
    this.itemsReady = new Promise((res)=>{
        // TODO(b/175626389): Type '(value: never[] | PromiseLike<never[]>) => void'
        // is not assignable to type '(value?: never[] | PromiseLike<never[]> |
        // undefined) => void'.
        return this.itemsReadyResolver = res;
    });
    oldResolver();
}
class $971e8ee8213db93e$export$8f4a37dcf1e373df extends (0, $4ifWP.BaseElement) {
    constructor(){
        super();
        this.mdcAdapter = null;
        this.mdcFoundationClass = (0, $c8e0afcd6967f0e5$export$2e2bcd8739ae039);
        this.activatable = false;
        this.multi = false;
        this.wrapFocus = false;
        this.itemRoles = null;
        this.innerRole = null;
        this.innerAriaLabel = null;
        this.rootTabbable = false;
        this.previousTabindex = null;
        this.noninteractive = false;
        this.itemsReadyResolver = ()=>{
        //
        };
        this.itemsReady = Promise.resolve([]);
        // tslint:enable:ban-ts-ignore
        this.items_ = [];
        const debouncedFunction = $971e8ee8213db93e$var$debounceLayout(this.layout.bind(this));
        this.debouncedLayout = (updateItems = true)=>{
            $971e8ee8213db93e$var$clearAndCreateItemsReadyPromise.call(this);
            debouncedFunction(updateItems);
        };
    }
    // tslint:disable:ban-ts-ignore
    async getUpdateComplete() {
        // @ts-ignore
        const result = await super.getUpdateComplete();
        await this.itemsReady;
        return result;
    }
    get items() {
        return this.items_;
    }
    updateItems() {
        var _a;
        const nodes = (_a = this.assignedElements) !== null && _a !== void 0 ? _a : [];
        const listItems = [];
        for (const node of nodes){
            if ($971e8ee8213db93e$var$isListItem(node)) {
                listItems.push(node);
                node._managingList = this;
            }
            if (node.hasAttribute('divider') && !node.hasAttribute('role')) node.setAttribute('role', 'separator');
        }
        this.items_ = listItems;
        const selectedIndices = new Set();
        this.items_.forEach((item, index)=>{
            if (this.itemRoles) item.setAttribute('role', this.itemRoles);
            else item.removeAttribute('role');
            if (item.selected) selectedIndices.add(index);
        });
        if (this.multi) this.select(selectedIndices);
        else {
            const index = selectedIndices.size ? selectedIndices.entries().next().value[1] : -1;
            this.select(index);
        }
        const itemsUpdatedEv = new Event('items-updated', {
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(itemsUpdatedEv);
    }
    get selected() {
        const index = this.index;
        if (!(0, $c8e0afcd6967f0e5$export$859dd8be312c112)(index)) {
            if (index === -1) return null;
            return this.items[index];
        }
        const selected = [];
        for (const entry of index)selected.push(this.items[entry]);
        return selected;
    }
    get index() {
        if (this.mdcFoundation) return this.mdcFoundation.getSelectedIndex();
        return -1;
    }
    render() {
        const role = this.innerRole === null ? undefined : this.innerRole;
        const ariaLabel = this.innerAriaLabel === null ? undefined : this.innerAriaLabel;
        const tabindex = this.rootTabbable ? '0' : '-1';
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      <!-- @ts-ignore -->
      <ul
          tabindex=${tabindex}
          role="${(0, $f1dcd76806134b37$export$f68dd208b5df064d)(role)}"
          aria-label="${(0, $f1dcd76806134b37$export$f68dd208b5df064d)(ariaLabel)}"
          class="mdc-deprecated-list"
          @keydown=${this.onKeydown}
          @focusin=${this.onFocusIn}
          @focusout=${this.onFocusOut}
          @request-selected=${this.onRequestSelected}
          @list-item-rendered=${this.onListItemConnected}>
        <slot></slot>
        ${this.renderPlaceholder()}
      </ul>
    `;
    }
    renderPlaceholder() {
        var _a;
        const nodes = (_a = this.assignedElements) !== null && _a !== void 0 ? _a : [];
        if (this.emptyMessage !== undefined && nodes.length === 0) return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
        <mwc-list-item noninteractive>${this.emptyMessage}</mwc-list-item>
      `;
        return null;
    }
    firstUpdated() {
        super.firstUpdated();
        if (!this.items.length) {
            // required because this is called before observers
            this.mdcFoundation.setMulti(this.multi);
            // for when children upgrade before list
            this.layout();
        }
    }
    onFocusIn(evt) {
        if (this.mdcFoundation && this.mdcRoot) {
            const index = this.getIndexOfTarget(evt);
            this.mdcFoundation.handleFocusIn(evt, index);
        }
    }
    onFocusOut(evt) {
        if (this.mdcFoundation && this.mdcRoot) {
            const index = this.getIndexOfTarget(evt);
            this.mdcFoundation.handleFocusOut(evt, index);
        }
    }
    onKeydown(evt) {
        if (this.mdcFoundation && this.mdcRoot) {
            const index = this.getIndexOfTarget(evt);
            const target = evt.target;
            const isRootListItem = $971e8ee8213db93e$var$isListItem(target);
            this.mdcFoundation.handleKeydown(evt, isRootListItem, index);
        }
    }
    onRequestSelected(evt) {
        if (this.mdcFoundation) {
            let index = this.getIndexOfTarget(evt);
            // might happen in shady dom slowness. Recalc children
            if (index === -1) {
                this.layout();
                index = this.getIndexOfTarget(evt);
                // still not found; may not be mwc-list-item. Unsupported case.
                if (index === -1) return;
            }
            const element = this.items[index];
            if (element.disabled) return;
            const selected = evt.detail.selected;
            const source = evt.detail.source;
            this.mdcFoundation.handleSingleSelection(index, source === 'interaction', selected);
            evt.stopPropagation();
        }
    }
    getIndexOfTarget(evt) {
        const elements = this.items;
        const path = evt.composedPath();
        for (const pathItem of path){
            let index = -1;
            if ((0, $gSEYT.isNodeElement)(pathItem) && $971e8ee8213db93e$var$isListItem(pathItem)) index = elements.indexOf(pathItem);
            if (index !== -1) return index;
        }
        return -1;
    }
    createAdapter() {
        this.mdcAdapter = {
            getListItemCount: ()=>{
                if (this.mdcRoot) return this.items.length;
                return 0;
            },
            getFocusedElementIndex: this.getFocusedItemIndex,
            getAttributeForElementIndex: (index, attr)=>{
                const listElement = this.mdcRoot;
                if (!listElement) return '';
                const element = this.items[index];
                return element ? element.getAttribute(attr) : '';
            },
            setAttributeForElementIndex: (index, attr, val)=>{
                if (!this.mdcRoot) return;
                const element = this.items[index];
                if (element) element.setAttribute(attr, val);
            },
            focusItemAtIndex: (index)=>{
                const element = this.items[index];
                if (element) element.focus();
            },
            setTabIndexForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (item) item.tabindex = value;
            },
            notifyAction: (index)=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                init.detail = {
                    index: index
                };
                const ev = new CustomEvent('action', init);
                this.dispatchEvent(ev);
            },
            notifySelected: (index, diff)=>{
                const init = {
                    bubbles: true,
                    composed: true
                };
                init.detail = {
                    index: index,
                    diff: diff
                };
                const ev = new CustomEvent('selected', init);
                this.dispatchEvent(ev);
            },
            isFocusInsideList: ()=>{
                return (0, $gSEYT.doesElementContainFocus)(this);
            },
            isRootFocused: ()=>{
                const mdcRoot = this.mdcRoot;
                const root = mdcRoot.getRootNode();
                return root.activeElement === mdcRoot;
            },
            setDisabledStateForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (!item) return;
                item.disabled = value;
            },
            getDisabledStateForElementIndex: (index)=>{
                const item = this.items[index];
                if (!item) return false;
                return item.disabled;
            },
            setSelectedStateForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (!item) return;
                item.selected = value;
            },
            getSelectedStateForElementIndex: (index)=>{
                const item = this.items[index];
                if (!item) return false;
                return item.selected;
            },
            setActivatedStateForElementIndex: (index, value)=>{
                const item = this.items[index];
                if (!item) return;
                item.activated = value;
            }
        };
        return this.mdcAdapter;
    }
    selectUi(index, activate = false) {
        const item = this.items[index];
        if (item) {
            item.selected = true;
            item.activated = activate;
        }
    }
    deselectUi(index) {
        const item = this.items[index];
        if (item) {
            item.selected = false;
            item.activated = false;
        }
    }
    select(index) {
        if (!this.mdcFoundation) return;
        this.mdcFoundation.setSelectedIndex(index);
    }
    toggle(index, force) {
        if (this.multi) this.mdcFoundation.toggleMultiAtIndex(index, force);
    }
    onListItemConnected(e) {
        const target = e.target;
        this.layout(this.items.indexOf(target) === -1);
    }
    layout(updateItems = true) {
        if (updateItems) this.updateItems();
        const first = this.items[0];
        for (const item of this.items)item.tabindex = -1;
        if (first) {
            if (this.noninteractive) {
                if (!this.previousTabindex) this.previousTabindex = first;
            } else first.tabindex = 0;
        }
        this.itemsReadyResolver();
    }
    getFocusedItemIndex() {
        if (!this.mdcRoot) return -1;
        if (!this.items.length) return -1;
        const activeElementPath = (0, $gSEYT.deepActiveElementPath)();
        if (!activeElementPath.length) return -1;
        for(let i = activeElementPath.length - 1; i >= 0; i--){
            const activeItem = activeElementPath[i];
            if ($971e8ee8213db93e$var$isListItem(activeItem)) return this.items.indexOf(activeItem);
        }
        return -1;
    }
    focusItemAtIndex(index) {
        for (const item of this.items)if (item.tabindex === 0) {
            item.tabindex = -1;
            break;
        }
        this.items[index].tabindex = 0;
        this.items[index].focus();
    }
    focus() {
        const root = this.mdcRoot;
        if (root) root.focus();
    }
    blur() {
        const root = this.mdcRoot;
        if (root) root.blur();
    }
}
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "emptyMessage", void 0);
(0, $czHfO.__decorate)([
    (0, $7c5121c1c38448b3$export$2fa187e846a241c4)('.mdc-deprecated-list')
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "mdcRoot", void 0);
(0, $czHfO.__decorate)([
    (0, $c3ef3cefb9b61ba4$export$1bdbe53f9df1b8)('', true, '*')
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "assignedElements", void 0);
(0, $czHfO.__decorate)([
    (0, $c3ef3cefb9b61ba4$export$1bdbe53f9df1b8)('', true, '[tabindex="0"]')
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "tabbableElements", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $k4Ngf.observer)(function(value) {
        if (this.mdcFoundation) this.mdcFoundation.setUseActivatedClass(value);
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "activatable", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $k4Ngf.observer)(function(newValue, oldValue) {
        if (this.mdcFoundation) this.mdcFoundation.setMulti(newValue);
        if (oldValue !== undefined) this.layout();
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "multi", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean
    }),
    (0, $k4Ngf.observer)(function(value) {
        if (this.mdcFoundation) this.mdcFoundation.setWrapFocus(value);
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "wrapFocus", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String
    }),
    (0, $k4Ngf.observer)(function(_newValue, oldValue) {
        if (oldValue !== undefined) this.updateItems();
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "itemRoles", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "innerRole", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "innerAriaLabel", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "rootTabbable", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    }),
    (0, $k4Ngf.observer)(function(value) {
        var _a, _b;
        if (value) {
            const tabbable = (_b = (_a = this.tabbableElements) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
            this.previousTabindex = tabbable;
            if (tabbable) tabbable.setAttribute('tabindex', '-1');
        } else if (!value && this.previousTabindex) {
            this.previousTabindex.setAttribute('tabindex', '0');
            this.previousTabindex = null;
        }
    })
], $971e8ee8213db93e$export$8f4a37dcf1e373df.prototype, "noninteractive", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $f8faebdc3771511d$export$9dd6ff9ea0189349 = (0, $9a9518a2664ee96e$export$dbf350e5966cf602)`@keyframes mdc-ripple-fg-radius-in{from{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transform:translate(var(--mdc-ripple-fg-translate-start, 0)) scale(1)}to{transform:translate(var(--mdc-ripple-fg-translate-end, 0)) scale(var(--mdc-ripple-fg-scale, 1))}}@keyframes mdc-ripple-fg-opacity-in{from{animation-timing-function:linear;opacity:0}to{opacity:var(--mdc-ripple-fg-opacity, 0)}}@keyframes mdc-ripple-fg-opacity-out{from{animation-timing-function:linear;opacity:var(--mdc-ripple-fg-opacity, 0)}to{opacity:0}}:host{display:block}.mdc-deprecated-list{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font-family:Roboto, sans-serif;font-family:var(--mdc-typography-subtitle1-font-family, var(--mdc-typography-font-family, Roboto, sans-serif));font-size:1rem;font-size:var(--mdc-typography-subtitle1-font-size, 1rem);line-height:1.75rem;line-height:var(--mdc-typography-subtitle1-line-height, 1.75rem);font-weight:400;font-weight:var(--mdc-typography-subtitle1-font-weight, 400);letter-spacing:0.009375em;letter-spacing:var(--mdc-typography-subtitle1-letter-spacing, 0.009375em);text-decoration:inherit;text-decoration:var(--mdc-typography-subtitle1-text-decoration, inherit);text-transform:inherit;text-transform:var(--mdc-typography-subtitle1-text-transform, inherit);line-height:1.5rem;margin:0;padding:8px 0;list-style-type:none;color:rgba(0, 0, 0, 0.87);color:var(--mdc-theme-text-primary-on-background, rgba(0, 0, 0, 0.87));padding:var(--mdc-list-vertical-padding, 8px) 0}.mdc-deprecated-list:focus{outline:none}.mdc-deprecated-list-item{height:48px}.mdc-deprecated-list--dense{padding-top:4px;padding-bottom:4px;font-size:.812rem}.mdc-deprecated-list ::slotted([divider]){height:0;margin:0;border:none;border-bottom-width:1px;border-bottom-style:solid;border-bottom-color:rgba(0, 0, 0, 0.12)}.mdc-deprecated-list ::slotted([divider][padded]){margin:0 var(--mdc-list-side-padding, 16px)}.mdc-deprecated-list ::slotted([divider][inset]){margin-left:var(--mdc-list-inset-margin, 72px);margin-right:0;width:calc( 100% - var(--mdc-list-inset-margin, 72px) )}[dir=rtl] .mdc-deprecated-list ::slotted([divider][inset]),.mdc-deprecated-list ::slotted([divider][inset][dir=rtl]){margin-left:0;margin-right:var(--mdc-list-inset-margin, 72px)}.mdc-deprecated-list ::slotted([divider][inset][padded]){width:calc( 100% - var(--mdc-list-inset-margin, 72px) - var(--mdc-list-side-padding, 16px) )}.mdc-deprecated-list--dense ::slotted([mwc-list-item]){height:40px}.mdc-deprecated-list--dense ::slotted([mwc-list]){--mdc-list-item-graphic-size: 20px}.mdc-deprecated-list--two-line.mdc-deprecated-list--dense ::slotted([mwc-list-item]),.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense ::slotted([mwc-list-item]){height:60px}.mdc-deprecated-list--avatar-list.mdc-deprecated-list--dense ::slotted([mwc-list]){--mdc-list-item-graphic-size: 36px}:host([noninteractive]){pointer-events:none;cursor:default}.mdc-deprecated-list--dense ::slotted(.mdc-deprecated-list-item__primary-text){display:block;margin-top:0;line-height:normal;margin-bottom:-20px}.mdc-deprecated-list--dense ::slotted(.mdc-deprecated-list-item__primary-text)::before{display:inline-block;width:0;height:24px;content:"";vertical-align:0}.mdc-deprecated-list--dense ::slotted(.mdc-deprecated-list-item__primary-text)::after{display:inline-block;width:0;height:20px;content:"";vertical-align:-20px}`;



let $9c971c8cb728e5dc$export$54c2e3dc7acea9f5 = class List extends (0, $971e8ee8213db93e$export$8f4a37dcf1e373df) {
};
$9c971c8cb728e5dc$export$54c2e3dc7acea9f5.styles = [
    (0, $f8faebdc3771511d$export$9dd6ff9ea0189349)
];
$9c971c8cb728e5dc$export$54c2e3dc7acea9f5 = (0, $czHfO.__decorate)([
    (0, $f06e04512dfe3b3d$export$da64fc29f17f9d0e)('mwc-list')
], $9c971c8cb728e5dc$export$54c2e3dc7acea9f5);


/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");

/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");





class $7c174e6d04d1b611$export$267ddefd750c5221 extends (0, $07424e342e0f9bfb$export$a2e32775fe3b6225) {
    constructor(){
        super(...arguments);
        this.left = false;
        this.graphic = 'control';
    }
    render() {
        const checkboxClasses = {
            'mdc-deprecated-list-item__graphic': this.left,
            'mdc-deprecated-list-item__meta': !this.left
        };
        const text = this.renderText();
        const graphic = this.graphic && this.graphic !== 'control' && !this.left ? this.renderGraphic() : (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)``;
        const meta = this.hasMeta && this.left ? this.renderMeta() : (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)``;
        const ripple = this.renderRipple();
        return (0, $6405b2275767d4a5$export$c0bb0b647f701bb5)`
      ${ripple}
      ${graphic}
      ${this.left ? '' : text}
      <span class=${(0, $49425fdcca742a3e$export$56cc687933817664)(checkboxClasses)}>
        <mwc-checkbox
            reducedTouchTarget
            tabindex=${this.tabindex}
            .checked=${this.selected}
            ?disabled=${this.disabled}
            @change=${this.onChange}>
        </mwc-checkbox>
      </span>
      ${this.left ? text : ''}
      ${meta}`;
    }
    async onChange(evt) {
        const checkbox = evt.target;
        const changeFromProp = this.selected === checkbox.checked;
        if (!changeFromProp) {
            this._skipPropRequest = true;
            this.selected = checkbox.checked;
            await this.updateComplete;
            this._skipPropRequest = false;
        }
    }
}
(0, $czHfO.__decorate)([
    (0, $7c5121c1c38448b3$export$2fa187e846a241c4)('slot')
], $7c174e6d04d1b611$export$267ddefd750c5221.prototype, "slotElement", void 0);
(0, $czHfO.__decorate)([
    (0, $7c5121c1c38448b3$export$2fa187e846a241c4)('mwc-checkbox')
], $7c174e6d04d1b611$export$267ddefd750c5221.prototype, "checkboxElement", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: Boolean
    })
], $7c174e6d04d1b611$export$267ddefd750c5221.prototype, "left", void 0);
(0, $czHfO.__decorate)([
    (0, $ea23336b77775fcf$export$d541bacb2bda4494)({
        type: String,
        reflect: true
    })
], $7c174e6d04d1b611$export$267ddefd750c5221.prototype, "graphic", void 0);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $9bff4ec17c6b93b8$export$9dd6ff9ea0189349 = (0, $9a9518a2664ee96e$export$dbf350e5966cf602)`:host(:not([twoline])){height:56px}:host(:not([left])) .mdc-deprecated-list-item__meta{height:40px;width:40px}`;



let $4bd4c46df64f44b4$export$bb65c59ac63c6f50 = class CheckListItem extends (0, $7c174e6d04d1b611$export$267ddefd750c5221) {
};
$4bd4c46df64f44b4$export$bb65c59ac63c6f50.styles = [
    (0, $ca44dfca37dcc040$export$9dd6ff9ea0189349),
    (0, $9bff4ec17c6b93b8$export$9dd6ff9ea0189349)
];
$4bd4c46df64f44b4$export$bb65c59ac63c6f50 = (0, $czHfO.__decorate)([
    (0, $f06e04512dfe3b3d$export$da64fc29f17f9d0e)('mwc-check-list-item')
], $4bd4c46df64f44b4$export$bb65c59ac63c6f50);


parcelRequire("8J3FQ");
parcelRequire("8qnmK");
parcelRequire("31pE8");
/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ var $d8ce4e734394a836$exports = {};
'use strict';
Object.defineProperty($d8ce4e734394a836$exports, '__esModule', {
    value: true
});
function $d8ce4e734394a836$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d8ce4e734394a836$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d8ce4e734394a836$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d8ce4e734394a836$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d8ce4e734394a836$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d8ce4e734394a836$var$_extends() {
    $d8ce4e734394a836$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8ce4e734394a836$var$_extends.apply(this, arguments);
}
function $d8ce4e734394a836$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d8ce4e734394a836$var$_setPrototypeOf(subClass, superClass);
}
function $d8ce4e734394a836$var$_getPrototypeOf(o) {
    $d8ce4e734394a836$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d8ce4e734394a836$var$_getPrototypeOf(o);
}
function $d8ce4e734394a836$var$_setPrototypeOf(o, p) {
    $d8ce4e734394a836$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d8ce4e734394a836$var$_setPrototypeOf(o, p);
}
function $d8ce4e734394a836$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d8ce4e734394a836$var$_construct(Parent, args, Class) {
    if ($d8ce4e734394a836$var$_isNativeReflectConstruct()) $d8ce4e734394a836$var$_construct = Reflect.construct.bind();
    else $d8ce4e734394a836$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $d8ce4e734394a836$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $d8ce4e734394a836$var$_construct.apply(null, arguments);
}
function $d8ce4e734394a836$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $d8ce4e734394a836$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $d8ce4e734394a836$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$d8ce4e734394a836$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $d8ce4e734394a836$var$_construct(Class, arguments, $d8ce4e734394a836$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $d8ce4e734394a836$var$_setPrototypeOf(Wrapper, Class);
    };
    return $d8ce4e734394a836$var$_wrapNativeSuper(Class);
}
function $d8ce4e734394a836$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d8ce4e734394a836$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d8ce4e734394a836$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d8ce4e734394a836$var$_arrayLikeToArray(o, minLen);
}
function $d8ce4e734394a836$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d8ce4e734394a836$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d8ce4e734394a836$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d8ce4e734394a836$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d8ce4e734394a836$var$_toPropertyKey(arg) {
    var key = $d8ce4e734394a836$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $d8ce4e734394a836$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $d8ce4e734394a836$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $d8ce4e734394a836$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $d8ce4e734394a836$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $d8ce4e734394a836$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($d8ce4e734394a836$var$LuxonError);
/**
 * @private
 */ var $d8ce4e734394a836$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $d8ce4e734394a836$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($d8ce4e734394a836$var$LuxonError);
/**
 * @private
 */ var $d8ce4e734394a836$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $d8ce4e734394a836$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($d8ce4e734394a836$var$LuxonError);
/**
 * @private
 */ var $d8ce4e734394a836$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $d8ce4e734394a836$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($d8ce4e734394a836$var$LuxonError);
/**
 * @private
 */ var $d8ce4e734394a836$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $d8ce4e734394a836$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($d8ce4e734394a836$var$LuxonError);
/**
 * @private
 */ var $d8ce4e734394a836$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $d8ce4e734394a836$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($d8ce4e734394a836$var$LuxonError);
/**
 * @private
 */ var $d8ce4e734394a836$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $d8ce4e734394a836$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($d8ce4e734394a836$var$LuxonError);
/**
 * @private
 */ var $d8ce4e734394a836$var$n = "numeric", $d8ce4e734394a836$var$s = "short", $d8ce4e734394a836$var$l = "long";
var $d8ce4e734394a836$var$DATE_SHORT = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$n,
    day: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATE_MED = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$s,
    day: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATE_MED_WITH_WEEKDAY = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$s,
    day: $d8ce4e734394a836$var$n,
    weekday: $d8ce4e734394a836$var$s
};
var $d8ce4e734394a836$var$DATE_FULL = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$l,
    day: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATE_HUGE = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$l,
    day: $d8ce4e734394a836$var$n,
    weekday: $d8ce4e734394a836$var$l
};
var $d8ce4e734394a836$var$TIME_SIMPLE = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$TIME_WITH_SECONDS = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$TIME_WITH_SHORT_OFFSET = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n,
    timeZoneName: $d8ce4e734394a836$var$s
};
var $d8ce4e734394a836$var$TIME_WITH_LONG_OFFSET = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n,
    timeZoneName: $d8ce4e734394a836$var$l
};
var $d8ce4e734394a836$var$TIME_24_SIMPLE = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    hourCycle: "h23"
};
var $d8ce4e734394a836$var$TIME_24_WITH_SECONDS = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n,
    hourCycle: "h23"
};
var $d8ce4e734394a836$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n,
    hourCycle: "h23",
    timeZoneName: $d8ce4e734394a836$var$s
};
var $d8ce4e734394a836$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n,
    hourCycle: "h23",
    timeZoneName: $d8ce4e734394a836$var$l
};
var $d8ce4e734394a836$var$DATETIME_SHORT = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$n,
    day: $d8ce4e734394a836$var$n,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$n,
    day: $d8ce4e734394a836$var$n,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATETIME_MED = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$s,
    day: $d8ce4e734394a836$var$n,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATETIME_MED_WITH_SECONDS = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$s,
    day: $d8ce4e734394a836$var$n,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$s,
    day: $d8ce4e734394a836$var$n,
    weekday: $d8ce4e734394a836$var$s,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n
};
var $d8ce4e734394a836$var$DATETIME_FULL = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$l,
    day: $d8ce4e734394a836$var$n,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    timeZoneName: $d8ce4e734394a836$var$s
};
var $d8ce4e734394a836$var$DATETIME_FULL_WITH_SECONDS = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$l,
    day: $d8ce4e734394a836$var$n,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n,
    timeZoneName: $d8ce4e734394a836$var$s
};
var $d8ce4e734394a836$var$DATETIME_HUGE = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$l,
    day: $d8ce4e734394a836$var$n,
    weekday: $d8ce4e734394a836$var$l,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    timeZoneName: $d8ce4e734394a836$var$l
};
var $d8ce4e734394a836$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $d8ce4e734394a836$var$n,
    month: $d8ce4e734394a836$var$l,
    day: $d8ce4e734394a836$var$n,
    weekday: $d8ce4e734394a836$var$l,
    hour: $d8ce4e734394a836$var$n,
    minute: $d8ce4e734394a836$var$n,
    second: $d8ce4e734394a836$var$n,
    timeZoneName: $d8ce4e734394a836$var$l
};
/**
 * @interface
 */ var $d8ce4e734394a836$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
    };
    $d8ce4e734394a836$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $d8ce4e734394a836$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $d8ce4e734394a836$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $d8ce4e734394a836$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $d8ce4e734394a836$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $d8ce4e734394a836$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $d8ce4e734394a836$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $d8ce4e734394a836$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($d8ce4e734394a836$var$singleton$1 === null) $d8ce4e734394a836$var$singleton$1 = new SystemZone();
                return $d8ce4e734394a836$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($d8ce4e734394a836$var$Zone);
var $d8ce4e734394a836$var$dtfCache = new Map();
function $d8ce4e734394a836$var$makeDTF(zoneName) {
    var dtf = $d8ce4e734394a836$var$dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        $d8ce4e734394a836$var$dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
var $d8ce4e734394a836$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $d8ce4e734394a836$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $d8ce4e734394a836$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $d8ce4e734394a836$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$d8ce4e734394a836$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $d8ce4e734394a836$var$ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $d8ce4e734394a836$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $d8ce4e734394a836$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        var zone = $d8ce4e734394a836$var$ianaZoneCache.get(name);
        if (zone === undefined) $d8ce4e734394a836$var$ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    };
    IANAZone.resetCache = function resetCache() {
        $d8ce4e734394a836$var$ianaZoneCache.clear();
        $d8ce4e734394a836$var$dtfCache.clear();
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $d8ce4e734394a836$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $d8ce4e734394a836$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        if (!this.valid) return NaN;
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $d8ce4e734394a836$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $d8ce4e734394a836$var$partsOffset(dtf, date) : $d8ce4e734394a836$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $d8ce4e734394a836$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $d8ce4e734394a836$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($d8ce4e734394a836$var$Zone);
var $d8ce4e734394a836$var$_excluded = [
    "base"
], $d8ce4e734394a836$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $d8ce4e734394a836$var$intlLFCache = {};
function $d8ce4e734394a836$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $d8ce4e734394a836$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $d8ce4e734394a836$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $d8ce4e734394a836$var$intlDTCache = new Map();
function $d8ce4e734394a836$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $d8ce4e734394a836$var$intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $d8ce4e734394a836$var$intlDTCache.set(key, dtf);
    }
    return dtf;
}
var $d8ce4e734394a836$var$intlNumCache = new Map();
function $d8ce4e734394a836$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $d8ce4e734394a836$var$intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        $d8ce4e734394a836$var$intlNumCache.set(key, inf);
    }
    return inf;
}
var $d8ce4e734394a836$var$intlRelCache = new Map();
function $d8ce4e734394a836$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $d8ce4e734394a836$var$_objectWithoutPropertiesLoose(_opts, $d8ce4e734394a836$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $d8ce4e734394a836$var$intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $d8ce4e734394a836$var$intlRelCache.set(key, inf);
    }
    return inf;
}
var $d8ce4e734394a836$var$sysLocaleCache = null;
function $d8ce4e734394a836$var$systemLocale() {
    if ($d8ce4e734394a836$var$sysLocaleCache) return $d8ce4e734394a836$var$sysLocaleCache;
    else {
        $d8ce4e734394a836$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $d8ce4e734394a836$var$sysLocaleCache;
    }
}
var $d8ce4e734394a836$var$intlResolvedOptionsCache = new Map();
function $d8ce4e734394a836$var$getCachedIntResolvedOptions(locString) {
    var opts = $d8ce4e734394a836$var$intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        $d8ce4e734394a836$var$intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
var $d8ce4e734394a836$var$weekInfoCache = new Map();
function $d8ce4e734394a836$var$getCachedWeekInfo(locString) {
    var data = $d8ce4e734394a836$var$weekInfoCache.get(locString);
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = $d8ce4e734394a836$var$_extends({}, $d8ce4e734394a836$var$fallbackWeekSettings, data);
        $d8ce4e734394a836$var$weekInfoCache.set(locString, data);
    }
    return data;
}
function $d8ce4e734394a836$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $d8ce4e734394a836$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $d8ce4e734394a836$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $d8ce4e734394a836$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $d8ce4e734394a836$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $d8ce4e734394a836$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $d8ce4e734394a836$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $d8ce4e734394a836$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $d8ce4e734394a836$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $d8ce4e734394a836$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $d8ce4e734394a836$var$getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ var $d8ce4e734394a836$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $d8ce4e734394a836$var$_objectWithoutPropertiesLoose(opts, $d8ce4e734394a836$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $d8ce4e734394a836$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $d8ce4e734394a836$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $d8ce4e734394a836$var$roundTo(i, 3);
            return $d8ce4e734394a836$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $d8ce4e734394a836$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $d8ce4e734394a836$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $d8ce4e734394a836$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $d8ce4e734394a836$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $d8ce4e734394a836$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $d8ce4e734394a836$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $d8ce4e734394a836$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $d8ce4e734394a836$var$hasRelative()) this.rtf = $d8ce4e734394a836$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $d8ce4e734394a836$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $d8ce4e734394a836$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $d8ce4e734394a836$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $d8ce4e734394a836$var$Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $d8ce4e734394a836$var$systemLocale());
        var numberingSystemR = numberingSystem || $d8ce4e734394a836$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $d8ce4e734394a836$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $d8ce4e734394a836$var$validateWeekSettings(weekSettings) || $d8ce4e734394a836$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $d8ce4e734394a836$var$sysLocaleCache = null;
        $d8ce4e734394a836$var$intlDTCache.clear();
        $d8ce4e734394a836$var$intlNumCache.clear();
        $d8ce4e734394a836$var$intlRelCache.clear();
        $d8ce4e734394a836$var$intlResolvedOptionsCache.clear();
        $d8ce4e734394a836$var$weekInfoCache.clear();
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $d8ce4e734394a836$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $d8ce4e734394a836$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $d8ce4e734394a836$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($d8ce4e734394a836$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($d8ce4e734394a836$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $d8ce4e734394a836$var$listStuff(this, length, $d8ce4e734394a836$var$months, function() {
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            var monthSpecialCase = _this2.intl === "ja" || _this2.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) {
                var mapper = !monthSpecialCase ? function(dt) {
                    return _this2.extract(dt, intl, "month");
                } : function(dt) {
                    return _this2.dtFormatter(dt, intl).format();
                };
                _this2.monthsCache[formatStr][length] = $d8ce4e734394a836$var$mapMonths(mapper);
            }
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $d8ce4e734394a836$var$listStuff(this, length, $d8ce4e734394a836$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $d8ce4e734394a836$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $d8ce4e734394a836$var$listStuff(this, undefined, function() {
            return $d8ce4e734394a836$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $d8ce4e734394a836$var$DateTime.utc(2016, 11, 13, 9),
                    $d8ce4e734394a836$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $d8ce4e734394a836$var$listStuff(this, length, $d8ce4e734394a836$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $d8ce4e734394a836$var$DateTime.utc(-40, 1, 1),
                $d8ce4e734394a836$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $d8ce4e734394a836$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $d8ce4e734394a836$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $d8ce4e734394a836$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $d8ce4e734394a836$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $d8ce4e734394a836$var$getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$d8ce4e734394a836$var$hasLocaleWeekInfo()) return $d8ce4e734394a836$var$fallbackWeekSettings;
        else return $d8ce4e734394a836$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    $d8ce4e734394a836$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $d8ce4e734394a836$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $d8ce4e734394a836$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $d8ce4e734394a836$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $d8ce4e734394a836$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($d8ce4e734394a836$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $d8ce4e734394a836$var$formatOffset(this.fixed, format);
    };
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $d8ce4e734394a836$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $d8ce4e734394a836$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $d8ce4e734394a836$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($d8ce4e734394a836$var$singleton === null) $d8ce4e734394a836$var$singleton = new FixedOffsetZone(0);
                return $d8ce4e734394a836$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($d8ce4e734394a836$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $d8ce4e734394a836$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $d8ce4e734394a836$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $d8ce4e734394a836$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($d8ce4e734394a836$var$Zone);
/**
 * @private
 */ function $d8ce4e734394a836$var$normalizeZone(input, defaultZone) {
    if ($d8ce4e734394a836$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $d8ce4e734394a836$var$Zone) return input;
    else if ($d8ce4e734394a836$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $d8ce4e734394a836$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $d8ce4e734394a836$var$FixedOffsetZone.utcInstance;
        else return $d8ce4e734394a836$var$FixedOffsetZone.parseSpecifier(lowered) || $d8ce4e734394a836$var$IANAZone.create(input);
    } else if ($d8ce4e734394a836$var$isNumber(input)) return $d8ce4e734394a836$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $d8ce4e734394a836$var$InvalidZone(input);
}
var $d8ce4e734394a836$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $d8ce4e734394a836$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $d8ce4e734394a836$var$hanidecChars = $d8ce4e734394a836$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $d8ce4e734394a836$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($d8ce4e734394a836$var$numberingSystems.hanidec) !== -1) value += $d8ce4e734394a836$var$hanidecChars.indexOf(str[i]);
            else for(var key in $d8ce4e734394a836$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $d8ce4e734394a836$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var $d8ce4e734394a836$var$digitRegexCache = new Map();
function $d8ce4e734394a836$var$resetDigitRegexCache() {
    $d8ce4e734394a836$var$digitRegexCache.clear();
}
function $d8ce4e734394a836$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    var appendCache = $d8ce4e734394a836$var$digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        $d8ce4e734394a836$var$digitRegexCache.set(ns, appendCache);
    }
    var regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp("" + $d8ce4e734394a836$var$numberingSystems[ns] + append);
        appendCache.set(append, regex);
    }
    return regex;
}
var $d8ce4e734394a836$var$now = function now() {
    return Date.now();
}, $d8ce4e734394a836$var$defaultZone = "system", $d8ce4e734394a836$var$defaultLocale = null, $d8ce4e734394a836$var$defaultNumberingSystem = null, $d8ce4e734394a836$var$defaultOutputCalendar = null, $d8ce4e734394a836$var$twoDigitCutoffYear = 60, $d8ce4e734394a836$var$throwOnInvalid, $d8ce4e734394a836$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $d8ce4e734394a836$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $d8ce4e734394a836$var$Locale.resetCache();
        $d8ce4e734394a836$var$IANAZone.resetCache();
        $d8ce4e734394a836$var$DateTime.resetCache();
        $d8ce4e734394a836$var$resetDigitRegexCache();
    };
    $d8ce4e734394a836$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $d8ce4e734394a836$var$now;
            },
            set: function set(n) {
                $d8ce4e734394a836$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $d8ce4e734394a836$var$normalizeZone($d8ce4e734394a836$var$defaultZone, $d8ce4e734394a836$var$SystemZone.instance);
            },
            set: function set(zone) {
                $d8ce4e734394a836$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $d8ce4e734394a836$var$defaultLocale;
            },
            set: function set(locale) {
                $d8ce4e734394a836$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $d8ce4e734394a836$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $d8ce4e734394a836$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $d8ce4e734394a836$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $d8ce4e734394a836$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $d8ce4e734394a836$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $d8ce4e734394a836$var$defaultWeekSettings = $d8ce4e734394a836$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $d8ce4e734394a836$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $d8ce4e734394a836$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $d8ce4e734394a836$var$throwOnInvalid;
            },
            set: function set(t) {
                $d8ce4e734394a836$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $d8ce4e734394a836$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $d8ce4e734394a836$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $d8ce4e734394a836$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $d8ce4e734394a836$var$unitOutOfRange(unit, value) {
    return new $d8ce4e734394a836$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $d8ce4e734394a836$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $d8ce4e734394a836$var$computeOrdinal(year, month, day) {
    return day + ($d8ce4e734394a836$var$isLeapYear(year) ? $d8ce4e734394a836$var$leapLadder : $d8ce4e734394a836$var$nonLeapLadder)[month - 1];
}
function $d8ce4e734394a836$var$uncomputeOrdinal(year, ordinal) {
    var table = $d8ce4e734394a836$var$isLeapYear(year) ? $d8ce4e734394a836$var$leapLadder : $d8ce4e734394a836$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $d8ce4e734394a836$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $d8ce4e734394a836$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $d8ce4e734394a836$var$computeOrdinal(year, month, day), weekday = $d8ce4e734394a836$var$isoWeekdayToLocal($d8ce4e734394a836$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $d8ce4e734394a836$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $d8ce4e734394a836$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $d8ce4e734394a836$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $d8ce4e734394a836$var$timeObject(gregObj));
}
function $d8ce4e734394a836$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $d8ce4e734394a836$var$isoWeekdayToLocal($d8ce4e734394a836$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $d8ce4e734394a836$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $d8ce4e734394a836$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $d8ce4e734394a836$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $d8ce4e734394a836$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $d8ce4e734394a836$var$_extends({
        year: year,
        month: month,
        day: day
    }, $d8ce4e734394a836$var$timeObject(weekData));
}
function $d8ce4e734394a836$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $d8ce4e734394a836$var$computeOrdinal(year, month, day);
    return $d8ce4e734394a836$var$_extends({
        year: year,
        ordinal: ordinal
    }, $d8ce4e734394a836$var$timeObject(gregData));
}
function $d8ce4e734394a836$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $d8ce4e734394a836$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $d8ce4e734394a836$var$_extends({
        year: year,
        month: month,
        day: day
    }, $d8ce4e734394a836$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $d8ce4e734394a836$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$d8ce4e734394a836$var$isUndefined(obj.localWeekday) || !$d8ce4e734394a836$var$isUndefined(obj.localWeekNumber) || !$d8ce4e734394a836$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$d8ce4e734394a836$var$isUndefined(obj.weekday) || !$d8ce4e734394a836$var$isUndefined(obj.weekNumber) || !$d8ce4e734394a836$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $d8ce4e734394a836$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$d8ce4e734394a836$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$d8ce4e734394a836$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$d8ce4e734394a836$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $d8ce4e734394a836$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $d8ce4e734394a836$var$isInteger(obj.weekYear), validWeek = $d8ce4e734394a836$var$integerBetween(obj.weekNumber, 1, $d8ce4e734394a836$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $d8ce4e734394a836$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $d8ce4e734394a836$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $d8ce4e734394a836$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $d8ce4e734394a836$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $d8ce4e734394a836$var$hasInvalidOrdinalData(obj) {
    var validYear = $d8ce4e734394a836$var$isInteger(obj.year), validOrdinal = $d8ce4e734394a836$var$integerBetween(obj.ordinal, 1, $d8ce4e734394a836$var$daysInYear(obj.year));
    if (!validYear) return $d8ce4e734394a836$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $d8ce4e734394a836$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $d8ce4e734394a836$var$hasInvalidGregorianData(obj) {
    var validYear = $d8ce4e734394a836$var$isInteger(obj.year), validMonth = $d8ce4e734394a836$var$integerBetween(obj.month, 1, 12), validDay = $d8ce4e734394a836$var$integerBetween(obj.day, 1, $d8ce4e734394a836$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $d8ce4e734394a836$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $d8ce4e734394a836$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $d8ce4e734394a836$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $d8ce4e734394a836$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $d8ce4e734394a836$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $d8ce4e734394a836$var$integerBetween(minute, 0, 59), validSecond = $d8ce4e734394a836$var$integerBetween(second, 0, 59), validMillisecond = $d8ce4e734394a836$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $d8ce4e734394a836$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $d8ce4e734394a836$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $d8ce4e734394a836$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $d8ce4e734394a836$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $d8ce4e734394a836$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $d8ce4e734394a836$var$isNumber(o) {
    return typeof o === "number";
}
function $d8ce4e734394a836$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $d8ce4e734394a836$var$isString(o) {
    return typeof o === "string";
}
function $d8ce4e734394a836$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $d8ce4e734394a836$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $d8ce4e734394a836$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $d8ce4e734394a836$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $d8ce4e734394a836$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $d8ce4e734394a836$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $d8ce4e734394a836$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $d8ce4e734394a836$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $d8ce4e734394a836$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$d8ce4e734394a836$var$integerBetween(settings.firstDay, 1, 7) || !$d8ce4e734394a836$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$d8ce4e734394a836$var$integerBetween(v, 1, 7);
        })) throw new $d8ce4e734394a836$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $d8ce4e734394a836$var$integerBetween(thing, bottom, top) {
    return $d8ce4e734394a836$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $d8ce4e734394a836$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $d8ce4e734394a836$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $d8ce4e734394a836$var$parseInteger(string) {
    if ($d8ce4e734394a836$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $d8ce4e734394a836$var$parseFloating(string) {
    if ($d8ce4e734394a836$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $d8ce4e734394a836$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($d8ce4e734394a836$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $d8ce4e734394a836$var$roundTo(number, digits, rounding) {
    if (rounding === void 0) rounding = "round";
    var factor = Math.pow(10, digits);
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError("Value rounding " + rounding + " is out of range");
    }
}
// DATE BASICS
function $d8ce4e734394a836$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $d8ce4e734394a836$var$daysInYear(year) {
    return $d8ce4e734394a836$var$isLeapYear(year) ? 366 : 365;
}
function $d8ce4e734394a836$var$daysInMonth(year, month) {
    var modMonth = $d8ce4e734394a836$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $d8ce4e734394a836$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $d8ce4e734394a836$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $d8ce4e734394a836$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $d8ce4e734394a836$var$isoWeekdayToLocal($d8ce4e734394a836$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $d8ce4e734394a836$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $d8ce4e734394a836$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $d8ce4e734394a836$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($d8ce4e734394a836$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $d8ce4e734394a836$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $d8ce4e734394a836$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $d8ce4e734394a836$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $d8ce4e734394a836$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $d8ce4e734394a836$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $d8ce4e734394a836$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new $d8ce4e734394a836$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $d8ce4e734394a836$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($d8ce4e734394a836$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $d8ce4e734394a836$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $d8ce4e734394a836$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $d8ce4e734394a836$var$padStart(hours, 2) + ":" + $d8ce4e734394a836$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $d8ce4e734394a836$var$padStart(hours, 2) + $d8ce4e734394a836$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $d8ce4e734394a836$var$timeObject(obj) {
    return $d8ce4e734394a836$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $d8ce4e734394a836$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $d8ce4e734394a836$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $d8ce4e734394a836$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $d8ce4e734394a836$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($d8ce4e734394a836$var$monthsNarrow);
        case "short":
            return [].concat($d8ce4e734394a836$var$monthsShort);
        case "long":
            return [].concat($d8ce4e734394a836$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $d8ce4e734394a836$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $d8ce4e734394a836$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $d8ce4e734394a836$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $d8ce4e734394a836$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($d8ce4e734394a836$var$weekdaysNarrow);
        case "short":
            return [].concat($d8ce4e734394a836$var$weekdaysShort);
        case "long":
            return [].concat($d8ce4e734394a836$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $d8ce4e734394a836$var$meridiems = [
    "AM",
    "PM"
];
var $d8ce4e734394a836$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $d8ce4e734394a836$var$erasShort = [
    "BC",
    "AD"
];
var $d8ce4e734394a836$var$erasNarrow = [
    "B",
    "A"
];
function $d8ce4e734394a836$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($d8ce4e734394a836$var$erasNarrow);
        case "short":
            return [].concat($d8ce4e734394a836$var$erasShort);
        case "long":
            return [].concat($d8ce4e734394a836$var$erasLong);
        default:
            return null;
    }
}
function $d8ce4e734394a836$var$meridiemForDateTime(dt) {
    return $d8ce4e734394a836$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $d8ce4e734394a836$var$weekdayForDateTime(dt, length) {
    return $d8ce4e734394a836$var$weekdays(length)[dt.weekday - 1];
}
function $d8ce4e734394a836$var$monthForDateTime(dt, length) {
    return $d8ce4e734394a836$var$months(length)[dt.month - 1];
}
function $d8ce4e734394a836$var$eraForDateTime(dt, length) {
    return $d8ce4e734394a836$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $d8ce4e734394a836$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $d8ce4e734394a836$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $d8ce4e734394a836$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $d8ce4e734394a836$var$_macroTokenToFormatOpts = {
    D: $d8ce4e734394a836$var$DATE_SHORT,
    DD: $d8ce4e734394a836$var$DATE_MED,
    DDD: $d8ce4e734394a836$var$DATE_FULL,
    DDDD: $d8ce4e734394a836$var$DATE_HUGE,
    t: $d8ce4e734394a836$var$TIME_SIMPLE,
    tt: $d8ce4e734394a836$var$TIME_WITH_SECONDS,
    ttt: $d8ce4e734394a836$var$TIME_WITH_SHORT_OFFSET,
    tttt: $d8ce4e734394a836$var$TIME_WITH_LONG_OFFSET,
    T: $d8ce4e734394a836$var$TIME_24_SIMPLE,
    TT: $d8ce4e734394a836$var$TIME_24_WITH_SECONDS,
    TTT: $d8ce4e734394a836$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $d8ce4e734394a836$var$TIME_24_WITH_LONG_OFFSET,
    f: $d8ce4e734394a836$var$DATETIME_SHORT,
    ff: $d8ce4e734394a836$var$DATETIME_MED,
    fff: $d8ce4e734394a836$var$DATETIME_FULL,
    ffff: $d8ce4e734394a836$var$DATETIME_HUGE,
    F: $d8ce4e734394a836$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $d8ce4e734394a836$var$DATETIME_MED_WITH_SECONDS,
    FFF: $d8ce4e734394a836$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $d8ce4e734394a836$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $d8ce4e734394a836$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $d8ce4e734394a836$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $d8ce4e734394a836$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $d8ce4e734394a836$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p, signDisplay) {
        if (p === void 0) p = 0;
        if (signDisplay === void 0) signDisplay = undefined;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $d8ce4e734394a836$var$padStart(n, p);
        var opts = $d8ce4e734394a836$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $d8ce4e734394a836$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $d8ce4e734394a836$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $d8ce4e734394a836$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $d8ce4e734394a836$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $d8ce4e734394a836$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur, info) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) {
                    var inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    var signDisplay;
                    if (_this2.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (_this2.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return _this2.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        })), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return $d8ce4e734394a836$var$stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $d8ce4e734394a836$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $d8ce4e734394a836$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $d8ce4e734394a836$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $d8ce4e734394a836$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $d8ce4e734394a836$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $d8ce4e734394a836$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $d8ce4e734394a836$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $d8ce4e734394a836$var$offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var $d8ce4e734394a836$var$isoExtendedZone = "(?:" + $d8ce4e734394a836$var$offsetRegex.source + "?(?:\\[(" + $d8ce4e734394a836$var$ianaRegex.source + ")\\])?)?";
var $d8ce4e734394a836$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $d8ce4e734394a836$var$isoTimeRegex = RegExp("" + $d8ce4e734394a836$var$isoTimeBaseRegex.source + $d8ce4e734394a836$var$isoExtendedZone);
var $d8ce4e734394a836$var$isoTimeExtensionRegex = RegExp("(?:[Tt]" + $d8ce4e734394a836$var$isoTimeRegex.source + ")?");
var $d8ce4e734394a836$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $d8ce4e734394a836$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $d8ce4e734394a836$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $d8ce4e734394a836$var$extractISOWeekData = $d8ce4e734394a836$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $d8ce4e734394a836$var$extractISOOrdinalData = $d8ce4e734394a836$var$simpleParse("year", "ordinal");
var $d8ce4e734394a836$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $d8ce4e734394a836$var$sqlTimeRegex = RegExp($d8ce4e734394a836$var$isoTimeBaseRegex.source + " ?(?:" + $d8ce4e734394a836$var$offsetRegex.source + "|(" + $d8ce4e734394a836$var$ianaRegex.source + "))?");
var $d8ce4e734394a836$var$sqlTimeExtensionRegex = RegExp("(?: " + $d8ce4e734394a836$var$sqlTimeRegex.source + ")?");
function $d8ce4e734394a836$var$int(match, pos, fallback) {
    var m = match[pos];
    return $d8ce4e734394a836$var$isUndefined(m) ? fallback : $d8ce4e734394a836$var$parseInteger(m);
}
function $d8ce4e734394a836$var$extractISOYmd(match, cursor) {
    var item = {
        year: $d8ce4e734394a836$var$int(match, cursor),
        month: $d8ce4e734394a836$var$int(match, cursor + 1, 1),
        day: $d8ce4e734394a836$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $d8ce4e734394a836$var$extractISOTime(match, cursor) {
    var item = {
        hours: $d8ce4e734394a836$var$int(match, cursor, 0),
        minutes: $d8ce4e734394a836$var$int(match, cursor + 1, 0),
        seconds: $d8ce4e734394a836$var$int(match, cursor + 2, 0),
        milliseconds: $d8ce4e734394a836$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $d8ce4e734394a836$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $d8ce4e734394a836$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $d8ce4e734394a836$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $d8ce4e734394a836$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $d8ce4e734394a836$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $d8ce4e734394a836$var$isoTimeOnly = RegExp("^T?" + $d8ce4e734394a836$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $d8ce4e734394a836$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $d8ce4e734394a836$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($d8ce4e734394a836$var$parseFloating(yearStr)),
            months: maybeNegate($d8ce4e734394a836$var$parseFloating(monthStr)),
            weeks: maybeNegate($d8ce4e734394a836$var$parseFloating(weekStr)),
            days: maybeNegate($d8ce4e734394a836$var$parseFloating(dayStr)),
            hours: maybeNegate($d8ce4e734394a836$var$parseFloating(hourStr)),
            minutes: maybeNegate($d8ce4e734394a836$var$parseFloating(minuteStr)),
            seconds: maybeNegate($d8ce4e734394a836$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($d8ce4e734394a836$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $d8ce4e734394a836$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $d8ce4e734394a836$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $d8ce4e734394a836$var$untruncateYear($d8ce4e734394a836$var$parseInteger(yearStr)) : $d8ce4e734394a836$var$parseInteger(yearStr),
        month: $d8ce4e734394a836$var$monthsShort.indexOf(monthStr) + 1,
        day: $d8ce4e734394a836$var$parseInteger(dayStr),
        hour: $d8ce4e734394a836$var$parseInteger(hourStr),
        minute: $d8ce4e734394a836$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $d8ce4e734394a836$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $d8ce4e734394a836$var$weekdaysLong.indexOf(weekdayStr) + 1 : $d8ce4e734394a836$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $d8ce4e734394a836$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $d8ce4e734394a836$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $d8ce4e734394a836$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $d8ce4e734394a836$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $d8ce4e734394a836$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $d8ce4e734394a836$var$FixedOffsetZone(offset)
    ];
}
function $d8ce4e734394a836$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $d8ce4e734394a836$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $d8ce4e734394a836$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $d8ce4e734394a836$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $d8ce4e734394a836$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $d8ce4e734394a836$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $d8ce4e734394a836$var$FixedOffsetZone.utcInstance
    ];
}
function $d8ce4e734394a836$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $d8ce4e734394a836$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $d8ce4e734394a836$var$FixedOffsetZone.utcInstance
    ];
}
var $d8ce4e734394a836$var$isoYmdWithTimeExtensionRegex = $d8ce4e734394a836$var$combineRegexes($d8ce4e734394a836$var$isoYmdRegex, $d8ce4e734394a836$var$isoTimeExtensionRegex);
var $d8ce4e734394a836$var$isoWeekWithTimeExtensionRegex = $d8ce4e734394a836$var$combineRegexes($d8ce4e734394a836$var$isoWeekRegex, $d8ce4e734394a836$var$isoTimeExtensionRegex);
var $d8ce4e734394a836$var$isoOrdinalWithTimeExtensionRegex = $d8ce4e734394a836$var$combineRegexes($d8ce4e734394a836$var$isoOrdinalRegex, $d8ce4e734394a836$var$isoTimeExtensionRegex);
var $d8ce4e734394a836$var$isoTimeCombinedRegex = $d8ce4e734394a836$var$combineRegexes($d8ce4e734394a836$var$isoTimeRegex);
var $d8ce4e734394a836$var$extractISOYmdTimeAndOffset = $d8ce4e734394a836$var$combineExtractors($d8ce4e734394a836$var$extractISOYmd, $d8ce4e734394a836$var$extractISOTime, $d8ce4e734394a836$var$extractISOOffset, $d8ce4e734394a836$var$extractIANAZone);
var $d8ce4e734394a836$var$extractISOWeekTimeAndOffset = $d8ce4e734394a836$var$combineExtractors($d8ce4e734394a836$var$extractISOWeekData, $d8ce4e734394a836$var$extractISOTime, $d8ce4e734394a836$var$extractISOOffset, $d8ce4e734394a836$var$extractIANAZone);
var $d8ce4e734394a836$var$extractISOOrdinalDateAndTime = $d8ce4e734394a836$var$combineExtractors($d8ce4e734394a836$var$extractISOOrdinalData, $d8ce4e734394a836$var$extractISOTime, $d8ce4e734394a836$var$extractISOOffset, $d8ce4e734394a836$var$extractIANAZone);
var $d8ce4e734394a836$var$extractISOTimeAndOffset = $d8ce4e734394a836$var$combineExtractors($d8ce4e734394a836$var$extractISOTime, $d8ce4e734394a836$var$extractISOOffset, $d8ce4e734394a836$var$extractIANAZone);
/*
 * @private
 */ function $d8ce4e734394a836$var$parseISODate(s) {
    return $d8ce4e734394a836$var$parse(s, [
        $d8ce4e734394a836$var$isoYmdWithTimeExtensionRegex,
        $d8ce4e734394a836$var$extractISOYmdTimeAndOffset
    ], [
        $d8ce4e734394a836$var$isoWeekWithTimeExtensionRegex,
        $d8ce4e734394a836$var$extractISOWeekTimeAndOffset
    ], [
        $d8ce4e734394a836$var$isoOrdinalWithTimeExtensionRegex,
        $d8ce4e734394a836$var$extractISOOrdinalDateAndTime
    ], [
        $d8ce4e734394a836$var$isoTimeCombinedRegex,
        $d8ce4e734394a836$var$extractISOTimeAndOffset
    ]);
}
function $d8ce4e734394a836$var$parseRFC2822Date(s) {
    return $d8ce4e734394a836$var$parse($d8ce4e734394a836$var$preprocessRFC2822(s), [
        $d8ce4e734394a836$var$rfc2822,
        $d8ce4e734394a836$var$extractRFC2822
    ]);
}
function $d8ce4e734394a836$var$parseHTTPDate(s) {
    return $d8ce4e734394a836$var$parse(s, [
        $d8ce4e734394a836$var$rfc1123,
        $d8ce4e734394a836$var$extractRFC1123Or850
    ], [
        $d8ce4e734394a836$var$rfc850,
        $d8ce4e734394a836$var$extractRFC1123Or850
    ], [
        $d8ce4e734394a836$var$ascii,
        $d8ce4e734394a836$var$extractASCII
    ]);
}
function $d8ce4e734394a836$var$parseISODuration(s) {
    return $d8ce4e734394a836$var$parse(s, [
        $d8ce4e734394a836$var$isoDuration,
        $d8ce4e734394a836$var$extractISODuration
    ]);
}
var $d8ce4e734394a836$var$extractISOTimeOnly = $d8ce4e734394a836$var$combineExtractors($d8ce4e734394a836$var$extractISOTime);
function $d8ce4e734394a836$var$parseISOTimeOnly(s) {
    return $d8ce4e734394a836$var$parse(s, [
        $d8ce4e734394a836$var$isoTimeOnly,
        $d8ce4e734394a836$var$extractISOTimeOnly
    ]);
}
var $d8ce4e734394a836$var$sqlYmdWithTimeExtensionRegex = $d8ce4e734394a836$var$combineRegexes($d8ce4e734394a836$var$sqlYmdRegex, $d8ce4e734394a836$var$sqlTimeExtensionRegex);
var $d8ce4e734394a836$var$sqlTimeCombinedRegex = $d8ce4e734394a836$var$combineRegexes($d8ce4e734394a836$var$sqlTimeRegex);
var $d8ce4e734394a836$var$extractISOTimeOffsetAndIANAZone = $d8ce4e734394a836$var$combineExtractors($d8ce4e734394a836$var$extractISOTime, $d8ce4e734394a836$var$extractISOOffset, $d8ce4e734394a836$var$extractIANAZone);
function $d8ce4e734394a836$var$parseSQL(s) {
    return $d8ce4e734394a836$var$parse(s, [
        $d8ce4e734394a836$var$sqlYmdWithTimeExtensionRegex,
        $d8ce4e734394a836$var$extractISOYmdTimeAndOffset
    ], [
        $d8ce4e734394a836$var$sqlTimeCombinedRegex,
        $d8ce4e734394a836$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $d8ce4e734394a836$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $d8ce4e734394a836$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $d8ce4e734394a836$var$casualMatrix = $d8ce4e734394a836$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $d8ce4e734394a836$var$lowOrderMatrix), $d8ce4e734394a836$var$daysInYearAccurate = 365.2425, $d8ce4e734394a836$var$daysInMonthAccurate = 30.436875, $d8ce4e734394a836$var$accurateMatrix = $d8ce4e734394a836$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $d8ce4e734394a836$var$daysInYearAccurate / 7,
        days: $d8ce4e734394a836$var$daysInYearAccurate,
        hours: $d8ce4e734394a836$var$daysInYearAccurate * 24,
        minutes: $d8ce4e734394a836$var$daysInYearAccurate * 1440,
        seconds: $d8ce4e734394a836$var$daysInYearAccurate * 86400,
        milliseconds: $d8ce4e734394a836$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $d8ce4e734394a836$var$daysInYearAccurate / 28,
        days: $d8ce4e734394a836$var$daysInYearAccurate / 4,
        hours: $d8ce4e734394a836$var$daysInYearAccurate * 24 / 4,
        minutes: $d8ce4e734394a836$var$daysInYearAccurate * 1440 / 4,
        seconds: $d8ce4e734394a836$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $d8ce4e734394a836$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $d8ce4e734394a836$var$daysInMonthAccurate / 7,
        days: $d8ce4e734394a836$var$daysInMonthAccurate,
        hours: $d8ce4e734394a836$var$daysInMonthAccurate * 24,
        minutes: $d8ce4e734394a836$var$daysInMonthAccurate * 1440,
        seconds: $d8ce4e734394a836$var$daysInMonthAccurate * 86400,
        milliseconds: $d8ce4e734394a836$var$daysInMonthAccurate * 86400000
    }
}, $d8ce4e734394a836$var$lowOrderMatrix);
// units ordered by size
var $d8ce4e734394a836$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $d8ce4e734394a836$var$reverseUnits = $d8ce4e734394a836$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $d8ce4e734394a836$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $d8ce4e734394a836$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $d8ce4e734394a836$var$Duration(conf);
}
function $d8ce4e734394a836$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $d8ce4e734394a836$var$_createForOfIteratorHelperLoose($d8ce4e734394a836$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $d8ce4e734394a836$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $d8ce4e734394a836$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $d8ce4e734394a836$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$d8ce4e734394a836$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $d8ce4e734394a836$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$d8ce4e734394a836$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $d8ce4e734394a836$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $d8ce4e734394a836$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $d8ce4e734394a836$var$accurateMatrix : $d8ce4e734394a836$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $d8ce4e734394a836$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $d8ce4e734394a836$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $d8ce4e734394a836$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $d8ce4e734394a836$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($d8ce4e734394a836$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $d8ce4e734394a836$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $d8ce4e734394a836$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $d8ce4e734394a836$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $d8ce4e734394a836$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $d8ce4e734394a836$var$Invalid ? reason : new $d8ce4e734394a836$var$Invalid(reason, explanation);
        if ($d8ce4e734394a836$var$Settings.throwOnInvalid) throw new $d8ce4e734394a836$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $d8ce4e734394a836$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $d8ce4e734394a836$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $d8ce4e734394a836$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $d8ce4e734394a836$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $d8ce4e734394a836$var$INVALID$2;
        var showZeros = opts.showZeros !== false;
        var l = $d8ce4e734394a836$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($d8ce4e734394a836$var$isUndefined(val) || val === 0 && !showZeros) return null;
            return _this.loc.numberFormatter($d8ce4e734394a836$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($d8ce4e734394a836$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $d8ce4e734394a836$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $d8ce4e734394a836$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $d8ce4e734394a836$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $d8ce4e734394a836$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $d8ce4e734394a836$var$durationToMillis(this.matrix, this.values);
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $d8ce4e734394a836$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($d8ce4e734394a836$var$hasOwnProperty(dur.values, k) || $d8ce4e734394a836$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $d8ce4e734394a836$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $d8ce4e734394a836$var$asNumber(fn(this.values[k], k));
        }
        return $d8ce4e734394a836$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $d8ce4e734394a836$var$_extends({}, this.values, $d8ce4e734394a836$var$normalizeObject(values, Duration.normalizeUnit));
        return $d8ce4e734394a836$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $d8ce4e734394a836$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $d8ce4e734394a836$var$normalizeValues(this.matrix, vals);
        return $d8ce4e734394a836$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $d8ce4e734394a836$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $d8ce4e734394a836$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $d8ce4e734394a836$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($d8ce4e734394a836$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($d8ce4e734394a836$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $d8ce4e734394a836$var$normalizeValues(this.matrix, built);
        return $d8ce4e734394a836$var$clone$1(this, {
            values: built
        }, true);
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $d8ce4e734394a836$var$clone$1(this, {
            values: negated
        }, true);
    };
    _proto.removeZeros = function removeZeros() {
        if (!this.isValid) return this;
        var vals = $d8ce4e734394a836$var$removeZeroes(this.values);
        return $d8ce4e734394a836$var$clone$1(this, {
            values: vals
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $d8ce4e734394a836$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $d8ce4e734394a836$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $d8ce4e734394a836$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $d8ce4e734394a836$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $d8ce4e734394a836$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $d8ce4e734394a836$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $d8ce4e734394a836$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $d8ce4e734394a836$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $d8ce4e734394a836$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $d8ce4e734394a836$var$Invalid ? reason : new $d8ce4e734394a836$var$Invalid(reason, explanation);
        if ($d8ce4e734394a836$var$Settings.throwOnInvalid) throw new $d8ce4e734394a836$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $d8ce4e734394a836$var$friendlyDateTime(start), builtEnd = $d8ce4e734394a836$var$friendlyDateTime(end);
        var validateError = $d8ce4e734394a836$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $d8ce4e734394a836$var$Duration.fromDurationLike(duration), dt = $d8ce4e734394a836$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $d8ce4e734394a836$var$Duration.fromDurationLike(duration), dt = $d8ce4e734394a836$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $d8ce4e734394a836$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $d8ce4e734394a836$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $d8ce4e734394a836$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $d8ce4e734394a836$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($d8ce4e734394a836$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $d8ce4e734394a836$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $d8ce4e734394a836$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $d8ce4e734394a836$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $d8ce4e734394a836$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $d8ce4e734394a836$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $d8ce4e734394a836$var$INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $d8ce4e734394a836$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $d8ce4e734394a836$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $d8ce4e734394a836$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $d8ce4e734394a836$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $d8ce4e734394a836$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $d8ce4e734394a836$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "lastDateTime",
            get: function get() {
                return this.isValid ? this.e ? this.e.minus(1) : null : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $d8ce4e734394a836$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $d8ce4e734394a836$var$Settings.defaultZone;
        var proto = $d8ce4e734394a836$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $d8ce4e734394a836$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $d8ce4e734394a836$var$normalizeZone(input, $d8ce4e734394a836$var$Settings.defaultZone);
    };
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $d8ce4e734394a836$var$Locale.create(locale)).getStartOfWeek();
    };
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $d8ce4e734394a836$var$Locale.create(locale)).getMinDaysInFirstWeek();
    };
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $d8ce4e734394a836$var$Locale.create(locale)).getWeekendDays().slice();
    };
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $d8ce4e734394a836$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $d8ce4e734394a836$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $d8ce4e734394a836$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $d8ce4e734394a836$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $d8ce4e734394a836$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $d8ce4e734394a836$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $d8ce4e734394a836$var$hasRelative(),
            localeWeek: $d8ce4e734394a836$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $d8ce4e734394a836$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($d8ce4e734394a836$var$Duration.fromMillis(ms).as("days"));
}
function $d8ce4e734394a836$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $d8ce4e734394a836$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $d8ce4e734394a836$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $d8ce4e734394a836$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $d8ce4e734394a836$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $d8ce4e734394a836$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $d8ce4e734394a836$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $d8ce4e734394a836$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $d8ce4e734394a836$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($d8ce4e734394a836$var$parseDigits(s));
        }
    };
}
var $d8ce4e734394a836$var$NBSP = String.fromCharCode(160);
var $d8ce4e734394a836$var$spaceOrNBSP = "[ " + $d8ce4e734394a836$var$NBSP + "]";
var $d8ce4e734394a836$var$spaceOrNBSPRegExp = new RegExp($d8ce4e734394a836$var$spaceOrNBSP, "g");
function $d8ce4e734394a836$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($d8ce4e734394a836$var$spaceOrNBSPRegExp, $d8ce4e734394a836$var$spaceOrNBSP);
}
function $d8ce4e734394a836$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($d8ce4e734394a836$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $d8ce4e734394a836$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($d8ce4e734394a836$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $d8ce4e734394a836$var$stripInsensitivities(s) === $d8ce4e734394a836$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $d8ce4e734394a836$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $d8ce4e734394a836$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $d8ce4e734394a836$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $d8ce4e734394a836$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $d8ce4e734394a836$var$unitForToken(token, loc) {
    var one = $d8ce4e734394a836$var$digitRegex(loc), two = $d8ce4e734394a836$var$digitRegex(loc, "{2}"), three = $d8ce4e734394a836$var$digitRegex(loc, "{3}"), four = $d8ce4e734394a836$var$digitRegex(loc, "{4}"), six = $d8ce4e734394a836$var$digitRegex(loc, "{6}"), oneOrTwo = $d8ce4e734394a836$var$digitRegex(loc, "{1,2}"), oneToThree = $d8ce4e734394a836$var$digitRegex(loc, "{1,3}"), oneToSix = $d8ce4e734394a836$var$digitRegex(loc, "{1,6}"), oneToNine = $d8ce4e734394a836$var$digitRegex(loc, "{1,9}"), twoToFour = $d8ce4e734394a836$var$digitRegex(loc, "{2,4}"), fourToSix = $d8ce4e734394a836$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($d8ce4e734394a836$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $d8ce4e734394a836$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $d8ce4e734394a836$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $d8ce4e734394a836$var$intUnit(oneToSix);
            case "yy":
                return $d8ce4e734394a836$var$intUnit(twoToFour, $d8ce4e734394a836$var$untruncateYear);
            case "yyyy":
                return $d8ce4e734394a836$var$intUnit(four);
            case "yyyyy":
                return $d8ce4e734394a836$var$intUnit(fourToSix);
            case "yyyyyy":
                return $d8ce4e734394a836$var$intUnit(six);
            // months
            case "M":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "MM":
                return $d8ce4e734394a836$var$intUnit(two);
            case "MMM":
                return $d8ce4e734394a836$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $d8ce4e734394a836$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "LL":
                return $d8ce4e734394a836$var$intUnit(two);
            case "LLL":
                return $d8ce4e734394a836$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $d8ce4e734394a836$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "dd":
                return $d8ce4e734394a836$var$intUnit(two);
            // ordinals
            case "o":
                return $d8ce4e734394a836$var$intUnit(oneToThree);
            case "ooo":
                return $d8ce4e734394a836$var$intUnit(three);
            // time
            case "HH":
                return $d8ce4e734394a836$var$intUnit(two);
            case "H":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "hh":
                return $d8ce4e734394a836$var$intUnit(two);
            case "h":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "mm":
                return $d8ce4e734394a836$var$intUnit(two);
            case "m":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "q":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "qq":
                return $d8ce4e734394a836$var$intUnit(two);
            case "s":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "ss":
                return $d8ce4e734394a836$var$intUnit(two);
            case "S":
                return $d8ce4e734394a836$var$intUnit(oneToThree);
            case "SSS":
                return $d8ce4e734394a836$var$intUnit(three);
            case "u":
                return $d8ce4e734394a836$var$simple(oneToNine);
            case "uu":
                return $d8ce4e734394a836$var$simple(oneOrTwo);
            case "uuu":
                return $d8ce4e734394a836$var$intUnit(one);
            // meridiem
            case "a":
                return $d8ce4e734394a836$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $d8ce4e734394a836$var$intUnit(four);
            case "kk":
                return $d8ce4e734394a836$var$intUnit(twoToFour, $d8ce4e734394a836$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $d8ce4e734394a836$var$intUnit(oneOrTwo);
            case "WW":
                return $d8ce4e734394a836$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $d8ce4e734394a836$var$intUnit(one);
            case "EEE":
                return $d8ce4e734394a836$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $d8ce4e734394a836$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $d8ce4e734394a836$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $d8ce4e734394a836$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $d8ce4e734394a836$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $d8ce4e734394a836$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $d8ce4e734394a836$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $d8ce4e734394a836$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $d8ce4e734394a836$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $d8ce4e734394a836$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $d8ce4e734394a836$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $d8ce4e734394a836$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $d8ce4e734394a836$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $d8ce4e734394a836$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($d8ce4e734394a836$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $d8ce4e734394a836$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$d8ce4e734394a836$var$isUndefined(matches.z)) zone = $d8ce4e734394a836$var$IANAZone.create(matches.z);
    if (!$d8ce4e734394a836$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $d8ce4e734394a836$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$d8ce4e734394a836$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$d8ce4e734394a836$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$d8ce4e734394a836$var$isUndefined(matches.u)) matches.S = $d8ce4e734394a836$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $d8ce4e734394a836$var$dummyDateTimeCache = null;
function $d8ce4e734394a836$var$getDummyDateTime() {
    if (!$d8ce4e734394a836$var$dummyDateTimeCache) $d8ce4e734394a836$var$dummyDateTimeCache = $d8ce4e734394a836$var$DateTime.fromMillis(1555555555555);
    return $d8ce4e734394a836$var$dummyDateTimeCache;
}
function $d8ce4e734394a836$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $d8ce4e734394a836$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $d8ce4e734394a836$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $d8ce4e734394a836$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $d8ce4e734394a836$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var $d8ce4e734394a836$var$TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = $d8ce4e734394a836$var$expandMacroTokens($d8ce4e734394a836$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return $d8ce4e734394a836$var$unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = $d8ce4e734394a836$var$buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = $d8ce4e734394a836$var$match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $d8ce4e734394a836$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if ($d8ce4e734394a836$var$hasOwnProperty(matches, "a") && $d8ce4e734394a836$var$hasOwnProperty(matches, "H")) throw new $d8ce4e734394a836$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    $d8ce4e734394a836$var$_createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function $d8ce4e734394a836$var$explainFromTokens(locale, input, format) {
    var parser = new $d8ce4e734394a836$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $d8ce4e734394a836$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $d8ce4e734394a836$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $d8ce4e734394a836$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $d8ce4e734394a836$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($d8ce4e734394a836$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $d8ce4e734394a836$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $d8ce4e734394a836$var$INVALID = "Invalid DateTime";
var $d8ce4e734394a836$var$MAX_DATE = 8.64e15;
function $d8ce4e734394a836$var$unsupportedZone(zone) {
    return new $d8ce4e734394a836$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $d8ce4e734394a836$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $d8ce4e734394a836$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $d8ce4e734394a836$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $d8ce4e734394a836$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $d8ce4e734394a836$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $d8ce4e734394a836$var$DateTime($d8ce4e734394a836$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $d8ce4e734394a836$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $d8ce4e734394a836$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $d8ce4e734394a836$var$objToTS(obj, offset, zone) {
    return $d8ce4e734394a836$var$fixOffset($d8ce4e734394a836$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $d8ce4e734394a836$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $d8ce4e734394a836$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $d8ce4e734394a836$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $d8ce4e734394a836$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $d8ce4e734394a836$var$objToLocalTS(c);
    var _fixOffset = $d8ce4e734394a836$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $d8ce4e734394a836$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $d8ce4e734394a836$var$DateTime.fromObject(parsed, $d8ce4e734394a836$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $d8ce4e734394a836$var$DateTime.invalid(new $d8ce4e734394a836$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $d8ce4e734394a836$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $d8ce4e734394a836$var$Formatter.create($d8ce4e734394a836$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $d8ce4e734394a836$var$_toISODate(o, extended, precision) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $d8ce4e734394a836$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += $d8ce4e734394a836$var$padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += $d8ce4e734394a836$var$padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += $d8ce4e734394a836$var$padStart(o.c.day);
    return c;
}
function $d8ce4e734394a836$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    var showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += $d8ce4e734394a836$var$padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += $d8ce4e734394a836$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += $d8ce4e734394a836$var$padStart(o.c.second);
                }
            } else {
                c += $d8ce4e734394a836$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += $d8ce4e734394a836$var$padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += $d8ce4e734394a836$var$padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $d8ce4e734394a836$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $d8ce4e734394a836$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $d8ce4e734394a836$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $d8ce4e734394a836$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $d8ce4e734394a836$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $d8ce4e734394a836$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $d8ce4e734394a836$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $d8ce4e734394a836$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $d8ce4e734394a836$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $d8ce4e734394a836$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $d8ce4e734394a836$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $d8ce4e734394a836$var$InvalidUnitError(unit);
    return normalized;
}
function $d8ce4e734394a836$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $d8ce4e734394a836$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function $d8ce4e734394a836$var$guessOffsetForZone(zone) {
    if ($d8ce4e734394a836$var$zoneOffsetTs === undefined) $d8ce4e734394a836$var$zoneOffsetTs = $d8ce4e734394a836$var$Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset($d8ce4e734394a836$var$zoneOffsetTs);
    var zoneName = zone.name;
    var offsetGuess = $d8ce4e734394a836$var$zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset($d8ce4e734394a836$var$zoneOffsetTs);
        $d8ce4e734394a836$var$zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $d8ce4e734394a836$var$quickDT(obj, opts) {
    var zone = $d8ce4e734394a836$var$normalizeZone(opts.zone, $d8ce4e734394a836$var$Settings.defaultZone);
    if (!zone.isValid) return $d8ce4e734394a836$var$DateTime.invalid($d8ce4e734394a836$var$unsupportedZone(zone));
    var loc = $d8ce4e734394a836$var$Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!$d8ce4e734394a836$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $d8ce4e734394a836$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($d8ce4e734394a836$var$isUndefined(obj[u])) obj[u] = $d8ce4e734394a836$var$defaultUnitValues[u];
        }
        var invalid = $d8ce4e734394a836$var$hasInvalidGregorianData(obj) || $d8ce4e734394a836$var$hasInvalidTimeData(obj);
        if (invalid) return $d8ce4e734394a836$var$DateTime.invalid(invalid);
        var offsetProvis = $d8ce4e734394a836$var$guessOffsetForZone(zone);
        var _objToTS = $d8ce4e734394a836$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = $d8ce4e734394a836$var$Settings.now();
    return new $d8ce4e734394a836$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $d8ce4e734394a836$var$diffRelative(start, end, opts) {
    var round = $d8ce4e734394a836$var$isUndefined(opts.round) ? true : opts.round, rounding = $d8ce4e734394a836$var$isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = function format(c, unit) {
        c = $d8ce4e734394a836$var$roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $d8ce4e734394a836$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $d8ce4e734394a836$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var $d8ce4e734394a836$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var $d8ce4e734394a836$var$zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $d8ce4e734394a836$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $d8ce4e734394a836$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $d8ce4e734394a836$var$Invalid("invalid input") : null) || (!zone.isValid ? $d8ce4e734394a836$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $d8ce4e734394a836$var$isUndefined(config.ts) ? $d8ce4e734394a836$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = $d8ce4e734394a836$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $d8ce4e734394a836$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $d8ce4e734394a836$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $d8ce4e734394a836$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $d8ce4e734394a836$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $d8ce4e734394a836$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $d8ce4e734394a836$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $d8ce4e734394a836$var$FixedOffsetZone.utcInstance;
        return $d8ce4e734394a836$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $d8ce4e734394a836$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $d8ce4e734394a836$var$normalizeZone(options.zone, $d8ce4e734394a836$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($d8ce4e734394a836$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $d8ce4e734394a836$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$d8ce4e734394a836$var$isNumber(milliseconds)) throw new $d8ce4e734394a836$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$d8ce4e734394a836$var$MAX_DATE || milliseconds > $d8ce4e734394a836$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $d8ce4e734394a836$var$normalizeZone(options.zone, $d8ce4e734394a836$var$Settings.defaultZone),
            loc: $d8ce4e734394a836$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$d8ce4e734394a836$var$isNumber(seconds)) throw new $d8ce4e734394a836$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $d8ce4e734394a836$var$normalizeZone(options.zone, $d8ce4e734394a836$var$Settings.defaultZone),
            loc: $d8ce4e734394a836$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $d8ce4e734394a836$var$normalizeZone(opts.zone, $d8ce4e734394a836$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($d8ce4e734394a836$var$unsupportedZone(zoneToUse));
        var loc = $d8ce4e734394a836$var$Locale.fromObject(opts);
        var normalized = $d8ce4e734394a836$var$normalizeObject(obj, $d8ce4e734394a836$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $d8ce4e734394a836$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $d8ce4e734394a836$var$Settings.now(), offsetProvis = !$d8ce4e734394a836$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$d8ce4e734394a836$var$isUndefined(normalized.ordinal), containsGregorYear = !$d8ce4e734394a836$var$isUndefined(normalized.year), containsGregorMD = !$d8ce4e734394a836$var$isUndefined(normalized.month) || !$d8ce4e734394a836$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $d8ce4e734394a836$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $d8ce4e734394a836$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $d8ce4e734394a836$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $d8ce4e734394a836$var$orderedWeekUnits;
            defaultValues = $d8ce4e734394a836$var$defaultWeekUnitValues;
            objNow = $d8ce4e734394a836$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $d8ce4e734394a836$var$orderedOrdinalUnits;
            defaultValues = $d8ce4e734394a836$var$defaultOrdinalUnitValues;
            objNow = $d8ce4e734394a836$var$gregorianToOrdinal(objNow);
        } else {
            units = $d8ce4e734394a836$var$orderedUnits;
            defaultValues = $d8ce4e734394a836$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $d8ce4e734394a836$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$d8ce4e734394a836$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $d8ce4e734394a836$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $d8ce4e734394a836$var$hasInvalidOrdinalData(normalized) : $d8ce4e734394a836$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $d8ce4e734394a836$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $d8ce4e734394a836$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $d8ce4e734394a836$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $d8ce4e734394a836$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $d8ce4e734394a836$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $d8ce4e734394a836$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $d8ce4e734394a836$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $d8ce4e734394a836$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $d8ce4e734394a836$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $d8ce4e734394a836$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($d8ce4e734394a836$var$isUndefined(text) || $d8ce4e734394a836$var$isUndefined(fmt)) throw new $d8ce4e734394a836$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $d8ce4e734394a836$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $d8ce4e734394a836$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $d8ce4e734394a836$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $d8ce4e734394a836$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $d8ce4e734394a836$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $d8ce4e734394a836$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $d8ce4e734394a836$var$Invalid ? reason : new $d8ce4e734394a836$var$Invalid(reason, explanation);
        if ($d8ce4e734394a836$var$Settings.throwOnInvalid) throw new $d8ce4e734394a836$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $d8ce4e734394a836$var$formatOptsToTokens(formatOpts, $d8ce4e734394a836$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $d8ce4e734394a836$var$expandMacroTokens($d8ce4e734394a836$var$Formatter.parseFormat(fmt), $d8ce4e734394a836$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        $d8ce4e734394a836$var$zoneOffsetTs = undefined;
        $d8ce4e734394a836$var$zoneOffsetGuessCache.clear();
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $d8ce4e734394a836$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $d8ce4e734394a836$var$tsToObj(ts1, o1);
        var c2 = $d8ce4e734394a836$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $d8ce4e734394a836$var$clone(this, {
                ts: ts1
            }),
            $d8ce4e734394a836$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $d8ce4e734394a836$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($d8ce4e734394a836$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($d8ce4e734394a836$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $d8ce4e734394a836$var$normalizeZone(zone, $d8ce4e734394a836$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($d8ce4e734394a836$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $d8ce4e734394a836$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $d8ce4e734394a836$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $d8ce4e734394a836$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $d8ce4e734394a836$var$normalizeObject(values, $d8ce4e734394a836$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $d8ce4e734394a836$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$d8ce4e734394a836$var$isUndefined(normalized.weekYear) || !$d8ce4e734394a836$var$isUndefined(normalized.weekNumber) || !$d8ce4e734394a836$var$isUndefined(normalized.weekday), containsOrdinal = !$d8ce4e734394a836$var$isUndefined(normalized.ordinal), containsGregorYear = !$d8ce4e734394a836$var$isUndefined(normalized.year), containsGregorMD = !$d8ce4e734394a836$var$isUndefined(normalized.month) || !$d8ce4e734394a836$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $d8ce4e734394a836$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $d8ce4e734394a836$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $d8ce4e734394a836$var$weekToGregorian($d8ce4e734394a836$var$_extends({}, $d8ce4e734394a836$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$d8ce4e734394a836$var$isUndefined(normalized.ordinal)) mixed = $d8ce4e734394a836$var$ordinalToGregorian($d8ce4e734394a836$var$_extends({}, $d8ce4e734394a836$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $d8ce4e734394a836$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($d8ce4e734394a836$var$isUndefined(normalized.day)) mixed.day = Math.min($d8ce4e734394a836$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $d8ce4e734394a836$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $d8ce4e734394a836$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $d8ce4e734394a836$var$Duration.fromDurationLike(duration);
        return $d8ce4e734394a836$var$clone(this, $d8ce4e734394a836$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $d8ce4e734394a836$var$Duration.fromDurationLike(duration).negate();
        return $d8ce4e734394a836$var$clone(this, $d8ce4e734394a836$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $d8ce4e734394a836$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $d8ce4e734394a836$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $d8ce4e734394a836$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $d8ce4e734394a836$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $d8ce4e734394a836$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $d8ce4e734394a836$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $d8ce4e734394a836$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone, _ref5$precision = _ref5.precision, precision = _ref5$precision === void 0 ? "milliseconds" : _ref5$precision;
        if (!this.isValid) return null;
        precision = $d8ce4e734394a836$var$normalizeUnit(precision);
        var ext = format === "extended";
        var c = $d8ce4e734394a836$var$_toISODate(this, ext, precision);
        if ($d8ce4e734394a836$var$orderedUnits.indexOf(precision) >= 3) c += "T";
        c += $d8ce4e734394a836$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    };
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format, _ref6$precision = _ref6.precision, precision = _ref6$precision === void 0 ? "day" : _ref6$precision;
        if (!this.isValid) return null;
        return $d8ce4e734394a836$var$_toISODate(this, format === "extended", $d8ce4e734394a836$var$normalizeUnit(precision));
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $d8ce4e734394a836$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format, _ref7$precision = _ref7.precision, precision = _ref7$precision === void 0 ? "milliseconds" : _ref7$precision;
        if (!this.isValid) return null;
        precision = $d8ce4e734394a836$var$normalizeUnit(precision);
        var c = includePrefix && $d8ce4e734394a836$var$orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + $d8ce4e734394a836$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $d8ce4e734394a836$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $d8ce4e734394a836$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $d8ce4e734394a836$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $d8ce4e734394a836$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $d8ce4e734394a836$var$INVALID;
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $d8ce4e734394a836$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $d8ce4e734394a836$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $d8ce4e734394a836$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $d8ce4e734394a836$var$maybeArray(unit).map($d8ce4e734394a836$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $d8ce4e734394a836$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $d8ce4e734394a836$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $d8ce4e734394a836$var$diffRelative(base, this.plus(padding), $d8ce4e734394a836$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $d8ce4e734394a836$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $d8ce4e734394a836$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $d8ce4e734394a836$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $d8ce4e734394a836$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $d8ce4e734394a836$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $d8ce4e734394a836$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $d8ce4e734394a836$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $d8ce4e734394a836$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = $d8ce4e734394a836$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $d8ce4e734394a836$var$TokenParser(localeToUse, fmt);
    };
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if ($d8ce4e734394a836$var$isUndefined(text) || $d8ce4e734394a836$var$isUndefined(formatParser)) throw new $d8ce4e734394a836$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = $d8ce4e734394a836$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $d8ce4e734394a836$var$InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return $d8ce4e734394a836$var$parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    };
    $d8ce4e734394a836$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $d8ce4e734394a836$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $d8ce4e734394a836$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $d8ce4e734394a836$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $d8ce4e734394a836$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $d8ce4e734394a836$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $d8ce4e734394a836$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $d8ce4e734394a836$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $d8ce4e734394a836$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $d8ce4e734394a836$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $d8ce4e734394a836$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $d8ce4e734394a836$var$friendlyDateTime(dateTimeish) {
    if ($d8ce4e734394a836$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $d8ce4e734394a836$var$isNumber(dateTimeish.valueOf())) return $d8ce4e734394a836$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $d8ce4e734394a836$var$DateTime.fromObject(dateTimeish);
    else throw new $d8ce4e734394a836$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $d8ce4e734394a836$var$VERSION = "3.7.2";
$d8ce4e734394a836$exports.DateTime = $d8ce4e734394a836$var$DateTime;
$d8ce4e734394a836$exports.Duration = $d8ce4e734394a836$var$Duration;
$d8ce4e734394a836$exports.FixedOffsetZone = $d8ce4e734394a836$var$FixedOffsetZone;
$d8ce4e734394a836$exports.IANAZone = $d8ce4e734394a836$var$IANAZone;
$d8ce4e734394a836$exports.Info = $d8ce4e734394a836$var$Info;
$d8ce4e734394a836$exports.Interval = $d8ce4e734394a836$var$Interval;
$d8ce4e734394a836$exports.InvalidZone = $d8ce4e734394a836$var$InvalidZone;
$d8ce4e734394a836$exports.Settings = $d8ce4e734394a836$var$Settings;
$d8ce4e734394a836$exports.SystemZone = $d8ce4e734394a836$var$SystemZone;
$d8ce4e734394a836$exports.VERSION = $d8ce4e734394a836$var$VERSION;
$d8ce4e734394a836$exports.Zone = $d8ce4e734394a836$var$Zone;


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $ae3c9e3bab400541$var$DEFAULT_TIMEOUT_SECONDS = 600;
const $ae3c9e3bab400541$var$EXPONENTIAL_BACKOFF_EXPONENT = 3;
const $ae3c9e3bab400541$export$782df2acbe10b22c = async (url, options = {}, timeoutSeconds = $ae3c9e3bab400541$var$DEFAULT_TIMEOUT_SECONDS, retries = 3, retryCount = 0, exponentialBackoffExponent = $ae3c9e3bab400541$var$EXPONENTIAL_BACKOFF_EXPONENT)=>{
    const requestMethod = (options.method || "GET").toUpperCase();
    try {
        const response = await Promise.race([
            fetch(url, options),
            new Promise((_resolve, reject)=>setTimeout(()=>reject(new Error(`Request timed out after ${timeoutSeconds} seconds.`)), timeoutSeconds * 1000))
        ]);
        if (!response.ok) {
            if ([
                429,
                503
            ].includes(response.status) && retries > 0) {
                retryCount++;
                retries--;
                // wait with exponential backoff
                await $ae3c9e3bab400541$var$sleep(retryCount * exponentialBackoffExponent);
                return $ae3c9e3bab400541$export$782df2acbe10b22c(url, options, timeoutSeconds, retries, retryCount, exponentialBackoffExponent);
            } else throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
        }
        return response;
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        if ($ae3c9e3bab400541$var$isRetryableNetworkError(errorMessage, requestMethod) && retries > 0) {
            retryCount++;
            retries--;
            // wait with exponential backoff
            await $ae3c9e3bab400541$var$sleep(retryCount ** exponentialBackoffExponent);
            return $ae3c9e3bab400541$export$782df2acbe10b22c(url, options, timeoutSeconds, retries, retryCount, exponentialBackoffExponent);
        }
        throw error instanceof Error ? error : new Error(errorMessage);
    }
};
function $ae3c9e3bab400541$var$isRetryableNetworkError(message, method) {
    if (![
        "GET",
        "HEAD"
    ].includes(method)) return false;
    return message === "Timeout" || message === "Network request failed" || message === "Failed to fetch" || message.startsWith("Request timed out after");
}
function $ae3c9e3bab400541$var$sleep(seconds) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}



var $a30lF = parcelRequire("a30lF");
class $20e0088800729d63$export$2398eb31525b8be1 {
    constructor(type, name, createTime = new Date(), queue, labels = [], pageImageUrls, data = {}, revisions){
        this.pageImageUrls = [];
        this.type = type;
        this.name = name;
        this.createTime = createTime;
        this.enqueueDuration = this.getEnqueueDuration();
        this.queue = queue;
        this.labels = labels;
        this.pageImageUrls = pageImageUrls;
        this.data = data;
        this.revisions = revisions;
    }
    getEnqueueDuration() {
        const now = (0, $d8ce4e734394a836$exports.DateTime).now();
        const duration = (0, $d8ce4e734394a836$exports.Interval).fromDateTimes((0, $d8ce4e734394a836$exports.DateTime).fromJSDate(this.createTime), now).toDuration([
            "hours",
            "minutes",
            "seconds"
        ]);
        return duration.toFormat("hh'h' mm'm' ss's'");
    }
    suggestedName() {
        return this.resultBaseName() + "-reviewed.json";
    }
}
class $20e0088800729d63$export$95b45e2cf1d26ada extends $20e0088800729d63$export$2398eb31525b8be1 {
    constructor(fileSystemFileHandle, type, name, createTime, queue, labels = [], pageImageUrls = []){
        super(type, name, createTime, queue, labels, pageImageUrls), this.id = ()=>{
            return this.queue + this.name;
        };
        this.inputFileSystemFileHandle = fileSystemFileHandle;
    }
    resultBaseName() {
        return this.name.replace(".json", "");
    }
    async getContent(_accessToken = "") {
        const file = await this.inputFileSystemFileHandle.getFile();
        const content = await file.text();
        return JSON.parse(content);
    }
    async saveContent(_accessToken, _idToken, content, _data, _rejectReason) {
        const outputFileSystemFileHandle = await this.outputFileSystemFileHandlePromise;
        // create a FileSystemWritableFileStream to write to
        const writableStream = await outputFileSystemFileHandle.createWritable();
        // write to file
        await writableStream.write(content);
        // close the file and write the contents to disk.
        await writableStream.close();
    }
}
class $20e0088800729d63$export$9ddd7e36c6c46838 extends $20e0088800729d63$export$2398eb31525b8be1 {
    static{
        // Document cache for performance optimization
        this.documentCache = new Map();
    }
    static{
        this.cacheExpiry = new Map();
    }
    static{
        this.CACHE_TTL = 600000 // 10 minutes
        ;
    }
    constructor(taskData, firestoreDb, userId){
        // Extract page URLs from the correct location in Firestore data
        let pageUrls = [];
        // Keep empty slots for pages beyond the image generation cap (merged chunks
        // >300 pages) so the page list length matches the document page count. The
        // AI UI component will show a broken image placeholder for empty URLs, but
        // the page navigation and entity overlays still work.
        // First try to get from processed_data.optimized_pages (new format)
        if (taskData.documentData?.processed_data?.optimized_pages) pageUrls = taskData.documentData.processed_data.optimized_pages.map((page)=>{
            return page.fullUrl || page.previewUrl || "";
        });
        else if (taskData.documentData?.pages) pageUrls = taskData.documentData.pages.map((p)=>{
            if (typeof p === "string") return p;
            else if (p && typeof p.fullUrl === "string") return p.fullUrl;
            else if (p && typeof p.previewUrl === "string") return p.previewUrl;
            else return "";
        });
        // Extract fields from processed_data
        const processedData = taskData.documentData?.processed_data || {};
        // Pad pageUrls to match pageCount. For merged chunk documents over the
        // image generation cap (300 pages), the backend only passes real image
        // entries via Pub/Sub to avoid the workflow memory limit. Pad with empty
        // strings so the page navigation reflects the true document length.
        const totalPageCount = processedData.pageCount || 0;
        if (totalPageCount > pageUrls.length) {
            const padding = new Array(totalPageCount - pageUrls.length).fill("");
            pageUrls = pageUrls.concat(padding);
        }
        super("Firestore", processedData.document_id && processedData.document_id !== "" ? processedData.document_id : processedData.envelope_id || "unknown", taskData.createdAt?.toDate() || new Date(), processedData.queue_name || "unknown", [], pageUrls, taskData, taskData.revisions), this.id = ()=>{
            return this.taskId;
        };
        this.taskId = taskData.taskId;
        this.documentId = processedData.document_id || processedData.envelope_id || "unknown";
        this.envelopeId = processedData.envelope_id || "unknown";
        this.processorType = processedData.processorType || "unknown";
        this.priority = taskData.priority;
        this.firestoreDb = firestoreDb;
        this.userId = userId;
        // Store expiration time if available
        if (taskData.expiresAt) {
            this.expiresAt = taskData.expiresAt.toDate ? taskData.expiresAt.toDate() : new Date(taskData.expiresAt);
            this.setupExpirationWarning();
        }
    }
    resultBaseName() {
        return `${this.documentId}_${this.processorType}`;
    }
    /**
   * Sets up warnings for task expiration
   * Logs when task is approaching expiration (45 min mark) and when expired
   */ setupExpirationWarning() {
        if (!this.expiresAt) return;
        const now = Date.now();
        const expiresAtMs = this.expiresAt.getTime();
        const timeUntilExpiration = expiresAtMs - now;
        // If already expired, log immediately
        if (timeUntilExpiration <= 0) {
            console.warn(`\u{26A0}\u{FE0F} Task ${this.taskId} has already expired!`);
            (0, $a30lF.sendCriticalLog)({
                timestamp: new Date().toISOString(),
                severity: "ERROR",
                userId: this.userId,
                action: "Task already expired on assignment",
                additionalInfo: {
                    taskId: this.taskId,
                    queue: this.queue,
                    envelopeId: this.envelopeId,
                    processorType: this.processorType,
                    expiresAt: this.expiresAt.toISOString(),
                    expiredMinutesAgo: Math.abs(Math.floor(timeUntilExpiration / 60000))
                }
            });
            return;
        }
        // Log initial expiration info
        const expiresInMinutes = Math.floor(timeUntilExpiration / 60000);
        console.log(`Task ${this.taskId} expires in ${expiresInMinutes} minutes (at ${this.expiresAt.toLocaleTimeString()})`);
        // Set warning at 45-minute mark (15 minutes before expiration)
        const warningTime = timeUntilExpiration - 900000;
        if (warningTime > 0) this.expirationWarningTimer = window.setTimeout(async ()=>{
            console.warn(`\u{26A0}\u{FE0F} Task ${this.taskId} will expire in 15 minutes!`);
            await (0, $a30lF.sendCriticalLog)({
                timestamp: new Date().toISOString(),
                severity: "WARNING",
                userId: this.userId,
                action: "Task approaching expiration",
                additionalInfo: {
                    taskId: this.taskId,
                    queue: this.queue,
                    envelopeId: this.envelopeId,
                    processorType: this.processorType,
                    expiresAt: this.expiresAt.toISOString(),
                    minutesUntilExpiration: 15
                }
            });
        }, warningTime);
        // Set critical alert at expiration time
        window.setTimeout(async ()=>{
            console.error(`\u{274C} Task ${this.taskId} has expired!`);
            await (0, $a30lF.sendCriticalLog)({
                timestamp: new Date().toISOString(),
                severity: "ERROR",
                userId: this.userId,
                action: "Task expired while user was reviewing",
                additionalInfo: {
                    taskId: this.taskId,
                    queue: this.queue,
                    envelopeId: this.envelopeId,
                    processorType: this.processorType,
                    expiresAt: this.expiresAt.toISOString(),
                    reviewDurationMinutes: this.reviewDuration ? Math.floor(this.reviewDuration / 60) : 0
                }
            });
        }, timeUntilExpiration);
    }
    // Cache management methods
    static isValidCacheEntry(cacheKey) {
        const expiry = $20e0088800729d63$export$9ddd7e36c6c46838.cacheExpiry.get(cacheKey);
        return expiry ? Date.now() < expiry : false;
    }
    static setCacheEntry(cacheKey, data) {
        $20e0088800729d63$export$9ddd7e36c6c46838.documentCache.set(cacheKey, data);
        $20e0088800729d63$export$9ddd7e36c6c46838.cacheExpiry.set(cacheKey, Date.now() + $20e0088800729d63$export$9ddd7e36c6c46838.CACHE_TTL);
    }
    static getCacheEntry(cacheKey) {
        if ($20e0088800729d63$export$9ddd7e36c6c46838.isValidCacheEntry(cacheKey)) return $20e0088800729d63$export$9ddd7e36c6c46838.documentCache.get(cacheKey);
        // Clean up expired entry
        $20e0088800729d63$export$9ddd7e36c6c46838.documentCache.delete(cacheKey);
        $20e0088800729d63$export$9ddd7e36c6c46838.cacheExpiry.delete(cacheKey);
        return null;
    }
    // Enhanced image preloading with adaptive batching for performance
    static async preloadImages(imageUrls, accessToken, batchSize) {
        if (imageUrls.length === 0) return;
        // Adaptive batch size based on number of images and estimated network conditions
        const adaptiveBatchSize = batchSize || $20e0088800729d63$export$9ddd7e36c6c46838.calculateOptimalBatchSize(imageUrls.length);
        console.log(`\u{1F5BC}\u{FE0F} Starting adaptive batch preload of ${imageUrls.length} images (batch size: ${adaptiveBatchSize})`);
        // Priority loading: First 2 images immediately for instant UI feedback
        if (imageUrls.length > 0) {
            console.log(`\u{1F680} Priority loading first 2 images for immediate display`);
            const priorityUrls = imageUrls.slice(0, 2);
            const priorityPromises = priorityUrls.map((url)=>$20e0088800729d63$export$9ddd7e36c6c46838.preloadSingleImage(url, accessToken));
            await Promise.allSettled(priorityPromises);
        }
        // Continue with remaining images in optimized batches
        const remainingUrls = imageUrls.slice(2);
        const startTime = performance.now();
        for(let i = 0; i < remainingUrls.length; i += adaptiveBatchSize){
            const batch = remainingUrls.slice(i, i + adaptiveBatchSize);
            const batchNumber = Math.floor(i / adaptiveBatchSize) + 1;
            console.log(`\u{1F4E6} Preloading image batch ${batchNumber}:`, batch.length, "images");
            // Process batch concurrently with performance monitoring
            const batchStart = performance.now();
            const batchPromises = batch.map((url)=>$20e0088800729d63$export$9ddd7e36c6c46838.preloadSingleImage(url, accessToken));
            try {
                await Promise.allSettled(batchPromises);
                const batchTime = performance.now() - batchStart;
                console.log(`\u{2705} Completed batch ${batchNumber} in ${Math.round(batchTime)}ms`);
            } catch (error) {
                console.warn(`\u{26A0}\u{FE0F} Some images failed in batch ${batchNumber}:`, error);
            }
            // Adaptive delay between batches based on performance
            if (i + adaptiveBatchSize < remainingUrls.length) {
                const delay = $20e0088800729d63$export$9ddd7e36c6c46838.calculateBatchDelay(batchNumber);
                await new Promise((resolve)=>setTimeout(resolve, delay));
            }
        }
        const totalTime = performance.now() - startTime;
        console.log(`\u{1F389} Completed preloading all ${imageUrls.length} images in ${Math.round(totalTime)}ms`);
    }
    static calculateOptimalBatchSize(totalImages) {
        // Adaptive batch sizing strategy
        if (totalImages <= 5) return 3; // Small documents: smaller batches
        if (totalImages <= 15) return 6; // Medium documents: medium batches
        if (totalImages <= 30) return 8; // Large documents: larger batches
        return 10; // Very large documents: maximum batches
    }
    static calculateBatchDelay(batchNumber) {
        // Progressive delay reduction as browser cache warms up
        if (batchNumber === 1) return 100; // Longer delay for first batch
        if (batchNumber <= 3) return 50; // Medium delay for early batches
        return 25; // Shorter delay for later batches
    }
    static preloadSingleImage(url, accessToken) {
        return new Promise((resolve, reject)=>{
            // Skip empty URLs (pages beyond the image generation cap for merged chunks)
            if (!url) {
                resolve();
                return;
            }
            const img = new Image();
            img.onload = ()=>{
                console.log(`\u{1F4F7} Preloaded image: ${url.split("/").pop()}`);
                resolve();
            };
            img.onerror = (error)=>{
                console.warn(`\u{274C} Failed to preload image: ${url.split("/").pop()}`, error);
                reject(error);
            };
            // Add access token to image URL for authentication
            const imageUrl = new URL(url);
            imageUrl.searchParams.set("access_token", accessToken);
            img.src = imageUrl.toString();
        });
    }
    async getContent(accessToken = "") {
        // Check if content was preloaded
        if (this._preloadedContent) {
            console.log("\uD83D\uDE80 PRELOAD HIT: Returning preloaded Document AI JSON");
            return this._preloadedContent;
        }
        // Try multiple possible locations for resultBucket and resultObject
        let resultBucket, resultObject;
        // First try nested processed_data
        const processedData = this.data?.documentData?.processed_data;
        if (processedData?.resultBucket && processedData?.resultObject) {
            resultBucket = processedData.resultBucket;
            resultObject = processedData.resultObject;
        } else if (this.data?.documentData?.resultBucket && this.data?.documentData?.resultObject) {
            resultBucket = this.data.documentData.resultBucket;
            resultObject = this.data.documentData.resultObject;
        }
        if (!resultBucket || !resultObject) {
            console.error("CRITICAL: No resultBucket or resultObject found in Firestore task data!");
            throw new Error("Cannot find Document AI result location in GCS");
        }
        // Check cache first
        const cacheKey = `${resultBucket}/${resultObject}`;
        const cachedContent = $20e0088800729d63$export$9ddd7e36c6c46838.getCacheEntry(cacheKey);
        if (cachedContent) {
            console.log("\uD83D\uDE80 Cache HIT: Returning cached Document AI JSON for:", cacheKey);
            return cachedContent;
        }
        console.log("\uD83D\uDCE5 Cache MISS: Fetching Document AI JSON from GCS for:", cacheKey);
        const encodedResultObject = String(resultObject).split("/").map(encodeURIComponent).join("/");
        const url = `https://storage.googleapis.com/${resultBucket}/${encodedResultObject}`;
        try {
            const response = await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    Accept: "application/json"
                }
            }, 600, 2);
            if (!response.ok) throw new Error(`Failed to fetch Document AI JSON from GCS: ${response.status} ${response.statusText}`);
            const jsonContent = await response.json();
            // Cache the result
            $20e0088800729d63$export$9ddd7e36c6c46838.setCacheEntry(cacheKey, jsonContent);
            console.log("\u2705 Successfully fetched and cached Document AI JSON from GCS");
            console.log("Document AI JSON structure - top level keys:", Object.keys(jsonContent));
            console.log("Has pages:", !!jsonContent.pages, "Pages count:", jsonContent.pages?.length || 0);
            console.log("Has entities:", !!jsonContent.entities, "Entities count:", jsonContent.entities?.length || 0);
            return jsonContent;
        } catch (error) {
            console.error("CRITICAL: Failed to fetch Document AI JSON from GCS:", error);
            throw error;
        }
    }
    async saveContent(accessToken, idToken, content, data, rejectReason) {
        // Implement PubSub-equivalent behaviors for Firestore tasks
        console.log(`Processing completed Firestore task ${this.taskId} (similar to PubSub message acknowledgement)`);
        try {
            // Get environment and project info
            const hitlApp = document.querySelector("hitl-app");
            const environment = hitlApp?.detectedEnvironment || "unknown";
            const databaseId = `${environment}-hitl-tasks`;
            // Get project ID from environment
            // Extract environment prefix (everything before the last part after final dash)
            const projectMatch = environment.match(/^(.+)-\d+$/);
            const projectId = "DEFAULT_PROJECT_ID";
            // Get the processed_data that contains handle_prediction_result output + workflow fields
            const processedData = this.data?.documentData?.processed_data || {};
            // Enrich data with processing metadata (similar to PubSub)
            data.reviewDuration = this.reviewDuration || 0;
            data.reviewWeekDay = new Date().toLocaleDateString("de", {
                weekday: "long"
            });
            data.queue = processedData.queue_name || this.queue;
            data.firestoreTaskId = this.taskId;
            data.processingTime = this.reviewDuration || 0;
            // Extract input bucket and object from the stored processed_data
            const inputBucket = processedData.inputBucket || "";
            const inputObject = processedData.inputObject || "";
            console.log("DEBUG: Extracted input fields from processed_data:", {
                inputBucket: inputBucket,
                inputObject: inputObject
            });
            // These fields are required by handle_reviewed_result
            data.inputBucket = inputBucket;
            data.inputObject = inputObject;
            // Get GCS storage settings from processed_data
            let outputBucket = processedData?.reviewedResultBucket || processedData?.resultBucket || "";
            let resultPrefix = processedData?.resultPrefix || "";
            // Check for callback URL from processed_data
            const callbackUrl = processedData?.callback_url;
            console.log("DEBUG: Checking for processedData and callback URL");
            console.log("DEBUG: Full task data structure:", this.data);
            console.log("DEBUG: documentData:", this.data?.documentData);
            console.log("DEBUG: processedData:", processedData);
            console.log("DEBUG: callback_url from processedData:", processedData?.callback_url);
            console.log("DEBUG: Final callbackUrl to use:", callbackUrl);
            // 1. Store results in GCS (similar to PubSub behavior)
            // Track whether GCS save was successful - callback should only be called after successful save
            let gcsSaveSuccessful = false;
            let newResultObjectName = "";
            if (processedData && outputBucket && resultPrefix) {
                // Ensure resultPrefix has trailing slash before concatenation
                const normalizedPrefix = resultPrefix.endsWith("/") ? resultPrefix : resultPrefix + "/";
                newResultObjectName = normalizedPrefix + this.suggestedName();
                // Determine output bucket based on rejection status
                if (rejectReason && processedData?.rejectedResultBucket) {
                    data.storno = rejectReason;
                    data.reviewedResult = content;
                    content = JSON.stringify({
                        data: data
                    });
                    outputBucket = processedData.rejectedResultBucket;
                } else if (processedData?.reviewedResultBucket) {
                    data.reviewedResult = content;
                    content = JSON.stringify({
                        data: data
                    });
                    outputBucket = processedData.reviewedResultBucket;
                }
                // Store result in GCS if we have bucket and prefix
                if (outputBucket && resultPrefix) {
                    console.log(`Storing result in GCS: gs://${outputBucket}/${newResultObjectName}`);
                    // Log GCS save attempt
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: "INFO",
                        userId: this.userId,
                        action: "GCS save attempt",
                        additionalInfo: {
                            taskId: this.taskId,
                            queue: this.queue,
                            bucket: outputBucket,
                            objectName: newResultObjectName,
                            processorType: processedData.processorType,
                            isRejection: !!rejectReason
                        }
                    });
                    // Normalize entities structure for classification tasks before saving
                    if (processedData.processorType === "CUSTOM_CLASSIFICATION_PROCESSOR") try {
                        const reviewedResult = JSON.parse(content);
                        console.log("DEBUG: Review result structure keys:", Object.keys(reviewedResult));
                        console.log("DEBUG: Full review result structure:", reviewedResult);
                        // Check if we need to unwrap from data object or access directly
                        let entities;
                        if (reviewedResult.entities) {
                            entities = reviewedResult.entities;
                            console.log("DEBUG: Found entities at top level");
                        } else if (reviewedResult.data && typeof reviewedResult.data === "object") {
                            console.log("DEBUG: data object keys:", Object.keys(reviewedResult.data));
                            console.log("DEBUG: data object structure:", reviewedResult.data);
                            // The entities are in the reviewedResult field inside data
                            if (reviewedResult.data.reviewedResult && typeof reviewedResult.data.reviewedResult === "string") try {
                                const actualDocAI = JSON.parse(reviewedResult.data.reviewedResult);
                                entities = actualDocAI.entities;
                                console.log("DEBUG: Found entities in data.reviewedResult (parsed)");
                            } catch (e) {
                                console.log("DEBUG: Failed to parse reviewedResult, trying direct access");
                            }
                            else if (reviewedResult.data.reviewedResult && typeof reviewedResult.data.reviewedResult === "object") {
                                entities = reviewedResult.data.reviewedResult.entities;
                                console.log("DEBUG: Found entities in data.reviewedResult (object)");
                            } else {
                                entities = reviewedResult.data.entities;
                                console.log("DEBUG: Found entities in data object (fallback)");
                            }
                        }
                        console.log("DEBUG: Original entities before normalization:", entities);
                        // Normalize classification entities to match splitting structure
                        if (entities && entities.length > 0) {
                            const normalizedEntities = entities.map((entity)=>{
                                if (entity.type === "Document Classification" && entity.normalized_value?.text) {
                                    // Strip ID prefix from classification value if present
                                    // Handle both dash and underscore formats: "1 - Neuschaden", "5_kuendigung", "2 _ beitragsfreistellung"
                                    let classificationValue = entity.normalized_value.text;
                                    const idPrefixMatch = classificationValue.match(/^(\d+)\s*[-_]\s*(.+)$/);
                                    if (idPrefixMatch) {
                                        classificationValue = idPrefixMatch[2];
                                        console.log("DEBUG: Stripped ID prefix from normalized_value.text:", {
                                            original: entity.normalized_value.text,
                                            stripped: classificationValue
                                        });
                                    }
                                    // Move the actual classification value from normalized_value.text to type
                                    const normalizedEntity = {
                                        ...entity,
                                        type: classificationValue,
                                        confidence: 1
                                    };
                                    // Remove normalized_value to match splitting structure
                                    delete normalizedEntity.normalized_value;
                                    console.log("DEBUG: Normalized classification entity:", {
                                        original_type: entity.type,
                                        new_type: normalizedEntity.type,
                                        confidence: normalizedEntity.confidence
                                    });
                                    return normalizedEntity;
                                }
                                return entity;
                            });
                            // Set the normalized entities back to the correct location
                            if (reviewedResult.entities) reviewedResult.entities = normalizedEntities;
                            else if (reviewedResult.data) {
                                if (reviewedResult.data.reviewedResult && typeof reviewedResult.data.reviewedResult === "string") try {
                                    const actualDocAI = JSON.parse(reviewedResult.data.reviewedResult);
                                    actualDocAI.entities = normalizedEntities;
                                    reviewedResult.data.reviewedResult = JSON.stringify(actualDocAI);
                                } catch (e) {
                                    console.warn("Failed to update normalized entities in parsed reviewedResult");
                                }
                                else if (reviewedResult.data.reviewedResult && typeof reviewedResult.data.reviewedResult === "object") reviewedResult.data.reviewedResult.entities = normalizedEntities;
                                else reviewedResult.data.entities = normalizedEntities;
                            }
                            console.log("DEBUG: Normalized entities after processing:", normalizedEntities);
                        } else console.log("DEBUG: No entities found to normalize");
                        content = JSON.stringify(reviewedResult);
                    } catch (error) {
                        console.warn("Failed to normalize classification entities, using original content:", error);
                    }
                    // Fixed: Properly encode path components separately to avoid encoding slashes
                    const pathComponents = newResultObjectName.split("/");
                    const encodedPath = pathComponents.map((component)=>encodeURIComponent(component)).join("/");
                    const gcsUrl = `https://storage.googleapis.com/${outputBucket}/${encodedPath}`;
                    const gcsResponse = await fetch(gcsUrl, {
                        method: "PUT",
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Content-Type": "application/json"
                        },
                        body: content
                    });
                    if (!gcsResponse.ok) {
                        const errorText = await gcsResponse.text().catch(()=>"Unknown error");
                        console.error(`Failed to save reviewed result to GCS: ${gcsResponse.status} ${gcsResponse.statusText}`, errorText);
                        // Log critical GCS save failure
                        await (0, $a30lF.sendCriticalLog)({
                            timestamp: new Date().toISOString(),
                            severity: "ERROR",
                            userId: this.userId,
                            action: "GCS save failed",
                            additionalInfo: {
                                taskId: this.taskId,
                                queue: this.queue,
                                bucket: outputBucket,
                                objectName: newResultObjectName,
                                httpStatus: gcsResponse.status,
                                httpStatusText: gcsResponse.statusText,
                                errorDetails: errorText,
                                processorType: processedData.processorType
                            }
                        });
                        throw new Error(`GCS save failed with status ${gcsResponse.status}: ${gcsResponse.statusText}`);
                    }
                    console.log(`Successfully saved reviewed result to GCS: gs://${outputBucket}/${newResultObjectName}`);
                    gcsSaveSuccessful = true;
                    // Log successful GCS save
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: "INFO",
                        userId: this.userId,
                        action: "GCS save successful",
                        additionalInfo: {
                            taskId: this.taskId,
                            queue: this.queue,
                            bucket: outputBucket,
                            objectName: newResultObjectName,
                            processorType: processedData.processorType
                        }
                    });
                }
                // 2. Call callback URL only after successful GCS save
                // This prevents the workflow from continuing without the reviewed result being available
                if (callbackUrl && gcsSaveSuccessful) await this.handleWorkflowCallback({
                    callback_url: callbackUrl
                }, outputBucket, newResultObjectName, data, content, accessToken, idToken);
                else if (callbackUrl && !gcsSaveSuccessful) {
                    console.error("Cannot call workflow callback - GCS save was not successful");
                    // Log critical callback skip due to GCS save failure
                    await (0, $a30lF.sendCriticalLog)({
                        timestamp: new Date().toISOString(),
                        severity: "ERROR",
                        userId: this.userId,
                        action: "Callback skipped - GCS save failed",
                        additionalInfo: {
                            taskId: this.taskId,
                            queue: this.queue,
                            callbackUrl: callbackUrl,
                            processorType: processedData.processorType
                        }
                    });
                    throw new Error("GCS save failed - cannot continue workflow without saved reviewed result");
                } else console.log("No callback URL found - skipping workflow notification");
            } else {
                // Log warning if GCS save was skipped due to missing configuration
                console.warn("GCS save skipped - missing required configuration:", {
                    hasProcessedData: !!processedData,
                    outputBucket: outputBucket || "(empty)",
                    resultPrefix: resultPrefix || "(empty)"
                });
                // Log warning about missing configuration
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "WARNING",
                    userId: this.userId,
                    action: "GCS save skipped - missing configuration",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        hasProcessedData: !!processedData,
                        hasOutputBucket: !!outputBucket,
                        hasResultPrefix: !!resultPrefix,
                        hasCallbackUrl: !!callbackUrl
                    }
                });
                // If there's a callback URL but we couldn't save, this is an error
                if (callbackUrl) {
                    console.error("Cannot call workflow callback - GCS save was skipped due to missing outputBucket or resultPrefix");
                    // Log critical error for callback with missing config
                    await (0, $a30lF.sendCriticalLog)({
                        timestamp: new Date().toISOString(),
                        severity: "ERROR",
                        userId: this.userId,
                        action: "Callback blocked - missing GCS configuration",
                        additionalInfo: {
                            taskId: this.taskId,
                            queue: this.queue,
                            callbackUrl: callbackUrl,
                            hasOutputBucket: !!outputBucket,
                            hasResultPrefix: !!resultPrefix
                        }
                    });
                    throw new Error("Missing GCS configuration (outputBucket or resultPrefix) - cannot save reviewed result");
                }
            }
            // 3. Delete the task document from Firestore (equivalent to PubSub acknowledgement)
            const collectionName = `hitl_tasks_${this.queue}`;
            const taskDocUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/${this.taskId}`;
            console.log(`Attempting to delete Firestore task: ${taskDocUrl}`);
            console.log(`Project ID: ${projectId}, Database ID: ${databaseId}, Collection: ${collectionName}`);
            const deleteResponse = await fetch(taskDocUrl, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json"
                }
            });
            if (!deleteResponse.ok) {
                console.error(`Failed to delete Firestore task ${this.taskId}: ${deleteResponse.status} ${deleteResponse.statusText}`);
                console.error(`Task URL: ${taskDocUrl}`);
                // Log critical Firestore deletion failure
                await (0, $a30lF.sendCriticalLog)({
                    timestamp: new Date().toISOString(),
                    severity: "ERROR",
                    userId: this.userId,
                    action: "Firestore task deletion failed",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        collectionName: collectionName,
                        httpStatus: deleteResponse.status,
                        httpStatusText: deleteResponse.statusText,
                        taskUrl: taskDocUrl
                    }
                });
                // For now, log the error but don't fail the entire save operation
                // The task will remain in Firestore and may be picked up again, but the results are saved
                console.warn(`Warning: Task ${this.taskId} could not be deleted from Firestore. Results have been saved successfully.`);
                console.warn(`This may result in the task being processed again if it has not expired.`);
            } else {
                console.log(`Successfully deleted Firestore task ${this.taskId} after processing`);
                // Log successful Firestore deletion
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "INFO",
                    userId: this.userId,
                    action: "Firestore task deleted successfully",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        collectionName: collectionName
                    }
                });
                // Emit custom event to trigger queue count refresh
                const event = new CustomEvent("task-completed", {
                    bubbles: true,
                    detail: {
                        taskId: this.taskId,
                        queueName: this.queue
                    }
                });
                document.dispatchEvent(event);
            }
            // Stop deadline extension worker (similar to PubSub ack extension termination)
            if (this.extendDeadlineWorker) {
                this.extendDeadlineWorker.terminate();
                console.log(`Terminated deadline extension worker for task ${this.taskId}`);
            }
            // Clear expiration warning timer
            if (this.expirationWarningTimer) {
                clearTimeout(this.expirationWarningTimer);
                console.log(`Cleared expiration warning timer for task ${this.taskId}`);
            }
        } catch (error) {
            console.error("Failed to complete Firestore task processing:", error);
            throw error;
        }
    }
    /**
   * Handles workflow callback with graceful degradation for timeout scenarios
   */ async handleWorkflowCallback(callbackInfo, outputBucket, newResultObjectName, data, content, accessToken, idToken) {
        if (!callbackInfo.callback_url) {
            console.log("No callback URL provided - skipping workflow notification");
            return;
        }
        // Get the stored processed_data (which contains handle_prediction_result output + workflow fields)
        const storedProcessedData = this.data?.documentData?.processed_data || {};
        // Parse the reviewed Document AI JSON to get updated entities
        const reviewedResult = JSON.parse(content);
        const reviewedEntities = reviewedResult.entities || [];
        console.log("DEBUG: handleWorkflowCallback - storedProcessedData.processorType:", storedProcessedData.processorType);
        console.log("DEBUG: handleWorkflowCallback - reviewedEntities:", reviewedEntities);
        // Build minimal processed_data structure matching historical HITL response format
        // Only include the essential fields that handle_prediction_result needs
        const processedData = {
            outputGcsDestination: `gs://${outputBucket}/${newResultObjectName}`,
            processor_type: storedProcessedData.processorType || "CUSTOM_SPLITTING_PROCESSOR",
            // Include reviewed entities for the workflow
            entities: reviewedEntities
        };
        // For classification tasks, also include the selected classification value
        if (storedProcessedData.processorType === "CUSTOM_CLASSIFICATION_PROCESSOR" && reviewedEntities.length > 0) {
            console.log("DEBUG: Processing classification entities before callback:", reviewedEntities);
            // For classification tasks, the actual value is in normalized_value.text, not type
            const selectedEntity = reviewedEntities.find((entity)=>entity.type === "Document Classification" && entity.normalized_value?.text);
            if (selectedEntity?.normalized_value?.text) {
                processedData.classification = selectedEntity.normalized_value.text;
                console.log("DEBUG: Added classification to callback from normalized_value.text:", selectedEntity.normalized_value.text);
            }
        }
        // This matches the historical response format that the workflow expects
        const callbackData = {
            status: "success",
            processed_data: processedData
        };
        console.log(`Attempting callback to: ${callbackInfo.callback_url}`);
        console.log("Callback data structure:", JSON.stringify(callbackData, null, 2));
        try {
            // Use shorter timeout for workflow callbacks to detect expired workflows quickly
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), 15000); // 15 second timeout
            const response = await fetch(callbackInfo.callback_url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(callbackData),
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            if (response.ok) {
                console.log("\u2705 Workflow callback successful");
                // Log successful callback
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "INFO",
                    userId: this.userId,
                    action: "Workflow callback successful",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        callbackUrl: callbackInfo.callback_url,
                        processorType: storedProcessedData.processorType
                    }
                });
            } else if (response.status === 404 || response.status === 410) {
                console.warn("\u26A0\uFE0F  Workflow has expired (404/410) - using fallback completion");
                // Log workflow expiration
                await (0, $a30lF.sendCriticalLog)({
                    timestamp: new Date().toISOString(),
                    severity: "WARNING",
                    userId: this.userId,
                    action: "Workflow expired - using fallback",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        callbackUrl: callbackInfo.callback_url,
                        httpStatus: response.status,
                        processorType: storedProcessedData.processorType
                    }
                });
                await this.handleExpiredWorkflowFallback(outputBucket, newResultObjectName, data, accessToken, idToken);
            } else {
                // Log callback failure with non-timeout error
                await (0, $a30lF.sendCriticalLog)({
                    timestamp: new Date().toISOString(),
                    severity: "ERROR",
                    userId: this.userId,
                    action: "Workflow callback failed",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        callbackUrl: callbackInfo.callback_url,
                        httpStatus: response.status,
                        httpStatusText: response.statusText,
                        processorType: storedProcessedData.processorType
                    }
                });
                throw new Error(`Callback failed with status ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            console.warn("\u26A0\uFE0F  Workflow callback failed:", error);
            // Determine if this looks like a workflow timeout scenario
            const isTimeoutError = error.name === "AbortError" || error.message?.includes("timeout") || error.message?.includes("network") || error.message?.includes("fetch");
            if (isTimeoutError) {
                console.log("\uD83D\uDD04 Detected workflow timeout - using fallback completion mechanism");
                // Log workflow timeout
                await (0, $a30lF.sendCriticalLog)({
                    timestamp: new Date().toISOString(),
                    severity: "WARNING",
                    userId: this.userId,
                    action: "Workflow callback timeout - using fallback",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        callbackUrl: callbackInfo.callback_url,
                        errorName: error.name,
                        errorMessage: error.message,
                        processorType: storedProcessedData.processorType
                    }
                });
                await this.handleExpiredWorkflowFallback(outputBucket, newResultObjectName, data, accessToken, idToken);
            } else {
                console.log("\u2139\uFE0F  Non-timeout callback error - document still processed successfully");
                // Log non-timeout callback error
                await (0, $a30lF.sendCriticalLog)({
                    timestamp: new Date().toISOString(),
                    severity: "ERROR",
                    userId: this.userId,
                    action: "Workflow callback error (non-timeout)",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        callbackUrl: callbackInfo.callback_url,
                        errorName: error.name,
                        errorMessage: error.message,
                        processorType: storedProcessedData.processorType
                    }
                });
            }
        // Important: Don't throw here - document processing should succeed even if workflow fails
        }
    }
    /**
   * Fallback mechanism for when workflows have timed out
   * Stores completion info in a special collection for later processing
   */ async handleExpiredWorkflowFallback(outputBucket, newResultObjectName, data, accessToken, idToken) {
        try {
            console.log("\uD83D\uDCDD Storing completion info for offline workflow processing");
            // Get environment info
            const hitlApp = document.querySelector("hitl-app");
            const environment = hitlApp?.detectedEnvironment || "unknown";
            const databaseId = `${environment}-hitl-tasks`;
            // Extract environment prefix (everything before the last part after final dash)
            const projectMatch = environment.match(/^(.+)-\d+$/);
            const projectId = "DEFAULT_PROJECT_ID";
            // Store completion info in a fallback collection for later processing
            const fallbackCollectionUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/hitl_fallback_completions`;
            const fallbackData = {
                taskId: this.taskId,
                queueName: this.queue,
                documentId: data.documentId || this.documentId || "",
                processorType: data.processorType || this.processorType || "",
                outputGcsDestination: `gs://${outputBucket}/${newResultObjectName}`,
                completedAt: new Date().toISOString(),
                completedBy: this.userId,
                originalCallbackUrl: this.data?.documentData?.processed_data?.callback_url || "",
                processingTime: this.reviewDuration || 0.0,
                status: "callback_failed"
            };
            const fallbackResponse = await fetch(fallbackCollectionUrl, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(fallbackData)
            });
            if (fallbackResponse.ok) {
                console.log("\u2705 Fallback completion record stored - document processing completed successfully despite workflow timeout");
                // Log successful fallback storage
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "INFO",
                    userId: this.userId,
                    action: "Fallback completion record stored",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        outputGcsDestination: `gs://${outputBucket}/${newResultObjectName}`,
                        processorType: data.processorType || this.processorType || ""
                    }
                });
            } else {
                console.error(`\u{274C} Failed to store fallback completion record: ${fallbackResponse.status} ${fallbackResponse.statusText}`);
                // Log fallback storage failure
                await (0, $a30lF.sendCriticalLog)({
                    timestamp: new Date().toISOString(),
                    severity: "ERROR",
                    userId: this.userId,
                    action: "Fallback completion record storage failed",
                    additionalInfo: {
                        taskId: this.taskId,
                        queue: this.queue,
                        httpStatus: fallbackResponse.status,
                        httpStatusText: fallbackResponse.statusText,
                        fallbackCollectionUrl: fallbackCollectionUrl
                    }
                });
            }
        } catch (fallbackError) {
            console.error("\u274C Failed to store fallback completion record:", fallbackError);
            // Log fallback storage exception
            await (0, $a30lF.sendCriticalLog)({
                timestamp: new Date().toISOString(),
                severity: "ERROR",
                userId: this.userId,
                action: "Fallback completion record exception",
                additionalInfo: {
                    taskId: this.taskId,
                    queue: this.queue,
                    errorName: fallbackError.name,
                    errorMessage: fallbackError.message
                }
            });
        // Still don't throw - document processing should complete
        }
    }
}
class $20e0088800729d63$export$9fee94aa43a40124 extends $20e0088800729d63$export$2398eb31525b8be1 {
    constructor(projectId, subscriptionName, ackId, messageId, resultBucket, resultPrefix, resultObject, reviewedResultBucket, rejectedResultBucket, callbackUrl, type, name, createTime = new Date(), queue, labels = [], pageImageUrls = [], data, revisions){
        super(type, name, createTime, queue, labels, pageImageUrls, data, revisions), this.id = ()=>{
            return this.resultBucket + this.resultObject;
        };
        this.projectId = projectId;
        this.subscriptionName = subscriptionName;
        this.ackId = ackId;
        this.messageId = messageId;
        this.resultBucket = resultBucket;
        this.resultPrefix = resultPrefix;
        this.resultObject = resultObject;
        this.reviewedResultBucket = reviewedResultBucket;
        this.rejectedResultBucket = rejectedResultBucket;
        this.callbackUrl = callbackUrl;
    }
    resultBaseName() {
        // Remove the result prefix from the result object path
        let basename = this.resultObject;
        // Handle both cases: resultPrefix with and without trailing slash
        const prefixWithSlash = this.resultPrefix.endsWith("/") ? this.resultPrefix : this.resultPrefix + "/";
        const prefixWithoutSlash = this.resultPrefix.endsWith("/") ? this.resultPrefix.slice(0, -1) : this.resultPrefix;
        // Try to remove prefix (try both variants)
        if (basename.startsWith(prefixWithSlash)) basename = basename.substring(prefixWithSlash.length);
        else if (basename.startsWith(prefixWithoutSlash)) {
            basename = basename.substring(prefixWithoutSlash.length);
            // If basename now starts with '/', remove it
            if (basename.startsWith("/")) basename = basename.substring(1);
        }
        // Remove .json extension
        return basename.replace(/\.json$/, "");
    }
    async getContent(accessToken) {
        const url = "https://storage.googleapis.com/" + this.resultBucket + "/" + this.resultObject;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + accessToken
            }
        });
        if (!response.ok) throw response;
        return await response.json();
    }
    //override getThumbnailUrl = async (accessToken: string): Promise<string> => {
    //  if (this.pageImageUrls.length > 0) {
    //    const url = new URL(this.pageImageUrls[0]);
    //    url.searchParams.set("access_token", accessToken);
    //    this.thumbnailUrl = url.toString();
    //    return this.thumbnailUrl;
    //  } else {
    //    const json = await this.getContent(accessToken);
    //    if (json.pages?.length > 0) {
    //      if (json.pages[0]?.image?.content) {
    //        this.thumbnailUrl = `data:${json.pages[0]?.image?.mime_type};base64,${json.pages[0]?.image?.content}`;
    //        return this.thumbnailUrl;
    //      }
    //    }
    //  }
    // return blank image
    //  return BLANK_IMAGE;
    //};
    async saveContent(accessToken, idToken, content, data, rejectReason) {
        // save content to GCS
        // Ensure resultPrefix has trailing slash before concatenation
        const normalizedPrefix = this.resultPrefix.endsWith("/") ? this.resultPrefix : this.resultPrefix + "/";
        const newResultObjectName = normalizedPrefix + this.suggestedName();
        let url;
        let outputBucket = this.resultBucket; // default
        if (typeof this.reviewDuration === "undefined" || Number.isNaN(this.reviewDuration)) this.reviewDuration = (new Date().getTime() - this.reviewStartTime.getTime()) / 1000;
        else this.reviewDuration += (new Date().getTime() - this.reviewStartTime.getTime()) / 1000;
        data.reviewDuration = this.reviewDuration;
        console.log("The final reviewDuration (seconds) due to saving is: ", this.reviewDuration);
        data.reviewWeekDay = new Date().toLocaleDateString("de", {
            weekday: "long"
        });
        console.log("The document was processed on a ", data.reviewWeekDay);
        // save the subscription name (queue), the ackId and messageId pertaining to a corresponding Pub/Sub message
        data.queue = this.queue;
        data.pubsubMessageId = this.messageId;
        data.pubsubAckId = this.ackId;
        // If the document is rejected, store it in the rejectedResultBucket and add both storno and reviewedResult keys if available.
        if (rejectReason && this.rejectedResultBucket) {
            data.storno = rejectReason;
            data.reviewedResult = content;
            content = JSON.stringify({
                data: data
            });
            outputBucket = this.rejectedResultBucket;
        } else if (this.reviewedResultBucket) {
            data.reviewedResult = content;
            content = JSON.stringify({
                data: data
            });
            outputBucket = this.reviewedResultBucket;
        } else outputBucket = this.resultBucket;
        // Fixed: Properly encode path components separately to avoid encoding slashes
        const pathComponents = newResultObjectName.split("/");
        const encodedPath = pathComponents.map((component)=>encodeURIComponent(component)).join("/");
        const gcsUrl = `https://storage.googleapis.com/${outputBucket}/${encodedPath}`;
        await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(gcsUrl, {
            method: "PUT",
            headers: {
                Authorization: "Bearer " + accessToken,
                "Content-Type": "application/json"
            },
            body: content
        });
        // publish the reviewResult to Pub/Sub topic (can also be storno)
        var pubsubMessage = {
            document_id: data.documentId,
            processor_type: data.processorType,
            outputGcsDestination: `gs://${outputBucket}/${encodedPath}`
        };
        console.log("PUBSUB MESSAGE", pubsubMessage);
        // acknowledge Pub/Sub message
        const response = await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(`https://pubsub.googleapis.com/v1/${this.subscriptionName}:acknowledge`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + accessToken
            },
            body: JSON.stringify({
                ackIds: [
                    this.ackId
                ]
            })
        });
        console.warn("The messageId and ackId are: ", this.messageId, this.ackId);
        console.warn("Document ID: ", data.documentId);
        console.warn("ACKTEST Pub/Sub acknowledge response: ", response);
        url = data.callback_url;
        console.log("Triggering callback URL: ", url);
        // Prepare the response data
        const responseData = {
            status: "success",
            processed_data: pubsubMessage
        };
        // Call callback_url of Workflow with graceful error handling
        try {
            await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(url, {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + accessToken,
                    "Content-Type": "application/json"
                },
                //body: JSON.stringify(this.toJson(newResultObjectName)),
                body: JSON.stringify(responseData)
            });
            console.log("Callback URL triggered successfully");
        } catch (callbackError) {
            console.warn("Callback URL request failed, but document was saved successfully:", callbackError);
            // Log the callback failure for monitoring
            const errorMessage = callbackError instanceof Error ? callbackError.message : String(callbackError);
            console.error("Callback URL details:", {
                url: url,
                error: errorMessage,
                timestamp: new Date().toISOString(),
                documentId: data.documentId,
                messageId: data.messageId
            });
        // Document was successfully saved - callback failure should not stop the process
        // The workflow may have expired or been cancelled, but the document processing is complete
        }
        // stop extending acknowledgement deadline
        if (this.extendAckIdWorker) this.extendAckIdWorker.terminate();
    }
    toJson(newResultObjectName) {
        return {
            resultBucket: this.resultBucket,
            resultPrefix: this.resultPrefix,
            resultObject: newResultObjectName
        };
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $a5412009125d86dc$export$3b798af8cc0f34eb {
    constructor(label){
        this.label = label;
    }
    static fromJson(json) {
        const entityLabel = new $a5412009125d86dc$export$3b798af8cc0f34eb(json.label);
        if (json.requireCategory) entityLabel.requireCategory = json.requireCategory;
        if (json.labelDescription) entityLabel.labelDescription = json.labelDescription;
        if (json.normalizedValueType) entityLabel.normalizedValueType = json.normalizedValueType;
        if (Array.isArray(json.nestedEntityLabels)) {
            entityLabel.nestedEntityLabels = [];
            json.nestedEntityLabels.forEach((nestedEntityLabel)=>{
                entityLabel.nestedEntityLabels?.push($a5412009125d86dc$export$3b798af8cc0f34eb.fromJson(nestedEntityLabel));
            });
        }
        if (json.validationFunction) entityLabel.validationFunction = json.validationFunction;
        return entityLabel;
    }
}
function $a5412009125d86dc$export$5dc1095df0929c56(entities) {
    let entityLabels = [];
    entities?.forEach((entity)=>{
        if (!entityLabels.some((entityLabel)=>entityLabel.label === entity.type)) {
            let entityLabel = new $a5412009125d86dc$export$3b798af8cc0f34eb(entity.type);
            if (entity.properties?.length > 0) {
                const nestedEntityLabels = $a5412009125d86dc$export$5dc1095df0929c56(entity.properties);
                entityLabel.nestedEntityLabels = nestedEntityLabels;
            }
            entityLabels.push(entityLabel);
        }
    });
    return entityLabels;
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $28cd16f8fd1092bc$export$d385b1740434b54b {
    constructor(displayName){
        this.displayName = displayName;
    }
    static fromJson(json) {
        const groupingLabel = new $28cd16f8fd1092bc$export$d385b1740434b54b(json.displayName);
        return groupingLabel;
    }
}
function $28cd16f8fd1092bc$export$d8deb1f7e4c5d129(entities) {
    let groupingLabels = [];
    entities?.forEach((entity)=>{
        // only add grouping label if it does not exist yet
        if (!groupingLabels.some((groupingLabel)=>groupingLabel.displayName === entity.type)) {
            let groupingLabel = new $28cd16f8fd1092bc$export$d385b1740434b54b(entity.type);
            groupingLabels.push(groupingLabel);
        }
    });
    return groupingLabels;
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Standardized processor type constants
 * These are the ONLY supported processor types in the application
 *
 * @readonly
 */ const $1d7c3ce87f93ab74$export$20033ba95002c1ee = {
    /** Document classification processor */ CLASSIFICATION: "CUSTOM_CLASSIFICATION_PROCESSOR",
    /** Document splitting processor */ SPLITTING: "CUSTOM_SPLITTING_PROCESSOR",
    /** Data extraction processor */ EXTRACTION: "CUSTOM_EXTRACTION_PROCESSOR"
};
const $1d7c3ce87f93ab74$export$2224233e5a6abcb7 = {
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.CLASSIFICATION]: "DAI_COMPLEX_CLASSIFICATION",
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.SPLITTING]: "DocSplitter",
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.EXTRACTION]: "Entity"
};
const $1d7c3ce87f93ab74$export$11b23ea87b443d86 = {
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.CLASSIFICATION]: "DAI_COMPLEX_CLASSIFICATION",
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.SPLITTING]: "DocSplitter",
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.EXTRACTION]: "Entity"
};
const $1d7c3ce87f93ab74$export$fcd8c83794cd8019 = {
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.CLASSIFICATION]: "Document Classification",
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.SPLITTING]: "Document Splitting",
    [$1d7c3ce87f93ab74$export$20033ba95002c1ee.EXTRACTION]: "Data Extraction"
};
function $1d7c3ce87f93ab74$export$4b8a5d492382a101(processorType) {
    const tabType = $1d7c3ce87f93ab74$export$2224233e5a6abcb7[processorType];
    if (!tabType) {
        console.warn(`Unknown processor type: ${processorType}. Defaulting to Entity extraction.`);
        return "Entity";
    }
    return tabType;
}
function $1d7c3ce87f93ab74$export$c6b1b06f7d8f6927(processorType) {
    const reviewType = $1d7c3ce87f93ab74$export$11b23ea87b443d86[processorType];
    if (!reviewType) {
        console.warn(`Unknown processor type: ${processorType}. Defaulting to Entity extraction.`);
        return "Entity";
    }
    return reviewType;
}
function $1d7c3ce87f93ab74$export$264c4b3240a3574(processorType) {
    return processorType in $1d7c3ce87f93ab74$export$2224233e5a6abcb7;
}
function $1d7c3ce87f93ab74$export$d2656bc57653cfb0(processorType) {
    return $1d7c3ce87f93ab74$export$fcd8c83794cd8019[processorType] || "Unknown Processor";
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
class $150c59cc1c2ee7ed$export$59e7611a9b95daae {
    constructor(values = []){
        this.label = "Document type";
        this.values = values;
    }
    static fromJson(json) {
        const classificationLabel = new $150c59cc1c2ee7ed$export$59e7611a9b95daae(json.values);
        return classificationLabel;
    }
}
function $150c59cc1c2ee7ed$export$253226dc27546fb7(entities) {
    console.log("DEBUG convertEntitiesToClassificationLabels - input entities:", entities);
    const entityLabels = [];
    let maxEntityConfidence = 0;
    let selectedValue;
    let selectedId;
    entities?.forEach((entity)=>{
        console.log("DEBUG - Processing entity:", {
            type: entity.type,
            confidence: entity.confidence,
            id: entity.id
        });
        // Create EntityLabel for each unique entity type
        if (!entityLabels.some((label)=>label.label === entity.type)) {
            const newEntityLabel = new (0, $a5412009125d86dc$export$3b798af8cc0f34eb)(entity.type);
            // Store original name (without ID prefix) for backend processing
            // This ensures consistency with labels created from processed_data
            // Updated regex to handle both dash and underscore formats:
            // - "1 - Neuschaden" (dash with spaces)
            // - "5_kuendigung" (underscore without spaces)
            // - "5 _ kuendigung" (underscore with spaces)
            const idPrefixMatch = entity.type.match(/^(\d+)\s*[-_]\s*(.+)$/);
            if (idPrefixMatch) {
                newEntityLabel.originalDisplayName = idPrefixMatch[2];
                console.log("DEBUG - Stored originalDisplayName:", idPrefixMatch[2]);
            }
            entityLabels.push(newEntityLabel);
            console.log("DEBUG - Created EntityLabel:", newEntityLabel);
            // Track the highest confidence entity for selection
            if (entity.confidence ?? 0 >= maxEntityConfidence) {
                maxEntityConfidence = entity.confidence ?? 0;
                // Strip ID prefix from selectedValue to avoid backend KeyError
                // Format: "1 - Neuschaden" -> "Neuschaden" OR "5_kuendigung" -> "kuendigung"
                selectedValue = idPrefixMatch ? idPrefixMatch[2] : entity.type;
                selectedId = entity.id;
                console.log("DEBUG - Set selectedValue:", {
                    original: entity.type,
                    stripped: selectedValue
                });
            }
        }
    });
    console.log("DEBUG - Final entityLabels array:", entityLabels);
    const classificationLabel = new $150c59cc1c2ee7ed$export$59e7611a9b95daae(entityLabels);
    classificationLabel.selectedValue = selectedValue;
    classificationLabel.id = selectedId;
    console.log("DEBUG - Final ClassificationLabel:", classificationLabel);
    return [
        classificationLabel
    ];
}




var $eUQW6 = parcelRequire("eUQW6");

var $a30lF = parcelRequire("a30lF");
const $cfe1945935cd34b8$var$SESSION_STORAGE_KEY = 'hitl_session';
const $cfe1945935cd34b8$var$SESSION_DURATION_MS = 28800000; // 8 hours in milliseconds
class $cfe1945935cd34b8$export$415798a788f40554 {
    /**
   * Save session data to localStorage
   */ static saveSession(data) {
        try {
            const sessionData = {
                ...data,
                sessionCreatedAt: data.sessionCreatedAt || new Date().toISOString()
            };
            localStorage.setItem($cfe1945935cd34b8$var$SESSION_STORAGE_KEY, JSON.stringify(sessionData));
        } catch (error) {
            console.warn('Failed to save session to localStorage:', error);
        }
    }
    /**
   * Load session data from localStorage
   * Returns null if no valid session exists
   */ static loadSession() {
        try {
            const stored = localStorage.getItem($cfe1945935cd34b8$var$SESSION_STORAGE_KEY);
            if (!stored) return null;
            const sessionData = JSON.parse(stored);
            return sessionData;
        } catch (error) {
            console.warn('Failed to load session from localStorage:', error);
            this.clearSession();
            return null;
        }
    }
    /**
   * Check if the current session is valid
   * A session is valid if:
   * 1. It exists
   * 2. It's less than 8 hours old
   * 3. The access token hasn't expired
   */ static isSessionValid(sessionData) {
        if (!sessionData) {
            console.warn('[Session] No session data provided');
            return false;
        }
        // Check session age (8 hours max)
        const sessionCreatedAt = new Date(sessionData.sessionCreatedAt);
        const sessionAge = Date.now() - sessionCreatedAt.getTime();
        const sessionAgeHours = sessionAge / 3600000;
        console.log(`[Session] Session age: ${sessionAgeHours.toFixed(2)} hours (created at ${sessionCreatedAt.toISOString()})`);
        if (sessionAge > $cfe1945935cd34b8$var$SESSION_DURATION_MS) {
            console.warn(`[Session] Session expired (${sessionAgeHours.toFixed(2)} hours old, max 8 hours)`);
            return false;
        }
        // Check token expiration
        const tokenExpiration = new Date(sessionData.accessTokenExpiration);
        const now = new Date();
        const timeUntilExpiration = tokenExpiration.getTime() - now.getTime();
        const minutesUntilExpiration = timeUntilExpiration / 60000;
        console.log(`[Session] Token expires at ${tokenExpiration.toISOString()} (in ${minutesUntilExpiration.toFixed(2)} minutes)`);
        if (tokenExpiration <= now) {
            console.warn(`[Session] Access token expired at ${tokenExpiration.toISOString()}`);
            return false;
        }
        console.log("[Session] Session is valid \u2713");
        return true;
    }
    /**
   * Clear session data from localStorage
   */ static clearSession() {
        try {
            console.log('[Session] Clearing session from localStorage');
            localStorage.removeItem($cfe1945935cd34b8$var$SESSION_STORAGE_KEY);
        } catch (error) {
            console.warn('Failed to clear session from localStorage:', error);
        }
    }
    /**
   * Update specific fields in the existing session
   */ static updateSession(updates) {
        const currentSession = this.loadSession();
        if (!currentSession) {
            console.warn('Cannot update session: no session exists');
            return;
        }
        const updatedSession = {
            ...currentSession,
            ...updates
        };
        this.saveSession(updatedSession);
    }
    /**
   * Get session age in milliseconds
   */ static getSessionAge() {
        const sessionData = this.loadSession();
        if (!sessionData) return null;
        return Date.now() - new Date(sessionData.sessionCreatedAt).getTime();
    }
    /**
   * Get time until session expires (in milliseconds)
   */ static getTimeUntilExpiration() {
        const sessionAge = this.getSessionAge();
        if (sessionAge === null) return null;
        const timeRemaining = $cfe1945935cd34b8$var$SESSION_DURATION_MS - sessionAge;
        return timeRemaining > 0 ? timeRemaining : 0;
    }
}


const $6aaf1204c60f2308$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $abbde52b10a5c31f$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $abbde52b10a5c31f$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $abbde52b10a5c31f$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $abbde52b10a5c31f$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $abbde52b10a5c31f$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $abbde52b10a5c31f$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $abbde52b10a5c31f$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $abbde52b10a5c31f$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($abbde52b10a5c31f$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $abbde52b10a5c31f$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $abbde52b10a5c31f$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $abbde52b10a5c31f$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $abbde52b10a5c31f$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $abbde52b10a5c31f$var$stringToByteArray$1(str);
    return $abbde52b10a5c31f$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $abbde52b10a5c31f$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $abbde52b10a5c31f$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $abbde52b10a5c31f$export$c62426fdd000a97e = function(str) {
    try {
        return $abbde52b10a5c31f$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $abbde52b10a5c31f$export$6c40052bed430212(value) {
    return $abbde52b10a5c31f$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $abbde52b10a5c31f$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$abbde52b10a5c31f$var$isValidKey(prop)) continue;
        target[prop] = $abbde52b10a5c31f$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $abbde52b10a5c31f$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $abbde52b10a5c31f$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $abbde52b10a5c31f$var$getDefaultsFromGlobal = ()=>$abbde52b10a5c31f$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $abbde52b10a5c31f$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $abbde52b10a5c31f$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $abbde52b10a5c31f$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $abbde52b10a5c31f$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $6aaf1204c60f2308$export$6d3c090e66a883b1)() || $abbde52b10a5c31f$var$getDefaultsFromGlobal() || $abbde52b10a5c31f$var$getDefaultsFromEnvVariable() || $abbde52b10a5c31f$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $abbde52b10a5c31f$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $abbde52b10a5c31f$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $abbde52b10a5c31f$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $abbde52b10a5c31f$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $abbde52b10a5c31f$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $abbde52b10a5c31f$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $abbde52b10a5c31f$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $abbde52b10a5c31f$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $abbde52b10a5c31f$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $abbde52b10a5c31f$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch (_a) {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $abbde52b10a5c31f$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $abbde52b10a5c31f$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $abbde52b10a5c31f$export$4b5284a3025a455(JSON.stringify(header)),
        $abbde52b10a5c31f$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
const $abbde52b10a5c31f$var$emulatorStatus = {};
// Checks whether any products are running on an emulator
function $abbde52b10a5c31f$var$getEmulatorSummary() {
    const summary = {
        prod: [],
        emulator: []
    };
    for (const key of Object.keys($abbde52b10a5c31f$var$emulatorStatus))if ($abbde52b10a5c31f$var$emulatorStatus[key]) summary.emulator.push(key);
    else summary.prod.push(key);
    return summary;
}
function $abbde52b10a5c31f$var$getOrCreateEl(id) {
    let parentDiv = document.getElementById(id);
    let created = false;
    if (!parentDiv) {
        parentDiv = document.createElement('div');
        parentDiv.setAttribute('id', id);
        created = true;
    }
    return {
        created: created,
        element: parentDiv
    };
}
let $abbde52b10a5c31f$var$previouslyDismissed = false;
/**
 * Updates Emulator Banner. Primarily used for Firebase Studio
 * @param name
 * @param isRunningEmulator
 * @public
 */ function $abbde52b10a5c31f$export$fd3d2954543183b1(name, isRunningEmulator) {
    if (typeof window === 'undefined' || typeof document === 'undefined' || !$abbde52b10a5c31f$export$5b4d24b45140ad90(window.location.host) || $abbde52b10a5c31f$var$emulatorStatus[name] === isRunningEmulator || $abbde52b10a5c31f$var$emulatorStatus[name] || // If already set to use emulator, can't go back to prod.
    $abbde52b10a5c31f$var$previouslyDismissed) return;
    $abbde52b10a5c31f$var$emulatorStatus[name] = isRunningEmulator;
    function prefixedId(id) {
        return `__firebase__banner__${id}`;
    }
    const bannerId = '__firebase__banner';
    const summary = $abbde52b10a5c31f$var$getEmulatorSummary();
    const showError = summary.prod.length > 0;
    function tearDown() {
        const element = document.getElementById(bannerId);
        if (element) element.remove();
    }
    function setupBannerStyles(bannerEl) {
        bannerEl.style.display = 'flex';
        bannerEl.style.background = '#7faaf0';
        bannerEl.style.position = 'fixed';
        bannerEl.style.bottom = '5px';
        bannerEl.style.left = '5px';
        bannerEl.style.padding = '.5em';
        bannerEl.style.borderRadius = '5px';
        bannerEl.style.alignItems = 'center';
    }
    function setupIconStyles(prependIcon, iconId) {
        prependIcon.setAttribute('width', '24');
        prependIcon.setAttribute('id', iconId);
        prependIcon.setAttribute('height', '24');
        prependIcon.setAttribute('viewBox', '0 0 24 24');
        prependIcon.setAttribute('fill', 'none');
        prependIcon.style.marginLeft = '-6px';
    }
    function setupCloseBtn() {
        const closeBtn = document.createElement('span');
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.marginLeft = '16px';
        closeBtn.style.fontSize = '24px';
        closeBtn.innerHTML = ' &times;';
        closeBtn.onclick = ()=>{
            $abbde52b10a5c31f$var$previouslyDismissed = true;
            tearDown();
        };
        return closeBtn;
    }
    function setupLinkStyles(learnMoreLink, learnMoreId) {
        learnMoreLink.setAttribute('id', learnMoreId);
        learnMoreLink.innerText = 'Learn more';
        learnMoreLink.href = 'https://firebase.google.com/docs/studio/preview-apps#preview-backend';
        learnMoreLink.setAttribute('target', '__blank');
        learnMoreLink.style.paddingLeft = '5px';
        learnMoreLink.style.textDecoration = 'underline';
    }
    function setupDom() {
        const banner = $abbde52b10a5c31f$var$getOrCreateEl(bannerId);
        const firebaseTextId = prefixedId('text');
        const firebaseText = document.getElementById(firebaseTextId) || document.createElement('span');
        const learnMoreId = prefixedId('learnmore');
        const learnMoreLink = document.getElementById(learnMoreId) || document.createElement('a');
        const prependIconId = prefixedId('preprendIcon');
        const prependIcon = document.getElementById(prependIconId) || document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        if (banner.created) {
            // update styles
            const bannerEl = banner.element;
            setupBannerStyles(bannerEl);
            setupLinkStyles(learnMoreLink, learnMoreId);
            const closeBtn = setupCloseBtn();
            setupIconStyles(prependIcon, prependIconId);
            bannerEl.append(prependIcon, firebaseText, learnMoreLink, closeBtn);
            document.body.appendChild(bannerEl);
        }
        if (showError) {
            firebaseText.innerText = `Preview backend disconnected.`;
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
        } else {
            prependIcon.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`;
            firebaseText.innerText = 'Preview backend running in this workspace.';
        }
        firebaseText.setAttribute('id', firebaseTextId);
    }
    if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', setupDom);
    else setupDom();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $abbde52b10a5c31f$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $abbde52b10a5c31f$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($abbde52b10a5c31f$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $abbde52b10a5c31f$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $abbde52b10a5c31f$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $abbde52b10a5c31f$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $abbde52b10a5c31f$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $abbde52b10a5c31f$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $abbde52b10a5c31f$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $abbde52b10a5c31f$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $abbde52b10a5c31f$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $abbde52b10a5c31f$export$f2f6a8999f8ebd30() {
    return $abbde52b10a5c31f$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $abbde52b10a5c31f$export$7e7b1a9668aaed8() {
    const ua = $abbde52b10a5c31f$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $abbde52b10a5c31f$export$202944b2d2824246() {
    return $abbde52b10a5c31f$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $abbde52b10a5c31f$export$5d1d834fbbf8bab7() {
    return $abbde52b10a5c31f$export$588c7fdda06fbb0a.NODE_CLIENT === true || $abbde52b10a5c31f$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $abbde52b10a5c31f$export$95df08bae54cb4df() {
    return !$abbde52b10a5c31f$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $abbde52b10a5c31f$export$ef10bcfb06572016() {
    return !$abbde52b10a5c31f$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $abbde52b10a5c31f$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $abbde52b10a5c31f$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $abbde52b10a5c31f$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $abbde52b10a5c31f$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $abbde52b10a5c31f$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $abbde52b10a5c31f$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $abbde52b10a5c31f$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $abbde52b10a5c31f$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $abbde52b10a5c31f$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $abbde52b10a5c31f$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $abbde52b10a5c31f$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $abbde52b10a5c31f$var$replaceTemplate(template, data) {
    return template.replace($abbde52b10a5c31f$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $abbde52b10a5c31f$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $abbde52b10a5c31f$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $abbde52b10a5c31f$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $abbde52b10a5c31f$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $abbde52b10a5c31f$export$c5a53ce6a17cf18d($abbde52b10a5c31f$export$c62426fdd000a97e(parts[0]) || '');
        claims = $abbde52b10a5c31f$export$c5a53ce6a17cf18d($abbde52b10a5c31f$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $abbde52b10a5c31f$export$5f870fcca7ae6a88 = function(token) {
    const claims = $abbde52b10a5c31f$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $abbde52b10a5c31f$export$701c661ec91095f2 = function(token) {
    const claims = $abbde52b10a5c31f$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $abbde52b10a5c31f$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $abbde52b10a5c31f$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $abbde52b10a5c31f$export$fc970ed23da99565 = function(token) {
    const claims = $abbde52b10a5c31f$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $abbde52b10a5c31f$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $abbde52b10a5c31f$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $abbde52b10a5c31f$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $abbde52b10a5c31f$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $abbde52b10a5c31f$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($abbde52b10a5c31f$var$isObject(aProp) && $abbde52b10a5c31f$var$isObject(bProp)) {
            if (!$abbde52b10a5c31f$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $abbde52b10a5c31f$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $abbde52b10a5c31f$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $abbde52b10a5c31f$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $abbde52b10a5c31f$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $abbde52b10a5c31f$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $abbde52b10a5c31f$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $abbde52b10a5c31f$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $abbde52b10a5c31f$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $abbde52b10a5c31f$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $abbde52b10a5c31f$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($abbde52b10a5c31f$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $abbde52b10a5c31f$var$noop;
        if (observer.error === undefined) observer.error = $abbde52b10a5c31f$var$noop;
        if (observer.complete === undefined) observer.complete = $abbde52b10a5c31f$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $abbde52b10a5c31f$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $abbde52b10a5c31f$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $abbde52b10a5c31f$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $abbde52b10a5c31f$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $abbde52b10a5c31f$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $abbde52b10a5c31f$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($abbde52b10a5c31f$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $abbde52b10a5c31f$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($abbde52b10a5c31f$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $abbde52b10a5c31f$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($abbde52b10a5c31f$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $abbde52b10a5c31f$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $abbde52b10a5c31f$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $abbde52b10a5c31f$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $abbde52b10a5c31f$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $abbde52b10a5c31f$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $abbde52b10a5c31f$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $abbde52b10a5c31f$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $abbde52b10a5c31f$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $abbde52b10a5c31f$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $abbde52b10a5c31f$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $abbde52b10a5c31f$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($abbde52b10a5c31f$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $abbde52b10a5c31f$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $abbde52b10a5c31f$var$indicator(i);
}
function $abbde52b10a5c31f$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $abbde52b10a5c31f$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $30f07c707847df11$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $30f07c707847df11$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $30f07c707847df11$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $abbde52b10a5c31f$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($30f07c707847df11$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $30f07c707847df11$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $30f07c707847df11$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $30f07c707847df11$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $30f07c707847df11$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $30f07c707847df11$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $30f07c707847df11$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $30f07c707847df11$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $30f07c707847df11$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $30f07c707847df11$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $30f07c707847df11$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $30f07c707847df11$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $30f07c707847df11$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $c2975c8f4799263d$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $c2975c8f4799263d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($c2975c8f4799263d$export$243e62d78d3b544d || ($c2975c8f4799263d$export$243e62d78d3b544d = {}));
const $c2975c8f4799263d$var$levelStringToEnum = {
    'debug': $c2975c8f4799263d$export$243e62d78d3b544d.DEBUG,
    'verbose': $c2975c8f4799263d$export$243e62d78d3b544d.VERBOSE,
    'info': $c2975c8f4799263d$export$243e62d78d3b544d.INFO,
    'warn': $c2975c8f4799263d$export$243e62d78d3b544d.WARN,
    'error': $c2975c8f4799263d$export$243e62d78d3b544d.ERROR,
    'silent': $c2975c8f4799263d$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $c2975c8f4799263d$var$defaultLogLevel = $c2975c8f4799263d$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $c2975c8f4799263d$var$ConsoleMethod = {
    [$c2975c8f4799263d$export$243e62d78d3b544d.DEBUG]: 'log',
    [$c2975c8f4799263d$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$c2975c8f4799263d$export$243e62d78d3b544d.INFO]: 'info',
    [$c2975c8f4799263d$export$243e62d78d3b544d.WARN]: 'warn',
    [$c2975c8f4799263d$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $c2975c8f4799263d$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $c2975c8f4799263d$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $c2975c8f4799263d$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $c2975c8f4799263d$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $c2975c8f4799263d$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $c2975c8f4799263d$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $c2975c8f4799263d$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $c2975c8f4799263d$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $c2975c8f4799263d$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $c2975c8f4799263d$export$c622e99c0ce7b1c9(level) {
    $c2975c8f4799263d$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $c2975c8f4799263d$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $c2975c8f4799263d$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $c2975c8f4799263d$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $c2975c8f4799263d$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $717396c8df15976c$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $717396c8df15976c$var$idbProxyableTypes;
let $717396c8df15976c$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $717396c8df15976c$var$getIdbProxyableTypes() {
    return $717396c8df15976c$var$idbProxyableTypes || ($717396c8df15976c$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $717396c8df15976c$var$getCursorAdvanceMethods() {
    return $717396c8df15976c$var$cursorAdvanceMethods || ($717396c8df15976c$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $717396c8df15976c$var$cursorRequestMap = new WeakMap();
const $717396c8df15976c$var$transactionDoneMap = new WeakMap();
const $717396c8df15976c$var$transactionStoreNamesMap = new WeakMap();
const $717396c8df15976c$var$transformCache = new WeakMap();
const $717396c8df15976c$export$407448d2b89b1813 = new WeakMap();
function $717396c8df15976c$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($717396c8df15976c$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $717396c8df15976c$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $717396c8df15976c$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $717396c8df15976c$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($717396c8df15976c$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $717396c8df15976c$var$transactionDoneMap.set(tx, done);
}
let $717396c8df15976c$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $717396c8df15976c$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $717396c8df15976c$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $717396c8df15976c$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $717396c8df15976c$export$43caf9889c228507(callback) {
    $717396c8df15976c$var$idbProxyTraps = callback($717396c8df15976c$var$idbProxyTraps);
}
function $717396c8df15976c$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($717396c8df15976c$export$3b14a55fb2447963(this), storeNames, ...args);
        $717396c8df15976c$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $717396c8df15976c$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($717396c8df15976c$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($717396c8df15976c$export$3b14a55fb2447963(this), args);
        return $717396c8df15976c$export$efccba1c4a2ef57b($717396c8df15976c$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $717396c8df15976c$export$efccba1c4a2ef57b(func.apply($717396c8df15976c$export$3b14a55fb2447963(this), args));
    };
}
function $717396c8df15976c$var$transformCachableValue(value) {
    if (typeof value === 'function') return $717396c8df15976c$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $717396c8df15976c$var$cacheDonePromiseForTransaction(value);
    if ($717396c8df15976c$export$23f2a1d2818174ef(value, $717396c8df15976c$var$getIdbProxyableTypes())) return new Proxy(value, $717396c8df15976c$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $717396c8df15976c$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $717396c8df15976c$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($717396c8df15976c$var$transformCache.has(value)) return $717396c8df15976c$var$transformCache.get(value);
    const newValue = $717396c8df15976c$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $717396c8df15976c$var$transformCache.set(value, newValue);
        $717396c8df15976c$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $717396c8df15976c$export$3b14a55fb2447963 = (value)=>$717396c8df15976c$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $2da6d08d336ac6d3$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $717396c8df15976c$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $717396c8df15976c$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $717396c8df15976c$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $2da6d08d336ac6d3$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $717396c8df15976c$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $2da6d08d336ac6d3$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $2da6d08d336ac6d3$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $2da6d08d336ac6d3$var$cachedMethods = new Map();
function $2da6d08d336ac6d3$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($2da6d08d336ac6d3$var$cachedMethods.get(prop)) return $2da6d08d336ac6d3$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $2da6d08d336ac6d3$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $2da6d08d336ac6d3$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $2da6d08d336ac6d3$var$cachedMethods.set(prop, method);
    return method;
}
(0, $717396c8df15976c$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$2da6d08d336ac6d3$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$2da6d08d336ac6d3$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $eda286d93c7c2273$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($eda286d93c7c2273$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $eda286d93c7c2273$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $eda286d93c7c2273$var$name$q = "@firebase/app";
const $eda286d93c7c2273$var$version$1 = "0.13.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eda286d93c7c2273$var$logger = new (0, $c2975c8f4799263d$export$efa9a398d6368992)('@firebase/app');
const $eda286d93c7c2273$var$name$p = "@firebase/app-compat";
const $eda286d93c7c2273$var$name$o = "@firebase/analytics-compat";
const $eda286d93c7c2273$var$name$n = "@firebase/analytics";
const $eda286d93c7c2273$var$name$m = "@firebase/app-check-compat";
const $eda286d93c7c2273$var$name$l = "@firebase/app-check";
const $eda286d93c7c2273$var$name$k = "@firebase/auth";
const $eda286d93c7c2273$var$name$j = "@firebase/auth-compat";
const $eda286d93c7c2273$var$name$i = "@firebase/database";
const $eda286d93c7c2273$var$name$h = "@firebase/data-connect";
const $eda286d93c7c2273$var$name$g = "@firebase/database-compat";
const $eda286d93c7c2273$var$name$f = "@firebase/functions";
const $eda286d93c7c2273$var$name$e = "@firebase/functions-compat";
const $eda286d93c7c2273$var$name$d = "@firebase/installations";
const $eda286d93c7c2273$var$name$c = "@firebase/installations-compat";
const $eda286d93c7c2273$var$name$b = "@firebase/messaging";
const $eda286d93c7c2273$var$name$a = "@firebase/messaging-compat";
const $eda286d93c7c2273$var$name$9 = "@firebase/performance";
const $eda286d93c7c2273$var$name$8 = "@firebase/performance-compat";
const $eda286d93c7c2273$var$name$7 = "@firebase/remote-config";
const $eda286d93c7c2273$var$name$6 = "@firebase/remote-config-compat";
const $eda286d93c7c2273$var$name$5 = "@firebase/storage";
const $eda286d93c7c2273$var$name$4 = "@firebase/storage-compat";
const $eda286d93c7c2273$var$name$3 = "@firebase/firestore";
const $eda286d93c7c2273$var$name$2 = "@firebase/ai";
const $eda286d93c7c2273$var$name$1 = "@firebase/firestore-compat";
const $eda286d93c7c2273$var$name = "firebase";
const $eda286d93c7c2273$var$version = "11.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $eda286d93c7c2273$export$9f30fa0c10967f7f = '[DEFAULT]';
const $eda286d93c7c2273$var$PLATFORM_LOG_STRING = {
    [$eda286d93c7c2273$var$name$q]: 'fire-core',
    [$eda286d93c7c2273$var$name$p]: 'fire-core-compat',
    [$eda286d93c7c2273$var$name$n]: 'fire-analytics',
    [$eda286d93c7c2273$var$name$o]: 'fire-analytics-compat',
    [$eda286d93c7c2273$var$name$l]: 'fire-app-check',
    [$eda286d93c7c2273$var$name$m]: 'fire-app-check-compat',
    [$eda286d93c7c2273$var$name$k]: 'fire-auth',
    [$eda286d93c7c2273$var$name$j]: 'fire-auth-compat',
    [$eda286d93c7c2273$var$name$i]: 'fire-rtdb',
    [$eda286d93c7c2273$var$name$h]: 'fire-data-connect',
    [$eda286d93c7c2273$var$name$g]: 'fire-rtdb-compat',
    [$eda286d93c7c2273$var$name$f]: 'fire-fn',
    [$eda286d93c7c2273$var$name$e]: 'fire-fn-compat',
    [$eda286d93c7c2273$var$name$d]: 'fire-iid',
    [$eda286d93c7c2273$var$name$c]: 'fire-iid-compat',
    [$eda286d93c7c2273$var$name$b]: 'fire-fcm',
    [$eda286d93c7c2273$var$name$a]: 'fire-fcm-compat',
    [$eda286d93c7c2273$var$name$9]: 'fire-perf',
    [$eda286d93c7c2273$var$name$8]: 'fire-perf-compat',
    [$eda286d93c7c2273$var$name$7]: 'fire-rc',
    [$eda286d93c7c2273$var$name$6]: 'fire-rc-compat',
    [$eda286d93c7c2273$var$name$5]: 'fire-gcs',
    [$eda286d93c7c2273$var$name$4]: 'fire-gcs-compat',
    [$eda286d93c7c2273$var$name$3]: 'fire-fst',
    [$eda286d93c7c2273$var$name$1]: 'fire-fst-compat',
    [$eda286d93c7c2273$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$eda286d93c7c2273$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $eda286d93c7c2273$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $eda286d93c7c2273$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eda286d93c7c2273$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $eda286d93c7c2273$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $eda286d93c7c2273$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $eda286d93c7c2273$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $eda286d93c7c2273$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($eda286d93c7c2273$export$9566bce3835c0f28.has(componentName)) {
        $eda286d93c7c2273$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $eda286d93c7c2273$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $eda286d93c7c2273$export$b4e3c36c855b14b5.values())$eda286d93c7c2273$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $eda286d93c7c2273$export$fb03ad8d3d5c5f76.values())$eda286d93c7c2273$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $eda286d93c7c2273$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $eda286d93c7c2273$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $eda286d93c7c2273$export$9f30fa0c10967f7f) {
    $eda286d93c7c2273$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $eda286d93c7c2273$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $eda286d93c7c2273$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $eda286d93c7c2273$export$3685d89b9c3cdfaf() {
    $eda286d93c7c2273$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eda286d93c7c2273$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $eda286d93c7c2273$var$ERROR_FACTORY = new (0, $abbde52b10a5c31f$export$3fa6e1b18a3b2d40)('app', 'Firebase', $eda286d93c7c2273$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $eda286d93c7c2273$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $30f07c707847df11$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $eda286d93c7c2273$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $eda286d93c7c2273$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $abbde52b10a5c31f$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $eda286d93c7c2273$var$FirebaseServerAppImpl extends $eda286d93c7c2273$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $eda286d93c7c2273$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $eda286d93c7c2273$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $eda286d93c7c2273$export$d29d5299a7137abc($eda286d93c7c2273$var$name$q, $eda286d93c7c2273$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $eda286d93c7c2273$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $eda286d93c7c2273$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $eda286d93c7c2273$export$31499a9cd224b78c = $eda286d93c7c2273$var$version;
function $eda286d93c7c2273$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $eda286d93c7c2273$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $eda286d93c7c2273$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $abbde52b10a5c31f$export$3dfb6827a9f89756)());
    if (!options) throw $eda286d93c7c2273$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $eda286d93c7c2273$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $abbde52b10a5c31f$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $abbde52b10a5c31f$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $eda286d93c7c2273$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $30f07c707847df11$export$436a80eea5d5c0c5)(name);
    for (const component of $eda286d93c7c2273$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $eda286d93c7c2273$var$FirebaseAppImpl(options, config, container);
    $eda286d93c7c2273$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $eda286d93c7c2273$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $abbde52b10a5c31f$export$4e09c449d6c407f7)() && !(0, $abbde52b10a5c31f$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $eda286d93c7c2273$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = true;
    let appOptions;
    if ($eda286d93c7c2273$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $eda286d93c7c2273$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $eda286d93c7c2273$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $30f07c707847df11$export$436a80eea5d5c0c5)(nameString);
    for (const component of $eda286d93c7c2273$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $eda286d93c7c2273$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $eda286d93c7c2273$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $eda286d93c7c2273$export$f9962582c9e66d99(name = $eda286d93c7c2273$export$9f30fa0c10967f7f) {
    const app = $eda286d93c7c2273$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $eda286d93c7c2273$export$9f30fa0c10967f7f && (0, $abbde52b10a5c31f$export$3dfb6827a9f89756)()) return $eda286d93c7c2273$export$c55cfd413944906d();
    if (!app) throw $eda286d93c7c2273$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $eda286d93c7c2273$export$68ddedf7d44b3bdf() {
    return Array.from($eda286d93c7c2273$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $eda286d93c7c2273$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($eda286d93c7c2273$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $eda286d93c7c2273$export$b4e3c36c855b14b5.delete(name);
    } else if ($eda286d93c7c2273$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $eda286d93c7c2273$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $eda286d93c7c2273$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $eda286d93c7c2273$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $eda286d93c7c2273$var$logger.warn(warning.join(' '));
        return;
    }
    $eda286d93c7c2273$export$c930050e7bb63965(new (0, $30f07c707847df11$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $eda286d93c7c2273$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $eda286d93c7c2273$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $c2975c8f4799263d$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $eda286d93c7c2273$export$c622e99c0ce7b1c9(logLevel) {
    (0, $c2975c8f4799263d$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eda286d93c7c2273$var$DB_NAME = 'firebase-heartbeat-database';
const $eda286d93c7c2273$var$DB_VERSION = 1;
const $eda286d93c7c2273$var$STORE_NAME = 'firebase-heartbeat-store';
let $eda286d93c7c2273$var$dbPromise = null;
function $eda286d93c7c2273$var$getDbPromise() {
    if (!$eda286d93c7c2273$var$dbPromise) $eda286d93c7c2273$var$dbPromise = (0, $2da6d08d336ac6d3$export$ca0ed41b1a2af7e)($eda286d93c7c2273$var$DB_NAME, $eda286d93c7c2273$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($eda286d93c7c2273$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $eda286d93c7c2273$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $eda286d93c7c2273$var$dbPromise;
}
async function $eda286d93c7c2273$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $eda286d93c7c2273$var$getDbPromise();
        const tx = db.transaction($eda286d93c7c2273$var$STORE_NAME);
        const result = await tx.objectStore($eda286d93c7c2273$var$STORE_NAME).get($eda286d93c7c2273$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $abbde52b10a5c31f$export$dd24e9cd51226c56)) $eda286d93c7c2273$var$logger.warn(e.message);
        else {
            const idbGetError = $eda286d93c7c2273$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $eda286d93c7c2273$var$logger.warn(idbGetError.message);
        }
    }
}
async function $eda286d93c7c2273$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $eda286d93c7c2273$var$getDbPromise();
        const tx = db.transaction($eda286d93c7c2273$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($eda286d93c7c2273$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $eda286d93c7c2273$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $abbde52b10a5c31f$export$dd24e9cd51226c56)) $eda286d93c7c2273$var$logger.warn(e.message);
        else {
            const idbGetError = $eda286d93c7c2273$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $eda286d93c7c2273$var$logger.warn(idbGetError.message);
        }
    }
}
function $eda286d93c7c2273$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $eda286d93c7c2273$var$MAX_HEADER_BYTES = 1024;
const $eda286d93c7c2273$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $eda286d93c7c2273$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $eda286d93c7c2273$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $eda286d93c7c2273$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $eda286d93c7c2273$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $eda286d93c7c2273$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $eda286d93c7c2273$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $eda286d93c7c2273$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $eda286d93c7c2273$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $abbde52b10a5c31f$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $eda286d93c7c2273$var$logger.warn(e);
            return '';
        }
    }
}
function $eda286d93c7c2273$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $eda286d93c7c2273$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $eda286d93c7c2273$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($eda286d93c7c2273$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($eda286d93c7c2273$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $eda286d93c7c2273$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $abbde52b10a5c31f$export$3865db50535c2055)()) return false;
        else return (0, $abbde52b10a5c31f$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $eda286d93c7c2273$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $eda286d93c7c2273$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $eda286d93c7c2273$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $eda286d93c7c2273$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $abbde52b10a5c31f$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $eda286d93c7c2273$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $eda286d93c7c2273$var$registerCoreComponents(variant) {
    $eda286d93c7c2273$export$c930050e7bb63965(new (0, $30f07c707847df11$export$16fa2f45be04daa8)('platform-logger', (container)=>new $eda286d93c7c2273$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $eda286d93c7c2273$export$c930050e7bb63965(new (0, $30f07c707847df11$export$16fa2f45be04daa8)('heartbeat', (container)=>new $eda286d93c7c2273$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $eda286d93c7c2273$export$d29d5299a7137abc($eda286d93c7c2273$var$name$q, $eda286d93c7c2273$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    $eda286d93c7c2273$export$d29d5299a7137abc($eda286d93c7c2273$var$name$q, $eda286d93c7c2273$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $eda286d93c7c2273$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $eda286d93c7c2273$var$registerCoreComponents('');





var $19e6a74148afb814$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $19e6a74148afb814$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $19e6a74148afb814$export$70ffa26850098d01;
var $19e6a74148afb814$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(f, a) {
        function c() {}
        c.prototype = a.prototype;
        f.D = a.prototype;
        f.prototype = new c;
        f.prototype.constructor = f;
        f.C = function(d, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(d, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.B = Array(this.blockSize);
        this.o = this.h = 0;
        this.s();
    }
    k(m, l);
    m.prototype.s = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(f, a, c) {
        c || (c = 0);
        var d = Array(16);
        if ("string" === typeof a) for(var e = 0; 16 > e; ++e)d[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; 16 > e; ++e)d[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = f.g[0];
        c = f.g[1];
        e = f.g[2];
        var g = f.g[3];
        var b = a + (g ^ c & (e ^ g)) + d[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + d[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + d[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + d[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + d[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + d[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + d[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + d[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + d[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + d[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + d[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + d[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + d[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + d[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + d[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + d[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + d[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + d[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + d[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + d[9] + 3951481745 & 4294967295;
        f.g[0] = f.g[0] + a & 4294967295;
        f.g[1] = f.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        f.g[2] = f.g[2] + e & 4294967295;
        f.g[3] = f.g[3] + g & 4294967295;
    }
    m.prototype.u = function(f, a) {
        void 0 === a && (a = f.length);
        for(var c = a - this.blockSize, d = this.B, e = this.h, g = 0; g < a;){
            if (0 == e) for(; g <= c;)n(this, f, g), g += this.blockSize;
            if ("string" === typeof f) {
                for(; g < a;)if (d[e++] = f.charCodeAt(g++), e == this.blockSize) {
                    n(this, d);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (d[e++] = f[g++], e == this.blockSize) {
                n(this, d);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.v = function() {
        var f = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
        f[0] = 128;
        for(var a = 1; a < f.length - 8; ++a)f[a] = 0;
        var c = 8 * this.o;
        for(a = f.length - 8; a < f.length; ++a)f[a] = c & 255, c /= 256;
        this.u(f);
        f = Array(16);
        for(a = c = 0; 4 > a; ++a)for(var d = 0; 32 > d; d += 8)f[c++] = this.g[a] >>> d & 255;
        return f;
    };
    function p(f, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, f) ? c[f] : c[f] = a(f);
    }
    function t(f, a) {
        this.h = a;
        for(var c = [], d = !0, e = f.length - 1; 0 <= e; e--){
            var g = f[e] | 0;
            d && g == a || (c[e] = g, d = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(f) {
        return -128 <= f && 128 > f ? p(f, function(a) {
            return new t([
                a | 0
            ], 0 > a ? -1 : 0);
        }) : new t([
            f | 0
        ], 0 > f ? -1 : 0);
    }
    function v(f) {
        if (isNaN(f) || !isFinite(f)) return w;
        if (0 > f) return x(v(-f));
        for(var a = [], c = 1, d = 0; f >= c; d++)a[d] = f / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(f, a) {
        if (0 == f.length) throw Error("number format error: empty string");
        a = a || 10;
        if (2 > a || 36 < a) throw Error("radix out of range: " + a);
        if ("-" == f.charAt(0)) return x(y(f.substring(1), a));
        if (0 <= f.indexOf("-")) throw Error('number format error: interior "-" character');
        for(var c = v(Math.pow(a, 8)), d = w, e = 0; e < f.length; e += 8){
            var g = Math.min(8, f.length - e), b = parseInt(f.substring(e, e + g), a);
            8 > g ? (g = v(Math.pow(a, g)), d = d.j(g).add(v(b))) : (d = d.j(c), d = d.add(v(b)));
        }
        return d;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        for(var f = 0, a = 1, c = 0; c < this.g.length; c++){
            var d = this.i(c);
            f += (0 <= d ? d : 4294967296 + d) * a;
            a *= 4294967296;
        }
        return f;
    };
    h.toString = function(f) {
        f = f || 10;
        if (2 > f || 36 < f) throw Error("radix out of range: " + f);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(f);
        for(var a = v(Math.pow(f, 6)), c = this, d = "";;){
            var e = D(c, a).g;
            c = F(c, e.j(a));
            var g = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(f);
            c = e;
            if (C(c)) return g + d;
            for(; 6 > g.length;)g = "0" + g;
            d = g + d;
        }
    };
    h.i = function(f) {
        return 0 > f ? 0 : f < this.g.length ? this.g[f] : this.h;
    };
    function C(f) {
        if (0 != f.h) return !1;
        for(var a = 0; a < f.g.length; a++)if (0 != f.g[a]) return !1;
        return !0;
    }
    function B(f) {
        return -1 == f.h;
    }
    h.l = function(f) {
        f = F(this, f);
        return B(f) ? -1 : C(f) ? 0 : 1;
    };
    function x(f) {
        for(var a = f.g.length, c = [], d = 0; d < a; d++)c[d] = ~f.g[d];
        return new t(c, ~f.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0, e = 0; e <= a; e++){
            var g = d + (this.i(e) & 65535) + (f.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (f.i(e) >>> 16);
            d = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(f, a) {
        return f.add(x(a));
    }
    h.j = function(f) {
        if (C(this) || C(f)) return w;
        if (B(this)) return B(f) ? x(this).j(x(f)) : x(x(this).j(f));
        if (B(f)) return x(this.j(x(f)));
        if (0 > this.l(A) && 0 > f.l(A)) return v(this.m() * f.m());
        for(var a = this.g.length + f.g.length, c = [], d = 0; d < 2 * a; d++)c[d] = 0;
        for(d = 0; d < this.g.length; d++)for(var e = 0; e < f.g.length; e++){
            var g = this.i(d) >>> 16, b = this.i(d) & 65535, r = f.i(e) >>> 16, E = f.i(e) & 65535;
            c[2 * d + 2 * e] += b * E;
            G(c, 2 * d + 2 * e);
            c[2 * d + 2 * e + 1] += g * E;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 1] += b * r;
            G(c, 2 * d + 2 * e + 1);
            c[2 * d + 2 * e + 2] += g * r;
            G(c, 2 * d + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(f, a) {
        for(; (f[a] & 65535) != f[a];)f[a + 1] += f[a] >>> 16, f[a] &= 65535, a++;
    }
    function H(f, a) {
        this.g = f;
        this.h = a;
    }
    function D(f, a) {
        if (C(a)) throw Error("division by zero");
        if (C(f)) return new H(w, w);
        if (B(f)) return a = D(x(f), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(f, x(a)), new H(x(a.g), a.h);
        if (30 < f.g.length) {
            if (B(f) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, d = a; 0 >= d.l(f);)c = I(c), d = I(d);
            var e = J(c, 1), g = J(d, 1);
            d = J(d, 2);
            for(c = J(c, 2); !C(d);){
                var b = g.add(d);
                0 >= b.l(f) && (e = e.add(c), g = b);
                d = J(d, 1);
                c = J(c, 1);
            }
            a = F(f, e.j(a));
            return new H(e, a);
        }
        for(e = w; 0 <= f.l(a);){
            c = Math.max(1, Math.floor(f.m() / a.m()));
            d = Math.ceil(Math.log(c) / Math.LN2);
            d = 48 >= d ? 1 : Math.pow(2, d - 48);
            g = v(c);
            for(b = g.j(a); B(b) || 0 < b.l(f);)c -= d, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            f = F(f, b);
        }
        return new H(e, f);
    }
    h.A = function(f) {
        return D(this, f).h;
    };
    h.and = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) & f.i(d);
        return new t(c, this.h & f.h);
    };
    h.or = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) | f.i(d);
        return new t(c, this.h | f.h);
    };
    h.xor = function(f) {
        for(var a = Math.max(this.g.length, f.g.length), c = [], d = 0; d < a; d++)c[d] = this.i(d) ^ f.i(d);
        return new t(c, this.h ^ f.h);
    };
    function I(f) {
        for(var a = f.g.length + 1, c = [], d = 0; d < a; d++)c[d] = f.i(d) << 1 | f.i(d - 1) >>> 31;
        return new t(c, f.h);
    }
    function J(f, a) {
        var c = a >> 5;
        a %= 32;
        for(var d = f.g.length - c, e = [], g = 0; g < d; g++)e[g] = 0 < a ? f.i(g + c) >>> a | f.i(g + c + 1) << 32 - a : f.i(g + c);
        return new t(e, f.h);
    }
    m.prototype.digest = m.prototype.v;
    m.prototype.reset = m.prototype.s;
    m.prototype.update = m.prototype.u;
    $19e6a74148afb814$export$9f5a3dfc7a9f5dd = $19e6a74148afb814$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.A;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $19e6a74148afb814$export$70ffa26850098d01 = $19e6a74148afb814$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $19e6a74148afb814$var$commonjsGlobal !== 'undefined' ? $19e6a74148afb814$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


var $26a29ea0054896c3$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $26a29ea0054896c3$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $26a29ea0054896c3$export$26404658cda3ee02;
var $26a29ea0054896c3$export$ddb1030448106742;
var $26a29ea0054896c3$export$aa726fb96ad3e039;
var $26a29ea0054896c3$export$3d7865934588d77e;
var $26a29ea0054896c3$export$d4e71bc0b80dc0fb;
var $26a29ea0054896c3$export$cbbc350c1dfc80cb;
var $26a29ea0054896c3$export$d61e24a684f9e51;
var $26a29ea0054896c3$export$888d0d9ab79d08fc;
var $26a29ea0054896c3$export$66869136fc133c3a;
(function() {
    var h, aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a;
        a[b] = c.value;
        return a;
    };
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $26a29ea0054896c3$var$commonjsGlobal && $26a29ea0054896c3$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    function ea(a, b) {
        a instanceof String && (a += "");
        var c = 0, d = !1, e = {
            next: function() {
                if (!d && c < a.length) {
                    var f = c++;
                    return {
                        value: b(f, a[f]),
                        done: !1
                    };
                }
                d = !0;
                return {
                    done: !0,
                    value: void 0
                };
            }
        };
        e[Symbol.iterator] = function() {
            return e;
        };
        return e;
    }
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return ea(this, function(b, c) {
                return c;
            });
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var fa = fa || {}, k = this || self;
    function ha(a) {
        var b = typeof a;
        b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
        return "array" == b || "object" == b && "number" == typeof a.length;
    }
    function n(a) {
        var b = typeof a;
        return "object" == b && null != a || "function" == b;
    }
    function ia(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ja(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var e = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(e, d);
                return a.apply(b, e);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ia : ja;
        return p.apply(null, arguments);
    }
    function ka(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function r(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.aa = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Qb = function(d, e, f) {
            for(var g = Array(arguments.length - 2), m = 2; m < arguments.length; m++)g[m - 2] = arguments[m];
            return b.prototype[e].apply(d, g);
        };
    }
    function la(a) {
        const b = a.length;
        if (0 < b) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ma(a, b) {
        for(let c = 1; c < arguments.length; c++){
            const d = arguments[c];
            if (ha(d)) {
                const e = a.length || 0, f = d.length || 0;
                a.length = e + f;
                for(let g = 0; g < f; g++)a[e + g] = d[g];
            } else a.push(d);
        }
    }
    class na {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function t(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function u() {
        var a = k.navigator;
        return a && (a = a.userAgent) ? a : "";
    }
    function oa(a) {
        oa[" "](a);
        return a;
    }
    oa[" "] = function() {};
    var pa = -1 != u().indexOf("Gecko") && !(-1 != u().toLowerCase().indexOf("webkit") && -1 == u().indexOf("Edge")) && !(-1 != u().indexOf("Trident") || -1 != u().indexOf("MSIE")) && -1 == u().indexOf("Edge");
    function qa(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function ra(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function sa(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function ua(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < ta.length; f++)c = ta[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function va(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; 0 < b && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function wa(a) {
        k.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function xa() {
        var a = za;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class Aa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = Ba.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var Ba = new na(()=>new Ca, (a)=>a.reset());
    class Ca {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let x, y = !1, za = new Aa, Ea = ()=>{
        const a = k.Promise.resolve(void 0);
        x = ()=>{
            a.then(Da);
        };
    };
    var Da = ()=>{
        for(var a; a = xa();){
            try {
                a.h.call(a.g);
            } catch (c) {
                wa(c);
            }
            var b = Ba;
            b.j(a);
            100 > b.h && (b.h++, a.next = b.g, b.g = a);
        }
        y = !1;
    };
    function z() {
        this.s = this.s;
        this.C = this.C;
    }
    z.prototype.s = !1;
    z.prototype.ma = function() {
        this.s || (this.s = !0, this.N());
    };
    z.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function A(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    A.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var Fa = function() {
        if (!k.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            k.addEventListener("test", c, b);
            k.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function C(a, b) {
        A.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        if (a) {
            var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
            this.target = a.target || a.srcElement;
            this.g = b;
            if (b = a.relatedTarget) {
                if (pa) {
                    a: {
                        try {
                            oa(b.nodeName);
                            var e = !0;
                            break a;
                        } catch (f) {}
                        e = !1;
                    }
                    e || (b = null);
                }
            } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
            this.relatedTarget = b;
            d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
            this.button = a.button;
            this.key = a.key || "";
            this.ctrlKey = a.ctrlKey;
            this.altKey = a.altKey;
            this.shiftKey = a.shiftKey;
            this.metaKey = a.metaKey;
            this.pointerId = a.pointerId || 0;
            this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Ga[a.pointerType] || "";
            this.state = a.state;
            this.i = a;
            a.defaultPrevented && C.aa.h.call(this);
        }
    }
    r(C, A);
    var Ga = {
        2: "touch",
        3: "pen",
        4: "mouse"
    };
    C.prototype.h = function() {
        C.aa.h.call(this);
        var a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var D = "closure_listenable_" + (1E6 * Math.random() | 0);
    var Ha = 0;
    function Ia(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++Ha;
        this.da = this.fa = !1;
    }
    function Ja(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function Ka(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ka.prototype.add = function(a, b, c, d, e) {
        var f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        var g = La(a, b, d, e);
        -1 < g ? (b = a[g], c || (b.fa = !1)) : (b = new Ia(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ma(a, b) {
        var c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
            f && (Ja(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
        }
    }
    function La(a, b, c, d) {
        for(var e = 0; e < a.length; ++e){
            var f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Na = "closure_lm_" + (1E6 * Math.random() | 0), Oa = {};
    function Qa(a, b, c, d, e) {
        if (d && d.once) return Ra(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Qa(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !1, d, e);
    }
    function Ta(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        var g = n(e) ? !!e.capture : !!e, m = Ua(a);
        m || (a[Na] = m = new Ka(a));
        c = m.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Va();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) Fa || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Wa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Va() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Xa;
        return a;
    }
    function Ra(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(var f = 0; f < b.length; f++)Ra(a, b[f], c, d, e);
            return null;
        }
        c = Sa(c);
        return a && a[D] ? a.L(b, c, n(d) ? !!d.capture : !!d, e) : Ta(a, b, c, !0, d, e);
    }
    function Ya(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Ya(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Sa(c), a && a[D]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = La(f, c, d, e), -1 < c && (Ja(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = Ua(a)) && (b = a.g[b.toString()], a = -1, b && (a = La(b, c, d, e)), (c = -1 < a ? b[a] : null) && Za(c));
    }
    function Za(a) {
        if ("number" !== typeof a && a && !a.da) {
            var b = a.src;
            if (b && b[D]) Ma(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Wa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Ua(b)) ? (Ma(c, a), 0 == c.h && (c.src = null, b[Na] = null)) : Ja(a);
            }
        }
    }
    function Wa(a) {
        return a in Oa ? Oa[a] : Oa[a] = "on" + a;
    }
    function Xa(a, b) {
        if (a.da) a = !0;
        else {
            b = new C(b, this);
            var c = a.listener, d = a.ha || a.src;
            a.fa && Za(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Ua(a) {
        a = a[Na];
        return a instanceof Ka ? a : null;
    }
    var $a = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
    function Sa(a) {
        if ("function" === typeof a) return a;
        a[$a] || (a[$a] = function(b) {
            return a.handleEvent(b);
        });
        return a[$a];
    }
    function E() {
        z.call(this);
        this.i = new Ka(this);
        this.M = this;
        this.F = null;
    }
    r(E, z);
    E.prototype[D] = !0;
    E.prototype.removeEventListener = function(a, b, c, d) {
        Ya(this, a, b, c, d);
    };
    function F(a, b) {
        var c, d = a.F;
        if (d) for(c = []; d; d = d.F)c.push(d);
        a = a.M;
        d = b.type || b;
        if ("string" === typeof b) b = new A(b, a);
        else if (b instanceof A) b.target = b.target || a;
        else {
            var e = b;
            b = new A(d, a);
            ua(b, e);
        }
        e = !0;
        if (c) for(var f = c.length - 1; 0 <= f; f--){
            var g = b.g = c[f];
            e = ab(g, d, !0, b) && e;
        }
        g = b.g = a;
        e = ab(g, d, !0, b) && e;
        e = ab(g, d, !1, b) && e;
        if (c) for(f = 0; f < c.length; f++)g = b.g = c[f], e = ab(g, d, !1, b) && e;
    }
    E.prototype.N = function() {
        E.aa.N.call(this);
        if (this.i) {
            var a = this.i, c;
            for(c in a.g){
                for(var d = a.g[c], e = 0; e < d.length; e++)Ja(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.F = null;
    };
    E.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    E.prototype.L = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function ab(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        for(var e = !0, f = 0; f < b.length; ++f){
            var g = b[f];
            if (g && !g.da && g.capture == c) {
                var m = g.listener, q = g.ha || g.src;
                g.fa && Ma(a.i, g);
                e = !1 !== m.call(q, d) && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function bb(a, b, c) {
        if ("function" === typeof a) c && (a = p(a, c));
        else if (a && "function" == typeof a.handleEvent) a = p(a.handleEvent, a);
        else throw Error("Invalid listener argument");
        return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
    }
    function cb(a) {
        a.g = bb(()=>{
            a.g = null;
            a.i && (a.i = !1, cb(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class eb extends z {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : cb(this);
        }
        N() {
            super.N();
            this.g && (k.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function G(a) {
        z.call(this);
        this.h = a;
        this.g = {};
    }
    r(G, z);
    var fb = [];
    function gb(a) {
        qa(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Za(b);
        }, a);
        a.g = {};
    }
    G.prototype.N = function() {
        G.aa.N.call(this);
        gb(this);
    };
    G.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var hb = k.JSON.stringify;
    var ib = k.JSON.parse;
    var jb = class {
        stringify(a) {
            return k.JSON.stringify(a, void 0);
        }
        parse(a) {
            return k.JSON.parse(a, void 0);
        }
    };
    function kb() {}
    kb.prototype.h = null;
    function lb(a) {
        return a.h || (a.h = a.i());
    }
    function mb() {}
    var H = {
        OPEN: "a",
        kb: "b",
        Ja: "c",
        wb: "d"
    };
    function nb() {
        A.call(this, "d");
    }
    r(nb, A);
    function ob() {
        A.call(this, "c");
    }
    r(ob, A);
    var I = {}, pb = null;
    function qb() {
        return pb = pb || new E;
    }
    I.La = "serverreachability";
    function rb(a) {
        A.call(this, I.La, a);
    }
    r(rb, A);
    function J(a) {
        const b = qb();
        F(b, new rb(b));
    }
    I.STAT_EVENT = "statevent";
    function sb(a, b) {
        A.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    r(sb, A);
    function K(a) {
        const b = qb();
        F(b, new sb(b, a));
    }
    I.Ma = "timingevent";
    function tb(a, b) {
        A.call(this, I.Ma, a);
        this.size = b;
    }
    r(tb, A);
    function ub(a, b) {
        if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
        return k.setTimeout(function() {
            a();
        }, b);
    }
    function vb() {
        this.g = !0;
    }
    vb.prototype.xa = function() {
        this.g = !1;
    };
    function wb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    for(var m = f.split("&"), q = 0; q < m.length; q++){
                        var l = m[q].split("=");
                        if (1 < l.length) {
                            var v = l[0];
                            l = l[1];
                            var w = v.split("_");
                            g = 2 <= w.length && "type" == w[1] ? g + (v + "=" + l + "&") : g + (v + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function xb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function L(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + yb(a, c) + (d ? " " + d : "");
        });
    }
    function zb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    vb.prototype.info = function() {};
    function yb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            var c = JSON.parse(b);
            if (c) {
                for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                    var d = c[a];
                    if (!(2 > d.length)) {
                        var e = d[1];
                        if (Array.isArray(e) && !(1 > e.length)) {
                            var f = e[0];
                            if ("noop" != f && "stop" != f && "close" != f) for(var g = 1; g < e.length; g++)e[g] = "";
                        }
                    }
                }
            }
            return hb(c);
        } catch (m) {
            return b;
        }
    }
    var Ab = {
        NO_ERROR: 0,
        gb: 1,
        tb: 2,
        sb: 3,
        nb: 4,
        rb: 5,
        ub: 6,
        Ia: 7,
        TIMEOUT: 8,
        xb: 9
    };
    var Bb = {
        lb: "complete",
        Hb: "success",
        Ja: "error",
        Ia: "abort",
        zb: "ready",
        Ab: "readystatechange",
        TIMEOUT: "timeout",
        vb: "incrementaldata",
        yb: "progress",
        ob: "downloadprogress",
        Pb: "uploadprogress"
    };
    var Cb;
    function Db() {}
    r(Db, kb);
    Db.prototype.g = function() {
        return new XMLHttpRequest;
    };
    Db.prototype.i = function() {
        return {};
    };
    Cb = new Db;
    function M(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.R = d || 1;
        this.U = new G(this);
        this.I = 45E3;
        this.H = null;
        this.o = !1;
        this.m = this.A = this.v = this.L = this.F = this.S = this.B = null;
        this.D = [];
        this.g = null;
        this.C = 0;
        this.s = this.u = null;
        this.X = -1;
        this.J = !1;
        this.O = 0;
        this.M = null;
        this.W = this.K = this.T = this.P = !1;
        this.h = new Eb;
    }
    function Eb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Fb = {}, Gb = {};
    function Hb(a, b, c) {
        a.L = 1;
        a.v = Ib(N(b));
        a.m = c;
        a.P = !0;
        Jb(a, null);
    }
    function Jb(a, b) {
        a.F = Date.now();
        Kb(a);
        a.A = N(a.v);
        var c = a.A, d = a.R;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Lb(c.i, "t", d);
        a.C = 0;
        c = a.j.J;
        a.h = new Eb;
        a.g = Mb(a.j, c ? b : null, !a.m);
        0 < a.O && (a.M = new eb(p(a.Y, a, a.g), a.O));
        b = a.U;
        c = a.g;
        d = a.ca;
        var e = "readystatechange";
        Array.isArray(e) || (e && (fb[0] = e.toString()), e = fb);
        for(var f = 0; f < e.length; f++){
            var g = Qa(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.H ? sa(a.H) : {};
        a.m ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.A, a.u, a.m, b)) : (a.u = "GET", a.g.ea(a.A, a.u, null, b));
        J();
        wb(a.i, a.u, a.A, a.l, a.R, a.m);
    }
    M.prototype.ca = function(a) {
        a = a.target;
        const b = this.M;
        b && 3 == P(a) ? b.j() : this.Y(a);
    };
    M.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const w = P(this.g);
                var b = this.g.Ba();
                const O = this.g.Z();
                if (!(3 > w) && (3 != w || this.g && (this.h.h || this.g.oa() || Nb(this.g)))) {
                    this.J || 4 != w || 7 == b || (8 == b || 0 >= O ? J(3) : J(2));
                    Ob(this);
                    var c = this.g.Z();
                    this.X = c;
                    b: if (Pb(this)) {
                        var d = Nb(this.g);
                        a = "";
                        var e = d.length, f = 4 == P(this.g);
                        if (!this.h.i) {
                            if ("undefined" === typeof TextDecoder) {
                                Q(this);
                                Qb(this);
                                var g = "";
                                break b;
                            }
                            this.h.i = new k.TextDecoder;
                        }
                        for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                            stream: !(f && b == e - 1)
                        });
                        d.length = 0;
                        this.h.g += a;
                        this.C = 0;
                        g = this.h.g;
                    } else g = this.g.oa();
                    this.o = 200 == c;
                    xb(this.i, this.u, this.A, this.l, this.R, w, c);
                    if (this.o) {
                        if (this.T && !this.K) {
                            b: {
                                if (this.g) {
                                    var m, q = this.g;
                                    if ((m = q.g ? q.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !t(m)) {
                                        var l = m;
                                        break b;
                                    }
                                }
                                l = null;
                            }
                            if (c = l) L(this.i, this.l, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Rb(this, c);
                            else {
                                this.o = !1;
                                this.s = 3;
                                K(12);
                                Q(this);
                                Qb(this);
                                break a;
                            }
                        }
                        if (this.P) {
                            c = !0;
                            let B;
                            for(; !this.J && this.C < g.length;)if (B = Sb(this, g), B == Gb) {
                                4 == w && (this.s = 4, K(14), c = !1);
                                L(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (B == Fb) {
                                this.s = 4;
                                K(15);
                                L(this.i, this.l, g, "[Invalid Chunk]");
                                c = !1;
                                break;
                            } else L(this.i, this.l, B, null), Rb(this, B);
                            Pb(this) && 0 != this.C && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            4 != w || 0 != g.length || this.h.h || (this.s = 1, K(16), c = !1);
                            this.o = this.o && c;
                            if (!c) L(this.i, this.l, g, "[Invalid Chunked Response]"), Q(this), Qb(this);
                            else if (0 < g.length && !this.W) {
                                this.W = !0;
                                var v = this.j;
                                v.g == this && v.ba && !v.M && (v.j.info("Great, no buffering proxy detected. Bytes received: " + g.length), Tb(v), v.M = !0, K(11));
                            }
                        } else L(this.i, this.l, g, null), Rb(this, g);
                        4 == w && Q(this);
                        this.o && !this.J && (4 == w ? Ub(this.j, this) : (this.o = !1, Kb(this)));
                    } else Vb(this.g), 400 == c && 0 < g.indexOf("Unknown SID") ? (this.s = 3, K(12)) : (this.s = 0, K(13)), Q(this), Qb(this);
                }
            }
        } catch (w) {} finally{}
    };
    function Pb(a) {
        return a.g ? "GET" == a.u && 2 != a.L && a.j.Ca : !1;
    }
    function Sb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (-1 == d) return Gb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Fb;
        d += 1;
        if (d + c > b.length) return Gb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    M.prototype.cancel = function() {
        this.J = !0;
        Q(this);
    };
    function Kb(a) {
        a.S = Date.now() + a.I;
        Wb(a, a.I);
    }
    function Wb(a, b) {
        if (null != a.B) throw Error("WatchDog timer not null");
        a.B = ub(p(a.ba, a), b);
    }
    function Ob(a) {
        a.B && (k.clearTimeout(a.B), a.B = null);
    }
    M.prototype.ba = function() {
        this.B = null;
        const a = Date.now();
        0 <= a - this.S ? (zb(this.i, this.A), 2 != this.L && (J(), K(17)), Q(this), this.s = 2, Qb(this)) : Wb(this, this.S - a);
    };
    function Qb(a) {
        0 == a.j.G || a.J || Ub(a.j, a);
    }
    function Q(a) {
        Ob(a);
        var b = a.M;
        b && "function" == typeof b.ma && b.ma();
        a.M = null;
        gb(a.U);
        a.g && (b = a.g, a.g = null, b.abort(), b.ma());
    }
    function Rb(a, b) {
        try {
            var c = a.j;
            if (0 != c.G && (c.g == a || Xb(c.h, a))) {
                if (!a.K && Xb(c.h, a) && 3 == c.G) {
                    try {
                        var d = c.Da.g.parse(b);
                    } catch (l) {
                        d = null;
                    }
                    if (Array.isArray(d) && 3 == d.length) {
                        var e = d;
                        if (0 == e[0]) {
                            a: if (!c.u) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Yb(c), Zb(c);
                                    else break a;
                                }
                                $b(c);
                                K(18);
                            }
                        } else c.za = e[1], 0 < c.za - c.T && 37500 > e[2] && c.F && 0 == c.v && !c.C && (c.C = ub(p(c.Za, c), 6E3));
                        if (1 >= ac(c.h) && c.ca) {
                            try {
                                c.ca();
                            } catch (l) {}
                            c.ca = void 0;
                        }
                    } else R(c, 11);
                } else if ((a.K || c.g == a) && Yb(c), !t(b)) for(e = c.Da.g.parse(b), b = 0; b < e.length; b++){
                    let l = e[b];
                    c.T = l[0];
                    l = l[1];
                    if (2 == c.G) {
                        if ("c" == l[0]) {
                            c.K = l[1];
                            c.ia = l[2];
                            const v = l[3];
                            null != v && (c.la = v, c.j.info("VER=" + c.la));
                            const w = l[4];
                            null != w && (c.Aa = w, c.j.info("SVER=" + c.Aa));
                            const O = l[5];
                            null != O && "number" === typeof O && 0 < O && (d = 1.5 * O, c.L = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                            d = c;
                            const B = a.g;
                            if (B) {
                                const ya = B.g ? B.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                if (ya) {
                                    var f = d.h;
                                    f.g || -1 == ya.indexOf("spdy") && -1 == ya.indexOf("quic") && -1 == ya.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && (bc(f, f.h), f.h = null));
                                }
                                if (d.D) {
                                    const db = B.g ? B.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                    db && (d.ya = db, S(d.I, d.D, db));
                                }
                            }
                            c.G = 3;
                            c.l && c.l.ua();
                            c.ba && (c.R = Date.now() - a.F, c.j.info("Handshake RTT: " + c.R + "ms"));
                            d = c;
                            var g = a;
                            d.qa = cc(d, d.J ? d.ia : null, d.W);
                            if (g.K) {
                                dc(d.h, g);
                                var m = g, q = d.L;
                                q && (m.I = q);
                                m.B && (Ob(m), Kb(m));
                                d.g = g;
                            } else ec(d);
                            0 < c.i.length && fc(c);
                        } else "stop" != l[0] && "close" != l[0] || R(c, 7);
                    } else 3 == c.G && ("stop" == l[0] || "close" == l[0] ? "stop" == l[0] ? R(c, 7) : gc(c) : "noop" != l[0] && c.l && c.l.ta(l), c.v = 0);
                }
            }
            J(4);
        } catch (l) {}
    }
    var hc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ic(a) {
        this.l = a || 10;
        k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.chrome && k.chrome.loadTimes && k.chrome.loadTimes() && k.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        1 < this.j && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function jc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function ac(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Xb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function bc(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function dc(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ic.prototype.cancel = function() {
        this.i = kc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && 0 !== this.g.size) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function kc(a) {
        if (null != a.h) return a.i.concat(a.h.D);
        if (null != a.g && 0 !== a.g.size) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.D);
            return b;
        }
        return la(a.i);
    }
    function lc(a) {
        if (a.V && "function" == typeof a.V) return a.V();
        if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
        if ("string" === typeof a) return a.split("");
        if (ha(a)) {
            for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
            return b;
        }
        b = [];
        c = 0;
        for(d in a)b[c++] = a[d];
        return b;
    }
    function mc(a) {
        if (a.na && "function" == typeof a.na) return a.na();
        if (!a.V || "function" != typeof a.V) {
            if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
            if (!("undefined" !== typeof Set && a instanceof Set)) {
                if (ha(a) || "string" === typeof a) {
                    var b = [];
                    a = a.length;
                    for(var c = 0; c < a; c++)b.push(c);
                    return b;
                }
                b = [];
                c = 0;
                for(const d in a)b[c++] = d;
                return b;
            }
        }
    }
    function nc(a, b) {
        if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
        else if (ha(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
        else for(var c = mc(a), d = lc(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
    }
    var oc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function pc(a, b) {
        if (a) {
            a = a.split("&");
            for(var c = 0; c < a.length; c++){
                var d = a[c].indexOf("="), e = null;
                if (0 <= d) {
                    var f = a[c].substring(0, d);
                    e = a[c].substring(d + 1);
                } else f = a[c];
                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.s = null;
        this.m = this.l = "";
        this.h = !1;
        if (a instanceof T) {
            this.h = a.h;
            qc(this, a.j);
            this.o = a.o;
            this.g = a.g;
            rc(this, a.s);
            this.l = a.l;
            var b = a.i;
            var c = new sc;
            c.i = b.i;
            b.g && (c.g = new Map(b.g), c.h = b.h);
            tc(this, c);
            this.m = a.m;
        } else a && (b = String(a).match(oc)) ? (this.h = !1, qc(this, b[1] || "", !0), this.o = uc(b[2] || ""), this.g = uc(b[3] || "", !0), rc(this, b[4]), this.l = uc(b[5] || "", !0), tc(this, b[6] || "", !0), this.m = uc(b[7] || "")) : (this.h = !1, this.i = new sc(null, this.h));
    }
    T.prototype.toString = function() {
        var a = [], b = this.j;
        b && a.push(vc(b, wc, !0), ":");
        var c = this.g;
        if (c || "file" == b) a.push("//"), (b = this.o) && a.push(vc(b, wc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.s, null != c && a.push(":", String(c));
        if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push(vc(c, "/" == c.charAt(0) ? xc : yc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", vc(c, zc));
        return a.join("");
    };
    function N(a) {
        return new T(a);
    }
    function qc(a, b, c) {
        a.j = c ? uc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function rc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
            a.s = b;
        } else a.s = null;
    }
    function tc(a, b, c) {
        b instanceof sc ? (a.i = b, Ac(a.i, a.h)) : (c || (b = vc(b, Bc)), a.i = new sc(b, a.h));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Ib(a) {
        S(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
        return a;
    }
    function uc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function vc(a, b, c) {
        return "string" === typeof a ? (a = encodeURI(a).replace(b, Cc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function Cc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var wc = /[#\/\?@]/g, yc = /[#\?:]/g, xc = /[#\?]/g, Bc = /[#\?@]/g, zc = /#/g;
    function sc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && pc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = sc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        var c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function Dc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function Ec(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    h.na = function() {
        U(this);
        const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
        for(let d = 0; d < b.length; d++){
            const e = a[d];
            for(let f = 0; f < e.length; f++)c.push(b[d]);
        }
        return c;
    };
    h.V = function(a) {
        U(this);
        let b = [];
        if ("string" === typeof a) Ec(this, a) && (b = b.concat(this.g.get(V(this, a))));
        else {
            a = Array.from(this.g.values());
            for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
        }
        return b;
    };
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        Ec(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = this.V(a);
        return 0 < a.length ? String(a[0]) : b;
    };
    function Lb(a, b, c) {
        Dc(a, b);
        0 < c.length && (a.i = null, a.g.set(V(a, b), la(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(var c = 0; c < b.length; c++){
            var d = b[c];
            const f = encodeURIComponent(String(d)), g = this.V(d);
            for(d = 0; d < g.length; d++){
                var e = f;
                "" !== g[d] && (e += "=" + encodeURIComponent(String(g[d])));
                a.push(e);
            }
        }
        return this.i = a.join("&");
    };
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function Ac(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            var e = d.toLowerCase();
            d != e && (Dc(this, d), Lb(this, e, c));
        }, a));
        a.j = b;
    }
    function Fc(a, b) {
        const c = new vb;
        if (k.Image) {
            const d = new Image;
            d.onload = ka(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ka(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ka(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ka(W, c, "TestLoadImage: timeout", !1, b, d);
            k.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Gc(a, b) {
        const c = new vb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Hc() {
        this.g = new jb;
    }
    function Ic(a, b, c) {
        const d = c || "";
        try {
            nc(a, function(e, f) {
                let g = e;
                n(e) && (g = hb(e));
                b.push(d + f + "=" + encodeURIComponent(g));
            });
        } catch (e) {
            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
        }
    }
    function Jc(a) {
        this.l = a.Ub || null;
        this.j = a.eb || !1;
    }
    r(Jc, kb);
    Jc.prototype.g = function() {
        return new Kc(this.l, this.j);
    };
    Jc.prototype.i = function(a) {
        return function() {
            return a;
        };
    }({});
    function Kc(a, b) {
        E.call(this);
        this.D = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.u = new Headers;
        this.h = null;
        this.B = "GET";
        this.A = "";
        this.g = !1;
        this.v = this.j = this.l = null;
    }
    r(Kc, E);
    h = Kc.prototype;
    h.open = function(a, b) {
        if (0 != this.readyState) throw this.abort(), Error("Error reopening a connection");
        this.B = a;
        this.A = b;
        this.readyState = 1;
        Lc(this);
    };
    h.send = function(a) {
        if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
        this.g = !0;
        const b = {
            headers: this.u,
            method: this.B,
            credentials: this.m,
            cache: void 0
        };
        a && (b.body = a);
        (this.D || k).fetch(new Request(this.A, b)).then(this.Sa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.u = new Headers;
        this.status = 0;
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, Mc(this));
        this.readyState = 0;
    };
    h.Sa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Lc(this)), this.g && (this.readyState = 3, Lc(this), this.g))) {
            if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
            else if ("undefined" !== typeof k.ReadableStream && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.v = new TextDecoder;
                Nc(this);
            } else a.text().then(this.Ra.bind(this), this.ga.bind(this));
        }
    };
    function Nc(a) {
        a.j.read().then(a.Pa.bind(a)).catch(a.ga.bind(a));
    }
    h.Pa = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.v.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Mc(this) : Lc(this);
            3 == this.readyState && Nc(this);
        }
    };
    h.Ra = function(a) {
        this.g && (this.response = this.responseText = a, Mc(this));
    };
    h.Qa = function(a) {
        this.g && (this.response = a, Mc(this));
    };
    h.ga = function() {
        this.g && Mc(this);
    };
    function Mc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.v = null;
        Lc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.u.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Lc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Kc.prototype, "withCredentials", {
        get: function() {
            return "include" === this.m;
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Oc(a) {
        let b = "";
        qa(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Pc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Oc(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : S(a, b, c));
    }
    function X(a) {
        E.call(this);
        this.headers = new Map;
        this.o = a || null;
        this.h = !1;
        this.v = this.g = null;
        this.D = "";
        this.m = 0;
        this.l = "";
        this.j = this.B = this.u = this.A = !1;
        this.I = null;
        this.H = "";
        this.J = !1;
    }
    r(X, E);
    var Qc = /^https?$/i, Rc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Ha = function(a) {
        this.J = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.m = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.o ? this.o.g() : Cb.g();
        this.v = this.o ? lb(this.o) : lb(Cb);
        this.g.onreadystatechange = p(this.Ea, this);
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Sc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = k.FormData && a instanceof k.FormData;
        !(0 <= Array.prototype.indexOf.call(Rc, b, void 0)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.H && (this.g.responseType = this.H);
        "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
        try {
            Tc(this), this.u = !0, this.g.send(a), this.u = !1;
        } catch (f) {
            Sc(this, f);
        }
    };
    function Sc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.m = 5;
        Uc(a);
        Vc(a);
    }
    function Uc(a) {
        a.A || (a.A = !0, F(a, "complete"), F(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = a || 7, F(this, "complete"), F(this, "abort"), Vc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Vc(this, !0));
        X.aa.N.call(this);
    };
    h.Ea = function() {
        this.s || (this.B || this.u || this.j ? Wc(this) : this.bb());
    };
    h.bb = function() {
        Wc(this);
    };
    function Wc(a) {
        if (a.h && "undefined" != typeof fa && (!a.v[1] || 4 != P(a) || 2 != a.Z())) {
            if (a.u && 4 == P(a)) bb(a.Ea, 0, a);
            else if (F(a, "readystatechange"), 4 == P(a)) {
                a.h = !1;
                try {
                    const g = a.Z();
                    a: switch(g){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = 0 === g) {
                            var e = String(a.D).match(oc)[1] || null;
                            !e && k.self && k.self.location && (e = k.self.location.protocol.slice(0, -1));
                            d = !Qc.test(e ? e.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) F(a, "complete"), F(a, "success");
                    else {
                        a.m = 6;
                        try {
                            var f = 2 < P(a) ? a.g.statusText : "";
                        } catch (m) {
                            f = "";
                        }
                        a.l = f + " [" + a.Z() + "]";
                        Uc(a);
                    }
                } finally{
                    Vc(a);
                }
            }
        }
    }
    function Vc(a, b) {
        if (a.g) {
            Tc(a);
            const c = a.g, d = a.v[0] ? ()=>{} : null;
            a.g = null;
            a.v = null;
            b || F(a, "ready");
            try {
                c.onreadystatechange = d;
            } catch (e) {}
        }
    }
    function Tc(a) {
        a.I && (k.clearTimeout(a.I), a.I = null);
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.Z = function() {
        try {
            return 2 < P(this) ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.oa = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.Oa = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
            return ib(b);
        }
    };
    function Nb(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.H){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Vb(a) {
        const b = {};
        a = (a.g && 2 <= P(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (t(a[d])) continue;
            var c = va(a[d]);
            const e = c[0];
            c = c[1];
            if ("string" !== typeof c) continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        ra(b, function(d) {
            return d.join(", ");
        });
    }
    h.Ba = function() {
        return this.m;
    };
    h.Ka = function() {
        return "string" === typeof this.l ? this.l : String(this.l);
    };
    function Xc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Yc(a) {
        this.Aa = 0;
        this.i = [];
        this.j = new vb;
        this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null;
        this.Ya = this.U = 0;
        this.Va = Xc("failFast", !1, a);
        this.F = this.C = this.u = this.s = this.l = null;
        this.X = !0;
        this.za = this.T = -1;
        this.Y = this.v = this.B = 0;
        this.Ta = Xc("baseRetryDelayMs", 5E3, a);
        this.cb = Xc("retryDelaySeedMs", 1E4, a);
        this.Wa = Xc("forwardChannelMaxRetries", 2, a);
        this.wa = Xc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.pa = a && a.xmlHttpFactory || void 0;
        this.Xa = a && a.Tb || void 0;
        this.Ca = a && a.useFetchStreams || !1;
        this.L = void 0;
        this.J = a && a.supportsCrossDomainXhr || !1;
        this.K = "";
        this.h = new ic(a && a.concurrentRequestLimit);
        this.Da = new Hc;
        this.P = a && a.fastHandshake || !1;
        this.O = a && a.encodeInitMessageHeaders || !1;
        this.P && this.O && (this.O = !1);
        this.Ua = a && a.Rb || !1;
        a && a.xa && this.j.xa();
        a && a.forceLongPolling && (this.X = !1);
        this.ba = !this.P && this.X && a && a.detectBufferingProxy || !1;
        this.ja = void 0;
        a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.ja = a.longPollingTimeout);
        this.ca = void 0;
        this.R = 0;
        this.M = !1;
        this.ka = this.A = null;
    }
    h = Yc.prototype;
    h.la = 8;
    h.G = 1;
    h.connect = function(a, b, c, d) {
        K(0);
        this.W = a;
        this.H = b || {};
        c && void 0 !== d && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.I = cc(this, null, this.W);
        fc(this);
    };
    function gc(a) {
        Zc(a);
        if (3 == a.G) {
            var b = a.U++, c = N(a.I);
            S(c, "SID", a.K);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            $c(a, c);
            b = new M(a, a.j, b);
            b.L = 2;
            b.v = Ib(N(c));
            c = !1;
            if (k.navigator && k.navigator.sendBeacon) try {
                c = k.navigator.sendBeacon(b.v.toString(), "");
            } catch (d) {}
            !c && k.Image && ((new Image).src = b.v, c = !0);
            c || (b.g = Mb(b.j, null), b.g.ea(b.v));
            b.F = Date.now();
            Kb(b);
        }
        ad(a);
    }
    function Zb(a) {
        a.g && (Tb(a), a.g.cancel(), a.g = null);
    }
    function Zc(a) {
        Zb(a);
        a.u && (k.clearTimeout(a.u), a.u = null);
        Yb(a);
        a.h.cancel();
        a.s && ("number" === typeof a.s && k.clearTimeout(a.s), a.s = null);
    }
    function fc(a) {
        if (!jc(a.h) && !a.s) {
            a.s = !0;
            var b = a.Ga;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.B = 0;
        }
    }
    function bd(a, b) {
        if (ac(a.h) >= a.h.j - (a.s ? 1 : 0)) return !1;
        if (a.s) return a.i = b.D.concat(a.i), !0;
        if (1 == a.G || 2 == a.G || a.B >= (a.Va ? 0 : a.Wa)) return !1;
        a.s = ub(p(a.Ga, a, b), cd(a, a.B));
        a.B++;
        return !0;
    }
    h.Ga = function(a) {
        if (this.s) {
            if (this.s = null, 1 == this.G) {
                if (!a) {
                    this.U = Math.floor(1E5 * Math.random());
                    a = this.U++;
                    const e = new M(this, this.j, a);
                    let f = this.o;
                    this.S && (f ? (f = sa(f), ua(f, this.S)) : f = this.S);
                    null !== this.m || this.O || (e.H = f, f = null);
                    if (this.P) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (void 0 === d) break;
                            b += d;
                            if (4096 < b) {
                                b = c;
                                break a;
                            }
                            if (4096 === b || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = dd(this, e, b);
                    c = N(this.I);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.D && S(c, "X-HTTP-Session-Id", this.D);
                    $c(this, c);
                    f && (this.O ? b = "headers=" + encodeURIComponent(String(Oc(f))) + "&" + b : this.m && Pc(c, this.m, f));
                    bc(this.h, e);
                    this.Ua && S(c, "TYPE", "init");
                    this.P ? (S(c, "$req", b), S(c, "SID", "null"), e.T = !0, Hb(e, c, null)) : Hb(e, c, b);
                    this.G = 2;
                }
            } else 3 == this.G && (a ? ed(this, a) : 0 == this.i.length || jc(this.h) || ed(this));
        }
    };
    function ed(a, b) {
        var c;
        b ? c = b.l : c = a.U++;
        const d = N(a.I);
        S(d, "SID", a.K);
        S(d, "RID", c);
        S(d, "AID", a.T);
        $c(a, d);
        a.m && a.o && Pc(d, a.m, a.o);
        c = new M(a, a.j, c, a.B + 1);
        null === a.m && (c.H = a.o);
        b && (a.i = b.D.concat(a.i));
        b = dd(a, c, 1E3);
        c.I = Math.round(.5 * a.wa) + Math.round(.5 * a.wa * Math.random());
        bc(a.h, c);
        Hb(c, d, b);
    }
    function $c(a, b) {
        a.H && qa(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && nc({}, function(c, d) {
            S(b, d, c);
        });
    }
    function dd(a, b, c) {
        c = Math.min(a.i.length, c);
        var d = a.l ? p(a.l.Na, a.l, a) : null;
        a: {
            var e = a.i;
            let f = -1;
            for(;;){
                const g = [
                    "count=" + c
                ];
                -1 == f ? 0 < c ? (f = e[0].g, g.push("ofs=" + f)) : f = 0 : g.push("ofs=" + f);
                let m = !0;
                for(let q = 0; q < c; q++){
                    let l = e[q].g;
                    const v = e[q].map;
                    l -= f;
                    if (0 > l) f = Math.max(0, e[q].g - 100), m = !1;
                    else try {
                        Ic(v, g, "req" + l + "_");
                    } catch (w) {
                        d && d(v);
                    }
                }
                if (m) {
                    d = g.join("&");
                    break a;
                }
            }
        }
        a = a.i.splice(0, c);
        b.D = a;
        return d;
    }
    function ec(a) {
        if (!a.g && !a.u) {
            a.Y = 1;
            var b = a.Fa;
            x || Ea();
            y || (x(), y = !0);
            za.add(b, a);
            a.v = 0;
        }
    }
    function $b(a) {
        if (a.g || a.u || 3 <= a.v) return !1;
        a.Y++;
        a.u = ub(p(a.Fa, a), cd(a, a.v));
        a.v++;
        return !0;
    }
    h.Fa = function() {
        this.u = null;
        fd(this);
        if (this.ba && !(this.M || null == this.g || 0 >= this.R)) {
            var a = 2 * this.R;
            this.j.info("BP detection timer enabled: " + a);
            this.A = ub(p(this.ab, this), a);
        }
    };
    h.ab = function() {
        this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, K(10), Zb(this), fd(this));
    };
    function Tb(a) {
        null != a.A && (k.clearTimeout(a.A), a.A = null);
    }
    function fd(a) {
        a.g = new M(a, a.j, "rpc", a.Y);
        null === a.m && (a.g.H = a.o);
        a.g.O = 0;
        var b = N(a.qa);
        S(b, "RID", "rpc");
        S(b, "SID", a.K);
        S(b, "AID", a.T);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ja && S(b, "TO", a.ja);
        S(b, "TYPE", "xmlhttp");
        $c(a, b);
        a.m && a.o && Pc(b, a.m, a.o);
        a.L && (a.g.I = a.L);
        var c = a.g;
        a = a.ia;
        c.L = 1;
        c.v = Ib(N(b));
        c.m = null;
        c.P = !0;
        Jb(c, a);
    }
    h.Za = function() {
        null != this.C && (this.C = null, Zb(this), $b(this), K(19));
    };
    function Yb(a) {
        null != a.C && (k.clearTimeout(a.C), a.C = null);
    }
    function Ub(a, b) {
        var c = null;
        if (a.g == b) {
            Yb(a);
            Tb(a);
            a.g = null;
            var d = 2;
        } else if (Xb(a.h, b)) c = b.D, dc(a.h, b), d = 1;
        else return;
        if (0 != a.G) {
            if (b.o) {
                if (1 == d) {
                    c = b.m ? b.m.length : 0;
                    b = Date.now() - b.F;
                    var e = a.B;
                    d = qb();
                    F(d, new tb(d, c));
                    fc(a);
                } else ec(a);
            } else if (e = b.s, 3 == e || 0 == e && 0 < b.X || !(1 == d && bd(a, b) || 2 == d && $b(a))) switch(c && 0 < c.length && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function cd(a, b) {
        let c = a.Ta + Math.floor(Math.random() * a.cb);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (2 == b) {
            var c = p(a.fb, a), d = a.Xa;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            k.location && "http" == k.location.protocol || qc(d, "https");
            Ib(d);
            e ? Fc(d.toString(), c) : Gc(d.toString(), c);
        } else K(2);
        a.G = 0;
        a.l && a.l.sa(b);
        ad(a);
        Zc(a);
    }
    h.fb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), K(2)) : (this.j.info("Failed to ping google.com"), K(1));
    };
    function ad(a) {
        a.G = 0;
        a.ka = [];
        if (a.l) {
            const b = kc(a.h);
            if (0 != b.length || 0 != a.i.length) ma(a.ka, b), ma(a.ka, a.i), a.h.i.length = 0, la(a.i), a.i.length = 0;
            a.l.ra();
        }
    }
    function cc(a, b, c) {
        var d = c instanceof T ? N(c) : new T(c);
        if ("" != d.g) b && (d.g = b + "." + d.g), rc(d, d.s);
        else {
            var e = k.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            var f = new T(null);
            d && qc(f, d);
            b && (f.g = b);
            e && rc(f, e);
            c && (f.l = c);
            d = f;
        }
        c = a.D;
        b = a.ya;
        c && b && S(d, c, b);
        S(d, "VER", a.la);
        $c(a, d);
        return d;
    }
    function Mb(a, b, c) {
        if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Ca && !a.pa ? new X(new Jc({
            eb: c
        })) : new X(a.pa);
        b.Ha(a.J);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function gd() {}
    h = gd.prototype;
    h.ua = function() {};
    h.ta = function() {};
    h.sa = function() {};
    h.ra = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Na = function() {};
    function hd() {}
    hd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        E.call(this);
        this.g = new Yc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.va && (a ? a["X-WebChannel-Client-Profile"] = b.va : a = {
            "X-WebChannel-Client-Profile": b.va
        });
        this.g.S = a;
        (a = b && b.Sb) && !t(a) && (this.g.m = a);
        this.v = b && b.supportsCrossDomainXhr || !1;
        this.u = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !t(b) && (this.g.D = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    r(Y, E);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.v && (this.g.J = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        gc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if ("string" === typeof a) {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.u && (c = {}, c.__data__ = hb(a), a = c);
        b.i.push(new hc(b.Ya++, a));
        3 == b.G && fc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        gc(this.g);
        delete this.g;
        Y.aa.N.call(this);
    };
    function id(a) {
        nb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    r(id, nb);
    function jd() {
        ob.call(this);
        this.status = 1;
    }
    r(jd, ob);
    function Z(a) {
        this.g = a;
    }
    r(Z, gd);
    Z.prototype.ua = function() {
        F(this.g, "a");
    };
    Z.prototype.ta = function(a) {
        F(this.g, new id(a));
    };
    Z.prototype.sa = function(a) {
        F(this.g, new jd());
    };
    Z.prototype.ra = function() {
        F(this.g, "b");
    };
    hd.prototype.createWebChannel = hd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $26a29ea0054896c3$export$66869136fc133c3a = $26a29ea0054896c3$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new hd;
    };
    $26a29ea0054896c3$export$888d0d9ab79d08fc = $26a29ea0054896c3$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return qb();
    };
    $26a29ea0054896c3$export$d61e24a684f9e51 = $26a29ea0054896c3$export$2e2bcd8739ae039.Event = I;
    $26a29ea0054896c3$export$cbbc350c1dfc80cb = $26a29ea0054896c3$export$2e2bcd8739ae039.Stat = {
        mb: 0,
        pb: 1,
        qb: 2,
        Jb: 3,
        Ob: 4,
        Lb: 5,
        Mb: 6,
        Kb: 7,
        Ib: 8,
        Nb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Gb: 12,
        Cb: 13,
        Db: 14,
        Bb: 15,
        Eb: 16,
        Fb: 17,
        ib: 18,
        hb: 19,
        jb: 20
    };
    Ab.NO_ERROR = 0;
    Ab.TIMEOUT = 8;
    Ab.HTTP_ERROR = 6;
    $26a29ea0054896c3$export$d4e71bc0b80dc0fb = $26a29ea0054896c3$export$2e2bcd8739ae039.ErrorCode = Ab;
    Bb.COMPLETE = "complete";
    $26a29ea0054896c3$export$3d7865934588d77e = $26a29ea0054896c3$export$2e2bcd8739ae039.EventType = Bb;
    mb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    E.prototype.listen = E.prototype.K;
    $26a29ea0054896c3$export$aa726fb96ad3e039 = $26a29ea0054896c3$export$2e2bcd8739ae039.WebChannel = mb;
    $26a29ea0054896c3$export$ddb1030448106742 = $26a29ea0054896c3$export$2e2bcd8739ae039.FetchXmlHttpFactory = Jc;
    X.prototype.listenOnce = X.prototype.L;
    X.prototype.getLastError = X.prototype.Ka;
    X.prototype.getLastErrorCode = X.prototype.Ba;
    X.prototype.getStatus = X.prototype.Z;
    X.prototype.getResponseJson = X.prototype.Oa;
    X.prototype.getResponseText = X.prototype.oa;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Ha;
    $26a29ea0054896c3$export$26404658cda3ee02 = $26a29ea0054896c3$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $26a29ea0054896c3$var$commonjsGlobal !== 'undefined' ? $26a29ea0054896c3$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $136d40cdb268fe10$export$a143d493d941bafc;
var $136d40cdb268fe10$export$e4cf37d7f6fb9e0a;
var $136d40cdb268fe10$export$f99ded8fe4b79145;
var $136d40cdb268fe10$export$599f31c3813fae4d;
'use strict';
var $e0eed84d5498f6e4$export$a48f0734ac7c2329;
var $e0eed84d5498f6e4$export$d622b2ad8d90c771;
var $e0eed84d5498f6e4$export$6100ba28696e12de;
'use strict';
$e0eed84d5498f6e4$export$a48f0734ac7c2329 = $e0eed84d5498f6e4$var$byteLength;
$e0eed84d5498f6e4$export$d622b2ad8d90c771 = $e0eed84d5498f6e4$var$toByteArray;
$e0eed84d5498f6e4$export$6100ba28696e12de = $e0eed84d5498f6e4$var$fromByteArray;
var $e0eed84d5498f6e4$var$lookup = [];
var $e0eed84d5498f6e4$var$revLookup = [];
var $e0eed84d5498f6e4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $e0eed84d5498f6e4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $e0eed84d5498f6e4$var$i = 0, $e0eed84d5498f6e4$var$len = $e0eed84d5498f6e4$var$code.length; $e0eed84d5498f6e4$var$i < $e0eed84d5498f6e4$var$len; ++$e0eed84d5498f6e4$var$i){
    $e0eed84d5498f6e4$var$lookup[$e0eed84d5498f6e4$var$i] = $e0eed84d5498f6e4$var$code[$e0eed84d5498f6e4$var$i];
    $e0eed84d5498f6e4$var$revLookup[$e0eed84d5498f6e4$var$code.charCodeAt($e0eed84d5498f6e4$var$i)] = $e0eed84d5498f6e4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e0eed84d5498f6e4$var$revLookup['-'.charCodeAt(0)] = 62;
$e0eed84d5498f6e4$var$revLookup['_'.charCodeAt(0)] = 63;
function $e0eed84d5498f6e4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e0eed84d5498f6e4$var$byteLength(b64) {
    var lens = $e0eed84d5498f6e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e0eed84d5498f6e4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e0eed84d5498f6e4$var$toByteArray(b64) {
    var tmp;
    var lens = $e0eed84d5498f6e4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e0eed84d5498f6e4$var$Arr($e0eed84d5498f6e4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 18 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 2 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i)] << 10 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e0eed84d5498f6e4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e0eed84d5498f6e4$var$tripletToBase64(num) {
    return $e0eed84d5498f6e4$var$lookup[num >> 18 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num >> 12 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num >> 6 & 0x3F] + $e0eed84d5498f6e4$var$lookup[num & 0x3F];
}
function $e0eed84d5498f6e4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e0eed84d5498f6e4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $e0eed84d5498f6e4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e0eed84d5498f6e4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e0eed84d5498f6e4$var$lookup[tmp >> 2] + $e0eed84d5498f6e4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e0eed84d5498f6e4$var$lookup[tmp >> 10] + $e0eed84d5498f6e4$var$lookup[tmp >> 4 & 0x3F] + $e0eed84d5498f6e4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $8ad9a3380a876530$export$aafa59e2e03f2942;
var $8ad9a3380a876530$export$68d8715fc104d294;
$8ad9a3380a876530$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$8ad9a3380a876530$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $136d40cdb268fe10$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$136d40cdb268fe10$export$a143d493d941bafc = $136d40cdb268fe10$var$Buffer;
$136d40cdb268fe10$export$e4cf37d7f6fb9e0a = $136d40cdb268fe10$var$SlowBuffer;
$136d40cdb268fe10$export$f99ded8fe4b79145 = 50;
const $136d40cdb268fe10$var$K_MAX_LENGTH = 0x7fffffff;
$136d40cdb268fe10$export$599f31c3813fae4d = $136d40cdb268fe10$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $136d40cdb268fe10$var$Buffer.TYPED_ARRAY_SUPPORT = $136d40cdb268fe10$var$typedArraySupport();
if (!$136d40cdb268fe10$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $136d40cdb268fe10$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($136d40cdb268fe10$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$136d40cdb268fe10$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($136d40cdb268fe10$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$136d40cdb268fe10$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $136d40cdb268fe10$var$createBuffer(length) {
    if (length > $136d40cdb268fe10$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $136d40cdb268fe10$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $136d40cdb268fe10$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $136d40cdb268fe10$var$allocUnsafe(arg);
    }
    return $136d40cdb268fe10$var$from(arg, encodingOrOffset, length);
}
$136d40cdb268fe10$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $136d40cdb268fe10$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $136d40cdb268fe10$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $136d40cdb268fe10$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($136d40cdb268fe10$var$isInstance(value, ArrayBuffer) || value && $136d40cdb268fe10$var$isInstance(value.buffer, ArrayBuffer)) return $136d40cdb268fe10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($136d40cdb268fe10$var$isInstance(value, SharedArrayBuffer) || value && $136d40cdb268fe10$var$isInstance(value.buffer, SharedArrayBuffer))) return $136d40cdb268fe10$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $136d40cdb268fe10$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $136d40cdb268fe10$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $136d40cdb268fe10$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $136d40cdb268fe10$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $136d40cdb268fe10$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($136d40cdb268fe10$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($136d40cdb268fe10$var$Buffer, Uint8Array);
function $136d40cdb268fe10$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $136d40cdb268fe10$var$alloc(size, fill, encoding) {
    $136d40cdb268fe10$var$assertSize(size);
    if (size <= 0) return $136d40cdb268fe10$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $136d40cdb268fe10$var$createBuffer(size).fill(fill, encoding) : $136d40cdb268fe10$var$createBuffer(size).fill(fill);
    return $136d40cdb268fe10$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $136d40cdb268fe10$var$Buffer.alloc = function(size, fill, encoding) {
    return $136d40cdb268fe10$var$alloc(size, fill, encoding);
};
function $136d40cdb268fe10$var$allocUnsafe(size) {
    $136d40cdb268fe10$var$assertSize(size);
    return $136d40cdb268fe10$var$createBuffer(size < 0 ? 0 : $136d40cdb268fe10$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $136d40cdb268fe10$var$Buffer.allocUnsafe = function(size) {
    return $136d40cdb268fe10$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $136d40cdb268fe10$var$Buffer.allocUnsafeSlow = function(size) {
    return $136d40cdb268fe10$var$allocUnsafe(size);
};
function $136d40cdb268fe10$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$136d40cdb268fe10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $136d40cdb268fe10$var$byteLength(string, encoding) | 0;
    let buf = $136d40cdb268fe10$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $136d40cdb268fe10$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $136d40cdb268fe10$var$checked(array.length) | 0;
    const buf = $136d40cdb268fe10$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $136d40cdb268fe10$var$fromArrayView(arrayView) {
    if ($136d40cdb268fe10$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $136d40cdb268fe10$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $136d40cdb268fe10$var$fromArrayLike(arrayView);
}
function $136d40cdb268fe10$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $136d40cdb268fe10$var$Buffer.prototype);
    return buf;
}
function $136d40cdb268fe10$var$fromObject(obj) {
    if ($136d40cdb268fe10$var$Buffer.isBuffer(obj)) {
        const len = $136d40cdb268fe10$var$checked(obj.length) | 0;
        const buf = $136d40cdb268fe10$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $136d40cdb268fe10$var$numberIsNaN(obj.length)) return $136d40cdb268fe10$var$createBuffer(0);
        return $136d40cdb268fe10$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $136d40cdb268fe10$var$fromArrayLike(obj.data);
}
function $136d40cdb268fe10$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $136d40cdb268fe10$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $136d40cdb268fe10$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $136d40cdb268fe10$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $136d40cdb268fe10$var$Buffer.alloc(+length);
}
$136d40cdb268fe10$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $136d40cdb268fe10$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$136d40cdb268fe10$var$Buffer.compare = function compare(a, b) {
    if ($136d40cdb268fe10$var$isInstance(a, Uint8Array)) a = $136d40cdb268fe10$var$Buffer.from(a, a.offset, a.byteLength);
    if ($136d40cdb268fe10$var$isInstance(b, Uint8Array)) b = $136d40cdb268fe10$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(a) || !$136d40cdb268fe10$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$136d40cdb268fe10$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$136d40cdb268fe10$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $136d40cdb268fe10$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $136d40cdb268fe10$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($136d40cdb268fe10$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) buf = $136d40cdb268fe10$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $136d40cdb268fe10$var$byteLength(string, encoding) {
    if ($136d40cdb268fe10$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $136d40cdb268fe10$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $136d40cdb268fe10$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $136d40cdb268fe10$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$136d40cdb268fe10$var$Buffer.byteLength = $136d40cdb268fe10$var$byteLength;
function $136d40cdb268fe10$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $136d40cdb268fe10$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8Slice(this, start, end);
        case 'ascii':
            return $136d40cdb268fe10$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $136d40cdb268fe10$var$latin1Slice(this, start, end);
        case 'base64':
            return $136d40cdb268fe10$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $136d40cdb268fe10$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$136d40cdb268fe10$var$Buffer.prototype._isBuffer = true;
function $136d40cdb268fe10$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$136d40cdb268fe10$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$136d40cdb268fe10$var$swap(this, i, i + 1);
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $136d40cdb268fe10$var$swap(this, i, i + 3);
        $136d40cdb268fe10$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $136d40cdb268fe10$var$swap(this, i, i + 7);
        $136d40cdb268fe10$var$swap(this, i + 1, i + 6);
        $136d40cdb268fe10$var$swap(this, i + 2, i + 5);
        $136d40cdb268fe10$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$136d40cdb268fe10$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $136d40cdb268fe10$var$utf8Slice(this, 0, length);
    return $136d40cdb268fe10$var$slowToString.apply(this, arguments);
};
$136d40cdb268fe10$var$Buffer.prototype.toLocaleString = $136d40cdb268fe10$var$Buffer.prototype.toString;
$136d40cdb268fe10$var$Buffer.prototype.equals = function equals(b) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $136d40cdb268fe10$var$Buffer.compare(this, b) === 0;
};
$136d40cdb268fe10$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $136d40cdb268fe10$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($136d40cdb268fe10$var$customInspectSymbol) $136d40cdb268fe10$var$Buffer.prototype[$136d40cdb268fe10$var$customInspectSymbol] = $136d40cdb268fe10$var$Buffer.prototype.inspect;
$136d40cdb268fe10$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($136d40cdb268fe10$var$isInstance(target, Uint8Array)) target = $136d40cdb268fe10$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $136d40cdb268fe10$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($136d40cdb268fe10$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $136d40cdb268fe10$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($136d40cdb268fe10$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $136d40cdb268fe10$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $136d40cdb268fe10$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $136d40cdb268fe10$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$136d40cdb268fe10$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$136d40cdb268fe10$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $136d40cdb268fe10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$136d40cdb268fe10$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $136d40cdb268fe10$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $136d40cdb268fe10$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($136d40cdb268fe10$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $136d40cdb268fe10$var$utf8Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $136d40cdb268fe10$var$asciiWrite(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$asciiToBytes(string), buf, offset, length);
}
function $136d40cdb268fe10$var$base64Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$base64ToBytes(string), buf, offset, length);
}
function $136d40cdb268fe10$var$ucs2Write(buf, string, offset, length) {
    return $136d40cdb268fe10$var$blitBuffer($136d40cdb268fe10$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$136d40cdb268fe10$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $136d40cdb268fe10$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $136d40cdb268fe10$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $136d40cdb268fe10$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $136d40cdb268fe10$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $136d40cdb268fe10$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$136d40cdb268fe10$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $136d40cdb268fe10$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e0eed84d5498f6e4$export$6100ba28696e12de(buf);
    else return $e0eed84d5498f6e4$export$6100ba28696e12de(buf.slice(start, end));
}
function $136d40cdb268fe10$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $136d40cdb268fe10$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $136d40cdb268fe10$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $136d40cdb268fe10$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $136d40cdb268fe10$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $136d40cdb268fe10$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $136d40cdb268fe10$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $136d40cdb268fe10$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $136d40cdb268fe10$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$136d40cdb268fe10$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $136d40cdb268fe10$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $136d40cdb268fe10$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$136d40cdb268fe10$var$Buffer.prototype.readUintLE = $136d40cdb268fe10$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readUintBE = $136d40cdb268fe10$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint8 = $136d40cdb268fe10$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$136d40cdb268fe10$var$Buffer.prototype.readUint16LE = $136d40cdb268fe10$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint16BE = $136d40cdb268fe10$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$136d40cdb268fe10$var$Buffer.prototype.readUint32LE = $136d40cdb268fe10$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$136d40cdb268fe10$var$Buffer.prototype.readUint32BE = $136d40cdb268fe10$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$136d40cdb268fe10$var$Buffer.prototype.readBigUInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$136d40cdb268fe10$var$Buffer.prototype.readBigUInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$136d40cdb268fe10$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$136d40cdb268fe10$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$136d40cdb268fe10$var$Buffer.prototype.readBigInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$136d40cdb268fe10$var$Buffer.prototype.readBigInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $136d40cdb268fe10$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$136d40cdb268fe10$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$136d40cdb268fe10$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 4, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$136d40cdb268fe10$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 8, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$136d40cdb268fe10$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkOffset(offset, 8, this.length);
    return $8ad9a3380a876530$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $136d40cdb268fe10$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$136d40cdb268fe10$var$Buffer.prototype.writeUintLE = $136d40cdb268fe10$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUintBE = $136d40cdb268fe10$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint8 = $136d40cdb268fe10$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint16LE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint16BE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint32LE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeUint32BE = $136d40cdb268fe10$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $136d40cdb268fe10$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $136d40cdb268fe10$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$136d40cdb268fe10$var$Buffer.prototype.writeBigUInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeBigUInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $136d40cdb268fe10$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$136d40cdb268fe10$var$Buffer.prototype.writeBigInt64LE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$136d40cdb268fe10$var$Buffer.prototype.writeBigInt64BE = $136d40cdb268fe10$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $136d40cdb268fe10$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $136d40cdb268fe10$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $8ad9a3380a876530$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$136d40cdb268fe10$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeFloat(this, value, offset, true, noAssert);
};
$136d40cdb268fe10$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeFloat(this, value, offset, false, noAssert);
};
function $136d40cdb268fe10$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $136d40cdb268fe10$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $8ad9a3380a876530$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$136d40cdb268fe10$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeDouble(this, value, offset, true, noAssert);
};
$136d40cdb268fe10$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $136d40cdb268fe10$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$136d40cdb268fe10$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$136d40cdb268fe10$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$136d40cdb268fe10$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$136d40cdb268fe10$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $136d40cdb268fe10$var$Buffer.isBuffer(val) ? val : $136d40cdb268fe10$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $136d40cdb268fe10$var$errors = {};
function $136d40cdb268fe10$var$E(sym, getMessage, Base) {
    $136d40cdb268fe10$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$136d40cdb268fe10$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$136d40cdb268fe10$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$136d40cdb268fe10$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $136d40cdb268fe10$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $136d40cdb268fe10$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $136d40cdb268fe10$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $136d40cdb268fe10$var$checkBounds(buf, offset, byteLength) {
    $136d40cdb268fe10$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $136d40cdb268fe10$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $136d40cdb268fe10$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $136d40cdb268fe10$var$checkBounds(buf, offset, byteLength);
}
function $136d40cdb268fe10$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $136d40cdb268fe10$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $136d40cdb268fe10$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $136d40cdb268fe10$var$validateNumber(value, type);
        throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $136d40cdb268fe10$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $136d40cdb268fe10$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $136d40cdb268fe10$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $136d40cdb268fe10$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($136d40cdb268fe10$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $136d40cdb268fe10$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $136d40cdb268fe10$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $136d40cdb268fe10$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $136d40cdb268fe10$var$base64ToBytes(str) {
    return $e0eed84d5498f6e4$export$d622b2ad8d90c771($136d40cdb268fe10$var$base64clean(str));
}
function $136d40cdb268fe10$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $136d40cdb268fe10$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $136d40cdb268fe10$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $136d40cdb268fe10$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $136d40cdb268fe10$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $136d40cdb268fe10$var$BufferBigIntNotDefined : fn;
}
function $136d40cdb268fe10$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $780b92061aa4a3e6$require$Buffer = $136d40cdb268fe10$export$a143d493d941bafc;
const $780b92061aa4a3e6$var$F = "@firebase/firestore", $780b92061aa4a3e6$var$M = "4.8.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $780b92061aa4a3e6$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $780b92061aa4a3e6$var$User.UNAUTHENTICATED = new $780b92061aa4a3e6$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$780b92061aa4a3e6$var$User.GOOGLE_CREDENTIALS = new $780b92061aa4a3e6$var$User("google-credentials-uid"), $780b92061aa4a3e6$var$User.FIRST_PARTY = new $780b92061aa4a3e6$var$User("first-party-uid"), $780b92061aa4a3e6$var$User.MOCK_USER = new $780b92061aa4a3e6$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $780b92061aa4a3e6$var$x = "11.10.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$O = new (0, $c2975c8f4799263d$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $780b92061aa4a3e6$var$__PRIVATE_getLogLevel() {
    return $780b92061aa4a3e6$var$O.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $780b92061aa4a3e6$export$c622e99c0ce7b1c9(e) {
    $780b92061aa4a3e6$var$O.setLogLevel(e);
}
function $780b92061aa4a3e6$var$__PRIVATE_logDebug(e, ...t) {
    if ($780b92061aa4a3e6$var$O.logLevel <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($780b92061aa4a3e6$var$__PRIVATE_argToString);
        $780b92061aa4a3e6$var$O.debug(`Firestore (${$780b92061aa4a3e6$var$x}): ${e}`, ...n);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_logError(e, ...t) {
    if ($780b92061aa4a3e6$var$O.logLevel <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).ERROR) {
        const n = t.map($780b92061aa4a3e6$var$__PRIVATE_argToString);
        $780b92061aa4a3e6$var$O.error(`Firestore (${$780b92061aa4a3e6$var$x}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $780b92061aa4a3e6$export$86cd73f49cc6e0bb(e, ...t) {
    if ($780b92061aa4a3e6$var$O.logLevel <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).WARN) {
        const n = t.map($780b92061aa4a3e6$var$__PRIVATE_argToString);
        $780b92061aa4a3e6$var$O.warn(`Firestore (${$780b92061aa4a3e6$var$x}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $780b92061aa4a3e6$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $780b92061aa4a3e6$var$fail(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $780b92061aa4a3e6$var$__PRIVATE__fail(e, r, n);
}
function $780b92061aa4a3e6$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$780b92061aa4a3e6$var$x}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $780b92061aa4a3e6$var$__PRIVATE_logError(r), new Error(r);
}
function $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $780b92061aa4a3e6$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $780b92061aa4a3e6$export$1d2b90eea9bba017(e, t) {
    e || $780b92061aa4a3e6$var$fail(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $780b92061aa4a3e6$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$N = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $780b92061aa4a3e6$export$8fada0bf726bf278 extends (0, $abbde52b10a5c31f$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $780b92061aa4a3e6$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($780b92061aa4a3e6$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $780b92061aa4a3e6$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $780b92061aa4a3e6$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $780b92061aa4a3e6$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $780b92061aa4a3e6$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($780b92061aa4a3e6$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $780b92061aa4a3e6$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($780b92061aa4a3e6$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($780b92061aa4a3e6$var$__PRIVATE_hardAssert("string" == typeof t.accessToken, 31837, {
                l: t
            }), new $780b92061aa4a3e6$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $780b92061aa4a3e6$var$__PRIVATE_hardAssert(null === e || "string" == typeof e, 2055, {
            h: e
        }), new $780b92061aa4a3e6$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $780b92061aa4a3e6$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n, this.type = "FirstParty", this.user = $780b92061aa4a3e6$var$User.FIRST_PARTY, this.A = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ R() {
        return this.I ? this.I() : null;
    }
    get headers() {
        this.A.set("X-Goog-AuthUser", this.P);
        // Use array notation to prevent minification
        const e = this.R();
        return e && this.A.set("Authorization", e), this.T && this.A.set("X-Goog-Iam-Authorization-Token", this.T), this.A;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $780b92061aa4a3e6$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n;
    }
    getToken() {
        return Promise.resolve(new $780b92061aa4a3e6$var$__PRIVATE_FirstPartyToken(this.P, this.T, this.I));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($780b92061aa4a3e6$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $780b92061aa4a3e6$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, $eda286d93c7c2273$export$643c8bc6c389f34e)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $780b92061aa4a3e6$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, $780b92061aa4a3e6$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $780b92061aa4a3e6$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $780b92061aa4a3e6$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new $780b92061aa4a3e6$var$AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($780b92061aa4a3e6$var$__PRIVATE_hardAssert("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new $780b92061aa4a3e6$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $780b92061aa4a3e6$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $780b92061aa4a3e6$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $780b92061aa4a3e6$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $780b92061aa4a3e6$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $780b92061aa4a3e6$export$253bcaa5572dcc83 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $780b92061aa4a3e6$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $780b92061aa4a3e6$var$__PRIVATE_compareUtf8Strings(e, t) {
    let n = 0;
    for(; n < e.length && n < t.length;){
        const r = e.codePointAt(n), i = t.codePointAt(n);
        if (r !== i) {
            if (r < 128 && i < 128) // ASCII comparison
            return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(r, i);
            {
                // Lazy instantiate TextEncoder
                const s = $780b92061aa4a3e6$var$__PRIVATE_newTextEncoder(), o = $780b92061aa4a3e6$var$__PRIVATE_compareByteArrays$1(s.encode($780b92061aa4a3e6$var$__PRIVATE_getUtf8SafeSubstring(e, n)), s.encode($780b92061aa4a3e6$var$__PRIVATE_getUtf8SafeSubstring(t, n)));
                // UTF-8 encode the character at index i for byte comparison.
                return 0 !== o ? o : $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(r, i);
            }
        }
        // Increment by 2 for surrogate pairs, 1 otherwise
        n += r > 65535 ? 2 : 1;
    }
    // Compare lengths if all characters are equal
    return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
function $780b92061aa4a3e6$var$__PRIVATE_getUtf8SafeSubstring(e, t) {
    return e.codePointAt(t) > 65535 ? e.substring(t, t + 2) : e.substring(t, t + 1);
}
function $780b92061aa4a3e6$var$__PRIVATE_compareByteArrays$1(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n)if (e[n] !== t[n]) return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e[n], t[n]);
    return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
/** Helper to compare arrays using isEqual(). */ function $780b92061aa4a3e6$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $780b92061aa4a3e6$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$B = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $780b92061aa4a3e6$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $780b92061aa4a3e6$var$fail(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $780b92061aa4a3e6$var$fail(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $780b92061aa4a3e6$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $780b92061aa4a3e6$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $780b92061aa4a3e6$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $780b92061aa4a3e6$var$BasePath.isNumericId(e), r = $780b92061aa4a3e6$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $780b92061aa4a3e6$var$BasePath.extractNumericId(e).compare($780b92061aa4a3e6$var$BasePath.extractNumericId(t)) : $780b92061aa4a3e6$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $19e6a74148afb814$export$70ffa26850098d01).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $780b92061aa4a3e6$var$ResourcePath extends $780b92061aa4a3e6$var$BasePath {
    construct(e, t, n) {
        return new $780b92061aa4a3e6$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $780b92061aa4a3e6$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $780b92061aa4a3e6$var$ResourcePath([]);
    }
}
const $780b92061aa4a3e6$var$L = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $780b92061aa4a3e6$export$b7871852b967eaf1 extends $780b92061aa4a3e6$var$BasePath {
    construct(e, t, n) {
        return new $780b92061aa4a3e6$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $780b92061aa4a3e6$var$L.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $780b92061aa4a3e6$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $780b92061aa4a3e6$var$B;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $780b92061aa4a3e6$export$b7871852b967eaf1([
            $780b92061aa4a3e6$var$B
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $780b92061aa4a3e6$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $780b92061aa4a3e6$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $780b92061aa4a3e6$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $780b92061aa4a3e6$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $780b92061aa4a3e6$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $780b92061aa4a3e6$export$afc2e57c475b7810(new $780b92061aa4a3e6$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $780b92061aa4a3e6$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $780b92061aa4a3e6$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $780b92061aa4a3e6$var$__PRIVATE_validateDocumentPath(e) {
    if (!$780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(e)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $780b92061aa4a3e6$var$__PRIVATE_validateCollectionPath(e) {
    if ($780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(e)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $780b92061aa4a3e6$var$__PRIVATE_isPlainObject(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $780b92061aa4a3e6$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $780b92061aa4a3e6$var$fail(12329, {
        type: typeof e
    });
}
function $780b92061aa4a3e6$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $780b92061aa4a3e6$var$__PRIVATE_valueDescription(e);
            throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $780b92061aa4a3e6$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $780b92061aa4a3e6$var$property(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json A JSON object to validate.
 * @param scheme a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $780b92061aa4a3e6$var$__PRIVATE_validateJSON(e, t) {
    if (!$780b92061aa4a3e6$var$__PRIVATE_isPlainObject(e)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const o = e[r];
        if (i && typeof o !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && o !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $780b92061aa4a3e6$var$k = -62135596800, $780b92061aa4a3e6$var$q = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $780b92061aa4a3e6$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $780b92061aa4a3e6$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $780b92061aa4a3e6$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $780b92061aa4a3e6$var$q);
        return new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $780b92061aa4a3e6$var$k) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $780b92061aa4a3e6$var$q;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $780b92061aa4a3e6$export$d9bcbd5e1ff81430._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($780b92061aa4a3e6$var$__PRIVATE_validateJSON(e, $780b92061aa4a3e6$export$d9bcbd5e1ff81430._jsonSchema)) return new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $780b92061aa4a3e6$var$k;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$780b92061aa4a3e6$export$d9bcbd5e1ff81430._jsonSchemaVersion = "firestore/timestamp/1.0", $780b92061aa4a3e6$export$d9bcbd5e1ff81430._jsonSchema = {
    type: $780b92061aa4a3e6$var$property("string", $780b92061aa4a3e6$export$d9bcbd5e1ff81430._jsonSchemaVersion),
    seconds: $780b92061aa4a3e6$var$property("number"),
    nanoseconds: $780b92061aa4a3e6$var$property("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $780b92061aa4a3e6$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $780b92061aa4a3e6$var$SnapshotVersion(e);
    }
    static min() {
        return new $780b92061aa4a3e6$var$SnapshotVersion(new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $780b92061aa4a3e6$var$SnapshotVersion(new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $780b92061aa4a3e6$var$Q = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $780b92061aa4a3e6$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $780b92061aa4a3e6$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $780b92061aa4a3e6$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $780b92061aa4a3e6$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $780b92061aa4a3e6$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $780b92061aa4a3e6$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $780b92061aa4a3e6$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $780b92061aa4a3e6$var$IndexState(0, $780b92061aa4a3e6$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $780b92061aa4a3e6$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $780b92061aa4a3e6$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(n + 1, 0) : new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(n, r));
    return new $780b92061aa4a3e6$var$IndexOffset(i, $780b92061aa4a3e6$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $780b92061aa4a3e6$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $780b92061aa4a3e6$var$IndexOffset(e.readTime, e.key, $780b92061aa4a3e6$var$Q);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $780b92061aa4a3e6$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $780b92061aa4a3e6$var$IndexOffset($780b92061aa4a3e6$var$SnapshotVersion.min(), $780b92061aa4a3e6$export$afc2e57c475b7810.empty(), $780b92061aa4a3e6$var$Q);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $780b92061aa4a3e6$var$IndexOffset($780b92061aa4a3e6$var$SnapshotVersion.max(), $780b92061aa4a3e6$export$afc2e57c475b7810.empty(), $780b92061aa4a3e6$var$Q);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $780b92061aa4a3e6$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$$ = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $780b92061aa4a3e6$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $780b92061aa4a3e6$var$N.FAILED_PRECONDITION || e.message !== $780b92061aa4a3e6$var$$) throw e;
    $780b92061aa4a3e6$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $780b92061aa4a3e6$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $780b92061aa4a3e6$var$fail(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $780b92061aa4a3e6$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $780b92061aa4a3e6$var$PersistencePromise ? t : $780b92061aa4a3e6$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $780b92061aa4a3e6$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $780b92061aa4a3e6$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $780b92061aa4a3e6$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $780b92061aa4a3e6$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $780b92061aa4a3e6$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $780b92061aa4a3e6$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $780b92061aa4a3e6$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $780b92061aa4a3e6$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $780b92061aa4a3e6$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $780b92061aa4a3e6$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $780b92061aa4a3e6$var$U = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $780b92061aa4a3e6$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $780b92061aa4a3e6$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.S = new $780b92061aa4a3e6$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.S.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.S.reject(new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.S.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $780b92061aa4a3e6$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.S.reject(new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get D() {
        return this.S.promise;
    }
    abort(e) {
        e && this.S.reject(e), this.aborted || ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    v() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $780b92061aa4a3e6$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $780b92061aa4a3e6$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "Removing database:", e);
        return $780b92061aa4a3e6$var$__PRIVATE_wrapRequest((0, $abbde52b10a5c31f$export$a4e55266d2135a7f)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static C() {
        if (!(0, $abbde52b10a5c31f$export$3865db50535c2055)()) return !1;
        if ($780b92061aa4a3e6$var$__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $abbde52b10a5c31f$export$c36915b22ce77c19)(), t = $780b92061aa4a3e6$var$__PRIVATE_SimpleDb.M(e), n = 0 < t && t < 10, r = $780b92061aa4a3e6$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        var e;
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static N(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static M(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.B = n, this.L = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $780b92061aa4a3e6$var$__PRIVATE_SimpleDb.M((0, $abbde52b10a5c31f$export$c36915b22ce77c19)()) && $780b92061aa4a3e6$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async k(e) {
        return this.db || ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                if (null !== this.L && this.L !== e.oldVersion) // This thrown error will get passed to the `onerror` callback
                // registered above, and will then be propagated correctly.
                throw new Error(`refusing to open IndexedDB database due to potential corruption of the IndexedDB database data; this corruption could be caused by clicking the "clear site data" button in a web browser; try reloading the web page to re-initialize the IndexedDB database: lastClosedDbVersion=${this.L}, event.oldVersion=${e.oldVersion}, event.newVersion=${e.newVersion}, db.version=${t.version}`);
                this.B.q(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "Database upgrade to version " + this.version + " complete");
                });
            };
        }), this.db.addEventListener("close", (e)=>{
            const t = e.target;
            this.L = t.version;
        }, {
            passive: !0
        })), this.db.addEventListener("versionchange", (e)=>{
            var t;
            // Notify the listener if another tab attempted to delete the IndexedDb
            // database, such as by calling clearIndexedDbPersistence().
            null === e.newVersion && ($780b92061aa4a3e6$export$86cd73f49cc6e0bb('Received "versionchange" event with newVersion===null; notifying the registered DatabaseDeletedListener, if any'), null === (t = this.databaseDeletedListener) || void 0 === t || t.call(this));
        }, {
            passive: !0
        }), this.db;
    }
    setDatabaseDeletedListener(e) {
        if (this.databaseDeletedListener) throw new Error("setDatabaseDeletedListener() may only be called once, and it has already been called");
        this.databaseDeletedListener = e;
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.k(e);
                const t = $780b92061aa4a3e6$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.v(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $780b92061aa4a3e6$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.D, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $780b92061aa4a3e6$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IterationController {
    constructor(e){
        this.$ = e, this.U = !1, this.K = null;
    }
    get isDone() {
        return this.U;
    }
    get W() {
        return this.K;
    }
    set cursor(e) {
        this.$ = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.U = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ G(e) {
        this.K = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $780b92061aa4a3e6$var$__PRIVATE_wrapRequest(this.$.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransactionError extends $780b92061aa4a3e6$export$8fada0bf726bf278 {
    constructor(e, t){
        super($780b92061aa4a3e6$var$N.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $780b92061aa4a3e6$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $780b92061aa4a3e6$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "ADD", this.store.name, e, e);
        return $780b92061aa4a3e6$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $780b92061aa4a3e6$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "DELETE", this.store.name, e);
        return $780b92061aa4a3e6$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "COUNT", this.store.name);
        return $780b92061aa4a3e6$var$__PRIVATE_wrapRequest(this.store.count());
    }
    j(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $780b92061aa4a3e6$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.J(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ H(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $780b92061aa4a3e6$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    Y(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$U, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.Z = !1;
        const r = this.cursor(n);
        return this.J(r, (e, t, n)=>n.delete());
    }
    X(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.J(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ ee(e) {
        const t = this.cursor({});
        return new $780b92061aa4a3e6$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $780b92061aa4a3e6$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    J(e, t) {
        const n = [];
        return new $780b92061aa4a3e6$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $780b92061aa4a3e6$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $780b92061aa4a3e6$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $780b92061aa4a3e6$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.W ? i.continue() : i.continue(s.W);
            };
        }).next(()=>$780b92061aa4a3e6$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.Z ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $780b92061aa4a3e6$var$__PRIVATE_wrapRequest(e) {
    return new $780b92061aa4a3e6$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $780b92061aa4a3e6$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $780b92061aa4a3e6$var$K = !1;
function $780b92061aa4a3e6$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_SimpleDb.M((0, $abbde52b10a5c31f$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $780b92061aa4a3e6$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $780b92061aa4a3e6$var$K || ($780b92061aa4a3e6$var$K = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $780b92061aa4a3e6$var$W = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $780b92061aa4a3e6$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.te = t, this.task = null;
    }
    start() {
        this.ne(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    ne(e) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$W, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.te.re();
                $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$W, `Documents written: ${e}`);
            } catch (e) {
                $780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e) ? $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$W, "Ignoring IndexedDB error during index backfill: ", e) : await $780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.ne(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $780b92061aa4a3e6$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async re(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.ie(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ ie(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $780b92061aa4a3e6$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$W, `Processing collection: ${t}`), this.se(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ se(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.oe(r, n)).next((n)=>($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$W, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ oe(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $780b92061aa4a3e6$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $780b92061aa4a3e6$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $780b92061aa4a3e6$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $780b92061aa4a3e6$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this._e(e), this.ae = (e)=>t.writeSequenceNumber(e));
    }
    _e(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ae && this.ae(e), e;
    }
}
$780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $780b92061aa4a3e6$var$G = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $780b92061aa4a3e6$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $780b92061aa4a3e6$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $780b92061aa4a3e6$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$780b92061aa4a3e6$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$z = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $780b92061aa4a3e6$var$__PRIVATE_encodeSeparator(t)), t = $780b92061aa4a3e6$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $780b92061aa4a3e6$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $780b92061aa4a3e6$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $780b92061aa4a3e6$var$z:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $780b92061aa4a3e6$var$__PRIVATE_encodeSeparator(e) {
    return e + $780b92061aa4a3e6$var$z + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(t >= 2, 64408, {
        path: e
    }), 2 === t) return $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.charAt(0) === $780b92061aa4a3e6$var$z && "" === e.charAt(1), 56145, {
        path: e
    }), $780b92061aa4a3e6$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($780b92061aa4a3e6$var$z, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $780b92061aa4a3e6$var$fail(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $780b92061aa4a3e6$var$fail(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $780b92061aa4a3e6$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$j = "remoteDocuments", $780b92061aa4a3e6$var$J = "owner", $780b92061aa4a3e6$var$H = "owner", $780b92061aa4a3e6$var$Y = "mutationQueues", $780b92061aa4a3e6$var$Z = "userId", $780b92061aa4a3e6$var$X = "mutations", $780b92061aa4a3e6$var$ee = "batchId", $780b92061aa4a3e6$var$te = "userMutationsIndex", $780b92061aa4a3e6$var$ne = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $780b92061aa4a3e6$var$re = {}, $780b92061aa4a3e6$var$ie = "documentMutations", $780b92061aa4a3e6$var$se = "remoteDocumentsV14", $780b92061aa4a3e6$var$oe = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $780b92061aa4a3e6$var$_e = "documentKeyIndex", $780b92061aa4a3e6$var$ae = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $780b92061aa4a3e6$var$ue = "collectionGroupIndex", $780b92061aa4a3e6$var$ce = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $780b92061aa4a3e6$var$le = "remoteDocumentGlobal", $780b92061aa4a3e6$var$he = "remoteDocumentGlobalKey", $780b92061aa4a3e6$var$Pe = "targets", $780b92061aa4a3e6$var$Te = "queryTargetsIndex", $780b92061aa4a3e6$var$Ie = [
    "canonicalId",
    "targetId"
], $780b92061aa4a3e6$var$de = "targetDocuments", $780b92061aa4a3e6$var$Ee = [
    "targetId",
    "path"
], $780b92061aa4a3e6$var$Ae = "documentTargetsIndex", $780b92061aa4a3e6$var$Re = [
    "path",
    "targetId"
], $780b92061aa4a3e6$var$Ve = "targetGlobalKey", $780b92061aa4a3e6$var$me = "targetGlobal", $780b92061aa4a3e6$var$fe = "collectionParents", $780b92061aa4a3e6$var$ge = [
    "collectionId",
    "parent"
], $780b92061aa4a3e6$var$pe = "clientMetadata", $780b92061aa4a3e6$var$ye = "clientId", $780b92061aa4a3e6$var$we = "bundles", $780b92061aa4a3e6$var$Se = "bundleId", $780b92061aa4a3e6$var$be = "namedQueries", $780b92061aa4a3e6$var$De = "name", $780b92061aa4a3e6$var$ve = "indexConfiguration", $780b92061aa4a3e6$var$Ce = "indexId", $780b92061aa4a3e6$var$Fe = "collectionGroupIndex", $780b92061aa4a3e6$var$Me = "collectionGroup", $780b92061aa4a3e6$var$xe = "indexState", $780b92061aa4a3e6$var$Oe = [
    "indexId",
    "uid"
], $780b92061aa4a3e6$var$Ne = "sequenceNumberIndex", $780b92061aa4a3e6$var$Be = [
    "uid",
    "sequenceNumber"
], $780b92061aa4a3e6$var$Le = "indexEntries", $780b92061aa4a3e6$var$ke = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $780b92061aa4a3e6$var$qe = "documentKeyIndex", $780b92061aa4a3e6$var$Qe = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $780b92061aa4a3e6$var$$e = "documentOverlays", $780b92061aa4a3e6$var$Ue = [
    "userId",
    "collectionPath",
    "documentId"
], $780b92061aa4a3e6$var$Ke = "collectionPathOverlayIndex", $780b92061aa4a3e6$var$We = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $780b92061aa4a3e6$var$Ge = "collectionGroupOverlayIndex", $780b92061aa4a3e6$var$ze = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $780b92061aa4a3e6$var$je = "globals", $780b92061aa4a3e6$var$Je = "name", $780b92061aa4a3e6$var$He = [
    $780b92061aa4a3e6$var$Y,
    $780b92061aa4a3e6$var$X,
    $780b92061aa4a3e6$var$ie,
    $780b92061aa4a3e6$var$j,
    $780b92061aa4a3e6$var$Pe,
    $780b92061aa4a3e6$var$J,
    $780b92061aa4a3e6$var$me,
    $780b92061aa4a3e6$var$de,
    $780b92061aa4a3e6$var$pe,
    $780b92061aa4a3e6$var$le,
    $780b92061aa4a3e6$var$fe,
    $780b92061aa4a3e6$var$we,
    $780b92061aa4a3e6$var$be
], $780b92061aa4a3e6$var$Ye = [
    ...$780b92061aa4a3e6$var$He,
    $780b92061aa4a3e6$var$$e
], $780b92061aa4a3e6$var$Ze = [
    $780b92061aa4a3e6$var$Y,
    $780b92061aa4a3e6$var$X,
    $780b92061aa4a3e6$var$ie,
    $780b92061aa4a3e6$var$se,
    $780b92061aa4a3e6$var$Pe,
    $780b92061aa4a3e6$var$J,
    $780b92061aa4a3e6$var$me,
    $780b92061aa4a3e6$var$de,
    $780b92061aa4a3e6$var$pe,
    $780b92061aa4a3e6$var$le,
    $780b92061aa4a3e6$var$fe,
    $780b92061aa4a3e6$var$we,
    $780b92061aa4a3e6$var$be,
    $780b92061aa4a3e6$var$$e
], $780b92061aa4a3e6$var$Xe = $780b92061aa4a3e6$var$Ze, $780b92061aa4a3e6$var$et = [
    ...$780b92061aa4a3e6$var$Xe,
    $780b92061aa4a3e6$var$ve,
    $780b92061aa4a3e6$var$xe,
    $780b92061aa4a3e6$var$Le
], $780b92061aa4a3e6$var$tt = $780b92061aa4a3e6$var$et, $780b92061aa4a3e6$var$nt = [
    ...$780b92061aa4a3e6$var$et,
    $780b92061aa4a3e6$var$je
], $780b92061aa4a3e6$var$rt = $780b92061aa4a3e6$var$nt;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransaction extends $780b92061aa4a3e6$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.ce = e, this.currentSequenceNumber = t;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_getStore(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return $780b92061aa4a3e6$var$__PRIVATE_SimpleDb.N(n.ce, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $780b92061aa4a3e6$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $780b92061aa4a3e6$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $780b92061aa4a3e6$var$__PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $780b92061aa4a3e6$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $780b92061aa4a3e6$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $780b92061aa4a3e6$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $780b92061aa4a3e6$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $780b92061aa4a3e6$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $780b92061aa4a3e6$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $780b92061aa4a3e6$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $780b92061aa4a3e6$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $780b92061aa4a3e6$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $780b92061aa4a3e6$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $780b92061aa4a3e6$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $780b92061aa4a3e6$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $780b92061aa4a3e6$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $780b92061aa4a3e6$var$LLRBNode.RED, this.left = null != r ? r : $780b92061aa4a3e6$var$LLRBNode.EMPTY, this.right = null != i ? i : $780b92061aa4a3e6$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $780b92061aa4a3e6$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $780b92061aa4a3e6$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $780b92061aa4a3e6$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $780b92061aa4a3e6$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $780b92061aa4a3e6$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $780b92061aa4a3e6$var$fail(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $780b92061aa4a3e6$var$fail(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $780b92061aa4a3e6$var$fail(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$780b92061aa4a3e6$var$LLRBNode.EMPTY = null, $780b92061aa4a3e6$var$LLRBNode.RED = !0, $780b92061aa4a3e6$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$780b92061aa4a3e6$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $780b92061aa4a3e6$var$fail(57766);
    }
    get value() {
        throw $780b92061aa4a3e6$var$fail(16141);
    }
    get color() {
        throw $780b92061aa4a3e6$var$fail(16727);
    }
    get left() {
        throw $780b92061aa4a3e6$var$fail(29726);
    }
    get right() {
        throw $780b92061aa4a3e6$var$fail(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $780b92061aa4a3e6$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $780b92061aa4a3e6$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $780b92061aa4a3e6$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $780b92061aa4a3e6$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $780b92061aa4a3e6$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $780b92061aa4a3e6$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $780b92061aa4a3e6$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $780b92061aa4a3e6$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $780b92061aa4a3e6$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $780b92061aa4a3e6$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($780b92061aa4a3e6$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $780b92061aa4a3e6$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $780b92061aa4a3e6$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $780b92061aa4a3e6$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $780b92061aa4a3e6$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $780b92061aa4a3e6$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $780b92061aa4a3e6$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $780b92061aa4a3e6$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $780b92061aa4a3e6$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $780b92061aa4a3e6$export$67460cdabfa21253("");
const $780b92061aa4a3e6$var$it = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $780b92061aa4a3e6$var$it.exec(e);
        if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $780b92061aa4a3e6$export$67460cdabfa21253.fromBase64String(e) : $780b92061aa4a3e6$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $780b92061aa4a3e6$var$st = "server_timestamp", $780b92061aa4a3e6$var$ot = "__type__", $780b92061aa4a3e6$var$_t = "__previous_value__", $780b92061aa4a3e6$var$at = "__local_write_time__";
function $780b92061aa4a3e6$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {})[$780b92061aa4a3e6$var$ot]) || void 0 === n ? void 0 : n.stringValue) === $780b92061aa4a3e6$var$st;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $780b92061aa4a3e6$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$780b92061aa4a3e6$var$_t];
    return $780b92061aa4a3e6$var$__PRIVATE_isServerTimestamp(t) ? $780b92061aa4a3e6$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $780b92061aa4a3e6$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$780b92061aa4a3e6$var$at].timestampValue);
    return new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a, u){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a, this.isUsingEmulator = u;
    }
}
/** The default database name for a project. */ const $780b92061aa4a3e6$var$ut = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $780b92061aa4a3e6$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || $780b92061aa4a3e6$var$ut;
    }
    static empty() {
        return new $780b92061aa4a3e6$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return this.database === $780b92061aa4a3e6$var$ut;
    }
    isEqual(e) {
        return e instanceof $780b92061aa4a3e6$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$ct = "__type__", $780b92061aa4a3e6$var$lt = "__max__", $780b92061aa4a3e6$var$ht = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $780b92061aa4a3e6$var$lt
            }
        }
    }
}, $780b92061aa4a3e6$var$Pt = "__vector__", $780b92061aa4a3e6$var$Tt = "value", $780b92061aa4a3e6$var$It = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $780b92061aa4a3e6$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $780b92061aa4a3e6$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $780b92061aa4a3e6$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $780b92061aa4a3e6$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $780b92061aa4a3e6$var$fail(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $780b92061aa4a3e6$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $780b92061aa4a3e6$var$__PRIVATE_typeOrder(e);
    if (n !== $780b92061aa4a3e6$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_getLocalWriteTime(e).isEqual($780b92061aa4a3e6$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.integerValue) === $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $780b92061aa4a3e6$var$__PRIVATE_isNegativeZero(n) === $780b92061aa4a3e6$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $780b92061aa4a3e6$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($780b92061aa4a3e6$var$__PRIVATE_objectSize(n) !== $780b92061aa4a3e6$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$780b92061aa4a3e6$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $780b92061aa4a3e6$var$fail(52216, {
                left: e
            });
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$780b92061aa4a3e6$var$__PRIVATE_valueEquals(e, t));
}
function $780b92061aa4a3e6$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $780b92061aa4a3e6$var$__PRIVATE_typeOrder(e), r = $780b92061aa4a3e6$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_compareTimestamps($780b92061aa4a3e6$var$__PRIVATE_getLocalWriteTime(e), $780b92061aa4a3e6$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(e), r = $780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator($780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.latitude), $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator($780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.longitude), $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                var n, r, i, s;
                const o = e.fields || {}, _ = t.fields || {}, a = null === (n = o[$780b92061aa4a3e6$var$Tt]) || void 0 === n ? void 0 : n.arrayValue, u = null === (r = _[$780b92061aa4a3e6$var$Tt]) || void 0 === r ? void 0 : r.arrayValue, c = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator((null === (i = null == a ? void 0 : a.values) || void 0 === i ? void 0 : i.length) || 0, (null === (s = null == u ? void 0 : u.values) || void 0 === s ? void 0 : s.length) || 0);
                if (0 !== c) return c;
                return $780b92061aa4a3e6$var$__PRIVATE_compareArrays(a, u);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $780b92061aa4a3e6$var$ht.mapValue && t === $780b92061aa4a3e6$var$ht.mapValue) return 0;
                if (e === $780b92061aa4a3e6$var$ht.mapValue) return 1;
                if (t === $780b92061aa4a3e6$var$ht.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $780b92061aa4a3e6$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $780b92061aa4a3e6$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $780b92061aa4a3e6$var$fail(23264, {
                le: n
            });
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e, t);
    const n = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(e), r = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(t), i = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $780b92061aa4a3e6$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $780b92061aa4a3e6$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $780b92061aa4a3e6$var$canonicalId(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_canonifyValue(e);
}
function $780b92061aa4a3e6$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $780b92061aa4a3e6$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $780b92061aa4a3e6$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$780b92061aa4a3e6$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $780b92061aa4a3e6$var$fail(61005, {
        value: e
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_estimateByteSize(e) {
    switch($780b92061aa4a3e6$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $780b92061aa4a3e6$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $780b92061aa4a3e6$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $780b92061aa4a3e6$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $780b92061aa4a3e6$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $780b92061aa4a3e6$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $780b92061aa4a3e6$var$fail(13486, {
                value: e
            });
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $780b92061aa4a3e6$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $780b92061aa4a3e6$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $780b92061aa4a3e6$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $780b92061aa4a3e6$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $780b92061aa4a3e6$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $780b92061aa4a3e6$var$__PRIVATE_isVectorValue(e) {
    var t, n;
    return (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {})[$780b92061aa4a3e6$var$ct]) || void 0 === n ? void 0 : n.stringValue) === $780b92061aa4a3e6$var$Pt;
}
/** Creates a deep copy of `source`. */ function $780b92061aa4a3e6$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $780b92061aa4a3e6$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $780b92061aa4a3e6$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $780b92061aa4a3e6$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $780b92061aa4a3e6$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $780b92061aa4a3e6$var$lt;
}
const $780b92061aa4a3e6$var$dt = {
    mapValue: {
        fields: {
            [$780b92061aa4a3e6$var$ct]: {
                stringValue: $780b92061aa4a3e6$var$Pt
            },
            [$780b92061aa4a3e6$var$Tt]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $780b92061aa4a3e6$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $780b92061aa4a3e6$var$It : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $780b92061aa4a3e6$var$__PRIVATE_refValue($780b92061aa4a3e6$export$4c3ccc07620ae30a.empty(), $780b92061aa4a3e6$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $780b92061aa4a3e6$var$__PRIVATE_isVectorValue(e) ? $780b92061aa4a3e6$var$dt : {
        mapValue: {}
    } : $780b92061aa4a3e6$var$fail(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $780b92061aa4a3e6$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $780b92061aa4a3e6$var$__PRIVATE_refValue($780b92061aa4a3e6$export$4c3ccc07620ae30a.empty(), $780b92061aa4a3e6$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $780b92061aa4a3e6$var$dt : "mapValue" in e ? $780b92061aa4a3e6$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $780b92061aa4a3e6$var$ht : $780b92061aa4a3e6$var$fail(61959, {
        value: e
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $780b92061aa4a3e6$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $780b92061aa4a3e6$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $780b92061aa4a3e6$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$780b92061aa4a3e6$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $780b92061aa4a3e6$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $780b92061aa4a3e6$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $780b92061aa4a3e6$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $780b92061aa4a3e6$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $780b92061aa4a3e6$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $780b92061aa4a3e6$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $780b92061aa4a3e6$var$ObjectValue($780b92061aa4a3e6$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $780b92061aa4a3e6$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $780b92061aa4a3e6$var$forEach(e.fields, (e, n)=>{
        const r = new $780b92061aa4a3e6$export$b7871852b967eaf1([
            e
        ]);
        if ($780b92061aa4a3e6$var$__PRIVATE_isMapValue(n)) {
            const e = $780b92061aa4a3e6$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $780b92061aa4a3e6$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $780b92061aa4a3e6$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $780b92061aa4a3e6$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $780b92061aa4a3e6$var$SnapshotVersion.min(), /* readTime */ $780b92061aa4a3e6$var$SnapshotVersion.min(), /* createTime */ $780b92061aa4a3e6$var$SnapshotVersion.min(), $780b92061aa4a3e6$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $780b92061aa4a3e6$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $780b92061aa4a3e6$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $780b92061aa4a3e6$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $780b92061aa4a3e6$var$SnapshotVersion.min(), /* createTime */ $780b92061aa4a3e6$var$SnapshotVersion.min(), $780b92061aa4a3e6$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $780b92061aa4a3e6$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $780b92061aa4a3e6$var$SnapshotVersion.min(), /* createTime */ $780b92061aa4a3e6$var$SnapshotVersion.min(), $780b92061aa4a3e6$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $780b92061aa4a3e6$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $780b92061aa4a3e6$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $780b92061aa4a3e6$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $780b92061aa4a3e6$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $780b92061aa4a3e6$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $780b92061aa4a3e6$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $780b92061aa4a3e6$export$afc2e57c475b7810.comparator($780b92061aa4a3e6$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $780b92061aa4a3e6$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $780b92061aa4a3e6$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$780b92061aa4a3e6$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $780b92061aa4a3e6$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$Filter {
}
class $780b92061aa4a3e6$var$FieldFilter extends $780b92061aa4a3e6$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $780b92061aa4a3e6$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $780b92061aa4a3e6$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $780b92061aa4a3e6$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $780b92061aa4a3e6$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $780b92061aa4a3e6$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $780b92061aa4a3e6$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $780b92061aa4a3e6$var$__PRIVATE_KeyFieldInFilter(e, n) : new $780b92061aa4a3e6$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($780b92061aa4a3e6$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $780b92061aa4a3e6$var$__PRIVATE_typeOrder(this.value) === $780b92061aa4a3e6$var$__PRIVATE_typeOrder(t) && this.matchesComparison($780b92061aa4a3e6$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $780b92061aa4a3e6$var$fail(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $780b92061aa4a3e6$var$CompositeFilter extends $780b92061aa4a3e6$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.he = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $780b92061aa4a3e6$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.he || (this.he = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.he;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsFlat(e) && $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $780b92061aa4a3e6$var$CompositeFilter) return !1;
    return !0;
}
function $780b92061aa4a3e6$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $780b92061aa4a3e6$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $780b92061aa4a3e6$var$canonicalId(e.value);
    if ($780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $780b92061aa4a3e6$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $780b92061aa4a3e6$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $780b92061aa4a3e6$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $780b92061aa4a3e6$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $780b92061aa4a3e6$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $780b92061aa4a3e6$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $780b92061aa4a3e6$var$fail(19439);
}
function $780b92061aa4a3e6$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $780b92061aa4a3e6$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $780b92061aa4a3e6$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $780b92061aa4a3e6$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$780b92061aa4a3e6$var$canonicalId(e.value)}`;
    }(e) : e instanceof $780b92061aa4a3e6$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($780b92061aa4a3e6$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $780b92061aa4a3e6$var$__PRIVATE_KeyFieldFilter extends $780b92061aa4a3e6$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $780b92061aa4a3e6$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $780b92061aa4a3e6$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $780b92061aa4a3e6$var$__PRIVATE_KeyFieldInFilter extends $780b92061aa4a3e6$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $780b92061aa4a3e6$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $780b92061aa4a3e6$var$__PRIVATE_KeyFieldNotInFilter extends $780b92061aa4a3e6$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $780b92061aa4a3e6$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e)=>$780b92061aa4a3e6$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $780b92061aa4a3e6$var$__PRIVATE_ArrayContainsFilter extends $780b92061aa4a3e6$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $780b92061aa4a3e6$var$isArray(t) && $780b92061aa4a3e6$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $780b92061aa4a3e6$var$__PRIVATE_InFilter extends $780b92061aa4a3e6$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $780b92061aa4a3e6$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $780b92061aa4a3e6$var$__PRIVATE_NotInFilter extends $780b92061aa4a3e6$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($780b92061aa4a3e6$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$780b92061aa4a3e6$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $780b92061aa4a3e6$var$__PRIVATE_ArrayContainsAnyFilter extends $780b92061aa4a3e6$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$780b92061aa4a3e6$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$780b92061aa4a3e6$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $780b92061aa4a3e6$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.Pe = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $780b92061aa4a3e6$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $780b92061aa4a3e6$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $780b92061aa4a3e6$var$__PRIVATE_canonifyTarget(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    if (null === t.Pe) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $780b92061aa4a3e6$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$780b92061aa4a3e6$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$780b92061aa4a3e6$var$canonicalId(e)).join(",")), t.Pe = e;
    }
    return t.Pe;
}
function $780b92061aa4a3e6$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$780b92061aa4a3e6$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$780b92061aa4a3e6$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$780b92061aa4a3e6$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $780b92061aa4a3e6$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $780b92061aa4a3e6$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $780b92061aa4a3e6$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $780b92061aa4a3e6$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $780b92061aa4a3e6$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $780b92061aa4a3e6$var$It, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $780b92061aa4a3e6$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $780b92061aa4a3e6$var$It, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $780b92061aa4a3e6$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $780b92061aa4a3e6$var$It;
        }
        $780b92061aa4a3e6$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $780b92061aa4a3e6$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $780b92061aa4a3e6$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $780b92061aa4a3e6$var$ht, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $780b92061aa4a3e6$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $780b92061aa4a3e6$var$ht, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $780b92061aa4a3e6$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $780b92061aa4a3e6$var$ht;
        }
        $780b92061aa4a3e6$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $780b92061aa4a3e6$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $780b92061aa4a3e6$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Te = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.de = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $780b92061aa4a3e6$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $780b92061aa4a3e6$var$__PRIVATE_newQueryForPath(e) {
    return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $780b92061aa4a3e6$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $780b92061aa4a3e6$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $780b92061aa4a3e6$var$__PRIVATE_queryNormalizedOrderBy(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    if (null === t.Te) {
        t.Te = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.Te.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$export$b7871852b967eaf1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.Te.push(new $780b92061aa4a3e6$var$OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($780b92061aa4a3e6$export$b7871852b967eaf1.keyField().canonicalString()) || t.Te.push(new $780b92061aa4a3e6$var$OrderBy($780b92061aa4a3e6$export$b7871852b967eaf1.keyField(), n));
    }
    return t.Te;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return t.Ie || (t.Ie = $780b92061aa4a3e6$var$__PRIVATE__queryToTarget(t, $780b92061aa4a3e6$var$__PRIVATE_queryNormalizedOrderBy(e))), t.Ie;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $780b92061aa4a3e6$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return t.de || // Do not include implicit order-bys for aggregate queries.
    (t.de = $780b92061aa4a3e6$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.de;
}
function $780b92061aa4a3e6$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $780b92061aa4a3e6$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $780b92061aa4a3e6$var$OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $780b92061aa4a3e6$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $780b92061aa4a3e6$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $780b92061aa4a3e6$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $780b92061aa4a3e6$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $780b92061aa4a3e6$var$__PRIVATE_queryEquals(e, t) {
    return $780b92061aa4a3e6$var$__PRIVATE_targetEquals($780b92061aa4a3e6$var$__PRIVATE_queryToTarget(e), $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $780b92061aa4a3e6$var$__PRIVATE_canonifyQuery(e) {
    return `${$780b92061aa4a3e6$var$__PRIVATE_canonifyTarget($780b92061aa4a3e6$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $780b92061aa4a3e6$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $780b92061aa4a3e6$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$780b92061aa4a3e6$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$780b92061aa4a3e6$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($780b92061aa4a3e6$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $780b92061aa4a3e6$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $780b92061aa4a3e6$var$__PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $780b92061aa4a3e6$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $780b92061aa4a3e6$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $780b92061aa4a3e6$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $780b92061aa4a3e6$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $780b92061aa4a3e6$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $780b92061aa4a3e6$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $780b92061aa4a3e6$var$__PRIVATE_queryNormalizedOrderBy(e)){
            const e = $780b92061aa4a3e6$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $780b92061aa4a3e6$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $780b92061aa4a3e6$var$__PRIVATE_valueCompare(r, i) : $780b92061aa4a3e6$var$fail(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $780b92061aa4a3e6$var$fail(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $780b92061aa4a3e6$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $780b92061aa4a3e6$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $780b92061aa4a3e6$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Et = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
function $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap() {
    return $780b92061aa4a3e6$var$Et;
}
const $780b92061aa4a3e6$var$At = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
function $780b92061aa4a3e6$var$documentMap(...e) {
    let t = $780b92061aa4a3e6$var$At;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $780b92061aa4a3e6$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $780b92061aa4a3e6$var$At;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap() {
    return $780b92061aa4a3e6$var$__PRIVATE_newDocumentKeyMap();
}
function $780b92061aa4a3e6$var$__PRIVATE_newMutationMap() {
    return $780b92061aa4a3e6$var$__PRIVATE_newDocumentKeyMap();
}
function $780b92061aa4a3e6$var$__PRIVATE_newDocumentKeyMap() {
    return new $780b92061aa4a3e6$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $780b92061aa4a3e6$var$Rt = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
const $780b92061aa4a3e6$var$Vt = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
function $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(...e) {
    let t = $780b92061aa4a3e6$var$Vt;
    for (const n of e)t = t.add(n);
    return t;
}
const $780b92061aa4a3e6$var$mt = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator);
function $780b92061aa4a3e6$var$__PRIVATE_targetIdSet() {
    return $780b92061aa4a3e6$var$mt;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $780b92061aa4a3e6$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $780b92061aa4a3e6$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $780b92061aa4a3e6$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $780b92061aa4a3e6$var$toNumber(e, t) {
    return $780b92061aa4a3e6$var$isSafeInteger(t) ? $780b92061aa4a3e6$var$__PRIVATE_toInteger(t) : $780b92061aa4a3e6$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $780b92061aa4a3e6$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $780b92061aa4a3e6$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$780b92061aa4a3e6$var$ot]: {
                    stringValue: $780b92061aa4a3e6$var$st
                },
                [$780b92061aa4a3e6$var$at]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $780b92061aa4a3e6$var$__PRIVATE_isServerTimestamp(t) && (t = $780b92061aa4a3e6$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$780b92061aa4a3e6$var$_t] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation ? $780b92061aa4a3e6$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation ? $780b92061aa4a3e6$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $780b92061aa4a3e6$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $780b92061aa4a3e6$var$asNumber(n) + $780b92061aa4a3e6$var$asNumber(e.Ee);
        return $780b92061aa4a3e6$var$isInteger(n) && $780b92061aa4a3e6$var$isInteger(e.Ee) ? $780b92061aa4a3e6$var$__PRIVATE_toInteger(r) : $780b92061aa4a3e6$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $780b92061aa4a3e6$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation ? $780b92061aa4a3e6$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation ? $780b92061aa4a3e6$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $780b92061aa4a3e6$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $780b92061aa4a3e6$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampTransform extends $780b92061aa4a3e6$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation extends $780b92061aa4a3e6$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$780b92061aa4a3e6$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation extends $780b92061aa4a3e6$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $780b92061aa4a3e6$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$780b92061aa4a3e6$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementTransformOperation extends $780b92061aa4a3e6$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Ee = t;
    }
}
function $780b92061aa4a3e6$var$asNumber(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $780b92061aa4a3e6$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $780b92061aa4a3e6$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $780b92061aa4a3e6$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation ? $780b92061aa4a3e6$var$__PRIVATE_arrayEquals(e.elements, t.elements, $780b92061aa4a3e6$var$__PRIVATE_valueEquals) : e instanceof $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementTransformOperation ? $780b92061aa4a3e6$var$__PRIVATE_valueEquals(e.Ee, t.Ee) : e instanceof $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampTransform && t instanceof $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $780b92061aa4a3e6$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $780b92061aa4a3e6$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $780b92061aa4a3e6$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $780b92061aa4a3e6$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $780b92061aa4a3e6$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $780b92061aa4a3e6$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $780b92061aa4a3e6$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $780b92061aa4a3e6$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $780b92061aa4a3e6$var$__PRIVATE_DeleteMutation(e.key, $780b92061aa4a3e6$var$Precondition.none()) : new $780b92061aa4a3e6$var$__PRIVATE_SetMutation(e.key, e.data, $780b92061aa4a3e6$var$Precondition.none());
    {
        const n = e.data, r = $780b92061aa4a3e6$var$ObjectValue.empty();
        let i = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $780b92061aa4a3e6$var$__PRIVATE_PatchMutation(e.key, r, new $780b92061aa4a3e6$var$FieldMask(i.toArray()), $780b92061aa4a3e6$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $780b92061aa4a3e6$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $780b92061aa4a3e6$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $780b92061aa4a3e6$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$780b92061aa4a3e6$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $780b92061aa4a3e6$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($780b92061aa4a3e6$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $780b92061aa4a3e6$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$780b92061aa4a3e6$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $780b92061aa4a3e6$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $780b92061aa4a3e6$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$780b92061aa4a3e6$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $780b92061aa4a3e6$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($780b92061aa4a3e6$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($780b92061aa4a3e6$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $780b92061aa4a3e6$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $780b92061aa4a3e6$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $780b92061aa4a3e6$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $780b92061aa4a3e6$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $780b92061aa4a3e6$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$780b92061aa4a3e6$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $780b92061aa4a3e6$var$__PRIVATE_SetMutation extends $780b92061aa4a3e6$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_PatchMutation extends $780b92061aa4a3e6$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $780b92061aa4a3e6$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.length === n.length, 32656, {
        Ae: n.length,
        Re: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $780b92061aa4a3e6$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $780b92061aa4a3e6$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $780b92061aa4a3e6$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $780b92061aa4a3e6$var$__PRIVATE_DeleteMutation extends $780b92061aa4a3e6$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_VerifyMutation extends $780b92061aa4a3e6$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $780b92061aa4a3e6$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $780b92061aa4a3e6$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $780b92061aa4a3e6$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($780b92061aa4a3e6$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $780b92061aa4a3e6$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $780b92061aa4a3e6$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$780b92061aa4a3e6$var$__PRIVATE_mutationEquals(e, t)) && $780b92061aa4a3e6$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$780b92061aa4a3e6$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $780b92061aa4a3e6$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.mutations.length === n.length, 58842, {
            Ve: e.mutations.length,
            me: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $780b92061aa4a3e6$var$Rt;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $780b92061aa4a3e6$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $780b92061aa4a3e6$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $780b92061aa4a3e6$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $780b92061aa4a3e6$var$ft, $780b92061aa4a3e6$var$gt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $780b92061aa4a3e6$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $780b92061aa4a3e6$var$N.OK:
            return $780b92061aa4a3e6$var$fail(64938);
        case $780b92061aa4a3e6$var$N.CANCELLED:
        case $780b92061aa4a3e6$var$N.UNKNOWN:
        case $780b92061aa4a3e6$var$N.DEADLINE_EXCEEDED:
        case $780b92061aa4a3e6$var$N.RESOURCE_EXHAUSTED:
        case $780b92061aa4a3e6$var$N.INTERNAL:
        case $780b92061aa4a3e6$var$N.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $780b92061aa4a3e6$var$N.UNAUTHENTICATED:
            return !1;
        case $780b92061aa4a3e6$var$N.INVALID_ARGUMENT:
        case $780b92061aa4a3e6$var$N.NOT_FOUND:
        case $780b92061aa4a3e6$var$N.ALREADY_EXISTS:
        case $780b92061aa4a3e6$var$N.PERMISSION_DENIED:
        case $780b92061aa4a3e6$var$N.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $780b92061aa4a3e6$var$N.ABORTED:
        case $780b92061aa4a3e6$var$N.OUT_OF_RANGE:
        case $780b92061aa4a3e6$var$N.UNIMPLEMENTED:
        case $780b92061aa4a3e6$var$N.DATA_LOSS:
            return !0;
        default:
            return $780b92061aa4a3e6$var$fail(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $780b92061aa4a3e6$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $780b92061aa4a3e6$var$__PRIVATE_logError("GRPC error has no .code"), $780b92061aa4a3e6$var$N.UNKNOWN;
    switch(e){
        case $780b92061aa4a3e6$var$ft.OK:
            return $780b92061aa4a3e6$var$N.OK;
        case $780b92061aa4a3e6$var$ft.CANCELLED:
            return $780b92061aa4a3e6$var$N.CANCELLED;
        case $780b92061aa4a3e6$var$ft.UNKNOWN:
            return $780b92061aa4a3e6$var$N.UNKNOWN;
        case $780b92061aa4a3e6$var$ft.DEADLINE_EXCEEDED:
            return $780b92061aa4a3e6$var$N.DEADLINE_EXCEEDED;
        case $780b92061aa4a3e6$var$ft.RESOURCE_EXHAUSTED:
            return $780b92061aa4a3e6$var$N.RESOURCE_EXHAUSTED;
        case $780b92061aa4a3e6$var$ft.INTERNAL:
            return $780b92061aa4a3e6$var$N.INTERNAL;
        case $780b92061aa4a3e6$var$ft.UNAVAILABLE:
            return $780b92061aa4a3e6$var$N.UNAVAILABLE;
        case $780b92061aa4a3e6$var$ft.UNAUTHENTICATED:
            return $780b92061aa4a3e6$var$N.UNAUTHENTICATED;
        case $780b92061aa4a3e6$var$ft.INVALID_ARGUMENT:
            return $780b92061aa4a3e6$var$N.INVALID_ARGUMENT;
        case $780b92061aa4a3e6$var$ft.NOT_FOUND:
            return $780b92061aa4a3e6$var$N.NOT_FOUND;
        case $780b92061aa4a3e6$var$ft.ALREADY_EXISTS:
            return $780b92061aa4a3e6$var$N.ALREADY_EXISTS;
        case $780b92061aa4a3e6$var$ft.PERMISSION_DENIED:
            return $780b92061aa4a3e6$var$N.PERMISSION_DENIED;
        case $780b92061aa4a3e6$var$ft.FAILED_PRECONDITION:
            return $780b92061aa4a3e6$var$N.FAILED_PRECONDITION;
        case $780b92061aa4a3e6$var$ft.ABORTED:
            return $780b92061aa4a3e6$var$N.ABORTED;
        case $780b92061aa4a3e6$var$ft.OUT_OF_RANGE:
            return $780b92061aa4a3e6$var$N.OUT_OF_RANGE;
        case $780b92061aa4a3e6$var$ft.UNIMPLEMENTED:
            return $780b92061aa4a3e6$var$N.UNIMPLEMENTED;
        case $780b92061aa4a3e6$var$ft.DATA_LOSS:
            return $780b92061aa4a3e6$var$N.DATA_LOSS;
        default:
            return $780b92061aa4a3e6$var$fail(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($780b92061aa4a3e6$var$gt = $780b92061aa4a3e6$var$ft || ($780b92061aa4a3e6$var$ft = {}))[$780b92061aa4a3e6$var$gt.OK = 0] = "OK", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.CANCELLED = 1] = "CANCELLED", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.UNKNOWN = 2] = "UNKNOWN", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.NOT_FOUND = 5] = "NOT_FOUND", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.ABORTED = 10] = "ABORTED", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.INTERNAL = 13] = "INTERNAL", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.UNAVAILABLE = 14] = "UNAVAILABLE", $780b92061aa4a3e6$var$gt[$780b92061aa4a3e6$var$gt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $780b92061aa4a3e6$var$pt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$yt = new (0, $19e6a74148afb814$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $780b92061aa4a3e6$var$__PRIVATE_getMd5HashValue(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $19e6a74148afb814$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $780b92061aa4a3e6$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $19e6a74148afb814$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $19e6a74148afb814$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $780b92061aa4a3e6$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $780b92061aa4a3e6$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $780b92061aa4a3e6$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $780b92061aa4a3e6$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $780b92061aa4a3e6$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.fe = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.ge = (0, $19e6a74148afb814$export$70ffa26850098d01).fromNumber(this.fe);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    pe(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $19e6a74148afb814$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($780b92061aa4a3e6$var$yt) && (r = new (0, $19e6a74148afb814$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.ge).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    ye(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.fe) return !1;
        const t = $780b92061aa4a3e6$var$__PRIVATE_getMd5HashValue(e), [n, r] = $780b92061aa4a3e6$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.pe(n, r, e);
            if (!this.ye(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $780b92061aa4a3e6$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.fe) return;
        const t = $780b92061aa4a3e6$var$__PRIVATE_getMd5HashValue(e), [n, r] = $780b92061aa4a3e6$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.pe(n, r, e);
            this.we(t);
        }
    }
    we(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $780b92061aa4a3e6$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $780b92061aa4a3e6$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $780b92061aa4a3e6$var$RemoteEvent($780b92061aa4a3e6$var$SnapshotVersion.min(), r, new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator), $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap(), $780b92061aa4a3e6$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $780b92061aa4a3e6$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $780b92061aa4a3e6$var$TargetChange(n, t, $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), $780b92061aa4a3e6$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $780b92061aa4a3e6$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Se = e, this.removedTargetIds = t, this.key = n, this.be = r;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.De = t;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $780b92061aa4a3e6$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ve = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Ce = $780b92061aa4a3e6$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Fe = $780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.Me = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.xe = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.Me;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Fe;
    }
    /** Whether this target has pending target adds or target removes. */ get Oe() {
        return 0 !== this.ve;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Ne() {
        return this.xe;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Be(e) {
        e.approximateByteSize() > 0 && (this.xe = !0, this.Fe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ Le() {
        let e = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), t = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), n = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        return this.Ce.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $780b92061aa4a3e6$var$fail(38017, {
                        changeType: i
                    });
            }
        }), new $780b92061aa4a3e6$var$TargetChange(this.Fe, this.Me, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ ke() {
        this.xe = !1, this.Ce = $780b92061aa4a3e6$var$__PRIVATE_snapshotChangesMap();
    }
    qe(e, t) {
        this.xe = !0, this.Ce = this.Ce.insert(e, t);
    }
    Qe(e) {
        this.xe = !0, this.Ce = this.Ce.remove(e);
    }
    $e() {
        this.ve += 1;
    }
    Ue() {
        this.ve -= 1, $780b92061aa4a3e6$var$__PRIVATE_hardAssert(this.ve >= 0, 3241, {
            ve: this.ve
        });
    }
    Ke() {
        this.xe = !0, this.Me = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $780b92061aa4a3e6$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.We = e, /** The internal state of all tracked targets. */ this.Ge = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.ze = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap(), this.je = $780b92061aa4a3e6$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.Je = $780b92061aa4a3e6$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.He = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ye(e) {
        for (const t of e.Se)e.be && e.be.isFoundDocument() ? this.Ze(t, e.be) : this.Xe(t, e.key, e.be);
        for (const t of e.removedTargetIds)this.Xe(t, e.key, e.be);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ et(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.tt(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.nt(t) && n.Be(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ue(), n.Oe || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.ke(), n.Be(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ue(), n.Oe || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.nt(t) && (n.Ke(), n.Be(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.nt(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.rt(t), n.Be(e.resumeToken));
                    break;
                default:
                    $780b92061aa4a3e6$var$fail(56790, {
                        state: e.state
                    });
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Ge.forEach((e, n)=>{
            this.nt(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ it(e) {
        const t = e.targetId, n = e.De.count, r = this.st(t);
        if (r) {
            const i = r.target;
            if ($780b92061aa4a3e6$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $780b92061aa4a3e6$export$afc2e57c475b7810(i.path);
                    this.Xe(t, e, $780b92061aa4a3e6$var$MutableDocument.newNoDocument(e, $780b92061aa4a3e6$var$SnapshotVersion.min()));
                } else $780b92061aa4a3e6$var$__PRIVATE_hardAssert(1 === n, 20013, {
                    expectedCount: n
                });
            } else {
                const r = this.ot(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this._t(e), i = n ? this.ut(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.rt(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.He = this.He.insert(t, e);
                    }
                    null == $780b92061aa4a3e6$var$pt || $780b92061aa4a3e6$var$pt.ct(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        var s, o, _, a, u, c;
                        const l = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, h = t.unchangedNames;
                        h && (l.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                            mightContain: (e)=>{
                                var t;
                                return null !== (t = null == r ? void 0 : r.mightContain(e)) && void 0 !== t && t;
                            }
                        });
                        return l;
                    }(r, e.De, this.We.lt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ _t(e) {
        const t = e.De.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $780b92061aa4a3e6$var$__PRIVATE_Base64DecodeError) return $780b92061aa4a3e6$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $780b92061aa4a3e6$var$BloomFilter(s, r, i);
        } catch (e) {
            return $780b92061aa4a3e6$export$86cd73f49cc6e0bb(e instanceof $780b92061aa4a3e6$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.fe ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ ut(e, t, n) {
        return t.De.count === n - this.ht(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ ht(e, t) {
        const n = this.We.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.We.lt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.Xe(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Pt(e) {
        const t = new Map;
        this.Ge.forEach((n, r)=>{
            const i = this.st(r);
            if (i) {
                if (n.current && $780b92061aa4a3e6$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $780b92061aa4a3e6$export$afc2e57c475b7810(i.target.path);
                    this.Tt(t).has(r) || this.It(r, t) || this.Xe(r, t, $780b92061aa4a3e6$var$MutableDocument.newNoDocument(t, e));
                }
                n.Ne && (t.set(r, n.Le()), n.ke());
            }
        });
        let n = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Je.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.st(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.ze.forEach((t, n)=>n.setReadTime(e));
        const r = new $780b92061aa4a3e6$var$RemoteEvent(e, t, this.He, this.ze, n);
        return this.ze = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap(), this.je = $780b92061aa4a3e6$var$__PRIVATE_documentTargetMap(), this.Je = $780b92061aa4a3e6$var$__PRIVATE_documentTargetMap(), this.He = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ze(e, t) {
        if (!this.nt(e)) return;
        const n = this.It(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.tt(e).qe(t.key, n), this.ze = this.ze.insert(t.key, t), this.je = this.je.insert(t.key, this.Tt(t.key).add(e)), this.Je = this.Je.insert(t.key, this.dt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Xe(e, t, n) {
        if (!this.nt(e)) return;
        const r = this.tt(e);
        this.It(e, t) ? r.qe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Qe(t), this.Je = this.Je.insert(t, this.dt(t).delete(e)), this.Je = this.Je.insert(t, this.dt(t).add(e)), n && (this.ze = this.ze.insert(t, n));
    }
    removeTarget(e) {
        this.Ge.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ ot(e) {
        const t = this.tt(e).Le();
        return this.We.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ $e(e) {
        this.tt(e).$e();
    }
    tt(e) {
        let t = this.Ge.get(e);
        return t || (t = new $780b92061aa4a3e6$var$__PRIVATE_TargetState, this.Ge.set(e, t)), t;
    }
    dt(e) {
        let t = this.Je.get(e);
        return t || (t = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    Tt(e) {
        let t = this.je.get(e);
        return t || (t = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator), this.je = this.je.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ nt(e) {
        const t = null !== this.st(e);
        return t || $780b92061aa4a3e6$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ st(e) {
        const t = this.Ge.get(e);
        return t && t.Oe ? null : this.We.Et(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ rt(e) {
        this.Ge.set(e, new $780b92061aa4a3e6$var$__PRIVATE_TargetState);
        this.We.getRemoteKeysForTarget(e).forEach((t)=>{
            this.Xe(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ It(e, t) {
        return this.We.getRemoteKeysForTarget(e).has(t);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_documentTargetMap() {
    return new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
}
function $780b92061aa4a3e6$var$__PRIVATE_snapshotChangesMap() {
    return new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
}
const $780b92061aa4a3e6$var$wt = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $780b92061aa4a3e6$var$St = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $780b92061aa4a3e6$var$bt = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $780b92061aa4a3e6$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $780b92061aa4a3e6$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $780b92061aa4a3e6$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $780b92061aa4a3e6$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ /**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $780b92061aa4a3e6$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $780b92061aa4a3e6$var$__PRIVATE_toVersion(e, t) {
    return $780b92061aa4a3e6$var$toTimestamp(e, t.toTimestamp());
}
function $780b92061aa4a3e6$var$__PRIVATE_fromVersion(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!e, 49232), $780b92061aa4a3e6$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(e);
        return new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $780b92061aa4a3e6$var$__PRIVATE_toResourceName(e, t) {
    return $780b92061aa4a3e6$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $780b92061aa4a3e6$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $780b92061aa4a3e6$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $780b92061aa4a3e6$var$__PRIVATE_fromResourceName(e) {
    const t = $780b92061aa4a3e6$var$ResourcePath.fromString(e);
    return $780b92061aa4a3e6$var$__PRIVATE_hardAssert($780b92061aa4a3e6$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $780b92061aa4a3e6$var$__PRIVATE_toName(e, t) {
    return $780b92061aa4a3e6$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $780b92061aa4a3e6$var$fromName(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $780b92061aa4a3e6$var$__PRIVATE_toQueryPath(e, t) {
    return $780b92061aa4a3e6$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $780b92061aa4a3e6$var$__PRIVATE_fromQueryPath(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $780b92061aa4a3e6$var$ResourcePath.emptyPath() : $780b92061aa4a3e6$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $780b92061aa4a3e6$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $780b92061aa4a3e6$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $780b92061aa4a3e6$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $780b92061aa4a3e6$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $780b92061aa4a3e6$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $780b92061aa4a3e6$var$fromName(e, t.name), i = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.createTime) : $780b92061aa4a3e6$var$SnapshotVersion.min(), o = new $780b92061aa4a3e6$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $780b92061aa4a3e6$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $780b92061aa4a3e6$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $780b92061aa4a3e6$var$fromName(e, t.found.name), r = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.found.createTime) : $780b92061aa4a3e6$var$SnapshotVersion.min(), s = new $780b92061aa4a3e6$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $780b92061aa4a3e6$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!t.missing, 3894), $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!t.readTime, 22933);
        const n = $780b92061aa4a3e6$var$fromName(e, t.missing), r = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.readTime);
        return $780b92061aa4a3e6$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $780b92061aa4a3e6$var$fail(7234, {
        result: t
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $780b92061aa4a3e6$var$fail(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t, 58123), $780b92061aa4a3e6$export$67460cdabfa21253.fromBase64String(t || "")) : ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $780b92061aa4a3e6$require$Buffer || t instanceof Uint8Array, 16193), $780b92061aa4a3e6$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $780b92061aa4a3e6$var$N.UNKNOWN : $780b92061aa4a3e6$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $780b92061aa4a3e6$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $780b92061aa4a3e6$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $780b92061aa4a3e6$var$fromName(e, r.document.name), s = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $780b92061aa4a3e6$var$__PRIVATE_fromVersion(r.document.createTime) : $780b92061aa4a3e6$var$SnapshotVersion.min(), _ = new $780b92061aa4a3e6$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $780b92061aa4a3e6$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $780b92061aa4a3e6$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $780b92061aa4a3e6$var$fromName(e, r.document), s = r.readTime ? $780b92061aa4a3e6$var$__PRIVATE_fromVersion(r.readTime) : $780b92061aa4a3e6$var$SnapshotVersion.min(), o = $780b92061aa4a3e6$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $780b92061aa4a3e6$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $780b92061aa4a3e6$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $780b92061aa4a3e6$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $780b92061aa4a3e6$var$fail(11601, {
            At: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $780b92061aa4a3e6$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $780b92061aa4a3e6$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $780b92061aa4a3e6$var$toMutation(e, t) {
    let n;
    if (t instanceof $780b92061aa4a3e6$var$__PRIVATE_SetMutation) n = {
        update: $780b92061aa4a3e6$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $780b92061aa4a3e6$var$__PRIVATE_DeleteMutation) n = {
        delete: $780b92061aa4a3e6$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $780b92061aa4a3e6$var$__PRIVATE_PatchMutation) n = {
        update: $780b92061aa4a3e6$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $780b92061aa4a3e6$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $780b92061aa4a3e6$var$__PRIVATE_VerifyMutation)) return $780b92061aa4a3e6$var$fail(16599, {
            Rt: t.type
        });
        n = {
            verify: $780b92061aa4a3e6$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Ee
            };
            throw $780b92061aa4a3e6$var$fail(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $780b92061aa4a3e6$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $780b92061aa4a3e6$var$fail(27497);
    }(e, t.precondition)), n;
}
function $780b92061aa4a3e6$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $780b92061aa4a3e6$var$Precondition.updateTime($780b92061aa4a3e6$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $780b92061aa4a3e6$var$Precondition.exists(e.exists) : $780b92061aa4a3e6$var$Precondition.none();
    }(t.currentDocument) : $780b92061aa4a3e6$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $780b92061aa4a3e6$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $780b92061aa4a3e6$var$fail(16584, {
                proto: t
            });
            const r = $780b92061aa4a3e6$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $780b92061aa4a3e6$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $780b92061aa4a3e6$var$fromName(e, t.update.name), s = new $780b92061aa4a3e6$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $780b92061aa4a3e6$var$FieldMask(t.map((e)=>$780b92061aa4a3e6$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $780b92061aa4a3e6$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $780b92061aa4a3e6$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $780b92061aa4a3e6$var$fromName(e, t.delete);
        return new $780b92061aa4a3e6$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $780b92061aa4a3e6$var$fromName(e, t.verify);
        return new $780b92061aa4a3e6$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $780b92061aa4a3e6$var$fail(1463, {
        proto: t
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $780b92061aa4a3e6$var$__PRIVATE_fromVersion(e.updateTime) : $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t);
            return n.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t)), new $780b92061aa4a3e6$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $780b92061aa4a3e6$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $780b92061aa4a3e6$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $780b92061aa4a3e6$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $780b92061aa4a3e6$var$__PRIVATE_toFilter($780b92061aa4a3e6$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $780b92061aa4a3e6$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $780b92061aa4a3e6$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        Vt: n,
        parent: i
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { Vt: i, parent: s } = $780b92061aa4a3e6$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        ft: o,
        parent: s
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $780b92061aa4a3e6$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_fromFilter(e);
        if (t instanceof $780b92061aa4a3e6$var$CompositeFilter && $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $780b92061aa4a3e6$var$OrderBy($780b92061aa4a3e6$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $780b92061aa4a3e6$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $780b92061aa4a3e6$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $780b92061aa4a3e6$var$Bound(n, t);
    }(n.endAt)), $780b92061aa4a3e6$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $780b92061aa4a3e6$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $780b92061aa4a3e6$var$fail(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $780b92061aa4a3e6$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $780b92061aa4a3e6$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $780b92061aa4a3e6$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $780b92061aa4a3e6$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $780b92061aa4a3e6$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $780b92061aa4a3e6$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $780b92061aa4a3e6$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $780b92061aa4a3e6$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $780b92061aa4a3e6$var$fail(61313);
            default:
                return $780b92061aa4a3e6$var$fail(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $780b92061aa4a3e6$var$FieldFilter.create($780b92061aa4a3e6$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $780b92061aa4a3e6$var$fail(58110);
                default:
                    return $780b92061aa4a3e6$var$fail(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $780b92061aa4a3e6$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $780b92061aa4a3e6$var$fail(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $780b92061aa4a3e6$var$fail(30097, {
        filter: e
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_toDirection(e) {
    return $780b92061aa4a3e6$var$wt[e];
}
function $780b92061aa4a3e6$var$__PRIVATE_toOperatorName(e) {
    return $780b92061aa4a3e6$var$St[e];
}
function $780b92061aa4a3e6$var$__PRIVATE_toCompositeOperatorName(e) {
    return $780b92061aa4a3e6$var$bt[e];
}
function $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_fromFieldPathReference(e) {
    return $780b92061aa4a3e6$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $780b92061aa4a3e6$var$__PRIVATE_toFilter(e) {
    return e instanceof $780b92061aa4a3e6$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($780b92061aa4a3e6$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($780b92061aa4a3e6$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($780b92061aa4a3e6$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($780b92061aa4a3e6$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $780b92061aa4a3e6$var$__PRIVATE_toFieldPathReference(e.field),
                op: $780b92061aa4a3e6$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $780b92061aa4a3e6$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$780b92061aa4a3e6$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $780b92061aa4a3e6$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $780b92061aa4a3e6$var$fail(54877, {
        filter: e
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $780b92061aa4a3e6$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $780b92061aa4a3e6$var$SnapshotVersion.min(), s = $780b92061aa4a3e6$var$SnapshotVersion.min(), o = $780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $780b92061aa4a3e6$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $780b92061aa4a3e6$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $780b92061aa4a3e6$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $780b92061aa4a3e6$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $780b92061aa4a3e6$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.gt = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $780b92061aa4a3e6$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $780b92061aa4a3e6$var$__PRIVATE_fromDocument(e.gt, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $780b92061aa4a3e6$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $780b92061aa4a3e6$var$fail(56709);
        {
            const e = $780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $780b92061aa4a3e6$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $780b92061aa4a3e6$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $780b92061aa4a3e6$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $780b92061aa4a3e6$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $780b92061aa4a3e6$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $780b92061aa4a3e6$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $780b92061aa4a3e6$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.gt, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $780b92061aa4a3e6$var$fail(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $780b92061aa4a3e6$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $780b92061aa4a3e6$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$780b92061aa4a3e6$var$__PRIVATE_fromMutation(e.gt, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$780b92061aa4a3e6$var$__PRIVATE_fromMutation(e.gt, t)), i = $780b92061aa4a3e6$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $780b92061aa4a3e6$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $780b92061aa4a3e6$var$__PRIVATE_fromDbTarget(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $780b92061aa4a3e6$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $780b92061aa4a3e6$var$__PRIVATE_hardAssert(1 === t, 1966, {
            count: t
        }), $780b92061aa4a3e6$var$__PRIVATE_queryToTarget($780b92061aa4a3e6$var$__PRIVATE_newQueryForPath($780b92061aa4a3e6$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_queryToTarget($780b92061aa4a3e6$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $780b92061aa4a3e6$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $780b92061aa4a3e6$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $780b92061aa4a3e6$var$__PRIVATE_toDbTarget(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $780b92061aa4a3e6$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $780b92061aa4a3e6$var$__PRIVATE_toDocumentsTarget(e.gt, t.target) : $780b92061aa4a3e6$var$__PRIVATE_toQueryTarget(e.gt, t.target).Vt;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $780b92061aa4a3e6$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $780b92061aa4a3e6$var$__PRIVATE_fromBundledQuery(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $780b92061aa4a3e6$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $780b92061aa4a3e6$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $780b92061aa4a3e6$var$Overlay(t.largestBatchId, $780b92061aa4a3e6$var$__PRIVATE_fromMutation(e.gt, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $780b92061aa4a3e6$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $780b92061aa4a3e6$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp($780b92061aa4a3e6$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $780b92061aa4a3e6$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $780b92061aa4a3e6$var$__PRIVATE_toDbTimestamp($780b92061aa4a3e6$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_bundlesStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$we);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_namedQueriesStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$be);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static yt(e, t) {
        const n = t.uid || "";
        return new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_documentOverlayStore(e).get($780b92061aa4a3e6$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $780b92061aa4a3e6$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap();
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $780b92061aa4a3e6$var$Overlay(t, i);
            r.push(this.wt(e, s));
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($780b92061aa4a3e6$var$__PRIVATE_documentOverlayStore(e).Y($780b92061aa4a3e6$var$Ke, r));
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap(), i = $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $780b92061aa4a3e6$var$__PRIVATE_documentOverlayStore(e).j($780b92061aa4a3e6$var$Ke, s).next((e)=>{
            for (const t of e){
                const e = $780b92061aa4a3e6$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $780b92061aa4a3e6$var$__PRIVATE_documentOverlayStore(e).X({
            index: $780b92061aa4a3e6$var$Ge,
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $780b92061aa4a3e6$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    wt(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $780b92061aa4a3e6$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $780b92061aa4a3e6$var$toMutation(e.gt, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_documentOverlayStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$$e);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbGlobalsCache {
    St(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$je);
    }
    getSessionToken(e) {
        return this.St(e).get("sessionToken").next((e)=>{
            const t = null == e ? void 0 : e.value;
            return t ? $780b92061aa4a3e6$export$67460cdabfa21253.fromUint8Array(t) : $780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.St(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ bt(e, t) {
        this.Dt(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.vt();
    }
    Dt(e, t) {
        if ("nullValue" in e) this.Ct(t, 5);
        else if ("booleanValue" in e) this.Ct(t, 10), t.Ft(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Ct(t, 15), t.Ft($780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Ct(t, 13) : (this.Ct(t, 15), $780b92061aa4a3e6$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.Ft(0) : t.Ft(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Ct(t, 20), "string" == typeof n && (n = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(n)), t.Mt(`${n.seconds || ""}`), t.Ft(n.nanos || 0);
        } else if ("stringValue" in e) this.xt(e.stringValue, t), this.Ot(t);
        else if ("bytesValue" in e) this.Ct(t, 30), t.Nt($780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Ot(t);
        else if ("referenceValue" in e) this.Bt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Ct(t, 45), t.Ft(n.latitude || 0), t.Ft(n.longitude || 0);
        } else "mapValue" in e ? $780b92061aa4a3e6$var$__PRIVATE_isMaxValue(e) ? this.Ct(t, Number.MAX_SAFE_INTEGER) : $780b92061aa4a3e6$var$__PRIVATE_isVectorValue(e) ? this.Lt(e.mapValue, t) : (this.kt(e.mapValue, t), this.Ot(t)) : "arrayValue" in e ? (this.qt(e.arrayValue, t), this.Ot(t)) : $780b92061aa4a3e6$var$fail(19022, {
            Qt: e
        });
    }
    xt(e, t) {
        this.Ct(t, 25), this.$t(e, t);
    }
    $t(e, t) {
        t.Mt(e);
    }
    kt(e, t) {
        const n = e.fields || {};
        this.Ct(t, 55);
        for (const e of Object.keys(n))this.xt(e, t), this.Dt(n[e], t);
    }
    Lt(e, t) {
        var n, r;
        const i = e.fields || {};
        this.Ct(t, 53);
        // Vectors sort first by length
        const s = $780b92061aa4a3e6$var$Tt, o = (null === (r = null === (n = i[s].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.length) || 0;
        this.Ct(t, 15), t.Ft($780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(o)), // Vectors then sort by position value
        this.xt(s, t), this.Dt(i[s], t);
    }
    qt(e, t) {
        const n = e.values || [];
        this.Ct(t, 50);
        for (const e of n)this.Dt(e, t);
    }
    Bt(e, t) {
        this.Ct(t, 37);
        $780b92061aa4a3e6$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.Ct(t, 60), this.$t(e, t);
        });
    }
    Ct(e, t) {
        e.Ft(t);
    }
    Ot(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Ft(2);
    }
}
$780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter.Ut = new $780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $780b92061aa4a3e6$var$Dt = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $780b92061aa4a3e6$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $780b92061aa4a3e6$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $780b92061aa4a3e6$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $780b92061aa4a3e6$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Kt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Wt(n.value), n = t.next();
        this.Gt();
    }
    zt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.jt(n.value), n = t.next();
        this.Jt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Ht(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Wt(e);
            else if (e < 2048) this.Wt(960 | e >>> 6), this.Wt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Wt(480 | e >>> 12), this.Wt(128 | 63 & e >>> 6), this.Wt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Wt(240 | e >>> 18), this.Wt(128 | 63 & e >>> 12), this.Wt(128 | 63 & e >>> 6), this.Wt(128 | 63 & e);
            }
        }
        this.Gt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Yt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.jt(e);
            else if (e < 2048) this.jt(960 | e >>> 6), this.jt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.jt(480 | e >>> 12), this.jt(128 | 63 & e >>> 6), this.jt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.jt(240 | e >>> 18), this.jt(128 | 63 & e >>> 12), this.jt(128 | 63 & e >>> 6), this.jt(128 | 63 & e);
            }
        }
        this.Jt();
    }
    Zt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.Xt(e), n = $780b92061aa4a3e6$var$__PRIVATE_unsignedNumLength(t);
        this.en(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    tn(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.Xt(e), n = $780b92061aa4a3e6$var$__PRIVATE_unsignedNumLength(t);
        this.en(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ nn() {
        this.rn($780b92061aa4a3e6$var$Dt), this.rn(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ sn() {
        this._n($780b92061aa4a3e6$var$Dt), this._n(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.en(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ an() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Xt(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Wt(e) {
        const t = 255 & e;
        0 === t ? (this.rn(0), this.rn(255)) : t === $780b92061aa4a3e6$var$Dt ? (this.rn($780b92061aa4a3e6$var$Dt), this.rn(0)) : this.rn(t);
    }
    /** Writes a single byte descending to the buffer.  */ jt(e) {
        const t = 255 & e;
        0 === t ? (this._n(0), this._n(255)) : t === $780b92061aa4a3e6$var$Dt ? (this._n($780b92061aa4a3e6$var$Dt), this._n(0)) : this._n(e);
    }
    Gt() {
        this.rn(0), this.rn(1);
    }
    Jt() {
        this._n(0), this._n(1);
    }
    rn(e) {
        this.en(1), this.buffer[this.position++] = e;
    }
    _n(e) {
        this.en(1), this.buffer[this.position++] = ~e;
    }
    en(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.un = e;
    }
    Nt(e) {
        this.un.Kt(e);
    }
    Mt(e) {
        this.un.Ht(e);
    }
    Ft(e) {
        this.un.Zt(e);
    }
    vt() {
        this.un.nn();
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.un = e;
    }
    Nt(e) {
        this.un.zt(e);
    }
    Mt(e) {
        this.un.Yt(e);
    }
    Ft(e) {
        this.un.tn(e);
    }
    vt() {
        this.un.sn();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.un = new $780b92061aa4a3e6$var$__PRIVATE_OrderedCodeWriter, this.cn = new $780b92061aa4a3e6$var$__PRIVATE_AscendingIndexByteEncoder(this.un), this.ln = new $780b92061aa4a3e6$var$__PRIVATE_DescendingIndexByteEncoder(this.un);
    }
    seed(e) {
        this.un.seed(e);
    }
    hn(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.cn : this.ln;
    }
    an() {
        return this.un.an();
    }
    reset() {
        this.un.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $780b92061aa4a3e6$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.Pn = e, this.Tn = t, this.In = n, this.dn = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ En() {
        const e = this.dn.length, t = 0 === e || 255 === this.dn[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.dn, 0), t !== e ? n.set([
            0
        ], this.dn.length) : ++n[n.length - 1], new $780b92061aa4a3e6$var$__PRIVATE_IndexEntry(this.Pn, this.Tn, this.In, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    An(e, t, n) {
        return {
            indexId: this.Pn,
            uid: e,
            arrayValue: $780b92061aa4a3e6$var$__PRIVATE_encodeKeySafeBytes(this.In),
            directionalValue: $780b92061aa4a3e6$var$__PRIVATE_encodeKeySafeBytes(this.dn),
            orderedDocumentKey: $780b92061aa4a3e6$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    Rn(e, t, n) {
        const r = this.An(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.Pn - t.Pn;
    return 0 !== n ? n : (n = $780b92061aa4a3e6$var$__PRIVATE_compareByteArrays(e.In, t.In), 0 !== n ? n : (n = $780b92061aa4a3e6$var$__PRIVATE_compareByteArrays(e.dn, t.dn), 0 !== n ? n : $780b92061aa4a3e6$export$afc2e57c475b7810.comparator(e.Tn, t.Tn)));
}
function $780b92061aa4a3e6$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $780b92061aa4a3e6$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $abbde52b10a5c31f$export$ef10bcfb06572016)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $780b92061aa4a3e6$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $780b92061aa4a3e6$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Vn = new $780b92061aa4a3e6$var$SortedSet((e, t)=>$780b92061aa4a3e6$export$b7871852b967eaf1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.mn = e.orderBy, this.fn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Vn = this.Vn.add(e) : this.fn.push(e);
        }
    }
    get gn() {
        return this.Vn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ pn(e) {
        if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId, 49279), this.gn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.yn(t)) return !1;
        const n = $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.yn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.Vn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.Vn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.wn(e, t) || !this.Sn(this.mn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.mn.length || !this.Sn(this.mn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ bn() {
        if (this.gn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$export$b7871852b967eaf1.comparator);
        const t = [];
        for (const n of this.fn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $780b92061aa4a3e6$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $780b92061aa4a3e6$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.mn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $780b92061aa4a3e6$var$IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $780b92061aa4a3e6$var$FieldIndex($780b92061aa4a3e6$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $780b92061aa4a3e6$var$IndexState.empty());
    }
    yn(e) {
        for (const t of this.fn)if (this.wn(t, e)) return !0;
        return !1;
    }
    wn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    Sn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $780b92061aa4a3e6$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(e instanceof $780b92061aa4a3e6$var$FieldFilter || e instanceof $780b92061aa4a3e6$var$CompositeFilter, 20012), e instanceof $780b92061aa4a3e6$var$FieldFilter) {
        if (e instanceof $780b92061aa4a3e6$var$__PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t)=>$780b92061aa4a3e6$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t))) || [];
            return $780b92061aa4a3e6$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const r = e.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_computeInExpansion(e));
    return $780b92061aa4a3e6$var$CompositeFilter.create(r, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $780b92061aa4a3e6$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $780b92061aa4a3e6$var$__PRIVATE_computeDistributedNormalForm($780b92061aa4a3e6$var$__PRIVATE_computeInExpansion(e));
    return $780b92061aa4a3e6$var$__PRIVATE_hardAssert($780b92061aa4a3e6$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $780b92061aa4a3e6$var$__PRIVATE_isSingleFieldFilter(t) || $780b92061aa4a3e6$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $780b92061aa4a3e6$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $780b92061aa4a3e6$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $780b92061aa4a3e6$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $780b92061aa4a3e6$var$CompositeFilter && $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $780b92061aa4a3e6$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_isSingleFieldFilter(e) || $780b92061aa4a3e6$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $780b92061aa4a3e6$var$CompositeFilter && $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$780b92061aa4a3e6$var$__PRIVATE_isSingleFieldFilter(t) && !$780b92061aa4a3e6$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $780b92061aa4a3e6$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(e instanceof $780b92061aa4a3e6$var$FieldFilter || e instanceof $780b92061aa4a3e6$var$CompositeFilter, 34018), e instanceof $780b92061aa4a3e6$var$FieldFilter) return e;
    if (1 === e.filters.length) return $780b92061aa4a3e6$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $780b92061aa4a3e6$var$CompositeFilter.create(t, e.op);
    return n = $780b92061aa4a3e6$var$__PRIVATE_applyAssociation(n), $780b92061aa4a3e6$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(n instanceof $780b92061aa4a3e6$var$CompositeFilter, 64498), $780b92061aa4a3e6$var$__PRIVATE_hardAssert($780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $780b92061aa4a3e6$var$__PRIVATE_hardAssert(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$780b92061aa4a3e6$var$__PRIVATE_applyDistribution(e, t)));
}
function $780b92061aa4a3e6$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e instanceof $780b92061aa4a3e6$var$FieldFilter || e instanceof $780b92061aa4a3e6$var$CompositeFilter, 38388), $780b92061aa4a3e6$var$__PRIVATE_hardAssert(t instanceof $780b92061aa4a3e6$var$FieldFilter || t instanceof $780b92061aa4a3e6$var$CompositeFilter, 25473), // FieldFilter FieldFilter
    n = e instanceof $780b92061aa4a3e6$var$FieldFilter ? t instanceof $780b92061aa4a3e6$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $780b92061aa4a3e6$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $780b92061aa4a3e6$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $780b92061aa4a3e6$var$FieldFilter ? $780b92061aa4a3e6$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0, 48005), $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsConjunction(e) && $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsConjunction(t)) return $780b92061aa4a3e6$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_applyDistribution(e, r));
        return $780b92061aa4a3e6$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $780b92061aa4a3e6$var$__PRIVATE_applyAssociation(n);
}
function $780b92061aa4a3e6$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $780b92061aa4a3e6$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$780b92061aa4a3e6$var$__PRIVATE_applyDistribution(e, t));
        return $780b92061aa4a3e6$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $780b92061aa4a3e6$var$__PRIVATE_applyAssociation(e) {
    if ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(e instanceof $780b92061aa4a3e6$var$FieldFilter || e instanceof $780b92061aa4a3e6$var$CompositeFilter, 11850), e instanceof $780b92061aa4a3e6$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $780b92061aa4a3e6$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($780b92061aa4a3e6$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $780b92061aa4a3e6$var$FieldFilter ? r.push(t) : t instanceof $780b92061aa4a3e6$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $780b92061aa4a3e6$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Dn = new $780b92061aa4a3e6$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Dn.add(t), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.Dn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve($780b92061aa4a3e6$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve($780b92061aa4a3e6$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$vt = "IndexedDbIndexManager", $780b92061aa4a3e6$var$Ct = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.vn = new $780b92061aa4a3e6$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Cn = new $780b92061aa4a3e6$var$ObjectMap((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyTarget(e), (e, t)=>$780b92061aa4a3e6$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.vn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.vn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(r)
            };
            return $780b92061aa4a3e6$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $780b92061aa4a3e6$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $780b92061aa4a3e6$var$__PRIVATE_collectionParentsStore(e).j(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $780b92061aa4a3e6$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($780b92061aa4a3e6$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_indexConfigurationStore(e), r = $780b92061aa4a3e6$var$__PRIVATE_indexStateStore(e), i = $780b92061aa4a3e6$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_indexConfigurationStore(e), n = $780b92061aa4a3e6$var$__PRIVATE_indexEntriesStore(e), r = $780b92061aa4a3e6$var$__PRIVATE_indexStateStore(e);
        return t.Y().next(()=>n.Y()).next(()=>r.Y());
    }
    createTargetIndexes(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(this.Fn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $780b92061aa4a3e6$var$__PRIVATE_TargetIndexMatcher(t).bn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(this.Fn(t), (t)=>this.Mn(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
                const r = [];
                return $780b92061aa4a3e6$var$PersistencePromise.forEach(i, (i, s)=>{
                    $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$vt, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$780b92061aa4a3e6$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $780b92061aa4a3e6$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $780b92061aa4a3e6$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $780b92061aa4a3e6$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $780b92061aa4a3e6$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $780b92061aa4a3e6$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $780b92061aa4a3e6$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $780b92061aa4a3e6$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $780b92061aa4a3e6$var$Bound(n, r);
                    }(s, i), c = this.xn(i, s, a), l = this.xn(i, s, u), h = this.On(i, s, _), P = this.Nn(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $780b92061aa4a3e6$var$PersistencePromise.forEach(P, (i)=>n.H(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $780b92061aa4a3e6$var$PersistencePromise.resolve(null);
        });
    }
    Fn(e) {
        let t = this.Cn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $780b92061aa4a3e6$var$__PRIVATE_getDnfTerms($780b92061aa4a3e6$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$780b92061aa4a3e6$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Cn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ Nn(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Bn(t[c / a]) : $780b92061aa4a3e6$var$Ct, l = this.Ln(e, _, n[c % a], r), h = this.kn(e, _, i[c % a], s), P = o.map((t)=>this.Ln(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ Ln(e, t, n, r) {
        const i = new $780b92061aa4a3e6$var$__PRIVATE_IndexEntry(e, $780b92061aa4a3e6$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.En();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ kn(e, t, n, r) {
        const i = new $780b92061aa4a3e6$var$__PRIVATE_IndexEntry(e, $780b92061aa4a3e6$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.En() : i;
    }
    Mn(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.pn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.Fn(t);
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(r, (t)=>this.Mn(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ qn(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_IndexByteEncoder;
        for (const r of $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.hn(r.kind);
            $780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, i);
        }
        return n.an();
    }
    /** Encodes a single value to the ascending index format. */ Bn(e) {
        const t = new $780b92061aa4a3e6$var$__PRIVATE_IndexByteEncoder;
        return $780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, t.hn(0 /* IndexKind.ASCENDING */ )), t.an();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ Qn(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_IndexByteEncoder;
        return $780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt($780b92061aa4a3e6$var$__PRIVATE_refValue(this.databaseId, t), n.hn(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.an();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ On(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $780b92061aa4a3e6$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.$n(t, s.fieldPath) && $780b92061aa4a3e6$var$isArray(e)) r = this.Un(r, s, e);
            else {
                const t = n.hn(s.kind);
                $780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, t);
            }
        }
        return this.Kn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ xn(e, t, n) {
        return this.On(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ Kn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].an();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Un(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $780b92061aa4a3e6$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.an()), $780b92061aa4a3e6$var$__PRIVATE_FirestoreIndexValueWriter.Ut.bt(e, r.hn(t.kind)), i.push(r);
        }
        return i;
    }
    $n(e, t) {
        return !!e.filters.find((e)=>e instanceof $780b92061aa4a3e6$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_indexConfigurationStore(e), r = $780b92061aa4a3e6$var$__PRIVATE_indexStateStore(e);
        return (t ? n.j($780b92061aa4a3e6$var$Fe, IDBKeyRange.bound(t, t)) : n.j()).next((e)=>{
            const t = [];
            return $780b92061aa4a3e6$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $780b92061aa4a3e6$var$IndexState(t.sequenceNumber, new $780b92061aa4a3e6$var$IndexOffset($780b92061aa4a3e6$var$__PRIVATE_fromDbTimestamp(t.readTime), new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $780b92061aa4a3e6$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $780b92061aa4a3e6$var$IndexSegment($780b92061aa4a3e6$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $780b92061aa4a3e6$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_indexConfigurationStore(e), i = $780b92061aa4a3e6$var$__PRIVATE_indexStateStore(e);
        return this.Wn(e).next((e)=>r.j($780b92061aa4a3e6$var$Fe, IDBKeyRange.bound(t, t)).next((t)=>$780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t)=>i.put($780b92061aa4a3e6$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $780b92061aa4a3e6$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $780b92061aa4a3e6$var$PersistencePromise.forEach(i, (n)=>this.Gn(e, t, n).next((t)=>{
                        const i = this.zn(r, n);
                        return t.isEqual(i) ? $780b92061aa4a3e6$var$PersistencePromise.resolve() : this.jn(e, r, n, t, i);
                    }))));
        });
    }
    Jn(e, t, n, r) {
        return $780b92061aa4a3e6$var$__PRIVATE_indexEntriesStore(e).put(r.An(this.uid, this.Qn(n, t.key), t.key));
    }
    Hn(e, t, n, r) {
        return $780b92061aa4a3e6$var$__PRIVATE_indexEntriesStore(e).delete(r.Rn(this.uid, this.Qn(n, t.key), t.key));
    }
    Gn(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_indexEntriesStore(e);
        let i = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator);
        return r.X({
            index: $780b92061aa4a3e6$var$qe,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $780b92061aa4a3e6$var$__PRIVATE_encodeKeySafeBytes(this.Qn(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $780b92061aa4a3e6$var$__PRIVATE_IndexEntry(n.indexId, t, $780b92061aa4a3e6$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $780b92061aa4a3e6$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ zn(e, t) {
        let n = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator);
        const r = this.qn(t, e);
        if (null == r) return n;
        const i = $780b92061aa4a3e6$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($780b92061aa4a3e6$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $780b92061aa4a3e6$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Bn(i), r));
        } else n = n.add(new $780b92061aa4a3e6$var$__PRIVATE_IndexEntry(t.indexId, e.key, $780b92061aa4a3e6$var$Ct, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ jn(e, t, n, r, i) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$vt, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $780b92061aa4a3e6$var$__PRIVATE_advanceIterator(s), a = $780b92061aa4a3e6$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $780b92061aa4a3e6$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $780b92061aa4a3e6$var$__PRIVATE_advanceIterator(s)) : (_ = $780b92061aa4a3e6$var$__PRIVATE_advanceIterator(s), a = $780b92061aa4a3e6$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.Jn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Hn(e, t, n, r));
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(s);
    }
    Wn(e) {
        let t = 1;
        return $780b92061aa4a3e6$var$__PRIVATE_indexStateStore(e).X({
            index: $780b92061aa4a3e6$var$Ne,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator(i, e), s = $780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.En();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.En());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Yn(r[e], r[e + 1])) return [];
            const t = r[e].Rn(this.uid, $780b92061aa4a3e6$var$Ct, $780b92061aa4a3e6$export$afc2e57c475b7810.empty()), n = r[e + 1].Rn(this.uid, $780b92061aa4a3e6$var$Ct, $780b92061aa4a3e6$export$afc2e57c475b7810.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Yn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $780b92061aa4a3e6$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($780b92061aa4a3e6$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.mapArray(this.Fn(t), (t)=>this.Mn(e, t).next((e)=>e || $780b92061aa4a3e6$var$fail(44426))).next($780b92061aa4a3e6$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_collectionParentsStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$fe);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_indexEntriesStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$Le);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_indexConfigurationStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$ve);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_indexStateStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$xe);
}
function $780b92061aa4a3e6$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $780b92061aa4a3e6$var$__PRIVATE_hardAssert(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $780b92061aa4a3e6$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $780b92061aa4a3e6$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Ft = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $780b92061aa4a3e6$var$Mt = 41943040;
class $780b92061aa4a3e6$var$LruParams {
    static withCacheSize(e) {
        return new $780b92061aa4a3e6$var$LruParams(e, $780b92061aa4a3e6$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $780b92061aa4a3e6$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $780b92061aa4a3e6$var$removeMutationBatch(e, t, n) {
    const r = e.store($780b92061aa4a3e6$var$X), i = e.store($780b92061aa4a3e6$var$ie), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.X({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(1 === _, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $780b92061aa4a3e6$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $780b92061aa4a3e6$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $780b92061aa4a3e6$var$fail(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $780b92061aa4a3e6$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $780b92061aa4a3e6$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $780b92061aa4a3e6$var$LruParams.DEFAULT = new $780b92061aa4a3e6$var$LruParams($780b92061aa4a3e6$var$Mt, $780b92061aa4a3e6$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $780b92061aa4a3e6$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $780b92061aa4a3e6$var$LruParams.DISABLED = new $780b92061aa4a3e6$var$LruParams(-1, 0, 0);
class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Zn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static yt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e).X({
            index: $780b92061aa4a3e6$var$te,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $780b92061aa4a3e6$var$__PRIVATE_documentMutationsStore(e), s = $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $780b92061aa4a3e6$var$__PRIVATE_hardAssert("number" == typeof o, 49019);
            const _ = new $780b92061aa4a3e6$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$780b92061aa4a3e6$var$toMutation(e.gt, t)), i = n.mutations.map((t)=>$780b92061aa4a3e6$var$toMutation(e.gt, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $780b92061aa4a3e6$var$SortedSet((e, t)=>$780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $780b92061aa4a3e6$var$re));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Zn[o] = _.keys();
            }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Xn(e, t) {
        return this.Zn[t] ? $780b92061aa4a3e6$var$PersistencePromise.resolve(this.Zn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Zn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e).X({
            index: $780b92061aa4a3e6$var$te,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(t.batchId >= n, 47524, {
                er: n
            }), i = $780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $780b92061aa4a3e6$var$G;
        return $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e).X({
            index: $780b92061aa4a3e6$var$te,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $780b92061aa4a3e6$var$G
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e).j($780b92061aa4a3e6$var$te, t).next((e)=>e.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $780b92061aa4a3e6$var$__PRIVATE_documentMutationsStore(e).X({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $780b92061aa4a3e6$var$fail(61480, {
                    tr: n,
                    batchId: a
                });
                $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $780b92061aa4a3e6$var$__PRIVATE_documentMutationsStore(e).X({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(r).next(()=>this.nr(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator);
        return $780b92061aa4a3e6$var$__PRIVATE_documentMutationsStore(e).X({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.nr(e, o));
    }
    nr(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $780b92061aa4a3e6$var$fail(35274, {
                    batchId: t
                });
                $780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $780b92061aa4a3e6$var$removeMutationBatch(e.ce, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.rr(t.batchId);
            }), $780b92061aa4a3e6$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    rr(e) {
        delete this.Zn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $780b92061aa4a3e6$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $780b92061aa4a3e6$var$__PRIVATE_documentMutationsStore(e).X({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $780b92061aa4a3e6$var$__PRIVATE_hardAssert(0 === r.length, 56720, {
                    ir: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ sr(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $780b92061aa4a3e6$var$G,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $780b92061aa4a3e6$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $780b92061aa4a3e6$var$__PRIVATE_documentMutationsStore(e).X({
        range: s,
        Z: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_mutationsStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$X);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_documentMutationsStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$ie);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_mutationQueuesStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$Y);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $780b92061aa4a3e6$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this._r = e;
    }
    next() {
        return this._r += 2, this._r;
    }
    static ar() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $780b92061aa4a3e6$var$__PRIVATE_TargetIdGenerator(0);
    }
    static ur() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $780b92061aa4a3e6$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.cr(e).next((t)=>{
            const n = new $780b92061aa4a3e6$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.lr(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.cr(e).next((e)=>$780b92061aa4a3e6$var$SnapshotVersion.fromTimestamp(new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.cr(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.cr(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.lr(e, r)));
    }
    addTargetData(e, t) {
        return this.hr(e, t).next(()=>this.cr(e).next((n)=>(n.targetCount += 1, this.Pr(t, n), this.lr(e, n))));
    }
    updateTargetData(e, t) {
        return this.hr(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$780b92061aa4a3e6$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.cr(e)).next((t)=>($780b92061aa4a3e6$var$__PRIVATE_hardAssert(t.targetCount > 0, 8065), t.targetCount -= 1, this.lr(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $780b92061aa4a3e6$var$__PRIVATE_targetsStore(e).X((s, o)=>{
            const _ = $780b92061aa4a3e6$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$780b92061aa4a3e6$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_targetsStore(e).X((e, n)=>{
            const r = $780b92061aa4a3e6$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    cr(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_globalTargetStore(e).get($780b92061aa4a3e6$var$Ve).next((e)=>($780b92061aa4a3e6$var$__PRIVATE_hardAssert(null !== e, 2888), e));
    }
    lr(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_globalTargetStore(e).put($780b92061aa4a3e6$var$Ve, t);
    }
    hr(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_targetsStore(e).put($780b92061aa4a3e6$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Pr(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.cr(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $780b92061aa4a3e6$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $780b92061aa4a3e6$var$__PRIVATE_targetsStore(e).X({
            range: r,
            index: $780b92061aa4a3e6$var$Te
        }, (e, n, r)=>{
            const s = $780b92061aa4a3e6$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $780b92061aa4a3e6$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e);
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t)=>{
            const i = $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(t.path);
            return $780b92061aa4a3e6$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e);
        let i = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        return r.X({
            range: n,
            Z: !0
        }, (e, t, n)=>{
            const r = $780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(e[1]), s = new $780b92061aa4a3e6$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $780b92061aa4a3e6$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e).X({
            index: $780b92061aa4a3e6$var$Ae,
            Z: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    Et(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $780b92061aa4a3e6$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_targetsStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$Pe);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_globalTargetStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$me);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$de);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$xt = "LruGarbageCollector", $780b92061aa4a3e6$var$Ot = 1048576;
function $780b92061aa4a3e6$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $780b92061aa4a3e6$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Tr = e, this.buffer = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_bufferEntryComparator), this.Ir = 0;
    }
    dr() {
        return ++this.Ir;
    }
    Er(e) {
        const t = [
            e,
            this.dr()
        ];
        if (this.buffer.size < this.Tr) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $780b92061aa4a3e6$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $780b92061aa4a3e6$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Ar = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Rr(6e4);
    }
    stop() {
        this.Ar && (this.Ar.cancel(), this.Ar = null);
    }
    get started() {
        return null !== this.Ar;
    }
    Rr(e) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$xt, `Garbage collection scheduled in ${e}ms`), this.Ar = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Ar = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e) ? $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$xt, "Ignoring IndexedDB error during garbage collection: ", e) : await $780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Rr(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $780b92061aa4a3e6$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Vr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Vr.mr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $780b92061aa4a3e6$var$PersistencePromise.resolve($780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue);
        const n = new $780b92061aa4a3e6$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Vr.forEachTarget(e, (e)=>n.Er(e.sequenceNumber)).next(()=>this.Vr.gr(e, (e)=>n.Er(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Vr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Vr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($780b92061aa4a3e6$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $780b92061aa4a3e6$var$PersistencePromise.resolve($780b92061aa4a3e6$var$Ft)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($780b92061aa4a3e6$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $780b92061aa4a3e6$var$Ft) : this.pr(e, t));
    }
    getCacheSize(e) {
        return this.Vr.getCacheSize(e);
    }
    pr(e, t) {
        let n, r, i, s, o, _, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($780b92061aa4a3e6$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, _ = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $780b92061aa4a3e6$var$__PRIVATE_getLogLevel() <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).DEBUG) $780b92061aa4a3e6$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (_ - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - _) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $780b92061aa4a3e6$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $780b92061aa4a3e6$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $780b92061aa4a3e6$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    mr(e) {
        const t = this.yr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    yr(e) {
        let t = 0;
        return this.gr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    gr(e, t) {
        return this.wr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $780b92061aa4a3e6$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $780b92061aa4a3e6$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Sr(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $780b92061aa4a3e6$var$__PRIVATE_mutationQueuesStore(e).ee((r)=>$780b92061aa4a3e6$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $780b92061aa4a3e6$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.wr(e, (s, o)=>{
            if (o <= t) {
                const t = this.Sr(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $780b92061aa4a3e6$var$SnapshotVersion.min()), $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$780b92061aa4a3e6$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ wr(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e);
        let r, i = $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue;
        return n.X({
            index: $780b92061aa4a3e6$var$Ae
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue && t(new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue && t(new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_writeSentinelKey(e, t) {
    return $780b92061aa4a3e6$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $780b92061aa4a3e6$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $780b92061aa4a3e6$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $780b92061aa4a3e6$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $780b92061aa4a3e6$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $780b92061aa4a3e6$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.br(e, n)));
    }
    getEntry(e, t) {
        let n = $780b92061aa4a3e6$var$MutableDocument.newInvalidDocument(t);
        return $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $780b92061aa4a3e6$var$_e,
            range: IDBKeyRange.only($780b92061aa4a3e6$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.Dr(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ vr(e, t) {
        let n = {
            size: 0,
            document: $780b92061aa4a3e6$var$MutableDocument.newInvalidDocument(t)
        };
        return $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $780b92061aa4a3e6$var$_e,
            range: IDBKeyRange.only($780b92061aa4a3e6$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.Dr(t, r),
                size: $780b92061aa4a3e6$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
        return this.Cr(e, t, (e, t)=>{
            const r = this.Dr(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ Fr(e, t) {
        let n = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap(), r = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
        return this.Cr(e, t, (e, t)=>{
            const i = this.Dr(e, t);
            n = n.insert(e, i), r = r.insert(e, $780b92061aa4a3e6$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Mr: r
            }));
    }
    Cr(e, t, n) {
        if (t.isEmpty()) return $780b92061aa4a3e6$var$PersistencePromise.resolve();
        let r = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($780b92061aa4a3e6$var$__PRIVATE_dbKey(r.first()), $780b92061aa4a3e6$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $780b92061aa4a3e6$var$_e,
            range: i
        }, (e, t, r)=>{
            const i = $780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $780b92061aa4a3e6$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.G($780b92061aa4a3e6$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $780b92061aa4a3e6$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e).j(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            null == i || i.incrementDocumentReadCount(e.length);
            let n = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.Dr($780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($780b92061aa4a3e6$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
        const s = $780b92061aa4a3e6$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $780b92061aa4a3e6$var$__PRIVATE_dbCollectionGroupKey(t, $780b92061aa4a3e6$var$IndexOffset.max());
        return $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e).X({
            index: $780b92061aa4a3e6$var$ue,
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.Dr($780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_documentGlobalStore(e).get($780b92061aa4a3e6$var$he).next((e)=>($780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!e, 20021), e));
    }
    br(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_documentGlobalStore(e).put($780b92061aa4a3e6$var$he, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Dr(e, t) {
        if (t) {
            const e = $780b92061aa4a3e6$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min()))) return e;
        }
        return $780b92061aa4a3e6$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $780b92061aa4a3e6$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $780b92061aa4a3e6$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.Or = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Nr = new $780b92061aa4a3e6$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $780b92061aa4a3e6$var$SortedSet((e, t)=>$780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Nr.get(i);
            if (t.push(this.Or.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $780b92061aa4a3e6$var$__PRIVATE_toDbRemoteDocument(this.Or.serializer, s);
                r = r.add(i.path.popLast());
                const a = $780b92061aa4a3e6$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.Or.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $780b92061aa4a3e6$var$__PRIVATE_toDbRemoteDocument(this.Or.serializer, s.convertToNoDocument($780b92061aa4a3e6$var$SnapshotVersion.min()));
                t.push(this.Or.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.Or.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.Or.updateMetadata(e, n)), $780b92061aa4a3e6$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Or.vr(e, t).next((e)=>(this.Nr.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Or.Fr(e, t).next(({ documents: e, Mr: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Nr.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_documentGlobalStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$le);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_remoteDocumentsStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$se);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $780b92061aa4a3e6$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $780b92061aa4a3e6$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $780b92061aa4a3e6$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $780b92061aa4a3e6$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $780b92061aa4a3e6$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $780b92061aa4a3e6$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $780b92061aa4a3e6$var$FieldMask.empty(), $780b92061aa4a3e6$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $780b92061aa4a3e6$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet()) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $780b92061aa4a3e6$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $780b92061aa4a3e6$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
        const s = $780b92061aa4a3e6$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $780b92061aa4a3e6$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $780b92061aa4a3e6$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $780b92061aa4a3e6$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $780b92061aa4a3e6$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>{
                var n;
                return o.set(e, new $780b92061aa4a3e6$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $780b92061aa4a3e6$var$SortedMap((e, t)=>e - t), i = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $780b92061aa4a3e6$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $780b92061aa4a3e6$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $780b92061aa4a3e6$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $780b92061aa4a3e6$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $780b92061aa4a3e6$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $780b92061aa4a3e6$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $780b92061aa4a3e6$var$PersistencePromise.resolve($780b92061aa4a3e6$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = $780b92061aa4a3e6$var$Q, _ = i;
            return s.next((t)=>$780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $780b92061aa4a3e6$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $780b92061aa4a3e6$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $780b92061aa4a3e6$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $780b92061aa4a3e6$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $780b92061aa4a3e6$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $780b92061aa4a3e6$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$780b92061aa4a3e6$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $780b92061aa4a3e6$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $780b92061aa4a3e6$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $780b92061aa4a3e6$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $780b92061aa4a3e6$var$FieldMask.empty(), $780b92061aa4a3e6$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $780b92061aa4a3e6$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Br = new Map, this.Lr = new Map;
    }
    getBundleMetadata(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.Br.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Br.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $780b92061aa4a3e6$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.Lr.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Lr.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $780b92061aa4a3e6$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $780b92061aa4a3e6$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator), this.kr = new Map;
    }
    getOverlay(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap();
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.wt(e, t, r);
        }), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.kr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.kr.delete(n)), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $780b92061aa4a3e6$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $780b92061aa4a3e6$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $780b92061aa4a3e6$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(o);
    }
    wt(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.kr.get(r.largestBatchId).delete(n.key);
            this.kr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $780b92061aa4a3e6$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.kr.get(t);
        void 0 === i && (i = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), this.kr.set(t, i)), this.kr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $780b92061aa4a3e6$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.qr = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_DocReference.Qr), // A set of outstanding references to a document sorted by target id.
        this.$r = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_DocReference.Ur);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.qr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(e, t);
        this.qr = this.qr.add(n), this.$r = this.$r.add(n);
    }
    /** Add references to the given document keys for the given ID. */ Kr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Wr(new $780b92061aa4a3e6$var$__PRIVATE_DocReference(e, t));
    }
    Gr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ zr(e) {
        const t = new $780b92061aa4a3e6$export$afc2e57c475b7810(new $780b92061aa4a3e6$var$ResourcePath([])), n = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t, e), r = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.$r.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Wr(e), i.push(e.key);
        }), i;
    }
    jr() {
        this.qr.forEach((e)=>this.Wr(e));
    }
    Wr(e) {
        this.qr = this.qr.delete(e), this.$r = this.$r.delete(e);
    }
    Jr(e) {
        const t = new $780b92061aa4a3e6$export$afc2e57c475b7810(new $780b92061aa4a3e6$var$ResourcePath([])), n = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t, e), r = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t, e + 1);
        let i = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        return this.$r.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(e, 0), n = this.qr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.Hr = t;
    }
    /** Compare by key then by ID */ static Qr(e, t) {
        return $780b92061aa4a3e6$export$afc2e57c475b7810.comparator(e.key, t.key) || $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr);
    }
    /** Compare by ID then by key */ static Ur(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr) || $780b92061aa4a3e6$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.er = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Yr = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_DocReference.Qr);
    }
    checkEmpty(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.er;
        this.er++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $780b92061aa4a3e6$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.Yr = this.Yr.add(new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.Zr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Xr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $780b92061aa4a3e6$var$G : this.er - 1);
    }
    getAllMutationBatches(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t, 0), r = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.Yr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Zr(e.Hr);
            i.push(t);
        }), $780b92061aa4a3e6$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(e, 0), r = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.Yr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.Hr);
            });
        }), $780b92061aa4a3e6$var$PersistencePromise.resolve(this.ei(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(new $780b92061aa4a3e6$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator);
        return this.Yr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.Hr)), !0);
        }, s), $780b92061aa4a3e6$var$PersistencePromise.resolve(this.ei(o));
    }
    ei(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Zr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(0 === this.ti(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.Yr;
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.Yr = n;
        });
    }
    rr(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_DocReference(t, 0), r = this.Yr.firstAfterOrEqual(n);
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ti(e, t) {
        return this.Xr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ Xr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Zr(e) {
        const t = this.Xr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.ni = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.ni(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $780b92061aa4a3e6$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $780b92061aa4a3e6$var$MutableDocument.newInvalidDocument(e));
        }), $780b92061aa4a3e6$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $780b92061aa4a3e6$export$afc2e57c475b7810(s.child("__id-9223372036854775808__")), _ = this.docs.getIteratorFrom(o);
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $780b92061aa4a3e6$var$__PRIVATE_indexOffsetComparator($780b92061aa4a3e6$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $780b92061aa4a3e6$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $780b92061aa4a3e6$var$fail(9500);
    }
    ri(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $780b92061aa4a3e6$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $780b92061aa4a3e6$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.Or = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.Or.addEntry(e, r)) : this.Or.removeEntry(n);
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.Or.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.Or.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.ii = new $780b92061aa4a3e6$var$ObjectMap((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyTarget(e), $780b92061aa4a3e6$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $780b92061aa4a3e6$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.si = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.oi = new $780b92061aa4a3e6$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this._i = $780b92061aa4a3e6$var$__PRIVATE_TargetIdGenerator.ar();
    }
    forEachTarget(e, t) {
        return this.ii.forEach((e, n)=>t(n)), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.si);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this._i.next(), $780b92061aa4a3e6$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.si && (this.si = t), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    hr(e) {
        this.ii.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this._i = new $780b92061aa4a3e6$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.si && (this.si = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.hr(t), this.targetCount += 1, $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.hr(t), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.ii.delete(t.target), this.oi.zr(t.targetId), this.targetCount -= 1, $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.ii.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.ii.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.ii.get(t) || null;
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.oi.Kr(t, n), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.oi.Gr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $780b92061aa4a3e6$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.oi.zr(t), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.oi.Jr(t);
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(this.oi.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.ai = {}, this.overlays = {}, this.ui = new $780b92061aa4a3e6$var$__PRIVATE_ListenSequence(0), this.ci = !1, this.ci = !0, this.li = new $780b92061aa4a3e6$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.hi = new $780b92061aa4a3e6$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $780b92061aa4a3e6$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $780b92061aa4a3e6$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.Pi(e)), this.serializer = new $780b92061aa4a3e6$var$__PRIVATE_LocalSerializer(t), this.Ti = new $780b92061aa4a3e6$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.ci = !1, Promise.resolve();
    }
    get started() {
        return this.ci;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $780b92061aa4a3e6$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.ai[e.toKey()];
        return n || (n = new $780b92061aa4a3e6$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.ai[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.li;
    }
    getTargetCache() {
        return this.hi;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Ti;
    }
    runTransaction(e, t, n) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $780b92061aa4a3e6$var$__PRIVATE_MemoryTransaction(this.ui.next());
        return this.referenceDelegate.Ii(), n(r).next((e)=>this.referenceDelegate.di(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Ei(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.or(Object.values(this.ai).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MemoryTransaction extends $780b92061aa4a3e6$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Ai = new $780b92061aa4a3e6$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Ri = null;
    }
    static Vi(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get mi() {
        if (this.Ri) return this.Ri;
        throw $780b92061aa4a3e6$var$fail(60996);
    }
    addReference(e, t, n) {
        return this.Ai.addReference(n, t), this.mi.delete(n.toString()), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Ai.removeReference(n, t), this.mi.add(n.toString()), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.mi.add(t.toString()), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Ai.zr(t.targetId).forEach((e)=>this.mi.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.mi.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Ii() {
        this.Ri = new Set;
    }
    di(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(this.mi, (n)=>{
            const r = $780b92061aa4a3e6$export$afc2e57c475b7810.fromPath(n);
            return this.fi(e, r).next((e)=>{
                e || t.removeEntry(r, $780b92061aa4a3e6$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Ri = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.fi(e, t).next((e)=>{
            e ? this.mi.delete(t.toString()) : this.mi.add(t.toString());
        });
    }
    Pi(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    fi(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.or([
            ()=>$780b92061aa4a3e6$var$PersistencePromise.resolve(this.Ai.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Ei(e, t)
        ]);
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.gi = new $780b92061aa4a3e6$var$ObjectMap((e)=>$780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $780b92061aa4a3e6$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static Vi(e, t) {
        return new $780b92061aa4a3e6$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Ii() {}
    di(e) {
        return $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    mr(e) {
        const t = this.yr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    yr(e) {
        let t = 0;
        return this.gr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    gr(e, t) {
        return $780b92061aa4a3e6$var$PersistencePromise.forEach(this.gi, (n, r)=>this.Sr(e, n, r).next((e)=>e ? $780b92061aa4a3e6$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.ri(e, (r)=>this.Sr(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $780b92061aa4a3e6$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.gi.set(t, e.currentSequenceNumber), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.gi.set(n, e.currentSequenceNumber), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.gi.set(n, e.currentSequenceNumber), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.gi.set(t, e.currentSequenceNumber), $780b92061aa4a3e6$var$PersistencePromise.resolve();
    }
    Pi(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $780b92061aa4a3e6$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    Sr(e, t, n) {
        return $780b92061aa4a3e6$var$PersistencePromise.or([
            ()=>this.persistence.Ei(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.gi.get(t);
                return $780b92061aa4a3e6$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $780b92061aa4a3e6$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ q(e, t, n, r) {
        const i = new $780b92061aa4a3e6$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($780b92061aa4a3e6$var$J);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($780b92061aa4a3e6$var$Y, {
                keyPath: $780b92061aa4a3e6$var$Z
            });
            const t = e.createObjectStore($780b92061aa4a3e6$var$X, {
                keyPath: $780b92061aa4a3e6$var$ee,
                autoIncrement: !0
            });
            t.createIndex($780b92061aa4a3e6$var$te, $780b92061aa4a3e6$var$ne, {
                unique: !0
            }), e.createObjectStore($780b92061aa4a3e6$var$ie);
        }(e), $780b92061aa4a3e6$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($780b92061aa4a3e6$var$j);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $780b92061aa4a3e6$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($780b92061aa4a3e6$var$de), e.deleteObjectStore($780b92061aa4a3e6$var$Pe), e.deleteObjectStore($780b92061aa4a3e6$var$me);
        }(e), $780b92061aa4a3e6$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($780b92061aa4a3e6$var$me), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $780b92061aa4a3e6$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($780b92061aa4a3e6$var$Ve, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($780b92061aa4a3e6$var$X);
                return n.j().next((n)=>{
                    e.deleteObjectStore($780b92061aa4a3e6$var$X);
                    e.createObjectStore($780b92061aa4a3e6$var$X, {
                        keyPath: $780b92061aa4a3e6$var$ee,
                        autoIncrement: !0
                    }).createIndex($780b92061aa4a3e6$var$te, $780b92061aa4a3e6$var$ne, {
                        unique: !0
                    });
                    const r = t.store($780b92061aa4a3e6$var$X), i = n.map((e)=>r.put(e));
                    return $780b92061aa4a3e6$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($780b92061aa4a3e6$var$pe, {
                    keyPath: $780b92061aa4a3e6$var$ye
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.pi(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($780b92061aa4a3e6$var$le);
            })(e), this.yi(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.wi(i))), n < 8 && r >= 8 && (s = s.next(()=>this.Si(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.bi(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($780b92061aa4a3e6$var$we, {
                    keyPath: $780b92061aa4a3e6$var$Se
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($780b92061aa4a3e6$var$be, {
                    keyPath: $780b92061aa4a3e6$var$De
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($780b92061aa4a3e6$var$$e, {
                    keyPath: $780b92061aa4a3e6$var$Ue
                });
                t.createIndex($780b92061aa4a3e6$var$Ke, $780b92061aa4a3e6$var$We, {
                    unique: !1
                }), t.createIndex($780b92061aa4a3e6$var$Ge, $780b92061aa4a3e6$var$ze, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($780b92061aa4a3e6$var$se, {
                    keyPath: $780b92061aa4a3e6$var$oe
                });
                t.createIndex($780b92061aa4a3e6$var$_e, $780b92061aa4a3e6$var$ae), t.createIndex($780b92061aa4a3e6$var$ue, $780b92061aa4a3e6$var$ce);
            })(e)).next(()=>this.Di(e, i)).next(()=>e.deleteObjectStore($780b92061aa4a3e6$var$j))), n < 14 && r >= 14 && (s = s.next(()=>this.Ci(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($780b92061aa4a3e6$var$ve, {
                    keyPath: $780b92061aa4a3e6$var$Ce,
                    autoIncrement: !0
                });
                t.createIndex($780b92061aa4a3e6$var$Fe, $780b92061aa4a3e6$var$Me, {
                    unique: !1
                });
                const n = e.createObjectStore($780b92061aa4a3e6$var$xe, {
                    keyPath: $780b92061aa4a3e6$var$Oe
                });
                n.createIndex($780b92061aa4a3e6$var$Ne, $780b92061aa4a3e6$var$Be, {
                    unique: !1
                });
                const r = e.createObjectStore($780b92061aa4a3e6$var$Le, {
                    keyPath: $780b92061aa4a3e6$var$ke
                });
                r.createIndex($780b92061aa4a3e6$var$qe, $780b92061aa4a3e6$var$Qe, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($780b92061aa4a3e6$var$xe).clear();
        }).next(()=>{
            t.objectStore($780b92061aa4a3e6$var$Le).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($780b92061aa4a3e6$var$je, {
                    keyPath: $780b92061aa4a3e6$var$Je
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $abbde52b10a5c31f$export$ef10bcfb06572016)() && (s = s.next(()=>{
            t.objectStore($780b92061aa4a3e6$var$xe).clear();
        }).next(()=>{
            t.objectStore($780b92061aa4a3e6$var$Le).clear();
        })), s;
    }
    yi(e) {
        let t = 0;
        return e.store($780b92061aa4a3e6$var$j).X((e, n)=>{
            t += $780b92061aa4a3e6$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($780b92061aa4a3e6$var$le).put($780b92061aa4a3e6$var$he, n);
        });
    }
    pi(e) {
        const t = e.store($780b92061aa4a3e6$var$Y), n = e.store($780b92061aa4a3e6$var$X);
        return t.j().next((t)=>$780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $780b92061aa4a3e6$var$G
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.j($780b92061aa4a3e6$var$te, r).next((n)=>$780b92061aa4a3e6$var$PersistencePromise.forEach(n, (n)=>{
                        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $780b92061aa4a3e6$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ wi(e) {
        const t = e.store($780b92061aa4a3e6$var$de), n = e.store($780b92061aa4a3e6$var$j);
        return e.store($780b92061aa4a3e6$var$me).get($780b92061aa4a3e6$var$Ve).next((e)=>{
            const r = [];
            return n.X((n, i)=>{
                const s = new $780b92061aa4a3e6$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $780b92061aa4a3e6$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$780b92061aa4a3e6$var$PersistencePromise.waitFor(r));
        });
    }
    Si(e, t) {
        // Create the index.
        e.createObjectStore($780b92061aa4a3e6$var$fe, {
            keyPath: $780b92061aa4a3e6$var$ge
        });
        const n = t.store($780b92061aa4a3e6$var$fe), r = new $780b92061aa4a3e6$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $780b92061aa4a3e6$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($780b92061aa4a3e6$var$j).X({
            Z: !0
        }, (e, t)=>{
            const n = new $780b92061aa4a3e6$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($780b92061aa4a3e6$var$ie).X({
                Z: !0
            }, ([e, t, n], r)=>{
                const i = $780b92061aa4a3e6$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    bi(e) {
        const t = e.store($780b92061aa4a3e6$var$Pe);
        return t.X((e, n)=>{
            const r = $780b92061aa4a3e6$var$__PRIVATE_fromDbTarget(n), i = $780b92061aa4a3e6$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    Di(e, t) {
        const n = t.store($780b92061aa4a3e6$var$j), r = [];
        return n.X((e, n)=>{
            const i = t.store($780b92061aa4a3e6$var$se), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $780b92061aa4a3e6$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $780b92061aa4a3e6$var$fail(36783);
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$780b92061aa4a3e6$var$PersistencePromise.waitFor(r));
    }
    Ci(e, t) {
        const n = t.store($780b92061aa4a3e6$var$X), r = $780b92061aa4a3e6$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $780b92061aa4a3e6$var$__PRIVATE_MemoryPersistence($780b92061aa4a3e6$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer.gt);
        return n.j().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
                $780b92061aa4a3e6$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>r = r.add(e)), n.set(e.userId, r);
            }), $780b92061aa4a3e6$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $780b92061aa4a3e6$var$User(n), o = $780b92061aa4a3e6$var$__PRIVATE_IndexedDbDocumentOverlayCache.yt(this.serializer, s), _ = i.getIndexManager(s), a = $780b92061aa4a3e6$var$__PRIVATE_IndexedDbMutationQueue.yt(s, this.serializer, _, i.referenceDelegate);
                return new $780b92061aa4a3e6$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransaction(t, $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue), e).next();
            });
        });
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($780b92061aa4a3e6$var$de, {
        keyPath: $780b92061aa4a3e6$var$Ee
    }).createIndex($780b92061aa4a3e6$var$Ae, $780b92061aa4a3e6$var$Re, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($780b92061aa4a3e6$var$Pe, {
        keyPath: "targetId"
    }).createIndex($780b92061aa4a3e6$var$Te, $780b92061aa4a3e6$var$Ie, {
        unique: !0
    }), e.createObjectStore($780b92061aa4a3e6$var$me);
}
const $780b92061aa4a3e6$var$Nt = "IndexedDbPersistence", $780b92061aa4a3e6$var$Bt = 18e5, $780b92061aa4a3e6$var$Lt = 5e3, $780b92061aa4a3e6$var$kt = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $780b92061aa4a3e6$var$qt = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Fi = i, this.window = s, this.document = o, this.Mi = a, this.xi = u, this.Oi = c, this.ui = null, this.ci = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Ni = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Bi = null, /** The client metadata refresh task. */ this.Li = null, /** The last time we garbage collected the client metadata object store. */ this.ki = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.qi = (e)=>Promise.resolve(), !$780b92061aa4a3e6$var$__PRIVATE_IndexedDbPersistence.C()) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Qi = t + $780b92061aa4a3e6$var$qt, this.serializer = new $780b92061aa4a3e6$var$__PRIVATE_LocalSerializer(_), this.$i = new $780b92061aa4a3e6$var$__PRIVATE_SimpleDb(this.Qi, this.Oi, new $780b92061aa4a3e6$var$__PRIVATE_SchemaConverter(this.serializer)), this.li = new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbGlobalsCache, this.hi = new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $780b92061aa4a3e6$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Ti = new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ui = this.window.localStorage : (this.Ui = null, !1 === u && $780b92061aa4a3e6$var$__PRIVATE_logError($780b92061aa4a3e6$var$Nt, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.Ki().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, $780b92061aa4a3e6$var$kt);
            return this.Wi(), this.Gi(), this.zi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.hi.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.ui = new $780b92061aa4a3e6$var$__PRIVATE_ListenSequence(e, this.Mi);
        }).then(()=>{
            this.ci = !0;
        }).catch((e)=>(this.$i && this.$i.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ ji(e) {
        return this.qi = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the underlying database receives
     * an event indicating that it either has been deleted or is pending deletion
     * and must be closed.
     *
     * For example, this callback will be called in the case that multi-tab
     * IndexedDB persistence is in use and another tab calls
     * clearIndexedDbPersistence(). In that case, this Firestore instance must
     * close its IndexedDB connection in order to allow the deletion initiated by
     * the other tab to proceed.
     *
     * This method may only be called once; subsequent invocations will result in
     * an exception, refusing to supersede the previously-registered listener.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.$i.setDatabaseDeletedListener(e);
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Fi.enqueueAndForget(async ()=>{
            this.started && await this.Ki();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ Ki() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$780b92061aa4a3e6$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.Ji(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Fi.enqueueRetryable(()=>this.qi(!1)));
                });
            }).next(()=>this.Hi(e)).next((t)=>this.isPrimary && !t ? this.Yi(e).next(()=>!1) : !!t && this.Zi(e).next(()=>!0))).catch((e)=>{
            if ($780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Nt, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Nt, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Fi.enqueueRetryable(()=>this.qi(e)), this.isPrimary = e;
        });
    }
    Ji(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_primaryClientStore(e).get($780b92061aa4a3e6$var$H).next((e)=>$780b92061aa4a3e6$var$PersistencePromise.resolve(this.Xi(e)));
    }
    es(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async ts() {
        if (this.isPrimary && !this.ns(this.ki, $780b92061aa4a3e6$var$Bt)) {
            this.ki = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$pe);
                return t.j().next((e)=>{
                    const n = this.rs(e, $780b92061aa4a3e6$var$Bt), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $780b92061aa4a3e6$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Ui) for (const t of e)this.Ui.removeItem(this.ss(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ zi() {
        this.Li = this.Fi.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.Ki().then(()=>this.ts()).then(()=>this.zi()));
    }
    /** Checks whether `client` is the local client. */ Xi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Hi(e) {
        if (this.xi) return $780b92061aa4a3e6$var$PersistencePromise.resolve(!0);
        return $780b92061aa4a3e6$var$__PRIVATE_primaryClientStore(e).get($780b92061aa4a3e6$var$H).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.ns(t.leaseTimestampMs, $780b92061aa4a3e6$var$Lt) && !this._s(t.ownerId)) {
                if (this.Xi(t) && this.networkEnabled) return !0;
                if (!this.Xi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, $780b92061aa4a3e6$var$kt);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $780b92061aa4a3e6$var$__PRIVATE_clientMetadataStore(e).j().next((e)=>void 0 === this.rs(e, $780b92061aa4a3e6$var$Lt).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Nt, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.ci = !1, this.us(), this.Li && (this.Li.cancel(), this.Li = null), this.cs(), this.ls(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.$i.runTransaction("shutdown", "readwrite", [
            $780b92061aa4a3e6$var$J,
            $780b92061aa4a3e6$var$pe
        ], (e)=>{
            const t = new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransaction(e, $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue);
            return this.Yi(t).next(()=>this.es(t));
        }), this.$i.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.hs();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ rs(e, t) {
        return e.filter((e)=>this.ns(e.updateTimeMs, t) && !this._s(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ps() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$780b92061aa4a3e6$var$__PRIVATE_clientMetadataStore(e).j().next((e)=>this.rs(e, $780b92061aa4a3e6$var$Bt).map((e)=>e.clientId)));
    }
    get started() {
        return this.ci;
    }
    getGlobalsCache() {
        return this.li;
    }
    getMutationQueue(e, t) {
        return $780b92061aa4a3e6$var$__PRIVATE_IndexedDbMutationQueue.yt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.hi;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.gt.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_IndexedDbDocumentOverlayCache.yt(this.serializer, e);
    }
    getBundleCache() {
        return this.Ti;
    }
    runTransaction(e, t, n) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Nt, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $780b92061aa4a3e6$var$rt : 17 === e ? $780b92061aa4a3e6$var$nt : 16 === e ? $780b92061aa4a3e6$var$tt : 15 === e ? $780b92061aa4a3e6$var$et : 14 === e ? $780b92061aa4a3e6$var$Xe : 13 === e ? $780b92061aa4a3e6$var$Ze : 12 === e ? $780b92061aa4a3e6$var$Ye : 11 === e ? $780b92061aa4a3e6$var$He : void $780b92061aa4a3e6$var$fail(60245);
        }(this.Oi);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.$i.runTransaction(e, r, i, (r)=>(s = new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbTransaction(r, this.ui ? this.ui.next() : $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue), "readwrite-primary" === t ? this.Ji(s).next((e)=>!!e || this.Hi(s)).next((t)=>{
                if (!t) throw $780b92061aa4a3e6$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Fi.enqueueRetryable(()=>this.qi(!1)), new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, $780b92061aa4a3e6$var$$);
                return n(s);
            }).next((e)=>this.Zi(s).next(()=>e)) : this.Ts(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ts(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_primaryClientStore(e).get($780b92061aa4a3e6$var$H).next((e)=>{
            if (null !== e && this.ns(e.leaseTimestampMs, $780b92061aa4a3e6$var$Lt) && !this._s(e.ownerId) && !this.Xi(e) && !(this.xi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, $780b92061aa4a3e6$var$kt);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Zi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $780b92061aa4a3e6$var$__PRIVATE_primaryClientStore(e).put($780b92061aa4a3e6$var$H, t);
    }
    static C() {
        return $780b92061aa4a3e6$var$__PRIVATE_SimpleDb.C();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Yi(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_primaryClientStore(e);
        return t.get($780b92061aa4a3e6$var$H).next((e)=>this.Xi(e) ? ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Nt, "Releasing primary lease."), t.delete($780b92061aa4a3e6$var$H)) : $780b92061aa4a3e6$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ ns(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($780b92061aa4a3e6$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Wi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Bi = ()=>{
            this.Fi.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.Ki()));
        }, this.document.addEventListener("visibilitychange", this.Bi), this.inForeground = "visible" === this.document.visibilityState);
    }
    cs() {
        this.Bi && (this.document.removeEventListener("visibilitychange", this.Bi), this.Bi = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Gi() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.Ni = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.us();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $abbde52b10a5c31f$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Fi.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Fi.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Ni));
    }
    ls() {
        this.Ni && (this.window.removeEventListener("pagehide", this.Ni), this.Ni = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ _s(e) {
        var t;
        try {
            const n = null !== (null === (t = this.Ui) || void 0 === t ? void 0 : t.getItem(this.ss(e)));
            return $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Nt, `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $780b92061aa4a3e6$var$__PRIVATE_logError($780b92061aa4a3e6$var$Nt, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ us() {
        if (this.Ui) try {
            this.Ui.setItem(this.ss(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $780b92061aa4a3e6$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ hs() {
        if (this.Ui) try {
            this.Ui.removeItem(this.ss(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    ss(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_primaryClientStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$J);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $780b92061aa4a3e6$var$__PRIVATE_clientMetadataStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_getStore(e, $780b92061aa4a3e6$var$pe);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $780b92061aa4a3e6$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $780b92061aa4a3e6$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Is = n, this.ds = r;
    }
    static Es(e, t) {
        let n = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), r = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $780b92061aa4a3e6$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $780b92061aa4a3e6$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $780b92061aa4a3e6$var$__PRIVATE_QueryEngine {
    constructor(){
        this.As = !1, this.Rs = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Vs = 100, this.fs = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $abbde52b10a5c31f$export$95df08bae54cb4df)() ? 8 : $780b92061aa4a3e6$var$__PRIVATE_getAndroidVersion((0, $abbde52b10a5c31f$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.gs = e, this.indexManager = t, this.As = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.ps(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.ys(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $780b92061aa4a3e6$var$QueryContext;
            return this.ws(e, t, n).next((r)=>{
                if (i.result = r, this.Rs) return this.Ss(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    Ss(e, t, n, r) {
        return n.documentReadCount < this.Vs ? ($780b92061aa4a3e6$var$__PRIVATE_getLogLevel() <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).DEBUG && $780b92061aa4a3e6$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $780b92061aa4a3e6$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Vs, "documents"), $780b92061aa4a3e6$var$PersistencePromise.resolve()) : ($780b92061aa4a3e6$var$__PRIVATE_getLogLevel() <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).DEBUG && $780b92061aa4a3e6$var$__PRIVATE_logDebug("QueryEngine", "Query:", $780b92061aa4a3e6$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.fs * r ? ($780b92061aa4a3e6$var$__PRIVATE_getLogLevel() <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).DEBUG && $780b92061aa4a3e6$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $780b92061aa4a3e6$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(t))) : $780b92061aa4a3e6$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ ps(e, t) {
        if ($780b92061aa4a3e6$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $780b92061aa4a3e6$var$PersistencePromise.resolve(null);
        let n = $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $780b92061aa4a3e6$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(...r);
                return this.gs.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.bs(t, r);
                        return this.Ds(t, s, i, n.readTime) ? this.ps(e, $780b92061aa4a3e6$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.vs(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ ys(e, t, n, r) {
        return $780b92061aa4a3e6$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min()) ? $780b92061aa4a3e6$var$PersistencePromise.resolve(null) : this.gs.getDocuments(e, n).next((i)=>{
            const s = this.bs(t, i);
            return this.Ds(t, s, n, r) ? $780b92061aa4a3e6$var$PersistencePromise.resolve(null) : ($780b92061aa4a3e6$var$__PRIVATE_getLogLevel() <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).DEBUG && $780b92061aa4a3e6$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $780b92061aa4a3e6$var$__PRIVATE_stringifyQuery(t)), this.vs(e, s, t, $780b92061aa4a3e6$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $780b92061aa4a3e6$var$Q)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ bs(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $780b92061aa4a3e6$var$SortedSet($780b92061aa4a3e6$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $780b92061aa4a3e6$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Ds(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    ws(e, t, n) {
        return $780b92061aa4a3e6$var$__PRIVATE_getLogLevel() <= (0, $c2975c8f4799263d$export$243e62d78d3b544d).DEBUG && $780b92061aa4a3e6$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $780b92061aa4a3e6$var$__PRIVATE_stringifyQuery(t)), this.gs.getDocumentsMatchingQuery(e, t, $780b92061aa4a3e6$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ vs(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.gs.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Qt = "LocalStore", $780b92061aa4a3e6$var$$t = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $780b92061aa4a3e6$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Cs = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Fs = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Ms = new $780b92061aa4a3e6$var$ObjectMap((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyTarget(e), $780b92061aa4a3e6$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.xs = new Map, this.Os = e.getRemoteDocumentCache(), this.hi = e.getTargetCache(), this.Ti = e.getBundleCache(), this.Ns(n);
    }
    Ns(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $780b92061aa4a3e6$var$LocalDocumentsView(this.Os, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Os.setIndexManager(this.indexManager), this.Cs.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.Fs));
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $780b92061aa4a3e6$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $780b92061aa4a3e6$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Ns(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Bs: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $780b92061aa4a3e6$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.Os.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $780b92061aa4a3e6$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $780b92061aa4a3e6$var$__PRIVATE_hardAssert(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $780b92061aa4a3e6$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.hi.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $780b92061aa4a3e6$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.Fs;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.Os.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Fs;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.hi.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.hi.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING, $780b92061aa4a3e6$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($780b92061aa4a3e6$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $780b92061aa4a3e6$var$$t) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && o.push(n.hi.updateTargetData(e, u));
        });
        let _ = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap(), a = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($780b92061aa4a3e6$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Ls, a = e.ks;
        })), !r.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min())) {
            const t = n.hi.getLastRemoteSnapshotVersion(e).next((t)=>n.hi.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $780b92061aa4a3e6$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.Fs = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $780b92061aa4a3e6$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), i = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Qt, "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Ls: r,
            ks: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $780b92061aa4a3e6$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $780b92061aa4a3e6$var$G), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $780b92061aa4a3e6$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.hi.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $780b92061aa4a3e6$var$PersistencePromise.resolve(r)) : n.hi.allocateTargetId(e).next((i)=>(r = new $780b92061aa4a3e6$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.hi.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.Fs.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.Fs = n.Fs.insert(e.targetId, e), n.Ms.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $780b92061aa4a3e6$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), i = r.Fs.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Qt, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.Fs = r.Fs.remove(t), r.Ms.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $780b92061aa4a3e6$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    let i = $780b92061aa4a3e6$var$SnapshotVersion.min(), s = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), i = r.Ms.get(n);
            return void 0 !== i ? $780b92061aa4a3e6$var$PersistencePromise.resolve(r.Fs.get(i)) : r.hi.getTargetData(t, n);
        })(r, e, $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.hi.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Cs.getDocumentsMatchingQuery(e, t, n ? i : $780b92061aa4a3e6$var$SnapshotVersion.min(), n ? s : $780b92061aa4a3e6$var$__PRIVATE_documentKeySet())).next((e)=>($780b92061aa4a3e6$var$__PRIVATE_setMaxReadTime(r, $780b92061aa4a3e6$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                qs: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $780b92061aa4a3e6$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(n.hi), i = n.Fs.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.Et(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $780b92061aa4a3e6$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = n.xs.get(t) || $780b92061aa4a3e6$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.Os.getAllFromCollectionGroup(e, t, $780b92061aa4a3e6$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $780b92061aa4a3e6$var$Q), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($780b92061aa4a3e6$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $780b92061aa4a3e6$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.xs.get(t) || $780b92061aa4a3e6$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.xs.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    let s = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), o = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Qs(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.$s(e);
        r.setReadTime(t.Us(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.Os.newChangeBuffer({
        trackRemovals: !0
    }), a = await $780b92061aa4a3e6$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $780b92061aa4a3e6$var$__PRIVATE_queryToTarget($780b92061aa4a3e6$var$__PRIVATE_newQueryForPath($780b92061aa4a3e6$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$780b92061aa4a3e6$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.hi.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.hi.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Ls, t.ks)).next(()=>t.Ls)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $780b92061aa4a3e6$var$__PRIVATE_localStoreAllocateTarget(e, $780b92061aa4a3e6$var$__PRIVATE_queryToTarget($780b92061aa4a3e6$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Ti.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.Fs = i.Fs.insert(o.targetId, o), i.hi.updateTargetData(e, o).next(()=>i.hi.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.hi.addMatchingKeys(e, n, r.targetId)).next(()=>i.Ti.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $780b92061aa4a3e6$var$Ut = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $780b92061aa4a3e6$var$createWebStorageClientStateKey(e, t) {
    return `${$780b92061aa4a3e6$var$Ut}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $780b92061aa4a3e6$var$Kt = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $780b92061aa4a3e6$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$780b92061aa4a3e6$var$Kt}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $780b92061aa4a3e6$var$Wt = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $780b92061aa4a3e6$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$780b92061aa4a3e6$var$Wt}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Gt = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $780b92061aa4a3e6$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $780b92061aa4a3e6$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $780b92061aa4a3e6$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($780b92061aa4a3e6$var$__PRIVATE_logError($780b92061aa4a3e6$var$Gt, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $780b92061aa4a3e6$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $780b92061aa4a3e6$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $780b92061aa4a3e6$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($780b92061aa4a3e6$var$__PRIVATE_logError($780b92061aa4a3e6$var$Gt, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $780b92061aa4a3e6$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $780b92061aa4a3e6$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $780b92061aa4a3e6$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $780b92061aa4a3e6$var$__PRIVATE_RemoteClientState(e, i) : ($780b92061aa4a3e6$var$__PRIVATE_logError($780b92061aa4a3e6$var$Gt, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $780b92061aa4a3e6$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static Ks(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $780b92061aa4a3e6$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($780b92061aa4a3e6$var$__PRIVATE_logError($780b92061aa4a3e6$var$Gt, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $780b92061aa4a3e6$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $780b92061aa4a3e6$var$__PRIVATE_targetIdSet();
    }
    Gs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    zs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Ws() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $780b92061aa4a3e6$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Fi = t, this.persistenceKey = n, this.js = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.Js = this.Hs.bind(this), this.Ys = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Zs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Xs = $780b92061aa4a3e6$var$createWebStorageClientStateKey(this.persistenceKey, this.js), this.eo = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Ys = this.Ys.insert(this.js, new $780b92061aa4a3e6$var$__PRIVATE_LocalClientState), this.no = new RegExp(`^${$780b92061aa4a3e6$var$Ut}_${s}_([^_]*)$`), this.ro = new RegExp(`^${$780b92061aa4a3e6$var$Kt}_${s}_(\\d+)(?:_(.*))?$`), this.io = new RegExp(`^${$780b92061aa4a3e6$var$Wt}_${s}_(\\d+)$`), this.so = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.oo = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.Js);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static C(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.Ps();
        for (const t of e){
            if (t === this.js) continue;
            const e = this.getItem($780b92061aa4a3e6$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $780b92061aa4a3e6$var$__PRIVATE_RemoteClientState.Ks(t, e);
                n && (this.Ys = this.Ys.insert(n.clientId, n));
            }
        }
        this._o();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.so);
        if (t) {
            const e = this.ao(t);
            e && this.uo(e);
        }
        for (const e of this.Zs)this.Hs(e);
        this.Zs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.eo, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.co(this.Ys);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Ys.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.lo(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.lo(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.ho(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($780b92061aa4a3e6$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $780b92061aa4a3e6$var$__PRIVATE_QueryTargetMetadata.Ks(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.Po.Gs(e), this._o(), n;
    }
    removeLocalQueryTarget(e) {
        this.Po.zs(e), this._o();
    }
    isLocalQueryTarget(e) {
        return this.Po.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($780b92061aa4a3e6$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.To(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.ho(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Io(e);
    }
    notifyBundleLoaded(e) {
        this.Eo(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.Js), this.removeItem(this.Xs), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Gt, "READ", e, t), t;
    }
    setItem(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Gt, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Gt, "REMOVE", e), this.storage.removeItem(e);
    }
    Hs(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Gt, "EVENT", t.key, t.newValue), t.key === this.Xs) return void $780b92061aa4a3e6$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Fi.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.no.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Ao(t.key);
                                return this.Ro(e, null);
                            }
                            {
                                const e = this.Vo(t.key, t.newValue);
                                if (e) return this.Ro(e.clientId, e);
                            }
                        } else if (this.ro.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.mo(t.key, t.newValue);
                                if (e) return this.fo(e);
                            }
                        } else if (this.io.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.po(t.key, t.newValue);
                                if (e) return this.yo(e);
                            }
                        } else if (t.key === this.so) {
                            if (null !== t.newValue) {
                                const e = this.ao(t.newValue);
                                if (e) return this.uo(e);
                            }
                        } else if (t.key === this.eo) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $780b92061aa4a3e6$var$__PRIVATE_hardAssert("number" == typeof n, 30636, {
                                        wo: e
                                    }), t = n;
                                } catch (e) {
                                    $780b92061aa4a3e6$var$__PRIVATE_logError($780b92061aa4a3e6$var$Gt, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue && this.sequenceNumberHandler(e);
                        } else if (t.key === this.oo) {
                            const e = this.So(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.bo(e)));
                        }
                    }
                } else this.Zs.push(t);
            });
        }
    }
    get Po() {
        return this.Ys.get(this.js);
    }
    _o() {
        this.setItem(this.Xs, this.Po.Ws());
    }
    lo(e, t, n) {
        const r = new $780b92061aa4a3e6$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $780b92061aa4a3e6$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Ws());
    }
    ho(e) {
        const t = $780b92061aa4a3e6$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Io(e) {
        const t = {
            clientId: this.js,
            onlineState: e
        };
        this.storage.setItem(this.so, JSON.stringify(t));
    }
    To(e, t, n) {
        const r = $780b92061aa4a3e6$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $780b92061aa4a3e6$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Ws());
    }
    Eo(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.oo, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Ao(e) {
        const t = this.no.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Vo(e, t) {
        const n = this.Ao(e);
        return $780b92061aa4a3e6$var$__PRIVATE_RemoteClientState.Ks(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ mo(e, t) {
        const n = this.ro.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $780b92061aa4a3e6$var$__PRIVATE_MutationMetadata.Ks(new $780b92061aa4a3e6$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ po(e, t) {
        const n = this.io.exec(e), r = Number(n[1]);
        return $780b92061aa4a3e6$var$__PRIVATE_QueryTargetMetadata.Ks(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ ao(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_SharedOnlineState.Ks(e);
    }
    So(e) {
        return JSON.parse(e);
    }
    async fo(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Do(e.batchId, e.state, e.error);
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Gt, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    yo(e) {
        return this.syncEngine.vo(e.targetId, e.state, e.error);
    }
    Ro(e, t) {
        const n = t ? this.Ys.insert(e, t) : this.Ys.remove(e), r = this.co(this.Ys), i = this.co(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.Co(s, o).then(()=>{
            this.Ys = n;
        });
    }
    uo(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Ys.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    co(e) {
        let t = $780b92061aa4a3e6$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.Fo = new $780b92061aa4a3e6$var$__PRIVATE_LocalClientState, this.Mo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.Fo.Gs(e), this.Mo[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.Mo[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.Fo.zs(e);
    }
    isLocalQueryTarget(e) {
        return this.Fo.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.Mo[e];
    }
    getAllActiveQueryTargets() {
        return this.Fo.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.Fo.activeTargetIds.has(e);
    }
    start() {
        return this.Fo = new $780b92061aa4a3e6$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_NoopConnectivityMonitor {
    xo(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $780b92061aa4a3e6$var$zt = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $780b92061aa4a3e6$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.Oo = ()=>this.No(), this.Bo = ()=>this.Lo(), this.ko = [], this.qo();
    }
    xo(e) {
        this.ko.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.Oo), window.removeEventListener("offline", this.Bo);
    }
    qo() {
        window.addEventListener("online", this.Oo), window.addEventListener("offline", this.Bo);
    }
    No() {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$zt, "Network connectivity changed: AVAILABLE");
        for (const e of this.ko)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    Lo() {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$zt, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.ko)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static C() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $780b92061aa4a3e6$var$jt = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $780b92061aa4a3e6$var$__PRIVATE_generateUniqueDebugId() {
    return null === $780b92061aa4a3e6$var$jt ? $780b92061aa4a3e6$var$jt = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $780b92061aa4a3e6$var$jt++, "0x" + $780b92061aa4a3e6$var$jt.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Jt = "RestConnection", $780b92061aa4a3e6$var$Ht = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $780b92061aa4a3e6$var$__PRIVATE_RestConnection {
    get Qo() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.$o = t + "://" + e.host, this.Uo = `projects/${n}/databases/${r}`, this.Ko = this.databaseId.database === $780b92061aa4a3e6$var$ut ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Wo(e, t, n, r, i) {
        const s = $780b92061aa4a3e6$var$__PRIVATE_generateUniqueDebugId(), o = this.Go(e, t.toUriEncodedString());
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Jt, `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Uo,
            "x-goog-request-params": this.Ko
        };
        this.zo(_, r, i);
        const { host: a } = new URL(o), u = (0, $abbde52b10a5c31f$export$5b4d24b45140ad90)(a);
        return this.jo(e, o, _, n, u).then((t)=>($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Jt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $780b92061aa4a3e6$export$86cd73f49cc6e0bb($780b92061aa4a3e6$var$Jt, `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    Jo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Wo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ zo(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $780b92061aa4a3e6$var$x;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    Go(e, t) {
        const n = $780b92061aa4a3e6$var$Ht[e];
        return `${this.$o}/v1/${t}:${n}`;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $780b92061aa4a3e6$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Ho = e.Ho, this.Yo = e.Yo;
    }
    Zo(e) {
        this.Xo = e;
    }
    e_(e) {
        this.t_ = e;
    }
    n_(e) {
        this.r_ = e;
    }
    onMessage(e) {
        this.i_ = e;
    }
    close() {
        this.Yo();
    }
    send(e) {
        this.Ho(e);
    }
    s_() {
        this.Xo();
    }
    o_() {
        this.t_();
    }
    __(e) {
        this.r_(e);
    }
    a_(e) {
        this.i_(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Yt = "WebChannelConnection";
class $780b92061aa4a3e6$var$__PRIVATE_WebChannelConnection extends $780b92061aa4a3e6$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.u_ = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    jo(e, t, n, r, i) {
        const s = $780b92061aa4a3e6$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, o)=>{
            const _ = new (0, $26a29ea0054896c3$export$26404658cda3ee02);
            _.setWithCredentials(!0), _.listenOnce((0, $26a29ea0054896c3$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $26a29ea0054896c3$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = _.getResponseJson();
                            $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $26a29ea0054896c3$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' ${s} timed out`), o(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $26a29ea0054896c3$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' ${s} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = null == e ? void 0 : e.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($780b92061aa4a3e6$var$N).indexOf(t) >= 0 ? t : $780b92061aa4a3e6$var$N.UNKNOWN;
                                    }(t.status);
                                    o(new $780b92061aa4a3e6$export$8fada0bf726bf278(e, t.message));
                                } else o(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $780b92061aa4a3e6$var$fail(9055, {
                                c_: e,
                                streamId: s,
                                l_: _.getLastErrorCode(),
                                h_: _.getLastError()
                            });
                    }
                } finally{
                    $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' ${s} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    P_(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.$o,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $26a29ea0054896c3$export$66869136fc133c3a)(), o = (0, $26a29ea0054896c3$export$888d0d9ab79d08fc)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), this.zo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        this.T_(c);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $780b92061aa4a3e6$var$__PRIVATE_StreamBridge({
            Ho: (t)=>{
                h ? $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            Yo: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $26a29ea0054896c3$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            h || ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} transport opened.`), P.s_());
        }), __PRIVATE_unguardedEventListen(c, (0, $26a29ea0054896c3$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            h || (h = !0, $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} transport closed`), P.__(), this.I_(c));
        }), __PRIVATE_unguardedEventListen(c, (0, $26a29ea0054896c3$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            h || (h = !0, $780b92061aa4a3e6$export$86cd73f49cc6e0bb($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), P.__(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $26a29ea0054896c3$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            var n;
            if (!h) {
                const i = t.data[0];
                $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!i, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = (null == s ? void 0 : s.error) || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $780b92061aa4a3e6$var$ft[e];
                        if (void 0 !== t) return $780b92061aa4a3e6$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = $780b92061aa4a3e6$var$N.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), // Mark closed so no further events are propagated
                    h = !0, P.__(new $780b92061aa4a3e6$export$8fada0bf726bf278(n, i)), c.close();
                } else $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} received:`, i), P.a_(i);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $26a29ea0054896c3$export$d61e24a684f9e51).STAT_EVENT, (t)=>{
            t.stat === (0, $26a29ea0054896c3$export$cbbc350c1dfc80cb).PROXY ? $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $26a29ea0054896c3$export$cbbc350c1dfc80cb).NOPROXY && $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Yt, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.o_();
        }, 0), P;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.u_.forEach((e)=>e.close()), this.u_ = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ T_(e) {
        this.u_.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ I_(e) {
        this.u_ = this.u_.filter((t)=>t === e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $780b92061aa4a3e6$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $780b92061aa4a3e6$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $780b92061aa4a3e6$var$__PRIVATE_newSerializer(e) {
    return new $780b92061aa4a3e6$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $780b92061aa4a3e6$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Fi = e, this.timerId = t, this.d_ = n, this.E_ = r, this.A_ = i, this.R_ = 0, this.V_ = null, /** The last backoff attempt, as epoch milliseconds. */ this.m_ = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.R_ = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ f_() {
        this.R_ = this.A_;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ g_(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.R_ + this.p_()), n = Math.max(0, Date.now() - this.m_), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $780b92061aa4a3e6$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.R_} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.V_ = this.Fi.enqueueAfterDelay(this.timerId, r, ()=>(this.m_ = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.R_ *= this.E_, this.R_ < this.d_ && (this.R_ = this.d_), this.R_ > this.A_ && (this.R_ = this.A_);
    }
    y_() {
        null !== this.V_ && (this.V_.skipDelay(), this.V_ = null);
    }
    cancel() {
        null !== this.V_ && (this.V_.cancel(), this.V_ = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ p_() {
        return (Math.random() - .5) * this.R_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Zt = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $780b92061aa4a3e6$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.Fi = e, this.w_ = n, this.S_ = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.b_ = 0, this.D_ = null, this.v_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.C_ = 0, this.F_ = new $780b92061aa4a3e6$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ M_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.x_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ x_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.C_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.O_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.M_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ N_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.F_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ B_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.x_() && null === this.D_ && (this.D_ = this.Fi.enqueueAfterDelay(this.w_, 6e4, ()=>this.L_()));
    }
    /** Sends a message to the underlying stream. */ k_(e) {
        this.q_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async L_() {
        if (this.x_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ q_() {
        this.D_ && (this.D_.cancel(), this.D_ = null);
    }
    /** Cancels the health check delayed operation. */ Q_() {
        this.v_ && (this.v_.cancel(), this.v_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.q_(), this.Q_(), this.F_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.b_++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.F_.reset() : t && t.code === $780b92061aa4a3e6$var$N.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($780b92061aa4a3e6$var$__PRIVATE_logError(t.toString()), $780b92061aa4a3e6$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.F_.f_()) : t && t.code === $780b92061aa4a3e6$var$N.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.U_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.n_(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ U_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.K_(this.b_), t = this.b_;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.b_ === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.W_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.G_(e);
            });
        });
    }
    W_(e, t) {
        const n = this.K_(this.b_);
        this.stream = this.z_(e, t), this.stream.Zo(()=>{
            n(()=>this.listener.Zo());
        }), this.stream.e_(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.v_ = this.Fi.enqueueAfterDelay(this.S_, 1e4, ()=>(this.x_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.e_()));
        }), this.stream.n_((e)=>{
            n(()=>this.G_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.C_ ? this.j_(e) : this.onNext(e));
        });
    }
    O_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.F_.g_(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    G_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Zt, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ K_(e) {
        return (t)=>{
            this.Fi.enqueueAndForget(()=>this.b_ === e ? t() : ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Zt, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $780b92061aa4a3e6$var$__PRIVATE_PersistentListenStream extends $780b92061aa4a3e6$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    z_(e, t) {
        return this.connection.P_("Listen", e, t);
    }
    j_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.F_.reset();
        const t = $780b92061aa4a3e6$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $780b92061aa4a3e6$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $780b92061aa4a3e6$var$SnapshotVersion.min() : t.readTime ? $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.readTime) : $780b92061aa4a3e6$var$SnapshotVersion.min();
        }(e);
        return this.listener.J_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ H_(e) {
        const t = {};
        t.database = $780b92061aa4a3e6$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $780b92061aa4a3e6$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $780b92061aa4a3e6$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $780b92061aa4a3e6$var$__PRIVATE_toQueryTarget(e, r).Vt
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $780b92061aa4a3e6$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $780b92061aa4a3e6$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($780b92061aa4a3e6$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $780b92061aa4a3e6$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $780b92061aa4a3e6$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $780b92061aa4a3e6$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.k_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ Y_(e) {
        const t = {};
        t.database = $780b92061aa4a3e6$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.k_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $780b92061aa4a3e6$var$__PRIVATE_PersistentWriteStream extends $780b92061aa4a3e6$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Z_() {
        return this.C_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    U_() {
        this.Z_ && this.X_([]);
    }
    z_(e, t) {
        return this.connection.P_("Write", e, t);
    }
    j_(e) {
        // Always capture the last stream token.
        return $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.ea();
    }
    onNext(e) {
        // Always capture the last stream token.
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.F_.reset();
        const t = $780b92061aa4a3e6$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.ta(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ na() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $780b92061aa4a3e6$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.k_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ X_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$780b92061aa4a3e6$var$toMutation(this.serializer, e))
        };
        this.k_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $780b92061aa4a3e6$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $780b92061aa4a3e6$var$__PRIVATE_DatastoreImpl extends $780b92061aa4a3e6$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.ra = !1;
    }
    ia() {
        if (this.ra) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Wo(e, t, n, r) {
        return this.ia(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Wo(e, $780b92061aa4a3e6$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $780b92061aa4a3e6$var$N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ Jo(e, t, n, r, i) {
        return this.ia(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.Jo(e, $780b92061aa4a3e6$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $780b92061aa4a3e6$var$N.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.ra = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $780b92061aa4a3e6$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.sa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.oa = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this._a = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ aa() {
        0 === this.sa && (this.ua("Unknown" /* OnlineState.Unknown */ ), this.oa = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.oa = null, this.ca("Backend didn't respond within 10 seconds."), this.ua("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ la(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.ua("Unknown" /* OnlineState.Unknown */ ) : (this.sa++, this.sa >= 1 && (this.ha(), this.ca(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.ua("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.ha(), this.sa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this._a = !1), this.ua(e);
    }
    ua(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    ca(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this._a ? ($780b92061aa4a3e6$var$__PRIVATE_logError(t), this._a = !1) : $780b92061aa4a3e6$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    ha() {
        null !== this.oa && (this.oa.cancel(), this.oa = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Xt = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $780b92061aa4a3e6$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Pa = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ta = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.Ia = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.da = [], this.Ea = i, this.Ea.xo((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(this) && ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Xt, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
                    t.Ia.add(4 /* OfflineCause.ConnectivityChange */ ), await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkInternal(t), t.Aa.set("Unknown" /* OnlineState.Unknown */ ), t.Ia.delete(4 /* OfflineCause.ConnectivityChange */ ), await $780b92061aa4a3e6$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.Aa = new $780b92061aa4a3e6$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $780b92061aa4a3e6$var$__PRIVATE_enableNetworkInternal(e) {
    if ($780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(e)) for (const t of e.da)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $780b92061aa4a3e6$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.da)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $780b92061aa4a3e6$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    n.Ta.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.Ta.set(t.targetId, t), $780b92061aa4a3e6$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $780b92061aa4a3e6$var$__PRIVATE_startWatchStream(n) : $780b92061aa4a3e6$var$__PRIVATE_ensureWatchStream(n).x_() && $780b92061aa4a3e6$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $780b92061aa4a3e6$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = $780b92061aa4a3e6$var$__PRIVATE_ensureWatchStream(n);
    n.Ta.delete(t), r.x_() && $780b92061aa4a3e6$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.Ta.size && (r.x_() ? r.B_() : $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.Aa.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $780b92061aa4a3e6$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.Ra.$e(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($780b92061aa4a3e6$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $780b92061aa4a3e6$var$__PRIVATE_ensureWatchStream(e).H_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $780b92061aa4a3e6$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.Ra.$e(t), $780b92061aa4a3e6$var$__PRIVATE_ensureWatchStream(e).Y_(t);
}
function $780b92061aa4a3e6$var$__PRIVATE_startWatchStream(e) {
    e.Ra = new $780b92061aa4a3e6$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        Et: (t)=>e.Ta.get(t) || null,
        lt: ()=>e.datastore.serializer.databaseId
    }), $780b92061aa4a3e6$var$__PRIVATE_ensureWatchStream(e).start(), e.Aa.aa();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $780b92061aa4a3e6$var$__PRIVATE_shouldStartWatchStream(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(e) && !$780b92061aa4a3e6$var$__PRIVATE_ensureWatchStream(e).M_() && e.Ta.size > 0;
}
function $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $780b92061aa4a3e6$var$__PRIVATE_debugCast(e).Ia.size;
}
function $780b92061aa4a3e6$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.Ra = void 0;
}
async function $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.Aa.set("Online" /* OnlineState.Online */ );
}
async function $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamOpen(e) {
    e.Ta.forEach((t, n)=>{
        $780b92061aa4a3e6$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamClose(e, t) {
    $780b92061aa4a3e6$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $780b92061aa4a3e6$var$__PRIVATE_shouldStartWatchStream(e) ? (e.Aa.la(t), $780b92061aa4a3e6$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.Aa.set("Unknown" /* OnlineState.Unknown */ );
}
async function $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.Aa.set("Online" /* OnlineState.Online */ ), t instanceof $780b92061aa4a3e6$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.Ta.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.Ta.delete(r), e.Ra.removeTarget(r));
        }(e, t);
    } catch (n) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Xt, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $780b92061aa4a3e6$var$__PRIVATE_DocumentWatchChange ? e.Ra.Ye(t) : t instanceof $780b92061aa4a3e6$var$__PRIVATE_ExistenceFilterChange ? e.Ra.it(t) : e.Ra.et(t), !n.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min())) try {
        const t = await $780b92061aa4a3e6$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.Ra.Pt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ta.get(r);
                    // A watched target might have been removed already.
                    i && e.Ta.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ta.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ta.set(t, r.withResumeToken($780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $780b92061aa4a3e6$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $780b92061aa4a3e6$var$TargetData(r.target, t, n, r.sequenceNumber);
                $780b92061aa4a3e6$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Xt, "Failed to raise snapshot:", t), await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.Ia.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkInternal(e), e.Aa.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$780b92061aa4a3e6$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Xt, "Retrying IndexedDB access"), await n(), e.Ia.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $780b92061aa4a3e6$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $780b92061aa4a3e6$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$780b92061aa4a3e6$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $780b92061aa4a3e6$var$__PRIVATE_fillWritePipeline(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), n = $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(t);
    let r = t.Pa.length > 0 ? t.Pa[t.Pa.length - 1].batchId : $780b92061aa4a3e6$var$G;
    for(; $780b92061aa4a3e6$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $780b92061aa4a3e6$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Pa.length && n.B_();
            break;
        }
        r = e.batchId, $780b92061aa4a3e6$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $780b92061aa4a3e6$var$__PRIVATE_shouldStartWriteStream(t) && $780b92061aa4a3e6$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $780b92061aa4a3e6$var$__PRIVATE_canAddToWritePipeline(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(e) && e.Pa.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $780b92061aa4a3e6$var$__PRIVATE_addToWritePipeline(e, t) {
    e.Pa.push(t);
    const n = $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e);
    n.x_() && n.Z_ && n.X_(t.mutations);
}
function $780b92061aa4a3e6$var$__PRIVATE_shouldStartWriteStream(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(e) && !$780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e).M_() && e.Pa.length > 0;
}
function $780b92061aa4a3e6$var$__PRIVATE_startWriteStream(e) {
    $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $780b92061aa4a3e6$var$__PRIVATE_onWriteStreamOpen(e) {
    $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e).na();
}
async function $780b92061aa4a3e6$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Pa)t.X_(n.mutations);
}
async function $780b92061aa4a3e6$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.Pa.shift(), i = $780b92061aa4a3e6$var$MutationBatchResult.from(r, t, n);
    await $780b92061aa4a3e6$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $780b92061aa4a3e6$var$__PRIVATE_fillWritePipeline(e);
}
async function $780b92061aa4a3e6$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e).Z_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $780b92061aa4a3e6$var$__PRIVATE_isPermanentError(e) && e !== $780b92061aa4a3e6$var$N.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Pa.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e).N_(), await $780b92061aa4a3e6$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $780b92061aa4a3e6$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $780b92061aa4a3e6$var$__PRIVATE_shouldStartWriteStream(e) && $780b92061aa4a3e6$var$__PRIVATE_startWriteStream(e);
}
async function $780b92061aa4a3e6$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Xt, "RemoteStore received new credentials");
    const r = $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.Ia.add(3 /* OfflineCause.CredentialChange */ ), await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.Aa.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.Ia.delete(3 /* OfflineCause.CredentialChange */ ), await $780b92061aa4a3e6$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    t ? (n.Ia.delete(2 /* OfflineCause.IsSecondary */ ), await $780b92061aa4a3e6$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.Ia.add(2 /* OfflineCause.IsSecondary */ ), await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkInternal(n), n.Aa.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $780b92061aa4a3e6$var$__PRIVATE_ensureWatchStream(e) {
    return e.Va || // Create stream (but note that it is not started yet).
    (e.Va = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
        return r.ia(), new $780b92061aa4a3e6$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        e_: $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        n_: $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        J_: $780b92061aa4a3e6$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.da.push(async (t)=>{
        t ? (e.Va.N_(), $780b92061aa4a3e6$var$__PRIVATE_shouldStartWatchStream(e) ? $780b92061aa4a3e6$var$__PRIVATE_startWatchStream(e) : e.Aa.set("Unknown" /* OnlineState.Unknown */ )) : (await e.Va.stop(), $780b92061aa4a3e6$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.Va;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $780b92061aa4a3e6$var$__PRIVATE_ensureWriteStream(e) {
    return e.ma || // Create stream (but note that it is not started yet).
    (e.ma = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
        return r.ia(), new $780b92061aa4a3e6$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: ()=>Promise.resolve(),
        e_: $780b92061aa4a3e6$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        n_: $780b92061aa4a3e6$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        ea: $780b92061aa4a3e6$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        ta: $780b92061aa4a3e6$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.da.push(async (t)=>{
        t ? (e.ma.N_(), // This will start the write stream if necessary.
        await $780b92061aa4a3e6$var$__PRIVATE_fillWritePipeline(e)) : (await e.ma.stop(), e.Pa.length > 0 && ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Xt, `Stopping write stream with ${e.Pa.length} pending writes`), e.Pa = []));
    })), e.ma;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $780b92061aa4a3e6$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $780b92061aa4a3e6$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $780b92061aa4a3e6$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $780b92061aa4a3e6$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($780b92061aa4a3e6$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $780b92061aa4a3e6$var$DocumentSet {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $780b92061aa4a3e6$var$DocumentSet(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $780b92061aa4a3e6$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$780b92061aa4a3e6$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $780b92061aa4a3e6$var$documentMap(), this.sortedSet = new $780b92061aa4a3e6$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $780b92061aa4a3e6$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $780b92061aa4a3e6$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $780b92061aa4a3e6$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.fa = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.fa.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.fa = this.fa.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.fa = this.fa.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.fa = this.fa.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.fa = this.fa.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.fa = this.fa.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.fa = this.fa.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.fa = this.fa.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $780b92061aa4a3e6$var$fail(63341, {
            At: e,
            ga: n
        }) : this.fa = this.fa.insert(t, e);
    }
    pa() {
        const e = [];
        return this.fa.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $780b92061aa4a3e6$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $780b92061aa4a3e6$var$ViewSnapshot(e, t, $780b92061aa4a3e6$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $780b92061aa4a3e6$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $780b92061aa4a3e6$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.ya = void 0, this.wa = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    Sa() {
        return this.wa.some((e)=>e.ba());
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $780b92061aa4a3e6$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Da = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $780b92061aa4a3e6$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.wa)e.onError(t);
            });
        }(this, new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.ABORTED, "Firestore shutting down"));
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_newQueriesObjectMap() {
    return new $780b92061aa4a3e6$var$ObjectMap((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyQuery(e), $780b92061aa4a3e6$var$__PRIVATE_queryEquals);
}
async function $780b92061aa4a3e6$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.Sa() && t.ba() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $780b92061aa4a3e6$var$__PRIVATE_QueryListenersInfo, r = t.ba() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.ya = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.ya = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$780b92061aa4a3e6$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.wa.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.va(n.onlineState), s.ya) t.Ca(s.ya) && $780b92061aa4a3e6$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $780b92061aa4a3e6$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.wa.indexOf(t);
        e >= 0 && (s.wa.splice(e, 1), 0 === s.wa.length ? i = t.ba() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.Sa() && t.ba() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.wa)t.Ca(e) && (r = !0);
            i.ya = e;
        }
    }
    r && $780b92061aa4a3e6$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $780b92061aa4a3e6$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.wa)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $780b92061aa4a3e6$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Da.forEach((e)=>{
        e.next();
    });
}
var $780b92061aa4a3e6$var$en, $780b92061aa4a3e6$var$tn;
/** Listen to both cache and server changes */ ($780b92061aa4a3e6$var$tn = $780b92061aa4a3e6$var$en || ($780b92061aa4a3e6$var$en = {})).Fa = "default", /** Listen to changes in cache only */ $780b92061aa4a3e6$var$tn.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $780b92061aa4a3e6$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.Ma = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.xa = !1, this.Oa = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Ca(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $780b92061aa4a3e6$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.xa ? this.Na(e) && (this.Ma.next(e), t = !0) : this.Ba(e, this.onlineState) && (this.La(e), t = !0), this.Oa = e, t;
    }
    onError(e) {
        this.Ma.error(e);
    }
    /** Returns whether a snapshot was raised. */ va(e) {
        this.onlineState = e;
        let t = !1;
        return this.Oa && !this.xa && this.Ba(this.Oa, e) && (this.La(this.Oa), t = !0), t;
    }
    Ba(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.ba()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.ka || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Na(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.Oa && this.Oa.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    La(e) {
        e = $780b92061aa4a3e6$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.xa = !0, this.Ma.next(e);
    }
    ba() {
        return this.options.source !== $780b92061aa4a3e6$var$en.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $780b92061aa4a3e6$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.qa = e, this.byteLength = t;
    }
    Qa() {
        return "metadata" in this.qa;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $780b92061aa4a3e6$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Qs(e) {
        return $780b92061aa4a3e6$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ $s(e) {
        return e.metadata.exists ? $780b92061aa4a3e6$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $780b92061aa4a3e6$var$MutableDocument.newNoDocument(this.Qs(e.metadata.name), this.Us(e.metadata.readTime));
    }
    Us(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $780b92061aa4a3e6$var$__PRIVATE_BundleLoader {
    constructor(e, t){
        this.$a = e, this.serializer = t, /** Batched queries to be saved into storage */ this.Ua = [], /** Batched documents to be saved into storage */ this.Ka = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $780b92061aa4a3e6$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.Ua;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.Ka;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Wa(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.qa.namedQuery) this.Ua.push(e.qa.namedQuery);
        else if (e.qa.documentMetadata) {
            this.Ka.push({
                metadata: e.qa.documentMetadata
            }), e.qa.documentMetadata.exists || ++t;
            const n = $780b92061aa4a3e6$var$ResourcePath.fromString(e.qa.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.qa.document && (this.Ka[this.Ka.length - 1].document = e.qa.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
    }
    Ga(e) {
        const t = new Map, n = new $780b92061aa4a3e6$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Qs(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $780b92061aa4a3e6$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async za(e) {
        const t = await $780b92061aa4a3e6$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $780b92061aa4a3e6$var$__PRIVATE_BundleConverterImpl(this.serializer), this.Ka, this.$a.id), n = this.Ga(this.documents);
        for (const t of this.Ua)await $780b92061aa4a3e6$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            ja: this.collectionGroups,
            Ja: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $780b92061aa4a3e6$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $780b92061aa4a3e6$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $780b92061aa4a3e6$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Ha = t, this.Ya = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Za = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), this.Xa = $780b92061aa4a3e6$var$__PRIVATE_newQueryComparator(e), this.eu = new $780b92061aa4a3e6$var$DocumentSet(this.Xa);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get tu() {
        return this.Ha;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ nu(e, t) {
        const n = t ? t.ru : new $780b92061aa4a3e6$var$__PRIVATE_DocumentChangeSet, r = t ? t.eu : this.eu;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $780b92061aa4a3e6$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.iu(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.Xa(c, _) > 0 || a && this.Xa(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            eu: s,
            ru: n,
            Ds: o,
            mutatedKeys: i
        };
    }
    iu(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.eu;
        this.eu = e.eu, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.ru.pa();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $780b92061aa4a3e6$var$fail(20277, {
                                At: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Xa(e.doc, t.doc)), this.su(n), r = null != r && r;
        const o = t && !r ? this.ou() : [], _ = 0 === this.Za.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.Ya;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Ya = _, 0 !== s.length || a) return {
            snapshot: new $780b92061aa4a3e6$var$ViewSnapshot(this.query, e.eu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            _u: o
        };
        // no changes
        return {
            _u: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ va(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            eu: this.eu,
            ru: new $780b92061aa4a3e6$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Ds: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            _u: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ au(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Ha.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.eu.has(e) && !this.eu.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ su(e) {
        e && (e.addedDocuments.forEach((e)=>this.Ha = this.Ha.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Ha = this.Ha.delete(e)), this.current = e.current);
    }
    ou() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Za;
        this.Za = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), this.eu.forEach((e)=>{
            this.au(e.key) && (this.Za = this.Za.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Za.has(e) || t.push(new $780b92061aa4a3e6$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Za.forEach((n)=>{
            e.has(n) || t.push(new $780b92061aa4a3e6$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    uu(e) {
        this.Ha = e.qs, this.Za = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        const t = this.nu(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    cu() {
        return $780b92061aa4a3e6$var$ViewSnapshot.fromInitialDocuments(this.query, this.eu, this.mutatedKeys, 0 /* SyncState.Local */  === this.Ya, this.hasCachedResults);
    }
}
const $780b92061aa4a3e6$var$nn = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $780b92061aa4a3e6$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $780b92061aa4a3e6$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.lu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $780b92061aa4a3e6$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.hu = {}, this.Pu = new $780b92061aa4a3e6$var$ObjectMap((e)=>$780b92061aa4a3e6$var$__PRIVATE_canonifyQuery(e), $780b92061aa4a3e6$var$__PRIVATE_queryEquals), this.Tu = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Iu = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.du = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Eu = new Map, this.Au = new $780b92061aa4a3e6$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.Ru = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Vu = new Map, this.mu = $780b92061aa4a3e6$var$__PRIVATE_TargetIdGenerator.ur(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.fu = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.fu;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.Pu.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.cu()) : i = await $780b92061aa4a3e6$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $780b92061aa4a3e6$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_ensureWatchCallbacks(e);
    await $780b92061aa4a3e6$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $780b92061aa4a3e6$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $780b92061aa4a3e6$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $780b92061aa4a3e6$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $780b92061aa4a3e6$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.gu = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.nu(n);
            i.Ds && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $780b92061aa4a3e6$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.nu(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $780b92061aa4a3e6$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _._u), _.snapshot;
        })(e, t, n, r);
    const s = await $780b92061aa4a3e6$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $780b92061aa4a3e6$var$__PRIVATE_View(t, s.qs), _ = o.nu(s.documents), a = $780b92061aa4a3e6$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $780b92061aa4a3e6$var$__PRIVATE_updateTrackedLimbos(e, n, u._u);
    const c = new $780b92061aa4a3e6$var$__PRIVATE_QueryView(t, n, o);
    return e.Pu.set(t, c), e.Tu.has(n) ? e.Tu.get(n).push(t) : e.Tu.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), i = r.Pu.get(t), s = r.Tu.get(i.targetId);
    if (s.length > 1) return r.Tu.set(i.targetId, s.filter((e)=>!$780b92061aa4a3e6$var$__PRIVATE_queryEquals(e, t))), void r.Pu.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $780b92061aa4a3e6$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $780b92061aa4a3e6$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $780b92061aa4a3e6$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $780b92061aa4a3e6$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $780b92061aa4a3e6$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $780b92061aa4a3e6$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = n.Pu.get(t), i = n.Tu.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $780b92061aa4a3e6$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = $780b92061aa4a3e6$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $780b92061aa4a3e6$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $780b92061aa4a3e6$var$__PRIVATE_mutableDocumentMap(), a = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
                return n.Os.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $780b92061aa4a3e6$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $780b92061aa4a3e6$var$__PRIVATE_PatchMutation(e.key, t, $780b92061aa4a3e6$var$__PRIVATE_extractFieldMask(t.value.mapValue), $780b92061aa4a3e6$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $780b92061aa4a3e6$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.Ru[e.currentUser.toKey()];
            r || (r = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.Ru[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $780b92061aa4a3e6$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $780b92061aa4a3e6$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    try {
        const e = await $780b92061aa4a3e6$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Eu.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.lu = !0 : e.modifiedDocuments.size > 0 ? $780b92061aa4a3e6$var$__PRIVATE_hardAssert(r.lu, 14607) : e.removedDocuments.size > 0 && ($780b92061aa4a3e6$var$__PRIVATE_hardAssert(r.lu, 42227), r.lu = !1));
        }), await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Pu.forEach((n, r)=>{
            const i = r.view.va(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.wa)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.va(t) && (r = !0);
            }), r && $780b92061aa4a3e6$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.hu.J_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Eu.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $780b92061aa4a3e6$var$MutableDocument.newNoDocument(s, $780b92061aa4a3e6$var$SnapshotVersion.min()));
        const n = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet().add(s), i = new $780b92061aa4a3e6$var$RemoteEvent($780b92061aa4a3e6$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$var$__PRIVATE_primitiveComparator), e, n);
        await $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.du = r.du.remove(s), r.Eu.delete(t), $780b92061aa4a3e6$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $780b92061aa4a3e6$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$780b92061aa4a3e6$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $780b92061aa4a3e6$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $780b92061aa4a3e6$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $780b92061aa4a3e6$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($780b92061aa4a3e6$var$__PRIVATE_hardAssert(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $780b92061aa4a3e6$var$__PRIVATE_processUserCallback(r, t, n), $780b92061aa4a3e6$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    $780b92061aa4a3e6$var$__PRIVATE_canUseNetwork(n.remoteStore) || $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$nn, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $780b92061aa4a3e6$var$G) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.Vu.get(e) || [];
        r.push(t), n.Vu.set(e, r);
    } catch (e) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $780b92061aa4a3e6$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Vu.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.Vu.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $780b92061aa4a3e6$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    let i = r.Ru[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.Ru[r.currentUser.toKey()] = i;
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Tu.get(t))e.Pu.delete(r), n && e.hu.pu(r, n);
    if (e.Tu.delete(t), e.isPrimaryClient) e.Au.zr(t).forEach((t)=>{
        e.Au.containsKey(t) || // We removed the last reference for this key
        $780b92061aa4a3e6$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Iu.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.du.get(t);
    null !== n && ($780b92061aa4a3e6$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.du = e.du.remove(t), e.Eu.delete(n), $780b92061aa4a3e6$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $780b92061aa4a3e6$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $780b92061aa4a3e6$var$__PRIVATE_AddedLimboDocument) e.Au.addReference(r.key, t), $780b92061aa4a3e6$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $780b92061aa4a3e6$var$__PRIVATE_RemovedLimboDocument) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$nn, "Document no longer in limbo: " + r.key), e.Au.removeReference(r.key, t);
        e.Au.containsKey(r.key) || // We removed the last reference for this key
        $780b92061aa4a3e6$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $780b92061aa4a3e6$var$fail(19791, {
        yu: r
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.du.get(n) || e.Iu.has(r) || ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$nn, "New document in limbo: " + n), e.Iu.add(r), $780b92061aa4a3e6$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $780b92061aa4a3e6$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Iu.size > 0 && e.du.size < e.maxConcurrentLimboResolutions;){
        const t = e.Iu.values().next().value;
        e.Iu.delete(t);
        const n = new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$ResourcePath.fromString(t)), r = e.mu.next();
        e.Eu.set(r, new $780b92061aa4a3e6$var$LimboResolution(n)), e.du = e.du.insert(n, r), $780b92061aa4a3e6$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $780b92061aa4a3e6$var$TargetData($780b92061aa4a3e6$var$__PRIVATE_queryToTarget($780b92061aa4a3e6$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $780b92061aa4a3e6$var$__PRIVATE_ListenSequence.ue));
    }
}
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Pu.isEmpty() || (r.Pu.forEach((e, _)=>{
        o.push(r.gu(_, t, n).then((e)=>{
            var t;
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const i = e ? !e.fromCache : null === (t = null == n ? void 0 : n.targetChanges.get(_.targetId)) || void 0 === t ? void 0 : t.current;
                r.sharedClientState.updateQueryState(_.targetId, i ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $780b92061aa4a3e6$var$__PRIVATE_LocalViewChanges.Es(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.hu.J_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$780b92061aa4a3e6$var$PersistencePromise.forEach(t, (t)=>$780b92061aa4a3e6$var$PersistencePromise.forEach(t.Is, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$780b92061aa4a3e6$var$PersistencePromise.forEach(t.ds, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Qt, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.Fs.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.Fs = n.Fs.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$nn, "User change. New user:", t.toKey());
        const e = await $780b92061aa4a3e6$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.Vu.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.CANCELLED, t));
                });
            }), e.Vu.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Bs);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = n.Eu.get(t);
    if (r && r.lu) return $780b92061aa4a3e6$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $780b92061aa4a3e6$var$__PRIVATE_documentKeySet();
        const r = n.Tu.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Pu.get(t);
            e = e.unionWith(r.view.tu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $780b92061aa4a3e6$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = await $780b92061aa4a3e6$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.uu(r);
    return n.isPrimaryClient && $780b92061aa4a3e6$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i._u), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return $780b92061aa4a3e6$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Xn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $780b92061aa4a3e6$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $780b92061aa4a3e6$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($780b92061aa4a3e6$var$__PRIVATE_processUserCallback(i, t, r || null), $780b92061aa4a3e6$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_debugCast($780b92061aa4a3e6$var$__PRIVATE_debugCast(e).mutationQueue).rr(t);
    }(i.localStore, t)) : $780b92061aa4a3e6$var$fail(6720, "Unknown batchState", {
        wu: n
    }), await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$nn, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    if ($780b92061aa4a3e6$var$__PRIVATE_ensureWatchCallbacks(n), $780b92061aa4a3e6$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.fu) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $780b92061aa4a3e6$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.fu = !0, await $780b92061aa4a3e6$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$780b92061aa4a3e6$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.fu) {
        const e = [];
        let t = Promise.resolve();
        n.Tu.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($780b92061aa4a3e6$var$__PRIVATE_removeAndCleanupTarget(n, i), $780b92061aa4a3e6$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $780b92061aa4a3e6$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $780b92061aa4a3e6$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            t.Eu.forEach((e, n)=>{
                $780b92061aa4a3e6$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Au.jr(), t.Eu = new Map, t.du = new $780b92061aa4a3e6$var$SortedMap($780b92061aa4a3e6$export$afc2e57c475b7810.comparator);
        }(n), n.fu = !1, await $780b92061aa4a3e6$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $780b92061aa4a3e6$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Tu.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $780b92061aa4a3e6$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Pu.get(e), n = await $780b92061aa4a3e6$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $780b92061aa4a3e6$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $780b92061aa4a3e6$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $780b92061aa4a3e6$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $780b92061aa4a3e6$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.hu.J_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $780b92061aa4a3e6$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $780b92061aa4a3e6$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_debugCast($780b92061aa4a3e6$var$__PRIVATE_debugCast(e).persistence).Ps();
    }($780b92061aa4a3e6$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    if (i.fu) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$nn, "Ignoring unexpected query state notification.");
    const s = i.Tu.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $780b92061aa4a3e6$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $780b92061aa4a3e6$var$__PRIVATE_queryCollectionGroup(s[0])), r = $780b92061aa4a3e6$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $780b92061aa4a3e6$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $780b92061aa4a3e6$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $780b92061aa4a3e6$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $780b92061aa4a3e6$var$fail(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.fu) {
        for (const e of t){
            if (r.Tu.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$nn, "Adding an already active target " + e);
                continue;
            }
            const t = await $780b92061aa4a3e6$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $780b92061aa4a3e6$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $780b92061aa4a3e6$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $780b92061aa4a3e6$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $780b92061aa4a3e6$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Tu.has(e) && // Release queries that are still active.
        await $780b92061aa4a3e6$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $780b92061aa4a3e6$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $780b92061aa4a3e6$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($780b92061aa4a3e6$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $780b92061aa4a3e6$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $780b92061aa4a3e6$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.hu.J_ = $780b92061aa4a3e6$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.hu.pu = $780b92061aa4a3e6$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $780b92061aa4a3e6$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $780b92061aa4a3e6$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $780b92061aa4a3e6$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = $780b92061aa4a3e6$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Ti.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($780b92061aa4a3e6$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $780b92061aa4a3e6$var$__PRIVATE_BundleLoader(r, t.serializer);
            let s = await t.Su();
            for(; s;){
                const e = await i.Wa(s);
                e && n._updateProgress(e), s = await t.Su();
            }
            const o = await i.za(e.localStore);
            return await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ja, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Ti.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.ja);
        } catch (e) {
            return $780b92061aa4a3e6$export$86cd73f49cc6e0bb($780b92061aa4a3e6$var$nn, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $780b92061aa4a3e6$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $780b92061aa4a3e6$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.bu(e), this.persistence = this.Du(e), await this.persistence.start(), this.localStore = this.vu(e), this.gcScheduler = this.Cu(e, this.localStore), this.indexBackfillerScheduler = this.Fu(e, this.localStore);
    }
    Cu(e, t) {
        return null;
    }
    Fu(e, t) {
        return null;
    }
    vu(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_newLocalStore(this.persistence, new $780b92061aa4a3e6$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Du(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_MemoryPersistence($780b92061aa4a3e6$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer);
    }
    bu(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        var e, t;
        null === (e = this.gcScheduler) || void 0 === e || e.stop(), null === (t = this.indexBackfillerScheduler) || void 0 === t || t.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$780b92061aa4a3e6$var$__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: ()=>new $780b92061aa4a3e6$var$__PRIVATE_MemoryOfflineComponentProvider
};
class $780b92061aa4a3e6$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $780b92061aa4a3e6$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Cu(e, t) {
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $780b92061aa4a3e6$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $780b92061aa4a3e6$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Du(e) {
        const t = void 0 !== this.cacheSizeBytes ? $780b92061aa4a3e6$var$LruParams.withCacheSize(this.cacheSizeBytes) : $780b92061aa4a3e6$var$LruParams.DEFAULT;
        return new $780b92061aa4a3e6$var$__PRIVATE_MemoryPersistence((e)=>$780b92061aa4a3e6$var$__PRIVATE_MemoryLruDelegate.Vi(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $780b92061aa4a3e6$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $780b92061aa4a3e6$var$__PRIVATE_MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.Mu = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Mu.initialize(this, e), // Enqueue writes from a previous session
        await $780b92061aa4a3e6$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Mu.syncEngine), await $780b92061aa4a3e6$var$__PRIVATE_fillWritePipeline(this.Mu.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ji(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    vu(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_newLocalStore(this.persistence, new $780b92061aa4a3e6$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Cu(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $780b92061aa4a3e6$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Fu(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $780b92061aa4a3e6$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Du(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $780b92061aa4a3e6$var$LruParams.withCacheSize(this.cacheSizeBytes) : $780b92061aa4a3e6$var$LruParams.DEFAULT;
        return new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $780b92061aa4a3e6$var$__PRIVATE_getWindow(), $780b92061aa4a3e6$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    bu(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $780b92061aa4a3e6$var$__PRIVATE_MultiTabOfflineComponentProvider extends $780b92061aa4a3e6$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.Mu = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Mu.syncEngine;
        this.sharedClientState instanceof $780b92061aa4a3e6$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Do: $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            vo: $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Co: $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            Ps: $780b92061aa4a3e6$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            bo: $780b92061aa4a3e6$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.ji(async (e)=>{
            await $780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyPrimaryState(this.Mu.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    bu(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_getWindow();
        if (!$780b92061aa4a3e6$var$__PRIVATE_WebStorageSharedClientState.C(t)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $780b92061aa4a3e6$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $780b92061aa4a3e6$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $780b92061aa4a3e6$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $780b92061aa4a3e6$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $780b92061aa4a3e6$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $780b92061aa4a3e6$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $780b92061aa4a3e6$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $780b92061aa4a3e6$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $780b92061aa4a3e6$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$780b92061aa4a3e6$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $780b92061aa4a3e6$var$__PRIVATE_BrowserConnectivityMonitor.C() ? new $780b92061aa4a3e6$var$__PRIVATE_BrowserConnectivityMonitor : new $780b92061aa4a3e6$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $780b92061aa4a3e6$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.fu = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        var e, t;
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$Xt, "RemoteStore shutting down."), t.Ia.add(5 /* OfflineCause.Shutdown */ ), await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkInternal(t), t.Ea.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.Aa.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), null === (e = this.datastore) || void 0 === e || e.terminate(), null === (t = this.eventManager) || void 0 === t || t.terminate();
    }
}
$780b92061aa4a3e6$var$OnlineComponentProvider.provider = {
    build: ()=>new $780b92061aa4a3e6$var$OnlineComponentProvider
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $780b92061aa4a3e6$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $780b92061aa4a3e6$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.xu(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.xu(this.observer.error, e) : $780b92061aa4a3e6$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Ou() {
        this.muted = !0;
    }
    xu(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $780b92061aa4a3e6$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Nu = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $780b92061aa4a3e6$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Bu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.Lu().then((e)=>{
            e && e.Qa() ? this.metadata.resolve(e.qa.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.qa)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Nu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Su() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.Lu();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async Lu() {
        const e = await this.ku();
        if (null === e) return null;
        const t = this.Bu.decode(e), n = Number(t);
        isNaN(n) && this.qu(`length string (${t}) is not valid number`);
        const r = await this.Qu(n);
        return new $780b92061aa4a3e6$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ $u() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async ku() {
        for(; this.$u() < 0;){
            if (await this.Uu()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.$u();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.qu("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Qu(e) {
        for(; this.buffer.length < e;)await this.Uu() && this.qu("Reached the end of bundle when more is expected.");
        const t = this.Bu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    qu(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Nu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Uu() {
        const e = await this.Nu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $780b92061aa4a3e6$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.Su();
        if (!n || !n.Qa()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(null == n ? void 0 : n.qa)}`);
        this.metadata = n;
        do n = this.Su(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ Ku() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ Su() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.ku(), t = this.Qu(e);
        return new $780b92061aa4a3e6$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length how many characters to read.
     * @returns a string parsed from the bundle.
     */ Qu(e) {
        if (this.cursor + e > this.bundleData.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ ku() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $780b92061aa4a3e6$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.Jo("BatchGetDocuments", n.serializer.databaseId, $780b92061aa4a3e6$var$ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $780b92061aa4a3e6$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $780b92061aa4a3e6$var$__PRIVATE_hardAssert(!!t, 55234, {
                    key: e
                }), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $780b92061aa4a3e6$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $780b92061aa4a3e6$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $780b92061aa4a3e6$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$780b92061aa4a3e6$var$toMutation(n.serializer, e))
            };
            await n.Wo("Commit", n.serializer.databaseId, $780b92061aa4a3e6$var$ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $780b92061aa4a3e6$var$fail(50498, {
                Wu: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $780b92061aa4a3e6$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min()) ? $780b92061aa4a3e6$var$Precondition.exists(!1) : $780b92061aa4a3e6$var$Precondition.updateTime(t) : $780b92061aa4a3e6$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($780b92061aa4a3e6$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $780b92061aa4a3e6$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $780b92061aa4a3e6$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $780b92061aa4a3e6$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Gu = n.maxAttempts, this.F_ = new $780b92061aa4a3e6$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ zu() {
        this.Gu -= 1, this.ju();
    }
    ju() {
        this.F_.g_(async ()=>{
            const e = new $780b92061aa4a3e6$var$Transaction$2(this.datastore), t = this.Ju(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Hu(e);
                    }));
            }).catch((e)=>{
                this.Hu(e);
            });
        });
    }
    Ju(e) {
        try {
            const t = this.updateFunction(e);
            return !$780b92061aa4a3e6$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Hu(e) {
        this.Gu > 0 && this.Yu(e) ? (this.Gu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.ju(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Yu(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$780b92061aa4a3e6$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$rn = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $780b92061aa4a3e6$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $780b92061aa4a3e6$var$User.UNAUTHENTICATED, this.clientId = $780b92061aa4a3e6$export$253bcaa5572dcc83.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $780b92061aa4a3e6$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $780b92061aa4a3e6$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $780b92061aa4a3e6$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), t.persistence.setDatabaseDeletedListener(()=>{
        $780b92061aa4a3e6$export$86cd73f49cc6e0bb("Terminating Firestore due to IndexedDb database deletion"), e.terminate().then(()=>{
            $780b92061aa4a3e6$var$__PRIVATE_logDebug("Terminating Firestore due to IndexedDb database deletion completed successfully");
        }).catch((e)=>{
            $780b92061aa4a3e6$export$86cd73f49cc6e0bb("Terminating Firestore due to IndexedDb database deletion failed", e);
        });
    }), e._offlineComponents = t;
}
async function $780b92061aa4a3e6$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $780b92061aa4a3e6$var$__PRIVATE_ensureOfflineComponents(e);
    $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$780b92061aa4a3e6$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$780b92061aa4a3e6$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $780b92061aa4a3e6$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Using user provided OfflineComponentProvider");
            try {
                await $780b92061aa4a3e6$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $780b92061aa4a3e6$var$N.FAILED_PRECONDITION || e.code === $780b92061aa4a3e6$var$N.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $780b92061aa4a3e6$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $780b92061aa4a3e6$var$__PRIVATE_setOfflineComponentProvider(e, new $780b92061aa4a3e6$var$__PRIVATE_MemoryOfflineComponentProvider);
            }
        } else $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Using default OfflineComponentProvider"), await $780b92061aa4a3e6$var$__PRIVATE_setOfflineComponentProvider(e, new $780b92061aa4a3e6$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    }
    return e._offlineComponents;
}
async function $780b92061aa4a3e6$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Using user provided OnlineComponentProvider"), await $780b92061aa4a3e6$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$rn, "Using default OnlineComponentProvider"), await $780b92061aa4a3e6$var$__PRIVATE_setOnlineComponentProvider(e, new $780b92061aa4a3e6$var$OnlineComponentProvider))), e._onlineComponents;
}
function $780b92061aa4a3e6$var$__PRIVATE_getPersistence(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $780b92061aa4a3e6$var$__PRIVATE_getLocalStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $780b92061aa4a3e6$var$__PRIVATE_getRemoteStore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $780b92061aa4a3e6$var$__PRIVATE_getSyncEngine(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $780b92061aa4a3e6$var$__PRIVATE_getDatastore(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $780b92061aa4a3e6$var$__PRIVATE_getEventManager(e) {
    const t = await $780b92061aa4a3e6$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $780b92061aa4a3e6$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $780b92061aa4a3e6$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $780b92061aa4a3e6$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $780b92061aa4a3e6$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $780b92061aa4a3e6$var$__PRIVATE_getPersistence(e), n = await $780b92061aa4a3e6$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            return t.Ia.delete(0 /* OfflineCause.UserDisabled */ ), $780b92061aa4a3e6$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $780b92061aa4a3e6$var$__PRIVATE_getPersistence(e), n = await $780b92061aa4a3e6$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            t.Ia.add(0 /* OfflineCause.UserDisabled */ ), await $780b92061aa4a3e6$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.Aa.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $780b92061aa4a3e6$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $780b92061aa4a3e6$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $780b92061aa4a3e6$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Ou(), t.enqueueAndForget(()=>$780b92061aa4a3e6$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $780b92061aa4a3e6$var$__PRIVATE_QueryListener($780b92061aa4a3e6$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                ka: !0
            });
            return $780b92061aa4a3e6$var$__PRIVATE_eventManagerListen(e, o);
        })(await $780b92061aa4a3e6$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $780b92061aa4a3e6$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $780b92061aa4a3e6$var$__PRIVATE_View(t, r.qs), s = i.nu(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $780b92061aa4a3e6$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $780b92061aa4a3e6$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $780b92061aa4a3e6$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Ou(), t.enqueueAndForget(()=>$780b92061aa4a3e6$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $780b92061aa4a3e6$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                ka: !0
            });
            return $780b92061aa4a3e6$var$__PRIVATE_eventManagerListen(e, o);
        })(await $780b92061aa4a3e6$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $780b92061aa4a3e6$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                var r;
                const i = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), { request: s, ft: o, parent: _ } = $780b92061aa4a3e6$var$__PRIVATE_toRunAggregationQueryRequest(i.serializer, $780b92061aa4a3e6$var$__PRIVATE_queryToAggregateTarget(t), n);
                i.connection.Qo || delete s.parent;
                const a = (await i.Jo("RunAggregationQuery", i.serializer.databaseId, _, s, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $780b92061aa4a3e6$var$__PRIVATE_hardAssert(1 === a.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                return Object.keys(u).reduce((e, t)=>(e[o[t]] = u[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $780b92061aa4a3e6$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $780b92061aa4a3e6$var$__PRIVATE_debugCast(e).Da.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $780b92061aa4a3e6$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Ou(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $780b92061aa4a3e6$var$__PRIVATE_debugCast(e).Da.delete(t);
            })(await $780b92061aa4a3e6$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $780b92061aa4a3e6$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $780b92061aa4a3e6$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $780b92061aa4a3e6$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $780b92061aa4a3e6$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $780b92061aa4a3e6$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $780b92061aa4a3e6$var$__PRIVATE_syncEngineLoadBundle(await $780b92061aa4a3e6$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Ti.getNamedQuery(e, t));
        })(await $780b92061aa4a3e6$var$__PRIVATE_getLocalStore(e), t));
}
function $780b92061aa4a3e6$var$__PRIVATE_createBundleReaderSync(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $780b92061aa4a3e6$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $780b92061aa4a3e6$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$780b92061aa4a3e6$var$PersistencePromise.waitFor(i)));
        })(await $780b92061aa4a3e6$var$__PRIVATE_getLocalStore(e), t));
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $780b92061aa4a3e6$var$__PRIVATE_debugCast(e).Cs.Rs = t;
        })(await $780b92061aa4a3e6$var$__PRIVATE_getLocalStore(e), t));
}
function $780b92061aa4a3e6$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $780b92061aa4a3e6$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $780b92061aa4a3e6$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $780b92061aa4a3e6$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$sn = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $780b92061aa4a3e6$var$on = "firestore.googleapis.com", $780b92061aa4a3e6$var$_n = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $780b92061aa4a3e6$var$FirestoreSettingsImpl {
    constructor(e){
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $780b92061aa4a3e6$var$on, this.ssl = $780b92061aa4a3e6$var$_n;
        } else this.host = e.host, this.ssl = null !== (t = e.ssl) && void 0 !== t ? t : $780b92061aa4a3e6$var$_n;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $780b92061aa4a3e6$var$Mt;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $780b92061aa4a3e6$var$Ot) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $780b92061aa4a3e6$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $780b92061aa4a3e6$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $780b92061aa4a3e6$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $780b92061aa4a3e6$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $780b92061aa4a3e6$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $780b92061aa4a3e6$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $780b92061aa4a3e6$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $780b92061aa4a3e6$var$sn.get(e);
            t && ($780b92061aa4a3e6$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $780b92061aa4a3e6$var$sn.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $780b92061aa4a3e6$export$966a03d25297d115(e, t, n, r = {}) {
    var i;
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$var$Firestore$1);
    const s = (0, $abbde52b10a5c31f$export$5b4d24b45140ad90)(t), o = e._getSettings(), _ = Object.assign(Object.assign({}, o), {
        emulatorOptions: e._getEmulatorOptions()
    }), a = `${t}:${n}`;
    s && ((0, $abbde52b10a5c31f$export$c0f0d0ce4283a937)(`https://${a}`), (0, $abbde52b10a5c31f$export$fd3d2954543183b1)("Firestore", !0)), o.host !== $780b92061aa4a3e6$var$on && o.host !== a && $780b92061aa4a3e6$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const u = Object.assign(Object.assign({}, o), {
        host: a,
        ssl: s,
        emulatorOptions: r
    });
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $abbde52b10a5c31f$export$9cb4719e2e525b7a)(u, _) && (e._setSettings(u), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $780b92061aa4a3e6$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $abbde52b10a5c31f$export$367bf224123348f1)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $780b92061aa4a3e6$var$User(s);
        }
        e._authCredentials = new $780b92061aa4a3e6$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $780b92061aa4a3e6$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $780b92061aa4a3e6$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $780b92061aa4a3e6$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $780b92061aa4a3e6$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $780b92061aa4a3e6$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $780b92061aa4a3e6$export$6be62b059fb12175(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $780b92061aa4a3e6$export$6be62b059fb12175._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($780b92061aa4a3e6$var$__PRIVATE_validateJSON(t, $780b92061aa4a3e6$export$6be62b059fb12175._jsonSchema)) return new $780b92061aa4a3e6$export$6be62b059fb12175(e, n || null, new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$ResourcePath.fromString(t.referencePath)));
    }
}
$780b92061aa4a3e6$export$6be62b059fb12175._jsonSchemaVersion = "firestore/documentReference/1.0", $780b92061aa4a3e6$export$6be62b059fb12175._jsonSchema = {
    type: $780b92061aa4a3e6$var$property("string", $780b92061aa4a3e6$export$6be62b059fb12175._jsonSchemaVersion),
    referencePath: $780b92061aa4a3e6$var$property("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $780b92061aa4a3e6$export$ab5a1a47940a200e extends $780b92061aa4a3e6$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $780b92061aa4a3e6$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $780b92061aa4a3e6$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $780b92061aa4a3e6$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $780b92061aa4a3e6$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $780b92061aa4a3e6$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e), $780b92061aa4a3e6$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $780b92061aa4a3e6$var$Firestore$1) {
        const r = $780b92061aa4a3e6$var$ResourcePath.fromString(t, ...n);
        return $780b92061aa4a3e6$var$__PRIVATE_validateCollectionPath(r), new $780b92061aa4a3e6$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $780b92061aa4a3e6$export$6be62b059fb12175 || e instanceof $780b92061aa4a3e6$export$ab5a1a47940a200e)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($780b92061aa4a3e6$var$ResourcePath.fromString(t, ...n));
        return $780b92061aa4a3e6$var$__PRIVATE_validateCollectionPath(r), new $780b92061aa4a3e6$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $780b92061aa4a3e6$export$473d82a73f88c107(e, t) {
    if (e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$var$Firestore$1), $780b92061aa4a3e6$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $780b92061aa4a3e6$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl($780b92061aa4a3e6$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $780b92061aa4a3e6$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $780b92061aa4a3e6$export$253bcaa5572dcc83.newId()), $780b92061aa4a3e6$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $780b92061aa4a3e6$var$Firestore$1) {
        const r = $780b92061aa4a3e6$var$ResourcePath.fromString(t, ...n);
        return $780b92061aa4a3e6$var$__PRIVATE_validateDocumentPath(r), new $780b92061aa4a3e6$export$6be62b059fb12175(e, /* converter= */ null, new $780b92061aa4a3e6$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $780b92061aa4a3e6$export$6be62b059fb12175 || e instanceof $780b92061aa4a3e6$export$ab5a1a47940a200e)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($780b92061aa4a3e6$var$ResourcePath.fromString(t, ...n));
        return $780b92061aa4a3e6$var$__PRIVATE_validateDocumentPath(r), new $780b92061aa4a3e6$export$6be62b059fb12175(e.firestore, e instanceof $780b92061aa4a3e6$export$ab5a1a47940a200e ? e.converter : null, new $780b92061aa4a3e6$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $780b92061aa4a3e6$export$62a32f2da6187d11(e, t) {
    return e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e), t = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(t), (e instanceof $780b92061aa4a3e6$export$6be62b059fb12175 || e instanceof $780b92061aa4a3e6$export$ab5a1a47940a200e) && (t instanceof $780b92061aa4a3e6$export$6be62b059fb12175 || t instanceof $780b92061aa4a3e6$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $780b92061aa4a3e6$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e), t = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(t), e instanceof $780b92061aa4a3e6$export$62297b13309008b2 && t instanceof $780b92061aa4a3e6$export$62297b13309008b2 && e.firestore === t.firestore && $780b92061aa4a3e6$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$an = "AsyncQueue";
class $780b92061aa4a3e6$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Zu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.Xu = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.ec = [], // visible for testing
        this.tc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.nc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.rc = !1, // List of TimerIds to fast-forward delays for.
        this.sc = [], // Backoff timer used to schedule retries for retryable operations
        this.F_ = new $780b92061aa4a3e6$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.oc = ()=>{
            const e = $780b92061aa4a3e6$var$getDocument();
            e && $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$an, "Visibility state changed to " + e.visibilityState), this.F_.y_();
        }, this._c = e;
        const t = $780b92061aa4a3e6$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.oc);
    }
    get isShuttingDown() {
        return this.Xu;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.ac(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.uc(e);
    }
    enterRestrictedMode(e) {
        if (!this.Xu) {
            this.Xu = !0, this.rc = e || !1;
            const t = $780b92061aa4a3e6$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.oc);
        }
    }
    enqueue(e) {
        if (this.ac(), this.Xu) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
        return this.uc(()=>this.Xu && this.rc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Zu.push(e), this.cc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async cc() {
        if (0 !== this.Zu.length) {
            try {
                await this.Zu[0](), this.Zu.shift(), this.F_.reset();
            } catch (e) {
                if (!$780b92061aa4a3e6$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $780b92061aa4a3e6$var$__PRIVATE_logDebug($780b92061aa4a3e6$var$an, "Operation failed with retryable error: " + e);
            }
            this.Zu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.F_.g_(()=>this.cc());
        }
    }
    uc(e) {
        const t = this._c.then(()=>(this.nc = !0, e().catch((e)=>{
                this.tc = e, this.nc = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $780b92061aa4a3e6$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $780b92061aa4a3e6$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.nc = !1, e))));
        return this._c = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.ac(), // Fast-forward delays for timerIds that have been overridden.
        this.sc.indexOf(e) > -1 && (t = 0);
        const r = $780b92061aa4a3e6$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.lc(e));
        return this.ec.push(r), r;
    }
    ac() {
        this.tc && $780b92061aa4a3e6$var$fail(47125, {
            hc: $780b92061aa4a3e6$var$__PRIVATE_getMessageOrStack(this.tc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async Pc() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this._c, await e;
        while (e !== this._c);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Tc(e) {
        for (const t of this.ec)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Ic(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Pc().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.ec.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.ec)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.Pc();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ dc(e) {
        this.sc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ lc(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.ec.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.ec.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $780b92061aa4a3e6$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $780b92061aa4a3e6$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $780b92061aa4a3e6$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $780b92061aa4a3e6$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $780b92061aa4a3e6$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $780b92061aa4a3e6$export$d0e2b3272814ce82 extends $780b92061aa4a3e6$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $780b92061aa4a3e6$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $780b92061aa4a3e6$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $780b92061aa4a3e6$export$9061557f3e3b42f9(e, t, n) {
    n || (n = $780b92061aa4a3e6$var$ut);
    const r = (0, $eda286d93c7c2273$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $abbde52b10a5c31f$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $780b92061aa4a3e6$var$Ot) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $abbde52b10a5c31f$export$5b4d24b45140ad90)(t.host) && (0, $abbde52b10a5c31f$export$c0f0d0ce4283a937)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $780b92061aa4a3e6$export$f06a05d14c3a6678(e, n) {
    const r = "object" == typeof e ? e : (0, $eda286d93c7c2273$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : n || $780b92061aa4a3e6$var$ut, s = (0, $eda286d93c7c2273$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $abbde52b10a5c31f$export$a3febcf1f14a3a0c)("firestore");
        e && $780b92061aa4a3e6$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $780b92061aa4a3e6$export$8da5fbea04405656(e) {
    if (e._terminated) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $780b92061aa4a3e6$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $780b92061aa4a3e6$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $780b92061aa4a3e6$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $780b92061aa4a3e6$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams, r.isUsingEmulator);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._componentsProvider || (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._componentsProvider = {
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    }), e._firestoreClient = new $780b92061aa4a3e6$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = null == e ? void 0 : e._online.build();
        return {
            _offline: null == e ? void 0 : e._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $780b92061aa4a3e6$export$cebe3b626a79c5f3(e, t) {
    $780b92061aa4a3e6$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $780b92061aa4a3e6$var$__PRIVATE_setPersistenceProviders(e, $780b92061aa4a3e6$var$OnlineComponentProvider.provider, {
        build: (e)=>new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, null == t ? void 0 : t.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $780b92061aa4a3e6$export$6d4c055e91302ab9(e) {
    $780b92061aa4a3e6$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $780b92061aa4a3e6$var$__PRIVATE_setPersistenceProviders(e, $780b92061aa4a3e6$var$OnlineComponentProvider.provider, {
        build: (e)=>new $780b92061aa4a3e6$var$__PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $780b92061aa4a3e6$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82))._firestoreClient || e._terminated) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $780b92061aa4a3e6$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $780b92061aa4a3e6$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$780b92061aa4a3e6$var$__PRIVATE_SimpleDb.C()) return Promise.resolve();
                const t = e + $780b92061aa4a3e6$var$qt;
                await $780b92061aa4a3e6$var$__PRIVATE_SimpleDb.delete(t);
            }($780b92061aa4a3e6$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $780b92061aa4a3e6$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$780b92061aa4a3e6$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $780b92061aa4a3e6$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $780b92061aa4a3e6$export$ee6bdee8287ecc5f(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientEnableNetwork($780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $780b92061aa4a3e6$export$f35b708ad73d52eb(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientDisableNetwork($780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $780b92061aa4a3e6$export$9aff22d1ec357a14(e) {
    return (0, $eda286d93c7c2273$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $780b92061aa4a3e6$export$4b8b93c690c9810b(e, t) {
    const n = $780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82)), r = new $780b92061aa4a3e6$export$6cac12425252ec14;
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $780b92061aa4a3e6$export$169d2c6fe0f7f4ea(e, t) {
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetNamedQuery($780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82)), t).then((t)=>t ? new $780b92061aa4a3e6$export$62297b13309008b2(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $780b92061aa4a3e6$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(e = "count", t){
        this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = e;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $780b92061aa4a3e6$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1($780b92061aa4a3e6$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1($780b92061aa4a3e6$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($780b92061aa4a3e6$var$__PRIVATE_validateJSON(e, $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1._jsonSchema)) return $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1.fromBase64String(e.bytes);
    }
}
$780b92061aa4a3e6$export$9f55f2e2bf8c2fc1._jsonSchemaVersion = "firestore/bytes/1.0", $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1._jsonSchema = {
    type: $780b92061aa4a3e6$var$property("string", $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1._jsonSchemaVersion),
    bytes: $780b92061aa4a3e6$var$property("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $780b92061aa4a3e6$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $780b92061aa4a3e6$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $780b92061aa4a3e6$export$bf6e62266977b8eb() {
    return new $780b92061aa4a3e6$export$a1a8fea822d17659($780b92061aa4a3e6$var$B);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $780b92061aa4a3e6$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $780b92061aa4a3e6$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $780b92061aa4a3e6$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $780b92061aa4a3e6$export$f9f719d1b6419c4._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($780b92061aa4a3e6$var$__PRIVATE_validateJSON(e, $780b92061aa4a3e6$export$f9f719d1b6419c4._jsonSchema)) return new $780b92061aa4a3e6$export$f9f719d1b6419c4(e.latitude, e.longitude);
    }
}
$780b92061aa4a3e6$export$f9f719d1b6419c4._jsonSchemaVersion = "firestore/geoPoint/1.0", $780b92061aa4a3e6$export$f9f719d1b6419c4._jsonSchema = {
    type: $780b92061aa4a3e6$var$property("string", $780b92061aa4a3e6$export$f9f719d1b6419c4._jsonSchemaVersion),
    latitude: $780b92061aa4a3e6$var$property("number"),
    longitude: $780b92061aa4a3e6$var$property("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 *
 * @class VectorValue
 */ class $780b92061aa4a3e6$export$994bb3d317350b37 {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $780b92061aa4a3e6$export$994bb3d317350b37._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($780b92061aa4a3e6$var$__PRIVATE_validateJSON(e, $780b92061aa4a3e6$export$994bb3d317350b37._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $780b92061aa4a3e6$export$994bb3d317350b37(e.vectorValues);
            throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$780b92061aa4a3e6$export$994bb3d317350b37._jsonSchemaVersion = "firestore/vectorValue/1.0", $780b92061aa4a3e6$export$994bb3d317350b37._jsonSchema = {
    type: $780b92061aa4a3e6$var$property("string", $780b92061aa4a3e6$export$994bb3d317350b37._jsonSchemaVersion),
    vectorValues: $780b92061aa4a3e6$var$property("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$cn = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $780b92061aa4a3e6$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $780b92061aa4a3e6$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $780b92061aa4a3e6$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $780b92061aa4a3e6$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $780b92061aa4a3e6$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $780b92061aa4a3e6$var$fail(40011, {
                Ec: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $780b92061aa4a3e6$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.Ac(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get Ec() {
        return this.settings.Ec;
    }
    /** Returns a new context with the specified settings overwritten. */ Rc(e) {
        return new $780b92061aa4a3e6$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    Vc(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Rc({
            path: n,
            mc: !1
        });
        return r.fc(e), r;
    }
    gc(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Rc({
            path: n,
            mc: !1
        });
        return r.Ac(), r;
    }
    yc(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.Rc({
            path: void 0,
            mc: !0
        });
    }
    wc(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.Sc || !1, this.path, this.settings.bc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    Ac() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.fc(this.path.get(e));
    }
    fc(e) {
        if (0 === e.length) throw this.wc("Document fields must not be empty");
        if ($780b92061aa4a3e6$var$__PRIVATE_isWrite(this.Ec) && $780b92061aa4a3e6$var$cn.test(e)) throw this.wc('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $780b92061aa4a3e6$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $780b92061aa4a3e6$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ Dc(e, t, n, r = !1) {
        return new $780b92061aa4a3e6$var$__PRIVATE_ParseContextImpl({
            Ec: e,
            methodName: t,
            bc: n,
            path: $780b92061aa4a3e6$export$b7871852b967eaf1.emptyPath(),
            mc: !1,
            Sc: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $780b92061aa4a3e6$var$__PRIVATE_newSerializer(e._databaseId);
    return new $780b92061aa4a3e6$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $780b92061aa4a3e6$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.Dc(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $780b92061aa4a3e6$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $780b92061aa4a3e6$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $780b92061aa4a3e6$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $780b92061aa4a3e6$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $780b92061aa4a3e6$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $780b92061aa4a3e6$var$ParsedSetData(new $780b92061aa4a3e6$var$ObjectValue(_), a, u);
}
class $780b92061aa4a3e6$var$__PRIVATE_DeleteFieldValueImpl extends $780b92061aa4a3e6$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.Ec) throw 1 /* UserDataSource.Update */  === e.Ec ? e.wc(`${this._methodName}() can only appear at the top level of your update data`) : e.wc(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $780b92061aa4a3e6$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $780b92061aa4a3e6$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $780b92061aa4a3e6$var$__PRIVATE_ParseContextImpl({
        Ec: 3 /* UserDataSource.Argument */ ,
        bc: t.settings.bc,
        methodName: e._methodName,
        mc: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampFieldValueImpl extends $780b92061aa4a3e6$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $780b92061aa4a3e6$var$FieldTransform(e.path, new $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionFieldValueImpl extends $780b92061aa4a3e6$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_parseData(e, t)), r = new $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $780b92061aa4a3e6$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $abbde52b10a5c31f$export$9cb4719e2e525b7a)(this.vc, e.vc);
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $780b92061aa4a3e6$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.vc = t;
    }
    _toFieldTransform(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.vc.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_parseData(e, t)), r = new $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $780b92061aa4a3e6$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $abbde52b10a5c31f$export$9cb4719e2e525b7a)(this.vc, e.vc);
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementFieldValueImpl extends $780b92061aa4a3e6$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Cc = t;
    }
    _toFieldTransform(e) {
        const t = new $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $780b92061aa4a3e6$var$toNumber(e.serializer, this.Cc));
        return new $780b92061aa4a3e6$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Cc === e.Cc;
    }
}
/** Parse update data from an update() call. */ function $780b92061aa4a3e6$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.Dc(1 /* UserDataSource.Update */ , t, n);
    $780b92061aa4a3e6$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $780b92061aa4a3e6$var$ObjectValue.empty();
    $780b92061aa4a3e6$var$forEach(r, (e, r)=>{
        const _ = $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(r);
        const a = i.gc(_);
        if (r instanceof $780b92061aa4a3e6$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $780b92061aa4a3e6$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $780b92061aa4a3e6$var$FieldMask(s);
    return new $780b92061aa4a3e6$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $780b92061aa4a3e6$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.Dc(1 /* UserDataSource.Update */ , t, n), _ = [
        $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $780b92061aa4a3e6$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$780b92061aa4a3e6$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(n);
        const r = o.gc(t);
        if (n instanceof $780b92061aa4a3e6$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $780b92061aa4a3e6$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $780b92061aa4a3e6$var$FieldMask(u);
    return new $780b92061aa4a3e6$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $780b92061aa4a3e6$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $780b92061aa4a3e6$var$__PRIVATE_parseData(n, e.Dc(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $780b92061aa4a3e6$var$__PRIVATE_parseData(e, t) {
    if ($780b92061aa4a3e6$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e))) return $780b92061aa4a3e6$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $780b92061aa4a3e6$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $780b92061aa4a3e6$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$780b92061aa4a3e6$var$__PRIVATE_isWrite(t.Ec)) throw t.wc(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.wc(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.mc && 4 /* UserDataSource.ArrayArgument */  !== t.Ec) throw t.wc("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $780b92061aa4a3e6$var$__PRIVATE_parseData(i, t.yc(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $780b92061aa4a3e6$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $780b92061aa4a3e6$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $780b92061aa4a3e6$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $780b92061aa4a3e6$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $780b92061aa4a3e6$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $780b92061aa4a3e6$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $780b92061aa4a3e6$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $780b92061aa4a3e6$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.wc(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $780b92061aa4a3e6$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $780b92061aa4a3e6$export$994bb3d317350b37) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = {
                fields: {
                    [$780b92061aa4a3e6$var$ct]: {
                        stringValue: $780b92061aa4a3e6$var$Pt
                    },
                    [$780b92061aa4a3e6$var$Tt]: {
                        arrayValue: {
                            values: e.toArray().map((e)=>{
                                if ("number" != typeof e) throw t.wc("VectorValues must only contain numeric values.");
                                return $780b92061aa4a3e6$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: n
            };
        }(e, t);
        throw t.wc(`Unsupported field value: ${$780b92061aa4a3e6$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $780b92061aa4a3e6$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $780b92061aa4a3e6$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $780b92061aa4a3e6$var$forEach(e, (e, r)=>{
        const i = $780b92061aa4a3e6$var$__PRIVATE_parseData(r, t.Vc(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $780b92061aa4a3e6$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $780b92061aa4a3e6$export$d9bcbd5e1ff81430 || e instanceof $780b92061aa4a3e6$export$f9f719d1b6419c4 || e instanceof $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1 || e instanceof $780b92061aa4a3e6$export$6be62b059fb12175 || e instanceof $780b92061aa4a3e6$export$c58bc8ee7ecc248d || e instanceof $780b92061aa4a3e6$export$994bb3d317350b37);
}
function $780b92061aa4a3e6$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$780b92061aa4a3e6$var$__PRIVATE_looksLikeJsonObject(n) || !$780b92061aa4a3e6$var$__PRIVATE_isPlainObject(n)) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.wc(e + " a custom object") : t.wc(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(t)) instanceof $780b92061aa4a3e6$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $780b92061aa4a3e6$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $780b92061aa4a3e6$var$ln = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($780b92061aa4a3e6$var$ln) >= 0) throw $780b92061aa4a3e6$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $780b92061aa4a3e6$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $780b92061aa4a3e6$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $780b92061aa4a3e6$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $780b92061aa4a3e6$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $780b92061aa4a3e6$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $780b92061aa4a3e6$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $780b92061aa4a3e6$var$QueryDocumentSnapshot$1 extends $780b92061aa4a3e6$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $780b92061aa4a3e6$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $780b92061aa4a3e6$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $780b92061aa4a3e6$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $780b92061aa4a3e6$export$b0e86f2c7431df4e extends $780b92061aa4a3e6$var$AppliableConstraint {
}
function $780b92061aa4a3e6$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $780b92061aa4a3e6$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $780b92061aa4a3e6$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $780b92061aa4a3e6$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $780b92061aa4a3e6$export$f765fc5789dfd439 extends $780b92061aa4a3e6$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $780b92061aa4a3e6$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $780b92061aa4a3e6$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $780b92061aa4a3e6$export$62297b13309008b2(e.firestore, e.converter, $780b92061aa4a3e6$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $780b92061aa4a3e6$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($780b92061aa4a3e6$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $780b92061aa4a3e6$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $780b92061aa4a3e6$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $780b92061aa4a3e6$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            const a = $780b92061aa4a3e6$var$FieldFilter.create(i, s, _);
            return a;
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $780b92061aa4a3e6$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $780b92061aa4a3e6$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $780b92061aa4a3e6$export$6bbc7aef0717f3d2 extends $780b92061aa4a3e6$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $780b92061aa4a3e6$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $780b92061aa4a3e6$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$780b92061aa4a3e6$var$__PRIVATE_validateNewFieldFilter(n, e), n = $780b92061aa4a3e6$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $780b92061aa4a3e6$export$62297b13309008b2(e.firestore, e.converter, $780b92061aa4a3e6$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $780b92061aa4a3e6$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$780b92061aa4a3e6$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $780b92061aa4a3e6$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $780b92061aa4a3e6$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$780b92061aa4a3e6$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $780b92061aa4a3e6$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $780b92061aa4a3e6$export$65a9ba8bbd6ed9e3 extends $780b92061aa4a3e6$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $780b92061aa4a3e6$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new $780b92061aa4a3e6$var$OrderBy(t, n);
            return r;
        }(e._query, this._field, this._direction);
        return new $780b92061aa4a3e6$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $780b92061aa4a3e6$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $780b92061aa4a3e6$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $780b92061aa4a3e6$export$49bb5356ca788047 extends $780b92061aa4a3e6$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $780b92061aa4a3e6$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $780b92061aa4a3e6$export$62297b13309008b2(e.firestore, e.converter, $780b92061aa4a3e6$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $780b92061aa4a3e6$export$ee37e834aaad6f7e(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_validatePositiveNumber("limit", e), $780b92061aa4a3e6$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $780b92061aa4a3e6$export$f823b3589f69d3b8(e) {
    return $780b92061aa4a3e6$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $780b92061aa4a3e6$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $780b92061aa4a3e6$export$d92e2830aca1d816 extends $780b92061aa4a3e6$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $780b92061aa4a3e6$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $780b92061aa4a3e6$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $780b92061aa4a3e6$export$859941c5fc8eba6b(...e) {
    return $780b92061aa4a3e6$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $780b92061aa4a3e6$export$dd8dee5f7b804673(...e) {
    return $780b92061aa4a3e6$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $780b92061aa4a3e6$export$fd1782fd870d1e06 extends $780b92061aa4a3e6$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $780b92061aa4a3e6$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $780b92061aa4a3e6$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $780b92061aa4a3e6$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $780b92061aa4a3e6$export$57203950645b8b11(...e) {
    return $780b92061aa4a3e6$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $780b92061aa4a3e6$export$28ec54a8428bdb3f(...e) {
    return $780b92061aa4a3e6$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $780b92061aa4a3e6$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $780b92061aa4a3e6$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $780b92061aa4a3e6$var$__PRIVATE_queryNormalizedOrderBy(e))if (n.field.isKeyField()) s.push($780b92061aa4a3e6$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($780b92061aa4a3e6$var$__PRIVATE_isServerTimestamp(e)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $780b92061aa4a3e6$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$780b92061aa4a3e6$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($780b92061aa4a3e6$var$ResourcePath.fromString(a));
                    if (!$780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(n)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $780b92061aa4a3e6$export$afc2e57c475b7810(n);
                    _.push($780b92061aa4a3e6$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $780b92061aa4a3e6$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $780b92061aa4a3e6$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$780b92061aa4a3e6$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($780b92061aa4a3e6$var$ResourcePath.fromString(n));
        if (!$780b92061aa4a3e6$export$afc2e57c475b7810.isDocumentKey(r)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $780b92061aa4a3e6$var$__PRIVATE_refValue(e, new $780b92061aa4a3e6$export$afc2e57c475b7810(r));
    }
    if (n instanceof $780b92061aa4a3e6$export$6be62b059fb12175) return $780b92061aa4a3e6$var$__PRIVATE_refValue(e, n._key);
    throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$780b92061aa4a3e6$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $780b92061aa4a3e6$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $780b92061aa4a3e6$var$__PRIVATE_validateNewFieldFilter(e, t) {
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $780b92061aa4a3e6$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $780b92061aa4a3e6$export$f765fc5789dfd439 || t instanceof $780b92061aa4a3e6$export$6bbc7aef0717f3d2)) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $780b92061aa4a3e6$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($780b92061aa4a3e6$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($780b92061aa4a3e6$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $780b92061aa4a3e6$var$fail(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $780b92061aa4a3e6$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        var t, n, r;
        const i = null === (r = null === (n = null === (t = e.fields) || void 0 === t ? void 0 : t[$780b92061aa4a3e6$var$Tt].arrayValue) || void 0 === n ? void 0 : n.values) || void 0 === r ? void 0 : r.map((e)=>$780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $780b92061aa4a3e6$export$994bb3d317350b37(i);
    }
    convertGeoPoint(e) {
        return new $780b92061aa4a3e6$export$f9f719d1b6419c4($780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.latitude), $780b92061aa4a3e6$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $780b92061aa4a3e6$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($780b92061aa4a3e6$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_normalizeTimestamp(e);
        return new $780b92061aa4a3e6$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $780b92061aa4a3e6$var$ResourcePath.fromString(e);
        $780b92061aa4a3e6$var$__PRIVATE_hardAssert($780b92061aa4a3e6$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $780b92061aa4a3e6$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $780b92061aa4a3e6$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $780b92061aa4a3e6$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $780b92061aa4a3e6$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $780b92061aa4a3e6$var$__PRIVATE_LiteUserDataWriter extends $780b92061aa4a3e6$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $780b92061aa4a3e6$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 */ function $780b92061aa4a3e6$export$8a63f25cc62965f1(e) {
    return new $780b92061aa4a3e6$export$fada2345be8928cf("sum", $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 */ function $780b92061aa4a3e6$export$cc6710ee5f037d57(e) {
    return new $780b92061aa4a3e6$export$fada2345be8928cf("avg", $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $780b92061aa4a3e6$export$85b9a36db797e02b() {
    return new $780b92061aa4a3e6$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 */ function $780b92061aa4a3e6$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $780b92061aa4a3e6$export$fada2345be8928cf && t instanceof $780b92061aa4a3e6$export$fada2345be8928cf && e.aggregateType === t.aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $780b92061aa4a3e6$export$104f59389a332076(e, t) {
    return $780b92061aa4a3e6$export$49b1d0de6ba30f41(e.query, t.query) && (0, $abbde52b10a5c31f$export$9cb4719e2e525b7a)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$hn = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $780b92061aa4a3e6$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $780b92061aa4a3e6$export$acab0e6ef25eb301 extends $780b92061aa4a3e6$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $780b92061aa4a3e6$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($780b92061aa4a3e6$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const e = this._document, t = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (t.type = $780b92061aa4a3e6$export$acab0e6ef25eb301._jsonSchemaVersion, t.bundle = "", t.bundleSource = "DocumentSnapshot", t.bundleName = this._key.toString(), !e || !e.isValidDocument() || !e.isFoundDocument()) return t;
        this._userDataWriter.convertObjectMap(e.data.value.mapValue.fields, "previous");
        return t.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), t;
    }
}
function $780b92061aa4a3e6$export$bbac1bdeb8972634(e, t, n) {
    if ($780b92061aa4a3e6$var$__PRIVATE_validateJSON(t, $780b92061aa4a3e6$export$acab0e6ef25eb301._jsonSchema)) {
        if (t.bundle === $780b92061aa4a3e6$var$hn) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = $780b92061aa4a3e6$var$__PRIVATE_newSerializer(e._databaseId), i = $780b92061aa4a3e6$var$__PRIVATE_createBundleReaderSync(t.bundle, r), s = i.Ku(), o = new $780b92061aa4a3e6$var$__PRIVATE_BundleLoader(i.getMetadata(), r);
        for (const e of s)o.Wa(e);
        // Ensure that we have the correct number of documents in the bundle.
        const _ = o.documents;
        if (1 !== _.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${_.length} documents.`);
        // Build out the internal document data.
        const a = $780b92061aa4a3e6$var$__PRIVATE_fromDocument(r, _[0].document), u = new $780b92061aa4a3e6$export$afc2e57c475b7810($780b92061aa4a3e6$var$ResourcePath.fromString(t.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $780b92061aa4a3e6$export$acab0e6ef25eb301(e, new $780b92061aa4a3e6$var$__PRIVATE_LiteUserDataWriter(e), u, a, new $780b92061aa4a3e6$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $780b92061aa4a3e6$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $780b92061aa4a3e6$export$acab0e6ef25eb301._jsonSchema = {
    type: $780b92061aa4a3e6$var$property("string", $780b92061aa4a3e6$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: $780b92061aa4a3e6$var$property("string", "DocumentSnapshot"),
    bundleName: $780b92061aa4a3e6$var$property("string"),
    bundle: $780b92061aa4a3e6$var$property("string")
};
class $780b92061aa4a3e6$export$6d4d04e42af6b03c extends $780b92061aa4a3e6$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $780b92061aa4a3e6$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $780b92061aa4a3e6$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $780b92061aa4a3e6$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $780b92061aa4a3e6$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $780b92061aa4a3e6$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $780b92061aa4a3e6$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $780b92061aa4a3e6$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $780b92061aa4a3e6$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $780b92061aa4a3e6$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = {};
        e.type = $780b92061aa4a3e6$export$8f21149d8133945c._jsonSchemaVersion, e.bundleSource = "QuerySnapshot", e.bundleName = $780b92061aa4a3e6$export$253bcaa5572dcc83.newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const t = [], n = [], r = [];
        return this.docs.forEach((e)=>{
            null !== e._document && (t.push(e._document), n.push(this._userDataWriter.convertObjectMap(e._document.data.value.mapValue.fields, "previous")), r.push(e.ref.path));
        }), e.bundle = (this._firestore, this.query._query, e.bundleName, "NOT SUPPORTED"), e;
    }
}
function $780b92061aa4a3e6$export$5bed7af38da9d026(e, t, n) {
    if ($780b92061aa4a3e6$var$__PRIVATE_validateJSON(t, $780b92061aa4a3e6$export$8f21149d8133945c._jsonSchema)) {
        if (t.bundle === $780b92061aa4a3e6$var$hn) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = $780b92061aa4a3e6$var$__PRIVATE_newSerializer(e._databaseId), i = $780b92061aa4a3e6$var$__PRIVATE_createBundleReaderSync(t.bundle, r), s = i.Ku(), o = new $780b92061aa4a3e6$var$__PRIVATE_BundleLoader(i.getMetadata(), r);
        for (const e of s)o.Wa(e);
        if (1 !== o.queries.length) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const _ = $780b92061aa4a3e6$var$__PRIVATE_fromBundledQuery(o.queries[0].bundledQuery), a = o.documents;
        // Construct the arrays of document data for the query.
        let u = new $780b92061aa4a3e6$var$DocumentSet;
        a.map((e)=>{
            const t = $780b92061aa4a3e6$var$__PRIVATE_fromDocument(r, e.document);
            u = u.add(t);
        });
        // Create a view snapshot of the query and documents.
        const c = $780b92061aa4a3e6$var$ViewSnapshot.fromInitialDocuments(_, u, $780b92061aa4a3e6$var$__PRIVATE_documentKeySet(), /* fromCache= */ !1, /* hasCachedResults= */ !1), l = new $780b92061aa4a3e6$export$62297b13309008b2(e, n || null, _);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $780b92061aa4a3e6$export$8f21149d8133945c(e, new $780b92061aa4a3e6$var$__PRIVATE_LiteUserDataWriter(e), l, c);
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $780b92061aa4a3e6$var$fail(61501, {
                type: e
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $780b92061aa4a3e6$export$f243a5d948512846(e, t) {
    return e instanceof $780b92061aa4a3e6$export$acab0e6ef25eb301 && t instanceof $780b92061aa4a3e6$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $780b92061aa4a3e6$export$8f21149d8133945c && t instanceof $780b92061aa4a3e6$export$8f21149d8133945c && e._firestore === t._firestore && $780b92061aa4a3e6$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $780b92061aa4a3e6$export$11eb3b5ef9574821(e) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$6be62b059fb12175);
    const t = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82);
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($780b92061aa4a3e6$export$8da5fbea04405656(t), e._key).then((n)=>$780b92061aa4a3e6$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
$780b92061aa4a3e6$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $780b92061aa4a3e6$export$8f21149d8133945c._jsonSchema = {
    type: $780b92061aa4a3e6$var$property("string", $780b92061aa4a3e6$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: $780b92061aa4a3e6$var$property("string", "QuerySnapshot"),
    bundleName: $780b92061aa4a3e6$var$property("string"),
    bundle: $780b92061aa4a3e6$var$property("string")
};
class $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter extends $780b92061aa4a3e6$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $780b92061aa4a3e6$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $780b92061aa4a3e6$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $780b92061aa4a3e6$export$a58bd92642f7fb58(e) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$6be62b059fb12175);
    const t = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), n = $780b92061aa4a3e6$export$8da5fbea04405656(t), r = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(t);
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $780b92061aa4a3e6$export$acab0e6ef25eb301(t, r, e._key, n, new $780b92061aa4a3e6$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $780b92061aa4a3e6$export$35dd759aed9686b4(e) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$6be62b059fb12175);
    const t = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82);
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($780b92061aa4a3e6$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$780b92061aa4a3e6$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $780b92061aa4a3e6$export$81d3477bd73c86ef(e) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$62297b13309008b2);
    const t = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), n = $780b92061aa4a3e6$export$8da5fbea04405656(t), r = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(t);
    return $780b92061aa4a3e6$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $780b92061aa4a3e6$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $780b92061aa4a3e6$export$3fd010f18eac1dd(e) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$62297b13309008b2);
    const t = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), n = $780b92061aa4a3e6$export$8da5fbea04405656(t), r = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(t);
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $780b92061aa4a3e6$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $780b92061aa4a3e6$export$ec7d9e44f349c77b(e) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$62297b13309008b2);
    const t = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), n = $780b92061aa4a3e6$export$8da5fbea04405656(t), r = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(t);
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $780b92061aa4a3e6$export$8f21149d8133945c(t, r, e, n));
}
function $780b92061aa4a3e6$export$5ff77ddaff3c9e12(e, t, n) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$6be62b059fb12175);
    const r = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), i = $780b92061aa4a3e6$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $780b92061aa4a3e6$export$1945f8fec9dda613(r, [
        $780b92061aa4a3e6$var$__PRIVATE_parseSetData($780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $780b92061aa4a3e6$var$Precondition.none())
    ]);
}
function $780b92061aa4a3e6$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$6be62b059fb12175);
    const i = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), s = $780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(t)) || t instanceof $780b92061aa4a3e6$export$a1a8fea822d17659 ? $780b92061aa4a3e6$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $780b92061aa4a3e6$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $780b92061aa4a3e6$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $780b92061aa4a3e6$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $780b92061aa4a3e6$export$a4f20481fae8f78b(e) {
    return $780b92061aa4a3e6$export$1945f8fec9dda613($780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), [
        new $780b92061aa4a3e6$var$__PRIVATE_DeleteMutation(e._key, $780b92061aa4a3e6$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $780b92061aa4a3e6$export$a13890143fb1c2dd(e, t) {
    const n = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), r = $780b92061aa4a3e6$export$2a111da947c407d2(e), i = $780b92061aa4a3e6$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $780b92061aa4a3e6$export$1945f8fec9dda613(n, [
        $780b92061aa4a3e6$var$__PRIVATE_parseSetData($780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $780b92061aa4a3e6$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $780b92061aa4a3e6$export$d36370812fb26935(e, ...t) {
    var n, r, i;
    // onSnapshot for Query or Document.
    e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e);
    let s = {
        includeMetadataChanges: !1,
        source: "default"
    }, o = 0;
    "object" != typeof t[o] || $780b92061aa4a3e6$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o++]);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges,
        source: s.source
    };
    if ($780b92061aa4a3e6$var$__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof $780b92061aa4a3e6$export$6be62b059fb12175) u = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), c = $780b92061aa4a3e6$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: (n)=>{
            t[o] && t[o]($780b92061aa4a3e6$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        const n = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$62297b13309008b2);
        u = $780b92061aa4a3e6$export$572106fb5803752c(n.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), c = n._query;
        const r = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: (e)=>{
                t[o] && t[o](new $780b92061aa4a3e6$export$8f21149d8133945c(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $780b92061aa4a3e6$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $780b92061aa4a3e6$var$__PRIVATE_AsyncObserver(r), s = new $780b92061aa4a3e6$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$780b92061aa4a3e6$var$__PRIVATE_eventManagerListen(await $780b92061aa4a3e6$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.Ou(), e.asyncQueue.enqueueAndForget(async ()=>$780b92061aa4a3e6$var$__PRIVATE_eventManagerUnlisten(await $780b92061aa4a3e6$var$__PRIVATE_getEventManager(e), s));
        };
    }($780b92061aa4a3e6$export$8da5fbea04405656(u), c, _, a);
}
function $780b92061aa4a3e6$export$a1ef90ed3b4a87fa(e, t, ...n) {
    const r = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e), i = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(e) {
        const t = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in e)) {
                t.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = e[r];
            if ("string" != typeof n) {
                t.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                t.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? t.bundle = n : "bundleName" === r ? t.bundleName = n : "bundleSource" === r && (t.bundleSource = n);
        }
        return t;
    }(t);
    if (i.error) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, i.error);
    let s, o = 0;
    if ("object" != typeof n[o] || $780b92061aa4a3e6$var$__PRIVATE_isPartialObserver(n[o]) || (s = n[o++]), "QuerySnapshot" === i.bundleSource) {
        let e = null;
        if ("object" == typeof n[o] && $780b92061aa4a3e6$var$__PRIVATE_isPartialObserver(n[o])) {
            const t = n[o++];
            e = {
                next: t.next,
                error: t.error,
                complete: t.complete
            };
        } else e = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(e, t, n, r, i) {
            let s, o = !1;
            const _ = $780b92061aa4a3e6$export$4b8b93c690c9810b(e, t.bundle);
            return _.then(()=>$780b92061aa4a3e6$export$169d2c6fe0f7f4ea(e, t.bundleName)).then((e)=>{
                if (e && !o) i && e.withConverter(i), s = $780b92061aa4a3e6$export$d36370812fb26935(e, n || {}, r);
            }).catch((e)=>(r.error && r.error(e), ()=>{})), ()=>{
                o || (o = !0, s && s());
            };
        }(r, i, s, e, n[o]);
    }
    if ("DocumentSnapshot" === i.bundleSource) {
        let e = null;
        if ("object" == typeof n[o] && $780b92061aa4a3e6$var$__PRIVATE_isPartialObserver(n[o])) {
            const t = n[o++];
            e = {
                next: t.next,
                error: t.error,
                complete: t.complete
            };
        } else e = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(e, t, n, r, i) {
            let s, o = !1;
            const _ = $780b92061aa4a3e6$export$4b8b93c690c9810b(e, t.bundle);
            return _.then(()=>{
                if (!o) {
                    const o = new $780b92061aa4a3e6$export$6be62b059fb12175(e, i || null, $780b92061aa4a3e6$export$afc2e57c475b7810.fromPath(t.bundleName));
                    s = $780b92061aa4a3e6$export$d36370812fb26935(o, n || {}, r);
                }
            }).catch((e)=>(r.error && r.error(e), ()=>{})), ()=>{
                o || (o = !0, s && s());
            };
        }(r, i, s, e, n[o]);
    }
    throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, `unsupported bundle source: ${i.bundleSource}`);
}
function $780b92061aa4a3e6$export$9dff4f5aba83e348(e, t) {
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82)), $780b92061aa4a3e6$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $780b92061aa4a3e6$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$780b92061aa4a3e6$var$__PRIVATE_syncEngineWrite(await $780b92061aa4a3e6$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($780b92061aa4a3e6$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $780b92061aa4a3e6$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(e);
    return new $780b92061aa4a3e6$export$acab0e6ef25eb301(e, i, t._key, r, new $780b92061aa4a3e6$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
function $780b92061aa4a3e6$export$b1de1b12889d0afb(e) {
    return $780b92061aa4a3e6$export$a51511de2fae49b3(e, {
        count: $780b92061aa4a3e6$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set is aggregated over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $780b92061aa4a3e6$export$a51511de2fae49b3(e, t) {
    const n = $780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82), r = $780b92061aa4a3e6$export$8da5fbea04405656(n), i = $780b92061aa4a3e6$var$__PRIVATE_mapToArray(t, (e, t)=>new $780b92061aa4a3e6$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientRunAggregateQuery(r, e._query, i).then((t)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(e), i = new $780b92061aa4a3e6$export$40257fef64be808b(t, r, n);
            return i;
        })(n, e, t));
}
class $780b92061aa4a3e6$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = $780b92061aa4a3e6$var$OnlineComponentProvider.provider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = {
            build: ()=>new $780b92061aa4a3e6$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $780b92061aa4a3e6$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = $780b92061aa4a3e6$var$__PRIVATE_MemoryOfflineComponentProvider.provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new $780b92061aa4a3e6$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $780b92061aa4a3e6$export$574728f3be606189() {
    return new $780b92061aa4a3e6$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $780b92061aa4a3e6$export$2340f88905cc0c23(e) {
    return new $780b92061aa4a3e6$var$__PRIVATE_MemoryLruGarbageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $780b92061aa4a3e6$export$72ef71adb739a32c(e) {
    return new $780b92061aa4a3e6$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $780b92061aa4a3e6$export$51b321e43d5331d5(e) {
    return new $780b92061aa4a3e6$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $780b92061aa4a3e6$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $780b92061aa4a3e6$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $780b92061aa4a3e6$var$__PRIVATE_IndexedDbOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $780b92061aa4a3e6$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = $780b92061aa4a3e6$var$OnlineComponentProvider.provider, this._offlineComponentProvider = {
            build: (t)=>new $780b92061aa4a3e6$var$__PRIVATE_MultiTabOfflineComponentProvider(t, null == e ? void 0 : e.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $780b92061aa4a3e6$export$d5f96a3c009e86ac(e) {
    return new $780b92061aa4a3e6$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $780b92061aa4a3e6$export$57e9d290b0b4dc04() {
    return new $780b92061aa4a3e6$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $780b92061aa4a3e6$var$Pn = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $780b92061aa4a3e6$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore), i = $780b92061aa4a3e6$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $780b92061aa4a3e6$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $780b92061aa4a3e6$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(t)) || t instanceof $780b92061aa4a3e6$export$a1a8fea822d17659 ? $780b92061aa4a3e6$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $780b92061aa4a3e6$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $780b92061aa4a3e6$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $780b92061aa4a3e6$var$__PRIVATE_DeleteMutation(t._key, $780b92061aa4a3e6$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(e)).firestore !== t) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $780b92061aa4a3e6$var$Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $780b92061aa4a3e6$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore), n = new $780b92061aa4a3e6$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $780b92061aa4a3e6$var$fail(24041);
            const r = e[0];
            if (r.isFoundDocument()) return new $780b92061aa4a3e6$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $780b92061aa4a3e6$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $780b92061aa4a3e6$var$fail(18433, {
                doc: r
            });
        });
    }
    set(e, t, n) {
        const r = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore), i = $780b92061aa4a3e6$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $780b92061aa4a3e6$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $abbde52b10a5c31f$export$4befe9b5fa509a1b)(t)) || t instanceof $780b92061aa4a3e6$export$a1a8fea822d17659 ? $780b92061aa4a3e6$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $780b92061aa4a3e6$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $780b92061aa4a3e6$export$febc5573c75cefb0 extends $780b92061aa4a3e6$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $780b92061aa4a3e6$var$__PRIVATE_validateReference(e, this._firestore), n = new $780b92061aa4a3e6$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $780b92061aa4a3e6$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $780b92061aa4a3e6$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $780b92061aa4a3e6$export$3c54e006bf9c93b7(e, t, n) {
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82);
    const r = Object.assign(Object.assign({}, $780b92061aa4a3e6$var$Pn), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $780b92061aa4a3e6$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $780b92061aa4a3e6$var$__PRIVATE_getDatastore(e);
            new $780b92061aa4a3e6$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).zu();
        }), r.promise;
    }($780b92061aa4a3e6$export$8da5fbea04405656(e), (n)=>t(new $780b92061aa4a3e6$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $780b92061aa4a3e6$export$2bbad96c62fdba3e() {
    return new $780b92061aa4a3e6$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $780b92061aa4a3e6$export$3ff8e7e00c3264b7() {
    return new $780b92061aa4a3e6$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $780b92061aa4a3e6$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $780b92061aa4a3e6$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $780b92061aa4a3e6$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $780b92061aa4a3e6$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $780b92061aa4a3e6$export$a2647aa13413c947(e) {
    return new $780b92061aa4a3e6$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $780b92061aa4a3e6$export$6074e20ba5c64bef(e) {
    return new $780b92061aa4a3e6$export$994bb3d317350b37(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $780b92061aa4a3e6$export$44cd1c9d57edd9b1(e) {
    return $780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82)), new $780b92061aa4a3e6$export$d94ed661b1cfd435(e, (t)=>$780b92061aa4a3e6$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $780b92061aa4a3e6$export$ff1663c0c1304f1a(e, t) {
    const n = $780b92061aa4a3e6$export$8da5fbea04405656(e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82));
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $780b92061aa4a3e6$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $780b92061aa4a3e6$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $780b92061aa4a3e6$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $780b92061aa4a3e6$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $780b92061aa4a3e6$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $780b92061aa4a3e6$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $780b92061aa4a3e6$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $780b92061aa4a3e6$var$FieldIndex($780b92061aa4a3e6$var$FieldIndex.UNKNOWN_ID, t, r, $780b92061aa4a3e6$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $780b92061aa4a3e6$var$__PRIVATE_firestoreClientSetIndexConfiguration(n, r);
}
function $780b92061aa4a3e6$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $780b92061aa4a3e6$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(e){
        this._firestore = e, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $780b92061aa4a3e6$export$61c6347b57bdfa06(e) {
    var t;
    e = $780b92061aa4a3e6$export$572106fb5803752c(e, $780b92061aa4a3e6$export$d0e2b3272814ce82);
    const n = $780b92061aa4a3e6$var$Tn.get(e);
    if (n) return n;
    if ("persistent" !== (null === (t = $780b92061aa4a3e6$export$8da5fbea04405656(e)._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offline.kind)) return null;
    const r = new $780b92061aa4a3e6$export$cf4db3c220e88bd8(e);
    return $780b92061aa4a3e6$var$Tn.set(e, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $780b92061aa4a3e6$export$9b2c0a7aacbcd151(e) {
    $780b92061aa4a3e6$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $780b92061aa4a3e6$export$5b460d5f48076743(e) {
    $780b92061aa4a3e6$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $780b92061aa4a3e6$export$72809fc2fc5083d5(e) {
    $780b92061aa4a3e6$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes($780b92061aa4a3e6$export$8da5fbea04405656(e._firestore)).then((e)=>$780b92061aa4a3e6$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded")).catch((e)=>$780b92061aa4a3e6$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e));
}
function $780b92061aa4a3e6$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    $780b92061aa4a3e6$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled($780b92061aa4a3e6$export$8da5fbea04405656(e._firestore), t).then((e)=>$780b92061aa4a3e6$var$__PRIVATE_logDebug(`setting persistent cache index auto creation isEnabled=${t} succeeded`)).catch((e)=>$780b92061aa4a3e6$export$86cd73f49cc6e0bb(`setting persistent cache index auto creation isEnabled=${t} failed`, e));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $780b92061aa4a3e6$var$Tn = new WeakMap;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $780b92061aa4a3e6$export$b22c6725d8899bb4(e) {
    var t;
    const n = null === (t = $780b92061aa4a3e6$export$8da5fbea04405656($780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82))._onlineComponents) || void 0 === t ? void 0 : t.datastore.serializer;
    return void 0 === n ? null : $780b92061aa4a3e6$var$__PRIVATE_toQueryTarget(n, $780b92061aa4a3e6$var$__PRIVATE_queryToTarget(e._query)).Vt;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $780b92061aa4a3e6$export$5bcaa7c32a88925e(e, t) {
    var n;
    const r = $780b92061aa4a3e6$var$__PRIVATE_mapToArray(t, (e, t)=>new $780b92061aa4a3e6$var$__PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), i = null === (n = $780b92061aa4a3e6$export$8da5fbea04405656($780b92061aa4a3e6$export$572106fb5803752c(e.firestore, $780b92061aa4a3e6$export$d0e2b3272814ce82))._onlineComponents) || void 0 === n ? void 0 : n.datastore.serializer;
    return void 0 === i ? null : $780b92061aa4a3e6$var$__PRIVATE_toRunAggregationQueryRequest(i, $780b92061aa4a3e6$var$__PRIVATE_queryToAggregateTarget(e._query), r, /* skipAliasing= */ !0).request;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $780b92061aa4a3e6$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(e) {
        return $780b92061aa4a3e6$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $780b92061aa4a3e6$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.Fc = new Map;
    }
    static get instance() {
        return $780b92061aa4a3e6$var$In || ($780b92061aa4a3e6$var$In = new $780b92061aa4a3e6$var$__PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
            if ($780b92061aa4a3e6$var$pt) throw new Error("a TestingHooksSpi instance is already set");
            $780b92061aa4a3e6$var$pt = e;
        }($780b92061aa4a3e6$var$In)), $780b92061aa4a3e6$var$In;
    }
    ct(e) {
        this.Fc.forEach((t)=>t(e));
    }
    onExistenceFilterMismatch(e) {
        const t = Symbol(), n = this.Fc;
        return n.set(t, e), ()=>n.delete(t);
    }
}
let $780b92061aa4a3e6$var$In = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $780b92061aa4a3e6$var$x = e;
    }((0, $eda286d93c7c2273$export$31499a9cd224b78c)), (0, $eda286d93c7c2273$export$c930050e7bb63965)(new (0, $30f07c707847df11$export$16fa2f45be04daa8)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $780b92061aa4a3e6$export$d0e2b3272814ce82(new $780b92061aa4a3e6$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $780b92061aa4a3e6$var$__PRIVATE_FirebaseAppCheckTokenProvider(i, e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $780b92061aa4a3e6$export$8fada0bf726bf278($780b92061aa4a3e6$var$N.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $780b92061aa4a3e6$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $eda286d93c7c2273$export$d29d5299a7137abc)($780b92061aa4a3e6$var$F, $780b92061aa4a3e6$var$M, e), // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
    (0, $eda286d93c7c2273$export$d29d5299a7137abc)($780b92061aa4a3e6$var$F, $780b92061aa4a3e6$var$M, "esm2017");
}();




var $71b210c792da224a$export$f49165103acf0cf8 = /*#__PURE__*/ function(QueueProviders) {
    QueueProviders["Firestore"] = "Firestore";
    QueueProviders["PubSub"] = "PubSub";
    QueueProviders["File"] = "File";
    return QueueProviders;
}({});


var $69926ef61c0bbaa0$exports = {};
var $d4c1b3532db9c06f$exports = {};
"use strict";
$d4c1b3532db9c06f$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $69926ef61c0bbaa0$var$url = new URL(import.meta.resolve("g7tC0"));
$69926ef61c0bbaa0$exports = $d4c1b3532db9c06f$exports($69926ef61c0bbaa0$var$url.toString(), $69926ef61c0bbaa0$var$url.origin, true);


class $d682416b82a19869$export$f0cad83ff67fe3b extends (0, $9cd293958617bb59$export$3f2f9f5909897157) {
    static{
        // Simple multi-user coordination
        this.styles = (0, $f57b1293e9d8fdf8$export$dbf350e5966cf602)`
    .mdc-card > div {
      margin: 0px 12px 0 12px;
      --mdc-theme-primary: #be153f;
      --mdc-theme-on-primary: white;
    }

    .mdc-card__actions {
      gap: 12px;
    }
  `;
    }
    constructor(){
        super(), this.messageWorker = null, this.firestoreUnsubscribers = new Map(), // Local tracking for immediate UI feedback before server confirmation
        this.localQueueAdjustments = new Map(), // Adaptive polling for better performance
        this.lastUserActivity = Date.now(), this.currentPollingInterval = 30000 // Start with 30 seconds
        , this.pollingTimer = null, // Change detection for requestUpdate optimization
        this.lastQueueCountsHash = "", this.pendingUpdateRequest = false, // Timeout for local adjustments
        this.adjustmentTimeouts = new Map(), this.queueType = "Firestore", this.queues = [], this.reviewRequestsPerQueue = 10, this.queueSelection = [], this.loading = false, this.envelopeIdSearch = "", this.loadingPromise = null, this.projectId = "DEFAULT_PROJECT_ID", this.clientPrefix = "DEFAULT_CLIENT_PREFIX", this.environment = "", this.updateQueueSelection = (e)=>{
            // Record user activity for adaptive polling
            this.recordUserActivity();
            if (e.target) {
                // @ts-ignore
                this.queueSelection = Array.from(e.target.index);
                // Persist queue selection to session
                (0, $cfe1945935cd34b8$export$415798a788f40554).updateSession({
                    selectedQueue: JSON.stringify(this.queueSelection)
                });
            }
        }, this.updateReviewRequestsPerQueue = (e)=>{
            // Record user activity for adaptive polling
            this.recordUserActivity();
            const reviewRequestsPerQueue = e.target.value;
            this.reviewRequestsPerQueue = parseInt(reviewRequestsPerQueue);
        }, this.updateEnvelopeIdSearch = (e)=>{
            // Record user activity for adaptive polling
            this.recordUserActivity();
            const envelopeId = e.target.value;
            this.envelopeIdSearch = envelopeId.trim();
            console.log(`Envelope ID search updated: "${this.envelopeIdSearch}"`);
        }, this.clearEnvelopeIdSearch = ()=>{
            // Record user activity for adaptive polling
            this.recordUserActivity();
            this.envelopeIdSearch = "";
            console.log("Envelope ID search cleared");
            this.requestUpdate();
        }, // Cache access token to avoid repeated refreshes
        this.cachedAccessToken = null, this.tokenCacheExpiry = 0;
        // Initialize Web Worker for message processing (optional optimization)
        if (typeof Worker !== "undefined") try {
            this.messageWorker = new Worker($69926ef61c0bbaa0$exports);
        } catch (error) {
            console.warn("Failed to initialize Web Worker, falling back to main thread processing:", error);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        // Initialize environment detection after properties are set
        if (this.queueType === (0, $71b210c792da224a$export$f49165103acf0cf8).Firestore) {
            if (!this.projectId) throw "Project ID not provided";
            // console.log(`CLIENT_PREFIX: '${process.env.CLIENT_PREFIX}'`);
            // console.log(`ENVIRONMENT: '${process.env.ENVIRONMENT}'`);
            this.environment = "DEFAULT_CLIENT_PREFIX-DEFAULT_ENVIRONMENT";
            // console.log(`Environment set to: '${this.environment}'`);
            // console.log(`Expected topic name would be: '${this.environment}-hitl-logger'`);
            // Initialize Firestore connection
            this.initializeFirestore();
            // Emit environment information for logger configuration
            if (this.environment) {
                const environmentEvent = new CustomEvent("environment-detected", {
                    bubbles: true,
                    detail: {
                        environment: this.environment
                    }
                });
                this.dispatchEvent(environmentEvent);
            }
        }
    }
    async initializeFirestore() {
        // Using REST API instead of Firebase SDK for named database access
        console.log(`Firestore REST API configured for database: ${this.environment}-hitl-tasks`);
    }
    async subscribeToFirestoreQueues() {
        const queueNames = this.queues.map((q)=>q.name);
        console.log("Setting up polling for Firestore queues:", queueNames);
        // Skip subscription if no queues are available
        if (queueNames.length === 0) {
            console.log("No queues available for subscription");
            return;
        }
        // Use polling with activity monitoring for cross-user coordination
        const pollQueues = async ()=>{
            try {
                const [accessToken, idToken] = await this.getAccessToken(false);
                const databaseId = `${this.environment}-hitl-tasks`;
                // Update counts for all queues by counting actual documents in task collections
                await this.updateQueueCountsWithAPI(this.queues, accessToken, idToken, databaseId);
                // Request UI update after counts are updated (optimized)
                this.requestUpdateIfChanged();
            } catch (error) {
                console.error("Queue polling error:", error);
            }
        };
        // Initial poll
        await pollQueues();
        // Set up simplified polling optimized for multi-user scenarios
        this.startSimpleRealtimePolling(pollQueues);
    }
    /**
   * Handle task release by clearing local adjustments and refreshing counts
   * Called when documents are removed from work stack
   */ handleTaskRelease(queueName, taskCount = 1) {
        console.log(`\u{1F504} Handling task release for queue ${queueName}: ${taskCount} tasks`);
        // Apply positive adjustment to show documents are available again
        this.applyLocalQueueAdjustment(queueName, taskCount, 0);
        // Force immediate queue refresh to get updated server counts
        this.refreshQueueCountsImmediate().catch((error)=>console.warn("Failed to refresh after task release:", error));
    }
    /**
   * Immediately refresh queue counts for real-time UI updates
   * Called after document assignment, release, or completion
   */ async refreshQueueCountsImmediate() {
        try {
            console.log("\uD83D\uDD04 Performing immediate queue count refresh...");
            const [accessToken, idToken] = await this.getAccessToken(false);
            const databaseId = `${this.environment}-hitl-tasks`;
            // Store current local adjustments before refresh
            const currentAdjustments = new Map(this.localQueueAdjustments);
            // Update counts for all queues immediately using the existing counting logic
            await this.updateQueueCountsWithAPI(this.queues, accessToken, idToken, databaseId);
            // For pre-assigned documents, server counts won't change immediately
            // Keep local adjustments to show correct UI state to users
            // Only refresh adjustments when tasks are actually released/completed
            console.log("\u23F3 Preserving local adjustments - server counts may not reflect document loading for pre-assigned tasks");
            this.localQueueAdjustments = currentAdjustments;
            // Force UI update (optimized)
            this.requestUpdateIfChanged();
            console.log("\u2705 Immediate queue count refresh completed");
        } catch (error) {
            console.error("\u274C Failed to refresh queue counts immediately:", error);
        }
    }
    /**
   * Apply local adjustment to queue counts for instant UI feedback
   */ applyLocalQueueAdjustment(queueName, availableChange, assignedChange) {
        const current = this.localQueueAdjustments.get(queueName) || {
            availableAdjustment: 0,
            assignedAdjustment: 0
        };
        this.localQueueAdjustments.set(queueName, {
            availableAdjustment: current.availableAdjustment + availableChange,
            assignedAdjustment: current.assignedAdjustment + assignedChange
        });
        console.log(`\u{1F4CA} Local adjustment for ${queueName}: available ${availableChange > 0 ? "+" : ""}${availableChange}, assigned ${assignedChange > 0 ? "+" : ""}${assignedChange}`);
        // Clear any existing timeout for this queue
        const existingTimeout = this.adjustmentTimeouts.get(queueName);
        if (existingTimeout) clearTimeout(existingTimeout);
        // Set timeout to clear adjustment after 2 minutes for very stale adjustments
        // This is a safety net - normal clearing should happen on task release/completion
        const timeoutId = window.setTimeout(()=>{
            console.log(`\u{23F0} Safety timeout: clearing very stale local adjustment for ${queueName}`);
            this.localQueueAdjustments.delete(queueName);
            this.adjustmentTimeouts.delete(queueName);
            this.requestUpdate();
        }, 120000); // 2 minutes instead of 30 seconds
        this.adjustmentTimeouts.set(queueName, timeoutId);
        // Force UI update to show local changes immediately
        this.requestUpdate();
    }
    /**
   * Get effective queue count including local adjustments
   */ getEffectiveQueueCount(queue, countType) {
        const adjustment = this.localQueueAdjustments.get(queue.name);
        const baseCount = countType === "available" ? queue.reviewRequestCount || 0 : queue.assignedCount || 0;
        if (!adjustment) return baseCount;
        const adjustmentValue = countType === "available" ? adjustment.availableAdjustment : adjustment.assignedAdjustment;
        const effectiveCount = Math.max(0, baseCount + adjustmentValue);
        // Only log when there's an actual adjustment being applied
        if (adjustmentValue !== 0) console.log(`\u{1F4CA} Queue ${queue.name} ${countType}: base=${baseCount}, adjustment=${adjustmentValue}, effective=${effectiveCount}`);
        // Ensure we don't show negative counts
        return effectiveCount;
    }
    /**
   * Record user activity to optimize polling frequency
   */ recordUserActivity() {
        this.lastUserActivity = Date.now();
    }
    /**
   * Simple real-time polling optimized for multi-user coordination
   * Polls every 10 seconds when users are active, 30 seconds when idle
   */ startSimpleRealtimePolling(pollFunction) {
        let pollCount = 0;
        const performPoll = async ()=>{
            try {
                await pollFunction();
                pollCount++;
                // Determine next interval based on activity
                const timeSinceActivity = Date.now() - this.lastUserActivity;
                let nextInterval;
                if (timeSinceActivity < 120000) // Active user: poll every 10 seconds for quick updates
                nextInterval = 10000;
                else if (timeSinceActivity < 600000) // Moderately idle: poll every 20 seconds
                nextInterval = 20000;
                else // Idle: poll every 30 seconds
                nextInterval = 30000;
                // Only log polling progress every 10 polls to reduce console noise
                if (pollCount % 10 === 0) console.log(`\u{1F4CA} Queue poll #${pollCount} completed, next poll in ${nextInterval / 1000}s`);
                // Schedule next poll
                const timeoutId = setTimeout(performPoll, nextInterval);
                // Store cleanup function
                this.firestoreUnsubscribers.set("queue-polling", ()=>clearTimeout(timeoutId));
            } catch (error) {
                console.error("Polling error:", error);
                // Retry in 30 seconds on error
                const retryTimeoutId = setTimeout(performPoll, 30000);
                this.firestoreUnsubscribers.set("queue-polling", ()=>clearTimeout(retryTimeoutId));
            }
        };
        // Start the polling cycle
        console.log("\uD83D\uDD04 Starting simplified real-time polling (10-30 second intervals)");
        performPoll();
    }
    // Legacy Firebase SDK method - replaced with REST API version
    // private async fetchFirestoreTaskBatch(queueName: string, batchSize: number = 10): Promise<HitlTask[]> {
    //   if (!this.firestoreDb) {
    //     console.error('Firestore not initialized');
    //     return [];
    //   }
    //   console.log('Fetching task batch from Firestore:', { queueName, batchSize });
    //   const q = query(
    //     collection(this.firestoreDb, 'hitl_tasks'),
    //     where('queueName', '==', queueName),
    //     where('status', '==', 'available'),
    //     orderBy('priority', 'desc'),
    //     orderBy('createdAt', 'asc'),
    //     limit(batchSize)
    //   );
    //   const snapshot = await getDocs(q);
    //   return snapshot.docs.map(doc => ({
    //     taskId: doc.id,
    //     ...doc.data()
    //   } as HitlTask));
    // }
    async assignFirestoreTask(taskId, userId) {
        if (!this.firestoreDb) {
            console.error("Firestore not initialized");
            return false;
        }
        console.log("Assigning Firestore task:", taskId);
        const taskRef = doc(this.firestoreDb, "hitl_tasks", taskId);
        const sessionRef = doc(this.firestoreDb, "hitl_user_sessions", userId);
        try {
            const result = await runTransaction(this.firestoreDb, async (transaction)=>{
                const taskDoc = await transaction.get(taskRef);
                if (!taskDoc.exists() || taskDoc.data()?.status !== "available") throw new Error("Task no longer available");
                const taskData = taskDoc.data();
                const expiresAt = (0, $780b92061aa4a3e6$export$d9bcbd5e1ff81430).fromDate(new Date(Date.now() + 3600000));
                // Update task
                transaction.update(taskRef, {
                    status: "assigned",
                    assignedTo: userId,
                    assignedAt: serverTimestamp(),
                    expiresAt: expiresAt,
                    viewCount: increment(1)
                });
                // Update user session
                transaction.set(sessionRef, {
                    userId: userId,
                    activeTaskIds: arrayUnion(taskId),
                    lastActivity: serverTimestamp()
                }, {
                    merge: true
                });
                // Update queue stats
                const queueRef = doc(this.firestoreDb, "hitl_queues", taskData.queueName);
                transaction.update(queueRef, {
                    activeTaskCount: increment(-1),
                    assignedTaskCount: increment(1)
                });
                return true;
            });
            console.log("Successfully assigned Firestore task:", taskId);
            return result;
        } catch (error) {
            console.error("Failed to assign Firestore task:", error);
            return false;
        }
    }
    async getFirestoreQueues() {
        try {
            // Query Firestore to discover available queues using REST API with access token
            console.log("Discovering available queues from Firestore using REST API...");
            // Get access token for authentication
            const [accessToken, idToken] = await this.getAccessToken(false);
            const databaseId = `${this.environment}-hitl-tasks`;
            const url = `${"DEFAULT_INTERNAL_API_URL"}/documents/hitl_queues`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${idToken}`
                },
                credentials: "include"
            });
            if (!response.ok) throw new Error(`Failed to fetch queues: ${response.status} ${response.statusText}`);
            const data = await response.json();
            const discoveredQueues = [];
            if (data.documents) data.documents.forEach((doc1)=>{
                // Extract queue name from document path
                const queueName = doc1.document_id;
                // Extract displayName from document fields, then apply mapping
                const firestoreDisplayName = doc1.displayName || queueName;
                const displayName = (0, $eUQW6.getQueueDisplayName)(queueName);
                console.log(`Found queue: ${queueName} (display: ${displayName})`);
                discoveredQueues.push({
                    name: queueName,
                    displayName: displayName,
                    reviewRequestCount: 0,
                    activeCount: 0,
                    assignedCount: 0,
                    completedToday: 0,
                    hasMoreDocuments: false,
                    getReviewRequests: async (count)=>{
                        try {
                            return await this.getFirestoreReviewRequests(queueName, count);
                        } catch (error) {
                            console.error(`Failed to get review requests for queue ${queueName}:`, error);
                            return [];
                        }
                    }
                });
            });
            // Sort queues by display name for consistent ordering
            discoveredQueues.sort((a, b)=>a.displayName.localeCompare(b.displayName));
            // Update queue counts dynamically by counting actual tasks
            await this.updateQueueCountsWithAPI(discoveredQueues, accessToken, idToken, databaseId);
            console.log(`Discovered ${discoveredQueues.length} queues from Firestore`);
            return discoveredQueues;
        } catch (error) {
            console.error("Failed to discover queues from Firestore:", error);
            // Fallback to empty array if discovery fails
            return [];
        }
    }
    async updateQueueCountsWithAPI(queues, accessToken, idToken, databaseId) {
        try {
            // Track previous counts for change detection
            const previousCounts = new Map();
            queues.forEach((q)=>previousCounts.set(q.name, q.reviewRequestCount || 0));
            // Count tasks for each queue using BULK REST API optimization
            const bulkCounts = await this.bulkCountFirestoreTasks(queues.map((q)=>q.name), accessToken, idToken, databaseId);
            await Promise.all(queues.map(async (queue)=>{
                try {
                    // Get counts from bulk response instead of individual API calls
                    const availableCount = bulkCounts[queue.name]?.available || 0;
                    const assignedCount = bulkCounts[queue.name]?.assigned || 0;
                    const hasMore = bulkCounts[queue.name]?.hasMore || false;
                    // The "available" count should represent documents available for assignment
                    // This means documents that are not assigned to anyone
                    const oldCount = queue.reviewRequestCount || 0;
                    queue.reviewRequestCount = availableCount;
                    queue.activeCount = availableCount;
                    queue.assignedCount = assignedCount;
                    queue.hasMoreDocuments = hasMore;
                    // Log changes
                    if (oldCount !== availableCount) console.log(`\u{1F4EC} Queue ${queue.name}: available ${oldCount} \u{2192} ${availableCount}${hasMore ? "+" : ""} (${availableCount > oldCount ? "\uD83C\uDD95 NEW DOCUMENTS" : "documents removed"})`);
                // console.log(`Queue ${queue.name}: ${availableCount} available, ${assignedCount} assigned (total unprocessed: ${availableCount + assignedCount})`);
                } catch (error) {
                    console.warn(`Failed to count tasks for queue ${queue.name}:`, error);
                }
            }));
        } catch (error) {
            console.error("Failed to update queue counts:", error);
        }
    }
    async countFirestoreTasks(queueName, status, accessToken, idToken, databaseId) {
        try {
            // Use queue-specific collection
            const collectionName = `hitl_tasks_${queueName}`;
            console.log(`\u{1F50D} Querying Firestore for ${queueName} tasks with status="${status}"`);
            // Use fast count endpoint instead of fetching documents
            const url = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/count?status=${status}`;
            console.log(`\u{1F4C4} Fetching count with URL: ${url}`);
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                const errorText = await response.text();
                console.error(`Firestore API error for ${queueName}:`, {
                    status: response.status,
                    statusText: response.statusText,
                    errorText: errorText,
                    url: url
                });
                throw new Error(`Failed to count tasks: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            const count = data.count || 0;
            const hasMore = data.has_more || false;
            console.log(`\u{1F4CA} Firestore count response for ${queueName}:`, {
                count: count,
                hasMore: hasMore,
                limit: data.limit || 1000
            });
            if (hasMore) console.log(`\u{2705} Final count for ${queueName} with status="${status}": ${count}+ documents (limit reached)`);
            else console.log(`\u{2705} Final count for ${queueName} with status="${status}": ${count} documents`);
            return count;
        } catch (error) {
            console.error(`Failed to count tasks for queue ${queueName} with status ${status}:`, error);
            return 0;
        }
    }
    async bulkCountFirestoreTasks(queueNames, accessToken, idToken, databaseId) {
        console.log(`BULK OPTIMIZATION: Counting ${queueNames.length} queues in parallel`);
        const startTime = performance.now();
        try {
            // Create parallel requests for all queue collections
            const bulkPromises = queueNames.flatMap((queueName)=>[
                    // Available count request
                    {
                        queueName: queueName,
                        status: "available",
                        promise: this.countSingleQueueBulk(queueName, "available", accessToken, idToken, databaseId)
                    },
                    // Assigned count request
                    {
                        queueName: queueName,
                        status: "assigned",
                        promise: this.countSingleQueueBulk(queueName, "assigned", accessToken, idToken, databaseId)
                    }
                ]);
            // Execute all requests in parallel
            const results = await Promise.allSettled(bulkPromises.map((req)=>req.promise));
            // Process results into structured format
            const bulkCounts = {};
            // Initialize all queues - optimized for loop
            for(let i = 0; i < queueNames.length; i++)bulkCounts[queueNames[i]] = {
                available: 0,
                assigned: 0,
                hasMore: false
            };
            // Populate results - optimized for loop
            for(let index = 0; index < bulkPromises.length; index++){
                const req = bulkPromises[index];
                const result = results[index];
                if (result.status === "fulfilled") {
                    bulkCounts[req.queueName][req.status] = result.value.count;
                    // Track hasMore if either available or assigned has more documents
                    if (result.value.hasMore) bulkCounts[req.queueName].hasMore = true;
                } else console.warn(`Failed to count ${req.status} tasks for queue ${req.queueName}:`, result.reason);
            }
            const totalTime = performance.now() - startTime;
            const totalRequests = queueNames.length * 2;
            console.log(`\u{26A1} BULK OPTIMIZATION COMPLETE: ${totalRequests} requests in ${Math.round(totalTime)}ms (${Math.round(totalTime / totalRequests)}ms avg per request)`);
            return bulkCounts;
        } catch (error) {
            console.error("Bulk count operation failed, falling back to individual requests:", error);
            // Fallback to individual requests if bulk fails
            const fallbackCounts = {};
            await Promise.all(queueNames.map(async (queueName)=>{
                try {
                    const available = await this.countFirestoreTasks(queueName, "available", accessToken, idToken, databaseId);
                    const assigned = await this.countFirestoreTasks(queueName, "assigned", accessToken, idToken, databaseId);
                    fallbackCounts[queueName] = {
                        available: available,
                        assigned: assigned,
                        hasMore: false
                    };
                } catch (err) {
                    console.error(`Fallback count failed for queue ${queueName}:`, err);
                    fallbackCounts[queueName] = {
                        available: 0,
                        assigned: 0,
                        hasMore: false
                    };
                }
            }));
            return fallbackCounts;
        }
    }
    async countSingleQueueBulk(queueName, status, accessToken, idToken, databaseId) {
        // Fast count using dedicated count endpoint (no document transfer)
        const collectionName = `hitl_tasks_${queueName}`;
        const url = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/count?status=${status}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${idToken}`,
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) throw new Error(`Failed to count tasks for ${queueName}: ${response.status} ${response.statusText}`);
        const data = await response.json();
        const count = data.count || 0;
        const hasMore = data.has_more || false;
        // Log the count
        if (hasMore) (0, $a30lF.log).debug(`\u{1F4CA} BULK: ${count}+ documents with status="${status}" for ${queueName} (limit reached)`);
        else (0, $a30lF.log).debug(`\u{1F4CA} BULK: ${count} documents with status="${status}" for ${queueName}`);
        return {
            count: count,
            hasMore: hasMore
        };
    }
    async getFirestoreReviewRequests(queueName, count) {
        const userId = this.getCurrentUserId();
        const result = await this.fetchAndAssignFirestoreTasksREST(queueName, count, userId);
        // Handle both old array format (fallback) and new object format
        if (Array.isArray(result)) return result.map((task)=>new (0, $20e0088800729d63$export$9ddd7e36c6c46838)(task, null, userId));
        const { tasks: tasks, newAssignmentCount: newAssignmentCount, totalCount: totalCount } = result;
        // Apply immediate local adjustment for user feedback, only for newly assigned tasks
        if (newAssignmentCount > 0) {
            console.log(`\u{1F4CA} Applying local adjustment for ${queueName}: -${newAssignmentCount} available (newly assigned documents)`);
            this.applyLocalQueueAdjustment(queueName, -newAssignmentCount, 0);
        }
        return tasks.map((task)=>new (0, $20e0088800729d63$export$9ddd7e36c6c46838)(task, null, userId)); // Pass null for firestoreDb since we're using REST API
    }
    getCurrentUserId() {
        // Get user ID from the parent component or system
        // This should be set when the user logs in
        const hitlApp = document.querySelector("hitl-app");
        if (hitlApp && hitlApp.userId) return hitlApp.userId;
        // Fallback to generating a session-based ID if no user ID is available
        if (!this.sessionUserId) {
            this.sessionUserId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            console.warn(`No userId found, using session ID: ${this.sessionUserId}`);
        }
        return this.sessionUserId;
    }
    async fetchAndAssignFirestoreTasksREST(queueName, batchSize = 10, userId) {
        try {
            console.log("Fetching task batch from Firestore using REST API:", {
                queueName: queueName,
                batchSize: batchSize,
                userId: userId
            });
            // Get access token for authentication
            const [accessToken, idToken] = await this.getAccessToken(false);
            const databaseId = `${this.environment}-hitl-tasks`;
            // Use queue-specific collection
            const collectionName = `hitl_tasks_${queueName}`;
            // Build URL - use search endpoint if envelope_id filter is provided
            let url;
            if (this.envelopeIdSearch) {
                // Apply FIFO ordering: oldest documents first
                url = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/search?envelope_id=${encodeURIComponent(this.envelopeIdSearch)}&limit=1000&orderBy=createdAt:asc`;
                console.log(`Searching tasks by envelope_id: ${this.envelopeIdSearch}`);
            } else // Apply FIFO ordering: oldest documents first
            url = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}?limit=1000&orderBy=createdAt:asc`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                const errorText = await response.text();
                console.error(`API Error Response:`, {
                    status: response.status,
                    statusText: response.statusText,
                    url: url,
                    errorText: errorText
                });
                throw new Error(`Failed to fetch tasks: ${response.status} ${response.statusText}`);
            }
            const responseText = await response.text();
            console.log(`Raw API Response (first 500 chars):`, responseText.substring(0, 500));
            let data;
            try {
                data = JSON.parse(responseText);
            } catch (e) {
                console.error(`Failed to parse JSON response:`, e, responseText.substring(0, 500));
                throw new Error(`Invalid JSON response from API`);
            }
            if (!data || !data.documents) {
                console.log(`No documents found in collection for queue ${queueName}`, data);
                return [];
            }
            console.log(`Total documents found in queue ${queueName}: ${data.documents.length}${data.has_more ? "+" : ""} (limit: ${data.limit || 1000})`);
            // Filter documents for: 1) available tasks, 2) tasks already assigned to current user, 3) not older than 30 days
            const thirtyDaysAgo = new Date(Date.now() - 2592000000).toISOString();
            const availableDocs = data.documents.filter((doc1)=>{
                const taskStatus = doc1.status;
                const assignedTo = doc1.assignedTo;
                const createdAt = doc1.createdAt;
                // Skip tasks older than 30 days
                if (createdAt && createdAt < thirtyDaysAgo) return false;
                return taskStatus === "available" || taskStatus === "assigned" && assignedTo === userId;
            });
            // Separate already assigned tasks from available tasks
            const alreadyAssignedDocs = availableDocs.filter((doc1)=>{
                const taskStatus = doc1.status;
                const assignedTo = doc1.assignedTo;
                return taskStatus === "assigned" && assignedTo === userId;
            });
            const availableForAssignment = availableDocs.filter((doc1)=>{
                const taskStatus = doc1.status;
                return taskStatus === "available";
            }).slice(0, Math.max(0, batchSize - alreadyAssignedDocs.length)); // Reserve space for already assigned
            // Limit already assigned tasks to fit within batch size
            const limitedAlreadyAssigned = alreadyAssignedDocs.slice(0, batchSize);
            console.log(`Found ${availableForAssignment.length} available tasks and ${limitedAlreadyAssigned.length} already assigned tasks (limited from ${alreadyAssignedDocs.length}) for queue ${queueName}`);
            // Atomically assign tasks to this user
            const assignedTasks = [];
            const assignmentTime = new Date().toISOString();
            const expirationTime = new Date(Date.now() + 1800000).toISOString(); // 30 minutes from now
            // Track how many new assignments we actually make
            let newAssignmentCount = 0;
            // First, process already assigned tasks (update expiration time to prevent indefinite assignment)
            for (const doc1 of limitedAlreadyAssigned)try {
                const taskId = doc1.taskId;
                console.log(`Using already assigned task: ${taskId}`);
                // Check if task has expiresAt field
                const currentExpiresAt = doc1.expiresAt;
                // If no expiration or expired, update it
                if (!currentExpiresAt || new Date(currentExpiresAt) < new Date()) {
                    console.log(`Updating expiration for already assigned task ${taskId}`);
                    const taskDocUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/${taskId}`;
                    const updatePayload = {
                        expiresAt: expirationTime
                    };
                    try {
                        const updateResponse = await fetch(taskDocUrl, {
                            method: "PATCH",
                            headers: {
                                Authorization: `Bearer ${idToken}`,
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(updatePayload)
                        });
                        if (updateResponse.ok) console.log(`Updated expiration for task ${taskId}`);
                        else console.warn(`Failed to update expiration for task ${taskId}: ${updateResponse.status}`);
                    } catch (updateError) {
                        console.warn(`Error updating expiration for task ${taskId}:`, updateError);
                    }
                }
                const task = {
                    taskId: taskId,
                    documentId: doc1.documentId || "",
                    envelopeId: doc1.envelopeId || "",
                    queueName: doc1.queueName || queueName,
                    processorType: doc1.processorType || "",
                    priority: parseInt(doc1.priority || "0"),
                    createdAt: doc1.createdAt ? {
                        toDate: ()=>new Date(doc1.createdAt)
                    } : {
                        toDate: ()=>new Date()
                    },
                    documentData: this.parseDocumentData(doc1.documentData),
                    revisions: doc1.revisions?.values || [],
                    source: doc1.source || undefined,
                    callbackUrl: doc1.callbackUrl || undefined
                };
                assignedTasks.push(task);
                console.log(`Using already assigned task: ${taskId}`);
            } catch (error) {
                console.warn(`Failed to process already assigned task:`, error);
            }
            // Then, process available tasks for assignment
            for (const doc1 of availableForAssignment){
                try {
                    const taskId = doc1.taskId;
                    const taskDocUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/${taskId}`;
                    // Prepare assignment update
                    const updatePayload = {
                        status: "assigned",
                        assignedTo: userId,
                        assignedAt: assignmentTime,
                        expiresAt: expirationTime
                    };
                    // Attempt to assign the task using conditional update
                    const updateResponse = await fetch(taskDocUrl, {
                        method: "PATCH",
                        headers: {
                            Authorization: `Bearer ${idToken}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(updatePayload)
                    });
                    if (updateResponse.ok) {
                        // Successfully assigned, parse and add to result
                        const task = {
                            taskId: taskId,
                            documentId: doc1.documentId || "",
                            envelopeId: doc1.envelopeId || "",
                            queueName: doc1.queueName || queueName,
                            processorType: doc1.processorType || "",
                            priority: parseInt(doc1.priority || "0"),
                            createdAt: doc1.createdAt ? {
                                toDate: ()=>new Date(doc1.createdAt)
                            } : {
                                toDate: ()=>new Date()
                            },
                            status: "assigned",
                            assignedTo: userId,
                            assignedAt: {
                                toDate: ()=>new Date(assignmentTime)
                            },
                            expiresAt: {
                                toDate: ()=>new Date(expirationTime)
                            },
                            documentData: this.parseDocumentData(doc1.documentData),
                            source: doc1.source || undefined,
                            callbackUrl: doc1.callbackUrl || undefined
                        };
                        assignedTasks.push(task);
                        newAssignmentCount++; // Track new assignments
                        console.log(`Successfully assigned NEW task ${taskId} to user ${userId}`);
                    } else // Assignment failed (likely race condition), skip this task
                    console.log(`Failed to assign task ${taskId}: ${updateResponse.status} ${updateResponse.statusText}`);
                } catch (error) {
                    console.error(`Error assigning task:`, error);
                // Continue with next task
                }
                // Stop if we've successfully assigned enough tasks
                if (assignedTasks.length >= batchSize) break;
            }
            console.log(`Successfully assigned ${assignedTasks.length} tasks for queue ${queueName} to user ${userId} (${newAssignmentCount} new, ${assignedTasks.length - newAssignmentCount} already assigned)`);
            // Return info about both total tasks and new assignments for UI adjustment logic
            return {
                tasks: assignedTasks,
                newAssignmentCount: newAssignmentCount,
                totalCount: assignedTasks.length
            };
        } catch (error) {
            console.error("Failed to fetch Firestore task batch using REST API:", error);
            return {
                tasks: [],
                newAssignmentCount: 0,
                totalCount: 0
            };
        }
    }
    /**
   * Release tasks assigned to a specific user (e.g., when user abandons work)
   */ async releaseUserTasks(userId, queueName) {
        try {
            console.log(`Releasing tasks for user ${userId}${queueName ? ` in queue ${queueName}` : ""}`);
            const [accessToken, idToken] = await this.getAccessToken(false);
            const databaseId = `${this.environment}-hitl-tasks`;
            let releasedCount = 0;
            // If specific queue, release only that queue's tasks
            const queuesToCheck = queueName ? [
                queueName
            ] : this.queues.map((q)=>q.name);
            for (const queue of queuesToCheck){
                const collectionName = `hitl_tasks_${queue}`;
                const baseUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}`;
                const queryUrl = `${baseUrl}?status=assigned`;
                // Find assigned tasks for this user
                const response = await fetch(queryUrl, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        "Content-Type": "application/json"
                    }
                });
                if (!response.ok) continue;
                const data = await response.json();
                if (!data.documents) continue;
                // Filter tasks assigned to this user
                const userTasks = data.documents.filter((doc1)=>{
                    const status = doc1.status;
                    const assignedTo = doc1.assignedTo;
                    return status === "assigned" && assignedTo === userId;
                });
                // Release each task
                for (const doc1 of userTasks){
                    const taskId = doc1.document_id;
                    if (!taskId) continue;
                    const taskDocUrl = `${baseUrl}/${taskId}`;
                    const updatePayload = {
                        status: "available",
                        assignedTo: null,
                        assignedAt: null,
                        expiresAt: null
                    };
                    const updateResponse = await fetch(taskDocUrl, {
                        method: "PATCH",
                        headers: {
                            Authorization: `Bearer ${idToken}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(updatePayload)
                    });
                    if (updateResponse.ok) {
                        releasedCount++;
                        console.log(`Released task ${taskId} from user ${userId}`);
                    }
                }
            }
            console.log(`Released ${releasedCount} tasks for user ${userId}`);
            return releasedCount;
        } catch (error) {
            console.error("Failed to release user tasks:", error);
            return 0;
        }
    }
    /**
   * Auto-release expired tasks across all queues
   */ async releaseExpiredTasks() {
        try {
            console.log("Checking for expired task assignments...");
            const [accessToken, idToken] = await this.getAccessToken(false);
            const databaseId = `${this.environment}-hitl-tasks`;
            const currentTime = new Date().toISOString();
            let releasedCount = 0;
            for (const queue of this.queues){
                const collectionName = `hitl_tasks_${queue.name}`;
                const baseUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}`;
                const queryUrl = `${baseUrl}?status=assigned`;
                try {
                    // Find assigned tasks
                    const response = await fetch(queryUrl, {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${idToken}`,
                            "Content-Type": "application/json"
                        }
                    });
                    if (!response.ok) continue;
                    const data = await response.json();
                    if (!data.documents) continue;
                    // Filter expired assigned tasks OR tasks with null expiration
                    const expiredTasks = data.documents.filter((doc1)=>{
                        const status = doc1.status;
                        const expiresAt = doc1.expiresAt;
                        // Release tasks that are:
                        // 1. Assigned AND have no expiration time (null/undefined)
                        // 2. Assigned AND have expired
                        if (status === "assigned") {
                            if (!expiresAt) {
                                console.log(`Found task with null expiration: ${doc1.document_id}`);
                                return true;
                            }
                            if (expiresAt < currentTime) {
                                console.log(`Found expired task: ${doc1.document_id}`);
                                return true;
                            }
                        }
                        return false;
                    });
                    // Release expired tasks
                    for (const doc1 of expiredTasks){
                        const taskId = doc1.taskId;
                        if (!taskId) continue;
                        const taskDocUrl = `${baseUrl}/${taskId}`;
                        const updatePayload = {
                            status: "available",
                            assignedTo: null,
                            assignedAt: null,
                            expiresAt: null
                        };
                        const updateResponse = await fetch(taskDocUrl, {
                            method: "PATCH",
                            headers: {
                                Authorization: `Bearer ${idToken}`,
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(updatePayload)
                        });
                        if (updateResponse.ok) {
                            releasedCount++;
                            const assignedTo = doc1.assignedTo || "unknown";
                            console.log(`Released expired task ${taskId} from user ${assignedTo}`);
                        }
                    }
                } catch (error) {
                    console.error(`Failed to check expired tasks for queue ${queue.name}:`, error);
                }
            }
            if (releasedCount > 0) {
                console.log(`Released ${releasedCount} expired task assignments`);
                // Refresh queue counts after releasing expired tasks
                await this.updateQueueCountsWithAPI(this.queues, accessToken, idToken, databaseId);
            }
            return releasedCount;
        } catch (error) {
            console.error("Failed to release expired tasks:", error);
            return 0;
        }
    }
    parseDocumentData(documentDataField) {
        if (!documentDataField) {
            console.log("parseDocumentData: No document data field provided, returning default structure");
            return {
                pageCount: 0,
                pages: [],
                loadingMetrics: {
                    totalPreviewSize: 0,
                    estimatedLoadTime: 0,
                    recommendedPreload: 0
                },
                resultBucket: "",
                resultPrefix: "",
                resultObject: "",
                labels: [],
                metadata: {}
            };
        }
        // console.log('parseDocumentData input type:', typeof documentDataField);
        // console.log('parseDocumentData input keys:', Object.keys(documentDataField || {}));
        // console.log('parseDocumentData input value:', documentDataField);
        // Check if it's stored as a stringValue (JSON string)
        if (documentDataField.stringValue) try {
            const parsed = JSON.parse(documentDataField.stringValue);
            console.log("parseDocumentData stringValue result:", parsed);
            return parsed;
        } catch (error) {
            console.error("Failed to parse documentData stringValue:", error, documentDataField.stringValue);
            return {};
        }
        // Check if it's stored as mapValue (nested fields)
        if (documentDataField.mapValue) try {
            const fields = documentDataField.mapValue.fields || documentDataField.mapValue;
            const parsed = this.convertFirestoreMapToObject(fields);
            console.log("parseDocumentData mapValue result:", parsed);
            return parsed;
        } catch (error) {
            console.error("Failed to parse documentData mapValue:", error, documentDataField.mapValue);
            return {};
        }
        // Check if it has fields directly (REST API response format)
        if (documentDataField.fields) try {
            const parsed = this.convertFirestoreMapToObject(documentDataField.fields);
            console.log("parseDocumentData fields result:", parsed);
            return parsed;
        } catch (error) {
            console.error("Failed to parse documentData fields:", error, documentDataField);
            return {};
        }
        // Fallback: treat it as a direct object (this might be the case)
        if (typeof documentDataField === "object" && documentDataField !== null) {
            console.log("parseDocumentData direct object result:", documentDataField);
            return documentDataField;
        }
        console.warn("parseDocumentData: Unknown field format:", typeof documentDataField, documentDataField);
        return {};
    }
    convertFirestoreMapToObject(fields) {
        const result = {};
        // Safety check for undefined/null fields
        if (!fields || typeof fields !== "object") {
            console.warn("convertFirestoreMapToObject received invalid fields:", fields);
            return result;
        }
        for (const [key, value] of Object.entries(fields)){
            // Skip null/undefined values, but allow objects with null values
            if (value === null || value === undefined) {
                result[key] = null;
                continue;
            }
            if (typeof value !== "object") {
                console.warn(`Skipping non-object field ${key}:`, value);
                result[key] = value; // Preserve primitive values as-is
                continue;
            }
            if (value.hasOwnProperty("stringValue")) result[key] = value.stringValue;
            else if (value.hasOwnProperty("integerValue")) result[key] = parseInt(value.integerValue);
            else if (value.hasOwnProperty("doubleValue")) result[key] = parseFloat(value.doubleValue);
            else if (value.hasOwnProperty("booleanValue")) result[key] = value.booleanValue;
            else if (value.hasOwnProperty("timestampValue")) result[key] = new Date(value.timestampValue);
            else if (value.hasOwnProperty("arrayValue")) result[key] = value.arrayValue?.values?.map((v)=>this.convertFirestoreValueToJS(v)) || [];
            else if (value.hasOwnProperty("mapValue")) result[key] = this.convertFirestoreMapToObject(value.mapValue?.fields || {});
            else if (value.hasOwnProperty("nullValue")) result[key] = null;
            else if (value.hasOwnProperty("geoPointValue")) result[key] = {
                latitude: value.geoPointValue.latitude,
                longitude: value.geoPointValue.longitude
            };
            else if (value.hasOwnProperty("referenceValue")) result[key] = value.referenceValue;
            else if (value.hasOwnProperty("bytesValue")) result[key] = value.bytesValue;
            else {
                console.warn(`Unknown field type for ${key}:`, Object.keys(value), value);
                // Instead of skipping unknown fields, try to preserve them as-is
                result[key] = value;
            }
        }
        return result;
    }
    convertFirestoreValueToJS(value) {
        // Handle null/undefined values
        if (value === null || value === undefined) return null;
        // Handle primitive values that aren't wrapped in Firestore format
        if (typeof value !== "object") return value;
        if (value.hasOwnProperty("stringValue")) return value.stringValue;
        if (value.hasOwnProperty("integerValue")) return parseInt(value.integerValue);
        if (value.hasOwnProperty("doubleValue")) return parseFloat(value.doubleValue);
        if (value.hasOwnProperty("booleanValue")) return value.booleanValue;
        if (value.hasOwnProperty("timestampValue")) return new Date(value.timestampValue);
        if (value.hasOwnProperty("arrayValue")) return value.arrayValue?.values?.map((v)=>this.convertFirestoreValueToJS(v)) || [];
        if (value.hasOwnProperty("mapValue")) return this.convertFirestoreMapToObject(value.mapValue?.fields || {});
        if (value.hasOwnProperty("nullValue")) return null;
        if (value.hasOwnProperty("geoPointValue")) return {
            latitude: value.geoPointValue.latitude,
            longitude: value.geoPointValue.longitude
        };
        if (value.hasOwnProperty("referenceValue")) return value.referenceValue;
        if (value.hasOwnProperty("bytesValue")) return value.bytesValue;
        // If none of the known types match, return the value as-is
        console.warn("Unknown Firestore value type:", Object.keys(value), value);
        return value;
    }
    getCurrentUserId() {
        // Get the current user ID from the app component
        const hitlApp = document.querySelector("hitl-app");
        if (hitlApp && hitlApp.userId) return hitlApp.userId;
        // Fallback to session-based ID if no user ID is available
        if (!this.sessionUserId) {
            this.sessionUserId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
            console.warn(`No userId found in getCurrentUserId, using session ID: ${this.sessionUserId}`);
        }
        return this.sessionUserId;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up Firestore subscriptions
        this.firestoreUnsubscribers.forEach((unsubscribe)=>unsubscribe());
        this.firestoreUnsubscribers.clear();
    }
    detectEnvironment() {
        // First try to detect from the current URL
        const hostname = window.location.hostname;
        console.log(`Detecting environment from hostname: ${hostname}`);
        // URL pattern: hitl-{env}.{domain} (e.g., hitl-dev-1.dev.devk.document-processing.app)
        // ALL environments have the pattern: {env}-{number} (dev-1, stg-1, prd-1, ci-1, sit-1)
        const urlMatch = hostname.match(/hitl-([^.]+)\./);
        if (urlMatch) {
            let environment = urlMatch[1]; // e.g., "dev-1", "ci-1", "stg-1", "prd-1"
            // Convert short form to full environment name with configurable client prefix
            // All environments follow the pattern: {env}-{number}
            if (environment.match(/^[a-z]+-\d+$/)) {
                environment = `${this.clientPrefix}-${environment}`; // Convert "dev-1" to "{client}-dev-1"
                console.log(`Auto-detected environment '${environment}' from URL: ${hostname} (client prefix: ${this.clientPrefix})`);
                return environment;
            }
        }
        // Try to detect from AD redirect URI if available
        const adRedirectUri = "DEFAULT_AD_REDIRECT_URI";
        console.log(`AD redirect URI: ${adRedirectUri}`);
        if (adRedirectUri) {
            const adMatch = adRedirectUri.match(/hitl-([^.]+)\./);
            if (adMatch) {
                let environment = adMatch[1];
                // All environments follow the pattern: {env}-{number}
                if (environment.match(/^[a-z]+-\d+$/)) {
                    environment = `${this.clientPrefix}-${environment}`;
                    console.log(`Auto-detected environment '${environment}' from AD redirect URI (client prefix: ${this.clientPrefix})`);
                    return environment;
                }
            }
        }
        console.error(`Could not detect environment from URL '${hostname}'. No fallback will be used.`);
        return "";
    }
    render() {
        return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
      <link
        href="https://unpkg.com/material-components-web@latest/dist/material-components-web.min.css"
        rel="stylesheet"
      />
      <div class="mdc-card">
        <div class="card-header">
          <div class="card-title">
            <h2 class="mdc-typography--headline6">
              Arbeitsvorrat nach Zuständigkeitsbereich
            </h2>
            <p
              class="mdc-typography--body2"
              style="margin: 4px 0; color: #666;"
            >
              Environment: <strong>${this.environment}</strong>
            </p>
          </div>
        </div>
        <div class="card-body mdc-typography--body2">
          <mwc-list multi id="checklist" @selected=${this.updateQueueSelection}>
            <mwc-linear-progress
              ?indeterminate=${true}
              ?closed=${!this.loading}
            ></mwc-linear-progress>
            <li divider role="separator"></li>
            ${this.queues.map((queue)=>{
            const effectiveCount = this.getEffectiveQueueCount(queue, "available");
            const displayCount = queue.hasMoreDocuments && effectiveCount >= 1000 ? ">1000" : effectiveCount;
            return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                <mwc-check-list-item left hasMeta>
                  <span>${queue.displayName}</span>
                  <span slot="meta">${displayCount}</span>
                </mwc-check-list-item>
                <li divider role="separator"></li>
              `;
        })}
          </mwc-list>
        </div>
        <div class="mdc-card__actions">
          <mwc-textfield
            style="width: 50ex;"
            type="text"
            value="${this.envelopeIdSearch}"
            @input=${this.updateEnvelopeIdSearch}
            label="Suche nach Sendungs-ID (max. 10)"
          ></mwc-textfield>
          ${this.envelopeIdSearch ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                <mwc-button
                  outlined
                  @click="${this.clearEnvelopeIdSearch}"
                  label="×"
                  style="min-width: 40px; padding: 0 8px;"
                ></mwc-button>
              ` : null}
          ${this.queueType === (0, $71b210c792da224a$export$f49165103acf0cf8).File ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)` <mwc-button
                outlined
                @click="${this.addFileQueue}"
                label="Zum Arbeitsstapel hinzufügen"
              ></mwc-button>` : null}
          <mwc-textfield
            ?disabled=${this.queues.length === 0}
            style="width: 25ex;"
            type="number"
            required
            value="10"
            @change=${this.updateReviewRequestsPerQueue}
            min="1"
            label="Angeforderte Dokumente"
          ></mwc-textfield>
          <mwc-button
            raised
            ?disabled=${this.queues.length === 0 || this.loading}
            @click="${this.addReviewRequestsToBatch}"
            label="Zum Arbeitsstapel hinzufügen"
          ></mwc-button>
        </div>
      </div>
    `;
    }
    // Optimized update method with change detection
    requestUpdateIfChanged() {
        if (this.pendingUpdateRequest) return;
        // Create hash of current queue counts for change detection
        const currentHash = this.queues.map((q)=>`${q.name}:${q.reviewRequestCount}:${q.assignedReviewRequestCount}`).join("|");
        if (currentHash !== this.lastQueueCountsHash) {
            this.lastQueueCountsHash = currentHash;
            this.pendingUpdateRequest = true;
            // Use requestIdleCallback for better performance if available
            if (window.requestIdleCallback) window.requestIdleCallback(()=>{
                this.requestUpdate();
                this.pendingUpdateRequest = false;
            });
            else {
                // Fallback to immediate update
                this.requestUpdate();
                this.pendingUpdateRequest = false;
            }
        }
    }
    async firstUpdated() {
        if (this.queueType === (0, $71b210c792da224a$export$f49165103acf0cf8).Firestore) {
            this.loading = true;
            try {
                this.queues = await this.getFirestoreQueues();
                // Restore queue selection from session
                const sessionData = (0, $cfe1945935cd34b8$export$415798a788f40554).loadSession();
                if (sessionData && sessionData.selectedQueue) try {
                    this.queueSelection = JSON.parse(sessionData.selectedQueue);
                } catch (error) {
                    this.queueSelection = [];
                }
                else this.queueSelection = [];
                // Start real-time subscription to queue updates
                await this.subscribeToFirestoreQueues();
                const reviewRequestUpdatedEvent = new CustomEvent("queues-updated", {
                    bubbles: true,
                    detail: this.queues
                });
                this.dispatchEvent(reviewRequestUpdatedEvent);
            } catch (error) {
                (0, $a30lF.log).error({
                    error: error,
                    message: "Error fetching queues during first update",
                    queueType: this.queueType,
                    queueSelection: this.queueSelection,
                    queues: this.queues
                });
            } finally{
                this.loading = false;
            }
            // Set up periodic cleanup and unload handlers
            this.startPeriodicCleanup();
            this.setupUnloadHandler();
        }
    }
    startPeriodicCleanup() {
        this.releaseExpiredTasks();
        // Clean up expired tasks every 5 minutes
        this.cleanupInterval = window.setInterval(()=>{
            this.releaseExpiredTasks();
        }, 300000);
    }
    setupUnloadHandler() {
        const userId = this.getCurrentUserId();
        // Release user's tasks when they leave the page
        const handleUnload = ()=>{
            // Use sendBeacon for more reliable cleanup on page unload
            if (navigator.sendBeacon) // Note: This would need a backend endpoint to handle the release
            console.log(`Page unload detected, would release tasks for user ${userId}`);
            else // Fallback for browsers without sendBeacon
            this.releaseUserTasks(userId);
        };
        window.addEventListener("beforeunload", handleUnload);
        window.addEventListener("pagehide", handleUnload);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up intervals
        if (this.cleanupInterval) clearInterval(this.cleanupInterval);
        // Release user's assigned tasks when component is destroyed
        const userId = this.getCurrentUserId();
        this.releaseUserTasks(userId);
    }
    async addFileQueue() {
        this.loading = true;
        // ensure that the access token is available (only refresh if needed)
        await this.getAccessToken(false);
        try {
            const fileQueue = await $d682416b82a19869$var$FileQueue.build(this);
            this.queues = this.queues.concat(fileQueue);
            const reviewRequestUpdatedEvent = new CustomEvent("queues-updated", {
                bubbles: true,
                detail: this.queues
            });
            this.dispatchEvent(reviewRequestUpdatedEvent);
        } catch  {
            console.log("fetching file queues failed");
        }
        this.loading = false;
    }
    async addReviewRequestsToBatch() {
        // Record user activity for adaptive polling
        this.recordUserActivity();
        // Debouncing: if already loading, return the existing promise
        if (this.loadingPromise || this.loading) {
            console.log("Batch loading already in progress, ignoring request...");
            return;
        }
        // Immediately set loading state to prevent multiple clicks
        this.loading = true;
        this.requestUpdate(); // Force UI update to disable button
        // Create and store the loading promise
        this.loadingPromise = this._performBatchLoad();
        try {
            await this.loadingPromise;
        } finally{
            // Clear the promise when done (whether successful or not)
            this.loadingPromise = null;
            this.loading = false;
            this.requestUpdate(); // Force UI update to re-enable button
        }
    }
    async _performBatchLoad() {
        // Immediate feedback: dispatch empty batch to show UI is responding
        const immediateEvent = new CustomEvent("review-requests-loading", {
            bubbles: true,
            detail: {
                queuesCount: this.queueSelection.length
            }
        });
        this.dispatchEvent(immediateEvent);
        try {
            // ensure that the access token is available (only refresh if needed)
            await this.getAccessToken(false);
            const selectedQueus = this.queueSelection.map((index)=>this.queues[index]);
            // Process queues in parallel for better performance
            const CHUNK_SIZE = 2; // Process documents in chunks of 2 for immediate visibility
            const allReviewRequests = [];
            // Fetch from all queues in parallel
            const queueResults = await Promise.all(selectedQueus.map(async (queue, index)=>{
                // Dispatch progress update
                const progressEvent = new CustomEvent("review-requests-progress", {
                    bubbles: true,
                    detail: {
                        current: index + 1,
                        total: selectedQueus.length,
                        queueName: queue.name
                    }
                });
                this.dispatchEvent(progressEvent);
                try {
                    // Skip queues with no available tasks AND no assigned tasks
                    if (queue.reviewRequestCount === 0 && (queue.assignedCount === 0 || queue.assignedCount === undefined)) {
                        console.log(`Skipping empty queue: ${queue.name}`);
                        return [];
                    }
                    const requests = await queue.getReviewRequests(this.reviewRequestsPerQueue);
                    // Note: Local adjustments are applied in fetchAndAssignFirestoreTasksREST to avoid double counting
                    return requests;
                } catch (error) {
                    console.warn(`Failed to fetch requests from queue ${queue.name}:`, error);
                    return []; // Return empty array for failed queues
                }
            }));
            // Flatten results
            const batchReviewRequests = queueResults.flat();
            // Note: Local adjustments are now applied in getFirestoreReviewRequests per queue
            if (batchReviewRequests.length > 0) console.log(`\u{1F4C4} ${batchReviewRequests.length} documents loaded into work stack`);
            // Progressive loading: dispatch documents in chunks
            for(let i = 0; i < batchReviewRequests.length; i += CHUNK_SIZE){
                const chunk = batchReviewRequests.slice(i, i + CHUNK_SIZE);
                allReviewRequests.push(...chunk);
                // Dispatch only the new chunk to avoid duplicates
                const reviewRequestUpdatedEvent = new CustomEvent("review-requests-updated", {
                    bubbles: true,
                    detail: chunk
                });
                this.dispatchEvent(reviewRequestUpdatedEvent);
                // Small delay to allow UI to update between chunks
                if (i + CHUNK_SIZE < batchReviewRequests.length) await new Promise((resolve)=>setTimeout(resolve, 20));
            }
            // Dispatch completion event to signal loading is done
            const completedEvent = new CustomEvent("review-requests-completed", {
                bubbles: true,
                detail: {
                    count: allReviewRequests.length
                }
            });
            this.dispatchEvent(completedEvent);
        } catch (error) {
            console.error("Error in addReviewRequestsToBatch:", error);
            const errorMessage = error instanceof Error ? error.message : String(error);
            const errorEvent = new CustomEvent("review-requests-error", {
                bubbles: true,
                detail: {
                    error: errorMessage
                }
            });
            this.dispatchEvent(errorEvent);
            throw error; // Re-throw to handle in the main method
        }
    }
    static{
        this.TOKEN_CACHE_DURATION = 300000 // 5 minutes
        ;
    }
    async getAccessToken(refresh = false) {
        // Check if we have a valid cached token and refresh is not forced
        const now = Date.now();
        if (!refresh && this.cachedAccessToken && now < this.tokenCacheExpiry) {
            this.updateQueueTokens(this.cachedAccessToken);
            return [
                this.cachedAccessToken,
                this.cachedIdToken
            ];
        }
        const [accessToken, idToken] = await new Promise((resolve, reject)=>{
            const getAccessToken = new CustomEvent("get-access-token", {
                bubbles: true,
                detail: {
                    refresh: refresh,
                    resolve: resolve,
                    reject: reject
                }
            });
            this.dispatchEvent(getAccessToken);
        });
        // Cache the token
        this.cachedAccessToken = accessToken;
        this.cachedIdToken = idToken;
        this.tokenCacheExpiry = now + $d682416b82a19869$export$f0cad83ff67fe3b.TOKEN_CACHE_DURATION;
        this.updateQueueTokens(accessToken);
        return [
            accessToken,
            idToken
        ];
    }
    updateQueueTokens(accessToken) {
        this.queues.forEach((queue)=>{
            if (queue instanceof $d682416b82a19869$var$PubSubQueue) queue.accessToken = accessToken;
        });
    }
    async getPubSubQueues() {
        // Must have environment to proceed
        if (!this.environment) {
            console.error("No environment detected. Cannot fetch HITL subscriptions.");
            return [];
        }
        const now = Date.now();
        // Check cache first
        if ($d682416b82a19869$export$3dc07afe418952bc.subscriptionCache && now - $d682416b82a19869$export$3dc07afe418952bc.subscriptionCache.timestamp < $d682416b82a19869$export$3dc07afe418952bc.CACHE_TTL) {
            console.log("Using cached subscription data");
            // Efficiently update access tokens for cached queues
            const [accessToken] = await this.getAccessToken();
            $d682416b82a19869$export$3dc07afe418952bc.subscriptionCache.data.forEach((queue)=>queue.accessToken = accessToken);
            return $d682416b82a19869$export$3dc07afe418952bc.subscriptionCache.data;
        }
        console.log("Fetching fresh subscription data");
        try {
            // Get access token once
            const [accessToken] = await this.getAccessToken();
            // Direct API call to get subscriptions for the specific HITL topic
            const hitlTopicName = `${this.environment}-hitl`;
            const topicPath = `projects/${this.projectId}/topics/${hitlTopicName}`;
            console.log(`Fetching subscriptions for HITL topic: ${hitlTopicName}`);
            const response = await fetch(`https://pubsub.googleapis.com/v1/${topicPath}/subscriptions`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch subscriptions for topic ${hitlTopicName}: ${response.status} ${response.statusText}`);
            const { subscriptions: subscriptions = [] } = await response.json();
            console.log(`Found ${subscriptions.length} HITL subscriptions for topic ${hitlTopicName}`);
            // Create queue instances efficiently
            const pubSubQueues = subscriptions.map((subscription)=>new $d682416b82a19869$var$PubSubQueue(this, accessToken, subscription));
            // Cache the results
            $d682416b82a19869$export$3dc07afe418952bc.subscriptionCache = {
                data: pubSubQueues,
                timestamp: now
            };
            return pubSubQueues;
        } catch (error) {
            console.error("Failed to fetch HITL subscriptions:", error);
            return [];
        }
    }
    inferEnvironmentFromQueues(queues) {
        // Look at queue names to find common environment pattern
        const environments = new Set();
        queues.forEach((queue)=>{
            // Use configurable client prefix instead of hardcoded "devk"
            const clientPrefix = this.clientPrefix || "devk";
            // All environments follow the pattern: {client}-{env}-{number} where {env}-{number} is like dev-1, stg-1, prd-1
            const match = queue.name.match(new RegExp(`^(${clientPrefix}-[a-z]+-\\d+)`));
            if (match) environments.add(match[1]);
        });
        // If we found exactly one environment, use it
        if (environments.size === 1) return Array.from(environments)[0];
        // If multiple environments, log warning and return empty
        if (environments.size > 1) console.warn(`Multiple environments found in queues: ${Array.from(environments).join(", ")}`);
        return "";
    }
    async fetchAllTopics(accessToken) {
        let topics = [];
        let pageToken;
        do try {
            let url = `https://pubsub.googleapis.com/v1/projects/${this.projectId}/topics`;
            if (pageToken) url += `?pageToken=${pageToken}`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            if (!response.ok) throw response;
            const json = await response.json();
            const allTopics = json.topics || [];
            // Log all topics for debugging
            console.log(`All topics found (page):`, allTopics.map((t)=>t.name.split("/").pop()));
            console.log(`Current environment for filtering: '${this.environment}'`);
            // Filter topics by environment to reduce API calls
            const environmentTopics = allTopics.filter((topic)=>{
                const topicName = topic.name.split("/").pop(); // Get topic name from full path
                // Skip filtering if no environment detected
                if (!this.environment) {
                    console.warn("No environment detected, returning all topics");
                    return true;
                }
                // Check multiple naming patterns:
                // 1. Exact prefix: devk-dev-1-hitl-*
                // 2. With number suffix: devk-dev-1-hitl-*, devk-dev-2-hitl-*, devk-dev-3-hitl-*
                // 3. Contains environment: *devk-dev*hitl*
                const envBase = this.environment.replace(/-\d+$/, ""); // Remove number suffix if present
                const matches = topicName?.startsWith(this.environment) || topicName?.startsWith(`${envBase}-`) || topicName?.includes(envBase) && topicName?.includes("hitl");
                if (matches) console.log(`Topic ${topicName} matches environment ${this.environment}`);
                return matches;
            });
            topics = topics.concat(environmentTopics);
            pageToken = json.nextPageToken;
        } catch (error) {
            console.log("Failed on fetching topics", error);
            break;
        }
        while (pageToken);
        console.log(`Filtered topics for environment ${this.environment}:`, topics.length);
        // Fallback: if no environment-specific topics found, fetch all topics with warning
        if (topics.length === 0) {
            console.warn(`No topics found for environment ${this.environment}. Falling back to all topics for debugging.`);
            // Re-fetch without filtering for debugging
            try {
                const response = await fetch(`https://pubsub.googleapis.com/v1/projects/${this.projectId}/topics`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                const json = await response.json();
                const allTopics = json.topics || [];
                console.log(`All available topics:`, allTopics.map((t)=>t.name.split("/").pop()));
                return allTopics; // Return all topics as fallback
            } catch (error) {
                console.error("Failed to fetch fallback topics:", error);
            }
        }
        return topics;
    }
    async batchFetchSubscriptions(topics, accessToken) {
        // Batch fetch subscriptions for all topics using Promise.allSettled
        const subscriptionPromises = topics.map(async (topic)=>{
            try {
                const response = await fetch(`https://pubsub.googleapis.com/v1/${topic.name}/subscriptions`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                if (!response.ok) throw new Error(`Failed to fetch subscriptions for topic ${topic.name}`);
                const json = await response.json();
                return json.subscriptions || [];
            } catch (error) {
                console.log(`Failed on fetching subscriptions for topic ${topic.name}:`, error);
                return [];
            }
        });
        const results = await Promise.allSettled(subscriptionPromises);
        // Extract successful results and flatten
        const allSubscriptions = results.filter((result)=>result.status === "fulfilled").map((result)=>result.value).flat().filter(Boolean);
        return allSubscriptions;
    }
    async batchFetchHitlSubscriptions(subscriptions, accessToken) {
        // Pre-filter subscriptions by environment and hitl naming convention to reduce API calls
        const environmentSubscriptions = subscriptions.filter((subscription)=>{
            const subscriptionName = subscription.split("/").pop(); // Get subscription name from full path
            // Skip filtering if no environment detected
            if (!this.environment) return subscriptionName?.includes("hitl");
            // Check multiple naming patterns similar to topic filtering
            const envBase = this.environment.replace(/-\d+$/, ""); // Remove number suffix if present
            return (subscriptionName?.includes(this.environment) || subscriptionName?.includes(envBase)) && subscriptionName?.includes("hitl");
        });
        console.log(`Pre-filtered subscriptions for environment ${this.environment}:`, environmentSubscriptions.length, "out of", subscriptions.length);
        // Batch fetch subscription details using Promise.allSettled
        const hitlPromises = environmentSubscriptions.map(async (subscription)=>{
            try {
                const response = await fetch(`https://pubsub.googleapis.com/v1/${subscription}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                if (!response.ok) throw new Error(`Failed to fetch subscription details for ${subscription}`);
                const json = await response.json();
                // Return subscription name if it has hitl=true label
                if (json.labels?.hitl === "true") return subscription;
                return null;
            } catch (error) {
                console.log(`Failed on fetching subscription details for ${subscription}:`, error);
                return null;
            }
        });
        const results = await Promise.allSettled(hitlPromises);
        // Extract successful results and filter out nulls
        const hitlSubscriptions = results.filter((result)=>result.status === "fulfilled").map((result)=>result.value).filter(Boolean);
        return hitlSubscriptions;
    }
}
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String
    })
], $d682416b82a19869$export$f0cad83ff67fe3b.prototype, "queueType", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Array
    })
], $d682416b82a19869$export$f0cad83ff67fe3b.prototype, "queues", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Number
    })
], $d682416b82a19869$export$f0cad83ff67fe3b.prototype, "reviewRequestsPerQueue", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Boolean
    })
], $d682416b82a19869$export$f0cad83ff67fe3b.prototype, "loading", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String
    })
], $d682416b82a19869$export$f0cad83ff67fe3b.prototype, "envelopeIdSearch", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String
    })
], $d682416b82a19869$export$f0cad83ff67fe3b.prototype, "environment", void 0);
$d682416b82a19869$export$f0cad83ff67fe3b = (0, $czHfO.__decorate)([
    (0, $df800a9dc9638977$export$da64fc29f17f9d0e)("hitl-queues")
], $d682416b82a19869$export$f0cad83ff67fe3b);
class $d682416b82a19869$export$3dc07afe418952bc {
    static{
        this.subscriptionCache = null;
    }
    static{
        this.CACHE_TTL = 300000 // 5 minutes
        ;
    }
    constructor(host, name){
        this.name = "";
        this.reviewRequestCount = 0;
        (this.host = host).addController(this);
        this.name = name;
    }
    hostConnected() {
        // Start a timer when the host is connected with adaptive interval
        this._timerID = window.setInterval(()=>this.getReviewRequestCount(), this.getRefreshInterval());
    }
    getRefreshInterval() {
        // More frequent refresh for queues with messages, less frequent for empty ones
        return this.reviewRequestCount > 0 ? 60000 : 300000; // 1min vs 5min
    }
    hostDisconnected() {
        // Clear the timer when the host is disconnected
        clearInterval(this._timerID);
        this._timerID = undefined;
    }
}
class $d682416b82a19869$var$FileQueue extends $d682416b82a19869$export$3dc07afe418952bc {
    constructor(host, fileSystemDirectoryHandle){
        if (typeof fileSystemDirectoryHandle === "undefined") throw new Error("Cannot be called directly");
        super(host, fileSystemDirectoryHandle.name), this.getReviewRequests = async (count)=>{
            const reviewRequests = [];
            const entries = this.fileSystemDirectoryHandle.entries();
            let i = 0;
            for await (const entry of entries)if (entry[0].endsWith(".json") && !entry[0].endsWith(".grouping-labels.json") && !entry[0].endsWith(".entity-labels.json") && i < count) {
                const name = entry[0];
                const reviewRequestFileSystemFileHandle = await this.fileSystemDirectoryHandle.getFileHandle(name);
                const reviewRequestFile = await reviewRequestFileSystemFileHandle.getFile();
                const lastModified = new Date(reviewRequestFile.lastModified);
                const fileBaseName = reviewRequestFile.name.replace(".json", "");
                const groupingLabelsFileName = fileBaseName + ".grouping-labels.json";
                const classificationLabelsFileName = fileBaseName + ".classification-labels.json";
                const entityLabelsFileName = fileBaseName + ".entity-labels.json";
                let type = "Entity";
                let labels = [];
                let pageImageUrls = [];
                for await (const [fileName, fileSystemFileHandle] of this.fileSystemDirectoryHandle.entries()){
                    if (groupingLabelsFileName === fileName) {
                        labels = await this.getGroupingLabels(fileSystemFileHandle);
                        type = "DocSplitter";
                    } else if (classificationLabelsFileName === fileName) {
                        labels = await this.getClassificationLabels(fileSystemFileHandle);
                        type = "DAI_COMPLEX_CLASSIFICATION";
                    } else if (entityLabelsFileName === fileName) labels = await this.getEntityLabels(fileSystemFileHandle);
                    else if (// if file ends with png or jpg then use the images as pageImageUrls
                    (fileName.endsWith(".png") || fileName.endsWith(".jpg")) && fileName.startsWith(fileBaseName)) {
                        const file = await fileSystemFileHandle.getFile();
                        // for File based images we need to convert image data to Data URL for Images served via HTTP the URL can directly be used
                        const pageImageUrl = await this.toDataUrl(file);
                        const pageString = fileName.replace(fileBaseName, "").replace(".page-", "").replace(".png", "").replace(".jpg", "");
                        const page = parseInt(pageString);
                        pageImageUrls[page - 1] = pageImageUrl;
                    }
                }
                // initialize file based review request - a different class implemeting ReviewRequest should be used for a different backend
                const reviewRequest = new (0, $20e0088800729d63$export$95b45e2cf1d26ada)(reviewRequestFileSystemFileHandle, type, reviewRequestFile.name, lastModified, this.name, labels, pageImageUrls);
                // add review request to list of review requests
                reviewRequests.push(reviewRequest);
                i++;
            }
            return reviewRequests;
        }, this.toDataUrl = (file)=>new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = (error)=>reject(error);
            });
        this.fileSystemDirectoryHandle = fileSystemDirectoryHandle;
        this.getReviewRequestCount();
    }
    static async build(host) {
        const fileSystemDirectoryHandle = await window.showDirectoryPicker();
        return new $d682416b82a19869$var$FileQueue(host, fileSystemDirectoryHandle);
    }
    async getEntityLabels(entityLabelsFileHandle) {
        let entityLabels = [];
        try {
            const file = await entityLabelsFileHandle.getFile();
            const content = await file.text();
            const json = JSON.parse(content);
            if (Array.isArray(json)) entityLabels = json.map((entityLabel)=>{
                return (0, $a5412009125d86dc$export$3b798af8cc0f34eb).fromJson(entityLabel);
            });
        } catch  {
            console.log("retrieving entity labels failed");
        }
        return entityLabels;
    }
    async getGroupingLabels(groupingLabelsFileHandle) {
        let groupingLabels = [];
        try {
            const file = await groupingLabelsFileHandle.getFile();
            const content = await file.text();
            const json = JSON.parse(content);
            if (Array.isArray(json)) groupingLabels = json.map((groupingLabel)=>{
                return (0, $28cd16f8fd1092bc$export$d385b1740434b54b).fromJson(groupingLabel);
            });
        } catch  {
            console.log("retrieving entity labels failed");
        }
        return groupingLabels;
    }
    // get classification labels from classification-labels.json file
    async getClassificationLabels(classificationLabelsFileHandle) {
        let classificationLabels = [];
        try {
            const file = await classificationLabelsFileHandle.getFile();
            const content = await file.text();
            const json = JSON.parse(content);
            if (Array.isArray(json)) classificationLabels = json.map((classificationLabel)=>{
                return (0, $150c59cc1c2ee7ed$export$59e7611a9b95daae).fromJson(classificationLabel);
            });
        } catch  {
            console.log("retrieving classification labels failed");
        }
        return classificationLabels;
    }
    async getReviewRequestCount() {
        let count = 0;
        const entries = this.fileSystemDirectoryHandle.entries();
        for await (const entry of entries)if (entry[0].endsWith(".json") && !entry[0].endsWith(".grouping-labels.json") && !entry[0].endsWith(".classification-labels.json") && !entry[0].endsWith(".entity-labels.json")) count++;
        // get reviewRequestCount every 60 seconds
        this.reviewRequestCount = count;
        // Update the host with new value
        this.host.requestUpdate();
    }
}
class $d682416b82a19869$var$PubSubQueue extends $d682416b82a19869$export$3dc07afe418952bc {
    constructor(host, accessToken, subscriptionName){
        const subscriptionId = subscriptionName.split("/")[3];
        const displayName = (0, $eUQW6.getQueueDisplayName)(subscriptionId);
        super(host, displayName), this.getReviewRequests = async (count)=>{
            const reviewRequests = [];
            // retrieve count messages from Pub/Sub subscription
            let url = "https://pubsub.googleapis.com/v1/" + this.subscriptionName + ":pull";
            try {
                const response = await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(url, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${this.accessToken}`
                    },
                    body: JSON.stringify({
                        maxMessages: count
                    })
                }, 5, 1);
                const json = await response.json();
                const receivedMessages = json.receivedMessages ?? [];
                // Early return if no messages to process
                if (receivedMessages.length === 0) {
                    console.log(`No messages available in queue: ${this.name}`);
                    return reviewRequests;
                }
                console.log(`Processing ${receivedMessages.length} messages from queue: ${this.name}`);
                // Use Web Worker for large batches, otherwise process in main thread
                const USE_WORKER_THRESHOLD = 20;
                let processedMessages;
                if (this.messageWorker && receivedMessages.length > USE_WORKER_THRESHOLD) // Process in Web Worker for better performance with large batches
                processedMessages = await this.processMessagesInWorker(receivedMessages);
                else // Process messages with optimized operations in main thread
                processedMessages = receivedMessages.map((message)=>{
                    try {
                        // Critical operations only - defer heavy processing
                        const data = JSON.parse(window.atob(message.message.data));
                        // Optimized: use centralized lookup for faster type determination
                        const type = (0, $1d7c3ce87f93ab74$export$11b23ea87b443d86)[data.processorType] || "Entity";
                        // Defer label processing - create lightweight placeholder
                        const labels = [];
                        // Store raw data for deferred processing
                        return {
                            message: message,
                            data: data,
                            type: type,
                            labels: labels,
                            rawLabels: data.labels
                        };
                    } catch (error) {
                        console.error(`Failed to process message:`, error);
                        return null;
                    }
                }).filter(Boolean); // Remove failed messages
                // Process in batches for better UI responsiveness
                const BATCH_SIZE = 5;
                for(let i = 0; i < processedMessages.length; i += BATCH_SIZE){
                    const batch = processedMessages.slice(i, i + BATCH_SIZE);
                    await Promise.all(batch.map(async ({ message: message, data: data, type: type, labels: labels, rawLabels: rawLabels })=>{
                        // Build pageImageUrls
                        const storageBaseUrl = `https://storage.googleapis.com/${data.resultBucket}/`;
                        const pageImageUrlPrefix = data.pageImageUrlPrefix + "/";
                        const pageImageUrls = data.pageImageNames.map((pageImageName)=>storageBaseUrl + encodeURIComponent(pageImageUrlPrefix + pageImageName));
                        // Process labels only when needed
                        if (rawLabels?.length > 0) {
                            if (type === "DocSplitter") rawLabels.forEach((label)=>{
                                const groupingLabel = (0, $28cd16f8fd1092bc$export$d385b1740434b54b).fromJson(label);
                                labels.push(groupingLabel);
                            });
                            else if (type === "DAI_COMPLEX_CLASSIFICATION") rawLabels.forEach((label)=>{
                                const classificationLabel = (0, $150c59cc1c2ee7ed$export$59e7611a9b95daae).fromJson(label);
                                labels.push(classificationLabel);
                            });
                            else rawLabels.forEach((label)=>{
                                const entityLabel = (0, $a5412009125d86dc$export$3b798af8cc0f34eb).fromJson(label);
                                labels.push(entityLabel);
                            });
                        }
                        const reviewRequest = new (0, $20e0088800729d63$export$9fee94aa43a40124)(this.projectId, this.subscriptionName, message.ackId, message.message.messageId, data.resultBucket, data.resultPrefix, data.resultObject, data.reviewedResultBucket ?? "", data.rejectedResultBucket ?? "", data.callbackUrl, type, data.inputObject, new Date(message.message.publishTime), this.name, labels, pageImageUrls, data, data.revisions);
                        reviewRequests.push(reviewRequest);
                    }));
                    // Small delay between batches to keep UI responsive
                    if (i + BATCH_SIZE < processedMessages.length) await new Promise((resolve)=>setTimeout(resolve, 20));
                }
                // remove timer for refreshing reviewRequestCount
                clearInterval(this._timerID);
                // remove the number of messages taken from the list from the overall count
                this.reviewRequestCount = Math.max(this.reviewRequestCount - receivedMessages.length, 0);
                // restart timer for refreshing reviewRequestCount with adaptive interval
                this._timerID = undefined;
                this._timerID = window.setInterval(()=>this.getReviewRequestCount(), this.getRefreshInterval());
                // Update the host with new value
                this.host.requestUpdate();
            } catch (error) {
                console.log("Failed to fetch messages from Pub/Sub subscription");
            }
            return reviewRequests;
        };
        this.subscriptionId = subscriptionId;
        this.projectId = subscriptionName.split("/")[1];
        this.accessToken = accessToken;
        this.subscriptionName = subscriptionName;
        this.getReviewRequestCount();
    }
    async getReviewRequestCount() {
        let count = this.reviewRequestCount;
        try {
            const response = await fetch("https://monitoring.googleapis.com/v3/projects/" + this.projectId + "/timeSeries:query", {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + this.accessToken
                },
                body: JSON.stringify({
                    query: `fetch pubsub_subscription | metric 'pubsub.googleapis.com/subscription/num_undelivered_messages' | filter (resource.subscription_id == '${this.subscriptionId}') | within 2m`
                })
            });
            if (!response.ok) throw response;
            const json = await response.json();
            //  undelivered messages, if null then return previous value
            count = json.timeSeriesData?.pop()?.pointData?.find(Boolean)?.values?.find(Boolean)?.int64Value ?? this.reviewRequestCount;
        } catch (error) {
            console.log("Failed on quering monitoring");
            console.log(error);
        }
        this.reviewRequestCount = count;
        // Update the host with new value
        this.host.requestUpdate();
    }
    // Process messages in Web Worker for better performance
    async processMessagesInWorker(messages) {
        return new Promise((resolve, reject)=>{
            if (!this.messageWorker) {
                reject(new Error("Web Worker not available"));
                return;
            }
            // Use centralized type map for the worker
            const typeMap = (0, $1d7c3ce87f93ab74$export$11b23ea87b443d86);
            // Set up one-time message handler
            const handler = (event)=>{
                if (event.data.success) resolve(event.data.results);
                else reject(new Error(event.data.error));
                this.messageWorker.removeEventListener("message", handler);
            };
            this.messageWorker.addEventListener("message", handler);
            // Send messages to worker for processing
            this.messageWorker.postMessage({
                messages: messages,
                typeMap: typeMap
            });
        });
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3dcebddf46157fd2$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3dcebddf46157fd2$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3dcebddf46157fd2$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $c6fa3a35ad8b4d56$var$t } = (0, $e4c6f5c4fa111bdf$export$8613d1ca9052b22e), $c6fa3a35ad8b4d56$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $c6fa3a35ad8b4d56$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $c6fa3a35ad8b4d56$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $c6fa3a35ad8b4d56$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $c6fa3a35ad8b4d56$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $c6fa3a35ad8b4d56$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $c6fa3a35ad8b4d56$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $c6fa3a35ad8b4d56$var$r = ()=>document.createComment(""), $c6fa3a35ad8b4d56$export$291b2338ad9b0b30 = (o, i, n)=>{
    const e = o._$AA.parentNode, l = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = e.insertBefore($c6fa3a35ad8b4d56$var$r(), l), d = e.insertBefore($c6fa3a35ad8b4d56$var$r(), l);
        n = new $c6fa3a35ad8b4d56$var$t(i, d, o, o.options);
    } else {
        const t = n._$AB.nextSibling, i = n._$AM, d = i !== o;
        if (d) {
            let t;
            n._$AQ?.(o), n._$AM = o, void 0 !== n._$AP && (t = o._$AU) !== i._$AU && n._$AP(t);
        }
        if (t !== l || d) {
            let o = n._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                e.insertBefore(o, l), o = t;
            }
        }
    }
    return n;
}, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $c6fa3a35ad8b4d56$var$u = {}, $c6fa3a35ad8b4d56$export$ea70d9dd5965b1c8 = (o, t = $c6fa3a35ad8b4d56$var$u)=>o._$AH = t, $c6fa3a35ad8b4d56$export$59e9bce518cde500 = (o)=>o._$AH, $c6fa3a35ad8b4d56$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $c6fa3a35ad8b4d56$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4a8aa2cdbf35fab5$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $4a8aa2cdbf35fab5$export$76d90c956114f2c2 = (0, $3dcebddf46157fd2$export$99b43ad1ed32e735)(class extends (0, $3dcebddf46157fd2$export$befdefbdce210f91) {
    constructor(e){
        if (super(e), e.type !== (0, $3dcebddf46157fd2$export$9ba3b3f20a85bfa).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    dt(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.dt(e, s, t).values;
    }
    update(s, [t, r, c]) {
        const d = (0, $c6fa3a35ad8b4d56$export$59e9bce518cde500)(s), { values: p, keys: a } = this.dt(t, r, c);
        if (!Array.isArray(d)) return this.ut = a, p;
        const h = this.ut ??= [], v = [];
        let m, y, x = 0, j = d.length - 1, k = 0, w = p.length - 1;
        for(; x <= j && k <= w;)if (null === d[x]) x++;
        else if (null === d[j]) j--;
        else if (h[x] === a[k]) v[k] = (0, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4)(d[x], p[k]), x++, k++;
        else if (h[j] === a[w]) v[w] = (0, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4)(d[j], p[w]), j--, w--;
        else if (h[x] === a[w]) v[w] = (0, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4)(d[x], p[w]), (0, $c6fa3a35ad8b4d56$export$291b2338ad9b0b30)(s, v[w + 1], d[x]), x++, w--;
        else if (h[j] === a[k]) v[k] = (0, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4)(d[j], p[k]), (0, $c6fa3a35ad8b4d56$export$291b2338ad9b0b30)(s, d[x], d[j]), j--, k++;
        else if (void 0 === m && (m = $4a8aa2cdbf35fab5$var$u(a, k, w), y = $4a8aa2cdbf35fab5$var$u(h, x, j)), m.has(h[x])) {
            if (m.has(h[j])) {
                const e = y.get(a[k]), t = void 0 !== e ? d[e] : null;
                if (null === t) {
                    const e = (0, $c6fa3a35ad8b4d56$export$291b2338ad9b0b30)(s, d[x]);
                    (0, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4)(e, p[k]), v[k] = e;
                } else v[k] = (0, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4)(t, p[k]), (0, $c6fa3a35ad8b4d56$export$291b2338ad9b0b30)(s, d[x], t), d[e] = null;
                k++;
            } else (0, $c6fa3a35ad8b4d56$export$3133b3144bbba267)(d[j]), j--;
        } else (0, $c6fa3a35ad8b4d56$export$3133b3144bbba267)(d[x]), x++;
        for(; k <= w;){
            const e = (0, $c6fa3a35ad8b4d56$export$291b2338ad9b0b30)(s, v[w + 1]);
            (0, $c6fa3a35ad8b4d56$export$cb8bf9562088e9f4)(e, p[k]), v[k++] = e;
        }
        for(; x <= j;){
            const e = d[x++];
            null !== e && (0, $c6fa3a35ad8b4d56$export$3133b3144bbba267)(e);
        }
        return this.ut = a, (0, $c6fa3a35ad8b4d56$export$ea70d9dd5965b1c8)(s, v), $e4c6f5c4fa111bdf$export$9c068ae9cc5db4e8;
    }
});






var $eUQW6 = parcelRequire("eUQW6");

parcelRequire("8J3FQ");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d9eb8308456aef2d$export$da64fc29f17f9d0e = (e)=>(n)=>"function" == typeof n ? ((e, n)=>(customElements.define(e, n), n))(e, n) : ((e, n)=>{
            const { kind: t, elements: s } = n;
            return {
                kind: t,
                elements: s,
                finisher (n) {
                    customElements.define(e, n);
                }
            };
        })(e, n);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8bff56f1ba1816d2$var$i = (i, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? {
        ...e,
        finisher (n) {
            n.createProperty(e.key, i);
        }
    } : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (n) {
            n.createProperty(e.key, i);
        }
    }, $8bff56f1ba1816d2$var$e = (i, e, n)=>{
    e.constructor.createProperty(n, i);
};
function $8bff56f1ba1816d2$export$d541bacb2bda4494(n) {
    return (t, o)=>void 0 !== o ? $8bff56f1ba1816d2$var$e(n, t, o) : $8bff56f1ba1816d2$var$i(n, t);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $712e48cf2c532416$export$ca000e230c0caa3e(t) {
    return (0, $8bff56f1ba1816d2$export$d541bacb2bda4494)({
        ...t,
        state: !0
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $80047f253c6c3efe$export$29fd0ed4087278b5 = (e, t, o)=>{
    Object.defineProperty(t, o, e);
}, $80047f253c6c3efe$export$18eb0154d0069a01 = (e, t)=>({
        kind: "method",
        placement: "prototype",
        key: t.key,
        descriptor: e
    }), $80047f253c6c3efe$export$757d561a932dc1cb = ({ finisher: e, descriptor: t })=>(o, n)=>{
        var r;
        if (void 0 === n) {
            const n = null !== (r = o.originalKey) && void 0 !== r ? r : o.key, i = null != t ? {
                kind: "method",
                placement: "prototype",
                key: n,
                descriptor: t(o.key)
            } : {
                ...o,
                key: n
            };
            return null != e && (i.finisher = function(t) {
                e(t, n);
            }), i;
        }
        {
            const r = o.constructor;
            void 0 !== t && Object.defineProperty(o, n, t(n)), null == e || e(r, n);
        }
    };


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $b857d0e6653d994d$export$b2b799818fbabcf3(e) {
    return (0, $80047f253c6c3efe$export$757d561a932dc1cb)({
        finisher: (r, t)=>{
            Object.assign(r.prototype[t], e);
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $eb97c8ed7ec12660$export$2fa187e846a241c4(i, n) {
    return (0, $80047f253c6c3efe$export$757d561a932dc1cb)({
        descriptor: (o)=>{
            const t = {
                get () {
                    var o, n;
                    return null !== (n = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== n ? n : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (n) {
                const n = "symbol" == typeof o ? Symbol() : "__" + o;
                t.get = function() {
                    var o, t;
                    return void 0 === this[n] && (this[n] = null !== (t = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(i)) && void 0 !== t ? t : null), this[n];
                };
            }
            return t;
        }
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e1809b2c9d48124e$export$dcd0d083aa86c355(e) {
    return (0, $80047f253c6c3efe$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                get () {
                    var r, o;
                    return null !== (o = null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelectorAll(e)) && void 0 !== o ? o : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $6af9860648364a46$export$163dfc35cc43f240(e) {
    return (0, $80047f253c6c3efe$export$757d561a932dc1cb)({
        descriptor: (r)=>({
                async get () {
                    var r;
                    return await this.updateComplete, null === (r = this.renderRoot) || void 0 === r ? void 0 : r.querySelector(e);
                },
                enumerable: !0,
                configurable: !0
            })
    });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $38833a659996479b$var$n;
const $38833a659996479b$var$e = null != (null === ($38833a659996479b$var$n = window.HTMLSlotElement) || void 0 === $38833a659996479b$var$n ? void 0 : $38833a659996479b$var$n.prototype.assignedElements) ? (o, n)=>o.assignedElements(n) : (o, n)=>o.assignedNodes(n).filter((o)=>o.nodeType === Node.ELEMENT_NODE);
function $38833a659996479b$export$4682af2d9ee91415(n) {
    const { slot: l, selector: t } = null != n ? n : {};
    return (0, $80047f253c6c3efe$export$757d561a932dc1cb)({
        descriptor: (o)=>({
                get () {
                    var o;
                    const r = "slot" + (l ? `[name=${l}]` : ":not([name])"), i = null === (o = this.renderRoot) || void 0 === o ? void 0 : o.querySelector(r), s = null != i ? $38833a659996479b$var$e(i, n) : [];
                    return t ? s.filter((o)=>o.matches(t)) : s;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $83020ea3bf298e59$export$1bdbe53f9df1b8(o, n, r) {
    let l, s = o;
    return "object" == typeof o ? (s = o.slot, l = o) : l = {
        flatten: n
    }, r ? (0, $38833a659996479b$export$4682af2d9ee91415)({
        slot: s,
        flatten: n,
        selector: r
    }) : (0, $80047f253c6c3efe$export$757d561a932dc1cb)({
        descriptor: (e)=>({
                get () {
                    var e, t;
                    const o = "slot" + (s ? `[name=${s}]` : ":not([name])"), n = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(o);
                    return null !== (t = null == n ? void 0 : n.assignedNodes(l)) && void 0 !== t ? t : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}




/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");
parcelRequire("aX7Bm");

var $bAdyM = parcelRequire("bAdyM");

var $2qnKN = parcelRequire("2qnKN");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f866afac225ddabb$var$t = window, $f866afac225ddabb$export$b4d10f6001c083c2 = $f866afac225ddabb$var$t.ShadowRoot && (void 0 === $f866afac225ddabb$var$t.ShadyCSS || $f866afac225ddabb$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $f866afac225ddabb$var$s = Symbol(), $f866afac225ddabb$var$n = new WeakMap;
class $f866afac225ddabb$export$505d1e8739bad805 {
    constructor(t, e, n){
        if (this._$cssResult$ = !0, n !== $f866afac225ddabb$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($f866afac225ddabb$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $f866afac225ddabb$var$n.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $f866afac225ddabb$var$n.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $f866afac225ddabb$export$8d80f9cac07cdb3 = (t)=>new $f866afac225ddabb$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $f866afac225ddabb$var$s), $f866afac225ddabb$export$dbf350e5966cf602 = (t, ...e)=>{
    const n = 1 === t.length ? t[0] : e.reduce((e, s, n)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[n + 1], t[0]);
    return new $f866afac225ddabb$export$505d1e8739bad805(n, t, $f866afac225ddabb$var$s);
}, $f866afac225ddabb$export$2ca4a66ec4cecb90 = (s, n)=>{
    $f866afac225ddabb$export$b4d10f6001c083c2 ? s.adoptedStyleSheets = n.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : n.forEach((e)=>{
        const n = document.createElement("style"), o = $f866afac225ddabb$var$t.litNonce;
        void 0 !== o && n.setAttribute("nonce", o), n.textContent = e.cssText, s.appendChild(n);
    });
}, $f866afac225ddabb$export$ee69dfd951e24778 = $f866afac225ddabb$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $f866afac225ddabb$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $2874bab787b9de40$var$s;
const $2874bab787b9de40$var$e = window, $2874bab787b9de40$var$r = $2874bab787b9de40$var$e.trustedTypes, $2874bab787b9de40$var$h = $2874bab787b9de40$var$r ? $2874bab787b9de40$var$r.emptyScript : "", $2874bab787b9de40$var$o = $2874bab787b9de40$var$e.reactiveElementPolyfillSupport, $2874bab787b9de40$export$7312b35fbf521afb = {
    toAttribute (t, i) {
        switch(i){
            case Boolean:
                t = t ? $2874bab787b9de40$var$h : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, i) {
        let s = t;
        switch(i){
            case Boolean:
                s = null !== t;
                break;
            case Number:
                s = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    s = JSON.parse(t);
                } catch (t) {
                    s = null;
                }
        }
        return s;
    }
}, $2874bab787b9de40$export$53a6892c50694894 = (t, i)=>i !== t && (i == i || t == t), $2874bab787b9de40$var$l = {
    attribute: !0,
    type: String,
    converter: $2874bab787b9de40$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $2874bab787b9de40$export$53a6892c50694894
}, $2874bab787b9de40$var$d = "finalized";
class $2874bab787b9de40$export$c7c07a37856565d extends HTMLElement {
    constructor(){
        super(), this._$Ei = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this._$Eu();
    }
    static addInitializer(t) {
        var i;
        this.finalize(), (null !== (i = this.h) && void 0 !== i ? i : this.h = []).push(t);
    }
    static get observedAttributes() {
        this.finalize();
        const t = [];
        return this.elementProperties.forEach((i, s)=>{
            const e = this._$Ep(s, i);
            void 0 !== e && (this._$Ev.set(e, s), t.push(e));
        }), t;
    }
    static createProperty(t, i = $2874bab787b9de40$var$l) {
        if (i.state && (i.attribute = !1), this.finalize(), this.elementProperties.set(t, i), !i.noAccessor && !this.prototype.hasOwnProperty(t)) {
            const s = "symbol" == typeof t ? Symbol() : "__" + t, e = this.getPropertyDescriptor(t, s, i);
            void 0 !== e && Object.defineProperty(this.prototype, t, e);
        }
    }
    static getPropertyDescriptor(t, i, s) {
        return {
            get () {
                return this[i];
            },
            set (e) {
                const r = this[t];
                this[i] = e, this.requestUpdate(t, r, s);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || $2874bab787b9de40$var$l;
    }
    static finalize() {
        if (this.hasOwnProperty($2874bab787b9de40$var$d)) return !1;
        this[$2874bab787b9de40$var$d] = !0;
        const t = Object.getPrototypeOf(this);
        if (t.finalize(), void 0 !== t.h && (this.h = [
            ...t.h
        ]), this.elementProperties = new Map(t.elementProperties), this._$Ev = new Map, this.hasOwnProperty("properties")) {
            const t = this.properties, i = [
                ...Object.getOwnPropertyNames(t),
                ...Object.getOwnPropertySymbols(t)
            ];
            for (const s of i)this.createProperty(s, t[s]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(i) {
        const s = [];
        if (Array.isArray(i)) {
            const e = new Set(i.flat(1 / 0).reverse());
            for (const i of e)s.unshift((0, $f866afac225ddabb$export$ee69dfd951e24778)(i));
        } else void 0 !== i && s.push((0, $f866afac225ddabb$export$ee69dfd951e24778)(i));
        return s;
    }
    static _$Ep(t, i) {
        const s = i.attribute;
        return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    _$Eu() {
        var t;
        this._$E_ = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Eg(), this.requestUpdate(), null === (t = this.constructor.h) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var i, s;
        (null !== (i = this._$ES) && void 0 !== i ? i : this._$ES = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (s = t.hostConnected) || void 0 === s || s.call(t));
    }
    removeController(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.splice(this._$ES.indexOf(t) >>> 0, 1);
    }
    _$Eg() {
        this.constructor.elementProperties.forEach((t, i)=>{
            this.hasOwnProperty(i) && (this._$Ei.set(i, this[i]), delete this[i]);
        });
    }
    createRenderRoot() {
        var t;
        const s = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $f866afac225ddabb$export$2ca4a66ec4cecb90)(s, this.constructor.elementStyles), s;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostConnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
            var i;
            return null === (i = t.hostDisconnected) || void 0 === i ? void 0 : i.call(t);
        });
    }
    attributeChangedCallback(t, i, s) {
        this._$AK(t, s);
    }
    _$EO(t, i, s = $2874bab787b9de40$var$l) {
        var e;
        const r = this.constructor._$Ep(t, s);
        if (void 0 !== r && !0 === s.reflect) {
            const h = (void 0 !== (null === (e = s.converter) || void 0 === e ? void 0 : e.toAttribute) ? s.converter : $2874bab787b9de40$export$7312b35fbf521afb).toAttribute(i, s.type);
            this._$El = t, null == h ? this.removeAttribute(r) : this.setAttribute(r, h), this._$El = null;
        }
    }
    _$AK(t, i) {
        var s;
        const e = this.constructor, r = e._$Ev.get(t);
        if (void 0 !== r && this._$El !== r) {
            const t = e.getPropertyOptions(r), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== (null === (s = t.converter) || void 0 === s ? void 0 : s.fromAttribute) ? t.converter : $2874bab787b9de40$export$7312b35fbf521afb;
            this._$El = r, this[r] = h.fromAttribute(i, t.type), this._$El = null;
        }
    }
    requestUpdate(t, i, s) {
        let e = !0;
        void 0 !== t && (((s = s || this.constructor.getPropertyOptions(t)).hasChanged || $2874bab787b9de40$export$53a6892c50694894)(this[t], i) ? (this._$AL.has(t) || this._$AL.set(t, i), !0 === s.reflect && this._$El !== t && (void 0 === this._$EC && (this._$EC = new Map), this._$EC.set(t, s))) : e = !1), !this.isUpdatePending && e && (this._$E_ = this._$Ej());
    }
    async _$Ej() {
        this.isUpdatePending = !0;
        try {
            await this._$E_;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (!this.isUpdatePending) return;
        this.hasUpdated, this._$Ei && (this._$Ei.forEach((t, i)=>this[i] = t), this._$Ei = void 0);
        let i = !1;
        const s = this._$AL;
        try {
            i = this.shouldUpdate(s), i ? (this.willUpdate(s), null === (t = this._$ES) || void 0 === t || t.forEach((t)=>{
                var i;
                return null === (i = t.hostUpdate) || void 0 === i ? void 0 : i.call(t);
            }), this.update(s)) : this._$Ek();
        } catch (t) {
            throw i = !1, this._$Ek(), t;
        }
        i && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        var i;
        null === (i = this._$ES) || void 0 === i || i.forEach((t)=>{
            var i;
            return null === (i = t.hostUpdated) || void 0 === i ? void 0 : i.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$Ek() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$E_;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$EC && (this._$EC.forEach((t, i)=>this._$EO(i, this[i], t)), this._$EC = void 0), this._$Ek();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$2874bab787b9de40$export$c7c07a37856565d[$2874bab787b9de40$var$d] = !0, $2874bab787b9de40$export$c7c07a37856565d.elementProperties = new Map, $2874bab787b9de40$export$c7c07a37856565d.elementStyles = [], $2874bab787b9de40$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, null == $2874bab787b9de40$var$o || $2874bab787b9de40$var$o({
    ReactiveElement: $2874bab787b9de40$export$c7c07a37856565d
}), (null !== ($2874bab787b9de40$var$s = $2874bab787b9de40$var$e.reactiveElementVersions) && void 0 !== $2874bab787b9de40$var$s ? $2874bab787b9de40$var$s : $2874bab787b9de40$var$e.reactiveElementVersions = []).push("1.6.3");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $14985d1c21e2be0d$var$t;
const $14985d1c21e2be0d$var$i = window, $14985d1c21e2be0d$var$s = $14985d1c21e2be0d$var$i.trustedTypes, $14985d1c21e2be0d$var$e = $14985d1c21e2be0d$var$s ? $14985d1c21e2be0d$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $14985d1c21e2be0d$var$o = "$lit$", $14985d1c21e2be0d$var$n = `lit$${(Math.random() + "").slice(9)}$`, $14985d1c21e2be0d$var$l = "?" + $14985d1c21e2be0d$var$n, $14985d1c21e2be0d$var$h = `<${$14985d1c21e2be0d$var$l}>`, $14985d1c21e2be0d$var$r = document, $14985d1c21e2be0d$var$u = ()=>$14985d1c21e2be0d$var$r.createComment(""), $14985d1c21e2be0d$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $14985d1c21e2be0d$var$c = Array.isArray, $14985d1c21e2be0d$var$v = (t)=>$14985d1c21e2be0d$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $14985d1c21e2be0d$var$a = "[ \t\n\f\r]", $14985d1c21e2be0d$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $14985d1c21e2be0d$var$_ = /-->/g, $14985d1c21e2be0d$var$m = />/g, $14985d1c21e2be0d$var$p = RegExp(`>|${$14985d1c21e2be0d$var$a}(?:([^\\s"'>=/]+)(${$14985d1c21e2be0d$var$a}*=${$14985d1c21e2be0d$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $14985d1c21e2be0d$var$g = /'/g, $14985d1c21e2be0d$var$$ = /"/g, $14985d1c21e2be0d$var$y = /^(?:script|style|textarea|title)$/i, $14985d1c21e2be0d$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $14985d1c21e2be0d$export$c0bb0b647f701bb5 = $14985d1c21e2be0d$var$w(1), $14985d1c21e2be0d$export$7ed1367e7fa1ad68 = $14985d1c21e2be0d$var$w(2), $14985d1c21e2be0d$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $14985d1c21e2be0d$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $14985d1c21e2be0d$var$E = new WeakMap, $14985d1c21e2be0d$var$C = $14985d1c21e2be0d$var$r.createTreeWalker($14985d1c21e2be0d$var$r, 129, null, !1);
function $14985d1c21e2be0d$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $14985d1c21e2be0d$var$e ? $14985d1c21e2be0d$var$e.createHTML(i) : i;
}
const $14985d1c21e2be0d$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $14985d1c21e2be0d$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $14985d1c21e2be0d$var$f ? "!--" === c[1] ? u = $14985d1c21e2be0d$var$_ : void 0 !== c[1] ? u = $14985d1c21e2be0d$var$m : void 0 !== c[2] ? ($14985d1c21e2be0d$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $14985d1c21e2be0d$var$p) : void 0 !== c[3] && (u = $14985d1c21e2be0d$var$p) : u === $14985d1c21e2be0d$var$p ? ">" === c[0] ? (u = null != l ? l : $14985d1c21e2be0d$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $14985d1c21e2be0d$var$p : '"' === c[3] ? $14985d1c21e2be0d$var$$ : $14985d1c21e2be0d$var$g) : u === $14985d1c21e2be0d$var$$ || u === $14985d1c21e2be0d$var$g ? u = $14985d1c21e2be0d$var$p : u === $14985d1c21e2be0d$var$_ || u === $14985d1c21e2be0d$var$m ? u = $14985d1c21e2be0d$var$f : (u = $14985d1c21e2be0d$var$p, l = void 0);
        const w = u === $14985d1c21e2be0d$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $14985d1c21e2be0d$var$f ? s + $14985d1c21e2be0d$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $14985d1c21e2be0d$var$o + s.slice(v) + $14985d1c21e2be0d$var$n + w) : s + $14985d1c21e2be0d$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $14985d1c21e2be0d$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $14985d1c21e2be0d$var$N {
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $14985d1c21e2be0d$var$V(t, i);
        if (this.el = $14985d1c21e2be0d$var$N.createElement(a, e), $14985d1c21e2be0d$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $14985d1c21e2be0d$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($14985d1c21e2be0d$var$o) || i.startsWith($14985d1c21e2be0d$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $14985d1c21e2be0d$var$o).split($14985d1c21e2be0d$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $14985d1c21e2be0d$var$H : "?" === i[1] ? $14985d1c21e2be0d$var$L : "@" === i[1] ? $14985d1c21e2be0d$var$z : $14985d1c21e2be0d$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($14985d1c21e2be0d$var$y.test(h.tagName)) {
                    const t = h.textContent.split($14985d1c21e2be0d$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $14985d1c21e2be0d$var$s ? $14985d1c21e2be0d$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $14985d1c21e2be0d$var$u()), $14985d1c21e2be0d$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $14985d1c21e2be0d$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $14985d1c21e2be0d$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($14985d1c21e2be0d$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $14985d1c21e2be0d$var$n.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $14985d1c21e2be0d$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $14985d1c21e2be0d$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $14985d1c21e2be0d$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $14985d1c21e2be0d$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $14985d1c21e2be0d$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $14985d1c21e2be0d$var$M {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $14985d1c21e2be0d$var$r).importNode(s, !0);
        $14985d1c21e2be0d$var$C.currentNode = o;
        let n = $14985d1c21e2be0d$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $14985d1c21e2be0d$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $14985d1c21e2be0d$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $14985d1c21e2be0d$var$C.nextNode(), l++);
        }
        return $14985d1c21e2be0d$var$C.currentNode = $14985d1c21e2be0d$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $14985d1c21e2be0d$var$R {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $14985d1c21e2be0d$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $14985d1c21e2be0d$var$S(this, t, i), $14985d1c21e2be0d$var$d(t) ? t === $14985d1c21e2be0d$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $14985d1c21e2be0d$export$45b790e32b2810ee && this._$AR(), this._$AH = $14985d1c21e2be0d$export$45b790e32b2810ee) : t !== this._$AH && t !== $14985d1c21e2be0d$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $14985d1c21e2be0d$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $14985d1c21e2be0d$export$45b790e32b2810ee && $14985d1c21e2be0d$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($14985d1c21e2be0d$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $14985d1c21e2be0d$var$N.createElement($14985d1c21e2be0d$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $14985d1c21e2be0d$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $14985d1c21e2be0d$var$E.get(t.strings);
        return void 0 === i && $14985d1c21e2be0d$var$E.set(t.strings, i = new $14985d1c21e2be0d$var$N(t)), i;
    }
    T(t) {
        $14985d1c21e2be0d$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $14985d1c21e2be0d$var$R(this.k($14985d1c21e2be0d$var$u()), this.k($14985d1c21e2be0d$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $14985d1c21e2be0d$var$k {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $14985d1c21e2be0d$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $14985d1c21e2be0d$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $14985d1c21e2be0d$var$S(this, t, i, 0), n = !$14985d1c21e2be0d$var$d(t) || t !== this._$AH && t !== $14985d1c21e2be0d$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $14985d1c21e2be0d$var$S(this, e[s + l], i, l), h === $14985d1c21e2be0d$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$14985d1c21e2be0d$var$d(h) || h !== this._$AH[l]), h === $14985d1c21e2be0d$export$45b790e32b2810ee ? t = $14985d1c21e2be0d$export$45b790e32b2810ee : t !== $14985d1c21e2be0d$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $14985d1c21e2be0d$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $14985d1c21e2be0d$var$H extends $14985d1c21e2be0d$var$k {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $14985d1c21e2be0d$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $14985d1c21e2be0d$var$I = $14985d1c21e2be0d$var$s ? $14985d1c21e2be0d$var$s.emptyScript : "";
class $14985d1c21e2be0d$var$L extends $14985d1c21e2be0d$var$k {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        t && t !== $14985d1c21e2be0d$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $14985d1c21e2be0d$var$I) : this.element.removeAttribute(this.name);
    }
}
class $14985d1c21e2be0d$var$z extends $14985d1c21e2be0d$var$k {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $14985d1c21e2be0d$var$S(this, t, i, 0)) && void 0 !== s ? s : $14985d1c21e2be0d$export$45b790e32b2810ee) === $14985d1c21e2be0d$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $14985d1c21e2be0d$export$45b790e32b2810ee && e !== $14985d1c21e2be0d$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $14985d1c21e2be0d$export$45b790e32b2810ee && (e === $14985d1c21e2be0d$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $14985d1c21e2be0d$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $14985d1c21e2be0d$var$S(this, t);
    }
}
const $14985d1c21e2be0d$export$8613d1ca9052b22e = {
    O: $14985d1c21e2be0d$var$o,
    P: $14985d1c21e2be0d$var$n,
    A: $14985d1c21e2be0d$var$l,
    C: 1,
    M: $14985d1c21e2be0d$var$V,
    L: $14985d1c21e2be0d$var$M,
    R: $14985d1c21e2be0d$var$v,
    D: $14985d1c21e2be0d$var$S,
    I: $14985d1c21e2be0d$var$R,
    V: $14985d1c21e2be0d$var$k,
    H: $14985d1c21e2be0d$var$L,
    N: $14985d1c21e2be0d$var$z,
    U: $14985d1c21e2be0d$var$H,
    F: $14985d1c21e2be0d$var$Z
}, $14985d1c21e2be0d$var$B = $14985d1c21e2be0d$var$i.litHtmlPolyfillSupport;
null == $14985d1c21e2be0d$var$B || $14985d1c21e2be0d$var$B($14985d1c21e2be0d$var$N, $14985d1c21e2be0d$var$R), (null !== ($14985d1c21e2be0d$var$t = $14985d1c21e2be0d$var$i.litHtmlVersions) && void 0 !== $14985d1c21e2be0d$var$t ? $14985d1c21e2be0d$var$t : $14985d1c21e2be0d$var$i.litHtmlVersions = []).push("2.8.0");
const $14985d1c21e2be0d$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $14985d1c21e2be0d$var$R(i.insertBefore($14985d1c21e2be0d$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $c559695556562f8d$var$l, $c559695556562f8d$var$o;
const $c559695556562f8d$export$8bf27daf9e8907c9 = (0, $2874bab787b9de40$export$c7c07a37856565d);
class $c559695556562f8d$export$3f2f9f5909897157 extends (0, $2874bab787b9de40$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        var t, e;
        const i = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $14985d1c21e2be0d$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return 0, $14985d1c21e2be0d$export$9c068ae9cc5db4e8;
    }
}
$c559695556562f8d$export$3f2f9f5909897157.finalized = !0, $c559695556562f8d$export$3f2f9f5909897157._$litElement$ = !0, null === ($c559695556562f8d$var$l = globalThis.litElementHydrateSupport) || void 0 === $c559695556562f8d$var$l || $c559695556562f8d$var$l.call(globalThis, {
    LitElement: $c559695556562f8d$export$3f2f9f5909897157
});
const $c559695556562f8d$var$n = globalThis.litElementPolyfillSupport;
null == $c559695556562f8d$var$n || $c559695556562f8d$var$n({
    LitElement: $c559695556562f8d$export$3f2f9f5909897157
});
const $c559695556562f8d$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(null !== ($c559695556562f8d$var$o = globalThis.litElementVersions) && void 0 !== $c559695556562f8d$var$o ? $c559695556562f8d$var$o : globalThis.litElementVersions = []).push("3.3.3");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $5e77d7e50dfb9c6e$export$6acf61af03e62db = !1;






/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9ce4c47ae508b77f$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $14985d1c21e2be0d$export$45b790e32b2810ee);




class $1f3baa207bb75ef6$export$50065871be0e3c7e extends (0, $c559695556562f8d$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.icon = '';
        this.shouldRenderRipple = false;
        this.rippleHandlers = new (0, $2qnKN.RippleHandlers)(()=>{
            this.shouldRenderRipple = true;
            return this.ripple;
        });
    }
    /** @soyTemplate */ renderRipple() {
        return this.shouldRenderRipple ? (0, $14985d1c21e2be0d$export$c0bb0b647f701bb5)`
            <mwc-ripple
                .disabled="${this.disabled}"
                unbounded>
            </mwc-ripple>` : '';
    }
    focus() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.startFocus();
            buttonElement.focus();
        }
    }
    blur() {
        const buttonElement = this.buttonElement;
        if (buttonElement) {
            this.rippleHandlers.endFocus();
            buttonElement.blur();
        }
    }
    /** @soyTemplate */ render() {
        return (0, $14985d1c21e2be0d$export$c0bb0b647f701bb5)`<button
        class="mdc-icon-button mdc-icon-button--display-flex"
        aria-label="${this.ariaLabel || this.icon}"
        aria-haspopup="${(0, $9ce4c47ae508b77f$export$f68dd208b5df064d)(this.ariaHasPopup)}"
        ?disabled="${this.disabled}"
        @focus="${this.handleRippleFocus}"
        @blur="${this.handleRippleBlur}"
        @mousedown="${this.handleRippleMouseDown}"
        @mouseenter="${this.handleRippleMouseEnter}"
        @mouseleave="${this.handleRippleMouseLeave}"
        @touchstart="${this.handleRippleTouchStart}"
        @touchend="${this.handleRippleDeactivate}"
        @touchcancel="${this.handleRippleDeactivate}"
    >${this.renderRipple()}
    ${this.icon ? (0, $14985d1c21e2be0d$export$c0bb0b647f701bb5)`<i class="material-icons">${this.icon}</i>` : ''}
    <span
      ><slot></slot
    ></span>
  </button>`;
    }
    handleRippleMouseDown(event) {
        const onUp = ()=>{
            window.removeEventListener('mouseup', onUp);
            this.handleRippleDeactivate();
        };
        window.addEventListener('mouseup', onUp);
        this.rippleHandlers.startPress(event);
    }
    handleRippleTouchStart(event) {
        this.rippleHandlers.startPress(event);
    }
    handleRippleDeactivate() {
        this.rippleHandlers.endPress();
    }
    handleRippleMouseEnter() {
        this.rippleHandlers.startHover();
    }
    handleRippleMouseLeave() {
        this.rippleHandlers.endHover();
    }
    handleRippleFocus() {
        this.rippleHandlers.startFocus();
    }
    handleRippleBlur() {
        this.rippleHandlers.endFocus();
    }
}
(0, $czHfO.__decorate)([
    (0, $8bff56f1ba1816d2$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "disabled", void 0);
(0, $czHfO.__decorate)([
    (0, $8bff56f1ba1816d2$export$d541bacb2bda4494)({
        type: String
    })
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "icon", void 0);
(0, $czHfO.__decorate)([
    (0, $bAdyM.ariaProperty),
    (0, $8bff56f1ba1816d2$export$d541bacb2bda4494)({
        type: String,
        attribute: 'aria-label'
    })
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "ariaLabel", void 0);
(0, $czHfO.__decorate)([
    (0, $bAdyM.ariaProperty),
    (0, $8bff56f1ba1816d2$export$d541bacb2bda4494)({
        type: String,
        attribute: 'aria-haspopup'
    })
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "ariaHasPopup", void 0);
(0, $czHfO.__decorate)([
    (0, $eb97c8ed7ec12660$export$2fa187e846a241c4)('button')
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "buttonElement", void 0);
(0, $czHfO.__decorate)([
    (0, $6af9860648364a46$export$163dfc35cc43f240)('mwc-ripple')
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "ripple", void 0);
(0, $czHfO.__decorate)([
    (0, $712e48cf2c532416$export$ca000e230c0caa3e)()
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "shouldRenderRipple", void 0);
(0, $czHfO.__decorate)([
    (0, $b857d0e6653d994d$export$b2b799818fbabcf3)({
        passive: true
    })
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "handleRippleMouseDown", null);
(0, $czHfO.__decorate)([
    (0, $b857d0e6653d994d$export$b2b799818fbabcf3)({
        passive: true
    })
], $1f3baa207bb75ef6$export$50065871be0e3c7e.prototype, "handleRippleTouchStart", null);


/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */ 
const $9b65678292e6bedb$export$9dd6ff9ea0189349 = (0, $f866afac225ddabb$export$dbf350e5966cf602)`.material-icons{font-family:var(--mdc-icon-font, "Material Icons");font-weight:normal;font-style:normal;font-size:var(--mdc-icon-size, 24px);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:"liga"}.mdc-icon-button{font-size:24px;width:48px;height:48px;padding:12px}.mdc-icon-button .mdc-icon-button__focus-ring{display:none}.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{display:block;max-height:48px;max-width:48px}@media screen and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{pointer-events:none;border:2px solid transparent;border-radius:6px;box-sizing:content-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{border-color:CanvasText}}@media screen and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{content:"";border:2px solid transparent;border-radius:8px;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:calc(100% + 4px);width:calc(100% + 4px)}}@media screen and (forced-colors: active)and (forced-colors: active){.mdc-icon-button.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring::after,.mdc-icon-button:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring::after{border-color:CanvasText}}.mdc-icon-button.mdc-icon-button--reduced-size .mdc-icon-button__ripple{width:40px;height:40px;margin-top:4px;margin-bottom:4px;margin-right:4px;margin-left:4px}.mdc-icon-button.mdc-icon-button--reduced-size.mdc-ripple-upgraded--background-focused .mdc-icon-button__focus-ring,.mdc-icon-button.mdc-icon-button--reduced-size:not(.mdc-ripple-upgraded):focus .mdc-icon-button__focus-ring{max-height:40px;max-width:40px}.mdc-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:48px;left:50%;width:48px;transform:translate(-50%, -50%)}.mdc-icon-button:disabled{color:rgba(0, 0, 0, 0.38);color:var(--mdc-theme-text-disabled-on-light, rgba(0, 0, 0, 0.38))}.mdc-icon-button svg,.mdc-icon-button img{width:24px;height:24px}.mdc-icon-button{display:inline-block;position:relative;box-sizing:border-box;border:none;outline:none;background-color:transparent;fill:currentColor;color:inherit;text-decoration:none;cursor:pointer;user-select:none;z-index:0;overflow:visible}.mdc-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:48px;left:50%;width:48px;transform:translate(-50%, -50%)}.mdc-icon-button:disabled{cursor:default;pointer-events:none}.mdc-icon-button--display-flex{align-items:center;display:inline-flex;justify-content:center}.mdc-icon-button__icon{display:inline-block}.mdc-icon-button__icon.mdc-icon-button__icon--on{display:none}.mdc-icon-button--on .mdc-icon-button__icon{display:none}.mdc-icon-button--on .mdc-icon-button__icon.mdc-icon-button__icon--on{display:inline-block}.mdc-icon-button__link{height:100%;left:0;outline:none;position:absolute;top:0;width:100%}.mdc-icon-button{display:inline-block;position:relative;box-sizing:border-box;border:none;outline:none;background-color:transparent;fill:currentColor;color:inherit;text-decoration:none;cursor:pointer;user-select:none;z-index:0;overflow:visible}.mdc-icon-button .mdc-icon-button__touch{position:absolute;top:50%;height:48px;left:50%;width:48px;transform:translate(-50%, -50%)}.mdc-icon-button:disabled{cursor:default;pointer-events:none}.mdc-icon-button--display-flex{align-items:center;display:inline-flex;justify-content:center}.mdc-icon-button__icon{display:inline-block}.mdc-icon-button__icon.mdc-icon-button__icon--on{display:none}.mdc-icon-button--on .mdc-icon-button__icon{display:none}.mdc-icon-button--on .mdc-icon-button__icon.mdc-icon-button__icon--on{display:inline-block}.mdc-icon-button__link{height:100%;left:0;outline:none;position:absolute;top:0;width:100%}:host{display:inline-block;outline:none}:host([disabled]){pointer-events:none}.mdc-icon-button i,.mdc-icon-button svg,.mdc-icon-button img,.mdc-icon-button ::slotted(*){display:block}:host{--mdc-ripple-color: currentcolor;-webkit-tap-highlight-color:transparent}:host,.mdc-icon-button{vertical-align:top}.mdc-icon-button{width:var(--mdc-icon-button-size, 48px);height:var(--mdc-icon-button-size, 48px);padding:calc( (var(--mdc-icon-button-size, 48px) - var(--mdc-icon-size, 24px)) / 2 )}.mdc-icon-button i,.mdc-icon-button svg,.mdc-icon-button img,.mdc-icon-button ::slotted(*){display:block;width:var(--mdc-icon-size, 24px);height:var(--mdc-icon-size, 24px)}`;


/** @soyCompatible */ let $c18cbb17c5797ffb$export$c25acd513dcc8062 = class IconButton extends (0, $1f3baa207bb75ef6$export$50065871be0e3c7e) {
};
$c18cbb17c5797ffb$export$c25acd513dcc8062.styles = [
    (0, $9b65678292e6bedb$export$9dd6ff9ea0189349)
];
$c18cbb17c5797ffb$export$c25acd513dcc8062 = (0, $czHfO.__decorate)([
    (0, $d9eb8308456aef2d$export$da64fc29f17f9d0e)('mwc-icon-button')
], $c18cbb17c5797ffb$export$c25acd513dcc8062);



class $d88dd2232853ef2e$export$33b107562567fc47 extends (0, $9cd293958617bb59$export$3f2f9f5909897157) {
    static{
        this.styles = (0, $f57b1293e9d8fdf8$export$dbf350e5966cf602)`
    .mdc-card > div {
      margin: 0px 12px 0 12px;
    }

    .mdc-card__actions {
      display: flex;
      align-items: center;
      margin-top: 12px;
      gap: 12px;
    }

    .mdc-data-table {
      width: 100%;
    }
  `;
    }
    // Computed property for sorted review requests (FIFO - oldest first)
    get sortedReviewRequests() {
        return [
            ...this.reviewRequests
        ].sort((a, b)=>{
            // Sort by createTime ascending (oldest first = longest duration first)
            return a.createTime.getTime() - b.createTime.getTime();
        });
    }
    constructor(){
        super(), this.reviewRequests = [];
    }
    render() {
        return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
      <link
        href="https://unpkg.com/material-components-web@latest/dist/material-components-web.min.css"
        rel="stylesheet"
      />
      <div class="mdc-card">
        <div class="card-header">
          <div class="card-title">
            <h2 class="mdc-typography--headline6">Arbeitsstapel</h2>
          </div>
        </div>
        <div class="card-body mdc-typography--body2">
          <div class="mdc-data-table">
            <div class="mdc-data-table__table-container">
              <table class="mdc-data-table__table">
                <thead>
                  <tr class="mdc-data-table__header-row">
                    <th
                        class="mdc-data-table__header-cell"
                        role="columnheader"
                        scope="col"
                    >
                      GB
                    </th>
                    <th
                        class="mdc-data-table__header-cell"
                        role="columnheader"
                        scope="col"
                    >
                      Sendung
                    </th>
                    <th
                        class="mdc-data-table__header-cell"
                        role="columnheader"
                        scope="col"
                    >
                      Dokument
                    </th>
                    <th
                        class="mdc-data-table__header-cell"
                        role="columnheader"
                        scope="col"
                    >
                      Eingangskanal
                    </th>
                    <th
                        class="mdc-data-table__header-cell"
                        role="columnheader"
                        scope="col"
                    >
                      Im Arbeitsvorrat seit
                    </th>
                    <th
                        class="mdc-data-table__header-cell"
                        role="columnheader"
                        scope="col"
                    >
                      Zu prüfen
                    </th>
                    <th
                        class="mdc-data-table__header-cell"
                        role="columnheader"
                        scope="col"
                    >
                      Entfernen
                    </th>
                  </tr>
                </thead>
                <tbody class="mdc-data-table__content">
                  ${(0, $4a8aa2cdbf35fab5$export$76d90c956114f2c2)(this.sortedReviewRequests, (reviewRequest)=>reviewRequest.id(), (reviewRequest, _index)=>{
            // Find the original index in the unsorted array for the remove button
            const originalIndex = this.reviewRequests.indexOf(reviewRequest);
            return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                        <tr class="mdc-data-table__row">
                          <td class="mdc-data-table__cell">
                            ${this.getBusinessArea(reviewRequest)}
                          </td>
                          <td class="mdc-data-table__cell">
                            ${this.getEnvelopeId(reviewRequest)}
                          </td>
                          <td class="mdc-data-table__cell">
                            ${this.getDocumentId(reviewRequest)}
                          </td>
                          <td class="mdc-data-table__cell">
                            ${this.getSource(reviewRequest)}
                          </td>
                          <td class="mdc-data-table__cell">
                            ${reviewRequest.getEnqueueDuration()}
                          </td>
                          <td class="mdc-data-table__cell">
                            ${(()=>{
                // Direct mapping for now to test
                if (reviewRequest.queue === 'hitl-classification-business-area') return 'Intelligente Weiche';
                else if (reviewRequest.queue === 'hitl-classification-rb') return 'Dokumentenklassifikation RB';
                else if (reviewRequest.queue === 'hitl-data-extraction-rb') return 'Datenextraktion RB';
                const displayName = (0, $eUQW6.getQueueDisplayName)(reviewRequest.queue);
                console.log('DEBUG queue display - queue:', reviewRequest.queue, 'displayName:', displayName);
                return displayName;
            })()}
                          </td>
                          <td class="mdc-data-table__cell">
                            <mwc-icon-button
                              icon="close"
                              data-index=${originalIndex}
                              @click=${this.removeReviewRequestFromBatch}
                            ></mwc-icon-button>
                          </td>
                        </tr>
                      `;
        })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="mdc-card__actions">
          <mwc-button
            raised
            @click=${this.reviewBatch}
            label="Arbeitsstapel prüfen"
            ?disabled=${this.reviewRequests.length === 0}
          ></mwc-button>
        </div>
      </div>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        // Update the durations every 5 seconds to keep them current (reduced frequency for better performance)
        this._timerID = window.setInterval(()=>{
            this.requestUpdate();
        }, 5000);
    }
    disconnectedCallback() {
        window.clearInterval(this._timerID);
        this._timerID = undefined;
    }
    async getAccessToken(refresh = false) {
        const [accessToken, idToken] = await new Promise((resolve, reject)=>{
            const getAccessToken = new CustomEvent("get-access-token", {
                bubbles: true,
                detail: {
                    refresh: refresh,
                    resolve: resolve,
                    reject: reject
                }
            });
            this.dispatchEvent(getAccessToken);
        });
        return [
            accessToken,
            idToken
        ];
    }
    async removeReviewRequestFromBatch(e) {
        // ensure that the access token gets refreshed if necessary
        await this.getAccessToken(true);
        const indexToRemove = parseInt(e.target.getAttribute("data-index"));
        const reviewRequestToRemove = this.reviewRequests[indexToRemove];
        console.log('Removing review request from batch:', reviewRequestToRemove);
        // Handle task release for different types of review requests
        if (reviewRequestToRemove) {
            if (reviewRequestToRemove instanceof (0, $20e0088800729d63$export$9fee94aa43a40124) && reviewRequestToRemove.extendAckIdWorker) // For PubSub requests: terminate the ack extension worker
            reviewRequestToRemove.extendAckIdWorker.terminate();
            else if (reviewRequestToRemove instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) {
                // For Firestore requests: try to release the task assignment back to available pool
                // But always emit the event and remove from UI even if server release fails
                try {
                    await this.releaseFirestoreTask(reviewRequestToRemove);
                    console.log(`Released Firestore task ${reviewRequestToRemove.taskId} from queue ${reviewRequestToRemove.queue}`);
                } catch (error) {
                    console.warn('Failed to release Firestore task on server (likely permissions issue), but removing from local UI:', error);
                // Continue anyway - the UI should still update even if server release fails
                }
                // Always emit event to trigger queue count update, regardless of server release success
                const queueUpdateEvent = new CustomEvent("task-released", {
                    bubbles: true,
                    detail: {
                        queueName: reviewRequestToRemove.queue,
                        taskId: reviewRequestToRemove.taskId
                    }
                });
                this.dispatchEvent(queueUpdateEvent);
            }
        }
        this.reviewRequests = this.reviewRequests.filter((_, i)=>i !== indexToRemove);
        const reviewRequestUpdatedEvent = new CustomEvent("review-requests-updated", {
            bubbles: true,
            detail: this.reviewRequests
        });
        this.dispatchEvent(reviewRequestUpdatedEvent);
    }
    async reviewBatch() {
        // ensure that the access token gets refreshed if necessary
        const [accessToken, idToken] = await this.getAccessToken(true);
        // Start background preloading of Document AI JSON content for better UX
        this.preloadDocumentAIContent(accessToken);
        const reviewRequestUpdatedEvent = new CustomEvent("batch-review-triggered", {
            bubbles: true,
            detail: this.sortedReviewRequests
        });
        this.dispatchEvent(reviewRequestUpdatedEvent);
    }
    async preloadDocumentAIContent(accessToken) {
        const sortedRequests = this.sortedReviewRequests;
        // Preload Document AI JSON for the first 3 documents in parallel
        // This reduces wait time when user starts reviewing
        const contentPromises = sortedRequests.slice(0, 3).map(async (reviewRequest, index)=>{
            try {
                console.log(`Preloading Document AI content for document ${index + 1}/${Math.min(3, sortedRequests.length)}`);
                // Only preload if content hasn't been cached yet
                if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) && !reviewRequest._preloadedContent) {
                    const content = await reviewRequest.getContent(accessToken);
                    reviewRequest._preloadedContent = content;
                    console.log(`Successfully preloaded content for document ${index + 1}`);
                    return reviewRequest;
                }
                return null;
            } catch (error) {
                console.warn(`Failed to preload content for document ${index + 1}:`, error);
                return null;
            }
        });
        // Parallel image preloading for documents with content
        const imagePromises = sortedRequests.slice(0, 3).map(async (reviewRequest, index)=>{
            try {
                if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) && reviewRequest.pageImageUrls.length > 0) {
                    console.log(`Starting image preloading for document ${index + 1}`);
                    return (0, $20e0088800729d63$export$9ddd7e36c6c46838).preloadImages(reviewRequest.pageImageUrls, accessToken);
                }
                return null;
            } catch (error) {
                console.warn(`Failed to preload images for document ${index + 1}:`, error);
                return null;
            }
        });
        // Execute content and image preloading in parallel for better performance
        Promise.all([
            Promise.allSettled(contentPromises),
            Promise.allSettled(imagePromises)
        ]).then(([contentResults, imageResults])=>{
            const successfulContent = contentResults.filter((r)=>r.status === 'fulfilled').length;
            const successfulImages = imageResults.filter((r)=>r.status === 'fulfilled').length;
            console.log(`Preloading completed: ${successfulContent}/3 content, ${successfulImages}/3 images`);
        }).catch((error)=>{
            console.warn('Document preloading failed:', error);
        });
    }
    getBusinessArea(reviewRequest) {
        if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) {
            // Return cached business area if already computed
            if (reviewRequest._cachedBusinessArea !== undefined) return reviewRequest._cachedBusinessArea;
            // For Firestore, try to get from multiple possible locations
            const businessArea = reviewRequest.data?.business_area || reviewRequest.data?.documentData?.metadata?.business_area || reviewRequest.data?.metadata?.business_area || "-";
            // Cache the result to prevent repeated computation
            reviewRequest._cachedBusinessArea = businessArea;
            return businessArea;
        }
        return reviewRequest.data?.business_area ?? "-";
    }
    getEnvelopeId(reviewRequest) {
        if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) // For Firestore, use envelopeId from the task data
        return reviewRequest.envelopeId || reviewRequest.name || "-";
        return reviewRequest.name.split('/')[0];
    }
    getDocumentId(reviewRequest) {
        if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) {
            // For Firestore, only check for actual document_id values from processed data
            // Do NOT use envelope_id or other fallbacks that aren't real document_ids
            const processedDataDocId = reviewRequest.data?.documentData?.processed_data?.document_id;
            const splittingResultDocId = reviewRequest.data?.documentData?.processed_data?.splittingResult?.[0]?.document_id;
            // Only return actual document_id values, not envelope_id fallbacks
            // For classification tasks before splitting, document_id will be null/undefined, so return "-"
            if (processedDataDocId && processedDataDocId !== null) return processedDataDocId;
            if (splittingResultDocId && splittingResultDocId !== null) return splittingResultDocId;
            // Check if any of the data locations have a real document_id (not envelope_id)
            const dataDocId = reviewRequest.data?.document_id || reviewRequest.data?.documentData?.document_id;
            if (dataDocId && dataDocId !== null && // Make sure it's not an envelope_id by checking it doesn't contain typical envelope patterns
            !dataDocId.includes('_rs-betrieb_') && !dataDocId.includes('scan')) return dataDocId;
            // For classification tasks, there's no document_id yet, so show nothing
            return "-";
        }
        return reviewRequest.data?.document_id ?? "-";
    }
    getSource(reviewRequest) {
        if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) {
            // Return cached source if already computed
            if (reviewRequest._cachedSource !== undefined) return reviewRequest._cachedSource;
            // Debug logging to understand data structure
            console.log('DEBUG getSource - Firestore task data structure:', {
                taskId: reviewRequest.taskId,
                topLevelSource: reviewRequest.data?.source,
                documentDataSource: reviewRequest.data?.documentData?.source,
                processedDataSource: reviewRequest.data?.documentData?.processed_data?.source,
                fullDocumentData: reviewRequest.data?.documentData,
                fullProcessedData: reviewRequest.data?.documentData?.processed_data
            });
            // For Firestore, try multiple possible locations for source information
            const source = reviewRequest.data?.source || reviewRequest.data?.documentData?.processed_data?.source || reviewRequest.data?.documentData?.source || "-";
            console.log('DEBUG getSource - Final source value:', source);
            // Cache the result to prevent repeated computation
            reviewRequest._cachedSource = source;
            return source;
        }
        return reviewRequest.data?.source ?? "-";
    }
    async releaseFirestoreTask(reviewRequest) {
        try {
            const [accessToken, idToken] = await this.getAccessToken(true); // Force refresh to ensure we have valid token
            const collectionName = `hitl_tasks_${reviewRequest.queue}`;
            const taskDocUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/${reviewRequest.taskId}`;
            // First, let's check if the document exists and what its current state is
            console.log(`Checking current state of task ${reviewRequest.taskId} before release...`);
            const getResponse = await fetch(taskDocUrl, {
                headers: {
                    'Authorization': `Bearer ${idToken}`
                }
            });
            if (!getResponse.ok) {
                console.error(`Cannot read task ${reviewRequest.taskId}:`, getResponse.status, getResponse.statusText);
                throw new Error(`Cannot read task before release: ${getResponse.status}`);
            }
            const currentDoc = await getResponse.json();
            console.log(`Current task state:`, {
                status: currentDoc.status,
                assignedTo: currentDoc.assignedTo,
                taskId: reviewRequest.taskId
            });
            const updatePayload = {
                status: 'available',
                assignedTo: null,
                assignedAt: null,
                expiresAt: null
            };
            const updateResponse = await fetch(taskDocUrl, {
                method: 'PATCH',
                headers: {
                    'Authorization': `Bearer ${idToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(updatePayload)
            });
            if (updateResponse.ok) console.log(`Released Firestore task ${reviewRequest.taskId} back to available pool`);
            else {
                // Get the response body for more detailed error information
                const errorBody = await updateResponse.text();
                console.error(`PATCH ${taskDocUrl} failed:`, {
                    status: updateResponse.status,
                    statusText: updateResponse.statusText,
                    body: errorBody,
                    headers: Object.fromEntries(updateResponse.headers.entries())
                });
                throw new Error(`Failed to release task: ${updateResponse.status} ${updateResponse.statusText} - ${errorBody}`);
            }
        } catch (error) {
            console.error('Error releasing Firestore task:', error);
            throw error;
        }
    }
}
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Array
    })
], $d88dd2232853ef2e$export$33b107562567fc47.prototype, "reviewRequests", void 0);
$d88dd2232853ef2e$export$33b107562567fc47 = (0, $czHfO.__decorate)([
    (0, $df800a9dc9638977$export$da64fc29f17f9d0e)("hitl-batch")
], $d88dd2232853ef2e$export$33b107562567fc47);


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");



/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $8b789eeed2d2b117$var$HumanReview {
    constructor(state, state_message = ""){
        this.state_message = "";
        this.state = state;
        this.state_message = state_message;
    }
}
class $8b789eeed2d2b117$export$65528947809bf36b {
    constructor(reviewedDocumentJson, humanRevisionState, humanRevisionStateMessage, userId){
        this.id = "0";
        this.parent_ids = [];
        this.create_time = new Date().toISOString();
        this.parent_ids = [];
        this.lastRevisionId = "0";
        reviewedDocumentJson.revisions = reviewedDocumentJson.revisions || [];
        const lastRevision = reviewedDocumentJson.revisions.slice().sort((a, b)=>{
            return a < b;
        }).pop();
        this.lastRevisionId = lastRevision?.id || this.lastRevisionId;
        lastRevision?.parent_ids?.push(this.lastRevisionId);
        this.parent_ids = lastRevision?.parent_ids || [
            this.lastRevisionId
        ];
        this.id = String((parseInt(this.lastRevisionId || "") || 0) + 1);
        if (humanRevisionState !== "rejected") humanRevisionState = "succeeded";
        this.create_time = new Date().toISOString();
        this.human_review = new $8b789eeed2d2b117$var$HumanReview(humanRevisionState, humanRevisionStateMessage);
        this.agent = userId;
    }
}


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $eUQW6 = parcelRequire("eUQW6");
class $88660971f394cb62$export$37b716936d129341 {
    constructor(labels, headerTitle, disablePrev = true, disableNext = true, type = "Entity", queueName, schemaFirst = true){
        let documentAnnotationData = {};
        documentAnnotationData.pages = [
            {
                "imageUrl": {
                    "privateDoNotAccessOrElseWrappedUrl": ""
                },
                "tokens": [],
                "kvPairs": [],
                "entities": [],
                "tables": [],
                "textBlocks": [],
                "angle": 0
            }
        ];
        // convert Document to DocumentAnnotationData which is different for splitting and entity extraction
        if (type === "DocSplitter") {
            // set groupingLabels
            documentAnnotationData.entityLabels = [];
            documentAnnotationData.groupingLabels = labels;
            // Explicitly disable search for DocSplitter
            documentAnnotationData.showSearchButton = false;
            // Disable rotate functionality for DocSplitter as it's not needed for splitting
            documentAnnotationData.allowRotate = false;
            // setup inital zoom for Splitter
            documentAnnotationData.zoomInfo = {
                // set center of zoom (x: 0, y:0 is left top corner)
                zoomCenter: {
                    x: 0,
                    y: 0
                },
                // zoom level is a multiplier to the minimal zoom
                zoomLevel: 8
            };
        } else if (type === "DAI_COMPLEX_CLASSIFICATION") {
            documentAnnotationData.entityLabels = [];
            documentAnnotationData.classificationLabels = labels;
            // Explicitly disable search for Classification
            documentAnnotationData.showSearchButton = false;
            // Enable rotate functionality for Classification
            documentAnnotationData.allowRotate = true;
            // setup inital zoom for Classification
            documentAnnotationData.zoomInfo = {
                // set center of zoom (x: 0, y:0 is left top corner)
                zoomCenter: {
                    x: 0,
                    y: 0
                },
                // zoom level is a multiplier to the minimal zoom
                zoomLevel: 1.75
            };
        } else {
            documentAnnotationData.entityLabels = labels;
            documentAnnotationData.editConfig = {
                // enable support for nested entities
                enableNestedEntities: true,
                // enable schema first labeling, e.g. show all values from the entityLabels even if they are not set in the document
                schemaFirst: schemaFirst
            };
            // Enable rotate functionality for Entity extraction
            documentAnnotationData.allowRotate = true;
            // setup inital zoom for Extractor
            documentAnnotationData.zoomInfo = {
                // set center of zoom (x: 0, y:0 is left top corner)
                zoomCenter: {
                    x: 0,
                    y: 0
                },
                // zoom level is a multiplier to the minimal zoom
                zoomLevel: 2
            };
        }
        // Whether to show the escalate button.
        documentAnnotationData.showEscalateButton = false;
        // Whether to show the search button - only for Entity extraction (data extraction)
        // Explicitly set to false for DocSplitter and Classification
        if (type === "DocSplitter" || type === "DAI_COMPLEX_CLASSIFICATION") documentAnnotationData.showSearchButton = false;
        else if (type === "Entity") documentAnnotationData.showSearchButton = true;
        else documentAnnotationData.showSearchButton = false;
        // Display name of the document.
        documentAnnotationData.documentName = headerTitle;
        this.data = documentAnnotationData;
        // setup navigation layout
        this.navigation = new $88660971f394cb62$export$33b4d5f5f5f1d8f4(headerTitle, disablePrev, disableNext, type, queueName);
    }
}
class $88660971f394cb62$export$33b4d5f5f5f1d8f4 {
    constructor(headerTitle, disablePrev = true, disableNext = true, type, queueName){
        this.appMode = "HumanLabeling";
        // Controls whether to show/hide action button.
        this.isEditable = true;
        // Whether there was a local change, according to if there was/was not, the action button will be enabled/disabled. Required when isEditable is true.
        this.dataChanged = false;
        // Controls whether to always enable primary button.
        this.enablePrimaryButton = true;
        // Button text for save button. Default value is 'Save'.
        this.primaryButtonText = "Speichern";
        // Optional text for secondary button. If not given, the secondary button will be invisible.
        this.secondaryButtonText = "Clearing";
        // Disable the confirm dialog for unsaved warning
        this.disableConfirmDialog = false;
        // Controls whether to show/hide header - will be overwritten by the constructor
        this.hideHeader = false;
        // Controls whether to show/hide back button.
        this.hideBackButton = false;
        // set the current tab type - will be overwritten by the constructor
        this.tabGroupConfig = {
            currentTabType: "Entity"
        };
        this.headerTitle = headerTitle;
        this.disablePrev = disablePrev;
        this.disableNext = disableNext;
        this.tabGroupConfig.currentTabType = type;
        if (queueName) {
            if (!(0, $eUQW6.showClearingButtonForQueue)(queueName)) this.secondaryButtonText = undefined;
        }
    }
}







/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 

var $a30lF = parcelRequire("a30lF");
const $deb0d02e703878e3$export$a5f8e180c9a78db7 = {
    // ==========================================
    // ALWAYS AVAILABLE SHORTCUTS
    // ==========================================
    SAVE: {
        key: 's',
        modifiers: {
            ctrl: true
        },
        description: 'Save',
        action: 'clickSaveButton',
        blockInInputFields: false // Save should work everywhere
    },
    ZOOM_IN: {
        key: '=',
        modifiers: {
            alt: true
        },
        description: 'Zoom In',
        action: 'zoomIn'
    },
    ZOOM_OUT: {
        key: '-',
        modifiers: {
            alt: true
        },
        description: 'Zoom Out',
        action: 'zoomOut'
    },
    ZOOM_TO_FIT: {
        key: '0',
        modifiers: {
            alt: true
        },
        description: 'Zoom to Fit',
        action: 'zoomToFit'
    },
    UNDO: {
        key: 'z',
        modifiers: {
            ctrl: true
        },
        description: 'Undo',
        action: 'undo',
        blockInInputFields: true // Don't interfere with text field undo
    },
    REDO: {
        key: 'z',
        modifiers: {
            ctrl: true,
            shift: true
        },
        description: 'Redo',
        action: 'redo',
        blockInInputFields: true // Don't interfere with text field redo
    },
    // ==========================================
    // MODE-SPECIFIC SHORTCUTS
    // ==========================================
    SEND_TO_CLEARING: {
        key: 'c',
        modifiers: {
            ctrl: true,
            shift: true
        },
        description: 'Send to Clearing',
        action: 'sendToClearing',
        modes: [
            'K',
            'E'
        ] // Available in Classification and Extraction modes
    },
    SEND_TO_IRRLAEUFER: {
        key: 'i',
        modifiers: {
            ctrl: true,
            shift: true
        },
        description: "Send to Irrl\xe4ufer (Wrong Business Area)",
        action: 'sendToIrrlaeufer',
        modes: [
            'K',
            'E'
        ] // Available in Classification and Extraction modes
    },
    EXIT_WITHOUT_SAVING: {
        code: 'F4',
        modifiers: {},
        description: 'Exit Without Saving',
        action: 'exitWithoutSaving',
        modes: [
            'E'
        ] // Extraction mode only
    },
    CLEAR_ALL_EXTRACTED_FIELDS: {
        key: 'd',
        modifiers: {
            ctrl: true,
            shift: true
        },
        description: 'Clear All Extracted Fields',
        action: 'deleteExtractedFields',
        modes: [
            'E'
        ] // Extraction mode only
    },
    NEXT_FIELD_OR_COMPLETE: {
        code: 'Enter',
        modifiers: {},
        description: 'Next Field',
        action: 'nextFieldOrCompleteCase',
        modes: [
            'E'
        ],
        blockInInputFields: false // Special handling in code
    },
    DELETE_CASE: {
        key: '0',
        modifiers: {
            ctrl: true,
            alt: true
        },
        description: 'Delete Case',
        action: 'deleteCase',
        modes: [
            'K'
        ] // Classification mode only
    }
};
function $deb0d02e703878e3$export$7fcc2805be45e900(config) {
    const parts = [];
    if (config.modifiers.ctrl) parts.push('Ctrl');
    if (config.modifiers.alt) parts.push('Alt');
    if (config.modifiers.shift) parts.push('Shift');
    // Use key if available (character-based), otherwise use code (physical key)
    let displayKey;
    if (config.key) // Character-based: display the character as-is
    displayKey = config.key.toUpperCase();
    else if (config.code) {
        // Physical key: convert code to display format
        const keyCode = Array.isArray(config.code) ? config.code[0] : config.code;
        displayKey = keyCode;
        if (displayKey.startsWith('Key')) displayKey = displayKey.replace('Key', '');
        else if (displayKey.startsWith('Digit')) displayKey = displayKey.replace('Digit', '');
    } else displayKey = '?';
    parts.push(displayKey);
    return parts.join('+');
}
function $deb0d02e703878e3$export$dbc4764bcb2d331c(mode) {
    return Object.values($deb0d02e703878e3$export$a5f8e180c9a78db7).filter((config)=>!config.modes || config.modes.length === 0 || mode && config.modes.includes(mode));
}


var $562a56af2be4988d$export$8f0f5881f019e57e = /*#__PURE__*/ function(HitlMode) {
    HitlMode["CLASSIFICATION"] = "K";
    HitlMode["EXTRACTION"] = "E";
    return HitlMode;
}({});
class $562a56af2be4988d$export$f4d37277bb2b4dfd {
    static{
        this.CACHE_DURATION = 5000 // 5 seconds
        ;
    }
    static{
        this.DIGIT_BUFFER_TIMEOUT_MS = 800 // 800ms timeout between digits
        ;
    }
    constructor(){
        this.currentMode = null;
        this.isActive = false;
        this.boundHandler = null;
        this.boundCaptureHandler = null;
        // Cached DOM references for performance
        this.cachedSelectors = {
            mwcTextfield: null,
            lastCacheTime: 0
        };
        // Multi-digit class ID input buffer (for IDs > 9)
        this.digitBuffer = '';
        this.digitBufferTimeout = null;
        // Action handlers - set by the component
        this.handlers = {
            sendToClearing: null,
            sendToIrrlaeufer: null,
            deleteCase: null,
            deleteExtractedFields: null,
            exitWithoutSaving: null,
            nextFieldOrCompleteCase: null,
            clickSaveButton: null,
            selectClassById: null,
            showDigitBufferFeedback: null,
            hideDigitBufferFeedback: null,
            zoomIn: null,
            zoomOut: null,
            zoomToFit: null,
            undo: null,
            redo: null
        };
        this.boundHandler = this.handleKeyDown.bind(this);
        this.boundCaptureHandler = this.handleKeyDownCapture.bind(this);
    }
    /**
     * Capture-phase handler to block ALL keyboard events when dialog is open
     * This intercepts events before they reach the Google AI UI component
     */ handleKeyDownCapture(e) {
        if (this.isDialogOpen()) {
            // Allow Tab for accessibility navigation within dialog
            if (e.key === 'Tab') return;
            // Allow Escape to close dialog
            if (e.key === 'Escape') return;
            // Allow Enter to submit forms in dialog
            if (e.key === 'Enter') return;
            // Block events from reaching AI UI component (prevents [ ] page navigation)
            e.stopPropagation();
        }
    }
    /**
     * Initialize shortcuts with handler functions
     */ initialize(handlers) {
        this.handlers = handlers;
        // Expose to window for debugging in development environments
        typeof window;
    }
    /**
     * Set the current mode based on processor type
     */ setModeFromProcessorType(processorType) {
        let newMode = null;
        if (processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION || processorType === "DAI_COMPLEX_CLASSIFICATION") newMode = "K";
        else if (processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).EXTRACTION || processorType === "Entity") newMode = "E";
        else if (processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).SPLITTING || processorType === "DocSplitter") newMode = "E"; // Splitting is treated as extraction mode
        if (newMode !== this.currentMode) {
            this.currentMode = newMode;
            (0, $a30lF.log).debug(`Keyboard shortcuts mode set to ${newMode || 'none'} for processor type: ${processorType}`);
        }
    }
    /**
     * Activate keyboard shortcuts
     */ activate() {
        if (!this.isActive && this.boundHandler && this.boundCaptureHandler) {
            // Capture-phase handler intercepts events BEFORE they reach AI UI component
            window.addEventListener('keydown', this.boundCaptureHandler, {
                capture: true
            });
            // Bubble-phase handler for HITL-specific shortcuts
            window.addEventListener('keydown', this.boundHandler);
            this.isActive = true;
        }
    }
    /**
     * Deactivate keyboard shortcuts
     */ deactivate() {
        if (this.isActive && this.boundHandler && this.boundCaptureHandler) {
            window.removeEventListener('keydown', this.boundCaptureHandler, {
                capture: true
            });
            window.removeEventListener('keydown', this.boundHandler);
            this.isActive = false;
        }
    }
    /**
     * Get cached mwc-textfield elements or refresh cache if stale
     */ getCachedMwcTextfields() {
        const now = Date.now();
        if (!this.cachedSelectors.mwcTextfield || now - this.cachedSelectors.lastCacheTime > $562a56af2be4988d$export$f4d37277bb2b4dfd.CACHE_DURATION) {
            this.cachedSelectors.mwcTextfield = document.querySelectorAll('mwc-textfield');
            this.cachedSelectors.lastCacheTime = now;
        }
        return this.cachedSelectors.mwcTextfield;
    }
    /**
     * Check if target is within a cached mwc-textfield
     */ isInMwcTextfield(target) {
        const cachedElements = this.getCachedMwcTextfields();
        for(let i = 0; i < cachedElements.length; i++){
            if (cachedElements[i].contains(target)) return true;
        }
        return false;
    }
    /**
     * Check if a dialog is currently open
     * Uses multiple detection methods for reliability
     */ isDialogOpen() {
        const dialogElement = document.getElementById('dialog');
        return !!(document.querySelector('mwc-dialog[open]') || document.querySelector('#dialog[open="true"]') || dialogElement && dialogElement.hasAttribute('open') || dialogElement && dialogElement.open === true);
    }
    /**
     * Check if a keyboard event matches a keybind configuration
     * Supports both character-based (event.key) and position-based (event.code) matching
     */ matchesKeybind(e, config) {
        // Match by character (event.key) if configured - works across keyboard layouts
        if (config.key) {
            // Case-insensitive character matching
            if (e.key.toLowerCase() !== config.key.toLowerCase()) return false;
        } else if (config.code) {
            const codes = Array.isArray(config.code) ? config.code : [
                config.code
            ];
            if (!codes.includes(e.code)) return false;
        } else // No key or code specified
        return false;
        // Check modifiers
        const hasCtrl = e.ctrlKey || e.metaKey;
        const hasAlt = e.altKey;
        const hasShift = e.shiftKey;
        const needsCtrl = config.modifiers.ctrl || false;
        const needsAlt = config.modifiers.alt || false;
        const needsShift = config.modifiers.shift || false;
        return hasCtrl === needsCtrl && hasAlt === needsAlt && hasShift === needsShift;
    }
    /**
     * Main keyboard event handler - configuration-driven approach
     */ handleKeyDown(e) {
        // Completely disable keyboard shortcuts when a dialog is open
        // This ensures users can type freely (including umlauts) in dialog inputs
        if (this.isDialogOpen()) return;
        // Debug logging for keyboard layout detection
        // Shows both the character produced (key) and physical position (code)
        if (e.altKey || e.ctrlKey && ![
            'Control',
            'Meta'
        ].includes(e.key)) (0, $a30lF.log).debug(`[Keyboard] key="${e.key}" code="${e.code}" | Alt:${e.altKey} Ctrl:${e.ctrlKey} Shift:${e.shiftKey} Meta:${e.metaKey}`);
        // Don't handle shortcuts if user is typing in input fields
        const target = e.target;
        const isInputField = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable || this.isInMwcTextfield(target));
        // Try to match against all configured keybinds
        for (const [key, config] of Object.entries((0, $deb0d02e703878e3$export$a5f8e180c9a78db7))){
            if (!this.matchesKeybind(e, config)) continue;
            // Check if shortcut should be blocked in input fields
            if (isInputField && config.blockInInputFields !== false) {
                // Special case: NEXT_FIELD_OR_COMPLETE (Enter) needs custom handling
                if (config.action === 'nextFieldOrCompleteCase') {
                    // Check if we're in a dialog - use multiple detection methods
                    const dialogElement = document.getElementById('dialog');
                    const inDialog = target.closest('mwc-dialog') || target.closest('[role="dialog"]') || target.closest('#dialog') || document.querySelector('mwc-dialog[open]') || document.querySelector('#dialog[open="true"]') || dialogElement && dialogElement.hasAttribute('open') || dialogElement && dialogElement.open === true;
                    if (inDialog) continue;
                    // Not in dialog and in extraction mode - allow it
                    if (this.currentMode !== "E") continue;
                } else continue;
            }
            // Check mode availability
            if (config.modes && config.modes.length > 0) {
                if (!this.currentMode || !config.modes.includes(this.currentMode)) continue;
            }
            // Match found! Execute the handler
            e.preventDefault();
            const handler = this.handlers[config.action];
            if (handler) handler();
            else (0, $a30lF.log).warn(`Handler not found for action: ${config.action}`);
            return;
        }
        // Number keys (0-9): Accumulate digits for classification class ID (K mode only)
        // Supports multi-digit IDs (e.g., "12", "345") with 800ms timeout between digits
        // Don't trigger if modifier keys are pressed or if a dialog is open
        if (this.currentMode === "K" && !e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey) {
            const numberKeys = [
                '0',
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9'
            ];
            if (numberKeys.includes(e.key)) // Only trigger if not in an input field and no dialog is open
            {
                if (!isInputField && !this.isDialogOpen()) {
                    e.preventDefault();
                    this.accumulateDigit(e.key);
                    return;
                }
            }
        }
        // Enter: Confirm digit buffer (K mode only)
        // Don't trigger if a dialog is open
        if (this.currentMode === "K" && e.key === 'Enter' && this.digitBuffer.length > 0 && !isInputField && !this.isDialogOpen()) {
            e.preventDefault();
            this.confirmDigitBuffer();
            return;
        }
        // Escape: Cancel digit buffer (K mode only)
        // Don't trigger if a dialog is open
        if (this.currentMode === "K" && e.key === 'Escape' && this.digitBuffer.length > 0 && !isInputField && !this.isDialogOpen()) {
            e.preventDefault();
            this.cancelDigitBuffer();
            return;
        }
    }
    /**
     * Get current mode for debugging
     */ getCurrentMode() {
        return this.currentMode;
    }
    /**
     * Get available shortcuts for current mode (configuration-driven)
     */ getAvailableShortcuts() {
        const shortcuts = [];
        // Get keybinds for current mode from configuration
        const availableKeybinds = (0, $deb0d02e703878e3$export$dbc4764bcb2d331c)(this.currentMode);
        for (const config of availableKeybinds){
            const display = (0, $deb0d02e703878e3$export$7fcc2805be45e900)(config);
            shortcuts.push(`${display} - ${config.description}`);
        }
        // Add classification-specific shortcuts (digit buffer)
        if (this.currentMode === "K") {
            shortcuts.push('0-9 - Select Classification Class by ID (multi-digit supported)');
            shortcuts.push('Enter - Confirm class ID selection');
            shortcuts.push('Escape - Cancel class ID input');
        }
        return shortcuts;
    }
    /**
     * Accumulate digit for multi-digit class ID input
     */ accumulateDigit(digit) {
        // Clear existing timeout
        if (this.digitBufferTimeout !== null) window.clearTimeout(this.digitBufferTimeout);
        // Add digit to buffer
        this.digitBuffer += digit;
        // Show visual feedback
        this.handlers.showDigitBufferFeedback?.(this.digitBuffer);
        // Set timeout to auto-confirm after inactivity
        this.digitBufferTimeout = window.setTimeout(()=>{
            this.confirmDigitBuffer();
        }, $562a56af2be4988d$export$f4d37277bb2b4dfd.DIGIT_BUFFER_TIMEOUT_MS);
    }
    /**
     * Confirm and execute digit buffer selection
     */ confirmDigitBuffer() {
        if (this.digitBuffer.length === 0) return;
        // Clear timeout
        if (this.digitBufferTimeout !== null) {
            window.clearTimeout(this.digitBufferTimeout);
            this.digitBufferTimeout = null;
        }
        // Execute selection with accumulated buffer
        const classId = this.digitBuffer;
        this.handlers.selectClassById?.(classId);
        // Hide feedback
        this.handlers.hideDigitBufferFeedback?.();
        // Clear buffer
        this.digitBuffer = '';
    }
    /**
     * Cancel digit buffer input
     */ cancelDigitBuffer() {
        // Clear timeout
        if (this.digitBufferTimeout !== null) {
            window.clearTimeout(this.digitBufferTimeout);
            this.digitBufferTimeout = null;
        }
        // Hide feedback
        this.handlers.hideDigitBufferFeedback?.();
        // Clear buffer
        this.digitBuffer = '';
    }
}
const $562a56af2be4988d$export$c6962176354dc525 = new $562a56af2be4988d$export$f4d37277bb2b4dfd();
 // Window assignment happens during initialization to ensure proper timing


/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ 
var $czHfO = parcelRequire("czHfO");




const $c9078919b982827b$var$KEYBOARD_LAYOUTS = {
    de: {
        code: "de",
        name: "Deutsch (German)",
        keyMappings: {
            "=": {
                alt: [
                    "Alt",
                    "Shift",
                    "0"
                ],
                "ctrl+shift": [
                    "Strg",
                    "Shift",
                    "0"
                ]
            },
            "-": {
                alt: [
                    "Alt",
                    "\xdf"
                ],
                ctrl: [
                    "Strg",
                    "\xdf"
                ]
            },
            "0": {
                alt: [
                    "Alt",
                    "0"
                ],
                "ctrl+alt": [
                    "Strg",
                    "Alt",
                    "0"
                ]
            },
            s: {
                ctrl: [
                    "Strg",
                    "S"
                ]
            },
            c: {
                "ctrl+shift": [
                    "Strg",
                    "Shift",
                    "C"
                ]
            },
            d: {
                "ctrl+shift": [
                    "Strg",
                    "Shift",
                    "D"
                ]
            },
            z: {
                ctrl: [
                    "Strg",
                    "Z"
                ],
                "ctrl+shift": [
                    "Strg",
                    "Shift",
                    "Z"
                ]
            }
        }
    },
    en: {
        code: "en",
        name: "English (US)",
        keyMappings: {
            "=": {
                alt: [
                    "Alt",
                    "="
                ],
                "ctrl+shift": [
                    "Ctrl",
                    "Shift",
                    "="
                ]
            },
            "-": {
                alt: [
                    "Alt",
                    "-"
                ],
                ctrl: [
                    "Ctrl",
                    "-"
                ]
            },
            "0": {
                alt: [
                    "Alt",
                    "0"
                ],
                "ctrl+alt": [
                    "Ctrl",
                    "Alt",
                    "0"
                ]
            },
            s: {
                ctrl: [
                    "Ctrl",
                    "S"
                ]
            },
            c: {
                "ctrl+shift": [
                    "Ctrl",
                    "Shift",
                    "C"
                ]
            },
            d: {
                "ctrl+shift": [
                    "Ctrl",
                    "Shift",
                    "D"
                ]
            },
            z: {
                ctrl: [
                    "Ctrl",
                    "Z"
                ],
                "ctrl+shift": [
                    "Ctrl",
                    "Shift",
                    "Z"
                ]
            }
        }
    }
};
class $c9078919b982827b$export$dc5d1c021e0a8741 extends (0, $9cd293958617bb59$export$3f2f9f5909897157) {
    static{
        this.styles = (0, $f57b1293e9d8fdf8$export$dbf350e5966cf602)`
    :host {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
      align-items: center;
      justify-content: center;
    }

    :host([open]) {
      display: flex;
    }

    .dialog {
      background: white;
      border-radius: 8px;
      box-shadow:
        0 11px 15px -7px rgba(0, 0, 0, 0.2),
        0 24px 38px 3px rgba(0, 0, 0, 0.14),
        0 9px 46px 8px rgba(0, 0, 0, 0.12);
      max-width: 600px;
      width: 90%;
      max-height: 80vh;
      overflow: auto;
    }

    .header {
      padding: 24px 24px 20px;
      border-bottom: 1px solid #e0e0e0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .header h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #333;
    }

    .layout-selector {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #666;
    }

    .layout-selector select {
      padding: 4px 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 14px;
    }

    .content {
      padding: 24px;
    }

    .section {
      margin-bottom: 24px;
    }

    .section-title {
      font-weight: 500;
      font-size: 14px;
      color: #666;
      text-transform: uppercase;
      margin-bottom: 12px;
      letter-spacing: 0.5px;
    }

    .shortcut-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      border-bottom: 1px solid #f5f5f5;
    }

    .shortcut-row:last-child {
      border-bottom: none;
    }

    .shortcut-action {
      font-size: 14px;
      color: #333;
    }

    .shortcut-keys {
      display: flex;
      gap: 4px;
      align-items: center;
      flex-shrink: 0;
    }

    .key {
      background: #f5f5f5;
      border: 1px solid #ddd;
      border-radius: 3px;
      padding: 4px 8px;
      font-family: "Courier New", monospace;
      font-size: 12px;
      font-weight: 600;
      color: #333;
      min-width: 24px;
      text-align: center;
    }

    .key-hint {
      font-size: 11px;
      color: #999;
      margin-left: 8px;
      font-style: italic;
    }

    .plus {
      color: #999;
      font-size: 12px;
    }

    .footer {
      padding: 16px 24px;
      border-top: 1px solid #e0e0e0;
      display: flex;
      justify-content: flex-end;
    }

    button {
      background: #be153f;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      text-transform: uppercase;
    }

    button:hover {
      background: #006b38;
    }

    .info-box {
      background: #e8f5e9;
      border-left: 4px solid #4caf50;
      padding: 12px;
      margin-bottom: 16px;
      font-size: 13px;
      color: #2e7d32;
      border-radius: 4px;
    }
  `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.detectKeyboardLayout();
    }
    /**
   * Detect keyboard layout based on browser language
   */ detectKeyboardLayout() {
        const lang = navigator.language.toLowerCase();
        if (lang.startsWith("de")) this.detectedLayout = "de";
        else this.detectedLayout = "en";
    }
    /**
   * Get layout-specific key combination for a shortcut
   */ getLayoutKeys(config) {
        const layout = $c9078919b982827b$var$KEYBOARD_LAYOUTS[this.detectedLayout];
        // Build modifier string (e.g., "ctrl+shift", "alt")
        const modifierParts = [];
        if (config.modifiers.ctrl) modifierParts.push("ctrl");
        if (config.modifiers.alt) modifierParts.push("alt");
        if (config.modifiers.shift) modifierParts.push("shift");
        const modifierKey = modifierParts.join("+");
        // Try to get layout-specific keys
        if (config.key && layout.keyMappings[config.key]?.[modifierKey]) return layout.keyMappings[config.key][modifierKey];
        // Fallback to generic display
        return (0, $deb0d02e703878e3$export$7fcc2805be45e900)(config).split("+");
    }
    /**
   * Render a single shortcut row
   */ renderShortcut(config) {
        const keys = this.getLayoutKeys(config);
        return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
      <div class="shortcut-row">
        <div class="shortcut-action">${config.description}</div>
        <div class="shortcut-keys">
          ${keys.map((key, index)=>(0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
              ${index > 0 ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`<span class="plus">+</span>` : ""}
              <span class="key">${key}</span>
            `)}
        </div>
      </div>
    `;
    }
    /**
   * Get shortcuts for current mode
   */ getShortcutsByCategory() {
        const mode = (0, $562a56af2be4988d$export$c6962176354dc525).getCurrentMode();
        const shortcuts = Object.values((0, $deb0d02e703878e3$export$a5f8e180c9a78db7));
        const always = shortcuts.filter((s)=>!s.modes || s.modes.length === 0);
        const modeSpecific = shortcuts.filter((s)=>s.modes && s.modes.length > 0 && mode && s.modes.includes(mode));
        return {
            always: always,
            modeSpecific: modeSpecific
        };
    }
    render() {
        const { always: always, modeSpecific: modeSpecific } = this.getShortcutsByCategory();
        const layoutInfo = $c9078919b982827b$var$KEYBOARD_LAYOUTS[this.detectedLayout];
        return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
      <div class="dialog" @click=${(e)=>e.stopPropagation()}>
        <div class="header">
          <h2>Tastaturkürzel / Keyboard Shortcuts</h2>
          <div class="layout-selector">
            <label>Layout:</label>
            <select @change=${this.handleLayoutChange}>
              ${Object.entries($c9078919b982827b$var$KEYBOARD_LAYOUTS).map(([code, layout])=>(0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                  <option
                    value="${code}"
                    ?selected=${code === this.detectedLayout}
                  >
                    ${layout.name}
                  </option>
                `)}
            </select>
          </div>
        </div>

        <div class="content">
          <div class="section">
            <div class="section-title">Immer verfügbar</div>
            ${always.map((shortcut)=>this.renderShortcut(shortcut))}
          </div>

          ${modeSpecific.length > 0 ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                <div class="section">
                  <div class="section-title">Aktueller Modus</div>
                  ${modeSpecific.map((shortcut)=>this.renderShortcut(shortcut))}
                </div>
              ` : ""}
        </div>

        <div class="footer">
          <button @click=${this.close}>Schließen / Close</button>
        </div>
      </div>
    `;
    }
    handleLayoutChange(e) {
        const select = e.target;
        this.detectedLayout = select.value;
    }
    show() {
        this.open = true;
    }
    close() {
        this.open = false;
    }
    constructor(...args){
        super(...args), this.open = false, this.detectedLayout = "en";
    }
}
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $c9078919b982827b$export$dc5d1c021e0a8741.prototype, "open", void 0);
(0, $czHfO.__decorate)([
    (0, $c0a011b960dd7d47$export$ca000e230c0caa3e)()
], $c9078919b982827b$export$dc5d1c021e0a8741.prototype, "detectedLayout", void 0);
$c9078919b982827b$export$dc5d1c021e0a8741 = (0, $czHfO.__decorate)([
    (0, $df800a9dc9638977$export$da64fc29f17f9d0e)("keyboard-shortcuts-dialog")
], $c9078919b982827b$export$dc5d1c021e0a8741);



var $a30lF = parcelRequire("a30lF");
const $2a37b32211ef6428$var$ANY_MATCH_TOKENS = new Set([
    "*",
    "ANY",
    "any"
]);
const $2a37b32211ef6428$var$asArray = (value)=>{
    if (value === null || value === undefined) return [];
    if (Array.isArray(value)) return [
        ...value
    ];
    if (value instanceof Set) return Array.from(value);
    return [
        value
    ];
};
const $2a37b32211ef6428$var$extractContextValue = (context, path)=>{
    const segments = path.split(".");
    let current = context;
    for (const segment of segments){
        if (typeof current !== "object" || current === null) return undefined;
        current = current[segment];
    }
    return current;
};
const $2a37b32211ef6428$var$valueMatchesRequirement = (value, requirement)=>{
    if (requirement === null || requirement === undefined || typeof requirement === "string" && $2a37b32211ef6428$var$ANY_MATCH_TOKENS.has(requirement) || typeof requirement === "object" && requirement !== null && !Array.isArray(requirement) && "any" in requirement && requirement.any === true) return true;
    if (typeof requirement === "object" && requirement !== null && !Array.isArray(requirement)) {
        const requirementMap = requirement;
        if ("exists" in requirementMap) {
            const existsFlag = requirementMap.exists;
            if (existsFlag === true && (value === undefined || value === null)) return false;
            if (existsFlag === false && value !== undefined && value !== null) return false;
        }
        if ("any_of" in requirementMap) {
            const allowed = $2a37b32211ef6428$var$asArray(requirementMap.any_of);
            if (value === undefined || value === null) {
                if (!allowed.includes(null) && !allowed.includes(undefined)) return false;
            } else if (Array.isArray(value)) {
                const intersection = value.some((item)=>allowed.includes(item));
                if (!intersection) return false;
            } else if (!allowed.includes(value)) return false;
        }
        if ("none_of" in requirementMap) {
            const blocked = $2a37b32211ef6428$var$asArray(requirementMap.none_of);
            if (Array.isArray(value)) {
                const hasBlocked = value.some((item)=>blocked.includes(item));
                if (hasBlocked) return false;
            } else if (value !== undefined && value !== null) {
                if (blocked.includes(value)) return false;
            }
        }
        if ("equals" in requirementMap) {
            if (value !== requirementMap.equals) return false;
        }
        return true;
    }
    if (Array.isArray(requirement)) {
        if (value === undefined || value === null) return requirement.includes(null) || requirement.includes(undefined);
        if (Array.isArray(value)) return value.some((item)=>requirement.includes(item));
        return requirement.includes(value);
    }
    return value === requirement;
};
const $2a37b32211ef6428$var$deepCopy = (input)=>JSON.parse(JSON.stringify(input ?? null));
const $2a37b32211ef6428$var$ensureString = (raw)=>typeof raw === "string" ? raw : String(raw ?? "");
const $2a37b32211ef6428$var$ensureNumber = (raw)=>{
    if (typeof raw === "number" && Number.isFinite(raw)) return raw;
    if (typeof raw === "string" && raw.trim() !== "" && !Number.isNaN(Number(raw))) return Number(raw);
    return undefined;
};
const $2a37b32211ef6428$var$cleaningExecutors = {
    remove_non_digits: (value)=>({
            value: value ? value.replace(/\D+/g, "") : ""
        }),
    remove_special_chars: (value, config)=>{
        const allowedPrefix = $2a37b32211ef6428$var$ensureString(config.allowed_prefix);
        if (!value) return {
            value: ""
        };
        if (allowedPrefix && value.startsWith(allowedPrefix)) {
            const rest = value.slice(allowedPrefix.length).replace(/\D+/g, "");
            return {
                value: allowedPrefix + rest
            };
        }
        // If no allowed prefix or value doesn't start with it, keep only digits
        // This prevents values starting with wrong letters from being accepted
        return {
            value: value.replace(/\D+/g, "")
        };
    },
    add_leading_zeros: (value, config)=>{
        const length = $2a37b32211ef6428$var$ensureNumber(config.length);
        if (length === undefined) return {
            value: value,
            warning: "Bereinigungsschritt 'add_leading_zeros' fehlt 'length' Konfiguration"
        };
        if (!value) return {
            value: "0".repeat(length)
        };
        if (value.length >= length) return {
            value: value
        };
        return {
            value: value.padStart(length, "0")
        };
    },
    add_prefix: (value, config)=>{
        const prefix = $2a37b32211ef6428$var$ensureString(config.prefix);
        if (!prefix) return {
            value: value,
            warning: "Bereinigungsschritt 'add_prefix' fehlt 'prefix' Konfiguration"
        };
        if (!value) return {
            value: prefix
        };
        if (value.startsWith(prefix)) return {
            value: value
        };
        return {
            value: prefix + value
        };
    },
    uppercase: (value)=>({
            value: value ? value.toUpperCase() : ""
        }),
    lowercase: (value)=>({
            value: value ? value.toLowerCase() : ""
        }),
    trim_whitespace: (value)=>({
            value: value ? value.trim() : ""
        }),
    remove_spaces: (value)=>({
            value: value ? value.replace(/\s+/g, "") : ""
        }),
    normalize_country_code: (value, config)=>{
        if (!value) return {
            value: ""
        };
        const codeLength = $2a37b32211ef6428$var$ensureNumber(config.code_length) ?? 2;
        const prefix = value.slice(0, codeLength).toUpperCase();
        return {
            value: prefix + value.slice(codeLength)
        };
    },
    remove_prefix: (value, config)=>{
        const prefix = $2a37b32211ef6428$var$ensureString(config.prefix);
        if (!prefix) return {
            value: value,
            warning: "Bereinigungsschritt 'remove_prefix' fehlt 'prefix' Konfiguration"
        };
        if (!value) return {
            value: ""
        };
        if (value.startsWith(prefix)) return {
            value: value.slice(prefix.length)
        };
        return {
            value: value
        };
    },
    pad_suffix_with_zeros: (value, config)=>{
        const length = $2a37b32211ef6428$var$ensureNumber(config.length);
        if (length === undefined) return {
            value: value,
            warning: "Bereinigungsschritt 'pad_suffix_with_zeros' fehlt 'length' Konfiguration"
        };
        const prefix = $2a37b32211ef6428$var$ensureString(config.prefix);
        const workingValue = value ?? "";
        let suffix = workingValue;
        if (prefix && workingValue.startsWith(prefix)) suffix = workingValue.slice(prefix.length);
        let numericSuffix = suffix.replace(/\D+/g, "");
        if (!numericSuffix) numericSuffix = "0".repeat(length);
        else if (numericSuffix.length < length) numericSuffix = numericSuffix.padStart(length, "0");
        const padded = prefix ? prefix + numericSuffix : numericSuffix;
        return {
            value: padded
        };
    },
    extract_vnr_from_zusatznummer: (value)=>{
        if (!value) return {
            value: ""
        };
        // Handle 11 digits: 9-digit VNR + Zusatznummer "00"
        if (value.length === 11 && value.endsWith("00")) return {
            value: value.slice(0, 9),
            warning: "VNR enthielt Zusatznummer '00', nur VNR-Teil wird validiert"
        };
        // Handle 12 digits: 10-digit VNR + Zusatznummer "00"
        if (value.length === 12 && value.endsWith("00")) return {
            value: value.slice(0, 10),
            warning: "VNR enthielt Zusatznummer '00', nur VNR-Teil wird validiert"
        };
        return {
            value: value
        };
    }
};
const $2a37b32211ef6428$var$calculateCheckDigitMethod1 = (numberWithoutCheck)=>{
    let total = 0;
    let weight = 2;
    for(let idx = numberWithoutCheck.length - 1; idx >= 0; idx -= 1){
        const digit = Number(numberWithoutCheck[idx]);
        total += digit * weight;
        weight = weight < 7 ? weight + 1 : 2;
    }
    let checkDigit = 11 - total % 11;
    if (checkDigit > 9) checkDigit -= 10;
    return String(checkDigit);
};
const $2a37b32211ef6428$var$validateCheckDigitMethod1 = (value)=>{
    if (!value) return {
        isValid: false,
        error: "Leerer Wert f\xfcr Pr\xfcfziffernvalidierung"
    };
    if (!/^\d+$/.test(value)) return {
        isValid: false,
        error: "Wert darf nur Ziffern f\xfcr Pr\xfcfziffernvalidierung enthalten"
    };
    const numberWithoutCheck = value.slice(0, -1);
    const givenCheckDigit = value.slice(-1);
    const calculated = $2a37b32211ef6428$var$calculateCheckDigitMethod1(numberWithoutCheck);
    return calculated === givenCheckDigit ? {
        isValid: true
    } : {
        isValid: false,
        error: "Pr\xfcfziffernvalidierung fehlgeschlagen: Der Wert ist fehlerhaft, der Vorgang muss \xfcber Kl\xe4rung gesteuert werden"
    };
};
const $2a37b32211ef6428$var$mod97 = (numericString)=>{
    let remainder = 0;
    const chunkSize = 9;
    for(let index = 0; index < numericString.length; index += chunkSize){
        const chunk = numericString.slice(index, index + chunkSize);
        const parsed = Number(`${remainder}${chunk}`);
        remainder = parsed % 97;
    }
    return remainder;
};
const $2a37b32211ef6428$var$validationExecutors = {
    length: (value, config)=>{
        const expected = $2a37b32211ef6428$var$ensureNumber(config.value);
        if (expected === undefined) return {
            isValid: false,
            error: "L\xe4ngenpr\xfcfung fehlt 'value' Konfiguration"
        };
        return value.length === expected ? {
            isValid: true
        } : {
            isValid: false,
            error: `Erwartet genau ${expected} Zeichen, erhalten ${value.length}`
        };
    },
    max_length: (value, config)=>{
        const maxLength = $2a37b32211ef6428$var$ensureNumber(config.value);
        if (maxLength === undefined) return {
            isValid: false,
            error: "Maximale L\xe4ngenpr\xfcfung fehlt 'value' Konfiguration"
        };
        return value.length <= maxLength ? {
            isValid: true
        } : {
            isValid: false,
            error: `Erwartet h\xf6chstens ${maxLength} Zeichen, erhalten ${value.length}`
        };
    },
    min_length: (value, config)=>{
        const minLength = $2a37b32211ef6428$var$ensureNumber(config.value);
        if (minLength === undefined) return {
            isValid: false,
            error: "Minimale L\xe4ngenpr\xfcfung fehlt 'value' Konfiguration"
        };
        return value.length >= minLength ? {
            isValid: true
        } : {
            isValid: false,
            error: `Erwartet mindestens ${minLength} Zeichen, erhalten ${value.length}`
        };
    },
    year_prefix: (value, config)=>{
        const expectedPrefix = $2a37b32211ef6428$var$ensureString(config.value);
        if (!expectedPrefix) return {
            isValid: false,
            error: "Jahrespr\xe4fix-Pr\xfcfung fehlt 'value' Konfiguration"
        };
        const prefixLength = $2a37b32211ef6428$var$ensureNumber(config.length) ?? expectedPrefix.length;
        if (value.length < prefixLength) return {
            isValid: false,
            error: "Wert zu kurz f\xfcr Jahrespr\xe4fix-Pr\xfcfung"
        };
        const actualPrefix = value.slice(0, prefixLength);
        return actualPrefix === expectedPrefix ? {
            isValid: true
        } : {
            isValid: false,
            error: `Jahr muss mit '${expectedPrefix}' beginnen, erhalten '${actualPrefix}'`
        };
    },
    position_range: (value, config)=>{
        const startPos = $2a37b32211ef6428$var$ensureNumber(config.start);
        const endPos = $2a37b32211ef6428$var$ensureNumber(config.end);
        const expected = $2a37b32211ef6428$var$ensureString(config.value);
        if (startPos === undefined || endPos === undefined || expected === undefined) return {
            isValid: false,
            error: "Positionsbereich-Pr\xfcfung fehlt 'start', 'end' oder 'value' Konfiguration"
        };
        const startIdx = Math.max(0, startPos - 1);
        const endIdx = Math.min(value.length, endPos);
        if (endIdx > value.length) return {
            isValid: false,
            error: `Wert zu kurz f\xfcr Positionsbereich-Pr\xfcfung (ben\xf6tigt mindestens ${endIdx} Zeichen)`
        };
        const actual = value.slice(startIdx, endIdx);
        return actual === expected ? {
            isValid: true
        } : {
            isValid: false,
            error: `Positionen ${startPos}-${endPos} m\xfcssen '${expected}' sein, erhalten '${actual}'`
        };
    },
    check_digit: (value)=>$2a37b32211ef6428$var$validateCheckDigitMethod1(value),
    devk_rs_claim_number_format: (value, config)=>{
        const allowedRdCodesRaw = Array.isArray(config.allowed_rd_codes) ? config.allowed_rd_codes : [
            "02",
            "03",
            "04",
            "05",
            "06",
            "14",
            "15",
            "28"
        ];
        const allowedRdCodes = new Set(allowedRdCodesRaw.map((code)=>String(code)));
        const applyCheckDigitFor99 = config.apply_check_digit_for_99 !== false;
        const applyCheckDigitForNon99 = config.apply_check_digit_for_non_99 !== false;
        if (value.length < 8) return {
            isValid: false,
            error: "Schadennummer zu kurz f\xfcr DEVK RS Formatvalidierung (mindestens 8 Ziffern erforderlich)"
        };
        const seriesCode = value.slice(4, 6);
        if (seriesCode === "99") {
            const rdCode = value.slice(6, 8);
            if (!allowedRdCodes.has(rdCode)) return {
                isValid: false,
                error: `DEVK RS Schadennummer (99-Serie) hat ung\xfcltigen RD-Code '${rdCode}' an Position 7-8. Erlaubte Codes: ${Array.from(allowedRdCodes).sort().join(", ")}`
            };
            if (applyCheckDigitFor99 && value.length === 14) return $2a37b32211ef6428$var$validateCheckDigitMethod1(value);
            return {
                isValid: true
            };
        }
        if (applyCheckDigitForNon99 && value.length === 14) return $2a37b32211ef6428$var$validateCheckDigitMethod1(value);
        return {
            isValid: true
        };
    },
    mod97_check: (value)=>{
        if (!value || value.length < 4) return {
            isValid: false,
            error: "IBAN zu kurz f\xfcr Modulo-97-Validierung"
        };
        const rearranged = value.slice(4) + value.slice(0, 4);
        let numericString = "";
        for (const char of rearranged)if (/[A-Za-z]/.test(char)) numericString += String(char.toUpperCase().charCodeAt(0) - 55);
        else numericString += char;
        if (!/^\d+$/.test(numericString)) return {
            isValid: false,
            error: "IBAN enth\xe4lt ung\xfcltige Zeichen f\xfcr Modulo-97-Berechnung"
        };
        return $2a37b32211ef6428$var$mod97(numericString) === 1 ? {
            isValid: true
        } : {
            isValid: false,
            error: "IBAN Modulo-97-Pr\xfcfung fehlgeschlagen (Ergebnis nicht gleich 1)"
        };
    },
    country_code: (value, config)=>{
        const expected = $2a37b32211ef6428$var$ensureString(config.value);
        if (!expected) return {
            isValid: false,
            error: "L\xe4ndercode-Pr\xfcfung fehlt 'value' Konfiguration"
        };
        if (value.length < expected.length) return {
            isValid: false,
            error: "Wert zu kurz f\xfcr L\xe4ndercode-Pr\xfcfung"
        };
        const actual = value.slice(0, expected.length).toUpperCase();
        return actual === expected.toUpperCase() ? {
            isValid: true
        } : {
            isValid: false,
            error: `Erwarteter L\xe4ndercode '${expected}', erhalten '${actual}'`
        };
    },
    regex_match: (value, config)=>{
        const pattern = $2a37b32211ef6428$var$ensureString(config.pattern);
        if (!pattern) return {
            isValid: false,
            error: "Regex-\xdcbereinstimmungspr\xfcfung fehlt 'pattern' Konfiguration"
        };
        try {
            const regex = new RegExp(pattern);
            return regex.test(value) ? {
                isValid: true
            } : {
                isValid: false,
                error: `Wert stimmt nicht mit Muster \xfcberein: ${pattern}`
            };
        } catch (error) {
            return {
                isValid: false,
                error: `Ung\xfcltiges Regex-Muster: ${String(error)}`
            };
        }
    },
    all_digits: (value)=>{
        return /^\d+$/.test(value) ? {
            isValid: true
        } : {
            isValid: false,
            error: "Wert darf nur Ziffern enthalten"
        };
    },
    valid_currency_amount: (value)=>{
        if (!value || value.trim() === "") return {
            isValid: false,
            error: "Betrag darf nicht leer sein"
        };
        const cleaned = value.trim();
        // Reject invalid separators (OCR errors: : ; /)
        if (/[:|;/]/.test(cleaned)) return {
            isValid: false,
            error: "Ung\xfcltiges Zeichen im Betrag (verwenden Sie ',' als Dezimaltrennzeichen)"
        };
        // Reject period (no thousands separators allowed, only comma as decimal)
        if (cleaned.includes('.')) return {
            isValid: false,
            error: "Ung\xfcltiges Format: Tausendertrennzeichen nicht erlaubt (Format: z.B. 1234,56)"
        };
        // Check for multiple commas
        const commaCount = (cleaned.match(/,/g) || []).length;
        if (commaCount > 1) return {
            isValid: false,
            error: "Ung\xfcltiger Betrag: mehrere Dezimalkommas gefunden"
        };
        // Validate final pattern: only digits, optional comma with 1-2 decimal places
        // Format: 1234 or 1234,56 or -1234,56
        const validCurrencyPattern = /^-?\d+(?:,\d{1,2})?$/;
        if (!validCurrencyPattern.test(cleaned)) return {
            isValid: false,
            error: "Ung\xfcltiges Betragsformat (erwartetes Format: z.B. 1234,56)"
        };
        return {
            isValid: true
        };
    }
};
const $2a37b32211ef6428$var$applyCleaningSteps = (rawValue, steps)=>{
    let value = typeof rawValue === "string" ? rawValue : String(rawValue ?? "");
    const warnings = [];
    for (const step of steps){
        const stepType = typeof step.type === "string" ? step.type : "";
        const executor = $2a37b32211ef6428$var$cleaningExecutors[stepType];
        if (!executor) {
            warnings.push(`Unbekannter Bereinigungsschritt '${stepType}'`);
            continue;
        }
        try {
            const result = executor(value, step);
            value = result.value;
            if (result.warning) warnings.push(result.warning);
        } catch (error) {
            warnings.push(`Bereinigungsschritt '${stepType}' fehlgeschlagen: ${String(error)}`);
        }
    }
    return {
        value: value,
        warnings: warnings
    };
};
const $2a37b32211ef6428$var$applyValidationChecks = (value, checks)=>{
    const errors = [];
    for (const check of checks){
        const checkType = typeof check.type === "string" ? check.type : "";
        const executor = $2a37b32211ef6428$var$validationExecutors[checkType];
        if (!executor) {
            errors.push(`Unbekannte Validierungspr\xfcfung '${checkType}'`);
            continue;
        }
        try {
            const result = executor(value, check);
            if (!result.isValid && result.error) errors.push(result.error);
        } catch (error) {
            errors.push(`Validierungspr\xfcfung '${checkType}' fehlgeschlagen: ${String(error)}`);
        }
    }
    return {
        isValid: errors.length === 0,
        errors: errors
    };
};
const $2a37b32211ef6428$var$normalizeMergeStrategy = (mergeStrategy)=>{
    if (mergeStrategy && typeof mergeStrategy === "object") {
        const cleaning = String(mergeStrategy.cleaning ?? "append");
        const validation = String(mergeStrategy.validation ?? "append");
        return [
            cleaning,
            validation
        ];
    }
    const strategy = String(mergeStrategy ?? "append");
    return [
        strategy,
        strategy
    ];
};
const $2a37b32211ef6428$var$applyWithStrategy = (base, additions, strategy)=>{
    if (!additions || additions.length === 0) return base;
    if (strategy === "replace" || strategy === "replace_all") return $2a37b32211ef6428$var$deepCopy(additions);
    if (strategy === "prepend") return [
        ...$2a37b32211ef6428$var$deepCopy(additions),
        ...base
    ];
    return [
        ...base,
        ...$2a37b32211ef6428$var$deepCopy(additions)
    ];
};
class $2a37b32211ef6428$var$FieldRuleDefinition {
    constructor(params){
        this.ruleId = params.ruleId;
        this.fieldTypes = new Set(params.fieldTypes);
        this.presets = params.presets ?? [];
        this.cleaningSteps = params.cleaningSteps ?? [];
        this.validationChecks = params.validationChecks ?? [];
        this.mergeStrategy = params.mergeStrategy ?? "append";
        this.options = params.options ?? {};
        this.description = params.description;
        this.metadata = params.metadata ?? {};
    }
    appliesTo(fieldType) {
        return this.fieldTypes.has("*") || this.fieldTypes.has(fieldType);
    }
}
class $2a37b32211ef6428$var$RuleScope {
    constructor(params){
        this.scopeId = params.scopeId;
        this.priority = params.priority;
        this.conditions = params.conditions;
        this.fieldRules = params.fieldRules;
        this.enabled = params.enabled ?? true;
        this.description = params.description;
        this.metadata = params.metadata ?? {};
    }
    matchesContext(context) {
        if (!this.enabled) return false;
        return Object.entries(this.conditions).every(([key, requirement])=>{
            const value = $2a37b32211ef6428$var$extractContextValue(context, key);
            return $2a37b32211ef6428$var$valueMatchesRequirement(value, requirement);
        });
    }
    iterFieldRules(fieldType) {
        return this.fieldRules.filter((rule)=>rule.appliesTo(fieldType));
    }
}
const $2a37b32211ef6428$var$buildScopeId = (parts)=>parts.filter((part)=>Boolean(part)).join("-");
const $2a37b32211ef6428$var$mergeMetadata = (base, extra)=>{
    const merged = {};
    if (base && typeof base === "object") Object.assign(merged, base);
    if (extra && typeof extra === "object") Object.assign(merged, extra);
    return merged;
};
const $2a37b32211ef6428$var$fetchValidationConfig = async (params)=>{
    const { accessToken: accessToken, idToken: idToken, environment: environment, projectId: projectId } = params;
    const documentId = "configuration";
    const url = `${"DEFAULT_INTERNAL_API_URL"}/documents/validation_rules/${documentId}`;
    (0, $a30lF.log).info("Fetching validation config", {
        documentId: documentId,
        url: url
    });
    const response = await fetch(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${idToken}`
        }
    });
    (0, $a30lF.log).debug("Validation API HTTP response", {
        status: response.status,
        statusText: response.statusText,
        ok: response.ok,
        headers: Object.fromEntries(response.headers.entries())
    });
    if (response.status === 404) {
        console.warn("Validation rules not found (404)");
        return undefined;
    }
    if (!response.ok) {
        const errorText = await response.text();
        console.error("Validation API error response", {
            status: response.status,
            statusText: response.statusText,
            body: errorText
        });
        throw new Error(`Validierungskonfiguration konnte nicht geladen werden (${response.status} ${response.statusText})`);
    }
    const responseText = await response.text();
    (0, $a30lF.log).debug("Validation API response body (raw)", {
        length: responseText.length,
        first100Chars: responseText.substring(0, 100),
        fullText: responseText
    });
    if (!responseText || responseText.trim() === "") {
        console.warn("Validation API returned empty body");
        return undefined;
    }
    const document = JSON.parse(responseText);
    (0, $a30lF.log).debug("Validation API response structure", {
        hasDocument: !!document,
        documentKeys: document ? Object.keys(document) : [],
        documentType: typeof document,
        fullDocument: document
    });
    if (!document) {
        console.warn("API returned null/empty document for validation rules");
        return undefined;
    }
    // Handle both Firestore REST API format and plain dict format
    const fields = document.fields ?? {};
    let configJson = fields.config_json?.stringValue ?? fields.config?.stringValue;
    // If not in REST API format, try plain format
    if (!configJson) configJson = document.config_json ?? document.config;
    if (!configJson) {
        (0, $a30lF.log).warn("No config_json found in document", {
            documentKeys: Object.keys(document),
            hasFields: !!document.fields,
            hasConfigJson: !!(document.config_json || document.config)
        });
        return undefined;
    }
    const config = JSON.parse(configJson);
    // Try to get version from Firestore fields or plain format
    if (!config.version) config.version = fields.version?.stringValue ?? document.version;
    // Try to get metadata from Firestore fields or plain format
    if (!config.metadata) {
        const metadataJson = fields.metadata_json?.stringValue ?? document.metadata_json;
        if (metadataJson) config.metadata = JSON.parse(metadataJson);
    }
    (0, $a30lF.log).info("Parsed validation config", {
        version: config.version,
        hasPresets: !!config.presets,
        hasScopes: !!config.scopes,
        configKeys: Object.keys(config)
    });
    return config;
};
class $2a37b32211ef6428$var$FrontendValidationRuleEngine {
    async ensureConfigLoaded(params) {
        const { environment: environment, projectId: projectId } = params;
        if (!environment) throw new Error("Umgebung nicht f\xfcr Validierungskonfiguration angegeben");
        if (!projectId) throw new Error("Projekt-ID nicht f\xfcr Validierungskonfiguration angegeben");
        const key = `${projectId}::${environment}`;
        if (this.loadKey === key && this.scopes.length > 0) {
            (0, $a30lF.log).debug("Validierungsregeln bereits geladen", {
                key: key,
                version: this.configVersion,
                scopesCount: this.scopes.length,
                presetsCount: this.presets.size
            });
            return;
        }
        if (!this.loadPromise) this.loadPromise = (async ()=>{
            (0, $a30lF.log).debug("Lade Validierungsregeln von Firestore", {
                environment: environment,
                projectId: projectId
            });
            const config = await $2a37b32211ef6428$var$fetchValidationConfig(params);
            if (!config) console.warn("Keine Validierungsregeln in Firestore gefunden", {
                environment: environment,
                projectId: projectId
            });
            else (0, $a30lF.log).debug("Validierungsregeln erfolgreich geladen", {
                version: config.version,
                hasPresets: !!config.presets,
                hasBusinessAreas: !!config.business_areas
            });
            this.applyConfiguration(config ?? {});
            this.loadKey = key;
            (0, $a30lF.log).debug("Validierungsregeln angewendet", {
                key: key,
                version: this.configVersion,
                scopesCount: this.scopes.length,
                presetsCount: this.presets.size,
                configuredFields: Array.from(this.configuredFieldTypes)
            });
        })().finally(()=>{
            this.loadPromise = undefined;
        });
        await this.loadPromise;
    }
    getConfigVersion() {
        return this.configVersion;
    }
    hasRuleForField(fieldType) {
        return this.configuredFieldTypes.has("*") || this.configuredFieldTypes.has(fieldType);
    }
    validateField(fieldType, rawValue, baseContext) {
        const context = this.buildContext(fieldType, baseContext);
        const rule = this.resolveRuleForContext(fieldType, context);
        if (!rule) return {
            fieldType: fieldType,
            originalValue: rawValue,
            cleanedValue: rawValue,
            isValid: true,
            errors: [],
            warnings: [],
            metadata: {
                source: "no_rule"
            },
            ruleTrace: []
        };
        const { cleaning_steps: cleaningSteps, validation_checks: validationChecks } = rule;
        const cleaningResult = $2a37b32211ef6428$var$applyCleaningSteps(rawValue ?? "", cleaningSteps);
        const validationResult = $2a37b32211ef6428$var$applyValidationChecks(cleaningResult.value, validationChecks);
        const errors = [
            ...validationResult.errors
        ];
        const warnings = [
            ...cleaningResult.warnings
        ];
        const dedupe = (items)=>items.length > 1 ? Array.from(new Set(items)) : items;
        const finalErrors = dedupe(errors);
        const finalWarnings = dedupe(warnings);
        return {
            fieldType: fieldType,
            originalValue: rawValue,
            cleanedValue: cleaningResult.value,
            isValid: validationResult.isValid,
            errors: finalErrors,
            warnings: finalWarnings,
            metadata: {
                config_version: this.configVersion,
                configuration_metadata: this.configMetadata,
                rule_metadata: rule.metadata
            },
            ruleTrace: rule.rule_trace ?? []
        };
    }
    buildContext(fieldType, baseContext) {
        return {
            field_type: fieldType,
            ...baseContext,
            extra: {
                ...baseContext
            }
        };
    }
    resolveRuleForContext(fieldType, context) {
        const matched = [];
        for (const scope of this.scopes){
            if (!scope.matchesContext(context)) continue;
            const applicable = scope.iterFieldRules(fieldType);
            for (const rule of applicable)matched.push([
                scope,
                rule
            ]);
        }
        if (matched.length === 0) return undefined;
        return this.assembleRulePayload(matched);
    }
    assembleRulePayload(matched) {
        let cleaningSteps = [];
        let validationChecks = [];
        const options = {
            fallback_to_builtin: true
        };
        const ruleTrace = [];
        const presetsApplied = [];
        const appliedRulesMetadata = [];
        for (const [scope, rule] of matched){
            const [cleaningStrategy, validationStrategy] = $2a37b32211ef6428$var$normalizeMergeStrategy(rule.mergeStrategy);
            if (cleaningStrategy === "replace" || cleaningStrategy === "replace_all") cleaningSteps = [];
            if (validationStrategy === "replace" || validationStrategy === "replace_all") validationChecks = [];
            for (const presetId of rule.presets){
                const preset = this.presets.get(presetId);
                if (!preset) {
                    console.warn(`Referenced validation preset '${presetId}' not found for scope '${scope.scopeId}'`);
                    continue;
                }
                if (preset.cleaningSteps.length > 0) cleaningSteps = $2a37b32211ef6428$var$applyWithStrategy(cleaningSteps, preset.cleaningSteps, cleaningStrategy);
                if (preset.validationChecks.length > 0) validationChecks = $2a37b32211ef6428$var$applyWithStrategy(validationChecks, preset.validationChecks, validationStrategy);
                presetsApplied.push(presetId);
            }
            if (rule.cleaningSteps.length > 0) cleaningSteps = $2a37b32211ef6428$var$applyWithStrategy(cleaningSteps, rule.cleaningSteps, cleaningStrategy);
            if (rule.validationChecks.length > 0) validationChecks = $2a37b32211ef6428$var$applyWithStrategy(validationChecks, rule.validationChecks, validationStrategy);
            Object.assign(options, rule.options ?? {});
            ruleTrace.push({
                scope_id: scope.scopeId,
                rule_id: rule.ruleId,
                priority: scope.priority,
                scope_description: scope.description ?? null,
                rule_description: rule.description ?? null
            });
            appliedRulesMetadata.push({
                scope_id: scope.scopeId,
                scope_priority: scope.priority,
                rule_id: rule.ruleId,
                scope_metadata: scope.metadata,
                rule_metadata: rule.metadata
            });
        }
        const metadata = {
            config_version: this.configVersion,
            rules_applied: appliedRulesMetadata
        };
        if (Object.keys(this.configMetadata).length > 0) metadata.configuration_metadata = this.configMetadata;
        return {
            cleaning_steps: cleaningSteps,
            validation_checks: validationChecks,
            options: options,
            rule_trace: ruleTrace,
            presets_applied: presetsApplied,
            metadata: metadata,
            source: "configuration"
        };
    }
    applyConfiguration(configData) {
        const payload = $2a37b32211ef6428$var$deepCopy(configData ?? {});
        this.presets.clear();
        this.scopes = [];
        this.configuredFieldTypes.clear();
        this.configVersion = typeof payload.version === "string" ? payload.version : undefined;
        this.configMetadata = (payload.metadata && typeof payload.metadata === "object" ? payload.metadata : {}) ?? {};
        const presets = payload.presets ?? {};
        for (const [presetId, presetConfigRaw] of Object.entries(presets)){
            if (!presetConfigRaw || typeof presetConfigRaw !== "object") continue;
            const presetConfig = presetConfigRaw;
            const cleaningSteps = presetConfig.cleaning_steps ?? presetConfig.cleaningSteps ?? [];
            const validationChecks = presetConfig.validation_checks ?? presetConfig.validationChecks ?? [];
            const metadata = presetConfig.metadata ?? presetConfigRaw;
            this.presets.set(presetId, {
                presetId: presetId,
                cleaningSteps: $2a37b32211ef6428$var$deepCopy(cleaningSteps),
                validationChecks: $2a37b32211ef6428$var$deepCopy(validationChecks),
                metadata: $2a37b32211ef6428$var$deepCopy(metadata ?? {})
            });
        }
        const compiledScopes = [];
        const scopesArray = payload.scopes ?? [];
        scopesArray.forEach((scopeConfig, index)=>{
            if (!scopeConfig) return;
            const scopeId = scopeConfig.id ?? $2a37b32211ef6428$var$buildScopeId([
                "scope",
                String(index)
            ]);
            const fieldRulesPayload = scopeConfig.field_rules ?? scopeConfig.fieldRules ?? [];
            const fieldRules = fieldRulesPayload.map((ruleConfig, ruleIndex)=>{
                if (!ruleConfig) return undefined;
                const fieldTypesRaw = ruleConfig.field_types ?? ruleConfig.fieldTypes ?? [];
                const fieldTypes = fieldTypesRaw.length > 0 ? fieldTypesRaw : [
                    "*"
                ];
                const ruleId = ruleConfig.id ?? $2a37b32211ef6428$var$buildScopeId([
                    scopeId,
                    "rule",
                    String(ruleIndex)
                ]);
                const definition = new $2a37b32211ef6428$var$FieldRuleDefinition({
                    ruleId: ruleId,
                    fieldTypes: fieldTypes,
                    presets: ruleConfig.presets ?? ruleConfig.preset_ids ?? [],
                    cleaningSteps: ruleConfig.cleaning_steps ?? ruleConfig.cleaningSteps ?? [],
                    validationChecks: ruleConfig.validation_checks ?? ruleConfig.validationChecks ?? [],
                    mergeStrategy: ruleConfig.merge_strategy ?? ruleConfig.mergeStrategy,
                    options: ruleConfig.options ?? {},
                    description: ruleConfig.description ?? null,
                    metadata: ruleConfig.metadata ?? {}
                });
                definition.fieldTypes.forEach((field)=>this.configuredFieldTypes.add(field));
                return definition;
            }).filter((rule)=>Boolean(rule));
            if (fieldRules.length === 0) return;
            const scope = new $2a37b32211ef6428$var$RuleScope({
                scopeId: scopeId,
                priority: Number(scopeConfig.priority ?? 100),
                conditions: scopeConfig.conditions ?? {},
                fieldRules: fieldRules,
                enabled: scopeConfig.enabled ?? true,
                description: scopeConfig.description ?? null,
                metadata: scopeConfig.metadata ?? {}
            });
            compiledScopes.push(scope);
        });
        this.buildScopesFromHierarchy(payload, compiledScopes);
        compiledScopes.sort((a, b)=>a.priority - b.priority);
        this.scopes = compiledScopes;
    }
    buildScopesFromHierarchy(config, compiledScopes) {
        const appendScope = (scopeId, priority, conditions, fieldMap, description, metadata)=>{
            const fieldRules = this.createFieldRulesFromMap(scopeId, fieldMap);
            if (fieldRules.length === 0) return;
            compiledScopes.push(new $2a37b32211ef6428$var$RuleScope({
                scopeId: scopeId,
                priority: priority,
                conditions: conditions,
                fieldRules: fieldRules,
                description: description,
                metadata: metadata
            }));
        };
        const globalSection = config.global ?? {};
        if (globalSection.fields && typeof globalSection.fields === "object") appendScope("global-fields", 100, {}, globalSection.fields, globalSection.description ?? null, globalSection.metadata ?? {});
        const businessAreas = config.business_areas ?? {};
        for (const [businessArea, businessConfig] of Object.entries(businessAreas)){
            const baseConditions = {
                business_area: [
                    businessArea
                ]
            };
            appendScope(`business-area-${businessArea}`, 200, baseConditions, businessConfig.fields ?? {}, businessConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(businessConfig.metadata, {
                business_area: businessArea
            }));
            const classes = businessConfig.document_classes ?? {};
            for (const [documentClass, classConfig] of Object.entries(classes))appendScope(`business-area-${businessArea}-class-${documentClass}`, 230, {
                business_area: [
                    businessArea
                ],
                document_class: [
                    documentClass
                ]
            }, classConfig.fields ?? {}, classConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(classConfig.metadata, {
                business_area: businessArea,
                document_class: documentClass
            }));
            const useCases = businessConfig.use_cases ?? {};
            for (const [useCase, useCaseConfig] of Object.entries(useCases))appendScope(`business-area-${businessArea}-use-case-${useCase}`, 240, {
                business_area: [
                    businessArea
                ],
                use_case: [
                    useCase
                ]
            }, useCaseConfig.fields ?? {}, useCaseConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(useCaseConfig.metadata, {
                business_area: businessArea,
                use_case: useCase
            }));
        }
        const documentClasses = config.document_classes ?? {};
        for (const [documentClass, docConfig] of Object.entries(documentClasses))appendScope(`document-class-${documentClass}`, 250, {
            document_class: [
                documentClass
            ]
        }, docConfig.fields ?? {}, docConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(docConfig.metadata, {
            document_class: documentClass
        }));
        const useCases = config.use_cases ?? {};
        for (const [useCase, useCaseConfig] of Object.entries(useCases))appendScope(`use-case-${useCase}`, 260, {
            use_case: [
                useCase
            ]
        }, useCaseConfig.fields ?? {}, useCaseConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(useCaseConfig.metadata, {
            use_case: useCase
        }));
        const processors = config.processors ?? {};
        for (const [processorId, processorConfig] of Object.entries(processors)){
            appendScope(`processor-${processorId}`, 300, {
                processor_id: [
                    processorId
                ]
            }, processorConfig.fields ?? {}, processorConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(processorConfig.metadata, {
                processor_id: processorId
            }));
            const processorClasses = processorConfig.document_classes ?? {};
            for (const [documentClass, docConfig] of Object.entries(processorClasses))appendScope(`processor-${processorId}-class-${documentClass}`, 340, {
                processor_id: [
                    processorId
                ],
                document_class: [
                    documentClass
                ]
            }, docConfig.fields ?? {}, docConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(docConfig.metadata, {
                processor_id: processorId,
                document_class: documentClass
            }));
            const processorUseCases = processorConfig.use_cases ?? {};
            for (const [useCase, useCaseConfig] of Object.entries(processorUseCases))appendScope(`processor-${processorId}-use-case-${useCase}`, 345, {
                processor_id: [
                    processorId
                ],
                use_case: [
                    useCase
                ]
            }, useCaseConfig.fields ?? {}, useCaseConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(useCaseConfig.metadata, {
                processor_id: processorId,
                use_case: useCase
            }));
            const processorBusinessAreas = processorConfig.business_areas ?? {};
            for (const [businessArea, businessConfig] of Object.entries(processorBusinessAreas)){
                appendScope(`processor-${processorId}-business-area-${businessArea}`, 350, {
                    processor_id: [
                        processorId
                    ],
                    business_area: [
                        businessArea
                    ]
                }, businessConfig.fields ?? {}, businessConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(businessConfig.metadata, {
                    processor_id: processorId,
                    business_area: businessArea
                }));
                const docClasses = businessConfig.document_classes ?? {};
                for (const [documentClass, docConfig] of Object.entries(docClasses))appendScope(`processor-${processorId}-business-area-${businessArea}-class-${documentClass}`, 360, {
                    processor_id: [
                        processorId
                    ],
                    business_area: [
                        businessArea
                    ],
                    document_class: [
                        documentClass
                    ]
                }, docConfig.fields ?? {}, docConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(docConfig.metadata, {
                    processor_id: processorId,
                    business_area: businessArea,
                    document_class: documentClass
                }));
                const useCaseSection = businessConfig.use_cases ?? {};
                for (const [useCase, useCaseConfig] of Object.entries(useCaseSection))appendScope(`processor-${processorId}-business-area-${businessArea}-use-case-${useCase}`, 365, {
                    processor_id: [
                        processorId
                    ],
                    business_area: [
                        businessArea
                    ],
                    use_case: [
                        useCase
                    ]
                }, useCaseConfig.fields ?? {}, useCaseConfig.description ?? null, $2a37b32211ef6428$var$mergeMetadata(useCaseConfig.metadata, {
                    processor_id: processorId,
                    business_area: businessArea,
                    use_case: useCase
                }));
            }
        }
    }
    createFieldRulesFromMap(scopeId, fieldMap) {
        const fieldRules = [];
        for (const [fieldType, definitionRaw] of Object.entries(fieldMap ?? {})){
            if (!definitionRaw || typeof definitionRaw !== "object") continue;
            const definition = definitionRaw;
            const ruleId = $2a37b32211ef6428$var$buildScopeId([
                scopeId,
                fieldType
            ]);
            const fieldTypes = definition.field_types ?? definition.fieldTypes ?? [
                fieldType === "*" ? "*" : fieldType
            ];
            const rule = new $2a37b32211ef6428$var$FieldRuleDefinition({
                ruleId: ruleId,
                fieldTypes: fieldTypes,
                presets: definition.presets ?? definition.preset_ids ?? [],
                cleaningSteps: definition.cleaning_steps ?? definition.cleaningSteps ?? [],
                validationChecks: definition.validation_checks ?? definition.validationChecks ?? [],
                mergeStrategy: definition.merge_strategy ?? definition.mergeStrategy,
                options: definition.options ?? {},
                description: definition.description ?? null,
                metadata: definition.metadata ?? {}
            });
            rule.fieldTypes.forEach((field)=>this.configuredFieldTypes.add(field));
            fieldRules.push(rule);
        }
        return fieldRules;
    }
    constructor(){
        this.presets = new Map();
        this.scopes = [];
        this.configuredFieldTypes = new Set();
        this.configMetadata = {};
    }
}
const $2a37b32211ef6428$export$150ebafc7ab2ff65 = new $2a37b32211ef6428$var$FrontendValidationRuleEngine();
const $2a37b32211ef6428$var$cloneEntity = (entity)=>entity ? JSON.parse(JSON.stringify(entity)) : entity;
const $2a37b32211ef6428$var$validateEntityTree = (entity, engine, context, collector)=>{
    if (!entity || typeof entity !== "object") return entity;
    const cloned = $2a37b32211ef6428$var$cloneEntity(entity);
    const fieldType = typeof entity.type === "string" ? entity.type : "";
    const mentionText = entity.mentionText != null ? String(entity.mentionText) : entity.mention_text != null ? String(entity.mention_text) : "";
    if (fieldType && mentionText) {
        const result = engine.validateField(fieldType, mentionText, context);
        collector.push(result);
        cloned.mentionText = result.cleanedValue;
        if ("mention_text" in cloned || entity.mention_text !== undefined) cloned.mention_text = result.cleanedValue;
    }
    if (Array.isArray(entity.properties)) cloned.properties = entity.properties.map((child)=>$2a37b32211ef6428$var$validateEntityTree(child, engine, context, collector));
    return cloned;
};
const $2a37b32211ef6428$export$b5f0e92079d91d44 = async (options)=>{
    const { entities: entities, context: context, accessToken: accessToken, idToken: idToken, environment: environment, projectId: projectId } = options;
    await $2a37b32211ef6428$export$150ebafc7ab2ff65.ensureConfigLoaded({
        accessToken: accessToken,
        idToken: idToken,
        environment: environment,
        projectId: projectId
    });
    const results = [];
    const cleanedEntities = entities.map((entity)=>$2a37b32211ef6428$var$validateEntityTree(entity, $2a37b32211ef6428$export$150ebafc7ab2ff65, context, results));
    const errors = results.filter((result)=>!result.isValid);
    const warnings = results.filter((result)=>result.isValid && result.warnings.length > 0);
    return {
        cleanedEntities: cleanedEntities,
        fieldResults: results,
        errors: errors,
        warnings: warnings,
        configVersion: $2a37b32211ef6428$export$150ebafc7ab2ff65.getConfigVersion()
    };
};


/**
 * Save Queue Manager for Non-blocking Document Saves
 *
 * Manages background save operations to prevent blocking the UI
 * while documents are being saved to GCS, Firestore, and callback URLs.
 */ 
var $a30lF = parcelRequire("a30lF");
class $43dc3253d70ebbd2$export$27d8c6d754335802 extends EventTarget {
    /**
   * Add a save operation to the queue
   */ async enqueueSave(reviewRequest, accessToken, idToken, content, data, rejectReason, userId, getAccessToken) {
        const operationId = `save_${++this.nextOperationId}_${Date.now()}`;
        const operation = {
            id: operationId,
            reviewRequest: reviewRequest,
            accessToken: accessToken,
            idToken: idToken,
            content: content,
            data: data,
            rejectReason: rejectReason,
            userId: userId,
            status: 'pending',
            retryCount: 0,
            timestamp: new Date(),
            getAccessToken: getAccessToken
        };
        this.queue.push(operation);
        // Log operation enqueued
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: userId,
            action: 'Save operation enqueued',
            additionalInfo: {
                operationId: operationId,
                reviewRequestName: reviewRequest.name,
                queueLength: this.queue.length
            }
        });
        // Emit status change
        this.emitStatusChange();
        // Start processing if not already processing
        if (!this.processing) this.processQueue();
        return operationId;
    }
    /**
   * Process the queue - executes one save at a time
   */ async processQueue() {
        if (this.processing || this.queue.length === 0) return;
        this.processing = true;
        while(this.queue.length > 0){
            // Get next pending operation
            const operation = this.queue.find((op)=>op.status === 'pending');
            if (!operation) break;
            await this.executeOperation(operation);
        }
        this.processing = false;
        // Emit final status
        this.emitStatusChange();
    }
    /**
   * Execute a single save operation
   */ async executeOperation(operation) {
        operation.status = 'in_progress';
        this.emitStatusChange();
        try {
            // Refresh access token before save attempt (prevents expiration during queue processing)
            if (operation.getAccessToken) try {
                const [freshToken, idToken] = await operation.getAccessToken(false);
                operation.accessToken = freshToken;
                console.log(`Access token refreshed for save operation ${operation.id}`);
            } catch (tokenError) {
                console.warn('Failed to refresh access token, using existing token:', tokenError);
            // Continue with existing token - if it's expired, the save will fail and retry
            }
            // Log start of save
            (0, $a30lF.logAction)({
                timestamp: new Date().toISOString(),
                severity: 'INFO',
                userId: operation.userId,
                action: 'Save operation started',
                additionalInfo: {
                    operationId: operation.id,
                    reviewRequestName: operation.reviewRequest.name,
                    retryCount: operation.retryCount
                }
            });
            // Execute the actual save
            await operation.reviewRequest.saveContent(operation.accessToken, operation.idToken, operation.content, operation.data, operation.rejectReason);
            // Success!
            operation.status = 'completed';
            (0, $a30lF.logAction)({
                timestamp: new Date().toISOString(),
                severity: 'INFO',
                userId: operation.userId,
                action: 'Save operation completed successfully',
                additionalInfo: {
                    operationId: operation.id,
                    reviewRequestName: operation.reviewRequest.name,
                    retryCount: operation.retryCount
                }
            });
            // Emit completion event
            this.dispatchEvent(new CustomEvent('save-completed', {
                detail: {
                    operationId: operation.id,
                    reviewRequest: operation.reviewRequest
                }
            }));
            // Auto-cleanup: Remove completed operations after a short delay
            // This prevents memory leaks from queue growing indefinitely
            setTimeout(()=>{
                this.clearCompleted();
            }, 5000); // Clean up 5 seconds after completion
        } catch (error) {
            console.error('Save operation failed:', error);
            // Log the save operation failure with full details
            await (0, $a30lF.sendCriticalLog)({
                timestamp: new Date().toISOString(),
                severity: 'ERROR',
                userId: operation.userId,
                action: 'Save operation exception caught',
                additionalInfo: {
                    operationId: operation.id,
                    reviewRequestName: operation.reviewRequest.name,
                    taskId: operation.reviewRequest.taskId,
                    queue: operation.reviewRequest.queue,
                    retryCount: operation.retryCount,
                    maxRetries: this.MAX_RETRIES,
                    willRetry: operation.retryCount < this.MAX_RETRIES,
                    error: error.message || String(error),
                    errorStack: error.stack || 'No stack trace available'
                }
            });
            // Check if we should retry
            if (operation.retryCount < this.MAX_RETRIES) {
                operation.retryCount++;
                operation.status = 'pending'; // Reset to pending for retry
                operation.error = error.message || String(error);
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: 'WARNING',
                    userId: operation.userId,
                    action: 'Save operation failed, will retry',
                    additionalInfo: {
                        operationId: operation.id,
                        reviewRequestName: operation.reviewRequest.name,
                        retryCount: operation.retryCount,
                        maxRetries: this.MAX_RETRIES,
                        error: operation.error
                    }
                });
                // Wait before retry
                await new Promise((resolve)=>setTimeout(resolve, this.RETRY_DELAY_MS * operation.retryCount));
            } else {
                // Max retries exceeded
                operation.status = 'failed';
                operation.error = error.message || String(error);
                // Log critical save failure
                await (0, $a30lF.sendCriticalLog)({
                    timestamp: new Date().toISOString(),
                    severity: 'ERROR',
                    userId: operation.userId,
                    action: 'Save operation failed permanently - max retries exceeded',
                    additionalInfo: {
                        operationId: operation.id,
                        reviewRequestName: operation.reviewRequest.name,
                        taskId: operation.reviewRequest.taskId,
                        queue: operation.reviewRequest.queue,
                        retryCount: operation.retryCount,
                        maxRetries: this.MAX_RETRIES,
                        error: operation.error,
                        errorStack: error.stack || 'No stack trace available'
                    }
                });
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: 'ERROR',
                    userId: operation.userId,
                    action: 'Save operation failed permanently',
                    additionalInfo: {
                        operationId: operation.id,
                        reviewRequestName: operation.reviewRequest.name,
                        retryCount: operation.retryCount,
                        error: operation.error
                    }
                });
                // Emit failure event
                this.dispatchEvent(new CustomEvent('save-failed', {
                    detail: {
                        operationId: operation.id,
                        reviewRequest: operation.reviewRequest,
                        error: operation.error
                    }
                }));
                // Auto-cleanup: Remove failed operations after 30 seconds
                // Gives user time to see the error and manually retry if desired
                setTimeout(()=>{
                    this.clearCompleted();
                }, 30000); // Clean up 30 seconds after permanent failure
            }
        }
        this.emitStatusChange();
    }
    /**
   * Retry a failed operation
   */ async retryOperation(operationId) {
        const operation = this.queue.find((op)=>op.id === operationId && op.status === 'failed');
        if (operation) {
            operation.status = 'pending';
            operation.retryCount = 0; // Reset retry count
            operation.error = undefined;
            (0, $a30lF.logAction)({
                timestamp: new Date().toISOString(),
                severity: 'INFO',
                userId: operation.userId,
                action: 'Manual retry of failed save operation',
                additionalInfo: {
                    operationId: operation.id,
                    reviewRequestName: operation.reviewRequest.name
                }
            });
            this.emitStatusChange();
            if (!this.processing) this.processQueue();
        }
    }
    /**
   * Remove completed/failed operations from queue
   */ clearCompleted() {
        const beforeCount = this.queue.length;
        this.queue = this.queue.filter((op)=>op.status === 'pending' || op.status === 'in_progress');
        const removed = beforeCount - this.queue.length;
        if (removed > 0) {
            console.log(`Cleared ${removed} completed/failed save operations from queue`);
            this.emitStatusChange();
        }
    }
    /**
   * Get current queue status
   */ getStatus() {
        const status = {
            pending: 0,
            inProgress: 0,
            completed: 0,
            failed: 0,
            total: this.queue.length
        };
        for (const op of this.queue)switch(op.status){
            case 'pending':
                status.pending++;
                break;
            case 'in_progress':
                status.inProgress++;
                break;
            case 'completed':
                status.completed++;
                break;
            case 'failed':
                status.failed++;
                break;
        }
        return status;
    }
    /**
   * Check if there are any pending or in-progress operations
   */ hasPendingOperations() {
        return this.queue.some((op)=>op.status === 'pending' || op.status === 'in_progress');
    }
    /**
   * Get all operations (for debugging/monitoring)
   */ getAllOperations() {
        return [
            ...this.queue
        ];
    }
    /**
   * Emit status change event
   */ emitStatusChange() {
        const status = this.getStatus();
        this.dispatchEvent(new CustomEvent('status-changed', {
            detail: status
        }));
    }
    constructor(...args){
        super(...args), this.queue = [], this.processing = false, this.MAX_RETRIES = 3, this.RETRY_DELAY_MS = 2000, this.nextOperationId = 0;
    }
}
const $43dc3253d70ebbd2$export$7b3128b0a24a6b60 = new $43dc3253d70ebbd2$export$27d8c6d754335802();



var $a30lF = parcelRequire("a30lF");

var $ad42dc5b6815f2da$require$Buffer = $136d40cdb268fe10$export$a143d493d941bafc;



// Lazy load Material Components only when needed
const $ad42dc5b6815f2da$var$loadMaterialComponents = async ()=>{
    const [{}, {}, {}] = await Promise.all([
        Promise.resolve((parcelRequire("8qnmK"))),
        Promise.resolve((parcelRequire("8J3FQ"))),
        Promise.resolve((parcelRequire("31pE8")))
    ]);
};
const $ad42dc5b6815f2da$var$MINIMUM_SAVE_INTERVAL_SECONDS = 5;
const $ad42dc5b6815f2da$var$MINIMUM_SAVE_INTERVAL_MS = $ad42dc5b6815f2da$var$MINIMUM_SAVE_INTERVAL_SECONDS * 1000;
const $ad42dc5b6815f2da$var$QUARANTINE_MAX_ATTEMPTS = 3;
const $ad42dc5b6815f2da$var$QUARANTINE_RETRY_DELAY_MS = 1000;
var $ad42dc5b6815f2da$var$NavEvent = /*#__PURE__*/ function(NavEvent) {
    NavEvent[NavEvent["BACK"] = 0] = "BACK";
    NavEvent[NavEvent["PREVIOUS"] = 1] = "PREVIOUS";
    NavEvent[NavEvent["NEXT"] = 2] = "NEXT";
    return NavEvent;
}($ad42dc5b6815f2da$var$NavEvent || {});

class $ad42dc5b6815f2da$export$6fffb60373372c0 extends (0, $9cd293958617bb59$export$3f2f9f5909897157) {
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        // Attach a global change event listener to log field changes and update state
        this.addEventListener("change", this.handleFieldChange);
        // Initialize keyboard shortcuts with all handler functions
        (0, $562a56af2be4988d$export$c6962176354dc525).initialize({
            sendToClearing: this.clickClearingButton.bind(this),
            sendToIrrlaeufer: this.sendToIrrlaeufer.bind(this),
            deleteCase: this.deleteProcess.bind(this),
            deleteExtractedFields: this.clearAllExtractedFields.bind(this),
            exitWithoutSaving: this.exitWithoutSaving.bind(this),
            nextFieldOrCompleteCase: this.navigateToNextFieldOrComplete.bind(this),
            clickSaveButton: this.clickSaveButton.bind(this),
            selectClassById: this.selectClassById.bind(this),
            showDigitBufferFeedback: this.showDigitBufferFeedback.bind(this),
            hideDigitBufferFeedback: this.hideDigitBufferFeedback.bind(this),
            zoomIn: this.zoomIn.bind(this),
            zoomOut: this.zoomOut.bind(this),
            zoomToFit: this.zoomToFit.bind(this),
            undo: this.undo.bind(this),
            redo: this.redo.bind(this)
        });
        // Activate keyboard shortcuts
        (0, $562a56af2be4988d$export$c6962176354dc525).activate();
        // Set up save queue event listeners
        this.setupSaveQueueListeners();
        // start reviewing first document
        this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
    }
    setupSaveQueueListeners() {
        // Listen for save queue status changes
        (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).addEventListener('status-changed', (event)=>{
            this.saveQueueStatus = event.detail;
            this.requestUpdate();
        });
        // Listen for successful saves
        (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).addEventListener('save-completed', (event)=>{
            const { reviewRequest: reviewRequest } = event.detail;
            this.showTemporaryNotification(`\u{2705} Dokument "${reviewRequest.name}" erfolgreich gespeichert`, 3000);
        });
        // Listen for failed saves
        (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).addEventListener('save-failed', (event)=>{
            const { reviewRequest: reviewRequest, error: error } = event.detail;
            this.showTemporaryNotification(`\u{274C} Fehler beim Speichern von "${reviewRequest.name}": ${error}`, 5000);
        });
    }
    resolveEnvironment() {
        const hitlApp = document.querySelector("hitl-app");
        const detected = hitlApp?.detectedEnvironment;
        if (typeof detected === "string" && detected.trim().length > 0) return detected.trim();
        const prefix = "DEFAULT_CLIENT_PREFIX";
        const envName = "DEFAULT_ENVIRONMENT";
        if (prefix && envName) return `${prefix}-${envName}`;
        return undefined;
    }
    resolveProjectId(reviewRequest) {
        const envProject = "DEFAULT_PROJECT_ID";
        if (typeof envProject === "string" && envProject.trim().length > 0) return envProject.trim();
        if (reviewRequest instanceof (0, $20e0088800729d63$export$9fee94aa43a40124)) {
            if (reviewRequest.projectId && reviewRequest.projectId.trim().length > 0) return reviewRequest.projectId.trim();
        }
        const data = reviewRequest.data ?? {};
        const processedData = data.documentData?.processed_data ?? data.processed_data ?? {};
        const directProject = this.pickFirstString(data, [
            "project_id",
            "projectId",
            "metadata.project_id",
            "metadata.projectId",
            "documentData.project_id",
            "documentData.projectId",
            "documentData.metadata.project_id",
            "documentData.metadata.projectId",
            "documentData.processed_data.project_id",
            "documentData.processed_data.projectId"
        ]);
        if (directProject) return directProject;
        const processorProject = this.pickFirstString(processedData, [
            "processorProject",
            "processor_project"
        ]) ?? this.pickFirstString(data, [
            "processorProject",
            "processor_project"
        ]);
        if (processorProject) {
            const match = processorProject.match(/projects\/([^/]+)/);
            if (match) return match[1];
        }
        return undefined;
    }
    buildValidationContext(reviewRequest, reviewedDocumentJson) {
        const data = reviewRequest.data ?? {};
        const processedData = data.documentData?.processed_data ?? data.processed_data ?? {};
        const metadata = data.documentData?.metadata ?? data.metadata ?? {};
        const docMetadata = reviewedDocumentJson?.metadata ?? {};
        const context = {};
        context.business_area = this.pickFirstString(data, [
            "business_area"
        ]) ?? this.pickFirstString(processedData, [
            "business_area"
        ]) ?? this.pickFirstString(metadata, [
            "business_area"
        ]) ?? this.pickFirstString(docMetadata, [
            "business_area"
        ]);
        context.use_case = this.pickFirstString(data, [
            "use_case",
            "use_case_id"
        ]) ?? this.pickFirstString(processedData, [
            "use_case",
            "use_case_id"
        ]) ?? this.pickFirstString(metadata, [
            "use_case",
            "use_case_id"
        ]) ?? this.pickFirstString(docMetadata, [
            "use_case",
            "use_case_id"
        ]);
        context.document_class = this.pickFirstString(data, [
            "document_class"
        ]) ?? this.pickFirstString(processedData, [
            "document_class"
        ]) ?? this.pickFirstString(metadata, [
            "document_class"
        ]) ?? this.pickFirstString(docMetadata, [
            "document_class"
        ]);
        context.processor_id = this.pickFirstString(data, [
            "processor_id"
        ]) ?? this.pickFirstString(processedData, [
            "processorId",
            "processor_id"
        ]) ?? (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? this.pickFirstString(reviewRequest.data?.documentData?.processed_data ?? {}, [
            "processorId",
            "processor_id"
        ]) : undefined);
        context.processor_type = this.pickFirstString(processedData, [
            "processorType",
            "processor_type"
        ]) ?? this.pickFirstString(data, [
            "processor_type"
        ]) ?? (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? reviewRequest.processorType : typeof reviewRequest.type === "string" ? reviewRequest.type : undefined);
        return Object.fromEntries(Object.entries(context).filter(([, value])=>typeof value === "string" && value.trim().length > 0));
    }
    pickFirstString(source, paths) {
        for (const path of paths){
            const value = this.readNestedValue(source, path);
            if (typeof value === "string" && value.trim().length > 0) return value.trim();
        }
        return undefined;
    }
    readNestedValue(source, path) {
        if (!source || typeof source !== "object") return undefined;
        const segments = path.split(".");
        let current = source;
        for (const segment of segments){
            if (!current || typeof current !== "object") return undefined;
            current = current[segment];
        }
        return current;
    }
    showValidationErrorDialog(dialog, errors, version) {
        if (!dialog) {
            console.error("Validierungsfehler:", errors);
            return;
        }
        const versionSuffix = version ? ` (Regelversion ${version})` : "";
        dialog.heading = "Dokumentvalidierung fehlgeschlagen";
        (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`Die folgenden Validierungsfehler wurden festgestellt${versionSuffix}:<br/>
            <ul>
                ${errors.map((error)=>(0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                    <li>${error}</li>`)}
            </ul>
            <mwc-button slot="primaryAction" dialogAction="ok">OK</mwc-button>`, dialog);
        dialog.open = true;
    }
    render() {
        return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
            <div id="documentAgainInHINTBanner"
                 style="height: 2vh; line-height: 2.2vh; color: rgb(255, 255, 255); text-align: center; background-color: rgb(176, 0, 32); display: none;">
                Dieses Dokument war bereits <span id="hintTrackerCount"></span> Mal im HINT. Bitte prüfen Sie die
                Pflichtfelder genau, damit das Dokument korrekt verarbeitet werden kann.
            </div>

            <!-- Save Status Indicator -->
            ${this.renderSaveStatusIndicator()}

            <!-- Keyboard Shortcuts Dialog -->
            <keyboard-shortcuts-dialog
                @click=${this.closeKeyboardShortcutsOnBackdrop}>
            </keyboard-shortcuts-dialog>

            <div class="content-div"></div>
        `;
    }
    /**
     * Open the custom keyboard shortcuts dialog
     */ async openKeyboardShortcuts() {
        console.log('Opening keyboard shortcuts dialog...');
        // Wait for next update cycle to ensure dialog is rendered
        await this.updateComplete;
        // Try multiple ways to find the dialog
        let dialog = this.shadowRoot?.querySelector('keyboard-shortcuts-dialog');
        if (!dialog) dialog = this.renderRoot?.querySelector('keyboard-shortcuts-dialog');
        if (!dialog) // Try querying from document
        dialog = document.querySelector('keyboard-shortcuts-dialog');
        console.log('Dialog element:', dialog);
        console.log('ShadowRoot:', this.shadowRoot);
        console.log('RenderRoot:', this.renderRoot);
        if (dialog) {
            console.log('Calling show() on dialog');
            dialog.show();
        } else {
            console.error('Keyboard shortcuts dialog not found!');
            // Debug: list all elements in shadow DOM
            const allElements = this.shadowRoot?.querySelectorAll('*');
            console.log('All elements in shadow DOM:', allElements);
        }
    }
    /**
     * Close the keyboard shortcuts dialog when clicking on backdrop
     */ closeKeyboardShortcutsOnBackdrop(e) {
        if (e.target === e.currentTarget) {
            const dialog = this.shadowRoot?.querySelector('keyboard-shortcuts-dialog');
            if (dialog) dialog.close();
        }
    }
    renderSaveStatusIndicator() {
        // Only show if there are pending or in-progress saves
        if (this.saveQueueStatus.pending === 0 && this.saveQueueStatus.inProgress === 0 && this.saveQueueStatus.failed === 0) return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)``;
        const totalActive = this.saveQueueStatus.pending + this.saveQueueStatus.inProgress;
        return (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
            <style>
                .save-status-indicator {
                    position: fixed;
                    top: 80px;
                    right: 20px;
                    background: #4CAF50;
                    color: white;
                    padding: 12px 20px;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    font-family: 'Roboto', sans-serif;
                    font-size: 14px;
                    z-index: 9999;
                    min-width: 200px;
                    animation: slideIn 0.3s ease;
                }

                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }

                .save-status-header {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 8px;
                    font-weight: 600;
                }

                .save-status-spinner {
                    width: 16px;
                    height: 16px;
                    border: 2px solid rgba(255, 255, 255, 0.3);
                    border-top-color: white;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                }

                @keyframes spin {
                    to {
                        transform: rotate(360deg);
                    }
                }

                .save-status-details {
                    font-size: 12px;
                    opacity: 0.9;
                    margin-top: 4px;
                }

                .save-status-failed {
                    background: #f44336;
                    cursor: pointer;
                }

                .save-status-failed:hover {
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
                }
            </style>

            <div class="save-status-indicator ${this.saveQueueStatus.failed > 0 ? 'save-status-failed' : ''}"
                 @click=${this.handleRetryFailedSaves}>
                <div class="save-status-header">
                    ${this.saveQueueStatus.inProgress > 0 ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                        <div class="save-status-spinner"></div>` : ''}
                    <span>
            ${this.saveQueueStatus.failed > 0 ? "\u274C Speicherfehler" : "\uD83D\uDCBE Speichert..."}
          </span>
                </div>
                <div class="save-status-details">
                    ${this.saveQueueStatus.inProgress > 0 ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`⏳ ${this.saveQueueStatus.inProgress} aktiv<br>` : ''}
                    ${this.saveQueueStatus.pending > 0 ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`📋 ${this.saveQueueStatus.pending} wartend<br>` : ''}
                    ${this.saveQueueStatus.failed > 0 ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                        <span style="color: #ffeb3b;">⚠️ ${this.saveQueueStatus.failed} fehlgeschlagen</span><br>
                        <span style="font-size: 11px; text-decoration: underline;">Klicken zum erneuten Versuch</span>
                    ` : ''}
                </div>
            </div>
        `;
    }
    handleRetryFailedSaves() {
        // Only retry if there are failed saves
        if (this.saveQueueStatus.failed === 0) return;
        // Get all failed operations
        const allOperations = (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).getAllOperations();
        const failedOperations = allOperations.filter((op)=>op.status === 'failed');
        if (failedOperations.length === 0) return;
        // Log retry action
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: this.userId,
            action: 'Manual retry of failed saves initiated',
            additionalInfo: {
                failedCount: failedOperations.length,
                operationIds: failedOperations.map((op)=>op.id)
            }
        });
        // Retry all failed operations
        failedOperations.forEach((operation)=>{
            (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).retryOperation(operation.id);
        });
        // Show feedback
        this.showTemporaryNotification(`${failedOperations.length} fehlgeschlagene Speichervorg\xe4nge werden erneut versucht...`, 3000);
    }
    batchInjectAccessTokens(urls, accessToken, gcsOnly = false) {
        // Optimized batch processing of URL token injection
        // Pre-compile the access token parameter to avoid repeated string concatenation
        const tokenParam = `access_token=${encodeURIComponent(accessToken)}`;
        return urls.map((url)=>{
            if (!url) return url;
            // For GCS-only mode, filter non-GCS URLs
            if (gcsOnly && !url.includes('storage.googleapis.com')) return url;
            // Optimized URL modification - avoid URL constructor when possible
            if (url.includes('?')) return `${url}&${tokenParam}`;
            else return `${url}?${tokenParam}`;
        });
    }
    showProgressiveLoadingState(message) {
        const contentDiv = this.renderRoot.querySelector(".content-div");
        if (contentDiv) contentDiv.innerHTML = `
        <div class="progressive-loading-container" style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 400px;
          color: #666;
          font-family: 'Roboto', sans-serif;
        ">
          <div class="loading-spinner" style="
            width: 40px;
            height: 40px;
            border: 4px solid #e0e0e0;
            border-top: 4px solid #1976d2;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            margin-bottom: 16px;
          "></div>
          <div class="loading-message" style="
            font-size: 16px;
            color: #424242;
            text-align: center;
          ">${message}</div>
        </div>
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `;
    }
    clearProgressiveLoadingState() {
        const contentDiv = this.renderRoot.querySelector(".content-div");
        if (contentDiv) {
            // Remove loading content - the actual document will be rendered by sdk.render
            const loadingContainer = contentDiv.querySelector(".progressive-loading-container");
            if (loadingContainer) loadingContainer.remove();
        }
    }
    async waitForAIUIToLoad() {
        return new Promise((resolve)=>{
            let attempts = 0;
            const maxAttempts = 100; // 10 seconds with 100ms intervals
            const checkForLoadedContent = ()=>{
                attempts++;
                const contentDiv = this.renderRoot.querySelector(".content-div");
                if (!contentDiv) {
                    if (attempts < maxAttempts) {
                        setTimeout(checkForLoadedContent, 100);
                        return;
                    } else {
                        console.warn("\u26A0\uFE0F Content div never found, proceeding anyway");
                        resolve();
                        return;
                    }
                }
                // Strategy 1: Check if the content div has any child elements at all
                const hasAnyContent = contentDiv.children.length > 0;
                // Strategy 2: Check for specific Google AI DocumentView patterns
                const aiPatterns = [
                    // Document AI specific patterns
                    'div[role="main"]',
                    'div[role="document"]',
                    'div[aria-label*="page"]',
                    'div[data-page]',
                    '*[class*="documentai"]',
                    '*[class*="document-ai"]',
                    // Image patterns
                    'img[src*="storage.googleapis.com"]',
                    'img[src*="googleusercontent.com"]',
                    'img[alt*="page"]',
                    // Canvas and interactive elements
                    'canvas',
                    'svg',
                    // Generic content indicators
                    'div[style*="width"]',
                    'div[style*="height"]' // Styled divs with height
                ];
                let foundValidContent = false;
                if (hasAnyContent) {
                    // Check for AI patterns
                    for (const pattern of aiPatterns){
                        const elements = contentDiv.querySelectorAll(pattern);
                        if (elements.length > 0) {
                            // For images, verify they're actually loaded
                            if (pattern.includes('img')) {
                                const images = Array.from(elements);
                                const loadedImages = images.filter((img)=>{
                                    return img.complete && img.naturalHeight > 0 && img.naturalWidth > 0;
                                });
                                if (loadedImages.length > 0) {
                                    console.log(`\u{1F3AF} Found ${loadedImages.length} loaded images via pattern: ${pattern}`);
                                    foundValidContent = true;
                                    break;
                                }
                            } else {
                                // For non-images, check if they have content or meaningful dimensions
                                const hasContent = Array.from(elements).some((el)=>{
                                    const htmlEl = el;
                                    return htmlEl.offsetHeight > 10 && htmlEl.offsetWidth > 10;
                                });
                                if (hasContent) {
                                    console.log(`\u{1F3AF} Found meaningful content via pattern: ${pattern}`);
                                    foundValidContent = true;
                                    break;
                                }
                            }
                        }
                    }
                    // Fallback: If content div has substantial content but no specific patterns match
                    if (!foundValidContent && contentDiv.innerHTML.length > 500) {
                        console.log("\uD83C\uDFAF Content div has substantial content, considering it loaded");
                        foundValidContent = true;
                    }
                }
                if (foundValidContent) {
                    console.log("\uD83C\uDFAF AI UI content detected and verified, waiting 200ms for final render");
                    setTimeout(resolve, 200);
                } else if (attempts >= maxAttempts) {
                    console.warn("\u26A0\uFE0F AI UI load detection timed out after 10 seconds, proceeding anyway");
                    console.log('Debug info:', {
                        contentDivExists: !!contentDiv,
                        childrenCount: contentDiv?.children.length || 0,
                        innerHTML: contentDiv?.innerHTML.substring(0, 200) || 'N/A'
                    });
                    resolve();
                } else // Continue checking every 100ms
                setTimeout(checkForLoadedContent, 100);
            };
            // Start checking immediately
            checkForLoadedContent();
        });
    }
    /**
     * Inject keyboard shortcuts button into AIUI toolbar
     */ injectKeyboardShortcutsButton() {
        // Wait for the AIUI toolbar to be available
        const checkForToolbar = ()=>{
            const contentDiv = this.renderRoot.querySelector(".content-div");
            if (!contentDiv) return;
            // Try to find the toolbar container in the shadow DOM
            const toolbar = contentDiv.querySelector('.main-panel-top-actions-left');
            if (toolbar && !toolbar.querySelector('.keyboard-shortcuts-toolbar-btn')) {
                console.log("\uD83C\uDFB9 Injecting keyboard shortcuts button into AIUI toolbar");
                // Create the button element
                const button = document.createElement('button');
                button.className = 'keyboard-shortcuts-toolbar-btn';
                button.title = "Tastaturk\xfcrzel anzeigen / Show keyboard shortcuts";
                button.setAttribute('aria-label', 'Keyboard shortcuts');
                // Create the icon
                const icon = document.createElement('mwc-icon');
                icon.textContent = 'keyboard';
                button.appendChild(icon);
                // Add click handler
                button.addEventListener('click', ()=>{
                    this.openKeyboardShortcuts();
                });
                // Inject the button into the toolbar
                toolbar.appendChild(button);
                console.log("\u2705 Keyboard shortcuts button injected successfully");
            }
        };
        // Try immediately and also retry a few times in case the toolbar loads later
        checkForToolbar();
        setTimeout(checkForToolbar, 100);
        setTimeout(checkForToolbar, 300);
        setTimeout(checkForToolbar, 500);
    }
    /**
     * Inject Irrläufer button into AIUI toolbar
     */ injectIrrlaueferButton() {
        // Wait for the AIUI toolbar to be available
        const checkForToolbar = ()=>{
            const contentDiv = this.renderRoot.querySelector(".content-div");
            if (!contentDiv) return;
            // Try to find the toolbar container in the shadow DOM
            const toolbar = contentDiv.querySelector('.main-panel-top-actions-left');
            if (toolbar && !toolbar.querySelector('.irrlaeufer-toolbar-btn')) {
                console.log("\uD83D\uDD00 Injecting Irrl\xe4ufer button into AIUI toolbar");
                // Create the button element
                const button = document.createElement('button');
                button.className = 'irrlaeufer-toolbar-btn';
                button.title = "Dokument als Irrl\xe4ufer markieren / Mark document as wrong business area";
                button.setAttribute('aria-label', "Irrl\xe4ufer");
                // Create the icon
                const icon = document.createElement('mwc-icon');
                icon.textContent = 'compare_arrows';
                button.appendChild(icon);
                // Add click handler
                button.addEventListener('click', ()=>{
                    this.sendToIrrlaeufer();
                });
                // Inject the button into the toolbar
                toolbar.appendChild(button);
                console.log("\u2705 Irrl\xe4ufer button injected successfully");
            }
        };
        // Try immediately and also retry a few times in case the toolbar loads later
        checkForToolbar();
        setTimeout(checkForToolbar, 100);
        setTimeout(checkForToolbar, 300);
        setTimeout(checkForToolbar, 500);
    }
    /**
     * Send document to Irrläufer with business area selection
     */ async sendToIrrlaeufer() {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        // Only works for Firestore review requests
        if (!(currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838))) {
            console.warn("Irrl\xe4ufer feature only available for Firestore requests");
            return;
        }
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: this.userId,
            action: "Send to Irrl\xe4ufer - Dialog Opened",
            additionalInfo: {
                reviewRequestName: currentRequest.name,
                envelopeId: currentRequest.envelopeId
            }
        });
        // Queue-to-business-area mapping loaded from infrastructure/locals.tf via environment variable
        const queueToBusinessAreaMap = JSON.parse("DEFAULT_QUEUE_BUSINESS_AREA_MAP");
        // Determine current business area from queue name
        const queueName = currentRequest.queue || '';
        let currentBusinessArea = 'Sonstige Bereiche'; // Default
        for (const [key, area] of Object.entries(queueToBusinessAreaMap))if (queueName.toLowerCase().includes(key)) {
            currentBusinessArea = area;
            break;
        }
        // Business areas loaded from infrastructure/locals.tf target_business_areas via environment variable
        const allBusinessAreas = JSON.parse("DEFAULT_BUSINESS_AREAS");
        // Filter out current business area from selectable options
        const selectableBusinessAreas = allBusinessAreas.filter((area)=>area !== currentBusinessArea);
        // Submit handler for Irrläufer form (shared by button click and Enter key)
        const handleSubmit = async ()=>{
            // Get values from DOM elements
            const selectField = document.getElementById('irrlaeufer-business-area');
            const textField = document.getElementById('irrlaeufer-comment');
            const businessArea = selectField?.value || '';
            const comment = textField?.value || '';
            const trimmedBusinessArea = businessArea.trim();
            const trimmedComment = comment.trim();
            if (!trimmedBusinessArea || !trimmedComment) {
                alert("Bitte w\xe4hlen Sie einen Gesch\xe4ftsbereich und geben Sie einen Kommentar ein.");
                return;
            }
            // Close dialog after validation passes
            dialog.open = false;
            // Complete the task immediately with irrlaeufer flag
            try {
                const [accessToken, idToken] = await this.getAccessToken();
                // Get the original Document AI JSON content
                const content = await currentRequest.getContent(accessToken);
                const contentString = JSON.stringify(content);
                // Build data object with irrlaeufer flag
                const data = {
                    documentId: currentRequest.documentId,
                    envelopeId: currentRequest.envelopeId,
                    processorType: currentRequest.processorType,
                    userId: this.userId,
                    flags: {
                        irrlaeufer: {
                            business_area: trimmedBusinessArea,
                            comment: trimmedComment
                        }
                    }
                };
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: 'INFO',
                    userId: this.userId,
                    action: "Queueing Irrl\xe4ufer save operation",
                    additionalInfo: {
                        reviewRequestName: currentRequest.name,
                        envelopeId: currentRequest.envelopeId,
                        businessArea: trimmedBusinessArea,
                        comment: trimmedComment
                    }
                });
                // Queue the save operation (no reject reason for Irrläufer)
                await (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).enqueueSave(currentRequest, accessToken, idToken, contentString, data, '', this.userId, this.getAccessToken.bind(this));
                // Show success message
                this.showTemporaryNotification(`\u{2713} Dokument als Irrl\xe4ufer markiert (${trimmedBusinessArea})`, 3000);
                // Move to next document immediately (save happens in background)
                this.proceedToNextDocument();
            } catch (error) {
                console.error("Error marking document as Irrl\xe4ufer:", error);
                alert("Fehler beim Speichern der Irrl\xe4ufer-Markierung. Bitte versuchen Sie es erneut.");
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: 'ERROR',
                    userId: this.userId,
                    action: "Failed to mark document as Irrl\xe4ufer",
                    additionalInfo: {
                        reviewRequestName: currentRequest.name,
                        envelopeId: currentRequest.envelopeId,
                        error: String(error)
                    }
                });
            }
        };
        // Keyboard handler for Enter key submission
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
            }
        };
        // Show dialog to get business area and comment from user
        const dialog = document.getElementById("dialog");
        if (dialog) {
            dialog.heading = "Irrl\xe4ufer";
            (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                    <p>Dieses Dokument gehört aktuell zu: <strong>${currentBusinessArea}</strong></p>
                    <p>Bitte wählen Sie den korrekten Geschäftsbereich und geben Sie einen Kommentar ein:</p>
                    <div style="margin: 16px 0;">
                        <label for="irrlaeufer-business-area" style="display: block; font-size: 12px; color: rgba(0, 0, 0, 0.6); margin-bottom: 4px;">Korrekter Geschäftsbereich *</label>
                        <select
                            id="irrlaeufer-business-area"
                            required
                            style="width: 100%; padding: 12px; font-size: 16px; border: 1px solid rgba(0, 0, 0, 0.38); border-radius: 4px; font-family: Roboto, sans-serif; background-color: white;"
                            @keydown=${handleKeyDown}
                        >
                            <option value="" disabled selected>Bitte wählen...</option>
                            ${selectableBusinessAreas.map((area)=>(0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                                <option value="${area}">${area}</option>
                            `)}
                        </select>
                    </div>
                    <mwc-textfield
                        id="irrlaeufer-comment"
                        label="Kommentar"
                        required
                        style="width: 100%; margin: 16px 0;"
                        maxlength="500"
                        helper="Max. 500 Zeichen"
                        @keydown=${handleKeyDown}
                    ></mwc-textfield>
                    <mwc-button
                        slot="secondaryAction"
                        dialogAction="cancel"
                    >Abbrechen</mwc-button>
                    <mwc-button
                        slot="primaryAction"
                        @click=${async (e)=>{
                e.preventDefault();
                await handleSubmit();
            }}
                    >Senden</mwc-button>
                `, dialog);
            dialog.open = true;
        }
    }
    logPerformanceMetrics(metrics, reviewRequest) {
        const roundedMetrics = {
            authTime: Math.round(metrics.authTime),
            contentLoadTime: Math.round(metrics.contentLoadTime),
            imageProcessingTime: Math.round(metrics.imageProcessingTime),
            renderTime: Math.round(metrics.renderTime),
            totalTime: Math.round(metrics.totalTime)
        };
        console.log("\uD83D\uDE80 Document Review Performance Metrics:", {
            documentName: reviewRequest.name,
            processorType: reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? reviewRequest.processorType : reviewRequest.type,
            pageCount: reviewRequest.pageImageUrls.length,
            metrics: roundedMetrics,
            breakdown: {
                authPercentage: Math.round(metrics.authTime / metrics.totalTime * 100),
                contentPercentage: Math.round(metrics.contentLoadTime / metrics.totalTime * 100),
                imagePercentage: Math.round(metrics.imageProcessingTime / metrics.totalTime * 100),
                renderPercentage: Math.round(metrics.renderTime / metrics.totalTime * 100)
            }
        });
        // Log performance action for analytics
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: "INFO",
            userId: this.userId,
            action: "Document Review Performance",
            additionalInfo: {
                reviewRequestName: reviewRequest.name,
                processorType: reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? reviewRequest.processorType : reviewRequest.type,
                pageCount: reviewRequest.pageImageUrls.length,
                ...roundedMetrics
            }
        });
    }
    async getAccessToken(refresh = false) {
        const accessToken = await new Promise((resolve, reject)=>{
            const getAccessToken = new CustomEvent("get-access-token", {
                bubbles: true,
                detail: {
                    refresh: refresh,
                    resolve: resolve,
                    reject: reject
                }
            });
            this.dispatchEvent(getAccessToken);
        });
        return accessToken;
    }
    async reviewDocument(reviewRequest) {
        if (!reviewRequest) {
            console.error('reviewDocument called with undefined reviewRequest');
            this.showProgressiveLoadingState("Keine Aufgaben verf\xfcgbar. Bitte versuchen Sie es sp\xe4ter erneut.");
            setTimeout(()=>this.clearProgressiveLoadingState(), 3000);
            return;
        }
        try {
            // Start performance monitoring
            const performanceMetrics = {
                startTime: performance.now(),
                authTime: 0,
                contentLoadTime: 0,
                imageProcessingTime: 0,
                renderTime: 0,
                totalTime: 0
            };
            this.rejectReason = "";
            // Show immediate loading feedback
            this.showProgressiveLoadingState("Initializing components...");
            // Lazy load Material Components if not already loaded
            await $ad42dc5b6815f2da$var$loadMaterialComponents();
            // Update loading state
            this.showProgressiveLoadingState("Authenticating...");
            const authStart = performance.now();
            const [accessToken, idToken] = await this.getAccessToken();
            performanceMetrics.authTime = performance.now() - authStart;
            // Log the start of a document review with enriched info
            (0, $a30lF.logAction)({
                timestamp: new Date().toISOString(),
                severity: "INFO",
                userId: this.userId,
                action: "Started document review",
                additionalInfo: {
                    reviewRequestName: reviewRequest.name,
                    batch_id: reviewRequest.data?.batch_id,
                    envelope_id: reviewRequest.data?.envelope_id,
                    processorType: reviewRequest.data?.processorType,
                    queue: reviewRequest.queue
                }
            });
            // Update loading state
            this.showProgressiveLoadingState("Loading document content...");
            const contentStart = performance.now();
            const json = await reviewRequest.getContent(accessToken);
            performanceMetrics.contentLoadTime = performance.now() - contentStart;
            // Update loading state
            this.showProgressiveLoadingState("Processing images...");
            const imageStart = performance.now();
            // Optimized batch access token injection for page image URLs
            let pageImageUrls;
            if (reviewRequest instanceof (0, $20e0088800729d63$export$9fee94aa43a40124)) pageImageUrls = this.batchInjectAccessTokens(reviewRequest.pageImageUrls, accessToken);
            else if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) // For Firestore requests, add access tokens to GCS URLs for authentication
            pageImageUrls = this.batchInjectAccessTokens(reviewRequest.pageImageUrls, accessToken, true);
            else pageImageUrls = reviewRequest.pageImageUrls;
            performanceMetrics.imageProcessingTime = performance.now() - imageStart;
            console.log('DEBUG reviewDocument - reviewRequest type:', reviewRequest.constructor.name);
            console.log('DEBUG reviewDocument - json keys:', Object.keys(json || {}));
            console.log('DEBUG reviewDocument - json is Document AI format:', !!json.pages && !!json.entities);
            console.log('DEBUG reviewDocument - pageImageUrls count:', pageImageUrls.length);
            console.log('DEBUG reviewDocument - pageImageUrls:', pageImageUrls);
            console.log('DEBUG reviewDocument - processorType:', reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? reviewRequest.processorType : reviewRequest.type);
            // initialize human review state
            this.humanRevisionState = "requested";
            this.humanRevisionStateMessage = "";
            if (reviewRequest.labels.length === 0) {
                console.log("This is the reviewRequest", reviewRequest);
                // Handle Firestore review requests
                if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) {
                    console.log("DEBUG - Processing Firestore review request");
                    console.log("DEBUG - Processor type:", reviewRequest.processorType);
                    console.log("DEBUG - Full Firestore task data:", reviewRequest.data);
                    console.log("DEBUG - Document AI JSON entities:", json.entities);
                    // For Firestore classification, the labels come from the processed_data
                    // which contains the complete handle_prediction_result output
                    const taskLabels = reviewRequest.data?.documentData?.processed_data?.labels;
                    console.log("DEBUG - Checking for taskLabels at processed_data.labels:", taskLabels);
                    // For classification processors, use Firestore labels if available, otherwise fall back to Document AI entities
                    if (reviewRequest.processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION) {
                        if (taskLabels && Array.isArray(taskLabels) && taskLabels.length > 0) {
                            console.log("Classification processor: Using processed_data.labels");
                            console.log("Raw labels from processed_data:", taskLabels);
                            // Convert labels (which have displayName field) to EntityLabels for the classification dropdown
                            const classificationOptions = taskLabels.map((label, index)=>{
                                console.log(`Processing label ${index}:`, label);
                                const displayName = label.displayName || label.label || label.name || `Option ${index + 1}`;
                                const id = label.id || index.toString();
                                // Augment display name with ID for hotkey support: <id> - <name>
                                // This allows users to press number keys to select classes directly
                                const augmentedDisplayName = `${id} - ${displayName}`;
                                const entityLabel = new (0, $a5412009125d86dc$export$3b798af8cc0f34eb)(augmentedDisplayName);
                                entityLabel.id = id;
                                // Store original name for backend processing (without ID prefix)
                                entityLabel.originalDisplayName = displayName;
                                console.log(`Created EntityLabel - Display: "${augmentedDisplayName}", Original: "${displayName}"`);
                                return entityLabel;
                            });
                            const singleClassificationLabel = new (0, $150c59cc1c2ee7ed$export$59e7611a9b95daae)(classificationOptions);
                            singleClassificationLabel.label = "Document Classification";
                            // We don't have confidence scores in this format, so don't pre-select anything
                            // Let the user make the selection
                            reviewRequest.labels = [
                                singleClassificationLabel
                            ];
                            console.log("Created classification label from processed_data:", reviewRequest.labels);
                        } else if (json.entities && json.entities.length > 0) {
                            console.log("Classification processor: No processed_data labels found, falling back to Document AI entities");
                            reviewRequest.labels = (0, $150c59cc1c2ee7ed$export$253226dc27546fb7)(json.entities);
                            console.log("Generated classification labels from Document AI:", reviewRequest.labels);
                        } else {
                            console.log("Classification processor: No labels found anywhere");
                            reviewRequest.labels = [];
                        }
                    } else if (taskLabels && Array.isArray(taskLabels) && taskLabels.length > 0) {
                        console.log("Using task labels for non-classification processor:", taskLabels);
                        if (reviewRequest.processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).SPLITTING) reviewRequest.labels = taskLabels.map((label)=>(0, $28cd16f8fd1092bc$export$d385b1740434b54b).fromJson(label));
                        else reviewRequest.labels = taskLabels.map((label)=>(0, $a5412009125d86dc$export$3b798af8cc0f34eb).fromJson(label));
                        console.log("Successfully processed labels from task data:", reviewRequest.labels);
                    } else if (json.entities) {
                        // Fallback: convert Document AI entities to labels (only if no task labels)
                        console.log("No task labels found, falling back to Document AI entity conversion");
                        console.log("DEBUG - Processor type for entity conversion:", reviewRequest.processorType);
                        console.log("DEBUG - Document AI entities to convert:", json.entities);
                        if (reviewRequest.processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).SPLITTING) reviewRequest.labels = (0, $28cd16f8fd1092bc$export$d8deb1f7e4c5d129)(json.entities);
                        else if (reviewRequest.processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION) {
                            console.log("Using convertEntitiesToClassificationLabels for processor type:", reviewRequest.processorType);
                            reviewRequest.labels = (0, $150c59cc1c2ee7ed$export$253226dc27546fb7)(json.entities);
                            console.log("Generated classification labels:", reviewRequest.labels);
                        } else reviewRequest.labels = (0, $a5412009125d86dc$export$5dc1095df0929c56)(json.entities);
                    } else {
                        console.log("No labels found in task data, checking if we should fallback to Document AI entities");
                        console.log("DEBUG - Available data keys:", Object.keys(reviewRequest.data || {}));
                        console.log("DEBUG - Available json keys:", Object.keys(json || {}));
                        // For classification, if no processed_data labels, fallback to Document AI entities
                        if (reviewRequest.processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION && json.entities && json.entities.length > 0) {
                            console.log("Classification processor: No processed_data labels found, falling back to Document AI entities");
                            reviewRequest.labels = (0, $150c59cc1c2ee7ed$export$253226dc27546fb7)(json.entities);
                            console.log("Generated classification labels from Document AI entities as fallback:", reviewRequest.labels);
                        } else {
                            console.log("No suitable labels found anywhere, using empty array");
                            reviewRequest.labels = [];
                        }
                    }
                } else if (json.entities) {
                    // For PubSub and File requests, convert entities to labels
                    // For PubSub and File requests, map legacy type field to standard processor types
                    const processorType = reviewRequest.type === "DocSplitter" ? (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).SPLITTING : reviewRequest.type === "DAI_COMPLEX_CLASSIFICATION" ? (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION : (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).EXTRACTION;
                    if (processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).SPLITTING) reviewRequest.labels = (0, $28cd16f8fd1092bc$export$d8deb1f7e4c5d129)(json.entities);
                    else if (processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION) reviewRequest.labels = (0, $150c59cc1c2ee7ed$export$253226dc27546fb7)(json.entities);
                    else reviewRequest.labels = (0, $a5412009125d86dc$export$5dc1095df0929c56)(json.entities);
                } else {
                    console.warn("No entities found in document, using empty labels");
                    reviewRequest.labels = [];
                }
            }
            // add the revisions to the reviewRequest for documents that have been reviewed before
            if (json.hasOwnProperty("revisions")) reviewRequest.revisions = json.revisions;
            // Import the queue display name mapping function
            const { getQueueDisplayName: getQueueDisplayName } = await Promise.resolve((parcelRequire("eUQW6")));
            // Get the display name for the queue
            const queueDisplayName = getQueueDisplayName(reviewRequest.queue);
            // Get envelope ID - for FirestoreReviewRequest it's a direct property, for others check data
            let envelopeId = 'N/A';
            if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) envelopeId = reviewRequest.envelopeId || 'N/A';
            else if (reviewRequest.data?.envelope_id) envelopeId = reviewRequest.data.envelope_id;
            else if (reviewRequest.data?.envelopeId) envelopeId = reviewRequest.data.envelopeId;
            const headerTitle = `${this.reviewRequestsIndex + 1} / ${this.reviewRequests.length} ${queueDisplayName} | Sendung: ${envelopeId}`;
            // convert Document AI document Protbuf format to Document Input format
            // For Firestore requests, use the processorType from the task data
            // Map processor types to valid DocumentInput TabTypes using centralized mapping
            const mapProcessorTypeToTabType = (processorType)=>{
                return (0, $1d7c3ce87f93ab74$export$4b8a5d492382a101)(processorType);
            };
            const rawProcessorType = reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? reviewRequest.processorType // Use actual processor type from Firestore
             : reviewRequest.type; // Use request type for PubSub/File
            const documentType = mapProcessorTypeToTabType(rawProcessorType);
            // Set keyboard shortcut mode based on processor type
            (0, $562a56af2be4988d$export$c6962176354dc525).setModeFromProcessorType(rawProcessorType);
            const documentInput = new (0, $88660971f394cb62$export$37b716936d129341)(reviewRequest.labels, headerTitle, this.reviewRequestsIndex === 0, this.reviewRequests.length - 1 === this.reviewRequestsIndex, documentType, reviewRequest.queue);
            // CRITICAL: For Firestore, follow EXACTLY the same pattern as PubSub
            // The AI UI component expects raw Document AI JSON format - DO NOT MODIFY IT
            // PubSub passes json unchanged from GCS, we must do the same
            console.log('DEBUG - Document AI JSON structure:');
            console.log('- Pages count:', json.pages?.length || 0);
            console.log('- Entities count:', json.entities?.length || 0);
            console.log('- Text length:', json.text?.length || 0);
            console.log('- Page image URLs:', pageImageUrls.length);
            // Create component client SDK instance with lazy loading
            // @ts-ignore
            const sdk = await this.getAIUISDK();
            console.log("sdk", sdk);
            // setup document view component and callback events
            var params = {
                component: "DocumentView",
                document: documentInput,
                // save event triggered immediately when primary button is clicked
                save: async ()=>{
                    const reviewRequest = this.reviewRequests[this.reviewRequestsIndex];
                    if (reviewRequest instanceof (0, $20e0088800729d63$export$9fee94aa43a40124)) // ensure that the access token gets refreshed if necessary
                    await this.getAccessToken(true);
                    if (reviewRequest instanceof (0, $20e0088800729d63$export$95b45e2cf1d26ada)) {
                        const pickerOptions = {
                            suggestedName: reviewRequest.suggestedName()
                        };
                        // create a new handle
                        reviewRequest.outputFileSystemFileHandlePromise = window.showSaveFilePicker(pickerOptions);
                    }
                },
                jsonSave: async (reviewedDocumentJson)=>{
                    const reviewRequest = this.reviewRequests[this.reviewRequestsIndex];
                    console.log("This is the reviewRequest", reviewRequest);
                    const dialog = document.getElementById("dialog");
                    const shouldSkipFieldValidation = typeof this.rejectReason === "string" && this.rejectReason.trim().length > 0;
                    let lastValidationVersion;
                    if (!shouldSkipFieldValidation && reviewedDocumentJson.entities) {
                        const environment = this.resolveEnvironment();
                        const projectId = this.resolveProjectId(reviewRequest);
                        if (!environment || !projectId) {
                            this.showValidationErrorDialog(dialog, [
                                "Validierungsregeln konnten nicht geladen werden (fehlende Umgebung oder Projekt-ID)."
                            ]);
                            return;
                        }
                        const validationContext = this.buildValidationContext(reviewRequest, reviewedDocumentJson);
                        try {
                            const validationResult = await (0, $2a37b32211ef6428$export$b5f0e92079d91d44)({
                                entities: reviewedDocumentJson.entities,
                                context: validationContext,
                                accessToken: accessToken,
                                idToken: idToken,
                                environment: environment,
                                projectId: projectId
                            });
                            // Check validation errors first, regardless of structure completeness
                            if (validationResult?.errors && validationResult.errors.length > 0) {
                                const formattedErrors = validationResult.errors.map((error)=>{
                                    const details = error.errors.join("; ");
                                    const cleanedSuffix = error.cleanedValue !== error.originalValue ? ` (bereinigt: ${error.cleanedValue})` : "";
                                    return `${error.fieldType}: ${details}${cleanedSuffix}`;
                                });
                                this.showValidationErrorDialog(dialog, formattedErrors, validationResult.configVersion);
                                return;
                            }
                            // If validation returned a complete result, use it
                            if (validationResult && validationResult.fieldResults && validationResult.errors && validationResult.warnings && validationResult.cleanedEntities) {
                                lastValidationVersion = validationResult.configVersion;
                                console.info("Validierung abgeschlossen", {
                                    configVersion: validationResult.configVersion,
                                    totalResults: validationResult.fieldResults.length,
                                    errorsCount: validationResult.errors.length,
                                    warningsCount: validationResult.warnings.length,
                                    rulesLoaded: validationResult.fieldResults.filter((r)=>r.metadata?.source !== "no_rule").length,
                                    fieldsWithoutRules: validationResult.fieldResults.filter((r)=>r.metadata?.source === "no_rule").map((r)=>r.fieldType)
                                });
                                if (validationResult.warnings.length > 0) console.info("Feldvalidierung abgeschlossen mit Warnungen", validationResult.warnings.map((warning)=>({
                                        field: warning.fieldType,
                                        warnings: warning.warnings
                                    })));
                                reviewedDocumentJson.entities = validationResult.cleanedEntities;
                            } else // Validation returned incomplete structure, log and proceed
                            console.warn("Validation returned incomplete result, proceeding without validation", {
                                hasValidationResult: !!validationResult,
                                hasFieldResults: !!validationResult?.fieldResults,
                                hasErrors: !!validationResult?.errors,
                                hasWarnings: !!validationResult?.warnings,
                                hasCleanedEntities: !!validationResult?.cleanedEntities,
                                actualStructure: validationResult
                            });
                        } catch (validationError) {
                            console.error("Feldvalidierung nicht m\xf6glich", validationError);
                        // Don't block save on validation exception - continue to required field check
                        // This ensures required fields are still validated even if validation rules fail to load
                        }
                    }
                    // check if required labels have been provided with valid values
                    const missingRequiredLabels = [];
                    (0, $a30lF.log).info("Checking required fields", {
                        totalLabels: reviewRequest.labels.length,
                        labels: reviewRequest.labels.map((l)=>({
                                label: l instanceof (0, $a5412009125d86dc$export$3b798af8cc0f34eb) ? l.label : 'not EntityLabel',
                                requireCategory: l instanceof (0, $a5412009125d86dc$export$3b798af8cc0f34eb) ? l.requireCategory : 'N/A'
                            }))
                    });
                    for (const label of reviewRequest.labels)if (label instanceof (0, $a5412009125d86dc$export$3b798af8cc0f34eb) && label.requireCategory === "required") {
                        let found = false;
                        let isValid = false;
                        // Only check entities if they exist
                        if (reviewedDocumentJson.entities) {
                            for (const entity of reviewedDocumentJson.entities)if (entity.type === label.label) {
                                found = true;
                                // Check if field has a non-empty value after cleaning/validation
                                const mentionText = entity.mention_text?.trim() || "";
                                if (mentionText.length > 0) isValid = true;
                            }
                        }
                        // Required field is missing or empty after validation
                        if (!found || !isValid) {
                            missingRequiredLabels.push(label.label);
                            (0, $a30lF.log).info(`Required field missing or invalid: ${label.label}`, {
                                found: found,
                                isValid: isValid
                            });
                        }
                    }
                    (0, $a30lF.log).info("Required fields check complete", {
                        missingRequiredLabels: missingRequiredLabels,
                        totalMissing: missingRequiredLabels.length
                    });
                    // Check if classification has been selected for classification processors
                    const processorType = reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? reviewRequest.processorType : reviewRequest.type;
                    if ((processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION || reviewRequest.type === "DAI_COMPLEX_CLASSIFICATION") && this.rejectReason === "") {
                        // Check if there are classification labels
                        const classificationLabels = reviewRequest.labels.filter((label)=>label instanceof (0, $150c59cc1c2ee7ed$export$59e7611a9b95daae));
                        if (classificationLabels.length > 0) {
                            // Check if a classification value has been selected
                            const hasSelectedClassification = reviewedDocumentJson.entities?.some((entity)=>entity.type === "Document Classification" && entity.normalized_value?.text && entity.normalized_value.text.trim().length > 0);
                            if (!hasSelectedClassification) {
                                dialog.heading = "Klassifizierung fehlt";
                                (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`Bitte wählen Sie eine Dokumentklassifikation aus, bevor Sie das Dokument speichern.
                                <mwc-button slot="primaryAction" dialogAction="ok">OK</mwc-button>`, dialog);
                                dialog.open = true;
                                return;
                            }
                        }
                    }
                    // check if entities marked for review have been reviewed
                    const missingEntityReviews = [];
                    // specific check if no rejectReason is provided (case if document is saved) and reviewDocumentJson contains an entities key
                    if (this.rejectReason === "" && reviewedDocumentJson.entities != undefined) {
                        console.log("First basic check passed for saving: No storno reason and entities available");
                        for (const entity of reviewedDocumentJson.entities){
                            console.log(entity);
                            if (entity.provenance?.type === 4) missingEntityReviews.push(entity.type);
                        }
                        // more specific check if regarding missing required entities and prevent saving
                        if (missingRequiredLabels.length > 0 || missingEntityReviews.length > 0) {
                            console.log("First more specific check not passed for saving: Missing entities");
                            dialog.heading = "Dokumentvalidierung fehlgeschlagen";
                            (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`Die folgenden Einträge weisen fehlende Werte auf: ${missingRequiredLabels.join(', ')}
                            <br>
                            Die folgenden erforderlichen Einträge wurden nicht überprüft: ${missingEntityReviews.join(', ')}
                            <mwc-button slot="primaryAction" dialogAction="ok"
                            >OK
                            </mwc-button
                            >`, dialog);
                            dialog.open = true;
                            return;
                        }
                    } else if (this.rejectReason === "" && reviewedDocumentJson.entities === undefined) {
                        console.log("Second check not passed for saving or storno: No entities in the reviewedDocumentJson and no rejectReason provided");
                        if (dialog) {
                            dialog.heading = "Dokumentvalidierung fehlgeschlagen";
                            (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`Sie haben keine Einträge vorgenommen.<br>
                            Überprüfen Sie bitte erneut das Dokument.
                            <mwc-button slot="primaryAction" dialogAction="ok"
                            >OK
                            </mwc-button
                            >`, dialog);
                            dialog.open = true;
                            return;
                        }
                    } else if (this.rejectReason != "") console.log("Rejecting document with reason: ", this.rejectReason);
                    // Defensive: Strip ID prefix from classification entity types if not already stripped
                    // This is a safety net - the main fix is in review-request.ts
                    if ((processorType === (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION || reviewRequest.type === "DAI_COMPLEX_CLASSIFICATION") && reviewedDocumentJson.entities) {
                        for (const entity of reviewedDocumentJson.entities)if (entity.type && /^(\d+)\s*[-_]\s*/.test(entity.type)) entity.type = entity.type.replace(/^(\d+)\s*[-_]\s*/, '');
                    }
                    // Log before initiating document save
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: "INFO",
                        userId: this.userId,
                        action: "Document save initiated",
                        additionalInfo: {
                            reviewRequestName: reviewRequest.name,
                            batch_id: reviewRequest.data?.batch_id,
                            envelope_id: reviewRequest.data?.envelope_id,
                            processorType: reviewRequest.data?.processorType,
                            queue: reviewRequest.queue
                        }
                    });
                    // Create a new revision and prepare content for saving
                    const revision = new (0, $8b789eeed2d2b117$export$65528947809bf36b)(reviewedDocumentJson, this.humanRevisionState, this.humanRevisionStateMessage, this.userId);
                    // remove lastRevisionId which is not allowed in the output
                    delete revision.lastRevisionId;
                    reviewedDocumentJson.revisions.push(revision);
                    const content = JSON.stringify(reviewedDocumentJson);
                    // NON-BLOCKING SAVE: Enqueue the save operation instead of waiting for it
                    // This allows the user to immediately proceed to the next document
                    // Log before initiating save
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: "INFO",
                        userId: this.userId,
                        action: "Document save queued (non-blocking)",
                        additionalInfo: {
                            reviewRequestName: reviewRequest.name,
                            batch_id: reviewRequest.data?.batch_id,
                            envelope_id: reviewRequest.data?.envelope_id,
                            processorType: reviewRequest.data?.processorType,
                            queue: reviewRequest.queue
                        }
                    });
                    // Enqueue the save operation (returns immediately)
                    // Note: Access token will be refreshed before each save attempt in the queue
                    (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).enqueueSave(reviewRequest, accessToken, idToken, content, reviewRequest.data, this.rejectReason, this.userId, this.getAccessToken.bind(this) // Pass token refresh function
                    );
                    // Show immediate success feedback to user
                    this.showTemporaryNotification('Dokument wird im Hintergrund gespeichert...', 2000);
                    // Close dialog immediately
                    if (dialog) dialog.open = false;
                    // Allow user to proceed to next document immediately
                    this.proceedToNextDocument();
                },
                secondaryButtonClick: async ()=>{
                    // ensure that the access token gets refreshed if necessary
                    await this.getAccessToken(true);
                    // Log the initial CLEARING button click
                    const currentReviewRequest = this.reviewRequests[this.reviewRequestsIndex];
                    // Debug logging to understand data structure
                    console.log("DEBUG CLEARING - Request type:", currentReviewRequest.constructor.name);
                    console.log("DEBUG CLEARING - Request data keys:", Object.keys(currentReviewRequest.data || {}));
                    console.log("DEBUG CLEARING - Request data:", currentReviewRequest.data);
                    console.log("DEBUG CLEARING - Current rejectReason:", this.rejectReason);
                    const additionalInfo = {
                        reviewRequestName: currentReviewRequest.name,
                        batch_id: currentReviewRequest.data?.batch_id,
                        envelope_id: currentReviewRequest.data?.envelope_id,
                        processorType: currentReviewRequest.data?.processorType,
                        queue: currentReviewRequest.queue,
                        requestType: currentReviewRequest.constructor.name,
                        rejectReason: this.rejectReason || null
                    };
                    // Add additional processor information if available (for Firestore requests)
                    if (currentReviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) {
                        additionalInfo.taskId = currentReviewRequest.taskId;
                        additionalInfo.documentId = currentReviewRequest.documentId;
                        additionalInfo.envelopeId = currentReviewRequest.envelopeId;
                        additionalInfo.priority = currentReviewRequest.priority;
                        additionalInfo.processorTypeFromRequest = currentReviewRequest.processorType;
                        // Debug for Firestore
                        console.log("DEBUG CLEARING - Firestore taskId:", currentReviewRequest.taskId);
                        console.log("DEBUG CLEARING - Firestore processorType:", currentReviewRequest.processorType);
                    } else {
                        // For non-Firestore requests, try to get processor type from different locations
                        additionalInfo.legacyType = currentReviewRequest.type;
                        console.log("DEBUG CLEARING - Legacy type:", currentReviewRequest.type);
                    }
                    // Add key processor, envelope and document information
                    if (currentReviewRequest.data) {
                        // Core envelope information
                        additionalInfo.envelope_id = currentReviewRequest.data.envelope_id;
                        additionalInfo.document_class = currentReviewRequest.data.document_class;
                        additionalInfo.original_filename = currentReviewRequest.data.original_filename;
                        additionalInfo.workflow_id = currentReviewRequest.data.workflow_id;
                        additionalInfo.submission_timestamp = currentReviewRequest.data.submission_timestamp;
                        // Processor information from various possible locations
                        additionalInfo.processor_type_alt = currentReviewRequest.data.processor_type;
                        additionalInfo.processor_id = currentReviewRequest.data.processor_id;
                        additionalInfo.task_id = currentReviewRequest.data.task_id;
                        additionalInfo.document_id = currentReviewRequest.data.document_id;
                        additionalInfo.priority = currentReviewRequest.data.priority;
                        additionalInfo.status = currentReviewRequest.data.status;
                        // Document data information
                        if (currentReviewRequest.data.documentData) {
                            additionalInfo.originalFileName = currentReviewRequest.data.documentData.originalFileName;
                            additionalInfo.documentId = currentReviewRequest.data.documentData.documentId;
                            additionalInfo.mimeType = currentReviewRequest.data.documentData.mimeType;
                            // Processor details from processed_data
                            if (currentReviewRequest.data.documentData.processed_data) {
                                const processedData = currentReviewRequest.data.documentData.processed_data;
                                additionalInfo.processorVersion = processedData.processorVersion;
                                additionalInfo.processorDisplayName = processedData.processorDisplayName;
                                additionalInfo.processorProject = processedData.processorProject;
                                additionalInfo.processorIdFromProcessedData = processedData.processorId;
                            }
                        }
                        // Add all available data keys for debugging
                        additionalInfo.availableDataKeys = Object.keys(currentReviewRequest.data);
                    }
                    // Add any processor-related data from the task data (legacy support)
                    if (currentReviewRequest.data?.documentData?.processed_data) {
                        const processedData = currentReviewRequest.data.documentData.processed_data;
                        console.log("DEBUG CLEARING - Found processed_data:", processedData);
                    }
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: "INFO",
                        userId: this.userId,
                        action: "CLEARING button clicked",
                        additionalInfo: additionalInfo
                    });
                    // retrieve rejection reason from user
                    const dialog = document.getElementById("dialog");
                    if (dialog) {
                        // Clear any previous rejection reason before opening the dialog
                        this.rejectReason = "";
                        dialog.heading = "Tragen Sie hier den Storno-Grund ein.";
                        (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                            <mwc-textfield
                                    outlined
                                    style="width: 100%;margin-top: 12px;"
                                    required
                                    name="rejectReason"
                                    value=${this.rejectReason}
                                    label="Storno-Grund"
                                    @change=${this.handleFieldChange}
                                    @input=${this.handleFieldChange}
                                    @keydown=${(e)=>{
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                this.rejectDocument(e);
                            }
                        }}
                            ></mwc-textfield>
                            <mwc-button
                                    id="dialogSubmitButton"
                                    label="CLEARING"
                                    slot="primaryAction"
                                    dialogAction="ok"
                                    @click=${this.rejectDocument}
                            ></mwc-button>`, dialog);
                        dialog.open = true;
                        // Auto-focus the textfield after dialog opens and ensure it's empty
                        requestAnimationFrame(()=>{
                            const textfield = dialog.querySelector('mwc-textfield[name="rejectReason"]');
                            if (textfield) {
                                textfield.value = ""; // Force clear the native input value
                                textfield.focus();
                            }
                        });
                    }
                },
                navigate: async (event)=>{
                    // set a reviewEndTime for when a revision is interrupted by navigation across different document
                    if (typeof reviewRequest.reviewDuration === 'undefined' || Number.isNaN(this.reviewDuration)) reviewRequest.reviewDuration = (new Date().getTime() - reviewRequest.reviewStartTime.getTime()) / 1000;
                    else reviewRequest.reviewDuration += (new Date().getTime() - reviewRequest.reviewStartTime.getTime()) / 1000;
                    console.log("Set the reviewDuration (seconds) due to navigation to", reviewRequest.reviewDuration);
                    // ensure that the access token gets refreshed if necessary
                    await this.getAccessToken(true);
                    let actionLabel = "";
                    if (event === 0) actionLabel = "Navigate back";
                    else if (event === 1) actionLabel = "Navigate previous";
                    else if (event === 2) actionLabel = "Navigate next";
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: "INFO",
                        userId: this.userId,
                        action: actionLabel,
                        additionalInfo: {
                            reviewRequestName: reviewRequest.name,
                            batch_id: reviewRequest.data?.batch_id,
                            envelope_id: reviewRequest.data?.envelope_id,
                            processorType: reviewRequest.data?.processorType,
                            queue: reviewRequest.queue
                        }
                    });
                    if (event === 0) {
                        // back button clicked
                        this.closeReview();
                        //Stop displaying the banner in case it was being displayed
                        document.getElementById("documentAgainInHINTBanner").style.display = "none";
                    } else {
                        if (event === 1) // previous button clicked
                        this.reviewRequestsIndex = Math.max(this.reviewRequestsIndex - 1, 0);
                        else if (event === 2) // next button clicked
                        this.reviewRequestsIndex = Math.min(this.reviewRequestsIndex + 1, this.reviewRequests.length - 1);
                        //Stop displaying the banner in case it was being displayed
                        document.getElementById("documentAgainInHINTBanner").style.display = "none";
                        this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
                    }
                },
                escalate: async ()=>{
                    // ensure that the access token gets refreshed if necessary
                    await this.getAccessToken(true);
                    const currentReviewRequest = this.reviewRequests[this.reviewRequestsIndex];
                    // Log escalation request with enriched info
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: "INFO",
                        userId: this.userId,
                        action: "Escalation requested",
                        additionalInfo: {
                            reviewRequestName: currentReviewRequest.name,
                            batch_id: currentReviewRequest.data?.batch_id,
                            envelope_id: currentReviewRequest.data?.envelope_id,
                            processorType: currentReviewRequest.data?.processorType,
                            queue: currentReviewRequest.queue
                        }
                    });
                    const dialog = document.getElementById("dialog");
                    if (dialog) {
                        dialog.heading = "Dokument wird eskaliert.";
                        (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                            <mwc-button slot="primaryAction" dialogAction="ok" @click=${this.escalateDocument}
                                        data-value=${accessToken}
                            >ESKALIEREN
                            </mwc-button
                            >`, dialog);
                        dialog.open = true;
                    }
                }
            };
            // retrieve element for rendering the main document view UI component
            const aiDocumentView = this.renderRoot.querySelector(".content-div");
            // Add mode-specific class for CSS targeting
            if (aiDocumentView) {
                // Remove any existing mode classes
                aiDocumentView.classList.remove('docsplitter-mode', 'classification-mode', 'entity-mode');
                // Add appropriate mode class
                if (documentType === "DocSplitter") aiDocumentView.classList.add('docsplitter-mode');
                else if (documentType === "DAI_COMPLEX_CLASSIFICATION") aiDocumentView.classList.add('classification-mode');
                else if (documentType === "Entity") aiDocumentView.classList.add('entity-mode');
                // Force cleanup of any corrupted React root state from a previous failed render
                aiDocumentView.innerHTML = "";
            }
            // Final loading state before rendering
            this.showProgressiveLoadingState("Loading document viewer...");
            const renderStart = performance.now();
            this.documentViewElement = await sdk.render(aiDocumentView, params);
            performanceMetrics.renderTime = performance.now() - renderStart;
            if (!this.documentViewElement) {
                console.error("sdk.render returned undefined. aiDocumentView exists:", !!aiDocumentView);
                throw new Error("Fehler bei der Initialisierung der Dokumentenansicht. Bitte laden Sie das Dokument neu.");
            }
            // Wait for AI UI component to be fully loaded and visible before clearing loading state
            this.waitForAIUIToLoad().then(()=>{
                this.clearProgressiveLoadingState();
                // Calculate total time and log performance metrics (after full UI load)
                performanceMetrics.totalTime = performance.now() - performanceMetrics.startTime;
                this.logPerformanceMetrics(performanceMetrics, reviewRequest);
                // Inject keyboard shortcuts button into AIUI toolbar
                this.injectKeyboardShortcutsButton();
                // Inject Irrläufer button into AIUI toolbar
                this.injectIrrlaueferButton();
            });
            if (documentType === "DocSplitter") {
                this.documentViewElement.isSplitter = true;
                this.documentViewElement.showSearchButton = false;
                // Add data attribute to enable CSS hiding
                const contentDiv = this.renderRoot.querySelector(".content-div");
                if (contentDiv) contentDiv.setAttribute("data-type", "docsplitter");
            } else {
                // For all other types (Entity, etc.), set data attribute to allow search
                const contentDiv = this.renderRoot.querySelector(".content-div");
                if (contentDiv) contentDiv.setAttribute("data-type", "entity");
            }
            if (reviewRequest.type === "Entity" && typeof reviewRequest.revisions !== 'undefined') {
                //extract the id of the last object that got pushed to the revisions array
                let hintTrackerCount = parseInt(reviewRequest.revisions.at(-1).id);
                //insert the amount of revisions into the banner
                document.getElementById("hintTrackerCount").innerHTML = hintTrackerCount;
                //display the banner
                console.log("Showing the Banner again");
                document.getElementById("documentAgainInHINTBanner").style.display = "block";
            }
            // Debug: log the final json structure and pageImageUrls
            console.log("Final json structure for AI UI:", json);
            console.log("Final pageImageUrls for AI UI:", pageImageUrls);
            console.log("Final documentInput.data:", documentInput.data);
            console.log('DEBUG AI UI - json.pages structure:', json.pages?.map((p, i)=>({
                    pageIndex: i,
                    hasImageUrl: !!p.imageUrl,
                    imageUrlType: typeof p.imageUrl,
                    hasTokens: !!p.tokens,
                    hasEntities: !!p.entities,
                    hasBlocks: !!p.blocks,
                    pageKeys: Object.keys(p || {})
                })));
            console.log('DEBUG AI UI - documentInput.data.pages structure:', documentInput.data.pages?.map((p, i)=>({
                    pageIndex: i,
                    hasImageUrl: !!p.imageUrl,
                    imageUrlType: typeof p.imageUrl,
                    imageUrlValue: p.imageUrl?.privateDoNotAccessOrElseWrappedUrl ? 'has privateDoNotAccessOrElseWrappedUrl' : p.imageUrl,
                    hasTokens: !!p.tokens,
                    hasEntities: !!p.entities,
                    pageKeys: Object.keys(p || {})
                })));
            console.log('DEBUG AI UI - entities available:', {
                jsonEntities: json.entities?.length || 0,
                documentInputEntities: documentInput.data.entities?.length || 0,
                entityLabels: documentInput.data.entityLabels?.length || 0
            });
            // Set the document data for AI UI - Follow PubSub approach exactly
            this.documentViewElement.docProtoJson = {
                json: json,
                imageUrls: pageImageUrls
            };
            reviewRequest.reviewStartTime = new Date();
            console.log("Set the reviewStartTime for the document to: ", reviewRequest.reviewStartTime);
            // Smart preloading: Start loading next document in background
            this.preloadNextDocument();
            // Batch preload images for better performance
            if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) && pageImageUrls.length > 1) // Don't await - preload in background
            (0, $20e0088800729d63$export$9ddd7e36c6c46838).preloadImages(pageImageUrls, accessToken).catch((error)=>{
                console.warn('Image preloading failed:', error);
            });
        } catch (error) {
            console.error('Error loading document for review:', error);
            const errorMessage = error instanceof Error ? error.message : String(error);
            this.lastDocumentLoadError = errorMessage;
            // Always clear the loading spinner to prevent it from being stuck
            this.clearProgressiveLoadingState();
            // Show error dialog using existing Material Dialog pattern
            const dialog = document.getElementById("dialog");
            if (dialog) {
                dialog.heading = "Fehler beim Laden des Dokuments";
                (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                        <p>Das Dokument konnte nicht geladen werden.</p>
                        <p style="color: #666; font-size: 14px;">
                            ${error instanceof Error ? error.message : 'Unbekannter Fehler'}
                        </p>
                        <p>Möchten Sie die Aufgabe aus der Bearbeitungsqueue entfernen und zum nächsten Dokument gehen?</p>
                        <mwc-button slot="primaryAction" @click=${(event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                    this.discardTaskAndProceed(dialog);
                }}>Ja</mwc-button>
                        <mwc-button slot="secondaryAction" dialogAction="close" @click=${()=>{
                    dialog.close();
                    this.closeReview();
                }}>Nein, Zurück zur Startseite</mwc-button>
                    `, dialog);
                dialog.open = true;
            }
            // Log the error for monitoring
            (0, $a30lF.logAction)({
                timestamp: new Date().toISOString(),
                severity: 'ERROR',
                userId: this.userId,
                action: 'Document loading failed',
                additionalInfo: {
                    reviewRequestName: reviewRequest.name,
                    error: errorMessage,
                    queue: reviewRequest.queue,
                    envelopeId: reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? reviewRequest.envelopeId : undefined
                }
            });
        }
    }
    /**
     * Lazy load AI UI SDK for better bundle size and initial load performance
     */ async getAIUISDK() {
        // @ts-ignore - AI UI SDK is loaded globally
        if (typeof AIUIComponentClient !== 'undefined') // @ts-ignore
        return new AIUIComponentClient("DEFAULT_API_KEY");
        // If not available, this is a development fallback
        console.warn('AI UI SDK not available - using fallback');
        return {
            render: ()=>console.warn('AI UI SDK not loaded')
        };
    }
    /**
     * Smart preloading: Preload next document in background for better performance
     */ async preloadNextDocument() {
        const nextIndex = this.reviewRequestsIndex + 1;
        if (nextIndex >= this.reviewRequests.length) return; // No next document to preload
        const nextRequest = this.reviewRequests[nextIndex];
        console.log(`\u{1F504} Preloading next document (${nextIndex + 1}/${this.reviewRequests.length}): ${nextRequest.name}`);
        try {
            const [accessToken, idToken] = await this.getAccessToken();
            // Preload in background - don't await, just let it load
            nextRequest.getContent(accessToken).then(()=>{
                console.log(`\u{2705} Successfully preloaded document: ${nextRequest.name}`);
            }).catch((error)=>{
                console.warn(`\u{26A0}\u{FE0F} Failed to preload document: ${nextRequest.name}`, error);
            });
        } catch (error) {
            console.warn(`\u{26A0}\u{FE0F} Failed to start preloading for document: ${nextRequest.name}`, error);
        }
    }
    clickSaveButton() {
        let saveButton = null;
        if (this.documentViewElement) {
            if (this.documentViewElement.shadowRoot) saveButton = this.documentViewElement.shadowRoot.querySelector(".primary-button");
            if (!saveButton) saveButton = this.documentViewElement.querySelector(".primary-button");
        }
        if (saveButton) {
            console.log("Simulating click on save button via hotkey.");
            saveButton.click();
        } else console.error("Save button not found; cannot trigger save action.");
    }
    /**
     * Zoom in on the document view (keyboard layout-independent)
     * Uses event.code for physical key detection
     */ zoomIn() {
        let zoomInButton = null;
        if (this.documentViewElement) {
            // Try multiple selector patterns to find the zoom in button
            const selectors = [
                '[aria-label*="Zoom in"]',
                '[title*="Zoom in"]',
                '.zoom-in',
                '.zoom-in-button',
                'button[aria-label*="zoom in" i]'
            ];
            if (this.documentViewElement.shadowRoot) for (const selector of selectors){
                zoomInButton = this.documentViewElement.shadowRoot.querySelector(selector);
                if (zoomInButton) break;
            }
            if (!zoomInButton) for (const selector of selectors){
                zoomInButton = this.documentViewElement.querySelector(selector);
                if (zoomInButton) break;
            }
        }
        if (zoomInButton) {
            (0, $a30lF.log).debug("Zooming in via keyboard shortcut (layout-independent)");
            zoomInButton.click();
        } else (0, $a30lF.log).warn("Zoom in button not found in AIUI component");
    }
    /**
     * Zoom out on the document view (keyboard layout-independent)
     * Uses event.code for physical key detection
     */ zoomOut() {
        let zoomOutButton = null;
        if (this.documentViewElement) {
            // Try multiple selector patterns to find the zoom out button
            const selectors = [
                '[aria-label*="Zoom out"]',
                '[title*="Zoom out"]',
                '.zoom-out',
                '.zoom-out-button',
                'button[aria-label*="zoom out" i]'
            ];
            if (this.documentViewElement.shadowRoot) for (const selector of selectors){
                zoomOutButton = this.documentViewElement.shadowRoot.querySelector(selector);
                if (zoomOutButton) break;
            }
            if (!zoomOutButton) for (const selector of selectors){
                zoomOutButton = this.documentViewElement.querySelector(selector);
                if (zoomOutButton) break;
            }
        }
        if (zoomOutButton) {
            (0, $a30lF.log).debug("Zooming out via keyboard shortcut (layout-independent)");
            zoomOutButton.click();
        } else (0, $a30lF.log).warn("Zoom out button not found in AIUI component");
    }
    /**
     * Zoom to fit the document view (keyboard layout-independent)
     * Uses event.code for physical key detection
     */ zoomToFit() {
        let zoomToFitButton = null;
        if (this.documentViewElement) {
            // Try multiple selector patterns to find the zoom to fit button
            const selectors = [
                '[aria-label*="Zoom to fit"]',
                '[aria-label*="Fit to page"]',
                '[aria-label*="Fit"]',
                '[title*="Zoom to fit"]',
                '[title*="Fit to page"]',
                '.zoom-to-fit',
                '.fit-to-page',
                'button[aria-label*="fit" i]'
            ];
            if (this.documentViewElement.shadowRoot) for (const selector of selectors){
                zoomToFitButton = this.documentViewElement.shadowRoot.querySelector(selector);
                if (zoomToFitButton) break;
            }
            if (!zoomToFitButton) for (const selector of selectors){
                zoomToFitButton = this.documentViewElement.querySelector(selector);
                if (zoomToFitButton) break;
            }
        }
        if (zoomToFitButton) {
            (0, $a30lF.log).debug("Zooming to fit via keyboard shortcut (layout-independent)");
            zoomToFitButton.click();
        } else (0, $a30lF.log).warn("Zoom to fit button not found in AIUI component");
    }
    /**
     * Undo last annotation action (keyboard layout-independent)
     * Uses event.code for physical key detection
     */ undo() {
        let undoButton = null;
        if (this.documentViewElement) {
            // Try multiple selector patterns to find the undo button
            const selectors = [
                '[aria-label*="Undo"]',
                '[title*="Undo"]',
                '.undo-button',
                'button[aria-label*="undo" i]'
            ];
            if (this.documentViewElement.shadowRoot) for (const selector of selectors){
                undoButton = this.documentViewElement.shadowRoot.querySelector(selector);
                if (undoButton) break;
            }
            if (!undoButton) for (const selector of selectors){
                undoButton = this.documentViewElement.querySelector(selector);
                if (undoButton) break;
            }
        }
        if (undoButton) {
            (0, $a30lF.log).debug("Undo via keyboard shortcut (layout-independent)");
            undoButton.click();
        } else (0, $a30lF.log).warn("Undo button not found in AIUI component");
    }
    /**
     * Redo last undone annotation action (keyboard layout-independent)
     * Uses event.code for physical key detection
     */ redo() {
        let redoButton = null;
        if (this.documentViewElement) {
            // Try multiple selector patterns to find the redo button
            const selectors = [
                '[aria-label*="Redo"]',
                '[title*="Redo"]',
                '.redo-button',
                'button[aria-label*="redo" i]'
            ];
            if (this.documentViewElement.shadowRoot) for (const selector of selectors){
                redoButton = this.documentViewElement.shadowRoot.querySelector(selector);
                if (redoButton) break;
            }
            if (!redoButton) for (const selector of selectors){
                redoButton = this.documentViewElement.querySelector(selector);
                if (redoButton) break;
            }
        }
        if (redoButton) {
            (0, $a30lF.log).debug("Redo via keyboard shortcut (layout-independent)");
            redoButton.click();
        } else (0, $a30lF.log).warn("Redo button not found in AIUI component");
    }
    closeReview() {
        const currentReviewRequest = this.reviewRequests[this.reviewRequestsIndex] || {};
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: "INFO",
            userId: this.userId,
            action: "Review session closed",
            additionalInfo: {
                reviewRequestName: currentReviewRequest.name,
                batch_id: currentReviewRequest.data?.batch_id,
                envelope_id: currentReviewRequest.data?.envelope_id,
                processorType: currentReviewRequest.data?.processorType,
                queue: currentReviewRequest.queue
            }
        });
        const reviewRequestUpdatedEvent = new CustomEvent("manage-batch-and-queues-triggered", {
            bubbles: true,
            detail: this.reviewRequests
        });
        this.dispatchEvent(reviewRequestUpdatedEvent);
    }
    /**
     * Check for workflow timeout warnings in recent console logs
     */ checkForWorkflowTimeoutWarnings() {
        // This is a simple heuristic - in a production system you might want
        // to implement a more sophisticated mechanism
        return false; // For now, we'll rely on the fallback mechanism to handle this gracefully
    }
    /**
     * Proceed to the next document after successful save
     */ proceedToNextDocument() {
        this.reviewRequests = this.reviewRequests.filter((_, i)=>i !== this.reviewRequestsIndex);
        if (this.reviewRequests.length > 0) {
            this.reviewRequestsIndex = Math.min(this.reviewRequestsIndex, this.reviewRequests.length - 1);
            console.log("REMOVING THE BANNER DUE TO SAVING");
            document.getElementById("documentAgainInHINTBanner").style.display = "none";
            this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
        } else {
            this.closeReview();
            console.log("REMOVING THE BANNER DUE TO SAVING");
            document.getElementById("documentAgainInHINTBanner").style.display = "none";
        }
    }
    renderQuarantineProgressDialog(dialog, attempt, maxAttempts, retrying = false) {
        if (!dialog) return;
        dialog.heading = retrying ? "Entfernen wird erneut versucht" : "Aufgabe wird entfernt";
        (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                <p>Die Aufgabe wird aus der Bearbeitungsqueue entfernt.</p>
                <mwc-linear-progress indeterminate></mwc-linear-progress>
                <p style="color: #666; font-size: 14px;">
                    Versuch ${attempt} von ${maxAttempts}
                </p>
                <mwc-button slot="primaryAction" disabled>Bitte warten</mwc-button>
            `, dialog);
        dialog.open = true;
    }
    renderQuarantineRetryDialog(dialog, errorMessage) {
        if (!dialog) return;
        dialog.heading = "Aufgabe konnte nicht entfernt werden";
        (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                <p>Die Aufgabe konnte nicht aus der Bearbeitungsqueue entfernt werden.</p>
                <p style="color: #666; font-size: 14px;">
                    ${errorMessage || "Unbekannter Fehler"}
                </p>
                <p>Sie wurde nicht freigegeben und nicht als eskaliert markiert. Bitte versuchen Sie es erneut.</p>
                <mwc-button slot="primaryAction" @click=${(event)=>{
            event.preventDefault();
            event.stopPropagation();
            this.discardTaskAndProceed(dialog);
        }}>Erneut versuchen</mwc-button>
                <mwc-button slot="secondaryAction" dialogAction="close" @click=${()=>{
            dialog.close();
            this.closeReview();
        }}>Zur Startseite</mwc-button>
            `, dialog);
        dialog.open = true;
    }
    waitBeforeQuarantineRetry(attempt) {
        return new Promise((resolve)=>{
            globalThis.setTimeout(resolve, $ad42dc5b6815f2da$var$QUARANTINE_RETRY_DELAY_MS * attempt);
        });
    }
    buildQuarantinePayload(failureReason, failedAt) {
        return {
            status: 'escalated',
            assignedTo: null,
            assignedAt: null,
            expiresAt: null,
            failedAt: failedAt,
            failedBy: this.userId,
            failureStage: 'document_load',
            failureAction: 'operator_discard_after_load_error',
            failureReason: failureReason
        };
    }
    async patchQuarantineTask(taskDocUrl, idToken, updatePayload) {
        const updateResponse = await fetch(taskDocUrl, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${idToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(updatePayload)
        });
        if (!updateResponse.ok) {
            const responseText = await updateResponse.text().catch(()=>"No response body");
            throw new Error(`Quarantine PATCH failed (${updateResponse.status} ${updateResponse.statusText}): ${responseText}`);
        }
    }
    async tryQuarantinePatch(taskDocUrl, idToken, updatePayload, attempt) {
        try {
            await this.patchQuarantineTask(taskDocUrl, idToken, updatePayload);
            return null;
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : String(error);
            console.error(`Error quarantining unloadable task (attempt ${attempt}/${$ad42dc5b6815f2da$var$QUARANTINE_MAX_ATTEMPTS}):`, error);
            return errorMessage;
        }
    }
    async retryQuarantinePatch(dialog, taskDocUrl, idToken, updatePayload) {
        let lastErrorMessage = "";
        for(let attempt = 1; attempt <= $ad42dc5b6815f2da$var$QUARANTINE_MAX_ATTEMPTS; attempt++){
            this.renderQuarantineProgressDialog(dialog, attempt, $ad42dc5b6815f2da$var$QUARANTINE_MAX_ATTEMPTS, attempt > 1);
            lastErrorMessage = await this.tryQuarantinePatch(taskDocUrl, idToken, updatePayload, attempt) ?? "";
            if (!lastErrorMessage) return null;
            if (attempt < $ad42dc5b6815f2da$var$QUARANTINE_MAX_ATTEMPTS) {
                this.renderQuarantineProgressDialog(dialog, attempt + 1, $ad42dc5b6815f2da$var$QUARANTINE_MAX_ATTEMPTS, true);
                await this.waitBeforeQuarantineRetry(attempt);
            }
        }
        return lastErrorMessage;
    }
    async logQuarantineSuccess(currentRequest, failedAt, failureReason) {
        console.log(`Quarantined unloadable Firestore task ${currentRequest.taskId}`);
        await (0, $a30lF.sendCriticalLog)({
            timestamp: failedAt,
            severity: 'ERROR',
            userId: this.userId,
            action: 'Quarantined unloadable Firestore task',
            additionalInfo: {
                taskId: currentRequest.taskId,
                queue: currentRequest.queue,
                envelopeId: currentRequest.envelopeId,
                reviewRequestName: currentRequest.name,
                failureReason: failureReason
            }
        });
    }
    async logQuarantineFailure(currentRequest, failureReason, errorMessage) {
        await (0, $a30lF.sendCriticalLog)({
            timestamp: new Date().toISOString(),
            severity: 'ERROR',
            userId: this.userId,
            action: 'Failed to quarantine unloadable Firestore task',
            additionalInfo: {
                taskId: currentRequest.taskId,
                queue: currentRequest.queue,
                envelopeId: currentRequest.envelopeId,
                reviewRequestName: currentRequest.name,
                failureReason: failureReason,
                error: errorMessage
            }
        });
    }
    dispatchQuarantineEvent(currentRequest) {
        const queueUpdateEvent = new CustomEvent("task-completed", {
            bubbles: true,
            detail: {
                queueName: currentRequest.queue,
                taskId: currentRequest.taskId,
                status: 'escalated'
            }
        });
        document.dispatchEvent(queueUpdateEvent);
    }
    async quarantineFirestoreTask(currentRequest, dialog, failureReason) {
        try {
            const failedAt = new Date().toISOString();
            const [, idToken] = await this.getAccessToken(true);
            const collectionName = `hitl_tasks_${currentRequest.queue}`;
            const taskDocUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/${collectionName}/${currentRequest.taskId}`;
            const updatePayload = this.buildQuarantinePayload(failureReason, failedAt);
            const errorMessage = await this.retryQuarantinePatch(dialog, taskDocUrl, idToken, updatePayload);
            if (errorMessage) {
                await this.logQuarantineFailure(currentRequest, failureReason, errorMessage);
                this.renderQuarantineRetryDialog(dialog, errorMessage);
                return false;
            }
            await this.logQuarantineSuccess(currentRequest, failedAt, failureReason);
            this.dispatchQuarantineEvent(currentRequest);
            return true;
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : String(error);
            console.error("Error preparing unloadable task quarantine:", error);
            await this.logQuarantineFailure(currentRequest, failureReason, errorMessage);
            this.renderQuarantineRetryDialog(dialog, errorMessage);
            return false;
        }
    }
    /**
     * Move an unloadable task out of the normal assignment queue and proceed to the next document.
     */ async discardTaskAndProceed(dialog = document.getElementById("dialog")) {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        if (!(currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838))) {
            this.proceedToNextDocument();
            return;
        }
        const failureReason = this.lastDocumentLoadError || "Document could not be loaded in HITL UI";
        const quarantined = await this.quarantineFirestoreTask(currentRequest, dialog, failureReason);
        if (quarantined) {
            dialog?.close();
            this.proceedToNextDocument();
        }
    }
    // ==================== KEYBOARD SHORTCUT HANDLERS ====================
    // Based on working implementation from second repo
    /**
     * Click the clearing button directly
     */ clickClearingButton() {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        const processorType = currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? currentRequest.processorType : currentRequest.type;
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: this.userId,
            action: 'Send to Clearing (Keyboard Shortcut)',
            additionalInfo: {
                reviewRequestName: currentRequest.name,
                shortcut: 'Alt+8'
            }
        });
        // Try multiple strategies to find and click the clearing/secondary button
        let clearingButton = null;
        if (this.documentViewElement) {
            // Strategy 1: Look for secondary button class
            if (this.documentViewElement.shadowRoot) clearingButton = this.documentViewElement.shadowRoot.querySelector('.secondary-button');
            if (!clearingButton) clearingButton = this.documentViewElement.querySelector('.secondary-button');
            // Strategy 2: Look for button containing "CLEARING" text
            if (!clearingButton) {
                const allButtons = this.documentViewElement.shadowRoot ? this.documentViewElement.shadowRoot.querySelectorAll('button') : this.documentViewElement.querySelectorAll('button');
                for (const button of allButtons)if (button.textContent?.includes('CLEARING') || button.textContent?.includes('Clearing') || button.getAttribute('label')?.includes('CLEARING')) {
                    clearingButton = button;
                    break;
                }
            }
            // Strategy 3: Look for mwc-button with specific attributes
            if (!clearingButton) {
                const mwcButtons = this.documentViewElement.shadowRoot ? this.documentViewElement.shadowRoot.querySelectorAll('mwc-button') : this.documentViewElement.querySelectorAll('mwc-button');
                for (const button of mwcButtons)if (button.getAttribute('label') === 'CLEARING' || button.textContent?.includes('CLEARING')) {
                    clearingButton = button;
                    break;
                }
            }
        }
        if (clearingButton) clearingButton.click();
        else // Fallback: Try to trigger the secondaryButtonClick event programmatically
        if (this.documentViewElement && typeof this.documentViewElement.triggerSecondaryAction === 'function') this.documentViewElement.triggerSecondaryAction();
        else console.error('Clearing button not found and no fallback method available');
    }
    /**
     * Delete Process (Ctrl+Alt+0)
     */ deleteProcess() {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        // Only allow delete process in classification mode
        const processorType = currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? currentRequest.processorType : currentRequest.type;
        if (processorType !== (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION && currentRequest.type !== "DAI_COMPLEX_CLASSIFICATION") return;
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: this.userId,
            action: 'Delete Process (Keyboard Shortcut)',
            additionalInfo: {
                reviewRequestName: currentRequest.name,
                shortcut: 'Ctrl+Alt+0'
            }
        });
        const dialog = document.getElementById("dialog");
        if (dialog) {
            dialog.heading = "Prozess l\xf6schen";
            (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`<p>Sind Sie sicher, dass Sie diesen Prozess löschen möchten?</p>
                <p><strong>Diese Aktion kann nicht rückgängig gemacht werden.</strong></p>
                <mwc-button
                        slot="secondaryAction"
                        dialogAction="cancel"
                >Abbrechen
                </mwc-button>
                <mwc-button
                        slot="primaryAction"
                        dialogAction="ok"
                        @click=${this.confirmDeleteProcess}
                >Löschen
                </mwc-button>`, dialog);
            dialog.open = true;
        }
    }
    /**
     * Clear All Extracted Fields (Ctrl+Shift+D)
     */ clearAllExtractedFields() {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        // Only allow clearing fields in data extraction mode (Entity type)
        const processorType = currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? currentRequest.processorType : currentRequest.type;
        if (processorType !== (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).EXTRACTION && currentRequest.type !== "Entity") return;
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: this.userId,
            action: 'Clear All Extracted Fields (Keyboard Shortcut)',
            additionalInfo: {
                reviewRequestName: currentRequest.name,
                shortcut: 'Ctrl+Shift+D'
            }
        });
        // Find all delete buttons and click them to clear all fields.
        const deleteButtons = document.querySelectorAll('button[aria-label="Quick delete"], button[cfctooltip="delete"]');
        if (deleteButtons.length > 0) {
            deleteButtons.forEach((button)=>button.click());
            this.showTemporaryNotification(`${deleteButtons.length} fields cleared successfully.`, 2000);
        } else this.showTemporaryNotification('Could not find any fields to clear.', 2000);
    }
    /**
     * Exit Without Saving (F4)
     */ exitWithoutSaving() {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        // Only allow exit without saving in data extraction mode (Entity type)
        const processorType = currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? currentRequest.processorType : currentRequest.type;
        if (processorType !== (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).EXTRACTION && currentRequest.type !== "Entity") return;
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: this.userId,
            action: 'Exit Without Saving (F4 hotkey)',
            additionalInfo: {
                reviewRequestName: currentRequest.name,
                shortcut: 'F4'
            }
        });
        // Return to main page without saving - same as back button behavior
        this.closeReview();
        // Hide the banner if it was being displayed
        const banner = document.getElementById("documentAgainInHINTBanner");
        if (banner) banner.style.display = "none";
    }
    /**
     * Navigate to Next Field or Complete (Enter)
     */ navigateToNextFieldOrComplete() {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        // Only allow field navigation in data extraction mode (Entity type)
        const processorType = currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? currentRequest.processorType : currentRequest.type;
        if (processorType !== (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).EXTRACTION && currentRequest.type !== "Entity") return;
        try {
            // Field navigation only - Enter key no longer triggers save
            const activeElement = document.activeElement;
            if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.closest('mwc-textfield'))) {
                // We're in an input field, try to navigate to next
                const allInputs = Array.from(document.querySelectorAll('input, textarea, mwc-textfield'));
                const currentIndex = allInputs.indexOf(activeElement);
                if (currentIndex !== -1 && currentIndex < allInputs.length - 1) {
                    // Move to next field
                    (0, $a30lF.logAction)({
                        timestamp: new Date().toISOString(),
                        severity: 'INFO',
                        userId: this.userId,
                        action: 'Next Field (Enter hotkey)',
                        additionalInfo: {
                            reviewRequestName: currentRequest.name,
                            fieldIndex: currentIndex + 1
                        }
                    });
                    allInputs[currentIndex + 1].focus();
                } else // At last field - stay focused, no save action
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: 'INFO',
                    userId: this.userId,
                    action: 'Last Field Reached (Enter hotkey)',
                    additionalInfo: {
                        reviewRequestName: currentRequest.name,
                        message: 'Use Ctrl+S to save document'
                    }
                });
            }
        // If not in an input field, do nothing (no accidental saves)
        } catch (error) {
            console.error('Error in navigateToNextFieldOrComplete:', error);
        }
    }
    /**
     * Select classification class by ID (Number keys 0-9)
     * Finds and selects a classification class that starts with the given ID
     *
     * NEW APPROACH: Directly manipulate the <cfc-select> component to update the dropdown
     */ selectClassById(classId) {
        const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
        // Only work in classification mode
        const processorType = currentRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838) ? currentRequest.processorType : currentRequest.type;
        if (processorType !== (0, $1d7c3ce87f93ab74$export$20033ba95002c1ee).CLASSIFICATION && currentRequest.type !== "DAI_COMPLEX_CLASSIFICATION") return;
        // Find the classification label that starts with this ID
        const classificationLabel = currentRequest.labels.find((label)=>label instanceof (0, $150c59cc1c2ee7ed$export$59e7611a9b95daae));
        if (!classificationLabel || !classificationLabel.values) {
            console.warn(`No classification labels found for hotkey ${classId}`);
            return;
        }
        // Find the EntityLabel that starts with the given ID
        const matchingLabel = classificationLabel.values.find((value)=>value.label.startsWith(`${classId} - `));
        if (!matchingLabel) {
            console.warn(`No classification class found for ID: ${classId}`);
            this.showTemporaryNotification(`Keine Klasse f\xfcr ID ${classId} gefunden`, 2000);
            return;
        }
        console.log(`DEBUG selectClassById - Selected class: ${matchingLabel.label}`);
        // Log the selection
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: 'INFO',
            userId: this.userId,
            action: 'Classification Hotkey Selection',
            additionalInfo: {
                reviewRequestName: currentRequest.name,
                hotkey: classId,
                selectedClass: matchingLabel.label
            }
        });
        // Update the classification label's selectedValue - this is what gets saved!
        // IMPORTANT: Strip the ID prefix before saving to avoid backend KeyError
        // The label format is "ID - ClassName", but backend expects only "ClassName"
        const strippedLabel = matchingLabel.originalDisplayName || matchingLabel.label.replace(/^\d+ - /, '');
        classificationLabel.selectedValue = strippedLabel;
        console.log(`DEBUG - Updated classificationLabel.selectedValue from: "${matchingLabel.label}" to: "${classificationLabel.selectedValue}"`);
        // NEW: Try to update the <cfc-select> (Angular Material) dropdown element directly
        try {
            // Find the cfc-select element (Angular Material component)
            const cfcSelect = document.querySelector('cfc-select[role="combobox"]');
            if (cfcSelect) {
                console.log('DEBUG - Found cfc-select element:', cfcSelect);
                // Strategy 1: Click the dropdown to open it
                cfcSelect.click();
                console.log('DEBUG - Clicked dropdown to open');
                // Wait for dropdown to open and find the matching option
                setTimeout(()=>{
                    // Find all mat-option elements that contain the matching text
                    const options = document.querySelectorAll('mat-option');
                    console.log(`DEBUG - Found ${options.length} mat-option elements`);
                    let foundOption = null;
                    for (const option of options){
                        const optionText = option.querySelector('.mat-option-text');
                        if (optionText && optionText.textContent?.trim() === matchingLabel.label) {
                            foundOption = option;
                            console.log('DEBUG - Found matching option:', optionText.textContent);
                            break;
                        }
                    }
                    if (foundOption) {
                        // Click the matching option
                        foundOption.click();
                        console.log('DEBUG - Clicked matching option');
                        this.showTemporaryNotification(`\u{2713} Klasse "${matchingLabel.label}" ausgew\xe4hlt`, 3000);
                    } else {
                        console.warn('DEBUG - Could not find matching option in dropdown');
                        // Close the dropdown
                        cfcSelect.click();
                        this.showTemporaryNotification(`\u{2713} Klasse "${matchingLabel.label}" intern ausgew\xe4hlt`, 3000);
                    }
                }, 100); // Wait 100ms for dropdown to open
            } else {
                console.warn('DEBUG - cfc-select element not found, falling back to internal state only');
                this.showTemporaryNotification(`\u{2713} Klasse "${matchingLabel.label}" intern ausgew\xe4hlt`, 3000);
            }
        } catch (error) {
            console.error('Error updating cfc-select dropdown:', error);
            this.showTemporaryNotification(`\u{2713} Klasse "${matchingLabel.label}" intern ausgew\xe4hlt`, 3000);
        }
    }
    /**
     * Show digit buffer visual feedback for multi-digit class ID input
     */ showDigitBufferFeedback(buffer) {
        // Remove existing feedback if any
        this.hideDigitBufferFeedback();
        // Create feedback element
        const feedback = document.createElement('div');
        feedback.id = 'digit-buffer-feedback';
        feedback.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0, 135, 70, 0.95);
      color: white;
      padding: 24px 32px;
      border-radius: 8px;
      font-family: 'Roboto', sans-serif;
      font-size: 32px;
      font-weight: 500;
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
      z-index: 10001;
      min-width: 100px;
      text-align: center;
      border: 3px solid rgba(255, 255, 255, 0.3);
    `;
        // Add content with current buffer and hint
        feedback.innerHTML = `
      <div style="margin-bottom: 8px;">Klassen-ID:</div>
      <div style="font-size: 48px; font-weight: 700; letter-spacing: 4px;">${buffer}</div>
      <div style="font-size: 14px; margin-top: 12px; opacity: 0.9;">
        Enter zum Best\xe4tigen | Esc zum Abbrechen
      </div>
    `;
        // Add to document
        document.body.appendChild(feedback);
    }
    /**
     * Hide digit buffer visual feedback
     */ hideDigitBufferFeedback() {
        const existing = document.getElementById('digit-buffer-feedback');
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    }
    /**
     * Show temporary notification to user
     */ showTemporaryNotification(message, duration = 3000) {
        // Create notification element
        const notification = document.createElement('div');
        notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #BE153F !important;
      color: white;
      padding: 16px 24px;
      border-radius: 4px;
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      z-index: 10000;
      opacity: 0;
      transform: translateX(100%);
      transition: all 0.3s ease;
    `;
        notification.textContent = message;
        // Add to document
        document.body.appendChild(notification);
        // Show with animation
        setTimeout(()=>{
            notification.style.opacity = '1';
            notification.style.transform = 'translateX(0)';
        }, 10);
        // Hide and remove after duration
        setTimeout(()=>{
            notification.style.opacity = '0';
            notification.style.transform = 'translateX(100%)';
            setTimeout(()=>{
                if (notification.parentNode) notification.parentNode.removeChild(notification);
            }, 300);
        }, duration);
    }
    disconnectedCallback() {
        (0, $562a56af2be4988d$export$c6962176354dc525).deactivate();
        super.disconnectedCallback();
    }
    constructor(...args){
        super(...args), this.reviewRequests = [], this.reviewRequestsIndex = 0, this.userId = "", // New property to store the rendered DocumentView element
        this.documentViewElement = null, this.rejectReason = "", this.humanRevisionStateMessage = "", this.humanRevisionState = "requested", this.lastDocumentLoadError = "", // Save queue status tracking
        this.saveQueueStatus = {
            pending: 0,
            inProgress: 0,
            completed: 0,
            failed: 0,
            total: 0
        }, /**
     * Global field change handler.
     * If the changed field is "rejectReason", update the rejectReason property.
     * Logs every field change with enriched context.
     */ this.handleFieldChange = (e)=>{
            const target = e.target;
            if (!target || !target.name) return;
            const newValue = target.value;
            const fieldName = target.name;
            // If the changed field is the reject reason, update the property
            if (fieldName === "rejectReason") this.rejectReason = newValue;
            const currentReviewRequest = this.reviewRequests[this.reviewRequestsIndex];
            (0, $a30lF.logAction)({
                timestamp: new Date().toISOString(),
                severity: "INFO",
                userId: this.userId,
                action: "Field changed",
                additionalInfo: {
                    fieldName: fieldName,
                    newValue: newValue,
                    batch_id: currentReviewRequest.data?.batch_id,
                    envelope_id: currentReviewRequest.data?.envelope_id,
                    processorType: currentReviewRequest.data?.processorType,
                    queue: currentReviewRequest.queue
                }
            });
        }, // Legacy hotkey handler - now replaced by centralized keyboard shortcuts
        this.handleHotkeys = (e)=>{
            // Keep existing Ctrl+S functionality for backward compatibility
            if ((e.ctrlKey || e.metaKey) && (e.key === "s" || e.key === "S")) {
                e.preventDefault();
                this.clickSaveButton();
            }
        }, this.rejectDocument = async (e)=>{
            // ensure that the access token gets refreshed if necessary
            await this.getAccessToken(true);
            this.humanRevisionStateMessage = this.rejectReason;
            this.humanRevisionState = "rejected";
            const currentReviewRequest = this.reviewRequests[this.reviewRequestsIndex];
            const dialog = document.getElementById("dialog");
            if (this.rejectReason != "") {
                // Log comprehensive document rejection with enhanced information
                const additionalInfo = {
                    reviewRequestName: currentReviewRequest.name,
                    batch_id: currentReviewRequest.data?.batch_id,
                    envelope_id: currentReviewRequest.data?.envelope_id,
                    processorType: currentReviewRequest.data?.processorType,
                    queue: currentReviewRequest.queue,
                    requestType: currentReviewRequest.constructor.name,
                    rejectReason: this.rejectReason
                };
                // Add additional processor information if available (for Firestore requests)
                if (currentReviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) {
                    additionalInfo.taskId = currentReviewRequest.taskId;
                    additionalInfo.documentId = currentReviewRequest.documentId;
                    additionalInfo.envelopeId = currentReviewRequest.envelopeId;
                    additionalInfo.priority = currentReviewRequest.priority;
                    additionalInfo.processorTypeFromRequest = currentReviewRequest.processorType;
                } else additionalInfo.legacyType = currentReviewRequest.type;
                // Add key processor, envelope and document information
                if (currentReviewRequest.data) {
                    // Core envelope information
                    additionalInfo.envelope_id = currentReviewRequest.data.envelope_id;
                    additionalInfo.document_class = currentReviewRequest.data.document_class;
                    additionalInfo.original_filename = currentReviewRequest.data.original_filename;
                    additionalInfo.workflow_id = currentReviewRequest.data.workflow_id;
                    additionalInfo.submission_timestamp = currentReviewRequest.data.submission_timestamp;
                    // Processor information from various possible locations
                    additionalInfo.processor_type_alt = currentReviewRequest.data.processor_type;
                    additionalInfo.processor_id = currentReviewRequest.data.processor_id;
                    additionalInfo.task_id = currentReviewRequest.data.task_id;
                    additionalInfo.document_id = currentReviewRequest.data.document_id;
                    additionalInfo.priority = currentReviewRequest.data.priority;
                    additionalInfo.status = currentReviewRequest.data.status;
                    // Document data information
                    if (currentReviewRequest.data.documentData) {
                        additionalInfo.originalFileName = currentReviewRequest.data.documentData.originalFileName;
                        additionalInfo.documentId = currentReviewRequest.data.documentData.documentId;
                        additionalInfo.mimeType = currentReviewRequest.data.documentData.mimeType;
                        // Processor details from processed_data
                        if (currentReviewRequest.data.documentData.processed_data) {
                            const processedData = currentReviewRequest.data.documentData.processed_data;
                            additionalInfo.processorVersion = processedData.processorVersion;
                            additionalInfo.processorDisplayName = processedData.processorDisplayName;
                            additionalInfo.processorProject = processedData.processorProject;
                            additionalInfo.processorIdFromProcessedData = processedData.processorId;
                        }
                    }
                    // Add all available data keys for debugging
                    additionalInfo.availableDataKeys = Object.keys(currentReviewRequest.data);
                }
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "INFO",
                    userId: this.userId,
                    action: "Document rejected",
                    additionalInfo: additionalInfo
                });
                // Close the dialog before triggering save
                if (dialog) dialog.open = false;
                // Try to trigger the save action by looking for the primary save button.
                let saveButton = null;
                if (this.documentViewElement) {
                    // Try the shadow DOM first...
                    if (this.documentViewElement.shadowRoot) saveButton = this.documentViewElement.shadowRoot.querySelector(".primary-button");
                    // If not found, try the light DOM of the DocumentView element
                    if (!saveButton) saveButton = this.documentViewElement.querySelector(".primary-button");
                }
                if (saveButton) {
                    console.log("Simulating click on save button.");
                    saveButton.click();
                } else console.error("Save button not found; cannot trigger save action.");
            } else {
                console.log("Stopping propagation due to missing rejection reason");
                e.stopPropagation();
                e.preventDefault();
                if (dialog) {
                    // Instead of re-rendering the entire dialog content, just update the textfield focus and validation
                    const existingTextField = dialog.querySelector('mwc-textfield[name="rejectReason"]');
                    if (existingTextField) {
                        // Focus the existing textfield and show validation error
                        existingTextField.focus();
                        existingTextField.setCustomValidity("Bitte geben Sie einen Storno-Grund ein.");
                        existingTextField.reportValidity();
                        // Clear the validation error when user starts typing
                        existingTextField.addEventListener('input', ()=>{
                            existingTextField.setCustomValidity("");
                        }, {
                            once: true
                        });
                    } else {
                        // Fallback: re-render if textfield not found, but ensure proper event handling
                        dialog.heading = "Tragen Sie hier den Storno-Grund ein.";
                        (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                            <mwc-textfield
                                    outlined
                                    style="width: 100%; margin-top: 12px;"
                                    required
                                    name="rejectReason"
                                    value=${this.rejectReason}
                                    label="Fehlenden Storno-Grund eingeben"
                                    @change=${this.handleFieldChange}
                                    @input=${this.handleFieldChange}
                                    @keydown=${(e)=>{
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                this.rejectDocument(e);
                            }
                        }}
                            ></mwc-textfield>
                            <mwc-button
                                    label="CLEARING"
                                    slot="primaryAction"
                                    dialogAction="ok"
                                    @click=${this.rejectDocument}
                            ></mwc-button>`, dialog);
                    }
                    // Ensure dialog remains open
                    dialog.open = true;
                    // Auto-focus the textfield after dialog re-renders
                    requestAnimationFrame(()=>{
                        const textfield = dialog.querySelector('mwc-textfield[name="rejectReason"]');
                        if (textfield) textfield.focus();
                    });
                }
            }
        }, this.escalateDocument = async (event)=>{
            const dialog = document.getElementById("dialog");
            try {
                var accessToken = event.target.dataset.value;
                // ensure that the access token gets refreshed if necessary
                await this.getAccessToken(true);
                //retrieve the reviewRequest
                var reviewRequest = this.reviewRequests[this.reviewRequestsIndex];
                // Log escalation initiation (again, if not already logged in escalate callback)
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "INFO",
                    userId: this.userId,
                    action: "Document escalation initiated",
                    additionalInfo: {
                        reviewRequestName: reviewRequest.name,
                        batch_id: reviewRequest.data?.batch_id,
                        envelope_id: reviewRequest.data?.envelope_id,
                        processorType: reviewRequest.data?.processorType,
                        queue: reviewRequest.queue
                    }
                });
                //check if it is the entity extractor (HINT)
                if (reviewRequest.type === "Entity") {
                    var pubsubMessage = reviewRequest.data;
                    console.log("This is the stringified pubsubMessage:", JSON.stringify(pubsubMessage));
                    // publish message to the escalationTopic
                    var url_topic = `https://pubsub.googleapis.com/v1/projects/${reviewRequest.projectId}/topics/hint_escalation_queues:publish`;
                    await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(url_topic, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer " + accessToken
                        },
                        body: JSON.stringify({
                            messages: [
                                {
                                    data: $ad42dc5b6815f2da$require$Buffer.from(JSON.stringify(pubsubMessage)).toString("base64")
                                }
                            ]
                        })
                    });
                    // acknowledge the message from the source subscription
                    var url_subscription = `https://pubsub.googleapis.com/v1/${reviewRequest.subscriptionName}:acknowledge`;
                    await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(url_subscription, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer " + accessToken
                        },
                        body: JSON.stringify({
                            ackIds: [
                                reviewRequest.ackId
                            ]
                        })
                    });
                }
                // stop extending acknowledgement deadline for this particular document
                if (this.reviewRequests[this.reviewRequestsIndex].extendAckIdWorker) this.reviewRequests[this.reviewRequestsIndex].extendAckIdWorker.terminate();
                //close the dialog
                dialog.open = false;
                await this.getAccessToken(true);
                this.reviewRequests = this.reviewRequests.filter((_, i)=>i !== this.reviewRequestsIndex);
                if (this.reviewRequests.length > 0) {
                    await this.getAccessToken(true);
                    this.reviewRequestsIndex = Math.min(this.reviewRequestsIndex, this.reviewRequests.length - 1);
                    this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
                } else {
                    this.closeReview();
                    console.log("REMOVING THE BANNER DUE TO SAVING");
                    document.getElementById("documentAgainInHINTBanner").style.display = "none";
                }
            } catch (error) {
                console.log("Error while escalating the document", error);
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "ERROR",
                    userId: this.userId,
                    action: "Document escalation failed",
                    additionalInfo: {
                        reviewRequestName: this.reviewRequests[this.reviewRequestsIndex]?.name,
                        batch_id: this.reviewRequests[this.reviewRequestsIndex]?.data?.batch_id,
                        envelope_id: this.reviewRequests[this.reviewRequestsIndex]?.data?.envelope_id,
                        processorType: this.reviewRequests[this.reviewRequestsIndex]?.data?.processorType,
                        queue: this.reviewRequests[this.reviewRequestsIndex]?.queue,
                        error: error
                    }
                });
                dialog.heading = "Eskalation fehlgeschlagen oder abgebrochen.";
                (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                    <mwc-button slot="primaryAction" dialogAction="ok"
                    >OK
                    </mwc-button
                    >`, dialog);
                dialog.open = true;
            }
        }, this.confirmDeleteProcess = ()=>{
            const currentRequest = this.reviewRequests[this.reviewRequestsIndex];
            try {
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: 'WARNING',
                    userId: this.userId,
                    action: 'Process deleted',
                    additionalInfo: {
                        reviewRequestName: currentRequest.name
                    }
                });
                this.reviewRequests = this.reviewRequests.filter((_, i)=>i !== this.reviewRequestsIndex);
                const dialog = document.getElementById("dialog");
                if (dialog) dialog.open = false;
                if (this.reviewRequests.length > 0) {
                    this.reviewRequestsIndex = Math.min(this.reviewRequestsIndex, this.reviewRequests.length - 1);
                    this.reviewDocument(this.reviewRequests[this.reviewRequestsIndex]);
                } else this.closeReview();
            } catch (error) {
                console.error('Error deleting process:', error);
            }
        };
    }
}
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Array
    })
], $ad42dc5b6815f2da$export$6fffb60373372c0.prototype, "reviewRequests", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Number
    })
], $ad42dc5b6815f2da$export$6fffb60373372c0.prototype, "reviewRequestsIndex", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String
    })
], $ad42dc5b6815f2da$export$6fffb60373372c0.prototype, "userId", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Object
    })
], $ad42dc5b6815f2da$export$6fffb60373372c0.prototype, "saveQueueStatus", void 0);
$ad42dc5b6815f2da$export$6fffb60373372c0 = (0, $czHfO.__decorate)([
    (0, $df800a9dc9638977$export$da64fc29f17f9d0e)("hitl-review-document")
], $ad42dc5b6815f2da$export$6fffb60373372c0);





var $a30lF = parcelRequire("a30lF");

// ABOUTME: Version information for the HITL UI
// ABOUTME: Automatically populated from Azure DevOps pipeline build number or npm script
// APP_BUILD_NUMBER format:
// - Pipeline: YYYYMMDD.buildAttemptNumber (e.g., "20251110.63")
// - Local dev: YYYYMMDD.dev-GITHASH (e.g., "20251110.dev-2987227")
// - Fallback: "dev-local" if environment variable not set
const $1018539d0d0a6926$export$7a3351394a303ac2 = "20260706.4";



// to prevent an access token expiration, how many minutes before the expiration should the accessToken be renewed?
const $7ad5d60cead493d6$var$MINUTES_BEFORE_ACCESS_TOKEN_RENEWAL = 20;
var $7ad5d60cead493d6$var$ComponentType = /*#__PURE__*/ function(ComponentType) {
    ComponentType[ComponentType["ManageBatchAndQueues"] = 0] = "ManageBatchAndQueues";
    ComponentType[ComponentType["ReviewDocument"] = 1] = "ReviewDocument";
    return ComponentType;
}($7ad5d60cead493d6$var$ComponentType || {});
var $cacaf4c590a6c4cc$exports = {};

let $cacaf4c590a6c4cc$var$url = new URL(import.meta.resolve("2cYrp"));
$cacaf4c590a6c4cc$exports = $d4c1b3532db9c06f$exports($cacaf4c590a6c4cc$var$url.toString(), $cacaf4c590a6c4cc$var$url.origin, true);


class $7ad5d60cead493d6$export$71c93d36757fcdb1 extends (0, $9cd293958617bb59$export$3f2f9f5909897157) {
    static{
        this.CACHE_DURATION = 3000 // 3 seconds
        ;
    }
    createRenderRoot() {
        return this;
    }
    #accessTokenAD;
    #accessToken;
    #idToken;
    #accessTokenExpiration;
    #loggedUserName;
    #loggedUserEmail;
    #loggedUserAccessType;
    #sessionCreatedAt;
    connectedCallback() {
        super.connectedCallback();
        // Attempt to restore session before initializing
        this.attemptSessionRestore();
    }
    firstUpdated() {
        // load AI UI component scripts into document head
        let aiuiScriptElement = document.createElement("script");
        aiuiScriptElement.src = "https://aiui.googleapis.com/v1/component/client.js?key=DEFAULT_API_KEY";
        aiuiScriptElement.src += "&version=DEFAULT_AI_UI_API_VERSION";
        document.head.appendChild(aiuiScriptElement);
        // load Google Identity Services library and register callbacks to ensure that GIS is loaded before login button is used
        let gsiScriptElement = document.createElement("script");
        gsiScriptElement.src = "https://accounts.google.com/gsi/client";
        gsiScriptElement.onload = this.setupIdentityServices.bind(this);
        document.head.appendChild(gsiScriptElement);
        if (this.identityType === "gis") this.loginRequired = true;
        else if (this.identityType === "ad") {
            const configuration = {
                auth: {
                    clientId: "DEFAULT_AD_CLIENT_ID",
                    authority: "https://login.microsoftonline.com/DEFAULT_AD_TENANT_ID",
                    redirectUri: "DEFAULT_AD_REDIRECT_URI"
                }
            };
            this.ADclientApplication = new (0, $3bd58a16e7acfae5$export$89f4855ef88b7920)(configuration);
            this.ADclientApplication.initialize();
            this.loginRequired = true;
            this.setupCompleted = true;
        } else {
            this.loginRequired = false;
            this.setupCompleted = true;
        }
        // Listen for global task completion events
        this.boundTaskCompletedHandler = this.handleTaskCompleted.bind(this);
        document.addEventListener("task-completed", this.boundTaskCompletedHandler);
        // Set up tab close protection for pending saves
        this.boundBeforeUnloadHandler = this.handleBeforeUnload.bind(this);
        window.addEventListener("beforeunload", this.boundBeforeUnloadHandler);
    }
    handleBeforeUnload(event) {
        // Check if there are pending saves
        if ((0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).hasPendingOperations()) {
            const status = (0, $43dc3253d70ebbd2$export$7b3128b0a24a6b60).getStatus();
            const message = `Sie haben ${status.pending + status.inProgress} ausstehende Speichervorg\xe4nge. M\xf6chten Sie wirklich fortfahren?`;
            // Modern browsers ignore custom messages, but setting returnValue triggers the warning
            event.preventDefault();
            event.returnValue = message;
            console.warn("User attempted to close tab with pending save operations:", status);
            return message;
        }
    }
    render() {
        const template = [];
        template.push((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)` <mwc-dialog id="dialog"> </mwc-dialog> `);
        if (this.componentType === 0) template.push((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
        <style>
          .mdc-top-app-bar-fixed {
            background-color: #be153f;
          }

          .header-content {
            display: flex;
            align-items: center;
            justify-content: flex-start; /* Ensures the content is aligned to the left */
            width: 100%;
            padding: 10px;
          }

          .logo {
            height: 40px;
            margin-right: 10px;
            background-color: white; /* Adds white background to the logo */
            padding: 5px; /* Adjust padding as needed */
            border-radius: 5px; /* Optional: adds rounded corners */
          }

          .header-title {
            color: white;
            font-size: 20px;
            font-weight: bold;
          }

          .logout-button {
            --mdc-icon-button-size: 48px;
            --mdc-icon-size: 24px;
            color: white;
          }

          .user-info {
            color: white;
            font-size: 14px;
            margin-right: 16px;
            display: flex;
            align-items: center;
          }

          .content-wrapper {
            padding: 20px;
          }

          .rows {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            gap: 1rem;
          }

          .version-badge {
            position: fixed;
            bottom: 10px;
            right: 10px;
            background-color: rgba(0, 72, 103, 0.8);
            color: white;
            padding: 4px 10px;
            border-radius: 4px;
            font-size: 11px;
            font-family: monospace;
            z-index: 1000;
            cursor: help;
          }
        </style>
        <mwc-top-app-bar-fixed id="header" ?centertitle=${false}>
          <div slot="title" class="header-content">
            <img src="${this.clientLogo}" alt="Logo" class="logo" />
            <span class="header-title">${this.appTitle}</span>
          </div>
          ${this.userId ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                <div
                  slot="actionItems"
                  style="display: flex; align-items: center;"
                >
                  <span class="user-info"
                    >${this.#loggedUserName || this.#loggedUserEmail}</span
                  >
                  <mwc-icon-button
                    class="logout-button"
                    icon="logout"
                    title="Logout"
                    @click=${this.logout}
                  ></mwc-icon-button>
                </div>
              ` : ""}
        </mwc-top-app-bar-fixed>
        <main>
          <div class="content-wrapper">
            ${!this.userId ? this.loginRequired // login required and no userId available
         ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                    <div class="rows">
                      <mwc-button
                        raised
                        style="margin: auto; min-width: 25ex;"
                        @click=${this.login}
                        label="Login"
                        ?disabled=${!this.setupCompleted}
                      ></mwc-button>
                      ${window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || this.detectedEnvironment && (this.detectedEnvironment.startsWith("DEFAULT_CLIENT_PREFIX-dev-") || this.detectedEnvironment.startsWith("DEFAULT_CLIENT_PREFIX-ci-") || this.detectedEnvironment.startsWith("DEFAULT_CLIENT_PREFIX-poc-")) ? (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                            <mwc-formfield
                              label="Are you using a Deloitte account?"
                            >
                              <mwc-checkbox
                                id="deloitteCb"
                                type="checkbox"
                                @change=${this.updateIdentityType}
                              ></mwc-checkbox>
                            </mwc-formfield>
                          ` : ""}
                    </div>
                  ` : (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)` <mwc-textfield
                    style="margin: auto;max-width: 25ex;"
                    id="userId"
                    required
                    value=${this.userId}
                    @change=${this.updateUserId}
                    label="User ID"
                  ></mwc-textfield>` : (0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                <hitl-queues
                  .queues=${this.queues}
                  .queueType=${this.queueType}
                  @queues-updated=${this.updateQueues}
                  @review-requests-updated=${this.addReviewRequests}
                  @review-requests-loading=${this.handleReviewRequestsLoading}
                  @review-requests-progress=${this.handleReviewRequestsProgress}
                  @review-requests-error=${this.handleReviewRequestsError}
                  @review-requests-completed=${this.handleReviewRequestsCompleted}
                  @environment-detected=${this.handleEnvironmentDetected}
                  @get-access-token=${this.getAccessTokenEvent}
                ></hitl-queues>
                <hitl-batch
                @batch-review-triggered=${this.startBatchReview}
                @review-requests-updated=${this.replaceReviewRequests}
                @task-released=${this.handleTaskReleased}
                @get-access-token=${this.getAccessTokenEvent}
                .reviewRequests=${this.reviewRequests}>
              </hitl-batch>
              </div>
              `}
          </div>
        </main>
        <div class="version-badge" title="Build Number">
          ${(0, $1018539d0d0a6926$export$7a3351394a303ac2)}
        </div>
      `);
        else if (this.componentType === 1) template.push((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
        <style>
          .version-badge {
            position: fixed;
            bottom: 10px;
            right: 10px;
            background-color: rgba(0, 72, 103, 0.8);
            color: white;
            padding: 4px 10px;
            border-radius: 4px;
            font-size: 11px;
            font-family: monospace;
            z-index: 1000;
            cursor: help;
          }
        </style>
        <hitl-review-document
          @manage-batch-and-queues-triggered=${this.manageBatchAndQueues}
          .reviewRequests=${this.reviewRequests}
          .userId=${this.userId}
          @get-access-token=${this.getAccessTokenEvent}
        ></hitl-review-document>
        <div class="version-badge" title="Build Number">
          ${(0, $1018539d0d0a6926$export$7a3351394a303ac2)}
        </div>
      `);
        return template;
    }
    setupIdentityServices() {
        this.setupCompleted = true;
        this.initTokenClient = google.accounts.oauth2.initTokenClient;
    }
    updateIdentityType(e) {
        const hitlAppElement = document.getElementById("hitlApp");
        if (e.target.checked) {
            hitlAppElement.setAttribute("identityType", "gis");
            this.identityType = "gis";
        } else {
            hitlAppElement.setAttribute("identityType", "ad");
            this.identityType = "ad";
            // Initialize AD client application when switching to AD identity
            if (!this.ADclientApplication) {
                const configuration = {
                    auth: {
                        clientId: "DEFAULT_AD_CLIENT_ID",
                        authority: "https://login.microsoftonline.com/DEFAULT_AD_TENANT_ID",
                        redirectUri: "DEFAULT_AD_REDIRECT_URI"
                    }
                };
                this.ADclientApplication = new (0, $3bd58a16e7acfae5$export$89f4855ef88b7920)(configuration);
                this.ADclientApplication.initialize();
            }
        }
    }
    updateUserId(e) {
        this.userId = e.target.value;
    }
    updateQueues(e) {
        this.queues = e.detail;
    }
    async addReviewRequests(e) {
        const newReviewRequests = e.detail;
        const [accessToken, idToken] = await this.getAccessToken();
        newReviewRequests.forEach((reviewRequest)=>{
            if (reviewRequest instanceof (0, $20e0088800729d63$export$9fee94aa43a40124)) {
                // setup ExtendAckIdWorker to regularly extend the ackId and thus prevent someone else picking up the message
                reviewRequest.extendAckIdWorker = new Worker($cacaf4c590a6c4cc$exports);
                reviewRequest.extendAckIdWorker.postMessage([
                    reviewRequest.subscriptionName,
                    reviewRequest.ackId,
                    accessToken
                ]);
                reviewRequest.extendAckIdWorker.onmessage = this.ackIdExtensionError.bind(this);
            } else if (reviewRequest instanceof (0, $20e0088800729d63$export$9ddd7e36c6c46838)) // Firestore tasks don't need deadline extension like PubSub
            // Tasks are assigned with expiresAt and auto-released by cleanup processes
            console.log(`Firestore task ${reviewRequest.taskId} assigned, no deadline extension needed`);
        });
        // Filter out duplicates before adding new requests
        const existingIds = new Set(this.reviewRequests.map((req)=>req.id()));
        const uniqueNewRequests = newReviewRequests.filter((req)=>!existingIds.has(req.id()));
        this.reviewRequests = this.reviewRequests.concat(uniqueNewRequests);
        if (uniqueNewRequests.length !== newReviewRequests.length) console.log(`Filtered out ${newReviewRequests.length - uniqueNewRequests.length} duplicate requests`);
        // Start periodic token refresh for worker tokens if we have review requests
        if (this.reviewRequests.length > 0) this.startTokenRefreshTimer();
        // Log addition of review requests
        (0, $a30lF.logAction)({
            timestamp: new Date().toISOString(),
            severity: "INFO",
            userId: this.userId,
            action: "Added review requests",
            additionalInfo: {
                count: newReviewRequests.length
            }
        });
        // Save updated session with new review requests
        this.saveCurrentSession();
    }
    async replaceReviewRequests(e) {
        this.reviewRequests = e.detail;
        // Save session after replacing review requests
        this.saveCurrentSession();
    }
    ackIdExtensionError(e) {
        console.log("ackIdExtensionError");
        const ackId = e.data;
        // Find the failed document
        const failedRequest = this.reviewRequests.find((reviewRequest)=>reviewRequest.ackId === ackId);
        // Remove the failed document from the batch
        const previousCount = this.reviewRequests.length;
        this.reviewRequests = this.reviewRequests.filter((reviewRequest)=>reviewRequest.ackId !== ackId);
        const remainingCount = this.reviewRequests.length;
        // Log the removal for debugging purposes but don't interrupt the user
        console.log(`Document with ackId ${ackId} silently removed from batch (${previousCount} -> ${remainingCount} documents)`);
        if (failedRequest) console.log(`Removed document: ${failedRequest.name}`);
        // Save session after removing failed request
        this.saveCurrentSession();
        // Only redirect to landing page if there are no more documents to review
        if (remainingCount === 0) {
            // cleanup leftover from DocumentView component
            document.querySelectorAll(".cdk-overlay-container").forEach((element)=>element.innerHTML = "");
            // change to manage batch and queue view
            this.componentType = 0;
        } else // If we're currently in review mode, notify the review component about the updated list
        if (this.componentType === 1) {
            const reviewComponent = document.querySelector("hitl-review-document");
            if (reviewComponent) {
                // Update the review component's list and adjust the index if necessary
                reviewComponent.reviewRequests = this.reviewRequests;
                // If the current index is beyond the new list length, adjust it
                if (reviewComponent.reviewRequestsIndex >= this.reviewRequests.length) reviewComponent.reviewRequestsIndex = Math.max(0, this.reviewRequests.length - 1);
                // Continue reviewing with the updated list
                reviewComponent.reviewDocument(this.reviewRequests[reviewComponent.reviewRequestsIndex]);
            }
        }
    }
    startBatchReview(e) {
        this.reviewRequests = e.detail;
        this.componentType = 1;
    }
    manageBatchAndQueues(e) {
        // cleanup leftover from DocumentView component
        document.querySelectorAll(".cdk-overlay-container").forEach((element)=>element.innerHTML = "");
        this.reviewRequests = e.detail;
        this.componentType = 0;
    }
    // Cached DOM reference helpers for performance
    getCachedDialog() {
        const now = Date.now();
        if (!this.cachedElements.dialog || now - this.cachedElements.lastCacheTime > $7ad5d60cead493d6$export$71c93d36757fcdb1.CACHE_DURATION) {
            this.cachedElements.dialog = document.getElementById("dialog");
            this.cachedElements.lastCacheTime = now;
        }
        return this.cachedElements.dialog;
    }
    getCachedQueuesComponent() {
        const now = Date.now();
        if (!this.cachedElements.queues || now - this.cachedElements.lastCacheTime > $7ad5d60cead493d6$export$71c93d36757fcdb1.CACHE_DURATION) {
            this.cachedElements.queues = document.querySelector("hitl-queues");
            this.cachedElements.lastCacheTime = now;
        }
        return this.cachedElements.queues;
    }
    /**
   * Determines error type and dialog content for login failures
   * @param errorMessage The error message from the login attempt
   * @returns Object with heading and whether it's a permission error
   */ getLoginErrorContent(errorMessage) {
        const isPermissionDenied = errorMessage.toLowerCase().includes("does not have permissions");
        return {
            heading: isPermissionDenied ? "Zugriff verweigert" : "Anmeldung fehlgeschlagen",
            isPermissionDenied: isPermissionDenied
        };
    }
    // Update access tokens in all active ACK extension workers
    updateWorkerTokens() {
        if (!this.#accessToken) return;
        console.log(`Updating access tokens in ${this.reviewRequests.length} workers`);
        this.reviewRequests.forEach((reviewRequest)=>{
            if (reviewRequest instanceof (0, $20e0088800729d63$export$9fee94aa43a40124) && reviewRequest.extendAckIdWorker) try {
                reviewRequest.extendAckIdWorker.postMessage({
                    type: "refresh_token",
                    token: this.#accessToken,
                    idToken: this.#idToken
                });
            } catch (error) {
                console.warn("Failed to update token in worker:", error);
            }
        });
    }
    // Start periodic token refresh for worker tokens
    startTokenRefreshTimer() {
        // Clear any existing timer
        if (this.tokenRefreshTimer) clearInterval(this.tokenRefreshTimer);
        // Refresh worker tokens every 10 minutes (more aggressive to prevent expiration)
        this.tokenRefreshTimer = setInterval(async ()=>{
            try {
                console.log("Performing periodic token refresh for workers");
                // Force a refresh if token will expire in next 25 minutes
                const willExpireSoon = this.#accessTokenExpiration <= new Date(new Date().getTime() + 1500000);
                if (willExpireSoon) {
                    console.log("Token will expire soon, forcing refresh");
                    await this.getAccessToken(true);
                } else // Just update workers with current token
                this.updateWorkerTokens();
            } catch (error) {
                console.error("Periodic token refresh failed - redirecting to login screen:", error);
                this.handleAuthenticationFailure(true);
            }
        }, 600000); // 10 minutes
    }
    attemptSessionRestore() {
        const sessionData = (0, $cfe1945935cd34b8$export$415798a788f40554).loadSession();
        if (!sessionData) {
            console.log("[HitlApp] No session found in localStorage");
            return;
        }
        if (!(0, $cfe1945935cd34b8$export$415798a788f40554).isSessionValid(sessionData)) {
            console.log("[HitlApp] Session invalid or expired - clearing session");
            (0, $cfe1945935cd34b8$export$415798a788f40554).clearSession();
            return;
        }
        console.log("[HitlApp] Valid session found - restoring user state");
        // Restore authentication tokens
        this.#accessToken = sessionData.accessToken;
        this.#accessTokenAD = sessionData.accessTokenAD;
        this.#idToken = sessionData.idToken;
        this.#accessTokenExpiration = new Date(sessionData.accessTokenExpiration);
        // Restore user information
        this.userId = sessionData.userId;
        this.#loggedUserName = sessionData.userName;
        this.#loggedUserEmail = sessionData.userEmail;
        // Preserve the original session creation timestamp
        this.#sessionCreatedAt = sessionData.sessionCreatedAt;
        // Always allow login bypass if session is valid, regardless of identity type mismatch
        this.loginRequired = false;
        // Configure logger with restored token
        if (this.detectedEnvironment) (0, $a30lF.configurePubsubLogger)(this.detectedEnvironment, this.#accessToken);
        else (0, $a30lF.setPubsubAccessToken)(this.#accessToken);
        // Start token refresh timer
        this.startTokenRefreshTimer();
        console.log("[HitlApp] Session restored successfully \u2713", {
            userId: this.userId,
            loginRequired: this.loginRequired,
            reviewRequestsCount: this.reviewRequests.length
        });
    }
    saveCurrentSession() {
        if (!this.userId || this.identityType === "none") return;
        const sessionData = {
            accessToken: this.#accessToken,
            accessTokenAD: this.#accessTokenAD,
            idToken: this.#idToken,
            accessTokenExpiration: this.#accessTokenExpiration.toISOString(),
            userId: this.userId,
            userName: this.#loggedUserName,
            userEmail: this.#loggedUserEmail,
            identityType: this.identityType,
            sessionCreatedAt: this.#sessionCreatedAt || new Date().toISOString()
        };
        (0, $cfe1945935cd34b8$export$415798a788f40554).saveSession(sessionData);
    }
    handleAuthenticationFailure(clearTokens = true) {
        console.log("Clearing session and returning to login screen");
        // Clear persisted session
        (0, $cfe1945935cd34b8$export$415798a788f40554).clearSession();
        window.sessionStorage.clear();
        // Clear authentication state
        if (clearTokens) {
            this.#accessToken = "";
            this.#accessTokenAD = "";
            this.#idToken = "";
            this.#accessTokenExpiration = new Date();
        }
        this.userId = "";
        this.loginRequired = true;
        this.#loggedUserName = "";
        this.#loggedUserEmail = "";
        this.#sessionCreatedAt = "";
        // Clear review requests and any ongoing work
        this.reviewRequests.forEach((reviewRequest)=>{
            if (reviewRequest instanceof (0, $20e0088800729d63$export$9fee94aa43a40124) && reviewRequest.extendAckIdWorker) try {
                reviewRequest.extendAckIdWorker.terminate();
            } catch (error) {
                console.warn("Failed to terminate worker:", error);
            }
        });
        this.reviewRequests = [];
        // Clear any timers
        if (this.tokenRefreshTimer) {
            clearInterval(this.tokenRefreshTimer);
            this.tokenRefreshTimer = undefined;
        }
        // Return to the login screen view
        this.componentType = 0;
        // Force a re-render to show the clean login screen
        this.requestUpdate();
        console.log("User session cleared - showing login screen");
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up timer when component is destroyed
        if (this.tokenRefreshTimer) clearInterval(this.tokenRefreshTimer);
        // Clean up event listeners
        if (this.boundTaskCompletedHandler) document.removeEventListener("task-completed", this.boundTaskCompletedHandler);
        if (this.boundBeforeUnloadHandler) window.removeEventListener("beforeunload", this.boundBeforeUnloadHandler);
    }
    constructor(...args){
        super(...args), this.reviewRequests = [], this.componentType = 0, this.userId = "", this.queueType = "File", this.identityType = "none", this.queues = [], this.loginRequired = false, this.setupCompleted = false, this.loadingReviewRequests = false, // Cached DOM references for performance
        this.cachedElements = {
            dialog: null,
            queues: null,
            lastCacheTime: 0
        }, this.loadingProgress = null, this.clientLogo = "alh_logo.svg", this.appTitle = "DEFAULT_APP_TITLE", this.detectedEnvironment = "", this.#accessTokenAD = "", this.#accessToken = "", this.#idToken = "", this.#accessTokenExpiration = new Date(), this.#loggedUserName = "", this.#loggedUserEmail = "", this.#loggedUserAccessType = "", this.#sessionCreatedAt = "", // returns promise for accessToken either by using an existing token or by requesting a new token
        this.getAccessTokenEvent = async (e)=>{
            const refresh = e.detail.refresh;
            let resolve = e.detail.resolve;
            let reject = e.detail.reject;
            try {
                const [accessToken, idToken] = await this.getAccessToken(refresh);
                resolve([
                    accessToken,
                    idToken
                ]);
            } catch (error) {
                reject(error);
            }
        }, this.getAccessToken = async (refresh = false)=>{
            if (this.identityType === "none") return [
                "",
                ""
            ];
            else if (!refresh && this.#accessToken && this.#accessTokenExpiration > new Date() || refresh && this.#accessTokenExpiration > new Date(new Date().getTime() + $7ad5d60cead493d6$var$MINUTES_BEFORE_ACCESS_TOKEN_RENEWAL * 60000)) return [
                this.#accessToken,
                this.#idToken
            ];
            else if (refresh || !this.#accessToken || this.#accessTokenExpiration <= new Date()) {
                // Token needs refresh (either explicitly requested or expired)
                if (this.identityType === "gis") try {
                    // Settle this promise in the response callback for requestAccessToken()
                    const promise = new Promise((resolve, reject)=>{
                        if (this.initTokenClient) {
                            const tokenClient = this.initTokenClient({
                                client_id: "DEFAULT_GIS_CLIENT_ID",
                                scope: "https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/datastore email profile",
                                prompt: "",
                                callback: (tokenResponse)=>{
                                    if (tokenResponse.error !== undefined) {
                                        console.log("tokenResponse has an error");
                                        reject(tokenResponse.error_description);
                                    }
                                    resolve(tokenResponse);
                                },
                                error_callback: (error)=>{
                                    console.log("error_callback");
                                    reject(error);
                                }
                            });
                            tokenClient.requestAccessToken();
                        } else reject("initTokenClient not defined");
                    });
                    const tokenResponse = await promise;
                    this.#accessToken = tokenResponse.access_token;
                    this.#accessTokenExpiration = new Date(new Date().getTime() + parseInt(tokenResponse.expires_in) * 1000);
                    const audience = "DEFAULT_INTERNAL_API_URL";
                    const saEmail = `${"DEFAULT_CLIENT_PREFIX"}-${"DEFAULT_ENVIRONMENT"}-hitl-supervisor@${"DEFAULT_PROJECT_ID"}.iam.gserviceaccount.com`;
                    const idTokenUrl = `https://iamcredentials.googleapis.com/v1/projects/-/serviceAccounts/${saEmail}:generateIdToken`;
                    const idTokenResponse = await fetch(idTokenUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + this.#accessToken
                        },
                        body: JSON.stringify({
                            audience: audience,
                            includeEmail: "true"
                        })
                    });
                    if (!idTokenResponse.ok) {
                        const errorText = await idTokenResponse.text();
                        console.error("Token exchange failed:", errorText);
                        throw new Error(`HTTP ${idTokenResponse.status}: ${errorText}`);
                    }
                    const idTokenResponseJson = await idTokenResponse.json();
                    this.#idToken = idTokenResponseJson.token;
                    this.#loggedUserAccessType = "supervisor";
                    // Configure the logger with environment-aware topic if environment is detected
                    if (this.detectedEnvironment) (0, $a30lF.configurePubsubLogger)(this.detectedEnvironment, this.#accessToken);
                    else // Fallback to legacy configuration for backward compatibility
                    (0, $a30lF.setPubsubAccessToken)(this.#accessToken);
                    // Save session after token refresh (only if user is logged in)
                    if (this.userId) this.saveCurrentSession();
                } catch (error) {
                    console.log("requesting access token failed - redirecting to login screen");
                    this.handleAuthenticationFailure(false);
                }
                else if (this.identityType === "ad" && this.ADclientApplication) try {
                    const loginResponse = await this.ADclientApplication.loginPopup({
                        scopes: [
                            "openid",
                            "profile",
                            "email"
                        ]
                    });
                    this.#loggedUserName = loginResponse.account.name;
                    this.#loggedUserEmail = loginResponse.account.username;
                    if (loginResponse.idToken) {
                        this.#accessTokenAD = loginResponse.accessToken;
                        const body = JSON.stringify({
                            ad_id_token: loginResponse.idToken,
                            ad_access_token: loginResponse.accessToken
                        });
                        const tokenResponse = await fetch("DEFAULT_HITL_CREDS_ENDPOINT_URL", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: body
                        });
                        if (!tokenResponse.ok) {
                            const errorText = await tokenResponse.text();
                            console.error("Token exchange failed:", errorText);
                            throw new Error(`HTTP ${tokenResponse.status}: ${errorText}`);
                        }
                        const tokenResponseJson = await tokenResponse.json();
                        this.#idToken = tokenResponseJson.id_token;
                        this.#accessToken = tokenResponseJson.access_token;
                        this.#accessTokenExpiration = new Date(new Date().getTime() + parseInt(tokenResponseJson.expires_in) * 1000);
                        this.#loggedUserAccessType = tokenResponseJson.access_type;
                        // Save session after token refresh (only if user is logged in)
                        if (this.userId) this.saveCurrentSession();
                        // Configure logger with environment-aware topic name
                        if (this.detectedEnvironment) (0, $a30lF.configurePubsubLogger)(this.detectedEnvironment, this.#accessToken);
                        else // Fallback to legacy configuration for backward compatibility
                        (0, $a30lF.setPubsubAccessToken)(this.#accessToken);
                    }
                } catch (error) {
                    const errorMessage = error instanceof Error ? error.message : String(error);
                    console.log("Azure AD authentication failed:", errorMessage);
                    // Show error dialog before redirecting
                    const dialog = this.getCachedDialog();
                    if (dialog) {
                        const { heading: heading, isPermissionDenied: isPermissionDenied } = this.getLoginErrorContent(errorMessage);
                        dialog.heading = heading;
                        if (isPermissionDenied) (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                  <div style="margin-bottom: 16px;">
                    <p>
                      Sie haben keine Berechtigung, auf die HITL-Anwendung
                      zuzugreifen.
                    </p>
                    <p style="margin-top: 12px;">
                      Bitte wenden Sie sich an Ihren Administrator, um die
                      erforderlichen EntraID-Gruppenberechtigungen zu erhalten.
                    </p>
                  </div>
                  <mwc-button slot="primaryAction" dialogAction="ok"
                    >OK</mwc-button
                  >
                `, dialog);
                        else (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
                  <div style="margin-bottom: 16px;">
                    <p>Bei der Anmeldung ist ein Fehler aufgetreten.</p>
                    <p style="margin-top: 12px;">
                      Bitte versuchen Sie es erneut oder wenden Sie sich an den
                      Support.
                    </p>
                  </div>
                  <mwc-button slot="primaryAction" dialogAction="ok"
                    >OK</mwc-button
                  >
                `, dialog);
                        dialog.open = true;
                    }
                    this.handleAuthenticationFailure(false);
                }
                // update accessToken in all extendAckIdWorkers of Review Requests
                this.updateWorkerTokens();
            } else {
                console.log("cannot fetch access token due to missing user action - redirecting to login screen");
                this.handleAuthenticationFailure(false);
            }
            return [
                this.#accessToken,
                this.#idToken
            ];
        }, this.login = async ()=>{
            // Set session creation timestamp BEFORE getting tokens
            // This ensures the timestamp is always earlier than token expiration
            this.#sessionCreatedAt = new Date().toISOString();
            await this.getAccessToken(true);
            // fetch user info
            let userInfoUrl;
            let accessToken;
            let idToken;
            if (this.identityType === "gis") {
                userInfoUrl = "https://www.googleapis.com/oauth2/v1/userinfo";
                accessToken = this.#accessToken;
                const response = await (0, $ae3c9e3bab400541$export$782df2acbe10b22c)(userInfoUrl, {
                    headers: {
                        authorization: `Bearer ${accessToken}`
                    }
                }, 5000, 3);
                const json = await response.json();
                this.#loggedUserName = json.name;
                this.#loggedUserEmail = json.email;
                this.userId = json.email;
            } else if (this.identityType === "ad") this.userId = this.#loggedUserEmail;
            if (this.userId) {
                idToken = this.#idToken;
                const loginUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/hitl_logins_${this.#loggedUserAccessType}`;
                const queryResponse = await fetch(`${loginUrl}/${this.#loggedUserEmail}`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        "Content-Type": "application/json"
                    }
                });
                const loginData = {
                    timestamp: new Date().toISOString(),
                    documentId: this.#loggedUserEmail,
                    userName: this.#loggedUserName,
                    identityType: this.identityType,
                    accessType: this.#loggedUserAccessType
                };
                if (!queryResponse.ok) // User is not logged in atm; add new login entry in Firestore
                await fetch(loginUrl, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(loginData)
                });
                else {
                    const responseData = await queryResponse.json();
                    const currentTimestamp = Date.now();
                    const timestamp = responseData.timestamp ? new Date(responseData.timestamp).getTime() : null;
                    if (!timestamp || isNaN(timestamp)) {
                        console.error("The 'timestamp' field is either missing or invalid.");
                        throw new Error("Invalid or missing 'timestamp' format.");
                    }
                    if (currentTimestamp > timestamp + 300000) // User login expired; proceeding to updating login entry in Firestore
                    await fetch(`${loginUrl}/${this.#loggedUserEmail}`, {
                        method: "PATCH",
                        headers: {
                            Authorization: `Bearer ${idToken}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(loginData)
                    });
                    else {
                        // User is already logged in
                        console.error("User is already logged in - redirecting to login screen");
                        this.handleAuthenticationFailure(true);
                        return;
                    }
                }
                // Log successful login
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "INFO",
                    documentId: this.userId,
                    action: "User logged in",
                    additionalInfo: {
                        identityType: this.identityType,
                        userEmail: this.#loggedUserEmail,
                        accessType: this.#loggedUserAccessType
                    }
                });
                // Save session after successful login
                this.saveCurrentSession();
            }
        }, this.logout = async ()=>{
            // Show confirmation dialog
            const dialog = this.getCachedDialog();
            if (dialog) {
                dialog.heading = "Abmelden";
                (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`
          <div style="margin-bottom: 16px;">
            Sind Sie sicher, dass Sie sich abmelden möchten?
          </div>
          <mwc-button
            slot="primaryAction"
            dialogAction="confirm"
            @click=${()=>this.silentLogout()}
          >
            Ja
          </mwc-button>
          <mwc-button slot="secondaryAction" dialogAction="cancel">
            Nein
          </mwc-button>
        `, dialog);
                dialog.open = true;
            } else // Fallback to silent logout if dialog not available
            await this.silentLogout();
        }, this.silentLogout = async ()=>{
            // Log silent logout action
            if (this.userId) {
                const loginUrl = `${"DEFAULT_INTERNAL_API_URL"}/documents/hitl_logins_${this.#loggedUserAccessType}/${this.#loggedUserEmail}`;
                const deleteResponse = await fetch(loginUrl, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${this.#idToken}`,
                        "Content-Type": "application/json"
                    }
                });
                if (!deleteResponse.ok) console.error(`Could not clear login from Firestore`);
                else console.log(`Successfully logout`);
                (0, $a30lF.logAction)({
                    timestamp: new Date().toISOString(),
                    severity: "INFO",
                    userId: this.userId,
                    action: "User logged out (silent - HITL only)",
                    additionalInfo: {
                        identityType: this.identityType,
                        userEmail: this.#loggedUserEmail,
                        accessType: this.#loggedUserAccessType
                    }
                });
            }
            // Clear local session only - skip identity provider logout
            (0, $cfe1945935cd34b8$export$415798a788f40554).clearSession();
            // Clear all authentication state and return to login screen
            this.handleAuthenticationFailure(true);
        }, this.fullLogout = async ()=>{
            // Log full logout action
            if (this.userId) (0, $a30lF.logAction)({
                timestamp: new Date().toISOString(),
                severity: "INFO",
                userId: this.userId,
                action: "User logged out (full - including identity provider)",
                additionalInfo: {
                    identityType: this.identityType,
                    userEmail: this.#loggedUserEmail
                }
            });
            (0, $cfe1945935cd34b8$export$415798a788f40554).clearSession();
            // Handle identity provider logout
            if (this.identityType === "ad" && this.ADclientApplication) // Azure AD logout
            try {
                await this.ADclientApplication.logoutPopup({
                    mainWindowRedirectUri: window.location.href
                });
            } catch (error) {
                console.warn("Azure AD logout failed, continuing with local logout:", error);
            }
            else if (this.identityType === "gis" && this.#accessToken) // Google Identity Services - revoke access token
            try {
                const revokeUrl = `https://oauth2.googleapis.com/revoke?token=${this.#accessToken}`;
                await fetch(revokeUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                });
                console.log("Google access token revoked successfully");
            } catch (error) {
                console.warn("Google token revocation failed, continuing with local logout:", error);
            }
            // Clear all authentication state and return to login screen
            this.handleAuthenticationFailure(true);
        }, this.handleReviewRequestsLoading = (e)=>{
            this.loadingReviewRequests = true;
            this.loadingProgress = {
                current: 0,
                total: e.detail.queuesCount
            };
            console.log(`Starting to load review requests from ${e.detail.queuesCount} queues`);
        }, this.handleReviewRequestsProgress = (e)=>{
            this.loadingProgress = {
                current: e.detail.current,
                total: e.detail.total,
                queueName: e.detail.queueName
            };
            console.log(`Loading progress: ${e.detail.current}/${e.detail.total} (${e.detail.queueName})`);
        }, this.handleReviewRequestsError = (e)=>{
            this.loadingReviewRequests = false;
            this.loadingProgress = null;
            console.error("Error loading review requests:", e.detail.error);
            // Show error dialog to user
            const dialog = this.getCachedDialog();
            if (dialog) {
                dialog.heading = "Fehler beim Laden der Arbeitsstapel";
                (0, $e4c6f5c4fa111bdf$export$b3890eb0ae9dca99)((0, $e4c6f5c4fa111bdf$export$c0bb0b647f701bb5)`Es ist ein Fehler beim Laden der Arbeitsstapel aufgetreten:
          ${e.detail.error}
          <mwc-button slot="primaryAction" dialogAction="ok">OK</mwc-button>`, dialog);
                dialog.open = true;
            }
        }, this.handleReviewRequestsCompleted = (e)=>{
            this.loadingReviewRequests = false;
            this.loadingProgress = null;
            console.log(`Finished loading ${e.detail.count} review requests`);
        }, this.handleEnvironmentDetected = (e)=>{
            this.detectedEnvironment = e.detail.environment;
            console.log(`Environment detected in main app: ${this.detectedEnvironment}`);
            // If we already have an access token, configure the logger immediately
            if (this.#accessToken && this.detectedEnvironment) (0, $a30lF.configurePubsubLogger)(this.detectedEnvironment, this.#accessToken);
        }, this.handleTaskReleased = (e)=>{
            console.log(`Task released from batch: ${e.detail.taskId} from queue ${e.detail.queueName}`);
            // Find the queues component and handle task release properly
            const queuesComponent = this.getCachedQueuesComponent();
            if (queuesComponent && typeof queuesComponent.handleTaskRelease === "function") {
                console.log("\uD83D\uDD04 Handling task release for queue count update");
                queuesComponent.handleTaskRelease(e.detail.queueName, 1);
            } else if (queuesComponent && typeof queuesComponent.refreshQueueCountsImmediate === "function") {
                // Fallback to immediate refresh if handleTaskRelease is not available
                console.log("\uD83D\uDD04 Triggering immediate queue refresh after task release");
                queuesComponent.refreshQueueCountsImmediate().catch((error)=>console.warn("Failed to refresh queue counts after task release:", error));
            }
        }, this.handleTaskCompleted = (e)=>{
            console.log(`Task completed: ${e.detail.taskId} from queue ${e.detail.queueName}`);
            // Find the queues component and trigger immediate refresh
            const queuesComponent = this.getCachedQueuesComponent();
            if (queuesComponent && typeof queuesComponent.refreshQueueCountsImmediate === "function") {
                console.log("\uD83D\uDD04 Triggering immediate queue refresh after task completion");
                queuesComponent.refreshQueueCountsImmediate().catch((error)=>console.warn("Failed to refresh queue counts after task completion:", error));
            }
        };
    }
}
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Array
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "reviewRequests", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Array
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "componentType", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "userId", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String,
        attribute: "queuetype"
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "queueType", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String,
        attribute: "identitytype"
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "identityType", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Array
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "queues", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Boolean
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "loginRequired", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Boolean
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "setupCompleted", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Boolean
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "loadingReviewRequests", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: Object
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "loadingProgress", void 0);
(0, $czHfO.__decorate)([
    (0, $ea0a8a49bb7a0c56$export$d541bacb2bda4494)({
        type: String
    })
], $7ad5d60cead493d6$export$71c93d36757fcdb1.prototype, "detectedEnvironment", void 0);
$7ad5d60cead493d6$export$71c93d36757fcdb1 = (0, $czHfO.__decorate)([
    (0, $df800a9dc9638977$export$da64fc29f17f9d0e)("hitl-app")
], $7ad5d60cead493d6$export$71c93d36757fcdb1);


//# sourceMappingURL=hitl.js.map
